
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5caa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5caa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("fCKVd", function(module, exports) {

$parcel$export(module.exports, "BouncingLoader", () => $b5fecd57b45662f2$export$b6adbc8a92f93a5b);
$parcel$export(module.exports, "useModal", () => $b5fecd57b45662f2$export$33ffd74ebf07f060);
$parcel$export(module.exports, "Modal", () => $b5fecd57b45662f2$export$2b77a92f1a5ad772);
$parcel$export(module.exports, "useConfirm", () => $b5fecd57b45662f2$export$bf4da147a5964edb);
$parcel$export(module.exports, "useExternalStore", () => $b5fecd57b45662f2$export$4b79bd8f34740571);
$parcel$export(module.exports, "useAppConfig", () => $b5fecd57b45662f2$export$a3e0ece8c3f698d7);
$parcel$export(module.exports, "useBaseAppConfig", () => $b5fecd57b45662f2$export$a9d1b6bbcaa78af1);
$parcel$export(module.exports, "useAppExternalConfig", () => $b5fecd57b45662f2$export$f1d07fa4061ab6b1);
$parcel$export(module.exports, "useAppAuth", () => $b5fecd57b45662f2$export$c594d3118da9430d);
$parcel$export(module.exports, "useAppNavigation", () => $b5fecd57b45662f2$export$846279b0d7f2d98d);
$parcel$export(module.exports, "useAppToasts", () => $b5fecd57b45662f2$export$5425318366a9780c);
$parcel$export(module.exports, "useAppPageContext", () => $b5fecd57b45662f2$export$45bb9e733e328a26);
$parcel$export(module.exports, "useAppPageContextData", () => $b5fecd57b45662f2$export$ff791c79b16a1b08);
$parcel$export(module.exports, "useAppService", () => $b5fecd57b45662f2$export$e69cda64f05dea11);
$parcel$export(module.exports, "Tooltip", () => $b5fecd57b45662f2$export$28c660c63b792dea);
$parcel$export(module.exports, "Form", () => $b5fecd57b45662f2$export$a7fed597f4b8afd8);
$parcel$export(module.exports, "useBoolean", () => $b5fecd57b45662f2$export$c32275ecbd12948f);
$parcel$export(module.exports, "AbstractDataStore", () => $b5fecd57b45662f2$export$8c2572089a81a391);
$parcel$export(module.exports, "ActionButton", () => $b5fecd57b45662f2$export$cfc7921d29ef7b80);
$parcel$export(module.exports, "ActionsDropdown", () => $b5fecd57b45662f2$export$be40bdb4a62faae1);
$parcel$export(module.exports, "useActionHandler", () => $b5fecd57b45662f2$export$275c020f4a82b180);
$parcel$export(module.exports, "AsTopbarRow", () => $b5fecd57b45662f2$export$6f268783f91b5174);
$parcel$export(module.exports, "DateTimeFormat", () => $b5fecd57b45662f2$export$841a7e6dcc7fe44e);
$parcel$export(module.exports, "FlexCentered", () => $b5fecd57b45662f2$export$1d3945ea2d8839cb);
$parcel$export(module.exports, "Avatar", () => $b5fecd57b45662f2$export$e2255cf6045e8d47);
$parcel$export(module.exports, "Preloader", () => $b5fecd57b45662f2$export$a3de6efb5461e66f);
$parcel$export(module.exports, "FlexCenteredInfo", () => $b5fecd57b45662f2$export$bf0213d36508970c);
$parcel$export(module.exports, "AppLayout", () => $b5fecd57b45662f2$export$e034111dc0cfe9e7);
$parcel$export(module.exports, "makeSimpleRoute", () => $b5fecd57b45662f2$export$540eaef543e5a49a);
$parcel$export(module.exports, "makeCrudRoute", () => $b5fecd57b45662f2$export$a39f5bc07fd1b226);
$parcel$export(module.exports, "AddItemMode", () => $b5fecd57b45662f2$export$188ffe2069709b9f);
$parcel$export(module.exports, "EventAction", () => $b5fecd57b45662f2$export$4f3bc3f0d9ac9da2);
$parcel$export(module.exports, "useWebsocketArrayDataStore", () => $b5fecd57b45662f2$export$8fa67717b2c61f2b);
$parcel$export(module.exports, "Application", () => $b5fecd57b45662f2$export$16975c34e60e1e61);
$parcel$export(module.exports, "AwaitBlock", () => $b5fecd57b45662f2$export$daf72112110fee48);
$parcel$export(module.exports, "Block", () => $b5fecd57b45662f2$export$d96a8827a60d6b69);
$parcel$export(module.exports, "useSavedState", () => $b5fecd57b45662f2$export$bc4ac5c7b57c369a);

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");
var $2vsP7 = parcelRequire("2vsP7");
var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $2vsP7 = parcelRequire("2vsP7");

var $2rasJ = parcelRequire("2rasJ");

var $9JAYi = parcelRequire("9JAYi");

var $8g1PZ = parcelRequire("8g1PZ");

var $cpxrl = parcelRequire("cpxrl");
var $gmc0U = parcelRequire("gmc0U");
var $6LAgE = parcelRequire("6LAgE");
var $f57q8 = parcelRequire("f57q8");
var $aX99y = parcelRequire("aX99y");
var $77pHI = parcelRequire("77pHI");
var $99eL8 = parcelRequire("99eL8");
var $8qr9R = parcelRequire("8qr9R");
var $6l6B5 = parcelRequire("6l6B5");
var $gzHIW = parcelRequire("gzHIW");
var $8CrHJ = parcelRequire("8CrHJ");
var $48fuN = parcelRequire("48fuN");
var $81OvX = parcelRequire("81OvX");
var $81s7d = parcelRequire("81s7d");
var $azy33 = parcelRequire("azy33");
var $6WSsf = parcelRequire("6WSsf");
var $gBH4L = parcelRequire("gBH4L");
var $eBMdo = parcelRequire("eBMdo");
var $5o2go = parcelRequire("5o2go");
var $2jjfn = parcelRequire("2jjfn");
var $h7C4J = parcelRequire("h7C4J");
var $4dB0L = parcelRequire("4dB0L");
var $j3TSU = parcelRequire("j3TSU");
var $93EsN = parcelRequire("93EsN");
var $N43sL = parcelRequire("N43sL");

var $ket0H = parcelRequire("ket0H");
var $9PE8j = parcelRequire("9PE8j");
var $fmlaG = parcelRequire("fmlaG");
var $3nvVi = parcelRequire("3nvVi");
var $ifGBV = parcelRequire("ifGBV");
var $9lLem = parcelRequire("9lLem");

var $4mPkP = parcelRequire("4mPkP");

var $22i8b = parcelRequire("22i8b");

var $a3QyA = parcelRequire("a3QyA");
parcelRequire("01djI");
var $fEyWK = parcelRequire("fEyWK");
parcelRequire("4Tcsi");
var $kwclR = parcelRequire("kwclR");

var $5arZS = parcelRequire("5arZS");

var $kqTi2 = parcelRequire("kqTi2");
var $i7g9v = parcelRequire("i7g9v");
var $5Dm6P = parcelRequire("5Dm6P");
var $4ysIF = parcelRequire("4ysIF");
var $bSFz8 = parcelRequire("bSFz8");

var $8JYDX = parcelRequire("8JYDX");

var $5sKyw = parcelRequire("5sKyw");

var $htkMF = parcelRequire("htkMF");

var $f1q41 = parcelRequire("f1q41");

var $1u0KT = parcelRequire("1u0KT");

var $8x08q = parcelRequire("8x08q");

var $8WR9B = parcelRequire("8WR9B");

var $e0UFp = parcelRequire("e0UFp");

var $48fuN = parcelRequire("48fuN");

var $dW8ts = parcelRequire("dW8ts");

var $82Jpc = parcelRequire("82Jpc");

var $apXAB = parcelRequire("apXAB");
var $dsEvO = parcelRequire("dsEvO");
var $b5fecd57b45662f2$var$pD = Object.create;
var $b5fecd57b45662f2$var$li = Object.defineProperty;
var $b5fecd57b45662f2$var$mD = Object.getOwnPropertyDescriptor;
var $b5fecd57b45662f2$var$cD = Object.getOwnPropertyNames;
var $b5fecd57b45662f2$var$uD = Object.getPrototypeOf, $b5fecd57b45662f2$var$dD = Object.prototype.hasOwnProperty;
var $b5fecd57b45662f2$var$n = (t, e)=>()=>(t && (e = t(t = 0)), e);
var $b5fecd57b45662f2$var$pi = (t, e)=>()=>(e || t((e = {
            exports: {}
        }).exports, e), e.exports), $b5fecd57b45662f2$var$Ie = (t, e)=>{
    for(var o in e)$b5fecd57b45662f2$var$li(t, o, {
        get: e[o],
        enumerable: !0
    });
}, $b5fecd57b45662f2$var$fD = (t, e, o, r)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let a of $b5fecd57b45662f2$var$cD(e))!$b5fecd57b45662f2$var$dD.call(t, a) && a !== o && $b5fecd57b45662f2$var$li(t, a, {
        get: ()=>e[a],
        enumerable: !(r = $b5fecd57b45662f2$var$mD(e, a)) || r.enumerable
    });
    return t;
};
var $b5fecd57b45662f2$var$Jl = (t, e, o)=>(o = t != null ? $b5fecd57b45662f2$var$pD($b5fecd57b45662f2$var$uD(t)) : {}, $b5fecd57b45662f2$var$fD(e || !t || !t.__esModule ? $b5fecd57b45662f2$var$li(o, "default", {
        value: t,
        enumerable: !0
    }) : o, t));
function $b5fecd57b45662f2$export$b2521dd6e4e1a602(t) {
    let e = localStorage.getItem(t);
    if (e) try {
        return JSON.parse(e);
    } catch  {}
    return null;
}
function $b5fecd57b45662f2$export$66e1b6860596375e(t, e) {
    localStorage.setItem(t, JSON.stringify(e));
}
var $b5fecd57b45662f2$var$pa = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$RD, $b5fecd57b45662f2$var$mo, $b5fecd57b45662f2$var$ca = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$RD = {
        tableMode: "full",
        settingsShow: !0
    }, $b5fecd57b45662f2$var$mo = $b5fecd57b45662f2$var$RD;
});
var $b5fecd57b45662f2$var$FD, $b5fecd57b45662f2$var$ua, $b5fecd57b45662f2$var$hi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ca();
    $b5fecd57b45662f2$var$FD = (0, $acw62.createContext)({
        settings: {
            displayColumns: {},
            disableMobileLayout: !1
        },
        setSettings: ()=>{},
        showColumns: [],
        config: $b5fecd57b45662f2$var$mo,
        renderConfig: null,
        isResults: !1,
        isFilters: !1,
        activeFilters: {},
        isActiveFilters: !1,
        isSort: !1,
        activeSorts: {},
        toggleSort: ()=>{},
        setSorts: ()=>{},
        setSearchParams: ()=>{},
        hasGroupActions: !1,
        rowsSelected: [],
        setRowSelected: ()=>{},
        setAllRowsSelected: ()=>{},
        isAllRowsSelected: !1,
        isRowSelected: ()=>!1,
        data: {
            name: "unknown",
            options: {
                hasRowActions: !1,
                hasIndexes: !1,
                actionsModel: "test"
            },
            columns: [],
            filters: [],
            data: [],
            pagination: null
        },
        rows: []
    }), $b5fecd57b45662f2$var$ua = $b5fecd57b45662f2$var$FD;
});
function $b5fecd57b45662f2$var$h() {
    return (0, $acw62.useContext)($b5fecd57b45662f2$var$ua);
}
var $b5fecd57b45662f2$var$lp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$hi();
});
function $b5fecd57b45662f2$var$pp(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))).parse(t.toString());
}
function $b5fecd57b45662f2$var$MD(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))).stringify(t);
}
function $b5fecd57b45662f2$var$Pt() {
    let [t, e] = (0, $lzNIT.useSearchParams)(), o = t.toString(), r = (0, $acw62.useMemo)(()=>$b5fecd57b45662f2$var$pp(t), [
        o
    ]);
    return {
        searchString: o,
        searchParams: r,
        getSearchParams: (s)=>r[s],
        setSearchParams: (s)=>{
            if (!s) {
                e(void 0);
                return;
            }
            e((l)=>$b5fecd57b45662f2$var$MD({
                    ...$b5fecd57b45662f2$var$pp(l),
                    ...s
                }));
        }
    };
}
var $b5fecd57b45662f2$var$co = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$da = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$ND, $b5fecd57b45662f2$export$b6adbc8a92f93a5b, $b5fecd57b45662f2$var$Tt = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ND = ()=>$acw62.createElement("div", {
            className: "bouncing-loader"
        }, $acw62.createElement("div", null), $acw62.createElement("div", null), $acw62.createElement("div", null)), $b5fecd57b45662f2$export$b6adbc8a92f93a5b = $b5fecd57b45662f2$var$ND;
});
var $b5fecd57b45662f2$var$_D, $b5fecd57b45662f2$export$da65322c66e325fa, $b5fecd57b45662f2$var$fa = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$_D = ()=>($acw62.useEffect(()=>{
            var t;
            return (t = document.body) == null || t.classList.add("body-lock-scroll"), ()=>{
                var e;
                return (e = document.body) == null ? void 0 : e.classList.remove("body-lock-scroll");
            };
        }), $acw62.createElement("div", {
            className: "page-loader"
        }, $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null))), $b5fecd57b45662f2$export$da65322c66e325fa = $b5fecd57b45662f2$var$_D;
});
var $b5fecd57b45662f2$var$BD, $b5fecd57b45662f2$var$yi, $b5fecd57b45662f2$var$dp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$hi();
    $b5fecd57b45662f2$var$ca();
    $b5fecd57b45662f2$var$co();
    $b5fecd57b45662f2$var$da();
    $b5fecd57b45662f2$var$pa();
    $b5fecd57b45662f2$var$fa();
    $b5fecd57b45662f2$var$BD = ({ data: t, renderConfig: e, config: o, children: r })=>{
        var ql, Kl, Zl;
        let { searchString: a, getSearchParams: i, setSearchParams: s } = $b5fecd57b45662f2$var$Pt(), l = (0, $acw62.useMemo)(()=>`datatable:settings:${t.name}`, [
            t.name
        ]), [p, m] = (0, $acw62.useState)(()=>{
            var V, ot;
            let S = t.columns.reduce((iD, sD, lD)=>({
                    ...iD,
                    [sD.key]: {
                        showType: "captioned",
                        order: lD
                    }
                }), {}), w = $b5fecd57b45662f2$export$b2521dd6e4e1a602(l);
            return {
                displayColumns: {
                    ...S,
                    ...(V = w == null ? void 0 : w.displayColumns) != null ? V : {}
                },
                disableMobileLayout: (ot = w == null ? void 0 : w.disableMobileLayout) != null ? ot : !1
            };
        }), c = (0, $acw62.useCallback)((S)=>{
            m(S), $b5fecd57b45662f2$export$66e1b6860596375e(l, S);
        }, []), d = (0, $acw62.useMemo)(()=>({
                ...$b5fecd57b45662f2$var$mo,
                ...o != null ? o : {}
            }), [
            o
        ]), f = (0, $acw62.useMemo)(()=>{
            var S;
            return ((S = t.filters) == null ? void 0 : S.length) > 0;
        }, [
            t.filters
        ]), u = (0, $acw62.useMemo)(()=>{
            var S;
            return (S = i("filter")) != null ? S : {};
        }, [
            a
        ]), g = (0, $acw62.useMemo)(()=>Object.entries(u).length > 0, [
            u
        ]), x = (0, $acw62.useMemo)(()=>t.columns.filter((S)=>{
                var w;
                return ((w = p.displayColumns[S.key]) == null ? void 0 : w.showType) !== "hidden";
            }).map((S)=>({
                    ...S,
                    ...p.displayColumns[S.key]
                })).sort((S, w)=>S.order - w.order), [
            t.columns,
            p.displayColumns
        ]), [v, F] = (0, $acw62.useState)([]), mt = (0, $acw62.useCallback)((S, w)=>{
            F((V)=>w ? [
                    ...V,
                    S
                ] : V.filter((ot)=>ot !== S));
        }, []), st = (0, $acw62.useCallback)((S)=>{
            var w, V;
            return F(S ? (V = (w = t == null ? void 0 : t.data) == null ? void 0 : w.map((ot)=>ot._id)) != null ? V : [] : []);
        }, [
            t == null ? void 0 : t.data
        ]), ft = (0, $acw62.useCallback)((S)=>v.includes(S), [
            v
        ]), It = (0, $acw62.useMemo)(()=>{
            var S;
            return (v == null ? void 0 : v.length) === ((S = t == null ? void 0 : t.data) == null ? void 0 : S.length);
        }, [
            v == null ? void 0 : v.length,
            (ql = t == null ? void 0 : t.data) == null ? void 0 : ql.length
        ]), G = (0, $acw62.useMemo)(()=>{
            let S = i("sort"), w = {};
            return S ? (S.split(",").forEach((V, ot)=>{
                V.substring(0, 1) === "-" ? w[V.substring(1)] = {
                    dir: "desc",
                    order: ot + 1
                } : w[V] = {
                    dir: "asc",
                    order: ot + 1
                };
            }), w) : {};
        }, [
            a
        ]), k = (0, $acw62.useCallback)((S)=>{
            let w = Object.entries(S).filter(([, V])=>V.dir !== null).map(([V, ot])=>(ot.dir === "desc" ? "-" : "") + V);
            s({
                sort: w.length > 0 ? w.join(",") : void 0
            });
        }, []), la = (0, $acw62.useCallback)((S)=>{
            let w = G[S], V = {
                ...G
            }, ot = null;
            w != null && w.dir ? w.dir === "asc" && (ot = "desc") : ot = "asc", V[S] = {
                dir: ot,
                order: 0
            }, k(V);
        }, [
            G
        ]), [jl, si] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            if (e === void 0) {
                si(null);
                return;
            }
            typeof e == "function" ? e().then((S)=>{
                si(S.default);
            }) : si(e);
        }, [
            e
        ]);
        let $l = (0, $acw62.useMemo)(()=>t != null && t.data ? d.clientFilter ? t.data.filter(d.clientFilter) : t.data : [], [
            d.clientFilter,
            t == null ? void 0 : t.data
        ]);
        if (jl === void 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$da65322c66e325fa, null);
        let nD = {
            settings: p,
            setSettings: c,
            showColumns: x,
            data: t,
            rows: $l,
            config: d,
            renderConfig: jl,
            isFilters: f,
            activeFilters: u,
            isActiveFilters: g,
            setSearchParams: s,
            isSort: ((Kl = t == null ? void 0 : t.columns) == null ? void 0 : Kl.filter((S)=>S.isSortable).length) > 0,
            activeSorts: G,
            setSorts: k,
            toggleSort: la,
            hasGroupActions: typeof ((Zl = t == null ? void 0 : t.options) == null ? void 0 : Zl.actionsModel) == "string" && d.tableMode !== "simple",
            rowsSelected: v,
            setRowSelected: mt,
            isAllRowsSelected: It,
            setAllRowsSelected: st,
            isRowSelected: ft,
            isResults: $l.length > 0
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$ua.Provider, {
            value: nD
        }, r);
    }, $b5fecd57b45662f2$var$yi = $b5fecd57b45662f2$var$BD;
});
var $b5fecd57b45662f2$var$P = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$lp();
    $b5fecd57b45662f2$var$dp();
});
var $b5fecd57b45662f2$var$OD, $b5fecd57b45662f2$var$fo, $b5fecd57b45662f2$var$ha = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$OD = ({ children: t })=>$acw62.createElement("th", {
            style: {
                width: "1px"
            },
            className: "align-middle"
        }, t), $b5fecd57b45662f2$var$fo = $b5fecd57b45662f2$var$OD;
});
var $b5fecd57b45662f2$var$LD, $b5fecd57b45662f2$var$gp, $b5fecd57b45662f2$var$hp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ha();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$LD = ()=>{
        let { isAllRowsSelected: t, setAllRowsSelected: e } = $b5fecd57b45662f2$var$h();
        return $acw62.createElement($b5fecd57b45662f2$var$fo, null, $acw62.createElement((0, $9JAYi.default), {
            checked: t,
            onChange: (o)=>e(o.target.checked)
        }));
    }, $b5fecd57b45662f2$var$gp = $b5fecd57b45662f2$var$LD;
});
var $b5fecd57b45662f2$var$VD, $b5fecd57b45662f2$var$yp, $b5fecd57b45662f2$var$xp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ha();
    $b5fecd57b45662f2$var$co();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$VD = ()=>{
        let { getSearchParams: t, setSearchParams: e } = $b5fecd57b45662f2$var$Pt(), { config: { tableMode: o } } = $b5fecd57b45662f2$var$h(), r = $acw62.useCallback((i)=>{
            i.preventDefault(), i.stopPropagation(), e({
                sort: void 0
            });
        }, []), a = !t("sort");
        return $acw62.createElement($b5fecd57b45662f2$var$fo, null, o === "full" ? $acw62.createElement((0, $lzNIT.Link), {
            to: "#",
            className: a ? "link-primary" : "link-secondary",
            onClick: r
        }, "#") : "#");
    }, $b5fecd57b45662f2$var$yp = $b5fecd57b45662f2$var$VD;
});
var $b5fecd57b45662f2$var$GD, $b5fecd57b45662f2$var$bp, $b5fecd57b45662f2$var$Dp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$GD = ({ data: t })=>{
        let { activeSorts: e, toggleSort: o } = $b5fecd57b45662f2$var$h(), r = (0, $acw62.useCallback)((i)=>{
            i.preventDefault(), i.stopPropagation(), o(t.key);
        }, [
            o
        ]), a = (0, $acw62.useMemo)(()=>e[t.key], [
            e
        ]);
        return $acw62.createElement("th", null, $acw62.createElement((0, $lzNIT.Link), {
            to: "#",
            onClick: r,
            className: "d-inline-flex align-items-center"
        }, $acw62.createElement("span", null, t.title), a && $acw62.createElement((0, $gmc0U.default), {
            bg: "primary",
            className: "ms-1 d-inline-flex align-items-center small"
        }, a.order, $acw62.createElement("i", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mdi", {
                "mdi-arrow-down-bold": a.dir === "asc",
                "mdi-arrow-up-bold": a.dir === "desc"
            })
        }))));
    }, $b5fecd57b45662f2$var$bp = $b5fecd57b45662f2$var$GD;
});
var $b5fecd57b45662f2$var$zD, $b5fecd57b45662f2$var$Sp, $b5fecd57b45662f2$var$Cp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Dp();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$zD = ({ data: t })=>{
        let { config: { tableMode: e } } = $b5fecd57b45662f2$var$h();
        return t.isSortable && e !== "simple" ? $acw62.createElement($b5fecd57b45662f2$var$bp, {
            data: t
        }) : $acw62.createElement("th", null, t.title);
    }, $b5fecd57b45662f2$var$Sp = $b5fecd57b45662f2$var$zD;
});
var $b5fecd57b45662f2$var$jD, $b5fecd57b45662f2$var$vp, $b5fecd57b45662f2$var$Ap = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$ha();
    $b5fecd57b45662f2$var$hp();
    $b5fecd57b45662f2$var$xp();
    $b5fecd57b45662f2$var$Cp();
    $b5fecd57b45662f2$var$jD = ()=>{
        let { showColumns: t, hasGroupActions: e, data: { options: { hasIndexes: o, hasRowActions: r } } } = $b5fecd57b45662f2$var$h();
        return $acw62.createElement("thead", null, $acw62.createElement("tr", null, e && $acw62.createElement($b5fecd57b45662f2$var$gp, null), o && $acw62.createElement($b5fecd57b45662f2$var$yp, null), t.map((a)=>$acw62.createElement($b5fecd57b45662f2$var$Sp, {
                key: "col-" + a.key,
                data: a
            })), r && $acw62.createElement($b5fecd57b45662f2$var$fo, null)));
    }, $b5fecd57b45662f2$var$vp = $b5fecd57b45662f2$var$jD;
});
var $b5fecd57b45662f2$var$Rp, $b5fecd57b45662f2$var$$D, $b5fecd57b45662f2$var$qD, $b5fecd57b45662f2$var$ya, $b5fecd57b45662f2$var$Di = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Rp = ({ value: t })=>t === null ? null : typeof t != "string" ? t != null && t.toString ? t.toString() : "[unknown value " + typeof t + "]" : t, $b5fecd57b45662f2$var$$D = ({ renderConfig: t, ...e })=>!t || !t[e.name] ? $acw62.createElement($b5fecd57b45662f2$var$Rp, {
            ...e
        }) : $acw62.createElement($acw62.Fragment, null, t[e.name](e)), $b5fecd57b45662f2$var$qD = (t)=>{
        let { renderConfig: e } = $b5fecd57b45662f2$var$h();
        return e ? $acw62.createElement($b5fecd57b45662f2$var$$D, {
            ...t,
            renderConfig: e
        }) : $acw62.createElement($b5fecd57b45662f2$var$Rp, {
            ...t
        });
    }, $b5fecd57b45662f2$var$ya = $b5fecd57b45662f2$var$qD;
});
var $b5fecd57b45662f2$var$ZD, $b5fecd57b45662f2$var$kp, $b5fecd57b45662f2$var$Fp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Di();
    $b5fecd57b45662f2$var$ZD = ({ col: t, data: e })=>{
        let o = (0, $acw62.useMemo)(()=>{
            var r;
            return (r = e[t.key]) != null ? r : null;
        }, [
            e,
            t.key
        ]);
        return $acw62.createElement("td", null, $acw62.createElement($b5fecd57b45662f2$var$ya, {
            name: t.key,
            value: o,
            data: e
        }));
    }, $b5fecd57b45662f2$var$kp = $b5fecd57b45662f2$var$ZD;
});
function $b5fecd57b45662f2$var$wp(t) {
    return typeof t < "u" && typeof t.route == "string";
}
function $b5fecd57b45662f2$var$Pp(t, e) {
    return typeof t < "u" && "action" in t && t.action === e;
}
var $b5fecd57b45662f2$var$Tp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$QD, $b5fecd57b45662f2$var$xa, $b5fecd57b45662f2$var$vi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$QD = ({ icon: t, title: e, className: o, buttonVariant: r, onClick: a })=>$acw62.createElement((0, $6LAgE.default), {
            title: e,
            onClick: a,
            variant: r,
            className: o
        }, t && $acw62.createElement("i", {
            className: `mdi mdi-${t}`
        })), $b5fecd57b45662f2$var$xa = $b5fecd57b45662f2$var$QD;
});
var $b5fecd57b45662f2$var$e0, $b5fecd57b45662f2$var$Np, $b5fecd57b45662f2$var$_p = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$vi();
    $b5fecd57b45662f2$var$e0 = ({ action: t, className: e })=>{
        let o = (0, $aphAM.useNavigate)(), r = ()=>o(t.route);
        return $acw62.createElement($b5fecd57b45662f2$var$xa, {
            icon: t.icon,
            title: t.title,
            className: e,
            buttonVariant: t.buttonVariant,
            onClick: r
        });
    }, $b5fecd57b45662f2$var$Np = $b5fecd57b45662f2$var$e0;
});
function $b5fecd57b45662f2$export$33ffd74ebf07f060(t = {
    initialState: !1
}) {
    var m, c;
    let [e, o] = (0, $acw62.useState)((m = t.initialState) != null ? m : !1), [r, a] = (0, $acw62.useState)((c = t.initialData) != null ? c : null), i = (0, $acw62.useCallback)(()=>{
        o(!0), t.onOpen && t.onOpen();
    }, [
        t.onOpen
    ]), s = (0, $acw62.useCallback)(()=>{
        o(!1), t.onClose && t.onClose();
    }, [
        t.onClose
    ]), l = (0, $acw62.useCallback)(()=>{
        o(!1);
    }, []), p = (0, $acw62.useCallback)(()=>{
        o((d)=>!d);
    }, []);
    return {
        state: e,
        open: i,
        close: s,
        closeSilent: l,
        toggle: p,
        data: r,
        setData: a,
        onExited: t.onExited
    };
}
var $b5fecd57b45662f2$var$ue = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$a0, $b5fecd57b45662f2$export$2b77a92f1a5ad772, $b5fecd57b45662f2$var$ho = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$a0 = ({ title: t, titleBg: e, children: o, centered: r = !0, state: a, lockClose: i, ...s })=>{
        let l = (0, $acw62.useMemo)(()=>{
            if (e && [
                "success",
                "danger",
                "primary",
                "info"
            ].includes(e)) return "white";
        }, [
            e
        ]), p = ()=>{
            i || a.close();
        };
        return $acw62.createElement((0, $gBH4L.default), {
            show: a.state,
            onHide: p,
            onExited: a.onExited,
            centered: r,
            backdrop: i ? "static" : !0,
            ...s
        }, $acw62.createElement((0, $gBH4L.default).Header, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("py-0", {
                [`text-bg-${e}`]: !!e
            }),
            closeButton: !i,
            closeVariant: l
        }, $acw62.createElement((0, $gBH4L.default).Title, null, t)), o);
    }, $b5fecd57b45662f2$export$2b77a92f1a5ad772 = Object.assign($b5fecd57b45662f2$var$a0, {
        Body: (0, $gBH4L.default).Body,
        Footer: (0, $gBH4L.default).Footer
    });
});
function $b5fecd57b45662f2$export$bf4da147a5964edb(t) {
    let { title: e = "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0434\u0456\u0457", submitText: o = "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438", cancelText: r = "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438", color: a = "danger", text: i, handleContinue: s, handleClose: l, handleExit: p, initialModalState: m = !1 } = t, c = $b5fecd57b45662f2$export$33ffd74ebf07f060({
        initialState: m,
        onExited: p
    }), [d, f] = $acw62.useState(), [u, g] = $acw62.useState(!1), x = $acw62.useCallback(()=>{
        c.open();
    }, []), v = $acw62.useCallback(()=>{
        c.close(), l && l();
    }, []), F = $acw62.useCallback(()=>{
        g(!0), f(void 0);
        let st = s();
        st instanceof Promise ? st.then(()=>c.close()).catch((ft)=>f(ft)).finally(()=>g(!1)) : (c.close(), g(!1));
    }, [
        s
    ]), mt = $acw62.useMemo(()=>$acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772, {
            state: c,
            title: e,
            titleBg: a,
            centered: !0,
            lockClose: u,
            backdropClassName: "modal-backdrop-nested",
            className: "modal-nested"
        }, $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772.Body, null, d && $acw62.createElement((0, $cpxrl.default), {
            variant: "danger"
        }, d), $acw62.createElement("div", null, i)), $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772.Footer, null, $acw62.createElement((0, $6LAgE.default), {
            variant: a,
            onClick: F,
            disabled: u
        }, o), $acw62.createElement((0, $6LAgE.default), {
            variant: "secondary",
            onClick: v,
            disabled: u
        }, r))), [
        c.state,
        e,
        a,
        d,
        i,
        u,
        o,
        r,
        F,
        v
    ]);
    return {
        handleClick: x,
        ConfirmModal: mt
    };
}
var $b5fecd57b45662f2$var$Sa = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ue();
    $b5fecd57b45662f2$var$ho();
});
var $b5fecd57b45662f2$export$fc8a1cc6d4fd1a88, $b5fecd57b45662f2$var$xo = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$export$fc8a1cc6d4fd1a88 = ((a)=>(a[a.Idle = 0] = "Idle", a[a.Submitting = 1] = "Submitting", a[a.Success = 2] = "Success", a[a.Error = 3] = "Error", a))($b5fecd57b45662f2$export$fc8a1cc6d4fd1a88 || {});
});
function $b5fecd57b45662f2$var$lt() {
    let t = (0, $acw62.useContext)($b5fecd57b45662f2$var$Lp);
    if (!t) throw new Error("FormOptionsContext is not provided");
    return t;
}
var $b5fecd57b45662f2$var$s0, $b5fecd57b45662f2$var$Lp, $b5fecd57b45662f2$var$Xp, $b5fecd57b45662f2$var$qt = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$xo();
    $b5fecd57b45662f2$var$s0 = {
        name: "form",
        feedbackType: "tooltip",
        formStatus: 0
    }, $b5fecd57b45662f2$var$Lp = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $b5fecd57b45662f2$var$Xp = ({ children: t, ...e })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Lp.Provider, {
            value: {
                ...$b5fecd57b45662f2$var$s0,
                ...e
            }
        }, t);
});
function $b5fecd57b45662f2$export$4b79bd8f34740571(t) {
    let e = (0, $acw62.useMemo)(()=>typeof t == "function" ? t() : t, []), [o, r] = (0, $acw62.useReducer)($b5fecd57b45662f2$var$c0, {
        updateIdx: 0,
        data: e.getData()
    });
    return (0, $acw62.useEffect)(()=>{
        let a = e.subscribe(()=>{
            r(e.getData());
        });
        return ()=>a();
    }, []), o.data;
}
var $b5fecd57b45662f2$var$c0, $b5fecd57b45662f2$var$_ = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$c0 = (t, e)=>({
            updateIdx: t.updateIdx + 1,
            data: e
        });
});
function $b5fecd57b45662f2$export$fdc397e486fa83e7() {
    let t = $acw62.useContext($b5fecd57b45662f2$var$Vp);
    if (!t) throw new Error("useAppContext must be used within a ApplicationContextProvider");
    return t;
}
function $b5fecd57b45662f2$export$a3e0ece8c3f698d7() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().config;
}
function $b5fecd57b45662f2$export$a9d1b6bbcaa78af1() {
    return $b5fecd57b45662f2$export$a3e0ece8c3f698d7().base;
}
function $b5fecd57b45662f2$export$f1d07fa4061ab6b1(t, e) {
    var r;
    let o = (r = $b5fecd57b45662f2$export$a3e0ece8c3f698d7().external) == null ? void 0 : r[t];
    if (!o || !e(o)) throw new Error("Invalid external config data");
    return o;
}
function $b5fecd57b45662f2$export$719b7bd3d9a721a9() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().actions;
}
function $b5fecd57b45662f2$export$c594d3118da9430d() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().auth;
}
function $b5fecd57b45662f2$export$846279b0d7f2d98d() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().navigation;
}
function $b5fecd57b45662f2$export$5425318366a9780c() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().toasts;
}
function $b5fecd57b45662f2$export$8ce16a1f3a483377() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().helpers;
}
function $b5fecd57b45662f2$export$d47fd796db1c6664() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().router;
}
function $b5fecd57b45662f2$export$5f78f356137e000a() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().search;
}
function $b5fecd57b45662f2$export$a70634c62f743f5f() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().services;
}
function $b5fecd57b45662f2$export$45bb9e733e328a26() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().pageContext;
}
function $b5fecd57b45662f2$export$101fe40f41b35148() {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().websocket;
}
function $b5fecd57b45662f2$export$ff791c79b16a1b08() {
    let t = $b5fecd57b45662f2$export$45bb9e733e328a26();
    return $b5fecd57b45662f2$export$4b79bd8f34740571(t);
}
function $b5fecd57b45662f2$export$e69cda64f05dea11(t, e) {
    return $b5fecd57b45662f2$export$fdc397e486fa83e7().services.get(t, e);
}
var $b5fecd57b45662f2$var$Vp, $b5fecd57b45662f2$var$Yp, $b5fecd57b45662f2$var$Ri = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$Vp = $acw62.createContext(void 0);
    $b5fecd57b45662f2$var$Yp = $b5fecd57b45662f2$var$Vp;
});
var $b5fecd57b45662f2$var$b = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ri();
});
var $b5fecd57b45662f2$var$h0, $b5fecd57b45662f2$var$y0, $b5fecd57b45662f2$var$zp, $b5fecd57b45662f2$var$jp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$h0 = (t)=>{
        var o, r;
        if (!(0, $ifGBV.isApiValidationError)(t)) throw new Error("Invalid error type");
        let e = (0, $fmlaG.default)(t);
        return ((o = e.unknown) == null ? void 0 : o.length) > 0 ? e.unknown.length === 1 ? e.unknown[0] : e.unknown : ((r = e.global) == null ? void 0 : r.length) > 0 ? e.global.length === 1 ? e.global[0] : e.global : "\u0414\u0430\u043D\u0456 \u0444\u043E\u0440\u043C\u0438 \u043C\u0456\u0441\u0442\u044F\u0442\u044C \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \u0430\u0431\u043E \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C \u0432\u0438\u043C\u043E\u0433\u0430\u043C. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0444\u043E\u0440\u043C\u0443 \u0442\u0430 \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.";
    }, $b5fecd57b45662f2$var$y0 = (t, e)=>{
        let o = (a)=>{
            let i = (0, (/*@__PURE__*/$parcel$interopDefault($4mPkP))).pick(a, e.control._fields);
            return i && !Array.isArray(i);
        };
        if ((0, $ifGBV.isApiValidationError)(t)) {
            let a = [];
            return (0, $9lLem.default)(t, (i, s)=>{
                i === "unknown" || i === "global" || (o(i) ? e.setError(i, {
                    type: "server",
                    message: s.join("; ")
                }) : a.push(...s));
            }), {
                errorTitle: $b5fecd57b45662f2$var$h0(t),
                globalErrors: a
            };
        }
        return {
            errorTitle: (0, $9PE8j.default)(t)
        };
    }, $b5fecd57b45662f2$var$zp = $b5fecd57b45662f2$var$y0;
});
var $b5fecd57b45662f2$var$x0, $b5fecd57b45662f2$var$$p, $b5fecd57b45662f2$var$qp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$x0 = ({ errorTitle: t, globalErrors: e })=>$acw62.createElement($acw62.Fragment, null, Array.isArray(t) ? $acw62.createElement("ul", {
            className: "my-0"
        }, t.map((o, r)=>$acw62.createElement("li", {
                key: `error-${r}`
            }, o))) : $acw62.createElement("div", null, t), e && e.length > 0 && $acw62.createElement("ul", {
            className: "mt-1 mb-0"
        }, e.map((o, r)=>$acw62.createElement("li", {
                key: `error-${r}`
            }, o)))), $b5fecd57b45662f2$var$$p = $b5fecd57b45662f2$var$x0;
});
var $b5fecd57b45662f2$var$D0, $b5fecd57b45662f2$var$ka, $b5fecd57b45662f2$var$ki = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$xo();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$jp();
    $b5fecd57b45662f2$var$qp();
    $b5fecd57b45662f2$var$D0 = ({ name: t, handleSubmit: e, feedbackType: o, showSuccess: r = !0, methods: a, children: i, ...s })=>{
        let l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(), p = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(), [m, c] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), d = $b5fecd57b45662f2$export$5425318366a9780c(), f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            c(0), l.current && (clearTimeout(l.current), l.current = void 0), p.current && (p.current.delete(), p.current = void 0);
        }, []), u = async (g)=>{
            g.preventDefault(), g.stopPropagation(), f(), c(1);
            try {
                await a.handleSubmit(e)(g), c(2), r && (p.current = d.createToast({
                    body: typeof r == "string" ? r : "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456",
                    variant: "success"
                }));
            } catch (x) {
                c(3);
                let v = $b5fecd57b45662f2$var$zp(x, a);
                p.current = d.createToast({
                    body: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$$p, {
                        ...v
                    }),
                    variant: "danger"
                });
            } finally{
                l.current = setTimeout(f, 5e3);
            }
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Xp, {
            name: t,
            formStatus: m,
            feedbackType: o
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22i8b.FormProvider), {
            ...s,
            ...a
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
            onSubmit: u
        }, i)));
    }, $b5fecd57b45662f2$var$ka = $b5fecd57b45662f2$var$D0;
});
function $b5fecd57b45662f2$var$C0(t, e) {
    let [o] = (0, $lzNIT.useSearchParams)(), r = (0, $acw62.useMemo)(()=>{
        if (!t) return {};
        let a = {};
        for (let i of t){
            let s = o.get(i);
            s && (a[i] = s);
        }
        return a;
    }, [
        t
    ]);
    return (0, $acw62.useMemo)(()=>({
            ...r,
            ...e != null ? e : {}
        }), []);
}
function $b5fecd57b45662f2$var$v0(t) {
    return (0, $acw62.useMemo)(()=>({
            ...t != null ? t : {}
        }), []);
}
function $b5fecd57b45662f2$var$ar(t, e) {
    return e ? $b5fecd57b45662f2$var$C0(e, t) : $b5fecd57b45662f2$var$v0(t);
}
var $b5fecd57b45662f2$var$wi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$R0, $b5fecd57b45662f2$var$So, $b5fecd57b45662f2$var$Fa = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ki();
    $b5fecd57b45662f2$var$wi();
    $b5fecd57b45662f2$var$R0 = ({ data: t, children: e, urlValues: o, handleSubmit: r, ...a })=>{
        let i = $b5fecd57b45662f2$var$ar(t, o), s = (0, $22i8b.useForm)({
            defaultValues: i
        });
        return $acw62.createElement($b5fecd57b45662f2$var$ka, {
            ...a,
            methods: s,
            handleSubmit: r,
            children: e
        });
    }, $b5fecd57b45662f2$var$So = $b5fecd57b45662f2$var$R0;
});
function $b5fecd57b45662f2$export$baf341815cf7915b() {
    let t = (0, $aphAM.useMatches)(), e = (0, $aphAM.useLocation)();
    return (0, $acw62.useMemo)(()=>{
        let o = t.findIndex(({ pathname: r })=>r === e.pathname);
        return t.slice(0, o + 1).filter((r)=>typeof r.handle < "u").map((r)=>{
            let a = r.handle;
            return {
                name: a.name(r.data),
                title: a.title(r.data),
                url: r.pathname,
                breadcrumb: a.breadcrumb(r.data, r.pathname),
                titleLinks: a.titleLinks(r.data),
                titleEnd: a.titleEnd(r.data),
                actionHandler: async (i)=>{
                    var s;
                    await ((s = a.actionHandler) == null ? void 0 : s.call(a, i, r.params));
                }
            };
        });
    }, [
        t,
        e.pathname
    ]);
}
var $b5fecd57b45662f2$var$nr = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$M0, $b5fecd57b45662f2$var$Jp, $b5fecd57b45662f2$var$Qp = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Fa();
    $b5fecd57b45662f2$var$nr();
    $b5fecd57b45662f2$var$M0 = ({ onSuccess: t, children: e, ...o })=>{
        let { data: r } = (0, $aphAM.useLoaderData)(), a = (0, $aphAM.useNavigate)(), i = $b5fecd57b45662f2$export$baf341815cf7915b(), { actionHandler: s } = (0, $acw62.useMemo)(()=>{
            var m;
            return (m = i.slice(-1)[0]) != null ? m : {};
        }, [
            i
        ]), { url: l } = (0, $acw62.useMemo)(()=>{
            var m;
            return (m = i.slice(-2)[0]) != null ? m : {};
        }, [
            i
        ]), p = $acw62.useCallback(async (m)=>{
            if (!s) throw new Error("No action handler found");
            let c = await s(m);
            return t ? t(m, c) : l && a(l), c;
        }, [
            s,
            l
        ]);
        return $acw62.createElement($b5fecd57b45662f2$var$So, {
            ...o,
            data: r,
            handleSubmit: p
        }, e);
    }, $b5fecd57b45662f2$var$Jp = $b5fecd57b45662f2$var$M0;
});
var $b5fecd57b45662f2$var$_0, $b5fecd57b45662f2$var$tm, $b5fecd57b45662f2$var$em = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Fa();
    $b5fecd57b45662f2$var$_0 = ({ submitEndpoint: t, submitMethod: e = "update", successCallback: o, children: r, ...a })=>{
        let i = $acw62.useCallback((s)=>new Promise(async (l, p)=>{
                try {
                    let m = await (0, $ket0H.default)[e](t, s);
                    m.status !== 204 ? l(m.data) : l(), o && o(s, m.data);
                } catch (m) {
                    p(m);
                }
            }), []);
        return $acw62.createElement($b5fecd57b45662f2$var$So, {
            ...a,
            handleSubmit: i
        }, r);
    }, $b5fecd57b45662f2$var$tm = $b5fecd57b45662f2$var$_0;
});
var $b5fecd57b45662f2$var$B0, $b5fecd57b45662f2$var$om, $b5fecd57b45662f2$var$rm = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$B0 = ({ title: t, titleSize: e = 3, info: o, children: r })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "mb-2"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: `fs-${e} fw-bold`
        }, t), o && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "text-muted small"
        }, o)), r), $b5fecd57b45662f2$var$om = $b5fecd57b45662f2$var$B0;
});
function $b5fecd57b45662f2$var$yt(t) {
    let { formState: { errors: e } } = (0, $22i8b.useFormContext)(), o = (0, (/*@__PURE__*/$parcel$interopDefault($4mPkP))).pick(t, e), r = (0, $acw62.useMemo)(()=>o ? Array.isArray(o) ? o.map((a)=>a.message).join("; ") : o.message : null, [
        o
    ]);
    return {
        isError: !!r,
        errorMessage: r
    };
}
var $b5fecd57b45662f2$var$Co = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$U0, $b5fecd57b45662f2$export$28c660c63b792dea, $b5fecd57b45662f2$var$Mi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$U0 = ({ text: t, children: e, placement: o = "top" })=>$acw62.createElement((0, $5o2go.default), {
            defaultShow: !1,
            trigger: [
                "hover",
                "focus"
            ],
            delay: {
                show: 0,
                hide: 0
            },
            flip: void 0,
            onHide: void 0,
            onToggle: void 0,
            popperConfig: void 0,
            show: void 0,
            target: void 0,
            placement: o,
            overlay: (a)=>$acw62.createElement((0, $N43sL.default), {
                    ...a,
                    style: {
                        position: "relative",
                        ...a.style
                    }
                }, t)
        }, e), $b5fecd57b45662f2$export$28c660c63b792dea = $b5fecd57b45662f2$var$U0;
});
var $b5fecd57b45662f2$var$W0, $b5fecd57b45662f2$var$Ma, $b5fecd57b45662f2$var$_i = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Mi();
    $b5fecd57b45662f2$var$W0 = ({ text: t, icon: e = "help-circle-outline", placement: o })=>$acw62.createElement($b5fecd57b45662f2$export$28c660c63b792dea, {
            text: t,
            placement: o
        }, $acw62.createElement("i", {
            className: `mdi mdi-${e} link-secondary ms-1`
        })), $b5fecd57b45662f2$var$Ma = $b5fecd57b45662f2$var$W0;
});
var $b5fecd57b45662f2$var$Y0, $b5fecd57b45662f2$var$Na, $b5fecd57b45662f2$var$Oi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$_i();
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$Y0 = ({ name: t, children: e, isHorizontal: o = !1, tooltip: r, tooltipIcon: a, tooltipPlacement: i })=>{
        let { name: s } = $b5fecd57b45662f2$var$lt(), l = t ? s + "." + t : void 0;
        return $acw62.createElement((0, $81s7d.default), {
            htmlFor: l,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                "col-3 col-form-label": o
            })
        }, e, r && $acw62.createElement($b5fecd57b45662f2$var$Ma, {
            text: r,
            icon: a,
            placement: i
        }));
    }, $b5fecd57b45662f2$var$Na = $b5fecd57b45662f2$var$Y0;
});
var $b5fecd57b45662f2$var$K0, $b5fecd57b45662f2$var$Z0, $b5fecd57b45662f2$var$Q, $b5fecd57b45662f2$var$Jt = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Co();
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$Oi();
    $b5fecd57b45662f2$var$K0 = ({ isHorizontal: t, children: e })=>t ? $acw62.createElement((0, $99eL8.default), {
            xs: 9
        }, e) : $acw62.createElement($acw62.Fragment, null, e), $b5fecd57b45662f2$var$Z0 = ({ name: t, controlId: e, label: o, text: r, groupClass: a, layout: i, children: s, tooltip: l, tooltipPlacement: p, tooltipIcon: m, ...c })=>{
        let { name: d } = $b5fecd57b45662f2$var$lt(), { register: f, control: u } = (0, $22i8b.useFormContext)(), { isError: g, errorMessage: x } = $b5fecd57b45662f2$var$yt(t), v = e != null ? e : `${d}.${t}`, F = i === "horizontal";
        return $acw62.createElement((0, $81OvX.default), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(a != null ? a : "mb-3", {
                row: F
            }),
            controlId: v
        }, !!o && $acw62.createElement($b5fecd57b45662f2$var$Na, {
            children: o,
            tooltip: l,
            tooltipIcon: m,
            tooltipPlacement: p,
            isHorizontal: F
        }), $acw62.createElement($b5fecd57b45662f2$var$K0, {
            isHorizontal: F
        }, s({
            isError: g,
            errorMessage: x,
            controlId: v,
            register: f,
            control: u,
            props: c
        }), !!r && $acw62.createElement((0, $8CrHJ.default).Text, null, r)));
    }, $b5fecd57b45662f2$var$Q = $b5fecd57b45662f2$var$Z0;
});
var $b5fecd57b45662f2$var$Q0, $b5fecd57b45662f2$var$xt, $b5fecd57b45662f2$var$Ue = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$Q0 = ({ isError: t, errorMessage: e })=>{
        let { feedbackType: o } = $b5fecd57b45662f2$var$lt();
        return t ? $acw62.createElement((0, $8CrHJ.default).Control.Feedback, {
            type: "invalid",
            tooltip: o === "tooltip",
            className: "force-display"
        }, e != null ? e : "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430") : null;
    }, $b5fecd57b45662f2$var$xt = $b5fecd57b45662f2$var$Q0;
});
var $b5fecd57b45662f2$var$tS, $b5fecd57b45662f2$var$ge, $b5fecd57b45662f2$var$ir = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$Ue();
    $b5fecd57b45662f2$var$tS = ({ name: t, prepend: e, append: o, children: r, label: a, text: i, groupClass: s, layout: l, tooltip: p, tooltipIcon: m, tooltipPlacement: c, ...d })=>$acw62.createElement($b5fecd57b45662f2$var$Q, {
            name: t,
            label: a,
            text: i,
            groupClass: s,
            layout: l,
            tooltip: p,
            tooltipIcon: m,
            tooltipPlacement: c
        }, ({ isError: f, errorMessage: u, controlId: g, register: x, control: v })=>$acw62.createElement((0, $6WSsf.default), {
                hasValidation: !0
            }, !!e && $acw62.createElement((0, $6WSsf.default).Text, {
                id: g + ".prepend"
            }, e), r({
                isError: f,
                controlId: g,
                register: x,
                control: v,
                props: d
            }), !!o && $acw62.createElement((0, $6WSsf.default).Text, {
                id: g + ".append"
            }, o), $acw62.createElement($b5fecd57b45662f2$var$xt, {
                isError: f,
                errorMessage: u
            }))), $b5fecd57b45662f2$var$ge = $b5fecd57b45662f2$var$tS;
});
var $b5fecd57b45662f2$var$im = $b5fecd57b45662f2$var$pi((XM, nm)=>{
    "use strict";
    var eS = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    nm.exports = eS;
});
var $b5fecd57b45662f2$var$mm = $b5fecd57b45662f2$var$pi((VM, pm)=>{
    "use strict";
    var oS = $b5fecd57b45662f2$var$im();
    function sm() {}
    function lm() {}
    lm.resetWarningCache = sm;
    pm.exports = function() {
        function t(r, a, i, s, l, p) {
            if (p !== oS) {
                var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw m.name = "Invariant Violation", m;
            }
        }
        t.isRequired = t;
        function e() {
            return t;
        }
        var o = {
            array: t,
            bigint: t,
            bool: t,
            func: t,
            number: t,
            object: t,
            string: t,
            symbol: t,
            any: t,
            arrayOf: e,
            element: t,
            elementType: t,
            instanceOf: e,
            node: t,
            objectOf: e,
            oneOf: e,
            oneOfType: e,
            shape: e,
            exact: e,
            checkPropTypes: lm,
            resetWarningCache: sm
        };
        return o.PropTypes = o, o;
    };
});
var $b5fecd57b45662f2$var$Li = $b5fecd57b45662f2$var$pi((EM, cm)=>{
    cm.exports = $b5fecd57b45662f2$var$mm()();
    var UM, WM;
});
var $b5fecd57b45662f2$var$j, $b5fecd57b45662f2$var$Xi, $b5fecd57b45662f2$var$Ao, $b5fecd57b45662f2$var$_a = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$j = $b5fecd57b45662f2$var$Jl($b5fecd57b45662f2$var$Li());
    $b5fecd57b45662f2$var$ir();
    $b5fecd57b45662f2$var$Xi = ({ type: t, name: e, ...o })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$ge, {
            ...o,
            name: e
        }, ({ isError: r, register: a, props: i })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48fuN.default), {
                type: t,
                as: t === "textarea" ? "textarea" : "input",
                ...i,
                isInvalid: r,
                ...a(e)
            }));
    $b5fecd57b45662f2$var$Xi.propTypes = {
        ...(0, $48fuN.default).propTypes,
        label: $b5fecd57b45662f2$var$j.default.oneOfType([
            $b5fecd57b45662f2$var$j.default.string,
            $b5fecd57b45662f2$var$j.default.element
        ]),
        name: $b5fecd57b45662f2$var$j.default.string.isRequired,
        type: $b5fecd57b45662f2$var$j.default.string,
        placeholder: $b5fecd57b45662f2$var$j.default.string,
        groupClass: $b5fecd57b45662f2$var$j.default.string,
        text: $b5fecd57b45662f2$var$j.default.oneOfType([
            $b5fecd57b45662f2$var$j.default.string,
            $b5fecd57b45662f2$var$j.default.element
        ]),
        prepend: $b5fecd57b45662f2$var$j.default.oneOfType([
            $b5fecd57b45662f2$var$j.default.string,
            $b5fecd57b45662f2$var$j.default.element
        ]),
        append: $b5fecd57b45662f2$var$j.default.oneOfType([
            $b5fecd57b45662f2$var$j.default.string,
            $b5fecd57b45662f2$var$j.default.element
        ])
    };
    $b5fecd57b45662f2$var$Xi.defaultProps = {
        label: null,
        type: "text",
        name: "name",
        placeholder: null,
        text: null,
        prepend: null,
        append: null,
        options: null
    };
    $b5fecd57b45662f2$var$Ao = $b5fecd57b45662f2$var$Xi;
});
var $b5fecd57b45662f2$var$sS, $b5fecd57b45662f2$var$Ba, $b5fecd57b45662f2$var$Vi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Co();
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$sS = ({ type: t = "checkbox", name: e, label: o, value: r = 1, disabled: a, readOnly: i, className: s, controlId: l })=>{
        let { register: p } = (0, $22i8b.useFormContext)(), { name: m, feedbackType: c } = $b5fecd57b45662f2$var$lt(), { isError: d, errorMessage: f } = $b5fecd57b45662f2$var$yt(e);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8CrHJ.default).Check, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("position-relative user-select-none", s),
            type: t,
            label: o,
            value: r,
            id: l != null ? l : `${m}.${e}.${r}`,
            isInvalid: d,
            feedback: f,
            feedbackType: "invalid",
            feedbackTooltip: c === "tooltip",
            disabled: a,
            readOnly: i,
            ...p(e)
        });
    }, $b5fecd57b45662f2$var$Ba = $b5fecd57b45662f2$var$sS;
});
var $b5fecd57b45662f2$var$pS, $b5fecd57b45662f2$var$fm, $b5fecd57b45662f2$var$gm = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ir();
    $b5fecd57b45662f2$var$pS = ({ name: t, options: e, ...o })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$ge, {
            name: t,
            ...o
        }, ({ isError: r, register: a, props: i })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $azy33.default), {
                ...i,
                ...a(t),
                isInvalid: r
            }, e.map((s, l)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                    key: "option-" + l,
                    value: s.value
                }, s.label)))), $b5fecd57b45662f2$var$fm = $b5fecd57b45662f2$var$pS;
});
var $b5fecd57b45662f2$var$fS, $b5fecd57b45662f2$var$gS, $b5fecd57b45662f2$var$Ro, $b5fecd57b45662f2$var$Oa = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$Ue();
    $b5fecd57b45662f2$var$fS = (t)=>t ? (Array.isArray(t) ? t : [
            t
        ]).map((e)=>e == null ? void 0 : e.toString()) : [], $b5fecd57b45662f2$var$gS = ({ name: t, options: e, placeholder: o, isMulti: r = !1, allowEmpty: a, disableValues: i, disabled: s, ...l })=>{
        let p = (0, $acw62.useCallback)((m)=>i ? i.indexOf(m.value.toString()) !== -1 : !1, [
            i
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Q, {
            name: t,
            ...l
        }, ({ isError: m, errorMessage: c, control: d })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22i8b.Controller), {
                name: t,
                control: d,
                render: ({ field: { value: f, onChange: u, ref: g } })=>{
                    let x = (F)=>{
                        var mt;
                        if (!F) {
                            u(r ? [] : null);
                            return;
                        }
                        if (r) {
                            u((mt = F == null ? void 0 : F.map((st)=>st.value)) != null ? mt : []);
                            return;
                        }
                        u(F ? F == null ? void 0 : F.value : null);
                    }, v = $b5fecd57b45662f2$var$fS(f);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        className: "position-relative"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a3QyA.default), {
                        ref: g,
                        options: e,
                        isClearable: a,
                        isMulti: r,
                        isOptionSelected: p,
                        value: (e != null ? e : []).filter((F)=>v.indexOf(F.value.toString()) !== -1),
                        onChange: x,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("react-select", {
                            "is-invalid": m
                        }),
                        classNamePrefix: "react-select",
                        placeholder: o,
                        isDisabled: s
                    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$xt, {
                        isError: m,
                        errorMessage: c
                    }));
                }
            }));
    }, $b5fecd57b45662f2$var$Ro = $b5fecd57b45662f2$var$gS;
});
var $b5fecd57b45662f2$var$DS, $b5fecd57b45662f2$var$SS, $b5fecd57b45662f2$var$CS, $b5fecd57b45662f2$var$vS, $b5fecd57b45662f2$var$AS, $b5fecd57b45662f2$var$ym, $b5fecd57b45662f2$var$xm = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$DS = (t)=>t.map((e)=>typeof e == "string" ? {
                value: e,
                label: e
            } : {
                value: e.value,
                label: e.label
            }), $b5fecd57b45662f2$var$SS = (t, e)=>e ? t.map((o)=>o.value.toString()) : t.length > 0 ? t[0].value.toString() : null, $b5fecd57b45662f2$var$CS = (t)=>Array.isArray(t) ? t : t ? [
            t
        ] : [], $b5fecd57b45662f2$var$vS = ({ controlId: t, isError: e, value: o, onChange: r, endpoint: a, multiple: i, clearButton: s, promptText: l, emptyLabel: p, placeholder: m, searchText: c })=>{
        let d = $acw62.useRef(), [f, u] = $acw62.useState([]), [g, x] = $acw62.useState([]), [v, F] = $acw62.useState(!1), [mt, st] = $acw62.useState(!1), ft = $acw62.useCallback((G)=>{
            let k = $b5fecd57b45662f2$var$DS(G);
            u(k);
            let la = $b5fecd57b45662f2$var$SS(k, i);
            r(la), d.current = la;
        }, []), It = $acw62.useCallback((G)=>{
            F(!0), (0, $ket0H.default).getData(a, {
                query: G
            }).then((k)=>x(k)).catch((k)=>console.error(k)).finally(()=>F(!1));
        }, []);
        return $acw62.useEffect(()=>{
            o !== d.current && (st(!0), (0, $ket0H.default).getData(a, {
                ids: $b5fecd57b45662f2$var$CS(o)
            }).then((G)=>u(G)).catch((G)=>console.error(G)).finally(()=>st(!1)));
        }, [
            o
        ]), $acw62.createElement((0, $fEyWK.default), {
            id: t,
            isLoading: v || mt,
            filterBy: ()=>!0,
            minLength: 3,
            clearButton: s,
            multiple: i,
            promptText: l != null ? l : "\u041F\u043E\u0447\u043D\u0456\u0442\u044C \u0432\u0432\u043E\u0434\u0438\u0442\u0438...",
            emptyLabel: p != null ? p : "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
            placeholder: m != null ? m : "\u041F\u043E\u0447\u043D\u0456\u0442\u044C \u0432\u0432\u043E\u0434\u0438\u0442\u0438 \u0434\u043B\u044F \u043F\u043E\u0448\u0443\u043A\u0443",
            searchText: c != null ? c : $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $4dB0L.default), {
                animation: "border",
                size: "sm",
                className: "me-1"
            }), " \u0406\u0434\u0435 \u043F\u043E\u0448\u0443\u043A, \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435..."),
            onSearch: It,
            options: g,
            isInvalid: e,
            selected: f,
            onChange: ft,
            labelKey: "label"
        });
    }, $b5fecd57b45662f2$var$AS = ({ name: t, endpoint: e, multiple: o, clearButton: r, promptText: a, emptyLabel: i, placeholder: s, searchText: l, ...p })=>$acw62.createElement($b5fecd57b45662f2$var$Q, {
            name: t,
            ...p
        }, ({ control: m, isError: c, errorMessage: d, controlId: f })=>$acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $22i8b.Controller), {
                control: m,
                name: t,
                render: ({ field: { value: u, onChange: g } })=>$acw62.createElement($b5fecd57b45662f2$var$vS, {
                        controlId: f,
                        endpoint: e,
                        multiple: o,
                        clearButton: r,
                        promptText: a,
                        emptyLabel: i,
                        placeholder: s,
                        searchText: l,
                        isError: c,
                        value: u != null ? u : [],
                        onChange: g
                    })
            }), c && $acw62.createElement((0, $48fuN.default).Feedback, {
                type: "invalid"
            }, d))), $b5fecd57b45662f2$var$ym = $b5fecd57b45662f2$var$AS;
});
var $b5fecd57b45662f2$var$FS, $b5fecd57b45662f2$var$wS, $b5fecd57b45662f2$var$PS, $b5fecd57b45662f2$var$bm, $b5fecd57b45662f2$var$Dm = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$Ue();
    $b5fecd57b45662f2$var$FS = (t)=>t.label, $b5fecd57b45662f2$var$wS = (t, e, o, r)=>{
        let a = t.find((i)=>i.value === e);
        return a ? o(a) : r;
    }, $b5fecd57b45662f2$var$PS = ({ name: t, options: e, placeholder: o, variant: r, disabled: a, renderOption: i = $b5fecd57b45662f2$var$FS, toggleClassName: s, ...l })=>$acw62.createElement($b5fecd57b45662f2$var$Q, {
            name: t,
            ...l
        }, ({ isError: p, errorMessage: m, control: c, controlId: d })=>$acw62.createElement((0, $22i8b.Controller), {
                name: t,
                control: c,
                render: ({ field: { value: f, onChange: u, ref: g } })=>{
                    var x;
                    return $acw62.createElement("div", {
                        className: "position-relative"
                    }, $acw62.createElement((0, $gzHIW.default), {
                        ref: g
                    }, $acw62.createElement((0, $gzHIW.default).Toggle, {
                        variant: r,
                        id: d,
                        disabled: a,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(s, p && "border border-danger")
                    }, (x = $b5fecd57b45662f2$var$wS(e, f, i, o)) != null ? x : $acw62.createElement("span", {
                        className: "text-muted"
                    }, "(\u043D\u0435 \u0432\u0438\u0431\u0440\u0430\u043D\u043E)")), $acw62.createElement((0, $gzHIW.default).Menu, null, e.map((v)=>$acw62.createElement((0, $gzHIW.default).Item, {
                            key: v.value,
                            onClick: ()=>u(v.value)
                        }, i(v))))), $acw62.createElement($b5fecd57b45662f2$var$xt, {
                        isError: p,
                        errorMessage: m
                    }));
                }
            })), $b5fecd57b45662f2$var$bm = $b5fecd57b45662f2$var$PS;
});
var $b5fecd57b45662f2$var$MS, $b5fecd57b45662f2$var$NS, $b5fecd57b45662f2$var$lr, $b5fecd57b45662f2$var$Sm = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$MS = ()=>$acw62.createElement("div", {
            className: "d-flex align-items-center gap-1"
        }, $acw62.createElement((0, $4dB0L.default), {
            animation: "grow",
            size: "sm"
        }), $acw62.createElement("span", {
            className: "ms-1"
        }, "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F, \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435...")), $b5fecd57b45662f2$var$NS = ({ body: t, ...e })=>$acw62.createElement($b5fecd57b45662f2$var$Q, {
            ...e
        }, ()=>t ? $acw62.createElement($acw62.Fragment, null, t) : $acw62.createElement($b5fecd57b45662f2$var$MS, null)), $b5fecd57b45662f2$var$lr = $b5fecd57b45662f2$var$NS;
});
var $b5fecd57b45662f2$var$BS, $b5fecd57b45662f2$var$OS, $b5fecd57b45662f2$var$IS, $b5fecd57b45662f2$var$La, $b5fecd57b45662f2$var$Wi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Oa();
    $b5fecd57b45662f2$var$Sm();
    $b5fecd57b45662f2$var$BS = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "text-danger font-18"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            className: "mdi mdi-alert me-1"
        }), "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F"), $b5fecd57b45662f2$var$OS = ({ options: t, nullFallback: e, emptyFallback: o, ...r })=>{
        if (e || o) {
            if (t === null) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$lr, {
                ...r,
                body: e != null ? e : o
            });
            if (t.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$lr, {
                ...r,
                body: o
            });
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Ro, {
            ...r,
            options: t != null ? t : []
        });
    }, $b5fecd57b45662f2$var$IS = ({ awaiter: t, nullFallback: e, emptyFallback: o, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$lr, {
                ...r
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aphAM.Await), {
            resolve: t,
            errorElement: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$lr, {
                ...r,
                body: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$BS, null)
            }),
            children: (a)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$OS, {
                    ...r,
                    options: a
                })
        })), $b5fecd57b45662f2$var$La = $b5fecd57b45662f2$var$IS;
});
var $b5fecd57b45662f2$var$VS, $b5fecd57b45662f2$var$Cm, $b5fecd57b45662f2$var$vm = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Wi();
    $b5fecd57b45662f2$var$VS = ({ listKey: t, ...e })=>{
        let { [t]: o } = (0, $aphAM.useLoaderData)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$La, {
            ...e,
            awaiter: o
        });
    }, $b5fecd57b45662f2$var$Cm = $b5fecd57b45662f2$var$VS;
});
var $b5fecd57b45662f2$var$HS, $b5fecd57b45662f2$var$Rm, $b5fecd57b45662f2$var$km = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$xo();
    $b5fecd57b45662f2$var$HS = ({ variant: t = "primary", size: e, icon: o, className: r, enable: a, hideOnDisabled: i, children: s = "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438" })=>{
        let { formState: { isDirty: l, isValid: p } } = (0, $22i8b.useFormContext)(), { formStatus: m } = $b5fecd57b45662f2$var$lt(), c = (0, $acw62.useMemo)(()=>m === 1 ? "mdi mdi-loading mdi-spin" : o || null, [
            o,
            m
        ]), d = (!l || !p) && !a || m === 1;
        return d && i ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6LAgE.default), {
            type: "submit",
            disabled: d,
            variant: t,
            size: e,
            className: r
        }, o && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            className: `${c} me-2`
        }), s);
    }, $b5fecd57b45662f2$var$Rm = $b5fecd57b45662f2$var$HS;
});
var $b5fecd57b45662f2$var$Fm, $b5fecd57b45662f2$var$qS, $b5fecd57b45662f2$var$wm, $b5fecd57b45662f2$var$Va, $b5fecd57b45662f2$var$Ei = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$_a();
    $b5fecd57b45662f2$var$ir();
    $b5fecd57b45662f2$var$Fm = $b5fecd57b45662f2$var$Jl($b5fecd57b45662f2$var$Li()), $b5fecd57b45662f2$var$qS = ({ onChange: t, mask: e, value: o, ...r })=>{
        let { ref: a, maskRef: i } = (0, $kwclR.default)({
            mask: e
        });
        return (0, $acw62.useEffect)(()=>{
            var s;
            (s = i.current) == null || s.on("accept", ()=>{
                var l, p;
                return t((p = (l = i.current) == null ? void 0 : l.unmaskedValue) != null ? p : "");
            });
        }, [
            i.current
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48fuN.default), {
            ref: a,
            ...r,
            defaultValue: o != null ? o : ""
        });
    }, $b5fecd57b45662f2$var$wm = ({ type: t, name: e, mask: o, className: r, ...a })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$ge, {
            name: e,
            ...a
        }, ({ control: i, isError: s, props: l })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22i8b.Controller), {
                name: e,
                control: i,
                render: ({ field: p })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$qS, {
                        ...l,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("form-control", {
                            "is-invalid": s,
                            [r != null ? r : ""]: !!r
                        }),
                        mask: o,
                        value: p.value,
                        onChange: p.onChange
                    })
            }));
    $b5fecd57b45662f2$var$wm.propTypes = {
        ...$b5fecd57b45662f2$var$Ao.propTypes,
        mask: $b5fecd57b45662f2$var$Fm.default.string.isRequired
    };
    $b5fecd57b45662f2$var$Va = $b5fecd57b45662f2$var$wm;
});
var $b5fecd57b45662f2$var$JS, $b5fecd57b45662f2$var$Wa, $b5fecd57b45662f2$var$Hi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$JS = (0, $acw62.forwardRef)(({ handleChange: t, disabled: e, ...o }, r)=>{
        let a = ()=>{
            t && t(new Date);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6LAgE.default), {
            variant: "link",
            className: "position-absolute end-0 top-0 bottom-0 mdi mdi-clock-in font-20 p-0 px-1",
            disabled: e,
            onClick: a
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            ...o,
            type: "text",
            ref: r,
            disabled: e
        }));
    }), $b5fecd57b45662f2$var$Wa = $b5fecd57b45662f2$var$JS;
});
var $b5fecd57b45662f2$var$Pm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Tm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Mm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Nm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$_m = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Bm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Om = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Im = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Lm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Xm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$QS, $b5fecd57b45662f2$var$D_, $b5fecd57b45662f2$var$Yi, $b5fecd57b45662f2$var$Gi, $b5fecd57b45662f2$var$tC, $b5fecd57b45662f2$var$Vm, $b5fecd57b45662f2$var$S_, $b5fecd57b45662f2$var$eC, $b5fecd57b45662f2$var$oC, $b5fecd57b45662f2$var$C_, $b5fecd57b45662f2$var$Um = $b5fecd57b45662f2$var$n(()=>{
    $b5fecd57b45662f2$var$QS = Math.pow(10, 8) * 86400000, $b5fecd57b45662f2$var$D_ = -$b5fecd57b45662f2$var$QS, $b5fecd57b45662f2$var$Yi = 6e4, $b5fecd57b45662f2$var$Gi = 36e5, $b5fecd57b45662f2$var$tC = 3600, $b5fecd57b45662f2$var$Vm = $b5fecd57b45662f2$var$tC * 24, $b5fecd57b45662f2$var$S_ = $b5fecd57b45662f2$var$Vm * 7, $b5fecd57b45662f2$var$eC = $b5fecd57b45662f2$var$Vm * 365.2425, $b5fecd57b45662f2$var$oC = $b5fecd57b45662f2$var$eC / 12, $b5fecd57b45662f2$var$C_ = $b5fecd57b45662f2$var$oC * 3;
});
var $b5fecd57b45662f2$var$Wm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Em = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Hm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ym = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Gm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$zm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$jm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$$m = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$qm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Km = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Zm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Jm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Qm = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$tc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ec = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$oc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$rc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ac = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$nc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ic = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$sc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$lc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$pc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$mc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$cc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$uc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$dc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$fc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$gc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$hc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$yc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$xc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$bc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Dc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Sc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Cc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$vc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ac = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Rc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$kc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Fc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$wc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Pc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Tc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Mc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Nc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$_c = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Bc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Oc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ic = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Lc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Xc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Vc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Uc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Wc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ec = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Hc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Yc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Gc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$zc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$jc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$$c = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$qc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Kc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Zc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Jc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Qc = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$tu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$eu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ou = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ru = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$au = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$nu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$iu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$su = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$lu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$pu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$mu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$cu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$uu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$du = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$fu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$gu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$hu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$yu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$xu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$bu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Du = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Su = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Cu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$vu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Au = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ru = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ku = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Fu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$wu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Pu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Tu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Mu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Nu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$_u = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Bu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ou = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Iu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Lu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Xu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Vu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Uu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Wu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Eu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Hu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Yu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Gu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$zu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ju = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$$u = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$qu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ku = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Zu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ju = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Qu = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$td = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ed = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$od = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$rd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ad = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$nd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$id = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$sd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ld = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$pd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$md = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$cd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ud = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$dd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$fd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$gd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$hd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$yd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$xd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$bd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Dd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Sd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Cd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$vd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ad = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Rd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$kd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Fd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$wd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Pd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Td = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Md = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Nd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$_d = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Bd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Od = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Id = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ld = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Xd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Vd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ud = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Wd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ed = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Hd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Yd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Gd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$zd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$jd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$$d = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$qd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Kd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Zd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Jd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Qd = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$tf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ef = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$of = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$rf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$af = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$nf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$sf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$lf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$pf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$mf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$cf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$uf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$df = $b5fecd57b45662f2$var$n(()=>{});
function $b5fecd57b45662f2$var$ff(t, e) {
    var p;
    let o = (p = e == null ? void 0 : e.additionalDigits) != null ? p : 2, r = $b5fecd57b45662f2$var$iC(t), a;
    if (r.date) {
        let m = $b5fecd57b45662f2$var$sC(r.date, o);
        a = $b5fecd57b45662f2$var$lC(m.restDateString, m.year);
    }
    if (!a || isNaN(a.getTime())) return new Date(NaN);
    let i = a.getTime(), s = 0, l;
    if (r.time && (s = $b5fecd57b45662f2$var$pC(r.time), isNaN(s))) return new Date(NaN);
    if (r.timezone) {
        if (l = $b5fecd57b45662f2$var$mC(r.timezone), isNaN(l)) return new Date(NaN);
    } else {
        let m = new Date(i + s), c = new Date(0);
        return c.setFullYear(m.getUTCFullYear(), m.getUTCMonth(), m.getUTCDate()), c.setHours(m.getUTCHours(), m.getUTCMinutes(), m.getUTCSeconds(), m.getUTCMilliseconds()), c;
    }
    return new Date(i + s + l);
}
function $b5fecd57b45662f2$var$iC(t) {
    let e = {}, o = t.split($b5fecd57b45662f2$var$Ea.dateTimeDelimiter), r;
    if (o.length > 2) return e;
    if (/:/.test(o[0]) ? r = o[0] : (e.date = o[0], r = o[1], $b5fecd57b45662f2$var$Ea.timeZoneDelimiter.test(e.date) && (e.date = t.split($b5fecd57b45662f2$var$Ea.timeZoneDelimiter)[0], r = t.substr(e.date.length, t.length))), r) {
        let a = $b5fecd57b45662f2$var$Ea.timezone.exec(r);
        a ? (e.time = r.replace(a[1], ""), e.timezone = a[1]) : e.time = r;
    }
    return e;
}
function $b5fecd57b45662f2$var$sC(t, e) {
    let o = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), r = t.match(o);
    if (!r) return {
        year: NaN,
        restDateString: ""
    };
    let a = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
    return {
        year: i === null ? a : i * 100,
        restDateString: t.slice((r[1] || r[2]).length)
    };
}
function $b5fecd57b45662f2$var$lC(t, e) {
    if (e === null) return new Date(NaN);
    let o = t.match($b5fecd57b45662f2$var$rC);
    if (!o) return new Date(NaN);
    let r = !!o[4], a = $b5fecd57b45662f2$var$pr(o[1]), i = $b5fecd57b45662f2$var$pr(o[2]) - 1, s = $b5fecd57b45662f2$var$pr(o[3]), l = $b5fecd57b45662f2$var$pr(o[4]), p = $b5fecd57b45662f2$var$pr(o[5]) - 1;
    if (r) return $b5fecd57b45662f2$var$gC(e, l, p) ? $b5fecd57b45662f2$var$cC(e, l, p) : new Date(NaN);
    {
        let m = new Date(0);
        return !$b5fecd57b45662f2$var$dC(e, i, s) || !$b5fecd57b45662f2$var$fC(e, a) ? new Date(NaN) : (m.setUTCFullYear(e, i, Math.max(a, s)), m);
    }
}
function $b5fecd57b45662f2$var$pr(t) {
    return t ? parseInt(t) : 1;
}
function $b5fecd57b45662f2$var$pC(t) {
    let e = t.match($b5fecd57b45662f2$var$aC);
    if (!e) return NaN;
    let o = $b5fecd57b45662f2$var$zi(e[1]), r = $b5fecd57b45662f2$var$zi(e[2]), a = $b5fecd57b45662f2$var$zi(e[3]);
    return $b5fecd57b45662f2$var$hC(o, r, a) ? o * $b5fecd57b45662f2$var$Gi + r * $b5fecd57b45662f2$var$Yi + a * 1e3 : NaN;
}
function $b5fecd57b45662f2$var$zi(t) {
    return t && parseFloat(t.replace(",", ".")) || 0;
}
function $b5fecd57b45662f2$var$mC(t) {
    if (t === "Z") return 0;
    let e = t.match($b5fecd57b45662f2$var$nC);
    if (!e) return 0;
    let o = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), a = e[3] && parseInt(e[3]) || 0;
    return $b5fecd57b45662f2$var$yC(r, a) ? o * (r * $b5fecd57b45662f2$var$Gi + a * $b5fecd57b45662f2$var$Yi) : NaN;
}
function $b5fecd57b45662f2$var$cC(t, e, o) {
    let r = new Date(0);
    r.setUTCFullYear(t, 0, 4);
    let a = r.getUTCDay() || 7, i = (e - 1) * 7 + o + 1 - a;
    return r.setUTCDate(r.getUTCDate() + i), r;
}
function $b5fecd57b45662f2$var$gf(t) {
    return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function $b5fecd57b45662f2$var$dC(t, e, o) {
    return e >= 0 && e <= 11 && o >= 1 && o <= ($b5fecd57b45662f2$var$uC[e] || ($b5fecd57b45662f2$var$gf(t) ? 29 : 28));
}
function $b5fecd57b45662f2$var$fC(t, e) {
    return e >= 1 && e <= ($b5fecd57b45662f2$var$gf(t) ? 366 : 365);
}
function $b5fecd57b45662f2$var$gC(t, e, o) {
    return e >= 1 && e <= 53 && o >= 0 && o <= 6;
}
function $b5fecd57b45662f2$var$hC(t, e, o) {
    return t === 24 ? e === 0 && o === 0 : o >= 0 && o < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function $b5fecd57b45662f2$var$yC(t, e) {
    return e >= 0 && e <= 59;
}
var $b5fecd57b45662f2$var$Ea, $b5fecd57b45662f2$var$rC, $b5fecd57b45662f2$var$aC, $b5fecd57b45662f2$var$nC, $b5fecd57b45662f2$var$uC, $b5fecd57b45662f2$var$hf = $b5fecd57b45662f2$var$n(()=>{
    $b5fecd57b45662f2$var$Um();
    $b5fecd57b45662f2$var$Ea = {
        dateTimeDelimiter: /[T ]/,
        timeZoneDelimiter: /[Z ]/i,
        timezone: /([Z+-].*)$/
    }, $b5fecd57b45662f2$var$rC = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, $b5fecd57b45662f2$var$aC = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, $b5fecd57b45662f2$var$nC = /^([+-])(\d{2})(?::?(\d{2}))?$/;
    $b5fecd57b45662f2$var$uC = [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
});
var $b5fecd57b45662f2$var$yf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$xf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$bf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Df = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Sf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Cf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$vf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Af = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Rf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$kf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ff = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$wf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Pf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Tf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Mf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Nf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$_f = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Bf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Of = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$If = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Lf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Xf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Vf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Uf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Wf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Ef = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Hf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Yf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Gf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$zf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$jf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$$f = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$qf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Kf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Zf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Jf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$Qf = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$tg = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$eg = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$og = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$rg = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ag = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ng = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$ig = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$sg = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$lg = $b5fecd57b45662f2$var$n(()=>{});
var $b5fecd57b45662f2$var$pg = $b5fecd57b45662f2$var$n(()=>{
    $b5fecd57b45662f2$var$_m();
    $b5fecd57b45662f2$var$Lm();
    $b5fecd57b45662f2$var$Mm();
    $b5fecd57b45662f2$var$Wm();
    $b5fecd57b45662f2$var$qm();
    $b5fecd57b45662f2$var$Xm();
    $b5fecd57b45662f2$var$Km();
    $b5fecd57b45662f2$var$Nm();
    $b5fecd57b45662f2$var$Zm();
    $b5fecd57b45662f2$var$Jm();
    $b5fecd57b45662f2$var$Qm();
    $b5fecd57b45662f2$var$tc();
    $b5fecd57b45662f2$var$ec();
    $b5fecd57b45662f2$var$ac();
    $b5fecd57b45662f2$var$nc();
    $b5fecd57b45662f2$var$ic();
    $b5fecd57b45662f2$var$sc();
    $b5fecd57b45662f2$var$lc();
    $b5fecd57b45662f2$var$Tm();
    $b5fecd57b45662f2$var$pc();
    $b5fecd57b45662f2$var$mc();
    $b5fecd57b45662f2$var$fc();
    $b5fecd57b45662f2$var$zm();
    $b5fecd57b45662f2$var$gc();
    $b5fecd57b45662f2$var$hc();
    $b5fecd57b45662f2$var$yc();
    $b5fecd57b45662f2$var$bc();
    $b5fecd57b45662f2$var$Dc();
    $b5fecd57b45662f2$var$Sc();
    $b5fecd57b45662f2$var$Cc();
    $b5fecd57b45662f2$var$Ac();
    $b5fecd57b45662f2$var$kc();
    $b5fecd57b45662f2$var$vc();
    $b5fecd57b45662f2$var$Fc();
    $b5fecd57b45662f2$var$Mc();
    $b5fecd57b45662f2$var$Nc();
    $b5fecd57b45662f2$var$_c();
    $b5fecd57b45662f2$var$Bc();
    $b5fecd57b45662f2$var$Oc();
    $b5fecd57b45662f2$var$Ic();
    $b5fecd57b45662f2$var$Lc();
    $b5fecd57b45662f2$var$Vc();
    $b5fecd57b45662f2$var$Uc();
    $b5fecd57b45662f2$var$Ec();
    $b5fecd57b45662f2$var$Hc();
    $b5fecd57b45662f2$var$Yc();
    $b5fecd57b45662f2$var$zc();
    $b5fecd57b45662f2$var$qc();
    $b5fecd57b45662f2$var$Kc();
    $b5fecd57b45662f2$var$wc();
    $b5fecd57b45662f2$var$Zc();
    $b5fecd57b45662f2$var$Jc();
    $b5fecd57b45662f2$var$tu();
    $b5fecd57b45662f2$var$eu();
    $b5fecd57b45662f2$var$ou();
    $b5fecd57b45662f2$var$Pc();
    $b5fecd57b45662f2$var$ru();
    $b5fecd57b45662f2$var$au();
    $b5fecd57b45662f2$var$nu();
    $b5fecd57b45662f2$var$iu();
    $b5fecd57b45662f2$var$Qc();
    $b5fecd57b45662f2$var$jc();
    $b5fecd57b45662f2$var$su();
    $b5fecd57b45662f2$var$du();
    $b5fecd57b45662f2$var$fu();
    $b5fecd57b45662f2$var$gu();
    $b5fecd57b45662f2$var$hu();
    $b5fecd57b45662f2$var$yu();
    $b5fecd57b45662f2$var$xu();
    $b5fecd57b45662f2$var$bu();
    $b5fecd57b45662f2$var$Du();
    $b5fecd57b45662f2$var$Su();
    $b5fecd57b45662f2$var$Cu();
    $b5fecd57b45662f2$var$vu();
    $b5fecd57b45662f2$var$Au();
    $b5fecd57b45662f2$var$Ru();
    $b5fecd57b45662f2$var$ku();
    $b5fecd57b45662f2$var$Fu();
    $b5fecd57b45662f2$var$lu();
    $b5fecd57b45662f2$var$wu();
    $b5fecd57b45662f2$var$Tu();
    $b5fecd57b45662f2$var$Mu();
    $b5fecd57b45662f2$var$Nu();
    $b5fecd57b45662f2$var$_u();
    $b5fecd57b45662f2$var$Bu();
    $b5fecd57b45662f2$var$pu();
    $b5fecd57b45662f2$var$Ym();
    $b5fecd57b45662f2$var$Ou();
    $b5fecd57b45662f2$var$Iu();
    $b5fecd57b45662f2$var$Lu();
    $b5fecd57b45662f2$var$Xu();
    $b5fecd57b45662f2$var$Vu();
    $b5fecd57b45662f2$var$xc();
    $b5fecd57b45662f2$var$Uu();
    $b5fecd57b45662f2$var$Wu();
    $b5fecd57b45662f2$var$Eu();
    $b5fecd57b45662f2$var$uu();
    $b5fecd57b45662f2$var$Hu();
    $b5fecd57b45662f2$var$mu();
    $b5fecd57b45662f2$var$Gu();
    $b5fecd57b45662f2$var$zu();
    $b5fecd57b45662f2$var$ju();
    $b5fecd57b45662f2$var$$u();
    $b5fecd57b45662f2$var$qu();
    $b5fecd57b45662f2$var$Ku();
    $b5fecd57b45662f2$var$Zu();
    $b5fecd57b45662f2$var$Ju();
    $b5fecd57b45662f2$var$Qu();
    $b5fecd57b45662f2$var$td();
    $b5fecd57b45662f2$var$ed();
    $b5fecd57b45662f2$var$uc();
    $b5fecd57b45662f2$var$od();
    $b5fecd57b45662f2$var$rd();
    $b5fecd57b45662f2$var$ad();
    $b5fecd57b45662f2$var$nd();
    $b5fecd57b45662f2$var$id();
    $b5fecd57b45662f2$var$Tc();
    $b5fecd57b45662f2$var$Pu();
    $b5fecd57b45662f2$var$dd();
    $b5fecd57b45662f2$var$fd();
    $b5fecd57b45662f2$var$gd();
    $b5fecd57b45662f2$var$cc();
    $b5fecd57b45662f2$var$yd();
    $b5fecd57b45662f2$var$bd();
    $b5fecd57b45662f2$var$Dd();
    $b5fecd57b45662f2$var$Sd();
    $b5fecd57b45662f2$var$Cd();
    $b5fecd57b45662f2$var$vd();
    $b5fecd57b45662f2$var$Rd();
    $b5fecd57b45662f2$var$xd();
    $b5fecd57b45662f2$var$kd();
    $b5fecd57b45662f2$var$Bm();
    $b5fecd57b45662f2$var$Om();
    $b5fecd57b45662f2$var$Fd();
    $b5fecd57b45662f2$var$wd();
    $b5fecd57b45662f2$var$Pd();
    $b5fecd57b45662f2$var$Td();
    $b5fecd57b45662f2$var$Md();
    $b5fecd57b45662f2$var$Nd();
    $b5fecd57b45662f2$var$_d();
    $b5fecd57b45662f2$var$Bd();
    $b5fecd57b45662f2$var$Od();
    $b5fecd57b45662f2$var$Id();
    $b5fecd57b45662f2$var$Ld();
    $b5fecd57b45662f2$var$Xd();
    $b5fecd57b45662f2$var$dc();
    $b5fecd57b45662f2$var$Vd();
    $b5fecd57b45662f2$var$Im();
    $b5fecd57b45662f2$var$Ud();
    $b5fecd57b45662f2$var$Ed();
    $b5fecd57b45662f2$var$Hd();
    $b5fecd57b45662f2$var$Gd();
    $b5fecd57b45662f2$var$zd();
    $b5fecd57b45662f2$var$Yu();
    $b5fecd57b45662f2$var$jd();
    $b5fecd57b45662f2$var$Yd();
    $b5fecd57b45662f2$var$$d();
    $b5fecd57b45662f2$var$qd();
    $b5fecd57b45662f2$var$oc();
    $b5fecd57b45662f2$var$Kd();
    $b5fecd57b45662f2$var$Zd();
    $b5fecd57b45662f2$var$Jd();
    $b5fecd57b45662f2$var$Qd();
    $b5fecd57b45662f2$var$rc();
    $b5fecd57b45662f2$var$tf();
    $b5fecd57b45662f2$var$ef();
    $b5fecd57b45662f2$var$of();
    $b5fecd57b45662f2$var$rf();
    $b5fecd57b45662f2$var$af();
    $b5fecd57b45662f2$var$nf();
    $b5fecd57b45662f2$var$sf();
    $b5fecd57b45662f2$var$lf();
    $b5fecd57b45662f2$var$pf();
    $b5fecd57b45662f2$var$mf();
    $b5fecd57b45662f2$var$cf();
    $b5fecd57b45662f2$var$uf();
    $b5fecd57b45662f2$var$df();
    $b5fecd57b45662f2$var$ud();
    $b5fecd57b45662f2$var$hf();
    $b5fecd57b45662f2$var$yf();
    $b5fecd57b45662f2$var$xf();
    $b5fecd57b45662f2$var$bf();
    $b5fecd57b45662f2$var$Df();
    $b5fecd57b45662f2$var$Sf();
    $b5fecd57b45662f2$var$Cf();
    $b5fecd57b45662f2$var$vf();
    $b5fecd57b45662f2$var$Af();
    $b5fecd57b45662f2$var$Rf();
    $b5fecd57b45662f2$var$kf();
    $b5fecd57b45662f2$var$Ff();
    $b5fecd57b45662f2$var$wf();
    $b5fecd57b45662f2$var$Pf();
    $b5fecd57b45662f2$var$Tf();
    $b5fecd57b45662f2$var$Mf();
    $b5fecd57b45662f2$var$Nf();
    $b5fecd57b45662f2$var$Bf();
    $b5fecd57b45662f2$var$Of();
    $b5fecd57b45662f2$var$md();
    $b5fecd57b45662f2$var$If();
    $b5fecd57b45662f2$var$Lf();
    $b5fecd57b45662f2$var$Xf();
    $b5fecd57b45662f2$var$cd();
    $b5fecd57b45662f2$var$pd();
    $b5fecd57b45662f2$var$$m();
    $b5fecd57b45662f2$var$Vf();
    $b5fecd57b45662f2$var$Uf();
    $b5fecd57b45662f2$var$_f();
    $b5fecd57b45662f2$var$Wf();
    $b5fecd57b45662f2$var$Ef();
    $b5fecd57b45662f2$var$ld();
    $b5fecd57b45662f2$var$Hf();
    $b5fecd57b45662f2$var$Yf();
    $b5fecd57b45662f2$var$Gm();
    $b5fecd57b45662f2$var$Gf();
    $b5fecd57b45662f2$var$hd();
    $b5fecd57b45662f2$var$Hm();
    $b5fecd57b45662f2$var$jm();
    $b5fecd57b45662f2$var$Xc();
    $b5fecd57b45662f2$var$Gc();
    $b5fecd57b45662f2$var$Wc();
    $b5fecd57b45662f2$var$Ad();
    $b5fecd57b45662f2$var$zf();
    $b5fecd57b45662f2$var$jf();
    $b5fecd57b45662f2$var$Em();
    $b5fecd57b45662f2$var$cu();
    $b5fecd57b45662f2$var$$c();
    $b5fecd57b45662f2$var$$f();
    $b5fecd57b45662f2$var$Kf();
    $b5fecd57b45662f2$var$Zf();
    $b5fecd57b45662f2$var$Wd();
    $b5fecd57b45662f2$var$Jf();
    $b5fecd57b45662f2$var$Rc();
    $b5fecd57b45662f2$var$Qf();
    $b5fecd57b45662f2$var$tg();
    $b5fecd57b45662f2$var$qf();
    $b5fecd57b45662f2$var$eg();
    $b5fecd57b45662f2$var$og();
    $b5fecd57b45662f2$var$rg();
    $b5fecd57b45662f2$var$ag();
    $b5fecd57b45662f2$var$Pm();
    $b5fecd57b45662f2$var$sd();
    $b5fecd57b45662f2$var$ng();
    $b5fecd57b45662f2$var$ig();
    $b5fecd57b45662f2$var$sg();
    $b5fecd57b45662f2$var$lg();
});
function $b5fecd57b45662f2$export$3c2ab2c4f3202ceb(t) {
    if (t instanceof Date) return t;
    if (typeof t == "string") return $b5fecd57b45662f2$var$ff(t);
}
var $b5fecd57b45662f2$var$Ha = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$pg();
});
var $b5fecd57b45662f2$var$SC, $b5fecd57b45662f2$var$Ya, $b5fecd57b45662f2$var$ji = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Hi();
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$Ha();
    $b5fecd57b45662f2$var$Ue();
    $b5fecd57b45662f2$var$SC = ({ name: t, isTime: e = !1, minDate: o, maxDate: r, monthsShown: a, showTimeSelectOnly: i, inline: s, disabled: l, readOnly: p, ...m })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Q, {
            name: t,
            ...m
        }, ({ isError: c, errorMessage: d, control: f })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22i8b.Controller), {
                name: t,
                control: f,
                render: ({ field: u })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        className: "position-relative"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5arZS))), {
                        customInput: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Wa, {
                            handleChange: (g)=>{
                                var x;
                                return u.onChange((x = g == null ? void 0 : g.toISOString()) != null ? x : null);
                            }
                        }),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("form-control", {
                            "is-invalid": c
                        }),
                        onChange: (g)=>{
                            var x;
                            return u.onChange((x = g == null ? void 0 : g.toISOString()) != null ? x : null);
                        },
                        selected: u.value ? new Date(u.value) : null,
                        dateFormat: e ? "dd.MM.yyyy HH:mm" : "dd.MM.yyyy",
                        timeFormat: "HH:mm",
                        timeInputLabel: "\u0427\u0430\u0441",
                        minDate: $b5fecd57b45662f2$export$3c2ab2c4f3202ceb(o),
                        maxDate: $b5fecd57b45662f2$export$3c2ab2c4f3202ceb(r),
                        monthsShown: a,
                        inline: s,
                        showTimeSelectOnly: i,
                        autoComplete: "off",
                        disabled: l,
                        readOnly: p,
                        showTimeInput: e
                    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$xt, {
                        isError: c,
                        errorMessage: d
                    }))
            })), $b5fecd57b45662f2$var$Ya = $b5fecd57b45662f2$var$SC;
});
var $b5fecd57b45662f2$var$kC, $b5fecd57b45662f2$var$FC, $b5fecd57b45662f2$var$Ga, $b5fecd57b45662f2$var$$i = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Hi();
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$Ha();
    $b5fecd57b45662f2$var$Ue();
    $b5fecd57b45662f2$var$kC = ({ value: t, onChange: e, isTime: o, isError: r, minDate: a, maxDate: i, monthsShown: s, inline: l, readOnly: p, disabled: m })=>{
        let { startDate: c, endDate: d } = (0, $acw62.useMemo)(()=>{
            var x;
            let [u, g] = (x = t == null ? void 0 : t.split("/")) != null ? x : [
                null,
                null
            ];
            return {
                startDate: u ? new Date(u) : null,
                endDate: g ? new Date(g) : null
            };
        }, [
            t
        ]), f = (u)=>{
            e(u.map((g)=>{
                var x;
                return (x = g == null ? void 0 : g.toISOString()) != null ? x : "";
            }).join("/"));
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5arZS))), {
            customInput: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Wa, null),
            showTimeSelect: o,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("form-control", {
                "is-invalid": r
            }),
            onChange: f,
            dateFormat: o ? "dd.MM.yyyy HH:mm" : "dd.MM.yyyy",
            timeFormat: "HH:mm",
            timeCaption: "\u0427\u0430\u0441",
            minDate: $b5fecd57b45662f2$export$3c2ab2c4f3202ceb(a),
            maxDate: $b5fecd57b45662f2$export$3c2ab2c4f3202ceb(i),
            monthsShown: s,
            inline: l,
            autoComplete: "off",
            selectsRange: !0,
            startDate: c,
            endDate: d,
            readOnly: p,
            disabled: m
        });
    }, $b5fecd57b45662f2$var$FC = ({ name: t, isTime: e, minDate: o, maxDate: r, monthsShown: a, inline: i, disabled: s, readOnly: l, ...p })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Q, {
            name: t,
            ...p
        }, ({ control: m, isError: c, errorMessage: d })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22i8b.Controller), {
                name: t,
                control: m,
                render: ({ field: f })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        className: "position-relative"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$kC, {
                        onChange: f.onChange,
                        value: f.value,
                        isTime: e,
                        isError: c,
                        minDate: o,
                        maxDate: r,
                        monthsShown: a,
                        inline: i,
                        disabled: s,
                        readOnly: l
                    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$xt, {
                        isError: c,
                        errorMessage: d
                    }))
            })), $b5fecd57b45662f2$var$Ga = $b5fecd57b45662f2$var$FC;
});
var $b5fecd57b45662f2$var$za, $b5fecd57b45662f2$var$qi = $b5fecd57b45662f2$var$n(()=>{
    $b5fecd57b45662f2$var$za = "data:image/png;base64,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";
});
var $b5fecd57b45662f2$var$LC, $b5fecd57b45662f2$var$XC, $b5fecd57b45662f2$var$VC, $b5fecd57b45662f2$var$ja, $b5fecd57b45662f2$var$Zi = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Co();
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$qi();
    $b5fecd57b45662f2$var$Ue();
    $b5fecd57b45662f2$var$LC = new (0, $8JYDX.Icon)({
        iconUrl: $b5fecd57b45662f2$var$za,
        shadowUrl: void 0,
        iconAnchor: [
            12,
            41
        ],
        popupAnchor: [
            0,
            -41
        ]
    }), $b5fecd57b45662f2$var$XC = ({ setValue: t })=>((0, $bSFz8.useMapEvent)("click", (e)=>t({
                ...e.latlng
            })), null), $b5fecd57b45662f2$var$VC = ({ nameLat: t, nameLng: e, label: o, text: r, disabled: a })=>{
        let { register: i, getValues: s, setValue: l } = (0, $22i8b.useFormContext)(), { name: p } = $b5fecd57b45662f2$var$lt(), { isError: m, errorMessage: c } = $b5fecd57b45662f2$var$yt(t), { isError: d, errorMessage: f } = $b5fecd57b45662f2$var$yt(e), u = m || d, g = [
            c,
            f
        ].filter((k)=>!!k).join("; "), x = s(t), v = s(e), F = {
            lat: x != null ? x : 49.824421,
            lng: v != null ? v : 23.979513
        }, [mt, st] = (0, $acw62.useState)(F), ft = (0, $acw62.useRef)(), It = (k)=>{
            a || (st(k), l(t, k.lat, {
                shouldDirty: !0
            }), l(e, k.lng, {
                shouldDirty: !0
            }));
        }, G = ()=>{
            var k;
            a || ft.current && It((k = ft.current) == null ? void 0 : k.getLatLng());
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8CrHJ.default).Group, {
            className: "mb-3 position-relative",
            controlId: p + "-" + t + "-" + e
        }, o && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8CrHJ.default).Label, null, o), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kqTi2.MapContainer), {
            center: F,
            zoom: 10,
            scrollWheelZoom: !0,
            style: {
                height: "300px"
            },
            dragging: !a
        }, a && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "position-absolute top-0 bottom-0 start-0 end-0",
            style: {
                backgroundColor: "rgba(0,0,0,.5)",
                zIndex: 9999
            }
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$XC, {
            setValue: It
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ysIF.TileLayer), {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i7g9v.Marker), {
            ref: (k)=>k && (ft.current = k),
            draggable: !0,
            eventHandlers: {
                click: (k)=>It(k.latlng),
                dragend: G
            },
            position: mt,
            icon: $b5fecd57b45662f2$var$LC
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "hidden",
            ...i(t)
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "hidden",
            ...i(e)
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$xt, {
            isError: u,
            errorMessage: g
        }), r && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8CrHJ.default).Text, null, r)));
    }, $b5fecd57b45662f2$var$ja = $b5fecd57b45662f2$var$VC;
});
var $b5fecd57b45662f2$var$WC, $b5fecd57b45662f2$var$$a, $b5fecd57b45662f2$var$Ji = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$WC = ({ name: t })=>{
        let { register: e } = (0, $22i8b.useFormContext)();
        return $acw62.createElement("input", {
            type: "hidden",
            ...e(t)
        });
    }, $b5fecd57b45662f2$var$$a = $b5fecd57b45662f2$var$WC;
});
var $b5fecd57b45662f2$var$HC, $b5fecd57b45662f2$var$ug, $b5fecd57b45662f2$var$dg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Co();
    $b5fecd57b45662f2$var$HC = ({ name: t })=>{
        let { isError: e, errorMessage: o } = $b5fecd57b45662f2$var$yt(t);
        return e ? $acw62.createElement((0, $cpxrl.default), {
            variant: "danger"
        }, o) : null;
    }, $b5fecd57b45662f2$var$ug = $b5fecd57b45662f2$var$HC;
});
var $b5fecd57b45662f2$var$YC, $b5fecd57b45662f2$var$fg, $b5fecd57b45662f2$var$gg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$qt();
    $b5fecd57b45662f2$var$xo();
    $b5fecd57b45662f2$var$YC = ({ icon: t = "check", title: e = "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438", variant: o = "success" })=>{
        let r = $b5fecd57b45662f2$export$846279b0d7f2d98d(), a = $acw62.useRef(null), { formStatus: i } = $b5fecd57b45662f2$var$lt(), { iconState: s, iconVariant: l, disabled: p } = $acw62.useMemo(()=>i === 1 ? {
                iconState: "loading mdi-spin",
                iconVariant: o,
                disabled: !0
            } : i === 2 ? {
                iconState: "check-all",
                iconVariant: "success",
                disabled: !0
            } : i === 3 ? {
                iconState: "alert-circle-outline",
                iconVariant: "danger",
                disabled: !0
            } : {
                iconState: t,
                iconVariant: o
            }, [
            i,
            t
        ]);
        return $acw62.useEffect(()=>{
            if (!a.current) return;
            let m = r.GlobalButtons.registerCustomButton("form-submit-global", {
                icon: s,
                title: e,
                variant: l,
                order: 101,
                disabled: p,
                handler: ()=>{
                    var c;
                    return (c = a.current) == null ? void 0 : c.click();
                }
            });
            return ()=>{
                m();
            };
        }, [
            s,
            l,
            p
        ]), $acw62.createElement("div", {
            className: "visually-hidden"
        }, $acw62.createElement("button", {
            ref: a,
            type: "submit"
        }));
    }, $b5fecd57b45662f2$var$fg = $b5fecd57b45662f2$var$YC;
});
function $b5fecd57b45662f2$var$Qi(t) {
    return typeof t < "u" && t.hasOwnProperty("type") && Object.values($b5fecd57b45662f2$var$mr).includes(t.type) && t.hasOwnProperty("props");
}
function $b5fecd57b45662f2$var$Vt(t, e) {
    return typeof t < "u" && t.hasOwnProperty("type") && t.type === e;
}
function $b5fecd57b45662f2$var$hg(t) {
    return Array.isArray(t) && t.every($b5fecd57b45662f2$var$Qi);
}
var $b5fecd57b45662f2$var$mr, $b5fecd57b45662f2$var$cr = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$mr = ((m)=>(m.Input = "input", m.Hidden = "hidden", m.Check = "check", m.Datetime = "datetime", m.DatetimeRange = "datetime-range", m.Map = "map", m.MaskInput = "mask-input", m.Select = "select", m.Custom = "custom", m))($b5fecd57b45662f2$var$mr || {});
});
var $b5fecd57b45662f2$var$ye, $b5fecd57b45662f2$var$ts = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ye = class {
        static registerField(e, o) {
            this.fields[e] = o;
        }
        static getField(e) {
            var o;
            return (o = this.fields[e]) != null ? o : void 0;
        }
    };
    $b5fecd57b45662f2$var$ye.fields = {};
});
var $b5fecd57b45662f2$var$GC, $b5fecd57b45662f2$var$yg, $b5fecd57b45662f2$var$xg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ts();
    $b5fecd57b45662f2$var$GC = ({ type: t, props: e })=>{
        let o = $acw62.useMemo(()=>$b5fecd57b45662f2$var$ye.getField(t), [
            t
        ]);
        return o ? $acw62.createElement(o, {
            ...e
        }) : null;
    }, $b5fecd57b45662f2$var$yg = $b5fecd57b45662f2$var$GC;
});
var $b5fecd57b45662f2$var$bg, $b5fecd57b45662f2$var$Ka, $b5fecd57b45662f2$var$es = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$cr();
    $b5fecd57b45662f2$var$_a();
    $b5fecd57b45662f2$var$Ji();
    $b5fecd57b45662f2$var$Vi();
    $b5fecd57b45662f2$var$ji();
    $b5fecd57b45662f2$var$$i();
    $b5fecd57b45662f2$var$Zi();
    $b5fecd57b45662f2$var$Ei();
    $b5fecd57b45662f2$var$Oa();
    $b5fecd57b45662f2$var$xg();
    $b5fecd57b45662f2$var$bg = ({ field: t })=>$b5fecd57b45662f2$var$Vt(t, "input") ? $acw62.createElement($b5fecd57b45662f2$var$Ao, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "hidden") ? $acw62.createElement($b5fecd57b45662f2$var$$a, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "check") ? $acw62.createElement($b5fecd57b45662f2$var$Ba, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "datetime") ? $acw62.createElement($b5fecd57b45662f2$var$Ya, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "datetime-range") ? $acw62.createElement($b5fecd57b45662f2$var$Ga, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "map") ? $acw62.createElement($b5fecd57b45662f2$var$ja, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "mask-input") ? $acw62.createElement($b5fecd57b45662f2$var$Va, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "select") ? $acw62.createElement($b5fecd57b45662f2$var$Ro, {
            ...t.props
        }) : $b5fecd57b45662f2$var$Vt(t, "custom") ? $acw62.createElement($b5fecd57b45662f2$var$yg, {
            ...t.props
        }) : $acw62.createElement((0, $cpxrl.default), {
            variant: "danger"
        }, "Field of type ", t.type, " not found."), $b5fecd57b45662f2$var$Ka = $b5fecd57b45662f2$var$bg;
});
var $b5fecd57b45662f2$var$jC, $b5fecd57b45662f2$var$Za, $b5fecd57b45662f2$var$os = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$es();
    $b5fecd57b45662f2$var$jC = ({ fields: t })=>$acw62.createElement($acw62.Fragment, null, t.map((e, o)=>$acw62.createElement($b5fecd57b45662f2$var$Ka, {
                key: `field-${o}`,
                field: e
            }))), $b5fecd57b45662f2$var$Za = $b5fecd57b45662f2$var$jC;
});
var $b5fecd57b45662f2$export$a7fed597f4b8afd8, $b5fecd57b45662f2$var$Ut = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Qp();
    $b5fecd57b45662f2$var$em();
    $b5fecd57b45662f2$var$Fa();
    $b5fecd57b45662f2$var$ki();
    $b5fecd57b45662f2$var$rm();
    $b5fecd57b45662f2$var$Jt();
    $b5fecd57b45662f2$var$ir();
    $b5fecd57b45662f2$var$_a();
    $b5fecd57b45662f2$var$Vi();
    $b5fecd57b45662f2$var$gm();
    $b5fecd57b45662f2$var$Oa();
    $b5fecd57b45662f2$var$xm();
    $b5fecd57b45662f2$var$Dm();
    $b5fecd57b45662f2$var$Wi();
    $b5fecd57b45662f2$var$vm();
    $b5fecd57b45662f2$var$km();
    $b5fecd57b45662f2$var$Ei();
    $b5fecd57b45662f2$var$ji();
    $b5fecd57b45662f2$var$$i();
    $b5fecd57b45662f2$var$Zi();
    $b5fecd57b45662f2$var$Ji();
    $b5fecd57b45662f2$var$dg();
    $b5fecd57b45662f2$var$gg();
    $b5fecd57b45662f2$var$Oi();
    $b5fecd57b45662f2$var$_i();
    $b5fecd57b45662f2$var$os();
    $b5fecd57b45662f2$var$es();
    $b5fecd57b45662f2$var$cr();
    $b5fecd57b45662f2$var$ts();
    $b5fecd57b45662f2$var$wi();
    $b5fecd57b45662f2$var$Co();
    $b5fecd57b45662f2$var$xo();
    $b5fecd57b45662f2$export$a7fed597f4b8afd8 = Object.assign($b5fecd57b45662f2$var$Jp, {
        Callback: $b5fecd57b45662f2$var$So,
        Data: $b5fecd57b45662f2$var$tm,
        Body: $b5fecd57b45662f2$var$ka,
        DynamicBody: $b5fecd57b45662f2$var$Za,
        DynamicField: $b5fecd57b45662f2$var$Ka,
        DynamicControlType: $b5fecd57b45662f2$var$mr,
        DynamicControlRegistry: $b5fecd57b45662f2$var$ye,
        FieldBlock: $b5fecd57b45662f2$var$om,
        GroupContainer: $b5fecd57b45662f2$var$Q,
        InputGroupContainer: $b5fecd57b45662f2$var$ge,
        ErrorAlert: $b5fecd57b45662f2$var$ug,
        GlobalSubmit: $b5fecd57b45662f2$var$fg,
        Label: $b5fecd57b45662f2$var$Na,
        LabelTooltip: $b5fecd57b45662f2$var$Ma,
        Input: $b5fecd57b45662f2$var$Ao,
        HiddenInput: $b5fecd57b45662f2$var$$a,
        MaskInput: $b5fecd57b45662f2$var$Va,
        Datetime: $b5fecd57b45662f2$var$Ya,
        DatetimeRange: $b5fecd57b45662f2$var$Ga,
        Check: $b5fecd57b45662f2$var$Ba,
        BasicSelect: $b5fecd57b45662f2$var$fm,
        Select: $b5fecd57b45662f2$var$Ro,
        SelectAwait: $b5fecd57b45662f2$var$La,
        SelectAwaitLoader: $b5fecd57b45662f2$var$Cm,
        TypeaheadSelect: $b5fecd57b45662f2$var$ym,
        DropdownSelect: $b5fecd57b45662f2$var$bm,
        Map: $b5fecd57b45662f2$var$ja,
        Submit: $b5fecd57b45662f2$var$Rm,
        useFormContext: (0, $22i8b.useFormContext),
        useDefaultValues: $b5fecd57b45662f2$var$ar,
        useFormError: $b5fecd57b45662f2$var$yt,
        useWatch: (0, $22i8b.useWatch),
        useController: (0, $22i8b.useController),
        useFormState: (0, $22i8b.useFormState),
        useFieldArray: (0, $22i8b.useFieldArray)
    });
});
function $b5fecd57b45662f2$var$rs({ endpoint: t, title: e, confirmText: o, method: r }) {
    let [a, i] = $acw62.useState(), [s, l] = $acw62.useState(), { revalidate: p } = (0, $aphAM.useRevalidator)(), m = $acw62.useCallback((g)=>new Promise(async (x, v)=>{
            var F, mt, st, ft, It, G;
            try {
                await (0, $ket0H.default)[r != null ? r : "delete"](t, g != null ? g : {}), p(), x();
            } catch (k) {
                if (g) {
                    v(k);
                    return;
                }
                if ((0, $ifGBV.isApiValidationError)(k) && $b5fecd57b45662f2$var$hg((mt = (F = k.response) == null ? void 0 : F.data) == null ? void 0 : mt.form)) {
                    i((ft = (st = k.response) == null ? void 0 : st.data) == null ? void 0 : ft.message), l((G = (It = k.response) == null ? void 0 : It.data) == null ? void 0 : G.form), d.open();
                    return;
                }
                v((0, $9PE8j.default)(k));
            }
        }), []), c = $acw62.useCallback(()=>{
        d.close(), i(void 0), l(void 0);
    }, []), d = $b5fecd57b45662f2$export$33ffd74ebf07f060(), f = $b5fecd57b45662f2$export$bf4da147a5964edb({
        title: e != null ? e : "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        text: o != null ? o : "\u0412\u0438 \u0434\u0456\u0439\u0441\u043D\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438?",
        submitText: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        color: "danger",
        handleContinue: m
    }), u = $acw62.createElement($acw62.Fragment, null, f.ConfirmModal, $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772, {
        state: d,
        title: e != null ? e : "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        titleBg: "danger"
    }, $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Callback, {
        handleSubmit: m,
        showSuccess: !1
    }, $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772.Body, null, a && $acw62.createElement((0, $cpxrl.default), {
        variant: "info"
    }, a), $acw62.createElement($b5fecd57b45662f2$var$Za, {
        fields: s != null ? s : []
    })), $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772.Footer, null, $acw62.createElement((0, $6LAgE.default), {
        onClick: c,
        variant: "secondary"
    }, "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Submit, {
        variant: "danger"
    }, "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438")))));
    return {
        handleClick: ()=>f.handleClick(),
        helpers: u
    };
}
var $b5fecd57b45662f2$var$Dg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Sa();
    $b5fecd57b45662f2$var$ue();
    $b5fecd57b45662f2$var$ho();
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$cr();
    $b5fecd57b45662f2$var$os();
});
var $b5fecd57b45662f2$var$nv, $b5fecd57b45662f2$var$Sg, $b5fecd57b45662f2$var$Cg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$vi();
    $b5fecd57b45662f2$var$Dg();
    $b5fecd57b45662f2$var$nv = ({ action: t, className: e })=>{
        let { helpers: o, handleClick: r } = $b5fecd57b45662f2$var$rs({
            endpoint: t.config.endpoint,
            title: t.config.title,
            confirmText: t.config.confirmText,
            method: t.config.method
        });
        return $acw62.createElement($acw62.Fragment, null, o, $acw62.createElement($b5fecd57b45662f2$var$xa, {
            icon: t.icon,
            title: t.title,
            className: e,
            buttonVariant: t.buttonVariant,
            onClick: r
        }));
    }, $b5fecd57b45662f2$var$Sg = $b5fecd57b45662f2$var$nv;
});
var $b5fecd57b45662f2$var$iv, $b5fecd57b45662f2$var$vg, $b5fecd57b45662f2$var$Ag = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Tp();
    $b5fecd57b45662f2$var$_p();
    $b5fecd57b45662f2$var$Cg();
    $b5fecd57b45662f2$var$iv = ({ className: t, action: e })=>$b5fecd57b45662f2$var$wp(e) ? $acw62.createElement($b5fecd57b45662f2$var$Np, {
            action: e,
            className: t
        }) : $b5fecd57b45662f2$var$Pp(e, "delete") ? $acw62.createElement($b5fecd57b45662f2$var$Sg, {
            action: e,
            className: t
        }) : null, $b5fecd57b45662f2$var$vg = $b5fecd57b45662f2$var$iv;
});
var $b5fecd57b45662f2$var$lv, $b5fecd57b45662f2$var$Rg, $b5fecd57b45662f2$var$kg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ag();
    $b5fecd57b45662f2$var$lv = ({ row: t, size: e, vertical: o, className: r, buttonClassName: a })=>!t._actions || t._actions.length === 0 ? null : $acw62.createElement((0, $f57q8.default), {
            size: e,
            vertical: o,
            className: r
        }, t._actions.map((i, s)=>$acw62.createElement($b5fecd57b45662f2$var$vg, {
                key: `action-${s}`,
                action: i,
                className: a
            }))), $b5fecd57b45662f2$var$Rg = $b5fecd57b45662f2$var$lv;
});
var $b5fecd57b45662f2$var$fr, $b5fecd57b45662f2$var$is = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$kg();
    $b5fecd57b45662f2$var$fr = $b5fecd57b45662f2$var$Rg;
});
var $b5fecd57b45662f2$var$pv, $b5fecd57b45662f2$var$Fg, $b5fecd57b45662f2$var$wg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$is();
    $b5fecd57b45662f2$var$pv = ({ row: t })=>$acw62.createElement("td", {
            className: "text-end align-middle"
        }, $acw62.createElement($b5fecd57b45662f2$var$fr, {
            row: t,
            size: "sm"
        })), $b5fecd57b45662f2$var$Fg = $b5fecd57b45662f2$var$pv;
});
var $b5fecd57b45662f2$var$cv, $b5fecd57b45662f2$var$Ja, $b5fecd57b45662f2$var$ls = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$cv = ({ id: t })=>{
        let { isRowSelected: e, setRowSelected: o } = $b5fecd57b45662f2$var$h();
        return $acw62.createElement((0, $9JAYi.default), {
            onChange: (r)=>o(t, r.target.checked),
            checked: e(t)
        });
    }, $b5fecd57b45662f2$var$Ja = $b5fecd57b45662f2$var$cv;
});
var $b5fecd57b45662f2$var$Tg, $b5fecd57b45662f2$var$Qa, $b5fecd57b45662f2$var$ps = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Tg = (0, $acw62.createContext)({
        isSelectionMode: !1,
        setSelectionMode: ()=>{},
        cardConfig: {
            fixed: []
        }
    });
    $b5fecd57b45662f2$var$Tg.displayName = "MobileTableContext";
    $b5fecd57b45662f2$var$Qa = $b5fecd57b45662f2$var$Tg;
});
function $b5fecd57b45662f2$var$tn() {
    return (0, $acw62.useContext)($b5fecd57b45662f2$var$Qa);
}
var $b5fecd57b45662f2$var$Mg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ps();
});
function $b5fecd57b45662f2$export$c32275ecbd12948f(t = !1) {
    let [e, o] = (0, $acw62.useState)(t), r = (0, $acw62.useCallback)((s = null)=>{
        o(s === null ? (l)=>!l : s);
    }, []), a = (0, $acw62.useCallback)(()=>{
        o(!0);
    }, []), i = (0, $acw62.useCallback)(()=>{
        o(!1);
    }, []);
    return {
        state: e,
        toggle: r,
        setTrue: a,
        setFalse: i
    };
}
var $b5fecd57b45662f2$var$Ee = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$Ng = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$yv, $b5fecd57b45662f2$var$_g, $b5fecd57b45662f2$var$cs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ps();
    $b5fecd57b45662f2$var$Mg();
    $b5fecd57b45662f2$var$Ee();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Ng();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$yv = ({ children: t })=>{
        let e = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { state: o, toggle: r } = $b5fecd57b45662f2$export$c32275ecbd12948f(), { rowsSelected: a, data: { columns: i } } = $b5fecd57b45662f2$var$h(), s = (0, $acw62.useCallback)((p)=>{
            r(p), e.Topbar.Row.updateOptions({
                fixed: p
            });
        }, []);
        (0, $acw62.useEffect)(()=>{
            !(a != null && a.length) && o && s(!1);
        }, [
            a == null ? void 0 : a.length
        ]);
        let l = $acw62.useMemo(()=>({
                fixed: i.map((p)=>({
                        [p.key]: {
                            captionMode: "text",
                            toEnd: !1
                        }
                    }))
            }), []);
        return $acw62.createElement($b5fecd57b45662f2$var$Qa.Provider, {
            value: {
                isSelectionMode: o,
                setSelectionMode: s,
                cardConfig: l
            }
        }, t);
    }, $b5fecd57b45662f2$var$_g = $b5fecd57b45662f2$var$yv;
});
var $b5fecd57b45662f2$var$xv, $b5fecd57b45662f2$var$Bg, $b5fecd57b45662f2$var$Og = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$cs();
    $b5fecd57b45662f2$var$ls();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$xv = ({ index: t, id: e })=>{
        let { isSelectionMode: o, setSelectionMode: r } = $b5fecd57b45662f2$var$tn(), { setRowSelected: a } = $b5fecd57b45662f2$var$h(), i = ()=>{
            r(!0), a(e, !0);
        };
        return o ? $acw62.createElement($b5fecd57b45662f2$var$Ja, {
            id: e
        }) : $acw62.createElement("span", {
            role: "button",
            onClick: i
        }, t);
    }, $b5fecd57b45662f2$var$Bg = $b5fecd57b45662f2$var$xv;
});
function $b5fecd57b45662f2$var$Ig(t) {
    return typeof t == "object" && t !== null && "name" in t && "options" in t && "columns" in t && "filters" in t && "data" in t && "pagination" in t;
}
var $b5fecd57b45662f2$var$Fo, $b5fecd57b45662f2$var$on, $b5fecd57b45662f2$var$gr = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Fo = (t)=>typeof t == "object" && t !== null && "currentPage" in t && "from" in t && "to" in t && "total" in t && "perPage" in t, $b5fecd57b45662f2$var$on = (t)=>typeof t == "object" && t !== null && "name" in t && "prev" in t && "next" in t && "perPage" in t;
});
function $b5fecd57b45662f2$var$hr(t, e) {
    let { hasGroupActions: o, data: { options: { hasIndexes: r }, pagination: a } } = $b5fecd57b45662f2$var$h();
    if (!o && !r) return null;
    if (!$b5fecd57b45662f2$var$Fo(a)) throw new Error("Index can only be used with base pagination data.");
    let i = e + a.from;
    return r ? o ? $acw62.createElement($b5fecd57b45662f2$var$Bg, {
        id: t,
        index: i
    }) : $acw62.createElement("span", null, i) : $acw62.createElement($b5fecd57b45662f2$var$Ja, {
        id: t
    });
}
var $b5fecd57b45662f2$var$ds = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$ls();
    $b5fecd57b45662f2$var$Og();
    $b5fecd57b45662f2$var$gr();
});
var $b5fecd57b45662f2$var$bv, $b5fecd57b45662f2$var$Dv, $b5fecd57b45662f2$var$Lg, $b5fecd57b45662f2$var$Xg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Fp();
    $b5fecd57b45662f2$var$wg();
    $b5fecd57b45662f2$var$ds();
    $b5fecd57b45662f2$var$bv = ({ row: t, index: e })=>{
        let o = $b5fecd57b45662f2$var$hr(t._id, e);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            className: "align-middle"
        }, o);
    }, $b5fecd57b45662f2$var$Dv = ({ row: t, index: e })=>{
        let { showColumns: o, hasGroupActions: r, data: { options: { hasIndexes: a, hasRowActions: i } } } = $b5fecd57b45662f2$var$h();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, (a || r) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$bv, {
            row: t,
            index: e
        }), o.map((s)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$kp, {
                key: `cell-${s.key}`,
                col: s,
                data: t
            })), i && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Fg, {
            row: t
        }));
    }, $b5fecd57b45662f2$var$Lg = $b5fecd57b45662f2$var$Dv;
});
var $b5fecd57b45662f2$var$Sv, $b5fecd57b45662f2$var$Ug, $b5fecd57b45662f2$var$Wg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Xg();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Sv = ()=>{
        let { rows: t } = $b5fecd57b45662f2$var$h();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, t.map((e, o)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Lg, {
                row: e,
                index: o,
                key: "row-" + e._id
            })));
    }, $b5fecd57b45662f2$var$Ug = $b5fecd57b45662f2$var$Sv;
});
var $b5fecd57b45662f2$var$vv, $b5fecd57b45662f2$var$gs, $b5fecd57b45662f2$var$Eg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ap();
    $b5fecd57b45662f2$var$Wg();
    $b5fecd57b45662f2$var$vv = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $j3TSU.default), {
            responsive: !0
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$vp, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Ug, null)), $b5fecd57b45662f2$var$gs = $b5fecd57b45662f2$var$vv;
});
var $b5fecd57b45662f2$var$Av, $b5fecd57b45662f2$var$an, $b5fecd57b45662f2$var$Hg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Di();
    $b5fecd57b45662f2$var$Av = ({ data: t, cols: e })=>$acw62.createElement($acw62.Fragment, null, e.map((o)=>{
            var r;
            return $acw62.createElement("div", {
                key: `col-${o.key}`,
                "data-title": o.title
            }, $acw62.createElement($b5fecd57b45662f2$var$ya, {
                name: o.key,
                value: (r = t[o.key]) != null ? r : null,
                data: t
            }));
        })), $b5fecd57b45662f2$var$an = $b5fecd57b45662f2$var$Av;
});
function $b5fecd57b45662f2$var$nn(t, e) {
    return Object.entries(t).filter(([o])=>o !== e).reduce((o, [r, a])=>({
            ...o,
            [r]: a
        }), {});
}
function $b5fecd57b45662f2$var$xr(t) {
    return t.length > 0;
}
var $b5fecd57b45662f2$var$sn = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$Pv, $b5fecd57b45662f2$var$Yg, $b5fecd57b45662f2$var$Gg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Hg();
    $b5fecd57b45662f2$var$da();
    $b5fecd57b45662f2$var$sn();
    $b5fecd57b45662f2$var$Ee();
    $b5fecd57b45662f2$var$ds();
    $b5fecd57b45662f2$var$is();
    $b5fecd57b45662f2$var$Pv = ({ data: t, index: e })=>{
        var d;
        let { showColumns: o, hasGroupActions: r, data: { options: { hasIndexes: a } } } = $b5fecd57b45662f2$var$h(), i = (0, $acw62.useMemo)(()=>{
            var u;
            let f = {
                fixed: [],
                captioned: [],
                collapsed: [],
                hidden: []
            };
            for (let g of o)(u = f[g.showType]) == null || u.push(g);
            return f;
        }, [
            o
        ]), s = $b5fecd57b45662f2$var$xr(i.collapsed), l = $b5fecd57b45662f2$export$c32275ecbd12948f(), p = $b5fecd57b45662f2$var$hr(t._id, e), m = $acw62.useCallback((f)=>{
            let u = f.target;
            u && !u.classList.contains("datatable-mobile-row") && ([
                "a",
                "button",
                "input"
            ].includes(u.tagName.toLowerCase()) || u.closest("a, button") || u.role && [
                "dialog",
                "button"
            ].includes(u.role.toLowerCase())) || l.toggle();
        }, [
            l.toggle
        ]), c = a || r;
        return $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("datatable-mobile-row", c && "datatable-mobile-row-with-index"),
            role: "button",
            onClick: m
        }, c && $acw62.createElement("div", {
            className: "datatable-mobile-row-info"
        }, p), s && $acw62.createElement("div", {
            className: "datatable-mobile-collapse-btn"
        }, $acw62.createElement((0, $6LAgE.default), {
            variant: "link",
            className: "mt-auto p-0"
        }, $acw62.createElement("i", {
            className: `mdi mdi-chevron-double-${l.state ? "up" : "down"}`
        }))), $acw62.createElement("div", {
            className: "datatable-mobile-row-data"
        }, !s && !!((d = t._actions) != null && d.length) && $acw62.createElement($b5fecd57b45662f2$var$fr, {
            row: t,
            size: "sm",
            className: "float-end"
        }), $b5fecd57b45662f2$var$xr(i.fixed) && $acw62.createElement("div", {
            className: "datatable-mobile-row-fixed"
        }, $acw62.createElement($b5fecd57b45662f2$var$an, {
            data: t,
            cols: i.fixed
        })), $b5fecd57b45662f2$var$xr(i.captioned) && $acw62.createElement("div", {
            className: "datatable-mobile-row-captioned"
        }, $acw62.createElement($b5fecd57b45662f2$var$an, {
            data: t,
            cols: i.captioned
        })), $b5fecd57b45662f2$var$xr(i.collapsed) && $acw62.createElement((0, $8qr9R.default), {
            in: l.state
        }, $acw62.createElement("div", null, $acw62.createElement("div", {
            className: "datatable-mobile-row-collapsed"
        }, $acw62.createElement($b5fecd57b45662f2$var$an, {
            data: t,
            cols: i.collapsed
        })), t._actions && $acw62.createElement($b5fecd57b45662f2$var$fr, {
            row: t,
            size: "sm"
        })))));
    }, $b5fecd57b45662f2$var$Yg = $b5fecd57b45662f2$var$Pv;
});
var $b5fecd57b45662f2$var$Tv, $b5fecd57b45662f2$var$zg, $b5fecd57b45662f2$var$jg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Gg();
    $b5fecd57b45662f2$var$cs();
    $b5fecd57b45662f2$var$Tv = ({})=>{
        let { rows: t } = $b5fecd57b45662f2$var$h();
        return $acw62.createElement($b5fecd57b45662f2$var$_g, null, $acw62.createElement("div", {
            className: "datatable-mobile"
        }, t.map((e, o)=>$acw62.createElement($b5fecd57b45662f2$var$Yg, {
                data: e,
                index: o,
                key: "row-" + e._id
            }))));
    }, $b5fecd57b45662f2$var$zg = $b5fecd57b45662f2$var$Tv;
});
var $b5fecd57b45662f2$var$qg, $b5fecd57b45662f2$var$$g = $b5fecd57b45662f2$var$n(()=>{
    $b5fecd57b45662f2$var$qg = 'data:image/svg+xml,<svg id="9a5c15f4-7944-40bc-b8da-d63b7d478a28" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="842" height="778.92" viewBox="0 0 842 778.92"><defs><linearGradient id="a91ba363-77be-43f7-9cf6-91c4a3880d9c" x1="378.37" y1="732.81" x2="378.37" y2="130.21" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="gray" stop-opacity="0.25"/><stop offset="0.54" stop-color="gray" stop-opacity="0.12"/><stop offset="1" stop-color="gray" stop-opacity="0.1"/></linearGradient><linearGradient id="d1e6aa0e-d79d-4f6f-afbb-c37e9ed80ff9" x1="274.44" y1="409.32" x2="274.44" y2="248.16" xlink:href="%23a91ba363-77be-43f7-9cf6-91c4a3880d9c"/><linearGradient id="a279b039-1afd-4281-8292-ccd5c8c9b734" x1="274.44" y1="361.44" x2="274.44" y2="261.01" xlink:href="%23a91ba363-77be-43f7-9cf6-91c4a3880d9c"/><clipPath id="42e7b1d1-2be2-47b0-aacb-a853df270819" transform="translate(-179 -60.54)"><rect id="cf34cfb5-9399-4bae-9cea-d47bbef6cb3a" data-name="&lt;Rectangle&gt;" x="381.54" y="322.72" width="143.79" height="96.93" fill="%23fff"/></clipPath><linearGradient id="972637f2-71db-4198-9c75-a0854a7fe249" x1="274.44" y1="616.03" x2="274.44" y2="454.87" xlink:href="%23a91ba363-77be-43f7-9cf6-91c4a3880d9c"/><linearGradient id="6c85befd-f960-412c-83e0-663d4b13bf85" x1="274.44" y1="568.15" x2="274.44" y2="467.72" xlink:href="%23a91ba363-77be-43f7-9cf6-91c4a3880d9c"/><clipPath id="f66b8fac-771d-49bf-85c7-4ce29a79f723" transform="translate(-179 -60.54)"><rect id="7439734d-5f7c-428f-88ce-e68b86a45c07" data-name="&lt;Rectangle&gt;" x="381.54" y="529.42" width="143.79" height="96.93" fill="%23fff"/></clipPath><linearGradient id="598f8edf-c762-4b18-b52d-250fc678075a" x1="688.76" y1="765.86" x2="688.76" y2="163.26" gradientTransform="translate(1142.22 -188.53) rotate(90)" xlink:href="%23a91ba363-77be-43f7-9cf6-91c4a3880d9c"/><linearGradient id="013b841e-9a42-49b8-8a36-6db9ed002b72" x1="688.18" y1="568.49" x2="688.18" y2="409.67" gradientTransform="translate(1161.39 -164.01) rotate(90)" xlink:href="%23a91ba363-77be-43f7-9cf6-91c4a3880d9c"/><linearGradient id="f8cab3c1-d868-48bc-b87d-cd2075ddc26a" x1="810.6" y1="767.54" x2="810.6" y2="362.71" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="%23b3b3b3" stop-opacity="0.25"/><stop offset="0.54" stop-color="%23b3b3b3" stop-opacity="0.1"/><stop offset="1" stop-color="%23b3b3b3" stop-opacity="0.05"/></linearGradient><linearGradient id="043d467e-585e-47c7-bb2c-06dd6f5be04b" x1="685.49" y1="507.08" x2="685.49" y2="487.6" gradientUnits="userSpaceOnUse"><stop offset="0" stop-opacity="0.12"/><stop offset="0.55" stop-opacity="0.09"/><stop offset="1" stop-opacity="0.02"/></linearGradient><linearGradient id="be08032f-102d-431e-9b5f-1e4ebfc8159b" x1="774.99" y1="484.73" x2="774.99" y2="425.15" xlink:href="%23043d467e-585e-47c7-bb2c-06dd6f5be04b"/></defs><title>file searching</title><g opacity="0.5"><rect x="154.15" y="130.21" width="448.44" height="602.6" fill="url(%23a91ba363-77be-43f7-9cf6-91c4a3880d9c)"/></g><rect x="159.99" y="138.39" width="434.43" height="581.58" fill="%23f2f2f2"/><rect x="193.86" y="162.91" width="149.48" height="4.67" fill="%23e0e0e0"/><rect x="193.86" y="183.93" width="149.48" height="4.67" fill="%23727cf5" opacity="0.7"/><rect x="365.53" y="162.91" width="149.48" height="4.67" fill="%23e0e0e0"/><rect x="388.88" y="296.05" width="149.48" height="4.67" fill="%23e0e0e0"/><rect x="392.39" y="308.89" width="149.48" height="4.67" fill="%23e0e0e0"/><rect x="399.4" y="321.74" width="149.48" height="4.67" fill="%23e0e0e0"/><rect x="388.88" y="502.75" width="149.48" height="4.67" fill="%23e0e0e0"/><rect x="392.39" y="515.6" width="149.48" height="4.67" fill="%23e0e0e0"/><rect x="399.4" y="528.44" width="149.48" height="4.67" fill="%23e0e0e0"/><g opacity="0.5"><rect x="195.03" y="248.16" width="158.82" height="161.16" fill="url(%23d1e6aa0e-d79d-4f6f-afbb-c37e9ed80ff9)"/></g><rect x="196.03" y="251.67" width="156.32" height="154.15" fill="%23f5f5f5"/><g opacity="0.5"><rect x="201.54" y="261.01" width="145.8" height="100.43" fill="url(%23a279b039-1afd-4281-8292-ccd5c8c9b734)"/></g><rect id="e1f34465-d008-41db-868b-e00503fb87b3" data-name="&lt;Rectangle&gt;" x="202.54" y="262.18" width="143.79" height="96.93" fill="%23fff"/><g clip-path="url(%2342e7b1d1-2be2-47b0-aacb-a853df270819)"><polygon points="190.35 355.61 226.56 299.55 241.74 324.07 274.44 290.21 302.47 324.07 326.99 273.86 390.05 374.29 185.68 367.28 190.35 355.61" fill="%23727cf5" opacity="0.4"/><circle cx="218.38" cy="276.19" r="10.51" fill="%23727cf5" opacity="0.4"/></g><g opacity="0.5"><rect x="195.03" y="454.87" width="158.82" height="161.16" fill="url(%23972637f2-71db-4198-9c75-a0854a7fe249)"/></g><rect x="196.03" y="458.37" width="156.32" height="154.15" fill="%23f5f5f5"/><g opacity="0.5"><rect x="201.54" y="467.72" width="145.8" height="100.43" fill="url(%236c85befd-f960-412c-83e0-663d4b13bf85)"/></g><rect id="c95ac4f6-be4d-44a3-92c2-5c8066e2b531" data-name="&lt;Rectangle&gt;" x="202.54" y="468.88" width="143.79" height="96.93" fill="%23fff"/><g clip-path="url(%23f66b8fac-771d-49bf-85c7-4ce29a79f723)"><polygon points="190.35 562.31 226.56 506.25 241.74 530.78 274.44 496.91 302.47 530.78 326.99 480.56 390.05 580.99 185.68 573.99 190.35 562.31" fill="%23bdbdbd" opacity="0.4"/><circle cx="218.38" cy="482.9" r="10.51" fill="%23bdbdbd" opacity="0.4"/></g><g opacity="0.5"><rect x="376.36" y="276.01" width="602.6" height="448.44" transform="translate(-124.09 1006.82) rotate(-78.76)" fill="url(%23598f8edf-c762-4b18-b52d-250fc678075a)"/></g><rect x="386.18" y="280.49" width="581.58" height="434.43" transform="translate(-122.17 1004.12) rotate(-78.76)" fill="%23fff"/><rect x="542.89" y="232.65" width="308.31" height="4.67" transform="translate(-119.81 -191.93) rotate(11.24)" fill="%23e0e0e0"/><rect x="456.83" y="665.62" width="308.31" height="4.67" transform="translate(-37.05 -166.84) rotate(11.24)" fill="%23e0e0e0"/><rect x="452.26" y="685.13" width="238.24" height="4.67" transform="translate(-34.01 -158.75) rotate(11.24)" fill="%23e0e0e0"/><rect x="448.46" y="696.91" width="88.75" height="4.67" transform="translate(-33.22 -143.21) rotate(11.24)" fill="%23727cf5" opacity="0.7"/><rect x="539.13" y="243.97" width="154.15" height="4.67" transform="translate(-119.16 -175.95) rotate(11.24)" fill="%23727cf5" opacity="0.7"/><rect x="532.71" y="282.38" width="277.94" height="4.67" transform="translate(-110.6 -186.03) rotate(11.24)" fill="%23e0e0e0"/><rect x="529.49" y="288.24" width="67.73" height="4.67" transform="translate(-111.54 -164.8) rotate(11.24)" fill="%233ad29f" opacity="0.7"/><rect x="521.95" y="338.03" width="308.31" height="4.67" transform="translate(-99.67 -185.82) rotate(11.24)" fill="%23e0e0e0"/><g opacity="0.5"><rect x="592.89" y="385.78" width="158.82" height="276.77" transform="translate(-151.88 1020.84) rotate(-78.76)" fill="url(%23013b841e-9a42-49b8-8a36-6db9ed002b72)"/></g><rect x="535.78" y="445.94" width="273.27" height="155.32" transform="translate(-64.02 -181.59) rotate(11.24)" fill="%23fff"/><rect x="516.71" y="364.38" width="308.31" height="4.67" transform="translate(-94.63 -184.29) rotate(11.24)" fill="%23e0e0e0"/><rect x="566.14" y="449.2" width="33.87" height="113.28" transform="translate(-69.19 -164.51) rotate(11.24)" fill="%23727cf5"/><rect x="622.06" y="498.05" width="33.87" height="75.91" transform="translate(-62.24 -174.83) rotate(11.24)" fill="%233ad29f"/><rect x="678.21" y="544.59" width="33.87" height="40.87" transform="translate(-55.5 -185.22) rotate(11.24)" fill="%23f55f44"/><rect x="741.87" y="514.79" width="33.87" height="82.92" transform="translate(-55.99 -197.8) rotate(11.24)" fill="%23fdd835"/><path d="M880.45,410.55a155.89,155.89,0,0,0-223.11-1.68c-59,59.48-60,156.33-2.29,217.07A155.89,155.89,0,0,0,854.95,648L967.64,765.21a7.59,7.59,0,0,0,10.73.21l28.08-27a7.59,7.59,0,0,0,.21-10.73L894,610.49A155.9,155.9,0,0,0,880.45,410.55ZM845.35,599a111.5,111.5,0,1,1,3.1-157.66A111.5,111.5,0,0,1,845.35,599Z" transform="translate(-179 -60.54)" fill="url(%23f8cab3c1-d868-48bc-b87d-cd2075ddc26a)"/><path d="M685.49,487.6c-12.54,0-12.56,19.49,0,19.49S698.05,487.6,685.49,487.6Z" transform="translate(-179 -60.54)" fill="url(%23043d467e-585e-47c7-bb2c-06dd6f5be04b)"/><path d="M772.9,425.17c-33.75-.76-64.46,16.17-80.79,41.73-5.33,8.34,9.8,15.71,15.1,7.41,13.52-21.16,39.21-34.6,67-33.9,29.12.73,55.62,17.39,69.65,40.51,5.32,8.77,19.27.8,14-7.92C840.8,445,807.76,426,772.9,425.17Z" transform="translate(-179 -60.54)" fill="url(%23be08032f-102d-431e-9b5f-1e4ebfc8159b)"/><path d="M892.68,404.63a155.89,155.89,0,0,0-223.11-1.68c-59,59.48-60,156.33-2.29,217.07a155.89,155.89,0,0,0,199.9,22.05L979.86,759.29a7.59,7.59,0,0,0,10.73.21l28.08-27a7.59,7.59,0,0,0,.21-10.73L906.19,604.56A155.9,155.9,0,0,0,892.68,404.63ZM857.58,593a111.5,111.5,0,1,1,3.1-157.66A111.5,111.5,0,0,1,857.58,593Z" transform="translate(-179 -60.54)" fill="%23727cf5"/><path d="M697.72,481.67c-12.54,0-12.56,19.49,0,19.49S710.28,481.67,697.72,481.67Z" transform="translate(-179 -60.54)" fill="%23727cf5"/><path d="M785.13,419.25c-33.75-.76-64.46,16.17-80.79,41.73-5.33,8.34,9.8,15.71,15.1,7.41,13.52-21.16,39.21-34.6,67-33.9,29.12.73,55.62,17.39,69.65,40.51,5.32,8.77,19.27.8,14-7.92C853,439,820,420,785.13,419.25Z" transform="translate(-179 -60.54)" fill="%23727cf5"/><rect x="121.45" y="663.91" width="3.5" height="19.85" fill="%2347e6b1"/><rect x="300.45" y="724.45" width="3.5" height="19.85" transform="translate(857.58 371.63) rotate(90)" fill="%2347e6b1"/><path d="M750.87,68.49a4.29,4.29,0,0,1-2.39-5.19,2.06,2.06,0,0,0,.09-.48h0a2.15,2.15,0,0,0-3.87-1.43h0a2.06,2.06,0,0,0-.24.42,4.29,4.29,0,0,1-5.19,2.39,2.06,2.06,0,0,0-.48-.09h0A2.15,2.15,0,0,0,737.38,68h0a2.06,2.06,0,0,0,.42.24,4.29,4.29,0,0,1,2.39,5.19,2.06,2.06,0,0,0-.09.48h0A2.15,2.15,0,0,0,744,75.32h0a2.06,2.06,0,0,0,.24-.42,4.29,4.29,0,0,1,5.19-2.39,2.06,2.06,0,0,0,.48.09h0a2.15,2.15,0,0,0,1.43-3.87h0A2.06,2.06,0,0,0,750.87,68.49Z" transform="translate(-179 -60.54)" fill="%234d8af0"/><path d="M316.44,215.64a4.29,4.29,0,0,1-2.39-5.19,2.06,2.06,0,0,0,.09-.48h0a2.15,2.15,0,0,0-3.87-1.43h0a2.06,2.06,0,0,0-.24.42,4.29,4.29,0,0,1-5.19,2.39,2.06,2.06,0,0,0-.48-.09h0a2.15,2.15,0,0,0-1.43,3.87h0a2.06,2.06,0,0,0,.42.24,4.29,4.29,0,0,1,2.39,5.19,2.06,2.06,0,0,0-.09.48h0a2.15,2.15,0,0,0,3.87,1.43h0a2.06,2.06,0,0,0,.24-.42,4.29,4.29,0,0,1,5.19-2.39,2.06,2.06,0,0,0,.48.09h0a2.15,2.15,0,0,0,1.43-3.87h0A2.06,2.06,0,0,0,316.44,215.64Z" transform="translate(-179 -60.54)" fill="%23fdd835"/><path d="M934.22,822.9a4.29,4.29,0,0,1-2.39-5.19,2.06,2.06,0,0,0,.09-.48h0a2.15,2.15,0,0,0-3.87-1.43h0a2.06,2.06,0,0,0-.24.42,4.29,4.29,0,0,1-5.19,2.39,2.06,2.06,0,0,0-.48-.09h0a2.15,2.15,0,0,0-1.43,3.87h0a2.06,2.06,0,0,0,.42.24,4.29,4.29,0,0,1,2.39,5.19,2.06,2.06,0,0,0-.09.48h0a2.15,2.15,0,0,0,3.87,1.43h0a2.06,2.06,0,0,0,.24-.42,4.29,4.29,0,0,1,5.19-2.39,2.06,2.06,0,0,0,.48.09h0a2.15,2.15,0,0,0,1.43-3.87h0A2.06,2.06,0,0,0,934.22,822.9Z" transform="translate(-179 -60.54)" fill="%23fdd835"/><circle cx="321.15" cy="75.33" r="7.01" fill="%23f55f44"/><circle cx="823.31" cy="162.91" r="7.01" fill="%23f55f44"/><circle cx="783.61" cy="371.95" r="7.01" fill="%234d8af0"/><circle cx="7.01" cy="28.61" r="7.01" fill="%2347e6b1" opacity="0.5"/></svg>';
});
var $b5fecd57b45662f2$var$_v, $b5fecd57b45662f2$var$Kg, $b5fecd57b45662f2$var$Zg = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$$g();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$_v = ()=>{
        let { isActiveFilters: t, setSearchParams: e } = $b5fecd57b45662f2$var$h();
        return $acw62.createElement("div", {
            className: "d-flex flex-column gap-2 align-items-center"
        }, $acw62.createElement("img", {
            src: $b5fecd57b45662f2$var$qg,
            className: "w-100",
            style: {
                maxWidth: "250px"
            },
            alt: ""
        }), $acw62.createElement("div", {
            className: "fs-2"
        }, "\u041D\u0435\u043C\u0430\u0454 \u0436\u043E\u0434\u043D\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443"), t && $acw62.createElement($acw62.Fragment, null, $acw62.createElement("p", null, "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0448\u0443\u043A \u0431\u0435\u0437 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432"), $acw62.createElement((0, $6LAgE.default), {
            variant: "outline-secondary",
            size: "sm",
            onClick: ()=>e()
        }, "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440")));
    }, $b5fecd57b45662f2$var$Kg = $b5fecd57b45662f2$var$_v;
});
var $b5fecd57b45662f2$var$Jg, $b5fecd57b45662f2$var$Bv, $b5fecd57b45662f2$var$Qg, $b5fecd57b45662f2$var$th = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Eg();
    $b5fecd57b45662f2$var$jg();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Zg();
    $b5fecd57b45662f2$var$Jg = 1450, $b5fecd57b45662f2$var$Bv = ()=>{
        let { settings: { disableMobileLayout: t } } = $b5fecd57b45662f2$var$h(), [e, o] = $acw62.useState(()=>window.innerWidth > $b5fecd57b45662f2$var$Jg), r = ()=>{
            o(window.innerWidth > $b5fecd57b45662f2$var$Jg);
        };
        $acw62.useEffect(()=>(window.addEventListener("resize", r), ()=>window.removeEventListener("resize", r)));
        let { isResults: a } = $b5fecd57b45662f2$var$h();
        return a ? t ? $acw62.createElement($b5fecd57b45662f2$var$gs, null) : e ? $acw62.createElement($b5fecd57b45662f2$var$gs, null) : $acw62.createElement($b5fecd57b45662f2$var$zg, null) : $acw62.createElement($b5fecd57b45662f2$var$Kg, null);
    }, $b5fecd57b45662f2$var$Qg = $b5fecd57b45662f2$var$Bv;
});
var $b5fecd57b45662f2$var$Ov, $b5fecd57b45662f2$var$pn, $b5fecd57b45662f2$var$ys = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$gr();
    $b5fecd57b45662f2$var$Ov = ({ pagination: t, rowsCnt: e })=>{
        if (!e) return null;
        if ($b5fecd57b45662f2$var$Fo(t)) {
            let { from: o, to: r, total: a } = t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "table-display-info text-muted small"
            }, "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u0437\u0430\u043F\u0438\u0441\u0438 ", o, " - ", r, " \u0437 ", a);
        }
        return $b5fecd57b45662f2$var$on(t) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "table-display-info text-muted small"
        }, "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E ", e, " \u0437\u0430\u043F\u0438\u0441\u0456\u0432") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "table-display-info text-muted small"
        }, "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u0432\u0441\u0456 \u0437\u0430\u043F\u0438\u0441\u0438");
    }, $b5fecd57b45662f2$var$pn = $b5fecd57b45662f2$var$Ov;
});
function $b5fecd57b45662f2$var$Lv(t, e) {
    let o = e - t + 1;
    return Array(o).fill(0).map((r, a)=>a + t);
}
function $b5fecd57b45662f2$var$xs({ currentPage: t, perPage: e, total: o }) {
    let r = (0, $acw62.useMemo)(()=>Math.ceil(o / e), [
        o,
        e
    ]);
    if (r < 2) return [];
    let a = Math.max(t - 1, 1), i = Math.min(t + 2, r), s = $b5fecd57b45662f2$var$Lv(a, i);
    s.indexOf(1) === -1 && s.unshift(1), s.indexOf(r) === -1 && s.push(r);
    let l = [], p = 0;
    return s.forEach((m)=>{
        m - p > 1 && l.push({
            type: "ellipsis"
        }), l.push({
            type: "item",
            page: m,
            current: t === m
        }), p = m;
    }), l;
}
var $b5fecd57b45662f2$var$eh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$Xv, $b5fecd57b45662f2$var$oh, $b5fecd57b45662f2$var$rh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$eh();
    $b5fecd57b45662f2$var$co();
    $b5fecd57b45662f2$var$Xv = ({ data: { currentPage: t, perPage: e, total: o } })=>{
        let r = $b5fecd57b45662f2$var$xs({
            currentPage: t,
            perPage: e,
            total: o
        }), { setSearchParams: a } = $b5fecd57b45662f2$var$Pt(), i = (s)=>{
            a({
                page: s
            });
        };
        return $acw62.createElement((0, $2jjfn.default), {
            className: "mb-0 table-pagination",
            size: "sm"
        }, r.map((s, l)=>s.type === "item" ? $acw62.createElement((0, $2jjfn.default).Item, {
                key: "p-" + l,
                active: s.current,
                onClick: ()=>i(s.page)
            }, s.page) : $acw62.createElement((0, $2jjfn.default).Ellipsis, {
                key: "p-" + l,
                disabled: !0
            })));
    }, $b5fecd57b45662f2$var$oh = $b5fecd57b45662f2$var$Xv;
});
var $b5fecd57b45662f2$var$ah, $b5fecd57b45662f2$var$Vv, $b5fecd57b45662f2$var$ih, $b5fecd57b45662f2$var$sh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$co();
    $b5fecd57b45662f2$var$ah = ({ disabled: t, onClick: e, type: o })=>$acw62.createElement((0, $2jjfn.default).Item, {
            onClick: e,
            disabled: t
        }, $acw62.createElement("span", {
            className: "d-flex align-items-center user-select-none"
        }, o === "prev" ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement("i", {
            className: "mdi mdi-chevron-left"
        }), $acw62.createElement("span", {
            className: "ms-1 d-none d-md-inline-block small"
        }, "\u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F")) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement("span", {
            className: "me-1 d-none d-md-inline-block small"
        }, "\u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0430"), $acw62.createElement("i", {
            className: "mdi mdi-chevron-right"
        })))), $b5fecd57b45662f2$var$Vv = ({ data: { name: t, prev: e, next: o } })=>{
        let { setSearchParams: r } = $b5fecd57b45662f2$var$Pt(), a = (i)=>{
            r({
                [t]: i
            });
        };
        return $acw62.createElement((0, $2jjfn.default), {
            className: "mb-0 table-pagination",
            size: "sm"
        }, $acw62.createElement($b5fecd57b45662f2$var$ah, {
            onClick: ()=>a(e),
            disabled: e === null,
            type: "prev"
        }), $acw62.createElement($b5fecd57b45662f2$var$ah, {
            onClick: ()=>a(o),
            disabled: o === null,
            type: "next"
        }));
    }, $b5fecd57b45662f2$var$ih = $b5fecd57b45662f2$var$Vv;
});
var $b5fecd57b45662f2$var$Uv, $b5fecd57b45662f2$var$ph, $b5fecd57b45662f2$var$mh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$gr();
    $b5fecd57b45662f2$var$rh();
    $b5fecd57b45662f2$var$sh();
    $b5fecd57b45662f2$var$Uv = ({ pagination: t })=>$b5fecd57b45662f2$var$Fo(t) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$oh, {
            data: t
        }) : $b5fecd57b45662f2$var$on(t) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$ih, {
            data: t
        }) : null, $b5fecd57b45662f2$var$ph = $b5fecd57b45662f2$var$Uv;
});
function $b5fecd57b45662f2$export$3c61b618e38b9752(t, e, o) {
    return t % 10 === 1 && t % 100 !== 11 ? e : o;
}
var $b5fecd57b45662f2$var$Ds = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$export$8c2572089a81a391, $b5fecd57b45662f2$var$tt = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$export$8c2572089a81a391 = class {
        constructor(){
            this._listeners = [];
        }
        subscribe(e) {
            return this._listeners.push(e), e(), ()=>{
                this._listeners = this._listeners.filter((o)=>o !== e);
            };
        }
        _callListeners() {
            for (let e of this._listeners)e();
        }
    };
});
function $b5fecd57b45662f2$var$re(t) {
    return typeof t == "object" && t !== null && "id" in t && "name" in t && "username" in t;
}
var $b5fecd57b45662f2$var$Ss = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
function $b5fecd57b45662f2$var$ct(t, e) {
    return typeof t == "object" && t !== null && "state" in t && t.state === e;
}
function $b5fecd57b45662f2$var$Dr(t, e) {
    return typeof t == "object" && t !== null && "status" in t && t.status === e;
}
var $b5fecd57b45662f2$var$Cs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$He, $b5fecd57b45662f2$var$As = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Cs();
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$He = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(o, r){
            super();
            this._data = {
                state: "credentials"
            };
            this.resendTimeout = null;
            this._config = o, this._auth = r, this._auth.subscribe(()=>{
                this._refresh();
            });
        }
        _refresh() {
            this._data = {
                state: "credentials"
            }, this._callListeners();
        }
        _makeResendTimeout(o) {
            if (this.resendTimeout && (clearTimeout(this.resendTimeout), this.resendTimeout = null), !$b5fecd57b45662f2$var$ct(this._data, "second-factor")) {
                this._refresh();
                return;
            }
            this.resendTimeout = setTimeout(()=>{
                this._data = {
                    ...this._data,
                    allowResend: !0
                }, this._callListeners();
            }, o * 1e3);
        }
        _setWaitSecondFactor(o) {
            this._data = {
                state: "second-factor",
                token: o.data.token,
                info: o.data.info,
                allowResend: !1
            }, this._makeResendTimeout(o.data.time), this._callListeners();
        }
        _markSuccess() {
            this._data = {
                state: "success"
            }, this._callListeners(), this._auth.refresh();
        }
        login(o) {
            return new Promise(async (r, a)=>{
                if (!$b5fecd57b45662f2$var$ct(this._data, "credentials")) {
                    this._refresh(), a("\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
                    return;
                }
                try {
                    let i = await this._config.loginHandler(o);
                    if ($b5fecd57b45662f2$var$Dr(i, "success")) {
                        this._markSuccess(), r();
                        return;
                    }
                    if ($b5fecd57b45662f2$var$Dr(i, "wait-second-factor")) {
                        this._setWaitSecondFactor(i), r();
                        return;
                    }
                    this._refresh(), a("\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
                } catch (i) {
                    a(i);
                }
            });
        }
        loginSecondFactor(o) {
            return new Promise(async (r, a)=>{
                if (!$b5fecd57b45662f2$var$ct(this._data, "second-factor")) {
                    this._refresh(), a("\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
                    return;
                }
                if (!this._config.loginSecondFactorHandler) {
                    a("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u0457");
                    return;
                }
                try {
                    let i = await this._config.loginSecondFactorHandler({
                        ...o,
                        token: this._data.token
                    });
                    if ($b5fecd57b45662f2$var$Dr(i, "success")) {
                        this._markSuccess(), r();
                        return;
                    }
                    this._refresh(), a("\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
                } catch (i) {
                    a(i);
                }
            });
        }
        resendSecondFactor() {
            return new Promise(async (o, r)=>{
                if (!$b5fecd57b45662f2$var$ct(this._data, "second-factor") || !this._data.allowResend) {
                    this._refresh(), r("\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
                    return;
                }
                if (!this._config.resendSecondFactorHandler) {
                    r("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u0457");
                    return;
                }
                try {
                    let a = await this._config.resendSecondFactorHandler(this._data.token);
                    if ($b5fecd57b45662f2$var$Dr(a, "wait-second-factor")) {
                        this._setWaitSecondFactor(a), o();
                        return;
                    }
                    this._refresh(), r("\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
                } catch (a) {
                    this._refresh(), r(a);
                }
            });
        }
        getData() {
            return this._data;
        }
    };
});
var $b5fecd57b45662f2$export$334c29725a78c21d, $b5fecd57b45662f2$var$uh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$Ss();
    $b5fecd57b45662f2$var$As();
    $b5fecd57b45662f2$export$334c29725a78c21d = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(o){
            super();
            this._data = null;
            this._config = o, this.refresh(), this.authenticator = new $b5fecd57b45662f2$var$He(o, this), (0, $ket0H.default).registerGlobalErrorHandler(this._handleApiError.bind(this));
        }
        _handleApiError(o) {
            this.isAuth() && (0, $ifGBV.isApiNotAuthorizedError)(o) && this.refresh();
        }
        async refresh() {
            return new Promise(async (o)=>{
                try {
                    this._data = await this._config.authUserResolver(), this._callListeners(), o();
                } catch  {
                    this._data = !1, this._callListeners(), o();
                }
            });
        }
        logout() {
            return new Promise(async (o, r)=>{
                try {
                    await this._config.logoutHandler(), this._data = null, this._callListeners(), this.refresh(), o();
                } catch (a) {
                    r(a);
                }
            });
        }
        isAuth() {
            return $b5fecd57b45662f2$var$re(this._data);
        }
        _can(o) {
            return !$b5fecd57b45662f2$var$re(this._data) || !this._data.permissions ? !1 : this._data.permissions.includes(o);
        }
        can(o) {
            return this.isAuth() ? Array.isArray(o) ? o.every((r)=>this._can(r)) : this._can(o) : !1;
        }
        canAny(o) {
            return this.isAuth() ? Array.isArray(o) ? o.some((r)=>this._can(r)) : this._can(o) : !1;
        }
        getData() {
            return this._data;
        }
    };
});
var $b5fecd57b45662f2$var$Rs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$uh();
    $b5fecd57b45662f2$var$As();
    $b5fecd57b45662f2$var$Ss();
    $b5fecd57b45662f2$var$Cs();
});
var $b5fecd57b45662f2$var$Sr = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
function $b5fecd57b45662f2$var$dh(t) {
    return typeof t < "u" && t.hasOwnProperty("text") && typeof t.text < "u";
}
function $b5fecd57b45662f2$var$fh(t) {
    return typeof t < "u" && t.hasOwnProperty("fields") && Array.isArray(t.fields) && t.fields.every((e)=>$b5fecd57b45662f2$var$Qi(e));
}
function $b5fecd57b45662f2$var$cn(t) {
    return typeof t < "u" && t.hasOwnProperty("formName") && typeof t.formName == "string";
}
function $b5fecd57b45662f2$var$gh(t) {
    return typeof t < "u" && t.hasOwnProperty("continue") && t.continue === !0;
}
function $b5fecd57b45662f2$var$Cr(t, e) {
    return typeof t < "u" && t.hasOwnProperty("status") && t.status === e;
}
function $b5fecd57b45662f2$var$un(t, e) {
    return typeof t < "u" && t.hasOwnProperty("status") && t.status === e;
}
var $b5fecd57b45662f2$var$dn = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$cr();
});
var $b5fecd57b45662f2$var$Hv, $b5fecd57b45662f2$export$e423b3d76cff810b, $b5fecd57b45662f2$var$Fs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Hv = ({ errors: t })=>typeof t == "string" ? $acw62.createElement("div", null, t) : $acw62.createElement($acw62.Fragment, null, t.map((e, o)=>$acw62.createElement("div", {
                key: `error-${o}`
            }, $acw62.createElement("i", {
                className: "mdi mdi-bullet"
            }), " ", e))), $b5fecd57b45662f2$export$e423b3d76cff810b = $b5fecd57b45662f2$var$Hv;
});
function $b5fecd57b45662f2$var$ws(t, e) {
    return !t || t.length < 1 ? e : t;
}
var $b5fecd57b45662f2$var$hh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$export$b52183d5cfb26dc9, $b5fecd57b45662f2$var$xh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$Sr();
    $b5fecd57b45662f2$var$dn();
    $b5fecd57b45662f2$var$Fs();
    $b5fecd57b45662f2$var$sn();
    $b5fecd57b45662f2$var$hh();
    $b5fecd57b45662f2$export$b52183d5cfb26dc9 = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(o, r){
            super();
            this._actions = [];
            this._websocketUnregister = {};
            this._resultRenderers = {};
            this._customForms = {};
            this._app = o, this._config = r;
        }
        _makeName(o, r) {
            return o + "." + r;
        }
        registerResultRenderer(o, r, a) {
            this._resultRenderers[this._makeName(o, r)] = a;
        }
        _getResultRenderer(o, r) {
            return this._resultRenderers[this._makeName(o, r)];
        }
        registerCustomForm(o, r) {
            this._customForms[o] = r;
        }
        getCustomFormComponent(o) {
            if (!this._customForms[o]) throw new Error("Custom form " + o + " not found");
            return this._customForms[o];
        }
        _makeEndpoint(o, r, a) {
            return this._config.endpoint + "/" + o + (r ? "/" + r : "") + (a ? "/" + a : "");
        }
        loadAction(o) {
            return new Promise((r, a)=>{
                (0, $ket0H.default).getData(this._makeEndpoint(o.model, o.action), {
                    ids: o.ids
                }).then((i)=>r({
                        ...i,
                        ids: o.ids,
                        model: o.model
                    })).catch((i)=>a(i));
            });
        }
        loadActions(o) {
            return new Promise((r, a)=>{
                (0, $ket0H.default).getData(this._makeEndpoint(o.model), {
                    ids: o.ids,
                    filter: o.filter
                }).then((i)=>r(i.map((s)=>({
                            ...s,
                            ids: o.ids,
                            model: o.model
                        })))).catch((i)=>a(i));
            });
        }
        handleAction(o, r) {
            let a = this._app.toasts.createToast({
                icon: o.icon,
                title: o.title,
                body: $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $4dB0L.default), {
                    animation: "border",
                    size: "sm",
                    className: "me-1"
                }), " \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F, \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435..."),
                disableClose: !0
            });
            return new Promise((i)=>{
                let s = (0, $5sKyw.default)(), l = (0, $ket0H.default)._makeUrl(this._makeEndpoint(o.model, o.name), {
                    ids: o.ids
                });
                this._actions.push({
                    actionId: s,
                    endpoint: l,
                    action: o,
                    status: "wait-check",
                    data: void 0,
                    toast: a,
                    handleRun: (p)=>this._runAction(s, p),
                    handleCancel: ()=>this._cancelAction(s),
                    getResultRenderer: ()=>this._getResultRenderer(o.model, o.name),
                    isRunning: !1,
                    handlers: r
                }), this._callListeners(), this._checkAction(s), i();
            });
        }
        _getAction(o) {
            return this._actions.find((r)=>r.actionId === o);
        }
        _updateAction(o, r) {
            let a = this._actions.findIndex((i)=>i.actionId === o);
            a !== -1 && (this._actions[a] = {
                ...this._actions[a],
                ...r
            }, this._callListeners());
        }
        _handleActionError(o, r) {
            let a = this._getAction(o);
            a && (this._updateAction(o, {
                status: "error",
                data: {
                    message: r
                }
            }), typeof r == "string" ? a.toast.update({
                variant: "danger",
                body: $acw62.createElement((0, $htkMF.ReactMarkdown), {
                    className: "markdown-text",
                    children: r
                }),
                showTime: 10,
                disableClose: !1
            }) : a.toast.update({
                variant: "danger",
                body: $acw62.createElement($b5fecd57b45662f2$export$e423b3d76cff810b, {
                    errors: r
                }),
                showTime: 10,
                disableClose: !1
            }), this._clearWebsocketHandler(o), this._clearAction(o));
        }
        async _checkAction(o) {
            let r = this._getAction(o);
            if (r) try {
                let a = this._makeEndpoint(r.action.model, r.action.name, "check"), i = await (0, $ket0H.default).getData(a, {
                    ids: r.action.ids
                });
                if ($b5fecd57b45662f2$var$dh(i)) {
                    this._updateAction(o, {
                        status: "confirming",
                        data: i
                    }), r.toast.hide();
                    return;
                }
                if ($b5fecd57b45662f2$var$fh(i) || $b5fecd57b45662f2$var$cn(i)) {
                    this._updateAction(o, {
                        status: "wait-data",
                        data: i
                    }), r.toast.hide();
                    return;
                }
                if ($b5fecd57b45662f2$var$gh(i)) {
                    await this._runAction(o, {
                        continue: !0
                    });
                    return;
                }
                this._handleActionError(o, "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
            } catch (a) {
                this._handleActionError(o, (0, $9PE8j.default)(a));
            }
        }
        async _runAction(o, r) {
            let a = this._getAction(o);
            if (a) {
                this._updateAction(o, {
                    isRunning: !0
                }), a.toast.update({
                    variant: void 0,
                    body: $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $4dB0L.default), {
                        animation: "border",
                        size: "sm",
                        className: "me-1"
                    }), " \u0412\u0438\u043A\u043E\u043D\u0443\u0454\u0442\u044C\u0441\u044F \u0434\u0456\u044F, \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435..."),
                    disableClose: !0
                }), a.toast.show(), this._makeWebsocketHandler(o);
                try {
                    let { data: i } = Object.values(r).some((s)=>s instanceof File || s instanceof FileList) ? await (0, $ket0H.default).postWithFile(a.endpoint, {
                        ...r,
                        action_id: o
                    }) : await (0, $ket0H.default).post(a.endpoint, {
                        ...r,
                        action_id: o
                    });
                    await this._handleActionResult(o, i);
                } catch (i) {
                    throw this._updateAction(o, {
                        isRunning: !1
                    }), a.toast.hide(), i;
                }
            }
        }
        async _handleActionResult(o, r) {
            var i, s, l, p, m, c, d, f;
            let a = this._getAction(o);
            if (a && a.isRunning) {
                if ($b5fecd57b45662f2$var$un(r, "success")) {
                    this._updateAction(o, {
                        status: "success",
                        data: r,
                        isRunning: !1
                    }), a.toast.update({
                        variant: "success",
                        body: $acw62.createElement((0, $htkMF.ReactMarkdown), {
                            className: "markdown-text",
                            children: $b5fecd57b45662f2$var$ws(r.message, "\u0423\u0441\u043F\u0456\u0448\u043D\u043E")
                        }),
                        showTime: 10,
                        disableClose: !1
                    }), a.toast.show(), this._clearWebsocketHandler(o), r.data || this._clearAction(o), r.redirect && r.redirect.length > 0 && this._app.navigation.navigate(r.redirect), (s = (i = a.handlers) == null ? void 0 : i.onSuccess) == null || s.call(i), (p = (l = a.handlers) == null ? void 0 : l.onAny) == null || p.call(l);
                    return;
                }
                if ($b5fecd57b45662f2$var$un(r, "error")) {
                    this._updateAction(o, {
                        status: "error",
                        data: r,
                        isRunning: !1
                    }), a.toast.update({
                        variant: "danger",
                        body: $acw62.createElement((0, $htkMF.ReactMarkdown), {
                            className: "markdown-text",
                            children: $b5fecd57b45662f2$var$ws(r.message, "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F")
                        }),
                        showTime: 10,
                        disableClose: !1
                    }), a.toast.show(), this._clearWebsocketHandler(o), r.data || this._clearAction(o), (c = (m = a.handlers) == null ? void 0 : m.onError) == null || c.call(m), (f = (d = a.handlers) == null ? void 0 : d.onAny) == null || f.call(d);
                    return;
                }
                if ($b5fecd57b45662f2$var$un(r, "queued")) {
                    this._updateAction(o, {
                        status: "queued",
                        data: r
                    }), a.toast.update({
                        variant: void 0,
                        body: $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $4dB0L.default), {
                            animation: "border",
                            size: "sm",
                            className: "me-1"
                        }), " \u0414\u0456\u044F \u0432 \u0447\u0435\u0440\u0437\u0456, \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435..."),
                        disableClose: !0
                    }), a.toast.show();
                    return;
                }
                this._handleActionError(o, "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430");
            }
        }
        _makeWebsocketHandler(o) {
            let r = (a)=>{
                this._handleActionResult(o, a), this._clearWebsocketHandler(o);
            };
            this._websocketUnregister[o] = this._app.websocket.listen("Action." + o, ".action.result", r);
        }
        _clearWebsocketHandler(o) {
            this._websocketUnregister[o] && (this._websocketUnregister[o](), this._websocketUnregister = $b5fecd57b45662f2$var$nn(this._websocketUnregister, o));
        }
        _clearAction(o) {
            this._actions = this._actions.filter((r)=>r.actionId !== o), this._callListeners();
        }
        _cancelAction(o) {
            this._clearWebsocketHandler(o), this._clearAction(o);
        }
        getData() {
            return this._actions;
        }
    };
});
var $b5fecd57b45662f2$var$bh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$xh();
    $b5fecd57b45662f2$var$Sr();
});
function $b5fecd57b45662f2$export$9ddc9e1ee85f7eca(t = "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F") {
    let e = (0, $aphAM.useAsyncError)();
    return (0, $acw62.useMemo)(()=>(console.warn("Await error", e), (0, $ifGBV.isApiAccessDeniedError)(e) ? {
            text: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u0446\u044C\u043E\u0433\u043E",
            icon: "lock-outline",
            color: "muted"
        } : (0, $ifGBV.isApiNotFoundError)(e) ? {
            text: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
            icon: "file-alert-outline",
            color: "muted"
        } : {
            text: t,
            icon: "alert-circle-outline",
            color: "danger"
        }), [
        e,
        t
    ]);
}
var $b5fecd57b45662f2$var$vr = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
function $b5fecd57b45662f2$export$8c673d87af9a56cb(t) {
    t.stopPropagation(), t.preventDefault();
}
var $b5fecd57b45662f2$var$Ms = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$Ns, $b5fecd57b45662f2$var$Jv, $b5fecd57b45662f2$var$Qv, $b5fecd57b45662f2$var$tA, $b5fecd57b45662f2$var$eA, $b5fecd57b45662f2$export$cfc7921d29ef7b80, $b5fecd57b45662f2$var$Dh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$vr();
    $b5fecd57b45662f2$var$Ms();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Ns = ({ icon: t, label: e, onClick: o = $b5fecd57b45662f2$export$8c673d87af9a56cb, ...r })=>$acw62.createElement((0, $6LAgE.default), {
            ...r,
            onClick: o
        }, t && $acw62.createElement("i", {
            className: `mdi mdi-${t} me-1`
        }), $acw62.createElement("span", null, e)), $b5fecd57b45662f2$var$Jv = (t)=>$acw62.createElement($b5fecd57b45662f2$var$Ns, {
            ...t,
            disabled: !0,
            icon: "loading mdi-spin",
            label: "\u041F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430"
        }), $b5fecd57b45662f2$var$Qv = ()=>($b5fecd57b45662f2$export$9ddc9e1ee85f7eca(), null), $b5fecd57b45662f2$var$tA = (t)=>{
        let { icon: e, text: o } = $b5fecd57b45662f2$export$9ddc9e1ee85f7eca();
        return $acw62.createElement($b5fecd57b45662f2$var$Ns, {
            ...t,
            disabled: !0,
            icon: e,
            label: o
        });
    }, $b5fecd57b45662f2$var$eA = ({ variant: t, size: e, className: o, showIfDisabled: r, onSuccess: a, onError: i, onAny: s, ...l })=>{
        let [p, m] = $acw62.useState(!1), c = $b5fecd57b45662f2$export$719b7bd3d9a721a9(), d = $acw62.useMemo(()=>c.loadAction(l), []), f = {
            variant: t,
            size: e,
            className: o
        }, u = $acw62.useCallback(async (g, x)=>{
            m(!0), g.preventDefault(), g.stopPropagation(), await c.handleAction(x, {
                onSuccess: a,
                onError: i,
                onAny: s
            }), m(!1);
        }, []);
        return $acw62.createElement($acw62.Suspense, {
            fallback: r ? $acw62.createElement($b5fecd57b45662f2$var$Jv, {
                ...f
            }) : $acw62.createElement("span", null)
        }, $acw62.createElement((0, $aphAM.Await), {
            resolve: d,
            errorElement: r ? $acw62.createElement($b5fecd57b45662f2$var$tA, {
                ...f
            }) : $acw62.createElement($b5fecd57b45662f2$var$Qv, null)
        }, (g)=>$acw62.createElement($b5fecd57b45662f2$var$Ns, {
                ...f,
                onClick: (x)=>u(x, g),
                icon: g.icon,
                label: g.title,
                disabled: !g.allowed || p
            })));
    }, $b5fecd57b45662f2$export$cfc7921d29ef7b80 = $b5fecd57b45662f2$var$eA;
});
var $b5fecd57b45662f2$var$nA, $b5fecd57b45662f2$var$iA, $b5fecd57b45662f2$var$Sh, $b5fecd57b45662f2$var$sA, $b5fecd57b45662f2$var$lA, $b5fecd57b45662f2$var$pA, $b5fecd57b45662f2$export$be40bdb4a62faae1, $b5fecd57b45662f2$var$Ch = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$vr();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$nA = ()=>$acw62.createElement((0, $gzHIW.default).ItemText, null, $acw62.createElement((0, $4dB0L.default), {
            animation: "border",
            size: "sm"
        }), $acw62.createElement("span", {
            className: "ms-1"
        }, "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0456\u0439")), $b5fecd57b45662f2$var$iA = ()=>{
        let { color: t, icon: e, text: o } = $b5fecd57b45662f2$export$9ddc9e1ee85f7eca();
        return $acw62.createElement((0, $gzHIW.default).ItemText, {
            className: `text-${t}`
        }, $acw62.createElement("i", {
            className: `mdi mdi-${e} me-1`
        }), o);
    }, $b5fecd57b45662f2$var$Sh = ({ icon: t, title: e, disabled: o, onClick: r, handleHide: a })=>{
        let [i, s] = $acw62.useState(!1), l = $acw62.useCallback(async (p)=>{
            s(!0), p.preventDefault(), p.stopPropagation();
            let m = r();
            m instanceof Promise && await m, s(!1), a();
        }, []);
        return $acw62.createElement((0, $gzHIW.default).Item, {
            onClick: l,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                "text-muted": o
            }),
            disabled: i
        }, t && $acw62.createElement("i", {
            className: `mdi mdi-${t} me-1`
        }), $acw62.createElement("span", null, e));
    }, $b5fecd57b45662f2$var$sA = ({ handleHide: t, additionalOptions: e, onSuccess: o, onError: r, onAny: a, ...i })=>{
        let s = $b5fecd57b45662f2$export$719b7bd3d9a721a9(), l = $acw62.useMemo(()=>s.loadActions(i), []);
        return $acw62.createElement($acw62.Suspense, {
            fallback: $acw62.createElement($b5fecd57b45662f2$var$nA, null)
        }, $acw62.createElement((0, $aphAM.Await), {
            resolve: l,
            errorElement: $acw62.createElement($b5fecd57b45662f2$var$iA, null)
        }, (p)=>$acw62.createElement($acw62.Fragment, null, (p == null ? void 0 : p.length) > 0 ? p.map((m)=>$acw62.createElement($b5fecd57b45662f2$var$Sh, {
                    key: `action-${m.name}`,
                    icon: m.icon,
                    title: m.title,
                    onClick: ()=>s.handleAction(m, {
                            onSuccess: o,
                            onError: r,
                            onAny: a
                        }),
                    disabled: !m.allowed,
                    handleHide: t
                })) : !e && $acw62.createElement((0, $gzHIW.default).ItemText, {
                className: "text-muted"
            }, $acw62.createElement("span", null, "\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u0434\u0456\u0439 \u043D\u0435\u043C\u0430\u0454")))), e && e.map((p, m)=>$acw62.createElement($b5fecd57b45662f2$var$Sh, {
                key: `option-${m}`,
                icon: p.icon,
                title: p.title,
                onClick: p.onClick,
                handleHide: t
            })));
    }, $b5fecd57b45662f2$var$lA = {
        strategy: "fixed",
        onFirstUpdate: ()=>window.dispatchEvent(new CustomEvent("scroll"))
    }, $b5fecd57b45662f2$var$pA = ({ toggleLabel: t = "\u0414\u0456\u0457", className: e, toggleProps: o, ...r })=>{
        let [a, i] = $acw62.useState(!1), s = $acw62.useCallback(()=>{
            i(!1);
        }, []), l = $acw62.useCallback((p)=>{
            i(p);
        }, []);
        return $acw62.createElement((0, $gzHIW.default), {
            show: a,
            onToggle: l,
            className: e
        }, $acw62.createElement((0, $gzHIW.default).Toggle, {
            ...o
        }, t), $acw62.createElement((0, $gzHIW.default).Menu, {
            show: a,
            popperConfig: $b5fecd57b45662f2$var$lA
        }, $acw62.createElement($b5fecd57b45662f2$var$sA, {
            ...r,
            handleHide: s
        })));
    }, $b5fecd57b45662f2$export$be40bdb4a62faae1 = $b5fecd57b45662f2$var$pA;
});
function $b5fecd57b45662f2$export$275c020f4a82b180(t) {
    let e = $b5fecd57b45662f2$export$719b7bd3d9a721a9();
    return $acw62.useCallback(async ()=>{
        let o = await e.loadAction(t);
        await e.handleAction(o);
    }, []);
}
var $b5fecd57b45662f2$var$Ah = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
});
var $b5fecd57b45662f2$var$Rh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Dh();
    $b5fecd57b45662f2$var$Ch();
    $b5fecd57b45662f2$var$Ah();
});
function $b5fecd57b45662f2$var$De(t) {
    return typeof t < "u" && t.hasOwnProperty("icon") && typeof t.icon == "string";
}
function $b5fecd57b45662f2$var$Ct(t) {
    return typeof t < "u" && t.hasOwnProperty("url") && typeof t.url == "string";
}
function $b5fecd57b45662f2$var$Rr(t) {
    return typeof t < "u" && t.hasOwnProperty("children") && Array.isArray(t.children);
}
var $b5fecd57b45662f2$var$kh, $b5fecd57b45662f2$var$Fh, $b5fecd57b45662f2$var$wh, $b5fecd57b45662f2$var$Bs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$kh = (t)=>typeof t == "string" || typeof t == "number" || t === !0 || t === null, $b5fecd57b45662f2$var$Fh = (t)=>typeof t == "object" && t !== null && t.hasOwnProperty("name") && typeof t.name == "string" && t.hasOwnProperty("value") && $b5fecd57b45662f2$var$kh(t.value), $b5fecd57b45662f2$var$wh = (t)=>{
        if (typeof t != "object" || t === null) return !1;
        for(let e in t)if (!$b5fecd57b45662f2$var$kh(t[e])) return !1;
        return !0;
    };
});
var $b5fecd57b45662f2$var$kr, $b5fecd57b45662f2$var$Ph = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$Bs();
    $b5fecd57b45662f2$var$kr = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(o, r){
            super();
            this._data = {
                data: null,
                counters: {},
                isOpen: !1
            };
            this._app = o, this._config = r, this._init();
        }
        _updateData(o, r = !1) {
            this._data = {
                ...this._data,
                ...o
            }, r || this._callListeners();
        }
        async _init() {
            if (!this._config.navigationMenuResolver) {
                this._updateData({
                    data: !1
                });
                return;
            }
            try {
                this._updateData({
                    data: await this._config.navigationMenuResolver(this._app)
                }, !0), await this._initCounters(), this._callListeners();
            } catch  {
                this._updateData({
                    data: !1
                }), this._callListeners();
            }
        }
        _handleCounterUpdate(o) {
            if (!$b5fecd57b45662f2$var$Fh(o)) {
                console.error("Invalid badge update data", o);
                return;
            }
            this._updateData({
                counters: {
                    ...this._data.counters,
                    [o.name]: o.value
                }
            });
        }
        async _initCounters() {
            if (!this._config.navigationCountersResolver) return;
            let o = await this._config.navigationCountersResolver(this._app);
            if (!$b5fecd57b45662f2$var$wh(o)) {
                console.error("Invalid initial badge list data", o);
                return;
            }
            this._updateData({
                counters: o
            }, !0), this._app.websocket.listen("App.Navigation", ".counter.updated", this._handleCounterUpdate.bind(this));
        }
        toggle(o) {
            this._updateData({
                isOpen: o !== void 0 ? o : !this._data.isOpen
            });
        }
        getData() {
            return this._data;
        }
    };
});
function $b5fecd57b45662f2$var$Fr(t) {
    return typeof t < "u" && t.hasOwnProperty("url") && typeof t.url == "string";
}
function $b5fecd57b45662f2$var$wr(t) {
    return typeof t < "u" && t.hasOwnProperty("handler") && typeof t.handler == "function";
}
function $b5fecd57b45662f2$var$To(t) {
    return typeof t < "u" && t.hasOwnProperty("items") && typeof t.items == "object";
}
function $b5fecd57b45662f2$var$Pr(t) {
    return typeof t < "u" && t.hasOwnProperty("portalRefHandler") && typeof t.portalRefHandler == "function";
}
var $b5fecd57b45662f2$var$Os = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$Tr, $b5fecd57b45662f2$var$Th = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$Os();
    $b5fecd57b45662f2$var$sn();
    $b5fecd57b45662f2$var$Tr = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(o, r){
            super();
            this._basicButtons = {};
            this._customButtons = {};
            this._customDropdownItems = [];
            this._buttons = {};
            this._app = o, this._config = r, this._init();
        }
        async _init() {
            if (this._config.globalButtonsResolver) try {
                this._basicButtons = await this._config.globalButtonsResolver(this._app), this._updateButtons();
            } catch (o) {
                console.error(o);
            }
        }
        _removeCustomButton(o) {
            this._customButtons = $b5fecd57b45662f2$var$nn(this._customButtons, o), this._updateButtons();
        }
        registerCustomButton(o, r) {
            return this._customButtons = {
                ...this._customButtons,
                [o]: r
            }, this._updateButtons(), ()=>{
                this._removeCustomButton(o);
            };
        }
        _removeDropdownItem(o, r) {
            this._customDropdownItems = this._customDropdownItems.filter((a)=>!(a.buttonKey === o && a.key === r)), this._updateButtons();
        }
        registerDropdownItem(o, r, a, i = !1) {
            if (!this._basicButtons.hasOwnProperty(o) && !this._customButtons.hasOwnProperty(o) && !i) throw new Error(`Button with key ${o} does not exist`);
            return this._customDropdownItems = [
                ...this._customDropdownItems,
                {
                    buttonKey: o,
                    key: r,
                    button: a
                }
            ], this._updateButtons(), ()=>{
                this._removeDropdownItem(o, r);
            };
        }
        _sortButtons(o) {
            return Object.entries(o).sort(([, r], [, a])=>{
                var i, s;
                return ((i = r.order) != null ? i : -1) - ((s = a.order) != null ? s : -1);
            }).reduce((r, [a, i])=>($b5fecd57b45662f2$var$To(i) && (i.items = this._sortButtons(i.items)), {
                    ...r,
                    [a]: i
                }), {});
        }
        _updateButtons() {
            let o = (0, $f1q41.cloneDeep)({
                ...this._basicButtons,
                ...this._customButtons
            });
            this._customDropdownItems.forEach(({ buttonKey: r, key: a, button: i })=>{
                if (!o.hasOwnProperty(r)) return;
                let s = o[r];
                if ($b5fecd57b45662f2$var$Pr(s)) throw new Error(`Cannot add dropdown item to portal button with key ${r}`);
                $b5fecd57b45662f2$var$To(s) ? o[r] = {
                    ...s,
                    items: {
                        ...s.items,
                        [a]: (0, $f1q41.cloneDeep)(i)
                    }
                } : o[r] = {
                    icon: s.icon,
                    title: s.title,
                    order: s.order,
                    variant: s.variant,
                    items: {
                        [`${r}.basic`]: (0, $f1q41.cloneDeep)(s),
                        [a]: (0, $f1q41.cloneDeep)(i)
                    }
                };
            }), this._buttons = this._sortButtons(o), this._callListeners();
        }
        getData() {
            return this._buttons;
        }
    };
});
function $b5fecd57b45662f2$var$yn(t) {
    return typeof t < "u" && t.hasOwnProperty("ref") && t.ref instanceof HTMLElement;
}
function $b5fecd57b45662f2$var$Mh(t) {
    return typeof t < "u" && t.hasOwnProperty("link") && typeof t.link == "string";
}
function $b5fecd57b45662f2$var$Nh(t) {
    return typeof t < "u" && t.hasOwnProperty("id") && typeof t.id == "string";
}
var $b5fecd57b45662f2$var$_h = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
var $b5fecd57b45662f2$var$Mr, $b5fecd57b45662f2$var$Bh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$_h();
    $b5fecd57b45662f2$var$Mr = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(){
            super(...arguments);
            this._data = {
                tabs: [],
                activeTab: ""
            };
            this._activeTab = "";
            this._tabs = [];
            this._scrollLocked = !1;
        }
        registerTab(o) {
            let r = $b5fecd57b45662f2$var$Nh(o) ? o.id : (0, $5sKyw.default)();
            return this._tabs = [
                ...this._tabs,
                {
                    ...o,
                    key: r,
                    handleClick: ()=>{
                        this._handleTabClick(o), this._setActiveTab(r);
                    }
                }
            ], this._checkActiveTab(), this._callListeners(), this._updateBodyClass(), $b5fecd57b45662f2$var$yn(o) && this.handleScroll(), ()=>{
                this._unregisterTab(r);
            };
        }
        _checkActiveTab() {
            this._tabs.length !== 0 && (this._tabs.some((o)=>o.key === this._activeTab) || (this._activeTab = this._tabs[0].key));
        }
        _unregisterTab(o) {
            this._tabs = this._tabs.filter((r)=>r.key !== o), this._checkActiveTab(), this._callListeners(), this._updateBodyClass();
        }
        makeScrollTabRegister(o) {
            let r = null;
            return (a)=>{
                if (a === null) {
                    r !== null && (r(), r = null);
                    return;
                }
                r = this.registerTab({
                    ref: a,
                    ...o
                });
            };
        }
        _updateBodyClass() {
            this._tabs.length > 0 ? document.body.classList.add("has-topbar-tabs") : document.body.classList.remove("has-topbar-tabs");
        }
        _handleTabClick(o) {
            var r, a;
            if ($b5fecd57b45662f2$var$Mh(o) && (window.location.href = o.link), $b5fecd57b45662f2$var$yn(o)) {
                this._scrollLocked = !0, window.addEventListener("scrollend", ()=>this._scrollLocked = !1, {
                    once: !0
                });
                let i = ((a = (r = document.querySelector(".navbar-custom")) == null ? void 0 : r.getBoundingClientRect().bottom) != null ? a : 30) + 10;
                window.scroll({
                    top: o.ref.getBoundingClientRect().top + window.scrollY - i,
                    behavior: "instant"
                });
            }
        }
        _setActiveTab(o) {
            this._activeTab !== o && (this._activeTab = o, this._callListeners());
        }
        handleScroll() {
            if (this._tabs.length === 0) return;
            let r = window.innerHeight / 4;
            for (let a of this._tabs)if ($b5fecd57b45662f2$var$yn(a)) {
                let i = a.ref.getBoundingClientRect(), s = i.top + i.height;
                if (i.top < 0 && s < r) continue;
                this._setActiveTab(a.key);
                return;
            }
        }
        _callListeners() {
            this._data = {
                tabs: [
                    ...this._tabs
                ],
                activeTab: this._activeTab
            }, super._callListeners();
        }
        isScrollLocked() {
            return this._scrollLocked;
        }
        getData() {
            return this._data;
        }
    };
});
var $b5fecd57b45662f2$var$Nr, $b5fecd57b45662f2$var$Oh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Nr = class {
        constructor(){
            this._container = null;
            this._isNode = !1;
            this._opts = {};
        }
        createPortal(e, o) {
            if (!this._container) throw new Error("TopbarRow: container is not set");
            return this._isNode = !0, this._opts = o, this._updateBodyClass(), (0, $1u0KT.createPortal)(e, this._container);
        }
        handlePortalUnmount() {
            this._isNode = !1, this._opts = {}, this._updateBodyClass();
        }
        setOptions(e) {
            this._opts = e, this._updateBodyClass();
        }
        updateOptions(e) {
            this._opts = {
                ...this._opts,
                ...e
            }, this._updateBodyClass();
        }
        setFixed(e) {
            this.updateOptions({
                fixed: e
            }), this._updateBodyClass();
        }
        _updateBodyClass() {
            let e = !!this._container && this._isNode;
            document.body.classList.toggle("has-topbar-row__fixed", e && this._opts.fixed), document.body.classList.toggle("has-topbar-row__desktop", e && this._opts.desktop), document.body.classList.toggle("has-topbar-row__mobile", e && this._opts.mobile), document.body.classList.toggle("has-topbar-row__full-size", e && this._opts.fullSize);
        }
        setContainer(e) {
            this._container = e;
        }
    };
});
var $b5fecd57b45662f2$var$_r, $b5fecd57b45662f2$var$Ih = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Bh();
    $b5fecd57b45662f2$var$Oh();
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$_r = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(){
            super();
            this._prevScroll = 0;
            this._data = {
                isVisible: !0
            };
            this.Tabs = new $b5fecd57b45662f2$var$Mr, this.Row = new $b5fecd57b45662f2$var$Nr, window.addEventListener("scroll", ()=>this._handleScroll());
        }
        _handleScroll() {
            if (this.Tabs.handleScroll(), this.Tabs.isScrollLocked()) return;
            let o = window.scrollY, r = this._prevScroll > o || o < 10;
            this._prevScroll = o, r !== this._data.isVisible && (this._data = {
                ...this._data,
                isVisible: r
            }, this._callListeners());
        }
        getData() {
            return this._data;
        }
    };
});
var $b5fecd57b45662f2$var$Br, $b5fecd57b45662f2$var$Lh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ph();
    $b5fecd57b45662f2$var$Th();
    $b5fecd57b45662f2$var$Ih();
    $b5fecd57b45662f2$var$Br = class {
        constructor(e, o){
            this._navigate = null;
            this._app = e, this._config = o, this.MainNavigation = new $b5fecd57b45662f2$var$kr(this._app, this._config), this.GlobalButtons = new $b5fecd57b45662f2$var$Tr(this._app, this._config), this.Topbar = new $b5fecd57b45662f2$var$_r;
        }
        setNavigate(e) {
            return this._navigate = e, ()=>{
                this._navigate = null;
            };
        }
        navigate(e, o) {
            this._navigate ? this._navigate(e, o) : console.error("navigate() failed: no navigate function set.");
        }
    };
});
var $b5fecd57b45662f2$var$uA, $b5fecd57b45662f2$export$6f268783f91b5174, $b5fecd57b45662f2$var$Vh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$uA = ({ children: t, ...e })=>{
        let o = $b5fecd57b45662f2$export$846279b0d7f2d98d();
        return $acw62.useEffect(()=>()=>{
                o.Topbar.Row.handlePortalUnmount();
            }, []), o.Topbar.Row.createPortal(t, e);
    }, $b5fecd57b45662f2$export$6f268783f91b5174 = $b5fecd57b45662f2$var$uA;
});
var $b5fecd57b45662f2$var$fA, $b5fecd57b45662f2$export$18797e461f15897a, $b5fecd57b45662f2$var$Uh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$fA = ({ children: t, options: e })=>{
        let o = $b5fecd57b45662f2$export$846279b0d7f2d98d(), r = $acw62.useId(), [a, i] = $acw62.useState(null), s = $acw62.useCallback((l)=>{
            i(l);
        }, []);
        return $acw62.useEffect(()=>{
            let l = o.GlobalButtons.registerCustomButton(r, {
                ...e,
                portalRefHandler: s
            });
            return ()=>{
                l();
            };
        }, [
            r
        ]), $acw62.createElement($acw62.Fragment, null, !!a && (0, $1u0KT.createPortal)(t, a));
    }, $b5fecd57b45662f2$export$18797e461f15897a = $b5fecd57b45662f2$var$fA;
});
var $b5fecd57b45662f2$export$b8a61e5c71402559, $b5fecd57b45662f2$var$ne = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Lh();
    $b5fecd57b45662f2$var$Bs();
    $b5fecd57b45662f2$var$Os();
    $b5fecd57b45662f2$var$Vh();
    $b5fecd57b45662f2$var$Uh();
    $b5fecd57b45662f2$export$b8a61e5c71402559 = $b5fecd57b45662f2$var$Br;
});
var $b5fecd57b45662f2$var$Mo, $b5fecd57b45662f2$var$Wh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$Mo = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(){
            super(...arguments);
            this._data = null;
        }
        register(o, r, a) {
            return this._data = {
                type: o,
                name: r,
                data: a
            }, this._callListeners(), ()=>{
                this._data = null, this._callListeners();
            };
        }
        getData() {
            return this._data;
        }
    };
});
function $b5fecd57b45662f2$export$162d9a1f1cb5190c() {
    let [t, e] = (0, $acw62.useState)(window.innerWidth);
    return (0, $acw62.useLayoutEffect)(()=>{
        function o() {
            e(window.innerWidth);
        }
        return window.addEventListener("resize", o), ()=>window.removeEventListener("resize", o);
    }, []), t;
}
var $b5fecd57b45662f2$var$Ls = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
});
function $b5fecd57b45662f2$export$199d6754bdf4e1e3(t, e = !0) {
    let o = $b5fecd57b45662f2$export$162d9a1f1cb5190c();
    return e ? o >= $b5fecd57b45662f2$var$Eh[t] : o < $b5fecd57b45662f2$var$Eh[t];
}
var $b5fecd57b45662f2$var$Eh, $b5fecd57b45662f2$var$Xs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ls();
    $b5fecd57b45662f2$var$Eh = {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400
    };
});
var $b5fecd57b45662f2$var$yA, $b5fecd57b45662f2$export$86990adc65b4ab45, $b5fecd57b45662f2$var$Yh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$Xs();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$yA = ({ breakpoint: t = "md", ...e })=>{
        let o = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { tabs: r, activeTab: a } = $b5fecd57b45662f2$export$4b79bd8f34740571(o.Topbar.Tabs);
        return $b5fecd57b45662f2$export$199d6754bdf4e1e3(t) ? $acw62.createElement((0, $eBMdo.default), {
            ...e,
            activeKey: a
        }, r.map((s)=>$acw62.createElement((0, $eBMdo.default).Item, {
                key: `tab-${s.key}`
            }, $acw62.createElement((0, $eBMdo.default).Link, {
                eventKey: s.key,
                onClick: s.handleClick
            }, s.icon && $acw62.createElement("i", {
                className: `mdi mdi-${s.icon} me-1`
            }), s.title, s.badge !== void 0 && $acw62.createElement("span", {
                className: "ms-1 text-muted"
            }, s.badge))))) : null;
    }, $b5fecd57b45662f2$export$86990adc65b4ab45 = $b5fecd57b45662f2$var$yA;
});
var $b5fecd57b45662f2$var$Ir, $b5fecd57b45662f2$var$Gh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$Ir = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(){
            super(...arguments);
            this._toasts = [];
        }
        _getToast(o) {
            return this._toasts.find((r)=>r.id === o);
        }
        _updateToastData(o, r) {
            this._toasts.some((a)=>a.id === o) && (this._toasts = this._toasts.map((a)=>a.id !== o ? a : {
                    ...a,
                    ...r
                }));
        }
        _clearShowTimeout(o) {
            let r = this._getToast(o);
            r && r.showTimeout && (clearTimeout(r.showTimeout), this._updateToastData(o, {
                showTimeout: void 0
            }));
        }
        _makeShowTimeout(o, r) {
            if (r) return setTimeout(()=>{
                this.deleteToast(o);
            }, r * 1e3);
        }
        createToast(o) {
            let r = (0, $5sKyw.default)();
            return this._toasts.push({
                ...o,
                id: r,
                hidden: !1,
                showTimeout: this._makeShowTimeout(r, o.showTime)
            }), this._callListeners(), {
                id: r,
                update: (a)=>this.updateToast(r, a),
                hide: ()=>this._hideToast(r),
                show: ()=>this._showToast(r),
                delete: ()=>this.deleteToast(r)
            };
        }
        updateToast(o, r) {
            this._updateToastData(o, r), r.showTime && (this._clearShowTimeout(o), this._updateToastData(o, {
                showTimeout: this._makeShowTimeout(o, r.showTime)
            })), this._callListeners();
        }
        deleteToast(o) {
            var a;
            let r = this._getToast(o);
            r && (this._clearShowTimeout(o), (a = r.onDelete) == null || a.call(r), this._toasts = this._toasts.filter((i)=>i.id !== o), this._callListeners());
        }
        _showToast(o) {
            this._updateToastData(o, {
                hidden: !1
            }), this._callListeners();
        }
        _hideToast(o) {
            this._updateToastData(o, {
                hidden: !0
            }), this._callListeners();
        }
        getData() {
            return this._toasts;
        }
    };
});
var $b5fecd57b45662f2$export$46f5fe4dd7fa3070, $b5fecd57b45662f2$var$zh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Gh();
    $b5fecd57b45662f2$export$46f5fe4dd7fa3070 = $b5fecd57b45662f2$var$Ir;
});
var $b5fecd57b45662f2$var$bA, $b5fecd57b45662f2$var$Us, $b5fecd57b45662f2$var$jh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Rs();
    $b5fecd57b45662f2$var$bA = ()=>{
        let t = $b5fecd57b45662f2$export$c594d3118da9430d(), e = $b5fecd57b45662f2$export$4b79bd8f34740571(t), o = $acw62.useMemo(()=>$b5fecd57b45662f2$var$re(e), [
            e
        ]), r = $b5fecd57b45662f2$export$8ce16a1f3a483377(), a = $b5fecd57b45662f2$export$4b79bd8f34740571(r), i = $acw62.useMemo(()=>a.filter((s)=>s.mode === "auth" && o || s.mode === "guest" && !o ? !0 : s.mode === "both").map((s)=>s.component), [
            a,
            o
        ]);
        return e === null ? null : $acw62.createElement($acw62.Fragment, null, i.map((s, l)=>$acw62.createElement(s, {
                key: `helper-${l}`
            })));
    }, $b5fecd57b45662f2$var$Us = $b5fecd57b45662f2$var$bA;
});
var $b5fecd57b45662f2$var$SA, $b5fecd57b45662f2$export$841a7e6dcc7fe44e, $b5fecd57b45662f2$var$Es = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$SA = ({ dt: t, children: e })=>{
        var r;
        let o = $acw62.useMemo(()=>(0, $8x08q.DateTime).fromISO(t), [
            t
        ]);
        return $acw62.createElement("time", {
            title: (r = o.toISOTime()) != null ? r : void 0
        }, e(o));
    }, $b5fecd57b45662f2$export$841a7e6dcc7fe44e = $b5fecd57b45662f2$var$SA;
});
var $b5fecd57b45662f2$var$qh = {};
$b5fecd57b45662f2$var$Ie($b5fecd57b45662f2$var$qh, {
    default: ()=>$b5fecd57b45662f2$var$RA
});
var $b5fecd57b45662f2$var$vA, $b5fecd57b45662f2$var$AA, $b5fecd57b45662f2$var$RA, $b5fecd57b45662f2$var$Kh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Es();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$vA = ({ data: t, handleClose: e })=>{
        let o = t.variant ? `text-with-bg-${t.variant}` : void 0;
        return $acw62.createElement((0, $93EsN.default), {
            show: !t.hidden,
            autohide: !1,
            bg: t.variant
        }, t.title && $acw62.createElement((0, $93EsN.default).Header, {
            closeButton: !1
        }, t.icon && $acw62.createElement("i", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`mdi mdi-${t.icon} font-18 lh-1 me-1`, o)
        }), $acw62.createElement("strong", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(o, "me-auto")
        }, t.title), t.dt && $acw62.createElement($b5fecd57b45662f2$export$841a7e6dcc7fe44e, {
            dt: t.dt
        }, (r)=>r.toRelative()), !t.disableClose && $acw62.createElement((0, $77pHI.default), {
            onClick: e
        })), $acw62.createElement((0, $93EsN.default).Body, {
            className: o
        }, t.body));
    }, $b5fecd57b45662f2$var$AA = ()=>{
        let t = $b5fecd57b45662f2$export$5425318366a9780c(), e = $b5fecd57b45662f2$export$4b79bd8f34740571(t);
        return $acw62.createElement("div", {
            className: "toast-container"
        }, e.map((o)=>$acw62.createElement($b5fecd57b45662f2$var$vA, {
                key: `toast-${o.id}`,
                data: o,
                handleClose: ()=>t.deleteToast(o.id)
            })));
    }, $b5fecd57b45662f2$var$RA = $b5fecd57b45662f2$var$AA;
});
var $b5fecd57b45662f2$var$kA, $b5fecd57b45662f2$var$Zh, $b5fecd57b45662f2$var$Jh = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Sa();
    $b5fecd57b45662f2$var$kA = ({ action: t })=>{
        let { ConfirmModal: e } = $b5fecd57b45662f2$export$bf4da147a5964edb({
            ...t.data,
            initialModalState: !0,
            handleContinue: ()=>t.handleRun({
                    confirmed: !0
                }),
            handleExit: t.handleCancel
        });
        return $acw62.createElement($acw62.Fragment, null, e);
    }, $b5fecd57b45662f2$var$Zh = $b5fecd57b45662f2$var$kA;
});
var $b5fecd57b45662f2$var$FA, $b5fecd57b45662f2$export$19898d418eb4b16b, $b5fecd57b45662f2$var$Gs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$FA = ({ children: t })=>$acw62.createElement("div", {
            className: "top-overlay"
        }, t), $b5fecd57b45662f2$export$19898d418eb4b16b = $b5fecd57b45662f2$var$FA;
});
var $b5fecd57b45662f2$var$wA, $b5fecd57b45662f2$export$1004aa206bb0d828, $b5fecd57b45662f2$var$$s = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Gs();
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$wA = ()=>$acw62.createElement($b5fecd57b45662f2$export$19898d418eb4b16b, null, $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null)), $b5fecd57b45662f2$export$1004aa206bb0d828 = $b5fecd57b45662f2$var$wA;
});
var $b5fecd57b45662f2$var$NA, $b5fecd57b45662f2$var$_A, $b5fecd57b45662f2$var$BA, $b5fecd57b45662f2$var$ty, $b5fecd57b45662f2$var$ey = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ue();
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$ho();
    $b5fecd57b45662f2$var$$s();
    $b5fecd57b45662f2$var$dn();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$NA = ({ name: t })=>{
        let o = $b5fecd57b45662f2$export$719b7bd3d9a721a9().getCustomFormComponent(t);
        return $acw62.createElement(o, null);
    }, $b5fecd57b45662f2$var$_A = ({ data: t })=>$b5fecd57b45662f2$var$cn(t) ? $acw62.createElement($b5fecd57b45662f2$var$NA, {
            name: t.formName
        }) : $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.DynamicBody, {
            fields: t.fields
        }), $b5fecd57b45662f2$var$BA = ({ action: t })=>{
        var r, a, i, s;
        let e = $b5fecd57b45662f2$export$33ffd74ebf07f060({
            initialState: !0,
            onClose: t.handleCancel
        }), o = $acw62.useCallback((l)=>new Promise((p, m)=>{
                t.handleRun(l).then(()=>p()).catch(m);
            }), []);
        return $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772, {
            state: e,
            title: t.action.title,
            titleBg: t.data.color
        }, t.isRunning && $acw62.createElement($b5fecd57b45662f2$export$1004aa206bb0d828, null), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Callback, {
            data: (r = t.data.values) != null ? r : {},
            handleSubmit: o,
            showSuccess: !1
        }, $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772.Body, null, t.data.message && $acw62.createElement((0, $cpxrl.default), {
            variant: "info"
        }, $acw62.createElement((0, $htkMF.ReactMarkdown), {
            className: "markdown-text",
            children: t.data.message
        })), $acw62.createElement($b5fecd57b45662f2$var$_A, {
            data: t.data
        })), $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772.Footer, null, $acw62.createElement((0, $6LAgE.default), {
            variant: "secondary",
            type: "button",
            onClick: e.close
        }, (a = t.data.cancelText) != null ? a : "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Submit, {
            variant: (i = t.data.color) != null ? i : "primary"
        }, (s = t.data.submitText) != null ? s : "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438"))));
    }, $b5fecd57b45662f2$var$ty = $b5fecd57b45662f2$var$BA;
});
var $b5fecd57b45662f2$var$IA, $b5fecd57b45662f2$var$LA, $b5fecd57b45662f2$var$oy, $b5fecd57b45662f2$var$ry = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Sr();
    $b5fecd57b45662f2$var$ho();
    $b5fecd57b45662f2$var$ue();
    $b5fecd57b45662f2$var$gr();
    $b5fecd57b45662f2$var$Lr();
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$IA = ({ data: t, action: e })=>{
        let o = $acw62.useMemo(()=>e.getResultRenderer(), [
            e
        ]);
        return o ? $acw62.createElement($acw62.Suspense, {
            fallback: $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null)
        }, $acw62.createElement(o, {
            data: t
        })) : $b5fecd57b45662f2$var$Ig(t) ? $acw62.createElement($b5fecd57b45662f2$export$aeedc005af528695.Base, {
            data: t,
            config: {
                tableMode: "simple",
                hideFooter: !0,
                settingsShow: !1
            }
        }) : null;
    }, $b5fecd57b45662f2$var$LA = ({ action: t })=>{
        let e = $b5fecd57b45662f2$export$33ffd74ebf07f060({
            initialState: !0,
            onClose: t.handleCancel
        });
        return $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772, {
            state: e,
            title: t.action.title,
            titleBg: t.status === "error" ? "danger" : void 0
        }, $acw62.createElement($b5fecd57b45662f2$export$2b77a92f1a5ad772.Body, null, t.data.message && $acw62.createElement((0, $cpxrl.default), {
            variant: t.status === "error" ? "danger" : "success"
        }, t.data.message), t.data.data && $acw62.createElement($b5fecd57b45662f2$var$IA, {
            action: t,
            data: t.data.data
        })));
    }, $b5fecd57b45662f2$var$oy = $b5fecd57b45662f2$var$LA;
});
var $b5fecd57b45662f2$var$XA, $b5fecd57b45662f2$var$ay, $b5fecd57b45662f2$var$ny = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Sr();
    $b5fecd57b45662f2$var$Jh();
    $b5fecd57b45662f2$var$dn();
    $b5fecd57b45662f2$var$ey();
    $b5fecd57b45662f2$var$ry();
    $b5fecd57b45662f2$var$XA = ({ action: t })=>$b5fecd57b45662f2$var$Cr(t, "confirming") ? $acw62.createElement($b5fecd57b45662f2$var$Zh, {
            action: t
        }) : $b5fecd57b45662f2$var$Cr(t, "wait-data") ? $acw62.createElement($b5fecd57b45662f2$var$ty, {
            action: t
        }) : $b5fecd57b45662f2$var$Cr(t, "success") || $b5fecd57b45662f2$var$Cr(t, "error") ? $acw62.createElement($b5fecd57b45662f2$var$oy, {
            action: t
        }) : null, $b5fecd57b45662f2$var$ay = $b5fecd57b45662f2$var$XA;
});
var $b5fecd57b45662f2$var$iy = {};
$b5fecd57b45662f2$var$Ie($b5fecd57b45662f2$var$iy, {
    default: ()=>$b5fecd57b45662f2$var$UA
});
var $b5fecd57b45662f2$var$VA, $b5fecd57b45662f2$var$UA, $b5fecd57b45662f2$var$sy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ny();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$VA = ()=>{
        let t = $b5fecd57b45662f2$export$719b7bd3d9a721a9(), e = $b5fecd57b45662f2$export$4b79bd8f34740571(t);
        return $acw62.createElement($acw62.Fragment, null, Object.entries(e).map(([o, r])=>$acw62.createElement($b5fecd57b45662f2$var$ay, {
                key: o,
                action: r
            })));
    }, $b5fecd57b45662f2$var$UA = $b5fecd57b45662f2$var$VA;
});
var $b5fecd57b45662f2$var$WA, $b5fecd57b45662f2$var$EA, $b5fecd57b45662f2$export$f943027287067ba0, $b5fecd57b45662f2$var$qs = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$WA = (0, $acw62.lazy)(()=>Promise.resolve().then(()=>($b5fecd57b45662f2$var$Kh(), $b5fecd57b45662f2$var$qh))), $b5fecd57b45662f2$var$EA = (0, $acw62.lazy)(()=>Promise.resolve().then(()=>($b5fecd57b45662f2$var$sy(), $b5fecd57b45662f2$var$iy))), $b5fecd57b45662f2$export$f943027287067ba0 = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(){
            super(...arguments);
            this._helpers = [
                {
                    key: "toasts",
                    mode: "auth",
                    component: $b5fecd57b45662f2$var$WA
                },
                {
                    key: "actions",
                    mode: "auth",
                    component: $b5fecd57b45662f2$var$EA
                }
            ];
        }
        register(o, r, a) {
            this._helpers.push({
                key: o,
                component: r,
                mode: a
            }), this._callListeners();
        }
        getData() {
            return this._helpers;
        }
    };
});
var $b5fecd57b45662f2$var$je, $b5fecd57b45662f2$var$py = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$je = class {
        constructor(){
            this._services = {};
        }
        register(e, o) {
            this._services[e] = o;
        }
        get(e, o) {
            if (!this._services[e]) throw new Error(`Service ${e} not found`);
            if (!o(this._services[e])) throw new Error(`Service ${e} is not of the expected type`);
            return this._services[e];
        }
    };
});
var $b5fecd57b45662f2$var$my = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$py();
});
var $b5fecd57b45662f2$var$HA, $b5fecd57b45662f2$export$7333dba96a70fd48, $b5fecd57b45662f2$var$Ks = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$HA = ({ result: t })=>{
        let e = $b5fecd57b45662f2$export$5f78f356137e000a(), o = $acw62.useCallback((r, a)=>{
            r.preventDefault(), r.stopPropagation(), e.handleResultSelect(t, a);
        }, []);
        return $acw62.createElement($acw62.Fragment, null, t.edit_url && $acw62.createElement((0, $6LAgE.default), {
            variant: "link",
            className: "p-0 m-0 ms-1 mdi mdi-pencil font-20",
            onClick: (r)=>o(r, !0)
        }), t.view_url && $acw62.createElement((0, $6LAgE.default), {
            variant: "link",
            className: "p-0 m-0 ms-1 mdi mdi-eye font-20",
            onClick: (r)=>o(r, !1)
        }));
    }, $b5fecd57b45662f2$export$7333dba96a70fd48 = $b5fecd57b45662f2$var$HA;
});
var $b5fecd57b45662f2$var$YA, $b5fecd57b45662f2$var$uy, $b5fecd57b45662f2$var$dy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ks();
    $b5fecd57b45662f2$var$YA = (t)=>{
        var e;
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("b", null, (e = t.data.name) != null ? e : t.data.title), $acw62.createElement("span", {
            className: "ms-auto d-flex align-items-center"
        }, $acw62.createElement($b5fecd57b45662f2$export$7333dba96a70fd48, {
            result: t
        })));
    }, $b5fecd57b45662f2$var$uy = $b5fecd57b45662f2$var$YA;
});
var $b5fecd57b45662f2$var$_o, $b5fecd57b45662f2$var$qe, $b5fecd57b45662f2$var$hy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$tt();
    $b5fecd57b45662f2$var$dy();
    $b5fecd57b45662f2$var$_o = class _o extends $b5fecd57b45662f2$export$8c2572089a81a391 {
        constructor(o, r){
            super();
            this._page = 1;
            this._inputRef = null;
            this._handleKeyDown = (o)=>{
                if (!this._data.isActive) return;
                let r = ()=>{
                    o.preventDefault(), o.stopPropagation();
                };
                o.key === "Escape" ? (r(), this.close()) : o.key === "Enter" ? (r(), this._handleEnter(o.ctrlKey)) : o.key === "ArrowDown" || o.key === "ArrowUp" ? (r(), this._handleUpDownArrows(o.key === "ArrowDown")) : (o.key === "ArrowRight" || o.key === "ArrowLeft") && (r(), this._changeSelectedType(o.key === "ArrowRight" ? 1 : -1));
            };
            this._loadResultsDebounced = (0, $f1q41.debounce)(this._loadResults.bind(this), 300);
            this._handleSearchDebounced = (0, $f1q41.debounce)(this._handleSearch.bind(this), 300);
            this._app = o, this._config = r, this._data = {
                query: "",
                isActive: !1,
                isLoading: !1,
                isLoadingMore: !1,
                selectedType: null,
                types: this._filterAllowedTypes(r.types),
                typesCnt: {},
                selectedResultIdx: 0,
                results: null,
                hasMore: !1,
                error: null,
                selectedHistoryIdx: -1,
                history: this._loadHistory()
            }, this._initListeners();
        }
        _filterAllowedTypes(o) {
            return Object.entries(o).filter(([r, a])=>!a.allowCheck || a.allowCheck(this._app)).reduce((r, [a, i])=>({
                    ...r,
                    [a]: i
                }), {});
        }
        _loadHistory() {
            let o = localStorage.getItem(_o.historyKey);
            if (!o) return [];
            try {
                return JSON.parse(o);
            } catch  {
                return localStorage.removeItem(_o.historyKey), [];
            }
        }
        _addToHistory(o) {
            let r = this._loadHistory(), a = [
                o,
                ...r
            ].filter((i)=>i.trim().length > 0).filter((i, s, l)=>l.indexOf(i) === s).slice(0, 20);
            localStorage.setItem(_o.historyKey, JSON.stringify(a)), this._updateData({
                selectedHistoryIdx: -1,
                history: a
            });
        }
        _initListeners() {
            window.addEventListener("keydown", this._handleKeyDown.bind(this)), this._app.auth.subscribe(()=>{
                this._updateData({
                    types: this._filterAllowedTypes(this._config.types)
                });
            });
        }
        handleInputRef(o) {
            this._inputRef = o;
        }
        _changeSelectedType(o) {
            var s;
            let r = Object.keys(this._data.types), i = (this._data.selectedType ? r.indexOf(this._data.selectedType) : -1) + o;
            for(; i >= 0 && i < r.length;){
                let l = r[i];
                if (((s = this._data.typesCnt[l]) != null ? s : 0) > 0) {
                    this.handleTypeSelect(l);
                    break;
                }
                i += o;
            }
        }
        _handleUpDownArrows(o) {
            var r;
            if (this._data.results === null) {
                let a = this._data.selectedHistoryIdx + (o ? 1 : -1);
                if (a < -1 || a >= this._data.history.length) return;
                this._updateData({
                    selectedHistoryIdx: a,
                    query: (r = this._data.history[a]) != null ? r : ""
                });
            } else {
                let a = this._data.selectedResultIdx + (o ? 1 : -1);
                if (a >= this._data.results.length) {
                    this._data.hasMore && this.handleMore();
                    return;
                }
                if (a < -1) return;
                this._updateData({
                    selectedResultIdx: a
                });
            }
        }
        _getResultUrl(o, r) {
            var a, i;
            return r ? (a = o.edit_url) != null && a.length ? o.edit_url : o.view_url : (i = o.view_url) != null && i.length ? o.view_url : o.edit_url;
        }
        handleResultSelect(o, r) {
            var i, s, l;
            if ((i = this._data.types[o.type]) != null && i.onSelected) {
                (l = (s = this._data.types[o.type]) == null ? void 0 : s.onSelected) == null || l.call(s, o, r, this._app), this.close();
                return;
            }
            let a = this._getResultUrl(o, r);
            if (!a) {
                this.close();
                return;
            }
            if (a.startsWith("http")) {
                let p = window.open(a, "_blank");
                p == null || p.focus(), this.close();
                return;
            }
            this._app.navigation.navigate(a), this.close();
        }
        _handleEnter(o) {
            if (this._data.results === null) {
                this._startSearch();
                return;
            }
            let r = this._data.results[this._data.selectedResultIdx];
            r && this.handleResultSelect(r, o);
        }
        async _loadResultsCount() {
            let o = await (0, $ket0H.default).getData(`${this._config.endpoint}/counters`, {
                query: this._data.query
            });
            this._updateData({
                typesCnt: o
            }, !0);
        }
        async _resolveSelectedType() {
            if (this._data.selectedType === null) {
                for (let [o, r] of Object.entries(this._data.typesCnt))if (r > 0) {
                    this._updateData({
                        selectedType: o
                    }, !0);
                    return;
                }
            }
        }
        async _loadResults() {
            if (this._data.selectedType === null) {
                this._setEmptyResult();
                return;
            }
            this._page = 1;
            let o = await (0, $ket0H.default).getData(this._config.endpoint, {
                query: this._data.query,
                type: this._data.selectedType
            });
            this._updateData({
                isLoading: !1,
                results: o.items,
                hasMore: o.hasMore,
                selectedType: o.type
            });
        }
        async _handleSearch() {
            if (!this._isQueryValid()) {
                this._setEmptyResult();
                return;
            }
            try {
                await this._loadResultsCount(), await this._resolveSelectedType(), await this._loadResults();
            } catch (o) {
                console.error("Search error:", o), this._updateData({
                    error: (0, $9PE8j.default)(o)
                });
            } finally{
                this._updateData({
                    isLoading: !1
                });
            }
        }
        async handleMore() {
            var o;
            if (!this._data.isLoadingMore) {
                this._updateData({
                    isLoadingMore: !0
                });
                try {
                    let r = await (0, $ket0H.default).getData(this._config.endpoint, {
                        query: this._data.query,
                        type: this._data.selectedType,
                        page: this._page + 1
                    });
                    this._page++, this._updateData({
                        results: [
                            ...(o = this._data.results) != null ? o : [],
                            ...r.items
                        ],
                        hasMore: r.hasMore
                    });
                } catch (r) {
                    console.error("Search error:", r), this._updateData({
                        error: (0, $9PE8j.default)(r)
                    });
                } finally{
                    this._updateData({
                        isLoadingMore: !1
                    });
                }
            }
        }
        _isQueryValid() {
            return this._data.query.trim().length >= 3;
        }
        _cancelLoading() {
            this._handleSearchDebounced.cancel(), this._loadResultsDebounced.cancel();
        }
        _cleanSearchData() {
            this._updateData({
                results: null,
                error: null,
                isLoading: !1
            });
        }
        _setEmptyResult() {
            this._updateData({
                results: null,
                error: null,
                isLoading: !1
            });
        }
        _startSearch() {
            if (this._cancelLoading(), !this._isQueryValid()) {
                this._cleanSearchData();
                return;
            }
            this._updateData({
                isLoading: !0,
                error: null
            }), this._handleSearchDebounced();
        }
        setQuery(o) {
            this._updateData({
                query: o
            }), this._startSearch();
        }
        activate() {
            this._updateData({
                isActive: !0
            });
        }
        close() {
            var o;
            this._addToHistory(this._data.query), this._page = 1, this._updateData({
                query: "",
                isActive: !1,
                isLoading: !1,
                isLoadingMore: !1,
                selectedType: null,
                typesCnt: {},
                selectedResultIdx: 0,
                results: null,
                hasMore: !1,
                error: null
            }), this._cancelLoading(), (o = this._inputRef) == null || o.blur();
        }
        handleTypeSelect(o) {
            if (this._cancelLoading(), this._updateData({
                selectedType: o,
                selectedResultIdx: 0
            }, !0), !this._isQueryValid()) {
                this._cleanSearchData();
                return;
            }
            this._updateData({
                isLoading: !0,
                error: null
            }), this._loadResultsDebounced();
        }
        resolveTypeRenderer(o) {
            var r, a;
            return (a = (r = this._data.types[o]) == null ? void 0 : r.render) != null ? a : $b5fecd57b45662f2$var$uy;
        }
        resolveTypeIcon(o) {
            var r, a;
            return (a = (r = this._data.types[o]) == null ? void 0 : r.icon) != null ? a : null;
        }
        _updateData(o, r = !1) {
            this._data = {
                ...this._data,
                ...o
            }, r || this._callListeners();
        }
        getData() {
            return this._data;
        }
    };
    $b5fecd57b45662f2$var$_o.historyKey = "ova-admin::search-history";
    $b5fecd57b45662f2$var$qe = $b5fecd57b45662f2$var$_o;
});
var $b5fecd57b45662f2$var$yy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$hy();
    $b5fecd57b45662f2$var$Ks();
});
var $b5fecd57b45662f2$var$xy, $b5fecd57b45662f2$var$by = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$xy = (t)=>typeof t < "u" && typeof t.appKey == "string" && typeof t.host == "string" && typeof t.port == "string" && (typeof t.path > "u" || typeof t.path == "string") && (typeof t.authEndpoint > "u" || typeof t.authEndpoint == "string");
});
var $b5fecd57b45662f2$var$Ur, $b5fecd57b45662f2$var$Dy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$by();
    $b5fecd57b45662f2$var$Ur = class {
        constructor(e){
            this._clientInternal = void 0;
            this._channels = {};
            this._app = e;
        }
        get _config() {
            var o;
            let e = (o = this._app.config.external) == null ? void 0 : o.websocket;
            if (!$b5fecd57b45662f2$var$xy(e)) throw new Error("Websocket config not found");
            return e;
        }
        _initClient() {
            this._clientInternal || (this._clientInternal = new (0, $8WR9B.default)({
                broadcaster: "pusher",
                Pusher: (0, (/*@__PURE__*/$parcel$interopDefault($e0UFp))),
                authEndpoint: this._config.authEndpoint,
                key: this._config.appKey,
                wsHost: this._config.host,
                wsPort: this._config.port,
                wssPort: this._config.port,
                wsPath: this._config.path,
                encrypted: !0,
                disableStats: !0,
                forceTLS: !1,
                enabledTransports: [
                    "ws",
                    "wss"
                ]
            }));
        }
        get _client() {
            if (this._initClient(), !this._clientInternal) throw new Error("Websocket client not initialized");
            return this._clientInternal;
        }
        _resolveChannel(e) {
            return this._channels[e] || (this._channels[e] = {
                channelName: e,
                instance: this._client.private(e),
                listeners: []
            }), this._channels[e];
        }
        _ensureChannelIsActive(e) {
            this._resolveChannel(e).listeners.length > 0 || (this._client.leave(e), delete this._channels[e]);
        }
        listen(e, o, r) {
            let a = Array.isArray(o) ? o : [
                o
            ], i = this._resolveChannel(e);
            for (let s of a)i.instance.listen(s, r);
            return i.listeners.push(r), ()=>{
                for (let s of a)i.instance.stopListening(s, r);
                i.listeners = i.listeners.filter((s)=>s !== r), this._ensureChannelIsActive(e);
            };
        }
    };
});
var $b5fecd57b45662f2$export$ae7b7f99370a87b2, $b5fecd57b45662f2$var$Sy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Dy();
    $b5fecd57b45662f2$export$ae7b7f99370a87b2 = $b5fecd57b45662f2$var$Ur;
});
var $b5fecd57b45662f2$var$Ke = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Rs();
    $b5fecd57b45662f2$var$bh();
    $b5fecd57b45662f2$var$Rh();
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$Wh();
    $b5fecd57b45662f2$var$Yh();
    $b5fecd57b45662f2$var$zh();
    $b5fecd57b45662f2$var$jh();
    $b5fecd57b45662f2$var$qs();
    $b5fecd57b45662f2$var$my();
    $b5fecd57b45662f2$var$yy();
    $b5fecd57b45662f2$var$Sy();
});
var $b5fecd57b45662f2$var$qA, $b5fecd57b45662f2$var$Cy, $b5fecd57b45662f2$var$vy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ds();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Ke();
    $b5fecd57b45662f2$var$qA = ()=>{
        let { rowsSelected: t, setAllRowsSelected: e, isAllRowsSelected: o, data: { options: { actionsModel: r } } } = $b5fecd57b45662f2$var$h(), a = $b5fecd57b45662f2$export$3c61b618e38b9752(t.length, "\u0417 \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u043C", "\u0417 \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u043C\u0438"), i = $b5fecd57b45662f2$export$3c61b618e38b9752(t.length, "\u0437\u0430\u043F\u0438\u0441\u043E\u043C", "\u0437\u0430\u043F\u0438\u0441\u0430\u043C\u0438"), s = (0, $acw62.useDeferredValue)(t);
        return t.length === 0 ? null : $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $6LAgE.default), {
            variant: "outline-secondary",
            className: "p-0 px-1 d-md-none",
            size: "sm",
            onClick: ()=>e(!o)
        }, $acw62.createElement("i", {
            className: `mdi mdi-${o ? "collapse-all-outline" : "expand-all-outline"} lh-1 font-20`
        })), $acw62.createElement("span", {
            className: "text-nowrap small"
        }, a, " ", t.length, " ", i), s.length > 0 && r && $acw62.createElement($b5fecd57b45662f2$export$be40bdb4a62faae1, {
            ids: s,
            model: r
        }));
    }, $b5fecd57b45662f2$var$Cy = $b5fecd57b45662f2$var$qA;
});
var $b5fecd57b45662f2$var$KA, $b5fecd57b45662f2$var$Js, $b5fecd57b45662f2$var$Ay = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ys();
    $b5fecd57b45662f2$var$mh();
    $b5fecd57b45662f2$var$vy();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$KA = ({ className: t })=>{
        var i;
        let { rowsSelected: e, data: { data: o, pagination: r } } = $b5fecd57b45662f2$var$h(), a = (i = o == null ? void 0 : o.length) != null ? i : 0;
        return a ? $acw62.createElement("div", {
            className: `table-footer ${t}`
        }, (e == null ? void 0 : e.length) > 0 ? $acw62.createElement($b5fecd57b45662f2$var$Cy, null) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement($b5fecd57b45662f2$var$pn, {
            pagination: r,
            rowsCnt: a
        }), $acw62.createElement($b5fecd57b45662f2$var$ph, {
            pagination: r
        }))) : null;
    }, $b5fecd57b45662f2$var$Js = $b5fecd57b45662f2$var$KA;
});
var $b5fecd57b45662f2$var$ZA, $b5fecd57b45662f2$var$Ry, $b5fecd57b45662f2$var$ky = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ys();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$ZA = ()=>{
        var o;
        let { data: { data: t, pagination: e } } = $b5fecd57b45662f2$var$h();
        return $acw62.createElement("div", null, $acw62.createElement($b5fecd57b45662f2$var$pn, {
            pagination: e,
            rowsCnt: (o = t == null ? void 0 : t.length) != null ? o : 0
        }));
    }, $b5fecd57b45662f2$var$Ry = $b5fecd57b45662f2$var$ZA;
});
var $b5fecd57b45662f2$var$JA, $b5fecd57b45662f2$var$Fy, $b5fecd57b45662f2$var$wy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Ay();
    $b5fecd57b45662f2$var$ky();
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$JA = ()=>{
        let { config: { tableMode: t, hideFooter: e } } = $b5fecd57b45662f2$var$h();
        return e ? null : t === "simple" ? $acw62.createElement($b5fecd57b45662f2$var$Ry, null) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement($b5fecd57b45662f2$export$6f268783f91b5174, {
            mobile: !0,
            desktop: !1
        }, $acw62.createElement($b5fecd57b45662f2$var$Js, {
            className: "table-footer-topbar"
        })), $acw62.createElement($b5fecd57b45662f2$var$Js, {
            className: "table-footer-inline"
        }));
    }, $b5fecd57b45662f2$var$Fy = $b5fecd57b45662f2$var$JA;
});
var $b5fecd57b45662f2$var$QA, $b5fecd57b45662f2$var$tR, $b5fecd57b45662f2$var$Py, $b5fecd57b45662f2$var$Ty = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$QA = ({ controlId: t, filter: e })=>{
        switch(e.type){
            case "date":
            case "datetime":
                {
                    let o = e.values.min_dt ? new Date(e.values.min_dt) : void 0, r = e.values.max_dt ? new Date(e.values.max_dt) : void 0;
                    return $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Datetime, {
                        name: e.name,
                        controlId: t,
                        isTime: e.type === "datetime",
                        minDate: o,
                        maxDate: r,
                        groupClass: ""
                    });
                }
            case "date-range":
            case "datetime-range":
                {
                    let o = e.values.min_dt ? new Date(e.values.min_dt) : void 0, r = e.values.max_dt ? new Date(e.values.max_dt) : void 0;
                    return $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.DatetimeRange, {
                        name: e.name,
                        controlId: t,
                        isTime: e.type === "datetime-range",
                        minDate: o,
                        maxDate: r,
                        groupClass: ""
                    });
                }
            case "select":
                return $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Select, {
                    name: e.name,
                    controlId: t,
                    isMulti: !0,
                    options: e.values,
                    groupClass: ""
                });
            case "toggle":
                return $acw62.createElement($acw62.Fragment, null, Object.entries(e.values).map(([o, r])=>$acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Check, {
                        key: o,
                        className: "mb-1",
                        name: e.name,
                        controlId: `${t}.${o}`,
                        type: "radio",
                        label: r
                    })));
            case "boolean":
                return $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Check, {
                    name: e.name,
                    controlId: t,
                    type: "switch"
                });
            default:
                return $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Input, {
                    name: e.name,
                    controlId: t,
                    groupClass: ""
                });
        }
    }, $b5fecd57b45662f2$var$tR = ({ filter: t })=>{
        let e = $acw62.useId();
        return t.label === "[hidden]" ? null : $acw62.createElement($acw62.Fragment, null, $acw62.createElement("label", {
            className: "fw-bold pe-2",
            htmlFor: e
        }, t.label), $acw62.createElement("div", null, $acw62.createElement($b5fecd57b45662f2$var$QA, {
            filter: t,
            controlId: e
        })));
    }, $b5fecd57b45662f2$var$Py = $b5fecd57b45662f2$var$tR;
});
var $b5fecd57b45662f2$var$rR, $b5fecd57b45662f2$var$Ny, $b5fecd57b45662f2$var$_y = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Ty();
    $b5fecd57b45662f2$var$rR = ({ open: t, closeModal: e })=>{
        let { data: { name: o, filters: r }, activeFilters: a, setSearchParams: i } = $b5fecd57b45662f2$var$h(), s = (0, $acw62.useMemo)(()=>{
            let f = {};
            return r == null || r.map((u)=>{
                switch(u.type){
                    case "date":
                    case "datetime":
                    case "date-range":
                    case "datetime-range":
                        f[u.name] = "";
                        break;
                    case "select":
                        f[u.name] = [];
                        break;
                    default:
                        f[u.name] = "";
                        break;
                }
            }), f;
        }, [
            r
        ]), l = (0, $acw62.useMemo)(()=>({
                ...s,
                ...a
            }), [
            s,
            a
        ]), p = (0, $22i8b.useForm)({
            defaultValues: l
        }), m = ()=>{
            p.reset(l), e();
        }, c = ()=>{
            i({
                filter: void 0
            }), p.reset({
                ...s
            }), e();
        }, d = async (f)=>{
            let u = Object.fromEntries(Object.entries(f).filter(([g, x])=>x != null && (x == null ? void 0 : x.length) > 0));
            i({
                filter: u,
                page: void 0
            }), p.reset({
                ...s,
                ...u
            }), e();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default), {
            show: t,
            onHide: m,
            centered: !0
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Header, {
            className: "py-0",
            closeButton: !0
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Title, null, "\u0424\u0456\u043B\u044C\u0442\u0440")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Body, {
            name: `filters-${o}`,
            methods: p,
            handleSubmit: d
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Body, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "grid-form grid-form-col-2"
        }, r.map((f)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$Py, {
                key: `filters-${o}-${f.name}`,
                filter: f
            })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Footer, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6LAgE.default), {
            variant: "outline-secondary",
            onClick: c
        }, "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0432\u0441\u0456"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Submit, null, "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u0442\u0438"))));
    }, $b5fecd57b45662f2$var$Ny = $b5fecd57b45662f2$var$rR;
});
var $b5fecd57b45662f2$var$iR, $b5fecd57b45662f2$var$sR, $b5fecd57b45662f2$var$By, $b5fecd57b45662f2$var$Oy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$da();
    $b5fecd57b45662f2$var$iR = [
        {
            value: "fixed",
            label: "\u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u043E (\u0431\u0435\u0437 \u043F\u0456\u0434\u043F\u0438\u0441\u0443)"
        },
        {
            value: "captioned",
            label: "\u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u043E (\u0437 \u043F\u0456\u0434\u043F\u0438\u0441\u043E\u043C)"
        },
        {
            value: "collapsed",
            label: "\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u043E"
        },
        {
            value: "hidden",
            label: "\u043F\u0440\u0438\u0445\u043E\u0432\u0430\u043D\u043E"
        }
    ], $b5fecd57b45662f2$var$sR = ({ state: t, close: e })=>{
        let { settings: o, setSettings: r, data: { columns: a } } = $b5fecd57b45662f2$var$h(), i = (0, $acw62.useCallback)((s)=>new Promise((l)=>{
                r(s), l(), e();
            }), []);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default), {
            show: t,
            onHide: e,
            centered: !0,
            size: "lg"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Header, {
            className: "py-0",
            closeButton: !0
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Title, null, "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0442\u0430\u0431\u043B\u0438\u0446\u0456")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Callback, {
            data: o,
            handleSubmit: i
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Body, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "font-16 fw-bold"
        }, "\u041F\u043E\u043B\u044F"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "grid-form grid-form-col-3"
        }, a.map((s)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: `column-config-${s.key}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, s.title), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.BasicSelect, {
                name: `displayColumns.${s.key}.showType`,
                options: $b5fecd57b45662f2$var$iR,
                groupClass: ""
            })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Input, {
                type: "number",
                name: `displayColumns.${s.key}.order`,
                groupClass: ""
            }))))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "mt-3"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Check, {
            name: "disableMobileLayout",
            label: "\u0417\u0430\u0432\u0436\u0434\u0438 \u043F\u043E\u043A\u0430\u0437\u0443\u0432\u0430\u0442\u0438 \u044F\u043A \u0442\u0430\u0431\u043B\u0438\u0446\u044E"
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gBH4L.default).Footer, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6LAgE.default), {
            variant: "secondary",
            onClick: e
        }, "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Submit, null, "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438"))));
    }, $b5fecd57b45662f2$var$By = $b5fecd57b45662f2$var$sR;
});
var $b5fecd57b45662f2$var$cR, $b5fecd57b45662f2$var$uR, $b5fecd57b45662f2$var$dR, $b5fecd57b45662f2$var$Ly, $b5fecd57b45662f2$var$Xy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$cR = [
        {
            value: "asc",
            label: "\u0437\u0430 \u0437\u0440\u043E\u0441\u0442\u0430\u043D\u043D\u044F\u043C"
        },
        {
            value: "desc",
            label: "\u0437\u0430 \u0441\u043F\u0430\u0434\u0430\u043D\u043D\u044F\u043C"
        }
    ], $b5fecd57b45662f2$var$uR = ({ list: t })=>{
        let { fields: e, append: o, remove: r } = (0, $22i8b.useFieldArray)({
            name: "sort"
        }), a = ()=>o({}), i = ()=>{
            r(e.map((s, l)=>l));
        };
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("div", {
            className: "grid-form grid-form-col-3-delete"
        }, e.map((s, l)=>$acw62.createElement($acw62.Fragment, {
                key: s.id
            }, $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.BasicSelect, {
                options: t,
                name: `sort.${l}.col`,
                groupClass: ""
            }), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.BasicSelect, {
                options: $b5fecd57b45662f2$var$cR,
                name: `sort.${l}.dir`,
                groupClass: ""
            }), $acw62.createElement((0, $77pHI.default), {
                onClick: ()=>r(l)
            })))), $acw62.createElement("div", {
            className: "d-flex"
        }, $acw62.createElement((0, $6LAgE.default), {
            size: "sm",
            variant: "link",
            onClick: a,
            className: "p-0"
        }, $acw62.createElement("i", {
            className: "mdi mdi-plus me-1"
        }), "\u0434\u043E\u0434\u0430\u0442\u0438 \u0441\u043E\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F"), e.length > 0 && $acw62.createElement((0, $6LAgE.default), {
            size: "sm",
            variant: "link",
            onClick: i,
            className: "p-0 link-danger ms-auto"
        }, $acw62.createElement("i", {
            className: "mdi mdi-close-circle-multiple-outline me-1"
        }), "\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0438")));
    }, $b5fecd57b45662f2$var$dR = ({ state: t, close: e })=>{
        let { activeSorts: o, setSorts: r, data: { columns: a } } = $b5fecd57b45662f2$var$h(), i = (0, $acw62.useCallback)((p)=>new Promise((m)=>{
                var c, d;
                r((d = (c = p.sort) == null ? void 0 : c.reduce((f, u, g)=>({
                        ...f,
                        [u.col]: {
                            dir: u.dir,
                            ord: g
                        }
                    }), {})) != null ? d : {}), m(), e();
            }), []), s = (0, $acw62.useMemo)(()=>Object.entries(o).map(([p, { dir: m }])=>({
                    col: p,
                    dir: m
                })), [
            o
        ]), l = (0, $acw62.useMemo)(()=>a.filter((p)=>p.isSortable).map((p)=>({
                    value: p.key,
                    label: p.title
                })), [
            a
        ]);
        return $acw62.createElement((0, $gBH4L.default), {
            show: t,
            onHide: e,
            centered: !0
        }, $acw62.createElement((0, $gBH4L.default).Header, {
            className: "py-0",
            closeButton: !0
        }, $acw62.createElement((0, $gBH4L.default).Title, null, "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F")), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Callback, {
            data: {
                sort: s
            },
            handleSubmit: i,
            showSuccess: !1
        }, $acw62.createElement((0, $gBH4L.default).Body, null, $acw62.createElement($b5fecd57b45662f2$var$uR, {
            list: l
        })), $acw62.createElement((0, $gBH4L.default).Footer, null, $acw62.createElement((0, $6LAgE.default), {
            variant: "secondary",
            onClick: e
        }, "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Submit, null, "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438"))));
    }, $b5fecd57b45662f2$var$Ly = $b5fecd57b45662f2$var$dR;
});
var $b5fecd57b45662f2$var$hR, $b5fecd57b45662f2$var$Vy, $b5fecd57b45662f2$var$Uy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$ue();
    $b5fecd57b45662f2$var$_y();
    $b5fecd57b45662f2$var$Oy();
    $b5fecd57b45662f2$var$Xy();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$hR = ()=>{
        let t = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { config: { tableMode: e, settingsShow: o }, isFilters: r, isSort: a, data: { options: { createAction: i } } } = $b5fecd57b45662f2$var$h(), s = $b5fecd57b45662f2$export$33ffd74ebf07f060(), l = $b5fecd57b45662f2$export$33ffd74ebf07f060(), p = $b5fecd57b45662f2$export$33ffd74ebf07f060(), m = (0, $aphAM.useLocation)();
        return (0, $acw62.useEffect)(()=>{
            if (e === "simple") return;
            let c = [], d = {};
            return o && (d.settings = {
                icon: "cog",
                title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
                handler: ()=>p.open()
            }), r && (d.filters = {
                icon: "filter-cog",
                title: "\u0424\u0456\u043B\u044C\u0442\u0440\u0430\u0446\u0456\u044F",
                handler: ()=>s.open()
            }), a && (d.sort = {
                icon: "sort",
                title: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
                handler: ()=>l.open()
            }), Object.keys(d).length > 0 && c.push(t.GlobalButtons.registerCustomButton("datatable", {
                icon: "table-settings",
                title: "\u0422\u0430\u0431\u043B\u0438\u0446\u044F",
                variant: "secondary",
                items: d
            })), i && c.push(t.GlobalButtons.registerDropdownItem("create", i.key, {
                icon: i.icon,
                title: i.title,
                url: `${m.pathname}/create`
            })), ()=>{
                c.forEach((f)=>f());
            };
        }, [
            e,
            o,
            r,
            a,
            i == null ? void 0 : i.key
        ]), e === "simple" ? null : $acw62.createElement($acw62.Fragment, null, r && $acw62.createElement($b5fecd57b45662f2$var$Ny, {
            open: s.state,
            closeModal: s.close
        }), a && $acw62.createElement($b5fecd57b45662f2$var$Ly, {
            state: l.state,
            close: l.close
        }), o && $acw62.createElement($b5fecd57b45662f2$var$By, {
            state: p.state,
            close: p.close
        }));
    }, $b5fecd57b45662f2$var$Vy = $b5fecd57b45662f2$var$hR;
});
var $b5fecd57b45662f2$var$yR, $b5fecd57b45662f2$var$kn, $b5fecd57b45662f2$var$el = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$th();
    $b5fecd57b45662f2$var$P();
    $b5fecd57b45662f2$var$wy();
    $b5fecd57b45662f2$var$Uy();
    $b5fecd57b45662f2$var$yR = ({ data: t, renderConfig: e, config: o })=>$acw62.createElement($b5fecd57b45662f2$var$yi, {
            key: t.name,
            data: t,
            renderConfig: e,
            config: o
        }, $acw62.createElement($b5fecd57b45662f2$var$Qg, null), $acw62.createElement($b5fecd57b45662f2$var$Fy, null), $acw62.createElement($b5fecd57b45662f2$var$Vy, null)), $b5fecd57b45662f2$var$kn = $b5fecd57b45662f2$var$yR;
});
var $b5fecd57b45662f2$var$bR, $b5fecd57b45662f2$var$Ey, $b5fecd57b45662f2$var$Hy = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$el();
    $b5fecd57b45662f2$var$bR = (t)=>{
        let { data: e } = (0, $aphAM.useLoaderData)();
        return typeof e != "object" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$var$kn, {
            data: e,
            ...t
        });
    }, $b5fecd57b45662f2$var$Ey = $b5fecd57b45662f2$var$bR;
});
var $b5fecd57b45662f2$export$aeedc005af528695, $b5fecd57b45662f2$var$Lr = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$el();
    $b5fecd57b45662f2$var$Hy();
    $b5fecd57b45662f2$var$ca();
    $b5fecd57b45662f2$var$co();
    $b5fecd57b45662f2$export$aeedc005af528695 = Object.assign($b5fecd57b45662f2$var$Ey, {
        Base: $b5fecd57b45662f2$var$kn,
        defaultConfig: $b5fecd57b45662f2$var$mo,
        useSearchParams: $b5fecd57b45662f2$var$Pt
    });
});
var $b5fecd57b45662f2$var$tk, $b5fecd57b45662f2$var$Mn, $b5fecd57b45662f2$var$fl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$tk = ()=>{
        let { appCreateYear: t, appName: e } = $b5fecd57b45662f2$export$a9d1b6bbcaa78af1(), o = $acw62.useMemo(()=>{
            let r = t != null ? t : new Date().getFullYear(), a = new Date().getFullYear();
            return (r !== a ? `${r} - ` : "") + a.toString();
        }, []);
        return $acw62.createElement($acw62.Fragment, null, o, " \xa9 ", e);
    }, $b5fecd57b45662f2$var$Mn = $b5fecd57b45662f2$var$tk;
});
var $b5fecd57b45662f2$var$ek, $b5fecd57b45662f2$var$Nn, $b5fecd57b45662f2$var$gl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ek = ()=>$acw62.createElement($acw62.Fragment, null, "Developed in ", $acw62.createElement("a", {
            href: "https://ova.in.ua"
        }, "OVA Studio")), $b5fecd57b45662f2$var$Nn = $b5fecd57b45662f2$var$ek;
});
var $b5fecd57b45662f2$var$ok, $b5fecd57b45662f2$var$_n, $b5fecd57b45662f2$var$hl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$fl();
    $b5fecd57b45662f2$var$gl();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$ok = ({ className: t })=>{
        let { appInfoRender: e } = $b5fecd57b45662f2$export$a9d1b6bbcaa78af1();
        return $acw62.createElement("footer", {
            className: "footer py-2 text-muted small " + (t != null ? t : "")
        }, $acw62.createElement("div", {
            className: "container-fluid"
        }, $acw62.createElement("div", {
            className: "row"
        }, $acw62.createElement("div", {
            className: "col-md-6 text-start"
        }, $acw62.createElement($b5fecd57b45662f2$var$Mn, null), e && $acw62.createElement(e, null)), $acw62.createElement("div", {
            className: "col-md-6"
        }, $acw62.createElement("div", {
            className: "text-md-end footer-links d-none d-md-block"
        }, $acw62.createElement($b5fecd57b45662f2$var$Nn, null))))));
    }, $b5fecd57b45662f2$var$_n = $b5fecd57b45662f2$var$ok;
});
var $b5fecd57b45662f2$var$uk, $b5fecd57b45662f2$var$Bn, $b5fecd57b45662f2$var$xl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$uk = ({ title: t, info: e })=>$acw62.createElement((0, $h7C4J.default), {
            className: "justify-content-center"
        }, $acw62.createElement((0, $99eL8.default), {
            lg: 4,
            className: "text-center"
        }, $acw62.createElement("h1", {
            className: "text-error mt-4"
        }, t), $acw62.createElement("h4", {
            className: "text-uppercase text-danger mt-3"
        }, e), $acw62.createElement((0, $lzNIT.Link), {
            to: "/",
            className: "btn btn-info mt-3"
        }, $acw62.createElement("i", {
            className: "mdi mdi-reply me-2"
        }), "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044C \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043E\u043A"))), $b5fecd57b45662f2$var$Bn = $b5fecd57b45662f2$var$uk;
});
var $b5fecd57b45662f2$var$tx = {};
$b5fecd57b45662f2$var$Ie($b5fecd57b45662f2$var$tx, {
    default: ()=>$b5fecd57b45662f2$var$bl
});
var $b5fecd57b45662f2$var$dk, $b5fecd57b45662f2$var$bl, $b5fecd57b45662f2$var$Dl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$xl();
    $b5fecd57b45662f2$var$dk = ()=>$acw62.createElement($b5fecd57b45662f2$var$Bn, {
            title: "404",
            info: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E"
        }), $b5fecd57b45662f2$var$bl = $b5fecd57b45662f2$var$dk;
});
var $b5fecd57b45662f2$var$Dk, $b5fecd57b45662f2$var$Sk, $b5fecd57b45662f2$var$ax, $b5fecd57b45662f2$var$nx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Dk = ({ data: t, isActive: e })=>{
        let o = $acw62.useRef();
        return $acw62.useEffect(()=>{
            var a;
            e && ((a = o.current) == null || a.scrollIntoView({
                inline: "center"
            }));
        }, [
            o.current,
            e
        ]), $acw62.createElement("a", {
            href: "#",
            onClick: (a)=>{
                a.preventDefault(), a.stopPropagation(), t.handleClick();
            },
            className: `${e ? "active" : ""}`,
            ref: (a)=>o.current = a != null ? a : void 0
        }, t.icon && $acw62.createElement("i", {
            className: `mdi mdi-${t.icon} me-1`
        }), t.title, t.badge !== void 0 && $acw62.createElement("span", {
            className: "ms-1 text-muted"
        }, t.badge));
    }, $b5fecd57b45662f2$var$Sk = ()=>{
        let t = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { tabs: e, activeTab: o } = $b5fecd57b45662f2$export$4b79bd8f34740571(t.Topbar.Tabs);
        return $acw62.createElement("div", {
            className: "navbar-tabs-row"
        }, e.map((r)=>$acw62.createElement($b5fecd57b45662f2$var$Dk, {
                key: `tab-${r.key}`,
                data: r,
                isActive: r.key === o
            })));
    }, $b5fecd57b45662f2$var$ax = $b5fecd57b45662f2$var$Sk;
});
function $b5fecd57b45662f2$export$8cefe241bd876ca0() {
    let t = $b5fecd57b45662f2$export$baf341815cf7915b();
    return (0, $acw62.useMemo)(()=>{
        let e = [];
        return t.map(({ breadcrumb: o })=>e.push(...o)), e.length < 2 ? null : e;
    }, [
        t
    ]);
}
var $b5fecd57b45662f2$var$On = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$nr();
});
var $b5fecd57b45662f2$var$Ak, $b5fecd57b45662f2$var$ix, $b5fecd57b45662f2$var$sx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$On();
    $b5fecd57b45662f2$var$Ak = ()=>{
        let t = $b5fecd57b45662f2$export$8cefe241bd876ca0();
        return t ? $acw62.createElement((0, $gzHIW.default), {
            className: "d-block d-lg-none"
        }, $acw62.createElement((0, $gzHIW.default).Toggle, {
            variant: "link",
            className: "arrow-none px-1"
        }, $acw62.createElement("i", {
            className: "mdi mdi-chevron-triple-left font-24 lh-1"
        })), $acw62.createElement((0, $gzHIW.default).Menu, null, t.map((e, o)=>{
            let r = o === t.length - 1;
            return $acw62.createElement((0, $gzHIW.default).Item, {
                key: `breadcrumb-${o}`,
                disabled: r,
                as: (0, $lzNIT.Link),
                to: e.to
            }, e.text);
        }))) : null;
    }, $b5fecd57b45662f2$var$ix = $b5fecd57b45662f2$var$Ak;
});
var $b5fecd57b45662f2$var$Rk, $b5fecd57b45662f2$var$lx, $b5fecd57b45662f2$var$px = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Rk = ()=>{
        let t = $b5fecd57b45662f2$export$846279b0d7f2d98d(), e = $acw62.useRef(null);
        return $acw62.useEffect(()=>{
            e.current && t.Topbar.Row.setContainer(e.current);
        }, []), $acw62.createElement("div", {
            ref: e,
            className: "navbar-data-row"
        });
    }, $b5fecd57b45662f2$var$lx = $b5fecd57b45662f2$var$Rk;
});
var $b5fecd57b45662f2$var$Fk, $b5fecd57b45662f2$var$mx, $b5fecd57b45662f2$var$cx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Fk = ({ result: t, isSelected: e, type: o })=>{
        let r = $b5fecd57b45662f2$export$5f78f356137e000a(), a = $acw62.useMemo(()=>r.resolveTypeRenderer(o), [
            o
        ]), i = $acw62.useMemo(()=>r.resolveTypeIcon(o), [
            o
        ]), s = $acw62.useRef(null);
        return $acw62.useEffect(()=>{
            e && s.current && s.current.scrollIntoView({
                block: "nearest"
            });
        }, [
            e
        ]), $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("search-app-result", e && "selected"),
            role: "button",
            onClick: (l)=>r.handleResultSelect(t, l.ctrlKey),
            ref: s
        }, i && $acw62.createElement("i", {
            className: `mdi mdi-${i} font-16 lh-1 me-1`
        }), $acw62.createElement(a, {
            ...t
        }));
    }, $b5fecd57b45662f2$var$mx = $b5fecd57b45662f2$var$Fk;
});
var $b5fecd57b45662f2$var$wk, $b5fecd57b45662f2$var$ux, $b5fecd57b45662f2$var$dx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$cx();
    $b5fecd57b45662f2$var$wk = ()=>{
        let t = $b5fecd57b45662f2$export$5f78f356137e000a(), { query: e, results: o, selectedResultIdx: r, hasMore: a, isLoadingMore: i, selectedType: s } = $b5fecd57b45662f2$export$4b79bd8f34740571(t);
        return o === null ? null : o.length ? $acw62.createElement($acw62.Fragment, null, o.map((l, p)=>$acw62.createElement($b5fecd57b45662f2$var$mx, {
                key: p,
                result: l,
                isSelected: p === r,
                type: s
            })), a && $acw62.createElement("div", {
            className: "search-app-result",
            role: "button",
            onClick: t.handleMore.bind(t),
            "aria-disabled": i
        }, i ? $acw62.createElement("span", {
            className: "text-muted"
        }, "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...") : "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0449\u0435")) : $acw62.createElement("div", {
            className: "text-muted"
        }, '\u0417\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C "', e, '" \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.');
    }, $b5fecd57b45662f2$var$ux = $b5fecd57b45662f2$var$wk;
});
var $b5fecd57b45662f2$var$Tk, $b5fecd57b45662f2$var$fx, $b5fecd57b45662f2$var$gx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$Tk = ()=>{
        let t = $b5fecd57b45662f2$export$5f78f356137e000a(), { history: e, selectedHistoryIdx: o } = $b5fecd57b45662f2$export$4b79bd8f34740571(t);
        return e.length === 0 ? null : $acw62.createElement("div", null, $acw62.createElement("div", {
            className: "text-muted small"
        }, "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u0430\u043F\u0438\u0442\u0438:"), e.map((r, a)=>$acw62.createElement("div", {
                key: `suggest-${a}`,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("search-app-result", o === a && "selected"),
                role: "button",
                onClick: ()=>t.setQuery(r)
            }, r)));
    }, $b5fecd57b45662f2$var$fx = $b5fecd57b45662f2$var$Tk;
});
var $b5fecd57b45662f2$var$Mk, $b5fecd57b45662f2$var$hx, $b5fecd57b45662f2$var$yx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$dx();
    $b5fecd57b45662f2$var$gx();
    $b5fecd57b45662f2$var$Mk = ()=>{
        let t = $b5fecd57b45662f2$export$5f78f356137e000a(), { isLoading: e, history: o, results: r } = $b5fecd57b45662f2$export$4b79bd8f34740571(t);
        return e ? $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null) : r === null ? $acw62.createElement($acw62.Fragment, null, o.length > 0 ? $acw62.createElement($b5fecd57b45662f2$var$fx, null) : $acw62.createElement("div", {
            className: "text-muted"
        }, "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0437\u0430\u043F\u0438\u0442 \u0434\u043B\u044F \u043F\u043E\u0448\u0443\u043A\u0443")) : $acw62.createElement($b5fecd57b45662f2$var$ux, null);
    }, $b5fecd57b45662f2$var$hx = $b5fecd57b45662f2$var$Mk;
});
var $b5fecd57b45662f2$var$_k, $b5fecd57b45662f2$var$Bk, $b5fecd57b45662f2$var$bx, $b5fecd57b45662f2$var$Dx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$yx();
    $b5fecd57b45662f2$var$_k = ({ eventKey: t, name: e, icon: o, active: r, cnt: a })=>{
        let i = $acw62.useRef(null);
        return $acw62.useEffect(()=>{
            r && i.current && i.current.scrollIntoView({
                block: "nearest",
                inline: "nearest"
            });
        }, [
            r
        ]), $acw62.createElement((0, $eBMdo.default).Item, null, $acw62.createElement((0, $eBMdo.default).Link, {
            eventKey: t,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("py-md-1 px-md-2 d-flex align-items-center", {
                [r ? "text-secondary" : "text-muted"]: !a
            }),
            ref: i
        }, o && $acw62.createElement("i", {
            className: `mdi mdi-${o} font-16 lh-1 me-1`
        }), e, !!a && a > 0 && $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("ms-1 font-12", r ? "text-secondary" : "text-muted")
        }, a)));
    }, $b5fecd57b45662f2$var$Bk = ()=>{
        let t = $b5fecd57b45662f2$export$5f78f356137e000a(), { selectedType: e, types: o, typesCnt: r, error: a } = $b5fecd57b45662f2$export$4b79bd8f34740571(t);
        return $acw62.createElement("div", {
            className: "search-dropdown bg-light"
        }, $acw62.createElement((0, $eBMdo.default), {
            variant: "pills",
            className: "search-type-selector",
            activeKey: e || "none",
            onSelect: t.handleTypeSelect.bind(t)
        }, o && Object.entries(o).map(([i, { name: s, icon: l }])=>$acw62.createElement($b5fecd57b45662f2$var$_k, {
                key: i,
                eventKey: i,
                name: s,
                icon: l,
                cnt: r[i],
                active: e === i
            }))), a && $acw62.createElement((0, $cpxrl.default), {
            variant: "danger",
            className: "my-2"
        }, a), $acw62.createElement("div", {
            className: "search-results custom-scrollbar"
        }, $acw62.createElement($b5fecd57b45662f2$var$hx, null)));
    }, $b5fecd57b45662f2$var$bx = $b5fecd57b45662f2$var$Bk;
});
var $b5fecd57b45662f2$var$Lk, $b5fecd57b45662f2$var$Sx, $b5fecd57b45662f2$var$Cx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$Dx();
    $b5fecd57b45662f2$var$Lk = ()=>{
        let t = $b5fecd57b45662f2$export$5f78f356137e000a(), { query: e, isActive: o } = $b5fecd57b45662f2$export$4b79bd8f34740571(t);
        return $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("search-app", {
                active: o
            })
        }, $acw62.createElement("div", {
            className: "backdrop",
            onClick: t.close.bind(t)
        }), $acw62.createElement("div", {
            className: "search-app-suggest"
        }, $acw62.createElement("span", null, $acw62.createElement("b", null, "\u2190"), " / ", $acw62.createElement("b", null, "\u2192"), " - \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u043C\u0456\u0436 \u0432\u043A\u043B\u0430\u0434\u043A\u0430\u043C\u0438,"), " ", $acw62.createElement("span", null, $acw62.createElement("b", null, "\u2191"), " / ", $acw62.createElement("b", null, "\u2193"), " - \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F \u043F\u043E \u0441\u043F\u0438\u0441\u043A\u0443,"), " ", $acw62.createElement("span", null, $acw62.createElement("b", null, "Enter"), " - \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438,"), " ", $acw62.createElement("span", null, $acw62.createElement("b", null, "Ctrl+Enter"), " - \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438,"), " ", $acw62.createElement("span", null, $acw62.createElement("b", null, "Esc"), " - \u0437\u0430\u043A\u0440\u0438\u0442\u0438")), $acw62.createElement((0, $48fuN.default), {
            ref: t.handleInputRef.bind(t),
            tabIndex: 0,
            inputMode: "search",
            placeholder: "\u041F\u043E\u0448\u0443\u043A...",
            value: e,
            onChange: (r)=>t.setQuery(r.target.value),
            onFocus: t.activate.bind(t)
        }), $acw62.createElement($b5fecd57b45662f2$var$bx, null));
    }, $b5fecd57b45662f2$var$Sx = $b5fecd57b45662f2$var$Lk;
});
var $b5fecd57b45662f2$var$Vk, $b5fecd57b45662f2$var$vx, $b5fecd57b45662f2$var$Ax = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$nx();
    $b5fecd57b45662f2$var$sx();
    $b5fecd57b45662f2$var$px();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Cx();
    $b5fecd57b45662f2$var$Vk = ()=>{
        let t = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { isVisible: e } = $b5fecd57b45662f2$export$4b79bd8f34740571(t.Topbar), { isOpen: o } = $b5fecd57b45662f2$export$4b79bd8f34740571(t.MainNavigation);
        return $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("navbar-custom", {
                "navbar-hidden": !e
            }),
            style: o ? {
                zIndex: 90
            } : void 0
        }, $acw62.createElement("div", {
            className: "navbar-main-row d-flex align-items-center gap-1"
        }, $acw62.createElement("div", {
            className: "d-md-none topbar-breadcrumbs"
        }, $acw62.createElement($b5fecd57b45662f2$var$ix, null)), $acw62.createElement($b5fecd57b45662f2$var$Sx, null)), $acw62.createElement($b5fecd57b45662f2$var$ax, null), $acw62.createElement($b5fecd57b45662f2$var$lx, null));
    }, $b5fecd57b45662f2$var$vx = $b5fecd57b45662f2$var$Vk;
});
var $b5fecd57b45662f2$var$Uk, $b5fecd57b45662f2$export$1d3945ea2d8839cb, $b5fecd57b45662f2$var$ro = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Uk = ({ addClassName: t, children: e })=>$acw62.createElement("div", {
            className: "h-100 d-flex flex-column align-items-center justify-content-center " + (t != null ? t : "")
        }, e), $b5fecd57b45662f2$export$1d3945ea2d8839cb = $b5fecd57b45662f2$var$Uk;
});
var $b5fecd57b45662f2$var$Wk, $b5fecd57b45662f2$var$vl, $b5fecd57b45662f2$var$kx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$ro();
    $b5fecd57b45662f2$var$Wk = ({ state: t })=>$acw62.createElement("div", {
            className: "bottom-menu"
        }, $acw62.createElement($b5fecd57b45662f2$export$1d3945ea2d8839cb, null, t === "error" ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement("i", {
            className: "mdi mdi-alert fs-1 lh-1 text-danger"
        }), $acw62.createElement("div", {
            className: "font-16 text-danger"
        }, "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F")) : $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null))), $b5fecd57b45662f2$var$vl = $b5fecd57b45662f2$var$Wk;
});
var $b5fecd57b45662f2$var$Ek, $b5fecd57b45662f2$var$Vn, $b5fecd57b45662f2$var$Al = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ek = ({})=>$acw62.createElement($acw62.Fragment, null), $b5fecd57b45662f2$var$Vn = $b5fecd57b45662f2$var$Ek;
});
var $b5fecd57b45662f2$var$Yk, $b5fecd57b45662f2$var$Go, $b5fecd57b45662f2$var$Un = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Yk = ({ icon: t, className: e })=>typeof t == "string" ? $acw62.createElement("i", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`mdi mdi-${t}`, e)
        }) : $acw62.createElement($acw62.Fragment, null, t), $b5fecd57b45662f2$var$Go = $b5fecd57b45662f2$var$Yk;
});
var $b5fecd57b45662f2$var$zk, $b5fecd57b45662f2$var$Wn, $b5fecd57b45662f2$var$Rl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Un();
    $b5fecd57b45662f2$var$zk = ({ options: t, onClick: e })=>{
        var o;
        return $acw62.createElement((0, $gzHIW.default).Item, {
            className: "px-2 py-1 font-16 d-flex gap-1 align-items-center",
            onClick: e
        }, $acw62.createElement($b5fecd57b45662f2$var$Go, {
            icon: t.icon,
            className: "font-18"
        }), $acw62.createElement("span", null, t.title), t.badge !== void 0 && $acw62.createElement("span", {
            className: "rounded ms-auto bg-danger px-1 text-light"
        }, (o = t.badge) != null ? o : " "));
    }, $b5fecd57b45662f2$var$Wn = $b5fecd57b45662f2$var$zk;
});
var $b5fecd57b45662f2$var$$k, $b5fecd57b45662f2$var$wx, $b5fecd57b45662f2$var$Px = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Rl();
    $b5fecd57b45662f2$var$$k = ({ data: t })=>{
        let e = (0, $aphAM.useNavigate)();
        return $acw62.createElement($b5fecd57b45662f2$var$Wn, {
            onClick: ()=>e(t.url),
            options: t
        });
    }, $b5fecd57b45662f2$var$wx = $b5fecd57b45662f2$var$$k;
});
var $b5fecd57b45662f2$var$qk, $b5fecd57b45662f2$var$Mx, $b5fecd57b45662f2$var$Nx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Rl();
    $b5fecd57b45662f2$var$qk = ({ data: t })=>$acw62.createElement($b5fecd57b45662f2$var$Wn, {
            options: t,
            onClick: t.handler
        }), $b5fecd57b45662f2$var$Mx = $b5fecd57b45662f2$var$qk;
});
var $b5fecd57b45662f2$var$Kk, $b5fecd57b45662f2$var$_x, $b5fecd57b45662f2$var$Bx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$Px();
    $b5fecd57b45662f2$var$Nx();
    $b5fecd57b45662f2$var$Kk = ({ data: t })=>$b5fecd57b45662f2$var$Fr(t) ? $acw62.createElement($b5fecd57b45662f2$var$wx, {
            data: t
        }) : $b5fecd57b45662f2$var$wr(t) ? $acw62.createElement($b5fecd57b45662f2$var$Mx, {
            data: t
        }) : null, $b5fecd57b45662f2$var$_x = $b5fecd57b45662f2$var$Kk;
});
var $b5fecd57b45662f2$var$Jk, $b5fecd57b45662f2$var$Ox, $b5fecd57b45662f2$var$Ix = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Al();
    $b5fecd57b45662f2$var$Bx();
    $b5fecd57b45662f2$var$Un();
    $b5fecd57b45662f2$var$Jk = ({ data: t, className: e })=>{
        var o, r;
        return $acw62.createElement((0, $gzHIW.default), {
            drop: "up-centered"
        }, $acw62.createElement((0, $gzHIW.default).Toggle, {
            variant: (o = t.variant) != null ? o : "secondary",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("arrow-none rounded-btn", e),
            disabled: t.disabled,
            title: t.title
        }, $acw62.createElement($b5fecd57b45662f2$var$Go, {
            icon: t.icon
        }), $acw62.createElement($b5fecd57b45662f2$var$Vn, {
            data: t.badge
        })), $acw62.createElement((0, $gzHIW.default).Menu, null, Object.entries((r = t.items) != null ? r : {}).map(([a, i])=>$acw62.createElement($b5fecd57b45662f2$var$_x, {
                key: `btn-${a}`,
                data: i
            }))));
    }, $b5fecd57b45662f2$var$Ox = $b5fecd57b45662f2$var$Jk;
});
var $b5fecd57b45662f2$var$t1, $b5fecd57b45662f2$var$zo, $b5fecd57b45662f2$var$Hn = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Al();
    $b5fecd57b45662f2$var$Un();
    $b5fecd57b45662f2$var$t1 = ({ className: t, onClick: e, options: o })=>{
        var r;
        return $acw62.createElement((0, $6LAgE.default), {
            title: o.title,
            onClick: e,
            className: `rounded-btn ${t}`,
            variant: (r = o.variant) != null ? r : "secondary",
            disabled: o.disabled
        }, $acw62.createElement($b5fecd57b45662f2$var$Go, {
            icon: o.icon
        }), $acw62.createElement($b5fecd57b45662f2$var$Vn, {
            data: o.badge
        }));
    }, $b5fecd57b45662f2$var$zo = $b5fecd57b45662f2$var$t1;
});
var $b5fecd57b45662f2$var$e1, $b5fecd57b45662f2$var$Xx, $b5fecd57b45662f2$var$Vx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Hn();
    $b5fecd57b45662f2$var$e1 = ({ className: t, data: e })=>$acw62.createElement($b5fecd57b45662f2$var$zo, {
            className: t,
            onClick: e.handler,
            options: e
        }), $b5fecd57b45662f2$var$Xx = $b5fecd57b45662f2$var$e1;
});
var $b5fecd57b45662f2$var$r1, $b5fecd57b45662f2$var$Wx, $b5fecd57b45662f2$var$Ex = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Hn();
    $b5fecd57b45662f2$var$r1 = ({ className: t, data: e })=>{
        let o = (0, $aphAM.useNavigate)();
        return $acw62.createElement($b5fecd57b45662f2$var$zo, {
            className: t,
            onClick: ()=>o(e.url),
            options: e
        });
    }, $b5fecd57b45662f2$var$Wx = $b5fecd57b45662f2$var$r1;
});
var $b5fecd57b45662f2$var$n1, $b5fecd57b45662f2$var$Hx, $b5fecd57b45662f2$var$Yx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Hn();
    $b5fecd57b45662f2$var$Ee();
    $b5fecd57b45662f2$var$n1 = ({ className: t, data: { openIcon: e, icon: o, title: r, portalTitle: a, registerRemoteStateHandler: i, portalRefHandler: s, scrollable: l = !0, popoverClassName: p, popoverHeaderClassName: m, popoverBodyClassName: c, ...d } })=>{
        let f = $b5fecd57b45662f2$export$c32275ecbd12948f();
        $acw62.useEffect(()=>{
            if (!i) return;
            let x = i(f);
            return ()=>{
                x();
            };
        }, []);
        let u = f.state ? e : o, g = a != null ? a : r;
        return $acw62.createElement("div", null, $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("button-portal", {
                show: f.state
            })
        }, $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("button-portal-popover", p)
        }, a !== !1 && $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("button-portal-popover-header", m)
        }, typeof g == "string" ? $acw62.createElement("h5", {
            className: "my-0 me-auto"
        }, g) : g, $acw62.createElement((0, $77pHI.default), {
            onClick: f.setFalse
        })), $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("button-portal-popover-body", c, {
                "button-portal-popover-body-scroll": l
            }),
            ref: s
        }))), $acw62.createElement("div", {
            className: "button-portal-backdrop",
            role: "button",
            onClick: f.setFalse
        }), $acw62.createElement($b5fecd57b45662f2$var$zo, {
            className: t,
            onClick: ()=>f.toggle(),
            options: {
                title: r,
                icon: u,
                ...d
            }
        }));
    }, $b5fecd57b45662f2$var$Hx = $b5fecd57b45662f2$var$n1;
});
var $b5fecd57b45662f2$var$Gx, $b5fecd57b45662f2$var$zx, $b5fecd57b45662f2$var$jx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$Ix();
    $b5fecd57b45662f2$var$Vx();
    $b5fecd57b45662f2$var$Ex();
    $b5fecd57b45662f2$var$Yx();
    $b5fecd57b45662f2$var$Gx = ({ data: t, className: e })=>$b5fecd57b45662f2$var$To(t) ? $acw62.createElement($b5fecd57b45662f2$var$Ox, {
            data: t,
            className: e
        }) : $b5fecd57b45662f2$var$wr(t) ? $acw62.createElement($b5fecd57b45662f2$var$Xx, {
            data: t,
            className: e
        }) : $b5fecd57b45662f2$var$Fr(t) ? $acw62.createElement($b5fecd57b45662f2$var$Wx, {
            data: t,
            className: e
        }) : $b5fecd57b45662f2$var$Pr(t) ? $acw62.createElement($b5fecd57b45662f2$var$Hx, {
            data: t,
            className: e
        }) : null, $b5fecd57b45662f2$var$zx = $b5fecd57b45662f2$var$Gx;
});
var $b5fecd57b45662f2$var$i1, $b5fecd57b45662f2$var$$x, $b5fecd57b45662f2$var$qx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$jx();
    $b5fecd57b45662f2$var$i1 = ({ data: t })=>{
        let e = Object.entries(t);
        return e.length ? $acw62.createElement("div", {
            className: "rounded-buttons-container"
        }, $acw62.createElement("div", {
            role: "group",
            className: "rounded-buttons-group"
        }, e.map(([o, r])=>$acw62.createElement($b5fecd57b45662f2$var$zx, {
                key: `btn-${o}`,
                className: `rounded-button--act-${o}`,
                data: r
            })))) : null;
    }, $b5fecd57b45662f2$var$$x = $b5fecd57b45662f2$var$i1;
});
var $b5fecd57b45662f2$var$p1, $b5fecd57b45662f2$var$m1, $b5fecd57b45662f2$var$Zx, $b5fecd57b45662f2$var$Jx = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$p1 = (t)=>typeof t == "string" ? t !== "" : typeof t == "number" ? t !== 0 : t !== null, $b5fecd57b45662f2$var$m1 = ({ name: t, variant: e })=>{
        var s;
        let o = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { counters: r } = $b5fecd57b45662f2$export$4b79bd8f34740571(o.MainNavigation), a = (s = r[t]) != null ? s : null;
        if (!$b5fecd57b45662f2$var$p1(a)) return null;
        let i = typeof e == "function" ? e(a) : e;
        return $acw62.createElement((0, $gmc0U.default), {
            bg: i != null ? i : void 0,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("float-end", e && `text-bg-${e}`)
        }, a);
    }, $b5fecd57b45662f2$var$Zx = $b5fecd57b45662f2$var$m1;
});
var $b5fecd57b45662f2$var$c1, $b5fecd57b45662f2$var$no, $b5fecd57b45662f2$var$zn = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Jx();
    $b5fecd57b45662f2$var$c1 = ({ data: t })=>$acw62.createElement($acw62.Fragment, null, Object.entries(t).map(([e, o])=>$acw62.createElement($b5fecd57b45662f2$var$Zx, {
                name: e,
                variant: o,
                key: `nav-counter-${e}`
            }))), $b5fecd57b45662f2$var$no = $b5fecd57b45662f2$var$c1;
});
var $b5fecd57b45662f2$var$f1, $b5fecd57b45662f2$var$tb, $b5fecd57b45662f2$var$eb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$zn();
    $b5fecd57b45662f2$var$f1 = ({ data: t })=>{
        let [e, o] = $acw62.useState(!1), r = (s, l)=>{
            if ($b5fecd57b45662f2$var$Ct(t)) {
                (l.source === "rootClose" || l.source === "select") && o(!1);
                return;
            }
            o(s);
        }, { registerNode: a } = (0, $dW8ts.default)(()=>{
            o(!0);
        }, {
            preventContextMenuOnLongPress: !0,
            preventLongPressOnMove: !0
        }), i = $b5fecd57b45662f2$var$Ct(t);
        return $acw62.createElement((0, $gzHIW.default), {
            show: e,
            onToggle: r
        }, $acw62.createElement((0, $gzHIW.default).Toggle, {
            as: (0, $lzNIT.NavLink),
            to: $b5fecd57b45662f2$var$Ct(t) ? t.url : "#",
            ref: a,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bottom-menu-item arrow-none", i && "bottom-menu-item-link")
        }, $b5fecd57b45662f2$var$De(t) && $acw62.createElement("i", {
            className: `mdi mdi-${t.icon}`
        }), $acw62.createElement("span", null, t.name, t.counters && $acw62.createElement($b5fecd57b45662f2$var$no, {
            data: t.counters
        }))), $acw62.createElement((0, $gzHIW.default).Menu, null, t.children.map((s, l)=>$acw62.createElement((0, $gzHIW.default).Item, {
                key: `item-${l}`,
                as: (0, $lzNIT.NavLink),
                to: $b5fecd57b45662f2$var$Ct(s) ? s.url : "#"
            }, s.name))));
    }, $b5fecd57b45662f2$var$tb = $b5fecd57b45662f2$var$f1;
});
var $b5fecd57b45662f2$var$y1, $b5fecd57b45662f2$var$ob, $b5fecd57b45662f2$var$rb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$zn();
    $b5fecd57b45662f2$var$y1 = ({ data: t, handleClick: e })=>{
        let o = $b5fecd57b45662f2$var$Ct(t);
        return $acw62.createElement((0, $lzNIT.NavLink), {
            to: $b5fecd57b45662f2$var$Ct(t) ? t.url : "#",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bottom-menu-item arrow-none", o && "bottom-menu-item-link"),
            onClick: e
        }, $b5fecd57b45662f2$var$De(t) && $acw62.createElement("i", {
            className: `mdi mdi-${t.icon}`
        }), $acw62.createElement("span", null, t.name, t.counters && $acw62.createElement($b5fecd57b45662f2$var$no, {
            data: t.counters
        })));
    }, $b5fecd57b45662f2$var$ob = $b5fecd57b45662f2$var$y1;
});
var $b5fecd57b45662f2$var$x1, $b5fecd57b45662f2$var$ab, $b5fecd57b45662f2$var$nb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$eb();
    $b5fecd57b45662f2$var$rb();
    $b5fecd57b45662f2$var$x1 = ({ data: t, handleClick: e })=>$b5fecd57b45662f2$var$Rr(t) ? $acw62.createElement($b5fecd57b45662f2$var$tb, {
            data: t,
            handleClick: e
        }) : $acw62.createElement($b5fecd57b45662f2$var$ob, {
            data: t,
            handleClick: e
        }), $b5fecd57b45662f2$var$ab = $b5fecd57b45662f2$var$x1;
});
var $b5fecd57b45662f2$var$b1, $b5fecd57b45662f2$var$sb, $b5fecd57b45662f2$var$lb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$kx();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$qx();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$nb();
    $b5fecd57b45662f2$var$b1 = ({ items: t })=>{
        let e = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { isOpen: o } = $b5fecd57b45662f2$export$4b79bd8f34740571(e.MainNavigation), r = $b5fecd57b45662f2$export$4b79bd8f34740571(e.GlobalButtons), a = ()=>{
            e.MainNavigation.toggle(!1);
        }, i = (l)=>{
            l.preventDefault(), l.stopPropagation(), e.MainNavigation.toggle();
        }, s = Object.keys(r).length;
        return $acw62.createElement($acw62.Fragment, null, !o && $acw62.createElement($b5fecd57b45662f2$var$$x, {
            data: r
        }), $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bottom-menu", !o && {
                "with-rounded-buttons": s > 0,
                "with-rounded-buttons-two": s > 1
            })
        }, t.map((l, p)=>$acw62.createElement($b5fecd57b45662f2$var$ab, {
                data: l,
                key: `item-${p}`,
                handleClick: a
            })), $acw62.createElement("a", {
            href: "#",
            className: "bottom-menu-item",
            onClick: i
        }, $acw62.createElement("i", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mdi", o ? "mdi-close" : "mdi-menu")
        }), $acw62.createElement("span", null, "\u041C\u0435\u043D\u044E"))));
    }, $b5fecd57b45662f2$var$sb = $b5fecd57b45662f2$var$b1;
});
var $b5fecd57b45662f2$var$S1, $b5fecd57b45662f2$var$C1, $b5fecd57b45662f2$var$mb, $b5fecd57b45662f2$var$cb, $b5fecd57b45662f2$var$ub = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ne();
    $b5fecd57b45662f2$var$Ee();
    $b5fecd57b45662f2$var$zn();
    $b5fecd57b45662f2$var$S1 = ({ item: t })=>{
        let e = $b5fecd57b45662f2$var$Ct(t), o = $acw62.useCallback((r)=>{
            e || (r.preventDefault(), r.stopPropagation());
        }, [
            e
        ]);
        return $acw62.createElement("li", {
            className: "side-nav-item"
        }, $acw62.createElement((0, $lzNIT.NavLink), {
            to: e ? t.url : "#",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("side-nav-link", e && "side-nav--has-link"),
            onClick: o
        }, $b5fecd57b45662f2$var$De(t) && $acw62.createElement("i", {
            className: `mdi mdi-${t.icon}`
        }), $acw62.createElement("span", null, t.name), t.counters && $acw62.createElement($b5fecd57b45662f2$var$no, {
            data: t.counters
        })));
    }, $b5fecd57b45662f2$var$C1 = ({ item: t, level: e })=>{
        let o = $b5fecd57b45662f2$export$c32275ecbd12948f(), r = $b5fecd57b45662f2$var$Ct(t), a = $acw62.useCallback((i)=>{
            r || (i.preventDefault(), i.stopPropagation()), o.toggle();
        }, [
            t
        ]);
        return $acw62.createElement("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("side-nav-item", {
                "menuitem-open": o.state
            })
        }, $acw62.createElement((0, $lzNIT.NavLink), {
            to: r ? t.url : "#",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("side-nav-link has-arrow", r && "side-nav--has-link", {
                collapsed: !o.state
            }),
            onClick: a
        }, $b5fecd57b45662f2$var$De(t) && $acw62.createElement("i", {
            className: `mdi mdi-${t.icon}`
        }), $acw62.createElement("span", null, t.name), t.counters && $acw62.createElement($b5fecd57b45662f2$var$no, {
            data: t.counters
        }), $acw62.createElement("span", {
            className: "menu-arrow"
        })), $acw62.createElement((0, $8qr9R.default), {
            in: o.state
        }, $acw62.createElement($b5fecd57b45662f2$var$mb, {
            items: t.children,
            level: e + 1
        })));
    }, $b5fecd57b45662f2$var$mb = $acw62.forwardRef(({ items: t, className: e = "", level: o = 1 }, r)=>$acw62.createElement("ul", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                "side-nav": o === 1,
                "side-nav-second-level": o === 2,
                "side-nav-third-level": o === 3,
                [e]: !!e
            }),
            ref: r
        }, t.map((a, i)=>$b5fecd57b45662f2$var$Rr(a) && a.children.length > 0 ? $acw62.createElement($b5fecd57b45662f2$var$C1, {
                item: a,
                level: o,
                key: `item-${i}`
            }) : $acw62.createElement($b5fecd57b45662f2$var$S1, {
                item: a,
                key: `item-${i}`
            })))), $b5fecd57b45662f2$var$cb = $b5fecd57b45662f2$var$mb;
});
var $b5fecd57b45662f2$var$db, $b5fecd57b45662f2$var$Kn, $b5fecd57b45662f2$var$Pl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$db = (t)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 310 57.26",
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M69.17 8.2v.92a5.91 5.91 0 0 0-2.88 1.14A10.24 10.24 0 0 0 63.81 14L51.32 42.59h-1l-13.42-29a15.29 15.29 0 0 0-1.45-2.73 4.63 4.63 0 0 0-1.62-1.2 7.88 7.88 0 0 0-2.61-.56v-.9h14.66v.92a7.06 7.06 0 0 0-3.23.79 1.78 1.78 0 0 0-.74 1.46 10.69 10.69 0 0 0 1.22 3.87L52.24 35l8.45-19.47a12.45 12.45 0 0 0 1.24-4 1.85 1.85 0 0 0-.76-1.38 5.21 5.21 0 0 0-2.59-.93l-.45-.07V8.2ZM81.22 30.57H67.35l-2.43 5.3A8 8 0 0 0 64 38.8a1.68 1.68 0 0 0 .78 1.35 7.18 7.18 0 0 0 3.37.76v.91H56.89v-.91a6.25 6.25 0 0 0 2.9-1 15 15 0 0 0 3-4.84L75.38 7.43h.92l12.47 28a12.57 12.57 0 0 0 2.73 4.38 5.85 5.85 0 0 0 3.42 1.13v.91H80.79v-.91a5.58 5.58 0 0 0 2.89-.67 1.72 1.72 0 0 0 .76-1.39 9.91 9.91 0 0 0-1.06-3.45Zm-.75-1.84L74.4 15.14l-6.23 13.59ZM30 12.4a17.7 17.7 0 0 0-5.35-3.62c0 .89.2 3.14.8 3.83Q29 16.86 29 25.48q0 8-3.29 11.66a10.68 10.68 0 0 1-8.34 3.69 9.49 9.49 0 0 1-7.6-3.37Q6 33 6.05 24.79c0-4.59.91-8.21 2.68-10.91a.52.52 0 0 1-.11-.1A1.77 1.77 0 0 1 8.1 13l-.38-.35-.35-.25c-.2-.06-.4-.1-.59-.17a4.41 4.41 0 0 1-.9-.43l-.07.05A16.54 16.54 0 0 0 0 24.89a17 17 0 0 0 17.46 17.7 17.1 17.1 0 0 0 12.46-5.06 17.06 17.06 0 0 0 5.15-12.72A16.6 16.6 0 0 0 30 12.4Z"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            transform: "matrix(1.09 0 0 1 98.79 41.82)",
            style: {
                fontSize: "50.33px",
                fontFamily: "TimesNewRomanPSMT,Times New Roman",
                letterSpacing: "-.02em"
            }
        }, "STUDIO"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M24.54 27.79a1.22 1.22 0 0 0-.1-.63l-.18-.71a.48.48 0 0 0 .15-.29.5.5 0 0 0-.23-.46.61.61 0 0 0-.14-.07c0-.07-.86-3.23-1.05-4.85a5.86 5.86 0 0 1 0-.93 4.73 4.73 0 0 0-.05-1.33 4.75 4.75 0 0 0-.38-.94 4.22 4.22 0 0 1-.43-1.2A2.87 2.87 0 0 0 22 16a1.57 1.57 0 0 1-.09-.6 2.51 2.51 0 0 1 .14-.52 2.77 2.77 0 0 0 .15-.49.67.67 0 0 0 .1-.44v-.05h-.1a2.51 2.51 0 0 0-.5-1.32 11.67 11.67 0 0 0-.84-.93c.09-.14.2-.29.28-.43a6.79 6.79 0 0 0 .71-1.8 8.66 8.66 0 0 0 .51-1.21c.12-.32.24-.63.29-.72l.05-.11h-.12a2 2 0 0 0-.68.12 2.5 2.5 0 0 0-.05-.29v-.1h-.06a4.51 4.51 0 0 0-2.62 1.45c0-.39-.46-.63-.92-.68a9.14 9.14 0 0 0-4.63 1.19c-.65.29-1.32.59-2 .82a21.29 21.29 0 0 1-2.92.68l-.54.1c-.43.08-.86.18-1.29.28a9.16 9.16 0 0 0-3.27 4.33 19.32 19.32 0 0 0-1.23 5.77 28.09 28.09 0 0 0-.08 7.27A20 20 0 0 0 2.94 31a21.59 21.59 0 0 1 4.56-4.35c1.4-1 2.55-1.31 3.52-1l.1.16A7.5 7.5 0 0 0 12.43 27c.18.15.35.29.5.43a.37.37 0 0 0-.07.45.89.89 0 0 0 .3.31 1.35 1.35 0 0 0 .52.27h.05a3.88 3.88 0 0 1 .84 1 .65.65 0 0 0 0 .13c-.09.41.3.75.67.91a2 2 0 0 0 .63.17H16l.16.07c.15.19.36.41.58.65a9.61 9.61 0 0 1 .9 1.05 2.42 2.42 0 0 1 .36 1.25 4.39 4.39 0 0 0 .8 2.07 2.24 2.24 0 0 0 1.39.65 1.35 1.35 0 0 0 .61-.09 2.92 2.92 0 0 0 2.74-1.06c.12-.14.34-.34.47-.47l.15-.14a.38.38 0 0 0 .12-.09.6.6 0 0 0 .09-.13 1.83 1.83 0 0 0 .25-.35 4 4 0 0 0 .38-1.72v-.29a16.34 16.34 0 0 0-.46-4.28Z"
        }));
    $b5fecd57b45662f2$var$db.defaultProps = {
        fill: "#fff"
    };
    $b5fecd57b45662f2$var$Kn = $b5fecd57b45662f2$var$db;
});
var $b5fecd57b45662f2$var$fb, $b5fecd57b45662f2$var$gb, $b5fecd57b45662f2$var$hb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$fb = (t)=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 35.07 35.48",
            ...t
        }, $acw62.createElement("path", {
            d: "M30,5.29a17.52,17.52,0,0,0-5.35-3.62c0,.88.2,3.14.8,3.83Q29,9.75,29,18.37q0,8-3.29,11.65a10.65,10.65,0,0,1-8.34,3.7,9.52,9.52,0,0,1-7.6-3.37Q6,25.91,6.05,17.67c0-4.59.91-8.21,2.68-10.9a1.09,1.09,0,0,1-.11-.1,1.82,1.82,0,0,1-.52-.8h0L7.72,5.5l-.35-.24c-.2-.06-.4-.11-.59-.18a4,4,0,0,1-.9-.43l-.07.06A16.52,16.52,0,0,0,0,17.77,17.05,17.05,0,0,0,17.46,35.48a17.14,17.14,0,0,0,12.46-5.06A17.06,17.06,0,0,0,35.07,17.7,16.58,16.58,0,0,0,30,5.29Z"
        }), $acw62.createElement("path", {
            d: "M24.54,20.68a1.18,1.18,0,0,0-.1-.63l0,0h0l-.18-.72a.46.46,0,0,0,.15-.29.5.5,0,0,0-.23-.46.59.59,0,0,0-.14-.06c0-.08-.86-3.23-1.05-4.85a5.86,5.86,0,0,1,0-.93,4.73,4.73,0,0,0-.05-1.33,4.83,4.83,0,0,0-.38-.95,4,4,0,0,1-.43-1.2A2.45,2.45,0,0,0,22,8.85a1.59,1.59,0,0,1-.09-.6,2.6,2.6,0,0,1,.14-.53,2.67,2.67,0,0,0,.15-.48.67.67,0,0,0,.1-.44v0h-.1a2.54,2.54,0,0,0-.5-1.33c-.16-.19-.71-.83-.84-.93.09-.14.2-.28.28-.42a6.93,6.93,0,0,0,.71-1.8h0a8.66,8.66,0,0,0,.51-1.21c.12-.33.24-.64.29-.73l.05-.1h-.12a2.7,2.7,0,0,0-.68.12c0-.09,0-.19-.05-.29V0h-.06a4.49,4.49,0,0,0-2.62,1.44c0-.38-.46-.63-.92-.67A9.13,9.13,0,0,0,13.62,2a21.45,21.45,0,0,1-2,.83,19.88,19.88,0,0,1-2.92.67l-.54.1c-.43.08-.86.18-1.29.29A9.18,9.18,0,0,0,3.6,8.16a19.32,19.32,0,0,0-1.23,5.78,28,28,0,0,0-.08,7.26,20.13,20.13,0,0,0,.65,2.68A21.59,21.59,0,0,1,7.5,19.54c1.4-1,2.55-1.32,3.52-1a1.3,1.3,0,0,0,.1.15,7.55,7.55,0,0,0,1.31,1.27c.18.15.35.29.5.43h0a.38.38,0,0,0-.07.46,1,1,0,0,0,.3.3,1.13,1.13,0,0,0,.52.27h.05a3.72,3.72,0,0,1,.84,1,.5.5,0,0,0,0,.13c-.09.41.3.74.67.91a2,2,0,0,0,.63.16.38.38,0,0,0,.15,0l.16.07c.15.19.36.42.58.65a9.63,9.63,0,0,1,.9,1.06A2.42,2.42,0,0,1,18,26.58a4.35,4.35,0,0,0,.8,2.06,2.14,2.14,0,0,0,1.39.65,1.23,1.23,0,0,0,.61-.09,2.89,2.89,0,0,0,2.74-1.05c.12-.14.34-.35.47-.47l.15-.15a.36.36,0,0,0,.12-.08.6.6,0,0,0,.09-.13,2.31,2.31,0,0,0,.25-.36A3.92,3.92,0,0,0,25,25.25c0-.1,0-.2,0-.29A16.25,16.25,0,0,0,24.54,20.68Z"
        }));
    $b5fecd57b45662f2$var$fb.defaultProps = {
        fill: "#fff"
    };
    $b5fecd57b45662f2$var$gb = $b5fecd57b45662f2$var$fb;
});
var $b5fecd57b45662f2$var$v1, $b5fecd57b45662f2$var$Jn, $b5fecd57b45662f2$var$Tl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Pl();
    $b5fecd57b45662f2$var$hb();
    $b5fecd57b45662f2$var$v1 = ({ isOpen: t, children: e })=>{
        let o = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { dashboardLink: r, logoComponent: a, logoComponentSmall: i } = $b5fecd57b45662f2$export$a9d1b6bbcaa78af1(), s = $acw62.useMemo(()=>a != null ? a : $b5fecd57b45662f2$var$Kn, []), l = $acw62.useMemo(()=>i != null ? i : $b5fecd57b45662f2$var$gb, []), p = $acw62.useCallback(()=>{
            o.MainNavigation.toggle(!1);
        }, []);
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("leftside-menu-backdrop", {
                open: t
            }),
            onClick: p
        }), $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("leftside-menu", {
                open: t
            })
        }, $acw62.createElement("div", {
            className: "h-100",
            id: "leftside-menu-container"
        }, $acw62.createElement((0, $lzNIT.Link), {
            to: r != null ? r : "/",
            className: "logo text-center logo-dark"
        }, $acw62.createElement("span", {
            className: "logo-lg"
        }, $acw62.createElement(s, {
            height: 40,
            fill: "var(--ct-link-color)"
        })), $acw62.createElement("span", {
            className: "logo-sm"
        }, $acw62.createElement(l, {
            height: 25,
            fill: "var(--ct-link-color)"
        }))), $acw62.createElement((0, $lzNIT.Link), {
            to: r != null ? r : "/",
            className: "logo text-center logo-light"
        }, $acw62.createElement("span", {
            className: "logo-lg"
        }, $acw62.createElement(s, {
            height: 40
        })), $acw62.createElement("span", {
            className: "logo-sm"
        }, $acw62.createElement(l, {
            height: 25
        }))), e, $acw62.createElement("div", {
            className: "clearfix"
        }))));
    }, $b5fecd57b45662f2$var$Jn = $b5fecd57b45662f2$var$v1;
});
var $b5fecd57b45662f2$var$R1, $b5fecd57b45662f2$var$k1, $b5fecd57b45662f2$export$e2255cf6045e8d47, $b5fecd57b45662f2$var$Nl = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$R1 = ({ name: t, style: e, className: o })=>{
        let r = $acw62.useMemo(()=>{
            var a;
            return (a = t == null ? void 0 : t.split(/\s+/).map((i)=>i.substring(0, 1)).slice(0, 2).join("").toUpperCase()) != null ? a : "??";
        }, [
            t
        ]);
        return $acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 100 100",
            height: "100",
            width: "100",
            className: o,
            style: e
        }, $acw62.createElement("circle", {
            cx: "50",
            cy: "50",
            r: "50",
            fill: "#ccc",
            style: {
                opacity: .5
            }
        }), $acw62.createElement("text", {
            x: "50%",
            y: "50%",
            dominantBaseline: "middle",
            textAnchor: "middle",
            fontSize: "40",
            fill: "#fff"
        }, r));
    }, $b5fecd57b45662f2$var$k1 = ({ name: t, avatarUrl: e, color: o, borderColor: r, className: a })=>{
        let i = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("avatar", e ? "avatar-image" : "avatar-fallback", a, {
            "avatar--bordered": !!r,
            "avatar--colored": !!o
        }), s = {
            "--avatar-color": o != null ? o : "",
            "--avatar-border-color": r != null ? r : ""
        };
        return e ? $acw62.createElement("img", {
            src: e,
            alt: t,
            className: i,
            style: s
        }) : $acw62.createElement($b5fecd57b45662f2$var$R1, {
            name: t,
            className: i,
            style: s
        });
    }, $b5fecd57b45662f2$export$e2255cf6045e8d47 = $b5fecd57b45662f2$var$k1;
});
var $b5fecd57b45662f2$var$F1, $b5fecd57b45662f2$var$bb, $b5fecd57b45662f2$var$Db = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Nl();
    $b5fecd57b45662f2$var$F1 = ()=>{
        let t = $b5fecd57b45662f2$export$c594d3118da9430d(), e = $b5fecd57b45662f2$export$4b79bd8f34740571(t), o = ()=>{
            t.logout();
        };
        return e ? $acw62.createElement("div", {
            className: "user-profile-container"
        }, $acw62.createElement((0, $gzHIW.default), {
            align: "end"
        }, $acw62.createElement((0, $gzHIW.default).Toggle, {
            as: "div",
            className: "user-profile arrow-none",
            role: "button"
        }, $acw62.createElement($b5fecd57b45662f2$export$e2255cf6045e8d47, {
            name: e.name,
            avatarUrl: e.avatar,
            className: "user-profile-avatar"
        }), $acw62.createElement("div", {
            className: "user-profile-name"
        }, e.name), $acw62.createElement("div", {
            className: "user-profile-position"
        }, e.position)), $acw62.createElement((0, $gzHIW.default).Menu, null, $acw62.createElement((0, $gzHIW.default).Item, {
            onClick: o
        }, $acw62.createElement("i", {
            className: "mdi mdi-logout-variant me-1"
        }), "\u0412\u0438\u0439\u0442\u0438")))) : null;
    }, $b5fecd57b45662f2$var$bb = $b5fecd57b45662f2$var$F1;
});
var $b5fecd57b45662f2$var$w1, $b5fecd57b45662f2$var$_l, $b5fecd57b45662f2$var$Sb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Tl();
    $b5fecd57b45662f2$var$ro();
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$w1 = ({ state: t })=>$acw62.createElement($b5fecd57b45662f2$var$Jn, {
            isOpen: !1
        }, $acw62.createElement($b5fecd57b45662f2$export$1d3945ea2d8839cb, null, t === "loading" ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null)) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement("i", {
            className: "mdi mdi-alert fs-1 text-danger"
        }), $acw62.createElement("div", {
            className: "font-18 text-danger"
        }, "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F")))), $b5fecd57b45662f2$var$_l = $b5fecd57b45662f2$var$w1;
});
var $b5fecd57b45662f2$var$T1, $b5fecd57b45662f2$var$Cb, $b5fecd57b45662f2$var$vb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ub();
    $b5fecd57b45662f2$var$Tl();
    $b5fecd57b45662f2$var$Db();
    $b5fecd57b45662f2$var$Sb();
    $b5fecd57b45662f2$var$T1 = ({ isOpen: t, data: e })=>$acw62.createElement($b5fecd57b45662f2$var$Jn, {
            isOpen: t
        }, $acw62.createElement((0, $82Jpc.default), {
            style: {
                height: "100%"
            },
            scrollbarMaxSize: 320
        }, $acw62.createElement($b5fecd57b45662f2$var$cb, {
            items: e
        })), $acw62.createElement($b5fecd57b45662f2$var$bb, null)), $b5fecd57b45662f2$var$Cb = $b5fecd57b45662f2$var$T1;
});
var $b5fecd57b45662f2$var$Ab, $b5fecd57b45662f2$var$M1, $b5fecd57b45662f2$var$Rb, $b5fecd57b45662f2$var$kb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$lb();
    $b5fecd57b45662f2$var$vb();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Ab = ({ state: t })=>$acw62.createElement($acw62.Fragment, null, $acw62.createElement($b5fecd57b45662f2$var$vl, {
            state: t
        }), $acw62.createElement($b5fecd57b45662f2$var$_l, {
            state: t
        })), $b5fecd57b45662f2$var$M1 = ()=>{
        let t = $b5fecd57b45662f2$export$846279b0d7f2d98d(), { data: e, isOpen: o } = $b5fecd57b45662f2$export$4b79bd8f34740571(t.MainNavigation);
        if (e === null) return $acw62.createElement($b5fecd57b45662f2$var$Ab, {
            state: "loading"
        });
        if (!e) return $acw62.createElement($b5fecd57b45662f2$var$Ab, {
            state: "error"
        });
        let r = e.slice(0, 3);
        return $acw62.createElement($acw62.Fragment, null, r && $acw62.createElement($b5fecd57b45662f2$var$sb, {
            items: r
        }), $acw62.createElement($b5fecd57b45662f2$var$Cb, {
            data: e,
            isOpen: o
        }));
    }, $b5fecd57b45662f2$var$Rb = $b5fecd57b45662f2$var$M1;
});
var $b5fecd57b45662f2$var$_1, $b5fecd57b45662f2$var$wb, $b5fecd57b45662f2$var$Pb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$_1 = ()=>{
        let t = $b5fecd57b45662f2$export$846279b0d7f2d98d(), e = (0, $aphAM.useLocation)();
        return $acw62.useEffect(()=>{
            t.MainNavigation.toggle(!1);
        }, [
            e
        ]), null;
    }, $b5fecd57b45662f2$var$wb = $b5fecd57b45662f2$var$_1;
});
var $b5fecd57b45662f2$var$Tb = {};
$b5fecd57b45662f2$var$Ie($b5fecd57b45662f2$var$Tb, {
    default: ()=>$b5fecd57b45662f2$var$I1
});
var $b5fecd57b45662f2$var$O1, $b5fecd57b45662f2$var$I1, $b5fecd57b45662f2$var$Mb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ax();
    $b5fecd57b45662f2$var$hl();
    $b5fecd57b45662f2$var$kb();
    $b5fecd57b45662f2$var$Pb();
    $b5fecd57b45662f2$var$O1 = ()=>$acw62.createElement("div", {
            className: "wrapper"
        }, $acw62.createElement($b5fecd57b45662f2$var$Rb, null), $acw62.createElement("div", {
            className: "content-page"
        }, $acw62.createElement("div", {
            className: "content"
        }, $acw62.createElement($b5fecd57b45662f2$var$vx, null), $acw62.createElement((0, $aphAM.Outlet), null)), $acw62.createElement($b5fecd57b45662f2$var$_n, null)), $acw62.createElement($b5fecd57b45662f2$var$wb, null)), $b5fecd57b45662f2$var$I1 = $b5fecd57b45662f2$var$O1;
});
var $b5fecd57b45662f2$var$L1, $b5fecd57b45662f2$export$a3de6efb5461e66f, $b5fecd57b45662f2$var$oa = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$L1 = ()=>$acw62.createElement("div", {
            id: "status"
        }, $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null)), $b5fecd57b45662f2$export$a3de6efb5461e66f = $b5fecd57b45662f2$var$L1;
});
var $b5fecd57b45662f2$var$V1, $b5fecd57b45662f2$var$Nb, $b5fecd57b45662f2$var$_b = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$fa();
    $b5fecd57b45662f2$var$V1 = ({ children: t })=>{
        let { state: e } = (0, $aphAM.useNavigation)();
        return $acw62.createElement($acw62.Fragment, null, e === "loading" && $acw62.createElement($b5fecd57b45662f2$export$da65322c66e325fa, null), t);
    }, $b5fecd57b45662f2$var$Nb = $b5fecd57b45662f2$var$V1;
});
var $b5fecd57b45662f2$var$H1, $b5fecd57b45662f2$var$Bb, $b5fecd57b45662f2$var$Ob = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$nr();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$H1 = ()=>{
        let { appName: t } = $b5fecd57b45662f2$export$a9d1b6bbcaa78af1(), e = $b5fecd57b45662f2$export$baf341815cf7915b(), o = (0, $acw62.useMemo)(()=>{
            var r;
            return (r = e.slice(-1)[0]) != null ? r : null;
        }, [
            e
        ]);
        return (0, $acw62.useEffect)(()=>{
            document.title = (o != null && o.title ? `${o.title} \u2022 ` : "") + t;
        }, [
            o == null ? void 0 : o.title
        ]), o ? $acw62.createElement("h4", {
            className: "page-title d-flex align-items-center gap-1"
        }, o.name, o.titleLinks.map((r, a)=>$acw62.createElement((0, $lzNIT.Link), {
                key: `title-link-${a}`,
                to: r.to,
                className: r.className
            }, r.text)), o.titleEnd && $acw62.createElement("div", {
            className: "ms-auto"
        }, o.titleEnd)) : null;
    }, $b5fecd57b45662f2$var$Bb = $b5fecd57b45662f2$var$H1;
});
var $b5fecd57b45662f2$var$z1, $b5fecd57b45662f2$var$Ib, $b5fecd57b45662f2$var$Lb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$On();
    $b5fecd57b45662f2$var$z1 = ()=>{
        let t = $b5fecd57b45662f2$export$8cefe241bd876ca0();
        return t ? $acw62.createElement("ol", {
            className: "breadcrumb m-0 d-none d-lg-flex ps-2"
        }, t.map((e, o)=>{
            let r = o === t.length - 1;
            return $acw62.createElement("li", {
                key: `breadcrumb-${o}`,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("breadcrumb-item", {
                    active: r
                })
            }, r ? e.text : $acw62.createElement((0, $lzNIT.Link), {
                to: e.to,
                className: e.className
            }, e.text));
        })) : null;
    }, $b5fecd57b45662f2$var$Ib = $b5fecd57b45662f2$var$z1;
});
var $b5fecd57b45662f2$var$j1, $b5fecd57b45662f2$var$Xb, $b5fecd57b45662f2$var$Vb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ob();
    $b5fecd57b45662f2$var$Lb();
    $b5fecd57b45662f2$var$j1 = ()=>$acw62.createElement("div", {
            className: "row"
        }, $acw62.createElement("div", {
            className: "col-12"
        }, $acw62.createElement("div", {
            className: "page-title-box"
        }, $acw62.createElement("div", {
            className: "page-title-right"
        }, $acw62.createElement($b5fecd57b45662f2$var$Ib, null)), $acw62.createElement($b5fecd57b45662f2$var$Bb, null)))), $b5fecd57b45662f2$var$Xb = $b5fecd57b45662f2$var$j1;
});
var $b5fecd57b45662f2$var$Ub = {};
$b5fecd57b45662f2$var$Ie($b5fecd57b45662f2$var$Ub, {
    default: ()=>$b5fecd57b45662f2$var$K1
});
var $b5fecd57b45662f2$var$q1, $b5fecd57b45662f2$var$K1, $b5fecd57b45662f2$var$Wb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$oa();
    $b5fecd57b45662f2$var$_b();
    $b5fecd57b45662f2$var$Vb();
    $b5fecd57b45662f2$var$q1 = ()=>$acw62.createElement("div", {
            className: "container-fluid"
        }, $acw62.createElement($acw62.Suspense, {
            fallback: $acw62.createElement($b5fecd57b45662f2$export$a3de6efb5461e66f, null)
        }, $acw62.createElement($b5fecd57b45662f2$var$Nb, null, $acw62.createElement($b5fecd57b45662f2$var$Xb, null), $acw62.createElement((0, $aphAM.Outlet), null)))), $b5fecd57b45662f2$var$K1 = $b5fecd57b45662f2$var$q1;
});
var $b5fecd57b45662f2$var$Hb = {};
$b5fecd57b45662f2$var$Ie($b5fecd57b45662f2$var$Hb, {
    default: ()=>$b5fecd57b45662f2$var$iF
});
var $b5fecd57b45662f2$var$nF, $b5fecd57b45662f2$var$iF, $b5fecd57b45662f2$var$Yb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$fl();
    $b5fecd57b45662f2$var$gl();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$Pl();
    $b5fecd57b45662f2$var$nF = ()=>{
        let { appName: t, logoComponent: e } = $b5fecd57b45662f2$export$a9d1b6bbcaa78af1();
        $acw62.useEffect(()=>{
            document.body.classList.add("authentication-bg");
            let r = document.title;
            return document.title = `\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0456\u044F \u2022 ${t}`, ()=>{
                document.body.classList.remove("authentication-bg"), document.title = r;
            };
        }, []);
        let o = $acw62.useMemo(()=>e != null ? e : $b5fecd57b45662f2$var$Kn, []);
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("div", {
            className: "account-pages pt-2 pt-sm-5 pb-4 pb-sm-5"
        }, $acw62.createElement((0, $6l6B5.default), null, $acw62.createElement((0, $h7C4J.default), {
            className: "justify-content-center"
        }, $acw62.createElement((0, $99eL8.default), {
            md: 8,
            lg: 6,
            xl: 5,
            xxl: 4
        }, $acw62.createElement((0, $aX99y.default), null, $acw62.createElement((0, $aX99y.default).Header, {
            className: "p-2 pt-3 text-center bg-primary"
        }, $acw62.createElement((0, $lzNIT.Link), {
            to: "/"
        }, $acw62.createElement(o, {
            height: "45px"
        }))), $acw62.createElement((0, $aX99y.default).Body, {
            className: "px-3 py-4 position-relative"
        }, $acw62.createElement((0, $aphAM.Outlet), null))))))), $acw62.createElement("footer", {
            className: "footer footer-alt"
        }, $acw62.createElement("div", null, $acw62.createElement($b5fecd57b45662f2$var$Mn, null), " \xb7 ", $acw62.createElement($b5fecd57b45662f2$var$Nn, null))));
    }, $b5fecd57b45662f2$var$iF = $b5fecd57b45662f2$var$nF;
});
var $b5fecd57b45662f2$var$sF, $b5fecd57b45662f2$var$Gb, $b5fecd57b45662f2$var$zb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ee();
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$sF = ()=>{
        let t = $b5fecd57b45662f2$export$c32275ecbd12948f(), e = $b5fecd57b45662f2$export$c594d3118da9430d();
        $acw62.useEffect(()=>{
            if (!t.state) return;
            let r = setTimeout(()=>t.toggle(!1), 3e3);
            return ()=>clearTimeout(r);
        }, [
            t.state
        ]);
        let o = $acw62.useCallback((r)=>e.authenticator.login(r), []);
        return $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Callback, {
            handleSubmit: o,
            showSuccess: !1
        }, $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Input, {
            name: "username",
            label: "\u0406\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
        }), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Input, {
            name: "password",
            type: t.state ? "text" : "password",
            label: "\u041F\u0430\u0440\u043E\u043B\u044C",
            append: $acw62.createElement("i", {
                className: `mdi mdi-${t.state ? "eye-off" : "eye"}`,
                role: "button",
                onClick: ()=>t.toggle()
            })
        }), $acw62.createElement("div", {
            className: "d-flex align-items-center"
        }, $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Check, {
            name: "no-remember",
            label: "\u0427\u0443\u0436\u0438\u0439 \u043A\u043E\u043C\u043F'\u044E\u0442\u0435\u0440"
        }), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Submit, {
            className: "ms-auto",
            enable: !0
        }, "\u0423\u0432\u0456\u0439\u0442\u0438")));
    }, $b5fecd57b45662f2$var$Gb = $b5fecd57b45662f2$var$sF;
});
var $b5fecd57b45662f2$var$pF, $b5fecd57b45662f2$var$jb, $b5fecd57b45662f2$var$$b = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$Ut();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$pF = ({ data: t })=>{
        let e = $b5fecd57b45662f2$export$c594d3118da9430d(), o = $acw62.useCallback((a)=>e.authenticator.loginSecondFactor(a), []), r = $acw62.useCallback(()=>e.authenticator.resendSecondFactor(), []);
        return $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Callback, {
            handleSubmit: o,
            showSuccess: !1
        }, $acw62.createElement("div", null, $acw62.createElement("div", null, t.info), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Input, {
            name: "code",
            size: "lg",
            className: "text-center",
            groupClass: ""
        }), $acw62.createElement((0, $6LAgE.default), {
            variant: "link",
            disabled: !t.allowResend,
            onClick: r,
            className: "px-0"
        }, "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u0449\u0435 \u0440\u0430\u0437")), $acw62.createElement("div", {
            className: "d-flex align-items-center mt-2"
        }, $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Check, {
            name: "remember",
            label: "\u0417\u0430\u043F\u0430\u043C'\u044F\u0442\u0430\u0442\u0438 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439"
        }), $acw62.createElement($b5fecd57b45662f2$export$a7fed597f4b8afd8.Submit, {
            className: "ms-auto",
            enable: !0
        }, "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438")));
    }, $b5fecd57b45662f2$var$jb = $b5fecd57b45662f2$var$pF;
});
var $b5fecd57b45662f2$var$mF, $b5fecd57b45662f2$export$bf0213d36508970c, $b5fecd57b45662f2$var$aa = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ro();
    $b5fecd57b45662f2$var$mF = ({ icon: t, text: e, color: o })=>$acw62.createElement($b5fecd57b45662f2$export$1d3945ea2d8839cb, {
            addClassName: o ? `text-${o}` : void 0
        }, $acw62.createElement("i", {
            className: `mdi mdi-${t} fs-2`
        }), $acw62.createElement("div", {
            className: "mt-1"
        }, e)), $b5fecd57b45662f2$export$bf0213d36508970c = $b5fecd57b45662f2$var$mF;
});
var $b5fecd57b45662f2$var$qb = {};
$b5fecd57b45662f2$var$Ie($b5fecd57b45662f2$var$qb, {
    default: ()=>$b5fecd57b45662f2$var$uF
});
var $b5fecd57b45662f2$var$cF, $b5fecd57b45662f2$var$uF, $b5fecd57b45662f2$var$Kb = $b5fecd57b45662f2$var$n(()=>{
    "use strict";
    $b5fecd57b45662f2$var$ro();
    $b5fecd57b45662f2$var$Tt();
    $b5fecd57b45662f2$var$zb();
    $b5fecd57b45662f2$var$$b();
    $b5fecd57b45662f2$var$_();
    $b5fecd57b45662f2$var$Ke();
    $b5fecd57b45662f2$var$aa();
    $b5fecd57b45662f2$var$b();
    $b5fecd57b45662f2$var$cF = ()=>{
        let t = $b5fecd57b45662f2$export$c594d3118da9430d(), e = $b5fecd57b45662f2$export$4b79bd8f34740571(t.authenticator);
        return $b5fecd57b45662f2$var$ct(e, "loading") ? $acw62.createElement($b5fecd57b45662f2$export$1d3945ea2d8839cb, null, $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null)) : $b5fecd57b45662f2$var$ct(e, "success") ? $acw62.createElement($b5fecd57b45662f2$export$bf0213d36508970c, {
            icon: "check-all",
            text: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D\u0456. \u0417\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F..."
        }) : $b5fecd57b45662f2$var$ct(e, "error") ? $acw62.createElement($b5fecd57b45662f2$export$bf0213d36508970c, {
            icon: "alert-circle-outline",
            text: e.error
        }) : $b5fecd57b45662f2$var$ct(e, "credentials") ? $acw62.createElement($b5fecd57b45662f2$var$Gb, null) : $b5fecd57b45662f2$var$ct(e, "second-factor") ? $acw62.createElement($b5fecd57b45662f2$var$jb, {
            data: e
        }) : null;
    }, $b5fecd57b45662f2$var$uF = $b5fecd57b45662f2$var$cF;
});
$b5fecd57b45662f2$var$pa();
var $b5fecd57b45662f2$var$Lt = class Lt {
    constructor(e){
        this._layoutUserSettings = {};
        this._layoutConfig = {
            ...Lt._layoutConfigDefaults,
            ...e
        }, this.loadUserSettings(), this.updateAttributes();
    }
    isAllowedByConfig(e, o) {
        return o ? this._layoutConfig[e].includes(o) : !1;
    }
    setUserSettings(e, o = !1) {
        let r = !o;
        for(let a in e){
            let i = a, s = e[i];
            this.isAllowedByConfig(i, s) || (console.warn(`Layout param '${i}' = '${s}' in not allowed in config`), delete e[i], r = !0);
        }
        this._layoutUserSettings = {
            ...this._layoutUserSettings,
            ...e
        }, o || this.updateAttributes(), r && this.writeUserSettings();
    }
    get(e) {
        var o;
        return (o = this._layoutUserSettings[e]) != null ? o : this._layoutConfig[e][0];
    }
    updateAttributes() {
        Object.entries(Lt._attributeMap).forEach(([e, o])=>{
            document.body.setAttribute(o, this.get(e));
        });
    }
    loadUserSettings() {
        let e = $b5fecd57b45662f2$export$b2521dd6e4e1a602("ova-admin-app:layout-settings");
        e && this.setUserSettings(e, !0);
    }
    writeUserSettings() {
        localStorage.setItem("ova-admin-app:layout-settings", JSON.stringify(this._layoutUserSettings));
    }
    clearUserSettings() {
        localStorage.removeItem("ova-admin-app:layout-settings");
    }
    static singleton(e) {
        return typeof Lt.instance > "u" ? Lt.instance = new Lt(e != null ? e : {}) : typeof e < "u" && console.warn("Layout is already configured"), Lt.instance;
    }
};
$b5fecd57b45662f2$var$Lt._attributeMap = {
    layoutColor: "data-layout-color",
    layoutMode: "data-layout-mode",
    leftbarTheme: "data-leftbar-theme",
    leftbarCompactMode: "data-leftbar-compact-mode"
}, $b5fecd57b45662f2$var$Lt._layoutConfigDefaults = {
    layoutColor: [
        "dark"
    ],
    layoutMode: [
        "fluid"
    ],
    leftbarTheme: [
        "dark"
    ],
    leftbarCompactMode: [
        "fixed"
    ]
};
var $b5fecd57b45662f2$var$ci = $b5fecd57b45662f2$var$Lt, $b5fecd57b45662f2$export$e034111dc0cfe9e7 = $b5fecd57b45662f2$var$ci;
function $b5fecd57b45662f2$var$lo(t, e) {
    return t.replace(/{([a-zA-Z0-9.\-_]+)}/gm, (o, r)=>{
        var a;
        return (a = (0, (/*@__PURE__*/$parcel$interopDefault($4mPkP))).pick(r, e)) != null ? a : "...";
    });
}
function $b5fecd57b45662f2$var$Ql(t, e) {
    return $b5fecd57b45662f2$var$lo(typeof t == "string" ? t : t(e), e);
}
function $b5fecd57b45662f2$var$xD(t, e, o) {
    let r = [];
    if (typeof t < "u") {
        let a = typeof t == "function" ? t(o) : t;
        r = (Array.isArray(a) ? a : [
            a
        ]).map((i)=>({
                ...i,
                to: $b5fecd57b45662f2$var$lo(i.to, o)
            }));
    }
    return e && r.push({
        to: e,
        className: "link-secondary font-18",
        text: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            className: "mdi mdi-help-circle"
        })
    }), r;
}
function $b5fecd57b45662f2$var$bD(t, e, o, r) {
    return t === !1 ? [] : typeof t > "u" ? [
        {
            to: o,
            text: e(r)
        }
    ] : (typeof t == "function" ? t(r) : [
        t
    ]).map((i)=>typeof i == "string" ? {
            to: o,
            text: $b5fecd57b45662f2$var$lo(i, r)
        } : i);
}
function $b5fecd57b45662f2$var$T({ name: t, title: e, titleLinks: o, docsLink: r, titleEnd: a, breadcrumb: i }, s = !1, l) {
    let p = (u)=>$b5fecd57b45662f2$var$Ql(t, u);
    return {
        name: p,
        title: e ? (u)=>$b5fecd57b45662f2$var$Ql(e, u) : p,
        breadcrumb: (u, g)=>s ? [] : $b5fecd57b45662f2$var$bD(i, p, g, u),
        titleLinks: (u)=>$b5fecd57b45662f2$var$xD(o, r, u),
        titleEnd: (u)=>typeof a == "function" ? a(u) : a,
        actionHandler: l
    };
}
function $b5fecd57b45662f2$var$Jo(t, e) {
    let o = $b5fecd57b45662f2$var$lo(t.endpoint, e);
    return t.paramName && (o += "/" + e[t.paramName]), t.subEndpoint && (o += "/" + t.subEndpoint), o;
}
function $b5fecd57b45662f2$var$vD(t) {
    return t.data !== void 0;
}
function $b5fecd57b45662f2$var$ep(t, { params: e, request: o }) {
    return $b5fecd57b45662f2$var$vD(t) ? Promise.resolve(t.data) : new Promise(async (r, a)=>{
        let i = $b5fecd57b45662f2$var$Jo({
            endpoint: t.endpoint,
            paramName: t.paramName,
            subEndpoint: t.subEndpoint
        }, e), s = {
            ...t.params
        };
        t.queryString && (s = {
            ...s,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))).parse(new URL(o.url).searchParams.toString())
        }), Object.keys(s).length > 0 && (i += "?" + (0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))).stringify(s));
        try {
            let l = await (0, $ket0H.default).get(i);
            r(t.asResponse ? l : l.data);
        } catch (l) {
            a(l);
        }
    });
}
function $b5fecd57b45662f2$var$ui(t) {
    return async (e)=>{
        let o = {}, r = !1;
        if (t.sync) for(let a in t.sync)o[a] = await $b5fecd57b45662f2$var$ep(t.sync[a], e);
        if (t.defer) for(let a in t.defer){
            let i = t.defer[a];
            i.condition && !i.condition(o) || (r = !0, o[a] = $b5fecd57b45662f2$var$ep(i, e));
        }
        return r ? (0, $2vsP7.defer)(o) : (0, $2vsP7.json)(o);
    };
}
function $b5fecd57b45662f2$export$ca123a7df6e7eaf7(t) {
    return typeof t == "function" ? t : $b5fecd57b45662f2$var$ui(t);
}
function $b5fecd57b45662f2$var$L(t) {
    if (!(typeof t > "u")) return $b5fecd57b45662f2$export$ca123a7df6e7eaf7(t);
}
function $b5fecd57b45662f2$var$di(t) {
    return async (e, o)=>{
        let r = await (0, $ket0H.default)[t.method]($b5fecd57b45662f2$var$Jo({
            endpoint: t.endpoint,
            paramName: t.paramName,
            subEndpoint: t.subEndpoint
        }, o), e);
        if (r.status < 200 || r.status >= 300) throw new Error(r.statusText);
        return r.data;
    };
}
function $b5fecd57b45662f2$var$fi(t) {
    return typeof t == "function" ? t : $b5fecd57b45662f2$var$di(t);
}
function $b5fecd57b45662f2$var$wt(t) {
    if (!(typeof t > "u")) return $b5fecd57b45662f2$var$fi(t);
}
function $b5fecd57b45662f2$export$540eaef543e5a49a(t) {
    let { name: e, title: o, titleLinks: r, docsLink: a, titleEnd: i, breadcrumb: s, loader: l, element: p, action: m, ...c } = t;
    return {
        ...c,
        loader: $b5fecd57b45662f2$var$L(l),
        handle: $b5fecd57b45662f2$var$T({
            name: e,
            title: o,
            titleLinks: r,
            docsLink: a,
            titleEnd: i,
            breadcrumb: s
        }, !1, $b5fecd57b45662f2$var$wt(m)),
        element: p
    };
}
function $b5fecd57b45662f2$var$op(t) {
    return typeof t < "u" && t.hasOwnProperty("type") && t.type === "simple";
}
function $b5fecd57b45662f2$var$rp(t) {
    return typeof t < "u" && t.hasOwnProperty("type") && t.type === "extend";
}
function $b5fecd57b45662f2$var$po(t) {
    return typeof t < "u" && t.hasOwnProperty("type") && t.type === "related-modal";
}
function $b5fecd57b45662f2$var$ap(t) {
    return typeof t < "u" && t.hasOwnProperty("forms") && typeof t.forms < "u";
}
function $b5fecd57b45662f2$var$np(t) {
    return typeof t < "u" && t.hasOwnProperty("create") && typeof t.create < "u";
}
function $b5fecd57b45662f2$var$ip(t) {
    return typeof t < "u" && t.hasOwnProperty("update") && typeof t.update < "u";
}
function $b5fecd57b45662f2$var$sp(t) {
    return typeof t < "u" && t.hasOwnProperty("createName") && typeof t.createName == "string" && t.hasOwnProperty("updateName") && typeof t.updateName == "string";
}
function $b5fecd57b45662f2$var$gi(t) {
    return typeof t < "u" && t.hasOwnProperty("initialData") && typeof t.initialData < "u";
}
$b5fecd57b45662f2$var$Lr();
function $b5fecd57b45662f2$var$rl(t, e) {
    let o = (()=>{
        if (t.wrapper) {
            let r = t.wrapper;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(r, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$aeedc005af528695, {
                renderConfig: t.renderConfig
            }));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$aeedc005af528695, {
            renderConfig: t.renderConfig
        });
    })();
    return {
        index: !0,
        handle: $b5fecd57b45662f2$var$T({
            ...t,
            breadcrumb: !1
        }, e.isModal),
        loader: $b5fecd57b45662f2$var$L({
            sync: {
                data: {
                    endpoint: e.baseEndpoint,
                    queryString: !0
                }
            }
        }),
        element: o
    };
}
$b5fecd57b45662f2$var$ue();
var $b5fecd57b45662f2$var$AR = ({ closeNavigatePath: t, children: e })=>{
    let o = (0, $aphAM.useMatches)(), r = (0, $aphAM.useNavigate)(), a = ()=>{
        r(t);
    }, i = (0, $acw62.useMemo)(()=>{
        let l = o.pop();
        if (!l) return;
        let p = l.handle;
        return {
            title: p.title(l.data),
            titleLinks: p.titleLinks(l.data),
            titleEnd: p.titleEnd(l.data)
        };
    }, [
        o
    ]), s = $b5fecd57b45662f2$export$33ffd74ebf07f060({
        initialState: !0,
        onClose: a
    });
    return i ? $acw62.createElement((0, $gBH4L.default), {
        show: s.state,
        onHide: s.close,
        size: "lg",
        centered: !0
    }, $acw62.createElement((0, $gBH4L.default).Header, {
        className: "py-0",
        closeButton: !0
    }, $acw62.createElement((0, $gBH4L.default).Title, null, i.title, i.titleLinks.map((l, p)=>$acw62.createElement((0, $lzNIT.Link), {
            key: `title-link-${p}`,
            to: l.to,
            className: l.className
        }, l.text))), i.titleEnd && $acw62.createElement("div", {
        className: "ms-auto"
    }, i.titleEnd)), e) : null;
}, $b5fecd57b45662f2$var$Yy = $b5fecd57b45662f2$var$AR;
function $b5fecd57b45662f2$var$Je(t, e, o) {
    return e ? $acw62.createElement($b5fecd57b45662f2$var$Yy, {
        closeNavigatePath: o
    }, t) : $acw62.createElement($acw62.Fragment, null, t);
}
function $b5fecd57b45662f2$var$jy(t) {
    let [e, o] = t.split("?"), r = (o == null ? void 0 : o.length) > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))).parse(o) : {};
    return {
        url: e,
        params: r
    };
}
function $b5fecd57b45662f2$var$Gy(t) {
    let { url: e, params: o } = $b5fecd57b45662f2$var$jy(typeof t == "string" ? t : t.endpoint);
    return {
        condition: typeof t != "string" ? t.condition : void 0,
        endpoint: e,
        queryString: typeof t == "string" ? void 0 : t.queryString,
        params: {
            type: "helper",
            ...o
        }
    };
}
function $b5fecd57b45662f2$var$zy(t, e) {
    let { url: o, params: r } = $b5fecd57b45662f2$var$jy(typeof e == "string" ? e : e.endpoint);
    return {
        endpoint: t,
        paramName: "id",
        subEndpoint: o,
        condition: typeof e != "string" ? e.condition : void 0,
        queryString: typeof e == "string" ? void 0 : e.queryString,
        params: {
            type: "helper",
            ...r
        }
    };
}
function $b5fecd57b45662f2$var$Qe(t, e) {
    let o = {}, r = {};
    if (e.initialData ? o.data = {
        data: e.initialData
    } : e.dataType && (o.data = {
        endpoint: e.baseEndpoint,
        paramName: e.paramName,
        params: {
            type: e.dataType
        }
    }), t.helpers) for (let [a, i] of Object.entries(t.helpers)){
        if (typeof i != "string" && i.isSync) {
            o[a] = $b5fecd57b45662f2$var$Gy(i);
            continue;
        }
        r[a] = $b5fecd57b45662f2$var$Gy(i);
    }
    if (t.relations) for (let [a, i] of Object.entries(t.relations)){
        if (typeof i != "string" && i.isSync) {
            o[a] = $b5fecd57b45662f2$var$zy(e.baseEndpoint, i);
            continue;
        }
        r[a] = $b5fecd57b45662f2$var$zy(e.baseEndpoint, i);
    }
    return {
        sync: Object.keys(o).length > 0 ? o : void 0,
        defer: Object.keys(r).length > 0 ? r : void 0
    };
}
function $b5fecd57b45662f2$var$nl(t, e) {
    return {
        path: `:${e.paramName}`,
        handle: $b5fecd57b45662f2$var$T(t, e.isModal),
        loader: $b5fecd57b45662f2$var$L($b5fecd57b45662f2$var$Qe({
            helpers: t.helpers,
            relations: t.relations
        }, {
            baseEndpoint: e.baseEndpoint,
            paramName: e.paramName,
            dataType: "show"
        })),
        shouldRevalidate: (o)=>t.shouldRevalidate === "disable-on-stalled-params" ? o.currentParams[e.paramName] !== o.nextParams[e.paramName] : typeof t.shouldRevalidate == "function" ? t.shouldRevalidate(o) : o.defaultShouldRevalidate,
        element: $b5fecd57b45662f2$var$Je(t.element, e.isModal, "../../"),
        children: t.children
    };
}
function $b5fecd57b45662f2$var$Fn(t, e) {
    return {
        path: "create",
        handle: $b5fecd57b45662f2$var$T(t, e.isModal, $b5fecd57b45662f2$var$wt({
            endpoint: e.baseEndpoint,
            method: "create"
        })),
        loader: $b5fecd57b45662f2$var$L($b5fecd57b45662f2$var$Qe({
            helpers: t.helpers,
            relations: t.relations
        }, {
            baseEndpoint: e.baseEndpoint,
            paramName: e.paramName,
            initialData: e.initialData
        })),
        element: $b5fecd57b45662f2$var$Je(t.element, e.isModal, "../")
    };
}
function $b5fecd57b45662f2$var$wn(t, e) {
    return {
        path: `:${e.paramName}/edit`,
        handle: $b5fecd57b45662f2$var$T(t, e.isModal, $b5fecd57b45662f2$var$wt({
            endpoint: e.baseEndpoint,
            paramName: e.paramName,
            method: "update"
        })),
        loader: $b5fecd57b45662f2$var$L($b5fecd57b45662f2$var$Qe({
            helpers: t.helpers,
            relations: t.relations
        }, {
            baseEndpoint: e.baseEndpoint,
            paramName: e.paramName,
            dataType: "edit"
        })),
        element: $b5fecd57b45662f2$var$Je(t.element, e.isModal, "../../")
    };
}
function $b5fecd57b45662f2$var$il(t) {
    return {
        index: !0,
        handle: $b5fecd57b45662f2$var$T({
            ...t,
            breadcrumb: !1
        }),
        loader: $b5fecd57b45662f2$var$L(t.loader),
        element: t.element
    };
}
function $b5fecd57b45662f2$var$sl(t) {
    return {
        path: ":id",
        handle: $b5fecd57b45662f2$var$T(t),
        loader: $b5fecd57b45662f2$var$L(t.loader),
        element: t.element,
        children: t.children
    };
}
function $b5fecd57b45662f2$var$Pn(t) {
    return {
        path: "create",
        handle: $b5fecd57b45662f2$var$T(t, !1, $b5fecd57b45662f2$var$wt(t.action)),
        loader: $b5fecd57b45662f2$var$L(t.loader),
        element: t.element
    };
}
function $b5fecd57b45662f2$var$Tn(t) {
    return {
        path: ":id/edit",
        handle: $b5fecd57b45662f2$var$T(t, !1, $b5fecd57b45662f2$var$wt(t.action)),
        loader: $b5fecd57b45662f2$var$L(t.loader),
        element: t.element
    };
}
function $b5fecd57b45662f2$var$Oo(t, e) {
    return $b5fecd57b45662f2$var$sp(t) ? {
        name: e === "create" ? t.createName : t.updateName
    } : e === "create" ? t.create : t.update;
}
function $b5fecd57b45662f2$var$ll(t) {
    var a;
    let e = [], o = $b5fecd57b45662f2$var$op(t) || $b5fecd57b45662f2$var$po(t);
    if (!o && !$b5fecd57b45662f2$var$rp(t)) return [];
    let r = {
        baseEndpoint: t.baseEndpoint,
        isModal: $b5fecd57b45662f2$var$po(t),
        paramName: (a = t.paramName) != null ? a : "id"
    };
    return !$b5fecd57b45662f2$var$po(t) && t.index && (o ? e.push($b5fecd57b45662f2$var$rl(t.index, r)) : e.push($b5fecd57b45662f2$var$il(t.index))), t.show && (o ? e.push($b5fecd57b45662f2$var$nl(t.show, r)) : e.push($b5fecd57b45662f2$var$sl(t.show))), $b5fecd57b45662f2$var$ap(t) ? o ? (e.push($b5fecd57b45662f2$var$Fn({
        ...t.forms,
        ...$b5fecd57b45662f2$var$Oo(t.forms, "create")
    }, {
        ...r,
        initialData: $b5fecd57b45662f2$var$gi(t.forms) ? t.forms.initialData : void 0
    })), e.push($b5fecd57b45662f2$var$wn({
        ...t.forms,
        ...$b5fecd57b45662f2$var$Oo(t.forms, "update")
    }, r))) : (e.push($b5fecd57b45662f2$var$Pn({
        ...t.forms,
        ...$b5fecd57b45662f2$var$Oo(t.forms, "create")
    })), e.push($b5fecd57b45662f2$var$Tn({
        ...t.forms,
        ...$b5fecd57b45662f2$var$Oo(t.forms, "update")
    }))) : ($b5fecd57b45662f2$var$np(t) && (o ? e.push($b5fecd57b45662f2$var$Fn(t.create, {
        ...r,
        initialData: $b5fecd57b45662f2$var$gi(t.create) ? t.create.initialData : void 0
    })) : e.push($b5fecd57b45662f2$var$Pn(t.create))), $b5fecd57b45662f2$var$ip(t) && (o ? e.push($b5fecd57b45662f2$var$wn(t.update, r)) : e.push($b5fecd57b45662f2$var$Tn(t.update)))), e;
}
function $b5fecd57b45662f2$export$a39f5bc07fd1b226(t) {
    var e, o;
    return {
        path: t.basePath,
        element: (e = t.baseElement) != null ? e : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aphAM.Outlet), null),
        handle: $b5fecd57b45662f2$var$T(t, $b5fecd57b45662f2$var$po(t)),
        children: [
            ...$b5fecd57b45662f2$var$ll(t),
            ...(o = t.children) != null ? o : []
        ]
    };
}
$b5fecd57b45662f2$var$Lr();
function $b5fecd57b45662f2$export$837f9adc55b95f23(t) {
    let { name: e, title: o, titleLinks: r, docsLink: a, titleEnd: i, breadcrumb: s, loader: l, ...p } = t, m = (()=>{
        if (t.wrapper) {
            let c = t.wrapper;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(c, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$aeedc005af528695, {
                renderConfig: t.renderConfig
            }));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5fecd57b45662f2$export$aeedc005af528695, {
            renderConfig: t.renderConfig
        });
    })();
    return {
        ...p,
        loader: $b5fecd57b45662f2$var$L(l),
        handle: $b5fecd57b45662f2$var$T({
            name: e,
            title: o,
            titleLinks: r,
            docsLink: a,
            titleEnd: i,
            breadcrumb: s
        }),
        element: m
    };
}
$b5fecd57b45662f2$var$tt();
var $b5fecd57b45662f2$export$188ffe2069709b9f = ((o)=>(o.Prepend = "prepend", o.Append = "append", o))($b5fecd57b45662f2$export$188ffe2069709b9f || {}), $b5fecd57b45662f2$export$8d2e4efc6def37b0 = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
    constructor(e, o){
        super(), this._options = o, this._data = e;
    }
    updateInitialData(e) {
        this._updateData(e);
    }
    _updateData(e) {
        this._data = e, this._options.filterFunction && (this._data = this._data.filter(this._options.filterFunction)), this._options.sortFunction && (this._data = this._data.toSorted(this._options.sortFunction)), this._callListeners();
    }
    get _keyName() {
        return this._options.keyName;
    }
    _resolveKey(e) {
        return typeof e == "string" ? e : e[this._keyName];
    }
    _resolveAddMode(e) {
        var o;
        return (o = e != null ? e : this._options.addMode) != null ? o : "append";
    }
    hasItem(e) {
        let o = this._resolveKey(e);
        return this._data.some((r)=>r[this._keyName] === o);
    }
    addItem(e, o) {
        switch(this._resolveAddMode(o)){
            case "prepend":
                this._updateData([
                    e,
                    ...this._data
                ]);
                break;
            case "append":
                this._updateData([
                    ...this._data,
                    e
                ]);
                break;
        }
    }
    updateItemData(e) {
        let o = e[this._keyName];
        if (o === void 0) throw new Error(`Key ${this._keyName} not found in data`);
        this._updateData(this._data.map((r)=>r[this._keyName] === o ? {
                ...r,
                ...e
            } : r));
    }
    removeItem(e) {
        let o = this._resolveKey(e);
        this._updateData(this._data.filter((r)=>r[this._keyName] !== o));
    }
    updateOrAddItem(e, o) {
        let r = e[this._keyName];
        if (r === void 0) throw new Error(`Key ${this._keyName} not found in data`);
        this.hasItem(r) ? this.updateItemData(e) : this.addItem(e, o);
    }
    addItems(e, o) {
        switch(this._resolveAddMode(o)){
            case "prepend":
                this._updateData([
                    ...e,
                    ...this._data
                ]);
                break;
            case "append":
                this._updateData([
                    ...this._data,
                    ...e
                ]);
                break;
        }
    }
    getData() {
        return this._data;
    }
};
$b5fecd57b45662f2$var$_();
var $b5fecd57b45662f2$var$NR = (t, e)=>{
    let o = (0, $acw62.useRef)(t), r = (0, $acw62.useMemo)(()=>new $b5fecd57b45662f2$export$8d2e4efc6def37b0(t, e), []), a = $b5fecd57b45662f2$export$4b79bd8f34740571(r);
    return (0, $acw62.useEffect)(()=>{
        (0, $f1q41.isEqual)(o.current, t) || (r.updateInitialData(t), o.current = t);
    }, [
        t
    ]), {
        store: r,
        data: a
    };
}, $b5fecd57b45662f2$export$50d0da76846bc564 = $b5fecd57b45662f2$var$NR;
$b5fecd57b45662f2$var$tt();
var $b5fecd57b45662f2$var$qy = (t)=>t instanceof Promise && t._tracked === !0, $b5fecd57b45662f2$var$jr = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
    constructor(o){
        super();
        this._state = "pending";
        this._promise = o, this._init();
    }
    _init() {
        $b5fecd57b45662f2$var$qy(this._promise) && this._processTrackedPromise(), this._state === "pending" && (Object.hasOwn(this._promise, "_tracked") || Object.defineProperty(this._promise, "_tracked", {
            get: ()=>!0
        }), this._promise.then((o)=>{
            this._result = o, this._state = "resolved", Object.hasOwn(this._promise, "_data") || Object.defineProperty(this._promise, "_data", {
                get: ()=>o
            });
        }, (o)=>{
            this._error = o, this._state = "rejected", Object.hasOwn(this._promise, "_error") || Object.defineProperty(this._promise, "_error", {
                get: ()=>o
            });
        }));
    }
    _processTrackedPromise() {
        if (!$b5fecd57b45662f2$var$qy(this._promise)) throw new Error("Promise is not a tracked promise");
        if (this._promise._data) {
            this._result = this._promise._data, this._state = "resolved";
            return;
        }
        if (this._promise._error) {
            this._error = this._promise._error, this._state = "rejected";
            return;
        }
    }
    get state() {
        return this._state;
    }
    get result() {
        if (this._state === "pending") throw this._promise;
        if (this._state === "rejected") throw this._error;
        if (this._result === void 0) throw new Error("Result is undefined");
        return this._result;
    }
    getData() {
        return this.result;
    }
};
$b5fecd57b45662f2$var$_();
var $b5fecd57b45662f2$var$BR = (t, e)=>{
    let o = (0, $acw62.useMemo)(()=>new $b5fecd57b45662f2$var$jr(t), e);
    return $b5fecd57b45662f2$export$4b79bd8f34740571(o);
}, $b5fecd57b45662f2$var$Ky = $b5fecd57b45662f2$var$BR;
var $b5fecd57b45662f2$var$IR = (t)=>{
    let { [t]: e } = (0, $aphAM.useLoaderData)();
    return e instanceof Promise ? $b5fecd57b45662f2$var$Ky(e, [
        t
    ]) : e;
}, $b5fecd57b45662f2$var$ke = $b5fecd57b45662f2$var$IR;
var $b5fecd57b45662f2$var$LR = (t, e)=>{
    let o = $b5fecd57b45662f2$var$ke(t);
    return $b5fecd57b45662f2$export$50d0da76846bc564(o, e);
}, $b5fecd57b45662f2$export$60d66ce3f3481b8c = $b5fecd57b45662f2$var$LR;
$b5fecd57b45662f2$var$b();
var $b5fecd57b45662f2$var$to = class {
    constructor(e){
        this._onDestroy = [];
        this._ws = e;
    }
    _initListener(e, o, r) {
        this._onDestroy.push(this._ws.listen(e, o, r));
    }
    destroy() {
        this._onDestroy.forEach((e)=>e());
    }
};
var $b5fecd57b45662f2$export$4f3bc3f0d9ac9da2 = ((a)=>(a.Create = "create", a.Update = "update", a.UpdateOrCreate = "updateOrCreate", a.Delete = "delete", a))($b5fecd57b45662f2$export$4f3bc3f0d9ac9da2 || {}), $b5fecd57b45662f2$export$69fc87e246faddc4 = class extends $b5fecd57b45662f2$var$to {
    constructor(e, o, r){
        super(e), this._store = o, this._options = r;
    }
    _handleAction(e, o) {
        switch(e){
            case "create":
                this._store.updateOrAddItem(o);
                break;
            case "update":
                this._store.updateItemData(o);
                break;
            case "updateOrCreate":
                this._store.updateOrAddItem(o);
                break;
            case "delete":
                this._store.removeItem(o);
                break;
            default:
                throw new Error(`Unknown action: ${e}`);
        }
    }
    init() {
        for (let [e, o] of Object.entries(this._options.actionsMap))this._initListener(this._options.channelName, e, (r)=>{
            this._handleAction(o, r);
        });
    }
};
var $b5fecd57b45662f2$var$UR = (t, e)=>{
    let { store: o, data: r } = $b5fecd57b45662f2$export$50d0da76846bc564(t, e), a = $b5fecd57b45662f2$export$101fe40f41b35148();
    return (0, $acw62.useEffect)(()=>{
        let i = new $b5fecd57b45662f2$export$69fc87e246faddc4(a, o, e);
        return i.init(), ()=>{
            i.destroy();
        };
    }, []), {
        store: o,
        data: r
    };
}, $b5fecd57b45662f2$export$8fa67717b2c61f2b = $b5fecd57b45662f2$var$UR;
var $b5fecd57b45662f2$var$WR = (t, e)=>{
    let o = $b5fecd57b45662f2$var$ke(t);
    return $b5fecd57b45662f2$export$8fa67717b2c61f2b(o, e);
}, $b5fecd57b45662f2$export$93054adfd8a2556b = $b5fecd57b45662f2$var$WR;
$b5fecd57b45662f2$var$tt();
var $b5fecd57b45662f2$export$d5b26c534972db31 = class extends $b5fecd57b45662f2$export$8c2572089a81a391 {
    constructor(e){
        super(), this._data = e;
    }
    _updateData(e) {
        this._data = e, this._callListeners();
    }
    updateData(e) {
        this._updateData({
            ...this._data,
            ...e
        });
    }
    updateInitialData(e) {
        this._data = e, this._callListeners();
    }
    getData() {
        return this._data;
    }
};
$b5fecd57b45662f2$var$_();
var $b5fecd57b45662f2$var$jR = (t)=>{
    let e = (0, $acw62.useRef)(t), o = (0, $acw62.useMemo)(()=>new $b5fecd57b45662f2$export$d5b26c534972db31(t), []), r = $b5fecd57b45662f2$export$4b79bd8f34740571(o);
    return (0, $acw62.useEffect)(()=>{
        (0, $f1q41.isEqual)(e.current, t) || (o.updateInitialData(t), e.current = t);
    }, [
        t
    ]), {
        store: o,
        data: r
    };
}, $b5fecd57b45662f2$export$9d79fedc7454e296 = $b5fecd57b45662f2$var$jR;
var $b5fecd57b45662f2$var$$R = (t)=>{
    let e = $b5fecd57b45662f2$var$ke(t);
    return $b5fecd57b45662f2$export$9d79fedc7454e296(e);
}, $b5fecd57b45662f2$export$67cf3bf0b7731d1e = $b5fecd57b45662f2$var$$R;
var $b5fecd57b45662f2$export$c183ce8879171077 = class extends $b5fecd57b45662f2$var$to {
    constructor(e, o, r){
        super(e), this._store = o, this._options = r;
    }
    get _channelName() {
        let e = this._store.getData();
        return typeof this._options.channelName == "function" ? this._options.channelName(e) : this._options.channelName;
    }
    init() {
        this._initListener(this._channelName, this._options.events, (e)=>{
            this._store.updateData(e);
        });
    }
};
$b5fecd57b45662f2$var$b();
var $b5fecd57b45662f2$var$ZR = (t, e)=>{
    let { store: o, data: r } = $b5fecd57b45662f2$export$9d79fedc7454e296(t), a = $b5fecd57b45662f2$export$101fe40f41b35148();
    return (0, $acw62.useEffect)(()=>{
        let i = new $b5fecd57b45662f2$export$c183ce8879171077(a, o, e);
        return i.init(), ()=>{
            i.destroy();
        };
    }, []), {
        store: o,
        data: r
    };
}, $b5fecd57b45662f2$export$78164e18a21ee8f2 = $b5fecd57b45662f2$var$ZR;
var $b5fecd57b45662f2$var$JR = (t, e)=>{
    let o = $b5fecd57b45662f2$var$ke(t);
    return $b5fecd57b45662f2$export$78164e18a21ee8f2(o, e);
}, $b5fecd57b45662f2$export$53c8d58a7d4bae3a = $b5fecd57b45662f2$var$JR;
$b5fecd57b45662f2$var$Ke();
$b5fecd57b45662f2$var$tt();
$b5fecd57b45662f2$var$Ke();
$b5fecd57b45662f2$var$qs();
$b5fecd57b45662f2$var$hl();
var $b5fecd57b45662f2$var$nk = ({ image: t, title: e, message: o, btnLink: r, btnText: a })=>$acw62.createElement((0, $6l6B5.default), {
        className: "vh-100 d-flex align-items-center justify-content-center"
    }, $acw62.createElement("div", {
        className: "text-center"
    }, !!t && $acw62.createElement("img", {
        src: t,
        style: {
            maxHeight: "50vh"
        },
        alt: ""
    }), $acw62.createElement("h3", {
        className: "mt-4"
    }, e), !!o && $acw62.createElement("div", {
        className: "text-muted"
    }, o), r && a && $acw62.createElement("div", {
        className: "mt-2"
    }, $acw62.createElement((0, $lzNIT.Link), {
        to: r,
        className: "btn btn-primary"
    }, a))), $acw62.createElement($b5fecd57b45662f2$var$_n, {
        className: "footer-alt"
    })), $b5fecd57b45662f2$export$e3dc9f5889e7d102 = $b5fecd57b45662f2$var$nk;
var $b5fecd57b45662f2$var$Jy = "data:image/png;base64,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";
var $b5fecd57b45662f2$var$lk = ()=>{
    var o;
    let t = (0, $aphAM.useRouteError)(), e = (t == null ? void 0 : t.message) || ((o = t == null ? void 0 : t.data) == null ? void 0 : o.message) || null;
    return $acw62.createElement($b5fecd57b45662f2$export$e3dc9f5889e7d102, {
        image: $b5fecd57b45662f2$var$Jy,
        title: "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A...",
        message: e ? $acw62.createElement($acw62.Fragment, null, "\u041F\u0456\u0434 \u0447\u0430\u0441 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0438 \u0432\u0456\u0434\u0431\u0443\u043B\u0430\u0441\u044C \u043A\u0440\u0438\u0442\u0438\u0447\u043D\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430: ", e) : $acw62.createElement($acw62.Fragment, null, "\u041F\u0456\u0434 \u0447\u0430\u0441 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0438 \u0432\u0456\u0434\u0431\u0443\u043B\u0430\u0441\u044C \u043D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043A\u0440\u0438\u0442\u0438\u0447\u043D\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430"),
        btnLink: "/",
        btnText: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044C \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043E\u043A"
    });
}, $b5fecd57b45662f2$var$Wo = $b5fecd57b45662f2$var$lk;
$b5fecd57b45662f2$var$Dl();
$b5fecd57b45662f2$var$xl();
var $b5fecd57b45662f2$var$fk = ()=>$acw62.createElement($b5fecd57b45662f2$var$Bn, {
        title: "403",
        info: "\u0414\u043E\u0441\u0442\u0443\u043F \u0432 \u0446\u0435\u0439 \u0440\u043E\u0437\u0434\u0456\u043B \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u0431\u0456\u043B\u044C\u0448 \u0432\u0438\u0441\u043E\u043A\u0438\u0445 \u043F\u0440\u0430\u0432"
    }), $b5fecd57b45662f2$var$ox = $b5fecd57b45662f2$var$fk;
$b5fecd57b45662f2$var$b();
var $b5fecd57b45662f2$var$bk = ()=>{
    let t = (0, $aphAM.useRouteError)(), e = $b5fecd57b45662f2$export$c594d3118da9430d();
    if ((0, $ifGBV.isApiNotFoundError)(t)) return $acw62.createElement($b5fecd57b45662f2$var$bl, null);
    if ((0, $ifGBV.isApiAccessDeniedError)(t)) return $acw62.createElement($b5fecd57b45662f2$var$ox, null);
    throw (0, $ifGBV.isApiNotAuthorizedError)(t) && (e.logout(), window.location.reload()), t;
}, $b5fecd57b45662f2$var$rx = $b5fecd57b45662f2$var$bk;
var $b5fecd57b45662f2$var$Z1 = $acw62.lazy(()=>Promise.resolve().then(()=>($b5fecd57b45662f2$var$Dl(), $b5fecd57b45662f2$var$tx))), $b5fecd57b45662f2$var$J1 = $acw62.lazy(()=>Promise.resolve().then(()=>($b5fecd57b45662f2$var$Mb(), $b5fecd57b45662f2$var$Tb))), $b5fecd57b45662f2$var$Q1 = $acw62.lazy(()=>Promise.resolve().then(()=>($b5fecd57b45662f2$var$Wb(), $b5fecd57b45662f2$var$Ub)));
function $b5fecd57b45662f2$var$Eb(t) {
    return t.map((e)=>e.children ? {
            name: "\u041F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
            path: e.path,
            element: $acw62.createElement((0, $aphAM.Navigate), {
                to: "/"
            }),
            children: $b5fecd57b45662f2$var$Eb(e.children)
        } : {
            name: "\u041F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
            path: e.path,
            element: $acw62.createElement((0, $aphAM.Navigate), {
                to: "/"
            })
        });
}
function $b5fecd57b45662f2$var$Il(t, e, o) {
    return [
        {
            element: $acw62.createElement($b5fecd57b45662f2$var$J1, null),
            errorElement: $acw62.createElement($b5fecd57b45662f2$var$Wo, null),
            children: [
                {
                    element: $acw62.createElement($b5fecd57b45662f2$var$Q1, null),
                    errorElement: $acw62.createElement($b5fecd57b45662f2$var$rx, null),
                    handle: $b5fecd57b45662f2$var$T({
                        name: t
                    }),
                    children: [
                        ...e,
                        ...$b5fecd57b45662f2$var$Eb(o),
                        $b5fecd57b45662f2$export$540eaef543e5a49a({
                            path: "login",
                            name: "\u041F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
                            element: $acw62.createElement((0, $aphAM.Navigate), {
                                to: "/"
                            })
                        }),
                        $b5fecd57b45662f2$export$540eaef543e5a49a({
                            path: "*",
                            name: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
                            element: $acw62.createElement($b5fecd57b45662f2$var$Z1, null)
                        })
                    ]
                }
            ]
        }
    ];
}
var $b5fecd57b45662f2$var$fF = $acw62.lazy(()=>Promise.resolve().then(()=>($b5fecd57b45662f2$var$Yb(), $b5fecd57b45662f2$var$Hb))), $b5fecd57b45662f2$var$gF = $acw62.lazy(()=>Promise.resolve().then(()=>($b5fecd57b45662f2$var$Kb(), $b5fecd57b45662f2$var$qb))), $b5fecd57b45662f2$var$hF = [
    {
        path: "login",
        element: $acw62.createElement($b5fecd57b45662f2$var$gF, null)
    }
];
function $b5fecd57b45662f2$var$Xl(t) {
    return [
        {
            element: $acw62.createElement($b5fecd57b45662f2$var$fF, null),
            errorElement: $acw62.createElement($b5fecd57b45662f2$var$Wo, null),
            children: [
                ...$b5fecd57b45662f2$var$hF,
                ...t,
                $b5fecd57b45662f2$export$540eaef543e5a49a({
                    path: "*",
                    name: "\u041F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0445\u043E\u0434\u0443",
                    element: $acw62.createElement((0, $aphAM.Navigate), {
                        to: "/login"
                    })
                })
            ]
        }
    ];
}
$b5fecd57b45662f2$var$oa();
$b5fecd57b45662f2$var$b();
var $b5fecd57b45662f2$var$bF = ()=>{
    let t = (0, $aphAM.useNavigate)(), e = $b5fecd57b45662f2$export$846279b0d7f2d98d();
    return $acw62.useEffect(()=>e.setNavigate(t), []), $acw62.createElement($acw62.Suspense, {
        fallback: $acw62.createElement($b5fecd57b45662f2$export$a3de6efb5461e66f, null)
    }, $acw62.createElement((0, $aphAM.Outlet), null));
}, $b5fecd57b45662f2$var$Zb = $b5fecd57b45662f2$var$bF;
function $b5fecd57b45662f2$var$ri(t) {
    return [
        {
            element: $acw62.createElement($b5fecd57b45662f2$var$Zb, null),
            errorElement: $acw62.createElement($b5fecd57b45662f2$var$Wo, null),
            children: t
        }
    ];
}
var $b5fecd57b45662f2$var$Jb = $dsEvO.wrapCreateBrowserRouter((0, $lzNIT.createBrowserRouter)), $b5fecd57b45662f2$var$jo = class {
    constructor(e, o, r){
        this._appRouter = null;
        this._guestRouter = null;
        this._app = e, this._appRoutes = $b5fecd57b45662f2$var$Il(this._app.config.base.appName, o, r), this._guestRoutes = $b5fecd57b45662f2$var$Xl(r);
    }
    getRouter(e) {
        var r;
        let o = (r = this._app.config.base.baseName) != null ? r : "/";
        return e ? (this._appRouter || (this._appRouter = $b5fecd57b45662f2$var$Jb($b5fecd57b45662f2$var$ri(this._appRoutes), {
            basename: o
        })), this._appRouter) : (this._guestRouter || (this._guestRouter = $b5fecd57b45662f2$var$Jb($b5fecd57b45662f2$var$ri(this._guestRoutes), {
            basename: o
        })), this._guestRouter);
    }
};
var $b5fecd57b45662f2$var$na = class {
    constructor(e){
        var o, r;
        this.config = e.config, this._initSentry(), this.actions = new $b5fecd57b45662f2$export$b52183d5cfb26dc9(this, this.config.actions), this.auth = new $b5fecd57b45662f2$export$334c29725a78c21d(this.config.auth), this.navigation = new $b5fecd57b45662f2$export$b8a61e5c71402559(this, this.config.navigation), this.toasts = new $b5fecd57b45662f2$export$46f5fe4dd7fa3070, this.helpers = new $b5fecd57b45662f2$export$f943027287067ba0, this.router = new $b5fecd57b45662f2$var$jo(this, (o = e == null ? void 0 : e.appRoutes) != null ? o : [], (r = e == null ? void 0 : e.guestRoutes) != null ? r : []), this.search = new $b5fecd57b45662f2$var$qe(this, this.config.search), this.services = new $b5fecd57b45662f2$var$je, this.pageContext = new $b5fecd57b45662f2$var$Mo, this.websocket = new $b5fecd57b45662f2$export$ae7b7f99370a87b2(this), e != null && e.onAppReady && e.onAppReady(this);
    }
    _initSentry() {
        this.config.base.sentryDsn && $apXAB.init({
            dsn: this.config.base.sentryDsn,
            release: this.config.base.appRelease,
            integrations: [
                $dsEvO.reactRouterV6BrowserTracingIntegration({
                    useEffect: $acw62.useEffect,
                    useLocation: (0, $aphAM.useLocation),
                    useNavigationType: (0, $aphAM.useNavigationType),
                    createRoutesFromChildren: (0, $aphAM.createRoutesFromChildren),
                    matchRoutes: (0, $2vsP7.matchRoutes)
                })
            ],
            tracesSampleRate: 1,
            replaysSessionSampleRate: .1,
            replaysOnErrorSampleRate: 1
        });
    }
};
$b5fecd57b45662f2$var$Ri();
$b5fecd57b45662f2$var$b();
$b5fecd57b45662f2$var$oa();
$b5fecd57b45662f2$var$_();
$b5fecd57b45662f2$var$Ke();
var $b5fecd57b45662f2$var$kF = ()=>{
    let t = $b5fecd57b45662f2$export$c594d3118da9430d(), e = $b5fecd57b45662f2$export$4b79bd8f34740571(t), o = $acw62.useMemo(()=>$b5fecd57b45662f2$var$re(e), [
        e
    ]), r = $b5fecd57b45662f2$export$d47fd796db1c6664();
    return e === null ? $acw62.createElement($b5fecd57b45662f2$export$a3de6efb5461e66f, null) : $acw62.createElement((0, $lzNIT.RouterProvider), {
        router: r.getRouter(o),
        fallbackElement: $acw62.createElement($b5fecd57b45662f2$export$a3de6efb5461e66f, null)
    });
}, $b5fecd57b45662f2$var$eD = $b5fecd57b45662f2$var$kF;
$b5fecd57b45662f2$var$Ke();
var $b5fecd57b45662f2$var$FF = (t)=>{
    let e = $acw62.useMemo(()=>new $b5fecd57b45662f2$var$na(t), []);
    return $acw62.createElement($b5fecd57b45662f2$var$Yp.Provider, {
        value: e
    }, $acw62.createElement($b5fecd57b45662f2$var$eD, null), $acw62.createElement($b5fecd57b45662f2$var$Us, null));
}, $b5fecd57b45662f2$export$16975c34e60e1e61 = $b5fecd57b45662f2$var$FF;
$b5fecd57b45662f2$var$b();
$b5fecd57b45662f2$var$Nl();
$b5fecd57b45662f2$var$vr();
$b5fecd57b45662f2$var$Tt();
$b5fecd57b45662f2$var$ro();
var $b5fecd57b45662f2$var$TF = ({ variant: t = "inline" })=>t === "block" ? $acw62.createElement($b5fecd57b45662f2$export$1d3945ea2d8839cb, null, $acw62.createElement($b5fecd57b45662f2$export$b6adbc8a92f93a5b, null)) : $acw62.createElement("div", {
        className: "d-inline-flex align-items-center gap-1"
    }, $acw62.createElement((0, $4dB0L.default), {
        animation: "border",
        size: "sm"
    }), $acw62.createElement("span", null, "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...")), $b5fecd57b45662f2$export$f9f64d1c9e28f783 = $b5fecd57b45662f2$var$TF;
$b5fecd57b45662f2$var$aa();
var $b5fecd57b45662f2$var$NF = ({ variant: t = "inline", error: e })=>{
    let { icon: o, text: r, color: a } = e;
    return t === "block" ? $acw62.createElement($b5fecd57b45662f2$export$bf0213d36508970c, {
        icon: o,
        text: r,
        color: a
    }) : $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("d-inline-flex align-items-center gap-1", {
            [`text-${a}`]: !!a
        })
    }, $acw62.createElement("i", {
        className: `mdi mdi-${o} font-16 lh-1`
    }), $acw62.createElement("span", null, r));
}, $b5fecd57b45662f2$export$476a4f0203f33529 = $b5fecd57b45662f2$var$NF;
var $b5fecd57b45662f2$var$BF = ({ variant: t, errorFallback: e })=>{
    let o = $b5fecd57b45662f2$export$9ddc9e1ee85f7eca();
    return e ? $acw62.createElement($acw62.Fragment, null, typeof e == "function" ? e(o) : e) : $acw62.createElement($b5fecd57b45662f2$export$476a4f0203f33529, {
        variant: t,
        error: o
    });
}, $b5fecd57b45662f2$var$OF = ({ resolve: t, children: e, loadFallback: o, errorFallback: r, variant: a })=>$acw62.createElement($acw62.Suspense, {
        fallback: o != null ? o : $acw62.createElement($b5fecd57b45662f2$export$f9f64d1c9e28f783, {
            variant: a
        })
    }, $acw62.createElement((0, $aphAM.Await), {
        resolve: t,
        errorElement: $acw62.createElement($b5fecd57b45662f2$var$BF, {
            variant: a,
            errorFallback: r
        }),
        children: e
    })), $b5fecd57b45662f2$export$daf72112110fee48 = $b5fecd57b45662f2$var$OF;
var $b5fecd57b45662f2$var$IF = $acw62.forwardRef(({ id: t, cardClassName: e, headerClassName: o, title: r, buttons: a, className: i, children: s, cardStyle: l, style: p }, m)=>$acw62.createElement((0, $aX99y.default), {
        className: e,
        id: t,
        ref: m,
        style: l
    }, r && $acw62.createElement((0, $aX99y.default).Header, {
        className: o != null ? o : "d-flex align-items-center bg-primary-lighten py-2"
    }, typeof r == "string" ? $acw62.createElement("h4", {
        className: "header-title lh-1 text-dark"
    }, r) : r, a && $acw62.createElement("div", {
        className: "ms-auto d-flex align-items-center gap-2"
    }, a)), $acw62.createElement((0, $aX99y.default).Body, {
        className: i,
        style: p
    }, s))), $b5fecd57b45662f2$export$d96a8827a60d6b69 = $b5fecd57b45662f2$var$IF;
$b5fecd57b45662f2$var$Tt();
$b5fecd57b45662f2$var$Es();
$b5fecd57b45662f2$var$Fs();
$b5fecd57b45662f2$var$ro();
$b5fecd57b45662f2$var$aa();
$b5fecd57b45662f2$var$aa();
var $b5fecd57b45662f2$var$Gl = ({ icon: t, text: e = "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E", nullText: o, variant: r = "inline", color: a = "muted", isNull: i = !1 })=>r === "block" ? $acw62.createElement($b5fecd57b45662f2$export$bf0213d36508970c, {
        icon: t != null ? t : "file-hidden",
        text: i && o != null ? o : e,
        color: a
    }) : t ? $acw62.createElement("div", {
        className: "d-inline-flex align-items-center gap-1"
    }, $acw62.createElement("i", {
        className: `mdi mdi-${t} font-16 lh-1`
    }), $acw62.createElement("span", null, i && o != null ? o : e)) : $acw62.createElement("span", null, i && o != null ? o : e), $b5fecd57b45662f2$var$oD = ({ data: t, itemRender: e, wrapper: o = $acw62.Fragment, emptyProps: r })=>t === null ? $acw62.createElement($b5fecd57b45662f2$var$Gl, {
        ...r,
        isNull: !0
    }) : Array.isArray(t) && t.length === 0 ? $acw62.createElement($b5fecd57b45662f2$var$Gl, {
        ...r
    }) : typeof t == "object" && Object.keys(t).length === 0 ? $acw62.createElement($b5fecd57b45662f2$var$Gl, {
        ...r
    }) : Array.isArray(t) ? $acw62.createElement(o, null, t.map((a, i)=>e(a, i))) : $acw62.createElement(o, null, Object.entries(t).map(([a, i])=>e(i, a))), $b5fecd57b45662f2$var$LF = ({ resolve: t, emptyProps: e, variant: o, ...r })=>$acw62.createElement($b5fecd57b45662f2$export$daf72112110fee48, {
        resolve: t,
        variant: o,
        ...r
    }, (a)=>$acw62.createElement($b5fecd57b45662f2$var$oD, {
            data: a,
            ...r,
            emptyProps: {
                variant: o,
                ...e
            }
        })), $b5fecd57b45662f2$export$4bb272cfb9cd934d = Object.assign($b5fecd57b45662f2$var$oD, {
    Await: $b5fecd57b45662f2$var$LF
});
$b5fecd57b45662f2$var$fa();
$b5fecd57b45662f2$var$qi();
var $b5fecd57b45662f2$var$YF = new (0, $8JYDX.Icon)({
    iconUrl: $b5fecd57b45662f2$var$za,
    shadowUrl: void 0,
    iconAnchor: [
        12,
        41
    ],
    popupAnchor: [
        0,
        -41
    ]
});
function $b5fecd57b45662f2$var$GF(t) {
    return typeof t < "u" && t.hasOwnProperty("location") && t.location.hasOwnProperty("lat") && t.location.hasOwnProperty("lng");
}
var $b5fecd57b45662f2$var$zF = ({ markers: t, center: e, style: o })=>{
    let r = (0, $acw62.useMemo)(()=>t.map((s)=>$b5fecd57b45662f2$var$GF(s) ? s : {
                location: s
            }), [
        t
    ]), a = (0, $acw62.useMemo)(()=>e || (r.length > 0 ? {
            lat: r.reduce((s, l)=>s + l.location.lat, 0) / r.length,
            lng: r.reduce((s, l)=>s + l.location.lng, 0) / r.length
        } : {
            lat: 49.824421,
            lng: 23.979513
        }), [
        r,
        e
    ]), i = (0, $acw62.useMemo)(()=>{
        if (r.length === 0) return;
        let s = r.reduce((p, m)=>m.location.lng < p.location.lng || m.location.lat < p.location.lat ? m : p), l = r.reduce((p, m)=>m.location.lng > p.location.lng || m.location.lat > p.location.lat ? m : p);
        return [
            [
                s.location.lat,
                s.location.lng
            ],
            [
                l.location.lat,
                l.location.lng
            ]
        ];
    }, [
        r
    ]);
    return $acw62.createElement((0, $kqTi2.MapContainer), {
        center: a,
        bounds: i,
        zoom: i ? void 0 : 10,
        boundsOptions: {
            padding: [
                5,
                5
            ]
        },
        style: o != null ? o : {
            height: 300
        }
    }, $acw62.createElement((0, $4ysIF.TileLayer), {
        attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    }), r.map((s, l)=>{
        var p;
        return $acw62.createElement((0, $i7g9v.Marker), {
            key: `marker-${l}`,
            position: s.location,
            icon: (p = s.icon) != null ? p : $b5fecd57b45662f2$var$YF
        }, !!s.info && $acw62.createElement((0, $5Dm6P.Popup), null, s.info));
    }));
}, $b5fecd57b45662f2$export$a5c7b93649eaf8f8 = $b5fecd57b45662f2$var$zF;
$b5fecd57b45662f2$var$ho();
$b5fecd57b45662f2$var$oa();
$b5fecd57b45662f2$var$b();
var $b5fecd57b45662f2$var$$F = ({ title: t, hideTitle: e, icon: o, badge: r, children: a, ...i })=>{
    let s = $b5fecd57b45662f2$export$846279b0d7f2d98d(), l = $acw62.useId();
    return $acw62.createElement($b5fecd57b45662f2$export$d96a8827a60d6b69, {
        ref: s.Topbar.Tabs.makeScrollTabRegister({
            icon: o,
            badge: r,
            title: t
        }),
        title: e ? void 0 : t,
        id: l,
        ...i
    }, a);
}, $b5fecd57b45662f2$export$f1a8dc3aff81fc32 = $b5fecd57b45662f2$var$$F;
$b5fecd57b45662f2$var$Mi();
$b5fecd57b45662f2$var$Gs();
$b5fecd57b45662f2$var$$s();
$b5fecd57b45662f2$var$Ut();
$b5fecd57b45662f2$var$Lr();
$b5fecd57b45662f2$var$vr();
$b5fecd57b45662f2$var$Ee();
$b5fecd57b45662f2$var$On();
$b5fecd57b45662f2$var$Xs();
$b5fecd57b45662f2$var$Sa();
$b5fecd57b45662f2$var$_();
$b5fecd57b45662f2$var$ue();
$b5fecd57b45662f2$var$Ds();
$b5fecd57b45662f2$var$nr();
function $b5fecd57b45662f2$export$bc4ac5c7b57c369a(t, e) {
    let [o, r] = $acw62.useState(()=>{
        let a = window.localStorage.getItem(e);
        return a !== null ? JSON.parse(a) : t;
    });
    return $acw62.useEffect(()=>{
        window.localStorage.setItem(e, JSON.stringify(o));
    }, [
        e,
        o
    ]), [
        o,
        r
    ];
}
$b5fecd57b45662f2$var$Ls();
$b5fecd57b45662f2$var$Ha();
$b5fecd57b45662f2$var$pa();
function $b5fecd57b45662f2$export$5257ce418d6a2f1b(t) {
    return Array.isArray(t) ? t.join(", ") : t;
}
function $b5fecd57b45662f2$export$63a4c2c99115c70a(t) {
    return (0, $ifGBV.isApiValidationError)(t) ? (0, $3nvVi.default)(t) : (0, $9PE8j.default)(t);
}
$b5fecd57b45662f2$var$Ms();
var $b5fecd57b45662f2$var$tw = (...t)=>()=>{
        t.forEach((e)=>e());
    }, $b5fecd57b45662f2$export$f05a241035b5c5eb = $b5fecd57b45662f2$var$tw;

});
parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigationType", () => $7939e29d663dd3ed$export$1b3f31771c5d07c);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "useRouteError", () => $7939e29d663dd3ed$export$ed527bf60f6e05f2);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useRevalidator", () => $7939e29d663dd3ed$export$600dc272ed516c15);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useLoaderData", () => $7939e29d663dd3ed$export$1448a5050d252c4d);
$parcel$export(module.exports, "useAsyncError", () => $7939e29d663dd3ed$export$17f53340677d5831);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $7939e29d663dd3ed$export$910ae8079b2c2852);
$parcel$export(module.exports, "createRoutesFromChildren", () => $7939e29d663dd3ed$export$16da398f5434bdec);
$parcel$export(module.exports, "Await", () => $7939e29d663dd3ed$export$6ddabde395c8c576);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
$parcel$export(module.exports, "matchRoutes", () => (parcelRequire("2vsP7")).matchRoutes);
/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "json", () => $1d34d5c4a288b213$export$7b419323e6ed4f31);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "defer", () => $1d34d5c4a288b213$export$260e5c0943f31606);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", () => $040dbb9c344a508d$export$1f3f55432a00e06d);
$parcel$export(module.exports, "RouterProvider", () => $040dbb9c344a508d$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $040dbb9c344a508d$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useMatches", () => (parcelRequire("aphAM")).useMatches);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
$parcel$export(module.exports, "useNavigation", () => (parcelRequire("aphAM")).useNavigation);
/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $aphAM = parcelRequire("aphAM");
var $2vsP7 = parcelRequire("2vsP7");
var $2vsP7 = parcelRequire("2vsP7");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});

parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !(({
        __proto__: null
    }) instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});




parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $iBfJ5.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});


parcelRegister("9JAYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7164fecb4f365c4a$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $bALFW = parcelRequire("bALFW");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7164fecb4f365c4a$var$FormCheckInput = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = "checkbox", isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $bALFW.default));
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$7164fecb4f365c4a$var$FormCheckInput.displayName = "FormCheckInput";
var $7164fecb4f365c4a$export$2e2bcd8739ae039 = $7164fecb4f365c4a$var$FormCheckInput;

});
parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("bALFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $870809e0939c9f82$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
// TODO
const $870809e0939c9f82$var$FormContext = /*#__PURE__*/ $acw62.createContext({});
var $870809e0939c9f82$export$2e2bcd8739ae039 = $870809e0939c9f82$var$FormContext;

});

parcelRegister("8rTrh", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", () => $626bd95fa485b758$export$7f387860ebffb32c);
$parcel$export(module.exports, "useBootstrapBreakpoints", () => $626bd95fa485b758$export$8970c8db816a5863);
$parcel$export(module.exports, "useBootstrapMinBreakpoint", () => $626bd95fa485b758$export$d926d6ef38f3fd32);
$parcel$export(module.exports, "useIsRTL", () => $626bd95fa485b758$export$35e511eefa30ac5a);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $626bd95fa485b758$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $626bd95fa485b758$export$ff817e17bad2e091 = "xs";
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f, Provider: $626bd95fa485b758$var$Provider } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === "rtl";
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef" } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;

});


parcelRegister("cpxrl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9091c2598933ffd8$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("4pN5t");
var $7yCAN = parcelRequire("7yCAN");

var $dsxUx = parcelRequire("dsxUx");

var $8rTrh = parcelRequire("8rTrh");

var $6R6KX = parcelRequire("6R6KX");

var $bAX4s = parcelRequire("bAX4s");

var $7BpMa = parcelRequire("7BpMa");

var $77pHI = parcelRequire("77pHI");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $9091c2598933ffd8$var$Alert = /*#__PURE__*/ $acw62.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = "Close alert", closeVariant: closeVariant, className: className, children: children, variant: variant = "primary", onClose: onClose, dismissible: dismissible, transition: transition = (0, $7BpMa.default), ...props } = (0, $7yCAN.default)(uncontrolledProps, {
        show: "onClose"
    });
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "alert");
    const handleClose = (0, $dsxUx.default)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $7BpMa.default) : transition;
    const alert = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77pHI.default), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$9091c2598933ffd8$var$Alert.displayName = "Alert";
var $9091c2598933ffd8$export$2e2bcd8739ae039 = Object.assign($9091c2598933ffd8$var$Alert, {
    Link: (0, $bAX4s.default),
    Heading: (0, $6R6KX.default)
});

});
parcelRegister("4pN5t", function(module, exports) {

$parcel$export(module.exports, "useUncontrolled", () => (parcelRequire("7yCAN")).default);
$parcel$export(module.exports, "useUncontrolledProp", () => (parcelRequire("7yCAN")).useUncontrolledProp);

var $7yCAN = parcelRequire("7yCAN");

var $dVlN2 = parcelRequire("dVlN2");

});
parcelRegister("7yCAN", function(module, exports) {

$parcel$export(module.exports, "useUncontrolledProp", () => $5809a50e160ad91a$export$2ee51287a16ca325);
$parcel$export(module.exports, "default", () => $5809a50e160ad91a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $fNcGF = parcelRequire("fNcGF");
function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$fNcGF.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, $1En50.default)(_ref, [
            $fNcGF.defaultKey(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $8nd05.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("fNcGF", function(module, exports) {

$parcel$export(module.exports, "defaultKey", () => $b7f5460541b42e0f$export$26cbf8c37e721e67);
$parcel$export(module.exports, "uncontrolledPropTypes", () => $b7f5460541b42e0f$export$8abd944bed26e726);
$parcel$export(module.exports, "isProp", () => $b7f5460541b42e0f$export$12ae2baa35bd9b8b);
$parcel$export(module.exports, "canAcceptRef", () => $b7f5460541b42e0f$export$95e5b18573b29087);
parcelRequire("aaXwj");
var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler;
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}

});
parcelRegister("aaXwj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $768901fea8dbe440$var$invariant;

});



parcelRegister("dVlN2", function(module, exports) {

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $hdX8Q = parcelRequire("hdX8Q");

var $aaXwj = parcelRequire("aaXwj");

var $fNcGF = parcelRequire("fNcGF");
var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $fNcGF.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($fNcGF.defaultKey);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $g7ajw.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $8nd05.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$fNcGF.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $8nd05.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$fNcGF.isProp(props, key) && $fNcGF.isProp(prevProps, key)) nextState.values[key] = props[$fNcGF.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $1En50.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $hdX8Q.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $8nd05.default)({
        innerRef: function innerRef() {}
    }, $fNcGF.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $8nd05.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $8nd05.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $VFVve.default)(subClass, superClass);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("hdX8Q", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $c8a186e1757974bb$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("dsxUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc831e7fe1726fc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eIUqb = parcelRequire("eIUqb");
function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $eIUqb.default)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("eIUqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab80f0daa08f2134$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;

});


parcelRegister("6R6KX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fdceeff8a5914bf$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $4gthj = parcelRequire("4gthj");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4fdceeff8a5914bf$var$DivStyledAsH4 = (0, $4gthj.default)("h4");
$4fdceeff8a5914bf$var$DivStyledAsH4.displayName = "DivStyledAsH4";
const $4fdceeff8a5914bf$var$AlertHeading = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $4fdceeff8a5914bf$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "alert-heading");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$4fdceeff8a5914bf$var$AlertHeading.displayName = "AlertHeading";
var $4fdceeff8a5914bf$export$2e2bcd8739ae039 = $4fdceeff8a5914bf$var$AlertHeading;

});
parcelRegister("4gthj", function(module, exports) {

$parcel$export(module.exports, "default", () => $31af5e1d0c3b3c37$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $ayMG0 = parcelRequire("ayMG0");
var $31af5e1d0c3b3c37$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $acw62.forwardRef((p, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(p.className, className)
        }));

});


parcelRegister("bAX4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $8710e0c5b76ea92e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $dKAJt = parcelRequire("dKAJt");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $8710e0c5b76ea92e$var$AlertLink = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $dKAJt.default), ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "alert-link");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$8710e0c5b76ea92e$var$AlertLink.displayName = "AlertLink";
var $8710e0c5b76ea92e$export$2e2bcd8739ae039 = $8710e0c5b76ea92e$var$AlertLink;

});
parcelRegister("dKAJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a02c1087963bbb34$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("iOGDy");
var $dsxUx = parcelRequire("dsxUx");

var $rldgt = parcelRequire("rldgt");

var $ayMG0 = parcelRequire("ayMG0");
const $a02c1087963bbb34$var$_excluded = [
    "onKeyDown"
];
function $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a02c1087963bbb34$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a02c1087963bbb34$var$Anchor = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(_ref, $a02c1087963bbb34$var$_excluded);
    const [buttonProps] = (0, $rldgt.useButtonProps)(Object.assign({
        tagName: "a"
    }, props));
    const handleKeyDown = (0, $dsxUx.default)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a02c1087963bbb34$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $ayMG0.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a02c1087963bbb34$var$Anchor.displayName = "Anchor";
var $a02c1087963bbb34$export$2e2bcd8739ae039 = $a02c1087963bbb34$var$Anchor;

});
parcelRegister("iOGDy", function(module, exports) {

$parcel$export(module.exports, "useEventCallback", () => (parcelRequire("dsxUx")).default);

var $9whQJ = parcelRequire("9whQJ");

var $eIUqb = parcelRequire("eIUqb");

var $dsxUx = parcelRequire("dsxUx");

var $k9rTF = parcelRequire("k9rTF");

var $5loVj = parcelRequire("5loVj");

var $9Bkpo = parcelRequire("9Bkpo");

var $2c3w9 = parcelRequire("2c3w9");

var $fIMMG = parcelRequire("fIMMG");

var $5URzb = parcelRequire("5URzb");

var $kob1U = parcelRequire("kob1U");

var $d1b47 = parcelRequire("d1b47");

var $b10YF = parcelRequire("b10YF");

var $e5Ern = parcelRequire("e5Ern");

});
parcelRegister("9whQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee4f2c1aea3527b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $6ee4f2c1aea3527b$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}

});

parcelRegister("k9rTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaba49a725115ef9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");
function $eaba49a725115ef9$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $dsxUx.default)(listener);
    (0, $acw62.useEffect)(()=>{
        const target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

});

parcelRegister("5loVj", function(module, exports) {

var $k9rTF = parcelRequire("k9rTF");

var $acw62 = parcelRequire("acw62");
function $3e423f2a0d715058$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $acw62.useCallback)(()=>document, []);
    return (0, $k9rTF.default)(documentTarget, event, handler, capture);
}

});

parcelRegister("9Bkpo", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $eIUqb = parcelRequire("eIUqb");
/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $6fd76678a314d183$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $eIUqb.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $eIUqb.default)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $acw62.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $6fd76678a314d183$export$2e2bcd8739ae039 = $6fd76678a314d183$var$useInterval;

});

parcelRegister("2c3w9", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $eIUqb = parcelRequire("eIUqb");
function $198f6e47917f30c6$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $eIUqb.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $eIUqb.default)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $acw62.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $198f6e47917f30c6$export$2e2bcd8739ae039 = $198f6e47917f30c6$var$useRafInterval;

});

parcelRegister("fIMMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b720ce9b20d786bc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $b720ce9b20d786bc$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $acw62.useState)(initialState);
    const updater = (0, $acw62.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === "function") setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}

});

parcelRegister("5URzb", function(module, exports) {

var $fIMMG = parcelRequire("fIMMG");
function $44ebbbe01160f4fd$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $fIMMG.default)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}

});

parcelRegister("kob1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7e9ace1ce49d9f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $ed7e9ace1ce49d9f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});

parcelRegister("d1b47", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a3f3bdcb91cb9e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $97a3f3bdcb91cb9e$export$2e2bcd8739ae039(value) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

});

parcelRegister("b10YF", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $80508bd696338b90$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $acw62.useState)({
        image: null,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return ()=>{
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}

});

parcelRegister("e5Ern", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $8wLL1 = parcelRequire("8wLL1");
const $a420e6fa685a8a6f$var$targetMap = new WeakMap();
let $a420e6fa685a8a6f$var$resizeObserver;
function $a420e6fa685a8a6f$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $a420e6fa685a8a6f$var$resizeObserver = $a420e6fa685a8a6f$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $a420e6fa685a8a6f$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $a420e6fa685a8a6f$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $acw62.useState)(null);
    (0, $8wLL1.default)(()=>{
        if (!element) return;
        $a420e6fa685a8a6f$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $a420e6fa685a8a6f$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $a420e6fa685a8a6f$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}

});
parcelRegister("8wLL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $63565b817d447aae$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $63565b817d447aae$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
const $63565b817d447aae$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $63565b817d447aae$export$2e2bcd8739ae039 = $63565b817d447aae$var$isDOM || $63565b817d447aae$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});



parcelRegister("rldgt", function(module, exports) {

$parcel$export(module.exports, "useButtonProps", () => $0522fa2e4977c358$export$a0ee72f2c720a5c3);
$parcel$export(module.exports, "default", () => $0522fa2e4977c358$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = "Button";
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;

});



parcelRegister("7BpMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $588ffbaaa8a325aa$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");

var $kNQyj = parcelRequire("kNQyj");

var $fN7cd = parcelRequire("fN7cd");

var $84Ser = parcelRequire("84Ser");

var $ayMG0 = parcelRequire("ayMG0");
const $588ffbaaa8a325aa$var$fadeStyles = {
    [(0, $1mPeS.ENTERING)]: "show",
    [(0, $1mPeS.ENTERED)]: "show"
};
const $588ffbaaa8a325aa$var$Fade = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $acw62.useCallback)((node, isAppearing)=>{
        (0, $fN7cd.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84Ser.default), {
        ref: ref,
        addEndListener: (0, $kNQyj.default),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fade", className, children.props.className, $588ffbaaa8a325aa$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$588ffbaaa8a325aa$var$Fade.displayName = "Fade";
var $588ffbaaa8a325aa$export$2e2bcd8739ae039 = $588ffbaaa8a325aa$var$Fade;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "EXITED", () => $0fef977f04119bf5$export$84cbff306f539230);
$parcel$export(module.exports, "ENTERING", () => $0fef977f04119bf5$export$df38205c966be359);
$parcel$export(module.exports, "ENTERED", () => $0fef977f04119bf5$export$78e9e6e3e014d60a);
$parcel$export(module.exports, "EXITING", () => $0fef977f04119bf5$export$4aacc83d4d59139f);
$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");


var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("kNQyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f251260f6a38a977$export$2e2bcd8739ae039);

var $2voRd = parcelRequire("2voRd");

var $4VxHp = parcelRequire("4VxHp");
function $f251260f6a38a977$var$parseDuration(node, property) {
    const str = (0, $2voRd.default)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f251260f6a38a977$export$2e2bcd8739ae039(element, handler) {
    const duration = $f251260f6a38a977$var$parseDuration(element, "transitionDuration");
    const delay = $f251260f6a38a977$var$parseDuration(element, "transitionDelay");
    const remove = (0, $4VxHp.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});
parcelRegister("2voRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d31c226dae4138f$export$2e2bcd8739ae039);

var $dtYQo = parcelRequire("dtYQo");

var $PQK9L = parcelRequire("PQK9L");

var $heeAB = parcelRequire("heeAB");
function $1d31c226dae4138f$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $PQK9L.default)(property)) || (0, $dtYQo.default)(node).getPropertyValue((0, $PQK9L.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $PQK9L.default)(key));
        else if ((0, $heeAB.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $PQK9L.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;

});
parcelRegister("dtYQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0d2e2a013bac9c$export$2e2bcd8739ae039);

var $iJqLk = parcelRequire("iJqLk");
function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $iJqLk.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("iJqLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $da31306d5140b746$export$2e2bcd8739ae039);

var $lIo3y = parcelRequire("lIo3y");
function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $lIo3y.default)(node);
    return doc && doc.defaultView || window;
}

});
parcelRegister("lIo3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf05e248574eb57$export$2e2bcd8739ae039);
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("PQK9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $09bdad49a6503060$export$2e2bcd8739ae039);
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $dFgU8 = parcelRequire("dFgU8");
var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $dFgU8.default)(string).replace($09bdad49a6503060$var$msPattern, "-ms-");
}

});
parcelRegister("dFgU8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2c378a21ca2430$export$2e2bcd8739ae039);
var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, "-$1").toLowerCase();
}

});


parcelRegister("heeAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8af0fa0e8553220$export$2e2bcd8739ae039);
var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}

});


parcelRegister("4VxHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3966a04026e86a49$export$2e2bcd8739ae039);

var $2voRd = parcelRequire("2voRd");

var $7YnSj = parcelRequire("7YnSj");

var $iq7UD = parcelRequire("iq7UD");
function $3966a04026e86a49$var$parseDuration(node) {
    var str = (0, $2voRd.default)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $iq7UD.default)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $7YnSj.default)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3966a04026e86a49$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3966a04026e86a49$var$parseDuration(element) || 0;
    var removeEmulate = $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $7YnSj.default)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("7YnSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ce0a80dcc778636$export$2e2bcd8739ae039);

var $3shzr = parcelRequire("3shzr");

var $7J0wn = parcelRequire("7J0wn");
function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $3shzr.default)(node, eventName, handler, options);
    return function() {
        (0, $7J0wn.default)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;

});
parcelRegister("3shzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $28419dce7921d430$export$2e2bcd8739ae039);
/* eslint-disable no-return-assign */ 
var $7lCBb = parcelRequire("7lCBb");
var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $7lCBb.default) {
        window.addEventListener("test", $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener("test", $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;

});
parcelRegister("7lCBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $55986f7b0f69fd17$export$2e2bcd8739ae039);
var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);

});


parcelRegister("7J0wn", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fd23e4cc6020bf$export$2e2bcd8739ae039);
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;

});


parcelRegister("iq7UD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d690caf237d1909f$export$2e2bcd8739ae039);
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $d690caf237d1909f$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});



parcelRegister("fN7cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f7800ef44133eb$export$2e2bcd8739ae039);
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $02f7800ef44133eb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});

parcelRegister("84Ser", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e18c3cbbc2321dd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");

var $dvyhD = parcelRequire("dvyhD");

var $a59eu = parcelRequire("a59eu");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $5e18c3cbbc2321dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $dvyhD.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $a59eu.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1mPeS.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $5e18c3cbbc2321dd$export$2e2bcd8739ae039 = $5e18c3cbbc2321dd$var$TransitionWrapper;

});
parcelRegister("dvyhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d58c39545e3cedc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $9d58c39545e3cedc$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    const a = $9d58c39545e3cedc$var$toFnRef(refA);
    const b = $9d58c39545e3cedc$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$9d58c39545e3cedc$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;

});

parcelRegister("a59eu", function(module, exports) {

$parcel$export(module.exports, "default", () => $75718871ab216e51$export$2e2bcd8739ae039);

var $1u0KT = parcelRequire("1u0KT");
function $75718871ab216e51$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});



parcelRegister("77pHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $52ed202a4f01c477$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $ayMG0 = parcelRequire("ayMG0");
const $52ed202a4f01c477$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "white"
    ])
};
const $52ed202a4f01c477$var$CloseButton = /*#__PURE__*/ $acw62.forwardRef(({ className: className, variant: variant, "aria-label": ariaLabel = "Close", ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$52ed202a4f01c477$var$CloseButton.displayName = "CloseButton";
$52ed202a4f01c477$var$CloseButton.propTypes = $52ed202a4f01c477$var$propTypes;
var $52ed202a4f01c477$export$2e2bcd8739ae039 = $52ed202a4f01c477$var$CloseButton;

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});





parcelRegister("gmc0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $be88051441b9a39d$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $be88051441b9a39d$var$Badge = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, bg: bg = "primary", pill: pill = false, text: text, className: className, as: Component = "span", ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "badge");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$be88051441b9a39d$var$Badge.displayName = "Badge";
var $be88051441b9a39d$export$2e2bcd8739ae039 = $be88051441b9a39d$var$Badge;

});

parcelRegister("6LAgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed343d4b409b2f2$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $rldgt = parcelRequire("rldgt");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4ed343d4b409b2f2$var$Button = /*#__PURE__*/ $acw62.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = "primary", size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName }] = (0, $rldgt.useButtonProps)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$4ed343d4b409b2f2$var$Button.displayName = "Button";
var $4ed343d4b409b2f2$export$2e2bcd8739ae039 = $4ed343d4b409b2f2$var$Button;

});

parcelRegister("f57q8", function(module, exports) {

$parcel$export(module.exports, "default", () => $afad1432bd80d9ce$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $afad1432bd80d9ce$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = "group", // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...rest }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "btn-group");
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$afad1432bd80d9ce$var$ButtonGroup.displayName = "ButtonGroup";
var $afad1432bd80d9ce$export$2e2bcd8739ae039 = $afad1432bd80d9ce$var$ButtonGroup;

});

parcelRegister("aX99y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9683b4f5c2a43f$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $3zXxn = parcelRequire("3zXxn");

var $50rAQ = parcelRequire("50rAQ");

var $dh2LE = parcelRequire("dh2LE");

var $itv6f = parcelRequire("itv6f");

var $jgn7l = parcelRequire("jgn7l");

var $laDRJ = parcelRequire("laDRJ");

var $hbxT3 = parcelRequire("hbxT3");

var $gYx2o = parcelRequire("gYx2o");

var $8Ieke = parcelRequire("8Ieke");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7f9683b4f5c2a43f$var$Card = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3zXxn.default), {
            children: children
        }) : children
    });
});
$7f9683b4f5c2a43f$var$Card.displayName = "Card";
var $7f9683b4f5c2a43f$export$2e2bcd8739ae039 = Object.assign($7f9683b4f5c2a43f$var$Card, {
    Img: (0, $itv6f.default),
    Title: (0, $8Ieke.default),
    Subtitle: (0, $hbxT3.default),
    Body: (0, $3zXxn.default),
    Link: (0, $laDRJ.default),
    Text: (0, $gYx2o.default),
    Header: (0, $dh2LE.default),
    Footer: (0, $50rAQ.default),
    ImgOverlay: (0, $jgn7l.default)
});

});
parcelRegister("3zXxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b2d2ddf65676f3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $29b2d2ddf65676f3$var$CardBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-body");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$29b2d2ddf65676f3$var$CardBody.displayName = "CardBody";
var $29b2d2ddf65676f3$export$2e2bcd8739ae039 = $29b2d2ddf65676f3$var$CardBody;

});

parcelRegister("50rAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a525b42d7f3b597$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $3a525b42d7f3b597$var$CardFooter = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-footer");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$3a525b42d7f3b597$var$CardFooter.displayName = "CardFooter";
var $3a525b42d7f3b597$export$2e2bcd8739ae039 = $3a525b42d7f3b597$var$CardFooter;

});

parcelRegister("dh2LE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a9f027adafde870$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $881NI = parcelRequire("881NI");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $9a9f027adafde870$var$CardHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-header");
    const contextValue = (0, $acw62.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $881NI.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix)
        })
    });
});
$9a9f027adafde870$var$CardHeader.displayName = "CardHeader";
var $9a9f027adafde870$export$2e2bcd8739ae039 = $9a9f027adafde870$var$CardHeader;

});
parcelRegister("881NI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb077b72b2eb187$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $5eb077b72b2eb187$var$context = /*#__PURE__*/ $acw62.createContext(null);
$5eb077b72b2eb187$var$context.displayName = "CardHeaderContext";
var $5eb077b72b2eb187$export$2e2bcd8739ae039 = $5eb077b72b2eb187$var$context;

});


parcelRegister("itv6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7330f2b9423c4ea$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $d7330f2b9423c4ea$var$CardImg = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = "img", ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$d7330f2b9423c4ea$var$CardImg.displayName = "CardImg";
var $d7330f2b9423c4ea$export$2e2bcd8739ae039 = $d7330f2b9423c4ea$var$CardImg;

});

parcelRegister("jgn7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $e061719421ea7037$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $e061719421ea7037$var$CardImgOverlay = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-img-overlay");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$e061719421ea7037$var$CardImgOverlay.displayName = "CardImgOverlay";
var $e061719421ea7037$export$2e2bcd8739ae039 = $e061719421ea7037$var$CardImgOverlay;

});

parcelRegister("laDRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f699749ca3cc3e98$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $f699749ca3cc3e98$var$CardLink = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "a", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-link");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$f699749ca3cc3e98$var$CardLink.displayName = "CardLink";
var $f699749ca3cc3e98$export$2e2bcd8739ae039 = $f699749ca3cc3e98$var$CardLink;

});

parcelRegister("hbxT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c82dc004881f9e7b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $4gthj = parcelRequire("4gthj");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c82dc004881f9e7b$var$DivStyledAsH6 = (0, $4gthj.default)("h6");
const $c82dc004881f9e7b$var$CardSubtitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $c82dc004881f9e7b$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-subtitle");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$c82dc004881f9e7b$var$CardSubtitle.displayName = "CardSubtitle";
var $c82dc004881f9e7b$export$2e2bcd8739ae039 = $c82dc004881f9e7b$var$CardSubtitle;

});

parcelRegister("gYx2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5bbe089badf3410$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c5bbe089badf3410$var$CardText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "p", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-text");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$c5bbe089badf3410$var$CardText.displayName = "CardText";
var $c5bbe089badf3410$export$2e2bcd8739ae039 = $c5bbe089badf3410$var$CardText;

});

parcelRegister("8Ieke", function(module, exports) {

$parcel$export(module.exports, "default", () => $657d8b8404bcef88$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $4gthj = parcelRequire("4gthj");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $657d8b8404bcef88$var$DivStyledAsH5 = (0, $4gthj.default)("h5");
const $657d8b8404bcef88$var$CardTitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $657d8b8404bcef88$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "card-title");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$657d8b8404bcef88$var$CardTitle.displayName = "CardTitle";
var $657d8b8404bcef88$export$2e2bcd8739ae039 = $657d8b8404bcef88$var$CardTitle;

});


parcelRegister("99eL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a906738aa440808$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $6a906738aa440808$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "col");
    const breakpoints = (0, $8rTrh.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $8rTrh.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $6a906738aa440808$var$Col = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = "div", bsPrefix: bsPrefix, spans: spans }] = $6a906738aa440808$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, !spans.length && bsPrefix)
    });
});
$6a906738aa440808$var$Col.displayName = "Col";
var $6a906738aa440808$export$2e2bcd8739ae039 = $6a906738aa440808$var$Col;

});

parcelRegister("8qr9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $6225d171b822135d$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $2voRd = parcelRequire("2voRd");

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");

var $kNQyj = parcelRequire("kNQyj");

var $9FCr1 = parcelRequire("9FCr1");

var $fN7cd = parcelRequire("fN7cd");

var $84Ser = parcelRequire("84Ser");

var $ayMG0 = parcelRequire("ayMG0");
const $6225d171b822135d$var$MARGINS = {
    height: [
        "marginTop",
        "marginBottom"
    ],
    width: [
        "marginLeft",
        "marginRight"
    ]
};
function $6225d171b822135d$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $6225d171b822135d$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $2voRd.default)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $2voRd.default)(elem, margins[1]), 10);
}
const $6225d171b822135d$var$collapseStyles = {
    [(0, $1mPeS.EXITED)]: "collapse",
    [(0, $1mPeS.EXITING)]: "collapsing",
    [(0, $1mPeS.ENTERING)]: "collapsing",
    [(0, $1mPeS.ENTERED)]: "collapse show"
};
const $6225d171b822135d$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = "height", in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $6225d171b822135d$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === "function" ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $acw62.useMemo)(()=>(0, $9FCr1.default)((elem)=>{
            elem.style[computedDimension] = "0";
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $acw62.useMemo)(()=>(0, $9FCr1.default)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $acw62.useMemo)(()=>(0, $9FCr1.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $acw62.useMemo)(()=>(0, $9FCr1.default)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $fN7cd.default)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $acw62.useMemo)(()=>(0, $9FCr1.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84Ser.default), {
        ref: ref,
        addEndListener: (0, $kNQyj.default),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: children.ref,
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, children.props.className, $6225d171b822135d$var$collapseStyles[state], computedDimension === "width" && "collapse-horizontal")
            })
    });
});
var // @ts-ignore
$6225d171b822135d$export$2e2bcd8739ae039 = $6225d171b822135d$var$Collapse;

});
parcelRegister("9FCr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a5c1c5c22ba944$export$2e2bcd8739ae039);
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $70a5c1c5c22ba944$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== "function") throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $70a5c1c5c22ba944$export$2e2bcd8739ae039 = $70a5c1c5c22ba944$var$createChainedFunction;

});


parcelRegister("6l6B5", function(module, exports) {

$parcel$export(module.exports, "default", () => $49d9d24d620fa26d$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $49d9d24d620fa26d$var$Container = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "container");
    const suffix = typeof fluid === "string" ? `-${fluid}` : "-fluid";
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$49d9d24d620fa26d$var$Container.displayName = "Container";
var $49d9d24d620fa26d$export$2e2bcd8739ae039 = $49d9d24d620fa26d$var$Container;

});

parcelRegister("gzHIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c111d4db45b07888$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $7zFi2 = parcelRequire("7zFi2");
parcelRequire("4pN5t");
var $7yCAN = parcelRequire("7yCAN");

var $dsxUx = parcelRequire("dsxUx");

var $iWxmO = parcelRequire("iWxmO");

var $7KIXd = parcelRequire("7KIXd");

var $kiZsT = parcelRequire("kiZsT");

var $gLli8 = parcelRequire("gLli8");

var $3APFa = parcelRequire("3APFa");

var $82jyR = parcelRequire("82jyR");

var $9bD6f = parcelRequire("9bD6f");

var $j1NGT = parcelRequire("j1NGT");

var $8rTrh = parcelRequire("8rTrh");


var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c111d4db45b07888$var$Dropdown = /*#__PURE__*/ $acw62.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = "down", show: show, className: className, align: align = "start", onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", navbar: _4, autoClose: autoClose = true, ...props } = (0, $7yCAN.default)(pProps, {
        show: "onToggle"
    });
    const isInputGroup = (0, $acw62.useContext)((0, $j1NGT.default));
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "dropdown");
    const isRTL = (0, $8rTrh.useIsRTL)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === "click";
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === "inside") return source !== "rootClose";
        // autoClose=outside doesn't permit close on select
        if (autoClose === "outside") return source !== "select";
        return true;
    };
    const handleToggle = (0, $dsxUx.default)((nextShow, meta)=>{
        var _meta$originalEvent, _meta$originalEvent$t;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null ? void 0 : (_meta$originalEvent$t = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent$t.classList.contains("dropdown-toggle");
        if (isToggleButton && meta.source === "mousedown") return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== "keydown" || meta.originalEvent.key === "Escape")) meta.source = "rootClose";
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === "end";
    const placement = (0, $82jyR.getDropdownMenuPlacement)(alignEnd, drop, isRTL);
    const contextValue = (0, $acw62.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        "down-centered": `${prefix}-center`,
        up: "dropup",
        "up-centered": "dropup-center dropup",
        end: "dropend",
        start: "dropstart"
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iWxmO.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7zFi2.default), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, show && "show", directionClasses[drop])
            })
        })
    });
});
$c111d4db45b07888$var$Dropdown.displayName = "Dropdown";
var $c111d4db45b07888$export$2e2bcd8739ae039 = Object.assign($c111d4db45b07888$var$Dropdown, {
    Toggle: (0, $9bD6f.default),
    Menu: (0, $82jyR.default),
    Item: (0, $gLli8.default),
    ItemText: (0, $3APFa.default),
    Divider: (0, $7KIXd.default),
    Header: (0, $kiZsT.default)
});

});
parcelRegister("7zFi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $583bd49bf9b8480b$export$2e2bcd8739ae039);

var $95lS5 = parcelRequire("95lS5");

var $3shzr = parcelRequire("3shzr");

var $acw62 = parcelRequire("acw62");

var $9Ebs1 = parcelRequire("9Ebs1");

var $d1b47 = parcelRequire("d1b47");

var $dkoqn = parcelRequire("dkoqn");

var $k9rTF = parcelRequire("k9rTF");

var $dsxUx = parcelRequire("dsxUx");

var $bmAm9 = parcelRequire("bmAm9");

var $ayLjw = parcelRequire("ayLjw");

var $fpkzq = parcelRequire("fpkzq");

var $juu42 = parcelRequire("juu42");

var $drkGp = parcelRequire("drkGp");

var $1teBw = parcelRequire("1teBw");

var $1cXvU = parcelRequire("1cXvU");

var $ayMG0 = parcelRequire("ayMG0");
function $583bd49bf9b8480b$var$useRefWithUpdate() {
    const forceUpdate = (0, $dkoqn.default)();
    const ref = (0, $acw62.useRef)(null);
    const attachRef = (0, $acw62.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $583bd49bf9b8480b$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $1teBw.dataAttr)("dropdown-item")}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = "bottom-start", children: children }) {
    const window = (0, $1cXvU.default)();
    const [show, onToggle] = (0, $9Ebs1.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $d1b47.default)(show);
    const lastSourceEvent = (0, $acw62.useRef)(null);
    const focusInDropdown = (0, $acw62.useRef)(false);
    const onSelectCtx = (0, $acw62.useContext)((0, $drkGp.default));
    const toggle = (0, $acw62.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $dsxUx.default)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, "select");
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $acw62.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $dsxUx.default)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $dsxUx.default)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $fpkzq.isRoleMenu)(menuRef.current) ? "keyboard" : false;
        if (focusType === false || focusType === "keyboard" && !/^key.+$/.test(type)) return;
        const first = (0, $95lS5.default)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $acw62.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $acw62.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $95lS5.default)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $k9rTF.default)((0, $acw62.useCallback)(()=>window.document, [
        window
    ]), "keydown", (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === " " || key !== "Escape" && fromMenu || key === "Escape" && target.type === "search")) return;
        if (!fromMenu && !fromToggle) return;
        if (key === "Tab" && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case "ArrowUp":
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case "ArrowDown":
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case "Tab":
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $3shzr.default)(target.ownerDocument, "keyup", (e)=>{
                    var _menuRef$current2;
                    if (e.key === "Tab" && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case "Escape":
                if (key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drkGp.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bmAm9.default).Provider, {
            value: context,
            children: children
        })
    });
}
$583bd49bf9b8480b$var$Dropdown.displayName = "Dropdown";
$583bd49bf9b8480b$var$Dropdown.Menu = (0, $ayLjw.default);
$583bd49bf9b8480b$var$Dropdown.Toggle = (0, $fpkzq.default);
$583bd49bf9b8480b$var$Dropdown.Item = (0, $juu42.default);
var $583bd49bf9b8480b$export$2e2bcd8739ae039 = $583bd49bf9b8480b$var$Dropdown;

});
parcelRegister("95lS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $01b4fe2088fac58b$export$2e2bcd8739ae039);
var $01b4fe2088fac58b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $01b4fe2088fac58b$export$2e2bcd8739ae039(element, selector) {
    return $01b4fe2088fac58b$var$toArray(element.querySelectorAll(selector));
}

});

parcelRegister("9Ebs1", function(module, exports) {

$parcel$export(module.exports, "useUncontrolledProp", () => $7060bb66c8fa08f7$export$2ee51287a16ca325);

var $acw62 = parcelRequire("acw62");
function $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7060bb66c8fa08f7$var$_toPropertyKey(arg) {
    var key = $7060bb66c8fa08f7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7060bb66c8fa08f7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7060bb66c8fa08f7$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $7060bb66c8fa08f7$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $acw62.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $7060bb66c8fa08f7$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $7060bb66c8fa08f7$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($7060bb66c8fa08f7$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $7060bb66c8fa08f7$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}

});

parcelRegister("dkoqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b4016ced1cecfef$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9b4016ced1cecfef$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $acw62.useReducer)((state)=>!state, false);
    return dispatch;
}

});

parcelRegister("bmAm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $845df35e9a3b7033$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $845df35e9a3b7033$var$DropdownContext = /*#__PURE__*/ $acw62.createContext(null);
var $845df35e9a3b7033$export$2e2bcd8739ae039 = $845df35e9a3b7033$var$DropdownContext;

});

parcelRegister("ayLjw", function(module, exports) {

$parcel$export(module.exports, "useDropdownMenu", () => $7b01c7ecb51f8572$export$133c4d08f3775d64);
$parcel$export(module.exports, "default", () => $7b01c7ecb51f8572$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9whQJ = parcelRequire("9whQJ");

var $bmAm9 = parcelRequire("bmAm9");

var $5n9vj = parcelRequire("5n9vj");

var $gshx1 = parcelRequire("gshx1");

var $i521y = parcelRequire("i521y");

var $ayMG0 = parcelRequire("ayMG0");
const $7b01c7ecb51f8572$var$_excluded = [
    "children"
];
function $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $7b01c7ecb51f8572$var$noop = ()=>{};
function $7b01c7ecb51f8572$export$133c4d08f3775d64(options = {}) {
    const context = (0, $acw62.useContext)((0, $bmAm9.default));
    const [arrowElement, attachArrowRef] = (0, $9whQJ.default)();
    const hasShownRef = (0, $acw62.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $5n9vj.default)(toggleElement, menuElement, (0, $i521y.default)({
        placement: placementOverride || placement || "bottom-start",
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $7b01c7ecb51f8572$var$noop,
        "aria-labelledby": toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $gshx1.default)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
const $7b01c7ecb51f8572$var$defaultProps = {
    usePopper: true
};
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $7b01c7ecb51f8572$var$DropdownMenu(_ref) {
    let { children: children } = _ref, options = $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(_ref, $7b01c7ecb51f8572$var$_excluded);
    const [props, meta] = $7b01c7ecb51f8572$export$133c4d08f3775d64(options);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children(props, meta)
    });
}
$7b01c7ecb51f8572$var$DropdownMenu.displayName = "DropdownMenu";
$7b01c7ecb51f8572$var$DropdownMenu.defaultProps = $7b01c7ecb51f8572$var$defaultProps;
var /** @component */ $7b01c7ecb51f8572$export$2e2bcd8739ae039 = $7b01c7ecb51f8572$var$DropdownMenu;

});
parcelRegister("5n9vj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e96790ca7bcc44e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fimmU = parcelRequire("fimmU");

var $9Ubg7 = parcelRequire("9Ubg7");

var $eBJZ0 = parcelRequire("eBJZ0");
const $3e96790ca7bcc44e$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $3e96790ca7bcc44e$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false,
    phase: "afterWrite",
    fn: ()=>undefined
};
// until docjs supports type exports...
const $3e96790ca7bcc44e$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ("removeAttribute" in reference) {
                const ids = (reference.getAttribute("aria-describedby") || "").split(",").filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            const ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $3e96790ca7bcc44e$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $3e96790ca7bcc44e$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = "bottom", strategy: strategy = "absolute", modifiers: modifiers = $3e96790ca7bcc44e$var$EMPTY_MODIFIERS } = _ref, config = $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(_ref, $3e96790ca7bcc44e$var$_excluded);
    const prevModifiers = (0, $acw62.useRef)(modifiers);
    const popperInstanceRef = (0, $acw62.useRef)();
    const update = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $9Ubg7.default)((0, $acw62.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $acw62.useMemo)(()=>({
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $acw62.useMemo)(()=>{
        if (!(0, $fimmU.dequal)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $3e96790ca7bcc44e$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $eBJZ0.createPopper)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $3e96790ca7bcc44e$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $3e96790ca7bcc44e$export$2e2bcd8739ae039 = $3e96790ca7bcc44e$var$usePopper;

});
parcelRegister("fimmU", function(module, exports) {

$parcel$export(module.exports, "dequal", () => $371d31aa64efa655$export$de8294bb3be0322f);
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});

parcelRegister("9Ubg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $736213cceee2e4cc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $kob1U = parcelRequire("kob1U");
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $736213cceee2e4cc$var$useSafeState(state) {
    const isMounted = (0, $kob1U.default)();
    return [
        state[0],
        (0, $acw62.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $736213cceee2e4cc$export$2e2bcd8739ae039 = $736213cceee2e4cc$var$useSafeState;

});

parcelRegister("eBJZ0", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $aa2830a619d3769f$export$8f7491d57c8f97a9);

var $kU5lB = parcelRequire("kU5lB");

var $5ZHwq = parcelRequire("5ZHwq");

var $jU5vk = parcelRequire("jU5vk");

var $hMqHB = parcelRequire("hMqHB");

var $95q7y = parcelRequire("95q7y");

var $lWzyf = parcelRequire("lWzyf");

var $cePA2 = parcelRequire("cePA2");

var $bxdrS = parcelRequire("bxdrS");


var $8iXfp = parcelRequire("8iXfp");
const $aa2830a619d3769f$export$8f7491d57c8f97a9 = (0, $8iXfp.popperGenerator)({
    defaultModifiers: [
        (0, $95q7y.default),
        (0, $cePA2.default),
        (0, $5ZHwq.default),
        (0, $jU5vk.default),
        (0, $lWzyf.default),
        (0, $hMqHB.default),
        (0, $bxdrS.default),
        (0, $kU5lB.default)
    ]
});

});
parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === "html" || (0, $oKPBf.default)(offsetParent) === "body" && (0, $huVQQ.default)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});

parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});

parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});

parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});
parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});
parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === "rtl") x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});

parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === "x" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});


parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});




parcelRegister("gshx1", function(module, exports) {

$parcel$export(module.exports, "getRefTarget", () => $bfacdc492f374f5e$export$347601c75fcd4732);
$parcel$export(module.exports, "default", () => $bfacdc492f374f5e$export$2e2bcd8739ae039);

var $cUYrv = parcelRequire("cUYrv");

var $7YnSj = parcelRequire("7YnSj");

var $lIo3y = parcelRequire("lIo3y");

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");

var $kg9aN = parcelRequire("kg9aN");
const $bfacdc492f374f5e$var$noop = ()=>{};
function $bfacdc492f374f5e$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $bfacdc492f374f5e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $bfacdc492f374f5e$export$347601c75fcd4732 = (ref)=>ref && ("current" in ref ? ref.current : ref);
const $bfacdc492f374f5e$var$InitialTriggerEvents = {
    click: "mousedown",
    mouseup: "mousedown",
    pointerup: "pointerdown"
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $bfacdc492f374f5e$var$useClickOutside(ref, onClickOutside = $bfacdc492f374f5e$var$noop, { disabled: disabled, clickTrigger: clickTrigger = "click" } = {}) {
    const preventMouseClickOutsideRef = (0, $acw62.useRef)(false);
    const waitingForTrigger = (0, $acw62.useRef)(false);
    const handleMouseCapture = (0, $acw62.useCallback)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $bfacdc492f374f5e$var$isModifiedEvent(e) || !$bfacdc492f374f5e$var$isLeftClickEvent(e) || !!(0, $cUYrv.default)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $dsxUx.default)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $cUYrv.default)(currentTarget, e.target)) waitingForTrigger.current = true;
    });
    const handleMouse = (0, $dsxUx.default)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $lIo3y.default)($bfacdc492f374f5e$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $7YnSj.default)(doc, $bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $7YnSj.default)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $7YnSj.default)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $7YnSj.default)(el, "mousemove", $bfacdc492f374f5e$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $bfacdc492f374f5e$export$2e2bcd8739ae039 = $bfacdc492f374f5e$var$useClickOutside;

});
parcelRegister("cUYrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $967999a1a8cec832$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("kg9aN", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $ebfc6adce9fdacf8$var$warning;

});


parcelRegister("i521y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29a438d14321507$export$2e2bcd8739ae039);
function $d29a438d14321507$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $d29a438d14321507$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $d29a438d14321507$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $d29a438d14321507$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $d29a438d14321507$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

});


parcelRegister("fpkzq", function(module, exports) {

$parcel$export(module.exports, "isRoleMenu", () => $02e50cfe922d2ca9$export$386b1213cf9779d8);
$parcel$export(module.exports, "useDropdownToggle", () => $02e50cfe922d2ca9$export$96df6c7c5036b9a2);
$parcel$export(module.exports, "default", () => $02e50cfe922d2ca9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4ZxLq = parcelRequire("4ZxLq");

var $bmAm9 = parcelRequire("bmAm9");

var $ayMG0 = parcelRequire("ayMG0");
const $02e50cfe922d2ca9$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute("role")) == null ? void 0 : _el$getAttribute.toLowerCase()) === "menu";
};
const $02e50cfe922d2ca9$var$noop = ()=>{};
function $02e50cfe922d2ca9$export$96df6c7c5036b9a2() {
    const id = (0, $4ZxLq.useSSRSafeId)();
    const { show: show = false, toggle: toggle = $02e50cfe922d2ca9$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $acw62.useContext)((0, $bmAm9.default)) || {};
    const handleClick = (0, $acw62.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $02e50cfe922d2ca9$var$noop,
        onClick: handleClick,
        "aria-expanded": !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $02e50cfe922d2ca9$export$386b1213cf9779d8(menuElement)) props["aria-haspopup"] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $02e50cfe922d2ca9$var$DropdownToggle({ children: children }) {
    const [props, meta] = $02e50cfe922d2ca9$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children(props, meta)
    });
}
$02e50cfe922d2ca9$var$DropdownToggle.displayName = "DropdownToggle";
var /** @component */ $02e50cfe922d2ca9$export$2e2bcd8739ae039 = $02e50cfe922d2ca9$var$DropdownToggle;

});
parcelRegister("4ZxLq", function(module, exports) {

$parcel$export(module.exports, "useSSRSafeId", () => $3a270cbf4792ab41$export$619500959fc48b26);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $3a270cbf4792ab41$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $3a270cbf4792ab41$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($3a270cbf4792ab41$var$$b5e257d569688ac6$var$defaultContext);
const $3a270cbf4792ab41$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $3a270cbf4792ab41$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($3a270cbf4792ab41$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $3a270cbf4792ab41$var$$b5e257d569688ac6$var$useCounter(cur === $3a270cbf4792ab41$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $3a270cbf4792ab41$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a270cbf4792ab41$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a270cbf4792ab41$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $3a270cbf4792ab41$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $3a270cbf4792ab41$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$3a270cbf4792ab41$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $3a270cbf4792ab41$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a270cbf4792ab41$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $3a270cbf4792ab41$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $3a270cbf4792ab41$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $3a270cbf4792ab41$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($3a270cbf4792ab41$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $3a270cbf4792ab41$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $3a270cbf4792ab41$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $3a270cbf4792ab41$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $3a270cbf4792ab41$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($3a270cbf4792ab41$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $3a270cbf4792ab41$var$$b5e257d569688ac6$var$defaultContext && !$3a270cbf4792ab41$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $3a270cbf4792ab41$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $3a270cbf4792ab41$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($3a270cbf4792ab41$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$3a270cbf4792ab41$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $3a270cbf4792ab41$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $3a270cbf4792ab41$var$$b5e257d569688ac6$var$useModernSSRSafeId : $3a270cbf4792ab41$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $3a270cbf4792ab41$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $3a270cbf4792ab41$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $3a270cbf4792ab41$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $3a270cbf4792ab41$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($3a270cbf4792ab41$var$$b5e257d569688ac6$var$subscribe, $3a270cbf4792ab41$var$$b5e257d569688ac6$var$getSnapshot, $3a270cbf4792ab41$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($3a270cbf4792ab41$var$$b5e257d569688ac6$var$IsSSRContext);
}

});


parcelRegister("juu42", function(module, exports) {

$parcel$export(module.exports, "useDropdownItem", () => $e30823bf64a2218d$export$522d7e1e4e0e22b2);
$parcel$export(module.exports, "default", () => $e30823bf64a2218d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");

var $drkGp = parcelRequire("drkGp");

var $5Ztgc = parcelRequire("5Ztgc");

var $rldgt = parcelRequire("rldgt");

var $1teBw = parcelRequire("1teBw");

var $ayMG0 = parcelRequire("ayMG0");
const $e30823bf64a2218d$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e30823bf64a2218d$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $acw62.useContext)((0, $drkGp.default));
    const navContext = (0, $acw62.useContext)((0, $5Ztgc.default));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $drkGp.makeEventKey)(key, href);
    const isActive = active == null && key != null ? (0, $drkGp.makeEventKey)(activeKey) === eventKey : active;
    const handleClick = (0, $dsxUx.default)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            "aria-disabled": disabled || undefined,
            "aria-selected": isActive,
            [(0, $1teBw.dataAttr)("dropdown-item")]: ""
        },
        {
            isActive: isActive
        }
    ];
}
const $e30823bf64a2218d$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $rldgt.default) } = _ref, props = $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(_ref, $e30823bf64a2218d$var$_excluded);
    const [dropdownItemProps] = $e30823bf64a2218d$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$e30823bf64a2218d$var$DropdownItem.displayName = "DropdownItem";
var $e30823bf64a2218d$export$2e2bcd8739ae039 = $e30823bf64a2218d$var$DropdownItem;

});
parcelRegister("drkGp", function(module, exports) {

$parcel$export(module.exports, "makeEventKey", () => $9c8dd72e635c1db4$export$eef49b42fde998a3);
$parcel$export(module.exports, "default", () => $9c8dd72e635c1db4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $9c8dd72e635c1db4$var$SelectableContext = /*#__PURE__*/ $acw62.createContext(null);
const $9c8dd72e635c1db4$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $9c8dd72e635c1db4$export$2e2bcd8739ae039 = $9c8dd72e635c1db4$var$SelectableContext;

});

parcelRegister("5Ztgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $45c958b882f3532f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $45c958b882f3532f$var$NavContext = /*#__PURE__*/ $acw62.createContext(null);
$45c958b882f3532f$var$NavContext.displayName = "NavContext";
var $45c958b882f3532f$export$2e2bcd8739ae039 = $45c958b882f3532f$var$NavContext;

});

parcelRegister("1teBw", function(module, exports) {

$parcel$export(module.exports, "dataAttr", () => $1123d3fd1f42218c$export$5cc3b7b83e34ade7);
$parcel$export(module.exports, "dataProp", () => $1123d3fd1f42218c$export$7776c0a7cd2eb3e0);
const $1123d3fd1f42218c$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1123d3fd1f42218c$export$635202801f9383a0 = `rrUi`;
function $1123d3fd1f42218c$export$5cc3b7b83e34ade7(property) {
    return `${$1123d3fd1f42218c$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1123d3fd1f42218c$export$7776c0a7cd2eb3e0(property) {
    return `${$1123d3fd1f42218c$export$635202801f9383a0}${property}`;
}

});


parcelRegister("1cXvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e151397e562aebc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7lCBb = parcelRequire("7lCBb");
const $0e151397e562aebc$var$Context = /*#__PURE__*/ (0, $acw62.createContext)((0, $7lCBb.default) ? window : undefined);
const $0e151397e562aebc$export$f7d306aeb1cf5fbc = $0e151397e562aebc$var$Context.Provider;
function $0e151397e562aebc$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)($0e151397e562aebc$var$Context);
}

});


parcelRegister("iWxmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dca786c6a99c4e45$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $dca786c6a99c4e45$var$DropdownContext = /*#__PURE__*/ $acw62.createContext({});
$dca786c6a99c4e45$var$DropdownContext.displayName = "DropdownContext";
var $dca786c6a99c4e45$export$2e2bcd8739ae039 = $dca786c6a99c4e45$var$DropdownContext;

});

parcelRegister("7KIXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a4fb33eeda93525$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5a4fb33eeda93525$var$DropdownDivider = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "hr", role: role = "separator", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "dropdown-divider");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$5a4fb33eeda93525$var$DropdownDivider.displayName = "DropdownDivider";
var $5a4fb33eeda93525$export$2e2bcd8739ae039 = $5a4fb33eeda93525$var$DropdownDivider;

});

parcelRegister("kiZsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec852ac21aa53987$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $ec852ac21aa53987$var$DropdownHeader = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", role: role = "heading", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "dropdown-header");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$ec852ac21aa53987$var$DropdownHeader.displayName = "DropdownHeader";
var $ec852ac21aa53987$export$2e2bcd8739ae039 = $ec852ac21aa53987$var$DropdownHeader;

});

parcelRegister("gLli8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3418d2c4a03af95$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $juu42 = parcelRequire("juu42");

var $dKAJt = parcelRequire("dKAJt");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c3418d2c4a03af95$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $dKAJt.default), ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "dropdown-item");
    const [dropdownItemProps, meta] = (0, $juu42.useDropdownItem)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, meta.isActive && "active", disabled && "disabled")
    });
});
$c3418d2c4a03af95$var$DropdownItem.displayName = "DropdownItem";
var $c3418d2c4a03af95$export$2e2bcd8739ae039 = $c3418d2c4a03af95$var$DropdownItem;

});

parcelRegister("3APFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $29dccf165986723f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $29dccf165986723f$var$DropdownItemText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "dropdown-item-text");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$29dccf165986723f$var$DropdownItemText.displayName = "DropdownItemText";
var $29dccf165986723f$export$2e2bcd8739ae039 = $29dccf165986723f$var$DropdownItemText;

});

parcelRegister("82jyR", function(module, exports) {

$parcel$export(module.exports, "getDropdownMenuPlacement", () => $5d9daf1899b89eeb$export$a2c648e264f4a946);
$parcel$export(module.exports, "default", () => $5d9daf1899b89eeb$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $ayLjw = parcelRequire("ayLjw");

var $8wLL1 = parcelRequire("8wLL1");

var $dvyhD = parcelRequire("dvyhD");
parcelRequire("kg9aN");

var $iWxmO = parcelRequire("iWxmO");

var $j1NGT = parcelRequire("j1NGT");

var $61Zds = parcelRequire("61Zds");

var $8rTrh = parcelRequire("8rTrh");

var $8NFwE = parcelRequire("8NFwE");


var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? "top-end" : "top-start";
    const topEnd = isRTL ? "top-start" : "top-end";
    const bottomStart = isRTL ? "bottom-end" : "bottom-start";
    const bottomEnd = isRTL ? "bottom-start" : "bottom-end";
    const leftStart = isRTL ? "right-start" : "left-start";
    const leftEnd = isRTL ? "right-end" : "left-end";
    const rightStart = isRTL ? "left-start" : "right-start";
    const rightEnd = isRTL ? "left-end" : "right-end";
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === "up") placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === "end") placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === "start") placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === "down-centered") placement = "bottom";
    else if (dropDirection === "up-centered") placement = "top";
    return placement;
}
const $5d9daf1899b89eeb$var$DropdownMenu = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $acw62.useContext)((0, $61Zds.default));
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "dropdown-menu");
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $acw62.useContext)((0, $iWxmO.default));
    align = align || contextAlign;
    const isInputGroup = (0, $acw62.useContext)((0, $j1NGT.default));
    const alignClasses = [];
    if (align) {
        if (typeof align === "object") {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === "start";
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === "end") alignEnd = true;
    }
    const placement = $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $ayLjw.useDropdownMenu)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $dvyhD.default)((0, $8NFwE.default)(ref, "DropdownMenu"), menuProps.ref);
    (0, $8wLL1.default)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== "string") {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props["x-placement"] = popper.placement;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            "data-bs-popper": "static"
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, show && "show", alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$5d9daf1899b89eeb$var$DropdownMenu.displayName = "DropdownMenu";
var $5d9daf1899b89eeb$export$2e2bcd8739ae039 = $5d9daf1899b89eeb$var$DropdownMenu;

});
parcelRegister("j1NGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda4a7e32e3b00d2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $dda4a7e32e3b00d2$var$context = /*#__PURE__*/ $acw62.createContext(null);
$dda4a7e32e3b00d2$var$context.displayName = "InputGroupContext";
var $dda4a7e32e3b00d2$export$2e2bcd8739ae039 = $dda4a7e32e3b00d2$var$context;

});

parcelRegister("61Zds", function(module, exports) {

$parcel$export(module.exports, "default", () => $46425249d1e44fce$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
// TODO: check
const $46425249d1e44fce$var$context = /*#__PURE__*/ $acw62.createContext(null);
$46425249d1e44fce$var$context.displayName = "NavbarContext";
var $46425249d1e44fce$export$2e2bcd8739ae039 = $46425249d1e44fce$var$context;

});

parcelRegister("8NFwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $66831c738b74ab47$export$2e2bcd8739ae039);
parcelRequire("aaXwj");
parcelRequire("acw62");
parcelRequire("dvyhD");
function $66831c738b74ab47$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}

});


parcelRegister("9bD6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b03788ed4f0962b$export$2e2bcd8739ae039);

var $dvyhD = parcelRequire("dvyhD");

var $bmAm9 = parcelRequire("bmAm9");

var $fpkzq = parcelRequire("fpkzq");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $6LAgE = parcelRequire("6LAgE");

var $8rTrh = parcelRequire("8rTrh");

var $8NFwE = parcelRequire("8NFwE");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $6b03788ed4f0962b$var$DropdownToggle = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $6LAgE.default), ...props }, ref)=>{
    const prefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "dropdown-toggle");
    const dropdownContext = (0, $acw62.useContext)((0, $bmAm9.default));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $fpkzq.useDropdownToggle)();
    toggleProps.ref = (0, $dvyhD.default)(toggleProps.ref, (0, $8NFwE.default)(ref, "DropdownToggle"));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && "show"),
        ...toggleProps,
        ...props
    });
});
$6b03788ed4f0962b$var$DropdownToggle.displayName = "DropdownToggle";
var $6b03788ed4f0962b$export$2e2bcd8739ae039 = $6b03788ed4f0962b$var$DropdownToggle;

});


parcelRegister("8CrHJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $64675cdb3851f16c$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $bFeNN = parcelRequire("bFeNN");

var $48fuN = parcelRequire("48fuN");

var $5hxqt = parcelRequire("5hxqt");

var $81OvX = parcelRequire("81OvX");

var $81s7d = parcelRequire("81s7d");

var $fTien = parcelRequire("fTien");

var $azy33 = parcelRequire("azy33");

var $geXd8 = parcelRequire("geXd8");

var $lCsHT = parcelRequire("lCsHT");

var $3k5VR = parcelRequire("3k5VR");

var $ayMG0 = parcelRequire("ayMG0");
const $64675cdb3851f16c$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
};
const $64675cdb3851f16c$var$Form = /*#__PURE__*/ $acw62.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "form", ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, validated && "was-validated")
    }));
$64675cdb3851f16c$var$Form.displayName = "Form";
$64675cdb3851f16c$var$Form.propTypes = $64675cdb3851f16c$var$propTypes;
var $64675cdb3851f16c$export$2e2bcd8739ae039 = Object.assign($64675cdb3851f16c$var$Form, {
    Group: (0, $81OvX.default),
    Control: (0, $48fuN.default),
    Floating: (0, $5hxqt.default),
    Check: (0, $bFeNN.default),
    Switch: $lCsHT.default,
    Label: (0, $81s7d.default),
    Text: (0, $geXd8.default),
    Range: (0, $fTien.default),
    Select: (0, $azy33.default),
    FloatingLabel: $3k5VR.default
});

});
parcelRegister("bFeNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $87df01720ec94e93$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $2pRbH = parcelRequire("2pRbH");

var $9JAYi = parcelRequire("9JAYi");

var $fapzY = parcelRequire("fapzY");

var $bALFW = parcelRequire("bALFW");

var $8rTrh = parcelRequire("8rTrh");

var $iaLOT = parcelRequire("iaLOT");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $87df01720ec94e93$var$FormCheck = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = "", type: type = "checkbox", label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = "input", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $8rTrh.useBootstrapPrefix)(bsSwitchPrefix, "form-switch");
    const { controlId: controlId } = (0, $acw62.useContext)((0, $bALFW.default));
    const innerFormContext = (0, $acw62.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $iaLOT.hasChildOfType)(children, (0, $fapzY.default));
    const input = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9JAYi.default), {
        ...props,
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bALFW.default).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fapzY.default), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2pRbH.default), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$87df01720ec94e93$var$FormCheck.displayName = "FormCheck";
var $87df01720ec94e93$export$2e2bcd8739ae039 = Object.assign($87df01720ec94e93$var$FormCheck, {
    Input: (0, $9JAYi.default),
    Label: (0, $fapzY.default)
});

});
parcelRegister("2pRbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c272c8c9427e0c0$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");
const $1c272c8c9427e0c0$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
};
const $1c272c8c9427e0c0$var$Feedback = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = "div", className: className, type: type = "valid", tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, `${type}-${tooltip ? "tooltip" : "feedback"}`)
    }));
$1c272c8c9427e0c0$var$Feedback.displayName = "Feedback";
$1c272c8c9427e0c0$var$Feedback.propTypes = $1c272c8c9427e0c0$var$propTypes;
var $1c272c8c9427e0c0$export$2e2bcd8739ae039 = $1c272c8c9427e0c0$var$Feedback;

});

parcelRegister("fapzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0aba1aace6996b7$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $bALFW = parcelRequire("bALFW");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $b0aba1aace6996b7$var$FormCheckLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $bALFW.default));
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix)
    });
});
$b0aba1aace6996b7$var$FormCheckLabel.displayName = "FormCheckLabel";
var $b0aba1aace6996b7$export$2e2bcd8739ae039 = $b0aba1aace6996b7$var$FormCheckLabel;

});

parcelRegister("iaLOT", function(module, exports) {

$parcel$export(module.exports, "map", () => $d3ae4136892dd278$export$871de8747c9eaa88);
$parcel$export(module.exports, "forEach", () => $d3ae4136892dd278$export$4b80e395e36b5a56);
$parcel$export(module.exports, "hasChildOfType", () => $d3ae4136892dd278$export$500fd6099226ffae);

var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}

});


parcelRegister("48fuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3023ede31d3d1660$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("kg9aN");

var $2pRbH = parcelRequire("2pRbH");

var $bALFW = parcelRequire("bALFW");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $3023ede31d3d1660$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $bALFW.default));
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-control");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === "color" && `${bsPrefix}-color`, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$3023ede31d3d1660$var$FormControl.displayName = "FormControl";
var $3023ede31d3d1660$export$2e2bcd8739ae039 = Object.assign($3023ede31d3d1660$var$FormControl, {
    Feedback: $2pRbH.default
});

});

parcelRegister("5hxqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d8877fa5535421d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $3d8877fa5535421d$var$FormFloating = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$3d8877fa5535421d$var$FormFloating.displayName = "FormFloating";
var $3d8877fa5535421d$export$2e2bcd8739ae039 = $3d8877fa5535421d$var$FormFloating;

});

parcelRegister("81OvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d8599dc34b64b39$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $bALFW = parcelRequire("bALFW");

var $ayMG0 = parcelRequire("ayMG0");
const $5d8599dc34b64b39$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const context = (0, $acw62.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bALFW.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$5d8599dc34b64b39$var$FormGroup.displayName = "FormGroup";
var $5d8599dc34b64b39$export$2e2bcd8739ae039 = $5d8599dc34b64b39$var$FormGroup;

});

parcelRegister("81s7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7439d74bf97ebc$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("kg9aN");

var $99eL8 = parcelRequire("99eL8");

var $bALFW = parcelRequire("bALFW");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5d7439d74bf97ebc$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "label", bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $bALFW.default));
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-label");
    let columnClass = "col-form-label";
    if (typeof column === "string") columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$5d7439d74bf97ebc$var$FormLabel.displayName = "FormLabel";
var $5d7439d74bf97ebc$export$2e2bcd8739ae039 = $5d7439d74bf97ebc$var$FormLabel;

});

parcelRegister("fTien", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91a225b00146fdd$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $bALFW = parcelRequire("bALFW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $b91a225b00146fdd$var$FormRange = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $bALFW.default));
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        id: id || controlId
    });
});
$b91a225b00146fdd$var$FormRange.displayName = "FormRange";
var $b91a225b00146fdd$export$2e2bcd8739ae039 = $b91a225b00146fdd$var$FormRange;

});

parcelRegister("azy33", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b27958f5a457ab6$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $bALFW = parcelRequire("bALFW");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7b27958f5a457ab6$var$FormSelect = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $bALFW.default));
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$7b27958f5a457ab6$var$FormSelect.displayName = "FormSelect";
var $7b27958f5a457ab6$export$2e2bcd8739ae039 = $7b27958f5a457ab6$var$FormSelect;

});

parcelRegister("geXd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd2be22fa282ca4a$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $bd2be22fa282ca4a$var$FormText = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = "small", muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, muted && "text-muted")
    });
});
$bd2be22fa282ca4a$var$FormText.displayName = "FormText";
var $bd2be22fa282ca4a$export$2e2bcd8739ae039 = $bd2be22fa282ca4a$var$FormText;

});

parcelRegister("lCsHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd36a2b679cb998$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $bFeNN = parcelRequire("bFeNN");

var $ayMG0 = parcelRequire("ayMG0");
const $fbd36a2b679cb998$var$Switch = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bFeNN.default), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$fbd36a2b679cb998$var$Switch.displayName = "Switch";
var $fbd36a2b679cb998$export$2e2bcd8739ae039 = Object.assign($fbd36a2b679cb998$var$Switch, {
    Input: (0, $bFeNN.default).Input,
    Label: (0, $bFeNN.default).Label
});

});

parcelRegister("3k5VR", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b7d75a1da62deb$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $81OvX = parcelRequire("81OvX");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $26b7d75a1da62deb$var$FloatingLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $81OvX.default), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$26b7d75a1da62deb$var$FloatingLabel.displayName = "FloatingLabel";
var $26b7d75a1da62deb$export$2e2bcd8739ae039 = $26b7d75a1da62deb$var$FloatingLabel;

});


parcelRegister("6WSsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f26667fbf3b753$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $9JAYi = parcelRequire("9JAYi");

var $j1NGT = parcelRequire("j1NGT");

var $eDa1v = parcelRequire("eDa1v");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $50f26667fbf3b753$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDa1v.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9JAYi.default), {
            type: "checkbox",
            ...props
        })
    });
const $50f26667fbf3b753$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDa1v.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9JAYi.default), {
            type: "radio",
            ...props
        })
    });
const $50f26667fbf3b753$var$InputGroup = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "input-group");
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $acw62.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j1NGT.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && "has-validation")
        })
    });
});
$50f26667fbf3b753$var$InputGroup.displayName = "InputGroup";
var $50f26667fbf3b753$export$2e2bcd8739ae039 = Object.assign($50f26667fbf3b753$var$InputGroup, {
    Text: (0, $eDa1v.default),
    Radio: $50f26667fbf3b753$var$InputGroupRadio,
    Checkbox: $50f26667fbf3b753$var$InputGroupCheckbox
});

});
parcelRegister("eDa1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa6c7b9d31e9cfee$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $aa6c7b9d31e9cfee$var$InputGroupText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "input-group-text");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$aa6c7b9d31e9cfee$var$InputGroupText.displayName = "InputGroupText";
var $aa6c7b9d31e9cfee$export$2e2bcd8739ae039 = $aa6c7b9d31e9cfee$var$InputGroupText;

});


parcelRegister("gBH4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $c17184070610a5f4$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $3shzr = parcelRequire("3shzr");

var $7lCBb = parcelRequire("7lCBb");

var $lIo3y = parcelRequire("lIo3y");

var $7J0wn = parcelRequire("7J0wn");

var $3Se4L = parcelRequire("3Se4L");

var $9whQJ = parcelRequire("9whQJ");

var $dsxUx = parcelRequire("dsxUx");

var $dvyhD = parcelRequire("dvyhD");

var $8xDUK = parcelRequire("8xDUK");

var $4VxHp = parcelRequire("4VxHp");

var $acw62 = parcelRequire("acw62");

var $7J9Sm = parcelRequire("7J9Sm");

var $kBJTi = parcelRequire("kBJTi");

var $7BpMa = parcelRequire("7BpMa");

var $3e2kQ = parcelRequire("3e2kQ");

var $hHDKi = parcelRequire("hHDKi");

var $flZCY = parcelRequire("flZCY");

var $dodCm = parcelRequire("dodCm");

var $fjsq5 = parcelRequire("fjsq5");

var $4Y7Cc = parcelRequire("4Y7Cc");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $c17184070610a5f4$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7BpMa.default), {
        ...props,
        timeout: null
    });
}
function $c17184070610a5f4$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7BpMa.default), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $c17184070610a5f4$var$Modal = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $flZCY.default), "data-bs-theme": dataBsTheme, "aria-labelledby": ariaLabelledby, "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $acw62.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $acw62.useState)(false);
    const waitingForMouseUpRef = (0, $acw62.useRef)(false);
    const ignoreBackdropClickRef = (0, $acw62.useRef)(false);
    const removeStaticModalAnimationRef = (0, $acw62.useRef)(null);
    const [modal, setModalRef] = (0, $9whQJ.default)();
    const mergedRef = (0, $dvyhD.default)(ref, setModalRef);
    const handleHide = (0, $dsxUx.default)(onHide);
    const isRTL = (0, $8rTrh.useIsRTL)();
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "modal");
    const modalContext = (0, $acw62.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $kBJTi.getSharedManager)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $7lCBb.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $lIo3y.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $3Se4L.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $3Se4L.default)() : undefined
        });
    }
    const handleWindowResize = (0, $dsxUx.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $8xDUK.default)(()=>{
        (0, $7J0wn.default)(window, "resize", handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $4VxHp.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === "static") {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === "static") // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $3shzr.default)(window, "resize", handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ""; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $7J0wn.default)(window, "resize", handleWindowResize);
    };
    const renderBackdrop = (0, $acw62.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && "show")
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = "block";
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && "show"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHDKi.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7J9Sm.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $c17184070610a5f4$var$DialogTransition : undefined,
            backdropTransition: animation ? $c17184070610a5f4$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$c17184070610a5f4$var$Modal.displayName = "Modal";
var $c17184070610a5f4$export$2e2bcd8739ae039 = Object.assign($c17184070610a5f4$var$Modal, {
    Body: (0, $3e2kQ.default),
    Header: (0, $fjsq5.default),
    Title: (0, $4Y7Cc.default),
    Footer: (0, $dodCm.default),
    Dialog: (0, $flZCY.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

});
parcelRegister("3Se4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d215567a00cb0b5$export$2e2bcd8739ae039);

var $7lCBb = parcelRequire("7lCBb");
var $2d215567a00cb0b5$var$size;
function $2d215567a00cb0b5$export$2e2bcd8739ae039(recalc) {
    if (!$2d215567a00cb0b5$var$size && $2d215567a00cb0b5$var$size !== 0 || recalc) {
        if (0, $7lCBb.default) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $2d215567a00cb0b5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $2d215567a00cb0b5$var$size;
}

});

parcelRegister("8xDUK", function(module, exports) {

$parcel$export(module.exports, "default", () => $63805df80cf3ca43$export$2e2bcd8739ae039);

var $8qtQJ = parcelRequire("8qtQJ");

var $acw62 = parcelRequire("acw62");
function $63805df80cf3ca43$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $8qtQJ.default)(fn);
    (0, $acw62.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("8qtQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6227e7ea0d71afb1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $6227e7ea0d71afb1$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("7J9Sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0173af0e859d9b0f$export$2e2bcd8739ae039);

var $i47Tf = parcelRequire("i47Tf");

var $cUYrv = parcelRequire("cUYrv");

var $7lCBb = parcelRequire("7lCBb");

var $7YnSj = parcelRequire("7YnSj");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $kob1U = parcelRequire("kob1U");

var $8xDUK = parcelRequire("8xDUK");

var $d1b47 = parcelRequire("d1b47");

var $dsxUx = parcelRequire("dsxUx");

var $3cumy = parcelRequire("3cumy");

var $26MZC = parcelRequire("26MZC");

var $1cXvU = parcelRequire("1cXvU");

var $bzCBy = parcelRequire("bzCBy");

var $e1WyV = parcelRequire("e1WyV");

var $ayMG0 = parcelRequire("ayMG0");
const $0173af0e859d9b0f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $0173af0e859d9b0f$var$manager;
function $0173af0e859d9b0f$var$getManager(window) {
    if (!$0173af0e859d9b0f$var$manager) $0173af0e859d9b0f$var$manager = new (0, $3cumy.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $0173af0e859d9b0f$var$manager;
}
function $0173af0e859d9b0f$var$useModalManager(provided) {
    const window = (0, $1cXvU.default)();
    const modalManager = provided || $0173af0e859d9b0f$var$getManager(window);
    const modal = (0, $acw62.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $0173af0e859d9b0f$var$Modal = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = "dialog", className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(_ref, $0173af0e859d9b0f$var$_excluded);
    const ownerWindow = (0, $1cXvU.default)();
    const container = (0, $26MZC.default)(containerRef);
    const modal = $0173af0e859d9b0f$var$useModalManager(providedManager);
    const isMounted = (0, $kob1U.default)();
    const prevShow = (0, $d1b47.default)(show);
    const [exited, setExited] = (0, $acw62.useState)(!show);
    const lastFocusRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $7lCBb.default) && !prevShow && show) lastFocusRef.current = (0, $i47Tf.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $dsxUx.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $7YnSj.default)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $7YnSj.default)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $i47Tf.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $cUYrv.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $dsxUx.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $acw62.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $acw62.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $8xDUK.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $dsxUx.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $i47Tf.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $cUYrv.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $dsxUx.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $dsxUx.default)((e)=>{
        if (keyboard && (0, $e1WyV.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $acw62.useRef)();
    const removeKeydownListenerRef = (0, $acw62.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $bzCBy.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $bzCBy.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$0173af0e859d9b0f$var$Modal.displayName = "Modal";
var $0173af0e859d9b0f$export$2e2bcd8739ae039 = Object.assign($0173af0e859d9b0f$var$Modal, {
    Manager: (0, $3cumy.default)
});

});
parcelRegister("i47Tf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26eb8849281a3d4$export$2e2bcd8739ae039);

var $lIo3y = parcelRequire("lIo3y");
function $d26eb8849281a3d4$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $lIo3y.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

});

parcelRegister("3cumy", function(module, exports) {

$parcel$export(module.exports, "default", () => $254a0b83be45660e$export$2e2bcd8739ae039);

var $2voRd = parcelRequire("2voRd");

var $1teBw = parcelRequire("1teBw");

var $92zlG = parcelRequire("92zlG");
const $254a0b83be45660e$export$1a88c12b8b979fa0 = (0, $1teBw.dataAttr)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $254a0b83be45660e$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $92zlG.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $2voRd.default)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($254a0b83be45660e$export$1a88c12b8b979fa0, "");
        (0, $2voRd.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($254a0b83be45660e$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $254a0b83be45660e$export$2e2bcd8739ae039 = $254a0b83be45660e$var$ModalManager;

});
parcelRegister("92zlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $01b2d58e52126803$export$2e2bcd8739ae039);
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $01b2d58e52126803$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

});


parcelRegister("26MZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1892253eb6d46162$export$2e2bcd8739ae039);

var $lIo3y = parcelRequire("lIo3y");

var $7lCBb = parcelRequire("7lCBb");

var $acw62 = parcelRequire("acw62");

var $1cXvU = parcelRequire("1cXvU");
const $1892253eb6d46162$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $7lCBb.default)) return null;
    if (ref == null) return (document || (0, $lIo3y.default)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $1892253eb6d46162$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $1cXvU.default)();
    const [resolvedRef, setRef] = (0, $acw62.useState)(()=>$1892253eb6d46162$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $acw62.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const nextRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});

parcelRegister("bzCBy", function(module, exports) {

$parcel$export(module.exports, "renderTransition", () => $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5);

var $dvyhD = parcelRequire("dvyhD");

var $dsxUx = parcelRequire("dsxUx");

var $8wLL1 = parcelRequire("8wLL1");

var $acw62 = parcelRequire("acw62");

var $biDDE = parcelRequire("biDDE");

var $54rmF = parcelRequire("54rmF");

var $ayMG0 = parcelRequire("ayMG0");
function $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $acw62.useRef)(null);
    const isInitialRef = (0, $acw62.useRef)(true);
    const handleTransition = (0, $dsxUx.default)(onTransition);
    (0, $8wLL1.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $8wLL1.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $86d0e8a9dc3b2e91$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $acw62.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $dvyhD.default)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
}
function $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54rmF.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $ayMG0.jsx)($86d0e8a9dc3b2e91$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biDDE.default), Object.assign({}, props));
}

});
parcelRegister("biDDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $83a01f83dd44ef33$export$2e2bcd8739ae039);

var $dsxUx = parcelRequire("dsxUx");

var $dvyhD = parcelRequire("dvyhD");

var $acw62 = parcelRequire("acw62");
function $83a01f83dd44ef33$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $acw62.useRef)(null);
    const hasEnteredRef = (0, $acw62.useRef)(inProp);
    const handleExited = (0, $dsxUx.default)(onExited);
    (0, $acw62.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $dvyhD.default)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $83a01f83dd44ef33$export$2e2bcd8739ae039 = $83a01f83dd44ef33$var$NoopTransition;

});

parcelRegister("54rmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b128d8465760c69$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $liP8S = parcelRequire("liP8S");

var $ayMG0 = parcelRequire("ayMG0");
const $3b128d8465760c69$var$_excluded = [
    "component"
];
function $3b128d8465760c69$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Normalizes Transition callbacks when nodeRef is used.
const $3b128d8465760c69$var$RTGTransition = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $3b128d8465760c69$var$_objectWithoutPropertiesLoose(_ref, $3b128d8465760c69$var$_excluded);
    const transitionProps = (0, $liP8S.default)(props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $3b128d8465760c69$export$2e2bcd8739ae039 = $3b128d8465760c69$var$RTGTransition;

});
parcelRegister("liP8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f822f32dd67fcc9c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dvyhD = parcelRequire("dvyhD");
const $f822f32dd67fcc9c$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $f822f32dd67fcc9c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f822f32dd67fcc9c$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $f822f32dd67fcc9c$var$_objectWithoutPropertiesLoose(_ref, $f822f32dd67fcc9c$var$_excluded);
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $dvyhD.default)(nodeRef, typeof children === "function" ? null : children.ref);
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

});



parcelRegister("e1WyV", function(module, exports) {

$parcel$export(module.exports, "isEscKey", () => $a36e95ee292bed8b$export$806fcc22e55e107d);
/* eslint-disable import/prefer-default-export */ function $a36e95ee292bed8b$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}

});


parcelRegister("kBJTi", function(module, exports) {

$parcel$export(module.exports, "getSharedManager", () => $f00adc503d5cecaf$export$a03641438014b436);

var $8pZ1o = parcelRequire("8pZ1o");

var $2voRd = parcelRequire("2voRd");

var $95lS5 = parcelRequire("95lS5");

var $gFyrF = parcelRequire("gFyrF");

var $3cumy = parcelRequire("3cumy");
const $f00adc503d5cecaf$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $f00adc503d5cecaf$var$BootstrapModalManager extends (0, $3cumy.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $2voRd.default)(element, {
            [prop]: `${parseFloat((0, $2voRd.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $2voRd.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $8pZ1o.default)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $95lS5.default)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $95lS5.default)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $95lS5.default)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $gFyrF.default)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $95lS5.default)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $95lS5.default)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $95lS5.default)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $f00adc503d5cecaf$var$sharedManager;
function $f00adc503d5cecaf$export$a03641438014b436(options) {
    if (!$f00adc503d5cecaf$var$sharedManager) $f00adc503d5cecaf$var$sharedManager = new $f00adc503d5cecaf$var$BootstrapModalManager(options);
    return $f00adc503d5cecaf$var$sharedManager;
}
var $f00adc503d5cecaf$export$2e2bcd8739ae039 = $f00adc503d5cecaf$var$BootstrapModalManager;

});
parcelRegister("8pZ1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $620ffe1c3bcccf8e$export$2e2bcd8739ae039);

var $59GJ0 = parcelRequire("59GJ0");
function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $59GJ0.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("59GJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0eef4e7b8d3866$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("gFyrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22b31c675df16bf$export$2e2bcd8739ae039);
function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});


parcelRegister("3e2kQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25947da381dd154d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $25947da381dd154d$var$ModalBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "modal-body");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$25947da381dd154d$var$ModalBody.displayName = "ModalBody";
var $25947da381dd154d$export$2e2bcd8739ae039 = $25947da381dd154d$var$ModalBody;

});

parcelRegister("hHDKi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce35488230cbfb2e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $ce35488230cbfb2e$var$ModalContext = /*#__PURE__*/ $acw62.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $ce35488230cbfb2e$export$2e2bcd8739ae039 = $ce35488230cbfb2e$var$ModalContext;

});

parcelRegister("flZCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d89f22a8b39e63$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $b2d89f22a8b39e63$var$ModalDialog = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "modal");
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === "string" ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$b2d89f22a8b39e63$var$ModalDialog.displayName = "ModalDialog";
var $b2d89f22a8b39e63$export$2e2bcd8739ae039 = $b2d89f22a8b39e63$var$ModalDialog;

});

parcelRegister("dodCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf8146dd7a62ed4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $9bf8146dd7a62ed4$var$ModalFooter = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "modal-footer");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$9bf8146dd7a62ed4$var$ModalFooter.displayName = "ModalFooter";
var $9bf8146dd7a62ed4$export$2e2bcd8739ae039 = $9bf8146dd7a62ed4$var$ModalFooter;

});

parcelRegister("fjsq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b25eacf4397cf179$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $aTdSA = parcelRequire("aTdSA");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $b25eacf4397cf179$var$ModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "modal-header");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTdSA.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$b25eacf4397cf179$var$ModalHeader.displayName = "ModalHeader";
var $b25eacf4397cf179$export$2e2bcd8739ae039 = $b25eacf4397cf179$var$ModalHeader;

});
parcelRegister("aTdSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed9ce9ab3e9405e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");

var $77pHI = parcelRequire("77pHI");

var $hHDKi = parcelRequire("hHDKi");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $7ed9ce9ab3e9405e$var$AbstractModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $hHDKi.default));
    const handleClick = (0, $dsxUx.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77pHI.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $7ed9ce9ab3e9405e$export$2e2bcd8739ae039 = $7ed9ce9ab3e9405e$var$AbstractModalHeader;

});


parcelRegister("4Y7Cc", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e2ac330b33f57e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $4gthj = parcelRequire("4gthj");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $39e2ac330b33f57e$var$DivStyledAsH4 = (0, $4gthj.default)("h4");
const $39e2ac330b33f57e$var$ModalTitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $39e2ac330b33f57e$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "modal-title");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$39e2ac330b33f57e$var$ModalTitle.displayName = "ModalTitle";
var $39e2ac330b33f57e$export$2e2bcd8739ae039 = $39e2ac330b33f57e$var$ModalTitle;

});


parcelRegister("eBMdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa29ebe1e6d9cd49$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("7u2go");

var $acw62 = parcelRequire("acw62");
parcelRequire("4pN5t");
var $7yCAN = parcelRequire("7yCAN");

var $gjdlu = parcelRequire("gjdlu");

var $8rTrh = parcelRequire("8rTrh");

var $61Zds = parcelRequire("61Zds");

var $881NI = parcelRequire("881NI");

var $fpJLk = parcelRequire("fpJLk");

var $caxsr = parcelRequire("caxsr");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $aa29ebe1e6d9cd49$var$Nav = /*#__PURE__*/ $acw62.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = "div", bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $7yCAN.default)(uncontrolledProps, {
        activeKey: "onSelect"
    });
    const bsPrefix = (0, $8rTrh.useBootstrapPrefix)(initialBsPrefix, "nav");
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $acw62.useContext)((0, $61Zds.default));
    const cardHeaderContext = (0, $acw62.useContext)((0, $881NI.default));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gjdlu.default), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$aa29ebe1e6d9cd49$var$Nav.displayName = "Nav";
var $aa29ebe1e6d9cd49$export$2e2bcd8739ae039 = Object.assign($aa29ebe1e6d9cd49$var$Nav, {
    Item: (0, $fpJLk.default),
    Link: (0, $caxsr.default)
});

});
parcelRegister("7u2go", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $572d173155431dc3$var$all;

var $9gx1l = parcelRequire("9gx1l");
var $572d173155431dc3$var$_createChainableTypeChecker2 = $572d173155431dc3$var$_interopRequireDefault($9gx1l);
function $572d173155431dc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $572d173155431dc3$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $572d173155431dc3$var$_createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = module.exports["default"];

});
parcelRegister("9gx1l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bef38e8094f8c50$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $6bef38e8094f8c50$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
module.exports = module.exports["default"];

});


parcelRegister("gjdlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdf8c5d517fb941c$export$2e2bcd8739ae039);

var $95lS5 = parcelRequire("95lS5");

var $acw62 = parcelRequire("acw62");

var $dkoqn = parcelRequire("dkoqn");

var $dvyhD = parcelRequire("dvyhD");

var $5Ztgc = parcelRequire("5Ztgc");

var $drkGp = parcelRequire("drkGp");

var $fINhF = parcelRequire("fINhF");

var $1teBw = parcelRequire("1teBw");

var $4hpi3 = parcelRequire("4hpi3");

var $ayMG0 = parcelRequire("ayMG0");
const $bdf8c5d517fb941c$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $bdf8c5d517fb941c$var$noop = ()=>{};
const $bdf8c5d517fb941c$var$EVENT_KEY_ATTR = (0, $1teBw.dataAttr)("event-key");
const $bdf8c5d517fb941c$var$Nav = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(_ref, $bdf8c5d517fb941c$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $dkoqn.default)();
    const needsRefocusRef = (0, $acw62.useRef)(false);
    const parentOnSelect = (0, $acw62.useContext)((0, $drkGp.default));
    const tabContext = (0, $acw62.useContext)((0, $fINhF.default));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || "tablist";
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $acw62.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $95lS5.default)(currentListNode, `[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector("[aria-selected=true]");
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                nextActiveChild = getNextActiveTab(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $1teBw.dataProp)("EventKey")] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $acw62.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $dvyhD.default)(ref, listNode);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drkGp.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ztgc.default).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $drkGp.makeEventKey)(activeKey),
                getControlledId: getControlledId || $bdf8c5d517fb941c$var$noop,
                getControllerId: getControllerId || $bdf8c5d517fb941c$var$noop
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$bdf8c5d517fb941c$var$Nav.displayName = "Nav";
var $bdf8c5d517fb941c$export$2e2bcd8739ae039 = Object.assign($bdf8c5d517fb941c$var$Nav, {
    Item: (0, $4hpi3.default)
});

});
parcelRegister("fINhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b72131d84963b3ba$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $b72131d84963b3ba$var$TabContext = /*#__PURE__*/ $acw62.createContext(null);
var $b72131d84963b3ba$export$2e2bcd8739ae039 = $b72131d84963b3ba$var$TabContext;

});

parcelRegister("4hpi3", function(module, exports) {

$parcel$export(module.exports, "useNavItem", () => $31dc5e0f2f162e1f$export$d7a68693710982a);
$parcel$export(module.exports, "default", () => $31dc5e0f2f162e1f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");

var $5Ztgc = parcelRequire("5Ztgc");

var $drkGp = parcelRequire("drkGp");

var $rldgt = parcelRequire("rldgt");

var $1teBw = parcelRequire("1teBw");

var $fINhF = parcelRequire("fINhF");

var $ayMG0 = parcelRequire("ayMG0");
const $31dc5e0f2f162e1f$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $31dc5e0f2f162e1f$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $acw62.useContext)((0, $drkGp.default));
    const navContext = (0, $acw62.useContext)((0, $5Ztgc.default));
    const tabContext = (0, $acw62.useContext)((0, $fINhF.default));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === "tablist") props.role = "tab";
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $1teBw.dataAttr)("event-key")] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props["aria-controls"] = contextControlledId;
    }
    if (props.role === "tab") {
        props["aria-selected"] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props["aria-disabled"] = true;
        }
    }
    props.onClick = (0, $dsxUx.default)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $31dc5e0f2f162e1f$var$NavItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $rldgt.default), active: active, eventKey: eventKey } = _ref, options = $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(_ref, $31dc5e0f2f162e1f$var$_excluded);
    const [props, meta] = $31dc5e0f2f162e1f$export$d7a68693710982a(Object.assign({
        key: (0, $drkGp.makeEventKey)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $1teBw.dataAttr)("active")] = meta.isActive;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$31dc5e0f2f162e1f$var$NavItem.displayName = "NavItem";
var $31dc5e0f2f162e1f$export$2e2bcd8739ae039 = $31dc5e0f2f162e1f$var$NavItem;

});


parcelRegister("fpJLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38cb042d7fdd569$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $b38cb042d7fdd569$var$NavItem = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "nav-item");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$b38cb042d7fdd569$var$NavItem.displayName = "NavItem";
var $b38cb042d7fdd569$export$2e2bcd8739ae039 = $b38cb042d7fdd569$var$NavItem;

});

parcelRegister("caxsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dc05f39bc918f56$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $dKAJt = parcelRequire("dKAJt");

var $4hpi3 = parcelRequire("4hpi3");

var $drkGp = parcelRequire("drkGp");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $8dc05f39bc918f56$var$NavLink = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $dKAJt.default), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "nav-link");
    const [navItemProps, meta] = (0, $4hpi3.useNavItem)({
        key: (0, $drkGp.makeEventKey)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, disabled && "disabled", meta.isActive && "active")
    });
});
$8dc05f39bc918f56$var$NavLink.displayName = "NavLink";
var $8dc05f39bc918f56$export$2e2bcd8739ae039 = $8dc05f39bc918f56$var$NavLink;

});


parcelRegister("5o2go", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ec0f3191f4dead1$export$2e2bcd8739ae039);

var $cUYrv = parcelRequire("cUYrv");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $aMKOh = parcelRequire("aMKOh");
parcelRequire("kg9aN");
parcelRequire("4pN5t");
var $7yCAN = parcelRequire("7yCAN");

var $dvyhD = parcelRequire("dvyhD");

var $lvcVC = parcelRequire("lvcVC");

var $a59eu = parcelRequire("a59eu");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $3ec0f3191f4dead1$var$normalizeDelay(delay) {
    return delay && typeof delay === "object" ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $3ec0f3191f4dead1$var$handleMouseOverOut(// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $cUYrv.default)(target, related)) handler(...args);
}
const $3ec0f3191f4dead1$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
    "click",
    "hover",
    "focus"
]);
const $3ec0f3191f4dead1$var$OverlayTrigger = ({ trigger: trigger = [
    "hover",
    "focus"
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf("auto") !== -1, ...props })=>{
    const triggerNodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $dvyhD.default)(triggerNodeRef, children.ref);
    const timeout = (0, $aMKOh.default)();
    const hoverStateRef = (0, $acw62.useRef)("");
    const [show, setShow] = (0, $7yCAN.useUncontrolledProp)(propsShow, defaultShow, onToggle);
    const delay = $3ec0f3191f4dead1$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== "function" ? $acw62.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $a59eu.default)(r));
    };
    const handleShow = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "show";
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "show") setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "hide";
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "hide") setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $acw62.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $acw62.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $acw62.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleShow, args, "fromElement");
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleHide, args, "toElement");
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf("click") !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf("focus") !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf("hover") !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            typeof children === "function" ? children(triggerProps) : /*#__PURE__*/ (0, $acw62.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lvcVC.default), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $3ec0f3191f4dead1$export$2e2bcd8739ae039 = $3ec0f3191f4dead1$var$OverlayTrigger;

});
parcelRegister("aMKOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da2b291db98759b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $kob1U = parcelRequire("kob1U");

var $8xDUK = parcelRequire("8xDUK");
/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $7da2b291db98759b$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $7da2b291db98759b$var$MAX_DELAY_MS);
}
function $7da2b291db98759b$export$2e2bcd8739ae039() {
    const isMounted = (0, $kob1U.default)();
    // types are confused between node and web here IDK
    const handleRef = (0, $acw62.useRef)();
    (0, $8xDUK.default)(()=>clearTimeout(handleRef.current));
    return (0, $acw62.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}

});

parcelRegister("lvcVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa76858134013112$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $cGPVv = parcelRequire("cGPVv");

var $dsxUx = parcelRequire("dsxUx");

var $8wLL1 = parcelRequire("8wLL1");

var $dvyhD = parcelRequire("dvyhD");

var $7ey4e = parcelRequire("7ey4e");

var $7BpMa = parcelRequire("7BpMa");

var $a59eu = parcelRequire("a59eu");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $fa76858134013112$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $a59eu.default)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $a59eu.default)(r)));
}
const $fa76858134013112$var$Overlay = /*#__PURE__*/ $acw62.forwardRef(({ children: overlay, transition: transition = (0, $7BpMa.default), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = "top", show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $acw62.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $acw62.useState)(null);
    const [ref, modifiers] = (0, $7ey4e.default)(outerProps.offset);
    const mergedRef = (0, $dvyhD.default)(outerRef, ref);
    const actualTransition = transition === true ? (0, $7BpMa.default) : transition || undefined;
    const handleFirstUpdate = (0, $dsxUx.default)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $8wLL1.default)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cGPVv.default), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state, _popperObj$state$modi;
            $fa76858134013112$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null ? void 0 : (_popperObj$state = popperObj.state) == null ? void 0 : (_popperObj$state$modi = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state$modi.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === "function") return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: "show"
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $acw62.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlay.props.className, !transition && show && "show"),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$fa76858134013112$var$Overlay.displayName = "Overlay";
var $fa76858134013112$export$2e2bcd8739ae039 = $fa76858134013112$var$Overlay;

});
parcelRegister("cGPVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d1afca8879b95a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $9whQJ = parcelRequire("9whQJ");

var $dvyhD = parcelRequire("dvyhD");

var $5n9vj = parcelRequire("5n9vj");

var $jVgRl = parcelRequire("jVgRl");

var $26MZC = parcelRequire("26MZC");

var $i521y = parcelRequire("i521y");

var $bzCBy = parcelRequire("bzCBy");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $93d1afca8879b95a$var$Overlay = /*#__PURE__*/ $acw62.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $9whQJ.default)();
    const [arrowElement, attachArrowRef] = (0, $9whQJ.default)();
    const mergedRef = (0, $dvyhD.default)(attachRef, outerRef);
    const container = (0, $26MZC.default)(props.container);
    const target = (0, $26MZC.default)(props.target);
    const [exited, setExited] = (0, $acw62.useState)(!props.show);
    const popper = (0, $5n9vj.default)(target, rootElement, (0, $i521y.default)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $jVgRl.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $bzCBy.renderTransition)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(child, container) : null;
});
$93d1afca8879b95a$var$Overlay.displayName = "Overlay";
var $93d1afca8879b95a$export$2e2bcd8739ae039 = $93d1afca8879b95a$var$Overlay;

});
parcelRegister("jVgRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8106b249b7a3807$export$2e2bcd8739ae039);

var $7YnSj = parcelRequire("7YnSj");

var $lIo3y = parcelRequire("lIo3y");

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");

var $gshx1 = parcelRequire("gshx1");

var $e1WyV = parcelRequire("e1WyV");
const $e8106b249b7a3807$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $e8106b249b7a3807$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $e8106b249b7a3807$var$noop;
    (0, $gshx1.default)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $dsxUx.default)((e)=>{
        if ((0, $e1WyV.isEscKey)(e)) onClose(e);
    });
    (0, $acw62.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $lIo3y.default)((0, $gshx1.getRefTarget)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $7YnSj.default)(doc, "keyup", (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $e8106b249b7a3807$export$2e2bcd8739ae039 = $e8106b249b7a3807$var$useRootClose;

});


parcelRegister("7ey4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $5444443f433675a7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $59GJ0 = parcelRequire("59GJ0");

var $8rTrh = parcelRequire("8rTrh");

var $hVPbf = parcelRequire("hVPbf");

var $N43sL = parcelRequire("N43sL");
"use client";
function $5444443f433675a7$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $acw62.useRef)(null);
    const popoverClass = (0, $8rTrh.useBootstrapPrefix)(undefined, "popover");
    const tooltipClass = (0, $8rTrh.useBootstrapPrefix)(undefined, "tooltip");
    const offset = (0, $acw62.useMemo)(()=>({
            name: "offset",
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $59GJ0.default)(overlayRef.current, popoverClass)) return (0, $hVPbf.default).POPPER_OFFSET;
                        if ((0, $59GJ0.default)(overlayRef.current, tooltipClass)) return (0, $N43sL.default).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}

});
parcelRegister("hVPbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0df75e22d728968$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ekoxY = parcelRequire("ekoxY");

var $4j5TD = parcelRequire("4j5TD");

var $7T4rG = parcelRequire("7T4rG");

var $3o0kK = parcelRequire("3o0kK");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $d0df75e22d728968$var$Popover = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "popover");
    const isRTL = (0, $8rTrh.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $7T4rG.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $3o0kK.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4j5TD.default), {
                children: children
            }) : children
        ]
    });
});
var $d0df75e22d728968$export$2e2bcd8739ae039 = Object.assign($d0df75e22d728968$var$Popover, {
    Header: (0, $ekoxY.default),
    Body: (0, $4j5TD.default),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});

});
parcelRegister("ekoxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e5f9750149a1a0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $a6e5f9750149a1a0$var$PopoverHeader = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "popover-header");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$a6e5f9750149a1a0$var$PopoverHeader.displayName = "PopoverHeader";
var $a6e5f9750149a1a0$export$2e2bcd8739ae039 = $a6e5f9750149a1a0$var$PopoverHeader;

});

parcelRegister("4j5TD", function(module, exports) {

$parcel$export(module.exports, "default", () => $322d82ade70b4ad6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $322d82ade70b4ad6$var$PopoverBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "popover-body");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$322d82ade70b4ad6$var$PopoverBody.displayName = "PopoverBody";
var $322d82ade70b4ad6$export$2e2bcd8739ae039 = $322d82ade70b4ad6$var$PopoverBody;

});

parcelRegister("7T4rG", function(module, exports) {

$parcel$export(module.exports, "getOverlayDirection", () => $5be11e4096c49daa$export$c15856915a9b3464);

var $acw62 = parcelRequire("acw62");
class $5be11e4096c49daa$export$34582a676b91ff07 extends $acw62.Component {
}
function $5be11e4096c49daa$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === "left") bsDirection = isRTL ? "end" : "start";
    else if (placement === "right") bsDirection = isRTL ? "start" : "end";
    return bsDirection;
}

});

parcelRegister("3o0kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2773df40e83847cd$export$2e2bcd8739ae039);
function $2773df40e83847cd$export$2e2bcd8739ae039(position = "absolute") {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
}

});


parcelRegister("N43sL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0937b8ed541186d0$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $7T4rG = parcelRequire("7T4rG");

var $3o0kK = parcelRequire("3o0kK");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $0937b8ed541186d0$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "tooltip");
    const isRTL = (0, $8rTrh.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $7T4rG.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $3o0kK.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$0937b8ed541186d0$var$Tooltip.displayName = "Tooltip";
var $0937b8ed541186d0$export$2e2bcd8739ae039 = Object.assign($0937b8ed541186d0$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});

});




parcelRegister("2jjfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aec4932168fe6dc$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $4QRZk = parcelRequire("4QRZk");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $1aec4932168fe6dc$var$Pagination = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, size: size, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "pagination");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, decoratedBsPrefix, size && `${decoratedBsPrefix}-${size}`)
    });
});
$1aec4932168fe6dc$var$Pagination.displayName = "Pagination";
var $1aec4932168fe6dc$export$2e2bcd8739ae039 = Object.assign($1aec4932168fe6dc$var$Pagination, {
    First: $4QRZk.First,
    Prev: $4QRZk.Prev,
    Ellipsis: $4QRZk.Ellipsis,
    Item: (0, $4QRZk.default),
    Next: $4QRZk.Next,
    Last: $4QRZk.Last
});

});
parcelRegister("4QRZk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3885e5b41156f53c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "First", () => $3885e5b41156f53c$export$b25abba66f7be210);
$parcel$export(module.exports, "Prev", () => $3885e5b41156f53c$export$1b265216817111b9);
$parcel$export(module.exports, "Ellipsis", () => $3885e5b41156f53c$export$1297970233533a7d);
$parcel$export(module.exports, "Next", () => $3885e5b41156f53c$export$b820fc49f2736e85);
$parcel$export(module.exports, "Last", () => $3885e5b41156f53c$export$bed9238d8933c9a8);
/* eslint-disable react/no-multi-comp */ 
var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $dKAJt = parcelRequire("dKAJt");

var $ayMG0 = parcelRequire("ayMG0");
const $3885e5b41156f53c$var$PageItem = /*#__PURE__*/ $acw62.forwardRef(({ active: active = false, disabled: disabled = false, className: className, style: style, activeLabel: activeLabel = "(current)", children: children, linkStyle: linkStyle, linkClassName: linkClassName, as: as = (0, $dKAJt.default), ...props }, ref)=>{
    const Component = active || disabled ? "span" : as;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "page-item", {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Component, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("page-link", linkClassName),
            style: linkStyle,
            ...props,
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        })
    });
});
$3885e5b41156f53c$var$PageItem.displayName = "PageItem";
var $3885e5b41156f53c$export$2e2bcd8739ae039 = $3885e5b41156f53c$var$PageItem;
function $3885e5b41156f53c$var$createButton(name, defaultValue, label = name) {
    const Button = /*#__PURE__*/ $acw62.forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($3885e5b41156f53c$var$PageItem, {
            ...props,
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    Button.displayName = name;
    return Button;
}
const $3885e5b41156f53c$export$b25abba66f7be210 = $3885e5b41156f53c$var$createButton("First", "\xab");
const $3885e5b41156f53c$export$1b265216817111b9 = $3885e5b41156f53c$var$createButton("Prev", "\u2039", "Previous");
const $3885e5b41156f53c$export$1297970233533a7d = $3885e5b41156f53c$var$createButton("Ellipsis", "\u2026", "More");
const $3885e5b41156f53c$export$b820fc49f2736e85 = $3885e5b41156f53c$var$createButton("Next", "\u203A");
const $3885e5b41156f53c$export$bed9238d8933c9a8 = $3885e5b41156f53c$var$createButton("Last", "\xbb");

});


parcelRegister("h7C4J", function(module, exports) {

$parcel$export(module.exports, "default", () => $c770a015764ac03c$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c770a015764ac03c$var$Row = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const decoratedBsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "row");
    const breakpoints = (0, $8rTrh.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $8rTrh.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, decoratedBsPrefix, ...classes)
    });
});
$c770a015764ac03c$var$Row.displayName = "Row";
var $c770a015764ac03c$export$2e2bcd8739ae039 = $c770a015764ac03c$var$Row;

});

parcelRegister("4dB0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $312515fc7a4c2917$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $312515fc7a4c2917$var$Spinner = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = "border", size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "spinner");
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$312515fc7a4c2917$var$Spinner.displayName = "Spinner";
var $312515fc7a4c2917$export$2e2bcd8739ae039 = $312515fc7a4c2917$var$Spinner;

});

parcelRegister("j3TSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $de09a5a2a561d3fb$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $de09a5a2a561d3fb$var$Table = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "table");
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === "string" ? `striped-${striped}` : "striped"}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === "string") responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
var $de09a5a2a561d3fb$export$2e2bcd8739ae039 = $de09a5a2a561d3fb$var$Table;

});

parcelRegister("93EsN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6983c81067896c21$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $aMKOh = parcelRequire("aMKOh");

var $04GNG = parcelRequire("04GNG");

var $4aAvI = parcelRequire("4aAvI");

var $ks3hL = parcelRequire("ks3hL");

var $8rTrh = parcelRequire("8rTrh");

var $knWnn = parcelRequire("knWnn");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $6983c81067896c21$var$Toast = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, transition: Transition = (0, $04GNG.default), show: show = true, animation: animation = true, delay: delay = 5000, autohide: autohide = false, onClose: onClose, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, bg: bg, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "toast");
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, $acw62.useRef)(delay);
    const onCloseRef = (0, $acw62.useRef)(onClose);
    (0, $acw62.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, $aMKOh.default)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, $acw62.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $acw62.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, $acw62.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? "show" : "hide")),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $knWnn.default).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $ayMG0.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$6983c81067896c21$var$Toast.displayName = "Toast";
var $6983c81067896c21$export$2e2bcd8739ae039 = Object.assign($6983c81067896c21$var$Toast, {
    Body: (0, $ks3hL.default),
    Header: (0, $4aAvI.default)
});

});
parcelRegister("04GNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e1931a5a411411$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");

var $7BpMa = parcelRequire("7BpMa");

var $ayMG0 = parcelRequire("ayMG0");
const $00e1931a5a411411$var$fadeStyles = {
    [(0, $1mPeS.ENTERING)]: "showing",
    [(0, $1mPeS.EXITING)]: "showing show"
};
const $00e1931a5a411411$var$ToastFade = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7BpMa.default), {
        ...props,
        ref: ref,
        transitionClasses: $00e1931a5a411411$var$fadeStyles
    }));
$00e1931a5a411411$var$ToastFade.displayName = "ToastFade";
var $00e1931a5a411411$export$2e2bcd8739ae039 = $00e1931a5a411411$var$ToastFade;

});

parcelRegister("4aAvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $30946ad0f37cc61a$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");

var $8rTrh = parcelRequire("8rTrh");

var $77pHI = parcelRequire("77pHI");

var $knWnn = parcelRequire("knWnn");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $30946ad0f37cc61a$var$ToastHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = true, className: className, children: children, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "toast-header");
    const context = (0, $acw62.useContext)((0, $knWnn.default));
    const handleClick = (0, $dsxUx.default)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77pHI.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
$30946ad0f37cc61a$var$ToastHeader.displayName = "ToastHeader";
var $30946ad0f37cc61a$export$2e2bcd8739ae039 = $30946ad0f37cc61a$var$ToastHeader;

});
parcelRegister("knWnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed733ce3364e9053$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
"use client";
const $ed733ce3364e9053$var$ToastContext = /*#__PURE__*/ $acw62.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose () {}
});
var $ed733ce3364e9053$export$2e2bcd8739ae039 = $ed733ce3364e9053$var$ToastContext;

});


parcelRegister("ks3hL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee38f89d3acd2add$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $ee38f89d3acd2add$var$ToastBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "toast-body");
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$ee38f89d3acd2add$var$ToastBody.displayName = "ToastBody";
var $ee38f89d3acd2add$export$2e2bcd8739ae039 = $ee38f89d3acd2add$var$ToastBody;

});


parcelRegister("ket0H", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebab9e4aee662d47$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isApiNotAuthorizedError", () => (parcelRequire("ifGBV")).isApiNotAuthorizedError);
$parcel$export(module.exports, "isApiAccessDeniedError", () => (parcelRequire("ifGBV")).isApiAccessDeniedError);
$parcel$export(module.exports, "isApiNotFoundError", () => (parcelRequire("ifGBV")).isApiNotFoundError);
$parcel$export(module.exports, "isApiValidationError", () => (parcelRequire("ifGBV")).isApiValidationError);
$parcel$export(module.exports, "getApiErrorMessage", () => (parcelRequire("9PE8j")).default);
$parcel$export(module.exports, "getErrorsListFromError", () => (parcelRequire("fmlaG")).default);
$parcel$export(module.exports, "getValidationErrorMessages", () => (parcelRequire("3nvVi")).default);
$parcel$export(module.exports, "mapValidationErrors", () => (parcelRequire("9lLem")).default);

var $glsxi = parcelRequire("glsxi");
parcelRequire("bKVNu");
var $9PE8j = parcelRequire("9PE8j");
var $fmlaG = parcelRequire("fmlaG");
var $3nvVi = parcelRequire("3nvVi");
var $ifGBV = parcelRequire("ifGBV");
var $9lLem = parcelRequire("9lLem");
var // noinspection JSUnusedGlobalSymbols
$ebab9e4aee662d47$export$2e2bcd8739ae039 = (0, $glsxi.default);

});
parcelRegister("glsxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $be64be24fce3e607$export$2e2bcd8739ae039);
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");

var $2rasJ = parcelRequire("2rasJ");
parcelRequire("bKVNu");
var $1iBx7 = parcelRequire("1iBx7");
var $1TwKv = parcelRequire("1TwKv");
var $be64be24fce3e607$var$__assign = undefined && undefined.__assign || function() {
    $be64be24fce3e607$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be64be24fce3e607$var$__assign.apply(this, arguments);
};
var $be64be24fce3e607$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $be64be24fce3e607$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $be64be24fce3e607$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $be64be24fce3e607$var$API = /** @class */ function() {
    function API() {}
    // noinspection JSUnusedGlobalSymbols
    API.registerGlobalErrorHandler = function(handler) {
        API._errorHandlers = $be64be24fce3e607$var$__spreadArray($be64be24fce3e607$var$__spreadArray([], API._errorHandlers, true), [
            handler
        ], false);
        return function() {
            API._errorHandlers = API._errorHandlers.filter(function(h) {
                return h !== handler;
            });
        };
    };
    API._handleGlobalError = function(e) {
        API._errorHandlers.forEach(function(handler) {
            return handler(e);
        });
    };
    API.initErrorHandling = function() {
        if (API._axios === undefined) return;
        API._axios.interceptors.response.use(function(response) {
            return response;
        }, function(error) {
            var errorObj = (0, $1TwKv.makeRequestError)((0, $1iBx7.ErrorType).Request);
            if (error.response) {
                var response = error.response;
                switch(error.response.status){
                    case 401:
                        errorObj = (0, $1TwKv.makeRequestErrorFromResponse)((0, $1iBx7.ErrorType).NotAuthorized, response);
                        break;
                    case 403:
                        errorObj = (0, $1TwKv.makeRequestErrorFromResponse)((0, $1iBx7.ErrorType).AccessDenied, response);
                        break;
                    case 404:
                        errorObj = (0, $1TwKv.makeRequestErrorFromResponse)((0, $1iBx7.ErrorType).NotFound, response);
                        break;
                    case 422:
                        errorObj = (0, $1TwKv.makeRequestErrorFromResponse)((0, $1iBx7.ErrorType).Validation, response);
                        break;
                    case 503:
                        errorObj = (0, $1TwKv.makeRequestErrorFromResponse)((0, $1iBx7.ErrorType).Maintenance, response);
                        break;
                    default:
                        if (error.response.status >= 500) errorObj = (0, $1TwKv.makeRequestErrorFromResponse)((0, $1iBx7.ErrorType).Server, response);
                        else errorObj = (0, $1TwKv.makeRequestErrorFromResponse)((0, $1iBx7.ErrorType).Request, response);
                        break;
                }
            } else if (error.request) {
                if (error.message === "Network Error" || !navigator.onLine) errorObj = (0, $1TwKv.makeRequestError)((0, $1iBx7.ErrorType).Offline);
                else errorObj = (0, $1TwKv.makeRequestError)((0, $1iBx7.ErrorType).Request);
            }
            API._handleGlobalError(errorObj);
            throw errorObj;
        });
    };
    API.getAxios = function() {
        if (API._axios === undefined) {
            // noinspection JSAnnotator
            API._axios = (0, $7we3r.default).create({
                baseURL: API._config.baseUrl,
                timeout: API._config.timeout,
                headers: {
                    post: {
                        "Content-Type": "application/json"
                    }
                }
            });
            API.initErrorHandling();
        }
        return API._axios;
    };
    // noinspection JSUnusedGlobalSymbols
    API.setConfig = function(config) {
        API._config = $be64be24fce3e607$var$__assign($be64be24fce3e607$var$__assign({}, API._config), config);
        API._axios = undefined;
    };
    API._makeUrl = function(url, params) {
        if (params === void 0) params = null;
        return url + (params ? "?" + (0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))).stringify(params) : "");
    };
    API._makeOptions = function(options) {
        var _a;
        return {
            timeout: (_a = options === null || options === void 0 ? void 0 : options.timeout) !== null && _a !== void 0 ? _a : API._config.timeout
        };
    };
    API.get = function(url, params, options) {
        if (params === void 0) params = null;
        return API.getAxios().get(API._makeUrl(url, params), this._makeOptions(options));
    };
    API.getData = function(url, params, options) {
        var _this = this;
        if (params === void 0) params = null;
        return new Promise(function(resolve, reject) {
            return $be64be24fce3e607$var$__awaiter(_this, void 0, void 0, function() {
                var response, e_1;
                return $be64be24fce3e607$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                API.get(url, params, this._makeOptions(options))
                            ];
                        case 1:
                            response = _a.sent();
                            resolve(response.data);
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            e_1 = _a.sent();
                            reject(e_1);
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    API.getFile = function(url, params, options) {
        if (params === void 0) params = null;
        return API.getAxios().get(API._makeUrl(url, params), $be64be24fce3e607$var$__assign($be64be24fce3e607$var$__assign({}, options !== null && options !== void 0 ? options : {}), {
            responseType: "blob"
        }));
    };
    API.getMultiple = function(urls, params, options) {
        var _this = this;
        if (params === void 0) params = null;
        return (0, $7we3r.default).all(urls.map(function(url) {
            return API.getAxios().get(API._makeUrl(url, params), _this._makeOptions(options));
        }));
    };
    API.post = function(url, data, options) {
        return API.getAxios().post(url, data, this._makeOptions(options));
    };
    API.create = function(url, data, options) {
        return API.post(url, data, options);
    };
    API.patch = function(url, data, options) {
        return API.getAxios().patch(url, data, this._makeOptions(options));
    };
    API.put = function(url, data, options) {
        return API.getAxios().put(url, data, this._makeOptions(options));
    };
    API.update = function(url, data, options) {
        return API.put(url, data, options);
    };
    API.delete = function(url, data, options) {
        if (data === void 0) data = null;
        return API.getAxios().delete(url, $be64be24fce3e607$var$__assign({
            data: data !== null && data !== void 0 ? data : {}
        }, this._makeOptions(options)));
    };
    API._makeFormDataValue = function(value) {
        if (value instanceof File) return value;
        if (value instanceof Date) return value.toISOString();
        if (typeof value === "boolean") return value ? "1" : "0";
        if (typeof value === "undefined" || value === null) return "";
        return value.toString();
    };
    API._makeFormData = function(data, formData, parentKey) {
        var _this = this;
        if (formData === void 0) formData = new FormData();
        if (data && typeof data === "object" && !(data instanceof Date) && !(data instanceof File) && !(data instanceof FileList)) Object.keys(data).forEach(function(key) {
            _this._makeFormData(data[key], formData, parentKey ? "".concat(parentKey, "[").concat(key, "]") : key);
        });
        else if (data instanceof FileList) for(var i = 0; i < data.length; i++)formData.append(parentKey ? "".concat(parentKey, "[]") : "[]", data[i]);
        else formData.append(parentKey || "", this._makeFormDataValue(data));
        return formData;
    };
    API._makeFilesConfig = function(options) {
        return $be64be24fce3e607$var$__assign($be64be24fce3e607$var$__assign({}, options), {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    };
    API.postWithFile = function(url, data, options) {
        return API.getAxios().post(url, API._makeFormData(data), API._makeFilesConfig(options));
    };
    API.createWithFile = function(url, data, options) {
        return API.postWithFile(url, data, options);
    };
    API.patchWithFile = function(url, data, options) {
        return API.getAxios().patch(url, API._makeFormData(data), API._makeFilesConfig(options));
    };
    API.updateWithFile = function(url, data, options) {
        return API.patchWithFile(url, data, options);
    };
    API._axios = undefined;
    API._config = {
        baseUrl: "/",
        timeout: 5000
    };
    API._errorHandlers = [];
    return API;
}();
var $be64be24fce3e607$export$e8fd4b36d2babe12 = [
    "get",
    "getData",
    "getFile",
    "getMultiple"
];
var $be64be24fce3e607$export$759bda45f60fd331 = [
    "post",
    "postWithFile",
    "patch",
    "patchWithFile",
    "put",
    "delete",
    "create",
    "createWithFile",
    "update",
    "updateWithFile"
];
var $be64be24fce3e607$export$2e2bcd8739ae039 = $be64be24fce3e607$var$API;

});
parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $jJbMR.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $gKvUL.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $gKvUL.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, "[]")) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $gKvUL.default).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $gKvUL.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $gKvUL.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});

parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $lcuqa.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = ((product)=>{
    return $565e85ead8bde60a$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $gKvUL.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});


parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");
"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6HVMZ.default).call(this, message == null ? "canceled" : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $gKvUL.default).inherits($9fd0919e266b4fda$var$CanceledError, (0, $6HVMZ.default), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $6HVMZ = parcelRequire("6HVMZ");
const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default)
};
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $889er = parcelRequire("889er");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $6paAk = parcelRequire("6paAk");
"use strict";
function $79f0a48d5eb7919b$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $bxxyx.default).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $gKvUL.default).isFormData(requestData)) {
            if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)("Request aborted", (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6HVMZ.default)("Network Error", (0, $6HVMZ.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $6YCMk.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $g65xr.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, $gKvUL.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $889er.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $8JRzs.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $gKvUL.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $32jg5.default)(fullPath);
        if (protocol && (0, $g65xr.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6HVMZ.default)("Unsupported protocol " + protocol + ":", (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)("Request failed with status code " + response.status, [
        (0, $6HVMZ.default).ERR_BAD_REQUEST,
        (0, $6HVMZ.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $gKvUL.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $gKvUL.default).isString(path) && cookie.push("path=" + path);
        (0, $gKvUL.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $ckHwb.default)(requestedURL)) return (0, $fE4ul.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $gKvUL.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});




parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $gKvUL.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});

parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $6HVMZ.default)("options must be an object", (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)("option " + opt + " must be " + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)("Unknown option " + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.6.8";

});



parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});



parcelRegister("bKVNu", function(module, exports) {

$parcel$export(module.exports, "ErrorType", () => (parcelRequire("1iBx7")).ErrorType);
$parcel$export(module.exports, "isApiNotAuthorizedError", () => (parcelRequire("ifGBV")).isApiNotAuthorizedError);
$parcel$export(module.exports, "isApiAccessDeniedError", () => (parcelRequire("ifGBV")).isApiAccessDeniedError);
$parcel$export(module.exports, "isApiNotFoundError", () => (parcelRequire("ifGBV")).isApiNotFoundError);
$parcel$export(module.exports, "isApiValidationError", () => (parcelRequire("ifGBV")).isApiValidationError);
$parcel$export(module.exports, "getApiErrorMessage", () => (parcelRequire("9PE8j")).default);
$parcel$export(module.exports, "getErrorsListFromError", () => (parcelRequire("fmlaG")).default);
$parcel$export(module.exports, "getValidationErrorMessages", () => (parcelRequire("3nvVi")).default);
$parcel$export(module.exports, "makeRequestError", () => (parcelRequire("1TwKv")).makeRequestError);
$parcel$export(module.exports, "makeRequestErrorFromResponse", () => (parcelRequire("1TwKv")).makeRequestErrorFromResponse);
$parcel$export(module.exports, "mapValidationErrors", () => (parcelRequire("9lLem")).default);

var $1iBx7 = parcelRequire("1iBx7");

var $ifGBV = parcelRequire("ifGBV");

var $9PE8j = parcelRequire("9PE8j");

var $fmlaG = parcelRequire("fmlaG");

var $bPyxi = parcelRequire("bPyxi");

var $6eVVc = parcelRequire("6eVVc");

var $3nvVi = parcelRequire("3nvVi");

var $1TwKv = parcelRequire("1TwKv");

var $9lLem = parcelRequire("9lLem");

});
parcelRegister("1iBx7", function(module, exports) {

$parcel$export(module.exports, "ErrorType", () => $0f24962ff746184c$export$dba1278861bf0dc1);
var $0f24962ff746184c$export$dba1278861bf0dc1;
(function(ErrorType) {
    ErrorType["Request"] = "Request";
    ErrorType["NotAuthorized"] = "NotAuthorized";
    ErrorType["AccessDenied"] = "AccessDenied";
    ErrorType["NotFound"] = "NotFound";
    ErrorType["Server"] = "Server";
    ErrorType["Validation"] = "Validation";
    ErrorType["Offline"] = "Offline";
    ErrorType["Maintenance"] = "Maintenance";
})($0f24962ff746184c$export$dba1278861bf0dc1 || ($0f24962ff746184c$export$dba1278861bf0dc1 = {}));

});

parcelRegister("ifGBV", function(module, exports) {

$parcel$export(module.exports, "isErrorType", () => $d49aae53b97652ea$export$6b962dc243a13a24);
$parcel$export(module.exports, "isApiError", () => $d49aae53b97652ea$export$89d83cc97c52a37);
$parcel$export(module.exports, "isApiNotAuthorizedError", () => $d49aae53b97652ea$export$cf410c32afa503f2);
$parcel$export(module.exports, "isApiAccessDeniedError", () => $d49aae53b97652ea$export$d25ce01ed4ed6b5c);
$parcel$export(module.exports, "isApiNotFoundError", () => $d49aae53b97652ea$export$ccd4d091a7a20ef);
$parcel$export(module.exports, "isApiValidationError", () => $d49aae53b97652ea$export$3174c0a06fe7c2d7);
$parcel$export(module.exports, "isValidMessage", () => $d49aae53b97652ea$export$f648e44869ab6afd);
$parcel$export(module.exports, "isErrorsList", () => $d49aae53b97652ea$export$72a3254ecacb0adc);

var $1iBx7 = parcelRequire("1iBx7");
var $d49aae53b97652ea$export$6b962dc243a13a24 = function(type) {
    return Object.values((0, $1iBx7.ErrorType)).includes(type);
};
var $d49aae53b97652ea$export$89d83cc97c52a37 = function(error) {
    return typeof error === "object" && error !== null && "type" in error && $d49aae53b97652ea$export$6b962dc243a13a24(error.type) && "response" in error && (error.response === null || typeof error.response === "object") && "message" in error && typeof error.message === "string";
};
var $d49aae53b97652ea$export$b93eeba63b4bfd5e = function(error, type) {
    return $d49aae53b97652ea$export$89d83cc97c52a37(error) && $d49aae53b97652ea$export$6b962dc243a13a24(type) && error.type === type;
};
var $d49aae53b97652ea$export$9a56cf69212c15ad = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).Request);
};
var $d49aae53b97652ea$export$cf410c32afa503f2 = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).NotAuthorized);
};
var $d49aae53b97652ea$export$d25ce01ed4ed6b5c = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).AccessDenied);
};
var $d49aae53b97652ea$export$ccd4d091a7a20ef = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).NotFound);
};
var $d49aae53b97652ea$export$7a93170d248b2045 = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).Server);
};
var $d49aae53b97652ea$export$3174c0a06fe7c2d7 = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).Validation);
};
var $d49aae53b97652ea$export$55e141f9bd5874a8 = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).Offline);
};
var $d49aae53b97652ea$export$58fba4fd86d0bda9 = function(error) {
    return $d49aae53b97652ea$export$b93eeba63b4bfd5e(error, (0, $1iBx7.ErrorType).Maintenance);
};
var $d49aae53b97652ea$export$f648e44869ab6afd = function(message) {
    return typeof message === "string" && message.length > 0;
};
var $d49aae53b97652ea$export$72a3254ecacb0adc = function(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value) && Object.values(value).every(function(v) {
        return Array.isArray(v) && v.every(function(v) {
            return typeof v === "string";
        });
    });
};

});

parcelRegister("9PE8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $7288020ddc3cc8d2$export$2e2bcd8739ae039);

var $ifGBV = parcelRequire("ifGBV");

var $bPyxi = parcelRequire("bPyxi");

var $6eVVc = parcelRequire("6eVVc");
function $7288020ddc3cc8d2$export$2e2bcd8739ae039(e) {
    if (!(0, $ifGBV.isApiError)(e)) return "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430";
    if ((0, $ifGBV.isApiValidationError)(e)) return (0, $6eVVc.default)(e);
    if ((0, $ifGBV.isValidMessage)(e.message)) return e.message;
    return (0, $bPyxi.default)(e.type);
}

});
parcelRegister("bPyxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $89cf3f48ed586cd3$export$2e2bcd8739ae039);

var $ifGBV = parcelRequire("ifGBV");

var $1iBx7 = parcelRequire("1iBx7");
function $89cf3f48ed586cd3$export$2e2bcd8739ae039(type) {
    if (!(0, $ifGBV.isErrorType)(type)) return "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430";
    switch(type){
        case (0, $1iBx7.ErrorType).Request:
            return "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u043F\u0438\u0442\u0443";
        case (0, $1iBx7.ErrorType).NotAuthorized:
            return "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0456\u044F";
        case (0, $1iBx7.ErrorType).AccessDenied:
            return "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u0446\u044C\u043E\u0433\u043E";
        case (0, $1iBx7.ErrorType).NotFound:
            return "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E";
        case (0, $1iBx7.ErrorType).Server:
            return "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430";
        case (0, $1iBx7.ErrorType).Validation:
            return "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0430\u043B\u0456\u0434\u0430\u0446\u0456\u0457";
        case (0, $1iBx7.ErrorType).Offline:
            return "\u0421\u0435\u0440\u0432\u0435\u0440 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0437'\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u0437 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043E\u043C";
        case (0, $1iBx7.ErrorType).Maintenance:
            return "\u041F\u0440\u043E\u0432\u043E\u0434\u044F\u0442\u044C\u0441\u044F \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0456 \u0440\u043E\u0431\u043E\u0442\u0438";
    }
}

});

parcelRegister("6eVVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b0faec9c152ad1$export$2e2bcd8739ae039);

var $3nvVi = parcelRequire("3nvVi");
function $48b0faec9c152ad1$export$2e2bcd8739ae039(e) {
    return (0, $3nvVi.default)(e).join("; ");
}

});
parcelRegister("3nvVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $275c486005af70ee$export$2e2bcd8739ae039);

var $fmlaG = parcelRequire("fmlaG");
function $275c486005af70ee$export$2e2bcd8739ae039(e) {
    var errors = (0, $fmlaG.default)(e);
    return Object.values(errors).map(function(v) {
        return v.join(", ");
    });
}

});
parcelRegister("fmlaG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2e95540af4dd44a$export$2e2bcd8739ae039);

var $ifGBV = parcelRequire("ifGBV");
var $b2e95540af4dd44a$var$getErrorsListFromError = function(e) {
    var _a, _b, _c;
    if (!(0, $ifGBV.isApiValidationError)(e) || !e.response || !((_a = e.response) === null || _a === void 0 ? void 0 : _a.data) || !((_c = (_b = e.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errors)) return {
        "unknown": [
            "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
        ]
    };
    var errors = e.response.data.errors;
    if (!(0, $ifGBV.isErrorsList)(errors)) return {
        "unknown": [
            "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
        ]
    };
    return errors;
};
var $b2e95540af4dd44a$export$2e2bcd8739ae039 = $b2e95540af4dd44a$var$getErrorsListFromError;

});




parcelRegister("1TwKv", function(module, exports) {

$parcel$export(module.exports, "makeRequestErrorFromResponse", () => $161454cae91449e6$export$f84bc725cefbaaae);
$parcel$export(module.exports, "makeRequestError", () => $161454cae91449e6$export$6d569da90654e800);
var $161454cae91449e6$export$f84bc725cefbaaae = function(type, response) {
    var _a, _b;
    return {
        type: type,
        response: response,
        message: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : null
    };
};
var $161454cae91449e6$export$6d569da90654e800 = function(type, message) {
    if (message === void 0) message = null;
    return {
        type: type,
        response: null,
        message: message
    };
};

});

parcelRegister("9lLem", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ceab637f8c50bfa$export$2e2bcd8739ae039);

var $fmlaG = parcelRequire("fmlaG");
function $6ceab637f8c50bfa$export$2e2bcd8739ae039(e, callback) {
    var errors = (0, $fmlaG.default)(e);
    Object.entries(errors).forEach(function(_a) {
        var k = _a[0], v = _a[1];
        return callback(k, v);
    });
}

});




parcelRegister("4mPkP", function(module, exports) {
"use strict";
function $32e109894e6e6af3$var$_process(v, mod) {
    var i;
    var r;
    if (typeof mod === "function") {
        r = mod(v);
        if (r !== undefined) v = r;
    } else if (Array.isArray(mod)) for(i = 0; i < mod.length; i++){
        r = mod[i](v);
        if (r !== undefined) v = r;
    }
    return v;
}
function $32e109894e6e6af3$var$parseKey(key, val) {
    // detect negative index notation
    if (key[0] === "-" && Array.isArray(val) && /^-\d+$/.test(key)) return val.length + parseInt(key, 10);
    return key;
}
function $32e109894e6e6af3$var$isIndex(k) {
    return /^\d+$/.test(k);
}
function $32e109894e6e6af3$var$isObject(val) {
    return Object.prototype.toString.call(val) === "[object Object]";
}
function $32e109894e6e6af3$var$isArrayOrObject(val) {
    return Object(val) === val;
}
function $32e109894e6e6af3$var$isEmptyObject(val) {
    return Object.keys(val).length === 0;
}
var $32e109894e6e6af3$var$blacklist = [
    "__proto__",
    "prototype",
    "constructor"
];
var $32e109894e6e6af3$var$blacklistFilter = function(part) {
    return $32e109894e6e6af3$var$blacklist.indexOf(part) === -1;
};
function $32e109894e6e6af3$var$parsePath(path, sep) {
    if (path.indexOf("[") >= 0) path = path.replace(/\[/g, sep).replace(/]/g, "");
    var parts = path.split(sep);
    var check = parts.filter($32e109894e6e6af3$var$blacklistFilter);
    if (check.length !== parts.length) throw Error("Refusing to update blacklisted property " + path);
    return parts;
}
var $32e109894e6e6af3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $32e109894e6e6af3$var$DotObject(separator, override, useArray, useBrackets) {
    if (!(this instanceof $32e109894e6e6af3$var$DotObject)) return new $32e109894e6e6af3$var$DotObject(separator, override, useArray, useBrackets);
    if (typeof override === "undefined") override = false;
    if (typeof useArray === "undefined") useArray = true;
    if (typeof useBrackets === "undefined") useBrackets = true;
    this.separator = separator || ".";
    this.override = override;
    this.useArray = useArray;
    this.useBrackets = useBrackets;
    this.keepArray = false;
    // contains touched arrays
    this.cleanup = [];
}
var $32e109894e6e6af3$var$dotDefault = new $32e109894e6e6af3$var$DotObject(".", false, true, true);
function $32e109894e6e6af3$var$wrap(method) {
    return function() {
        return $32e109894e6e6af3$var$dotDefault[method].apply($32e109894e6e6af3$var$dotDefault, arguments);
    };
}
$32e109894e6e6af3$var$DotObject.prototype._fill = function(a, obj, v, mod) {
    var k = a.shift();
    if (a.length > 0) {
        obj[k] = obj[k] || (this.useArray && $32e109894e6e6af3$var$isIndex(a[0]) ? [] : {});
        if (!$32e109894e6e6af3$var$isArrayOrObject(obj[k])) {
            if (this.override) obj[k] = {};
            else {
                if (!($32e109894e6e6af3$var$isArrayOrObject(v) && $32e109894e6e6af3$var$isEmptyObject(v))) throw new Error("Trying to redefine `" + k + "` which is a " + typeof obj[k]);
                return;
            }
        }
        this._fill(a, obj[k], v, mod);
    } else {
        if (!this.override && $32e109894e6e6af3$var$isArrayOrObject(obj[k]) && !$32e109894e6e6af3$var$isEmptyObject(obj[k])) {
            if (!($32e109894e6e6af3$var$isArrayOrObject(v) && $32e109894e6e6af3$var$isEmptyObject(v))) throw new Error("Trying to redefine non-empty obj['" + k + "']");
            return;
        }
        obj[k] = $32e109894e6e6af3$var$_process(v, mod);
    }
};
/**
 *
 * Converts an object with dotted-key/value pairs to it's expanded version
 *
 * Optionally transformed by a set of modifiers.
 *
 * Usage:
 *
 *   var row = {
 *     'nr': 200,
 *     'doc.name': '  My Document  '
 *   }
 *
 *   var mods = {
 *     'doc.name': [_s.trim, _s.underscored]
 *   }
 *
 *   dot.object(row, mods)
 *
 * @param {Object} obj
 * @param {Object} mods
 */ $32e109894e6e6af3$var$DotObject.prototype.object = function(obj, mods) {
    var self = this;
    Object.keys(obj).forEach(function(k) {
        var mod = mods === undefined ? null : mods[k];
        // normalize array notation.
        var ok = $32e109894e6e6af3$var$parsePath(k, self.separator).join(self.separator);
        if (ok.indexOf(self.separator) !== -1) {
            self._fill(ok.split(self.separator), obj, obj[k], mod);
            delete obj[k];
        } else obj[k] = $32e109894e6e6af3$var$_process(obj[k], mod);
    });
    return obj;
};
/**
 * @param {String} path dotted path
 * @param {String} v value to be set
 * @param {Object} obj object to be modified
 * @param {Function|Array} mod optional modifier
 */ $32e109894e6e6af3$var$DotObject.prototype.str = function(path, v, obj, mod) {
    var ok = $32e109894e6e6af3$var$parsePath(path, this.separator).join(this.separator);
    if (path.indexOf(this.separator) !== -1) this._fill(ok.split(this.separator), obj, v, mod);
    else obj[path] = $32e109894e6e6af3$var$_process(v, mod);
    return obj;
};
/**
 *
 * Pick a value from an object using dot notation.
 *
 * Optionally remove the value
 *
 * @param {String} path
 * @param {Object} obj
 * @param {Boolean} remove
 */ $32e109894e6e6af3$var$DotObject.prototype.pick = function(path, obj, remove, reindexArray) {
    var i;
    var keys;
    var val;
    var key;
    var cp;
    keys = $32e109894e6e6af3$var$parsePath(path, this.separator);
    for(i = 0; i < keys.length; i++){
        key = $32e109894e6e6af3$var$parseKey(keys[i], obj);
        if (obj && typeof obj === "object" && key in obj) {
            if (i === keys.length - 1) {
                if (remove) {
                    val = obj[key];
                    if (reindexArray && Array.isArray(obj)) obj.splice(key, 1);
                    else delete obj[key];
                    if (Array.isArray(obj)) {
                        cp = keys.slice(0, -1).join(".");
                        if (this.cleanup.indexOf(cp) === -1) this.cleanup.push(cp);
                    }
                    return val;
                } else return obj[key];
            } else obj = obj[key];
        } else return undefined;
    }
    if (remove && Array.isArray(obj)) obj = obj.filter(function(n) {
        return n !== undefined;
    });
    return obj;
};
/**
 *
 * Delete value from an object using dot notation.
 *
 * @param {String} path
 * @param {Object} obj
 * @return {any} The removed value
 */ $32e109894e6e6af3$var$DotObject.prototype.delete = function(path, obj) {
    return this.remove(path, obj, true);
};
/**
 *
 * Remove value from an object using dot notation.
 *
 * Will remove multiple items if path is an array.
 * In this case array indexes will be retained until all
 * removals have been processed.
 *
 * Use dot.delete() to automatically  re-index arrays.
 *
 * @param {String|Array<String>} path
 * @param {Object} obj
 * @param {Boolean} reindexArray
 * @return {any} The removed value
 */ $32e109894e6e6af3$var$DotObject.prototype.remove = function(path, obj, reindexArray) {
    var i;
    this.cleanup = [];
    if (Array.isArray(path)) {
        for(i = 0; i < path.length; i++)this.pick(path[i], obj, true, reindexArray);
        if (!reindexArray) this._cleanup(obj);
        return obj;
    } else return this.pick(path, obj, true, reindexArray);
};
$32e109894e6e6af3$var$DotObject.prototype._cleanup = function(obj) {
    var ret;
    var i;
    var keys;
    var root;
    if (this.cleanup.length) {
        for(i = 0; i < this.cleanup.length; i++){
            keys = this.cleanup[i].split(".");
            root = keys.splice(0, -1).join(".");
            ret = root ? this.pick(root, obj) : obj;
            ret = ret[keys[0]].filter(function(v) {
                return v !== undefined;
            });
            this.set(this.cleanup[i], ret, obj);
        }
        this.cleanup = [];
    }
};
/**
 * Alias method  for `dot.remove`
 *
 * Note: this is not an alias for dot.delete()
 *
 * @param {String|Array<String>} path
 * @param {Object} obj
 * @param {Boolean} reindexArray
 * @return {any} The removed value
 */ $32e109894e6e6af3$var$DotObject.prototype.del = $32e109894e6e6af3$var$DotObject.prototype.remove;
/**
 *
 * Move a property from one place to the other.
 *
 * If the source path does not exist (undefined)
 * the target property will not be set.
 *
 * @param {String} source
 * @param {String} target
 * @param {Object} obj
 * @param {Function|Array} mods
 * @param {Boolean} merge
 */ $32e109894e6e6af3$var$DotObject.prototype.move = function(source, target, obj, mods, merge) {
    if (typeof mods === "function" || Array.isArray(mods)) this.set(target, $32e109894e6e6af3$var$_process(this.pick(source, obj, true), mods), obj, merge);
    else {
        merge = mods;
        this.set(target, this.pick(source, obj, true), obj, merge);
    }
    return obj;
};
/**
 *
 * Transfer a property from one object to another object.
 *
 * If the source path does not exist (undefined)
 * the property on the other object will not be set.
 *
 * @param {String} source
 * @param {String} target
 * @param {Object} obj1
 * @param {Object} obj2
 * @param {Function|Array} mods
 * @param {Boolean} merge
 */ $32e109894e6e6af3$var$DotObject.prototype.transfer = function(source, target, obj1, obj2, mods, merge) {
    if (typeof mods === "function" || Array.isArray(mods)) this.set(target, $32e109894e6e6af3$var$_process(this.pick(source, obj1, true), mods), obj2, merge);
    else {
        merge = mods;
        this.set(target, this.pick(source, obj1, true), obj2, merge);
    }
    return obj2;
};
/**
 *
 * Copy a property from one object to another object.
 *
 * If the source path does not exist (undefined)
 * the property on the other object will not be set.
 *
 * @param {String} source
 * @param {String} target
 * @param {Object} obj1
 * @param {Object} obj2
 * @param {Function|Array} mods
 * @param {Boolean} merge
 */ $32e109894e6e6af3$var$DotObject.prototype.copy = function(source, target, obj1, obj2, mods, merge) {
    if (typeof mods === "function" || Array.isArray(mods)) this.set(target, $32e109894e6e6af3$var$_process(// clone what is picked
    JSON.parse(JSON.stringify(this.pick(source, obj1, false))), mods), obj2, merge);
    else {
        merge = mods;
        this.set(target, this.pick(source, obj1, false), obj2, merge);
    }
    return obj2;
};
/**
 *
 * Set a property on an object using dot notation.
 *
 * @param {String} path
 * @param {any} val
 * @param {Object} obj
 * @param {Boolean} merge
 */ $32e109894e6e6af3$var$DotObject.prototype.set = function(path, val, obj, merge) {
    var i;
    var k;
    var keys;
    var key;
    // Do not operate if the value is undefined.
    if (typeof val === "undefined") return obj;
    keys = $32e109894e6e6af3$var$parsePath(path, this.separator);
    for(i = 0; i < keys.length; i++){
        key = keys[i];
        if (i === keys.length - 1) {
            if (merge && $32e109894e6e6af3$var$isObject(val) && $32e109894e6e6af3$var$isObject(obj[key])) {
                for(k in val)if ($32e109894e6e6af3$var$hasOwnProperty.call(val, k)) obj[key][k] = val[k];
            } else if (merge && Array.isArray(obj[key]) && Array.isArray(val)) for(var j = 0; j < val.length; j++)obj[keys[i]].push(val[j]);
            else obj[key] = val;
        } else if (// force the value to be an object
        !$32e109894e6e6af3$var$hasOwnProperty.call(obj, key) || !$32e109894e6e6af3$var$isObject(obj[key]) && !Array.isArray(obj[key])) {
            // initialize as array if next key is numeric
            if (/^\d+$/.test(keys[i + 1])) obj[key] = [];
            else obj[key] = {};
        }
        obj = obj[key];
    }
    return obj;
};
/**
 *
 * Transform an object
 *
 * Usage:
 *
 *   var obj = {
 *     "id": 1,
 *    "some": {
 *      "thing": "else"
 *    }
 *   }
 *
 *   var transform = {
 *     "id": "nr",
 *    "some.thing": "name"
 *   }
 *
 *   var tgt = dot.transform(transform, obj)
 *
 * @param {Object} recipe Transform recipe
 * @param {Object} obj Object to be transformed
 * @param {Array} mods modifiers for the target
 */ $32e109894e6e6af3$var$DotObject.prototype.transform = function(recipe, obj, tgt) {
    obj = obj || {};
    tgt = tgt || {};
    Object.keys(recipe).forEach((function(key) {
        this.set(recipe[key], this.pick(key, obj), tgt);
    }).bind(this));
    return tgt;
};
/**
 *
 * Convert object to dotted-key/value pair
 *
 * Usage:
 *
 *   var tgt = dot.dot(obj)
 *
 *   or
 *
 *   var tgt = {}
 *   dot.dot(obj, tgt)
 *
 * @param {Object} obj source object
 * @param {Object} tgt target object
 * @param {Array} path path array (internal)
 */ $32e109894e6e6af3$var$DotObject.prototype.dot = function(obj, tgt, path) {
    tgt = tgt || {};
    path = path || [];
    var isArray = Array.isArray(obj);
    Object.keys(obj).forEach((function(key) {
        var index = isArray && this.useBrackets ? "[" + key + "]" : key;
        if ($32e109894e6e6af3$var$isArrayOrObject(obj[key]) && ($32e109894e6e6af3$var$isObject(obj[key]) && !$32e109894e6e6af3$var$isEmptyObject(obj[key]) || Array.isArray(obj[key]) && !this.keepArray && obj[key].length !== 0)) {
            if (isArray && this.useBrackets) {
                var previousKey = path[path.length - 1] || "";
                return this.dot(obj[key], tgt, path.slice(0, -1).concat(previousKey + index));
            } else return this.dot(obj[key], tgt, path.concat(index));
        } else if (isArray && this.useBrackets) tgt[path.join(this.separator).concat("[" + key + "]")] = obj[key];
        else tgt[path.concat(index).join(this.separator)] = obj[key];
    }).bind(this));
    return tgt;
};
$32e109894e6e6af3$var$DotObject.pick = $32e109894e6e6af3$var$wrap("pick");
$32e109894e6e6af3$var$DotObject.move = $32e109894e6e6af3$var$wrap("move");
$32e109894e6e6af3$var$DotObject.transfer = $32e109894e6e6af3$var$wrap("transfer");
$32e109894e6e6af3$var$DotObject.transform = $32e109894e6e6af3$var$wrap("transform");
$32e109894e6e6af3$var$DotObject.copy = $32e109894e6e6af3$var$wrap("copy");
$32e109894e6e6af3$var$DotObject.object = $32e109894e6e6af3$var$wrap("object");
$32e109894e6e6af3$var$DotObject.str = $32e109894e6e6af3$var$wrap("str");
$32e109894e6e6af3$var$DotObject.set = $32e109894e6e6af3$var$wrap("set");
$32e109894e6e6af3$var$DotObject.delete = $32e109894e6e6af3$var$wrap("delete");
$32e109894e6e6af3$var$DotObject.del = $32e109894e6e6af3$var$DotObject.remove = $32e109894e6e6af3$var$wrap("remove");
$32e109894e6e6af3$var$DotObject.dot = $32e109894e6e6af3$var$wrap("dot");
[
    "override",
    "overwrite"
].forEach(function(prop) {
    Object.defineProperty($32e109894e6e6af3$var$DotObject, prop, {
        get: function() {
            return $32e109894e6e6af3$var$dotDefault.override;
        },
        set: function(val) {
            $32e109894e6e6af3$var$dotDefault.override = !!val;
        }
    });
});
[
    "useArray",
    "keepArray",
    "useBrackets"
].forEach(function(prop) {
    Object.defineProperty($32e109894e6e6af3$var$DotObject, prop, {
        get: function() {
            return $32e109894e6e6af3$var$dotDefault[prop];
        },
        set: function(val) {
            $32e109894e6e6af3$var$dotDefault[prop] = val;
        }
    });
});
$32e109894e6e6af3$var$DotObject._process = $32e109894e6e6af3$var$_process;
module.exports = $32e109894e6e6af3$var$DotObject;

});

parcelRegister("22i8b", function(module, exports) {

$parcel$export(module.exports, "useFormContext", () => $0d70f179cf56e662$export$4d957a5e1be13b03);
$parcel$export(module.exports, "FormProvider", () => $0d70f179cf56e662$export$8ce1ff4f94d08846);
$parcel$export(module.exports, "useFormState", () => $0d70f179cf56e662$export$606f11b2eb45ecc6);
$parcel$export(module.exports, "useWatch", () => $0d70f179cf56e662$export$3c773aa2b84f29e0);
$parcel$export(module.exports, "useController", () => $0d70f179cf56e662$export$e8c786024a2b0a79);
$parcel$export(module.exports, "Controller", () => $0d70f179cf56e662$export$bd0bf19f25da8474);
$parcel$export(module.exports, "useFieldArray", () => $0d70f179cf56e662$export$310131896651d559);
$parcel$export(module.exports, "useForm", () => $0d70f179cf56e662$export$87c0cf8eb5a167e0);

var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === "object";
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $0d70f179cf56e662$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(object)) return defaultValue;
    const result = $0d70f179cf56e662$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0d70f179cf56e662$var$isUndefined(result) || result === object ? $0d70f179cf56e662$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0d70f179cf56e662$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $0d70f179cf56e662$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0d70f179cf56e662$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === "string";
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($0d70f179cf56e662$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $0d70f179cf56e662$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0d70f179cf56e662$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $0d70f179cf56e662$var$getEventValue(event),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0d70f179cf56e662$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $0d70f179cf56e662$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $0d70f179cf56e662$var$iterateFieldsByAction(currentField, action);
            } else if ($0d70f179cf56e662$var$isObject(currentField)) $0d70f179cf56e662$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === "file";
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === "function";
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMessage = (value1)=>$0d70f179cf56e662$var$isString(value1);
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === "radio";
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === "" ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getValidateError(result, ref, type = "validate") {
    if ($0d70f179cf56e662$var$isMessage(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isMessage) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $0d70f179cf56e662$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $0d70f179cf56e662$var$appendAt = (data, value1)=>[
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0d70f179cf56e662$var$prependAt = (data, value1)=>[
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $0d70f179cf56e662$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$appendAt(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$appendAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prependAt(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prependAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit)) $0d70f179cf56e662$var$validateField(field, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $0d70f179cf56e662$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0d70f179cf56e662$var$markFieldsDirty(data[key], []) : {
                ...$0d70f179cf56e662$var$markFieldsDirty(data[key])
            };
            else $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $0d70f179cf56e662$var$getDirtyFields = (defaultValues, formValues)=>$0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0d70f179cf56e662$var$markFieldsDirty(formValues));
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.values) || $0d70f179cf56e662$var$isObject(_options.defaultValues) ? $0d70f179cf56e662$var$cloneObject(_options.values || _options.defaultValues) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $0d70f179cf56e662$var$createSubject(),
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name) && $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? "" : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$0d70f179cf56e662$var$isPrimitive(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                error = (await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$var$getFieldValue(field ? field._f : $0d70f179cf56e662$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (currentField && $0d70f179cf56e662$var$isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $0d70f179cf56e662$var$unset(_formState.errors, "root");
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, $0d70f179cf56e662$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const values = formValues && !$0d70f179cf56e662$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$0d70f179cf56e662$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($0d70f179cf56e662$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRegister("a3QyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7532f3e29d96fa2a$export$2e2bcd8739ae039);

var $dwyob = parcelRequire("dwyob");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $e7eho = parcelRequire("e7eho");

var $1my5K = parcelRequire("1my5K");

var $lDTld = parcelRequire("lDTld");

parcelRequire("cbdLd");
parcelRequire("02Ztr");
parcelRequire("gZU1N");
parcelRequire("fu0YK");
parcelRequire("lR7jo");
parcelRequire("f8wIT");
parcelRequire("9jKhT");
parcelRequire("fUHKi");

parcelRequire("41YNz");
parcelRequire("gS6QF");
parcelRequire("g5Zhu");
parcelRequire("1u0KT");

parcelRequire("jLbqB");
var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $dwyob.u)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $e7eho.S), (0, $8nd05.default)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $lDTld.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $1my5K.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("dwyob", function(module, exports) {

$parcel$export(module.exports, "u", () => $9d88f0746ba78f85$export$3b14a55fb2447963);

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $9X7IJ.default)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $eUqlC.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $eUqlC.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $eUqlC.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $d49SP.default)((0, $d49SP.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $4ZreY.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : String(i);
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1uEeT.default)(arr) || (0, $guSBA.default)(arr, i) || (0, $abLc2.default)(arr, i) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7K8zV.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7K8zV.default)(o, minLen);
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $1En50.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});


parcelRegister("e7eho", function(module, exports) {

$parcel$export(module.exports, "S", () => $02a6ea8308eefe55$export$25ce5a424b770e84);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $ewq5C = parcelRequire("ewq5C");

var $8zogs = parcelRequire("8zogs");

var $5mpUE = parcelRequire("5mpUE");

var $9X7IJ = parcelRequire("9X7IJ");
function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $02a6ea8308eefe55$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $02a6ea8308eefe55$var$A11yText = function A11yText(props) {
    return (0, $8zogs.jsx)("span", (0, $8nd05.default)({
        css: $02a6ea8308eefe55$var$_ref
    }, props));
};
var $02a6ea8308eefe55$var$A11yText$1 = $02a6ea8308eefe55$var$A11yText;
var $02a6ea8308eefe55$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $02a6ea8308eefe55$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, $02a6ea8308eefe55$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $d49SP.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $8zogs.jsx)((0, $acw62.Fragment), null, (0, $8zogs.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $8zogs.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $8zogs.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $8zogs.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $8zogs.jsx)((0, $acw62.Fragment), null, (0, $8zogs.jsx)($02a6ea8308eefe55$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $8zogs.jsx)($02a6ea8308eefe55$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $02a6ea8308eefe55$var$LiveRegion$1 = $02a6ea8308eefe55$var$LiveRegion;
var $02a6ea8308eefe55$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $02a6ea8308eefe55$var$anyDiacritic = new RegExp("[" + $02a6ea8308eefe55$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $02a6ea8308eefe55$var$diacriticToBase = {};
for(var $02a6ea8308eefe55$var$i = 0; $02a6ea8308eefe55$var$i < $02a6ea8308eefe55$var$diacritics.length; $02a6ea8308eefe55$var$i++){
    var $02a6ea8308eefe55$var$diacritic = $02a6ea8308eefe55$var$diacritics[$02a6ea8308eefe55$var$i];
    for(var $02a6ea8308eefe55$var$j = 0; $02a6ea8308eefe55$var$j < $02a6ea8308eefe55$var$diacritic.letters.length; $02a6ea8308eefe55$var$j++)$02a6ea8308eefe55$var$diacriticToBase[$02a6ea8308eefe55$var$diacritic.letters[$02a6ea8308eefe55$var$j]] = $02a6ea8308eefe55$var$diacritic.base;
}
var $02a6ea8308eefe55$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($02a6ea8308eefe55$var$anyDiacritic, function(match) {
        return $02a6ea8308eefe55$var$diacriticToBase[match];
    });
};
var $02a6ea8308eefe55$var$memoizedStripDiacriticsForInput = (0, $5mpUE.default)($02a6ea8308eefe55$var$stripDiacritics);
var $02a6ea8308eefe55$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $02a6ea8308eefe55$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $02a6ea8308eefe55$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $d49SP.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $02a6ea8308eefe55$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $02a6ea8308eefe55$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $02a6ea8308eefe55$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $02a6ea8308eefe55$var$memoizedStripDiacriticsForInput(input);
            candidate = $02a6ea8308eefe55$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $02a6ea8308eefe55$var$_excluded = [
    "innerRef"
];
function $02a6ea8308eefe55$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $9X7IJ.default)(_ref, $02a6ea8308eefe55$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $ewq5C.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $8zogs.jsx)("input", (0, $8nd05.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $8zogs.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $02a6ea8308eefe55$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $02a6ea8308eefe55$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $02a6ea8308eefe55$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $ewq5C.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $02a6ea8308eefe55$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $02a6ea8308eefe55$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $02a6ea8308eefe55$var$preventTouchMove(e) {
    e.preventDefault();
}
function $02a6ea8308eefe55$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $02a6ea8308eefe55$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $02a6ea8308eefe55$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $02a6ea8308eefe55$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $02a6ea8308eefe55$var$activeScrollLocks = 0;
var $02a6ea8308eefe55$var$listenerOptions = {
    capture: false,
    passive: false
};
function $02a6ea8308eefe55$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$02a6ea8308eefe55$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $02a6ea8308eefe55$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $02a6ea8308eefe55$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($02a6ea8308eefe55$var$LOCK_STYLES).forEach(function(key) {
                var val = $02a6ea8308eefe55$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $02a6ea8308eefe55$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $02a6ea8308eefe55$var$preventTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $02a6ea8308eefe55$var$preventInertiaScroll, $02a6ea8308eefe55$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $02a6ea8308eefe55$var$allowTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $02a6ea8308eefe55$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$02a6ea8308eefe55$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $02a6ea8308eefe55$var$activeScrollLocks = Math.max($02a6ea8308eefe55$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $02a6ea8308eefe55$var$activeScrollLocks < 1) $02a6ea8308eefe55$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $02a6ea8308eefe55$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $02a6ea8308eefe55$var$preventTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $02a6ea8308eefe55$var$preventInertiaScroll, $02a6ea8308eefe55$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $02a6ea8308eefe55$var$allowTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $02a6ea8308eefe55$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $02a6ea8308eefe55$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $02a6ea8308eefe55$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $02a6ea8308eefe55$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $02a6ea8308eefe55$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $8zogs.jsx)((0, $acw62.Fragment), null, lockEnabled && (0, $8zogs.jsx)("div", {
        onClick: $02a6ea8308eefe55$var$blurSelectInput,
        css: $02a6ea8308eefe55$var$_ref2$1
    }), children(targetRef));
}
function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $02a6ea8308eefe55$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $02a6ea8308eefe55$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $8zogs.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $02a6ea8308eefe55$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $02a6ea8308eefe55$var$RequiredInput$1 = $02a6ea8308eefe55$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $02a6ea8308eefe55$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $02a6ea8308eefe55$var$isIPhone() {
    return $02a6ea8308eefe55$var$testPlatform(/^iPhone/i);
}
function $02a6ea8308eefe55$var$isMac() {
    return $02a6ea8308eefe55$var$testPlatform(/^Mac/i);
}
function $02a6ea8308eefe55$var$isIPad() {
    return $02a6ea8308eefe55$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $02a6ea8308eefe55$var$isMac() && navigator.maxTouchPoints > 1;
}
function $02a6ea8308eefe55$var$isIOS() {
    return $02a6ea8308eefe55$var$isIPhone() || $02a6ea8308eefe55$var$isIPad();
}
function $02a6ea8308eefe55$var$isAppleDevice() {
    return $02a6ea8308eefe55$var$isMac() || $02a6ea8308eefe55$var$isIOS();
}
var $02a6ea8308eefe55$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $02a6ea8308eefe55$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $02a6ea8308eefe55$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $02a6ea8308eefe55$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $02a6ea8308eefe55$var$defaultStyles = {
    clearIndicator: (0, $ewq5C.a),
    container: (0, $ewq5C.b),
    control: (0, $ewq5C.d),
    dropdownIndicator: (0, $ewq5C.e),
    group: (0, $ewq5C.g),
    groupHeading: (0, $ewq5C.f),
    indicatorsContainer: (0, $ewq5C.i),
    indicatorSeparator: (0, $ewq5C.h),
    input: (0, $ewq5C.j),
    loadingIndicator: (0, $ewq5C.l),
    loadingMessage: (0, $ewq5C.k),
    menu: (0, $ewq5C.m),
    menuList: (0, $ewq5C.n),
    menuPortal: (0, $ewq5C.o),
    multiValue: (0, $ewq5C.p),
    multiValueLabel: (0, $ewq5C.q),
    multiValueRemove: (0, $ewq5C.t),
    noOptionsMessage: (0, $ewq5C.u),
    option: (0, $ewq5C.v),
    placeholder: (0, $ewq5C.w),
    singleValue: (0, $ewq5C.x),
    valueContainer: (0, $ewq5C.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $02a6ea8308eefe55$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $d49SP.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $02a6ea8308eefe55$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $02a6ea8308eefe55$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $02a6ea8308eefe55$var$baseUnit = 4;
// The minimum height of the control
var $02a6ea8308eefe55$var$controlHeight = 38;
// The amount of space between the control and menu */
var $02a6ea8308eefe55$var$menuGutter = $02a6ea8308eefe55$var$baseUnit * 2;
var $02a6ea8308eefe55$var$spacing = {
    baseUnit: $02a6ea8308eefe55$var$baseUnit,
    controlHeight: $02a6ea8308eefe55$var$controlHeight,
    menuGutter: $02a6ea8308eefe55$var$menuGutter
};
var $02a6ea8308eefe55$export$4368d992c4eafac0 = {
    borderRadius: $02a6ea8308eefe55$var$borderRadius,
    colors: $02a6ea8308eefe55$var$colors,
    spacing: $02a6ea8308eefe55$var$spacing
};
var $02a6ea8308eefe55$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $ewq5C.z)(),
    captureMenuScroll: !(0, $ewq5C.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $02a6ea8308eefe55$export$db3b6bfb95261072(),
    formatGroupLabel: $02a6ea8308eefe55$var$formatGroupLabel,
    getOptionLabel: $02a6ea8308eefe55$export$8b22cf2602fb60ce,
    getOptionValue: $02a6ea8308eefe55$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $02a6ea8308eefe55$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $ewq5C.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $02a6ea8308eefe55$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $02a6ea8308eefe55$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $02a6ea8308eefe55$var$_isOptionSelected(props, option, selectValue);
    var label = $02a6ea8308eefe55$var$getOptionLabel(props, option);
    var value = $02a6ea8308eefe55$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $02a6ea8308eefe55$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $02a6ea8308eefe55$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $02a6ea8308eefe55$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $02a6ea8308eefe55$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $ewq5C.K));
}
function $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $kbxxf.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $02a6ea8308eefe55$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $kbxxf.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $02a6ea8308eefe55$var$buildFocusableOptions(props, selectValue) {
    return $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions($02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue));
}
function $02a6ea8308eefe55$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$02a6ea8308eefe55$var$shouldHideSelectedOptions(props) || !isSelected) && $02a6ea8308eefe55$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $02a6ea8308eefe55$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $02a6ea8308eefe55$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $02a6ea8308eefe55$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $02a6ea8308eefe55$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $02a6ea8308eefe55$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $02a6ea8308eefe55$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $02a6ea8308eefe55$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $02a6ea8308eefe55$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $02a6ea8308eefe55$var$getOptionValue(props, i) === candidate;
    });
}
function $02a6ea8308eefe55$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $02a6ea8308eefe55$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $02a6ea8308eefe55$var$instanceId = 1;
var $02a6ea8308eefe55$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Select, _Component);
    var _super = (0, $enfmq.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $6CZeq.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $02a6ea8308eefe55$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $ewq5C.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $ewq5C.B)([].concat((0, $kbxxf.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $ewq5C.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $ewq5C.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $ewq5C.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $ewq5C.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $ewq5C.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $02a6ea8308eefe55$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $02a6ea8308eefe55$var$buildFocusableOptionsWithIds($02a6ea8308eefe55$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $ewq5C.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $02a6ea8308eefe55$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $02a6ea8308eefe55$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $02a6ea8308eefe55$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $ewq5C.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $02a6ea8308eefe55$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $d49SP.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $ewq5C.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $02a6ea8308eefe55$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$02a6ea8308eefe55$var$instanceId);
        _this.state.selectValue = (0, $ewq5C.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $02a6ea8308eefe55$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $cHPF9.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $ewq5C.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $ewq5C.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $02a6ea8308eefe55$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($02a6ea8308eefe55$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $d49SP.default)((0, $d49SP.default)({}, $02a6ea8308eefe55$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $02a6ea8308eefe55$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $02a6ea8308eefe55$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $02a6ea8308eefe55$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $ewq5C.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $8nd05.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $8nd05.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $8nd05.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $ewq5C.M), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$LiveRegion$1, (0, $8nd05.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $ewq5C.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $02a6ea8308eefe55$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $02a6ea8308eefe55$var$buildFocusableOptionsWithIds($02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $02a6ea8308eefe55$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $02a6ea8308eefe55$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $02a6ea8308eefe55$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $ewq5C.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$02a6ea8308eefe55$export$25ce5a424b770e84.defaultProps = $02a6ea8308eefe55$export$407448d2b89b1813;

});
parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $4ZreY.default)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $VFVve.default)(subClass, superClass);
}

});

parcelRegister("enfmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76f20fb39fa9d46$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $fhGLX = parcelRequire("fhGLX");

var $9715X = parcelRequire("9715X");
function $a76f20fb39fa9d46$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $fhGLX.default)();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}

});
parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $fSwVM.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(self);
}

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $cN7Ua.default)(arr) || (0, $dOjF6.default)(arr) || (0, $abLc2.default)(arr) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7K8zV.default)(arr);
}

});

parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("ewq5C", function(module, exports) {

$parcel$export(module.exports, "J", () => $a9284aba291bbde9$export$b4171a6734a65d42);
$parcel$export(module.exports, "E", () => $a9284aba291bbde9$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "H", () => $a9284aba291bbde9$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "G", () => $a9284aba291bbde9$export$2329c99376c9d0a4);
$parcel$export(module.exports, "I", () => $a9284aba291bbde9$export$9bb611d729802a56);
$parcel$export(module.exports, "z", () => $a9284aba291bbde9$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $a9284aba291bbde9$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $a9284aba291bbde9$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "K", () => $a9284aba291bbde9$export$3466f893ebf79586);
$parcel$export(module.exports, "D", () => $a9284aba291bbde9$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $a9284aba291bbde9$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $a9284aba291bbde9$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $a9284aba291bbde9$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $a9284aba291bbde9$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $a9284aba291bbde9$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $a9284aba291bbde9$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $a9284aba291bbde9$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $a9284aba291bbde9$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $a9284aba291bbde9$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $a9284aba291bbde9$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $a9284aba291bbde9$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $a9284aba291bbde9$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $a9284aba291bbde9$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $a9284aba291bbde9$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $a9284aba291bbde9$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $a9284aba291bbde9$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $a9284aba291bbde9$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $a9284aba291bbde9$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $a9284aba291bbde9$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $a9284aba291bbde9$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $a9284aba291bbde9$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $a9284aba291bbde9$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $a9284aba291bbde9$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $a9284aba291bbde9$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $a9284aba291bbde9$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $a9284aba291bbde9$export$d141bba7fdc215a3);
$parcel$export(module.exports, "F", () => $a9284aba291bbde9$export$d66501df72047452);

var $d49SP = parcelRequire("d49SP");

var $8nd05 = parcelRequire("8nd05");

var $8zogs = parcelRequire("8zogs");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $hvnYt = parcelRequire("hvnYt");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $618j3 = parcelRequire("618j3");

var $jLbqB = parcelRequire("jLbqB");
var $a9284aba291bbde9$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $a9284aba291bbde9$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $a9284aba291bbde9$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $a9284aba291bbde9$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($a9284aba291bbde9$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $a9284aba291bbde9$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($a9284aba291bbde9$var$isArray(value)) return value.filter(Boolean);
    if ((0, $fSwVM.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $a9284aba291bbde9$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $9X7IJ.default)(props, $a9284aba291bbde9$var$_excluded$4);
    return (0, $d49SP.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $a9284aba291bbde9$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $a9284aba291bbde9$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $a9284aba291bbde9$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $a9284aba291bbde9$var$normalizedHeight(el) {
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $a9284aba291bbde9$var$getScrollTop(el) {
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a9284aba291bbde9$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $a9284aba291bbde9$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $a9284aba291bbde9$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a9284aba291bbde9$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a9284aba291bbde9$export$b4171a6734a65d42;
    var start = $a9284aba291bbde9$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $a9284aba291bbde9$var$easeOutCubic(currentTime, start, change, duration);
        $a9284aba291bbde9$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $a9284aba291bbde9$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a9284aba291bbde9$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a9284aba291bbde9$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $a9284aba291bbde9$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $a9284aba291bbde9$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $a9284aba291bbde9$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $a9284aba291bbde9$var$passiveOptionAccessed = false;
var $a9284aba291bbde9$var$options = {
    get passive () {
        return $a9284aba291bbde9$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $a9284aba291bbde9$var$w = typeof window !== "undefined" ? window : {};
if ($a9284aba291bbde9$var$w.addEventListener && $a9284aba291bbde9$var$w.removeEventListener) {
    $a9284aba291bbde9$var$w.addEventListener("p", $a9284aba291bbde9$export$b4171a6734a65d42, $a9284aba291bbde9$var$options);
    $a9284aba291bbde9$var$w.removeEventListener("p", $a9284aba291bbde9$export$b4171a6734a65d42, false);
}
var $a9284aba291bbde9$export$2408f22a0fab9ae5 = $a9284aba291bbde9$var$passiveOptionAccessed;
function $a9284aba291bbde9$export$3466f893ebf79586(item) {
    return item != null;
}
function $a9284aba291bbde9$var$isArray(arg) {
    return Array.isArray(arg);
}
function $a9284aba291bbde9$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a9284aba291bbde9$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $a9284aba291bbde9$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $a9284aba291bbde9$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $eUqlC.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $a9284aba291bbde9$var$_excluded$3 = [
    "children",
    "innerProps"
], $a9284aba291bbde9$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $a9284aba291bbde9$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $a9284aba291bbde9$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $a9284aba291bbde9$var$normalizedHeight(scrollParent);
    var scrollTop = $a9284aba291bbde9$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $a9284aba291bbde9$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $a9284aba291bbde9$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $a9284aba291bbde9$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $a9284aba291bbde9$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $d49SP.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $kSlfw.default)(_objectSpread2, $a9284aba291bbde9$var$alignToControl(placement), "100%"), (0, $kSlfw.default)(_objectSpread2, "position", "absolute"), (0, $kSlfw.default)(_objectSpread2, "width", "100%"), (0, $kSlfw.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $a9284aba291bbde9$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $a9284aba291bbde9$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($a9284aba291bbde9$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $eUqlC.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $jLbqB.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $a9284aba291bbde9$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            placement: placement || $a9284aba291bbde9$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $a9284aba291bbde9$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $a9284aba291bbde9$var$Menu$1 = $a9284aba291bbde9$var$Menu;
// ==============================
// Menu List
// ==============================
var $a9284aba291bbde9$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $d49SP.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $a9284aba291bbde9$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $a9284aba291bbde9$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $d49SP.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $a9284aba291bbde9$export$3b14a55fb2447963 = $a9284aba291bbde9$var$noticeCSS;
var $a9284aba291bbde9$export$342063e11d6c3cad = $a9284aba291bbde9$var$noticeCSS;
var $a9284aba291bbde9$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $9X7IJ.default)(_ref6, $a9284aba291bbde9$var$_excluded$3);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $9X7IJ.default)(_ref7, $a9284aba291bbde9$var$_excluded2$1);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $a9284aba291bbde9$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $a9284aba291bbde9$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($a9284aba291bbde9$var$coercePlacement(menuPlacement)), _useState6 = (0, $eUqlC.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $eUqlC.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $a9284aba291bbde9$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $jLbqB.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $618j3.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $jLbqB.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $8zogs.jsx)("div", (0, $8nd05.default)({
        ref: setMenuPortalElement
    }, $a9284aba291bbde9$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $8zogs.jsx)($a9284aba291bbde9$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $a9284aba291bbde9$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $a9284aba291bbde9$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $a9284aba291bbde9$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $d49SP.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $a9284aba291bbde9$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $a9284aba291bbde9$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $a9284aba291bbde9$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$_templateObject;
var $a9284aba291bbde9$var$_excluded$2 = [
    "size"
], $a9284aba291bbde9$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $a9284aba291bbde9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $a9284aba291bbde9$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $a9284aba291bbde9$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9X7IJ.default)(_ref, $a9284aba291bbde9$var$_excluded$2);
    return (0, $8zogs.jsx)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $a9284aba291bbde9$var$_ref2
    }, props));
};
var $a9284aba291bbde9$var$CrossIcon = function CrossIcon(props) {
    return (0, $8zogs.jsx)($a9284aba291bbde9$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $8zogs.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $a9284aba291bbde9$var$DownChevron = function DownChevron(props) {
    return (0, $8zogs.jsx)($a9284aba291bbde9$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $8zogs.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $a9284aba291bbde9$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $d49SP.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $a9284aba291bbde9$export$f1e1789686576879 = $a9284aba291bbde9$var$baseCSS;
var $a9284aba291bbde9$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $8zogs.jsx)($a9284aba291bbde9$var$DownChevron, null));
};
var $a9284aba291bbde9$export$407448d2b89b1813 = $a9284aba291bbde9$var$baseCSS;
var $a9284aba291bbde9$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $8zogs.jsx)($a9284aba291bbde9$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $a9284aba291bbde9$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $d49SP.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $a9284aba291bbde9$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $8zogs.jsx)("span", (0, $8nd05.default)({}, innerProps, $a9284aba291bbde9$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $a9284aba291bbde9$var$loadingDotAnimations = (0, $8zogs.keyframes)($a9284aba291bbde9$var$_templateObject || ($a9284aba291bbde9$var$_templateObject = (0, $hvnYt.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $a9284aba291bbde9$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $d49SP.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $a9284aba291bbde9$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $8zogs.jsx)("span", {
        css: /*#__PURE__*/ (0, $8zogs.css)({
            animation: "".concat($a9284aba291bbde9$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $a9284aba291bbde9$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $9X7IJ.default)(_ref7, $a9284aba291bbde9$var$_excluded2);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $8zogs.jsx)($a9284aba291bbde9$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $8zogs.jsx)($a9284aba291bbde9$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $8zogs.jsx)($a9284aba291bbde9$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $a9284aba291bbde9$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $d49SP.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $a9284aba291bbde9$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({
        ref: innerRef
    }, $a9284aba291bbde9$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $a9284aba291bbde9$var$Control$1 = $a9284aba291bbde9$var$Control;
var $a9284aba291bbde9$var$_excluded$1 = [
    "data"
];
var $a9284aba291bbde9$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $a9284aba291bbde9$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $8zogs.jsx)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $8zogs.jsx)("div", null, children));
};
var $a9284aba291bbde9$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $d49SP.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $a9284aba291bbde9$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $a9284aba291bbde9$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $9X7IJ.default)(_cleanCommonProps, $a9284aba291bbde9$var$_excluded$1);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $a9284aba291bbde9$var$Group$1 = $a9284aba291bbde9$var$Group;
var $a9284aba291bbde9$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $a9284aba291bbde9$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)((0, $d49SP.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $a9284aba291bbde9$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $a9284aba291bbde9$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $a9284aba291bbde9$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $d49SP.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $a9284aba291bbde9$var$spacingStyle)
};
var $a9284aba291bbde9$var$inputStyle = function inputStyle(isHidden) {
    return (0, $d49SP.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $a9284aba291bbde9$var$spacingStyle);
};
var $a9284aba291bbde9$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $a9284aba291bbde9$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $9X7IJ.default)(_cleanCommonProps, $a9284aba291bbde9$var$_excluded);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $8zogs.jsx)("input", (0, $8nd05.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $a9284aba291bbde9$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $a9284aba291bbde9$var$Input$1 = $a9284aba291bbde9$var$Input;
var $a9284aba291bbde9$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $d49SP.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $a9284aba291bbde9$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $d49SP.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $a9284aba291bbde9$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $8zogs.jsx)("div", innerProps, children);
};
var $a9284aba291bbde9$var$MultiValueContainer = $a9284aba291bbde9$var$MultiValueGeneric;
var $a9284aba291bbde9$var$MultiValueLabel = $a9284aba291bbde9$var$MultiValueGeneric;
function $a9284aba291bbde9$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({
        role: "button"
    }, innerProps), children || (0, $8zogs.jsx)($a9284aba291bbde9$var$CrossIcon, {
        size: 14
    }));
}
var $a9284aba291bbde9$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $8zogs.jsx)(Container, {
        data: data,
        innerProps: (0, $d49SP.default)((0, $d49SP.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $8zogs.jsx)(Label, {
        data: data,
        innerProps: (0, $d49SP.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $8zogs.jsx)(Remove, {
        data: data,
        innerProps: (0, $d49SP.default)((0, $d49SP.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $a9284aba291bbde9$var$MultiValue$1 = $a9284aba291bbde9$var$MultiValue;
var $a9284aba291bbde9$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $a9284aba291bbde9$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $a9284aba291bbde9$var$Option$1 = $a9284aba291bbde9$var$Option;
var $a9284aba291bbde9$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$Placeholder$1 = $a9284aba291bbde9$var$Placeholder;
var $a9284aba291bbde9$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $a9284aba291bbde9$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $a9284aba291bbde9$var$SingleValue$1 = $a9284aba291bbde9$var$SingleValue;
var $a9284aba291bbde9$export$db3b6bfb95261072 = {
    ClearIndicator: $a9284aba291bbde9$var$ClearIndicator,
    Control: $a9284aba291bbde9$var$Control$1,
    DropdownIndicator: $a9284aba291bbde9$var$DropdownIndicator,
    DownChevron: $a9284aba291bbde9$var$DownChevron,
    CrossIcon: $a9284aba291bbde9$var$CrossIcon,
    Group: $a9284aba291bbde9$var$Group$1,
    GroupHeading: $a9284aba291bbde9$var$GroupHeading,
    IndicatorsContainer: $a9284aba291bbde9$var$IndicatorsContainer,
    IndicatorSeparator: $a9284aba291bbde9$var$IndicatorSeparator,
    Input: $a9284aba291bbde9$var$Input$1,
    LoadingIndicator: $a9284aba291bbde9$var$LoadingIndicator,
    Menu: $a9284aba291bbde9$var$Menu$1,
    MenuList: $a9284aba291bbde9$var$MenuList,
    MenuPortal: $a9284aba291bbde9$var$MenuPortal,
    LoadingMessage: $a9284aba291bbde9$var$LoadingMessage,
    NoOptionsMessage: $a9284aba291bbde9$var$NoOptionsMessage,
    MultiValue: $a9284aba291bbde9$var$MultiValue$1,
    MultiValueContainer: $a9284aba291bbde9$var$MultiValueContainer,
    MultiValueLabel: $a9284aba291bbde9$var$MultiValueLabel,
    MultiValueRemove: $a9284aba291bbde9$var$MultiValueRemove,
    Option: $a9284aba291bbde9$var$Option$1,
    Placeholder: $a9284aba291bbde9$var$Placeholder$1,
    SelectContainer: $a9284aba291bbde9$var$SelectContainer,
    SingleValue: $a9284aba291bbde9$var$SingleValue$1,
    ValueContainer: $a9284aba291bbde9$var$ValueContainer
};
var $a9284aba291bbde9$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $d49SP.default)((0, $d49SP.default)({}, $a9284aba291bbde9$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("8zogs", function(module, exports) {

$parcel$export(module.exports, "css", () => $63d46a01db878c10$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $63d46a01db878c10$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $63d46a01db878c10$export$c8a8987d4410bf2d);

var $1my5K = parcelRequire("1my5K");

var $acw62 = parcelRequire("acw62");

var $2Hahg = parcelRequire("2Hahg");

var $2cQcJ = parcelRequire("2cQcJ");

var $cqnxX = parcelRequire("cqnxX");
parcelRequire("lDTld");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $1my5K.h).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $1my5K.E);
    createElementArgArray[1] = (0, $1my5K.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $1my5K.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cqnxX.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $1my5K.T)));
    if (!(0, $1my5K.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2Hahg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cqnxX.serializeStyles)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2Hahg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $2Hahg.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $1my5K.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2Hahg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $1my5K.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;

});
parcelRegister("1my5K", function(module, exports) {

$parcel$export(module.exports, "i", () => $0fe24a6591b39473$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $0fe24a6591b39473$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $0fe24a6591b39473$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $0fe24a6591b39473$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $0fe24a6591b39473$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $0fe24a6591b39473$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $0fe24a6591b39473$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $lDTld = parcelRequire("lDTld");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $kKN31 = parcelRequire("kKN31");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $lDTld.default)({
    key: "css"
}) : null);
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $lDTld.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $kKN31.default)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $2Hahg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cqnxX.serializeStyles)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;

});
parcelRegister("lDTld", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc182b1f84212d3f$export$2e2bcd8739ae039);

var $jmsCu = parcelRequire("jmsCu");

var $fm8kz = parcelRequire("fm8kz");
parcelRequire("iq6RI");
parcelRequire("9ffXE");
var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($fc182b1f84212d3f$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fm8kz.stringify),
        (0, $fm8kz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jmsCu.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmsCu", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e18645ac1956fbe6$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("kKN31", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1be2661c8fac766$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9cCWX"));

});
parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});




parcelRegister("2Hahg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $1f6791d0a193b918$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $1f6791d0a193b918$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $1f6791d0a193b918$export$6f077d94b33a01aa);
var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cqnxX", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $90ba2da1f62e5f1b$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2cQcJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $19b532704a3a90e7$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $19b532704a3a90e7$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hvnYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe7edbf3ccb8828$export$2e2bcd8739ae039);
function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "platform", () => $461947879dcdbcd4$export$722a64dea1b767dc);
$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $461947879dcdbcd4$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $461947879dcdbcd4$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $461947879dcdbcd4$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $461947879dcdbcd4$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $461947879dcdbcd4$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $461947879dcdbcd4$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $461947879dcdbcd4$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $461947879dcdbcd4$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $461947879dcdbcd4$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $461947879dcdbcd4$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $461947879dcdbcd4$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("33bLr")).getOverflowAncestors);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $461947879dcdbcd4$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $461947879dcdbcd4$var$isTopLayer(element) {
    return $461947879dcdbcd4$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? $461947879dcdbcd4$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if ((0, $33bLr.isHTMLElement)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + (0, $33bLr.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === "rtl") x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $461947879dcdbcd4$var$isTopLayer(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1obCQ.max)(rect.top, accRect.top);
        accRect.right = (0, $1obCQ.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1obCQ.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1obCQ.max)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $33bLr.getComputedStyle)(element).position === "static";
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $33bLr.getWindow)(element);
    if ($461947879dcdbcd4$var$isTopLayer(element)) return win;
    if (!(0, $33bLr.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $33bLr.getParentNode)(element);
        while(svgOffsetParent && !(0, $33bLr.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $33bLr.isElement)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $33bLr.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $33bLr.isLastTraversableNode)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $33bLr.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...(0, $33bLr.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $cZ41y.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $cZ41y.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $973e4da43f2a375d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1obCQ.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === "left";
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)((0, $1obCQ.getSide)(placement));
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1obCQ.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1obCQ.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1obCQ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1obCQ.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $1obCQ.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $1obCQ.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1obCQ.max)(overflow.left, 0);
                const xMax = (0, $1obCQ.max)(overflow.right, 0);
                const yMin = (0, $1obCQ.max)(overflow.top, 0);
                const yMax = (0, $1obCQ.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1obCQ.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1obCQ.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $238ac70369f38756$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$d6c4e8150c35fed1(element) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("jLbqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62b4578a0a2b358$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;

});


parcelRegister("5mpUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e731b8aba846199$export$2e2bcd8739ae039);
var $3e731b8aba846199$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $3e731b8aba846199$var$isEqual(first, second) {
    if (first === second) return true;
    if ($3e731b8aba846199$var$safeIsNaN(first) && $3e731b8aba846199$var$safeIsNaN(second)) return true;
    return false;
}
function $3e731b8aba846199$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$3e731b8aba846199$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $3e731b8aba846199$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $3e731b8aba846199$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("cbdLd", function(module, exports) {

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8de12fa6a893dcd1$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $5DKOa(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : String(i);
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(arr, i) {
    return $gpDEB(arr) || $kzBhd(arr, i) || $72a6v(arr, i) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2zZPz(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2zZPz(o, minLen);
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c05no(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5DKOa(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $aAhot(subClass, superClass);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9jKhT", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");

var $5HCVq = parcelRequire("5HCVq");

var $eN9hz = parcelRequire("eN9hz");
function $6c89cb228f797fa5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5HCVq();
    return function _createSuperInternal() {
        var Super = $cGTaw(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cGTaw(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $eN9hz(this, result);
    };
}
module.exports = $6c89cb228f797fa5$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(o) {
    module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $93d4339c80153a6a$var$_getPrototypeOf(o);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5HCVq", function(module, exports) {
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac4cd79166dac6e4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(self);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(arr) {
    return $5F6pO(arr) || $hAHB6(arr) || $72a6v(arr) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2zZPz(arr);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gS6QF", function(module, exports) {
function $c4870074adc2be76$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
module.exports = $c4870074adc2be76$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("01djI", function(module, exports) {

$parcel$export(module.exports, "AsyncTypeahead", () => (parcelRequire("fEyWK")).default);
// Components
parcelRequire("gab7z");
var $fEyWK = parcelRequire("fEyWK");
parcelRequire("9rTkk");
var $gTYbN = parcelRequire("gTYbN");
parcelRequire("8cKJG");
var $6raUh = parcelRequire("6raUh");
parcelRequire("6ILFq");
var $dFVhP = parcelRequire("dFVhP");
var $6ILFq = parcelRequire("6ILFq");
parcelRequire("guWSP");
var $gzLlR = parcelRequire("gzLlR");
parcelRequire("bOhDN");
var $aVH5j = parcelRequire("aVH5j");
parcelRequire("5s1zT");
var $fzpxR = parcelRequire("fzpxR");
parcelRequire("6JAUu");
var $2RnsI = parcelRequire("2RnsI");
parcelRequire("dcZRV");
var $2rWeT = parcelRequire("2rWeT");
parcelRequire("gbk80");
var $fK6wT = parcelRequire("fK6wT");
parcelRequire("l4Uyk");
var $7crIX = parcelRequire("7crIX");
parcelRequire("f6F5t");
var $4VvGI = parcelRequire("4VvGI");
parcelRequire("7H5QO");
var $cAEjP = parcelRequire("cAEjP");
parcelRequire("2ba9n");
parcelRequire("cChoD");
parcelRequire("lIXrf");

var $bv1Tx = parcelRequire("bv1Tx");

});
parcelRegister("gab7z", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("fEyWK")).default);

var $fEyWK = parcelRequire("fEyWK");

});
parcelRegister("fEyWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b655b31a4520bd45$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");

var $2ba9n = parcelRequire("2ba9n");
parcelRequire("gbk80");
var $fK6wT = parcelRequire("fK6wT");
var $b655b31a4520bd45$var$AsyncTypeahead = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fK6wT.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, (0, $2ba9n.useAsync)(props), {
        ref: ref
    }));
});
var $b655b31a4520bd45$export$2e2bcd8739ae039 = $b655b31a4520bd45$var$AsyncTypeahead;

});
parcelRegister("2ba9n", function(module, exports) {

$parcel$export(module.exports, "useAsync", () => $19647b806971472d$export$cdf1dc76b55502e3);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $lwfqC = parcelRequire("lwfqC");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $dkoqn = parcelRequire("dkoqn");

var $d1b47 = parcelRequire("d1b47");

var $1pmaC = parcelRequire("1pmaC");
parcelRequire("5cWuV");
var $5UFLY = parcelRequire("5UFLY");
var $jZK3h = parcelRequire("jZK3h");
var $ip893 = parcelRequire("ip893");
var $19647b806971472d$var$_excluded = [
    "allowNew",
    "delay",
    "emptyLabel",
    "isLoading",
    "minLength",
    "onInputChange",
    "onSearch",
    "options",
    "promptText",
    "searchText",
    "useCache"
];
function $19647b806971472d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19647b806971472d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19647b806971472d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19647b806971472d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19647b806971472d$var$propTypes = {
    /**
   * Delay, in milliseconds, before performing search.
   */ delay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Callback to perform when the search is executed.
   */ onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, $1pmaC.optionType)),
    /**
   * Message displayed in the menu when there is no user input.
   */ promptText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Message displayed in the menu while the request is pending.
   */ searchText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Whether or not the component should cache query results.
   */ useCache: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
function $19647b806971472d$export$cdf1dc76b55502e3(props) {
    var allowNew = props.allowNew, _props$delay = props.delay, delay = _props$delay === void 0 ? 200 : _props$delay, emptyLabel = props.emptyLabel, isLoading = props.isLoading, _props$minLength = props.minLength, minLength = _props$minLength === void 0 ? 2 : _props$minLength, onInputChange = props.onInputChange, onSearch = props.onSearch, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, _props$promptText = props.promptText, promptText = _props$promptText === void 0 ? "Type to search..." : _props$promptText, _props$searchText = props.searchText, searchText = _props$searchText === void 0 ? "Searching..." : _props$searchText, _props$useCache = props.useCache, useCache = _props$useCache === void 0 ? true : _props$useCache, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $19647b806971472d$var$_excluded);
    var cacheRef = (0, $acw62.useRef)({});
    var handleSearchDebouncedRef = (0, $acw62.useRef)(null);
    var queryRef = (0, $acw62.useRef)(props.defaultInputValue || "");
    var forceUpdate = (0, $dkoqn.default)();
    var prevProps = (0, $d1b47.default)(props);
    var handleSearch = (0, $acw62.useCallback)(function(query) {
        queryRef.current = query;
        if (!query || minLength && query.length < minLength) return;
        // Use cached results, if applicable.
        if (useCache && cacheRef.current[query]) {
            // Re-render the component with the cached results.
            forceUpdate();
            return;
        }
        // Perform the search.
        onSearch(query);
    }, [
        forceUpdate,
        minLength,
        onSearch,
        useCache
    ]);
    // Set the debounced search function.
    (0, $acw62.useEffect)(function() {
        handleSearchDebouncedRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($lwfqC)))(handleSearch, delay);
        return function() {
            handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
        };
    }, [
        delay,
        handleSearch
    ]);
    (0, $acw62.useEffect)(function() {
        // Ensure that we've gone from a loading to a completed state. Otherwise
        // an empty response could get cached if the component updates during the
        // request (eg: if the parent re-renders for some reason).
        if (!isLoading && prevProps && prevProps.isLoading && useCache) cacheRef.current[queryRef.current] = options;
    });
    var getEmptyLabel = function getEmptyLabel() {
        if (!queryRef.current.length) return promptText;
        if (isLoading) return searchText;
        return emptyLabel;
    };
    var handleInputChange = (0, $acw62.useCallback)(function(query, e) {
        onInputChange && onInputChange(query, e);
        handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
    }, [
        onInputChange
    ]);
    var cachedQuery = cacheRef.current[queryRef.current];
    return $19647b806971472d$var$_objectSpread($19647b806971472d$var$_objectSpread({}, otherProps), {}, {
        // Disable custom selections during a search if `allowNew` isn't a function.
        allowNew: (0, $jZK3h.isFunction)(allowNew) ? allowNew : allowNew && !isLoading,
        emptyLabel: getEmptyLabel(),
        isLoading: isLoading,
        minLength: minLength,
        onInputChange: handleInputChange,
        options: useCache && cachedQuery ? cachedQuery : options
    });
}
function $19647b806971472d$export$3523553ee0bc32a8(Component) {
    (0, $ip893.default)(false, "Warning: `withAsync` is deprecated and will be removed in the next major version. Use `useAsync` instead.");
    var AsyncTypeahead = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, $19647b806971472d$export$cdf1dc76b55502e3(props), {
            ref: ref
        }));
    });
    AsyncTypeahead.displayName = "withAsync(".concat((0, $5UFLY.default)(Component), ")");
    // @ts-ignore
    AsyncTypeahead.propTypes = $19647b806971472d$var$propTypes;
    return AsyncTypeahead;
}

});
parcelRegister("lwfqC", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
module.exports = $faa88de4f0afd1d0$var$debounce;

});

parcelRegister("1pmaC", function(module, exports) {

$parcel$export(module.exports, "sizeType", () => $106952c80969a26f$export$9ae6167e9ee9e6d0);
$parcel$export(module.exports, "checkPropType", () => $106952c80969a26f$export$1c8c72d28a0627d2);
$parcel$export(module.exports, "caseSensitiveType", () => $106952c80969a26f$export$8a831d0ae116fbcd);
$parcel$export(module.exports, "defaultInputValueType", () => $106952c80969a26f$export$5534cbfe725ae92a);
$parcel$export(module.exports, "defaultSelectedType", () => $106952c80969a26f$export$79f4757fa6baab77);
$parcel$export(module.exports, "highlightOnlyResultType", () => $106952c80969a26f$export$f8e54140ea7ea3a8);
$parcel$export(module.exports, "ignoreDiacriticsType", () => $106952c80969a26f$export$9b9aee2bc2e2973d);
$parcel$export(module.exports, "inputPropsType", () => $106952c80969a26f$export$82c0eddbd071e45f);
$parcel$export(module.exports, "isRequiredForA11y", () => $106952c80969a26f$export$50bb8c440cf2a42c);
$parcel$export(module.exports, "labelKeyType", () => $106952c80969a26f$export$8ae4524d34467ed5);
$parcel$export(module.exports, "optionType", () => $106952c80969a26f$export$7de5fae3688fa523);
$parcel$export(module.exports, "selectedType", () => $106952c80969a26f$export$1f1343c4475956f4);

var $g5Zhu = parcelRequire("g5Zhu");

var $c9Z8w = parcelRequire("c9Z8w");

var $lYCYm = parcelRequire("lYCYm");
parcelRequire("5cWuV");
var $jZK3h = parcelRequire("jZK3h");
var $ip893 = parcelRequire("ip893");
var $106952c80969a26f$var$INPUT_PROPS_BLACKLIST = [
    {
        alt: "onBlur",
        prop: "onBlur"
    },
    {
        alt: "onInputChange",
        prop: "onChange"
    },
    {
        alt: "onFocus",
        prop: "onFocus"
    },
    {
        alt: "onKeyDown",
        prop: "onKeyDown"
    }
];
var $106952c80969a26f$export$9ae6167e9ee9e6d0 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf((0, $lYCYm.SIZES));
function $106952c80969a26f$export$1c8c72d28a0627d2(validator, callback) {
    return function(props, propName, componentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).checkPropTypes((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, propName, validator), props, "prop", componentName);
        (0, $jZK3h.isFunction)(callback) && callback(props, propName, componentName);
    };
}
function $106952c80969a26f$export$8a831d0ae116fbcd(props) {
    var caseSensitive = props.caseSensitive, filterBy = props.filterBy;
    (0, $ip893.default)(!caseSensitive || typeof filterBy !== "function", "Your `filterBy` function will override the `caseSensitive` prop.");
}
function $106952c80969a26f$export$cdd73fc4100a6ef4(validator, reason) {
    return function(props, propName, componentName) {
        if (props[propName] != null) (0, $ip893.default)(false, "The `".concat(propName, "` prop is deprecated. ").concat(reason));
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).checkPropTypes((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, propName, validator), props, "prop", componentName);
    };
}
function $106952c80969a26f$export$5534cbfe725ae92a(props) {
    var defaultInputValue = props.defaultInputValue, defaultSelected = props.defaultSelected, multiple = props.multiple, selected = props.selected;
    var name = defaultSelected.length ? "defaultSelected" : "selected";
    (0, $ip893.default)(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function $106952c80969a26f$export$79f4757fa6baab77(props) {
    var defaultSelected = props.defaultSelected, multiple = props.multiple;
    (0, $ip893.default)(multiple || defaultSelected.length <= 1, "You are passing multiple options to the `defaultSelected` prop of a Typeahead in single-select mode. The selections will be truncated to a single selection.");
}
function $106952c80969a26f$export$f8e54140ea7ea3a8(_ref) {
    var allowNew = _ref.allowNew, highlightOnlyResult = _ref.highlightOnlyResult;
    (0, $ip893.default)(!(highlightOnlyResult && allowNew), "`highlightOnlyResult` will not work with `allowNew`.");
}
function $106952c80969a26f$export$9b9aee2bc2e2973d(props) {
    var filterBy = props.filterBy, ignoreDiacritics = props.ignoreDiacritics;
    (0, $ip893.default)(ignoreDiacritics || typeof filterBy !== "function", "Your `filterBy` function will override the `ignoreDiacritics` prop.");
}
function $106952c80969a26f$export$82c0eddbd071e45f(_ref2) {
    var inputProps = _ref2.inputProps;
    if (!(inputProps && Object.prototype.toString.call(inputProps) === "[object Object]")) return;
    // Blacklisted properties.
    $106952c80969a26f$var$INPUT_PROPS_BLACKLIST.forEach(function(_ref3) {
        var alt = _ref3.alt, prop = _ref3.prop;
        var msg = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
        (0, $ip893.default)(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg));
    });
}
function $106952c80969a26f$export$50bb8c440cf2a42c(props, propName, componentName) {
    (0, $ip893.default)(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + "accessible for users of assistive technologies such as screen readers.");
}
function $106952c80969a26f$export$8ae4524d34467ed5(_ref4) {
    var allowNew = _ref4.allowNew, labelKey = _ref4.labelKey;
    (0, $ip893.default)(!((0, $jZK3h.isFunction)(labelKey) && allowNew), "`labelKey` must be a string when `allowNew={true}`.");
}
var $106952c80969a26f$export$7de5fae3688fa523 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
]);
function $106952c80969a26f$export$1f1343c4475956f4(_ref5) {
    var multiple = _ref5.multiple, onChange = _ref5.onChange, selected = _ref5.selected;
    (0, $ip893.default)(multiple || !selected || selected.length <= 1, "You are passing multiple options to the `selected` prop of a Typeahead in single-select mode. This may lead to unexpected behaviors or errors.");
    (0, $ip893.default)(!selected || selected && (0, $jZK3h.isFunction)(onChange), "You provided a `selected` prop without an `onChange` handler. If you want the typeahead to be uncontrolled, use `defaultSelected`. Otherwise, set `onChange`.");
}

});
parcelRegister("lYCYm", function(module, exports) {

$parcel$export(module.exports, "ALIGN_VALUES", () => $fffd6eb312eea2ac$export$54df5a921294d7ab);
$parcel$export(module.exports, "DEFAULT_LABELKEY", () => $fffd6eb312eea2ac$export$365087e449b345ed);
$parcel$export(module.exports, "SIZES", () => $fffd6eb312eea2ac$export$57732b6846a8df7c);
var $fffd6eb312eea2ac$export$54df5a921294d7ab = [
    "justify",
    "left",
    "right"
];
var $fffd6eb312eea2ac$export$365087e449b345ed = "label";
var $fffd6eb312eea2ac$export$57732b6846a8df7c = [
    "lg",
    "sm"
];

});

parcelRegister("5cWuV", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => (parcelRequire("jZK3h")).isFunction);
$parcel$export(module.exports, "isString", () => (parcelRequire("jZK3h")).isString);
$parcel$export(module.exports, "noop", () => (parcelRequire("jZK3h")).noop);
$parcel$export(module.exports, "pick", () => (parcelRequire("jZK3h")).pick);
$parcel$export(module.exports, "uniqueId", () => (parcelRequire("jZK3h")).uniqueId);
$parcel$export(module.exports, "isSizeLarge", () => (parcelRequire("lnugP")).isSizeLarge);
$parcel$export(module.exports, "isSizeSmall", () => (parcelRequire("lnugP")).isSizeSmall);

$parcel$export(module.exports, "addCustomOption", () => (parcelRequire("1eu4T")).default);
$parcel$export(module.exports, "defaultFilterBy", () => (parcelRequire("j8xQV")).default);
$parcel$export(module.exports, "defaultSelectHint", () => (parcelRequire("9qZvf")).default);
$parcel$export(module.exports, "getDisplayName", () => (parcelRequire("5UFLY")).default);
$parcel$export(module.exports, "getHintText", () => (parcelRequire("dH4ut")).default);
$parcel$export(module.exports, "getInputProps", () => (parcelRequire("kiVBm")).default);
$parcel$export(module.exports, "getInputText", () => (parcelRequire("lWS4N")).default);
$parcel$export(module.exports, "getIsOnlyResult", () => (parcelRequire("gVTaw")).default);
$parcel$export(module.exports, "getMatchBounds", () => (parcelRequire("02mwI")).default);
$parcel$export(module.exports, "getMenuItemId", () => (parcelRequire("9YoBW")).default);
$parcel$export(module.exports, "getOptionLabel", () => (parcelRequire("lhbIa")).default);
$parcel$export(module.exports, "getOptionProperty", () => (parcelRequire("bDoz9")).default);
$parcel$export(module.exports, "getStringLabelKey", () => (parcelRequire("hcUKQ")).default);
$parcel$export(module.exports, "getTruncatedOptions", () => (parcelRequire("hV9FL")).default);
$parcel$export(module.exports, "getUpdatedActiveIndex", () => (parcelRequire("kwCOh")).default);
$parcel$export(module.exports, "isSelectable", () => (parcelRequire("19Q4n")).default);
$parcel$export(module.exports, "isShown", () => (parcelRequire("7jwFm")).default);
$parcel$export(module.exports, "preventInputBlur", () => (parcelRequire("8ojTx")).default);
$parcel$export(module.exports, "propsWithBsClassName", () => (parcelRequire("kKg6I")).default);
$parcel$export(module.exports, "validateSelectedPropChange", () => (parcelRequire("96Bz6")).default);
$parcel$export(module.exports, "warn", () => (parcelRequire("ip893")).default);

var $1eu4T = parcelRequire("1eu4T");

var $j8xQV = parcelRequire("j8xQV");

var $9qZvf = parcelRequire("9qZvf");

var $5UFLY = parcelRequire("5UFLY");

var $dH4ut = parcelRequire("dH4ut");

var $kiVBm = parcelRequire("kiVBm");

var $lWS4N = parcelRequire("lWS4N");

var $gVTaw = parcelRequire("gVTaw");

var $02mwI = parcelRequire("02mwI");

var $9YoBW = parcelRequire("9YoBW");

var $lhbIa = parcelRequire("lhbIa");

var $bDoz9 = parcelRequire("bDoz9");

var $hcUKQ = parcelRequire("hcUKQ");

var $hV9FL = parcelRequire("hV9FL");

var $kwCOh = parcelRequire("kwCOh");

var $ezOlr = parcelRequire("ezOlr");

var $19Q4n = parcelRequire("19Q4n");

var $7jwFm = parcelRequire("7jwFm");
parcelRequire("jZK3h");

var $8ojTx = parcelRequire("8ojTx");

var $kKg6I = parcelRequire("kKg6I");
parcelRequire("lnugP");

var $hK1Kc = parcelRequire("hK1Kc");

var $96Bz6 = parcelRequire("96Bz6");

var $ip893 = parcelRequire("ip893");

});
parcelRegister("1eu4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e5e6e1e53c2c9d5$export$2e2bcd8739ae039);

var $lhbIa = parcelRequire("lhbIa");

var $jZK3h = parcelRequire("jZK3h");
function $0e5e6e1e53c2c9d5$var$addCustomOption(results, props) {
    var allowNew = props.allowNew, labelKey = props.labelKey, text = props.text;
    if (!allowNew || !text.trim()) return false;
    // If the consumer has provided a callback, use that to determine whether or
    // not to add the custom option.
    if ((0, $jZK3h.isFunction)(allowNew)) return allowNew(results, props);
    // By default, don't add the custom option if there is an exact text match
    // with an existing option.
    return !results.some(function(o) {
        return (0, $lhbIa.default)(o, labelKey) === text;
    });
}
var $0e5e6e1e53c2c9d5$export$2e2bcd8739ae039 = $0e5e6e1e53c2c9d5$var$addCustomOption;

});
parcelRegister("lhbIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d44523b1f5063f$export$2e2bcd8739ae039);

var $aaXwj = parcelRequire("aaXwj");

var $hcUKQ = parcelRequire("hcUKQ");

var $ezOlr = parcelRequire("ezOlr");

var $jZK3h = parcelRequire("jZK3h");
/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */ function $f7d44523b1f5063f$var$getOptionLabel(option, labelKey) {
    // Handle internally created options first.
    if (!(0, $jZK3h.isString)(option) && ((0, $ezOlr.default)(option, "paginationOption") || (0, $ezOlr.default)(option, "customOption"))) return option[(0, $hcUKQ.default)(labelKey)];
    var optionLabel;
    if ((0, $jZK3h.isFunction)(labelKey)) optionLabel = labelKey(option);
    else if ((0, $jZK3h.isString)(option)) optionLabel = option;
    else // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
    !(0, $jZK3h.isString)(optionLabel) && (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(false);
    return optionLabel;
}
var $f7d44523b1f5063f$export$2e2bcd8739ae039 = $f7d44523b1f5063f$var$getOptionLabel;

});
parcelRegister("hcUKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86f94ea9632cf2e$export$2e2bcd8739ae039);

var $lYCYm = parcelRequire("lYCYm");
function $c86f94ea9632cf2e$export$2e2bcd8739ae039(labelKey) {
    return typeof labelKey === "string" ? labelKey : (0, $lYCYm.DEFAULT_LABELKEY);
}

});

parcelRegister("ezOlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9cb6302d4af6694$export$2e2bcd8739ae039);
/**
 * Check if an object has the given property in a type-safe way.
 */ function $a9cb6302d4af6694$export$2e2bcd8739ae039(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("jZK3h", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $e8e76fc5a9e377c5$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $e8e76fc5a9e377c5$export$844ec244b1367d54);
$parcel$export(module.exports, "noop", () => $e8e76fc5a9e377c5$export$8793edee2d425525);
$parcel$export(module.exports, "pick", () => $e8e76fc5a9e377c5$export$357523c63a2253b9);
$parcel$export(module.exports, "uniqueId", () => $e8e76fc5a9e377c5$export$8b15d37bc3f197d4);
var $e8e76fc5a9e377c5$var$idCounter = 0;
function $e8e76fc5a9e377c5$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $e8e76fc5a9e377c5$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $e8e76fc5a9e377c5$export$8793edee2d425525() {}
function $e8e76fc5a9e377c5$export$357523c63a2253b9(obj, keys) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    keys.forEach(function(key) {
        result[key] = obj[key];
    });
    return result;
}
function $e8e76fc5a9e377c5$export$8b15d37bc3f197d4(prefix) {
    $e8e76fc5a9e377c5$var$idCounter += 1;
    return (prefix == null ? "" : String(prefix)) + $e8e76fc5a9e377c5$var$idCounter;
}

});



parcelRegister("j8xQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee90614a07ac270$export$2e2bcd8739ae039);

var $7hFx0 = parcelRequire("7hFx0");

var $bDoz9 = parcelRequire("bDoz9");

var $jZK3h = parcelRequire("jZK3h");

var $hK1Kc = parcelRequire("hK1Kc");

var $ip893 = parcelRequire("ip893");
function $dee90614a07ac270$var$isMatch(input, string, props) {
    var searchStr = input;
    var str = string;
    if (!props.caseSensitive) {
        searchStr = searchStr.toLowerCase();
        str = str.toLowerCase();
    }
    if (props.ignoreDiacritics) {
        searchStr = (0, $hK1Kc.default)(searchStr);
        str = (0, $hK1Kc.default)(str);
    }
    return str.indexOf(searchStr) !== -1;
}
function $dee90614a07ac270$export$2e2bcd8739ae039(option, props) {
    var filterBy = props.filterBy, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    // Don't show selected options in the menu for the multi-select case.
    if (multiple && selected.some(function(o) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(o, option);
    })) return false;
    if ((0, $jZK3h.isFunction)(labelKey)) return $dee90614a07ac270$var$isMatch(text, labelKey(option), props);
    var fields = filterBy.slice();
    if ((0, $jZK3h.isString)(labelKey)) // Add the `labelKey` field to the list of fields if it isn't already there.
    {
        if (fields.indexOf(labelKey) === -1) fields.unshift(labelKey);
    }
    if ((0, $jZK3h.isString)(option)) {
        (0, $ip893.default)(fields.length <= 1, "You cannot filter by properties when `option` is a string.");
        return $dee90614a07ac270$var$isMatch(text, option, props);
    }
    return fields.some(function(field) {
        var value = (0, $bDoz9.default)(option, field);
        if (!(0, $jZK3h.isString)(value)) {
            (0, $ip893.default)(false, "Fields passed to `filterBy` should have string values. Value will be converted to a string; results may be unexpected.");
            value = String(value);
        }
        return $dee90614a07ac270$var$isMatch(text, value, props);
    });
}

});
parcelRegister("7hFx0", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("bDoz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8786647e54050303$export$2e2bcd8739ae039);

var $jZK3h = parcelRequire("jZK3h");
function $8786647e54050303$export$2e2bcd8739ae039(option, key) {
    if ((0, $jZK3h.isString)(option)) return undefined;
    return option[key];
}

});

parcelRegister("hK1Kc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea815dfe2f4fca1$export$2e2bcd8739ae039);
// prettier-ignore
var $cea815dfe2f4fca1$var$map = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xd0"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "OE",
        letters: "\x8c\u0152"
    },
    {
        base: "oe",
        letters: "\x9c\u0153"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
].reduce(function(acc, _ref) {
    var base = _ref.base, letters = _ref.letters;
    letters.split("").forEach(function(letter) {
        acc[letter] = base;
    });
    return acc;
}, {});
// Combining marks
var $cea815dfe2f4fca1$var$latin = "\u0300-\u036F";
var $cea815dfe2f4fca1$var$japanese = "\u3099\u309A";
function $cea815dfe2f4fca1$export$2e2bcd8739ae039(str) {
    return str.normalize("NFD")// Remove combining diacritics
    .replace(new RegExp("[".concat($cea815dfe2f4fca1$var$latin).concat($cea815dfe2f4fca1$var$japanese, "]"), "g"), "")/* eslint-disable-next-line no-control-regex */ .replace(/[^\u0000-\u007E]/g, function(a) {
        return $cea815dfe2f4fca1$var$map[a] || a;
    });
}

});

parcelRegister("ip893", function(module, exports) {

$parcel$export(module.exports, "default", () => $d660e13a849e7d5e$export$2e2bcd8739ae039);

var $kg9aN = parcelRequire("kg9aN");
var $d660e13a849e7d5e$var$warned = {};
function $d660e13a849e7d5e$export$2e2bcd8739ae039(falseToWarn, message) {
    // Only issue deprecation warnings once.
    if (!falseToWarn && message.indexOf("deprecated") !== -1) {
        if ($d660e13a849e7d5e$var$warned[message]) return;
        $d660e13a849e7d5e$var$warned[message] = true;
    }
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN))).apply(void 0, [
        falseToWarn,
        "[react-bootstrap-typeahead] ".concat(message)
    ].concat(args));
}
function $d660e13a849e7d5e$export$60eef1277fe463e4() {
    $d660e13a849e7d5e$var$warned = {};
}

});


parcelRegister("9qZvf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de63ff93716a94a$export$2e2bcd8739ae039);

var $19Q4n = parcelRequire("19Q4n");
function $6de63ff93716a94a$export$2e2bcd8739ae039(e, selectHint) {
    var shouldSelectHint = false;
    if (e.key === "ArrowRight") // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = (0, $19Q4n.default)(e.currentTarget) ? e.currentTarget.selectionStart === e.currentTarget.value.length : true;
    if (e.key === "Tab") {
        // Prevent input from blurring on TAB.
        e.preventDefault();
        shouldSelectHint = true;
    }
    return selectHint ? selectHint(shouldSelectHint, e) : shouldSelectHint;
}

});
parcelRegister("19Q4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7f05a08c5b7c5b$export$2e2bcd8739ae039);
/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */ function $0d7f05a08c5b7c5b$export$2e2bcd8739ae039(inputNode) {
    return inputNode.selectionStart != null;
}

});


parcelRegister("5UFLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e295e6a18dc75e$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $44e295e6a18dc75e$export$2e2bcd8739ae039(Component) {
    return Component.displayName || Component.name || "Component";
}

});

parcelRegister("dH4ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f82c6407dd8aca3$export$2e2bcd8739ae039);

var $02mwI = parcelRequire("02mwI");

var $lhbIa = parcelRequire("lhbIa");

var $ezOlr = parcelRequire("ezOlr");

var $jZK3h = parcelRequire("jZK3h");
function $9f82c6407dd8aca3$var$getHintText(_ref) {
    var activeIndex = _ref.activeIndex, initialItem = _ref.initialItem, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, labelKey = _ref.labelKey, multiple = _ref.multiple, selected = _ref.selected, text = _ref.text;
    // Don't display a hint under the following conditions:
    if (// No text entered.
    !text || // The input is not focused.
    !isFocused || // The menu is hidden.
    !isMenuShown || // No item in the menu.
    !initialItem || // The initial item is a custom option.
    !(0, $jZK3h.isString)(initialItem) && (0, $ezOlr.default)(initialItem, "customOption") || // One of the menu items is active.
    activeIndex > -1 || // There's already a selection in single-select mode.
    !!selected.length && !multiple) return "";
    var initialItemStr = (0, $lhbIa.default)(initialItem, labelKey);
    var bounds = (0, $02mwI.default)(initialItemStr.toLowerCase(), text.toLowerCase());
    if (!(bounds && bounds.start === 0)) return "";
    // Text matching is case- and accent-insensitive, so to display the hint
    // correctly, splice the input string with the hint string.
    return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}
var $9f82c6407dd8aca3$export$2e2bcd8739ae039 = $9f82c6407dd8aca3$var$getHintText;

});
parcelRegister("02mwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0071a9591d8319b3$export$2e2bcd8739ae039);

var $aaXwj = parcelRequire("aaXwj");

var $hK1Kc = parcelRequire("hK1Kc");
var $0071a9591d8319b3$var$CASE_INSENSITIVE = "i";
var $0071a9591d8319b3$var$COMBINING_MARKS = /[\u0300-\u036F]/;
function $0071a9591d8319b3$export$691f87e685a5fa78(str) {
    !(typeof str === "string") && (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(false);
    // Escape characters with special meaning either inside or outside character
    // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
    // escape when the simpler form would be disallowed by Unicode patterns’
    // stricter grammar.
    return str.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function $0071a9591d8319b3$export$2e2bcd8739ae039(subject, str) {
    var search = new RegExp($0071a9591d8319b3$export$691f87e685a5fa78((0, $hK1Kc.default)(str)), $0071a9591d8319b3$var$CASE_INSENSITIVE);
    var matches = search.exec((0, $hK1Kc.default)(subject));
    if (!matches) return null;
    var start = matches.index;
    var matchLength = matches[0].length;
    // Account for combining marks, which changes the indices.
    if ($0071a9591d8319b3$var$COMBINING_MARKS.test(subject)) {
        // Starting at the beginning of the subject string, check for the number of
        // combining marks and increment the start index whenever one is found.
        for(var ii = 0; ii <= start; ii++)if ($0071a9591d8319b3$var$COMBINING_MARKS.test(subject[ii])) start += 1;
        // Similarly, increment the length of the match string if it contains a
        // combining mark.
        for(var _ii = start; _ii <= start + matchLength; _ii++)if ($0071a9591d8319b3$var$COMBINING_MARKS.test(subject[_ii])) matchLength += 1;
    }
    return {
        end: start + matchLength,
        start: start
    };
}

});


parcelRegister("kiVBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec822b93121ee469$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $8g1PZ = parcelRequire("8g1PZ");

var $9YoBW = parcelRequire("9YoBW");

var $ezOlr = parcelRequire("ezOlr");
var $ec822b93121ee469$var$_excluded = [
    "activeIndex",
    "id",
    "isFocused",
    "isMenuShown",
    "multiple",
    "onClick",
    "onFocus",
    "placeholder"
];
function $ec822b93121ee469$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec822b93121ee469$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec822b93121ee469$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec822b93121ee469$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec822b93121ee469$var$getInputProps = function getInputProps(_ref) {
    var activeIndex = _ref.activeIndex, id = _ref.id, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, multiple = _ref.multiple, onClick = _ref.onClick, onFocus = _ref.onFocus, placeholder = _ref.placeholder, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $ec822b93121ee469$var$_excluded);
    return function() {
        var _cx;
        var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var className = (0, $ezOlr.default)(inputProps, "className") ? String(inputProps.className) : undefined;
        return $ec822b93121ee469$var$_objectSpread($ec822b93121ee469$var$_objectSpread($ec822b93121ee469$var$_objectSpread($ec822b93121ee469$var$_objectSpread({
            // These props can be overridden by values in `inputProps`.
            autoComplete: "off",
            placeholder: placeholder,
            type: "text"
        }, inputProps), props), {}, {
            "aria-activedescendant": activeIndex >= 0 ? (0, $9YoBW.default)(id, activeIndex) : undefined,
            "aria-autocomplete": "both",
            "aria-expanded": isMenuShown,
            "aria-haspopup": "listbox",
            "aria-multiselectable": multiple || undefined,
            "aria-owns": isMenuShown ? id : undefined,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((_cx = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_cx, className || "", !multiple), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_cx, "focus", isFocused), _cx))
        }, multiple && {
            inputClassName: className
        }), {}, {
            onClick: onClick,
            onFocus: onFocus,
            role: "combobox"
        });
    };
};
var $ec822b93121ee469$export$2e2bcd8739ae039 = $ec822b93121ee469$var$getInputProps;

});
parcelRegister("9YoBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $742ccee11c86615f$export$2e2bcd8739ae039);
function $742ccee11c86615f$export$2e2bcd8739ae039() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var position = arguments.length > 1 ? arguments[1] : undefined;
    return "".concat(id, "-item-").concat(position);
}

});


parcelRegister("lWS4N", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa8f631b19d476d$export$2e2bcd8739ae039);

var $lhbIa = parcelRequire("lhbIa");
function $ffa8f631b19d476d$var$getInputText(props) {
    var activeItem = props.activeItem, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    if (activeItem) // Display the input value if the pagination item is active.
    return (0, $lhbIa.default)(activeItem, labelKey);
    if (!multiple && selected.length && selected[0]) return (0, $lhbIa.default)(selected[0], labelKey);
    return text;
}
var $ffa8f631b19d476d$export$2e2bcd8739ae039 = $ffa8f631b19d476d$var$getInputText;

});

parcelRegister("gVTaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c53cc392fe8225f7$export$2e2bcd8739ae039);

var $bDoz9 = parcelRequire("bDoz9");
function $c53cc392fe8225f7$var$getIsOnlyResult(props) {
    var allowNew = props.allowNew, highlightOnlyResult = props.highlightOnlyResult, results = props.results;
    if (!highlightOnlyResult || allowNew) return false;
    return results.length === 1 && !(0, $bDoz9.default)(results[0], "disabled");
}
var $c53cc392fe8225f7$export$2e2bcd8739ae039 = $c53cc392fe8225f7$var$getIsOnlyResult;

});

parcelRegister("hV9FL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bf435149142ff2$export$2e2bcd8739ae039);
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */ function $d0bf435149142ff2$var$getTruncatedOptions(options, maxResults) {
    if (!maxResults || maxResults >= options.length) return options;
    return options.slice(0, maxResults);
}
var $d0bf435149142ff2$export$2e2bcd8739ae039 = $d0bf435149142ff2$var$getTruncatedOptions;

});

parcelRegister("kwCOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14e6a8fec3ca6a$export$2e2bcd8739ae039);

var $bDoz9 = parcelRequire("bDoz9");
function $ef14e6a8fec3ca6a$export$30acd1b3e7561a3(index, items) {
    var option = items[index];
    return !!option && !!(0, $bDoz9.default)(option, "disabled");
}
function $ef14e6a8fec3ca6a$export$3b2e82793fda938f(currentIndex, key, items) {
    var newIndex = currentIndex;
    while($ef14e6a8fec3ca6a$export$30acd1b3e7561a3(newIndex, items))newIndex += key === "ArrowUp" ? -1 : 1;
    return newIndex;
}
function $ef14e6a8fec3ca6a$export$2e2bcd8739ae039(currentIndex, key, items) {
    var newIndex = currentIndex;
    // Increment or decrement index based on user keystroke.
    newIndex += key === "ArrowUp" ? -1 : 1;
    // Skip over any disabled options.
    newIndex = $ef14e6a8fec3ca6a$export$3b2e82793fda938f(newIndex, key, items);
    // If we've reached the end, go back to the beginning or vice-versa.
    if (newIndex === items.length) newIndex = -1;
    else if (newIndex === -2) {
        newIndex = items.length - 1;
        // Skip over any disabled options.
        newIndex = $ef14e6a8fec3ca6a$export$3b2e82793fda938f(newIndex, key, items);
    }
    return newIndex;
}

});

parcelRegister("7jwFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5533a59415930d66$export$2e2bcd8739ae039);
function $5533a59415930d66$export$2e2bcd8739ae039(_ref) {
    var open = _ref.open, minLength = _ref.minLength, showMenu = _ref.showMenu, text = _ref.text;
    // If menu visibility is controlled via props, that value takes precedence.
    if (open || open === false) return open;
    if (text.length < minLength) return false;
    return showMenu;
}

});

parcelRegister("8ojTx", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bfff4b979dc2a5$export$2e2bcd8739ae039);
/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */ function $61bfff4b979dc2a5$export$2e2bcd8739ae039(e) {
    e.preventDefault();
}

});

parcelRegister("kKg6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a49919ba84dac0$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $8g1PZ = parcelRequire("8g1PZ");

var $lnugP = parcelRequire("lnugP");
var $f1a49919ba84dac0$var$_excluded = [
    "className",
    "isInvalid",
    "isValid",
    "size"
];
function $f1a49919ba84dac0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1a49919ba84dac0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1a49919ba84dac0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1a49919ba84dac0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f1a49919ba84dac0$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, isInvalid = _ref.isInvalid, isValid = _ref.isValid, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $f1a49919ba84dac0$var$_excluded);
    return $f1a49919ba84dac0$var$_objectSpread($f1a49919ba84dac0$var$_objectSpread({}, props), {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("form-control", "rbt-input", {
            "form-control-lg": (0, $lnugP.isSizeLarge)(size),
            "form-control-sm": (0, $lnugP.isSizeSmall)(size),
            "is-invalid": isInvalid,
            "is-valid": isValid
        }, className)
    });
}

});
parcelRegister("lnugP", function(module, exports) {

$parcel$export(module.exports, "isSizeLarge", () => $f9033a0419b7d22b$export$650961c52e438122);
$parcel$export(module.exports, "isSizeSmall", () => $f9033a0419b7d22b$export$93100e6f8d8c0365);
function $f9033a0419b7d22b$export$650961c52e438122(size) {
    return size === "lg";
}
function $f9033a0419b7d22b$export$93100e6f8d8c0365(size) {
    return size === "sm";
}

});


parcelRegister("96Bz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a11d03b68623984$export$2e2bcd8739ae039);

var $ip893 = parcelRequire("ip893");
function $6a11d03b68623984$export$2e2bcd8739ae039(prevSelected, selected) {
    var uncontrolledToControlled = !prevSelected && selected;
    var controlledToUncontrolled = prevSelected && !selected;
    var from, to, precedent;
    if (uncontrolledToControlled) {
        from = "uncontrolled";
        to = "controlled";
        precedent = "an";
    } else {
        from = "controlled";
        to = "uncontrolled";
        precedent = "a";
    }
    var message = "You are changing ".concat(precedent, " ").concat(from, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from, " to ").concat(to, " (or vice versa). ") + "Decide between using a controlled or uncontrolled element for the " + "lifetime of the component.";
    (0, $ip893.default)(!(uncontrolledToControlled || controlledToUncontrolled), message);
}

});




parcelRegister("gbk80", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("fK6wT")).default);

var $fK6wT = parcelRequire("fK6wT");

});
parcelRegister("fK6wT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7603787113cb553$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $8g1PZ = parcelRequire("8g1PZ");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $bv1Tx = parcelRequire("bv1Tx");
parcelRequire("9rTkk");
var $gTYbN = parcelRequire("gTYbN");
parcelRequire("bOhDN");
var $aVH5j = parcelRequire("aVH5j");
parcelRequire("lv1yE");
var $3cYPq = parcelRequire("3cYPq");
parcelRequire("2Wbd3");
var $ibShZ = parcelRequire("ibShZ");

var $2rWeT = parcelRequire("2rWeT");
parcelRequire("l4Uyk");
var $7crIX = parcelRequire("7crIX");
parcelRequire("f6F5t");
var $4VvGI = parcelRequire("4VvGI");
parcelRequire("7H5QO");
var $cAEjP = parcelRequire("cAEjP");
parcelRequire("5cWuV");
var $lhbIa = parcelRequire("lhbIa");
var $jZK3h = parcelRequire("jZK3h");
var $lnugP = parcelRequire("lnugP");
var $8ojTx = parcelRequire("8ojTx");

var $1pmaC = parcelRequire("1pmaC");
function $b7603787113cb553$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7603787113cb553$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7603787113cb553$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7603787113cb553$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b7603787113cb553$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b7603787113cb553$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $b7603787113cb553$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $b7603787113cb553$var$propTypes = {
    /**
   * Displays a button to clear the input when there are selections.
   */ clearButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */ inputProps: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, (0, $1pmaC.inputPropsType)),
    /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */ isInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Indicate whether an asynchronous data fetch is happening.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */ isValid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Callback for custom input rendering.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback for custom menu rendering.
   */ renderMenu: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback for custom menu rendering.
   */ renderToken: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Specifies the size of the input.
   */ size: (0, $1pmaC.sizeType)
};
var $b7603787113cb553$var$defaultProps = {
    isLoading: false
};
var $b7603787113cb553$var$defaultRenderMenu = function defaultRenderMenu(results, menuProps, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cAEjP.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, menuProps, {
        labelKey: props.labelKey,
        options: results,
        text: props.text
    }));
};
var $b7603787113cb553$var$defaultRenderToken = function defaultRenderToken(option, props, idx) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2rWeT.default), {
        disabled: props.disabled,
        key: idx,
        onRemove: props.onRemove,
        option: option,
        tabIndex: props.tabIndex
    }, (0, $lhbIa.default)(option, props.labelKey));
};
var $b7603787113cb553$var$overlayPropKeys = [
    "align",
    "dropup",
    "flip",
    "positionFixed"
];
function $b7603787113cb553$var$getOverlayProps(props) {
    return (0, $jZK3h.pick)(props, $b7603787113cb553$var$overlayPropKeys);
}
var $b7603787113cb553$var$TypeaheadComponent = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(TypeaheadComponent, _React$Component);
    var _super = $b7603787113cb553$var$_createSuper(TypeaheadComponent);
    function TypeaheadComponent() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, TypeaheadComponent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_referenceElement", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "referenceElementRef", function(referenceElement) {
            _this._referenceElement = referenceElement;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_renderInput", function(inputProps, props) {
            var _this$props = _this.props, isInvalid = _this$props.isInvalid, isValid = _this$props.isValid, multiple = _this$props.multiple, renderInput = _this$props.renderInput, renderToken = _this$props.renderToken, size = _this$props.size;
            if ((0, $jZK3h.isFunction)(renderInput)) return renderInput(inputProps, props);
            var commonProps = $b7603787113cb553$var$_objectSpread($b7603787113cb553$var$_objectSpread({}, inputProps), {}, {
                isInvalid: isInvalid,
                isValid: isValid,
                size: size
            });
            if (!multiple) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4VvGI.default), commonProps);
            var labelKey = props.labelKey, onRemove = props.onRemove, selected = props.selected;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7crIX.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, commonProps, {
                placeholder: selected.length ? "" : inputProps.placeholder,
                selected: selected
            }), selected.map(function(option, idx) {
                return (renderToken || $b7603787113cb553$var$defaultRenderToken)(option, $b7603787113cb553$var$_objectSpread($b7603787113cb553$var$_objectSpread({}, commonProps), {}, {
                    labelKey: labelKey,
                    onRemove: onRemove
                }), idx);
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_renderMenu", function(results, menuProps, props) {
            var _this$props2 = _this.props, emptyLabel = _this$props2.emptyLabel, id = _this$props2.id, maxHeight = _this$props2.maxHeight, newSelectionPrefix = _this$props2.newSelectionPrefix, paginationText = _this$props2.paginationText, renderMenu = _this$props2.renderMenu, renderMenuItemChildren = _this$props2.renderMenuItemChildren;
            return (renderMenu || $b7603787113cb553$var$defaultRenderMenu)(results, $b7603787113cb553$var$_objectSpread($b7603787113cb553$var$_objectSpread({}, menuProps), {}, {
                emptyLabel: emptyLabel,
                id: id,
                maxHeight: maxHeight,
                newSelectionPrefix: newSelectionPrefix,
                paginationText: paginationText,
                renderMenuItemChildren: renderMenuItemChildren
            }), props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_renderAux", function(_ref) {
            var onClear = _ref.onClear, selected = _ref.selected;
            var _this$props3 = _this.props, clearButton = _this$props3.clearButton, disabled = _this$props3.disabled, isLoading = _this$props3.isLoading, size = _this$props3.size;
            var content;
            if (isLoading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVH5j.default), null);
            else if (clearButton && !disabled && selected.length) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gTYbN.default), {
                onClick: onClear,
                onMouseDown: (0, $8ojTx.default),
                size: size
            });
            return content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("rbt-aux", {
                    "rbt-aux-lg": (0, $lnugP.isSizeLarge)(size)
                })
            }, content) : null;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(TypeaheadComponent, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, instanceRef = _this$props4.instanceRef, open = _this$props4.open, options = _this$props4.options, style = _this$props4.style;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bv1Tx.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, this.props, {
                    options: options,
                    ref: instanceRef
                }), function(props) {
                    var hideMenu = props.hideMenu, isMenuShown = props.isMenuShown, results = props.results;
                    var auxContent = _this2._renderAux(props);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ibShZ.default), {
                        disabled: open || !isMenuShown,
                        onRootClose: hideMenu
                    }, function(ref) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("rbt", {
                                "has-aux": !!auxContent,
                                "is-invalid": _this2.props.isInvalid,
                                "is-valid": _this2.props.isValid
                            }, className),
                            ref: ref,
                            style: $b7603787113cb553$var$_objectSpread($b7603787113cb553$var$_objectSpread({}, style), {}, {
                                outline: "none",
                                position: "relative"
                            }),
                            tabIndex: -1
                        }, _this2._renderInput($b7603787113cb553$var$_objectSpread($b7603787113cb553$var$_objectSpread({}, props.getInputProps(_this2.props.inputProps)), {}, {
                            referenceElementRef: _this2.referenceElementRef
                        }), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cYPq.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, $b7603787113cb553$var$getOverlayProps(_this2.props), {
                            isMenuShown: isMenuShown,
                            referenceElement: _this2._referenceElement
                        }), function(menuProps) {
                            return _this2._renderMenu(results, menuProps, props);
                        }), auxContent, (0, $jZK3h.isFunction)(children) ? children(props) : children);
                    });
                });
            }
        }
    ]);
    return TypeaheadComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($b7603787113cb553$var$TypeaheadComponent, "propTypes", $b7603787113cb553$var$propTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($b7603787113cb553$var$TypeaheadComponent, "defaultProps", $b7603787113cb553$var$defaultProps);
var $b7603787113cb553$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b7603787113cb553$var$TypeaheadComponent, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        instanceRef: ref
    }));
});

});
parcelRegister("bv1Tx", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f40f3467ab6c7a$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $7hFx0 = parcelRequire("7hFx0");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $4iY5n = parcelRequire("4iY5n");

var $519UU = parcelRequire("519UU");

var $1pmaC = parcelRequire("1pmaC");
parcelRequire("5cWuV");
var $1eu4T = parcelRequire("1eu4T");
var $j8xQV = parcelRequire("j8xQV");
var $lhbIa = parcelRequire("lhbIa");
var $bDoz9 = parcelRequire("bDoz9");
var $hcUKQ = parcelRequire("hcUKQ");
var $hV9FL = parcelRequire("hV9FL");
var $kwCOh = parcelRequire("kwCOh");
var $jZK3h = parcelRequire("jZK3h");
var $7jwFm = parcelRequire("7jwFm");
var $96Bz6 = parcelRequire("96Bz6");

var $lYCYm = parcelRequire("lYCYm");
var $85f40f3467ab6c7a$var$_excluded = [
    "onChange"
];
function $85f40f3467ab6c7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $85f40f3467ab6c7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $85f40f3467ab6c7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $85f40f3467ab6c7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $85f40f3467ab6c7a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $85f40f3467ab6c7a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $85f40f3467ab6c7a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $85f40f3467ab6c7a$var$propTypes = {
    /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */ allowNew: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * Autofocus the input when the component initially mounts.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Whether or not filtering should be case-sensitive.
   */ caseSensitive: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool, (0, $1pmaC.caseSensitiveType)),
    /**
   * The initial value displayed in the text input.
   */ defaultInputValue: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string, (0, $1pmaC.defaultInputValueType)),
    /**
   * Whether or not the menu is displayed upon initial render.
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */ defaultSelected: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, $1pmaC.optionType)), (0, $1pmaC.defaultSelectedType)),
    /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */ filterBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */ highlightOnlyResult: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool, (0, $1pmaC.highlightOnlyResultType)),
    /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */ id: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]), (0, $1pmaC.isRequiredForA11y)),
    /**
   * Whether the filter should ignore accents and other diacritical marks.
   */ ignoreDiacritics: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool, (0, $1pmaC.ignoreDiacriticsType)),
    /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */ labelKey: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]), (0, $1pmaC.labelKeyType)),
    /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */ maxResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Whether or not multiple selections are allowed.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Invoked when the input is blurred. Receives an event.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Invoked when the input is focused. Receives an event.
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */ onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Invoked when a key is pressed. Receives an event.
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Invoked when menu visibility changes.
   */ onMenuToggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */ onPaginate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, $1pmaC.optionType)).isRequired,
    /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */ paginate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */ selected: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, $1pmaC.optionType)), (0, $1pmaC.selectedType))
};
var $85f40f3467ab6c7a$var$defaultProps = {
    allowNew: false,
    autoFocus: false,
    caseSensitive: false,
    defaultInputValue: "",
    defaultOpen: false,
    defaultSelected: [],
    filterBy: [],
    highlightOnlyResult: false,
    ignoreDiacritics: true,
    labelKey: (0, $lYCYm.DEFAULT_LABELKEY),
    maxResults: 100,
    minLength: 0,
    multiple: false,
    onBlur: (0, $jZK3h.noop),
    onFocus: (0, $jZK3h.noop),
    onInputChange: (0, $jZK3h.noop),
    onKeyDown: (0, $jZK3h.noop),
    onMenuToggle: (0, $jZK3h.noop),
    onPaginate: (0, $jZK3h.noop),
    paginate: true
};
/**
 * Manually trigger the input's change event.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js/46012210#46012210
 */ function $85f40f3467ab6c7a$var$triggerInputChange(input, value) {
    var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value");
    inputValue && inputValue.set && inputValue.set.call(input, value);
    var e = new Event("input", {
        bubbles: true
    });
    input.dispatchEvent(e);
}
var $85f40f3467ab6c7a$var$Typeahead = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Typeahead, _React$Component);
    var _super = $85f40f3467ab6c7a$var$_createSuper(Typeahead);
    function Typeahead() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Typeahead);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "state", (0, $519UU.getInitialState)(_this.props));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "inputNode", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isMenuShown", false);
        // Keeps track of actual items displayed in the menu, after sorting,
        // truncating, grouping, etc.
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "items", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "blur", function() {
            _this.inputNode && _this.inputNode.blur();
            _this.hideMenu();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "clear", function() {
            _this.setState((0, $519UU.clearTypeahead));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "focus", function() {
            _this.inputNode && _this.inputNode.focus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "getInput", function() {
            return _this.inputNode;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "inputRef", function(inputNode) {
            _this.inputNode = inputNode;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "setItem", function(item, position) {
            _this.items[position] = item;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "hideMenu", function() {
            _this.setState((0, $519UU.hideMenu));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "toggleMenu", function() {
            _this.setState((0, $519UU.toggleMenu));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleActiveIndexChange", function(activeIndex) {
            _this.setState(function(state) {
                return {
                    activeIndex: activeIndex,
                    activeItem: activeIndex >= 0 ? state.activeItem : undefined
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleActiveItemChange", function(activeItem) {
            // Don't update the active item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(activeItem, _this.state.activeItem)) _this.setState({
                activeItem: activeItem
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleBlur", function(e) {
            e.persist();
            _this.setState({
                isFocused: false
            }, function() {
                return _this.props.onBlur(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleChange", function(selected) {
            _this.props.onChange && _this.props.onChange(selected);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleClear", function() {
            _this.inputNode && $85f40f3467ab6c7a$var$triggerInputChange(_this.inputNode, "");
            _this.setState((0, $519UU.clearTypeahead), function() {
                // Change handler is automatically triggered for single selections but
                // not multi-selections.
                if (_this.props.multiple) _this._handleChange([]);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleClick", function(e) {
            var _this$props$inputProp;
            e.persist();
            var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;
            _this.setState((0, $519UU.clickOrFocusInput), function() {
                return (0, $jZK3h.isFunction)(onClick) && onClick(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleFocus", function(e) {
            e.persist();
            _this.setState((0, $519UU.clickOrFocusInput), function() {
                return _this.props.onFocus(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleInitialItemChange", function(initialItem) {
            // Don't update the initial item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(initialItem, _this.state.initialItem)) _this.setState({
                initialItem: initialItem
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleInputChange", function(e) {
            e.persist();
            var text = e.currentTarget.value;
            var _this$props = _this.props, multiple = _this$props.multiple, onInputChange = _this$props.onInputChange;
            // Clear selections when the input value changes in single-select mode.
            var shouldClearSelections = _this.state.selected.length && !multiple;
            _this.setState(function(state, props) {
                var _getInitialState = (0, $519UU.getInitialState)(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, shownResults = _getInitialState.shownResults;
                return {
                    activeIndex: activeIndex,
                    activeItem: activeItem,
                    selected: shouldClearSelections ? [] : state.selected,
                    showMenu: true,
                    shownResults: shownResults,
                    text: text
                };
            }, function() {
                onInputChange(text, e);
                shouldClearSelections && _this._handleChange([]);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleKeyDown", function(e) {
            var activeItem = _this.state.activeItem;
            // Skip most actions when the menu is hidden.
            if (!_this.isMenuShown) {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") _this.setState({
                    showMenu: true
                });
                _this.props.onKeyDown(e);
                return;
            }
            switch(e.key){
                case "ArrowUp":
                case "ArrowDown":
                    // Prevent input cursor from going to the beginning when pressing up.
                    e.preventDefault();
                    _this._handleActiveIndexChange((0, $kwCOh.default)(_this.state.activeIndex, e.key, _this.items));
                    break;
                case "Enter":
                    // Prevent form submission while menu is open.
                    e.preventDefault();
                    activeItem && _this._handleMenuItemSelect(activeItem, e);
                    break;
                case "Escape":
                case "Tab":
                    // ESC simply hides the menu. TAB will blur the input and move focus to
                    // the next item; hide the menu so it doesn't gain focus.
                    _this.hideMenu();
                    break;
                default:
                    break;
            }
            _this.props.onKeyDown(e);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleMenuItemSelect", function(option, e) {
            if ((0, $bDoz9.default)(option, "paginationOption")) _this._handlePaginate(e);
            else _this._handleSelectionAdd(option);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handlePaginate", function(e) {
            e.persist();
            _this.setState(function(state, props) {
                return {
                    shownResults: state.shownResults + props.maxResults
                };
            }, function() {
                return _this.props.onPaginate(e, _this.state.shownResults);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleSelectionAdd", function(option) {
            var _this$props2 = _this.props, multiple = _this$props2.multiple, labelKey = _this$props2.labelKey;
            var selected;
            var selection = option;
            var text;
            // Add a unique id to the custom selection. Avoid doing this in `render` so
            // the id doesn't increment every time.
            if (!(0, $jZK3h.isString)(selection) && selection.customOption) selection = $85f40f3467ab6c7a$var$_objectSpread($85f40f3467ab6c7a$var$_objectSpread({}, selection), {}, {
                id: (0, $jZK3h.uniqueId)("new-id-")
            });
            if (multiple) {
                // If multiple selections are allowed, add the new selection to the
                // existing selections.
                selected = _this.state.selected.concat(selection);
                text = "";
            } else {
                // If only a single selection is allowed, replace the existing selection
                // with the new one.
                selected = [
                    selection
                ];
                text = (0, $lhbIa.default)(selection, labelKey);
            }
            _this.setState(function(state, props) {
                return $85f40f3467ab6c7a$var$_objectSpread($85f40f3467ab6c7a$var$_objectSpread({}, (0, $519UU.hideMenu)(state, props)), {}, {
                    initialItem: selection,
                    selected: selected,
                    text: text
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_handleSelectionRemove", function(selection) {
            var selected = _this.state.selected.filter(function(option) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(option, selection);
            });
            // Make sure the input stays focused after the item is removed.
            _this.focus();
            _this.setState(function(state, props) {
                return $85f40f3467ab6c7a$var$_objectSpread($85f40f3467ab6c7a$var$_objectSpread({}, (0, $519UU.hideMenu)(state, props)), {}, {
                    selected: selected
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Typeahead, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.autoFocus && this.focus();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props3 = this.props, labelKey = _this$props3.labelKey, multiple = _this$props3.multiple, selected = _this$props3.selected;
                (0, $96Bz6.default)(selected, prevProps.selected);
                // Sync selections in state with those in props.
                if (selected && !(0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(selected, prevState.selected)) {
                    this.setState({
                        selected: selected
                    });
                    if (!multiple) this.setState({
                        text: selected.length ? (0, $lhbIa.default)(selected[0], labelKey) : ""
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, onChange = _this$props4.onChange, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$props4, $85f40f3467ab6c7a$var$_excluded);
                var mergedPropsAndState = $85f40f3467ab6c7a$var$_objectSpread($85f40f3467ab6c7a$var$_objectSpread({}, props), this.state);
                var filterBy = mergedPropsAndState.filterBy, labelKey = mergedPropsAndState.labelKey, options = mergedPropsAndState.options, paginate = mergedPropsAndState.paginate, shownResults = mergedPropsAndState.shownResults, text = mergedPropsAndState.text;
                this.isMenuShown = (0, $7jwFm.default)(mergedPropsAndState);
                this.items = []; // Reset items on re-render.
                var results = [];
                if (this.isMenuShown) {
                    var cb = (0, $jZK3h.isFunction)(filterBy) ? filterBy : (0, $j8xQV.default);
                    results = options.filter(function(option) {
                        return cb(option, mergedPropsAndState);
                    });
                    // This must come before results are truncated.
                    var shouldPaginate = paginate && results.length > shownResults;
                    // Truncate results if necessary.
                    results = (0, $hV9FL.default)(results, shownResults);
                    // Add the custom option if necessary.
                    if ((0, $1eu4T.default)(results, mergedPropsAndState)) results.push((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({
                        customOption: true
                    }, (0, $hcUKQ.default)(labelKey), text));
                    // Add the pagination item if necessary.
                    if (shouldPaginate) {
                        var _results$push2;
                        results.push((_results$push2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_results$push2, (0, $hcUKQ.default)(labelKey), ""), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_results$push2, "paginationOption", true), _results$push2));
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4iY5n.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, mergedPropsAndState, {
                    hideMenu: this.hideMenu,
                    inputNode: this.inputNode,
                    inputRef: this.inputRef,
                    isMenuShown: this.isMenuShown,
                    onActiveItemChange: this._handleActiveItemChange,
                    onAdd: this._handleSelectionAdd,
                    onBlur: this._handleBlur,
                    onChange: this._handleInputChange,
                    onClear: this._handleClear,
                    onClick: this._handleClick,
                    onFocus: this._handleFocus,
                    onHide: this.hideMenu,
                    onInitialItemChange: this._handleInitialItemChange,
                    onKeyDown: this._handleKeyDown,
                    onMenuItemClick: this._handleMenuItemSelect,
                    onRemove: this._handleSelectionRemove,
                    results: results,
                    setItem: this.setItem,
                    toggleMenu: this.toggleMenu
                }));
            }
        }
    ]);
    return Typeahead;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($85f40f3467ab6c7a$var$Typeahead, "propTypes", $85f40f3467ab6c7a$var$propTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($85f40f3467ab6c7a$var$Typeahead, "defaultProps", $85f40f3467ab6c7a$var$defaultProps);
var $85f40f3467ab6c7a$export$2e2bcd8739ae039 = $85f40f3467ab6c7a$var$Typeahead;

});
parcelRegister("4iY5n", function(module, exports) {

$parcel$export(module.exports, "default", () => $322773a3d77f7b92$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $1Bizh = parcelRequire("1Bizh");
parcelRequire("5cWuV");
var $9qZvf = parcelRequire("9qZvf");
var $dH4ut = parcelRequire("dH4ut");
var $kiVBm = parcelRequire("kiVBm");
var $lWS4N = parcelRequire("lWS4N");
var $gVTaw = parcelRequire("gVTaw");
var $jZK3h = parcelRequire("jZK3h");
function $322773a3d77f7b92$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $322773a3d77f7b92$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $322773a3d77f7b92$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $322773a3d77f7b92$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $322773a3d77f7b92$var$inputPropKeys = [
    "activeIndex",
    "disabled",
    "id",
    "inputRef",
    "isFocused",
    "isMenuShown",
    "multiple",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "placeholder"
];
var $322773a3d77f7b92$var$propKeys = [
    "activeIndex",
    "hideMenu",
    "isMenuShown",
    "labelKey",
    "onClear",
    "onHide",
    "onRemove",
    "results",
    "selected",
    "text",
    "toggleMenu"
];
var $322773a3d77f7b92$var$contextKeys = [
    "activeIndex",
    "id",
    "initialItem",
    "inputNode",
    "onActiveItemChange",
    "onAdd",
    "onInitialItemChange",
    "onMenuItemClick",
    "setItem"
];
var $322773a3d77f7b92$var$TypeaheadManager = function TypeaheadManager(props) {
    var allowNew = props.allowNew, children = props.children, initialItem = props.initialItem, isMenuShown = props.isMenuShown, onAdd = props.onAdd, onInitialItemChange = props.onInitialItemChange, onKeyDown = props.onKeyDown, onMenuToggle = props.onMenuToggle, results = props.results, selectHint = props.selectHint;
    var hintText = (0, $dH4ut.default)(props);
    (0, $acw62.useEffect)(function() {
        // Clear the initial item when there are no results.
        if (!(allowNew || results.length)) onInitialItemChange();
    });
    var isInitialRender = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        onMenuToggle(isMenuShown);
    }, [
        isMenuShown,
        onMenuToggle
    ]);
    var handleKeyDown = function handleKeyDown(e) {
        onKeyDown(e);
        if (!initialItem) return;
        var addOnlyResult = e.key === "Enter" && (0, $gVTaw.default)(props);
        var shouldSelectHint = hintText && (0, $9qZvf.default)(e, selectHint);
        if (addOnlyResult || shouldSelectHint) onAdd(initialItem);
    };
    var childProps = $322773a3d77f7b92$var$_objectSpread($322773a3d77f7b92$var$_objectSpread({}, (0, $jZK3h.pick)(props, $322773a3d77f7b92$var$propKeys)), {}, {
        getInputProps: (0, $kiVBm.default)($322773a3d77f7b92$var$_objectSpread($322773a3d77f7b92$var$_objectSpread({}, (0, $jZK3h.pick)(props, $322773a3d77f7b92$var$inputPropKeys)), {}, {
            onKeyDown: handleKeyDown,
            value: (0, $lWS4N.default)(props)
        }))
    });
    var contextValue = $322773a3d77f7b92$var$_objectSpread($322773a3d77f7b92$var$_objectSpread({}, (0, $jZK3h.pick)(props, $322773a3d77f7b92$var$contextKeys)), {}, {
        hintText: hintText,
        isOnlyResult: (0, $gVTaw.default)(props)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1Bizh.TypeaheadContext).Provider, {
        value: contextValue
    }, (0, $jZK3h.isFunction)(children) ? children(childProps) : children);
};
var $322773a3d77f7b92$export$2e2bcd8739ae039 = $322773a3d77f7b92$var$TypeaheadManager;

});
parcelRegister("1Bizh", function(module, exports) {

$parcel$export(module.exports, "TypeaheadContext", () => $12a7a65c2f2ba424$export$b86a312c9066f850);
$parcel$export(module.exports, "useTypeaheadContext", () => $12a7a65c2f2ba424$export$20418b9b18662c6c);

var $acw62 = parcelRequire("acw62");
parcelRequire("5cWuV");
var $jZK3h = parcelRequire("jZK3h");
var $12a7a65c2f2ba424$export$2fba198b5b2e37fa = {
    activeIndex: -1,
    hintText: "",
    id: "",
    initialItem: null,
    inputNode: null,
    isOnlyResult: false,
    onActiveItemChange: (0, $jZK3h.noop),
    onAdd: (0, $jZK3h.noop),
    onInitialItemChange: (0, $jZK3h.noop),
    onMenuItemClick: (0, $jZK3h.noop),
    setItem: (0, $jZK3h.noop)
};
var $12a7a65c2f2ba424$export$b86a312c9066f850 = /*#__PURE__*/ (0, $acw62.createContext)($12a7a65c2f2ba424$export$2fba198b5b2e37fa);
var $12a7a65c2f2ba424$export$20418b9b18662c6c = function useTypeaheadContext() {
    return (0, $acw62.useContext)($12a7a65c2f2ba424$export$b86a312c9066f850);
};

});


parcelRegister("519UU", function(module, exports) {

$parcel$export(module.exports, "getInitialState", () => $3a74bd0706d2b729$export$53ac33307b5acee9);
$parcel$export(module.exports, "clearTypeahead", () => $3a74bd0706d2b729$export$df98f41f85652e52);
$parcel$export(module.exports, "clickOrFocusInput", () => $3a74bd0706d2b729$export$81b416d1310f34c8);
$parcel$export(module.exports, "hideMenu", () => $3a74bd0706d2b729$export$cdf0b0ed532145ff);
$parcel$export(module.exports, "toggleMenu", () => $3a74bd0706d2b729$export$ac262bcf0e49db26);

var $g5Zhu = parcelRequire("g5Zhu");
parcelRequire("5cWuV");
var $lhbIa = parcelRequire("lhbIa");
function $3a74bd0706d2b729$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a74bd0706d2b729$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a74bd0706d2b729$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a74bd0706d2b729$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a74bd0706d2b729$export$53ac33307b5acee9(props) {
    var defaultInputValue = props.defaultInputValue, defaultOpen = props.defaultOpen, defaultSelected = props.defaultSelected, maxResults = props.maxResults, multiple = props.multiple;
    var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
    var text = defaultInputValue;
    if (!multiple && selected.length) {
        // Set the text if an initial selection is passed in.
        text = (0, $lhbIa.default)(selected[0], props.labelKey);
        if (selected.length > 1) // Limit to 1 selection in single-select mode.
        selected = selected.slice(0, 1);
    }
    return {
        activeIndex: -1,
        activeItem: undefined,
        initialItem: undefined,
        isFocused: false,
        selected: selected,
        showMenu: defaultOpen,
        shownResults: maxResults,
        text: text
    };
}
function $3a74bd0706d2b729$export$df98f41f85652e52(state, props) {
    return $3a74bd0706d2b729$var$_objectSpread($3a74bd0706d2b729$var$_objectSpread({}, $3a74bd0706d2b729$export$53ac33307b5acee9(props)), {}, {
        isFocused: state.isFocused,
        selected: [],
        text: ""
    });
}
function $3a74bd0706d2b729$export$81b416d1310f34c8(state) {
    return $3a74bd0706d2b729$var$_objectSpread($3a74bd0706d2b729$var$_objectSpread({}, state), {}, {
        isFocused: true,
        showMenu: true
    });
}
function $3a74bd0706d2b729$export$cdf0b0ed532145ff(state, props) {
    var _getInitialState = $3a74bd0706d2b729$export$53ac33307b5acee9(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, initialItem = _getInitialState.initialItem, shownResults = _getInitialState.shownResults;
    return $3a74bd0706d2b729$var$_objectSpread($3a74bd0706d2b729$var$_objectSpread({}, state), {}, {
        activeIndex: activeIndex,
        activeItem: activeItem,
        initialItem: initialItem,
        showMenu: false,
        shownResults: shownResults
    });
}
function $3a74bd0706d2b729$export$ac262bcf0e49db26(state, props) {
    return state.showMenu ? $3a74bd0706d2b729$export$cdf0b0ed532145ff(state, props) : $3a74bd0706d2b729$var$_objectSpread($3a74bd0706d2b729$var$_objectSpread({}, state), {}, {
        showMenu: true
    });
}

});


parcelRegister("9rTkk", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("gTYbN")).default);

var $gTYbN = parcelRequire("gTYbN");

});
parcelRegister("gTYbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e078b9a88a5454$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $8g1PZ = parcelRequire("8g1PZ");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
parcelRequire("5cWuV");
var $lnugP = parcelRequire("lnugP");

var $1pmaC = parcelRequire("1pmaC");
var $c4e078b9a88a5454$var$_excluded = [
    "className",
    "label",
    "onClick",
    "onKeyDown",
    "size"
];
var $c4e078b9a88a5454$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    size: (0, $1pmaC.sizeType)
};
/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */ var $c4e078b9a88a5454$var$ClearButton = function ClearButton(_ref) {
    var className = _ref.className, _ref$label = _ref.label, label = _ref$label === void 0 ? "Clear" : _ref$label, _onClick = _ref.onClick, _onKeyDown = _ref.onKeyDown, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $c4e078b9a88a5454$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("close", "btn-close", "rbt-close", {
            "rbt-close-lg": (0, $lnugP.isSizeLarge)(size),
            "rbt-close-sm": (0, $lnugP.isSizeSmall)(size)
        }, className),
        onClick: function onClick(e) {
            e.stopPropagation();
            _onClick && _onClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            // Prevent browser from navigating back.
            if (e.key === "Backspace") e.preventDefault();
            _onKeyDown && _onKeyDown(e);
        },
        type: "button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "rbt-close-content"
    }, "\xd7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$c4e078b9a88a5454$var$ClearButton.propTypes = $c4e078b9a88a5454$var$propTypes;
var $c4e078b9a88a5454$export$2e2bcd8739ae039 = $c4e078b9a88a5454$var$ClearButton;

});


parcelRegister("bOhDN", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("aVH5j")).default);

var $aVH5j = parcelRequire("aVH5j");

});
parcelRegister("aVH5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f50a5f4a32ab96d$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
var $7f50a5f4a32ab96d$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $7f50a5f4a32ab96d$var$Loader = function Loader(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? "Loading..." : _ref$label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rbt-loader spinner-border spinner-border-sm",
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$7f50a5f4a32ab96d$var$Loader.propTypes = $7f50a5f4a32ab96d$var$propTypes;
var $7f50a5f4a32ab96d$export$2e2bcd8739ae039 = $7f50a5f4a32ab96d$var$Loader;

});


parcelRegister("lv1yE", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("3cYPq")).default);

var $3cYPq = parcelRequire("3cYPq");

var $2sZkt = parcelRequire("2sZkt");

});
parcelRegister("3cYPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2561ad578bcaaeab$export$2e2bcd8739ae039);

var $gZU1N = parcelRequire("gZU1N");

var $c9Z8w = parcelRequire("c9Z8w");

var $2sZkt = parcelRequire("2sZkt");

var $lYCYm = parcelRequire("lYCYm");
parcelRequire("5cWuV");
var $jZK3h = parcelRequire("jZK3h");
var $2561ad578bcaaeab$var$_excluded = [
    "referenceElement",
    "isMenuShown"
];
// `Element` is not defined during server-side rendering, so shim it here.
/* istanbul ignore next */ var $2561ad578bcaaeab$var$SafeElement = typeof Element === "undefined" ? (0, $jZK3h.noop) : Element;
var $2561ad578bcaaeab$var$propTypes = {
    /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf((0, $lYCYm.ALIGN_VALUES)),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * Specify whether the menu should appear above the input.
   */ dropup: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isMenuShown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    positionFixed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // @ts-ignore
    referenceElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf($2561ad578bcaaeab$var$SafeElement)
};
var $2561ad578bcaaeab$var$Overlay = function Overlay(_ref) {
    var referenceElement = _ref.referenceElement, isMenuShown = _ref.isMenuShown, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $2561ad578bcaaeab$var$_excluded);
    var overlayProps = (0, $2sZkt.default)(referenceElement, props);
    if (!isMenuShown) return null;
    return props.children(overlayProps);
};
$2561ad578bcaaeab$var$Overlay.propTypes = $2561ad578bcaaeab$var$propTypes;
var $2561ad578bcaaeab$export$2e2bcd8739ae039 = $2561ad578bcaaeab$var$Overlay;

});
parcelRegister("2sZkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cbdc504ad67db50$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $acw62 = parcelRequire("acw62");

var $KNTYF = parcelRequire("KNTYF");
function $1cbdc504ad67db50$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1cbdc504ad67db50$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1cbdc504ad67db50$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1cbdc504ad67db50$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1cbdc504ad67db50$var$setPopperWidth = {
    enabled: true,
    fn: function fn(data) {
        // eslint-disable-next-line no-param-reassign
        data.state.styles.popper.width = "".concat(data.state.rects.reference.width, "px");
    },
    name: "setPopperWidth",
    phase: "write"
};
function $1cbdc504ad67db50$export$8fd03b29ab57a08f(props) {
    var modifiers = [
        {
            enabled: !!props.flip,
            name: "flip"
        }
    ];
    if (props.align !== "right" && props.align !== "left") modifiers.push($1cbdc504ad67db50$var$setPopperWidth);
    return modifiers;
}
function $1cbdc504ad67db50$export$a9fe23cfa43a7b55(props) {
    var x = props.align === "right" ? "end" : "start";
    var y = props.dropup ? "top" : "bottom";
    return "".concat(y, "-").concat(x);
}
function $1cbdc504ad67db50$export$ea8f71083e90600f(referenceElement, options) {
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), popperElement = _useState2[0], attachRef = _useState2[1];
    var _usePopper = (0, $KNTYF.usePopper)(referenceElement, popperElement, {
        modifiers: $1cbdc504ad67db50$export$8fd03b29ab57a08f(options),
        placement: $1cbdc504ad67db50$export$a9fe23cfa43a7b55(options),
        strategy: options.positionFixed ? "fixed" : "absolute"
    }), attributes = _usePopper.attributes, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate;
    var refElementHeight = referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.offsetHeight;
    // Re-position the popper if the height of the reference element changes.
    // Exclude `forceUpdate` from dependencies since it changes with each render.
    (0, $acw62.useEffect)(function() {
        forceUpdate && forceUpdate();
    }, [
        refElementHeight
    ]); // eslint-disable-line
    return $1cbdc504ad67db50$var$_objectSpread($1cbdc504ad67db50$var$_objectSpread({}, attributes.popper), {}, {
        innerRef: attachRef,
        style: styles.popper
    });
}
var $1cbdc504ad67db50$export$2e2bcd8739ae039 = $1cbdc504ad67db50$export$ea8f71083e90600f;

});
parcelRegister("KNTYF", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $08cb017687258e89$export$f4d5bf230a36dd6e);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $buXxn = parcelRequire("buXxn");
var $08cb017687258e89$var$EMPTY_MODIFIERS = [];
var $08cb017687258e89$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $08cb017687258e89$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $buXxn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $buXxn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $buXxn.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $buXxn.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};

});


parcelRegister("ai2Pb", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("buXxn", function(module, exports) {

$parcel$export(module.exports, "fromEntries", () => $85f0adf197ea687e$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $85f0adf197ea687e$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $85f0adf197ea687e$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $85f0adf197ea687e$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $85f0adf197ea687e$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $85f0adf197ea687e$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $85f0adf197ea687e$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $85f0adf197ea687e$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;

});





parcelRegister("2Wbd3", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("ibShZ")).default);

var $ibShZ = parcelRequire("ibShZ");

var $017dE = parcelRequire("017dE");

});
parcelRegister("ibShZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3e35dca7842c141$export$2e2bcd8739ae039);

var $gZU1N = parcelRequire("gZU1N");

var $017dE = parcelRequire("017dE");
var $d3e35dca7842c141$var$_excluded = [
    "children",
    "onRootClose"
];
function $d3e35dca7842c141$var$RootClose(_ref) {
    var children = _ref.children, onRootClose = _ref.onRootClose, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $d3e35dca7842c141$var$_excluded);
    var rootRef = (0, $017dE.default)(onRootClose, props);
    return children(rootRef);
}
var $d3e35dca7842c141$export$2e2bcd8739ae039 = $d3e35dca7842c141$var$RootClose;

});
parcelRegister("017dE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0035b1b67853a043$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $gGEFY = parcelRequire("gGEFY");
function $0035b1b67853a043$var$useRootClose(onRootClose, options) {
    var rootElementRef = (0, $acw62.useRef)(null);
    (0, $gGEFY.default)(rootElementRef.current, onRootClose, options);
    return rootElementRef;
}
var $0035b1b67853a043$export$2e2bcd8739ae039 = $0035b1b67853a043$var$useRootClose;

});
parcelRegister("gGEFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2601f0275fb3a4b$export$2e2bcd8739ae039);

var $cUYrv = parcelRequire("cUYrv");

var $7YnSj = parcelRequire("7YnSj");

var $acw62 = parcelRequire("acw62");

var $dsxUx = parcelRequire("dsxUx");

var $kg9aN = parcelRequire("kg9aN");

var $1YeaP = parcelRequire("1YeaP");
var $c2601f0275fb3a4b$var$escapeKeyCode = 27;
var $c2601f0275fb3a4b$var$noop = function noop() {};
function $c2601f0275fb3a4b$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $c2601f0275fb3a4b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $c2601f0275fb3a4b$var$getRefTarget = function getRefTarget(ref) {
    return ref && ("current" in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $c2601f0275fb3a4b$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? "click" : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $acw62.useRef)(false);
    var onClose = onRootClose || $c2601f0275fb3a4b$var$noop;
    var handleMouseCapture = (0, $acw62.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $c2601f0275fb3a4b$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $c2601f0275fb3a4b$var$isModifiedEvent(e) || !$c2601f0275fb3a4b$var$isLeftClickEvent(e) || !!(0, $cUYrv.default)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $dsxUx.default)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $dsxUx.default)(function(e) {
        if (e.keyCode === $c2601f0275fb3a4b$var$escapeKeyCode) onClose(e);
    });
    (0, $acw62.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $1YeaP.default)($c2601f0275fb3a4b$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $7YnSj.default)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $7YnSj.default)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $7YnSj.default)(doc, "keyup", function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $7YnSj.default)(el, "mousemove", $c2601f0275fb3a4b$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $c2601f0275fb3a4b$export$2e2bcd8739ae039 = $c2601f0275fb3a4b$var$useRootClose;

});
parcelRegister("1YeaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f6639f645f6841$export$2e2bcd8739ae039);

var $lIo3y = parcelRequire("lIo3y");

var $817yx = parcelRequire("817yx");
var $16f6639f645f6841$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $lIo3y.default)((0, $817yx.default)(componentOrElement));
};

});
parcelRegister("817yx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d6447361a0fcf02$export$2e2bcd8739ae039);

var $1u0KT = parcelRequire("1u0KT");
function $5d6447361a0fcf02$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});






parcelRegister("2rWeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8b4776d5298567$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("9rTkk");
var $gTYbN = parcelRequire("gTYbN");

var $lIXrf = parcelRequire("lIXrf");
parcelRequire("5cWuV");
var $jZK3h = parcelRequire("jZK3h");
var $1c8b4776d5298567$var$_excluded = [
    "active",
    "children",
    "className",
    "onRemove",
    "tabIndex"
], $1c8b4776d5298567$var$_excluded2 = [
    "children",
    "option",
    "readOnly"
], $1c8b4776d5298567$var$_excluded3 = [
    "ref"
];
function $1c8b4776d5298567$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c8b4776d5298567$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c8b4776d5298567$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c8b4776d5298567$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c8b4776d5298567$var$InteractiveToken = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, onRemove = _ref.onRemove, tabIndex = _ref.tabIndex, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $1c8b4776d5298567$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("rbt-token", "rbt-token-removeable", {
            "rbt-token-active": !!active
        }, className),
        ref: ref,
        tabIndex: tabIndex || 0
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gTYbN.default), {
        className: "rbt-token-remove-button",
        label: "Remove",
        onClick: onRemove,
        tabIndex: -1
    }));
});
var $1c8b4776d5298567$var$StaticToken = function StaticToken(_ref2) {
    var children = _ref2.children, className = _ref2.className, disabled = _ref2.disabled, href = _ref2.href;
    var classnames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("rbt-token", {
        "rbt-token-disabled": disabled
    }, className);
    if (href && !disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        className: classnames,
        href: href
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classnames
    }, children);
};
/**
 * Individual token component, generally displayed within the
 * `TypeaheadInputMulti` component, but can also be rendered on its own.
 */ var $1c8b4776d5298567$var$Token = function Token(_ref3) {
    var children = _ref3.children, option = _ref3.option, readOnly = _ref3.readOnly, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref3, $1c8b4776d5298567$var$_excluded2);
    var _useToken = (0, $lIXrf.useToken)($1c8b4776d5298567$var$_objectSpread($1c8b4776d5298567$var$_objectSpread({}, props), {}, {
        option: option
    })), ref = _useToken.ref, tokenProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_useToken, $1c8b4776d5298567$var$_excluded3);
    var child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rbt-token-label"
    }, children);
    return !props.disabled && !readOnly && (0, $jZK3h.isFunction)(tokenProps.onRemove) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1c8b4776d5298567$var$InteractiveToken, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, tokenProps, {
        ref: ref
    }), child) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1c8b4776d5298567$var$StaticToken, props, child);
};
var $1c8b4776d5298567$export$2e2bcd8739ae039 = $1c8b4776d5298567$var$Token;

});
parcelRegister("lIXrf", function(module, exports) {

$parcel$export(module.exports, "useToken", () => $fd0bd04ca8c64363$export$31dcd79391e423fe);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $02Ztr = parcelRequire("02Ztr");

var $gZU1N = parcelRequire("gZU1N");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $gGEFY = parcelRequire("gGEFY");
parcelRequire("5cWuV");
var $5UFLY = parcelRequire("5UFLY");
var $jZK3h = parcelRequire("jZK3h");
var $ip893 = parcelRequire("ip893");

var $1pmaC = parcelRequire("1pmaC");
var $fd0bd04ca8c64363$var$_excluded = [
    "onBlur",
    "onClick",
    "onFocus",
    "onRemove",
    "option"
];
function $fd0bd04ca8c64363$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd0bd04ca8c64363$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd0bd04ca8c64363$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd0bd04ca8c64363$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fd0bd04ca8c64363$var$propTypes = {
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    option: (0, $1pmaC.optionType).isRequired
};
function $fd0bd04ca8c64363$export$31dcd79391e423fe(_ref) {
    var onBlur = _ref.onBlur, onClick = _ref.onClick, onFocus = _ref.onFocus, onRemove = _ref.onRemove, option = _ref.option, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $fd0bd04ca8c64363$var$_excluded);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), active = _useState2[0], setActive = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState3, 2), rootElement = _useState4[0], attachRef = _useState4[1];
    var handleBlur = function handleBlur(e) {
        setActive(false);
        onBlur && onBlur(e);
    };
    var handleClick = function handleClick(e) {
        setActive(true);
        onClick && onClick(e);
    };
    var handleFocus = function handleFocus(e) {
        setActive(true);
        onFocus && onFocus(e);
    };
    var handleRemove = function handleRemove() {
        onRemove && onRemove(option);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Backspace" && active) {
            // Prevent browser from going back.
            e.preventDefault();
            handleRemove();
        }
    };
    (0, $gGEFY.default)(rootElement, handleBlur, $fd0bd04ca8c64363$var$_objectSpread($fd0bd04ca8c64363$var$_objectSpread({}, props), {}, {
        disabled: !active
    }));
    return {
        active: active,
        onBlur: handleBlur,
        onClick: handleClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onRemove: (0, $jZK3h.isFunction)(onRemove) ? handleRemove : undefined,
        ref: attachRef
    };
}
function $fd0bd04ca8c64363$export$f6f0dceccdb6a70d(Component) {
    (0, $ip893.default)(false, "Warning: `withToken` is deprecated and will be removed in the next major version. Use `useToken` instead.");
    var displayName = "withToken(".concat((0, $5UFLY.default)(Component), ")");
    var WrappedToken = function WrappedToken(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, $fd0bd04ca8c64363$export$31dcd79391e423fe(props)));
    };
    WrappedToken.displayName = displayName;
    WrappedToken.propTypes = $fd0bd04ca8c64363$var$propTypes;
    return WrappedToken;
}

});


parcelRegister("l4Uyk", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7crIX")).default);

var $7crIX = parcelRequire("7crIX");

});
parcelRegister("7crIX", function(module, exports) {

$parcel$export(module.exports, "default", () => $53df28d32903440b$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
parcelRequire("6ILFq");
var $dFVhP = parcelRequire("dFVhP");
parcelRequire("guWSP");
var $gzLlR = parcelRequire("gzLlR");
parcelRequire("5cWuV");
var $19Q4n = parcelRequire("19Q4n");
var $kKg6I = parcelRequire("kKg6I");
var $53df28d32903440b$var$_excluded = [
    "children",
    "className",
    "inputClassName",
    "inputRef",
    "referenceElementRef",
    "selected"
];
function $53df28d32903440b$var$TypeaheadInputMulti(props) {
    var wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var inputElem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var _propsWithBsClassName = (0, $kKg6I.default)(props), children = _propsWithBsClassName.children, className = _propsWithBsClassName.className, inputClassName = _propsWithBsClassName.inputClassName, inputRef = _propsWithBsClassName.inputRef, referenceElementRef = _propsWithBsClassName.referenceElementRef, selected = _propsWithBsClassName.selected, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_propsWithBsClassName, $53df28d32903440b$var$_excluded);
    function getInputRef(input) {
        inputElem.current = input;
        props.inputRef(input);
    }
    /**
   * Forward click or focus events on the container element to the input.
   */ function handleContainerClickOrFocus(e) {
        // Don't focus the input if it's disabled.
        if (props.disabled) {
            e.currentTarget.blur();
            return;
        }
        var inputNode = inputElem.current;
        if (!inputNode || // Ignore if the clicked element is a child of the container, ie: a token
        // or the input itself.
        e.currentTarget.contains(e.target) && e.currentTarget !== e.target) return;
        if ((0, $19Q4n.default)(inputNode)) // Move cursor to the end if the user clicks outside the actual input.
        inputNode.selectionStart = inputNode.value.length;
        inputNode.focus();
    }
    function handleKeyDown(e) {
        if (e.key === "Backspace" && selected.length && !props.value) {
            var _wrapperRef$current;
            // Prevent browser from going back.
            e.preventDefault();
            // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.
            var wrapperChildren = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.children;
            if (wrapperChildren !== null && wrapperChildren !== void 0 && wrapperChildren.length) {
                var lastToken = wrapperChildren[wrapperChildren.length - 2];
                lastToken === null || lastToken === void 0 || lastToken.focus();
            }
        }
        props.onKeyDown && props.onKeyDown(e);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("rbt-input-multi", {
            disabled: props.disabled
        }, className),
        onClick: handleContainerClickOrFocus,
        onFocus: handleContainerClickOrFocus,
        ref: referenceElementRef,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rbt-input-wrapper",
        ref: wrapperRef
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dFVhP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gzLlR.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, rest, {
        className: inputClassName,
        onKeyDown: handleKeyDown,
        ref: getInputRef,
        style: {
            backgroundColor: "transparent",
            border: 0,
            boxShadow: "none",
            cursor: "inherit",
            outline: "none",
            padding: 0,
            width: "100%",
            zIndex: 1
        }
    })))));
}
var $53df28d32903440b$export$2e2bcd8739ae039 = $53df28d32903440b$var$TypeaheadInputMulti;

});
parcelRegister("6ILFq", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("dFVhP")).default);

var $dFVhP = parcelRequire("dFVhP");

});
parcelRegister("dFVhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f4b8aa1604b11ab$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1Bizh = parcelRequire("1Bizh");
// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function $9f4b8aa1604b11ab$var$interpolateStyle(styles, attr) {
    var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    // Title-case the sub-attribute.
    if (subattr) /* eslint-disable-next-line no-param-reassign */ subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
    return [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ].map(function(dir) {
        return styles["".concat(attr).concat(dir).concat(subattr)];
    }).join(" ");
}
function $9f4b8aa1604b11ab$var$copyStyles(inputNode, hintNode) {
    var inputStyle = window.getComputedStyle(inputNode);
    /* eslint-disable no-param-reassign */ hintNode.style.borderStyle = $9f4b8aa1604b11ab$var$interpolateStyle(inputStyle, "border", "style");
    hintNode.style.borderWidth = $9f4b8aa1604b11ab$var$interpolateStyle(inputStyle, "border", "width");
    hintNode.style.fontSize = inputStyle.fontSize;
    hintNode.style.fontWeight = inputStyle.fontWeight;
    hintNode.style.height = inputStyle.height;
    hintNode.style.lineHeight = inputStyle.lineHeight;
    hintNode.style.margin = $9f4b8aa1604b11ab$var$interpolateStyle(inputStyle, "margin");
    hintNode.style.padding = $9f4b8aa1604b11ab$var$interpolateStyle(inputStyle, "padding");
/* eslint-enable no-param-reassign */ }
var $9f4b8aa1604b11ab$export$efccc994a079cdc8 = function useHint() {
    var _useTypeaheadContext = (0, $1Bizh.useTypeaheadContext)(), hintText = _useTypeaheadContext.hintText, inputNode = _useTypeaheadContext.inputNode;
    var hintRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (inputNode && hintRef.current) $9f4b8aa1604b11ab$var$copyStyles(inputNode, hintRef.current);
    });
    return {
        hintRef: hintRef,
        hintText: hintText
    };
};
var $9f4b8aa1604b11ab$var$Hint = function Hint(_ref) {
    var children = _ref.children, className = _ref.className;
    var _useHint = $9f4b8aa1604b11ab$export$efccc994a079cdc8(), hintRef = _useHint.hintRef, hintText = _useHint.hintText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        style: {
            display: "flex",
            flex: 1,
            height: "100%",
            position: "relative"
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        "aria-hidden": true,
        className: "rbt-input-hint",
        ref: hintRef,
        readOnly: true,
        style: {
            backgroundColor: "transparent",
            borderColor: "transparent",
            boxShadow: "none",
            color: "rgba(0, 0, 0, 0.54)",
            left: 0,
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            width: "100%"
        },
        tabIndex: -1,
        value: hintText
    }));
};
var $9f4b8aa1604b11ab$export$2e2bcd8739ae039 = $9f4b8aa1604b11ab$var$Hint;

});


parcelRegister("guWSP", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("gzLlR")).default);

var $gzLlR = parcelRequire("gzLlR");

});
parcelRegister("gzLlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c114a5481ea5c7f2$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $c114a5481ea5c7f2$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("rbt-input-main", props.className),
        ref: ref
    }));
});
var $c114a5481ea5c7f2$export$2e2bcd8739ae039 = $c114a5481ea5c7f2$var$Input;

});




parcelRegister("f6F5t", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("4VvGI")).default);

var $4VvGI = parcelRequire("4VvGI");

});
parcelRegister("4VvGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $396510dd837b30f4$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $acw62 = parcelRequire("acw62");
parcelRequire("6ILFq");
var $dFVhP = parcelRequire("dFVhP");
parcelRequire("guWSP");
var $gzLlR = parcelRequire("gzLlR");
parcelRequire("5cWuV");
var $kKg6I = parcelRequire("kKg6I");
var $396510dd837b30f4$var$_excluded = [
    "inputRef",
    "referenceElementRef"
];
var $396510dd837b30f4$var$TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
    var inputRef = _ref.inputRef, referenceElementRef = _ref.referenceElementRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $396510dd837b30f4$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dFVhP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gzLlR.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, (0, $kKg6I.default)(props), {
        ref: function ref(node) {
            inputRef(node);
            referenceElementRef(node);
        }
    })));
};
var $396510dd837b30f4$export$2e2bcd8739ae039 = $396510dd837b30f4$var$TypeaheadInputSingle;

});


parcelRegister("7H5QO", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("cAEjP")).default);

var $cAEjP = parcelRequire("cAEjP");

});
parcelRegister("cAEjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a81f480f61a1eb$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
parcelRequire("8cKJG");
var $6raUh = parcelRequire("6raUh");
parcelRequire("5s1zT");
var $fzpxR = parcelRequire("fzpxR");
parcelRequire("6JAUu");
var $2RnsI = parcelRequire("2RnsI");
parcelRequire("5cWuV");
var $lhbIa = parcelRequire("lhbIa");
var $bDoz9 = parcelRequire("bDoz9");
var $jZK3h = parcelRequire("jZK3h");
var $92a81f480f61a1eb$var$_excluded = [
    "labelKey",
    "newSelectionPrefix",
    "options",
    "paginationText",
    "renderMenuItemChildren",
    "text"
];
var $92a81f480f61a1eb$var$propTypes = {
    /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */ newSelectionPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Prompt displayed when large data sets are paginated.
   */ paginationText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Provides a hook for customized rendering of menu item contents.
   */ renderMenuItemChildren: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
function $92a81f480f61a1eb$var$renderMenuItemChildrenFn(option, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6raUh.default), {
        search: props.text
    }, (0, $lhbIa.default)(option, props.labelKey));
}
var $92a81f480f61a1eb$var$TypeaheadMenu = function TypeaheadMenu(props) {
    var labelKey = props.labelKey, _props$newSelectionPr = props.newSelectionPrefix, newSelectionPrefix = _props$newSelectionPr === void 0 ? "New selection: " : _props$newSelectionPr, options = props.options, _props$paginationText = props.paginationText, paginationText = _props$paginationText === void 0 ? "Display additional results..." : _props$paginationText, _props$renderMenuItem = props.renderMenuItemChildren, renderMenuItemChildren = _props$renderMenuItem === void 0 ? $92a81f480f61a1eb$var$renderMenuItemChildrenFn : _props$renderMenuItem, text = props.text, menuProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(props, $92a81f480f61a1eb$var$_excluded);
    var renderMenuItem = function renderMenuItem(option, position) {
        var label = (0, $lhbIa.default)(option, labelKey);
        var menuItemProps = {
            disabled: !!(0, $bDoz9.default)(option, "disabled"),
            label: label,
            option: option,
            position: position
        };
        if ((0, $bDoz9.default)(option, "customOption")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2RnsI.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, menuItemProps, {
            className: "rbt-menu-custom-option",
            key: position,
            label: label
        }), newSelectionPrefix, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6raUh.default), {
            search: text
        }, label));
        if ((0, $bDoz9.default)(option, "paginationOption")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: "pagination-option-divider"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fzpxR.default).Divider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2RnsI.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, menuItemProps, {
            className: "rbt-menu-pagination-option",
            label: // TODO: Fix how (aria-)labels are passed to `MenuItem`.
            // `paginationText` can be a ReactNode.
            (0, $jZK3h.isString)(paginationText) ? paginationText : ""
        }), paginationText));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2RnsI.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, menuItemProps, {
            key: position
        }), renderMenuItemChildren(option, props, position));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fzpxR.default), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, menuProps, {
        key: // Force a re-render if the text changes to ensure that menu
        // positioning updates correctly.
        text
    }), options.map(renderMenuItem));
};
$92a81f480f61a1eb$var$TypeaheadMenu.propTypes = $92a81f480f61a1eb$var$propTypes;
var $92a81f480f61a1eb$export$2e2bcd8739ae039 = $92a81f480f61a1eb$var$TypeaheadMenu;

});
parcelRegister("8cKJG", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("6raUh")).default);

var $6raUh = parcelRequire("6raUh");

});
parcelRegister("6raUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4afdb987a0518297$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
parcelRequire("5cWuV");
var $02mwI = parcelRequire("02mwI");
var $4afdb987a0518297$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    highlightClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};
/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */ var $4afdb987a0518297$var$Highlighter = function Highlighter(_ref) {
    var children = _ref.children, _ref$highlightClassNa = _ref.highlightClassName, highlightClassName = _ref$highlightClassNa === void 0 ? "rbt-highlight-text" : _ref$highlightClassNa, search = _ref.search;
    if (!search || !children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    var matchCount = 0;
    var remaining = children;
    var highlighterChildren = [];
    while(remaining){
        var bounds = (0, $02mwI.default)(remaining, search);
        // No match anywhere in the remaining string, stop.
        if (!bounds) {
            highlighterChildren.push(remaining);
            break;
        }
        // Capture the string that leads up to a match.
        var nonMatch = remaining.slice(0, bounds.start);
        if (nonMatch) highlighterChildren.push(nonMatch);
        // Capture the matching string.
        var match = remaining.slice(bounds.start, bounds.end);
        highlighterChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("mark", {
            className: highlightClassName,
            key: matchCount
        }, match));
        matchCount += 1;
        // And if there's anything left over, continue the loop.
        remaining = remaining.slice(bounds.end);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, highlighterChildren);
};
$4afdb987a0518297$var$Highlighter.propTypes = $4afdb987a0518297$var$propTypes;
var $4afdb987a0518297$export$2e2bcd8739ae039 = $4afdb987a0518297$var$Highlighter;

});


parcelRegister("5s1zT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("fzpxR")).default);

var $fzpxR = parcelRequire("fzpxR");

});
parcelRegister("fzpxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b55df0a01d076036$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $3p9rK = parcelRequire("3p9rK");

var $8g1PZ = parcelRequire("8g1PZ");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
parcelRequire("6JAUu");
var $2RnsI = parcelRequire("2RnsI");
parcelRequire("5cWuV");
var $8ojTx = parcelRequire("8ojTx");

var $1pmaC = parcelRequire("1pmaC");
var $b55df0a01d076036$var$_excluded = [
    "emptyLabel",
    "innerRef",
    "maxHeight",
    "style"
];
function $b55df0a01d076036$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b55df0a01d076036$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b55df0a01d076036$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b55df0a01d076036$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b55df0a01d076036$var$MenuDivider = function MenuDivider() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "dropdown-divider",
        role: "separator"
    });
};
var $b55df0a01d076036$var$MenuHeader = function MenuHeader(props) {
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        className: "dropdown-header",
        role: "heading"
    })));
};
var $b55df0a01d076036$var$propTypes = {
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Message to display in the menu if there are no valid results.
   */ emptyLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * Needed for accessibility.
   */ id: (0, $1pmaC.checkPropType)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]), (0, $1pmaC.isRequiredForA11y)),
    /**
   * Maximum height of the dropdown menu.
   */ maxHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
/**
 * Menu component that handles empty state when passed a set of results.
 */ var $b55df0a01d076036$var$Menu = function Menu(_ref) {
    var _ref$emptyLabel = _ref.emptyLabel, emptyLabel = _ref$emptyLabel === void 0 ? "No matches found." : _ref$emptyLabel, innerRef = _ref.innerRef, _ref$maxHeight = _ref.maxHeight, maxHeight = _ref$maxHeight === void 0 ? "300px" : _ref$maxHeight, style = _ref.style, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $b55df0a01d076036$var$_excluded);
    var children = (0, $acw62.Children).count(props.children) === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2RnsI.BaseMenuItem), {
        disabled: true,
        role: "option"
    }, emptyLabel) : props.children;
    return /*#__PURE__*/ /* eslint-disable jsx-a11y/interactive-supports-focus */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        "aria-label": props["aria-label"] || "menu-options",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("rbt-menu", "dropdown-menu", "show", props.className),
        onMouseDown: // Prevent input from blurring when clicking on the menu scrollbar.
        (0, $8ojTx.default),
        ref: innerRef,
        role: "listbox",
        style: $b55df0a01d076036$var$_objectSpread($b55df0a01d076036$var$_objectSpread({}, style), {}, {
            display: "block",
            maxHeight: maxHeight,
            overflow: "auto"
        })
    }), children);
};
$b55df0a01d076036$var$Menu.propTypes = $b55df0a01d076036$var$propTypes;
$b55df0a01d076036$var$Menu.Divider = $b55df0a01d076036$var$MenuDivider;
$b55df0a01d076036$var$Menu.Header = $b55df0a01d076036$var$MenuHeader;
var $b55df0a01d076036$export$2e2bcd8739ae039 = $b55df0a01d076036$var$Menu;

});
parcelRegister("6JAUu", function(module, exports) {
$parcel$export(module.exports, "BaseMenuItem", () => (parcelRequire("2RnsI")).BaseMenuItem);

$parcel$export(module.exports, "default", () => (parcelRequire("2RnsI")).default);

var $2RnsI = parcelRequire("2RnsI");

});
parcelRegister("2RnsI", function(module, exports) {

$parcel$export(module.exports, "BaseMenuItem", () => $2152bb16979693ca$export$2ddca9041350239b);
$parcel$export(module.exports, "default", () => $2152bb16979693ca$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $gZU1N = parcelRequire("gZU1N");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $cChoD = parcelRequire("cChoD");
var $2152bb16979693ca$var$_excluded = [
    "active",
    "children",
    "className",
    "disabled",
    "onClick"
];
var $2152bb16979693ca$export$2ddca9041350239b = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, disabled = _ref.disabled, _onClick = _ref.onClick, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $2152bb16979693ca$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("dropdown-item", {
            active: active,
            disabled: disabled
        }, className),
        href: props.href || "#",
        onClick: function onClick(e) {
            e.preventDefault();
            !disabled && _onClick && _onClick(e);
        },
        ref: ref
    }), children);
});
function $2152bb16979693ca$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2152bb16979693ca$export$2ddca9041350239b, (0, $cChoD.useItem)(props));
}

});
parcelRegister("cChoD", function(module, exports) {

$parcel$export(module.exports, "useItem", () => $92f687348788b6cc$export$9842ce616dcc8723);

var $3p9rK = parcelRequire("3p9rK");

var $g5Zhu = parcelRequire("g5Zhu");

var $gZU1N = parcelRequire("gZU1N");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $fjK9t = parcelRequire("fjK9t");

var $1Bizh = parcelRequire("1Bizh");
parcelRequire("5cWuV");
var $5UFLY = parcelRequire("5UFLY");
var $9YoBW = parcelRequire("9YoBW");
var $8ojTx = parcelRequire("8ojTx");
var $ip893 = parcelRequire("ip893");

var $1pmaC = parcelRequire("1pmaC");
var $92f687348788b6cc$var$_excluded = [
    "label",
    "onClick",
    "option",
    "position"
];
function $92f687348788b6cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92f687348788b6cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92f687348788b6cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92f687348788b6cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $92f687348788b6cc$var$propTypes = {
    option: (0, $1pmaC.optionType).isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
};
function $92f687348788b6cc$export$9842ce616dcc8723(_ref) {
    var label = _ref.label, onClick = _ref.onClick, option = _ref.option, position = _ref.position, props = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $92f687348788b6cc$var$_excluded);
    var _useTypeaheadContext = (0, $1Bizh.useTypeaheadContext)(), activeIndex = _useTypeaheadContext.activeIndex, id = _useTypeaheadContext.id, isOnlyResult = _useTypeaheadContext.isOnlyResult, onActiveItemChange = _useTypeaheadContext.onActiveItemChange, onInitialItemChange = _useTypeaheadContext.onInitialItemChange, onMenuItemClick = _useTypeaheadContext.onMenuItemClick, setItem = _useTypeaheadContext.setItem;
    var itemRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (position === 0) onInitialItemChange(option);
    });
    (0, $acw62.useEffect)(function() {
        if (position === activeIndex) {
            onActiveItemChange(option);
            // Automatically scroll the menu as the user keys through it.
            var node = itemRef.current;
            node && (0, $fjK9t.default)(node, {
                boundary: node.parentNode,
                scrollMode: "if-needed"
            });
        }
    }, [
        activeIndex,
        onActiveItemChange,
        option,
        position
    ]);
    var handleClick = (0, $acw62.useCallback)(function(e) {
        onMenuItemClick(option, e);
        onClick && onClick(e);
    }, [
        onClick,
        onMenuItemClick,
        option
    ]);
    var active = isOnlyResult || activeIndex === position;
    // Update the item's position in the item stack.
    setItem(option, position);
    return $92f687348788b6cc$var$_objectSpread($92f687348788b6cc$var$_objectSpread({}, props), {}, {
        active: active,
        "aria-label": label,
        "aria-selected": active,
        id: (0, $9YoBW.default)(id, position),
        onClick: handleClick,
        onMouseDown: (0, $8ojTx.default),
        ref: itemRef,
        role: "option"
    });
}
function $92f687348788b6cc$export$a3a500069effb440(Component) {
    (0, $ip893.default)(false, "Warning: `withItem` is deprecated and will be removed in the next major version. Use `useItem` instead.");
    var WrappedMenuItem = function WrappedMenuItem(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, $92f687348788b6cc$export$9842ce616dcc8723(props)));
    };
    WrappedMenuItem.displayName = "withItem(".concat((0, $5UFLY.default)(Component), ")");
    WrappedMenuItem.propTypes = $92f687348788b6cc$var$propTypes;
    return WrappedMenuItem;
}

});
parcelRegister("fjK9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b26c6e29c94de039$export$2e2bcd8739ae039);

var $dQ6ka = parcelRequire("dQ6ka");
const $b26c6e29c94de039$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $b26c6e29c94de039$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $dQ6ka.compute)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $dQ6ka.compute)(e, $b26c6e29c94de039$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}

});
parcelRegister("dQ6ka", function(module, exports) {

$parcel$export(module.exports, "compute", () => $a135099456a3a66d$export$3b12cb22b12b954b);
const $a135099456a3a66d$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $a135099456a3a66d$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $a135099456a3a66d$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $a135099456a3a66d$var$e(o.overflowY, n) || $a135099456a3a66d$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $a135099456a3a66d$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $a135099456a3a66d$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $a135099456a3a66d$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$a135099456a3a66d$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $a135099456a3a66d$var$t(W) && p(W);){
        if (W = $a135099456a3a66d$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $a135099456a3a66d$var$n(W) && !$a135099456a3a66d$var$n(document.documentElement) || null != W && $a135099456a3a66d$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $a135099456a3a66d$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $a135099456a3a66d$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $a135099456a3a66d$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $a135099456a3a66d$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};

});













parcelRegister("dcZRV", function(module, exports) {

var $2rWeT = parcelRequire("2rWeT");

});


parcelRegister("4Tcsi", function(module, exports) {

$parcel$export(module.exports, "useIMask", () => (parcelRequire("kwclR")).default);
parcelRequire("fLlcT");
parcelRequire("hGKnh");
var $3VPSz = parcelRequire("3VPSz");

var $eBVXM = parcelRequire("eBVXM");

var $ih2iT = parcelRequire("ih2iT");

var $kwclR = parcelRequire("kwclR");
parcelRequire("3w54T");
parcelRequire("acw62");


});
parcelRegister("fLlcT", function(module, exports) {

var $hx7qC = parcelRequire("hx7qC");

var $3VPSz = parcelRequire("3VPSz");

var $7J9oQ = parcelRequire("7J9oQ");

var $8hM9o = parcelRequire("8hM9o");

var $l6DRi = parcelRequire("l6DRi");

var $4yFuH = parcelRequire("4yFuH");

var $62XRX = parcelRequire("62XRX");

var $icQ7P = parcelRequire("icQ7P");

var $aFZLp = parcelRequire("aFZLp");

var $70ryG = parcelRequire("70ryG");

var $2MfHr = parcelRequire("2MfHr");

var $f2ySt = parcelRequire("f2ySt");

var $isiCJ = parcelRequire("isiCJ");

var $daQKZ = parcelRequire("daQKZ");

var $iV2Eh = parcelRequire("iV2Eh");

var $lP4bh = parcelRequire("lP4bh");

var $aDXuy = parcelRequire("aDXuy");
parcelRequire("5MZVQ");
parcelRequire("hXrfI");
parcelRequire("8C3e0");
parcelRequire("g25yo");
parcelRequire("l46UZ");
parcelRequire("cuHCm");
parcelRequire("9QcM3");
parcelRequire("eumni");
try {
    globalThis.IMask = (0, $3VPSz.default);
} catch (e) {}

});
parcelRegister("hx7qC", function(module, exports) {

var $5MZVQ = parcelRequire("5MZVQ");

var $hXrfI = parcelRequire("hXrfI");

var $8C3e0 = parcelRequire("8C3e0");
parcelRequire("icQ7P");

var $f2ySt = parcelRequire("f2ySt");

var $isiCJ = parcelRequire("isiCJ");

var $daQKZ = parcelRequire("daQKZ");

var $iV2Eh = parcelRequire("iV2Eh");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("aDXuy");
parcelRequire("8hM9o");
parcelRequire("7J9oQ");
parcelRequire("g25yo");
parcelRequire("l46UZ");
parcelRequire("cuHCm");
parcelRequire("9QcM3");
parcelRequire("eumni");
parcelRequire("aFZLp");
parcelRequire("4yFuH");
const $cc3b47df982ee2b2$var$_excluded = [
    "mask"
];
/** Listens to element events and controls changes between element and {@link Masked} */ class $cc3b47df982ee2b2$export$2e2bcd8739ae039 {
    /**
    View element
    @readonly
  */ /**
    Internal {@link Masked} model
    @readonly
  */ /**
    @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
    @param {Object} opts
  */ constructor(el, opts){
        this.el = el instanceof (0, $isiCJ.default) ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new (0, $iV2Eh.default)(el) : new (0, $daQKZ.default)(el);
        this.masked = (0, $f2ySt.default)(opts);
        this._listeners = {};
        this._value = "";
        this._unmaskedValue = "";
        this._saveSelection = this._saveSelection.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onClick = this._onClick.bind(this);
        this.alignCursor = this.alignCursor.bind(this);
        this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
        this._bindEvents();
        // refresh
        this.updateValue();
        this._onChange();
    }
    /** Read or update mask */ get mask() {
        return this.masked.mask;
    }
    maskEquals(mask) {
        var _this$masked;
        return mask == null || ((_this$masked = this.masked) === null || _this$masked === void 0 ? void 0 : _this$masked.maskEquals(mask));
    }
    set mask(mask) {
        if (this.maskEquals(mask)) return;
        // $FlowFixMe No ideas ... after update
        if (!(mask instanceof (0, $3VPSz.default).Masked) && this.masked.constructor === (0, $f2ySt.maskedClass)(mask)) {
            this.masked.updateOptions({
                mask: mask
            });
            return;
        }
        const masked = (0, $f2ySt.default)({
            mask: mask
        });
        masked.unmaskedValue = this.masked.unmaskedValue;
        this.masked = masked;
    }
    /** Raw value */ get value() {
        return this._value;
    }
    set value(str) {
        if (this.value === str) return;
        this.masked.value = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Unmasked value */ get unmaskedValue() {
        return this._unmaskedValue;
    }
    set unmaskedValue(str) {
        if (this.unmaskedValue === str) return;
        this.masked.unmaskedValue = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Typed unmasked value */ get typedValue() {
        return this.masked.typedValue;
    }
    set typedValue(val) {
        if (this.masked.typedValueEquals(val)) return;
        this.masked.typedValue = val;
        this.updateControl();
        this.alignCursor();
    }
    /** Display value */ get displayValue() {
        return this.masked.displayValue;
    }
    /**
    Starts listening to element events
    @protected
  */ _bindEvents() {
        this.el.bindEvents({
            selectionChange: this._saveSelection,
            input: this._onInput,
            drop: this._onDrop,
            click: this._onClick,
            focus: this._onFocus,
            commit: this._onChange
        });
    }
    /**
    Stops listening to element events
    @protected
   */ _unbindEvents() {
        if (this.el) this.el.unbindEvents();
    }
    /**
    Fires custom event
    @protected
   */ _fireEvent(ev) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        const listeners = this._listeners[ev];
        if (!listeners) return;
        listeners.forEach((l)=>l(...args));
    }
    /**
    Current selection start
    @readonly
  */ get selectionStart() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */ get cursorPos() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    }
    set cursorPos(pos) {
        if (!this.el || !this.el.isActive) return;
        this.el.select(pos, pos);
        this._saveSelection();
    }
    /**
    Stores current selection
    @protected
  */ _saveSelection() {
        if (this.displayValue !== this.el.value) console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."); // eslint-disable-line no-console
        this._selection = {
            start: this.selectionStart,
            end: this.cursorPos
        };
    }
    /** Syncronizes model value from view */ updateValue() {
        this.masked.value = this.el.value;
        this._value = this.masked.value;
    }
    /** Syncronizes view from model value, fires change events */ updateControl() {
        const newUnmaskedValue = this.masked.unmaskedValue;
        const newValue = this.masked.value;
        const newDisplayValue = this.displayValue;
        const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
        this._unmaskedValue = newUnmaskedValue;
        this._value = newValue;
        if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
        if (isChanged) this._fireChangeEvents();
    }
    /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */ updateOptions(opts) {
        const { mask: mask } = opts, restOpts = (0, $5MZVQ._)(opts, $cc3b47df982ee2b2$var$_excluded);
        const updateMask = !this.maskEquals(mask);
        const updateOpts = !(0, $hXrfI.objectIncludes)(this.masked, restOpts);
        if (updateMask) this.mask = mask;
        if (updateOpts) this.masked.updateOptions(restOpts);
        if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */ updateCursor(cursorPos) {
        if (cursorPos == null) return;
        this.cursorPos = cursorPos;
        // also queue change cursor for mobile browsers
        this._delayUpdateCursor(cursorPos);
    }
    /**
    Delays cursor update to support mobile browsers
    @private
  */ _delayUpdateCursor(cursorPos) {
        this._abortUpdateCursor();
        this._changingCursorPos = cursorPos;
        this._cursorChanging = setTimeout(()=>{
            if (!this.el) return; // if was destroyed
            this.cursorPos = this._changingCursorPos;
            this._abortUpdateCursor();
        }, 10);
    }
    /**
    Fires custom events
    @protected
  */ _fireChangeEvents() {
        this._fireEvent("accept", this._inputEvent);
        if (this.masked.isComplete) this._fireEvent("complete", this._inputEvent);
    }
    /**
    Aborts delayed cursor update
    @private
  */ _abortUpdateCursor() {
        if (this._cursorChanging) {
            clearTimeout(this._cursorChanging);
            delete this._cursorChanging;
        }
    }
    /** Aligns cursor to nearest available position */ alignCursor() {
        this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, (0, $hXrfI.DIRECTION).LEFT));
    }
    /** Aligns cursor only if selection is empty */ alignCursorFriendly() {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
        this.alignCursor();
    }
    /** Adds listener on custom event */ on(ev, handler) {
        if (!this._listeners[ev]) this._listeners[ev] = [];
        this._listeners[ev].push(handler);
        return this;
    }
    /** Removes custom event listener */ off(ev, handler) {
        if (!this._listeners[ev]) return this;
        if (!handler) {
            delete this._listeners[ev];
            return this;
        }
        const hIndex = this._listeners[ev].indexOf(handler);
        if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
        return this;
    }
    /** Handles view input event */ _onInput(e) {
        this._inputEvent = e;
        this._abortUpdateCursor();
        // fix strange IE behavior
        if (!this._selection) return this.updateValue();
        const details = new (0, $8C3e0.default)(// new state
        this.el.value, this.cursorPos, // old state
        this.displayValue, this._selection);
        const oldRawValue = this.masked.rawInputValue;
        const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
            input: true,
            raw: true
        }).offset;
        // force align in remove direction only if no input chars were removed
        // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
        const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : (0, $hXrfI.DIRECTION).NONE;
        let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
        if (removeDirection !== (0, $hXrfI.DIRECTION).NONE) cursorPos = this.masked.nearestInputPos(cursorPos, (0, $hXrfI.DIRECTION).NONE);
        this.updateControl();
        this.updateCursor(cursorPos);
        delete this._inputEvent;
    }
    /** Handles view change event and commits model value */ _onChange() {
        if (this.displayValue !== this.el.value) this.updateValue();
        this.masked.doCommit();
        this.updateControl();
        this._saveSelection();
    }
    /** Handles view drop event, prevents by default */ _onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    /** Restore last selection on focus */ _onFocus(ev) {
        this.alignCursorFriendly();
    }
    /** Restore last selection on focus */ _onClick(ev) {
        this.alignCursorFriendly();
    }
    /** Unbind view events and removes element reference */ destroy() {
        this._unbindEvents();
        // $FlowFixMe why not do so?
        this._listeners.length = 0;
        // $FlowFixMe
        delete this.el;
    }
}
(0, $3VPSz.default).InputMask = $cc3b47df982ee2b2$export$2e2bcd8739ae039;

});
parcelRegister("5MZVQ", function(module, exports) {

$parcel$export(module.exports, "_", () => $437179de393d1e52$export$71511d61b312f219);
function $437179de393d1e52$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("hXrfI", function(module, exports) {

$parcel$export(module.exports, "isString", () => $d12d162673b655b0$export$844ec244b1367d54);
$parcel$export(module.exports, "DIRECTION", () => $d12d162673b655b0$export$9106728c49045482);
$parcel$export(module.exports, "forceDirection", () => $d12d162673b655b0$export$32af4dafed14c8ce);
$parcel$export(module.exports, "escapeRegExp", () => $d12d162673b655b0$export$7c57da42ce8e346f);
$parcel$export(module.exports, "normalizePrepare", () => $d12d162673b655b0$export$a5857239357aeb9a);
$parcel$export(module.exports, "objectIncludes", () => $d12d162673b655b0$export$7aeb68f71172641d);

var $aDXuy = parcelRequire("aDXuy");
parcelRequire("3VPSz");
/** Checks if value is string */ function $d12d162673b655b0$export$844ec244b1367d54(str) {
    return typeof str === "string" || str instanceof String;
}
/**
  Direction
  @prop {string} NONE
  @prop {string} LEFT
  @prop {string} FORCE_LEFT
  @prop {string} RIGHT
  @prop {string} FORCE_RIGHT
*/ const $d12d162673b655b0$export$9106728c49045482 = {
    NONE: "NONE",
    LEFT: "LEFT",
    FORCE_LEFT: "FORCE_LEFT",
    RIGHT: "RIGHT",
    FORCE_RIGHT: "FORCE_RIGHT"
};
/**
  Direction
  @enum {string}
*/ /** Returns next char index in direction */ function $d12d162673b655b0$export$49acc1dcf6e05985(pos, direction) {
    if (direction === $d12d162673b655b0$export$9106728c49045482.LEFT) --pos;
    return pos;
}
/** Returns next char position in direction */ function $d12d162673b655b0$export$b4ef8c52a2de85eb(pos, direction) {
    switch(direction){
        case $d12d162673b655b0$export$9106728c49045482.LEFT:
        case $d12d162673b655b0$export$9106728c49045482.FORCE_LEFT:
            return --pos;
        case $d12d162673b655b0$export$9106728c49045482.RIGHT:
        case $d12d162673b655b0$export$9106728c49045482.FORCE_RIGHT:
            return ++pos;
        default:
            return pos;
    }
}
/** */ function $d12d162673b655b0$export$32af4dafed14c8ce(direction) {
    switch(direction){
        case $d12d162673b655b0$export$9106728c49045482.LEFT:
            return $d12d162673b655b0$export$9106728c49045482.FORCE_LEFT;
        case $d12d162673b655b0$export$9106728c49045482.RIGHT:
            return $d12d162673b655b0$export$9106728c49045482.FORCE_RIGHT;
        default:
            return direction;
    }
}
/** Escapes regular expression control chars */ function $d12d162673b655b0$export$7c57da42ce8e346f(str) {
    return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
function $d12d162673b655b0$export$a5857239357aeb9a(prep) {
    return Array.isArray(prep) ? prep : [
        prep,
        new (0, $aDXuy.default)()
    ];
}
// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function $d12d162673b655b0$export$7aeb68f71172641d(b, a) {
    if (a === b) return true;
    var arrA = Array.isArray(a), arrB = Array.isArray(b), i;
    if (arrA && arrB) {
        if (a.length != b.length) return false;
        for(i = 0; i < a.length; i++)if (!$d12d162673b655b0$export$7aeb68f71172641d(a[i], b[i])) return false;
        return true;
    }
    if (arrA != arrB) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA && dateB) return a.getTime() == b.getTime();
        if (dateA != dateB) return false;
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA && regexpB) return a.toString() == b.toString();
        if (regexpA != regexpB) return false;
        var keys = Object.keys(a);
        // if (keys.length !== Object.keys(b).length) return false;
        for(i = 0; i < keys.length; i++)// $FlowFixMe ... ???
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = 0; i < keys.length; i++)if (!$d12d162673b655b0$export$7aeb68f71172641d(b[keys[i]], a[keys[i]])) return false;
        return true;
    } else if (a && b && typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
    return false;
}

});
parcelRegister("aDXuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bfbb1c19bc1f0cc$export$2e2bcd8739ae039);

var $3VPSz = parcelRequire("3VPSz");
/**
  Provides details of changing model value
  @param {Object} [details]
  @param {string} [details.inserted] - Inserted symbols
  @param {boolean} [details.skip] - Can skip chars
  @param {number} [details.removeCount] - Removed symbols count
  @param {number} [details.tailShift] - Additional offset if any changes occurred before tail
*/ class $7bfbb1c19bc1f0cc$export$2e2bcd8739ae039 {
    /** Inserted symbols */ /** Can skip chars */ /** Additional offset if any changes occurred before tail */ /** Raw inserted is used by dynamic mask */ constructor(details){
        Object.assign(this, {
            inserted: "",
            rawInserted: "",
            skip: false,
            tailShift: 0
        }, details);
    }
    /**
    Aggregate changes
    @returns {ChangeDetails} `this`
  */ aggregate(details) {
        this.rawInserted += details.rawInserted;
        this.skip = this.skip || details.skip;
        this.inserted += details.inserted;
        this.tailShift += details.tailShift;
        return this;
    }
    /** Total offset considering all changes */ get offset() {
        return this.tailShift + this.inserted.length;
    }
}
(0, $3VPSz.default).ChangeDetails = $7bfbb1c19bc1f0cc$export$2e2bcd8739ae039;

});
parcelRegister("3VPSz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dcef01601b9f124$export$2e2bcd8739ae039);
/**
 * Applies mask on element.
 * @constructor
 * @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
 * @param {Object} opts - Custom mask options
 * @return {InputMask}
 */ function $2dcef01601b9f124$export$2e2bcd8739ae039(el) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // currently available only for input-like elements
    return new $2dcef01601b9f124$export$2e2bcd8739ae039.InputMask(el, opts);
}

});



parcelRegister("8C3e0", function(module, exports) {

$parcel$export(module.exports, "default", () => $64545fbc80271a21$export$2e2bcd8739ae039);

var $hXrfI = parcelRequire("hXrfI");
parcelRequire("aDXuy");
parcelRequire("3VPSz");
/** Provides details of changing input */ class $64545fbc80271a21$export$2e2bcd8739ae039 {
    /** Current input value */ /** Current cursor position */ /** Old input value */ /** Old selection */ constructor(value, cursorPos, oldValue, oldSelection){
        this.value = value;
        this.cursorPos = cursorPos;
        this.oldValue = oldValue;
        this.oldSelection = oldSelection;
        // double check if left part was changed (autofilling, other non-standard input triggers)
        while(this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos))--this.oldSelection.start;
    }
    /**
    Start changing position
    @readonly
  */ get startChangePos() {
        return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /**
    Inserted symbols count
    @readonly
  */ get insertedCount() {
        return this.cursorPos - this.startChangePos;
    }
    /**
    Inserted symbols
    @readonly
  */ get inserted() {
        return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /**
    Removed symbols count
    @readonly
  */ get removedCount() {
        // Math.max for opposite operation
        return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
        this.oldValue.length - this.value.length, 0);
    }
    /**
    Removed symbols
    @readonly
  */ get removed() {
        return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /**
    Unchanged head symbols
    @readonly
  */ get head() {
        return this.value.substring(0, this.startChangePos);
    }
    /**
    Unchanged tail symbols
    @readonly
  */ get tail() {
        return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /**
    Remove direction
    @readonly
  */ get removeDirection() {
        if (!this.removedCount || this.insertedCount) return (0, $hXrfI.DIRECTION).NONE;
        // align right if delete at right
        return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
        this.oldSelection.end === this.oldSelection.start ? (0, $hXrfI.DIRECTION).RIGHT : (0, $hXrfI.DIRECTION).LEFT;
    }
}

});

parcelRegister("icQ7P", function(module, exports) {

var $8hM9o = parcelRequire("8hM9o");

var $4yFuH = parcelRequire("4yFuH");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("5MZVQ");
parcelRequire("hXrfI");
parcelRequire("aDXuy");
parcelRequire("7J9oQ");
parcelRequire("g25yo");
parcelRequire("l46UZ");
parcelRequire("f2ySt");
parcelRequire("cuHCm");
parcelRequire("9QcM3");
parcelRequire("eumni");
parcelRequire("aFZLp");
/** Date mask */ class $d411c7fd3a9c2f02$export$2e2bcd8739ae039 extends (0, $8hM9o.default) {
    /** Pattern mask for date according to {@link MaskedDate#format} */ /** Start date */ /** End date */ /** */ /**
    @param {Object} opts
  */ constructor(opts){
        super(Object.assign({}, $d411c7fd3a9c2f02$export$2e2bcd8739ae039.DEFAULTS, opts));
    }
    /**
    @override
  */ _update(opts) {
        if (opts.mask === Date) delete opts.mask;
        if (opts.pattern) opts.mask = opts.pattern;
        const blocks = opts.blocks;
        opts.blocks = Object.assign({}, $d411c7fd3a9c2f02$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS());
        // adjust year block
        if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
        if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();
        if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
            opts.blocks.m.from = opts.min.getMonth() + 1;
            opts.blocks.m.to = opts.max.getMonth() + 1;
            if (opts.blocks.m.from === opts.blocks.m.to) {
                opts.blocks.d.from = opts.min.getDate();
                opts.blocks.d.to = opts.max.getDate();
            }
        }
        Object.assign(opts.blocks, this.blocks, blocks);
        // add autofix
        Object.keys(opts.blocks).forEach((bk)=>{
            const b = opts.blocks[bk];
            if (!("autofix" in b) && "autofix" in opts) b.autofix = opts.autofix;
        });
        super._update(opts);
    }
    /**
    @override
  */ doValidate() {
        const date = this.date;
        return super.doValidate(...arguments) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */ isDateExist(str) {
        return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */ get date() {
        return this.typedValue;
    }
    set date(date) {
        this.typedValue = date;
    }
    /**
    @override
  */ get typedValue() {
        return this.isComplete ? super.typedValue : null;
    }
    set typedValue(value) {
        super.typedValue = value;
    }
    /**
    @override
  */ maskEquals(mask) {
        return mask === Date || super.maskEquals(mask);
    }
}
$d411c7fd3a9c2f02$export$2e2bcd8739ae039.DEFAULTS = {
    pattern: "d{.}`m{.}`Y",
    format: (date)=>{
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return [
            day,
            month,
            year
        ].join(".");
    },
    parse: (str)=>{
        const [day, month, year] = str.split(".");
        return new Date(year, month - 1, day);
    }
};
$d411c7fd3a9c2f02$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS = ()=>({
        d: {
            mask: (0, $4yFuH.default),
            from: 1,
            to: 31,
            maxLength: 2
        },
        m: {
            mask: (0, $4yFuH.default),
            from: 1,
            to: 12,
            maxLength: 2
        },
        Y: {
            mask: (0, $4yFuH.default),
            from: 1900,
            to: 9999
        }
    });
(0, $3VPSz.default).MaskedDate = $d411c7fd3a9c2f02$export$2e2bcd8739ae039;

});
parcelRegister("8hM9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $608542f471b0d0a0$export$2e2bcd8739ae039);

var $5MZVQ = parcelRequire("5MZVQ");

var $hXrfI = parcelRequire("hXrfI");

var $aDXuy = parcelRequire("aDXuy");

var $7J9oQ = parcelRequire("7J9oQ");

var $l46UZ = parcelRequire("l46UZ");

var $cuHCm = parcelRequire("cuHCm");

var $9QcM3 = parcelRequire("9QcM3");

var $eumni = parcelRequire("eumni");

var $f2ySt = parcelRequire("f2ySt");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("aFZLp");
parcelRequire("g25yo");
const $608542f471b0d0a0$var$_excluded = [
    "_blocks"
];
/**
  Pattern mask
  @param {Object} opts
  @param {Object} opts.blocks
  @param {Object} opts.definitions
  @param {string} opts.placeholderChar
  @param {string} opts.displayChar
  @param {boolean} opts.lazy
*/ class $608542f471b0d0a0$export$2e2bcd8739ae039 extends (0, $7J9oQ.default) {
    /** */ /** */ /** Single char for empty input */ /** Single char for filled input */ /** Show placeholder only when needed */ constructor(){
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO type $Shape<MaskedPatternOptions>={} does not work
        opts.definitions = Object.assign({}, (0, $l46UZ.DEFAULT_INPUT_DEFINITIONS), opts.definitions);
        super(Object.assign({}, $608542f471b0d0a0$export$2e2bcd8739ae039.DEFAULTS, opts));
    }
    /**
    @override
    @param {Object} opts
  */ _update() {
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        opts.definitions = Object.assign({}, this.definitions, opts.definitions);
        super._update(opts);
        this._rebuildMask();
    }
    /** */ _rebuildMask() {
        const defs = this.definitions;
        this._blocks = [];
        this._stops = [];
        this._maskedBlocks = {};
        let pattern = this.mask;
        if (!pattern || !defs) return;
        let unmaskingBlock = false;
        let optionalBlock = false;
        for(let i = 0; i < pattern.length; ++i){
            var _defs$char, _defs$char2;
            if (this.blocks) {
                const p = pattern.slice(i);
                const bNames = Object.keys(this.blocks).filter((bName)=>p.indexOf(bName) === 0);
                // order by key length
                bNames.sort((a, b)=>b.length - a.length);
                // use block name with max length
                const bName = bNames[0];
                if (bName) {
                    // $FlowFixMe no ideas
                    const maskedBlock = (0, $f2ySt.default)(Object.assign({
                        parent: this,
                        lazy: this.lazy,
                        eager: this.eager,
                        placeholderChar: this.placeholderChar,
                        displayChar: this.displayChar,
                        overwrite: this.overwrite
                    }, this.blocks[bName]));
                    if (maskedBlock) {
                        this._blocks.push(maskedBlock);
                        // store block index
                        if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
                        this._maskedBlocks[bName].push(this._blocks.length - 1);
                    }
                    i += bName.length - 1;
                    continue;
                }
            }
            let char = pattern[i];
            let isInput = char in defs;
            if (char === $608542f471b0d0a0$export$2e2bcd8739ae039.STOP_CHAR) {
                this._stops.push(this._blocks.length);
                continue;
            }
            if (char === "{" || char === "}") {
                unmaskingBlock = !unmaskingBlock;
                continue;
            }
            if (char === "[" || char === "]") {
                optionalBlock = !optionalBlock;
                continue;
            }
            if (char === $608542f471b0d0a0$export$2e2bcd8739ae039.ESCAPE_CHAR) {
                ++i;
                char = pattern[i];
                if (!char) break;
                isInput = false;
            }
            const maskOpts = (_defs$char = defs[char]) !== null && _defs$char !== void 0 && _defs$char.mask && !(((_defs$char2 = defs[char]) === null || _defs$char2 === void 0 ? void 0 : _defs$char2.mask.prototype) instanceof (0, $3VPSz.default).Masked) ? defs[char] : {
                mask: defs[char]
            };
            const def = isInput ? new (0, $l46UZ.default)(Object.assign({
                parent: this,
                isOptional: optionalBlock,
                lazy: this.lazy,
                eager: this.eager,
                placeholderChar: this.placeholderChar,
                displayChar: this.displayChar
            }, maskOpts)) : new (0, $cuHCm.default)({
                char: char,
                eager: this.eager,
                isUnmasking: unmaskingBlock
            });
            this._blocks.push(def);
        }
    }
    /**
    @override
  */ get state() {
        return Object.assign({}, super.state, {
            _blocks: this._blocks.map((b)=>b.state)
        });
    }
    set state(state) {
        const { _blocks: _blocks } = state, maskedState = (0, $5MZVQ._)(state, $608542f471b0d0a0$var$_excluded);
        this._blocks.forEach((b, bi)=>b.state = _blocks[bi]);
        super.state = maskedState;
    }
    /**
    @override
  */ reset() {
        super.reset();
        this._blocks.forEach((b)=>b.reset());
    }
    /**
    @override
  */ get isComplete() {
        return this._blocks.every((b)=>b.isComplete);
    }
    /**
    @override
  */ get isFilled() {
        return this._blocks.every((b)=>b.isFilled);
    }
    get isFixed() {
        return this._blocks.every((b)=>b.isFixed);
    }
    get isOptional() {
        return this._blocks.every((b)=>b.isOptional);
    }
    /**
    @override
  */ doCommit() {
        this._blocks.forEach((b)=>b.doCommit());
        super.doCommit();
    }
    /**
    @override
  */ get unmaskedValue() {
        return this._blocks.reduce((str, b)=>str += b.unmaskedValue, "");
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    /**
    @override
  */ get value() {
        // TODO return _value when not in change?
        return this._blocks.reduce((str, b)=>str += b.value, "");
    }
    set value(value) {
        super.value = value;
    }
    get displayValue() {
        return this._blocks.reduce((str, b)=>str += b.displayValue, "");
    }
    /**
    @override
  */ appendTail(tail) {
        return super.appendTail(tail).aggregate(this._appendPlaceholder());
    }
    /**
    @override
  */ _appendEager() {
        var _this$_mapPosToBlock;
        const details = new (0, $aDXuy.default)();
        let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.value.length)) === null || _this$_mapPosToBlock === void 0 ? void 0 : _this$_mapPosToBlock.index;
        if (startBlockIndex == null) return details;
        // TODO test if it works for nested pattern masks
        if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
        for(let bi = startBlockIndex; bi < this._blocks.length; ++bi){
            const d = this._blocks[bi]._appendEager();
            if (!d.inserted) break;
            details.aggregate(d);
        }
        return details;
    }
    /**
    @override
  */ _appendCharRaw(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const blockIter = this._mapPosToBlock(this.value.length);
        const details = new (0, $aDXuy.default)();
        if (!blockIter) return details;
        for(let bi = blockIter.index;; ++bi){
            var _flags$_beforeTailSta, _flags$_beforeTailSta2;
            const block = this._blocks[bi];
            if (!block) break;
            const blockDetails = block._appendChar(ch, Object.assign({}, flags, {
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : (_flags$_beforeTailSta2 = _flags$_beforeTailSta._blocks) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2[bi]
            }));
            const skip = blockDetails.skip;
            details.aggregate(blockDetails);
            if (skip || blockDetails.rawInserted) break; // go next char
        }
        return details;
    }
    /**
    @override
  */ extractTail() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        const chunkTail = new (0, $9QcM3.default)();
        if (fromPos === toPos) return chunkTail;
        this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos)=>{
            const blockChunk = b.extractTail(bFromPos, bToPos);
            blockChunk.stop = this._findStopBefore(bi);
            blockChunk.from = this._blockStartPos(bi);
            if (blockChunk instanceof (0, $9QcM3.default)) blockChunk.blockIndex = bi;
            chunkTail.extend(blockChunk);
        });
        return chunkTail;
    }
    /**
    @override
  */ extractInput() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        let flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (fromPos === toPos) return "";
        let input = "";
        this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos)=>{
            input += b.extractInput(fromPos, toPos, flags);
        });
        return input;
    }
    _findStopBefore(blockIndex) {
        let stopBefore;
        for(let si = 0; si < this._stops.length; ++si){
            const stop = this._stops[si];
            if (stop <= blockIndex) stopBefore = stop;
            else break;
        }
        return stopBefore;
    }
    /** Appends placeholder depending on laziness */ _appendPlaceholder(toBlockIndex) {
        const details = new (0, $aDXuy.default)();
        if (this.lazy && toBlockIndex == null) return details;
        const startBlockIter = this._mapPosToBlock(this.value.length);
        if (!startBlockIter) return details;
        const startBlockIndex = startBlockIter.index;
        const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
        this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b)=>{
            if (!b.lazy || toBlockIndex != null) {
                // $FlowFixMe `_blocks` may not be present
                const args = b._blocks != null ? [
                    b._blocks.length
                ] : [];
                const bDetails = b._appendPlaceholder(...args);
                this._value += bDetails.inserted;
                details.aggregate(bDetails);
            }
        });
        return details;
    }
    /** Finds block in pos */ _mapPosToBlock(pos) {
        let accVal = "";
        for(let bi = 0; bi < this._blocks.length; ++bi){
            const block = this._blocks[bi];
            const blockStartPos = accVal.length;
            accVal += block.value;
            if (pos <= accVal.length) return {
                index: bi,
                offset: pos - blockStartPos
            };
        }
    }
    /** */ _blockStartPos(blockIndex) {
        return this._blocks.slice(0, blockIndex).reduce((pos, b)=>pos += b.value.length, 0);
    }
    /** */ _forEachBlocksInRange(fromPos) {
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        let fn = arguments.length > 2 ? arguments[2] : undefined;
        const fromBlockIter = this._mapPosToBlock(fromPos);
        if (fromBlockIter) {
            const toBlockIter = this._mapPosToBlock(toPos);
            // process first block
            const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
            const fromBlockStartPos = fromBlockIter.offset;
            const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
            fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
            if (toBlockIter && !isSameBlock) {
                // process intermediate blocks
                for(let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi)fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
                // process last block
                fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
            }
        }
    }
    /**
    @override
  */ remove() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            removeDetails.aggregate(b.remove(bFromPos, bToPos));
        });
        return removeDetails;
    }
    /**
    @override
  */ nearestInputPos(cursorPos) {
        let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $hXrfI.DIRECTION).NONE;
        if (!this._blocks.length) return 0;
        const cursor = new (0, $eumni.default)(this, cursorPos);
        if (direction === (0, $hXrfI.DIRECTION).NONE) {
            // -------------------------------------------------
            // NONE should only go out from fixed to the right!
            // -------------------------------------------------
            if (cursor.pushRightBeforeInput()) return cursor.pos;
            cursor.popState();
            if (cursor.pushLeftBeforeInput()) return cursor.pos;
            return this.value.length;
        }
        // FORCE is only about a|* otherwise is 0
        if (direction === (0, $hXrfI.DIRECTION).LEFT || direction === (0, $hXrfI.DIRECTION).FORCE_LEFT) {
            // try to break fast when *|a
            if (direction === (0, $hXrfI.DIRECTION).LEFT) {
                cursor.pushRightBeforeFilled();
                if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                cursor.popState();
            }
            // forward flow
            cursor.pushLeftBeforeInput();
            cursor.pushLeftBeforeRequired();
            cursor.pushLeftBeforeFilled();
            // backward flow
            if (direction === (0, $hXrfI.DIRECTION).LEFT) {
                cursor.pushRightBeforeInput();
                cursor.pushRightBeforeRequired();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
            }
            if (cursor.ok) return cursor.pos;
            if (direction === (0, $hXrfI.DIRECTION).FORCE_LEFT) return 0;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            // cursor.popState();
            // if (
            //   cursor.pushRightBeforeInput() &&
            //   // TODO HACK for lazy if has aligned left inside fixed and has came to the start - use start position
            //   (!this.lazy || this.extractInput())
            // ) return cursor.pos;
            return 0;
        }
        if (direction === (0, $hXrfI.DIRECTION).RIGHT || direction === (0, $hXrfI.DIRECTION).FORCE_RIGHT) {
            // forward flow
            cursor.pushRightBeforeInput();
            cursor.pushRightBeforeRequired();
            if (cursor.pushRightBeforeFilled()) return cursor.pos;
            if (direction === (0, $hXrfI.DIRECTION).FORCE_RIGHT) return this.value.length;
            // backward flow
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return this.nearestInputPos(cursorPos, (0, $hXrfI.DIRECTION).LEFT);
        }
        return cursorPos;
    }
    /**
    @override
  */ totalInputPositions() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        let total = 0;
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            total += b.totalInputPositions(bFromPos, bToPos);
        });
        return total;
    }
    /** Get block by name */ maskedBlock(name) {
        return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */ maskedBlocks(name) {
        const indices = this._maskedBlocks[name];
        if (!indices) return [];
        return indices.map((gi)=>this._blocks[gi]);
    }
}
$608542f471b0d0a0$export$2e2bcd8739ae039.DEFAULTS = {
    lazy: true,
    placeholderChar: "_"
};
$608542f471b0d0a0$export$2e2bcd8739ae039.STOP_CHAR = "`";
$608542f471b0d0a0$export$2e2bcd8739ae039.ESCAPE_CHAR = "\\";
$608542f471b0d0a0$export$2e2bcd8739ae039.InputDefinition = (0, $l46UZ.default);
$608542f471b0d0a0$export$2e2bcd8739ae039.FixedDefinition = (0, $cuHCm.default);
(0, $3VPSz.default).MaskedPattern = $608542f471b0d0a0$export$2e2bcd8739ae039;

});
parcelRegister("7J9oQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a0406f4de738d3b$export$2e2bcd8739ae039);

var $aDXuy = parcelRequire("aDXuy");

var $g25yo = parcelRequire("g25yo");

var $hXrfI = parcelRequire("hXrfI");

var $3VPSz = parcelRequire("3VPSz");
/** Supported mask type */ /** Append flags */ /** Extract flags */ /** Provides common masking stuff */ class $5a0406f4de738d3b$export$2e2bcd8739ae039 {
    // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773
    /** @type {Mask} */ /** */ // $FlowFixMe no ideas
    /** Transforms value before mask processing */ /** Validates if value is acceptable */ /** Does additional processing in the end of editing */ /** Format typed value to string */ /** Parse strgin to get typed value */ /** Enable characters overwriting */ /** */ /** */ /** */ constructor(opts){
        this._value = "";
        this._update(Object.assign({}, $5a0406f4de738d3b$export$2e2bcd8739ae039.DEFAULTS, opts));
        this.isInitialized = true;
    }
    /** Sets and applies new options */ updateOptions(opts) {
        if (!Object.keys(opts).length) return;
        // $FlowFixMe
        this.withValueRefresh(this._update.bind(this, opts));
    }
    /**
    Sets new options
    @protected
  */ _update(opts) {
        Object.assign(this, opts);
    }
    /** Mask state */ get state() {
        return {
            _value: this.value
        };
    }
    set state(state) {
        this._value = state._value;
    }
    /** Resets value */ reset() {
        this._value = "";
    }
    /** */ get value() {
        return this._value;
    }
    set value(value) {
        this.resolve(value);
    }
    /** Resolve new value */ resolve(value) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            input: true
        };
        this.reset();
        this.append(value, flags, "");
        this.doCommit();
        return this.value;
    }
    /** */ get unmaskedValue() {
        return this.value;
    }
    set unmaskedValue(value) {
        this.reset();
        this.append(value, {}, "");
        this.doCommit();
    }
    /** */ get typedValue() {
        return this.doParse(this.value);
    }
    set typedValue(value) {
        this.value = this.doFormat(value);
    }
    /** Value that includes raw user input */ get rawInputValue() {
        return this.extractInput(0, this.value.length, {
            raw: true
        });
    }
    set rawInputValue(value) {
        this.reset();
        this.append(value, {
            raw: true
        }, "");
        this.doCommit();
    }
    get displayValue() {
        return this.value;
    }
    /** */ get isComplete() {
        return true;
    }
    /** */ get isFilled() {
        return this.isComplete;
    }
    /** Finds nearest input position in direction */ nearestInputPos(cursorPos, direction) {
        return cursorPos;
    }
    totalInputPositions() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return Math.min(this.value.length, toPos - fromPos);
    }
    /** Extracts value in range considering flags */ extractInput() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return this.value.slice(fromPos, toPos);
    }
    /** Extracts tail in range */ extractTail() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return new (0, $g25yo.default)(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */ // $FlowFixMe no ideas
    appendTail(tail) {
        if ((0, $hXrfI.isString)(tail)) tail = new (0, $g25yo.default)(String(tail));
        return tail.appendTo(this);
    }
    /** Appends char */ _appendCharRaw(ch) {
        if (!ch) return new (0, $aDXuy.default)();
        this._value += ch;
        return new (0, $aDXuy.default)({
            inserted: ch,
            rawInserted: ch
        });
    }
    /** Appends char */ _appendChar(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let checkTail = arguments.length > 2 ? arguments[2] : undefined;
        const consistentState = this.state;
        let details;
        [ch, details] = (0, $hXrfI.normalizePrepare)(this.doPrepare(ch, flags));
        details = details.aggregate(this._appendCharRaw(ch, flags));
        if (details.inserted) {
            let consistentTail;
            let appended = this.doValidate(flags) !== false;
            if (appended && checkTail != null) {
                // validation ok, check tail
                const beforeTailState = this.state;
                if (this.overwrite === true) {
                    consistentTail = checkTail.state;
                    checkTail.unshift(this.value.length - details.tailShift);
                }
                let tailDetails = this.appendTail(checkTail);
                appended = tailDetails.rawInserted === checkTail.toString();
                // not ok, try shift
                if (!(appended && tailDetails.inserted) && this.overwrite === "shift") {
                    this.state = beforeTailState;
                    consistentTail = checkTail.state;
                    checkTail.shift();
                    tailDetails = this.appendTail(checkTail);
                    appended = tailDetails.rawInserted === checkTail.toString();
                }
                // if ok, rollback state after tail
                if (appended && tailDetails.inserted) this.state = beforeTailState;
            }
            // revert all if something went wrong
            if (!appended) {
                details = new (0, $aDXuy.default)();
                this.state = consistentState;
                if (checkTail && consistentTail) checkTail.state = consistentTail;
            }
        }
        return details;
    }
    /** Appends optional placeholder at end */ _appendPlaceholder() {
        return new (0, $aDXuy.default)();
    }
    /** Appends optional eager placeholder at end */ _appendEager() {
        return new (0, $aDXuy.default)();
    }
    /** Appends symbols considering flags */ // $FlowFixMe no ideas
    append(str, flags, tail) {
        if (!(0, $hXrfI.isString)(str)) throw new Error("value should be string");
        const details = new (0, $aDXuy.default)();
        const checkTail = (0, $hXrfI.isString)(tail) ? new (0, $g25yo.default)(String(tail)) : tail;
        if (flags !== null && flags !== void 0 && flags.tail) flags._beforeTailState = this.state;
        for(let ci = 0; ci < str.length; ++ci){
            const d = this._appendChar(str[ci], flags, checkTail);
            if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
            details.aggregate(d);
        }
        if ((this.eager === true || this.eager === "append") && flags !== null && flags !== void 0 && flags.input && str) details.aggregate(this._appendEager());
        // append tail but aggregate only tailShift
        if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift;
        return details;
    }
    /** */ remove() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
        return new (0, $aDXuy.default)();
    }
    /** Calls function and reapplies current value */ withValueRefresh(fn) {
        if (this._refreshing || !this.isInitialized) return fn();
        this._refreshing = true;
        const rawInput = this.rawInputValue;
        const value = this.value;
        const ret = fn();
        this.rawInputValue = rawInput;
        // append lost trailing chars at end
        if (this.value && this.value !== value && value.indexOf(this.value) === 0) this.append(value.slice(this.value.length), {}, "");
        delete this._refreshing;
        return ret;
    }
    /** */ runIsolated(fn) {
        if (this._isolated || !this.isInitialized) return fn(this);
        this._isolated = true;
        const state = this.state;
        const ret = fn(this);
        this.state = state;
        delete this._isolated;
        return ret;
    }
    /** */ doSkipInvalid(ch) {
        return this.skipInvalid;
    }
    /**
    Prepares string before mask processing
    @protected
  */ doPrepare(str) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.prepare ? this.prepare(str, this, flags) : str;
    }
    /**
    Validates if value is acceptable
    @protected
  */ doValidate(flags) {
        return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /**
    Does additional processing in the end of editing
    @protected
  */ doCommit() {
        if (this.commit) this.commit(this.value, this);
    }
    /** */ doFormat(value) {
        return this.format ? this.format(value, this) : value;
    }
    /** */ doParse(str) {
        return this.parse ? this.parse(str, this) : str;
    }
    /** */ splice(start, deleteCount, inserted, removeDirection) {
        let flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            input: true
        };
        const tailPos = start + deleteCount;
        const tail = this.extractTail(tailPos);
        const eagerRemove = this.eager === true || this.eager === "remove";
        let oldRawValue;
        if (eagerRemove) {
            removeDirection = (0, $hXrfI.forceDirection)(removeDirection);
            oldRawValue = this.extractInput(0, tailPos, {
                raw: true
            });
        }
        let startChangePos = start;
        const details = new (0, $aDXuy.default)();
        // if it is just deletion without insertion
        if (removeDirection !== (0, $hXrfI.DIRECTION).NONE) {
            startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? (0, $hXrfI.DIRECTION).NONE : removeDirection);
            // adjust tailShift if start was aligned
            details.tailShift = startChangePos - start;
        }
        details.aggregate(this.remove(startChangePos));
        if (eagerRemove && removeDirection !== (0, $hXrfI.DIRECTION).NONE && oldRawValue === this.rawInputValue) {
            if (removeDirection === (0, $hXrfI.DIRECTION).FORCE_LEFT) {
                let valLength;
                while(oldRawValue === this.rawInputValue && (valLength = this.value.length))details.aggregate(new (0, $aDXuy.default)({
                    tailShift: -1
                })).aggregate(this.remove(valLength - 1));
            } else if (removeDirection === (0, $hXrfI.DIRECTION).FORCE_RIGHT) tail.unshift();
        }
        return details.aggregate(this.append(inserted, flags, tail));
    }
    maskEquals(mask) {
        return this.mask === mask;
    }
    typedValueEquals(value) {
        const tval = this.typedValue;
        return value === tval || $5a0406f4de738d3b$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $5a0406f4de738d3b$export$2e2bcd8739ae039.EMPTY_VALUES.includes(tval) || this.doFormat(value) === this.doFormat(this.typedValue);
    }
}
$5a0406f4de738d3b$export$2e2bcd8739ae039.DEFAULTS = {
    format: String,
    parse: (v)=>v,
    skipInvalid: true
};
$5a0406f4de738d3b$export$2e2bcd8739ae039.EMPTY_VALUES = [
    undefined,
    null,
    ""
];
(0, $3VPSz.default).Masked = $5a0406f4de738d3b$export$2e2bcd8739ae039;

});
parcelRegister("g25yo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bac1241c741a0bf7$export$2e2bcd8739ae039);
/** Provides details of continuous extracted tail */ class $bac1241c741a0bf7$export$2e2bcd8739ae039 {
    /** Tail value as string */ /** Tail start position */ /** Start position */ constructor(){
        let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let stop = arguments.length > 2 ? arguments[2] : undefined;
        this.value = value;
        this.from = from;
        this.stop = stop;
    }
    toString() {
        return this.value;
    }
    extend(tail) {
        this.value += String(tail);
    }
    appendTo(masked) {
        return masked.append(this.toString(), {
            tail: true
        }).aggregate(masked._appendPlaceholder());
    }
    get state() {
        return {
            value: this.value,
            from: this.from,
            stop: this.stop
        };
    }
    set state(state) {
        Object.assign(this, state);
    }
    unshift(beforePos) {
        if (!this.value.length || beforePos != null && this.from >= beforePos) return "";
        const shiftChar = this.value[0];
        this.value = this.value.slice(1);
        return shiftChar;
    }
    shift() {
        if (!this.value.length) return "";
        const shiftChar = this.value[this.value.length - 1];
        this.value = this.value.slice(0, -1);
        return shiftChar;
    }
}

});


parcelRegister("l46UZ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_INPUT_DEFINITIONS", () => $f55f5680b2874a32$export$a74729fcd56071c3);
$parcel$export(module.exports, "default", () => $f55f5680b2874a32$export$2e2bcd8739ae039);

var $5MZVQ = parcelRequire("5MZVQ");

var $f2ySt = parcelRequire("f2ySt");

var $aDXuy = parcelRequire("aDXuy");

var $hXrfI = parcelRequire("hXrfI");
parcelRequire("3VPSz");
const $f55f5680b2874a32$var$_excluded = [
    "parent",
    "isOptional",
    "placeholderChar",
    "displayChar",
    "lazy",
    "eager"
];
/** */ const $f55f5680b2874a32$export$a74729fcd56071c3 = {
    "0": /\d/,
    "a": /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    "*": /./
};
/** */ class $f55f5680b2874a32$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        const { parent: parent, isOptional: isOptional, placeholderChar: placeholderChar, displayChar: displayChar, lazy: lazy, eager: eager } = opts, maskOpts = (0, $5MZVQ._)(opts, $f55f5680b2874a32$var$_excluded);
        this.masked = (0, $f2ySt.default)(maskOpts);
        Object.assign(this, {
            parent: parent,
            isOptional: isOptional,
            placeholderChar: placeholderChar,
            displayChar: displayChar,
            lazy: lazy,
            eager: eager
        });
    }
    reset() {
        this.isFilled = false;
        this.masked.reset();
    }
    remove() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        if (fromPos === 0 && toPos >= 1) {
            this.isFilled = false;
            return this.masked.remove(fromPos, toPos);
        }
        return new (0, $aDXuy.default)();
    }
    get value() {
        return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
    }
    get unmaskedValue() {
        return this.masked.unmaskedValue;
    }
    get displayValue() {
        return this.masked.value && this.displayChar || this.value;
    }
    get isComplete() {
        return Boolean(this.masked.value) || this.isOptional;
    }
    _appendChar(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.isFilled) return new (0, $aDXuy.default)();
        const state = this.masked.state;
        // simulate input
        const details = this.masked._appendChar(ch, flags);
        if (details.inserted && this.doValidate(flags) === false) {
            details.inserted = details.rawInserted = "";
            this.masked.state = state;
        }
        if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
        details.skip = !details.inserted && !this.isOptional;
        this.isFilled = Boolean(details.inserted);
        return details;
    }
    append() {
        // TODO probably should be done via _appendChar
        return this.masked.append(...arguments);
    }
    _appendPlaceholder() {
        const details = new (0, $aDXuy.default)();
        if (this.isFilled || this.isOptional) return details;
        this.isFilled = true;
        details.inserted = this.placeholderChar;
        return details;
    }
    _appendEager() {
        return new (0, $aDXuy.default)();
    }
    extractTail() {
        return this.masked.extractTail(...arguments);
    }
    appendTail() {
        return this.masked.appendTail(...arguments);
    }
    extractInput() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        let flags = arguments.length > 2 ? arguments[2] : undefined;
        return this.masked.extractInput(fromPos, toPos, flags);
    }
    nearestInputPos(cursorPos) {
        let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $hXrfI.DIRECTION).NONE;
        const minPos = 0;
        const maxPos = this.value.length;
        const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
        switch(direction){
            case (0, $hXrfI.DIRECTION).LEFT:
            case (0, $hXrfI.DIRECTION).FORCE_LEFT:
                return this.isComplete ? boundPos : minPos;
            case (0, $hXrfI.DIRECTION).RIGHT:
            case (0, $hXrfI.DIRECTION).FORCE_RIGHT:
                return this.isComplete ? boundPos : maxPos;
            case (0, $hXrfI.DIRECTION).NONE:
            default:
                return boundPos;
        }
    }
    totalInputPositions() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return this.value.slice(fromPos, toPos).length;
    }
    doValidate() {
        return this.masked.doValidate(...arguments) && (!this.parent || this.parent.doValidate(...arguments));
    }
    doCommit() {
        this.masked.doCommit();
    }
    get state() {
        return {
            masked: this.masked.state,
            isFilled: this.isFilled
        };
    }
    set state(state) {
        this.masked.state = state.masked;
        this.isFilled = state.isFilled;
    }
}

});
parcelRegister("f2ySt", function(module, exports) {

$parcel$export(module.exports, "maskedClass", () => $af3218e7c348568d$export$81ad4b1539a22420);
$parcel$export(module.exports, "default", () => $af3218e7c348568d$export$2e2bcd8739ae039);

var $hXrfI = parcelRequire("hXrfI");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("aDXuy");
/** Get Masked class by mask type */ function $af3218e7c348568d$export$81ad4b1539a22420(mask) {
    if (mask == null) throw new Error("mask property should be defined");
    // $FlowFixMe
    if (mask instanceof RegExp) return (0, $3VPSz.default).MaskedRegExp;
    // $FlowFixMe
    if ((0, $hXrfI.isString)(mask)) return (0, $3VPSz.default).MaskedPattern;
    // $FlowFixMe
    if (mask instanceof Date || mask === Date) return (0, $3VPSz.default).MaskedDate;
    // $FlowFixMe
    if (mask instanceof Number || typeof mask === "number" || mask === Number) return (0, $3VPSz.default).MaskedNumber;
    // $FlowFixMe
    if (Array.isArray(mask) || mask === Array) return (0, $3VPSz.default).MaskedDynamic;
    // $FlowFixMe
    if ((0, $3VPSz.default).Masked && mask.prototype instanceof (0, $3VPSz.default).Masked) return mask;
    // $FlowFixMe
    if (mask instanceof (0, $3VPSz.default).Masked) return mask.constructor;
    // $FlowFixMe
    if (mask instanceof Function) return (0, $3VPSz.default).MaskedFunction;
    console.warn("Mask not found for mask", mask); // eslint-disable-line no-console
    // $FlowFixMe
    return (0, $3VPSz.default).Masked;
}
/** Creates new {@link Masked} depending on mask type */ function $af3218e7c348568d$export$2e2bcd8739ae039(opts) {
    // $FlowFixMe
    if ((0, $3VPSz.default).Masked && opts instanceof (0, $3VPSz.default).Masked) return opts;
    opts = Object.assign({}, opts);
    const mask = opts.mask;
    // $FlowFixMe
    if ((0, $3VPSz.default).Masked && mask instanceof (0, $3VPSz.default).Masked) return mask;
    const MaskedClass = $af3218e7c348568d$export$81ad4b1539a22420(mask);
    if (!MaskedClass) throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
    return new MaskedClass(opts);
}
(0, $3VPSz.default).createMask = $af3218e7c348568d$export$2e2bcd8739ae039;

});


parcelRegister("cuHCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $918a1ef60905b7c2$export$2e2bcd8739ae039);

var $aDXuy = parcelRequire("aDXuy");

var $hXrfI = parcelRequire("hXrfI");

var $g25yo = parcelRequire("g25yo");
parcelRequire("3VPSz");
/** */ class $918a1ef60905b7c2$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        Object.assign(this, opts);
        this._value = "";
        this.isFixed = true;
    }
    get value() {
        return this._value;
    }
    get unmaskedValue() {
        return this.isUnmasking ? this.value : "";
    }
    get displayValue() {
        return this.value;
    }
    reset() {
        this._isRawInput = false;
        this._value = "";
    }
    remove() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
        this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
        if (!this._value) this._isRawInput = false;
        return new (0, $aDXuy.default)();
    }
    nearestInputPos(cursorPos) {
        let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $hXrfI.DIRECTION).NONE;
        const minPos = 0;
        const maxPos = this._value.length;
        switch(direction){
            case (0, $hXrfI.DIRECTION).LEFT:
            case (0, $hXrfI.DIRECTION).FORCE_LEFT:
                return minPos;
            case (0, $hXrfI.DIRECTION).NONE:
            case (0, $hXrfI.DIRECTION).RIGHT:
            case (0, $hXrfI.DIRECTION).FORCE_RIGHT:
            default:
                return maxPos;
        }
    }
    totalInputPositions() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
        return this._isRawInput ? toPos - fromPos : 0;
    }
    extractInput() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
        let flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return Boolean(this._value);
    }
    _appendChar(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const details = new (0, $aDXuy.default)();
        if (this.isFilled) return details;
        const appendEager = this.eager === true || this.eager === "append";
        const appended = this.char === ch;
        const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
        if (isResolved) details.rawInserted = this.char;
        this._value = details.inserted = this.char;
        this._isRawInput = isResolved && (flags.raw || flags.input);
        return details;
    }
    _appendEager() {
        return this._appendChar(this.char, {
            tail: true
        });
    }
    _appendPlaceholder() {
        const details = new (0, $aDXuy.default)();
        if (this.isFilled) return details;
        this._value = details.inserted = this.char;
        return details;
    }
    extractTail() {
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return new (0, $g25yo.default)("");
    }
    // $FlowFixMe no ideas
    appendTail(tail) {
        if ((0, $hXrfI.isString)(tail)) tail = new (0, $g25yo.default)(String(tail));
        return tail.appendTo(this);
    }
    append(str, flags, tail) {
        const details = this._appendChar(str[0], flags);
        if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
        return details;
    }
    doCommit() {}
    get state() {
        return {
            _value: this._value,
            _isRawInput: this._isRawInput
        };
    }
    set state(state) {
        Object.assign(this, state);
    }
}

});

parcelRegister("9QcM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $72a2e1084caa4ef2$export$2e2bcd8739ae039);

var $5MZVQ = parcelRequire("5MZVQ");

var $aDXuy = parcelRequire("aDXuy");

var $hXrfI = parcelRequire("hXrfI");

var $g25yo = parcelRequire("g25yo");

var $3VPSz = parcelRequire("3VPSz");
const $72a2e1084caa4ef2$var$_excluded = [
    "chunks"
];
class $72a2e1084caa4ef2$export$2e2bcd8739ae039 {
    /** */ constructor(){
        let chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.chunks = chunks;
        this.from = from;
    }
    toString() {
        return this.chunks.map(String).join("");
    }
    // $FlowFixMe no ideas
    extend(tailChunk) {
        if (!String(tailChunk)) return;
        if ((0, $hXrfI.isString)(tailChunk)) tailChunk = new (0, $g25yo.default)(String(tailChunk));
        const lastChunk = this.chunks[this.chunks.length - 1];
        const extendLast = lastChunk && // if stops are same or tail has no stop
        (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
        tailChunk.from === lastChunk.from + lastChunk.toString().length;
        if (tailChunk instanceof (0, $g25yo.default)) {
            // check the ability to extend previous chunk
            if (extendLast) // extend previous chunk
            lastChunk.extend(tailChunk.toString());
            else // append new chunk
            this.chunks.push(tailChunk);
        } else if (tailChunk instanceof $72a2e1084caa4ef2$export$2e2bcd8739ae039) {
            if (tailChunk.stop == null) {
                // unwrap floating chunks to parent, keeping `from` pos
                let firstTailChunk;
                while(tailChunk.chunks.length && tailChunk.chunks[0].stop == null){
                    firstTailChunk = tailChunk.chunks.shift();
                    firstTailChunk.from += tailChunk.from;
                    this.extend(firstTailChunk);
                }
            }
            // if tail chunk still has value
            if (tailChunk.toString()) {
                // if chunks contains stops, then popup stop to container
                tailChunk.stop = tailChunk.blockIndex;
                this.chunks.push(tailChunk);
            }
        }
    }
    appendTo(masked) {
        // $FlowFixMe
        if (!(masked instanceof (0, $3VPSz.default).MaskedPattern)) {
            const tail = new (0, $g25yo.default)(this.toString());
            return tail.appendTo(masked);
        }
        const details = new (0, $aDXuy.default)();
        for(let ci = 0; ci < this.chunks.length && !details.skip; ++ci){
            const chunk = this.chunks[ci];
            const lastBlockIter = masked._mapPosToBlock(masked.value.length);
            const stop = chunk.stop;
            let chunkBlock;
            if (stop != null && // if block not found or stop is behind lastBlock
            (!lastBlockIter || lastBlockIter.index <= stop)) {
                if (chunk instanceof $72a2e1084caa4ef2$export$2e2bcd8739ae039 || // for continuous block also check if stop is exist
                masked._stops.indexOf(stop) >= 0) {
                    const phDetails = masked._appendPlaceholder(stop);
                    details.aggregate(phDetails);
                }
                chunkBlock = chunk instanceof $72a2e1084caa4ef2$export$2e2bcd8739ae039 && masked._blocks[stop];
            }
            if (chunkBlock) {
                const tailDetails = chunkBlock.appendTail(chunk);
                tailDetails.skip = false; // always ignore skip, it will be set on last
                details.aggregate(tailDetails);
                masked._value += tailDetails.inserted;
                // get not inserted chars
                const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                if (remainChars) details.aggregate(masked.append(remainChars, {
                    tail: true
                }));
            } else details.aggregate(masked.append(chunk.toString(), {
                tail: true
            }));
        }
        return details;
    }
    get state() {
        return {
            chunks: this.chunks.map((c)=>c.state),
            from: this.from,
            stop: this.stop,
            blockIndex: this.blockIndex
        };
    }
    set state(state) {
        const { chunks: chunks } = state, props = (0, $5MZVQ._)(state, $72a2e1084caa4ef2$var$_excluded);
        Object.assign(this, props);
        this.chunks = chunks.map((cstate)=>{
            const chunk = "chunks" in cstate ? new $72a2e1084caa4ef2$export$2e2bcd8739ae039() : new (0, $g25yo.default)();
            // $FlowFixMe already checked above
            chunk.state = cstate;
            return chunk;
        });
    }
    unshift(beforePos) {
        if (!this.chunks.length || beforePos != null && this.from >= beforePos) return "";
        const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
        let ci = 0;
        while(ci < this.chunks.length){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.unshift(chunkShiftPos);
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                ++ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return "";
    }
    shift() {
        if (!this.chunks.length) return "";
        let ci = this.chunks.length - 1;
        while(0 <= ci){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.shift();
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                --ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return "";
    }
}

});

parcelRegister("eumni", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c5392d3c40637d$export$2e2bcd8739ae039);

var $hXrfI = parcelRequire("hXrfI");
parcelRequire("aDXuy");
parcelRequire("3VPSz");
class $a8c5392d3c40637d$export$2e2bcd8739ae039 {
    constructor(masked, pos){
        this.masked = masked;
        this._log = [];
        const { offset: offset, index: index } = masked._mapPosToBlock(pos) || (pos < 0 ? // first
        {
            index: 0,
            offset: 0
        } : // last
        {
            index: this.masked._blocks.length,
            offset: 0
        });
        this.offset = offset;
        this.index = index;
        this.ok = false;
    }
    get block() {
        return this.masked._blocks[this.index];
    }
    get pos() {
        return this.masked._blockStartPos(this.index) + this.offset;
    }
    get state() {
        return {
            index: this.index,
            offset: this.offset,
            ok: this.ok
        };
    }
    set state(s) {
        Object.assign(this, s);
    }
    pushState() {
        this._log.push(this.state);
    }
    popState() {
        const s = this._log.pop();
        this.state = s;
        return s;
    }
    bindBlock() {
        if (this.block) return;
        if (this.index < 0) {
            this.index = 0;
            this.offset = 0;
        }
        if (this.index >= this.masked._blocks.length) {
            this.index = this.masked._blocks.length - 1;
            this.offset = this.block.value.length;
        }
    }
    _pushLeft(fn) {
        this.pushState();
        for(this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) === null || _this$block === void 0 ? void 0 : _this$block.value.length) || 0){
            var _this$block;
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    _pushRight(fn) {
        this.pushState();
        for(this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0){
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    pushLeftBeforeFilled() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $hXrfI.DIRECTION).FORCE_LEFT);
            if (this.offset !== 0) return true;
        });
    }
    pushLeftBeforeInput() {
        // cases:
        // filled input: 00|
        // optional empty input: 00[]|
        // nested block: XX<[]>|
        return this._pushLeft(()=>{
            if (this.block.isFixed) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $hXrfI.DIRECTION).LEFT);
            return true;
        });
    }
    pushLeftBeforeRequired() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $hXrfI.DIRECTION).LEFT);
            return true;
        });
    }
    pushRightBeforeFilled() {
        return this._pushRight(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $hXrfI.DIRECTION).FORCE_RIGHT);
            if (this.offset !== this.block.value.length) return true;
        });
    }
    pushRightBeforeInput() {
        return this._pushRight(()=>{
            if (this.block.isFixed) return;
            // const o = this.offset;
            this.offset = this.block.nearestInputPos(this.offset, (0, $hXrfI.DIRECTION).NONE);
            // HACK cases like (STILL DOES NOT WORK FOR NESTED)
            // aa|X
            // aa<X|[]>X_    - this will not work
            // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
            return true;
        });
    }
    pushRightBeforeRequired() {
        return this._pushRight(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            // TODO check |[*]XX_
            this.offset = this.block.nearestInputPos(this.offset, (0, $hXrfI.DIRECTION).NONE);
            return true;
        });
    }
}

});

parcelRegister("aFZLp", function(module, exports) {

var $7J9oQ = parcelRequire("7J9oQ");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("aDXuy");
parcelRequire("g25yo");
parcelRequire("hXrfI");
/** Masking by RegExp */ class $7c5da4afb6287e36$export$2e2bcd8739ae039 extends (0, $7J9oQ.default) {
    /**
    @override
    @param {Object} opts
  */ _update(opts) {
        if (opts.mask) opts.validate = (value)=>value.search(opts.mask) >= 0;
        super._update(opts);
    }
}
(0, $3VPSz.default).MaskedRegExp = $7c5da4afb6287e36$export$2e2bcd8739ae039;

});


parcelRegister("4yFuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $351a86465d6b70fb$export$2e2bcd8739ae039);

var $8hM9o = parcelRequire("8hM9o");
parcelRequire("aDXuy");

var $hXrfI = parcelRequire("hXrfI");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("5MZVQ");
parcelRequire("7J9oQ");
parcelRequire("g25yo");
parcelRequire("l46UZ");
parcelRequire("f2ySt");
parcelRequire("cuHCm");
parcelRequire("9QcM3");
parcelRequire("eumni");
parcelRequire("aFZLp");
/** Pattern which accepts ranges */ class $351a86465d6b70fb$export$2e2bcd8739ae039 extends (0, $8hM9o.default) {
    /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */ /** Min bound */ /** Max bound */ /** */ get _matchFrom() {
        return this.maxLength - String(this.from).length;
    }
    /**
    @override
  */ _update(opts) {
        // TODO type
        opts = Object.assign({
            to: this.to || 0,
            from: this.from || 0,
            maxLength: this.maxLength || 0
        }, opts);
        let maxLength = String(opts.to).length;
        if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
        opts.maxLength = maxLength;
        const fromStr = String(opts.from).padStart(maxLength, "0");
        const toStr = String(opts.to).padStart(maxLength, "0");
        let sameCharsCount = 0;
        while(sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])++sameCharsCount;
        opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(maxLength - sameCharsCount);
        super._update(opts);
    }
    /**
    @override
  */ get isComplete() {
        return super.isComplete && Boolean(this.value);
    }
    boundaries(str) {
        let minstr = "";
        let maxstr = "";
        const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
        if (num) {
            minstr = "0".repeat(placeholder.length) + num;
            maxstr = "9".repeat(placeholder.length) + num;
        }
        minstr = minstr.padEnd(this.maxLength, "0");
        maxstr = maxstr.padEnd(this.maxLength, "9");
        return [
            minstr,
            maxstr
        ];
    }
    // TODO str is a single char everytime
    /**
    @override
  */ doPrepare(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let details;
        [ch, details] = (0, $hXrfI.normalizePrepare)(super.doPrepare(ch.replace(/\D/g, ""), flags));
        if (!this.autofix || !ch) return ch;
        const fromStr = String(this.from).padStart(this.maxLength, "0");
        const toStr = String(this.to).padStart(this.maxLength, "0");
        let nextVal = this.value + ch;
        if (nextVal.length > this.maxLength) return "";
        const [minstr, maxstr] = this.boundaries(nextVal);
        if (Number(maxstr) < this.from) return fromStr[nextVal.length - 1];
        if (Number(minstr) > this.to) {
            if (this.autofix === "pad" && nextVal.length < this.maxLength) return [
                "",
                details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))
            ];
            return toStr[nextVal.length - 1];
        }
        return ch;
    }
    /**
    @override
  */ doValidate() {
        const str = this.value;
        const firstNonZero = str.search(/[^0]/);
        if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
        const [minstr, maxstr] = this.boundaries(str);
        return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(...arguments);
    }
}
(0, $3VPSz.default).MaskedRange = $351a86465d6b70fb$export$2e2bcd8739ae039;

});


parcelRegister("isiCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f949c60c039fb7$export$2e2bcd8739ae039);

var $3VPSz = parcelRequire("3VPSz");
/**
  Generic element API to use with mask
  @interface
*/ class $d6f949c60c039fb7$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** Safely returns selection start */ get selectionStart() {
        let start;
        try {
            start = this._unsafeSelectionStart;
        } catch (e) {}
        return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */ get selectionEnd() {
        let end;
        try {
            end = this._unsafeSelectionEnd;
        } catch (e) {}
        return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */ select(start, end) {
        if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
        try {
            this._unsafeSelect(start, end);
        } catch (e) {}
    }
    /** Should be overriden in subclasses */ _unsafeSelect(start, end) {}
    /** Should be overriden in subclasses */ get isActive() {
        return false;
    }
    /** Should be overriden in subclasses */ bindEvents(handlers) {}
    /** Should be overriden in subclasses */ unbindEvents() {}
}
(0, $3VPSz.default).MaskElement = $d6f949c60c039fb7$export$2e2bcd8739ae039;

});

parcelRegister("daQKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $997521ef281b5684$export$2e2bcd8739ae039);

var $isiCJ = parcelRequire("isiCJ");

var $3VPSz = parcelRequire("3VPSz");
/** Bridge between HTMLElement and {@link Masked} */ class $997521ef281b5684$export$2e2bcd8739ae039 extends (0, $isiCJ.default) {
    /** Mapping between HTMLElement events and mask internal events */ /** HTMLElement to use mask on */ /**
    @param {HTMLInputElement|HTMLTextAreaElement} input
  */ constructor(input){
        super();
        this.input = input;
        this._handlers = {};
    }
    /** */ // $FlowFixMe https://github.com/facebook/flow/issues/2839
    get rootElement() {
        var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
        return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) === null || _this$input$getRootNo2 === void 0 ? void 0 : _this$input$getRootNo2.call(_this$input)) !== null && _this$input$getRootNo !== void 0 ? _this$input$getRootNo : document;
    }
    /**
    Is element in focus
    @readonly
  */ get isActive() {
        //$FlowFixMe
        return this.input === this.rootElement.activeElement;
    }
    /**
    Returns HTMLElement selection start
    @override
  */ get _unsafeSelectionStart() {
        return this.input.selectionStart;
    }
    /**
    Returns HTMLElement selection end
    @override
  */ get _unsafeSelectionEnd() {
        return this.input.selectionEnd;
    }
    /**
    Sets HTMLElement selection
    @override
  */ _unsafeSelect(start, end) {
        this.input.setSelectionRange(start, end);
    }
    /**
    HTMLElement value
    @override
  */ get value() {
        return this.input.value;
    }
    set value(value) {
        this.input.value = value;
    }
    /**
    Binds HTMLElement events to mask internal events
    @override
  */ bindEvents(handlers) {
        Object.keys(handlers).forEach((event)=>this._toggleEventHandler($997521ef281b5684$export$2e2bcd8739ae039.EVENTS_MAP[event], handlers[event]));
    }
    /**
    Unbinds HTMLElement events to mask internal events
    @override
  */ unbindEvents() {
        Object.keys(this._handlers).forEach((event)=>this._toggleEventHandler(event));
    }
    /** */ _toggleEventHandler(event, handler) {
        if (this._handlers[event]) {
            this.input.removeEventListener(event, this._handlers[event]);
            delete this._handlers[event];
        }
        if (handler) {
            this.input.addEventListener(event, handler);
            this._handlers[event] = handler;
        }
    }
}
$997521ef281b5684$export$2e2bcd8739ae039.EVENTS_MAP = {
    selectionChange: "keydown",
    input: "input",
    drop: "drop",
    click: "click",
    focus: "focus",
    commit: "blur"
};
(0, $3VPSz.default).HTMLMaskElement = $997521ef281b5684$export$2e2bcd8739ae039;

});

parcelRegister("iV2Eh", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc5f9ad1606cdfd7$export$2e2bcd8739ae039);

var $daQKZ = parcelRequire("daQKZ");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("isiCJ");
class $dc5f9ad1606cdfd7$export$2e2bcd8739ae039 extends (0, $daQKZ.default) {
    /**
    Returns HTMLElement selection start
    @override
  */ get _unsafeSelectionStart() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
        return focusOffset;
    }
    /**
    Returns HTMLElement selection end
    @override
  */ get _unsafeSelectionEnd() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
        return focusOffset;
    }
    /**
    Sets HTMLElement selection
    @override
  */ _unsafeSelect(start, end) {
        if (!this.rootElement.createRange) return;
        const range = this.rootElement.createRange();
        range.setStart(this.input.firstChild || this.input, start);
        range.setEnd(this.input.lastChild || this.input, end);
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    /**
    HTMLElement value
    @override
  */ get value() {
        // $FlowFixMe
        return this.input.textContent;
    }
    set value(value) {
        this.input.textContent = value;
    }
}
(0, $3VPSz.default).HTMLContenteditableMaskElement = $dc5f9ad1606cdfd7$export$2e2bcd8739ae039;

});


parcelRegister("l6DRi", function(module, exports) {

var $8hM9o = parcelRequire("8hM9o");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("5MZVQ");
parcelRequire("hXrfI");
parcelRequire("aDXuy");
parcelRequire("7J9oQ");
parcelRequire("g25yo");
parcelRequire("l46UZ");
parcelRequire("f2ySt");
parcelRequire("cuHCm");
parcelRequire("9QcM3");
parcelRequire("eumni");
parcelRequire("aFZLp");
/** Pattern which validates enum values */ class $f5d9139d68bef78d$export$2e2bcd8739ae039 extends (0, $8hM9o.default) {
    /**
    @override
    @param {Object} opts
  */ _update(opts) {
        // TODO type
        if (opts.enum) opts.mask = "*".repeat(opts.enum[0].length);
        super._update(opts);
    }
    /**
    @override
  */ doValidate() {
        return this.enum.some((e)=>e.indexOf(this.unmaskedValue) >= 0) && super.doValidate(...arguments);
    }
}
(0, $3VPSz.default).MaskedEnum = $f5d9139d68bef78d$export$2e2bcd8739ae039;

});

parcelRegister("62XRX", function(module, exports) {

var $hXrfI = parcelRequire("hXrfI");

var $aDXuy = parcelRequire("aDXuy");

var $7J9oQ = parcelRequire("7J9oQ");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("g25yo");
/**
  Number mask
  @param {Object} opts
  @param {string} opts.radix - Single char
  @param {string} opts.thousandsSeparator - Single char
  @param {Array<string>} opts.mapToRadix - Array of single chars
  @param {number} opts.min
  @param {number} opts.max
  @param {number} opts.scale - Digits after point
  @param {boolean} opts.signed - Allow negative
  @param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
  @param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
*/ class $46715ecb90c66053$export$2e2bcd8739ae039 extends (0, $7J9oQ.default) {
    /** Single char */ /** Single char */ /** Array of single chars */ /** */ /** */ /** Digits after point */ /** */ /** Flag to remove leading and trailing zeros in the end of editing */ /** Flag to pad trailing zeros after point in the end of editing */ constructor(opts){
        super(Object.assign({}, $46715ecb90c66053$export$2e2bcd8739ae039.DEFAULTS, opts));
    }
    /**
    @override
  */ _update(opts) {
        super._update(opts);
        this._updateRegExps();
    }
    /** */ _updateRegExps() {
        let start = "^" + (this.allowNegative ? "[+|\\-]?" : "");
        let mid = "\\d*";
        let end = (this.scale ? "(".concat((0, $hXrfI.escapeRegExp)(this.radix), "\\d{0,").concat(this.scale, "})?") : "") + "$";
        this._numberRegExp = new RegExp(start + mid + end);
        this._mapToRadixRegExp = new RegExp("[".concat(this.mapToRadix.map((0, $hXrfI.escapeRegExp)).join(""), "]"), "g");
        this._thousandsSeparatorRegExp = new RegExp((0, $hXrfI.escapeRegExp)(this.thousandsSeparator), "g");
    }
    /** */ _removeThousandsSeparators(value) {
        return value.replace(this._thousandsSeparatorRegExp, "");
    }
    /** */ _insertThousandsSeparators(value) {
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        const parts = value.split(this.radix);
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
        return parts.join(this.radix);
    }
    /**
    @override
  */ doPrepare(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        ch = this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */ (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch);
        const [prepCh, details] = (0, $hXrfI.normalizePrepare)(super.doPrepare(ch, flags));
        if (ch && !prepCh) details.skip = true;
        return [
            prepCh,
            details
        ];
    }
    /** */ _separatorsCount(to) {
        let extendOnSeparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let count = 0;
        for(let pos = 0; pos < to; ++pos)if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
            ++count;
            if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
        return count;
    }
    /** */ _separatorsCountFromSlice() {
        let slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._value;
        return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    /**
    @override
  */ extractInput() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        let flags = arguments.length > 2 ? arguments[2] : undefined;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
    }
    /**
    @override
  */ _appendCharRaw(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.thousandsSeparator) return super._appendCharRaw(ch, flags);
        const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
        this._value = this._removeThousandsSeparators(this.value);
        const appendDetails = super._appendCharRaw(ch, flags);
        this._value = this._insertThousandsSeparators(this._value);
        const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
        appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
        appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
        return appendDetails;
    }
    /** */ _findSeparatorAround(pos) {
        if (this.thousandsSeparator) {
            const searchFrom = pos - this.thousandsSeparator.length + 1;
            const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
            if (separatorPos <= pos) return separatorPos;
        }
        return -1;
    }
    _adjustRangeWithSeparators(from, to) {
        const separatorAroundFromPos = this._findSeparatorAround(from);
        if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
        const separatorAroundToPos = this._findSeparatorAround(to);
        if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
        return [
            from,
            to
        ];
    }
    /**
    @override
  */ remove() {
        let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        const valueBeforePos = this.value.slice(0, fromPos);
        const valueAfterPos = this.value.slice(toPos);
        const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
        this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
        return new (0, $aDXuy.default)({
            tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
        });
    }
    /**
    @override
  */ nearestInputPos(cursorPos, direction) {
        if (!this.thousandsSeparator) return cursorPos;
        switch(direction){
            case (0, $hXrfI.DIRECTION).NONE:
            case (0, $hXrfI.DIRECTION).LEFT:
            case (0, $hXrfI.DIRECTION).FORCE_LEFT:
                {
                    const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
                    if (separatorAtLeftPos >= 0) {
                        const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
                        if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === (0, $hXrfI.DIRECTION).FORCE_LEFT) return separatorAtLeftPos;
                    }
                    break;
                }
            case (0, $hXrfI.DIRECTION).RIGHT:
            case (0, $hXrfI.DIRECTION).FORCE_RIGHT:
                {
                    const separatorAtRightPos = this._findSeparatorAround(cursorPos);
                    if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
                }
        }
        return cursorPos;
    }
    /**
    @override
  */ doValidate(flags) {
        // validate as string
        let valid = Boolean(this._removeThousandsSeparators(this.value).match(this._numberRegExp));
        if (valid) {
            // validate as number
            const number = this.number;
            valid = valid && !isNaN(number) && // check min bound for negative values
            (this.min == null || this.min >= 0 || this.min <= this.number) && // check max bound for positive values
            (this.max == null || this.max <= 0 || this.number <= this.max);
        }
        return valid && super.doValidate(flags);
    }
    /**
    @override
  */ doCommit() {
        if (this.value) {
            const number = this.number;
            let validnum = number;
            // check bounds
            if (this.min != null) validnum = Math.max(validnum, this.min);
            if (this.max != null) validnum = Math.min(validnum, this.max);
            if (validnum !== number) this.unmaskedValue = this.doFormat(validnum);
            let formatted = this.value;
            if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
            if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
            this._value = formatted;
        }
        super.doCommit();
    }
    /** */ _normalizeZeros(value) {
        const parts = this._removeThousandsSeparators(value).split(this.radix);
        // remove leading zeros
        parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num)=>sign + num);
        // add leading zero
        if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + "0";
        if (parts.length > 1) {
            parts[1] = parts[1].replace(/0*$/, ""); // remove trailing zeros
            if (!parts[1].length) parts.length = 1; // remove fractional
        }
        return this._insertThousandsSeparators(parts.join(this.radix));
    }
    /** */ _padFractionalZeros(value) {
        if (!value) return value;
        const parts = value.split(this.radix);
        if (parts.length < 2) parts.push("");
        parts[1] = parts[1].padEnd(this.scale, "0");
        return parts.join(this.radix);
    }
    /** */ doSkipInvalid(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let checkTail = arguments.length > 2 ? arguments[2] : undefined;
        const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === $46715ecb90c66053$export$2e2bcd8739ae039.UNMASKED_RADIX || this.mapToRadix.includes(ch));
        return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
    }
    /**
    @override
  */ get unmaskedValue() {
        return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, $46715ecb90c66053$export$2e2bcd8739ae039.UNMASKED_RADIX);
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    /**
    @override
  */ get typedValue() {
        return this.doParse(this.unmaskedValue);
    }
    set typedValue(n) {
        this.rawInputValue = this.doFormat(n).replace($46715ecb90c66053$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
    }
    /** Parsed Number */ get number() {
        return this.typedValue;
    }
    set number(number) {
        this.typedValue = number;
    }
    /**
    Is negative allowed
    @readonly
  */ get allowNegative() {
        return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    /**
    @override
  */ typedValueEquals(value) {
        // handle  0 -> '' case (typed = 0 even if value = '')
        // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
        return (super.typedValueEquals(value) || $46715ecb90c66053$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $46715ecb90c66053$export$2e2bcd8739ae039.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === "");
    }
}
$46715ecb90c66053$export$2e2bcd8739ae039.UNMASKED_RADIX = ".";
$46715ecb90c66053$export$2e2bcd8739ae039.DEFAULTS = {
    radix: ",",
    thousandsSeparator: "",
    mapToRadix: [
        $46715ecb90c66053$export$2e2bcd8739ae039.UNMASKED_RADIX
    ],
    scale: 2,
    signed: false,
    normalizeZeros: true,
    padFractionalZeros: false,
    parse: Number,
    format: (n)=>n.toLocaleString("en-US", {
            useGrouping: false,
            maximumFractionDigits: 20
        })
};
$46715ecb90c66053$export$2e2bcd8739ae039.EMPTY_VALUES = [
    ...(0, $7J9oQ.default).EMPTY_VALUES,
    0
];
(0, $3VPSz.default).MaskedNumber = $46715ecb90c66053$export$2e2bcd8739ae039;

});

parcelRegister("70ryG", function(module, exports) {

var $7J9oQ = parcelRequire("7J9oQ");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("aDXuy");
parcelRequire("g25yo");
parcelRequire("hXrfI");
/** Masking by custom Function */ class $519de906a824b347$export$2e2bcd8739ae039 extends (0, $7J9oQ.default) {
    /**
    @override
    @param {Object} opts
  */ _update(opts) {
        if (opts.mask) opts.validate = opts.mask;
        super._update(opts);
    }
}
(0, $3VPSz.default).MaskedFunction = $519de906a824b347$export$2e2bcd8739ae039;

});

parcelRegister("2MfHr", function(module, exports) {

var $5MZVQ = parcelRequire("5MZVQ");

var $hXrfI = parcelRequire("hXrfI");

var $aDXuy = parcelRequire("aDXuy");

var $f2ySt = parcelRequire("f2ySt");

var $7J9oQ = parcelRequire("7J9oQ");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("g25yo");
const $205c3e193edd605c$var$_excluded = [
    "compiledMasks",
    "currentMaskRef",
    "currentMask"
], $205c3e193edd605c$var$_excluded2 = [
    "mask"
];
/** Dynamic mask for choosing apropriate mask in run-time */ class $205c3e193edd605c$export$2e2bcd8739ae039 extends (0, $7J9oQ.default) {
    /** Currently chosen mask */ /** Compliled {@link Masked} options */ /** Chooses {@link Masked} depending on input value */ /**
    @param {Object} opts
  */ constructor(opts){
        super(Object.assign({}, $205c3e193edd605c$export$2e2bcd8739ae039.DEFAULTS, opts));
        this.currentMask = null;
    }
    /**
    @override
  */ _update(opts) {
        super._update(opts);
        if ("mask" in opts) // mask could be totally dynamic with only `dispatch` option
        this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m)=>(0, $f2ySt.default)(m)) : [];
    }
    /**
    @override
  */ _appendCharRaw(ch) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const details = this._applyDispatch(ch, flags);
        if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
        return details;
    }
    _applyDispatch() {
        let appended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let tail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
        const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
        const inputValue = this.rawInputValue;
        const insertValue = flags.tail && flags._beforeTailState != null ? // $FlowFixMe - tired to fight with type system
        flags._beforeTailState._rawInputValue : inputValue;
        const tailValue = inputValue.slice(insertValue.length);
        const prevMask = this.currentMask;
        const details = new (0, $aDXuy.default)();
        const prevMaskState = prevMask === null || prevMask === void 0 ? void 0 : prevMask.state;
        // clone flags to prevent overwriting `_beforeTailState`
        this.currentMask = this.doDispatch(appended, Object.assign({}, flags), tail);
        // restore state after dispatch
        if (this.currentMask) {
            if (this.currentMask !== prevMask) {
                // if mask changed reapply input
                this.currentMask.reset();
                if (insertValue) {
                    // $FlowFixMe - it's ok, we don't change current mask above
                    const d = this.currentMask.append(insertValue, {
                        raw: true
                    });
                    details.tailShift = d.inserted.length - prevValueBeforeTail.length;
                }
                if (tailValue) // $FlowFixMe - it's ok, we don't change current mask above
                details.tailShift += this.currentMask.append(tailValue, {
                    raw: true,
                    tail: true
                }).tailShift;
            } else // Dispatch can do something bad with state, so
            // restore prev mask state
            this.currentMask.state = prevMaskState;
        }
        return details;
    }
    _appendPlaceholder() {
        const details = this._applyDispatch(...arguments);
        if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
        return details;
    }
    /**
   @override
  */ _appendEager() {
        const details = this._applyDispatch(...arguments);
        if (this.currentMask) details.aggregate(this.currentMask._appendEager());
        return details;
    }
    appendTail(tail) {
        const details = new (0, $aDXuy.default)();
        if (tail) details.aggregate(this._applyDispatch("", {}, tail));
        return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta, _flags$_beforeTailSta2;
        return Object.assign({}, flags, {
            _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
        });
    }
    /**
    @override
  */ doDispatch(appended) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let tail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
        return this.dispatch(appended, this, flags, tail);
    }
    /**
    @override
  */ doValidate(flags) {
        return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    /**
    @override
  */ doPrepare(str) {
        let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let [s, details] = (0, $hXrfI.normalizePrepare)(super.doPrepare(str, flags));
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = (0, $hXrfI.normalizePrepare)(super.doPrepare(s, this.currentMaskFlags(flags)));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    /**
    @override
  */ reset() {
        var _this$currentMask;
        (_this$currentMask = this.currentMask) === null || _this$currentMask === void 0 || _this$currentMask.reset();
        this.compiledMasks.forEach((m)=>m.reset());
    }
    /**
    @override
  */ get value() {
        return this.currentMask ? this.currentMask.value : "";
    }
    set value(value) {
        super.value = value;
    }
    /**
    @override
  */ get unmaskedValue() {
        return this.currentMask ? this.currentMask.unmaskedValue : "";
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    /**
    @override
  */ get typedValue() {
        return this.currentMask ? this.currentMask.typedValue : "";
    }
    // probably typedValue should not be used with dynamic
    set typedValue(value) {
        let unmaskedValue = String(value);
        // double check it
        if (this.currentMask) {
            this.currentMask.typedValue = value;
            unmaskedValue = this.currentMask.unmaskedValue;
        }
        this.unmaskedValue = unmaskedValue;
    }
    get displayValue() {
        return this.currentMask ? this.currentMask.displayValue : "";
    }
    /**
    @override
  */ get isComplete() {
        var _this$currentMask2;
        return Boolean((_this$currentMask2 = this.currentMask) === null || _this$currentMask2 === void 0 ? void 0 : _this$currentMask2.isComplete);
    }
    /**
    @override
  */ get isFilled() {
        var _this$currentMask3;
        return Boolean((_this$currentMask3 = this.currentMask) === null || _this$currentMask3 === void 0 ? void 0 : _this$currentMask3.isFilled);
    }
    /**
    @override
  */ remove() {
        const details = new (0, $aDXuy.default)();
        if (this.currentMask) details.aggregate(this.currentMask.remove(...arguments))// update with dispatch
        .aggregate(this._applyDispatch());
        return details;
    }
    /**
    @override
  */ get state() {
        var _this$currentMask4;
        return Object.assign({}, super.state, {
            _rawInputValue: this.rawInputValue,
            compiledMasks: this.compiledMasks.map((m)=>m.state),
            currentMaskRef: this.currentMask,
            currentMask: (_this$currentMask4 = this.currentMask) === null || _this$currentMask4 === void 0 ? void 0 : _this$currentMask4.state
        });
    }
    set state(state) {
        const { compiledMasks: compiledMasks, currentMaskRef: currentMaskRef, currentMask: currentMask } = state, maskedState = (0, $5MZVQ._)(state, $205c3e193edd605c$var$_excluded);
        this.compiledMasks.forEach((m, mi)=>m.state = compiledMasks[mi]);
        if (currentMaskRef != null) {
            this.currentMask = currentMaskRef;
            this.currentMask.state = currentMask;
        }
        super.state = maskedState;
    }
    /**
    @override
  */ extractInput() {
        return this.currentMask ? this.currentMask.extractInput(...arguments) : "";
    }
    /**
    @override
  */ extractTail() {
        return this.currentMask ? this.currentMask.extractTail(...arguments) : super.extractTail(...arguments);
    }
    /**
    @override
  */ doCommit() {
        if (this.currentMask) this.currentMask.doCommit();
        super.doCommit();
    }
    /**
    @override
  */ nearestInputPos() {
        return this.currentMask ? this.currentMask.nearestInputPos(...arguments) : super.nearestInputPos(...arguments);
    }
    get overwrite() {
        return this.currentMask ? this.currentMask.overwrite : super.overwrite;
    }
    set overwrite(overwrite) {
        console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
    }
    get eager() {
        return this.currentMask ? this.currentMask.eager : super.eager;
    }
    set eager(eager) {
        console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
    }
    get skipInvalid() {
        return this.currentMask ? this.currentMask.skipInvalid : super.skipInvalid;
    }
    set skipInvalid(skipInvalid) {
        if (this.isInitialized || skipInvalid !== (0, $7J9oQ.default).DEFAULTS.skipInvalid) console.warn('"skipInvalid" option is not available in dynamic mask, use this option in siblings');
    }
    /**
    @override
  */ maskEquals(mask) {
        return Array.isArray(mask) && this.compiledMasks.every((m, mi)=>{
            if (!mask[mi]) return;
            const _mask$mi = mask[mi], { mask: oldMask } = _mask$mi, restOpts = (0, $5MZVQ._)(_mask$mi, $205c3e193edd605c$var$_excluded2);
            return (0, $hXrfI.objectIncludes)(m, restOpts) && m.maskEquals(oldMask);
        });
    }
    /**
    @override
  */ typedValueEquals(value) {
        var _this$currentMask5;
        return Boolean((_this$currentMask5 = this.currentMask) === null || _this$currentMask5 === void 0 ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
}
$205c3e193edd605c$export$2e2bcd8739ae039.DEFAULTS = {
    dispatch: (appended, masked, flags, tail)=>{
        if (!masked.compiledMasks.length) return;
        const inputValue = masked.rawInputValue;
        // simulate input
        const inputs = masked.compiledMasks.map((m, index)=>{
            const isCurrent = masked.currentMask === m;
            const startInputPos = isCurrent ? m.value.length : m.nearestInputPos(m.value.length, (0, $hXrfI.DIRECTION).FORCE_LEFT);
            if (m.rawInputValue !== inputValue) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
            } else if (!isCurrent) m.remove(startInputPos);
            m.append(appended, masked.currentMaskFlags(flags));
            m.appendTail(tail);
            return {
                index: index,
                weight: m.rawInputValue.length,
                totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.value.length, (0, $hXrfI.DIRECTION).FORCE_LEFT)))
            };
        });
        // pop masks with longer values first
        inputs.sort((i1, i2)=>i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
        return masked.compiledMasks[inputs[0].index];
    }
};
(0, $3VPSz.default).MaskedDynamic = $205c3e193edd605c$export$2e2bcd8739ae039;

});

parcelRegister("lP4bh", function(module, exports) {

var $f2ySt = parcelRequire("f2ySt");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("hXrfI");
parcelRequire("aDXuy");
/** Mask pipe source and destination types */ const $fe319a9dc77d4d37$export$90dab59c3d4b6e03 = {
    MASKED: "value",
    UNMASKED: "unmaskedValue",
    TYPED: "typedValue"
};
/** Creates new pipe function depending on mask type, source and destination options */ function $fe319a9dc77d4d37$export$a504d53a5b99e1b9(mask) {
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $fe319a9dc77d4d37$export$90dab59c3d4b6e03.MASKED;
    let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $fe319a9dc77d4d37$export$90dab59c3d4b6e03.MASKED;
    const masked = (0, $f2ySt.default)(mask);
    return (value)=>masked.runIsolated((m)=>{
            m[from] = value;
            return m[to];
        });
}
/** Pipes value through mask depending on mask type, source and destination options */ function $fe319a9dc77d4d37$export$a4627e546088548d(value) {
    for(var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)pipeArgs[_key - 1] = arguments[_key];
    return $fe319a9dc77d4d37$export$a504d53a5b99e1b9(...pipeArgs)(value);
}
(0, $3VPSz.default).PIPE_TYPE = $fe319a9dc77d4d37$export$90dab59c3d4b6e03;
(0, $3VPSz.default).createPipe = $fe319a9dc77d4d37$export$a504d53a5b99e1b9;
(0, $3VPSz.default).pipe = $fe319a9dc77d4d37$export$a4627e546088548d;

});


parcelRegister("hGKnh", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("3VPSz")).default);
parcelRequire("hx7qC");

var $3VPSz = parcelRequire("3VPSz");
parcelRequire("5MZVQ");
parcelRequire("hXrfI");
parcelRequire("aDXuy");
parcelRequire("8C3e0");
parcelRequire("icQ7P");
parcelRequire("8hM9o");
parcelRequire("7J9oQ");
parcelRequire("g25yo");
parcelRequire("l46UZ");
parcelRequire("f2ySt");
parcelRequire("cuHCm");
parcelRequire("9QcM3");
parcelRequire("eumni");
parcelRequire("aFZLp");
parcelRequire("4yFuH");
parcelRequire("isiCJ");
parcelRequire("daQKZ");
parcelRequire("iV2Eh");

});

parcelRegister("eBVXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa317bad8081acc2$export$2e2bcd8739ae039);

var $3w54T = parcelRequire("3w54T");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hGKnh");
var $3VPSz = parcelRequire("3VPSz");
// TODO should be imported from core
const $aa317bad8081acc2$var$MASK_PROPS = {
    // common
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(RegExp),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            Date,
            Number,
            (0, $3VPSz.default).Masked
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf((0, $3VPSz.default).Masked)
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    unmask: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "typed"
        ])
    ]),
    prepare: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    validate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    commit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    overwrite: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "shift"
        ])
    ]),
    eager: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "append",
            "remove"
        ])
    ]),
    skipInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // events
    onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    // pattern
    placeholderChar: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displayChar: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    lazy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    definitions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    blocks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    // date
    pattern: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    autofix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "pad"
        ])
    ]),
    // number
    radix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    thousandsSeparator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mapToRadix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    signed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    normalizeZeros: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    padFractionalZeros: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    min: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date)
    ]),
    max: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date)
    ]),
    // dynamic
    dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    // ref
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        })
    ])
};
const $aa317bad8081acc2$var$MASK_PROPS_NAMES = Object.keys($aa317bad8081acc2$var$MASK_PROPS).filter((p)=>p !== "value");
const $aa317bad8081acc2$var$NON_MASK_OPTIONS_PROPS_NAMES = [
    "value",
    "unmask",
    "onAccept",
    "onComplete",
    "inputRef"
];
const $aa317bad8081acc2$var$MASK_OPTIONS_PROPS_NAMES = $aa317bad8081acc2$var$MASK_PROPS_NAMES.filter((pName)=>$aa317bad8081acc2$var$NON_MASK_OPTIONS_PROPS_NAMES.indexOf(pName) < 0);
// TODO
// 1. seems like it's wrong to have Opts as only mask options. Other component/input props should also be there. Where is "unmask" prop for instance?
// 2. Unmask should be infered from Opts (see https://github.com/uNmAnNeR/imaskjs/issues/554#issuecomment-1114014010)
function $aa317bad8081acc2$export$2e2bcd8739ae039(ComposedComponent) {
    const MaskedComponent = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
        constructor(props){
            super(props);
            this._inputRef = this._inputRef.bind(this);
        }
        componentDidMount() {
            if (!this.props.mask) return;
            this.initMask();
        }
        componentDidUpdate() {
            const props = this.props;
            const maskOptions = this._extractMaskOptionsFromProps(props);
            if (maskOptions.mask) {
                if (this.maskRef) {
                    this.maskRef.updateOptions(maskOptions);
                    if ("value" in props) this.maskValue = props.value;
                } else this.initMask(maskOptions);
            } else {
                this.destroyMask();
                if ("value" in props) this.element.value = props.value;
            }
        }
        componentWillUnmount() {
            this.destroyMask();
        }
        _inputRef(el) {
            this.element = el;
            if (this.props.inputRef) {
                if (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current")) this.props.inputRef.current = el;
                else this.props.inputRef(el);
            }
        }
        initMask() {
            let maskOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._extractMaskOptionsFromProps(this.props);
            this.maskRef = (0, $3VPSz.default)(this.element, maskOptions).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this));
            if ("value" in this.props) this.maskValue = this.props.value;
        }
        destroyMask() {
            if (this.maskRef) {
                this.maskRef.destroy();
                delete this.maskRef;
            }
        }
        _extractMaskOptionsFromProps(props) {
            const cloneProps = Object.assign({}, ((0, $3w54T.a)(props), props));
            // keep only mask options props
            Object.keys(cloneProps)// TODO why need cast to string?
            .filter((prop)=>$aa317bad8081acc2$var$MASK_OPTIONS_PROPS_NAMES.indexOf(prop) < 0).forEach((nonMaskProp)=>{
                delete cloneProps[nonMaskProp];
            });
            // TODO type actually should be IMask.DeduceMasked<Opts>
            return cloneProps;
        }
        _extractNonMaskProps(props) {
            const _ref = props, cloneProps = Object.assign({}, ((0, $3w54T.a)(_ref), _ref));
            $aa317bad8081acc2$var$MASK_PROPS_NAMES.forEach((maskProp)=>{
                delete cloneProps[maskProp];
            });
            if (!("defaultValue" in cloneProps)) cloneProps.defaultValue = props.mask ? "" : cloneProps.value;
            delete cloneProps.value;
            return cloneProps;
        }
        get maskValue() {
            if (this.props.unmask === "typed") return this.maskRef.typedValue;
            if (this.props.unmask) return this.maskRef.unmaskedValue;
            return this.maskRef.value;
        }
        set maskValue(value) {
            value = value == null && this.props.unmask !== "typed" ? "" : value;
            if (this.props.unmask === "typed") this.maskRef.typedValue = value;
            else if (this.props.unmask) this.maskRef.unmaskedValue = value;
            else this.maskRef.value = value;
        }
        _onAccept(e) {
            if (this.props.onAccept && this.maskRef) this.props.onAccept(this.maskValue, this.maskRef, e);
        }
        _onComplete(e) {
            if (this.props.onComplete && this.maskRef) this.props.onComplete(this.maskValue, this.maskRef, e);
        }
        render() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ComposedComponent, Object.assign({}, this._extractNonMaskProps(this.props), {
                inputRef: this._inputRef
            }));
        }
    };
    const nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || "Component";
    MaskedComponent.displayName = "IMask(".concat(nestedComponentName, ")");
    MaskedComponent.propTypes = $aa317bad8081acc2$var$MASK_PROPS;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MaskedComponent, Object.assign({}, props, {
            ref: ref
        })));
}

});
parcelRegister("3w54T", function(module, exports) {

$parcel$export(module.exports, "a", () => $28f84c9c7f5dc9fe$export$407448d2b89b1813);
$parcel$export(module.exports, "_", () => $28f84c9c7f5dc9fe$export$71511d61b312f219);
function $28f84c9c7f5dc9fe$export$407448d2b89b1813(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $28f84c9c7f5dc9fe$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("ih2iT", function(module, exports) {

var $3w54T = parcelRequire("3w54T");

var $acw62 = parcelRequire("acw62");

var $eBVXM = parcelRequire("eBVXM");

parcelRequire("hGKnh");
const $d4db9a033373e2af$var$_excluded = [
    "inputRef"
];
const $d4db9a033373e2af$var$IMaskInputClass = (0, $eBVXM.default)((_ref)=>{
    let { inputRef: inputRef } = _ref, props = (0, $3w54T._)(_ref, $d4db9a033373e2af$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, props, {
        ref: inputRef
    }));
});
const $d4db9a033373e2af$var$IMaskInputFn = (props, ref)=>// TODO type
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d4db9a033373e2af$var$IMaskInputClass, Object.assign({}, props, {
        ref: ref
    }));
const $d4db9a033373e2af$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($d4db9a033373e2af$var$IMaskInputFn);

});

parcelRegister("kwclR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef00608d9f2f8a9c$export$2e2bcd8739ae039);

var $3w54T = parcelRequire("3w54T");
parcelRequire("hGKnh");
var $3VPSz = parcelRequire("3VPSz");

var $acw62 = parcelRequire("acw62");
const $ef00608d9f2f8a9c$var$_excluded = [
    "value"
], $ef00608d9f2f8a9c$var$_excluded2 = [
    "unmaskedValue"
], $ef00608d9f2f8a9c$var$_excluded3 = [
    "typedValue"
];
function $ef00608d9f2f8a9c$export$2e2bcd8739ae039(opts) {
    let { onAccept: onAccept, onComplete: onComplete } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const ref = (0, $acw62.useRef)(null);
    const maskRef = (0, $acw62.useRef)(null);
    const [initialized, setInitialized] = (0, $acw62.useState)(false);
    const [lastAcceptState, setLastAcceptState] = (0, $acw62.useState)({});
    const [value, setValue] = (0, $acw62.useState)("");
    const [unmaskedValue, setUnmaskedValue] = (0, $acw62.useState)("");
    const [typedValue, setTypedValue] = (0, $acw62.useState)();
    const _destroyMask = (0, $acw62.useCallback)(()=>{
        var _maskRef$current;
        (_maskRef$current = maskRef.current) === null || _maskRef$current === void 0 || _maskRef$current.destroy();
        maskRef.current = null;
    }, []);
    const _onAccept = (0, $acw62.useCallback)((event)=>{
        const m = maskRef.current;
        if (!m) return;
        setLastAcceptState({
            value: m.value,
            unmaskedValue: m.unmaskedValue,
            typedValue: m.typedValue
        });
        setTypedValue(m.typedValue);
        setUnmaskedValue(m.unmaskedValue);
        setValue(m.value);
        onAccept === null || onAccept === void 0 || onAccept(m.value, m, event);
    }, [
        onAccept
    ]);
    const _onComplete = (0, $acw62.useCallback)(()=>maskRef.current && (onComplete === null || onComplete === void 0 ? void 0 : onComplete(maskRef.current.value, maskRef.current)), [
        onComplete
    ]);
    (0, $acw62.useEffect)(()=>{
        const el = ref.current;
        if (!el || !(opts !== null && opts !== void 0 && opts.mask)) return _destroyMask();
        const mask = maskRef.current;
        if (!mask) {
            if (el && opts !== null && opts !== void 0 && opts.mask) {
                maskRef.current = (0, $3VPSz.default)(el, opts);
                _onAccept();
            }
        } else mask === null || mask === void 0 || mask.updateOptions(opts);
        setInitialized(Boolean(maskRef.current));
    }, [
        opts,
        _destroyMask,
        _onAccept
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!maskRef.current) return;
        const mask = maskRef.current;
        mask.on("accept", _onAccept);
        mask.on("complete", _onComplete);
        return ()=>{
            mask.off("accept", _onAccept);
            mask.off("complete", _onComplete);
        };
    }, [
        _onAccept,
        _onComplete
    ]);
    (0, $acw62.useEffect)(()=>{
        const { value: lastAcceptValue } = lastAcceptState, state = (0, $3w54T._)(lastAcceptState, $ef00608d9f2f8a9c$var$_excluded);
        const mask = maskRef.current;
        if (mask && initialized && lastAcceptValue !== value) mask.value = value;
        setLastAcceptState(state);
    }, [
        value
    ]);
    (0, $acw62.useEffect)(()=>{
        const { unmaskedValue: lastAcceptUnmaskedValue } = lastAcceptState, state = (0, $3w54T._)(lastAcceptState, $ef00608d9f2f8a9c$var$_excluded2);
        const mask = maskRef.current;
        if (mask && initialized && lastAcceptUnmaskedValue !== unmaskedValue) mask.unmaskedValue = unmaskedValue;
        setLastAcceptState(state);
    }, [
        unmaskedValue
    ]);
    (0, $acw62.useEffect)(()=>{
        const { typedValue: lastAcceptTypedValue } = lastAcceptState, state = (0, $3w54T._)(lastAcceptState, $ef00608d9f2f8a9c$var$_excluded3);
        const mask = maskRef.current;
        if (mask && initialized && lastAcceptTypedValue !== typedValue) mask.typedValue = typedValue;
        setLastAcceptState(state);
    }, [
        typedValue
    ]);
    (0, $acw62.useEffect)(()=>_destroyMask, [
        _destroyMask
    ]);
    return {
        ref: ref,
        maskRef: maskRef,
        value: value,
        setValue: setValue,
        unmaskedValue: unmaskedValue,
        setUnmaskedValue: setUnmaskedValue,
        typedValue: typedValue,
        setTypedValue: setTypedValue
    };
}

});


parcelRegister("5arZS", function(module, exports) {
/*!
  react-datepicker v6.9.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 
































































!function(e, t) {
    t(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("9QePP")), (parcelRequire("26SSu")), (parcelRequire("kPCB6")), (parcelRequire("48K34")), (parcelRequire("jZtIs")), (parcelRequire("iMX5A")), (parcelRequire("e1kwM")), (parcelRequire("gdvs1")), (parcelRequire("cls5f")), (parcelRequire("4chdC")), (parcelRequire("3cpd6")), (parcelRequire("5N9HD")), (parcelRequire("xHbuL")), (parcelRequire("gZrcY")), (parcelRequire("aZKRL")), (parcelRequire("aPY0w")), (parcelRequire("ebQpN")), (parcelRequire("12jbR")), (parcelRequire("lIpMn")), (parcelRequire("gf6Rq")), (parcelRequire("inqX7")), (parcelRequire("bjZpy")), (parcelRequire("9xRRE")), (parcelRequire("a9aPJ")), (parcelRequire("5CRrs")), (parcelRequire("dF81P")), (parcelRequire("f23Gj")), (parcelRequire("JJ6gI")), (parcelRequire("8l96w")), (parcelRequire("1VSw7")), (parcelRequire("dO1KX")), (parcelRequire("75Jn2")), (parcelRequire("80buy")), (parcelRequire("fIlxB")), (parcelRequire("9UMYl")), (parcelRequire("bTWJP")), (parcelRequire("7b4id")), (parcelRequire("7yyNc")), (parcelRequire("fH0a1")), (parcelRequire("8ple2")), (parcelRequire("gxLWY")), (parcelRequire("hgDzO")), (parcelRequire("3Au2i")), (parcelRequire("fG9DL")), (parcelRequire("iiR1c")), (parcelRequire("jHGP1")), (parcelRequire("9kRZo")), (parcelRequire("aw1Xf")), (parcelRequire("3p5lI")), (parcelRequire("AFgUD")), (parcelRequire("ea2hS")), (parcelRequire("f8HTF")), (parcelRequire("aFxrf")), (parcelRequire("i5nf8")), (parcelRequire("dzPMY")), (parcelRequire("30SVQ")), (parcelRequire("bUtct")), (parcelRequire("ewus1")), (parcelRequire("7PieZ")), (parcelRequire("hL3CS")), (parcelRequire("1u0KT")), (parcelRequire("5rxG7")), (parcelRequire("jYMLq")));
}(module.exports, function(e, t, r, n, a, o, s, i, p, c, l, d, u, h, f, m, y, g, v, D, k, w, b, S, M, C, _, Y, E, P, N, O, x, I, T, R, L, F, A, W, Q, K, q, B, H, j, V, U, $, z, G, J, X, Z, ee, te, re, ne, ae, oe, se, ie, pe, ce, le, de) {
    "use strict";
    function ue(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var he = ue(t), fe = ue(pe), me = ue(ce);
    function ye(e, t, r) {
        return t = Ee(t), function(e, t) {
            if (t && ("object" == typeof t || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e);
        }(e, ge() ? Reflect.construct(t, r || [], Ee(e).constructor) : t.apply(e, r));
    }
    function ge() {
        try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (e) {}
        return (ge = function() {
            return !!e;
        })();
    }
    function ve(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function De(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ve(Object(r), !0).forEach(function(t) {
                Ce(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ve(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ke(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
                var n = r.call(e, t || "default");
                if ("object" != typeof n) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }
    function we(e) {
        return we = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, we(e);
    }
    function be(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Se(e, t) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ke(n.key), n);
        }
    }
    function Me(e, t, r) {
        return t && Se(e.prototype, t), r && Se(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Ce(e, t, r) {
        return (t = ke(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function _e() {
        return _e = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, _e.apply(this, arguments);
    }
    function Ye(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && Pe(e, t);
    }
    function Ee(e) {
        return Ee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, Ee(e);
    }
    function Pe(e, t) {
        return Pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        }, Pe(e, t);
    }
    function Ne(e) {
        return function(e) {
            if (Array.isArray(e)) return Oe(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Oe(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Oe(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Oe(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
        return n;
    }
    var xe = 12, Ie = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Te(e) {
        var t = e ? "string" == typeof e || e instanceof String ? se.parseISO(e) : ae.toDate(e) : new Date;
        return Re(t) ? t : null;
    }
    function Re(e, t) {
        return t = t || new Date("1/1/1000"), o.isValid(e) && !re.isBefore(e, t);
    }
    function Le(e, t, r) {
        if ("en" === r) return s.format(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var n = Je(r);
        return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && Ge() && Je(Ge()) && (n = Je(Ge())), s.format(e, t, {
            locale: n || null,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Fe(e, t) {
        var r = t.dateFormat, n = t.locale;
        return e && Le(e, Array.isArray(r) ? r[0] : r, n) || "";
    }
    function Ae(e, t) {
        var r = t.hour, n = void 0 === r ? 0 : r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second, i = void 0 === s ? 0 : s;
        return O.setHours(N.setMinutes(P.setSeconds(e, i), o), n);
    }
    function We(e, t, r) {
        var n = Je(t || Ge());
        return q.startOfWeek(e, {
            locale: n,
            weekStartsOn: r
        });
    }
    function Qe(e) {
        return B.startOfMonth(e);
    }
    function Ke(e) {
        return j.startOfYear(e);
    }
    function qe(e) {
        return H.startOfQuarter(e);
    }
    function Be() {
        return K.startOfDay(Te());
    }
    function He(e, t) {
        return e && t ? Z.isSameYear(e, t) : !e && !t;
    }
    function je(e, t) {
        return e && t ? X.isSameMonth(e, t) : !e && !t;
    }
    function Ve(e, t) {
        return e && t ? ee.isSameQuarter(e, t) : !e && !t;
    }
    function Ue(e, t) {
        return e && t ? J.isSameDay(e, t) : !e && !t;
    }
    function $e(e, t) {
        return e && t ? G.isEqual(e, t) : !e && !t;
    }
    function ze(e, t, r) {
        var n, a = K.startOfDay(t), o = V.endOfDay(r);
        try {
            n = ne.isWithinInterval(e, {
                start: a,
                end: o
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function Ge() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Je(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Xe(e, t) {
        return Le(x.setMonth(Te(), e), "LLLL", t);
    }
    function Ze(e, t) {
        return Le(x.setMonth(Te(), e), "LLL", t);
    }
    function et(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return pt(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Ue(e, t.date ? t.date : t);
        }) || o && o.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || s && !s.some(function(t) {
            return Ue(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || p && !p(Te(e)) || !1;
    }
    function tt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, n = t.excludeDateIntervals;
        return n && n.length > 0 ? n.some(function(t) {
            var r = t.start, n = t.end;
            return ne.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) : r && r.some(function(t) {
            return Ue(e, t.date ? t.date : t);
        }) || !1;
    }
    function rt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return pt(e, {
            minDate: B.startOfMonth(r),
            maxDate: $.endOfMonth(n)
        }) || a && a.some(function(t) {
            return je(e, t);
        }) || o && !o.some(function(t) {
            return je(e, t);
        }) || s && !s(Te(e)) || !1;
    }
    function nt(e, t, r, n) {
        var a = Y.getYear(e), o = C.getMonth(e), s = Y.getYear(t), i = C.getMonth(t), p = Y.getYear(n);
        return a === s && a === p ? o <= r && r <= i : a < s ? p === a && o <= r || p === s && i >= r || p < s && p > a : void 0;
    }
    function at(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return pt(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Ve(e, t);
        }) || o && !o.some(function(t) {
            return Ve(e, t);
        }) || s && !s(Te(e)) || !1;
    }
    function ot(e, t, r) {
        if (!o.isValid(t) || !o.isValid(r)) return !1;
        var n = Y.getYear(t), a = Y.getYear(r);
        return n <= e && a >= e;
    }
    function st(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate, i = new Date(e, 0, 1);
        return pt(i, {
            minDate: j.startOfYear(r),
            maxDate: z.endOfYear(n)
        }) || a && a.some(function(e) {
            return He(i, e);
        }) || o && !o.some(function(e) {
            return He(i, e);
        }) || s && !s(Te(i)) || !1;
    }
    function it(e, t, r, n) {
        var a = Y.getYear(e), o = _.getQuarter(e), s = Y.getYear(t), i = _.getQuarter(t), p = Y.getYear(n);
        return a === s && a === p ? o <= r && r <= i : a < s ? p === a && o <= r || p === s && i >= r || p < s && p > a : void 0;
    }
    function pt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate;
        return r && F.differenceInCalendarDays(e, r) < 0 || n && F.differenceInCalendarDays(e, n) > 0;
    }
    function ct(e, t) {
        return t.some(function(t) {
            return w.getHours(t) === w.getHours(e) && k.getMinutes(t) === k.getMinutes(e) && D.getSeconds(t) === D.getSeconds(e);
        });
    }
    function lt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, n = t.includeTimes, a = t.filterTime;
        return r && ct(e, r) || n && !ct(e, n) || a && !a(e) || !1;
    }
    function dt(e, t) {
        var r = t.minTime, n = t.maxTime;
        if (!r || !n) throw new Error("Both minTime and maxTime props required");
        var a = Te();
        a = O.setHours(a, w.getHours(e)), a = N.setMinutes(a, k.getMinutes(e)), a = P.setSeconds(a, D.getSeconds(e));
        var o = Te();
        o = O.setHours(o, w.getHours(r)), o = N.setMinutes(o, k.getMinutes(r)), o = P.setSeconds(o, D.getSeconds(r));
        var s, i = Te();
        i = O.setHours(i, w.getHours(n)), i = N.setMinutes(i, k.getMinutes(n)), i = P.setSeconds(i, D.getSeconds(n));
        try {
            s = !ne.isWithinInterval(a, {
                start: o,
                end: i
            });
        } catch (e) {
            s = !1;
        }
        return s;
    }
    function ut(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = y.subMonths(e, 1);
        return r && A.differenceInCalendarMonths(r, a) > 0 || n && n.every(function(e) {
            return A.differenceInCalendarMonths(e, a) > 0;
        }) || !1;
    }
    function ht(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = d.addMonths(e, 1);
        return r && A.differenceInCalendarMonths(a, r) > 0 || n && n.every(function(e) {
            return A.differenceInCalendarMonths(a, e) > 0;
        }) || !1;
    }
    function ft(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = v.subYears(e, 1);
        return r && W.differenceInCalendarYears(r, a) > 0 || n && n.every(function(e) {
            return W.differenceInCalendarYears(e, a) > 0;
        }) || !1;
    }
    function mt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = h.addYears(e, 1);
        return r && W.differenceInCalendarYears(a, r) > 0 || n && n.every(function(e) {
            return W.differenceInCalendarYears(a, e) > 0;
        }) || !1;
    }
    function yt(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return F.differenceInCalendarDays(e, t) >= 0;
            });
            return R.min(n);
        }
        return r ? R.min(r) : t;
    }
    function gt(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return F.differenceInCalendarDays(e, t) <= 0;
            });
            return L.max(n);
        }
        return r ? L.max(r) : t;
    }
    function vt() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, n = 0, o = e.length; n < o; n++){
            var s = e[n];
            if (a.isDate(s)) {
                var i = Le(s, "MM.dd.yyyy"), p = r.get(i) || [];
                p.includes(t) || (p.push(t), r.set(i, p));
            } else if ("object" === we(s)) {
                var c = Object.keys(s), l = c[0], d = s[c[0]];
                if ("string" == typeof l && d.constructor === Array) for(var u = 0, h = d.length; u < h; u++){
                    var f = Le(d[u], "MM.dd.yyyy"), m = r.get(f) || [];
                    m.includes(l) || (m.push(l), r.set(f, m));
                }
            }
        }
        return r;
    }
    function Dt() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--holidays", r = new Map;
        return e.forEach(function(e) {
            var n = e.date, o = e.holidayName;
            if (a.isDate(n)) {
                var s = Le(n, "MM.dd.yyyy"), i = r.get(s) || {};
                if (!("className" in i) || i.className !== t || (p = i.holidayNames, c = [
                    o
                ], p.length !== c.length || !p.every(function(e, t) {
                    return e === c[t];
                }))) {
                    var p, c;
                    i.className = t;
                    var l = i.holidayNames;
                    i.holidayNames = l ? [].concat(Ne(l), [
                        o
                    ]) : [
                        o
                    ], r.set(s, i);
                }
            }
        }), r;
    }
    function kt(e, t, r, n, a) {
        for(var o = a.length, s = [], c = 0; c < o; c++){
            var l = e;
            l = p.addHours(l, w.getHours(a[c])), l = i.addMinutes(l, k.getMinutes(a[c])), l = ie.addSeconds(l, D.getSeconds(a[c]));
            var d = i.addMinutes(e, (r + 1) * n);
            te.isAfter(l, t) && re.isBefore(l, d) && s.push(a[c]);
        }
        return s;
    }
    function wt(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function bt(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xe, r = Math.ceil(Y.getYear(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function St(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return ae.toDate(e.getTime() - 1e3 * t - r);
    }
    function Mt(e) {
        if (!a.isDate(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function Ct(e, t) {
        if (!a.isDate(e) || !a.isDate(t)) throw new Error("Invalid date received");
        var r = Mt(e), n = Mt(t);
        return re.isBefore(r, n);
    }
    function _t(e) {
        return " " === e.key;
    }
    function Yt(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Y.getYear(r) <= s), n && i && (i = Y.getYear(n) >= s), i && a.push(s);
        }
        return a;
    }
    var Et = function(e) {
        function r(e) {
            var n;
            be(this, r), Ce(n = ye(this, r, [
                e
            ]), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return he.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(n, t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? he.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Y.getYear(n.props.minDate) : null, a = n.props.maxDate ? Y.getYear(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(he.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, he.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(he.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, he.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Ce(n, "onChange", function(e) {
                n.props.onChange(e);
            }), Ce(n, "handleClickOutside", function() {
                n.props.onCancel();
            }), Ce(n, "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Ce(n, "incrementYears", function() {
                return n.shiftYears(1);
            }), Ce(n, "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var a = e.yearDropdownItemNumber, o = e.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return n.state = {
                yearsList: Yt(n.props.year, s, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return Ye(r, e), Me(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    if (e) {
                        var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                            return e.ariaSelected;
                        }) : null;
                        e.scrollTop = r ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = n.clsx({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return he.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), Pt = fe.default(Et), Nt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Y.getYear(e.props.minDate) : 1900, r = e.props.maxDate ? Y.getYear(e.props.maxDate) : 2100, n = [], a = t; a <= r; a++)n.push(he.default.createElement("option", {
                    key: a,
                    value: a
                }, a));
                return n;
            }), Ce(e, "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Ce(e, "renderSelectMode", function() {
                return he.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Ce(e, "renderReadView", function(t) {
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, he.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Ce(e, "renderDropdown", function() {
                return he.default.createElement(Pt, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Ce(e, "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Ce(e, "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Ce(e, "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Ce(e, "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Ce(e, "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component), Ot = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Ce(e, "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return he.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(e, r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? he.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Ce(e, "onChange", function(t) {
                return e.props.onChange(t);
            }), Ce(e, "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), xt = fe.default(Ot), It = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return he.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Ce(e, "renderSelectMode", function(t) {
                return he.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Ce(e, "renderReadView", function(t, r) {
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, he.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Ce(e, "renderDropdown", function(t) {
                return he.default.createElement(xt, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Ce(e, "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, n = [
                    e.renderReadView(!r, t)
                ];
                return r && n.unshift(e.renderDropdown(t)), n;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Ce(e, "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return Ze(e, t.props.locale);
                    } : function(e) {
                        return Xe(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component);
    function Tt(e, t) {
        for(var r = [], n = Qe(e), a = Qe(t); !te.isAfter(n, a);)r.push(Te(n)), n = d.addMonths(n, 1);
        return r;
    }
    var Rt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "renderOptions", function() {
                return r.state.monthYearsList.map(function(e) {
                    var t = E.getTime(e), n = He(r.props.date, e) && je(r.props.date, e);
                    return he.default.createElement("div", {
                        className: n ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: r.onChange.bind(r, t),
                        "aria-selected": n ? "true" : void 0
                    }, n ? he.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Le(e, r.props.dateFormat, r.props.locale));
                });
            }), Ce(r, "onChange", function(e) {
                return r.props.onChange(e);
            }), Ce(r, "handleClickOutside", function() {
                r.props.onCancel();
            }), r.state = {
                monthYearsList: Tt(r.props.minDate, r.props.maxDate)
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = n.clsx({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return he.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]);
    }(he.default.Component), Lt = fe.default(Rt), Ft = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                dropdownVisible: !1
            }), Ce(e, "renderSelectOptions", function() {
                for(var t = Qe(e.props.minDate), r = Qe(e.props.maxDate), n = []; !te.isAfter(t, r);){
                    var a = E.getTime(t);
                    n.push(he.default.createElement("option", {
                        key: a,
                        value: a
                    }, Le(t, e.props.dateFormat, e.props.locale))), t = d.addMonths(t, 1);
                }
                return n;
            }), Ce(e, "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Ce(e, "renderSelectMode", function() {
                return he.default.createElement("select", {
                    value: E.getTime(Qe(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Ce(e, "renderReadView", function(t) {
                var r = Le(e.props.date, e.props.dateFormat, e.props.locale);
                return he.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, he.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), he.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Ce(e, "renderDropdown", function() {
                return he.default.createElement(Lt, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Ce(e, "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Ce(e, "onChange", function(t) {
                e.toggleDropdown();
                var r = Te(parseInt(t));
                He(e.props.date, r) && je(e.props.date, r) || e.props.onChange(r);
            }), Ce(e, "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]);
    }(he.default.Component), At = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, a = new Array(r), o = 0; o < r; o++)a[o] = arguments[o];
            return Ce(e = ye(this, t, [].concat(a)), "dayEl", he.default.createRef()), Ce(e, "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Ce(e, "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Ce(e, "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Ce(e, "isSameDay", function(t) {
                return Ue(e.props.day, t);
            }), Ce(e, "isKeyboardSelected", function() {
                var t;
                return !e.props.disabledKeyboardNavigation && !(e.props.selectsMultiple ? null === (t = e.props.selectedDates) || void 0 === t ? void 0 : t.some(function(t) {
                    return e.isSameDayOrWeek(t);
                }) : e.isSameDayOrWeek(e.props.selected)) && e.isSameDayOrWeek(e.props.preSelection);
            }), Ce(e, "isDisabled", function() {
                return et(e.props.day, e.props);
            }), Ce(e, "isExcluded", function() {
                return tt(e.props.day, e.props);
            }), Ce(e, "isStartOfWeek", function() {
                return Ue(e.props.day, We(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Ce(e, "isSameWeek", function(t) {
                return e.props.showWeekPicker && Ue(t, We(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Ce(e, "isSameDayOrWeek", function(t) {
                return e.isSameDay(t) || e.isSameWeek(t);
            }), Ce(e, "getHighLightedClass", function() {
                var t = e.props, r = t.day, n = t.highlightDates;
                if (!n) return !1;
                var a = Le(r, "MM.dd.yyyy");
                return n.get(a);
            }), Ce(e, "getHolidaysClass", function() {
                var t = e.props, r = t.day, n = t.holidays;
                if (!n) return !1;
                var a = Le(r, "MM.dd.yyyy");
                return n.has(a) ? [
                    n.get(a).className
                ] : void 0;
            }), Ce(e, "isInRange", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && ze(r, n, a);
            }), Ce(e, "isInSelectingRange", function() {
                var t, r = e.props, n = r.day, a = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, c = r.endDate, l = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(a || o || s) || !l || !i && e.isDisabled()) && (a && c && (re.isBefore(l, c) || $e(l, c)) ? ze(n, l, c) : (o && p && (te.isAfter(l, p) || $e(l, p)) || !(!s || !p || c || !te.isAfter(l, p) && !$e(l, p))) && ze(n, p, l));
            }), Ce(e, "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, n = r.day, a = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Ue(n, o ? s : a);
            }), Ce(e, "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, n = r.day, a = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Ue(n, o || s ? i : a);
            }), Ce(e, "isRangeStart", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && Ue(n, r);
            }), Ce(e, "isRangeEnd", function() {
                var t = e.props, r = t.day, n = t.startDate, a = t.endDate;
                return !(!n || !a) && Ue(a, r);
            }), Ce(e, "isWeekend", function() {
                var t = b.getDay(e.props.day);
                return 0 === t || 6 === t;
            }), Ce(e, "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === C.getMonth(e.props.day);
            }), Ce(e, "isBeforeMonth", function() {
                return void 0 !== e.props.month && (C.getMonth(e.props.day) + 1) % 12 === e.props.month;
            }), Ce(e, "isCurrentDay", function() {
                return e.isSameDay(Te());
            }), Ce(e, "isSelected", function() {
                var t;
                return e.props.selectsMultiple ? null === (t = e.props.selectedDates) || void 0 === t ? void 0 : t.some(function(t) {
                    return e.isSameDayOrWeek(t);
                }) : e.isSameDayOrWeek(e.props.selected);
            }), Ce(e, "getClassNames", function(t) {
                var r, a = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return n.clsx("react-datepicker__day", a, "react-datepicker__day--" + Le(e.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"), e.getHolidaysClass());
            }), Ce(e, "getAriaLabel", function() {
                var t = e.props, r = t.day, n = t.ariaLabelPrefixWhenEnabled, a = void 0 === n ? "Choose" : n, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : a;
                return "".concat(i, " ").concat(Le(r, "PPPP", e.props.locale));
            }), Ce(e, "getTitle", function() {
                var t = e.props, r = t.day, n = t.holidays, a = void 0 === n ? new Map : n, o = t.excludeDates, s = Le(r, "MM.dd.yyyy"), i = [];
                return a.has(s) && i.push.apply(i, Ne(a.get(s).holidayNames)), e.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return Ue(e.date ? e.date : e, r);
                }).map(function(e) {
                    return e.message;
                })), i.join(", ");
            }), Ce(e, "getTabIndex", function(t, r) {
                var n = t || e.props.selected, a = r || e.props.preSelection;
                return (!e.props.showWeekPicker || !e.props.showWeekNumber && e.isStartOfWeek()) && (e.isKeyboardSelected() || e.isSameDay(n) && Ue(a, n)) ? 0 : -1;
            }), Ce(e, "handleFocusDay", function() {
                var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = !1;
                0 === e.getTabIndex() && !r.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (n = !0), e.props.inline && !e.props.shouldFocusDayInline && (n = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (n = !0), e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() && (n = !1), e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() && (n = !1)), n && (null === (t = e.dayEl.current) || void 0 === t || t.focus({
                    preventScroll: !0
                }));
            }), Ce(e, "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(S.getDate(e.props.day), e.props.day) : S.getDate(e.props.day);
            }), Ce(e, "render", function() {
                return he.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.props.usePointerEvent ? void 0 : e.handleMouseEnter,
                    onPointerEnter: e.props.usePointerEvent ? e.handleMouseEnter : void 0,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    title: e.getTitle(),
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected() || e.isInRange()
                }, e.renderDayContents(), "" !== e.getTitle() && he.default.createElement("span", {
                    className: "overlay"
                }, e.getTitle()));
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]);
    }(he.default.Component), Wt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "weekNumberEl", he.default.createRef()), Ce(e, "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), Ce(e, "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Ce(e, "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Ue(e.props.date, e.props.selected) && Ue(e.props.date, e.props.preSelection);
            }), Ce(e, "getTabIndex", function() {
                return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || Ue(e.props.date, e.props.selected) && Ue(e.props.preSelection, e.props.selected)) ? 0 : -1;
            }), Ce(e, "handleFocusWeekNumber", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && Ue(e.props.date, e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && e.weekNumberEl.current && e.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusWeekNumber();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusWeekNumber(e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, o = e.onClick, s = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!o,
                        "react-datepicker__week-number--selected": !!o && Ue(this.props.date, this.props.selected),
                        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
                    };
                    return he.default.createElement("div", {
                        ref: this.weekNumberEl,
                        className: n.clsx(s),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick,
                        onKeyDown: this.handleOnKeyDown,
                        tabIndex: this.getTabIndex()
                    }, t);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        ariaLabelPrefix: "week "
                    };
                }
            }
        ]);
    }(he.default.Component), Qt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Ce(e, "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Ce(e, "handleWeekClick", function(t, r, n) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, n), e.props.showWeekPicker && e.handleDayClick(t, n), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Ce(e, "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : function(e, t) {
                    var r = t && Je(t) || Ge() && Je(Ge());
                    return M.getISOWeek(e, r ? {
                        locale: r
                    } : null);
                }(t);
            }), Ce(e, "renderDays", function() {
                var t = e.startOfWeek(), r = [], n = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var a = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(e, t, n) : void 0;
                    r.push(he.default.createElement(Wt, {
                        key: "W",
                        weekNumber: n,
                        date: t,
                        onClick: a,
                        selected: e.props.selected,
                        preSelection: e.props.preSelection,
                        ariaLabelPrefix: e.props.ariaLabelPrefix,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var n = c.addDays(t, r);
                    return he.default.createElement(At, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: n.valueOf(),
                        day: n,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(e, n),
                        usePointerEvent: e.props.usePointerEvent,
                        onMouseEnter: e.handleDayMouseEnter.bind(e, n),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        calendarStartDay: e.props.calendarStartDay,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        holidays: e.props.holidays,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        selectsMultiple: e.props.selectsMultiple,
                        selectedDates: e.props.selectedDates,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), Ce(e, "startOfWeek", function() {
                return We(e.props.day, e.props.locale, e.props.calendarStartDay);
            }), Ce(e, "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Ue(e.startOfWeek(), e.props.selected) && Ue(e.startOfWeek(), e.props.preSelection);
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = {
                        "react-datepicker__week": !0,
                        "react-datepicker__week--selected": Ue(this.startOfWeek(), this.props.selected),
                        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
                    };
                    return he.default.createElement("div", {
                        className: n.clsx(e)
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]);
    }(he.default.Component), Kt = "two_columns", qt = "three_columns", Bt = "four_columns", Ht = Ce(Ce(Ce({}, Kt, {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }), qt, {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }), Bt, {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    });
    function jt(e, t) {
        return e ? Bt : t ? Kt : qt;
    }
    var Vt = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, a = new Array(r), o = 0; o < r; o++)a[o] = arguments[o];
            return Ce(e = ye(this, t, [].concat(a)), "MONTH_REFS", Ne(Array(12)).map(function() {
                return he.default.createRef();
            })), Ce(e, "QUARTER_REFS", Ne(Array(4)).map(function() {
                return he.default.createRef();
            })), Ce(e, "isDisabled", function(t) {
                return et(t, e.props);
            }), Ce(e, "isExcluded", function(t) {
                return tt(t, e.props);
            }), Ce(e, "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Ce(e, "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Ce(e, "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Ce(e, "isRangeStartMonth", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && je(x.setMonth(n, t), a);
            }), Ce(e, "isRangeStartQuarter", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && Ve(I.setQuarter(n, t), a);
            }), Ce(e, "isRangeEndMonth", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && je(x.setMonth(n, t), o);
            }), Ce(e, "isRangeEndQuarter", function(t) {
                var r = e.props, n = r.day, a = r.startDate, o = r.endDate;
                return !(!a || !o) && Ve(I.setQuarter(n, t), o);
            }), Ce(e, "isInSelectingRangeMonth", function(t) {
                var r, n = e.props, a = n.day, o = n.selectsStart, s = n.selectsEnd, i = n.selectsRange, p = n.startDate, c = n.endDate, l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !l) && (o && c ? nt(l, c, t, a) : (s && p || !(!i || !p || c)) && nt(p, l, t, a));
            }), Ce(e, "isSelectingMonthRangeStart", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var n = e.props, a = n.day, o = n.startDate, s = n.selectsStart, i = x.setMonth(a, t), p = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return je(i, s ? p : o);
            }), Ce(e, "isSelectingMonthRangeEnd", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var n = e.props, a = n.day, o = n.endDate, s = n.selectsEnd, i = n.selectsRange, p = x.setMonth(a, t), c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return je(p, s || i ? c : o);
            }), Ce(e, "isInSelectingRangeQuarter", function(t) {
                var r, n = e.props, a = n.day, o = n.selectsStart, s = n.selectsEnd, i = n.selectsRange, p = n.startDate, c = n.endDate, l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !l) && (o && c ? it(l, c, t, a) : (s && p || !(!i || !p || c)) && it(p, l, t, a));
            }), Ce(e, "isWeekInMonth", function(t) {
                var r = e.props.day, n = c.addDays(t, 6);
                return je(t, r) || je(n, r);
            }), Ce(e, "isCurrentMonth", function(e, t) {
                return Y.getYear(e) === Y.getYear(Te()) && t === C.getMonth(Te());
            }), Ce(e, "isCurrentQuarter", function(e, t) {
                return Y.getYear(e) === Y.getYear(Te()) && t === _.getQuarter(Te());
            }), Ce(e, "isSelectedMonth", function(e, t, r) {
                return C.getMonth(r) === t && Y.getYear(e) === Y.getYear(r);
            }), Ce(e, "isSelectedQuarter", function(e, t, r) {
                return _.getQuarter(e) === t && Y.getYear(e) === Y.getYear(r);
            }), Ce(e, "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, n = 0, a = !1, o = We(Qe(e.props.day), e.props.locale, e.props.calendarStartDay), s = e.props.showWeekPicker ? We(e.props.selected, e.props.locale, e.props.calendarStartDay) : e.props.selected, i = e.props.showWeekPicker ? We(e.props.preSelection, e.props.locale, e.props.calendarStartDay) : e.props.preSelection; t.push(he.default.createElement(Qt, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: n,
                    day: o,
                    month: C.getMonth(e.props.day),
                    onDayClick: e.handleDayClick,
                    usePointerEvent: e.props.usePointerEvent,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    holidays: e.props.holidays,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: i,
                    selected: s,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    selectsMultiple: e.props.selectsMultiple,
                    selectedDates: e.props.selectedDates,
                    showWeekNumber: e.props.showWeekNumbers,
                    showWeekPicker: e.props.showWeekPicker,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !a;){
                    n++, o = l.addWeeks(o, 1);
                    var p = r && n >= 6, c = !r && !e.isWeekInMonth(o);
                    if (p || c) {
                        if (!e.props.peekNextMonth) break;
                        a = !0;
                    }
                }
                return t;
            }), Ce(e, "onMonthClick", function(t, r) {
                var n = x.setMonth(e.props.day, r);
                rt(n, e.props) || e.handleDayClick(Qe(n), t);
            }), Ce(e, "onMonthMouseEnter", function(t) {
                var r = x.setMonth(e.props.day, t);
                rt(r, e.props) || e.handleDayMouseEnter(Qe(r));
            }), Ce(e, "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Ce(e, "onMonthKeyDown", function(t, r) {
                var n = e.props, a = n.selected, o = n.preSelection, s = n.disabledKeyboardNavigation, i = n.showTwoColumnMonthYearPicker, p = n.showFourColumnMonthYearPicker, c = n.setPreSelection, l = n.handleOnMonthKeyDown, u = t.key;
                if ("Tab" !== u && t.preventDefault(), !s) {
                    var h = jt(p, i), f = Ht[h].verticalNavigationOffset, m = Ht[h].grid;
                    switch(u){
                        case "Enter":
                            e.onMonthClick(t, r), c(a);
                            break;
                        case "ArrowRight":
                            e.handleMonthNavigation(11 === r ? 0 : r + 1, d.addMonths(o, 1));
                            break;
                        case "ArrowLeft":
                            e.handleMonthNavigation(0 === r ? 11 : r - 1, y.subMonths(o, 1));
                            break;
                        case "ArrowUp":
                            e.handleMonthNavigation(m[0].includes(r) ? r + 12 - f : r - f, y.subMonths(o, f));
                            break;
                        case "ArrowDown":
                            e.handleMonthNavigation(m[m.length - 1].includes(r) ? r - 12 + f : r + f, d.addMonths(o, f));
                    }
                }
                l && l(t);
            }), Ce(e, "onQuarterClick", function(t, r) {
                var n = I.setQuarter(e.props.day, r);
                at(n, e.props) || e.handleDayClick(qe(n), t);
            }), Ce(e, "onQuarterMouseEnter", function(t) {
                var r = I.setQuarter(e.props.day, t);
                at(r, e.props) || e.handleDayMouseEnter(qe(r));
            }), Ce(e, "handleQuarterNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.QUARTER_REFS[t - 1].current && e.QUARTER_REFS[t - 1].current.focus());
            }), Ce(e, "onQuarterKeyDown", function(t, r) {
                var n = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(n){
                    case "Enter":
                        e.onQuarterClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleQuarterNavigation(4 === r ? 1 : r + 1, u.addQuarters(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleQuarterNavigation(1 === r ? 4 : r - 1, g.subQuarters(e.props.preSelection, 1));
                }
            }), Ce(e, "isMonthDisabled", function(t) {
                var r = e.props, n = r.day, a = r.minDate, o = r.maxDate, s = r.excludeDates, i = r.includeDates, p = x.setMonth(n, t);
                return (a || o || s || i) && rt(p, e.props);
            }), Ce(e, "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, p = r.preSelection, c = r.monthClassName, l = c ? c(x.setMonth(a, t)) : void 0;
                return n.clsx("react-datepicker__month-text", "react-datepicker__month-".concat(t), l, {
                    "react-datepicker__month-text--disabled": e.isMonthDisabled(t),
                    "react-datepicker__month-text--selected": e.isSelectedMonth(a, t, i),
                    "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && e.isSelectedMonth(a, t, p),
                    "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(t),
                    "react-datepicker__month-text--in-range": nt(o, s, t, a),
                    "react-datepicker__month-text--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month-text--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(t),
                    "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Ce(e, "getTabIndex", function(t) {
                var r = C.getMonth(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Ce(e, "getQuarterTabIndex", function(t) {
                var r = _.getQuarter(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Ce(e, "getAriaLabel", function(t) {
                var r = e.props, n = r.chooseDayAriaLabelPrefix, a = void 0 === n ? "Choose" : n, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = r.locale, c = x.setMonth(i, t), l = e.isDisabled(c) || e.isExcluded(c) ? s : a;
                return "".concat(l, " ").concat(Le(c, "MMMM yyyy", p));
            }), Ce(e, "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, p = r.minDate, c = r.maxDate, l = r.preSelection, d = r.disabledKeyboardNavigation;
                return n.clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter-text--disabled": (p || c) && at(I.setQuarter(a, t), e.props),
                    "react-datepicker__quarter-text--selected": e.isSelectedQuarter(a, t, i),
                    "react-datepicker__quarter-text--keyboard-selected": !d && e.isSelectedQuarter(a, t, l),
                    "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(t),
                    "react-datepicker__quarter-text--in-range": it(o, s, t, a),
                    "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(t)
                });
            }), Ce(e, "getMonthContent", function(t) {
                var r = e.props, n = r.showFullMonthYearPicker, a = r.renderMonthContent, o = r.locale, s = r.day, i = Ze(t, o), p = Xe(t, o);
                return a ? a(t, i, p, s) : n ? p : i;
            }), Ce(e, "getQuarterContent", function(t) {
                var r = e.props, n = r.renderQuarterContent, a = function(e, t) {
                    return Le(I.setQuarter(Te(), e), "QQQ", t);
                }(t, r.locale);
                return n ? n(t, a) : a;
            }), Ce(e, "renderMonths", function() {
                var t = e.props, r = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, a = t.day, o = t.selected;
                return Ht[jt(n, r)].grid.map(function(t, r) {
                    return he.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, t.map(function(t, r) {
                        return he.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: r,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                _t(r) && (r.preventDefault(), r.key = "Enter"), e.onMonthKeyDown(r, t);
                            },
                            onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
                                return e.onMonthMouseEnter(t);
                            },
                            onPointerEnter: e.props.usePointerEvent ? function() {
                                return e.onMonthMouseEnter(t);
                            } : void 0,
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            "aria-disabled": e.isMonthDisabled(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(a, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(a, t, o)
                        }, e.getMonthContent(t));
                    }));
                });
            }), Ce(e, "renderQuarters", function() {
                var t = e.props, r = t.day, n = t.selected;
                return he.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, a) {
                    return he.default.createElement("div", {
                        key: a,
                        ref: e.QUARTER_REFS[a],
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        onKeyDown: function(r) {
                            e.onQuarterKeyDown(r, t);
                        },
                        onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
                            return e.onQuarterMouseEnter(t);
                        },
                        onPointerEnter: e.props.usePointerEvent ? function() {
                            return e.onQuarterMouseEnter(t);
                        } : void 0,
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, n),
                        tabIndex: e.getQuarterTabIndex(t),
                        "aria-current": e.isCurrentQuarter(r, t) ? "date" : void 0
                    }, e.getQuarterContent(t));
                }));
            }), Ce(e, "getClassNames", function() {
                var t = e.props, r = t.selectingDate, a = t.selectsStart, o = t.selectsEnd, s = t.showMonthYearPicker, i = t.showQuarterYearPicker, p = t.showWeekPicker;
                return n.clsx("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": i
                }, {
                    "react-datepicker__weekPicker": p
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, n = e.day, a = e.ariaLabelPrefix, o = void 0 === a ? "Month " : a, s = o ? o.trim() + " " : "";
                    return he.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
                        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
                        "aria-label": "".concat(s).concat(Le(n, "MMMM, yyyy", this.props.locale)),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]);
    }(he.default.Component), Ut = function(e) {
        function t() {
            var e;
            be(this, t);
            for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
            return Ce(e = ye(this, t, [].concat(n)), "state", {
                height: null
            }), Ce(e, "scrollToTheSelectedTime", function() {
                requestAnimationFrame(function() {
                    e.list && (e.list.scrollTop = e.centerLi && t.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - e.header.clientHeight : e.list.clientHeight, e.centerLi));
                });
            }), Ce(e, "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && dt(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && lt(t, e.props) || e.props.onChange(t);
            }), Ce(e, "isSelectedTime", function(t) {
                var r, n;
                return e.props.selected && (r = e.props.selected, n = t, St(r).getTime() === St(n).getTime());
            }), Ce(e, "isDisabledTime", function(t) {
                return (e.props.minTime || e.props.maxTime) && dt(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && lt(t, e.props);
            }), Ce(e, "liClasses", function(t) {
                var r = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t) : void 0
                ];
                return e.isSelectedTime(t) && r.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(t) && r.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (3600 * w.getHours(t) + 60 * k.getMinutes(t) + ie.getSeconds(t)) % (60 * e.props.intervals) != 0 && r.push("react-datepicker__time-list-item--injected"), r.join(" ");
            }), Ce(e, "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "ArrowUp" !== t.key && "ArrowLeft" !== t.key || !t.target.previousSibling || (t.preventDefault(), t.target.previousSibling.focus()), "ArrowDown" !== t.key && "ArrowRight" !== t.key || !t.target.nextSibling || (t.preventDefault(), t.target.nextSibling.focus()), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Ce(e, "renderTimes", function() {
                for(var t, r = [], n = e.props.format ? e.props.format : "p", a = e.props.intervals, o = e.props.selected || e.props.openToDate || Te(), s = (t = o, K.startOfDay(t)), p = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), c = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(o), l = c / a, d = 0; d < l; d++){
                    var u = i.addMinutes(s, d * a);
                    if (r.push(u), p) {
                        var h = kt(s, u, d, a, p);
                        r = r.concat(h);
                    }
                }
                var f = r.reduce(function(e, t) {
                    return t.getTime() <= o.getTime() ? t : e;
                }, r[0]);
                return r.map(function(t, r) {
                    return he.default.createElement("li", {
                        key: r,
                        onClick: e.handleClick.bind(e, t),
                        className: e.liClasses(t),
                        ref: function(r) {
                            t === f && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: t === f ? 0 : -1,
                        role: "option",
                        "aria-selected": e.isSelectedTime(t) ? "true" : void 0,
                        "aria-disabled": e.isDisabledTime(t) ? "true" : void 0
                    }, Le(t, n, e.props.locale));
                });
            }), e;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return he.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, he.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), he.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, he.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, he.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        role: "listbox",
                        "aria-label": this.props.timeCaption
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]);
    }(he.default.Component);
    Ce(Ut, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var $t = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "YEAR_REFS", Ne(Array(r.props.yearItemNumber)).map(function() {
                return he.default.createRef();
            })), Ce(r, "isDisabled", function(e) {
                return et(e, r.props);
            }), Ce(r, "isExcluded", function(e) {
                return tt(e, r.props);
            }), Ce(r, "selectingDate", function() {
                var e;
                return null !== (e = r.props.selectingDate) && void 0 !== e ? e : r.props.preSelection;
            }), Ce(r, "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(r);
                window.requestAnimationFrame(t);
            }), Ce(r, "handleYearClick", function(e, t) {
                r.props.onDayClick && r.props.onDayClick(e, t);
            }), Ce(r, "handleYearNavigation", function(e, t) {
                var n = r.props, a = n.date, o = n.yearItemNumber, s = bt(a, o).startPeriod;
                r.isDisabled(t) || r.isExcluded(t) || (r.props.setPreSelection(t), e - s < 0 ? r.updateFocusOnPaginate(o - (s - e)) : e - s >= o ? r.updateFocusOnPaginate(Math.abs(o - (e - s))) : r.YEAR_REFS[e - s].current.focus());
            }), Ce(r, "isSameDay", function(e, t) {
                return Ue(e, t);
            }), Ce(r, "isCurrentYear", function(e) {
                return e === Y.getYear(Te());
            }), Ce(r, "isRangeStart", function(e) {
                return r.props.startDate && r.props.endDate && He(T.setYear(Te(), e), r.props.startDate);
            }), Ce(r, "isRangeEnd", function(e) {
                return r.props.startDate && r.props.endDate && He(T.setYear(Te(), e), r.props.endDate);
            }), Ce(r, "isInRange", function(e) {
                return ot(e, r.props.startDate, r.props.endDate);
            }), Ce(r, "isInSelectingRange", function(e) {
                var t = r.props, n = t.selectsStart, a = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(n || a || o) || !r.selectingDate()) && (n && i ? ot(e, r.selectingDate(), i) : (a && s || !(!o || !s || i)) && ot(e, s, r.selectingDate()));
            }), Ce(r, "isSelectingRangeStart", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, n = t.startDate, a = t.selectsStart, o = T.setYear(Te(), e);
                return He(o, a ? r.selectingDate() : n);
            }), Ce(r, "isSelectingRangeEnd", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, n = t.endDate, a = t.selectsEnd, o = t.selectsRange, s = T.setYear(Te(), e);
                return He(s, a || o ? r.selectingDate() : n);
            }), Ce(r, "isKeyboardSelected", function(e) {
                var t = Ke(T.setYear(r.props.date, e));
                return !r.props.disabledKeyboardNavigation && !r.props.inline && !Ue(t, Ke(r.props.selected)) && Ue(t, Ke(r.props.preSelection));
            }), Ce(r, "onYearClick", function(e, t) {
                var n = r.props.date;
                r.handleYearClick(Ke(T.setYear(n, t)), e);
            }), Ce(r, "onYearKeyDown", function(e, t) {
                var n = e.key, a = r.props, o = a.date, s = a.yearItemNumber, i = a.handleOnKeyDown;
                if ("Tab" !== n && e.preventDefault(), !r.props.disabledKeyboardNavigation) switch(n){
                    case "Enter":
                        r.onYearClick(e, t), r.props.setPreSelection(r.props.selected);
                        break;
                    case "ArrowRight":
                        r.handleYearNavigation(t + 1, h.addYears(r.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        r.handleYearNavigation(t - 1, v.subYears(r.props.preSelection, 1));
                        break;
                    case "ArrowUp":
                        var p = bt(o, s).startPeriod, c = 3, l = t - c;
                        if (l < p) {
                            var d = s % c;
                            t >= p && t < p + d ? c = d : c += d, l = t - c;
                        }
                        r.handleYearNavigation(l, v.subYears(r.props.preSelection, c));
                        break;
                    case "ArrowDown":
                        var u = bt(o, s).endPeriod, f = 3, m = t + f;
                        if (m > u) {
                            var y = s % f;
                            t <= u && t > u - y ? f = y : f += y, m = t + f;
                        }
                        r.handleYearNavigation(m, h.addYears(r.props.preSelection, f));
                }
                i && i(e);
            }), Ce(r, "getYearClassNames", function(e) {
                var t = r.props, a = t.date, o = t.minDate, s = t.maxDate, i = t.selected, p = t.excludeDates, c = t.includeDates, l = t.filterDate, d = t.yearClassName;
                return n.clsx("react-datepicker__year-text", "react-datepicker__year-".concat(e), d ? d(T.setYear(a, e)) : void 0, {
                    "react-datepicker__year-text--selected": e === Y.getYear(i),
                    "react-datepicker__year-text--disabled": (o || s || p || c || l) && st(e, r.props),
                    "react-datepicker__year-text--keyboard-selected": r.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": r.isRangeStart(e),
                    "react-datepicker__year-text--range-end": r.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": r.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": r.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": r.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": r.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": r.isCurrentYear(e)
                });
            }), Ce(r, "getYearTabIndex", function(e) {
                return r.props.disabledKeyboardNavigation ? "-1" : e === Y.getYear(r.props.preSelection) ? "0" : "-1";
            }), Ce(r, "getYearContainerClassNames", function() {
                var e = r.props, t = e.selectingDate, a = e.selectsStart, o = e.selectsEnd, s = e.selectsRange;
                return n.clsx("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": t && (a || o || s)
                });
            }), Ce(r, "getYearContent", function(e) {
                return r.props.renderYearContent ? r.props.renderYearContent(e) : e;
            }), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, n = r.date, a = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave, i = bt(n, a), p = i.startPeriod, c = i.endPeriod, l = function(r) {
                        t.push(he.default.createElement("div", {
                            ref: e.YEAR_REFS[r - p],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                _t(t) && (t.preventDefault(), t.key = "Enter"), e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            onMouseEnter: e.props.usePointerEvent ? void 0 : function(e) {
                                return o(e, r);
                            },
                            onPointerEnter: e.props.usePointerEvent ? function(e) {
                                return o(e, r);
                            } : void 0,
                            onMouseLeave: e.props.usePointerEvent ? void 0 : function(e) {
                                return s(e, r);
                            },
                            onPointerLeave: e.props.usePointerEvent ? function(e) {
                                return s(e, r);
                            } : void 0,
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, e.getYearContent(r)));
                    }, d = p; d <= c; d++)l(d);
                    return he.default.createElement("div", {
                        className: this.getYearContainerClassNames()
                    }, he.default.createElement("div", {
                        className: "react-datepicker__year-wrapper",
                        onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
                        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
                    }, t));
                }
            }
        ]);
    }(he.default.Component), zt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "onTimeChange", function(e) {
                r.setState({
                    time: e
                });
                var t = r.props.date, n = t instanceof Date && !isNaN(t) ? t : new Date;
                n.setHours(e.split(":")[0]), n.setMinutes(e.split(":")[1]), r.props.onChange(n);
            }), Ce(r, "renderTimeInput", function() {
                var e = r.state.time, t = r.props, n = t.date, a = t.timeString, o = t.customTimeInput;
                return o ? he.default.cloneElement(o, {
                    date: n,
                    value: e,
                    onChange: r.onTimeChange
                }) : he.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        r.onTimeChange(e.target.value || a);
                    }
                });
            }), r.state = {
                time: r.props.timeString
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return he.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), he.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, he.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]);
    }(he.default.Component);
    function Gt(e) {
        var t = e.showTimeSelectOnly, r = void 0 !== t && t, n = e.showTime, a = void 0 !== n && n, o = e.className, s = e.children, i = r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
        return he.default.createElement("div", {
            className: o,
            role: "dialog",
            "aria-label": i,
            "aria-modal": "true"
        }, s);
    }
    var Jt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Xt = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "handleClickOutside", function(e) {
                r.props.onClickOutside(e);
            }), Ce(r, "setClickOutsideRef", function() {
                return r.containerRef.current;
            }), Ce(r, "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Jt.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && r.props.onDropdownFocus();
            }), Ce(r, "getDateInView", function() {
                var e = r.props, t = e.preSelection, n = e.selected, a = e.openToDate, o = yt(r.props), s = gt(r.props), i = Te(), p = a || n || t;
                return p || (o && re.isBefore(i, o) ? o : s && te.isAfter(i, s) ? s : i);
            }), Ce(r, "increaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: d.addMonths(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "decreaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: y.subMonths(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "handleDayClick", function(e, t, n) {
                r.props.onSelect(e, t, n), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleDayMouseEnter", function(e) {
                r.setState({
                    selectingDate: e
                }), r.props.onDayMouseEnter && r.props.onDayMouseEnter(e);
            }), Ce(r, "handleMonthMouseLeave", function() {
                r.setState({
                    selectingDate: null
                }), r.props.onMonthMouseLeave && r.props.onMonthMouseLeave();
            }), Ce(r, "handleYearMouseEnter", function(e, t) {
                r.setState({
                    selectingDate: T.setYear(Te(), t)
                }), r.props.onYearMouseEnter && r.props.onYearMouseEnter(e, t);
            }), Ce(r, "handleYearMouseLeave", function(e, t) {
                r.props.onYearMouseLeave && r.props.onYearMouseLeave(e, t);
            }), Ce(r, "handleYearChange", function(e) {
                r.props.onYearChange && (r.props.onYearChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleMonthChange", function(e) {
                r.handleCustomMonthChange(e), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Ce(r, "handleCustomMonthChange", function(e) {
                r.props.onMonthChange && (r.props.onMonthChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }), Ce(r, "handleMonthYearChange", function(e) {
                r.handleYearChange(e), r.handleMonthChange(e);
            }), Ce(r, "changeYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: T.setYear(r, e)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "changeMonth", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: x.setMonth(r, e)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Ce(r, "changeMonthYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: T.setYear(x.setMonth(r, C.getMonth(e)), Y.getYear(e))
                    };
                }, function() {
                    return r.handleMonthYearChange(r.state.date);
                });
            }), Ce(r, "header", function() {
                var e = We(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, r.props.locale, r.props.calendarStartDay), t = [];
                return r.props.showWeekNumbers && t.push(he.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, r.props.weekLabel || "#")), t.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(t) {
                    var a = c.addDays(e, t), o = r.formatWeekday(a, r.props.locale), s = r.props.weekDayClassName ? r.props.weekDayClassName(a) : void 0;
                    return he.default.createElement("div", {
                        key: t,
                        "aria-label": Le(a, "EEEE", r.props.locale),
                        className: n.clsx("react-datepicker__day-name", s)
                    }, o);
                }));
            }), Ce(r, "formatWeekday", function(e, t) {
                return r.props.formatWeekDay ? function(e, t, r) {
                    return t(Le(e, "EEEE", r));
                }(e, r.props.formatWeekDay, t) : r.props.useWeekdaysShort ? function(e, t) {
                    return Le(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Le(e, "EEEEEE", t);
                }(e, t);
            }), Ce(r, "decreaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: v.subYears(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "clearSelectingDate", function() {
                r.setState({
                    selectingDate: null
                });
            }), Ce(r, "renderPreviousButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = ft(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.yearItemNumber, a = void 0 === n ? xe : n, o = bt(Ke(v.subYears(e, a)), a).endPeriod, s = r && Y.getYear(r);
                                return s && s > o || !1;
                            }(r.state.date, r.props);
                            break;
                        case r.props.showQuarterYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = j.startOfYear(e), o = g.subQuarters(a, 1);
                                return r && Q.differenceInCalendarQuarters(r, o) > 0 || n && n.every(function(e) {
                                    return Q.differenceInCalendarQuarters(e, o) > 0;
                                }) || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = ut(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], n = r.decreaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (n = r.decreaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), n = null);
                        var a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = r.props, c = p.previousMonthAriaLabel, l = void 0 === c ? "string" == typeof s ? s : "Previous Month" : c, d = p.previousYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Previous Year" : d;
                        return he.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: n,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": a ? u : l
                        }, he.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, a ? r.props.previousYearButtonLabel : r.props.previousMonthButtonLabel));
                    }
                }
            }), Ce(r, "increaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: h.addYears(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Ce(r, "renderNextButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = mt(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.yearItemNumber, a = void 0 === n ? xe : n, o = bt(h.addYears(e, a), a).startPeriod, s = r && Y.getYear(r);
                                return s && s < o || !1;
                            }(r.state.date, r.props);
                            break;
                        case r.props.showQuarterYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = z.endOfYear(e), o = u.addQuarters(a, 1);
                                return r && Q.differenceInCalendarQuarters(o, r) > 0 || n && n.every(function(e) {
                                    return Q.differenceInCalendarQuarters(o, e) > 0;
                                }) || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = ht(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        r.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), r.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var n = r.increaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (n = r.increaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), n = null);
                        var a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = r.props, c = p.nextMonthAriaLabel, l = void 0 === c ? "string" == typeof s ? s : "Next Month" : c, d = p.nextYearAriaLabel, f = void 0 === d ? "string" == typeof i ? i : "Next Year" : d;
                        return he.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: n,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": a ? f : l
                        }, he.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, a ? r.props.nextYearButtonLabel : r.props.nextMonthButtonLabel));
                    }
                }
            }), Ce(r, "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return r.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), r.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), r.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), he.default.createElement("div", {
                    className: t.join(" ")
                }, Le(e, r.props.dateFormat, r.props.locale));
            }), Ce(r, "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showYearDropdown && !e) return he.default.createElement(Nt, {
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    date: r.state.date,
                    onSelect: r.props.onSelect,
                    setOpen: r.props.setOpen,
                    dropdownMode: r.props.dropdownMode,
                    onChange: r.changeYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    year: Y.getYear(r.state.date),
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber
                });
            }), Ce(r, "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthDropdown && !e) return he.default.createElement(It, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    onChange: r.changeMonth,
                    month: C.getMonth(r.state.date),
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown
                });
            }), Ce(r, "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthYearDropdown && !e) return he.default.createElement(Ft, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    dateFormat: r.props.dateFormat,
                    onChange: r.changeMonthYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    date: r.state.date,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown
                });
            }), Ce(r, "handleTodayButtonClick", function(e) {
                r.props.onSelect(Be(), e), r.props.setPreSelection && r.props.setPreSelection(Be());
            }), Ce(r, "renderTodayButton", function() {
                if (r.props.todayButton && !r.props.showTimeSelectOnly) return he.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return r.handleTodayButtonClick(e);
                    }
                }, r.props.todayButton);
            }), Ce(r, "renderDefaultHeader", function(e) {
                var t = e.monthDate, n = e.i;
                return he.default.createElement("div", {
                    className: "react-datepicker__header ".concat(r.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, r.renderCurrentMonth(t), he.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),
                    onFocus: r.handleDropdownFocus
                }, r.renderMonthDropdown(0 !== n), r.renderMonthYearDropdown(0 !== n), r.renderYearDropdown(0 !== n)), he.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Ce(r, "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, n = e.i;
                if (r.props.showTimeSelect && !r.state.monthContainer || r.props.showTimeSelectOnly) return null;
                var a = ut(r.state.date, r.props), o = ht(r.state.date, r.props), s = ft(r.state.date, r.props), i = mt(r.state.date, r.props), p = !r.props.showMonthYearPicker && !r.props.showQuarterYearPicker && !r.props.showYearPicker;
                return he.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: r.props.onDropdownFocus
                }, r.props.renderCustomHeader(De(De({}, r.state), {}, {
                    customHeaderCount: n,
                    monthDate: t,
                    changeMonth: r.changeMonth,
                    changeYear: r.changeYear,
                    decreaseMonth: r.decreaseMonth,
                    increaseMonth: r.increaseMonth,
                    decreaseYear: r.decreaseYear,
                    increaseYear: r.increaseYear,
                    prevMonthButtonDisabled: a,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && he.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Ce(r, "renderYearHeader", function(e) {
                var t = e.monthDate, n = r.props, a = n.showYearPicker, o = bt(t, n.yearItemNumber), s = o.startPeriod, i = o.endPeriod;
                return he.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, a ? "".concat(s, " - ").concat(i) : Y.getYear(t));
            }), Ce(r, "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== r.props.renderCustomHeader:
                        return r.renderCustomHeader(e);
                    case r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker:
                        return r.renderYearHeader(e);
                    default:
                        return r.renderDefaultHeader(e);
                }
            }), Ce(r, "renderMonths", function() {
                var e;
                if (!r.props.showTimeSelectOnly && !r.props.showYearPicker) {
                    for(var t = [], n = r.props.showPreviousMonths ? r.props.monthsShown - 1 : 0, a = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? h.addYears(r.state.date, n) : y.subMonths(r.state.date, n), o = null !== (e = r.props.monthSelectedIn) && void 0 !== e ? e : n, s = 0; s < r.props.monthsShown; ++s){
                        var i = s - o + n, p = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? h.addYears(a, i) : d.addMonths(a, i), c = "month-".concat(s), l = s < r.props.monthsShown - 1, u = s > 0;
                        t.push(he.default.createElement("div", {
                            key: c,
                            ref: function(e) {
                                r.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, r.renderHeader({
                            monthDate: p,
                            i: s
                        }), he.default.createElement(Vt, {
                            chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: r.props.monthAriaLabelPrefix,
                            onChange: r.changeMonthYear,
                            day: p,
                            dayClassName: r.props.dayClassName,
                            calendarStartDay: r.props.calendarStartDay,
                            monthClassName: r.props.monthClassName,
                            onDayClick: r.handleDayClick,
                            handleOnKeyDown: r.props.handleOnDayKeyDown,
                            handleOnMonthKeyDown: r.props.handleOnKeyDown,
                            usePointerEvent: r.props.usePointerEvent,
                            onDayMouseEnter: r.handleDayMouseEnter,
                            onMouseLeave: r.handleMonthMouseLeave,
                            onWeekSelect: r.props.onWeekSelect,
                            orderInDisplay: s,
                            formatWeekNumber: r.props.formatWeekNumber,
                            locale: r.props.locale,
                            minDate: r.props.minDate,
                            maxDate: r.props.maxDate,
                            excludeDates: r.props.excludeDates,
                            excludeDateIntervals: r.props.excludeDateIntervals,
                            highlightDates: r.props.highlightDates,
                            holidays: r.props.holidays,
                            selectingDate: r.state.selectingDate,
                            includeDates: r.props.includeDates,
                            includeDateIntervals: r.props.includeDateIntervals,
                            inline: r.props.inline,
                            shouldFocusDayInline: r.props.shouldFocusDayInline,
                            fixedHeight: r.props.fixedHeight,
                            filterDate: r.props.filterDate,
                            preSelection: r.props.preSelection,
                            setPreSelection: r.props.setPreSelection,
                            selected: r.props.selected,
                            selectsStart: r.props.selectsStart,
                            selectsEnd: r.props.selectsEnd,
                            selectsRange: r.props.selectsRange,
                            selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                            selectsMultiple: r.props.selectsMultiple,
                            selectedDates: r.props.selectedDates,
                            showWeekNumbers: r.props.showWeekNumbers,
                            startDate: r.props.startDate,
                            endDate: r.props.endDate,
                            peekNextMonth: r.props.peekNextMonth,
                            setOpen: r.props.setOpen,
                            shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                            renderDayContents: r.props.renderDayContents,
                            renderMonthContent: r.props.renderMonthContent,
                            renderQuarterContent: r.props.renderQuarterContent,
                            renderYearContent: r.props.renderYearContent,
                            disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                            showMonthYearPicker: r.props.showMonthYearPicker,
                            showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                            showYearPicker: r.props.showYearPicker,
                            showQuarterYearPicker: r.props.showQuarterYearPicker,
                            showWeekPicker: r.props.showWeekPicker,
                            isInputFocused: r.props.isInputFocused,
                            containerRef: r.containerRef,
                            monthShowsDuplicateDaysEnd: l,
                            monthShowsDuplicateDaysStart: u
                        })));
                    }
                    return t;
                }
            }), Ce(r, "renderYears", function() {
                if (!r.props.showTimeSelectOnly) return r.props.showYearPicker ? he.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, r.renderHeader({
                    monthDate: r.state.date
                }), he.default.createElement($t, _e({
                    onDayClick: r.handleDayClick,
                    selectingDate: r.state.selectingDate,
                    clearSelectingDate: r.clearSelectingDate,
                    date: r.state.date
                }, r.props, {
                    onYearMouseEnter: r.handleYearMouseEnter,
                    onYearMouseLeave: r.handleYearMouseLeave
                }))) : void 0;
            }), Ce(r, "renderTimeSection", function() {
                if (r.props.showTimeSelect && (r.state.monthContainer || r.props.showTimeSelectOnly)) return he.default.createElement(Ut, {
                    selected: r.props.selected,
                    openToDate: r.props.openToDate,
                    onChange: r.props.onTimeChange,
                    timeClassName: r.props.timeClassName,
                    format: r.props.timeFormat,
                    includeTimes: r.props.includeTimes,
                    intervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    todayButton: r.props.todayButton,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    monthRef: r.state.monthContainer,
                    injectTimes: r.props.injectTimes,
                    locale: r.props.locale,
                    handleOnKeyDown: r.props.handleOnKeyDown,
                    showTimeSelectOnly: r.props.showTimeSelectOnly
                });
            }), Ce(r, "renderInputTimeSection", function() {
                var e = new Date(r.props.selected), t = Re(e) && Boolean(r.props.selected) ? "".concat(wt(e.getHours()), ":").concat(wt(e.getMinutes())) : "";
                if (r.props.showTimeInput) return he.default.createElement(zt, {
                    date: e,
                    timeString: t,
                    timeInputLabel: r.props.timeInputLabel,
                    onChange: r.props.onTimeChange,
                    customTimeInput: r.props.customTimeInput
                });
            }), Ce(r, "renderAriaLiveRegion", function() {
                var e, t = bt(r.state.date, r.props.yearItemNumber), n = t.startPeriod, a = t.endPeriod;
                return e = r.props.showYearPicker ? "".concat(n, " - ").concat(a) : r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? Y.getYear(r.state.date) : "".concat(Xe(C.getMonth(r.state.date), r.props.locale), " ").concat(Y.getYear(r.state.date)), he.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, r.state.isRenderAriaLiveMessage && e);
            }), Ce(r, "renderChildren", function() {
                if (r.props.children) return he.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, r.props.children);
            }), r.containerRef = he.default.createRef(), r.state = {
                date: r.getDateInView(),
                selectingDate: null,
                monthContainer: null,
                isRenderAriaLiveMessage: !1
            }, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    var t = this;
                    if (!this.props.preSelection || Ue(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Ue(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                    else {
                        var r = !je(this.state.date, this.props.preSelection);
                        this.setState({
                            date: this.props.preSelection
                        }, function() {
                            return r && t.handleCustomMonthChange(t.state.date);
                        });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Gt;
                    return he.default.createElement("div", {
                        style: {
                            display: "contents"
                        },
                        ref: this.containerRef
                    }, he.default.createElement(e, {
                        className: n.clsx("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showTime: this.props.showTimeSelect || this.props.showTimeInput,
                        showTimeSelectOnly: this.props.showTimeSelectOnly
                    }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: xe
                    };
                }
            }
        ]);
    }(he.default.Component), Zt = function(e) {
        var t = e.icon, r = e.className, n = void 0 === r ? "" : r, a = e.onClick, o = "react-datepicker__calendar-icon";
        return he.default.isValidElement(t) ? he.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(n),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof a && a(e);
            }
        }) : "string" == typeof t ? he.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(n),
            "aria-hidden": "true",
            onClick: a
        }) : he.default.createElement("svg", {
            className: "".concat(o, " ").concat(n),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: a
        }, he.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, er = function(e) {
        function t(e) {
            var r;
            return be(this, t), (r = ye(this, t, [
                e
            ])).el = document.createElement("div"), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return me.default.createPortal(this.props.children, this.el);
                }
            }
        ]);
    }(he.default.Component), tr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, rr = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "getTabChildren", function() {
                return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(tr);
            }), Ce(r, "handleFocusStart", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }), Ce(r, "handleFocusEnd", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }), r.tabLoopRef = he.default.createRef(), r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? he.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, he.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, he.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]);
    }(he.default.Component);
    var nr, ar = function(e) {
        function t() {
            return be(this, t), ye(this, t, arguments);
        }
        return Ye(t, e), Me(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, o = t.hidePopper, s = t.popperComponent, i = t.targetComponent, p = t.enableTabLoop, c = t.popperOnKeyDown, l = t.portalId, d = t.portalHost, u = t.popperProps, h = t.showArrow;
                    if (!o) {
                        var f = n.clsx("react-datepicker-popper", r);
                        e = he.default.createElement(rr, {
                            enableTabLoop: p
                        }, he.default.createElement("div", {
                            ref: u.refs.setFloating,
                            style: u.floatingStyles,
                            className: f,
                            "data-placement": u.placement,
                            onKeyDown: c
                        }, s, h && he.default.createElement(le.FloatingArrow, {
                            ref: u.arrowRef,
                            context: u.context,
                            fill: "currentColor",
                            strokeWidth: 1,
                            height: 8,
                            width: 16,
                            style: {
                                transform: "translateY(-1px)"
                            },
                            className: "react-datepicker__triangle"
                        })));
                    }
                    this.props.popperContainer && (e = he.default.createElement(this.props.popperContainer, {}, e)), l && !o && (e = he.default.createElement(er, {
                        portalId: l,
                        portalHost: d
                    }, e));
                    var m = n.clsx("react-datepicker-wrapper", a);
                    return he.default.createElement(he.default.Fragment, null, he.default.createElement("div", {
                        ref: u.refs.setReference,
                        className: m
                    }, i), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0
                    };
                }
            }
        ]);
    }(he.default.Component), or = (nr = ar, function(e) {
        var t = De(De({}, e), {}, {
            popperModifiers: e.popperModifiers || [],
            popperProps: e.popperProps || {},
            hidePopper: "boolean" != typeof e.hidePopper || e.hidePopper
        }), r = he.default.useRef(), n = le.useFloating(De({
            open: !t.hidePopper,
            whileElementsMounted: le.autoUpdate,
            placement: t.popperPlacement,
            middleware: [
                le.flip({
                    padding: 15
                }),
                le.offset(10),
                le.arrow({
                    element: r
                })
            ].concat(Ne(t.popperModifiers))
        }, t.popperProps));
        return he.default.createElement(nr, _e({}, t, {
            popperProps: De(De({}, n), {}, {
                arrowRef: r
            })
        }));
    }), sr = "react-datepicker-ignore-onclickoutside", ir = fe.default(Xt);
    var pr = "Date input not valid.", cr = function(e) {
        function t(e) {
            var r;
            return be(this, t), Ce(r = ye(this, t, [
                e
            ]), "getPreSelection", function() {
                return r.props.openToDate ? r.props.openToDate : r.props.selectsEnd && r.props.startDate ? r.props.startDate : r.props.selectsStart && r.props.endDate ? r.props.endDate : Te();
            }), Ce(r, "modifyHolidays", function() {
                var e;
                return null === (e = r.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return o.isValid(r) ? [].concat(Ne(e), [
                        De(De({}, t), {}, {
                            date: r
                        })
                    ]) : e;
                }, []);
            }), Ce(r, "calcInitialState", function() {
                var e, t = r.getPreSelection(), n = yt(r.props), a = gt(r.props), o = n && re.isBefore(t, K.startOfDay(n)) ? n : a && te.isAfter(t, V.endOfDay(a)) ? a : t;
                return {
                    open: r.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = r.props.selectsRange ? r.props.startDate : r.props.selected) && void 0 !== e ? e : o,
                    highlightDates: vt(r.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1
                };
            }), Ce(r, "clearPreventFocusTimeout", function() {
                r.preventFocusTimeout && clearTimeout(r.preventFocusTimeout);
            }), Ce(r, "setFocus", function() {
                r.input && r.input.focus && r.input.focus({
                    preventScroll: !0
                });
            }), Ce(r, "setBlur", function() {
                r.input && r.input.blur && r.input.blur(), r.cancelFocusInput();
            }), Ce(r, "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                r.setState({
                    open: e,
                    preSelection: e && r.state.open ? r.state.preSelection : r.calcInitialState().preSelection,
                    lastPreSelectChange: dr
                }, function() {
                    e || r.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && r.setBlur(), r.setState({
                            inputValue: null
                        });
                    });
                });
            }), Ce(r, "inputOk", function() {
                return a.isDate(r.state.preSelection);
            }), Ce(r, "isCalendarOpen", function() {
                return void 0 === r.props.open ? r.state.open && !r.props.disabled && !r.props.readOnly : r.props.open;
            }), Ce(r, "handleFocus", function(e) {
                r.state.preventFocus || (r.props.onFocus(e), r.props.preventOpenOnFocus || r.props.readOnly || r.setOpen(!0)), r.setState({
                    focused: !0
                });
            }), Ce(r, "sendFocusBackToInput", function() {
                r.preventFocusTimeout && r.clearPreventFocusTimeout(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.preventFocusTimeout = setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                });
            }), Ce(r, "cancelFocusInput", function() {
                clearTimeout(r.inputFocusTimeout), r.inputFocusTimeout = null;
            }), Ce(r, "deferFocusInput", function() {
                r.cancelFocusInput(), r.inputFocusTimeout = setTimeout(function() {
                    return r.setFocus();
                }, 1);
            }), Ce(r, "handleDropdownFocus", function() {
                r.cancelFocusInput();
            }), Ce(r, "handleBlur", function(e) {
                (!r.state.open || r.props.withPortal || r.props.showTimeInput) && r.props.onBlur(e), r.setState({
                    focused: !1
                });
            }), Ce(r, "handleCalendarClickOutside", function(e) {
                r.props.inline || r.setOpen(!1), r.props.onClickOutside(e), r.props.withPortal && e.preventDefault();
            }), Ce(r, "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                var a = t[0];
                if (!r.props.onChangeRaw || (r.props.onChangeRaw.apply(r, t), "function" == typeof a.isDefaultPrevented && !a.isDefaultPrevented())) {
                    r.setState({
                        inputValue: a.target.value,
                        lastPreSelectChange: lr
                    });
                    var o, i, p, c, l, d, u, h, f = (o = a.target.value, i = r.props.dateFormat, p = r.props.locale, c = r.props.strictParsing, l = r.props.minDate, d = null, u = Je(p) || Je(Ge()), h = !0, Array.isArray(i) ? (i.forEach(function(e) {
                        var t = oe.parse(o, e, new Date, {
                            locale: u,
                            useAdditionalWeekYearTokens: !0,
                            useAdditionalDayOfYearTokens: !0
                        });
                        c && (h = Re(t, l) && o === Le(t, e, p)), Re(t, l) && h && (d = t);
                    }), d) : (d = oe.parse(o, i, new Date, {
                        locale: u,
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    }), c ? h = Re(d) && o === Le(d, i, p) : Re(d) || (i = i.match(Ie).map(function(e) {
                        var t = e[0];
                        if ("p" === t || "P" === t) {
                            var r = s.longFormatters[t];
                            return u ? r(e, u.formatLong) : t;
                        }
                        return e;
                    }).join(""), o.length > 0 && (d = oe.parse(o, i.slice(0, o.length), new Date, {
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    })), Re(d) || (d = new Date(o))), Re(d) && h ? d : null));
                    r.props.showTimeSelectOnly && r.props.selected && f && !Ue(f, r.props.selected) && (f = de.set(r.props.selected, {
                        hours: w.getHours(f),
                        minutes: k.getMinutes(f),
                        seconds: D.getSeconds(f)
                    })), !f && a.target.value || r.setSelected(f, a, !0);
                }
            }), Ce(r, "handleSelect", function(e, t, n) {
                if (r.props.shouldCloseOnSelect && !r.props.showTimeSelect && r.sendFocusBackToInput(), r.props.onChangeRaw && r.props.onChangeRaw(t), r.setSelected(e, t, !1, n), r.props.showDateSelect && r.setState({
                    isRenderAriaLiveMessage: !0
                }), !r.props.shouldCloseOnSelect || r.props.showTimeSelect) r.setPreSelection(e);
                else if (!r.props.inline) {
                    r.props.selectsRange || r.setOpen(!1);
                    var a = r.props, o = a.startDate, s = a.endDate;
                    !o || s || !r.props.swapRange && Ct(e, o) || r.setOpen(!1);
                }
            }), Ce(r, "setSelected", function(e, t, n, a) {
                var o = e;
                if (r.props.showYearPicker) {
                    if (null !== o && st(Y.getYear(o), r.props)) return;
                } else if (r.props.showMonthYearPicker) {
                    if (null !== o && rt(o, r.props)) return;
                } else if (null !== o && et(o, r.props)) return;
                var s = r.props, i = s.onChange, p = s.selectsRange, c = s.startDate, l = s.endDate, d = s.selectsMultiple, u = s.selectedDates, h = s.minTime, f = s.swapRange;
                if (!$e(r.props.selected, o) || r.props.allowSameDay || p || d) {
                    if (null !== o && (!r.props.selected || n && (r.props.showTimeSelect || r.props.showTimeSelectOnly || r.props.showTimeInput) || (o = Ae(o, {
                        hour: w.getHours(r.props.selected),
                        minute: k.getMinutes(r.props.selected),
                        second: D.getSeconds(r.props.selected)
                    })), n || !r.props.showTimeSelect && !r.props.showTimeSelectOnly || h && (o = Ae(o, {
                        hour: h.getHours(),
                        minute: h.getMinutes(),
                        second: h.getSeconds()
                    })), r.props.inline || r.setState({
                        preSelection: o
                    }), r.props.focusSelectedMonth || r.setState({
                        monthSelectedIn: a
                    })), p) {
                        var m = c && !l, y = c && l;
                        !c && !l ? i([
                            o,
                            null
                        ], t) : m && (null === o ? i([
                            null,
                            null
                        ], t) : Ct(o, c) ? i(f ? [
                            o,
                            c
                        ] : [
                            o,
                            null
                        ], t) : i([
                            c,
                            o
                        ], t)), y && i([
                            o,
                            null
                        ], t);
                    } else if (d) {
                        if (null != u && u.length) {
                            if (u.some(function(e) {
                                return Ue(e, o);
                            })) i(u.filter(function(e) {
                                return !Ue(e, o);
                            }), t);
                            else i([].concat(Ne(u), [
                                o
                            ]), t);
                        } else i([
                            o
                        ], t);
                    } else i(o, t);
                }
                n || (r.props.onSelect(o, t), r.setState({
                    inputValue: null
                }));
            }), Ce(r, "setPreSelection", function(e) {
                var t = void 0 !== r.props.minDate, n = void 0 !== r.props.maxDate, a = !0;
                if (e) {
                    var o = K.startOfDay(e);
                    if (t && n) a = ze(e, r.props.minDate, r.props.maxDate);
                    else if (t) {
                        var s = K.startOfDay(r.props.minDate);
                        a = te.isAfter(e, s) || $e(o, s);
                    } else if (n) {
                        var i = V.endOfDay(r.props.maxDate);
                        a = re.isBefore(e, i) || $e(o, i);
                    }
                }
                a && r.setState({
                    preSelection: e
                });
            }), Ce(r, "toggleCalendar", function() {
                r.setOpen(!r.state.open);
            }), Ce(r, "handleTimeChange", function(e) {
                var t = r.props.selected ? r.props.selected : r.getPreSelection(), n = r.props.selected ? e : Ae(t, {
                    hour: w.getHours(e),
                    minute: k.getMinutes(e)
                });
                r.setState({
                    preSelection: n
                }), r.props.onChange(n), r.props.shouldCloseOnSelect && (r.sendFocusBackToInput(), r.setOpen(!1)), r.props.showTimeInput && r.setOpen(!0), (r.props.showTimeSelectOnly || r.props.showTimeSelect) && r.setState({
                    isRenderAriaLiveMessage: !0
                }), r.setState({
                    inputValue: null
                });
            }), Ce(r, "onInputClick", function() {
                r.props.disabled || r.props.readOnly || r.setOpen(!0), r.props.onInputClick();
            }), Ce(r, "onInputKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t = e.key;
                if (r.state.open || r.props.inline || r.props.preventOpenOnFocus) {
                    if (r.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var n = r.props.showWeekPicker && r.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : r.props.showFullMonthYearPicker || r.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', a = r.calendar.componentNode && r.calendar.componentNode.querySelector(n);
                            return void (a && a.focus({
                                preventScroll: !0
                            }));
                        }
                        var o = Te(r.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), r.inputOk() && r.state.lastPreSelectChange === dr ? (r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o)) : r.setOpen(!1)) : "Escape" === t ? (e.preventDefault(), r.sendFocusBackToInput(), r.setOpen(!1)) : "Tab" === t && r.setOpen(!1), r.inputOk() || r.props.onInputError({
                            code: 1,
                            msg: pr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || r.onInputClick();
            }), Ce(r, "onPortalKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.setOpen(!1), setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Ce(r, "onDayKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t, n = e.key, a = e.shiftKey, o = Te(r.state.preSelection);
                if ("Enter" === n) e.preventDefault(), r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o);
                else if ("Escape" === n) e.preventDefault(), r.setOpen(!1), r.inputOk() || r.props.onInputError({
                    code: 1,
                    msg: pr
                });
                else if (!r.props.disabledKeyboardNavigation) {
                    var s;
                    switch(n){
                        case "ArrowLeft":
                            s = r.props.showWeekPicker ? m.subWeeks(o, 1) : f.subDays(o, 1);
                            break;
                        case "ArrowRight":
                            s = r.props.showWeekPicker ? l.addWeeks(o, 1) : c.addDays(o, 1);
                            break;
                        case "ArrowUp":
                            s = m.subWeeks(o, 1);
                            break;
                        case "ArrowDown":
                            s = l.addWeeks(o, 1);
                            break;
                        case "PageUp":
                            s = a ? v.subYears(o, 1) : y.subMonths(o, 1);
                            break;
                        case "PageDown":
                            s = a ? h.addYears(o, 1) : d.addMonths(o, 1);
                            break;
                        case "Home":
                            s = We(o, r.props.locale, r.props.calendarStartDay);
                            break;
                        case "End":
                            t = o, s = U.endOfWeek(t);
                            break;
                        default:
                            s = null;
                    }
                    if (!s) return void (r.props.onInputError && r.props.onInputError({
                        code: 1,
                        msg: pr
                    }));
                    if (e.preventDefault(), r.setState({
                        lastPreSelectChange: dr
                    }), r.props.adjustDateOnChange && r.setSelected(s), r.setPreSelection(s), r.props.inline) {
                        var i = C.getMonth(o), p = C.getMonth(s), u = Y.getYear(o), g = Y.getYear(s);
                        i !== p || u !== g ? r.setState({
                            shouldFocusDayInline: !0
                        }) : r.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Ce(r, "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.sendFocusBackToInput());
            }), Ce(r, "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), r.sendFocusBackToInput(), r.props.selectsRange ? r.props.onChange([
                    null,
                    null
                ], e) : r.props.onChange(null, e), r.setState({
                    inputValue: null
                });
            }), Ce(r, "clear", function() {
                r.onClearClick();
            }), Ce(r, "onScroll", function(e) {
                "boolean" == typeof r.props.closeOnScroll && r.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || r.setOpen(!1) : "function" == typeof r.props.closeOnScroll && r.props.closeOnScroll(e) && r.setOpen(!1);
            }), Ce(r, "renderCalendar", function() {
                return r.props.inline || r.isCalendarOpen() ? he.default.createElement(ir, {
                    ref: function(e) {
                        r.calendar = e;
                    },
                    locale: r.props.locale,
                    calendarStartDay: r.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: r.props.monthAriaLabelPrefix,
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    setOpen: r.setOpen,
                    shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                    dateFormat: r.props.dateFormatCalendar,
                    useWeekdaysShort: r.props.useWeekdaysShort,
                    formatWeekDay: r.props.formatWeekDay,
                    dropdownMode: r.props.dropdownMode,
                    selected: r.props.selected,
                    preSelection: r.state.preSelection,
                    onSelect: r.handleSelect,
                    onWeekSelect: r.props.onWeekSelect,
                    openToDate: r.props.openToDate,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    selectsStart: r.props.selectsStart,
                    selectsEnd: r.props.selectsEnd,
                    selectsRange: r.props.selectsRange,
                    selectsMultiple: r.props.selectsMultiple,
                    selectedDates: r.props.selectedDates,
                    startDate: r.props.startDate,
                    endDate: r.props.endDate,
                    excludeDates: r.props.excludeDates,
                    excludeDateIntervals: r.props.excludeDateIntervals,
                    filterDate: r.props.filterDate,
                    onClickOutside: r.handleCalendarClickOutside,
                    formatWeekNumber: r.props.formatWeekNumber,
                    highlightDates: r.state.highlightDates,
                    holidays: Dt(r.modifyHolidays()),
                    includeDates: r.props.includeDates,
                    includeDateIntervals: r.props.includeDateIntervals,
                    includeTimes: r.props.includeTimes,
                    injectTimes: r.props.injectTimes,
                    inline: r.props.inline,
                    shouldFocusDayInline: r.state.shouldFocusDayInline,
                    peekNextMonth: r.props.peekNextMonth,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showPreviousMonths: r.props.showPreviousMonths,
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showWeekNumbers: r.props.showWeekNumbers,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    forceShowMonthNavigation: r.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: r.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown,
                    todayButton: r.props.todayButton,
                    weekLabel: r.props.weekLabel,
                    outsideClickIgnoreClass: sr,
                    fixedHeight: r.props.fixedHeight,
                    monthsShown: r.props.monthsShown,
                    monthSelectedIn: r.state.monthSelectedIn,
                    onDropdownFocus: r.handleDropdownFocus,
                    onMonthChange: r.props.onMonthChange,
                    onYearChange: r.props.onYearChange,
                    dayClassName: r.props.dayClassName,
                    weekDayClassName: r.props.weekDayClassName,
                    monthClassName: r.props.monthClassName,
                    timeClassName: r.props.timeClassName,
                    showDateSelect: r.props.showDateSelect,
                    showTimeSelect: r.props.showTimeSelect,
                    showTimeSelectOnly: r.props.showTimeSelectOnly,
                    onTimeChange: r.handleTimeChange,
                    timeFormat: r.props.timeFormat,
                    timeIntervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    className: r.props.calendarClassName,
                    container: r.props.calendarContainer,
                    yearItemNumber: r.props.yearItemNumber,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: r.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: r.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: r.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: r.props.nextMonthButtonLabel,
                    previousYearAriaLabel: r.props.previousYearAriaLabel,
                    previousYearButtonLabel: r.props.previousYearButtonLabel,
                    nextYearAriaLabel: r.props.nextYearAriaLabel,
                    nextYearButtonLabel: r.props.nextYearButtonLabel,
                    timeInputLabel: r.props.timeInputLabel,
                    disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                    renderCustomHeader: r.props.renderCustomHeader,
                    popperProps: r.props.popperProps,
                    renderDayContents: r.props.renderDayContents,
                    renderMonthContent: r.props.renderMonthContent,
                    renderQuarterContent: r.props.renderQuarterContent,
                    renderYearContent: r.props.renderYearContent,
                    onDayMouseEnter: r.props.onDayMouseEnter,
                    onMonthMouseLeave: r.props.onMonthMouseLeave,
                    onYearMouseEnter: r.props.onYearMouseEnter,
                    onYearMouseLeave: r.props.onYearMouseLeave,
                    selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                    showTimeInput: r.props.showTimeInput,
                    showMonthYearPicker: r.props.showMonthYearPicker,
                    showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                    showYearPicker: r.props.showYearPicker,
                    showQuarterYearPicker: r.props.showQuarterYearPicker,
                    showWeekPicker: r.props.showWeekPicker,
                    excludeScrollbar: r.props.excludeScrollbar,
                    handleOnKeyDown: r.props.onKeyDown,
                    handleOnDayKeyDown: r.onDayKeyDown,
                    isInputFocused: r.state.focused,
                    customTimeInput: r.props.customTimeInput,
                    setPreSelection: r.setPreSelection,
                    usePointerEvent: r.props.usePointerEvent,
                    yearClassName: r.props.yearClassName
                }, r.props.children) : null;
            }), Ce(r, "renderAriaLiveRegion", function() {
                var e, t = r.props, n = t.dateFormat, a = t.locale, o = r.props.showTimeInput || r.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = r.props.selectsRange ? "Selected start date: ".concat(Fe(r.props.startDate, {
                    dateFormat: o,
                    locale: a
                }), ". ").concat(r.props.endDate ? "End date: " + Fe(r.props.endDate, {
                    dateFormat: o,
                    locale: a
                }) : "") : r.props.showTimeSelectOnly ? "Selected time: ".concat(Fe(r.props.selected, {
                    dateFormat: n,
                    locale: a
                })) : r.props.showYearPicker ? "Selected year: ".concat(Fe(r.props.selected, {
                    dateFormat: "yyyy",
                    locale: a
                })) : r.props.showMonthYearPicker ? "Selected month: ".concat(Fe(r.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: a
                })) : r.props.showQuarterYearPicker ? "Selected quarter: ".concat(Fe(r.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: a
                })) : "Selected date: ".concat(Fe(r.props.selected, {
                    dateFormat: o,
                    locale: a
                })), he.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }), Ce(r, "renderDateInput", function() {
                var e, t = n.clsx(r.props.className, Ce({}, sr, r.state.open)), a = r.props.customInput || he.default.createElement("input", {
                    type: "text"
                }), o = r.props.customInputRef || "ref", s = "string" == typeof r.props.value ? r.props.value : "string" == typeof r.state.inputValue ? r.state.inputValue : r.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var n = Fe(e, r), a = t ? Fe(t, r) : "";
                    return "".concat(n, " - ").concat(a);
                }(r.props.startDate, r.props.endDate, r.props) : r.props.selectsMultiple ? function(e, t) {
                    if (null == e || !e.length) return "";
                    var r = Fe(e[0], t);
                    if (1 === e.length) return r;
                    if (2 === e.length) {
                        var n = Fe(e[1], t);
                        return "".concat(r, ", ").concat(n);
                    }
                    var a = e.length - 1;
                    return "".concat(r, " (+").concat(a, ")");
                }(r.props.selectedDates, r.props) : Fe(r.props.selected, r.props);
                return he.default.cloneElement(a, (Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(e = {}, o, function(e) {
                    r.input = e;
                }), "value", s), "onBlur", r.handleBlur), "onChange", r.handleChange), "onClick", r.onInputClick), "onFocus", r.handleFocus), "onKeyDown", r.onInputKeyDown), "id", r.props.id), "name", r.props.name), "form", r.props.form), Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(Ce(e, "autoFocus", r.props.autoFocus), "placeholder", r.props.placeholderText), "disabled", r.props.disabled), "autoComplete", r.props.autoComplete), "className", n.clsx(a.props.className, t)), "title", r.props.title), "readOnly", r.props.readOnly), "required", r.props.required), "tabIndex", r.props.tabIndex), "aria-describedby", r.props.ariaDescribedBy), Ce(Ce(Ce(e, "aria-invalid", r.props.ariaInvalid), "aria-labelledby", r.props.ariaLabelledBy), "aria-required", r.props.ariaRequired)));
            }), Ce(r, "renderClearButton", function() {
                var e = r.props, t = e.isClearable, a = e.disabled, o = e.selected, s = e.startDate, i = e.endDate, p = e.clearButtonTitle, c = e.clearButtonClassName, l = void 0 === c ? "" : c, d = e.ariaLabelClose, u = void 0 === d ? "Close" : d, h = e.selectedDates;
                return t && (null != o || null != s || null != i || null != h && h.length) ? he.default.createElement("button", {
                    type: "button",
                    className: n.clsx("react-datepicker__close-icon", l, {
                        "react-datepicker__close-icon--disabled": a
                    }),
                    disabled: a,
                    "aria-label": u,
                    onClick: r.onClearClick,
                    title: p,
                    tabIndex: -1
                }) : null;
            }), r.state = r.calcInitialState(), r.preventFocusTimeout = null, r;
        }
        return Ye(t, e), Me(t, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, n;
                    e.inline && (r = e.selected, n = this.props.selected, r && n ? C.getMonth(r) !== C.getMonth(n) || Y.getYear(r) !== Y.getYear(n) : r !== n) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: vt(this.props.highlightDates)
                    }), t.focused || $e(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    var e = this.props, t = e.showIcon, r = e.icon, n = e.calendarIconClassname, a = e.toggleCalendarOnIconClick, o = this.state.open;
                    return he.default.createElement("div", {
                        className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "")
                    }, t && he.default.createElement(Zt, _e({
                        icon: r,
                        className: "".concat(n, " ").concat(o && "react-datepicker-ignore-onclickoutside")
                    }, a ? {
                        onClick: this.toggleCalendar
                    } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? he.default.createElement(rr, {
                            enableTabLoop: this.props.enableTabLoop
                        }, he.default.createElement("div", {
                            className: "react-datepicker__portal",
                            tabIndex: -1,
                            onKeyDown: this.onPortalKeyDown
                        }, e)) : null;
                        return this.state.open && this.props.portalId && (t = he.default.createElement(er, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), he.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return he.default.createElement(or, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop,
                        showArrow: this.props.showPopperArrow
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        showWeekPicker: !1,
                        strictParsing: !1,
                        swapRange: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: xe,
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0,
                        toggleCalendarOnIconClick: !1,
                        usePointerEvent: !1
                    };
                }
            }
        ]);
    }(he.default.Component), lr = "input", dr = "navigate";
    e.CalendarContainer = Gt, e.default = cr, e.getDefaultLocale = Ge, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});
parcelRegister("9QePP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("26SSu", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $1896b5e28554d57b$export$871608497c498473, (v) => $1896b5e28554d57b$export$871608497c498473 = v);
var $1896b5e28554d57b$export$871608497c498473;
"use strict";
$1896b5e28554d57b$export$871608497c498473 = $1896b5e28554d57b$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $1896b5e28554d57b$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});

parcelRegister("kPCB6", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $f2a682b251363bc2$export$1ea939691cdc45b8, (v) => $f2a682b251363bc2$export$1ea939691cdc45b8 = v);
var $f2a682b251363bc2$export$1ea939691cdc45b8;
"use strict";
$f2a682b251363bc2$export$1ea939691cdc45b8 = $f2a682b251363bc2$var$isValid;

var $26SSu = parcelRequire("26SSu");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $f2a682b251363bc2$var$isValid(date) {
    if (!(0, $26SSu.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $30SVQ.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("30SVQ", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $231bfb8d72679740$export$e67a095c620b86fe, (v) => $231bfb8d72679740$export$e67a095c620b86fe = v);
var $231bfb8d72679740$export$e67a095c620b86fe;
"use strict";
$231bfb8d72679740$export$e67a095c620b86fe = $231bfb8d72679740$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $231bfb8d72679740$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});


parcelRegister("48K34", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $303ba10db2c74ab4$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $02Zw7.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $7hoR9.longFormatters;
    }
});

var $k1YNI = parcelRequire("k1YNI");

var $4UP3S = parcelRequire("4UP3S");

var $02Zw7 = parcelRequire("02Zw7");

var $7hoR9 = parcelRequire("7hoR9");

var $aRzsd = parcelRequire("aRzsd");

var $kPCB6 = parcelRequire("kPCB6");

var $30SVQ = parcelRequire("30SVQ");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $303ba10db2c74ab4$var$format(date, formatStr, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $30SVQ.toDate)(date);
    if (!(0, $kPCB6.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $7hoR9.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ($02Zw7.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $aRzsd.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $aRzsd.isProtectedDayOfYearToken)(token)) (0, $aRzsd.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $02Zw7.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("k1YNI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $hBsHh.enUS;
    }
});

var $hBsHh = parcelRequire("hBsHh");

});
parcelRegister("hBsHh", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $cd0c27002eb93234$export$137380d9ce54f7f, (v) => $cd0c27002eb93234$export$137380d9ce54f7f = v);
var $cd0c27002eb93234$export$137380d9ce54f7f;
"use strict";
$cd0c27002eb93234$export$137380d9ce54f7f = void 0;

var $10Jzk = parcelRequire("10Jzk");

var $8yY6E = parcelRequire("8yY6E");

var $l2ZM0 = parcelRequire("l2ZM0");

var $ke9K7 = parcelRequire("ke9K7");

var $i71E4 = parcelRequire("i71E4");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $cd0c27002eb93234$var$enUS = $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $10Jzk.formatDistance,
    formatLong: $8yY6E.formatLong,
    formatRelative: $l2ZM0.formatRelative,
    localize: $ke9K7.localize,
    match: $i71E4.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("10Jzk", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $0bc92389da5ca8f2$export$2c14ff85d6318973, (v) => $0bc92389da5ca8f2$export$2c14ff85d6318973 = v);
var $0bc92389da5ca8f2$export$2c14ff85d6318973;
"use strict";
$0bc92389da5ca8f2$export$2c14ff85d6318973 = void 0;
const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$0bc92389da5ca8f2$export$2c14ff85d6318973 = $0bc92389da5ca8f2$var$formatDistance;

});

parcelRegister("8yY6E", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $63c01f9040a729a9$export$cbf60ecb96cbb82f, (v) => $63c01f9040a729a9$export$cbf60ecb96cbb82f = v);
var $63c01f9040a729a9$export$cbf60ecb96cbb82f;
"use strict";
$63c01f9040a729a9$export$cbf60ecb96cbb82f = void 0;

var $64fKv = parcelRequire("64fKv");
const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$var$formatLong = $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $64fKv.buildFormatLongFn)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $64fKv.buildFormatLongFn)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $64fKv.buildFormatLongFn)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("64fKv", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $46af55383084911e$export$38e44e97ce4dbb7d, (v) => $46af55383084911e$export$38e44e97ce4dbb7d = v);
var $46af55383084911e$export$38e44e97ce4dbb7d;
"use strict";
$46af55383084911e$export$38e44e97ce4dbb7d = $46af55383084911e$var$buildFormatLongFn;
function $46af55383084911e$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("l2ZM0", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $f529b3bee3f6d835$export$8fbbfd65594f46a0, (v) => $f529b3bee3f6d835$export$8fbbfd65594f46a0 = v);
var $f529b3bee3f6d835$export$8fbbfd65594f46a0;
"use strict";
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = void 0;
const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$var$formatRelative = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = $f529b3bee3f6d835$var$formatRelative;

});

parcelRegister("ke9K7", function(module, exports) {

$parcel$export(module.exports, "localize", () => $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63, (v) => $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = v);
var $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63;
"use strict";
$eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = void 0;

var $4WM5U = parcelRequire("4WM5U");
const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$var$localize = $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4WM5U.buildLocalizeFn)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("4WM5U", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $39a1e2b6239b09b3$export$63596d6ee8878b25, (v) => $39a1e2b6239b09b3$export$63596d6ee8878b25 = v);
var $39a1e2b6239b09b3$export$63596d6ee8878b25;
"use strict";
$39a1e2b6239b09b3$export$63596d6ee8878b25 = $39a1e2b6239b09b3$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("i71E4", function(module, exports) {

$parcel$export(module.exports, "match", () => $d2fa28259adb3ab1$export$4659b591c19bdf3d, (v) => $d2fa28259adb3ab1$export$4659b591c19bdf3d = v);
var $d2fa28259adb3ab1$export$4659b591c19bdf3d;
"use strict";
$d2fa28259adb3ab1$export$4659b591c19bdf3d = void 0;

var $jEhBR = parcelRequire("jEhBR");

var $3e2wr = parcelRequire("3e2wr");
const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$var$match = $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $3e2wr.buildMatchPatternFn)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jEhBR.buildMatchFn)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("jEhBR", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $e4df69a5a2d494a3$export$1430a0f35710914d, (v) => $e4df69a5a2d494a3$export$1430a0f35710914d = v);
var $e4df69a5a2d494a3$export$1430a0f35710914d;
"use strict";
$e4df69a5a2d494a3$export$1430a0f35710914d = $e4df69a5a2d494a3$var$buildMatchFn;
function $e4df69a5a2d494a3$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("3e2wr", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $2594a2c0202dabc6$export$fdaf2fd6d7edde95, (v) => $2594a2c0202dabc6$export$fdaf2fd6d7edde95 = v);
var $2594a2c0202dabc6$export$fdaf2fd6d7edde95;
"use strict";
$2594a2c0202dabc6$export$fdaf2fd6d7edde95 = $2594a2c0202dabc6$var$buildMatchPatternFn;
function $2594a2c0202dabc6$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("4UP3S", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $39440020b58e1ef8$export$430a3269e24b912e, (v) => $39440020b58e1ef8$export$430a3269e24b912e = v);
$parcel$export(module.exports, "setDefaultOptions", () => $39440020b58e1ef8$export$95365be1b0704abc, (v) => $39440020b58e1ef8$export$95365be1b0704abc = v);
var $39440020b58e1ef8$export$430a3269e24b912e;
var $39440020b58e1ef8$export$95365be1b0704abc;
"use strict";
$39440020b58e1ef8$export$430a3269e24b912e = $39440020b58e1ef8$var$getDefaultOptions;
$39440020b58e1ef8$export$95365be1b0704abc = $39440020b58e1ef8$var$setDefaultOptions;
let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$var$getDefaultOptions() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$var$setDefaultOptions(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}

});

parcelRegister("02Zw7", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $008fe800ab658844$export$fe98a034cfb96d55, (v) => $008fe800ab658844$export$fe98a034cfb96d55 = v);
var $008fe800ab658844$export$fe98a034cfb96d55;
"use strict";
$008fe800ab658844$export$fe98a034cfb96d55 = void 0;

var $49JO2 = parcelRequire("49JO2");

var $bjZpy = parcelRequire("bjZpy");

var $hhS6V = parcelRequire("hhS6V");

var $1wdT6 = parcelRequire("1wdT6");

var $7Fy3C = parcelRequire("7Fy3C");

var $krIED = parcelRequire("krIED");

var $9KWEw = parcelRequire("9KWEw");
const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $008fe800ab658844$var$formatters = $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $9KWEw.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $7Fy3C.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $krIED.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $krIED.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $hhS6V.getISOWeekYear)(date);
        // Padding
        return (0, $krIED.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $krIED.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $krIED.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $krIED.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $9KWEw.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $krIED.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $1wdT6.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $krIED.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $bjZpy.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $krIED.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $9KWEw.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $49JO2.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $krIED.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $krIED.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $krIED.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $krIED.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $9KWEw.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $9KWEw.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $krIED.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $krIED.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $9KWEw.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $9KWEw.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $9KWEw.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $krIED.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $krIED.addLeadingZeros)(timestamp, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $krIED.addLeadingZeros)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $krIED.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $krIED.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $krIED.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("49JO2", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $306b88ce50904f9c$export$d3b42cd8452deec, (v) => $306b88ce50904f9c$export$d3b42cd8452deec = v);
var $306b88ce50904f9c$export$d3b42cd8452deec;
"use strict";
$306b88ce50904f9c$export$d3b42cd8452deec = $306b88ce50904f9c$var$getDayOfYear;

var $9UMYl = parcelRequire("9UMYl");

var $3Au2i = parcelRequire("3Au2i");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $306b88ce50904f9c$var$getDayOfYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $9UMYl.differenceInCalendarDays)(_date, (0, $3Au2i.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});
parcelRegister("9UMYl", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $737f54e9ffaddc15$export$4a02e9c37dab4871, (v) => $737f54e9ffaddc15$export$4a02e9c37dab4871 = v);
var $737f54e9ffaddc15$export$4a02e9c37dab4871;
"use strict";
$737f54e9ffaddc15$export$4a02e9c37dab4871 = $737f54e9ffaddc15$var$differenceInCalendarDays;

var $briB4 = parcelRequire("briB4");

var $fH0a1 = parcelRequire("fH0a1");

var $cBJez = parcelRequire("cBJez");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $737f54e9ffaddc15$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $fH0a1.startOfDay)(dateLeft);
    const startOfDayRight = (0, $fH0a1.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $briB4.millisecondsInDay);
}

});
parcelRegister("briB4", function(module, exports) {

$parcel$export(module.exports, "secondsInYear", () => $8540a44f59a4af84$export$7271e9e3478110d1, (v) => $8540a44f59a4af84$export$7271e9e3478110d1 = v);
$parcel$export(module.exports, "secondsInWeek", () => $8540a44f59a4af84$export$34804a017b31e2fe, (v) => $8540a44f59a4af84$export$34804a017b31e2fe = v);
$parcel$export(module.exports, "secondsInQuarter", () => $8540a44f59a4af84$export$be1dccf2de902d31, (v) => $8540a44f59a4af84$export$be1dccf2de902d31 = v);
$parcel$export(module.exports, "secondsInMonth", () => $8540a44f59a4af84$export$8e6600bbdee7dabb, (v) => $8540a44f59a4af84$export$8e6600bbdee7dabb = v);
$parcel$export(module.exports, "secondsInMinute", () => $8540a44f59a4af84$export$a77c1a7ebebe2a5a, (v) => $8540a44f59a4af84$export$a77c1a7ebebe2a5a = v);
$parcel$export(module.exports, "secondsInHour", () => $8540a44f59a4af84$export$698aec755e92c695, (v) => $8540a44f59a4af84$export$698aec755e92c695 = v);
$parcel$export(module.exports, "secondsInDay", () => $8540a44f59a4af84$export$815a9362476d2fe3, (v) => $8540a44f59a4af84$export$815a9362476d2fe3 = v);
$parcel$export(module.exports, "quartersInYear", () => $8540a44f59a4af84$export$4db7641526e3241f, (v) => $8540a44f59a4af84$export$4db7641526e3241f = v);
$parcel$export(module.exports, "monthsInYear", () => $8540a44f59a4af84$export$80d7e435f744f319, (v) => $8540a44f59a4af84$export$80d7e435f744f319 = v);
$parcel$export(module.exports, "monthsInQuarter", () => $8540a44f59a4af84$export$3c58128db900d44e, (v) => $8540a44f59a4af84$export$3c58128db900d44e = v);
$parcel$export(module.exports, "minutesInYear", () => $8540a44f59a4af84$export$3633035e63cee86a, (v) => $8540a44f59a4af84$export$3633035e63cee86a = v);
$parcel$export(module.exports, "minutesInMonth", () => $8540a44f59a4af84$export$ab7da2ccd1075c38, (v) => $8540a44f59a4af84$export$ab7da2ccd1075c38 = v);
$parcel$export(module.exports, "minutesInHour", () => $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f, (v) => $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = v);
$parcel$export(module.exports, "minutesInDay", () => $8540a44f59a4af84$export$2423174df8cd3cd2, (v) => $8540a44f59a4af84$export$2423174df8cd3cd2 = v);
$parcel$export(module.exports, "millisecondsInWeek", () => $8540a44f59a4af84$export$4fad13613e88edc8, (v) => $8540a44f59a4af84$export$4fad13613e88edc8 = v);
$parcel$export(module.exports, "millisecondsInSecond", () => $8540a44f59a4af84$export$397c2d5776aa9055, (v) => $8540a44f59a4af84$export$397c2d5776aa9055 = v);
$parcel$export(module.exports, "millisecondsInMinute", () => $8540a44f59a4af84$export$91246f0b9bd9beff, (v) => $8540a44f59a4af84$export$91246f0b9bd9beff = v);
$parcel$export(module.exports, "millisecondsInHour", () => $8540a44f59a4af84$export$7f72910d6dfd237a, (v) => $8540a44f59a4af84$export$7f72910d6dfd237a = v);
$parcel$export(module.exports, "millisecondsInDay", () => $8540a44f59a4af84$export$b76b1809a2898f9a, (v) => $8540a44f59a4af84$export$b76b1809a2898f9a = v);
$parcel$export(module.exports, "daysInYear", () => $8540a44f59a4af84$export$3913210603d8e9ae, (v) => $8540a44f59a4af84$export$3913210603d8e9ae = v);
$parcel$export(module.exports, "daysInWeek", () => $8540a44f59a4af84$export$dfd9b671c89acc8e, (v) => $8540a44f59a4af84$export$dfd9b671c89acc8e = v);
var $8540a44f59a4af84$export$7271e9e3478110d1;
var $8540a44f59a4af84$export$34804a017b31e2fe;
var $8540a44f59a4af84$export$be1dccf2de902d31;
var $8540a44f59a4af84$export$8e6600bbdee7dabb;
var $8540a44f59a4af84$export$a77c1a7ebebe2a5a;
var $8540a44f59a4af84$export$698aec755e92c695;
var $8540a44f59a4af84$export$815a9362476d2fe3;
var $8540a44f59a4af84$export$4db7641526e3241f;
var $8540a44f59a4af84$export$80d7e435f744f319;
var $8540a44f59a4af84$export$3c58128db900d44e;
var $8540a44f59a4af84$export$3633035e63cee86a;
var $8540a44f59a4af84$export$ab7da2ccd1075c38;
var $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f;
var $8540a44f59a4af84$export$2423174df8cd3cd2;
var $8540a44f59a4af84$export$4dec998e48f9c246;
var $8540a44f59a4af84$export$4fad13613e88edc8;
var $8540a44f59a4af84$export$397c2d5776aa9055;
var $8540a44f59a4af84$export$91246f0b9bd9beff;
var $8540a44f59a4af84$export$7f72910d6dfd237a;
var $8540a44f59a4af84$export$b76b1809a2898f9a;
var $8540a44f59a4af84$export$81caae6e1cc7a622;
var $8540a44f59a4af84$export$3913210603d8e9ae;
var $8540a44f59a4af84$export$dfd9b671c89acc8e;
"use strict";
$8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = $8540a44f59a4af84$export$698aec755e92c695 = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$4db7641526e3241f = $8540a44f59a4af84$export$80d7e435f744f319 = $8540a44f59a4af84$export$3c58128db900d44e = $8540a44f59a4af84$export$3633035e63cee86a = $8540a44f59a4af84$export$ab7da2ccd1075c38 = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = $8540a44f59a4af84$export$2423174df8cd3cd2 = $8540a44f59a4af84$export$4dec998e48f9c246 = $8540a44f59a4af84$export$4fad13613e88edc8 = $8540a44f59a4af84$export$397c2d5776aa9055 = $8540a44f59a4af84$export$91246f0b9bd9beff = $8540a44f59a4af84$export$7f72910d6dfd237a = $8540a44f59a4af84$export$b76b1809a2898f9a = $8540a44f59a4af84$export$81caae6e1cc7a622 = $8540a44f59a4af84$export$3913210603d8e9ae = $8540a44f59a4af84$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$var$daysInWeek = $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $8540a44f59a4af84$var$daysInYear = $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$maxTime = $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$minTime = $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $8540a44f59a4af84$var$millisecondsInWeek = $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $8540a44f59a4af84$var$millisecondsInDay = $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $8540a44f59a4af84$var$millisecondsInMinute = $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $8540a44f59a4af84$var$millisecondsInHour = $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $8540a44f59a4af84$var$millisecondsInSecond = $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $8540a44f59a4af84$var$minutesInYear = $8540a44f59a4af84$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $8540a44f59a4af84$var$minutesInMonth = $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $8540a44f59a4af84$var$minutesInDay = $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $8540a44f59a4af84$var$minutesInHour = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $8540a44f59a4af84$var$monthsInQuarter = $8540a44f59a4af84$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $8540a44f59a4af84$var$monthsInYear = $8540a44f59a4af84$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $8540a44f59a4af84$var$quartersInYear = $8540a44f59a4af84$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $8540a44f59a4af84$var$secondsInHour = $8540a44f59a4af84$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $8540a44f59a4af84$var$secondsInMinute = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $8540a44f59a4af84$var$secondsInDay = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $8540a44f59a4af84$var$secondsInWeek = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $8540a44f59a4af84$var$secondsInYear = $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$var$secondsInDay * $8540a44f59a4af84$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $8540a44f59a4af84$var$secondsInMonth = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $8540a44f59a4af84$var$secondsInQuarter = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$var$secondsInMonth * 3;

});

parcelRegister("fH0a1", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2, (v) => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = v);
var $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;
"use strict";
$b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = $b6caff0bf13dcaf5$var$startOfDay;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $b6caff0bf13dcaf5$var$startOfDay(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("cBJez", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $92dc0740ffabe180$export$113002b5eff6e430, (v) => $92dc0740ffabe180$export$113002b5eff6e430 = v);
var $92dc0740ffabe180$export$113002b5eff6e430;
"use strict";
$92dc0740ffabe180$export$113002b5eff6e430 = $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("3Au2i", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $29cc086f79701cd9$export$f91e89d3d0406102, (v) => $29cc086f79701cd9$export$f91e89d3d0406102 = v);
var $29cc086f79701cd9$export$f91e89d3d0406102;
"use strict";
$29cc086f79701cd9$export$f91e89d3d0406102 = $29cc086f79701cd9$var$startOfYear;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $29cc086f79701cd9$var$startOfYear(date) {
    const cleanDate = (0, $30SVQ.toDate)(date);
    const _date = (0, $eK5z7.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});
parcelRegister("eK5z7", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $abb9adbdb26342b3$export$ead8a1812b171991, (v) => $abb9adbdb26342b3$export$ead8a1812b171991 = v);
var $abb9adbdb26342b3$export$ead8a1812b171991;
"use strict";
$abb9adbdb26342b3$export$ead8a1812b171991 = $abb9adbdb26342b3$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $abb9adbdb26342b3$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});



parcelRegister("bjZpy", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $83e11b0db4cec366$export$7cabdc5698b63e2f, (v) => $83e11b0db4cec366$export$7cabdc5698b63e2f = v);
var $83e11b0db4cec366$export$7cabdc5698b63e2f;
"use strict";
$83e11b0db4cec366$export$7cabdc5698b63e2f = $83e11b0db4cec366$var$getISOWeek;

var $briB4 = parcelRequire("briB4");

var $2sjl8 = parcelRequire("2sjl8");

var $551eW = parcelRequire("551eW");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $83e11b0db4cec366$var$getISOWeek(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = +(0, $2sjl8.startOfISOWeek)(_date) - +(0, $551eW.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $briB4.millisecondsInWeek) + 1;
}

});
parcelRegister("2sjl8", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $1c9d32c6cb108460$export$6173213f95a4431e, (v) => $1c9d32c6cb108460$export$6173213f95a4431e = v);
var $1c9d32c6cb108460$export$6173213f95a4431e;
"use strict";
$1c9d32c6cb108460$export$6173213f95a4431e = $1c9d32c6cb108460$var$startOfISOWeek;

var $8ple2 = parcelRequire("8ple2");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $1c9d32c6cb108460$var$startOfISOWeek(date) {
    return (0, $8ple2.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("8ple2", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $61f11f7a26b3ab78$export$42c81a444fbfb5d4, (v) => $61f11f7a26b3ab78$export$42c81a444fbfb5d4 = v);
var $61f11f7a26b3ab78$export$42c81a444fbfb5d4;
"use strict";
$61f11f7a26b3ab78$export$42c81a444fbfb5d4 = $61f11f7a26b3ab78$var$startOfWeek;

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $61f11f7a26b3ab78$var$startOfWeek(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $30SVQ.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("551eW", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $3b2e6199275b27d6$export$236bdfa374eb69a9, (v) => $3b2e6199275b27d6$export$236bdfa374eb69a9 = v);
var $3b2e6199275b27d6$export$236bdfa374eb69a9;
"use strict";
$3b2e6199275b27d6$export$236bdfa374eb69a9 = $3b2e6199275b27d6$var$startOfISOWeekYear;

var $hhS6V = parcelRequire("hhS6V");

var $2sjl8 = parcelRequire("2sjl8");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $3b2e6199275b27d6$var$startOfISOWeekYear(date) {
    const year = (0, $hhS6V.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $2sjl8.startOfISOWeek)(fourthOfJanuary);
}

});
parcelRegister("hhS6V", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $c95dff76bf2f692a$export$3dbc52535f6f8fcc, (v) => $c95dff76bf2f692a$export$3dbc52535f6f8fcc = v);
var $c95dff76bf2f692a$export$3dbc52535f6f8fcc;
"use strict";
$c95dff76bf2f692a$export$3dbc52535f6f8fcc = $c95dff76bf2f692a$var$getISOWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $2sjl8 = parcelRequire("2sjl8");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $c95dff76bf2f692a$var$getISOWeekYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $2sjl8.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $2sjl8.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("1wdT6", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $11b38d723fd57381$export$efe19b760242b2fc, (v) => $11b38d723fd57381$export$efe19b760242b2fc = v);
var $11b38d723fd57381$export$efe19b760242b2fc;
"use strict";
$11b38d723fd57381$export$efe19b760242b2fc = $11b38d723fd57381$var$getWeek;

var $briB4 = parcelRequire("briB4");

var $8ple2 = parcelRequire("8ple2");

var $eO0Fp = parcelRequire("eO0Fp");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $11b38d723fd57381$var$getWeek(date, options) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = +(0, $8ple2.startOfWeek)(_date, options) - +(0, $eO0Fp.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $briB4.millisecondsInWeek) + 1;
}

});
parcelRegister("eO0Fp", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $ac7640a7ade5a435$export$bb7b45bb8e74da0f, (v) => $ac7640a7ade5a435$export$bb7b45bb8e74da0f = v);
var $ac7640a7ade5a435$export$bb7b45bb8e74da0f;
"use strict";
$ac7640a7ade5a435$export$bb7b45bb8e74da0f = $ac7640a7ade5a435$var$startOfWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $7Fy3C = parcelRequire("7Fy3C");

var $8ple2 = parcelRequire("8ple2");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $ac7640a7ade5a435$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $7Fy3C.getWeekYear)(date, options);
    const firstWeek = (0, $eK5z7.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $8ple2.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("7Fy3C", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $0170e230c8468ebb$export$12d572480ceb6e58, (v) => $0170e230c8468ebb$export$12d572480ceb6e58 = v);
var $0170e230c8468ebb$export$12d572480ceb6e58;
"use strict";
$0170e230c8468ebb$export$12d572480ceb6e58 = $0170e230c8468ebb$var$getWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $8ple2 = parcelRequire("8ple2");

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $0170e230c8468ebb$var$getWeekYear(date, options) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $eK5z7.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $8ple2.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $eK5z7.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $8ple2.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("krIED", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $03d75ed55eeb99fa$export$c8306e720e213c0f, (v) => $03d75ed55eeb99fa$export$c8306e720e213c0f = v);
var $03d75ed55eeb99fa$export$c8306e720e213c0f;
"use strict";
$03d75ed55eeb99fa$export$c8306e720e213c0f = $03d75ed55eeb99fa$var$addLeadingZeros;
function $03d75ed55eeb99fa$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("9KWEw", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $71a5e81f1193b7a8$export$b0d4b338e1516f13, (v) => $71a5e81f1193b7a8$export$b0d4b338e1516f13 = v);
var $71a5e81f1193b7a8$export$b0d4b338e1516f13;
"use strict";
$71a5e81f1193b7a8$export$b0d4b338e1516f13 = void 0;

var $krIED = parcelRequire("krIED");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $71a5e81f1193b7a8$var$lightFormatters = $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $krIED.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $krIED.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $krIED.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $krIED.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("7hoR9", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $54cd66db3e5e74df$export$70cc8fd02856fd58, (v) => $54cd66db3e5e74df$export$70cc8fd02856fd58 = v);
var $54cd66db3e5e74df$export$70cc8fd02856fd58;
"use strict";
$54cd66db3e5e74df$export$70cc8fd02856fd58 = void 0;
const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$var$longFormatters = $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};

});

parcelRegister("aRzsd", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $7e8a5b0b77bf77b9$export$c6cc36aa33304772, (v) => $7e8a5b0b77bf77b9$export$c6cc36aa33304772 = v);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1, (v) => $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1 = v);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879, (v) => $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879 = v);
var $7e8a5b0b77bf77b9$export$c6cc36aa33304772;
var $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1;
var $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879;
"use strict";
$7e8a5b0b77bf77b9$export$c6cc36aa33304772 = $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken;
$7e8a5b0b77bf77b9$export$c6b49d6dceb604a1 = $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken;
$7e8a5b0b77bf77b9$export$f5f38f90ecaaf879 = $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError;
const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});


parcelRegister("jZtIs", function(module, exports) {

$parcel$export(module.exports, "addMinutes", () => $e8dac3cf5df5dbc8$export$2287e3d29250119e, (v) => $e8dac3cf5df5dbc8$export$2287e3d29250119e = v);
var $e8dac3cf5df5dbc8$export$2287e3d29250119e;
"use strict";
$e8dac3cf5df5dbc8$export$2287e3d29250119e = $e8dac3cf5df5dbc8$var$addMinutes;

var $dR7TY = parcelRequire("dR7TY");

var $briB4 = parcelRequire("briB4");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $e8dac3cf5df5dbc8$var$addMinutes(date, amount) {
    return (0, $dR7TY.addMilliseconds)(date, amount * $briB4.millisecondsInMinute);
}

});
parcelRegister("dR7TY", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", () => $a1665abf6052bbc9$export$baf757aaf0c95c94, (v) => $a1665abf6052bbc9$export$baf757aaf0c95c94 = v);
var $a1665abf6052bbc9$export$baf757aaf0c95c94;
"use strict";
$a1665abf6052bbc9$export$baf757aaf0c95c94 = $a1665abf6052bbc9$var$addMilliseconds;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $a1665abf6052bbc9$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $30SVQ.toDate)(date);
    return (0, $eK5z7.constructFrom)(date, timestamp + amount);
}

});


parcelRegister("iMX5A", function(module, exports) {

$parcel$export(module.exports, "addHours", () => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6, (v) => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = v);
var $dada8b88b0873e8d$export$4a4306ad4fa0e5e6;
"use strict";
$dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = $dada8b88b0873e8d$var$addHours;

var $dR7TY = parcelRequire("dR7TY");

var $briB4 = parcelRequire("briB4");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $dada8b88b0873e8d$var$addHours(date, amount) {
    return (0, $dR7TY.addMilliseconds)(date, amount * $briB4.millisecondsInHour);
}

});

parcelRegister("e1kwM", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa, (v) => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa = v);
var $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;
"use strict";
$a351150ce2eb3ddb$export$dd412b56f1e4d8aa = $a351150ce2eb3ddb$var$addDays;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $a351150ce2eb3ddb$var$addDays(date, amount) {
    const _date = (0, $30SVQ.toDate)(date);
    if (isNaN(amount)) return (0, $eK5z7.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});

parcelRegister("gdvs1", function(module, exports) {

$parcel$export(module.exports, "addWeeks", () => $bce641bd93181421$export$ef501a2bb4f3ee6b, (v) => $bce641bd93181421$export$ef501a2bb4f3ee6b = v);
var $bce641bd93181421$export$ef501a2bb4f3ee6b;
"use strict";
$bce641bd93181421$export$ef501a2bb4f3ee6b = $bce641bd93181421$var$addWeeks;

var $e1kwM = parcelRequire("e1kwM");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $bce641bd93181421$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $e1kwM.addDays)(date, days);
}

});

parcelRegister("cls5f", function(module, exports) {

$parcel$export(module.exports, "addMonths", () => $8fcd3b0bf5df7635$export$17c93e242b2d3a22, (v) => $8fcd3b0bf5df7635$export$17c93e242b2d3a22 = v);
var $8fcd3b0bf5df7635$export$17c93e242b2d3a22;
"use strict";
$8fcd3b0bf5df7635$export$17c93e242b2d3a22 = $8fcd3b0bf5df7635$var$addMonths;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $8fcd3b0bf5df7635$var$addMonths(date, amount) {
    const _date = (0, $30SVQ.toDate)(date);
    if (isNaN(amount)) return (0, $eK5z7.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $eK5z7.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});

parcelRegister("4chdC", function(module, exports) {

$parcel$export(module.exports, "addQuarters", () => $30e5a3aa581ecd23$export$c252a41d0fbed2ce, (v) => $30e5a3aa581ecd23$export$c252a41d0fbed2ce = v);
var $30e5a3aa581ecd23$export$c252a41d0fbed2ce;
"use strict";
$30e5a3aa581ecd23$export$c252a41d0fbed2ce = $30e5a3aa581ecd23$var$addQuarters;

var $cls5f = parcelRequire("cls5f");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $30e5a3aa581ecd23$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $cls5f.addMonths)(date, months);
}

});

parcelRegister("3cpd6", function(module, exports) {

$parcel$export(module.exports, "addYears", () => $25460c542fb3bf74$export$3d83eec43f4ea476, (v) => $25460c542fb3bf74$export$3d83eec43f4ea476 = v);
var $25460c542fb3bf74$export$3d83eec43f4ea476;
"use strict";
$25460c542fb3bf74$export$3d83eec43f4ea476 = $25460c542fb3bf74$var$addYears;

var $cls5f = parcelRequire("cls5f");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $25460c542fb3bf74$var$addYears(date, amount) {
    return (0, $cls5f.addMonths)(date, amount * 12);
}

});

parcelRegister("5N9HD", function(module, exports) {

$parcel$export(module.exports, "subDays", () => $43790e1a97254ab3$export$70823084e2deb1ea, (v) => $43790e1a97254ab3$export$70823084e2deb1ea = v);
var $43790e1a97254ab3$export$70823084e2deb1ea;
"use strict";
$43790e1a97254ab3$export$70823084e2deb1ea = $43790e1a97254ab3$var$subDays;

var $e1kwM = parcelRequire("e1kwM");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $43790e1a97254ab3$var$subDays(date, amount) {
    return (0, $e1kwM.addDays)(date, -amount);
}

});

parcelRegister("xHbuL", function(module, exports) {

$parcel$export(module.exports, "subWeeks", () => $065494b4a3debec8$export$b4d8ae6376193efb, (v) => $065494b4a3debec8$export$b4d8ae6376193efb = v);
var $065494b4a3debec8$export$b4d8ae6376193efb;
"use strict";
$065494b4a3debec8$export$b4d8ae6376193efb = $065494b4a3debec8$var$subWeeks;

var $gdvs1 = parcelRequire("gdvs1");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $065494b4a3debec8$var$subWeeks(date, amount) {
    return (0, $gdvs1.addWeeks)(date, -amount);
}

});

parcelRegister("gZrcY", function(module, exports) {

$parcel$export(module.exports, "subMonths", () => $c5e772d389bae063$export$73d1c15a21f9fae5, (v) => $c5e772d389bae063$export$73d1c15a21f9fae5 = v);
var $c5e772d389bae063$export$73d1c15a21f9fae5;
"use strict";
$c5e772d389bae063$export$73d1c15a21f9fae5 = $c5e772d389bae063$var$subMonths;

var $cls5f = parcelRequire("cls5f");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c5e772d389bae063$var$subMonths(date, amount) {
    return (0, $cls5f.addMonths)(date, -amount);
}

});

parcelRegister("aZKRL", function(module, exports) {

$parcel$export(module.exports, "subQuarters", () => $8013f48d32fc8fb9$export$a31bfeeeee80cce6, (v) => $8013f48d32fc8fb9$export$a31bfeeeee80cce6 = v);
var $8013f48d32fc8fb9$export$a31bfeeeee80cce6;
"use strict";
$8013f48d32fc8fb9$export$a31bfeeeee80cce6 = $8013f48d32fc8fb9$var$subQuarters;

var $4chdC = parcelRequire("4chdC");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $8013f48d32fc8fb9$var$subQuarters(date, amount) {
    return (0, $4chdC.addQuarters)(date, -amount);
}

});

parcelRegister("aPY0w", function(module, exports) {

$parcel$export(module.exports, "subYears", () => $7e3d370a917aaad9$export$14867687ff6c92e2, (v) => $7e3d370a917aaad9$export$14867687ff6c92e2 = v);
var $7e3d370a917aaad9$export$14867687ff6c92e2;
"use strict";
$7e3d370a917aaad9$export$14867687ff6c92e2 = $7e3d370a917aaad9$var$subYears;

var $3cpd6 = parcelRequire("3cpd6");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $7e3d370a917aaad9$var$subYears(date, amount) {
    return (0, $3cpd6.addYears)(date, -amount);
}

});

parcelRegister("ebQpN", function(module, exports) {

$parcel$export(module.exports, "getSeconds", () => $a54ac051af9fd19a$export$5e9417507ff28427, (v) => $a54ac051af9fd19a$export$5e9417507ff28427 = v);
var $a54ac051af9fd19a$export$5e9417507ff28427;
"use strict";
$a54ac051af9fd19a$export$5e9417507ff28427 = $a54ac051af9fd19a$var$getSeconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $a54ac051af9fd19a$var$getSeconds(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("12jbR", function(module, exports) {

$parcel$export(module.exports, "getMinutes", () => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145, (v) => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = v);
var $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145;
"use strict";
$0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = $0c14dd26da4d9afe$var$getMinutes;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $0c14dd26da4d9afe$var$getMinutes(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("lIpMn", function(module, exports) {

$parcel$export(module.exports, "getHours", () => $fcf1b449283ad4a9$export$257b40f71c07d58f, (v) => $fcf1b449283ad4a9$export$257b40f71c07d58f = v);
var $fcf1b449283ad4a9$export$257b40f71c07d58f;
"use strict";
$fcf1b449283ad4a9$export$257b40f71c07d58f = $fcf1b449283ad4a9$var$getHours;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $fcf1b449283ad4a9$var$getHours(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("gf6Rq", function(module, exports) {

$parcel$export(module.exports, "getDay", () => $bd335e725902b989$export$1b64bc9c5306ed54, (v) => $bd335e725902b989$export$1b64bc9c5306ed54 = v);
var $bd335e725902b989$export$1b64bc9c5306ed54;
"use strict";
$bd335e725902b989$export$1b64bc9c5306ed54 = $bd335e725902b989$var$getDay;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $bd335e725902b989$var$getDay(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRegister("inqX7", function(module, exports) {

$parcel$export(module.exports, "getDate", () => $d60f4829c70cb6da$export$aa350b96d91cd94, (v) => $d60f4829c70cb6da$export$aa350b96d91cd94 = v);
var $d60f4829c70cb6da$export$aa350b96d91cd94;
"use strict";
$d60f4829c70cb6da$export$aa350b96d91cd94 = $d60f4829c70cb6da$var$getDate;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $d60f4829c70cb6da$var$getDate(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("9xRRE", function(module, exports) {

$parcel$export(module.exports, "getMonth", () => $6f30fa731c19b802$export$6ce1b5acc29cb53b, (v) => $6f30fa731c19b802$export$6ce1b5acc29cb53b = v);
var $6f30fa731c19b802$export$6ce1b5acc29cb53b;
"use strict";
$6f30fa731c19b802$export$6ce1b5acc29cb53b = $6f30fa731c19b802$var$getMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $6f30fa731c19b802$var$getMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("a9aPJ", function(module, exports) {

$parcel$export(module.exports, "getQuarter", () => $763325f0c93713da$export$de90a4bb31c25221, (v) => $763325f0c93713da$export$de90a4bb31c25221 = v);
var $763325f0c93713da$export$de90a4bb31c25221;
"use strict";
$763325f0c93713da$export$de90a4bb31c25221 = $763325f0c93713da$var$getQuarter;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $763325f0c93713da$var$getQuarter(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("5CRrs", function(module, exports) {

$parcel$export(module.exports, "getYear", () => $4189f4c9c3b9878d$export$5846dc2d57a5c860, (v) => $4189f4c9c3b9878d$export$5846dc2d57a5c860 = v);
var $4189f4c9c3b9878d$export$5846dc2d57a5c860;
"use strict";
$4189f4c9c3b9878d$export$5846dc2d57a5c860 = $4189f4c9c3b9878d$var$getYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $4189f4c9c3b9878d$var$getYear(date) {
    return (0, $30SVQ.toDate)(date).getFullYear();
}

});

parcelRegister("dF81P", function(module, exports) {

$parcel$export(module.exports, "getTime", () => $9f25550354d2edec$export$1428f42a7de81803, (v) => $9f25550354d2edec$export$1428f42a7de81803 = v);
var $9f25550354d2edec$export$1428f42a7de81803;
"use strict";
$9f25550354d2edec$export$1428f42a7de81803 = $9f25550354d2edec$var$getTime;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $9f25550354d2edec$var$getTime(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRegister("f23Gj", function(module, exports) {

$parcel$export(module.exports, "setSeconds", () => $af19e5fb9b37deaf$export$aec44746644cbf43, (v) => $af19e5fb9b37deaf$export$aec44746644cbf43 = v);
var $af19e5fb9b37deaf$export$aec44746644cbf43;
"use strict";
$af19e5fb9b37deaf$export$aec44746644cbf43 = $af19e5fb9b37deaf$var$setSeconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $af19e5fb9b37deaf$var$setSeconds(date, seconds) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("JJ6gI", function(module, exports) {

$parcel$export(module.exports, "setMinutes", () => $089730068462d950$export$ad569bf1c79ea89d, (v) => $089730068462d950$export$ad569bf1c79ea89d = v);
var $089730068462d950$export$ad569bf1c79ea89d;
"use strict";
$089730068462d950$export$ad569bf1c79ea89d = $089730068462d950$var$setMinutes;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $089730068462d950$var$setMinutes(date, minutes) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("8l96w", function(module, exports) {

$parcel$export(module.exports, "setHours", () => $612758c85246c1d0$export$f86b797a4659b781, (v) => $612758c85246c1d0$export$f86b797a4659b781 = v);
var $612758c85246c1d0$export$f86b797a4659b781;
"use strict";
$612758c85246c1d0$export$f86b797a4659b781 = $612758c85246c1d0$var$setHours;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $612758c85246c1d0$var$setHours(date, hours) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("1VSw7", function(module, exports) {

$parcel$export(module.exports, "setMonth", () => $16856745969af5fc$export$63264690f8e36790, (v) => $16856745969af5fc$export$63264690f8e36790 = v);
var $16856745969af5fc$export$63264690f8e36790;
"use strict";
$16856745969af5fc$export$63264690f8e36790 = $16856745969af5fc$var$setMonth;

var $eK5z7 = parcelRequire("eK5z7");

var $7uieS = parcelRequire("7uieS");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $16856745969af5fc$var$setMonth(date, month) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $eK5z7.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $7uieS.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});
parcelRegister("7uieS", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", () => $57397b9e44500b87$export$f645ddd439eb259d, (v) => $57397b9e44500b87$export$f645ddd439eb259d = v);
var $57397b9e44500b87$export$f645ddd439eb259d;
"use strict";
$57397b9e44500b87$export$f645ddd439eb259d = $57397b9e44500b87$var$getDaysInMonth;

var $30SVQ = parcelRequire("30SVQ");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $57397b9e44500b87$var$getDaysInMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $eK5z7.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("dO1KX", function(module, exports) {

$parcel$export(module.exports, "setQuarter", () => $a0d14eadad6d8ea7$export$8924d1de7efe1755, (v) => $a0d14eadad6d8ea7$export$8924d1de7efe1755 = v);
var $a0d14eadad6d8ea7$export$8924d1de7efe1755;
"use strict";
$a0d14eadad6d8ea7$export$8924d1de7efe1755 = $a0d14eadad6d8ea7$var$setQuarter;

var $1VSw7 = parcelRequire("1VSw7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $a0d14eadad6d8ea7$var$setQuarter(date, quarter) {
    const _date = (0, $30SVQ.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $1VSw7.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRegister("75Jn2", function(module, exports) {

$parcel$export(module.exports, "setYear", () => $529c31b1ede64581$export$a8408b6c5639cab7, (v) => $529c31b1ede64581$export$a8408b6c5639cab7 = v);
var $529c31b1ede64581$export$a8408b6c5639cab7;
"use strict";
$529c31b1ede64581$export$a8408b6c5639cab7 = $529c31b1ede64581$var$setYear;

var $eK5z7 = parcelRequire("eK5z7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $529c31b1ede64581$var$setYear(date, year) {
    const _date = (0, $30SVQ.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $eK5z7.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("80buy", function(module, exports) {

$parcel$export(module.exports, "min", () => $5d373ce01680b655$export$96ec731ed4dcb222, (v) => $5d373ce01680b655$export$96ec731ed4dcb222 = v);
var $5d373ce01680b655$export$96ec731ed4dcb222;
"use strict";
$5d373ce01680b655$export$96ec731ed4dcb222 = $5d373ce01680b655$var$min;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $5d373ce01680b655$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $30SVQ.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});

parcelRegister("fIlxB", function(module, exports) {

$parcel$export(module.exports, "max", () => $b70baca84fc92b6d$export$8960430cfd85939f, (v) => $b70baca84fc92b6d$export$8960430cfd85939f = v);
var $b70baca84fc92b6d$export$8960430cfd85939f;
"use strict";
$b70baca84fc92b6d$export$8960430cfd85939f = $b70baca84fc92b6d$var$max;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $b70baca84fc92b6d$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $30SVQ.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("bTWJP", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", () => $8aa264ebd3f03841$export$489984ac7c996389, (v) => $8aa264ebd3f03841$export$489984ac7c996389 = v);
var $8aa264ebd3f03841$export$489984ac7c996389;
"use strict";
$8aa264ebd3f03841$export$489984ac7c996389 = $8aa264ebd3f03841$var$differenceInCalendarMonths;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $8aa264ebd3f03841$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("7b4id", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", () => $539ce3f7450453a1$export$c06dce8b38891685, (v) => $539ce3f7450453a1$export$c06dce8b38891685 = v);
var $539ce3f7450453a1$export$c06dce8b38891685;
"use strict";
$539ce3f7450453a1$export$c06dce8b38891685 = $539ce3f7450453a1$var$differenceInCalendarYears;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $539ce3f7450453a1$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRegister("7yyNc", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", () => $5806b276dadb0858$export$f62ae9fb13958c7a, (v) => $5806b276dadb0858$export$f62ae9fb13958c7a = v);
var $5806b276dadb0858$export$f62ae9fb13958c7a;
"use strict";
$5806b276dadb0858$export$f62ae9fb13958c7a = $5806b276dadb0858$var$differenceInCalendarQuarters;

var $a9aPJ = parcelRequire("a9aPJ");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $5806b276dadb0858$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $a9aPJ.getQuarter)(_dateLeft) - (0, $a9aPJ.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});

parcelRegister("gxLWY", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", () => $c0b4ec5551eca4c9$export$a5a3b454ada2268e, (v) => $c0b4ec5551eca4c9$export$a5a3b454ada2268e = v);
var $c0b4ec5551eca4c9$export$a5a3b454ada2268e;
"use strict";
$c0b4ec5551eca4c9$export$a5a3b454ada2268e = $c0b4ec5551eca4c9$var$startOfMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c0b4ec5551eca4c9$var$startOfMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("hgDzO", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", () => $c922a15e7d8774a7$export$69be7267a042ecb3, (v) => $c922a15e7d8774a7$export$69be7267a042ecb3 = v);
var $c922a15e7d8774a7$export$69be7267a042ecb3;
"use strict";
$c922a15e7d8774a7$export$69be7267a042ecb3 = $c922a15e7d8774a7$var$startOfQuarter;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $c922a15e7d8774a7$var$startOfQuarter(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("fG9DL", function(module, exports) {

$parcel$export(module.exports, "endOfDay", () => $b6a2419fd0059687$export$eb9a03f0e9aa6cea, (v) => $b6a2419fd0059687$export$eb9a03f0e9aa6cea = v);
var $b6a2419fd0059687$export$eb9a03f0e9aa6cea;
"use strict";
$b6a2419fd0059687$export$eb9a03f0e9aa6cea = $b6a2419fd0059687$var$endOfDay;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $b6a2419fd0059687$var$endOfDay(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("iiR1c", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", () => $d53308c42f1e4c62$export$ef8b6d9133084f4e, (v) => $d53308c42f1e4c62$export$ef8b6d9133084f4e = v);
var $d53308c42f1e4c62$export$ef8b6d9133084f4e;
"use strict";
$d53308c42f1e4c62$export$ef8b6d9133084f4e = $d53308c42f1e4c62$var$endOfWeek;

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $d53308c42f1e4c62$var$endOfWeek(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $30SVQ.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("jHGP1", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", () => $e58340063d97ab50$export$a2258d9c4118825c, (v) => $e58340063d97ab50$export$a2258d9c4118825c = v);
var $e58340063d97ab50$export$a2258d9c4118825c;
"use strict";
$e58340063d97ab50$export$a2258d9c4118825c = $e58340063d97ab50$var$endOfMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $e58340063d97ab50$var$endOfMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("9kRZo", function(module, exports) {

$parcel$export(module.exports, "endOfYear", () => $6cbfdc6d008595cd$export$8b7aa55c66d5569e, (v) => $6cbfdc6d008595cd$export$8b7aa55c66d5569e = v);
var $6cbfdc6d008595cd$export$8b7aa55c66d5569e;
"use strict";
$6cbfdc6d008595cd$export$8b7aa55c66d5569e = $6cbfdc6d008595cd$var$endOfYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $6cbfdc6d008595cd$var$endOfYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("aw1Xf", function(module, exports) {

$parcel$export(module.exports, "isEqual", () => $7a7e68b5aa0b9077$export$248d38f6296296c5, (v) => $7a7e68b5aa0b9077$export$248d38f6296296c5 = v);
var $7a7e68b5aa0b9077$export$248d38f6296296c5;
"use strict";
$7a7e68b5aa0b9077$export$248d38f6296296c5 = $7a7e68b5aa0b9077$var$isEqual;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $7a7e68b5aa0b9077$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $30SVQ.toDate)(leftDate);
    const _dateRight = (0, $30SVQ.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("3p5lI", function(module, exports) {

$parcel$export(module.exports, "isSameDay", () => $27a7db21eafd685b$export$ea39ec197993aef0, (v) => $27a7db21eafd685b$export$ea39ec197993aef0 = v);
var $27a7db21eafd685b$export$ea39ec197993aef0;
"use strict";
$27a7db21eafd685b$export$ea39ec197993aef0 = $27a7db21eafd685b$var$isSameDay;

var $fH0a1 = parcelRequire("fH0a1");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $27a7db21eafd685b$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $fH0a1.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $fH0a1.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("AFgUD", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", () => $06e3609fc2fbc2e2$export$a18c89cbd24170ff, (v) => $06e3609fc2fbc2e2$export$a18c89cbd24170ff = v);
var $06e3609fc2fbc2e2$export$a18c89cbd24170ff;
"use strict";
$06e3609fc2fbc2e2$export$a18c89cbd24170ff = $06e3609fc2fbc2e2$var$isSameMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $06e3609fc2fbc2e2$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("ea2hS", function(module, exports) {

$parcel$export(module.exports, "isSameYear", () => $a4f3c61641c4093b$export$5841f9eb9773f25f, (v) => $a4f3c61641c4093b$export$5841f9eb9773f25f = v);
var $a4f3c61641c4093b$export$5841f9eb9773f25f;
"use strict";
$a4f3c61641c4093b$export$5841f9eb9773f25f = $a4f3c61641c4093b$var$isSameYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $a4f3c61641c4093b$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("f8HTF", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", () => $b059a7637303f908$export$5c60e4190867161c, (v) => $b059a7637303f908$export$5c60e4190867161c = v);
var $b059a7637303f908$export$5c60e4190867161c;
"use strict";
$b059a7637303f908$export$5c60e4190867161c = $b059a7637303f908$var$isSameQuarter;

var $hgDzO = parcelRequire("hgDzO");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $b059a7637303f908$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $hgDzO.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $hgDzO.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});

parcelRegister("aFxrf", function(module, exports) {

$parcel$export(module.exports, "isAfter", () => $7c47abeb099a42c0$export$e4de839670987035, (v) => $7c47abeb099a42c0$export$e4de839670987035 = v);
var $7c47abeb099a42c0$export$e4de839670987035;
"use strict";
$7c47abeb099a42c0$export$e4de839670987035 = $7c47abeb099a42c0$var$isAfter;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $7c47abeb099a42c0$var$isAfter(date, dateToCompare) {
    const _date = (0, $30SVQ.toDate)(date);
    const _dateToCompare = (0, $30SVQ.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("i5nf8", function(module, exports) {

$parcel$export(module.exports, "isBefore", () => $d2aab93838002ade$export$5c007e10c6929c95, (v) => $d2aab93838002ade$export$5c007e10c6929c95 = v);
var $d2aab93838002ade$export$5c007e10c6929c95;
"use strict";
$d2aab93838002ade$export$5c007e10c6929c95 = $d2aab93838002ade$var$isBefore;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $d2aab93838002ade$var$isBefore(date, dateToCompare) {
    const _date = (0, $30SVQ.toDate)(date);
    const _dateToCompare = (0, $30SVQ.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("dzPMY", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", () => $9e26b76e988d89a9$export$d7deef7a3738e19d, (v) => $9e26b76e988d89a9$export$d7deef7a3738e19d = v);
var $9e26b76e988d89a9$export$d7deef7a3738e19d;
"use strict";
$9e26b76e988d89a9$export$d7deef7a3738e19d = $9e26b76e988d89a9$var$isWithinInterval;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $9e26b76e988d89a9$var$isWithinInterval(date, interval) {
    const time = +(0, $30SVQ.toDate)(date);
    const [startTime, endTime] = [
        +(0, $30SVQ.toDate)(interval.start),
        +(0, $30SVQ.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("bUtct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $7hoR9.longFormatters;
    }
});
module.exports.parse = $8abb93379891fb3e$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $7YLa0.parsers;
    }
});

var $eK5z7 = parcelRequire("eK5z7");

var $kWcwI = parcelRequire("kWcwI");

var $k1YNI = parcelRequire("k1YNI");

var $30SVQ = parcelRequire("30SVQ");

var $7hoR9 = parcelRequire("7hoR9");

var $aRzsd = parcelRequire("aRzsd");

var $7YLa0 = parcelRequire("7YLa0");

var $3Mmu1 = parcelRequire("3Mmu1");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $8abb93379891fb3e$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $kWcwI.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $30SVQ.toDate)(referenceDate);
        else return (0, $eK5z7.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $3Mmu1.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $7hoR9.longFormatters) {
            const longFormatter = $7hoR9.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $aRzsd.isProtectedWeekYearToken)(token)) (0, $aRzsd.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $aRzsd.isProtectedDayOfYearToken)(token)) (0, $aRzsd.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $7YLa0.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $eK5z7.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $30SVQ.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $eK5z7.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $eK5z7.constructFrom)(referenceDate, date);
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("kWcwI", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $f3e2f0f906df8397$export$430a3269e24b912e, (v) => $f3e2f0f906df8397$export$430a3269e24b912e = v);
var $f3e2f0f906df8397$export$430a3269e24b912e;
"use strict";
$f3e2f0f906df8397$export$430a3269e24b912e = $f3e2f0f906df8397$var$getDefaultOptions;

var $4UP3S = parcelRequire("4UP3S");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $f3e2f0f906df8397$var$getDefaultOptions() {
    return Object.assign({}, (0, $4UP3S.getDefaultOptions)());
}

});

parcelRegister("7YLa0", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $5cf2b811a6ff5b69$export$19131010e7fd8373, (v) => $5cf2b811a6ff5b69$export$19131010e7fd8373 = v);
var $5cf2b811a6ff5b69$export$19131010e7fd8373;
"use strict";
$5cf2b811a6ff5b69$export$19131010e7fd8373 = void 0;

var $iNZ6W = parcelRequire("iNZ6W");

var $8Ltc2 = parcelRequire("8Ltc2");

var $dITef = parcelRequire("dITef");

var $2eUn4 = parcelRequire("2eUn4");

var $gMKCI = parcelRequire("gMKCI");

var $hZFMM = parcelRequire("hZFMM");

var $8tt4y = parcelRequire("8tt4y");

var $5TjZC = parcelRequire("5TjZC");

var $leRh0 = parcelRequire("leRh0");

var $1aJ6D = parcelRequire("1aJ6D");

var $8VFCo = parcelRequire("8VFCo");

var $jgEUH = parcelRequire("jgEUH");

var $9csEn = parcelRequire("9csEn");

var $dpfSm = parcelRequire("dpfSm");

var $lYulP = parcelRequire("lYulP");

var $1OfTe = parcelRequire("1OfTe");

var $8ADKY = parcelRequire("8ADKY");

var $imMH6 = parcelRequire("imMH6");

var $5zEqc = parcelRequire("5zEqc");

var $a0YFJ = parcelRequire("a0YFJ");

var $gU9jF = parcelRequire("gU9jF");

var $q1nV3 = parcelRequire("q1nV3");

var $fMKKf = parcelRequire("fMKKf");

var $3E4gZ = parcelRequire("3E4gZ");

var $lHBzG = parcelRequire("lHBzG");

var $2ucqy = parcelRequire("2ucqy");

var $cDVgN = parcelRequire("cDVgN");

var $ccq0m = parcelRequire("ccq0m");

var $b7ibZ = parcelRequire("b7ibZ");

var $epFsP = parcelRequire("epFsP");

var $je1c0 = parcelRequire("je1c0");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $5cf2b811a6ff5b69$var$parsers = $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new $iNZ6W.EraParser(),
    y: new $8Ltc2.YearParser(),
    Y: new $dITef.LocalWeekYearParser(),
    R: new $2eUn4.ISOWeekYearParser(),
    u: new $gMKCI.ExtendedYearParser(),
    Q: new $hZFMM.QuarterParser(),
    q: new $8tt4y.StandAloneQuarterParser(),
    M: new $5TjZC.MonthParser(),
    L: new $leRh0.StandAloneMonthParser(),
    w: new $1aJ6D.LocalWeekParser(),
    I: new $8VFCo.ISOWeekParser(),
    d: new $jgEUH.DateParser(),
    D: new $9csEn.DayOfYearParser(),
    E: new $dpfSm.DayParser(),
    e: new $lYulP.LocalDayParser(),
    c: new $1OfTe.StandAloneLocalDayParser(),
    i: new $8ADKY.ISODayParser(),
    a: new $imMH6.AMPMParser(),
    b: new $5zEqc.AMPMMidnightParser(),
    B: new $a0YFJ.DayPeriodParser(),
    h: new $gU9jF.Hour1to12Parser(),
    H: new $q1nV3.Hour0to23Parser(),
    K: new $fMKKf.Hour0To11Parser(),
    k: new $3E4gZ.Hour1To24Parser(),
    m: new $lHBzG.MinuteParser(),
    s: new $2ucqy.SecondParser(),
    S: new $cDVgN.FractionOfSecondParser(),
    X: new $ccq0m.ISOTimezoneWithZParser(),
    x: new $b7ibZ.ISOTimezoneParser(),
    t: new $epFsP.TimestampSecondsParser(),
    T: new $je1c0.TimestampMillisecondsParser()
};

});
parcelRegister("iNZ6W", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $db0c34f9a22bf78d$export$8e5a1d3f85a9688, (v) => $db0c34f9a22bf78d$export$8e5a1d3f85a9688 = v);
var $db0c34f9a22bf78d$export$8e5a1d3f85a9688;
"use strict";
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = void 0;

var $g9CO5 = parcelRequire("g9CO5");
class $db0c34f9a22bf78d$var$EraParser extends $g9CO5.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = $db0c34f9a22bf78d$var$EraParser;

});
parcelRegister("g9CO5", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $bc2b96d39fc4c3d8$export$7acfa6ed01010e37, (v) => $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = v);
var $bc2b96d39fc4c3d8$export$7acfa6ed01010e37;
"use strict";
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = void 0;

var $3Mmu1 = parcelRequire("3Mmu1");
class $bc2b96d39fc4c3d8$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $3Mmu1.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = $bc2b96d39fc4c3d8$var$Parser;

});
parcelRegister("3Mmu1", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5, (v) => $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = v);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee, (v) => $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = v);
var $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5;
var $2c074b7ab8cd2d6d$export$81d53e3678089a6;
var $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee;
"use strict";
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = void 0;

var $7F7K0 = parcelRequire("7F7K0");

var $eK5z7 = parcelRequire("eK5z7");
const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$var$Setter;
class $2c074b7ab8cd2d6d$var$ValueSetter extends $2c074b7ab8cd2d6d$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$var$ValueSetter;
class $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter extends $2c074b7ab8cd2d6d$var$Setter {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $eK5z7.constructFrom)(date, (0, $7F7K0.transpose)(date, Date));
    }
}
$2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter;

});
parcelRegister("7F7K0", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $59425df5ba0b4bea$export$9cb09a71b7d66923, (v) => $59425df5ba0b4bea$export$9cb09a71b7d66923 = v);
var $59425df5ba0b4bea$export$9cb09a71b7d66923;
"use strict";
$59425df5ba0b4bea$export$9cb09a71b7d66923 = $59425df5ba0b4bea$var$transpose;

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $59425df5ba0b4bea$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $eK5z7.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("8Ltc2", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $66195bae0f19f15a$export$48d352de7cd4a988, (v) => $66195bae0f19f15a$export$48d352de7cd4a988 = v);
var $66195bae0f19f15a$export$48d352de7cd4a988;
"use strict";
$66195bae0f19f15a$export$48d352de7cd4a988 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $66195bae0f19f15a$var$YearParser extends $g9CO5.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $aHGaK.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$66195bae0f19f15a$export$48d352de7cd4a988 = $66195bae0f19f15a$var$YearParser;

});
parcelRegister("aHGaK", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", () => $7caea2161b2082cf$export$fb506d2676e7f207, (v) => $7caea2161b2082cf$export$fb506d2676e7f207 = v);
$parcel$export(module.exports, "isLeapYearIndex", () => $7caea2161b2082cf$export$3d50627710b84d75, (v) => $7caea2161b2082cf$export$3d50627710b84d75 = v);
$parcel$export(module.exports, "mapValue", () => $7caea2161b2082cf$export$4f84e3a82c7b538, (v) => $7caea2161b2082cf$export$4f84e3a82c7b538 = v);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $7caea2161b2082cf$export$29126f735cbf69f7, (v) => $7caea2161b2082cf$export$29126f735cbf69f7 = v);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $7caea2161b2082cf$export$d931c43c4608a164, (v) => $7caea2161b2082cf$export$d931c43c4608a164 = v);
$parcel$export(module.exports, "parseNDigits", () => $7caea2161b2082cf$export$513bb01536146ab6, (v) => $7caea2161b2082cf$export$513bb01536146ab6 = v);
$parcel$export(module.exports, "parseNDigitsSigned", () => $7caea2161b2082cf$export$2c9307b2e29c533c, (v) => $7caea2161b2082cf$export$2c9307b2e29c533c = v);
$parcel$export(module.exports, "parseNumericPattern", () => $7caea2161b2082cf$export$cc7cc9e2a3ff9388, (v) => $7caea2161b2082cf$export$cc7cc9e2a3ff9388 = v);
$parcel$export(module.exports, "parseTimezonePattern", () => $7caea2161b2082cf$export$6497f4c0ecdfba8e, (v) => $7caea2161b2082cf$export$6497f4c0ecdfba8e = v);
var $7caea2161b2082cf$export$fb506d2676e7f207;
var $7caea2161b2082cf$export$3d50627710b84d75;
var $7caea2161b2082cf$export$4f84e3a82c7b538;
var $7caea2161b2082cf$export$29126f735cbf69f7;
var $7caea2161b2082cf$export$d931c43c4608a164;
var $7caea2161b2082cf$export$513bb01536146ab6;
var $7caea2161b2082cf$export$2c9307b2e29c533c;
var $7caea2161b2082cf$export$cc7cc9e2a3ff9388;
var $7caea2161b2082cf$export$6497f4c0ecdfba8e;
"use strict";
$7caea2161b2082cf$export$fb506d2676e7f207 = $7caea2161b2082cf$var$dayPeriodEnumToHours;
$7caea2161b2082cf$export$3d50627710b84d75 = $7caea2161b2082cf$var$isLeapYearIndex;
$7caea2161b2082cf$export$4f84e3a82c7b538 = $7caea2161b2082cf$var$mapValue;
$7caea2161b2082cf$export$29126f735cbf69f7 = $7caea2161b2082cf$var$normalizeTwoDigitYear;
$7caea2161b2082cf$export$d931c43c4608a164 = $7caea2161b2082cf$var$parseAnyDigitsSigned;
$7caea2161b2082cf$export$513bb01536146ab6 = $7caea2161b2082cf$var$parseNDigits;
$7caea2161b2082cf$export$2c9307b2e29c533c = $7caea2161b2082cf$var$parseNDigitsSigned;
$7caea2161b2082cf$export$cc7cc9e2a3ff9388 = $7caea2161b2082cf$var$parseNumericPattern;
$7caea2161b2082cf$export$6497f4c0ecdfba8e = $7caea2161b2082cf$var$parseTimezonePattern;

var $briB4 = parcelRequire("briB4");

var $crnJg = parcelRequire("crnJg");
function $7caea2161b2082cf$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $briB4.millisecondsInHour + minutes * $briB4.millisecondsInMinute + seconds * $briB4.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseAnyDigitsSigned(dateString) {
    return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.fourDigits, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($crnJg.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("crnJg", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", () => $90ea69bf2b625c49$export$a7ee192b982af9c1, (v) => $90ea69bf2b625c49$export$a7ee192b982af9c1 = v);
$parcel$export(module.exports, "numericPatterns", () => $90ea69bf2b625c49$export$c123ee06d9da8480, (v) => $90ea69bf2b625c49$export$c123ee06d9da8480 = v);
var $90ea69bf2b625c49$export$a7ee192b982af9c1;
var $90ea69bf2b625c49$export$c123ee06d9da8480;
"use strict";
$90ea69bf2b625c49$export$a7ee192b982af9c1 = $90ea69bf2b625c49$export$c123ee06d9da8480 = void 0;
const $90ea69bf2b625c49$var$numericPatterns = $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$var$timezonePatterns = $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("dITef", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $9fda39b31cab7345$export$b8ef38dfcf05d5db, (v) => $9fda39b31cab7345$export$b8ef38dfcf05d5db = v);
var $9fda39b31cab7345$export$b8ef38dfcf05d5db;
"use strict";
$9fda39b31cab7345$export$b8ef38dfcf05d5db = void 0;

var $7Fy3C = parcelRequire("7Fy3C");

var $8ple2 = parcelRequire("8ple2");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Local week-numbering year
class $9fda39b31cab7345$var$LocalWeekYearParser extends $g9CO5.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $7Fy3C.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $aHGaK.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $8ple2.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $8ple2.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$9fda39b31cab7345$export$b8ef38dfcf05d5db = $9fda39b31cab7345$var$LocalWeekYearParser;

});

parcelRegister("2eUn4", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $1a189db5f2a1065c$export$951d1df011fde06f, (v) => $1a189db5f2a1065c$export$951d1df011fde06f = v);
var $1a189db5f2a1065c$export$951d1df011fde06f;
"use strict";
$1a189db5f2a1065c$export$951d1df011fde06f = void 0;

var $2sjl8 = parcelRequire("2sjl8");

var $eK5z7 = parcelRequire("eK5z7");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// ISO week-numbering year
class $1a189db5f2a1065c$var$ISOWeekYearParser extends $g9CO5.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $aHGaK.parseNDigitsSigned)(4, dateString);
        return (0, $aHGaK.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $eK5z7.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $2sjl8.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$1a189db5f2a1065c$export$951d1df011fde06f = $1a189db5f2a1065c$var$ISOWeekYearParser;

});

parcelRegister("gMKCI", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $c3854b7a937037cd$export$bad9d2ea38e8f1a, (v) => $c3854b7a937037cd$export$bad9d2ea38e8f1a = v);
var $c3854b7a937037cd$export$bad9d2ea38e8f1a;
"use strict";
$c3854b7a937037cd$export$bad9d2ea38e8f1a = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $c3854b7a937037cd$var$ExtendedYearParser extends $g9CO5.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $aHGaK.parseNDigitsSigned)(4, dateString);
        return (0, $aHGaK.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c3854b7a937037cd$export$bad9d2ea38e8f1a = $c3854b7a937037cd$var$ExtendedYearParser;

});

parcelRegister("hZFMM", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $d1988bf983127f3e$export$5cb0f701186dde1d, (v) => $d1988bf983127f3e$export$5cb0f701186dde1d = v);
var $d1988bf983127f3e$export$5cb0f701186dde1d;
"use strict";
$d1988bf983127f3e$export$5cb0f701186dde1d = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $d1988bf983127f3e$var$QuarterParser extends $g9CO5.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$d1988bf983127f3e$export$5cb0f701186dde1d = $d1988bf983127f3e$var$QuarterParser;

});

parcelRegister("8tt4y", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $62b79555ac1f33b0$export$300c0c2990e20e6d, (v) => $62b79555ac1f33b0$export$300c0c2990e20e6d = v);
var $62b79555ac1f33b0$export$300c0c2990e20e6d;
"use strict";
$62b79555ac1f33b0$export$300c0c2990e20e6d = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $62b79555ac1f33b0$var$StandAloneQuarterParser extends $g9CO5.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$62b79555ac1f33b0$export$300c0c2990e20e6d = $62b79555ac1f33b0$var$StandAloneQuarterParser;

});

parcelRegister("5TjZC", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $44a198f4e488a239$export$400dd8b40ef138a3, (v) => $44a198f4e488a239$export$400dd8b40ef138a3 = v);
var $44a198f4e488a239$export$400dd8b40ef138a3;
"use strict";
$44a198f4e488a239$export$400dd8b40ef138a3 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $44a198f4e488a239$var$MonthParser extends $g9CO5.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$44a198f4e488a239$export$400dd8b40ef138a3 = $44a198f4e488a239$var$MonthParser;

});

parcelRegister("leRh0", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $f7643ab884280f91$export$1d7eaa53eaa5deba, (v) => $f7643ab884280f91$export$1d7eaa53eaa5deba = v);
var $f7643ab884280f91$export$1d7eaa53eaa5deba;
"use strict";
$f7643ab884280f91$export$1d7eaa53eaa5deba = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $f7643ab884280f91$var$StandAloneMonthParser extends $g9CO5.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f7643ab884280f91$export$1d7eaa53eaa5deba = $f7643ab884280f91$var$StandAloneMonthParser;

});

parcelRegister("1aJ6D", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $0da9b6c0b13ee7fd$export$c4005ffc174e07c0, (v) => $0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = v);
var $0da9b6c0b13ee7fd$export$c4005ffc174e07c0;
"use strict";
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = void 0;

var $8P5CE = parcelRequire("8P5CE");

var $8ple2 = parcelRequire("8ple2");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Local week of year
class $0da9b6c0b13ee7fd$var$LocalWeekParser extends $g9CO5.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $8ple2.startOfWeek)((0, $8P5CE.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = $0da9b6c0b13ee7fd$var$LocalWeekParser;

});
parcelRegister("8P5CE", function(module, exports) {

$parcel$export(module.exports, "setWeek", () => $66c7729eb95aa501$export$4b3066ce4afafd88, (v) => $66c7729eb95aa501$export$4b3066ce4afafd88 = v);
var $66c7729eb95aa501$export$4b3066ce4afafd88;
"use strict";
$66c7729eb95aa501$export$4b3066ce4afafd88 = $66c7729eb95aa501$var$setWeek;

var $1wdT6 = parcelRequire("1wdT6");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $66c7729eb95aa501$var$setWeek(date, week, options) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $1wdT6.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("8VFCo", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $6803ee1ef2b46eaa$export$6fc8dbedd560a6af, (v) => $6803ee1ef2b46eaa$export$6fc8dbedd560a6af = v);
var $6803ee1ef2b46eaa$export$6fc8dbedd560a6af;
"use strict";
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = void 0;

var $hTRRJ = parcelRequire("hTRRJ");

var $2sjl8 = parcelRequire("2sjl8");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// ISO week of year
class $6803ee1ef2b46eaa$var$ISOWeekParser extends $g9CO5.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $2sjl8.startOfISOWeek)((0, $hTRRJ.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = $6803ee1ef2b46eaa$var$ISOWeekParser;

});
parcelRegister("hTRRJ", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", () => $d0815b4ed45bc80a$export$6542bebf6be94082, (v) => $d0815b4ed45bc80a$export$6542bebf6be94082 = v);
var $d0815b4ed45bc80a$export$6542bebf6be94082;
"use strict";
$d0815b4ed45bc80a$export$6542bebf6be94082 = $d0815b4ed45bc80a$var$setISOWeek;

var $bjZpy = parcelRequire("bjZpy");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $d0815b4ed45bc80a$var$setISOWeek(date, week) {
    const _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $bjZpy.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("jgEUH", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $e06f3f7fc9153746$export$e8d4b28a20981dd2, (v) => $e06f3f7fc9153746$export$e8d4b28a20981dd2 = v);
var $e06f3f7fc9153746$export$e8d4b28a20981dd2;
"use strict";
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $e06f3f7fc9153746$var$DateParser extends $g9CO5.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $aHGaK.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = $e06f3f7fc9153746$var$DateParser;

});

parcelRegister("9csEn", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $6b2b75646543924f$export$6cfe0d613455f615, (v) => $6b2b75646543924f$export$6cfe0d613455f615 = v);
var $6b2b75646543924f$export$6cfe0d613455f615;
"use strict";
$6b2b75646543924f$export$6cfe0d613455f615 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $6b2b75646543924f$var$DayOfYearParser extends $g9CO5.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $aHGaK.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6b2b75646543924f$export$6cfe0d613455f615 = $6b2b75646543924f$var$DayOfYearParser;

});

parcelRegister("dpfSm", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $9c29ecc5d15fe12f$export$1b03c8b76262f7bd, (v) => $9c29ecc5d15fe12f$export$1b03c8b76262f7bd = v);
var $9c29ecc5d15fe12f$export$1b03c8b76262f7bd;
"use strict";
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = void 0;

var $1GcKu = parcelRequire("1GcKu");

var $g9CO5 = parcelRequire("g9CO5");
// Day of week
class $9c29ecc5d15fe12f$var$DayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1GcKu.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = $9c29ecc5d15fe12f$var$DayParser;

});
parcelRegister("1GcKu", function(module, exports) {

$parcel$export(module.exports, "setDay", () => $13939a537621d91b$export$b04fdcda82decc6c, (v) => $13939a537621d91b$export$b04fdcda82decc6c = v);
var $13939a537621d91b$export$b04fdcda82decc6c;
"use strict";
$13939a537621d91b$export$b04fdcda82decc6c = $13939a537621d91b$var$setDay;

var $e1kwM = parcelRequire("e1kwM");

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $13939a537621d91b$var$setDay(date, day, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $30SVQ.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $e1kwM.addDays)(_date, diff);
}

});


parcelRegister("lYulP", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $fff6beaa36b4d0e5$export$44d1c127ab42c480, (v) => $fff6beaa36b4d0e5$export$44d1c127ab42c480 = v);
var $fff6beaa36b4d0e5$export$44d1c127ab42c480;
"use strict";
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = void 0;

var $1GcKu = parcelRequire("1GcKu");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Local day of week
class $fff6beaa36b4d0e5$var$LocalDayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1GcKu.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = $fff6beaa36b4d0e5$var$LocalDayParser;

});

parcelRegister("1OfTe", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $1516c9543f7b6045$export$e447a647caaaec1d, (v) => $1516c9543f7b6045$export$e447a647caaaec1d = v);
var $1516c9543f7b6045$export$e447a647caaaec1d;
"use strict";
$1516c9543f7b6045$export$e447a647caaaec1d = void 0;

var $1GcKu = parcelRequire("1GcKu");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Stand-alone local day of week
class $1516c9543f7b6045$var$StandAloneLocalDayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $aHGaK.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1GcKu.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$1516c9543f7b6045$export$e447a647caaaec1d = $1516c9543f7b6045$var$StandAloneLocalDayParser;

});

parcelRegister("8ADKY", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $6410865f895f2a05$export$693fb1e525095b2a, (v) => $6410865f895f2a05$export$693fb1e525095b2a = v);
var $6410865f895f2a05$export$693fb1e525095b2a;
"use strict";
$6410865f895f2a05$export$693fb1e525095b2a = void 0;

var $bE3Y3 = parcelRequire("bE3Y3");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// ISO day of week
class $6410865f895f2a05$var$ISODayParser extends $g9CO5.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $aHGaK.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $bE3Y3.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6410865f895f2a05$export$693fb1e525095b2a = $6410865f895f2a05$var$ISODayParser;

});
parcelRegister("bE3Y3", function(module, exports) {

$parcel$export(module.exports, "setISODay", () => $87a68208fbd57247$export$1fd9df65adb0d1aa, (v) => $87a68208fbd57247$export$1fd9df65adb0d1aa = v);
var $87a68208fbd57247$export$1fd9df65adb0d1aa;
"use strict";
$87a68208fbd57247$export$1fd9df65adb0d1aa = $87a68208fbd57247$var$setISODay;

var $e1kwM = parcelRequire("e1kwM");

var $9zwKS = parcelRequire("9zwKS");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $87a68208fbd57247$var$setISODay(date, day) {
    const _date = (0, $30SVQ.toDate)(date);
    const currentDay = (0, $9zwKS.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $e1kwM.addDays)(_date, diff);
}

});
parcelRegister("9zwKS", function(module, exports) {

$parcel$export(module.exports, "getISODay", () => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e, (v) => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e = v);
var $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;
"use strict";
$6f80ca66d6710e40$export$c514f4c1a8ed5e9e = $6f80ca66d6710e40$var$getISODay;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $6f80ca66d6710e40$var$getISODay(date) {
    const _date = (0, $30SVQ.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});



parcelRegister("imMH6", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $d5f00db985cb1985$export$8d1e08492351df91, (v) => $d5f00db985cb1985$export$8d1e08492351df91 = v);
var $d5f00db985cb1985$export$8d1e08492351df91;
"use strict";
$d5f00db985cb1985$export$8d1e08492351df91 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $d5f00db985cb1985$var$AMPMParser extends $g9CO5.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $aHGaK.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$d5f00db985cb1985$export$8d1e08492351df91 = $d5f00db985cb1985$var$AMPMParser;

});

parcelRegister("5zEqc", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $40ef93898dc5fd94$export$73ca2bd0a17d273, (v) => $40ef93898dc5fd94$export$73ca2bd0a17d273 = v);
var $40ef93898dc5fd94$export$73ca2bd0a17d273;
"use strict";
$40ef93898dc5fd94$export$73ca2bd0a17d273 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $40ef93898dc5fd94$var$AMPMMidnightParser extends $g9CO5.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $aHGaK.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$40ef93898dc5fd94$export$73ca2bd0a17d273 = $40ef93898dc5fd94$var$AMPMMidnightParser;

});

parcelRegister("a0YFJ", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $74a8f7a92cf7f4b7$export$bb9212adf05373db, (v) => $74a8f7a92cf7f4b7$export$bb9212adf05373db = v);
var $74a8f7a92cf7f4b7$export$bb9212adf05373db;
"use strict";
$74a8f7a92cf7f4b7$export$bb9212adf05373db = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// in the morning, in the afternoon, in the evening, at night
class $74a8f7a92cf7f4b7$var$DayPeriodParser extends $g9CO5.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $aHGaK.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$74a8f7a92cf7f4b7$export$bb9212adf05373db = $74a8f7a92cf7f4b7$var$DayPeriodParser;

});

parcelRegister("gU9jF", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $c4e91a5550a4af76$export$8a04050a727a1756, (v) => $c4e91a5550a4af76$export$8a04050a727a1756 = v);
var $c4e91a5550a4af76$export$8a04050a727a1756;
"use strict";
$c4e91a5550a4af76$export$8a04050a727a1756 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $c4e91a5550a4af76$var$Hour1to12Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$c4e91a5550a4af76$export$8a04050a727a1756 = $c4e91a5550a4af76$var$Hour1to12Parser;

});

parcelRegister("q1nV3", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $04e380d05021e0e6$export$e56f4dea2c3e56dd, (v) => $04e380d05021e0e6$export$e56f4dea2c3e56dd = v);
var $04e380d05021e0e6$export$e56f4dea2c3e56dd;
"use strict";
$04e380d05021e0e6$export$e56f4dea2c3e56dd = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $04e380d05021e0e6$var$Hour0to23Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$04e380d05021e0e6$export$e56f4dea2c3e56dd = $04e380d05021e0e6$var$Hour0to23Parser;

});

parcelRegister("fMKKf", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $b7df994bc976acad$export$cbbe855312f87d77, (v) => $b7df994bc976acad$export$cbbe855312f87d77 = v);
var $b7df994bc976acad$export$cbbe855312f87d77;
"use strict";
$b7df994bc976acad$export$cbbe855312f87d77 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $b7df994bc976acad$var$Hour0To11Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$b7df994bc976acad$export$cbbe855312f87d77 = $b7df994bc976acad$var$Hour0To11Parser;

});

parcelRegister("3E4gZ", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $2a786c11f89b58f4$export$6008046d2b34b6a5, (v) => $2a786c11f89b58f4$export$6008046d2b34b6a5 = v);
var $2a786c11f89b58f4$export$6008046d2b34b6a5;
"use strict";
$2a786c11f89b58f4$export$6008046d2b34b6a5 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $2a786c11f89b58f4$var$Hour1To24Parser extends $g9CO5.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$2a786c11f89b58f4$export$6008046d2b34b6a5 = $2a786c11f89b58f4$var$Hour1To24Parser;

});

parcelRegister("lHBzG", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $fccac2a30b38ae4c$export$2b52670d9e2be53, (v) => $fccac2a30b38ae4c$export$2b52670d9e2be53 = v);
var $fccac2a30b38ae4c$export$2b52670d9e2be53;
"use strict";
$fccac2a30b38ae4c$export$2b52670d9e2be53 = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $fccac2a30b38ae4c$var$MinuteParser extends $g9CO5.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$fccac2a30b38ae4c$export$2b52670d9e2be53 = $fccac2a30b38ae4c$var$MinuteParser;

});

parcelRegister("2ucqy", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $1cf805ecbd4f0c4e$export$94d46d540cf1366a, (v) => $1cf805ecbd4f0c4e$export$94d46d540cf1366a = v);
var $1cf805ecbd4f0c4e$export$94d46d540cf1366a;
"use strict";
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = void 0;

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $1cf805ecbd4f0c4e$var$SecondParser extends $g9CO5.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $aHGaK.parseNumericPattern)($crnJg.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $aHGaK.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = $1cf805ecbd4f0c4e$var$SecondParser;

});

parcelRegister("cDVgN", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $93458d2bd887c060$export$b8e6f8b2d70893b1, (v) => $93458d2bd887c060$export$b8e6f8b2d70893b1 = v);
var $93458d2bd887c060$export$b8e6f8b2d70893b1;
"use strict";
$93458d2bd887c060$export$b8e6f8b2d70893b1 = void 0;

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $93458d2bd887c060$var$FractionOfSecondParser extends $g9CO5.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $aHGaK.mapValue)((0, $aHGaK.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$93458d2bd887c060$export$b8e6f8b2d70893b1 = $93458d2bd887c060$var$FractionOfSecondParser;

});

parcelRegister("ccq0m", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $8e1ac7071c05f7b7$export$104d901d49fea29b, (v) => $8e1ac7071c05f7b7$export$104d901d49fea29b = v);
var $8e1ac7071c05f7b7$export$104d901d49fea29b;
"use strict";
$8e1ac7071c05f7b7$export$104d901d49fea29b = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $cBJez = parcelRequire("cBJez");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser extends $g9CO5.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $eK5z7.constructFrom)(date, date.getTime() - (0, $cBJez.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$8e1ac7071c05f7b7$export$104d901d49fea29b = $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser;

});

parcelRegister("b7ibZ", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $817e75c4dd06b66a$export$12910e5204b52b9, (v) => $817e75c4dd06b66a$export$12910e5204b52b9 = v);
var $817e75c4dd06b66a$export$12910e5204b52b9;
"use strict";
$817e75c4dd06b66a$export$12910e5204b52b9 = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $cBJez = parcelRequire("cBJez");

var $crnJg = parcelRequire("crnJg");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
// Timezone (ISO-8601)
class $817e75c4dd06b66a$var$ISOTimezoneParser extends $g9CO5.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $aHGaK.parseTimezonePattern)($crnJg.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $eK5z7.constructFrom)(date, date.getTime() - (0, $cBJez.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$817e75c4dd06b66a$export$12910e5204b52b9 = $817e75c4dd06b66a$var$ISOTimezoneParser;

});

parcelRegister("epFsP", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $a7e39061a4ba0a45$export$2cd8bf877a05e96, (v) => $a7e39061a4ba0a45$export$2cd8bf877a05e96 = v);
var $a7e39061a4ba0a45$export$2cd8bf877a05e96;
"use strict";
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $a7e39061a4ba0a45$var$TimestampSecondsParser extends $g9CO5.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $aHGaK.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $eK5z7.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = $a7e39061a4ba0a45$var$TimestampSecondsParser;

});

parcelRegister("je1c0", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $dff03ff1496c0b81$export$6d8f69c6906d6368, (v) => $dff03ff1496c0b81$export$6d8f69c6906d6368 = v);
var $dff03ff1496c0b81$export$6d8f69c6906d6368;
"use strict";
$dff03ff1496c0b81$export$6d8f69c6906d6368 = void 0;

var $eK5z7 = parcelRequire("eK5z7");

var $g9CO5 = parcelRequire("g9CO5");

var $aHGaK = parcelRequire("aHGaK");
class $dff03ff1496c0b81$var$TimestampMillisecondsParser extends $g9CO5.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $aHGaK.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $eK5z7.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$dff03ff1496c0b81$export$6d8f69c6906d6368 = $dff03ff1496c0b81$var$TimestampMillisecondsParser;

});



parcelRegister("ewus1", function(module, exports) {

$parcel$export(module.exports, "parseISO", () => $a92bacc669eda25d$export$4393d2ccbbedb219, (v) => $a92bacc669eda25d$export$4393d2ccbbedb219 = v);
var $a92bacc669eda25d$export$4393d2ccbbedb219;
"use strict";
$a92bacc669eda25d$export$4393d2ccbbedb219 = $a92bacc669eda25d$var$parseISO;

var $briB4 = parcelRequire("briB4");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $a92bacc669eda25d$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $a92bacc669eda25d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $a92bacc669eda25d$var$parseYear(dateStrings.date, additionalDigits);
        date = $a92bacc669eda25d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $a92bacc669eda25d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $a92bacc669eda25d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $a92bacc669eda25d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $a92bacc669eda25d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $a92bacc669eda25d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $a92bacc669eda25d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a92bacc669eda25d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($a92bacc669eda25d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a92bacc669eda25d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a92bacc669eda25d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $a92bacc669eda25d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a92bacc669eda25d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a92bacc669eda25d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($a92bacc669eda25d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $a92bacc669eda25d$var$parseDateUnit(captures[1]);
    const month = $a92bacc669eda25d$var$parseDateUnit(captures[2]) - 1;
    const day = $a92bacc669eda25d$var$parseDateUnit(captures[3]);
    const week = $a92bacc669eda25d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $a92bacc669eda25d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a92bacc669eda25d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a92bacc669eda25d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$a92bacc669eda25d$var$validateDate(year, month, day) || !$a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a92bacc669eda25d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a92bacc669eda25d$var$parseTime(timeString) {
    const captures = timeString.match($a92bacc669eda25d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $a92bacc669eda25d$var$parseTimeUnit(captures[1]);
    const minutes = $a92bacc669eda25d$var$parseTimeUnit(captures[2]);
    const seconds = $a92bacc669eda25d$var$parseTimeUnit(captures[3]);
    if (!$a92bacc669eda25d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $briB4.millisecondsInHour + minutes * $briB4.millisecondsInMinute + seconds * 1000;
}
function $a92bacc669eda25d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a92bacc669eda25d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($a92bacc669eda25d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a92bacc669eda25d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $briB4.millisecondsInHour + minutes * $briB4.millisecondsInMinute);
}
function $a92bacc669eda25d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $a92bacc669eda25d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a92bacc669eda25d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a92bacc669eda25d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a92bacc669eda25d$var$daysInMonths[month] || ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a92bacc669eda25d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a92bacc669eda25d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a92bacc669eda25d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("7PieZ", function(module, exports) {
"use strict";

var $7eqmQ = parcelRequire("7eqmQ");
Object.keys($7eqmQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7eqmQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7eqmQ[key];
        }
    });
});

var $4J4yL = parcelRequire("4J4yL");
Object.keys($4J4yL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4J4yL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4J4yL[key];
        }
    });
});

var $e1kwM = parcelRequire("e1kwM");
Object.keys($e1kwM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e1kwM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e1kwM[key];
        }
    });
});

var $iMX5A = parcelRequire("iMX5A");
Object.keys($iMX5A).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iMX5A[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iMX5A[key];
        }
    });
});

var $gsBEc = parcelRequire("gsBEc");
Object.keys($gsBEc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gsBEc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gsBEc[key];
        }
    });
});

var $dR7TY = parcelRequire("dR7TY");
Object.keys($dR7TY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dR7TY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dR7TY[key];
        }
    });
});

var $jZtIs = parcelRequire("jZtIs");
Object.keys($jZtIs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jZtIs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jZtIs[key];
        }
    });
});

var $cls5f = parcelRequire("cls5f");
Object.keys($cls5f).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cls5f[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cls5f[key];
        }
    });
});

var $4chdC = parcelRequire("4chdC");
Object.keys($4chdC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4chdC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4chdC[key];
        }
    });
});

var $kiEfO = parcelRequire("kiEfO");
Object.keys($kiEfO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kiEfO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kiEfO[key];
        }
    });
});

var $gdvs1 = parcelRequire("gdvs1");
Object.keys($gdvs1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gdvs1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gdvs1[key];
        }
    });
});

var $3cpd6 = parcelRequire("3cpd6");
Object.keys($3cpd6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3cpd6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3cpd6[key];
        }
    });
});

var $lwpTe = parcelRequire("lwpTe");
Object.keys($lwpTe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lwpTe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lwpTe[key];
        }
    });
});

var $7LQtK = parcelRequire("7LQtK");
Object.keys($7LQtK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7LQtK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7LQtK[key];
        }
    });
});

var $U9Kpz = parcelRequire("U9Kpz");
Object.keys($U9Kpz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $U9Kpz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $U9Kpz[key];
        }
    });
});

var $eeNdR = parcelRequire("eeNdR");
Object.keys($eeNdR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eeNdR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eeNdR[key];
        }
    });
});

var $k4zPp = parcelRequire("k4zPp");
Object.keys($k4zPp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k4zPp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k4zPp[key];
        }
    });
});

var $1MTO0 = parcelRequire("1MTO0");
Object.keys($1MTO0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1MTO0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1MTO0[key];
        }
    });
});

var $eK5z7 = parcelRequire("eK5z7");
Object.keys($eK5z7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eK5z7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eK5z7[key];
        }
    });
});

var $izNX2 = parcelRequire("izNX2");
Object.keys($izNX2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $izNX2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $izNX2[key];
        }
    });
});

var $4f728 = parcelRequire("4f728");
Object.keys($4f728).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4f728[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4f728[key];
        }
    });
});

var $a8jD3 = parcelRequire("a8jD3");
Object.keys($a8jD3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a8jD3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a8jD3[key];
        }
    });
});

var $9UMYl = parcelRequire("9UMYl");
Object.keys($9UMYl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9UMYl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9UMYl[key];
        }
    });
});

var $jolZ6 = parcelRequire("jolZ6");
Object.keys($jolZ6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jolZ6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jolZ6[key];
        }
    });
});

var $9yHRM = parcelRequire("9yHRM");
Object.keys($9yHRM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9yHRM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9yHRM[key];
        }
    });
});

var $bTWJP = parcelRequire("bTWJP");
Object.keys($bTWJP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bTWJP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bTWJP[key];
        }
    });
});

var $7yyNc = parcelRequire("7yyNc");
Object.keys($7yyNc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7yyNc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7yyNc[key];
        }
    });
});

var $hcJKh = parcelRequire("hcJKh");
Object.keys($hcJKh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hcJKh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hcJKh[key];
        }
    });
});

var $7b4id = parcelRequire("7b4id");
Object.keys($7b4id).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7b4id[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7b4id[key];
        }
    });
});

var $2THNu = parcelRequire("2THNu");
Object.keys($2THNu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2THNu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2THNu[key];
        }
    });
});

var $kLDS0 = parcelRequire("kLDS0");
Object.keys($kLDS0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kLDS0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kLDS0[key];
        }
    });
});

var $gTY9Z = parcelRequire("gTY9Z");
Object.keys($gTY9Z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gTY9Z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gTY9Z[key];
        }
    });
});

var $fL7JV = parcelRequire("fL7JV");
Object.keys($fL7JV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fL7JV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fL7JV[key];
        }
    });
});

var $8V4Fd = parcelRequire("8V4Fd");
Object.keys($8V4Fd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8V4Fd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8V4Fd[key];
        }
    });
});

var $6v0iN = parcelRequire("6v0iN");
Object.keys($6v0iN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6v0iN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6v0iN[key];
        }
    });
});

var $l0dhV = parcelRequire("l0dhV");
Object.keys($l0dhV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l0dhV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l0dhV[key];
        }
    });
});

var $k0LcS = parcelRequire("k0LcS");
Object.keys($k0LcS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k0LcS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k0LcS[key];
        }
    });
});

var $bpFlP = parcelRequire("bpFlP");
Object.keys($bpFlP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bpFlP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bpFlP[key];
        }
    });
});

var $gpIjX = parcelRequire("gpIjX");
Object.keys($gpIjX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gpIjX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gpIjX[key];
        }
    });
});

var $VSaoY = parcelRequire("VSaoY");
Object.keys($VSaoY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $VSaoY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $VSaoY[key];
        }
    });
});

var $fafHZ = parcelRequire("fafHZ");
Object.keys($fafHZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fafHZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fafHZ[key];
        }
    });
});

var $1Nc0n = parcelRequire("1Nc0n");
Object.keys($1Nc0n).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1Nc0n[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1Nc0n[key];
        }
    });
});

var $kJrjC = parcelRequire("kJrjC");
Object.keys($kJrjC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kJrjC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kJrjC[key];
        }
    });
});

var $alowK = parcelRequire("alowK");
Object.keys($alowK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $alowK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $alowK[key];
        }
    });
});

var $9QT8W = parcelRequire("9QT8W");
Object.keys($9QT8W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9QT8W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9QT8W[key];
        }
    });
});

var $eUAWc = parcelRequire("eUAWc");
Object.keys($eUAWc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eUAWc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eUAWc[key];
        }
    });
});

var $bAVu4 = parcelRequire("bAVu4");
Object.keys($bAVu4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bAVu4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bAVu4[key];
        }
    });
});

var $kp39E = parcelRequire("kp39E");
Object.keys($kp39E).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kp39E[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kp39E[key];
        }
    });
});

var $lKJbU = parcelRequire("lKJbU");
Object.keys($lKJbU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lKJbU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lKJbU[key];
        }
    });
});

var $fG9DL = parcelRequire("fG9DL");
Object.keys($fG9DL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fG9DL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fG9DL[key];
        }
    });
});

var $keGeG = parcelRequire("keGeG");
Object.keys($keGeG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $keGeG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $keGeG[key];
        }
    });
});

var $6lnQU = parcelRequire("6lnQU");
Object.keys($6lnQU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6lnQU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6lnQU[key];
        }
    });
});

var $4yek1 = parcelRequire("4yek1");
Object.keys($4yek1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4yek1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4yek1[key];
        }
    });
});

var $amgp4 = parcelRequire("amgp4");
Object.keys($amgp4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $amgp4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $amgp4[key];
        }
    });
});

var $dz0HX = parcelRequire("dz0HX");
Object.keys($dz0HX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dz0HX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dz0HX[key];
        }
    });
});

var $jHGP1 = parcelRequire("jHGP1");
Object.keys($jHGP1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jHGP1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jHGP1[key];
        }
    });
});

var $3wcOM = parcelRequire("3wcOM");
Object.keys($3wcOM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3wcOM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3wcOM[key];
        }
    });
});

var $kr84Q = parcelRequire("kr84Q");
Object.keys($kr84Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kr84Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kr84Q[key];
        }
    });
});

var $gH8eG = parcelRequire("gH8eG");
Object.keys($gH8eG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gH8eG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gH8eG[key];
        }
    });
});

var $5HaPb = parcelRequire("5HaPb");
Object.keys($5HaPb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5HaPb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5HaPb[key];
        }
    });
});

var $iiR1c = parcelRequire("iiR1c");
Object.keys($iiR1c).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iiR1c[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iiR1c[key];
        }
    });
});

var $9kRZo = parcelRequire("9kRZo");
Object.keys($9kRZo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9kRZo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9kRZo[key];
        }
    });
});

var $b9D0S = parcelRequire("b9D0S");
Object.keys($b9D0S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b9D0S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b9D0S[key];
        }
    });
});

var $48K34 = parcelRequire("48K34");
Object.keys($48K34).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $48K34[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $48K34[key];
        }
    });
});

var $dwrDU = parcelRequire("dwrDU");
Object.keys($dwrDU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dwrDU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dwrDU[key];
        }
    });
});

var $cQzGW = parcelRequire("cQzGW");
Object.keys($cQzGW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cQzGW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cQzGW[key];
        }
    });
});

var $fS36e = parcelRequire("fS36e");
Object.keys($fS36e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fS36e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fS36e[key];
        }
    });
});

var $3t7lx = parcelRequire("3t7lx");
Object.keys($3t7lx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3t7lx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3t7lx[key];
        }
    });
});

var $7moI3 = parcelRequire("7moI3");
Object.keys($7moI3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7moI3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7moI3[key];
        }
    });
});

var $so6MK = parcelRequire("so6MK");
Object.keys($so6MK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $so6MK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $so6MK[key];
        }
    });
});

var $imstp = parcelRequire("imstp");
Object.keys($imstp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $imstp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $imstp[key];
        }
    });
});

var $9hw20 = parcelRequire("9hw20");
Object.keys($9hw20).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9hw20[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9hw20[key];
        }
    });
});

var $isJdR = parcelRequire("isJdR");
Object.keys($isJdR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $isJdR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $isJdR[key];
        }
    });
});

var $3kPwX = parcelRequire("3kPwX");
Object.keys($3kPwX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3kPwX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3kPwX[key];
        }
    });
});

var $bmvAp = parcelRequire("bmvAp");
Object.keys($bmvAp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bmvAp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bmvAp[key];
        }
    });
});

var $a7cZg = parcelRequire("a7cZg");
Object.keys($a7cZg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a7cZg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a7cZg[key];
        }
    });
});

var $inqX7 = parcelRequire("inqX7");
Object.keys($inqX7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $inqX7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $inqX7[key];
        }
    });
});

var $gf6Rq = parcelRequire("gf6Rq");
Object.keys($gf6Rq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gf6Rq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gf6Rq[key];
        }
    });
});

var $49JO2 = parcelRequire("49JO2");
Object.keys($49JO2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $49JO2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $49JO2[key];
        }
    });
});

var $7uieS = parcelRequire("7uieS");
Object.keys($7uieS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7uieS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7uieS[key];
        }
    });
});

var $8S6kT = parcelRequire("8S6kT");
Object.keys($8S6kT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8S6kT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8S6kT[key];
        }
    });
});

var $9C8D5 = parcelRequire("9C8D5");
Object.keys($9C8D5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9C8D5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9C8D5[key];
        }
    });
});

var $kWcwI = parcelRequire("kWcwI");
Object.keys($kWcwI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kWcwI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kWcwI[key];
        }
    });
});

var $lIpMn = parcelRequire("lIpMn");
Object.keys($lIpMn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lIpMn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lIpMn[key];
        }
    });
});

var $9zwKS = parcelRequire("9zwKS");
Object.keys($9zwKS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9zwKS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9zwKS[key];
        }
    });
});

var $bjZpy = parcelRequire("bjZpy");
Object.keys($bjZpy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bjZpy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bjZpy[key];
        }
    });
});

var $hhS6V = parcelRequire("hhS6V");
Object.keys($hhS6V).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hhS6V[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hhS6V[key];
        }
    });
});

var $1sX9f = parcelRequire("1sX9f");
Object.keys($1sX9f).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1sX9f[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1sX9f[key];
        }
    });
});

var $c1AiI = parcelRequire("c1AiI");
Object.keys($c1AiI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c1AiI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c1AiI[key];
        }
    });
});

var $12jbR = parcelRequire("12jbR");
Object.keys($12jbR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $12jbR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $12jbR[key];
        }
    });
});

var $9xRRE = parcelRequire("9xRRE");
Object.keys($9xRRE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9xRRE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9xRRE[key];
        }
    });
});

var $eavWe = parcelRequire("eavWe");
Object.keys($eavWe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eavWe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eavWe[key];
        }
    });
});

var $a9aPJ = parcelRequire("a9aPJ");
Object.keys($a9aPJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a9aPJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a9aPJ[key];
        }
    });
});

var $ebQpN = parcelRequire("ebQpN");
Object.keys($ebQpN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ebQpN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ebQpN[key];
        }
    });
});

var $dF81P = parcelRequire("dF81P");
Object.keys($dF81P).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dF81P[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dF81P[key];
        }
    });
});

var $h0fvZ = parcelRequire("h0fvZ");
Object.keys($h0fvZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h0fvZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h0fvZ[key];
        }
    });
});

var $1wdT6 = parcelRequire("1wdT6");
Object.keys($1wdT6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1wdT6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1wdT6[key];
        }
    });
});

var $8uZvx = parcelRequire("8uZvx");
Object.keys($8uZvx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8uZvx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8uZvx[key];
        }
    });
});

var $7Fy3C = parcelRequire("7Fy3C");
Object.keys($7Fy3C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Fy3C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Fy3C[key];
        }
    });
});

var $gDNrw = parcelRequire("gDNrw");
Object.keys($gDNrw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gDNrw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gDNrw[key];
        }
    });
});

var $5CRrs = parcelRequire("5CRrs");
Object.keys($5CRrs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5CRrs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5CRrs[key];
        }
    });
});

var $diyr6 = parcelRequire("diyr6");
Object.keys($diyr6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $diyr6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $diyr6[key];
        }
    });
});

var $id85t = parcelRequire("id85t");
Object.keys($id85t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $id85t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $id85t[key];
        }
    });
});

var $lHdeC = parcelRequire("lHdeC");
Object.keys($lHdeC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lHdeC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lHdeC[key];
        }
    });
});

var $8O4RE = parcelRequire("8O4RE");
Object.keys($8O4RE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8O4RE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8O4RE[key];
        }
    });
});

var $1uAld = parcelRequire("1uAld");
Object.keys($1uAld).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1uAld[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1uAld[key];
        }
    });
});

var $e4oj6 = parcelRequire("e4oj6");
Object.keys($e4oj6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e4oj6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e4oj6[key];
        }
    });
});

var $d2sW8 = parcelRequire("d2sW8");
Object.keys($d2sW8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d2sW8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d2sW8[key];
        }
    });
});

var $aFxrf = parcelRequire("aFxrf");
Object.keys($aFxrf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aFxrf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aFxrf[key];
        }
    });
});

var $i5nf8 = parcelRequire("i5nf8");
Object.keys($i5nf8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i5nf8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i5nf8[key];
        }
    });
});

var $26SSu = parcelRequire("26SSu");
Object.keys($26SSu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $26SSu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $26SSu[key];
        }
    });
});

var $aw1Xf = parcelRequire("aw1Xf");
Object.keys($aw1Xf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aw1Xf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aw1Xf[key];
        }
    });
});

var $31FEl = parcelRequire("31FEl");
Object.keys($31FEl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $31FEl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $31FEl[key];
        }
    });
});

var $beuaX = parcelRequire("beuaX");
Object.keys($beuaX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $beuaX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $beuaX[key];
        }
    });
});

var $eVoqM = parcelRequire("eVoqM");
Object.keys($eVoqM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eVoqM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eVoqM[key];
        }
    });
});

var $exQR4 = parcelRequire("exQR4");
Object.keys($exQR4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $exQR4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $exQR4[key];
        }
    });
});

var $i1VFZ = parcelRequire("i1VFZ");
Object.keys($i1VFZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i1VFZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i1VFZ[key];
        }
    });
});

var $goSQN = parcelRequire("goSQN");
Object.keys($goSQN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $goSQN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $goSQN[key];
        }
    });
});

var $ccRgt = parcelRequire("ccRgt");
Object.keys($ccRgt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ccRgt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ccRgt[key];
        }
    });
});

var $5sCnM = parcelRequire("5sCnM");
Object.keys($5sCnM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5sCnM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5sCnM[key];
        }
    });
});

var $cPMBB = parcelRequire("cPMBB");
Object.keys($cPMBB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cPMBB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cPMBB[key];
        }
    });
});

var $3p5lI = parcelRequire("3p5lI");
Object.keys($3p5lI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3p5lI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3p5lI[key];
        }
    });
});

var $5hZu1 = parcelRequire("5hZu1");
Object.keys($5hZu1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5hZu1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5hZu1[key];
        }
    });
});

var $44Tpm = parcelRequire("44Tpm");
Object.keys($44Tpm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $44Tpm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $44Tpm[key];
        }
    });
});

var $ic6FC = parcelRequire("ic6FC");
Object.keys($ic6FC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ic6FC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ic6FC[key];
        }
    });
});

var $iY0Kr = parcelRequire("iY0Kr");
Object.keys($iY0Kr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iY0Kr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iY0Kr[key];
        }
    });
});

var $AFgUD = parcelRequire("AFgUD");
Object.keys($AFgUD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $AFgUD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $AFgUD[key];
        }
    });
});

var $f8HTF = parcelRequire("f8HTF");
Object.keys($f8HTF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f8HTF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f8HTF[key];
        }
    });
});

var $f2HTn = parcelRequire("f2HTn");
Object.keys($f2HTn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f2HTn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f2HTn[key];
        }
    });
});

var $5NOJ1 = parcelRequire("5NOJ1");
Object.keys($5NOJ1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5NOJ1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5NOJ1[key];
        }
    });
});

var $ea2hS = parcelRequire("ea2hS");
Object.keys($ea2hS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ea2hS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ea2hS[key];
        }
    });
});

var $iz8Ir = parcelRequire("iz8Ir");
Object.keys($iz8Ir).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iz8Ir[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iz8Ir[key];
        }
    });
});

var $cYlfj = parcelRequire("cYlfj");
Object.keys($cYlfj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cYlfj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cYlfj[key];
        }
    });
});

var $2Jk1U = parcelRequire("2Jk1U");
Object.keys($2Jk1U).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2Jk1U[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Jk1U[key];
        }
    });
});

var $1HYQi = parcelRequire("1HYQi");
Object.keys($1HYQi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1HYQi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1HYQi[key];
        }
    });
});

var $1wBjh = parcelRequire("1wBjh");
Object.keys($1wBjh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1wBjh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1wBjh[key];
        }
    });
});

var $eaHlN = parcelRequire("eaHlN");
Object.keys($eaHlN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eaHlN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eaHlN[key];
        }
    });
});

var $aBSWZ = parcelRequire("aBSWZ");
Object.keys($aBSWZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aBSWZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aBSWZ[key];
        }
    });
});

var $gAd4x = parcelRequire("gAd4x");
Object.keys($gAd4x).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gAd4x[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gAd4x[key];
        }
    });
});

var $j8O8W = parcelRequire("j8O8W");
Object.keys($j8O8W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j8O8W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j8O8W[key];
        }
    });
});

var $RAJBK = parcelRequire("RAJBK");
Object.keys($RAJBK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $RAJBK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $RAJBK[key];
        }
    });
});

var $3CNVN = parcelRequire("3CNVN");
Object.keys($3CNVN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3CNVN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3CNVN[key];
        }
    });
});

var $l4yMD = parcelRequire("l4yMD");
Object.keys($l4yMD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l4yMD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l4yMD[key];
        }
    });
});

var $bufTo = parcelRequire("bufTo");
Object.keys($bufTo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bufTo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bufTo[key];
        }
    });
});

var $cpLDu = parcelRequire("cpLDu");
Object.keys($cpLDu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cpLDu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cpLDu[key];
        }
    });
});

var $kPCB6 = parcelRequire("kPCB6");
Object.keys($kPCB6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kPCB6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kPCB6[key];
        }
    });
});

var $47KA7 = parcelRequire("47KA7");
Object.keys($47KA7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $47KA7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $47KA7[key];
        }
    });
});

var $1A6k6 = parcelRequire("1A6k6");
Object.keys($1A6k6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1A6k6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1A6k6[key];
        }
    });
});

var $dzPMY = parcelRequire("dzPMY");
Object.keys($dzPMY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dzPMY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dzPMY[key];
        }
    });
});

var $agjyF = parcelRequire("agjyF");
Object.keys($agjyF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $agjyF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $agjyF[key];
        }
    });
});

var $8hIkN = parcelRequire("8hIkN");
Object.keys($8hIkN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8hIkN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8hIkN[key];
        }
    });
});

var $4rkNn = parcelRequire("4rkNn");
Object.keys($4rkNn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4rkNn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4rkNn[key];
        }
    });
});

var $lqZFe = parcelRequire("lqZFe");
Object.keys($lqZFe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lqZFe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lqZFe[key];
        }
    });
});

var $fUlt6 = parcelRequire("fUlt6");
Object.keys($fUlt6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fUlt6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fUlt6[key];
        }
    });
});

var $f7TmA = parcelRequire("f7TmA");
Object.keys($f7TmA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f7TmA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f7TmA[key];
        }
    });
});

var $hjcVO = parcelRequire("hjcVO");
Object.keys($hjcVO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hjcVO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hjcVO[key];
        }
    });
});

var $65ik4 = parcelRequire("65ik4");
Object.keys($65ik4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $65ik4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $65ik4[key];
        }
    });
});

var $hHGXj = parcelRequire("hHGXj");
Object.keys($hHGXj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hHGXj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hHGXj[key];
        }
    });
});

var $fIlxB = parcelRequire("fIlxB");
Object.keys($fIlxB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fIlxB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fIlxB[key];
        }
    });
});

var $d1uYB = parcelRequire("d1uYB");
Object.keys($d1uYB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d1uYB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d1uYB[key];
        }
    });
});

var $etvqT = parcelRequire("etvqT");
Object.keys($etvqT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $etvqT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $etvqT[key];
        }
    });
});

var $cTeBl = parcelRequire("cTeBl");
Object.keys($cTeBl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cTeBl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cTeBl[key];
        }
    });
});

var $fnpRN = parcelRequire("fnpRN");
Object.keys($fnpRN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fnpRN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fnpRN[key];
        }
    });
});

var $80buy = parcelRequire("80buy");
Object.keys($80buy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $80buy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80buy[key];
        }
    });
});

var $7sSFN = parcelRequire("7sSFN");
Object.keys($7sSFN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7sSFN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7sSFN[key];
        }
    });
});

var $VBJUF = parcelRequire("VBJUF");
Object.keys($VBJUF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $VBJUF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $VBJUF[key];
        }
    });
});

var $cLSol = parcelRequire("cLSol");
Object.keys($cLSol).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cLSol[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cLSol[key];
        }
    });
});

var $9lRiu = parcelRequire("9lRiu");
Object.keys($9lRiu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9lRiu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9lRiu[key];
        }
    });
});

var $aJr1u = parcelRequire("aJr1u");
Object.keys($aJr1u).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aJr1u[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aJr1u[key];
        }
    });
});

var $dG3Ke = parcelRequire("dG3Ke");
Object.keys($dG3Ke).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dG3Ke[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dG3Ke[key];
        }
    });
});

var $gdX2I = parcelRequire("gdX2I");
Object.keys($gdX2I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gdX2I[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gdX2I[key];
        }
    });
});

var $h4ZBY = parcelRequire("h4ZBY");
Object.keys($h4ZBY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h4ZBY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h4ZBY[key];
        }
    });
});

var $6Caeg = parcelRequire("6Caeg");
Object.keys($6Caeg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6Caeg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6Caeg[key];
        }
    });
});

var $a5Cws = parcelRequire("a5Cws");
Object.keys($a5Cws).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $a5Cws[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a5Cws[key];
        }
    });
});

var $hucRo = parcelRequire("hucRo");
Object.keys($hucRo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hucRo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hucRo[key];
        }
    });
});

var $469lh = parcelRequire("469lh");
Object.keys($469lh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $469lh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $469lh[key];
        }
    });
});

var $39xTu = parcelRequire("39xTu");
Object.keys($39xTu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $39xTu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $39xTu[key];
        }
    });
});

var $bUtct = parcelRequire("bUtct");
Object.keys($bUtct).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bUtct[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bUtct[key];
        }
    });
});

var $ewus1 = parcelRequire("ewus1");
Object.keys($ewus1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ewus1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ewus1[key];
        }
    });
});

var $1dBco = parcelRequire("1dBco");
Object.keys($1dBco).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1dBco[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1dBco[key];
        }
    });
});

var $2oV6Q = parcelRequire("2oV6Q");
Object.keys($2oV6Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2oV6Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2oV6Q[key];
        }
    });
});

var $4k66o = parcelRequire("4k66o");
Object.keys($4k66o).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4k66o[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4k66o[key];
        }
    });
});

var $kyleL = parcelRequire("kyleL");
Object.keys($kyleL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kyleL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kyleL[key];
        }
    });
});

var $cQimJ = parcelRequire("cQimJ");
Object.keys($cQimJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cQimJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cQimJ[key];
        }
    });
});

var $5KAOu = parcelRequire("5KAOu");
Object.keys($5KAOu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5KAOu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5KAOu[key];
        }
    });
});

var $iH2Ow = parcelRequire("iH2Ow");
Object.keys($iH2Ow).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iH2Ow[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iH2Ow[key];
        }
    });
});

var $gq2Ua = parcelRequire("gq2Ua");
Object.keys($gq2Ua).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gq2Ua[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gq2Ua[key];
        }
    });
});

var $1TjQW = parcelRequire("1TjQW");
Object.keys($1TjQW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1TjQW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1TjQW[key];
        }
    });
});

var $20acM = parcelRequire("20acM");
Object.keys($20acM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $20acM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $20acM[key];
        }
    });
});

var $2vexC = parcelRequire("2vexC");
Object.keys($2vexC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2vexC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2vexC[key];
        }
    });
});

var $luRW4 = parcelRequire("luRW4");
Object.keys($luRW4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $luRW4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $luRW4[key];
        }
    });
});

var $dtPbO = parcelRequire("dtPbO");
Object.keys($dtPbO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dtPbO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dtPbO[key];
        }
    });
});

var $cPgLr = parcelRequire("cPgLr");
Object.keys($cPgLr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cPgLr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cPgLr[key];
        }
    });
});

var $gcYU1 = parcelRequire("gcYU1");
Object.keys($gcYU1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gcYU1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gcYU1[key];
        }
    });
});

var $hdvEC = parcelRequire("hdvEC");
Object.keys($hdvEC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hdvEC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hdvEC[key];
        }
    });
});

var $jYMLq = parcelRequire("jYMLq");
Object.keys($jYMLq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jYMLq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jYMLq[key];
        }
    });
});

var $jD0I3 = parcelRequire("jD0I3");
Object.keys($jD0I3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jD0I3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jD0I3[key];
        }
    });
});

var $1GcKu = parcelRequire("1GcKu");
Object.keys($1GcKu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1GcKu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1GcKu[key];
        }
    });
});

var $2UgVu = parcelRequire("2UgVu");
Object.keys($2UgVu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2UgVu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2UgVu[key];
        }
    });
});

var $5EwcB = parcelRequire("5EwcB");
Object.keys($5EwcB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5EwcB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5EwcB[key];
        }
    });
});

var $8l96w = parcelRequire("8l96w");
Object.keys($8l96w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8l96w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8l96w[key];
        }
    });
});

var $bE3Y3 = parcelRequire("bE3Y3");
Object.keys($bE3Y3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bE3Y3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bE3Y3[key];
        }
    });
});

var $hTRRJ = parcelRequire("hTRRJ");
Object.keys($hTRRJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hTRRJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hTRRJ[key];
        }
    });
});

var $dSnV4 = parcelRequire("dSnV4");
Object.keys($dSnV4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dSnV4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dSnV4[key];
        }
    });
});

var $iOqGj = parcelRequire("iOqGj");
Object.keys($iOqGj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iOqGj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iOqGj[key];
        }
    });
});

var $JJ6gI = parcelRequire("JJ6gI");
Object.keys($JJ6gI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $JJ6gI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $JJ6gI[key];
        }
    });
});

var $1VSw7 = parcelRequire("1VSw7");
Object.keys($1VSw7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1VSw7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1VSw7[key];
        }
    });
});

var $dO1KX = parcelRequire("dO1KX");
Object.keys($dO1KX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dO1KX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dO1KX[key];
        }
    });
});

var $f23Gj = parcelRequire("f23Gj");
Object.keys($f23Gj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f23Gj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f23Gj[key];
        }
    });
});

var $8P5CE = parcelRequire("8P5CE");
Object.keys($8P5CE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8P5CE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8P5CE[key];
        }
    });
});

var $hQXT4 = parcelRequire("hQXT4");
Object.keys($hQXT4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hQXT4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hQXT4[key];
        }
    });
});

var $75Jn2 = parcelRequire("75Jn2");
Object.keys($75Jn2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $75Jn2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $75Jn2[key];
        }
    });
});

var $fH0a1 = parcelRequire("fH0a1");
Object.keys($fH0a1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fH0a1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fH0a1[key];
        }
    });
});

var $3q4Cu = parcelRequire("3q4Cu");
Object.keys($3q4Cu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3q4Cu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3q4Cu[key];
        }
    });
});

var $hYeCp = parcelRequire("hYeCp");
Object.keys($hYeCp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hYeCp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hYeCp[key];
        }
    });
});

var $2sjl8 = parcelRequire("2sjl8");
Object.keys($2sjl8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2sjl8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2sjl8[key];
        }
    });
});

var $551eW = parcelRequire("551eW");
Object.keys($551eW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $551eW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $551eW[key];
        }
    });
});

var $i06ug = parcelRequire("i06ug");
Object.keys($i06ug).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i06ug[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i06ug[key];
        }
    });
});

var $gxLWY = parcelRequire("gxLWY");
Object.keys($gxLWY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gxLWY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gxLWY[key];
        }
    });
});

var $hgDzO = parcelRequire("hgDzO");
Object.keys($hgDzO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hgDzO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hgDzO[key];
        }
    });
});

var $lS30d = parcelRequire("lS30d");
Object.keys($lS30d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lS30d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lS30d[key];
        }
    });
});

var $2uWPY = parcelRequire("2uWPY");
Object.keys($2uWPY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2uWPY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2uWPY[key];
        }
    });
});

var $hymmX = parcelRequire("hymmX");
Object.keys($hymmX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hymmX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hymmX[key];
        }
    });
});

var $8ple2 = parcelRequire("8ple2");
Object.keys($8ple2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8ple2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ple2[key];
        }
    });
});

var $eO0Fp = parcelRequire("eO0Fp");
Object.keys($eO0Fp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eO0Fp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eO0Fp[key];
        }
    });
});

var $3Au2i = parcelRequire("3Au2i");
Object.keys($3Au2i).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3Au2i[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3Au2i[key];
        }
    });
});

var $hDUcR = parcelRequire("hDUcR");
Object.keys($hDUcR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hDUcR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hDUcR[key];
        }
    });
});

var $ayi8B = parcelRequire("ayi8B");
Object.keys($ayi8B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ayi8B[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ayi8B[key];
        }
    });
});

var $5byfF = parcelRequire("5byfF");
Object.keys($5byfF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5byfF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5byfF[key];
        }
    });
});

var $5N9HD = parcelRequire("5N9HD");
Object.keys($5N9HD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5N9HD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5N9HD[key];
        }
    });
});

var $gE1IM = parcelRequire("gE1IM");
Object.keys($gE1IM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gE1IM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gE1IM[key];
        }
    });
});

var $1hill = parcelRequire("1hill");
Object.keys($1hill).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1hill[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1hill[key];
        }
    });
});

var $dtBkY = parcelRequire("dtBkY");
Object.keys($dtBkY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dtBkY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dtBkY[key];
        }
    });
});

var $euayu = parcelRequire("euayu");
Object.keys($euayu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $euayu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $euayu[key];
        }
    });
});

var $gZrcY = parcelRequire("gZrcY");
Object.keys($gZrcY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gZrcY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gZrcY[key];
        }
    });
});

var $aZKRL = parcelRequire("aZKRL");
Object.keys($aZKRL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aZKRL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aZKRL[key];
        }
    });
});

var $eT420 = parcelRequire("eT420");
Object.keys($eT420).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eT420[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eT420[key];
        }
    });
});

var $xHbuL = parcelRequire("xHbuL");
Object.keys($xHbuL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $xHbuL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $xHbuL[key];
        }
    });
});

var $aPY0w = parcelRequire("aPY0w");
Object.keys($aPY0w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aPY0w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aPY0w[key];
        }
    });
});

var $30SVQ = parcelRequire("30SVQ");
Object.keys($30SVQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $30SVQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $30SVQ[key];
        }
    });
});

var $7F7K0 = parcelRequire("7F7K0");
Object.keys($7F7K0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7F7K0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7F7K0[key];
        }
    });
});

var $lK1AJ = parcelRequire("lK1AJ");
Object.keys($lK1AJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lK1AJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lK1AJ[key];
        }
    });
});

var $9l7S6 = parcelRequire("9l7S6");
Object.keys($9l7S6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9l7S6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9l7S6[key];
        }
    });
});

var $eiL7j = parcelRequire("eiL7j");
Object.keys($eiL7j).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eiL7j[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eiL7j[key];
        }
    });
});

var $18DXO = parcelRequire("18DXO");
Object.keys($18DXO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $18DXO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $18DXO[key];
        }
    });
});

});
parcelRegister("7eqmQ", function(module, exports) {

$parcel$export(module.exports, "add", () => $543e4b3aa35bec3b$export$e16d8520af44a096, (v) => $543e4b3aa35bec3b$export$e16d8520af44a096 = v);
var $543e4b3aa35bec3b$export$e16d8520af44a096;
"use strict";
$543e4b3aa35bec3b$export$e16d8520af44a096 = $543e4b3aa35bec3b$var$add;

var $e1kwM = parcelRequire("e1kwM");

var $cls5f = parcelRequire("cls5f");

var $eK5z7 = parcelRequire("eK5z7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $543e4b3aa35bec3b$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $30SVQ.toDate)(date);
    const dateWithMonths = months || years ? (0, $cls5f.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $e1kwM.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $eK5z7.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});

parcelRegister("4J4yL", function(module, exports) {

$parcel$export(module.exports, "addBusinessDays", () => $370ee6dc5d0513ee$export$f087b9ada3136ae9, (v) => $370ee6dc5d0513ee$export$f087b9ada3136ae9 = v);
var $370ee6dc5d0513ee$export$f087b9ada3136ae9;
"use strict";
$370ee6dc5d0513ee$export$f087b9ada3136ae9 = $370ee6dc5d0513ee$var$addBusinessDays;

var $eK5z7 = parcelRequire("eK5z7");

var $iz8Ir = parcelRequire("iz8Ir");

var $cYlfj = parcelRequire("cYlfj");

var $1A6k6 = parcelRequire("1A6k6");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $370ee6dc5d0513ee$var$addBusinessDays(date, amount) {
    const _date = (0, $30SVQ.toDate)(date);
    const startedOnWeekend = (0, $1A6k6.isWeekend)(_date);
    if (isNaN(amount)) return (0, $eK5z7.constructFrom)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $1A6k6.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $1A6k6.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $iz8Ir.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $cYlfj.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}

});
parcelRegister("iz8Ir", function(module, exports) {

$parcel$export(module.exports, "isSaturday", () => $d84241a3868bd79f$export$def9f260655b3a76, (v) => $d84241a3868bd79f$export$def9f260655b3a76 = v);
var $d84241a3868bd79f$export$def9f260655b3a76;
"use strict";
$d84241a3868bd79f$export$def9f260655b3a76 = $d84241a3868bd79f$var$isSaturday;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $d84241a3868bd79f$var$isSaturday(date) {
    return (0, $30SVQ.toDate)(date).getDay() === 6;
}

});

parcelRegister("cYlfj", function(module, exports) {

$parcel$export(module.exports, "isSunday", () => $971b91a830c22187$export$70f720dfc6028987, (v) => $971b91a830c22187$export$70f720dfc6028987 = v);
var $971b91a830c22187$export$70f720dfc6028987;
"use strict";
$971b91a830c22187$export$70f720dfc6028987 = $971b91a830c22187$var$isSunday;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $971b91a830c22187$var$isSunday(date) {
    return (0, $30SVQ.toDate)(date).getDay() === 0;
}

});

parcelRegister("1A6k6", function(module, exports) {

$parcel$export(module.exports, "isWeekend", () => $126e0ee47695e680$export$618d60ea299da42, (v) => $126e0ee47695e680$export$618d60ea299da42 = v);
var $126e0ee47695e680$export$618d60ea299da42;
"use strict";
$126e0ee47695e680$export$618d60ea299da42 = $126e0ee47695e680$var$isWeekend;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $126e0ee47695e680$var$isWeekend(date) {
    const day = (0, $30SVQ.toDate)(date).getDay();
    return day === 0 || day === 6;
}

});


parcelRegister("gsBEc", function(module, exports) {

$parcel$export(module.exports, "addISOWeekYears", () => $bfbc76d70792463e$export$c8240694da10d5f, (v) => $bfbc76d70792463e$export$c8240694da10d5f = v);
var $bfbc76d70792463e$export$c8240694da10d5f;
"use strict";
$bfbc76d70792463e$export$c8240694da10d5f = $bfbc76d70792463e$var$addISOWeekYears;

var $hhS6V = parcelRequire("hhS6V");

var $dSnV4 = parcelRequire("dSnV4");
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $bfbc76d70792463e$var$addISOWeekYears(date, amount) {
    return (0, $dSnV4.setISOWeekYear)(date, (0, $hhS6V.getISOWeekYear)(date) + amount);
}

});
parcelRegister("dSnV4", function(module, exports) {

$parcel$export(module.exports, "setISOWeekYear", () => $a1a2df6fabe9eb62$export$814397aabf10ab77, (v) => $a1a2df6fabe9eb62$export$814397aabf10ab77 = v);
var $a1a2df6fabe9eb62$export$814397aabf10ab77;
"use strict";
$a1a2df6fabe9eb62$export$814397aabf10ab77 = $a1a2df6fabe9eb62$var$setISOWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $9UMYl = parcelRequire("9UMYl");

var $551eW = parcelRequire("551eW");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $a1a2df6fabe9eb62$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $9UMYl.differenceInCalendarDays)(_date, (0, $551eW.startOfISOWeekYear)(_date));
    const fourthOfJanuary = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $551eW.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("kiEfO", function(module, exports) {

$parcel$export(module.exports, "addSeconds", () => $ec74b6b01c6372f4$export$3cb31b0df13be68, (v) => $ec74b6b01c6372f4$export$3cb31b0df13be68 = v);
var $ec74b6b01c6372f4$export$3cb31b0df13be68;
"use strict";
$ec74b6b01c6372f4$export$3cb31b0df13be68 = $ec74b6b01c6372f4$var$addSeconds;

var $dR7TY = parcelRequire("dR7TY");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $ec74b6b01c6372f4$var$addSeconds(date, amount) {
    return (0, $dR7TY.addMilliseconds)(date, amount * 1000);
}

});

parcelRegister("lwpTe", function(module, exports) {

$parcel$export(module.exports, "areIntervalsOverlapping", () => $fab0ab4e3f2f210f$export$2bf3385645436101, (v) => $fab0ab4e3f2f210f$export$2bf3385645436101 = v);
var $fab0ab4e3f2f210f$export$2bf3385645436101;
"use strict";
$fab0ab4e3f2f210f$export$2bf3385645436101 = $fab0ab4e3f2f210f$var$areIntervalsOverlapping;

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $fab0ab4e3f2f210f$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $30SVQ.toDate)(intervalLeft.start),
        +(0, $30SVQ.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $30SVQ.toDate)(intervalRight.start),
        +(0, $30SVQ.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

});

parcelRegister("7LQtK", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $5a85a167b627226d$export$7d15b64cf5a3a4c4, (v) => $5a85a167b627226d$export$7d15b64cf5a3a4c4 = v);
var $5a85a167b627226d$export$7d15b64cf5a3a4c4;
"use strict";
$5a85a167b627226d$export$7d15b64cf5a3a4c4 = $5a85a167b627226d$var$clamp;

var $fIlxB = parcelRequire("fIlxB");

var $80buy = parcelRequire("80buy");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $5a85a167b627226d$var$clamp(date, interval) {
    return (0, $80buy.min)([
        (0, $fIlxB.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}

});

parcelRegister("U9Kpz", function(module, exports) {

$parcel$export(module.exports, "closestIndexTo", () => $0a8ccabde02ae96a$export$42127b72a9d091c7, (v) => $0a8ccabde02ae96a$export$42127b72a9d091c7 = v);
var $0a8ccabde02ae96a$export$42127b72a9d091c7;
"use strict";
$0a8ccabde02ae96a$export$42127b72a9d091c7 = $0a8ccabde02ae96a$var$closestIndexTo;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $0a8ccabde02ae96a$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $30SVQ.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $30SVQ.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("eeNdR", function(module, exports) {

$parcel$export(module.exports, "closestTo", () => $a5d88e0ec96e8c2a$export$73858b464497125a, (v) => $a5d88e0ec96e8c2a$export$73858b464497125a = v);
var $a5d88e0ec96e8c2a$export$73858b464497125a;
"use strict";
$a5d88e0ec96e8c2a$export$73858b464497125a = $a5d88e0ec96e8c2a$var$closestTo;

var $eK5z7 = parcelRequire("eK5z7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $a5d88e0ec96e8c2a$var$closestTo(dateToCompare, dates) {
    const date = (0, $30SVQ.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, $eK5z7.constructFrom)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $30SVQ.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $eK5z7.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("k4zPp", function(module, exports) {

$parcel$export(module.exports, "compareAsc", () => $e9cff913190bd013$export$fe114145ae75d197, (v) => $e9cff913190bd013$export$fe114145ae75d197 = v);
var $e9cff913190bd013$export$fe114145ae75d197;
"use strict";
$e9cff913190bd013$export$fe114145ae75d197 = $e9cff913190bd013$var$compareAsc;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $e9cff913190bd013$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("1MTO0", function(module, exports) {

$parcel$export(module.exports, "compareDesc", () => $14d58ffa6ac05331$export$ed84005ac9356f7a, (v) => $14d58ffa6ac05331$export$ed84005ac9356f7a = v);
var $14d58ffa6ac05331$export$ed84005ac9356f7a;
"use strict";
$14d58ffa6ac05331$export$ed84005ac9356f7a = $14d58ffa6ac05331$var$compareDesc;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $14d58ffa6ac05331$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

});

parcelRegister("izNX2", function(module, exports) {

$parcel$export(module.exports, "constructNow", () => $d8623e255497753b$export$18c3c6510fb97afc, (v) => $d8623e255497753b$export$18c3c6510fb97afc = v);
var $d8623e255497753b$export$18c3c6510fb97afc;
"use strict";
$d8623e255497753b$export$18c3c6510fb97afc = $d8623e255497753b$var$constructNow;

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $d8623e255497753b$var$constructNow(date) {
    return (0, $eK5z7.constructFrom)(date, Date.now());
}

});

parcelRegister("4f728", function(module, exports) {

$parcel$export(module.exports, "daysToWeeks", () => $316e04d0ee94a61b$export$66d8b66cbb6006a8, (v) => $316e04d0ee94a61b$export$66d8b66cbb6006a8 = v);
var $316e04d0ee94a61b$export$66d8b66cbb6006a8;
"use strict";
$316e04d0ee94a61b$export$66d8b66cbb6006a8 = $316e04d0ee94a61b$var$daysToWeeks;

var $briB4 = parcelRequire("briB4");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $316e04d0ee94a61b$var$daysToWeeks(days) {
    const weeks = days / $briB4.daysInWeek;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("a8jD3", function(module, exports) {

$parcel$export(module.exports, "differenceInBusinessDays", () => $7609e09e1797fdf5$export$f30d3269a6c53cb9, (v) => $7609e09e1797fdf5$export$f30d3269a6c53cb9 = v);
var $7609e09e1797fdf5$export$f30d3269a6c53cb9;
"use strict";
$7609e09e1797fdf5$export$f30d3269a6c53cb9 = $7609e09e1797fdf5$var$differenceInBusinessDays;

var $e1kwM = parcelRequire("e1kwM");

var $9UMYl = parcelRequire("9UMYl");

var $3p5lI = parcelRequire("3p5lI");

var $kPCB6 = parcelRequire("kPCB6");

var $1A6k6 = parcelRequire("1A6k6");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $7609e09e1797fdf5$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    let _dateRight = (0, $30SVQ.toDate)(dateRight);
    if (!(0, $kPCB6.isValid)(_dateLeft) || !(0, $kPCB6.isValid)(_dateRight)) return NaN;
    const calendarDifference = (0, $9UMYl.differenceInCalendarDays)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $e1kwM.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $3p5lI.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $1A6k6.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, $e1kwM.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("jolZ6", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeekYears", () => $e1e14fdea06c0988$export$7f8a73dc2e50a070, (v) => $e1e14fdea06c0988$export$7f8a73dc2e50a070 = v);
var $e1e14fdea06c0988$export$7f8a73dc2e50a070;
"use strict";
$e1e14fdea06c0988$export$7f8a73dc2e50a070 = $e1e14fdea06c0988$var$differenceInCalendarISOWeekYears;

var $hhS6V = parcelRequire("hhS6V");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $e1e14fdea06c0988$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $hhS6V.getISOWeekYear)(dateLeft) - (0, $hhS6V.getISOWeekYear)(dateRight);
}

});

parcelRegister("9yHRM", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeeks", () => $6f59510051d42333$export$28df1cb58b17e450, (v) => $6f59510051d42333$export$28df1cb58b17e450 = v);
var $6f59510051d42333$export$28df1cb58b17e450;
"use strict";
$6f59510051d42333$export$28df1cb58b17e450 = $6f59510051d42333$var$differenceInCalendarISOWeeks;

var $briB4 = parcelRequire("briB4");

var $2sjl8 = parcelRequire("2sjl8");

var $cBJez = parcelRequire("cBJez");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $6f59510051d42333$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $2sjl8.startOfISOWeek)(dateLeft);
    const startOfISOWeekRight = (0, $2sjl8.startOfISOWeek)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $briB4.millisecondsInWeek);
}

});

parcelRegister("hcJKh", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarWeeks", () => $c8670ac5b8c1edee$export$6ed034ce62348e4, (v) => $c8670ac5b8c1edee$export$6ed034ce62348e4 = v);
var $c8670ac5b8c1edee$export$6ed034ce62348e4;
"use strict";
$c8670ac5b8c1edee$export$6ed034ce62348e4 = $c8670ac5b8c1edee$var$differenceInCalendarWeeks;

var $briB4 = parcelRequire("briB4");

var $8ple2 = parcelRequire("8ple2");

var $cBJez = parcelRequire("cBJez");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $c8670ac5b8c1edee$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $8ple2.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, $8ple2.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $cBJez.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $briB4.millisecondsInWeek);
}

});

parcelRegister("2THNu", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", () => $21c2b10d84e6b5ad$export$86415ebf4eb36b8c, (v) => $21c2b10d84e6b5ad$export$86415ebf4eb36b8c = v);
var $21c2b10d84e6b5ad$export$86415ebf4eb36b8c;
"use strict";
$21c2b10d84e6b5ad$export$86415ebf4eb36b8c = $21c2b10d84e6b5ad$var$differenceInDays;

var $9UMYl = parcelRequire("9UMYl");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $21c2b10d84e6b5ad$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const sign = $21c2b10d84e6b5ad$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $9UMYl.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($21c2b10d84e6b5ad$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $21c2b10d84e6b5ad$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("kLDS0", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", () => $f1e71fcc3bd0bed6$export$5436ca250d4d6872, (v) => $f1e71fcc3bd0bed6$export$5436ca250d4d6872 = v);
var $f1e71fcc3bd0bed6$export$5436ca250d4d6872;
"use strict";
$f1e71fcc3bd0bed6$export$5436ca250d4d6872 = $f1e71fcc3bd0bed6$var$differenceInHours;

var $6it2M = parcelRequire("6it2M");

var $briB4 = parcelRequire("briB4");

var $fL7JV = parcelRequire("fL7JV");
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $f1e71fcc3bd0bed6$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $fL7JV.differenceInMilliseconds)(dateLeft, dateRight) / $briB4.millisecondsInHour;
    return (0, $6it2M.getRoundingMethod)(options?.roundingMethod)(diff);
}

});
parcelRegister("6it2M", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $495af4000bb18bf7$export$b6474a47258c1211, (v) => $495af4000bb18bf7$export$b6474a47258c1211 = v);
var $495af4000bb18bf7$export$b6474a47258c1211;
"use strict";
$495af4000bb18bf7$export$b6474a47258c1211 = $495af4000bb18bf7$var$getRoundingMethod;
function $495af4000bb18bf7$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("fL7JV", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", () => $b7913fc338fe28ad$export$7be94d13716b4bf6, (v) => $b7913fc338fe28ad$export$7be94d13716b4bf6 = v);
var $b7913fc338fe28ad$export$7be94d13716b4bf6;
"use strict";
$b7913fc338fe28ad$export$7be94d13716b4bf6 = $b7913fc338fe28ad$var$differenceInMilliseconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $b7913fc338fe28ad$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $30SVQ.toDate)(dateLeft) - +(0, $30SVQ.toDate)(dateRight);
}

});


parcelRegister("gTY9Z", function(module, exports) {

$parcel$export(module.exports, "differenceInISOWeekYears", () => $c4e072f0adb8f68e$export$bf7bde0b3bf8913a, (v) => $c4e072f0adb8f68e$export$bf7bde0b3bf8913a = v);
var $c4e072f0adb8f68e$export$bf7bde0b3bf8913a;
"use strict";
$c4e072f0adb8f68e$export$bf7bde0b3bf8913a = $c4e072f0adb8f68e$var$differenceInISOWeekYears;

var $k4zPp = parcelRequire("k4zPp");

var $jolZ6 = parcelRequire("jolZ6");

var $1hill = parcelRequire("1hill");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $c4e072f0adb8f68e$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const sign = (0, $k4zPp.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $jolZ6.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, $1hill.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $k4zPp.compareAsc)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("1hill", function(module, exports) {

$parcel$export(module.exports, "subISOWeekYears", () => $0ee59b8ff17647f3$export$4f7d47b952f4a0aa, (v) => $0ee59b8ff17647f3$export$4f7d47b952f4a0aa = v);
var $0ee59b8ff17647f3$export$4f7d47b952f4a0aa;
"use strict";
$0ee59b8ff17647f3$export$4f7d47b952f4a0aa = $0ee59b8ff17647f3$var$subISOWeekYears;

var $gsBEc = parcelRequire("gsBEc");
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $0ee59b8ff17647f3$var$subISOWeekYears(date, amount) {
    return (0, $gsBEc.addISOWeekYears)(date, -amount);
}

});


parcelRegister("8V4Fd", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", () => $67e743be56b112ce$export$d904251335be481a, (v) => $67e743be56b112ce$export$d904251335be481a = v);
var $67e743be56b112ce$export$d904251335be481a;
"use strict";
$67e743be56b112ce$export$d904251335be481a = $67e743be56b112ce$var$differenceInMinutes;

var $6it2M = parcelRequire("6it2M");

var $briB4 = parcelRequire("briB4");

var $fL7JV = parcelRequire("fL7JV");
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $67e743be56b112ce$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $fL7JV.differenceInMilliseconds)(dateLeft, dateRight) / $briB4.millisecondsInMinute;
    return (0, $6it2M.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("6v0iN", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", () => $4bb5df50b9b59298$export$fc1ed482c2861792, (v) => $4bb5df50b9b59298$export$fc1ed482c2861792 = v);
var $4bb5df50b9b59298$export$fc1ed482c2861792;
"use strict";
$4bb5df50b9b59298$export$fc1ed482c2861792 = $4bb5df50b9b59298$var$differenceInMonths;

var $k4zPp = parcelRequire("k4zPp");

var $bTWJP = parcelRequire("bTWJP");

var $i1VFZ = parcelRequire("i1VFZ");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $4bb5df50b9b59298$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const sign = (0, $k4zPp.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $bTWJP.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $k4zPp.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $i1VFZ.isLastDayOfMonth)((0, $30SVQ.toDate)(dateLeft)) && difference === 1 && (0, $k4zPp.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("i1VFZ", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", () => $d2050f4e5c1a3003$export$c817d0312007ea5e, (v) => $d2050f4e5c1a3003$export$c817d0312007ea5e = v);
var $d2050f4e5c1a3003$export$c817d0312007ea5e;
"use strict";
$d2050f4e5c1a3003$export$c817d0312007ea5e = $d2050f4e5c1a3003$var$isLastDayOfMonth;

var $fG9DL = parcelRequire("fG9DL");

var $jHGP1 = parcelRequire("jHGP1");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $d2050f4e5c1a3003$var$isLastDayOfMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    return +(0, $fG9DL.endOfDay)(_date) === +(0, $jHGP1.endOfMonth)(_date);
}

});


parcelRegister("l0dhV", function(module, exports) {

$parcel$export(module.exports, "differenceInQuarters", () => $03f220a44a4339e3$export$74b5c4055a405552, (v) => $03f220a44a4339e3$export$74b5c4055a405552 = v);
var $03f220a44a4339e3$export$74b5c4055a405552;
"use strict";
$03f220a44a4339e3$export$74b5c4055a405552 = $03f220a44a4339e3$var$differenceInQuarters;

var $6it2M = parcelRequire("6it2M");

var $6v0iN = parcelRequire("6v0iN");
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $03f220a44a4339e3$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $6v0iN.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, $6it2M.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("k0LcS", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", () => $e9186d0161460806$export$c1889aec51783710, (v) => $e9186d0161460806$export$c1889aec51783710 = v);
var $e9186d0161460806$export$c1889aec51783710;
"use strict";
$e9186d0161460806$export$c1889aec51783710 = $e9186d0161460806$var$differenceInSeconds;

var $6it2M = parcelRequire("6it2M");

var $fL7JV = parcelRequire("fL7JV");
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $e9186d0161460806$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $fL7JV.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, $6it2M.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("bpFlP", function(module, exports) {

$parcel$export(module.exports, "differenceInWeeks", () => $84f21af906303191$export$b5147a91dc40ddb7, (v) => $84f21af906303191$export$b5147a91dc40ddb7 = v);
var $84f21af906303191$export$b5147a91dc40ddb7;
"use strict";
$84f21af906303191$export$b5147a91dc40ddb7 = $84f21af906303191$var$differenceInWeeks;

var $6it2M = parcelRequire("6it2M");

var $2THNu = parcelRequire("2THNu");
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $84f21af906303191$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $2THNu.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, $6it2M.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("gpIjX", function(module, exports) {

$parcel$export(module.exports, "differenceInYears", () => $bf315c5624a2ab0b$export$ed6bf486f68899ca, (v) => $bf315c5624a2ab0b$export$ed6bf486f68899ca = v);
var $bf315c5624a2ab0b$export$ed6bf486f68899ca;
"use strict";
$bf315c5624a2ab0b$export$ed6bf486f68899ca = $bf315c5624a2ab0b$var$differenceInYears;

var $k4zPp = parcelRequire("k4zPp");

var $7b4id = parcelRequire("7b4id");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $bf315c5624a2ab0b$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $30SVQ.toDate)(dateLeft);
    const _dateRight = (0, $30SVQ.toDate)(dateRight);
    const sign = (0, $k4zPp.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $7b4id.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $k4zPp.compareAsc)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("VSaoY", function(module, exports) {

$parcel$export(module.exports, "eachDayOfInterval", () => $0adf5760eb71daea$export$7a337e5923c7ceb5, (v) => $0adf5760eb71daea$export$7a337e5923c7ceb5 = v);
var $0adf5760eb71daea$export$7a337e5923c7ceb5;
"use strict";
$0adf5760eb71daea$export$7a337e5923c7ceb5 = $0adf5760eb71daea$var$eachDayOfInterval;

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $0adf5760eb71daea$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $30SVQ.toDate)(interval.start);
    const endDate = (0, $30SVQ.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $30SVQ.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("fafHZ", function(module, exports) {

$parcel$export(module.exports, "eachHourOfInterval", () => $b0a3f99021d001ef$export$bb4f48fee90ea86e, (v) => $b0a3f99021d001ef$export$bb4f48fee90ea86e = v);
var $b0a3f99021d001ef$export$bb4f48fee90ea86e;
"use strict";
$b0a3f99021d001ef$export$bb4f48fee90ea86e = $b0a3f99021d001ef$var$eachHourOfInterval;

var $iMX5A = parcelRequire("iMX5A");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $b0a3f99021d001ef$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $30SVQ.toDate)(interval.start);
    const endDate = (0, $30SVQ.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $30SVQ.toDate)(currentDate));
        currentDate = (0, $iMX5A.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("1Nc0n", function(module, exports) {

$parcel$export(module.exports, "eachMinuteOfInterval", () => $14e3ae081dfb5d06$export$82e17d693ce9eb6c, (v) => $14e3ae081dfb5d06$export$82e17d693ce9eb6c = v);
var $14e3ae081dfb5d06$export$82e17d693ce9eb6c;
"use strict";
$14e3ae081dfb5d06$export$82e17d693ce9eb6c = $14e3ae081dfb5d06$var$eachMinuteOfInterval;

var $jZtIs = parcelRequire("jZtIs");

var $i06ug = parcelRequire("i06ug");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $14e3ae081dfb5d06$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $i06ug.startOfMinute)((0, $30SVQ.toDate)(interval.start));
    const endDate = (0, $30SVQ.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $30SVQ.toDate)(currentDate));
        currentDate = (0, $jZtIs.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("i06ug", function(module, exports) {

$parcel$export(module.exports, "startOfMinute", () => $d1ad424e56672364$export$c66440458c6aa793, (v) => $d1ad424e56672364$export$c66440458c6aa793 = v);
var $d1ad424e56672364$export$c66440458c6aa793;
"use strict";
$d1ad424e56672364$export$c66440458c6aa793 = $d1ad424e56672364$var$startOfMinute;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $d1ad424e56672364$var$startOfMinute(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}

});


parcelRegister("kJrjC", function(module, exports) {

$parcel$export(module.exports, "eachMonthOfInterval", () => $f17d32e46529568a$export$1c9322f2d2a5eed3, (v) => $f17d32e46529568a$export$1c9322f2d2a5eed3 = v);
var $f17d32e46529568a$export$1c9322f2d2a5eed3;
"use strict";
$f17d32e46529568a$export$1c9322f2d2a5eed3 = $f17d32e46529568a$var$eachMonthOfInterval;

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $f17d32e46529568a$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $30SVQ.toDate)(interval.start);
    const endDate = (0, $30SVQ.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $30SVQ.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("alowK", function(module, exports) {

$parcel$export(module.exports, "eachQuarterOfInterval", () => $787ee41e326f83b2$export$96790a0abfab0078, (v) => $787ee41e326f83b2$export$96790a0abfab0078 = v);
var $787ee41e326f83b2$export$96790a0abfab0078;
"use strict";
$787ee41e326f83b2$export$96790a0abfab0078 = $787ee41e326f83b2$var$eachQuarterOfInterval;

var $4chdC = parcelRequire("4chdC");

var $hgDzO = parcelRequire("hgDzO");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $787ee41e326f83b2$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $30SVQ.toDate)(interval.start);
    const endDate = (0, $30SVQ.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $hgDzO.startOfQuarter)(startDate) : +(0, $hgDzO.startOfQuarter)(endDate);
    let currentDate = reversed ? (0, $hgDzO.startOfQuarter)(endDate) : (0, $hgDzO.startOfQuarter)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $30SVQ.toDate)(currentDate));
        currentDate = (0, $4chdC.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("9QT8W", function(module, exports) {

$parcel$export(module.exports, "eachWeekOfInterval", () => $72c3bea95dec77b2$export$d31a8caec75fa456, (v) => $72c3bea95dec77b2$export$d31a8caec75fa456 = v);
var $72c3bea95dec77b2$export$d31a8caec75fa456;
"use strict";
$72c3bea95dec77b2$export$d31a8caec75fa456 = $72c3bea95dec77b2$var$eachWeekOfInterval;

var $gdvs1 = parcelRequire("gdvs1");

var $8ple2 = parcelRequire("8ple2");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $72c3bea95dec77b2$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $30SVQ.toDate)(interval.start);
    const endDate = (0, $30SVQ.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $8ple2.startOfWeek)(endDate, options) : (0, $8ple2.startOfWeek)(startDate, options);
    const endDateWeek = reversed ? (0, $8ple2.startOfWeek)(startDate, options) : (0, $8ple2.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $30SVQ.toDate)(currentDate));
        currentDate = (0, $gdvs1.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("eUAWc", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfInterval", () => $adb2f2b5832b8aeb$export$a2ae85dd849354a8, (v) => $adb2f2b5832b8aeb$export$a2ae85dd849354a8 = v);
var $adb2f2b5832b8aeb$export$a2ae85dd849354a8;
"use strict";
$adb2f2b5832b8aeb$export$a2ae85dd849354a8 = $adb2f2b5832b8aeb$var$eachWeekendOfInterval;

var $VSaoY = parcelRequire("VSaoY");

var $1A6k6 = parcelRequire("1A6k6");
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $adb2f2b5832b8aeb$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $VSaoY.eachDayOfInterval)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $1A6k6.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}

});

parcelRegister("bAVu4", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfMonth", () => $870fa59f10358ead$export$f9a185d0ad232d17, (v) => $870fa59f10358ead$export$f9a185d0ad232d17 = v);
var $870fa59f10358ead$export$f9a185d0ad232d17;
"use strict";
$870fa59f10358ead$export$f9a185d0ad232d17 = $870fa59f10358ead$var$eachWeekendOfMonth;

var $eUAWc = parcelRequire("eUAWc");

var $jHGP1 = parcelRequire("jHGP1");

var $gxLWY = parcelRequire("gxLWY");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $870fa59f10358ead$var$eachWeekendOfMonth(date) {
    const start = (0, $gxLWY.startOfMonth)(date);
    const end = (0, $jHGP1.endOfMonth)(date);
    return (0, $eUAWc.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});

parcelRegister("kp39E", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfYear", () => $eda896eb36e12788$export$d4a9e5efc1ddceb9, (v) => $eda896eb36e12788$export$d4a9e5efc1ddceb9 = v);
var $eda896eb36e12788$export$d4a9e5efc1ddceb9;
"use strict";
$eda896eb36e12788$export$d4a9e5efc1ddceb9 = $eda896eb36e12788$var$eachWeekendOfYear;

var $eUAWc = parcelRequire("eUAWc");

var $9kRZo = parcelRequire("9kRZo");

var $3Au2i = parcelRequire("3Au2i");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $eda896eb36e12788$var$eachWeekendOfYear(date) {
    const start = (0, $3Au2i.startOfYear)(date);
    const end = (0, $9kRZo.endOfYear)(date);
    return (0, $eUAWc.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});

parcelRegister("lKJbU", function(module, exports) {

$parcel$export(module.exports, "eachYearOfInterval", () => $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5, (v) => $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5 = v);
var $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5;
"use strict";
$fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5 = $fd60f2d8b17fd3e1$var$eachYearOfInterval;

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $fd60f2d8b17fd3e1$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $30SVQ.toDate)(interval.start);
    const endDate = (0, $30SVQ.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $30SVQ.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("keGeG", function(module, exports) {

$parcel$export(module.exports, "endOfDecade", () => $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6, (v) => $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6 = v);
var $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6;
"use strict";
$ebb5e0a078c03ed7$export$b922ac31d5bbe7a6 = $ebb5e0a078c03ed7$var$endOfDecade;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $ebb5e0a078c03ed7$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("6lnQU", function(module, exports) {

$parcel$export(module.exports, "endOfHour", () => $49e734d34adabd84$export$95ae95d2176c5f0, (v) => $49e734d34adabd84$export$95ae95d2176c5f0 = v);
var $49e734d34adabd84$export$95ae95d2176c5f0;
"use strict";
$49e734d34adabd84$export$95ae95d2176c5f0 = $49e734d34adabd84$var$endOfHour;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $49e734d34adabd84$var$endOfHour(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}

});

parcelRegister("4yek1", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeek", () => $3505726b435bc449$export$186cd934f32084be, (v) => $3505726b435bc449$export$186cd934f32084be = v);
var $3505726b435bc449$export$186cd934f32084be;
"use strict";
$3505726b435bc449$export$186cd934f32084be = $3505726b435bc449$var$endOfISOWeek;

var $iiR1c = parcelRequire("iiR1c");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $3505726b435bc449$var$endOfISOWeek(date) {
    return (0, $iiR1c.endOfWeek)(date, {
        weekStartsOn: 1
    });
}

});

parcelRegister("amgp4", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeekYear", () => $78a8aecdbc55404d$export$73068f3824c9c1d, (v) => $78a8aecdbc55404d$export$73068f3824c9c1d = v);
var $78a8aecdbc55404d$export$73068f3824c9c1d;
"use strict";
$78a8aecdbc55404d$export$73068f3824c9c1d = $78a8aecdbc55404d$var$endOfISOWeekYear;

var $hhS6V = parcelRequire("hhS6V");

var $2sjl8 = parcelRequire("2sjl8");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $78a8aecdbc55404d$var$endOfISOWeekYear(date) {
    const year = (0, $hhS6V.getISOWeekYear)(date);
    const fourthOfJanuaryOfNextYear = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $2sjl8.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}

});

parcelRegister("dz0HX", function(module, exports) {

$parcel$export(module.exports, "endOfMinute", () => $9dff17d493896adc$export$a06a772fc63bff07, (v) => $9dff17d493896adc$export$a06a772fc63bff07 = v);
var $9dff17d493896adc$export$a06a772fc63bff07;
"use strict";
$9dff17d493896adc$export$a06a772fc63bff07 = $9dff17d493896adc$var$endOfMinute;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $9dff17d493896adc$var$endOfMinute(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}

});

parcelRegister("3wcOM", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", () => $28fe4daca8fe3005$export$5f53493861eef879, (v) => $28fe4daca8fe3005$export$5f53493861eef879 = v);
var $28fe4daca8fe3005$export$5f53493861eef879;
"use strict";
$28fe4daca8fe3005$export$5f53493861eef879 = $28fe4daca8fe3005$var$endOfQuarter;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $28fe4daca8fe3005$var$endOfQuarter(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("kr84Q", function(module, exports) {

$parcel$export(module.exports, "endOfSecond", () => $ee0c9831f430316e$export$ef560ab2fa7b52a2, (v) => $ee0c9831f430316e$export$ef560ab2fa7b52a2 = v);
var $ee0c9831f430316e$export$ef560ab2fa7b52a2;
"use strict";
$ee0c9831f430316e$export$ef560ab2fa7b52a2 = $ee0c9831f430316e$var$endOfSecond;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $ee0c9831f430316e$var$endOfSecond(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}

});

parcelRegister("gH8eG", function(module, exports) {

$parcel$export(module.exports, "endOfToday", () => $c2770cefb072376e$export$1b7031a80bd92a6e, (v) => $c2770cefb072376e$export$1b7031a80bd92a6e = v);
var $c2770cefb072376e$export$1b7031a80bd92a6e;
"use strict";
$c2770cefb072376e$export$1b7031a80bd92a6e = $c2770cefb072376e$var$endOfToday;

var $fG9DL = parcelRequire("fG9DL");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $c2770cefb072376e$var$endOfToday() {
    return (0, $fG9DL.endOfDay)(Date.now());
}

});

parcelRegister("5HaPb", function(module, exports) {

$parcel$export(module.exports, "endOfTomorrow", () => $42595d73b3e9f363$export$d788ac27ae2a54ea, (v) => $42595d73b3e9f363$export$d788ac27ae2a54ea = v);
var $42595d73b3e9f363$export$d788ac27ae2a54ea;
"use strict";
$42595d73b3e9f363$export$d788ac27ae2a54ea = $42595d73b3e9f363$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $42595d73b3e9f363$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("b9D0S", function(module, exports) {

$parcel$export(module.exports, "endOfYesterday", () => $81eecc2fe560ca77$export$45190faf1024f97a, (v) => $81eecc2fe560ca77$export$45190faf1024f97a = v);
var $81eecc2fe560ca77$export$45190faf1024f97a;
"use strict";
$81eecc2fe560ca77$export$45190faf1024f97a = $81eecc2fe560ca77$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $81eecc2fe560ca77$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("dwrDU", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $9d83b4c514336dd1$export$2c14ff85d6318973, (v) => $9d83b4c514336dd1$export$2c14ff85d6318973 = v);
var $9d83b4c514336dd1$export$2c14ff85d6318973;
"use strict";
$9d83b4c514336dd1$export$2c14ff85d6318973 = $9d83b4c514336dd1$var$formatDistance;

var $k4zPp = parcelRequire("k4zPp");

var $briB4 = parcelRequire("briB4");

var $6v0iN = parcelRequire("6v0iN");

var $k0LcS = parcelRequire("k0LcS");

var $30SVQ = parcelRequire("30SVQ");

var $k1YNI = parcelRequire("k1YNI");

var $4UP3S = parcelRequire("4UP3S");

var $cBJez = parcelRequire("cBJez");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $9d83b4c514336dd1$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $k4zPp.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $30SVQ.toDate)(baseDate);
        dateRight = (0, $30SVQ.toDate)(date);
    } else {
        dateLeft = (0, $30SVQ.toDate)(date);
        dateRight = (0, $30SVQ.toDate)(baseDate);
    }
    const seconds = (0, $k0LcS.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $cBJez.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $cBJez.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $briB4.minutesInDay) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $briB4.minutesInMonth) {
        const days = Math.round(minutes / $briB4.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $briB4.minutesInMonth * 2) {
        months = Math.round(minutes / $briB4.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $6v0iN.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $briB4.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

});

parcelRegister("cQzGW", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", () => $95a606f89a9faad4$export$e4be225b8ee0a759, (v) => $95a606f89a9faad4$export$e4be225b8ee0a759 = v);
var $95a606f89a9faad4$export$e4be225b8ee0a759;
"use strict";
$95a606f89a9faad4$export$e4be225b8ee0a759 = $95a606f89a9faad4$var$formatDistanceStrict;

var $k1YNI = parcelRequire("k1YNI");

var $4UP3S = parcelRequire("4UP3S");

var $6it2M = parcelRequire("6it2M");

var $cBJez = parcelRequire("cBJez");

var $k4zPp = parcelRequire("k4zPp");

var $briB4 = parcelRequire("briB4");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $95a606f89a9faad4$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const comparison = (0, $k4zPp.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $30SVQ.toDate)(baseDate);
        dateRight = (0, $30SVQ.toDate)(date);
    } else {
        dateLeft = (0, $30SVQ.toDate)(date);
        dateRight = (0, $30SVQ.toDate)(baseDate);
    }
    const roundingMethod = (0, $6it2M.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $briB4.millisecondsInMinute;
    const timezoneOffset = (0, $cBJez.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $cBJez.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $briB4.millisecondsInMinute;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $briB4.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < $briB4.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < $briB4.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $briB4.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $briB4.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $briB4.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}

});

parcelRegister("fS36e", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", () => $b8de4dab140c0dd6$export$d130c20a256f8817, (v) => $b8de4dab140c0dd6$export$d130c20a256f8817 = v);
var $b8de4dab140c0dd6$export$d130c20a256f8817;
"use strict";
$b8de4dab140c0dd6$export$d130c20a256f8817 = $b8de4dab140c0dd6$var$formatDistanceToNow;

var $izNX2 = parcelRequire("izNX2");

var $dwrDU = parcelRequire("dwrDU");
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $b8de4dab140c0dd6$var$formatDistanceToNow(date, options) {
    return (0, $dwrDU.formatDistance)(date, (0, $izNX2.constructNow)(date), options);
}

});

parcelRegister("3t7lx", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNowStrict", () => $2869c75fd9cd8704$export$d0e02d4eb1ad1e32, (v) => $2869c75fd9cd8704$export$d0e02d4eb1ad1e32 = v);
var $2869c75fd9cd8704$export$d0e02d4eb1ad1e32;
"use strict";
$2869c75fd9cd8704$export$d0e02d4eb1ad1e32 = $2869c75fd9cd8704$var$formatDistanceToNowStrict;

var $cQzGW = parcelRequire("cQzGW");

var $izNX2 = parcelRequire("izNX2");
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $2869c75fd9cd8704$var$formatDistanceToNowStrict(date, options) {
    return (0, $cQzGW.formatDistanceStrict)(date, (0, $izNX2.constructNow)(date), options);
}

});

parcelRegister("7moI3", function(module, exports) {

$parcel$export(module.exports, "formatDuration", () => $55bdc14b4829f99f$export$bc733b0c5cbb3e8a, (v) => $55bdc14b4829f99f$export$bc733b0c5cbb3e8a = v);
var $55bdc14b4829f99f$export$bc733b0c5cbb3e8a;
"use strict";
$55bdc14b4829f99f$export$bc733b0c5cbb3e8a = $55bdc14b4829f99f$var$formatDuration;

var $k1YNI = parcelRequire("k1YNI");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link formatDuration} function options.
 */ const $55bdc14b4829f99f$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $55bdc14b4829f99f$var$formatDuration(duration, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const format = options?.format ?? $55bdc14b4829f99f$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

});

parcelRegister("so6MK", function(module, exports) {

$parcel$export(module.exports, "formatISO", () => $05555112c260885d$export$3c826ac3ab9da76c, (v) => $05555112c260885d$export$3c826ac3ab9da76c = v);
var $05555112c260885d$export$3c826ac3ab9da76c;
"use strict";
$05555112c260885d$export$3c826ac3ab9da76c = $05555112c260885d$var$formatISO;

var $30SVQ = parcelRequire("30SVQ");

var $krIED = parcelRequire("krIED");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $05555112c260885d$var$formatISO(date, options) {
    const _date = (0, $30SVQ.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $krIED.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $krIED.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $krIED.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $krIED.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $krIED.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $krIED.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $krIED.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $krIED.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}

});

parcelRegister("imstp", function(module, exports) {

$parcel$export(module.exports, "formatISO9075", () => $d5e05e4c82eadb91$export$a673944250043fa4, (v) => $d5e05e4c82eadb91$export$a673944250043fa4 = v);
var $d5e05e4c82eadb91$export$a673944250043fa4;
"use strict";
$d5e05e4c82eadb91$export$a673944250043fa4 = $d5e05e4c82eadb91$var$formatISO9075;

var $kPCB6 = parcelRequire("kPCB6");

var $30SVQ = parcelRequire("30SVQ");

var $krIED = parcelRequire("krIED");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $d5e05e4c82eadb91$var$formatISO9075(date, options) {
    const _date = (0, $30SVQ.toDate)(date);
    if (!(0, $kPCB6.isValid)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $krIED.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $krIED.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $krIED.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $krIED.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $krIED.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $krIED.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}

});

parcelRegister("9hw20", function(module, exports) {

$parcel$export(module.exports, "formatISODuration", () => $6c1e8c5de50036eb$export$437c31ab743f6b26, (v) => $6c1e8c5de50036eb$export$437c31ab743f6b26 = v);
var $6c1e8c5de50036eb$export$437c31ab743f6b26;
"use strict";
$6c1e8c5de50036eb$export$437c31ab743f6b26 = $6c1e8c5de50036eb$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $6c1e8c5de50036eb$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

});

parcelRegister("isJdR", function(module, exports) {

$parcel$export(module.exports, "formatRFC3339", () => $d70debc21ba74612$export$6d441bffeec6bd6c, (v) => $d70debc21ba74612$export$6d441bffeec6bd6c = v);
var $d70debc21ba74612$export$6d441bffeec6bd6c;
"use strict";
$d70debc21ba74612$export$6d441bffeec6bd6c = $d70debc21ba74612$var$formatRFC3339;

var $kPCB6 = parcelRequire("kPCB6");

var $30SVQ = parcelRequire("30SVQ");

var $krIED = parcelRequire("krIED");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $d70debc21ba74612$var$formatRFC3339(date, options) {
    const _date = (0, $30SVQ.toDate)(date);
    if (!(0, $kPCB6.isValid)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $krIED.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, $krIED.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $krIED.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, $krIED.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, $krIED.addLeadingZeros)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $krIED.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $krIED.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $krIED.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

});

parcelRegister("3kPwX", function(module, exports) {

$parcel$export(module.exports, "formatRFC7231", () => $26db363d7fafee68$export$7add2e4539ce658a, (v) => $26db363d7fafee68$export$7add2e4539ce658a = v);
var $26db363d7fafee68$export$7add2e4539ce658a;
"use strict";
$26db363d7fafee68$export$7add2e4539ce658a = $26db363d7fafee68$var$formatRFC7231;

var $kPCB6 = parcelRequire("kPCB6");

var $30SVQ = parcelRequire("30SVQ");

var $krIED = parcelRequire("krIED");
const $26db363d7fafee68$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $26db363d7fafee68$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $26db363d7fafee68$var$formatRFC7231(date) {
    const _date = (0, $30SVQ.toDate)(date);
    if (!(0, $kPCB6.isValid)(_date)) throw new RangeError("Invalid time value");
    const dayName = $26db363d7fafee68$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $krIED.addLeadingZeros)(_date.getUTCDate(), 2);
    const monthName = $26db363d7fafee68$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $krIED.addLeadingZeros)(_date.getUTCHours(), 2);
    const minute = (0, $krIED.addLeadingZeros)(_date.getUTCMinutes(), 2);
    const second = (0, $krIED.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

});

parcelRegister("bmvAp", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $845a402345cd1b5f$export$8fbbfd65594f46a0, (v) => $845a402345cd1b5f$export$8fbbfd65594f46a0 = v);
var $845a402345cd1b5f$export$8fbbfd65594f46a0;
"use strict";
$845a402345cd1b5f$export$8fbbfd65594f46a0 = $845a402345cd1b5f$var$formatRelative;

var $9UMYl = parcelRequire("9UMYl");

var $48K34 = parcelRequire("48K34");

var $30SVQ = parcelRequire("30SVQ");

var $k1YNI = parcelRequire("k1YNI");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $845a402345cd1b5f$var$formatRelative(date, baseDate, options) {
    const _date = (0, $30SVQ.toDate)(date);
    const _baseDate = (0, $30SVQ.toDate)(baseDate);
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $k1YNI.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $9UMYl.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $48K34.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

});

parcelRegister("a7cZg", function(module, exports) {

$parcel$export(module.exports, "fromUnixTime", () => $75d4a1cbf32d45ba$export$3664df8597731ed4, (v) => $75d4a1cbf32d45ba$export$3664df8597731ed4 = v);
var $75d4a1cbf32d45ba$export$3664df8597731ed4;
"use strict";
$75d4a1cbf32d45ba$export$3664df8597731ed4 = $75d4a1cbf32d45ba$var$fromUnixTime;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $75d4a1cbf32d45ba$var$fromUnixTime(unixTime) {
    return (0, $30SVQ.toDate)(unixTime * 1000);
}

});

parcelRegister("8S6kT", function(module, exports) {

$parcel$export(module.exports, "getDaysInYear", () => $675848174151c5de$export$63a4a9fc49e3550e, (v) => $675848174151c5de$export$63a4a9fc49e3550e = v);
var $675848174151c5de$export$63a4a9fc49e3550e;
"use strict";
$675848174151c5de$export$63a4a9fc49e3550e = $675848174151c5de$var$getDaysInYear;

var $goSQN = parcelRequire("goSQN");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $675848174151c5de$var$getDaysInYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $goSQN.isLeapYear)(_date) ? 366 : 365;
}

});
parcelRegister("goSQN", function(module, exports) {

$parcel$export(module.exports, "isLeapYear", () => $bf096f6f36c61b64$export$553d7fa8e3805fc0, (v) => $bf096f6f36c61b64$export$553d7fa8e3805fc0 = v);
var $bf096f6f36c61b64$export$553d7fa8e3805fc0;
"use strict";
$bf096f6f36c61b64$export$553d7fa8e3805fc0 = $bf096f6f36c61b64$var$isLeapYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $bf096f6f36c61b64$var$isLeapYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});


parcelRegister("9C8D5", function(module, exports) {

$parcel$export(module.exports, "getDecade", () => $6ffe5b46a49d8b61$export$5bc0f4decfc52b64, (v) => $6ffe5b46a49d8b61$export$5bc0f4decfc52b64 = v);
var $6ffe5b46a49d8b61$export$5bc0f4decfc52b64;
"use strict";
$6ffe5b46a49d8b61$export$5bc0f4decfc52b64 = $6ffe5b46a49d8b61$var$getDecade;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $6ffe5b46a49d8b61$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}

});

parcelRegister("1sX9f", function(module, exports) {

$parcel$export(module.exports, "getISOWeeksInYear", () => $1116498c017852ec$export$822983242a16750f, (v) => $1116498c017852ec$export$822983242a16750f = v);
var $1116498c017852ec$export$822983242a16750f;
"use strict";
$1116498c017852ec$export$822983242a16750f = $1116498c017852ec$var$getISOWeeksInYear;

var $gdvs1 = parcelRequire("gdvs1");

var $briB4 = parcelRequire("briB4");

var $551eW = parcelRequire("551eW");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $1116498c017852ec$var$getISOWeeksInYear(date) {
    const thisYear = (0, $551eW.startOfISOWeekYear)(date);
    const nextYear = (0, $551eW.startOfISOWeekYear)((0, $gdvs1.addWeeks)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $briB4.millisecondsInWeek);
}

});

parcelRegister("c1AiI", function(module, exports) {

$parcel$export(module.exports, "getMilliseconds", () => $8c11bc9b369aea05$export$b8e4380f312797af, (v) => $8c11bc9b369aea05$export$b8e4380f312797af = v);
var $8c11bc9b369aea05$export$b8e4380f312797af;
"use strict";
$8c11bc9b369aea05$export$b8e4380f312797af = $8c11bc9b369aea05$var$getMilliseconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $8c11bc9b369aea05$var$getMilliseconds(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

});

parcelRegister("eavWe", function(module, exports) {

$parcel$export(module.exports, "getOverlappingDaysInIntervals", () => $a50ac61c155d82aa$export$baae148532bd1d46, (v) => $a50ac61c155d82aa$export$baae148532bd1d46 = v);
var $a50ac61c155d82aa$export$baae148532bd1d46;
"use strict";
$a50ac61c155d82aa$export$baae148532bd1d46 = $a50ac61c155d82aa$var$getOverlappingDaysInIntervals;

var $cBJez = parcelRequire("cBJez");

var $briB4 = parcelRequire("briB4");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $a50ac61c155d82aa$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $30SVQ.toDate)(intervalLeft.start),
        +(0, $30SVQ.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $30SVQ.toDate)(intervalRight.start),
        +(0, $30SVQ.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $cBJez.getTimezoneOffsetInMilliseconds)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $cBJez.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $briB4.millisecondsInDay);
}

});

parcelRegister("h0fvZ", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", () => $c60e78b2b3ab2c93$export$1f77c0008d16313, (v) => $c60e78b2b3ab2c93$export$1f77c0008d16313 = v);
var $c60e78b2b3ab2c93$export$1f77c0008d16313;
"use strict";
$c60e78b2b3ab2c93$export$1f77c0008d16313 = $c60e78b2b3ab2c93$var$getUnixTime;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $c60e78b2b3ab2c93$var$getUnixTime(date) {
    return Math.trunc(+(0, $30SVQ.toDate)(date) / 1000);
}

});

parcelRegister("8uZvx", function(module, exports) {

$parcel$export(module.exports, "getWeekOfMonth", () => $6300d6356cdb10d1$export$59fb9b85a4d8d027, (v) => $6300d6356cdb10d1$export$59fb9b85a4d8d027 = v);
var $6300d6356cdb10d1$export$59fb9b85a4d8d027;
"use strict";
$6300d6356cdb10d1$export$59fb9b85a4d8d027 = $6300d6356cdb10d1$var$getWeekOfMonth;

var $inqX7 = parcelRequire("inqX7");

var $gf6Rq = parcelRequire("gf6Rq");

var $gxLWY = parcelRequire("gxLWY");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $6300d6356cdb10d1$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $inqX7.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $gf6Rq.getDay)((0, $gxLWY.startOfMonth)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

});

parcelRegister("gDNrw", function(module, exports) {

$parcel$export(module.exports, "getWeeksInMonth", () => $c1d6a42d4ff2e720$export$ccc1b2479e7dd654, (v) => $c1d6a42d4ff2e720$export$ccc1b2479e7dd654 = v);
var $c1d6a42d4ff2e720$export$ccc1b2479e7dd654;
"use strict";
$c1d6a42d4ff2e720$export$ccc1b2479e7dd654 = $c1d6a42d4ff2e720$var$getWeeksInMonth;

var $hcJKh = parcelRequire("hcJKh");

var $fUlt6 = parcelRequire("fUlt6");

var $gxLWY = parcelRequire("gxLWY");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $c1d6a42d4ff2e720$var$getWeeksInMonth(date, options) {
    return (0, $hcJKh.differenceInCalendarWeeks)((0, $fUlt6.lastDayOfMonth)(date), (0, $gxLWY.startOfMonth)(date), options) + 1;
}

});
parcelRegister("fUlt6", function(module, exports) {

$parcel$export(module.exports, "lastDayOfMonth", () => $b94cbd258d877bc8$export$36818250d6c87922, (v) => $b94cbd258d877bc8$export$36818250d6c87922 = v);
var $b94cbd258d877bc8$export$36818250d6c87922;
"use strict";
$b94cbd258d877bc8$export$36818250d6c87922 = $b94cbd258d877bc8$var$lastDayOfMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $b94cbd258d877bc8$var$lastDayOfMonth(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("diyr6", function(module, exports) {

$parcel$export(module.exports, "hoursToMilliseconds", () => $9ae7ab1e5313bfc3$export$5b42ab7a22898b69, (v) => $9ae7ab1e5313bfc3$export$5b42ab7a22898b69 = v);
var $9ae7ab1e5313bfc3$export$5b42ab7a22898b69;
"use strict";
$9ae7ab1e5313bfc3$export$5b42ab7a22898b69 = $9ae7ab1e5313bfc3$var$hoursToMilliseconds;

var $briB4 = parcelRequire("briB4");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $9ae7ab1e5313bfc3$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $briB4.millisecondsInHour);
}

});

parcelRegister("id85t", function(module, exports) {

$parcel$export(module.exports, "hoursToMinutes", () => $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8, (v) => $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8 = v);
var $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8;
"use strict";
$d41fb6e1e630ebbd$export$83bfc73cdf89a4d8 = $d41fb6e1e630ebbd$var$hoursToMinutes;

var $briB4 = parcelRequire("briB4");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $d41fb6e1e630ebbd$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $briB4.minutesInHour);
}

});

parcelRegister("lHdeC", function(module, exports) {

$parcel$export(module.exports, "hoursToSeconds", () => $fcb7e14c40da1793$export$59b1396ccbd5a4e1, (v) => $fcb7e14c40da1793$export$59b1396ccbd5a4e1 = v);
var $fcb7e14c40da1793$export$59b1396ccbd5a4e1;
"use strict";
$fcb7e14c40da1793$export$59b1396ccbd5a4e1 = $fcb7e14c40da1793$var$hoursToSeconds;

var $briB4 = parcelRequire("briB4");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $fcb7e14c40da1793$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $briB4.secondsInHour);
}

});

parcelRegister("8O4RE", function(module, exports) {

$parcel$export(module.exports, "interval", () => $6696c43013de930d$export$3174cdbf0a0cbc84, (v) => $6696c43013de930d$export$3174cdbf0a0cbc84 = v);
var $6696c43013de930d$export$3174cdbf0a0cbc84;
"use strict";
$6696c43013de930d$export$3174cdbf0a0cbc84 = $6696c43013de930d$var$interval;

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $6696c43013de930d$var$interval(start, end, options) {
    const _start = (0, $30SVQ.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $30SVQ.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}

});

parcelRegister("1uAld", function(module, exports) {

$parcel$export(module.exports, "intervalToDuration", () => $1164c85dc3b4daac$export$7b6c9a626316863, (v) => $1164c85dc3b4daac$export$7b6c9a626316863 = v);
var $1164c85dc3b4daac$export$7b6c9a626316863;
"use strict";
$1164c85dc3b4daac$export$7b6c9a626316863 = $1164c85dc3b4daac$var$intervalToDuration;

var $7eqmQ = parcelRequire("7eqmQ");

var $2THNu = parcelRequire("2THNu");

var $kLDS0 = parcelRequire("kLDS0");

var $8V4Fd = parcelRequire("8V4Fd");

var $6v0iN = parcelRequire("6v0iN");

var $k0LcS = parcelRequire("k0LcS");

var $gpIjX = parcelRequire("gpIjX");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $1164c85dc3b4daac$var$intervalToDuration(interval) {
    const start = (0, $30SVQ.toDate)(interval.start);
    const end = (0, $30SVQ.toDate)(interval.end);
    const duration = {};
    const years = (0, $gpIjX.differenceInYears)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $7eqmQ.add)(start, {
        years: duration.years
    });
    const months = (0, $6v0iN.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $7eqmQ.add)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $2THNu.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $7eqmQ.add)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $kLDS0.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $7eqmQ.add)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $8V4Fd.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $7eqmQ.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $k0LcS.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}

});

parcelRegister("e4oj6", function(module, exports) {

$parcel$export(module.exports, "intlFormat", () => $a3e44b502e508de0$export$f58f1234eed71f82, (v) => $a3e44b502e508de0$export$f58f1234eed71f82 = v);
var $a3e44b502e508de0$export$f58f1234eed71f82;
"use strict";
$a3e44b502e508de0$export$f58f1234eed71f82 = $a3e44b502e508de0$var$intlFormat;

var $30SVQ = parcelRequire("30SVQ");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $a3e44b502e508de0$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($a3e44b502e508de0$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $30SVQ.toDate)(date));
}
function $a3e44b502e508de0$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}

});

parcelRegister("d2sW8", function(module, exports) {

$parcel$export(module.exports, "intlFormatDistance", () => $97e1e87f40603cdb$export$a110a4020280fd5, (v) => $97e1e87f40603cdb$export$a110a4020280fd5 = v);
var $97e1e87f40603cdb$export$a110a4020280fd5;
"use strict";
$97e1e87f40603cdb$export$a110a4020280fd5 = $97e1e87f40603cdb$var$intlFormatDistance;

var $briB4 = parcelRequire("briB4");

var $9UMYl = parcelRequire("9UMYl");

var $bTWJP = parcelRequire("bTWJP");

var $7yyNc = parcelRequire("7yyNc");

var $hcJKh = parcelRequire("hcJKh");

var $7b4id = parcelRequire("7b4id");

var $kLDS0 = parcelRequire("kLDS0");

var $8V4Fd = parcelRequire("8V4Fd");

var $k0LcS = parcelRequire("k0LcS");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $97e1e87f40603cdb$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $30SVQ.toDate)(date);
    const dateRight = (0, $30SVQ.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $k0LcS.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $briB4.secondsInMinute) {
            value = (0, $k0LcS.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $briB4.secondsInHour) {
            value = (0, $8V4Fd.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $briB4.secondsInDay && Math.abs((0, $9UMYl.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, $kLDS0.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $briB4.secondsInWeek && (value = (0, $9UMYl.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $briB4.secondsInMonth) {
            value = (0, $hcJKh.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $briB4.secondsInQuarter) {
            value = (0, $bTWJP.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $briB4.secondsInYear) {
            if ((0, $7yyNc.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $7yyNc.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $7b4id.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $7b4id.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $k0LcS.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $8V4Fd.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $kLDS0.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $9UMYl.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $hcJKh.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $bTWJP.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $7yyNc.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $7b4id.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}

});

parcelRegister("31FEl", function(module, exports) {

$parcel$export(module.exports, "isExists", () => $2341c5e25fcfd1db$export$127519e0edcdc58b, (v) => $2341c5e25fcfd1db$export$127519e0edcdc58b = v);
var $2341c5e25fcfd1db$export$127519e0edcdc58b;
"use strict";
$2341c5e25fcfd1db$export$127519e0edcdc58b = $2341c5e25fcfd1db$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $2341c5e25fcfd1db$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

});

parcelRegister("beuaX", function(module, exports) {

$parcel$export(module.exports, "isFirstDayOfMonth", () => $82d868cdf6cf6fea$export$2716a425049f51dd, (v) => $82d868cdf6cf6fea$export$2716a425049f51dd = v);
var $82d868cdf6cf6fea$export$2716a425049f51dd;
"use strict";
$82d868cdf6cf6fea$export$2716a425049f51dd = $82d868cdf6cf6fea$var$isFirstDayOfMonth;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $82d868cdf6cf6fea$var$isFirstDayOfMonth(date) {
    return (0, $30SVQ.toDate)(date).getDate() === 1;
}

});

parcelRegister("eVoqM", function(module, exports) {

$parcel$export(module.exports, "isFriday", () => $add9570ccdd56579$export$3b7d89f127884993, (v) => $add9570ccdd56579$export$3b7d89f127884993 = v);
var $add9570ccdd56579$export$3b7d89f127884993;
"use strict";
$add9570ccdd56579$export$3b7d89f127884993 = $add9570ccdd56579$var$isFriday;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $add9570ccdd56579$var$isFriday(date) {
    return (0, $30SVQ.toDate)(date).getDay() === 5;
}

});

parcelRegister("exQR4", function(module, exports) {

$parcel$export(module.exports, "isFuture", () => $a96d25a4d70c8926$export$2baac2df6018cd7, (v) => $a96d25a4d70c8926$export$2baac2df6018cd7 = v);
var $a96d25a4d70c8926$export$2baac2df6018cd7;
"use strict";
$a96d25a4d70c8926$export$2baac2df6018cd7 = $a96d25a4d70c8926$var$isFuture;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $a96d25a4d70c8926$var$isFuture(date) {
    return +(0, $30SVQ.toDate)(date) > Date.now();
}

});

parcelRegister("ccRgt", function(module, exports) {

$parcel$export(module.exports, "isMatch", () => $8e2fec4c70f4ef6b$export$b74c33566721f70f, (v) => $8e2fec4c70f4ef6b$export$b74c33566721f70f = v);
var $8e2fec4c70f4ef6b$export$b74c33566721f70f;
"use strict";
$8e2fec4c70f4ef6b$export$b74c33566721f70f = $8e2fec4c70f4ef6b$var$isMatch;

var $kPCB6 = parcelRequire("kPCB6");

var $bUtct = parcelRequire("bUtct");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $8e2fec4c70f4ef6b$var$isMatch(dateStr, formatStr, options) {
    return (0, $kPCB6.isValid)((0, $bUtct.parse)(dateStr, formatStr, new Date(), options));
}

});

parcelRegister("5sCnM", function(module, exports) {

$parcel$export(module.exports, "isMonday", () => $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5, (v) => $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5 = v);
var $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5;
"use strict";
$3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5 = $3f9d573ef8d8a1fd$var$isMonday;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $3f9d573ef8d8a1fd$var$isMonday(date) {
    return (0, $30SVQ.toDate)(date).getDay() === 1;
}

});

parcelRegister("cPMBB", function(module, exports) {

$parcel$export(module.exports, "isPast", () => $957ff381b38ac7b6$export$fc5014aa3db48558, (v) => $957ff381b38ac7b6$export$fc5014aa3db48558 = v);
var $957ff381b38ac7b6$export$fc5014aa3db48558;
"use strict";
$957ff381b38ac7b6$export$fc5014aa3db48558 = $957ff381b38ac7b6$var$isPast;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $957ff381b38ac7b6$var$isPast(date) {
    return +(0, $30SVQ.toDate)(date) < Date.now();
}

});

parcelRegister("5hZu1", function(module, exports) {

$parcel$export(module.exports, "isSameHour", () => $3d9e3b90112ffc43$export$f9f3a94a0371013, (v) => $3d9e3b90112ffc43$export$f9f3a94a0371013 = v);
var $3d9e3b90112ffc43$export$f9f3a94a0371013;
"use strict";
$3d9e3b90112ffc43$export$f9f3a94a0371013 = $3d9e3b90112ffc43$var$isSameHour;

var $hYeCp = parcelRequire("hYeCp");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $3d9e3b90112ffc43$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $hYeCp.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, $hYeCp.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

});
parcelRegister("hYeCp", function(module, exports) {

$parcel$export(module.exports, "startOfHour", () => $d153613108f3ff12$export$24f91f68e7c9d9d5, (v) => $d153613108f3ff12$export$24f91f68e7c9d9d5 = v);
var $d153613108f3ff12$export$24f91f68e7c9d9d5;
"use strict";
$d153613108f3ff12$export$24f91f68e7c9d9d5 = $d153613108f3ff12$var$startOfHour;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $d153613108f3ff12$var$startOfHour(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

});


parcelRegister("44Tpm", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeek", () => $2f828403128a4c50$export$1c6e74e3c7b27764, (v) => $2f828403128a4c50$export$1c6e74e3c7b27764 = v);
var $2f828403128a4c50$export$1c6e74e3c7b27764;
"use strict";
$2f828403128a4c50$export$1c6e74e3c7b27764 = $2f828403128a4c50$var$isSameISOWeek;

var $5NOJ1 = parcelRequire("5NOJ1");
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $2f828403128a4c50$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $5NOJ1.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}

});
parcelRegister("5NOJ1", function(module, exports) {

$parcel$export(module.exports, "isSameWeek", () => $4398e052cc63a087$export$6ea683876c36b8d2, (v) => $4398e052cc63a087$export$6ea683876c36b8d2 = v);
var $4398e052cc63a087$export$6ea683876c36b8d2;
"use strict";
$4398e052cc63a087$export$6ea683876c36b8d2 = $4398e052cc63a087$var$isSameWeek;

var $8ple2 = parcelRequire("8ple2");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $4398e052cc63a087$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $8ple2.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $8ple2.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

});


parcelRegister("ic6FC", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeekYear", () => $d3ee8591ef34529f$export$5f55dbf38a1aee81, (v) => $d3ee8591ef34529f$export$5f55dbf38a1aee81 = v);
var $d3ee8591ef34529f$export$5f55dbf38a1aee81;
"use strict";
$d3ee8591ef34529f$export$5f55dbf38a1aee81 = $d3ee8591ef34529f$var$isSameISOWeekYear;

var $551eW = parcelRequire("551eW");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $d3ee8591ef34529f$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $551eW.startOfISOWeekYear)(dateLeft);
    const dateRightStartOfYear = (0, $551eW.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}

});

parcelRegister("iY0Kr", function(module, exports) {

$parcel$export(module.exports, "isSameMinute", () => $dcee691fa8b5c110$export$5d274bf63c8705cb, (v) => $dcee691fa8b5c110$export$5d274bf63c8705cb = v);
var $dcee691fa8b5c110$export$5d274bf63c8705cb;
"use strict";
$dcee691fa8b5c110$export$5d274bf63c8705cb = $dcee691fa8b5c110$var$isSameMinute;

var $i06ug = parcelRequire("i06ug");
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $dcee691fa8b5c110$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $i06ug.startOfMinute)(dateLeft);
    const dateRightStartOfMinute = (0, $i06ug.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

});

parcelRegister("f2HTn", function(module, exports) {

$parcel$export(module.exports, "isSameSecond", () => $af3916f9a5384d82$export$b88fbcfe038f3498, (v) => $af3916f9a5384d82$export$b88fbcfe038f3498 = v);
var $af3916f9a5384d82$export$b88fbcfe038f3498;
"use strict";
$af3916f9a5384d82$export$b88fbcfe038f3498 = $af3916f9a5384d82$var$isSameSecond;

var $lS30d = parcelRequire("lS30d");
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $af3916f9a5384d82$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $lS30d.startOfSecond)(dateLeft);
    const dateRightStartOfSecond = (0, $lS30d.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

});
parcelRegister("lS30d", function(module, exports) {

$parcel$export(module.exports, "startOfSecond", () => $fec0f854199fab32$export$66c51f9715fdbff5, (v) => $fec0f854199fab32$export$66c51f9715fdbff5 = v);
var $fec0f854199fab32$export$66c51f9715fdbff5;
"use strict";
$fec0f854199fab32$export$66c51f9715fdbff5 = $fec0f854199fab32$var$startOfSecond;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $fec0f854199fab32$var$startOfSecond(date) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}

});


parcelRegister("2Jk1U", function(module, exports) {

$parcel$export(module.exports, "isThisHour", () => $1fcf523a61a65140$export$5d41bdc7172839b9, (v) => $1fcf523a61a65140$export$5d41bdc7172839b9 = v);
var $1fcf523a61a65140$export$5d41bdc7172839b9;
"use strict";
$1fcf523a61a65140$export$5d41bdc7172839b9 = $1fcf523a61a65140$var$isThisHour;

var $izNX2 = parcelRequire("izNX2");

var $5hZu1 = parcelRequire("5hZu1");
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $1fcf523a61a65140$var$isThisHour(date) {
    return (0, $5hZu1.isSameHour)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("1HYQi", function(module, exports) {

$parcel$export(module.exports, "isThisISOWeek", () => $13e900ab202aea44$export$4e987896c721f753, (v) => $13e900ab202aea44$export$4e987896c721f753 = v);
var $13e900ab202aea44$export$4e987896c721f753;
"use strict";
$13e900ab202aea44$export$4e987896c721f753 = $13e900ab202aea44$var$isThisISOWeek;

var $izNX2 = parcelRequire("izNX2");

var $44Tpm = parcelRequire("44Tpm");
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $13e900ab202aea44$var$isThisISOWeek(date) {
    return (0, $44Tpm.isSameISOWeek)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("1wBjh", function(module, exports) {

$parcel$export(module.exports, "isThisMinute", () => $11c5b8927d0f9212$export$fa55b7d29d8d957a, (v) => $11c5b8927d0f9212$export$fa55b7d29d8d957a = v);
var $11c5b8927d0f9212$export$fa55b7d29d8d957a;
"use strict";
$11c5b8927d0f9212$export$fa55b7d29d8d957a = $11c5b8927d0f9212$var$isThisMinute;

var $izNX2 = parcelRequire("izNX2");

var $iY0Kr = parcelRequire("iY0Kr");
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $11c5b8927d0f9212$var$isThisMinute(date) {
    return (0, $iY0Kr.isSameMinute)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("eaHlN", function(module, exports) {

$parcel$export(module.exports, "isThisMonth", () => $a513a065f29b721f$export$173f1e1d92847276, (v) => $a513a065f29b721f$export$173f1e1d92847276 = v);
var $a513a065f29b721f$export$173f1e1d92847276;
"use strict";
$a513a065f29b721f$export$173f1e1d92847276 = $a513a065f29b721f$var$isThisMonth;

var $izNX2 = parcelRequire("izNX2");

var $AFgUD = parcelRequire("AFgUD");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $a513a065f29b721f$var$isThisMonth(date) {
    return (0, $AFgUD.isSameMonth)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("aBSWZ", function(module, exports) {

$parcel$export(module.exports, "isThisQuarter", () => $7b97fc1be12623a5$export$3d88fd18ab599ccc, (v) => $7b97fc1be12623a5$export$3d88fd18ab599ccc = v);
var $7b97fc1be12623a5$export$3d88fd18ab599ccc;
"use strict";
$7b97fc1be12623a5$export$3d88fd18ab599ccc = $7b97fc1be12623a5$var$isThisQuarter;

var $izNX2 = parcelRequire("izNX2");

var $f8HTF = parcelRequire("f8HTF");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $7b97fc1be12623a5$var$isThisQuarter(date) {
    return (0, $f8HTF.isSameQuarter)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("gAd4x", function(module, exports) {

$parcel$export(module.exports, "isThisSecond", () => $c12a26020747be23$export$8d7059b5bca087e6, (v) => $c12a26020747be23$export$8d7059b5bca087e6 = v);
var $c12a26020747be23$export$8d7059b5bca087e6;
"use strict";
$c12a26020747be23$export$8d7059b5bca087e6 = $c12a26020747be23$var$isThisSecond;

var $izNX2 = parcelRequire("izNX2");

var $f2HTn = parcelRequire("f2HTn");
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $c12a26020747be23$var$isThisSecond(date) {
    return (0, $f2HTn.isSameSecond)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("j8O8W", function(module, exports) {

$parcel$export(module.exports, "isThisWeek", () => $def5a9154a6fce3c$export$cfe4b66a69cdd8a, (v) => $def5a9154a6fce3c$export$cfe4b66a69cdd8a = v);
var $def5a9154a6fce3c$export$cfe4b66a69cdd8a;
"use strict";
$def5a9154a6fce3c$export$cfe4b66a69cdd8a = $def5a9154a6fce3c$var$isThisWeek;

var $izNX2 = parcelRequire("izNX2");

var $5NOJ1 = parcelRequire("5NOJ1");
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $def5a9154a6fce3c$var$isThisWeek(date, options) {
    return (0, $5NOJ1.isSameWeek)(date, (0, $izNX2.constructNow)(date), options);
}

});

parcelRegister("RAJBK", function(module, exports) {

$parcel$export(module.exports, "isThisYear", () => $0a1172148c7ecca3$export$a28c94941893a5ac, (v) => $0a1172148c7ecca3$export$a28c94941893a5ac = v);
var $0a1172148c7ecca3$export$a28c94941893a5ac;
"use strict";
$0a1172148c7ecca3$export$a28c94941893a5ac = $0a1172148c7ecca3$var$isThisYear;

var $izNX2 = parcelRequire("izNX2");

var $ea2hS = parcelRequire("ea2hS");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $0a1172148c7ecca3$var$isThisYear(date) {
    return (0, $ea2hS.isSameYear)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("3CNVN", function(module, exports) {

$parcel$export(module.exports, "isThursday", () => $2a3ba7018817a2a8$export$c8e7c906983ea347, (v) => $2a3ba7018817a2a8$export$c8e7c906983ea347 = v);
var $2a3ba7018817a2a8$export$c8e7c906983ea347;
"use strict";
$2a3ba7018817a2a8$export$c8e7c906983ea347 = $2a3ba7018817a2a8$var$isThursday;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $2a3ba7018817a2a8$var$isThursday(date) {
    return (0, $30SVQ.toDate)(date).getDay() === 4;
}

});

parcelRegister("l4yMD", function(module, exports) {

$parcel$export(module.exports, "isToday", () => $f574f3f9c5879b15$export$629b0a497aa65267, (v) => $f574f3f9c5879b15$export$629b0a497aa65267 = v);
var $f574f3f9c5879b15$export$629b0a497aa65267;
"use strict";
$f574f3f9c5879b15$export$629b0a497aa65267 = $f574f3f9c5879b15$var$isToday;

var $izNX2 = parcelRequire("izNX2");

var $3p5lI = parcelRequire("3p5lI");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $f574f3f9c5879b15$var$isToday(date) {
    return (0, $3p5lI.isSameDay)(date, (0, $izNX2.constructNow)(date));
}

});

parcelRegister("bufTo", function(module, exports) {

$parcel$export(module.exports, "isTomorrow", () => $85ced2fb3637e354$export$d6365ba92f0647f1, (v) => $85ced2fb3637e354$export$d6365ba92f0647f1 = v);
var $85ced2fb3637e354$export$d6365ba92f0647f1;
"use strict";
$85ced2fb3637e354$export$d6365ba92f0647f1 = $85ced2fb3637e354$var$isTomorrow;

var $e1kwM = parcelRequire("e1kwM");

var $izNX2 = parcelRequire("izNX2");

var $3p5lI = parcelRequire("3p5lI");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $85ced2fb3637e354$var$isTomorrow(date) {
    return (0, $3p5lI.isSameDay)(date, (0, $e1kwM.addDays)((0, $izNX2.constructNow)(date), 1));
}

});

parcelRegister("cpLDu", function(module, exports) {

$parcel$export(module.exports, "isTuesday", () => $909cc556808367c9$export$90d50b8f209f5ac3, (v) => $909cc556808367c9$export$90d50b8f209f5ac3 = v);
var $909cc556808367c9$export$90d50b8f209f5ac3;
"use strict";
$909cc556808367c9$export$90d50b8f209f5ac3 = $909cc556808367c9$var$isTuesday;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $909cc556808367c9$var$isTuesday(date) {
    return (0, $30SVQ.toDate)(date).getDay() === 2;
}

});

parcelRegister("47KA7", function(module, exports) {

$parcel$export(module.exports, "isWednesday", () => $300bf3048a829507$export$ec9de642cdd62944, (v) => $300bf3048a829507$export$ec9de642cdd62944 = v);
var $300bf3048a829507$export$ec9de642cdd62944;
"use strict";
$300bf3048a829507$export$ec9de642cdd62944 = $300bf3048a829507$var$isWednesday;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $300bf3048a829507$var$isWednesday(date) {
    return (0, $30SVQ.toDate)(date).getDay() === 3;
}

});

parcelRegister("agjyF", function(module, exports) {

$parcel$export(module.exports, "isYesterday", () => $01ed96ff4a2923d1$export$221990270ebfe867, (v) => $01ed96ff4a2923d1$export$221990270ebfe867 = v);
var $01ed96ff4a2923d1$export$221990270ebfe867;
"use strict";
$01ed96ff4a2923d1$export$221990270ebfe867 = $01ed96ff4a2923d1$var$isYesterday;

var $izNX2 = parcelRequire("izNX2");

var $3p5lI = parcelRequire("3p5lI");

var $5N9HD = parcelRequire("5N9HD");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $01ed96ff4a2923d1$var$isYesterday(date) {
    return (0, $3p5lI.isSameDay)(date, (0, $5N9HD.subDays)((0, $izNX2.constructNow)(date), 1));
}

});

parcelRegister("8hIkN", function(module, exports) {

$parcel$export(module.exports, "lastDayOfDecade", () => $60824d27a7e05259$export$2aaf6241f57dd605, (v) => $60824d27a7e05259$export$2aaf6241f57dd605 = v);
var $60824d27a7e05259$export$2aaf6241f57dd605;
"use strict";
$60824d27a7e05259$export$2aaf6241f57dd605 = $60824d27a7e05259$var$lastDayOfDecade;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $60824d27a7e05259$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("4rkNn", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeek", () => $33b9d09203a4d772$export$b08a8fc26ae6d94b, (v) => $33b9d09203a4d772$export$b08a8fc26ae6d94b = v);
var $33b9d09203a4d772$export$b08a8fc26ae6d94b;
"use strict";
$33b9d09203a4d772$export$b08a8fc26ae6d94b = $33b9d09203a4d772$var$lastDayOfISOWeek;

var $hjcVO = parcelRequire("hjcVO");
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $33b9d09203a4d772$var$lastDayOfISOWeek(date) {
    return (0, $hjcVO.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("hjcVO", function(module, exports) {

$parcel$export(module.exports, "lastDayOfWeek", () => $c99e3df3cf1d9686$export$b73502c35a293b0a, (v) => $c99e3df3cf1d9686$export$b73502c35a293b0a = v);
var $c99e3df3cf1d9686$export$b73502c35a293b0a;
"use strict";
$c99e3df3cf1d9686$export$b73502c35a293b0a = $c99e3df3cf1d9686$var$lastDayOfWeek;

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $c99e3df3cf1d9686$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $30SVQ.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("lqZFe", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeekYear", () => $f9abdbe2cf16ca3c$export$1810bada8cd02ee1, (v) => $f9abdbe2cf16ca3c$export$1810bada8cd02ee1 = v);
var $f9abdbe2cf16ca3c$export$1810bada8cd02ee1;
"use strict";
$f9abdbe2cf16ca3c$export$1810bada8cd02ee1 = $f9abdbe2cf16ca3c$var$lastDayOfISOWeekYear;

var $hhS6V = parcelRequire("hhS6V");

var $2sjl8 = parcelRequire("2sjl8");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $f9abdbe2cf16ca3c$var$lastDayOfISOWeekYear(date) {
    const year = (0, $hhS6V.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $eK5z7.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $2sjl8.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}

});

parcelRegister("f7TmA", function(module, exports) {

$parcel$export(module.exports, "lastDayOfQuarter", () => $b03274799f21cdd8$export$8693c04228304c7, (v) => $b03274799f21cdd8$export$8693c04228304c7 = v);
var $b03274799f21cdd8$export$8693c04228304c7;
"use strict";
$b03274799f21cdd8$export$8693c04228304c7 = $b03274799f21cdd8$var$lastDayOfQuarter;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $b03274799f21cdd8$var$lastDayOfQuarter(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("65ik4", function(module, exports) {

$parcel$export(module.exports, "lastDayOfYear", () => $46e16c3d8313f406$export$323f7bc07b828bed, (v) => $46e16c3d8313f406$export$323f7bc07b828bed = v);
var $46e16c3d8313f406$export$323f7bc07b828bed;
"use strict";
$46e16c3d8313f406$export$323f7bc07b828bed = $46e16c3d8313f406$var$lastDayOfYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $46e16c3d8313f406$var$lastDayOfYear(date) {
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("hHGXj", function(module, exports) {
"use strict";
module.exports.lightFormat = $ce37c5e4ac88a02b$var$lightFormat;
Object.defineProperty(module.exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $9KWEw.lightFormatters;
    }
});

var $kPCB6 = parcelRequire("kPCB6");

var $30SVQ = parcelRequire("30SVQ");

var $9KWEw = parcelRequire("9KWEw");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $ce37c5e4ac88a02b$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $ce37c5e4ac88a02b$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $ce37c5e4ac88a02b$var$doubleQuoteRegExp = /''/g;
const $ce37c5e4ac88a02b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $ce37c5e4ac88a02b$var$lightFormat(date, formatStr) {
    const _date = (0, $30SVQ.toDate)(date);
    if (!(0, $kPCB6.isValid)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($ce37c5e4ac88a02b$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $ce37c5e4ac88a02b$var$cleanEscapedString(substring);
        const formatter = $9KWEw.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($ce37c5e4ac88a02b$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $ce37c5e4ac88a02b$var$cleanEscapedString(input) {
    const matches = input.match($ce37c5e4ac88a02b$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($ce37c5e4ac88a02b$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("d1uYB", function(module, exports) {

$parcel$export(module.exports, "milliseconds", () => $97b365a16a43d25e$export$9a27fac83d67afd3, (v) => $97b365a16a43d25e$export$9a27fac83d67afd3 = v);
var $97b365a16a43d25e$export$9a27fac83d67afd3;
"use strict";
$97b365a16a43d25e$export$9a27fac83d67afd3 = $97b365a16a43d25e$var$milliseconds;

var $briB4 = parcelRequire("briB4");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $97b365a16a43d25e$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $briB4.daysInYear;
    if (months) totalDays += months * ($briB4.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}

});

parcelRegister("etvqT", function(module, exports) {

$parcel$export(module.exports, "millisecondsToHours", () => $a89c280122b57cc6$export$689a412b29fa9ed5, (v) => $a89c280122b57cc6$export$689a412b29fa9ed5 = v);
var $a89c280122b57cc6$export$689a412b29fa9ed5;
"use strict";
$a89c280122b57cc6$export$689a412b29fa9ed5 = $a89c280122b57cc6$var$millisecondsToHours;

var $briB4 = parcelRequire("briB4");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $a89c280122b57cc6$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $briB4.millisecondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("cTeBl", function(module, exports) {

$parcel$export(module.exports, "millisecondsToMinutes", () => $9625f295f3161b5c$export$a5f974e81e48cfc0, (v) => $9625f295f3161b5c$export$a5f974e81e48cfc0 = v);
var $9625f295f3161b5c$export$a5f974e81e48cfc0;
"use strict";
$9625f295f3161b5c$export$a5f974e81e48cfc0 = $9625f295f3161b5c$var$millisecondsToMinutes;

var $briB4 = parcelRequire("briB4");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $9625f295f3161b5c$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $briB4.millisecondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("fnpRN", function(module, exports) {

$parcel$export(module.exports, "millisecondsToSeconds", () => $b31d11994e596a58$export$f64c3bfbc58eec0f, (v) => $b31d11994e596a58$export$f64c3bfbc58eec0f = v);
var $b31d11994e596a58$export$f64c3bfbc58eec0f;
"use strict";
$b31d11994e596a58$export$f64c3bfbc58eec0f = $b31d11994e596a58$var$millisecondsToSeconds;

var $briB4 = parcelRequire("briB4");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $b31d11994e596a58$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $briB4.millisecondsInSecond;
    return Math.trunc(seconds);
}

});

parcelRegister("7sSFN", function(module, exports) {

$parcel$export(module.exports, "minutesToHours", () => $56f58edd96e5b9ca$export$815164eb42530ae7, (v) => $56f58edd96e5b9ca$export$815164eb42530ae7 = v);
var $56f58edd96e5b9ca$export$815164eb42530ae7;
"use strict";
$56f58edd96e5b9ca$export$815164eb42530ae7 = $56f58edd96e5b9ca$var$minutesToHours;

var $briB4 = parcelRequire("briB4");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $56f58edd96e5b9ca$var$minutesToHours(minutes) {
    const hours = minutes / $briB4.minutesInHour;
    return Math.trunc(hours);
}

});

parcelRegister("VBJUF", function(module, exports) {

$parcel$export(module.exports, "minutesToMilliseconds", () => $0ad299455c4a7bce$export$f6b9795ef9056e3d, (v) => $0ad299455c4a7bce$export$f6b9795ef9056e3d = v);
var $0ad299455c4a7bce$export$f6b9795ef9056e3d;
"use strict";
$0ad299455c4a7bce$export$f6b9795ef9056e3d = $0ad299455c4a7bce$var$minutesToMilliseconds;

var $briB4 = parcelRequire("briB4");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $0ad299455c4a7bce$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $briB4.millisecondsInMinute);
}

});

parcelRegister("cLSol", function(module, exports) {

$parcel$export(module.exports, "minutesToSeconds", () => $94c410dcdc963b83$export$81ded4628c655103, (v) => $94c410dcdc963b83$export$81ded4628c655103 = v);
var $94c410dcdc963b83$export$81ded4628c655103;
"use strict";
$94c410dcdc963b83$export$81ded4628c655103 = $94c410dcdc963b83$var$minutesToSeconds;

var $briB4 = parcelRequire("briB4");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $94c410dcdc963b83$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $briB4.secondsInMinute);
}

});

parcelRegister("9lRiu", function(module, exports) {

$parcel$export(module.exports, "monthsToQuarters", () => $6cef6af716faa10c$export$1932fa2a2068c849, (v) => $6cef6af716faa10c$export$1932fa2a2068c849 = v);
var $6cef6af716faa10c$export$1932fa2a2068c849;
"use strict";
$6cef6af716faa10c$export$1932fa2a2068c849 = $6cef6af716faa10c$var$monthsToQuarters;

var $briB4 = parcelRequire("briB4");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $6cef6af716faa10c$var$monthsToQuarters(months) {
    const quarters = months / $briB4.monthsInQuarter;
    return Math.trunc(quarters);
}

});

parcelRegister("aJr1u", function(module, exports) {

$parcel$export(module.exports, "monthsToYears", () => $7d031190fd4018fe$export$7489026ed27fc925, (v) => $7d031190fd4018fe$export$7489026ed27fc925 = v);
var $7d031190fd4018fe$export$7489026ed27fc925;
"use strict";
$7d031190fd4018fe$export$7489026ed27fc925 = $7d031190fd4018fe$var$monthsToYears;

var $briB4 = parcelRequire("briB4");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $7d031190fd4018fe$var$monthsToYears(months) {
    const years = months / $briB4.monthsInYear;
    return Math.trunc(years);
}

});

parcelRegister("dG3Ke", function(module, exports) {

$parcel$export(module.exports, "nextDay", () => $9f521a390e94151b$export$992728922317ffc8, (v) => $9f521a390e94151b$export$992728922317ffc8 = v);
var $9f521a390e94151b$export$992728922317ffc8;
"use strict";
$9f521a390e94151b$export$992728922317ffc8 = $9f521a390e94151b$var$nextDay;

var $e1kwM = parcelRequire("e1kwM");

var $gf6Rq = parcelRequire("gf6Rq");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $9f521a390e94151b$var$nextDay(date, day) {
    let delta = day - (0, $gf6Rq.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, $e1kwM.addDays)(date, delta);
}

});

parcelRegister("gdX2I", function(module, exports) {

$parcel$export(module.exports, "nextFriday", () => $bcfba8e94342fc2c$export$21d76934fce76327, (v) => $bcfba8e94342fc2c$export$21d76934fce76327 = v);
var $bcfba8e94342fc2c$export$21d76934fce76327;
"use strict";
$bcfba8e94342fc2c$export$21d76934fce76327 = $bcfba8e94342fc2c$var$nextFriday;

var $dG3Ke = parcelRequire("dG3Ke");
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $bcfba8e94342fc2c$var$nextFriday(date) {
    return (0, $dG3Ke.nextDay)(date, 5);
}

});

parcelRegister("h4ZBY", function(module, exports) {

$parcel$export(module.exports, "nextMonday", () => $c6f29a2a1ec58e88$export$a20373bb0df6efdd, (v) => $c6f29a2a1ec58e88$export$a20373bb0df6efdd = v);
var $c6f29a2a1ec58e88$export$a20373bb0df6efdd;
"use strict";
$c6f29a2a1ec58e88$export$a20373bb0df6efdd = $c6f29a2a1ec58e88$var$nextMonday;

var $dG3Ke = parcelRequire("dG3Ke");
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $c6f29a2a1ec58e88$var$nextMonday(date) {
    return (0, $dG3Ke.nextDay)(date, 1);
}

});

parcelRegister("6Caeg", function(module, exports) {

$parcel$export(module.exports, "nextSaturday", () => $4d0e39fd7f19b345$export$c52f069246f7b032, (v) => $4d0e39fd7f19b345$export$c52f069246f7b032 = v);
var $4d0e39fd7f19b345$export$c52f069246f7b032;
"use strict";
$4d0e39fd7f19b345$export$c52f069246f7b032 = $4d0e39fd7f19b345$var$nextSaturday;

var $dG3Ke = parcelRequire("dG3Ke");
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $4d0e39fd7f19b345$var$nextSaturday(date) {
    return (0, $dG3Ke.nextDay)(date, 6);
}

});

parcelRegister("a5Cws", function(module, exports) {

$parcel$export(module.exports, "nextSunday", () => $758840c198612cbb$export$a30adaa3ef47f854, (v) => $758840c198612cbb$export$a30adaa3ef47f854 = v);
var $758840c198612cbb$export$a30adaa3ef47f854;
"use strict";
$758840c198612cbb$export$a30adaa3ef47f854 = $758840c198612cbb$var$nextSunday;

var $dG3Ke = parcelRequire("dG3Ke");
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $758840c198612cbb$var$nextSunday(date) {
    return (0, $dG3Ke.nextDay)(date, 0);
}

});

parcelRegister("hucRo", function(module, exports) {

$parcel$export(module.exports, "nextThursday", () => $cbaf36c74556d9ba$export$36d9a8523a98d5a4, (v) => $cbaf36c74556d9ba$export$36d9a8523a98d5a4 = v);
var $cbaf36c74556d9ba$export$36d9a8523a98d5a4;
"use strict";
$cbaf36c74556d9ba$export$36d9a8523a98d5a4 = $cbaf36c74556d9ba$var$nextThursday;

var $dG3Ke = parcelRequire("dG3Ke");
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $cbaf36c74556d9ba$var$nextThursday(date) {
    return (0, $dG3Ke.nextDay)(date, 4);
}

});

parcelRegister("469lh", function(module, exports) {

$parcel$export(module.exports, "nextTuesday", () => $2fbef82198987bdb$export$391d63ff7dc2f668, (v) => $2fbef82198987bdb$export$391d63ff7dc2f668 = v);
var $2fbef82198987bdb$export$391d63ff7dc2f668;
"use strict";
$2fbef82198987bdb$export$391d63ff7dc2f668 = $2fbef82198987bdb$var$nextTuesday;

var $dG3Ke = parcelRequire("dG3Ke");
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $2fbef82198987bdb$var$nextTuesday(date) {
    return (0, $dG3Ke.nextDay)(date, 2);
}

});

parcelRegister("39xTu", function(module, exports) {

$parcel$export(module.exports, "nextWednesday", () => $24bc8105eef6f180$export$7a895c1ff204304e, (v) => $24bc8105eef6f180$export$7a895c1ff204304e = v);
var $24bc8105eef6f180$export$7a895c1ff204304e;
"use strict";
$24bc8105eef6f180$export$7a895c1ff204304e = $24bc8105eef6f180$var$nextWednesday;

var $dG3Ke = parcelRequire("dG3Ke");
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $24bc8105eef6f180$var$nextWednesday(date) {
    return (0, $dG3Ke.nextDay)(date, 3);
}

});

parcelRegister("1dBco", function(module, exports) {

$parcel$export(module.exports, "parseJSON", () => $0e33dc44389cd7c6$export$27924e57e9afff7f, (v) => $0e33dc44389cd7c6$export$27924e57e9afff7f = v);
var $0e33dc44389cd7c6$export$27924e57e9afff7f;
"use strict";
$0e33dc44389cd7c6$export$27924e57e9afff7f = $0e33dc44389cd7c6$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $0e33dc44389cd7c6$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}

});

parcelRegister("2oV6Q", function(module, exports) {

$parcel$export(module.exports, "previousDay", () => $1bfa1f6b04020399$export$4caccb62df4eacc0, (v) => $1bfa1f6b04020399$export$4caccb62df4eacc0 = v);
var $1bfa1f6b04020399$export$4caccb62df4eacc0;
"use strict";
$1bfa1f6b04020399$export$4caccb62df4eacc0 = $1bfa1f6b04020399$var$previousDay;

var $gf6Rq = parcelRequire("gf6Rq");

var $5N9HD = parcelRequire("5N9HD");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $1bfa1f6b04020399$var$previousDay(date, day) {
    let delta = (0, $gf6Rq.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $5N9HD.subDays)(date, delta);
}

});

parcelRegister("4k66o", function(module, exports) {

$parcel$export(module.exports, "previousFriday", () => $325dc36aced8b5fa$export$32d52646c338c11d, (v) => $325dc36aced8b5fa$export$32d52646c338c11d = v);
var $325dc36aced8b5fa$export$32d52646c338c11d;
"use strict";
$325dc36aced8b5fa$export$32d52646c338c11d = $325dc36aced8b5fa$var$previousFriday;

var $2oV6Q = parcelRequire("2oV6Q");
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $325dc36aced8b5fa$var$previousFriday(date) {
    return (0, $2oV6Q.previousDay)(date, 5);
}

});

parcelRegister("kyleL", function(module, exports) {

$parcel$export(module.exports, "previousMonday", () => $ef6774db45a223ab$export$398437ab6f45c582, (v) => $ef6774db45a223ab$export$398437ab6f45c582 = v);
var $ef6774db45a223ab$export$398437ab6f45c582;
"use strict";
$ef6774db45a223ab$export$398437ab6f45c582 = $ef6774db45a223ab$var$previousMonday;

var $2oV6Q = parcelRequire("2oV6Q");
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $ef6774db45a223ab$var$previousMonday(date) {
    return (0, $2oV6Q.previousDay)(date, 1);
}

});

parcelRegister("cQimJ", function(module, exports) {

$parcel$export(module.exports, "previousSaturday", () => $95989668dcda1eb0$export$36767a7e6101ecb0, (v) => $95989668dcda1eb0$export$36767a7e6101ecb0 = v);
var $95989668dcda1eb0$export$36767a7e6101ecb0;
"use strict";
$95989668dcda1eb0$export$36767a7e6101ecb0 = $95989668dcda1eb0$var$previousSaturday;

var $2oV6Q = parcelRequire("2oV6Q");
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $95989668dcda1eb0$var$previousSaturday(date) {
    return (0, $2oV6Q.previousDay)(date, 6);
}

});

parcelRegister("5KAOu", function(module, exports) {

$parcel$export(module.exports, "previousSunday", () => $42fdcdff82108acf$export$7d3d7d8fc5e81fd4, (v) => $42fdcdff82108acf$export$7d3d7d8fc5e81fd4 = v);
var $42fdcdff82108acf$export$7d3d7d8fc5e81fd4;
"use strict";
$42fdcdff82108acf$export$7d3d7d8fc5e81fd4 = $42fdcdff82108acf$var$previousSunday;

var $2oV6Q = parcelRequire("2oV6Q");
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $42fdcdff82108acf$var$previousSunday(date) {
    return (0, $2oV6Q.previousDay)(date, 0);
}

});

parcelRegister("iH2Ow", function(module, exports) {

$parcel$export(module.exports, "previousThursday", () => $d9be6ce747343891$export$1975b5b1f6b0e34e, (v) => $d9be6ce747343891$export$1975b5b1f6b0e34e = v);
var $d9be6ce747343891$export$1975b5b1f6b0e34e;
"use strict";
$d9be6ce747343891$export$1975b5b1f6b0e34e = $d9be6ce747343891$var$previousThursday;

var $2oV6Q = parcelRequire("2oV6Q");
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $d9be6ce747343891$var$previousThursday(date) {
    return (0, $2oV6Q.previousDay)(date, 4);
}

});

parcelRegister("gq2Ua", function(module, exports) {

$parcel$export(module.exports, "previousTuesday", () => $bf4153ed56fd16e2$export$a034a75f093bcfaf, (v) => $bf4153ed56fd16e2$export$a034a75f093bcfaf = v);
var $bf4153ed56fd16e2$export$a034a75f093bcfaf;
"use strict";
$bf4153ed56fd16e2$export$a034a75f093bcfaf = $bf4153ed56fd16e2$var$previousTuesday;

var $2oV6Q = parcelRequire("2oV6Q");
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $bf4153ed56fd16e2$var$previousTuesday(date) {
    return (0, $2oV6Q.previousDay)(date, 2);
}

});

parcelRegister("1TjQW", function(module, exports) {

$parcel$export(module.exports, "previousWednesday", () => $160a53e351bf91a7$export$26334f591e4ce672, (v) => $160a53e351bf91a7$export$26334f591e4ce672 = v);
var $160a53e351bf91a7$export$26334f591e4ce672;
"use strict";
$160a53e351bf91a7$export$26334f591e4ce672 = $160a53e351bf91a7$var$previousWednesday;

var $2oV6Q = parcelRequire("2oV6Q");
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $160a53e351bf91a7$var$previousWednesday(date) {
    return (0, $2oV6Q.previousDay)(date, 3);
}

});

parcelRegister("20acM", function(module, exports) {

$parcel$export(module.exports, "quartersToMonths", () => $17537f6141548b99$export$a29d19ce21d74c57, (v) => $17537f6141548b99$export$a29d19ce21d74c57 = v);
var $17537f6141548b99$export$a29d19ce21d74c57;
"use strict";
$17537f6141548b99$export$a29d19ce21d74c57 = $17537f6141548b99$var$quartersToMonths;

var $briB4 = parcelRequire("briB4");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $17537f6141548b99$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $briB4.monthsInQuarter);
}

});

parcelRegister("2vexC", function(module, exports) {

$parcel$export(module.exports, "quartersToYears", () => $1d29c198f18d87e1$export$c309fa8f184b4648, (v) => $1d29c198f18d87e1$export$c309fa8f184b4648 = v);
var $1d29c198f18d87e1$export$c309fa8f184b4648;
"use strict";
$1d29c198f18d87e1$export$c309fa8f184b4648 = $1d29c198f18d87e1$var$quartersToYears;

var $briB4 = parcelRequire("briB4");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $1d29c198f18d87e1$var$quartersToYears(quarters) {
    const years = quarters / $briB4.quartersInYear;
    return Math.trunc(years);
}

});

parcelRegister("luRW4", function(module, exports) {

$parcel$export(module.exports, "roundToNearestHours", () => $fa663ccbe744c7f5$export$a8b87649ebc0e3c2, (v) => $fa663ccbe744c7f5$export$a8b87649ebc0e3c2 = v);
var $fa663ccbe744c7f5$export$a8b87649ebc0e3c2;
"use strict";
$fa663ccbe744c7f5$export$a8b87649ebc0e3c2 = $fa663ccbe744c7f5$var$roundToNearestHours;

var $6it2M = parcelRequire("6it2M");

var $eK5z7 = parcelRequire("eK5z7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $fa663ccbe744c7f5$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $eK5z7.constructFrom)(date, NaN);
    const _date = (0, $30SVQ.toDate)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $6it2M.getRoundingMethod)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $eK5z7.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}

});

parcelRegister("dtPbO", function(module, exports) {

$parcel$export(module.exports, "roundToNearestMinutes", () => $9d05b0f997098e6a$export$d97410bb8cd0dff, (v) => $9d05b0f997098e6a$export$d97410bb8cd0dff = v);
var $9d05b0f997098e6a$export$d97410bb8cd0dff;
"use strict";
$9d05b0f997098e6a$export$d97410bb8cd0dff = $9d05b0f997098e6a$var$roundToNearestMinutes;

var $6it2M = parcelRequire("6it2M");

var $eK5z7 = parcelRequire("eK5z7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $9d05b0f997098e6a$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $eK5z7.constructFrom)(date, NaN);
    const _date = (0, $30SVQ.toDate)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $6it2M.getRoundingMethod)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $eK5z7.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}

});

parcelRegister("cPgLr", function(module, exports) {

$parcel$export(module.exports, "secondsToHours", () => $95674078571389b0$export$47d555ff5354096f, (v) => $95674078571389b0$export$47d555ff5354096f = v);
var $95674078571389b0$export$47d555ff5354096f;
"use strict";
$95674078571389b0$export$47d555ff5354096f = $95674078571389b0$var$secondsToHours;

var $briB4 = parcelRequire("briB4");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $95674078571389b0$var$secondsToHours(seconds) {
    const hours = seconds / $briB4.secondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("gcYU1", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", () => $bccd0254996c4544$export$fc3e7e8557f8c8c7, (v) => $bccd0254996c4544$export$fc3e7e8557f8c8c7 = v);
var $bccd0254996c4544$export$fc3e7e8557f8c8c7;
"use strict";
$bccd0254996c4544$export$fc3e7e8557f8c8c7 = $bccd0254996c4544$var$secondsToMilliseconds;

var $briB4 = parcelRequire("briB4");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $bccd0254996c4544$var$secondsToMilliseconds(seconds) {
    return seconds * $briB4.millisecondsInSecond;
}

});

parcelRegister("hdvEC", function(module, exports) {

$parcel$export(module.exports, "secondsToMinutes", () => $c88c346e362dfbe8$export$ed657adb62398e99, (v) => $c88c346e362dfbe8$export$ed657adb62398e99 = v);
var $c88c346e362dfbe8$export$ed657adb62398e99;
"use strict";
$c88c346e362dfbe8$export$ed657adb62398e99 = $c88c346e362dfbe8$var$secondsToMinutes;

var $briB4 = parcelRequire("briB4");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $c88c346e362dfbe8$var$secondsToMinutes(seconds) {
    const minutes = seconds / $briB4.secondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("jYMLq", function(module, exports) {

$parcel$export(module.exports, "set", () => $e8b97269a8745db5$export$adaa4cf7ef1b65be, (v) => $e8b97269a8745db5$export$adaa4cf7ef1b65be = v);
var $e8b97269a8745db5$export$adaa4cf7ef1b65be;
"use strict";
$e8b97269a8745db5$export$adaa4cf7ef1b65be = $e8b97269a8745db5$var$set;

var $eK5z7 = parcelRequire("eK5z7");

var $1VSw7 = parcelRequire("1VSw7");

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $e8b97269a8745db5$var$set(date, values) {
    let _date = (0, $30SVQ.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $eK5z7.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $1VSw7.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});

parcelRegister("jD0I3", function(module, exports) {

$parcel$export(module.exports, "setDate", () => $e4a235b7a447c4f0$export$566174fa40823587, (v) => $e4a235b7a447c4f0$export$566174fa40823587 = v);
var $e4a235b7a447c4f0$export$566174fa40823587;
"use strict";
$e4a235b7a447c4f0$export$566174fa40823587 = $e4a235b7a447c4f0$var$setDate;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $e4a235b7a447c4f0$var$setDate(date, dayOfMonth) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

});

parcelRegister("2UgVu", function(module, exports) {

$parcel$export(module.exports, "setDayOfYear", () => $21ddf0eaefea752e$export$2af590ffc7e7d7c5, (v) => $21ddf0eaefea752e$export$2af590ffc7e7d7c5 = v);
var $21ddf0eaefea752e$export$2af590ffc7e7d7c5;
"use strict";
$21ddf0eaefea752e$export$2af590ffc7e7d7c5 = $21ddf0eaefea752e$var$setDayOfYear;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $21ddf0eaefea752e$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}

});

parcelRegister("5EwcB", function(module, exports) {

$parcel$export(module.exports, "setDefaultOptions", () => $41d9aae4fa20420d$export$95365be1b0704abc, (v) => $41d9aae4fa20420d$export$95365be1b0704abc = v);
var $41d9aae4fa20420d$export$95365be1b0704abc;
"use strict";
$41d9aae4fa20420d$export$95365be1b0704abc = $41d9aae4fa20420d$var$setDefaultOptions;

var $4UP3S = parcelRequire("4UP3S");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $41d9aae4fa20420d$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $4UP3S.setDefaultOptions)(result);
}

});

parcelRegister("iOqGj", function(module, exports) {

$parcel$export(module.exports, "setMilliseconds", () => $db2197e0fa774070$export$de5664029b35e06d, (v) => $db2197e0fa774070$export$de5664029b35e06d = v);
var $db2197e0fa774070$export$de5664029b35e06d;
"use strict";
$db2197e0fa774070$export$de5664029b35e06d = $db2197e0fa774070$var$setMilliseconds;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $db2197e0fa774070$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $30SVQ.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

});

parcelRegister("hQXT4", function(module, exports) {

$parcel$export(module.exports, "setWeekYear", () => $cff5bf5fa0193e74$export$4340968d5939835e, (v) => $cff5bf5fa0193e74$export$4340968d5939835e = v);
var $cff5bf5fa0193e74$export$4340968d5939835e;
"use strict";
$cff5bf5fa0193e74$export$4340968d5939835e = $cff5bf5fa0193e74$var$setWeekYear;

var $eK5z7 = parcelRequire("eK5z7");

var $9UMYl = parcelRequire("9UMYl");

var $eO0Fp = parcelRequire("eO0Fp");

var $30SVQ = parcelRequire("30SVQ");

var $4UP3S = parcelRequire("4UP3S");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $cff5bf5fa0193e74$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $4UP3S.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $30SVQ.toDate)(date);
    const diff = (0, $9UMYl.differenceInCalendarDays)(_date, (0, $eO0Fp.startOfWeekYear)(_date, options));
    const firstWeek = (0, $eK5z7.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $eO0Fp.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});

parcelRegister("3q4Cu", function(module, exports) {

$parcel$export(module.exports, "startOfDecade", () => $27d7623072841c9e$export$730492981c634308, (v) => $27d7623072841c9e$export$730492981c634308 = v);
var $27d7623072841c9e$export$730492981c634308;
"use strict";
$27d7623072841c9e$export$730492981c634308 = $27d7623072841c9e$var$startOfDecade;

var $30SVQ = parcelRequire("30SVQ");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $27d7623072841c9e$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $30SVQ.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("2uWPY", function(module, exports) {

$parcel$export(module.exports, "startOfToday", () => $1d1c05f420cd3819$export$444d742fd5a45a57, (v) => $1d1c05f420cd3819$export$444d742fd5a45a57 = v);
var $1d1c05f420cd3819$export$444d742fd5a45a57;
"use strict";
$1d1c05f420cd3819$export$444d742fd5a45a57 = $1d1c05f420cd3819$var$startOfToday;

var $fH0a1 = parcelRequire("fH0a1");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $1d1c05f420cd3819$var$startOfToday() {
    return (0, $fH0a1.startOfDay)(Date.now());
}

});

parcelRegister("hymmX", function(module, exports) {

$parcel$export(module.exports, "startOfTomorrow", () => $cc76f6b1bb5f55ce$export$7e8566c79d5bee07, (v) => $cc76f6b1bb5f55ce$export$7e8566c79d5bee07 = v);
var $cc76f6b1bb5f55ce$export$7e8566c79d5bee07;
"use strict";
$cc76f6b1bb5f55ce$export$7e8566c79d5bee07 = $cc76f6b1bb5f55ce$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $cc76f6b1bb5f55ce$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("hDUcR", function(module, exports) {

$parcel$export(module.exports, "startOfYesterday", () => $cd81ad9ec468f6b4$export$23a16f3c6d143ce9, (v) => $cd81ad9ec468f6b4$export$23a16f3c6d143ce9 = v);
var $cd81ad9ec468f6b4$export$23a16f3c6d143ce9;
"use strict";
$cd81ad9ec468f6b4$export$23a16f3c6d143ce9 = $cd81ad9ec468f6b4$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $cd81ad9ec468f6b4$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("ayi8B", function(module, exports) {

$parcel$export(module.exports, "sub", () => $7aeb261fe061928a$export$f93b5905241a7cca, (v) => $7aeb261fe061928a$export$f93b5905241a7cca = v);
var $7aeb261fe061928a$export$f93b5905241a7cca;
"use strict";
$7aeb261fe061928a$export$f93b5905241a7cca = $7aeb261fe061928a$var$sub;

var $5N9HD = parcelRequire("5N9HD");

var $gZrcY = parcelRequire("gZrcY");

var $eK5z7 = parcelRequire("eK5z7");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $7aeb261fe061928a$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $gZrcY.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $5N9HD.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $eK5z7.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});

parcelRegister("5byfF", function(module, exports) {

$parcel$export(module.exports, "subBusinessDays", () => $3c688c7c0e30b622$export$e5cc51ae28664a93, (v) => $3c688c7c0e30b622$export$e5cc51ae28664a93 = v);
var $3c688c7c0e30b622$export$e5cc51ae28664a93;
"use strict";
$3c688c7c0e30b622$export$e5cc51ae28664a93 = $3c688c7c0e30b622$var$subBusinessDays;

var $4J4yL = parcelRequire("4J4yL");
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $3c688c7c0e30b622$var$subBusinessDays(date, amount) {
    return (0, $4J4yL.addBusinessDays)(date, -amount);
}

});

parcelRegister("gE1IM", function(module, exports) {

$parcel$export(module.exports, "subHours", () => $c1e1b7960398f22a$export$5e9fa51cd5bb1e71, (v) => $c1e1b7960398f22a$export$5e9fa51cd5bb1e71 = v);
var $c1e1b7960398f22a$export$5e9fa51cd5bb1e71;
"use strict";
$c1e1b7960398f22a$export$5e9fa51cd5bb1e71 = $c1e1b7960398f22a$var$subHours;

var $iMX5A = parcelRequire("iMX5A");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $c1e1b7960398f22a$var$subHours(date, amount) {
    return (0, $iMX5A.addHours)(date, -amount);
}

});

parcelRegister("dtBkY", function(module, exports) {

$parcel$export(module.exports, "subMilliseconds", () => $9cfaf2369322ee51$export$5abaf57ab8e91640, (v) => $9cfaf2369322ee51$export$5abaf57ab8e91640 = v);
var $9cfaf2369322ee51$export$5abaf57ab8e91640;
"use strict";
$9cfaf2369322ee51$export$5abaf57ab8e91640 = $9cfaf2369322ee51$var$subMilliseconds;

var $dR7TY = parcelRequire("dR7TY");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $9cfaf2369322ee51$var$subMilliseconds(date, amount) {
    return (0, $dR7TY.addMilliseconds)(date, -amount);
}

});

parcelRegister("euayu", function(module, exports) {

$parcel$export(module.exports, "subMinutes", () => $a8bc0e11c60ff399$export$e12a970efb73fce5, (v) => $a8bc0e11c60ff399$export$e12a970efb73fce5 = v);
var $a8bc0e11c60ff399$export$e12a970efb73fce5;
"use strict";
$a8bc0e11c60ff399$export$e12a970efb73fce5 = $a8bc0e11c60ff399$var$subMinutes;

var $jZtIs = parcelRequire("jZtIs");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $a8bc0e11c60ff399$var$subMinutes(date, amount) {
    return (0, $jZtIs.addMinutes)(date, -amount);
}

});

parcelRegister("eT420", function(module, exports) {

$parcel$export(module.exports, "subSeconds", () => $ad6954495f71f731$export$e95d8ad9981db689, (v) => $ad6954495f71f731$export$e95d8ad9981db689 = v);
var $ad6954495f71f731$export$e95d8ad9981db689;
"use strict";
$ad6954495f71f731$export$e95d8ad9981db689 = $ad6954495f71f731$var$subSeconds;

var $kiEfO = parcelRequire("kiEfO");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $ad6954495f71f731$var$subSeconds(date, amount) {
    return (0, $kiEfO.addSeconds)(date, -amount);
}

});

parcelRegister("lK1AJ", function(module, exports) {

$parcel$export(module.exports, "weeksToDays", () => $fd3f20e3d132724e$export$b696b6eeb89501ad, (v) => $fd3f20e3d132724e$export$b696b6eeb89501ad = v);
var $fd3f20e3d132724e$export$b696b6eeb89501ad;
"use strict";
$fd3f20e3d132724e$export$b696b6eeb89501ad = $fd3f20e3d132724e$var$weeksToDays;

var $briB4 = parcelRequire("briB4");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $fd3f20e3d132724e$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $briB4.daysInWeek);
}

});

parcelRegister("9l7S6", function(module, exports) {

$parcel$export(module.exports, "yearsToDays", () => $6ccc2e60f33c92b2$export$862cb7b6e45c3b17, (v) => $6ccc2e60f33c92b2$export$862cb7b6e45c3b17 = v);
var $6ccc2e60f33c92b2$export$862cb7b6e45c3b17;
"use strict";
$6ccc2e60f33c92b2$export$862cb7b6e45c3b17 = $6ccc2e60f33c92b2$var$yearsToDays;

var $briB4 = parcelRequire("briB4");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $6ccc2e60f33c92b2$var$yearsToDays(years) {
    return Math.trunc(years * $briB4.daysInYear);
}

});

parcelRegister("eiL7j", function(module, exports) {

$parcel$export(module.exports, "yearsToMonths", () => $a6974b8bd1359f14$export$894abb0747b9a00, (v) => $a6974b8bd1359f14$export$894abb0747b9a00 = v);
var $a6974b8bd1359f14$export$894abb0747b9a00;
"use strict";
$a6974b8bd1359f14$export$894abb0747b9a00 = $a6974b8bd1359f14$var$yearsToMonths;

var $briB4 = parcelRequire("briB4");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $a6974b8bd1359f14$var$yearsToMonths(years) {
    return Math.trunc(years * $briB4.monthsInYear);
}

});

parcelRegister("18DXO", function(module, exports) {

$parcel$export(module.exports, "yearsToQuarters", () => $0d4589c309e08ad6$export$ab26576e5e7379d7, (v) => $0d4589c309e08ad6$export$ab26576e5e7379d7 = v);
var $0d4589c309e08ad6$export$ab26576e5e7379d7;
"use strict";
$0d4589c309e08ad6$export$ab26576e5e7379d7 = $0d4589c309e08ad6$var$yearsToQuarters;

var $briB4 = parcelRequire("briB4");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $0d4589c309e08ad6$var$yearsToQuarters(years) {
    return Math.trunc(years * $briB4.quartersInYear);
}

});


parcelRegister("hL3CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", () => $ced9a37f3aaca250$export$e2911fc69bd3195e);
$parcel$export(module.exports, "default", () => $ced9a37f3aaca250$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $ced9a37f3aaca250$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ced9a37f3aaca250$var$_setPrototypeOf(subClass, superClass);
}
function $ced9a37f3aaca250$var$_setPrototypeOf(o, p) {
    $ced9a37f3aaca250$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ced9a37f3aaca250$var$_setPrototypeOf(o, p);
}
function $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ced9a37f3aaca250$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $ced9a37f3aaca250$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $ced9a37f3aaca250$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $ced9a37f3aaca250$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    var passive = false;
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener("testPassiveEventSupport", noop, options);
    window.removeEventListener("testPassiveEventSupport", noop, options);
    return passive;
};
function $ced9a37f3aaca250$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $ced9a37f3aaca250$var$uid = $ced9a37f3aaca250$var$autoInc();
var $ced9a37f3aaca250$var$passiveEventSupport;
var $ced9a37f3aaca250$var$handlersMap = {};
var $ced9a37f3aaca250$var$enabledInstances = {};
var $ced9a37f3aaca250$var$touchEvents = [
    "touchstart",
    "touchmove"
];
var $ced9a37f3aaca250$export$e2911fc69bd3195e = "ignore-react-onclickoutside";
/**
 * Options for addEventHandler and removeEventHandler
 */ function $ced9a37f3aaca250$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = $ced9a37f3aaca250$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $ced9a37f3aaca250$var$passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $ced9a37f3aaca250$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $ced9a37f3aaca250$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === "function") {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === "function") {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === "function") {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === "function") return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === "function") return instance.setClickOutsideRef();
                return (0, $1u0KT.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === "undefined" || $ced9a37f3aaca250$var$enabledInstances[_this._uid]) return;
                if (typeof $ced9a37f3aaca250$var$passiveEventSupport === "undefined") $ced9a37f3aaca250$var$passiveEventSupport = $ced9a37f3aaca250$var$testPassiveEventSupport();
                $ced9a37f3aaca250$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $ced9a37f3aaca250$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $ced9a37f3aaca250$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($ced9a37f3aaca250$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $ced9a37f3aaca250$var$handlersMap[_this._uid], $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $ced9a37f3aaca250$var$enabledInstances[_this._uid];
                var fn = $ced9a37f3aaca250$var$handlersMap[_this._uid];
                if (fn && typeof document !== "undefined") {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $ced9a37f3aaca250$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $ced9a37f3aaca250$var$uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === "undefined" || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === "function") {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== "function") throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $acw62.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $acw62.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $ced9a37f3aaca250$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $ced9a37f3aaca250$export$2e2bcd8739ae039 = $ced9a37f3aaca250$var$onClickOutsideHOC;

});

parcelRegister("5rxG7", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $3f69993268aa5b7a$export$74665b213cb5c4cf);
$parcel$export(module.exports, "FloatingList", () => $3f69993268aa5b7a$export$ffe15b0e64951704);
$parcel$export(module.exports, "useListItem", () => $3f69993268aa5b7a$export$dcdc7ff5149f7d1a);
$parcel$export(module.exports, "Composite", () => $3f69993268aa5b7a$export$43586241d9db0c6d);
$parcel$export(module.exports, "CompositeItem", () => $3f69993268aa5b7a$export$ef1ef7a3a43ace8e);
$parcel$export(module.exports, "useId", () => $3f69993268aa5b7a$export$f680877a34711e37);
$parcel$export(module.exports, "FloatingArrow", () => $3f69993268aa5b7a$export$33511391554732bc);
$parcel$export(module.exports, "useFloatingParentNodeId", () => $3f69993268aa5b7a$export$165209eae06d3488);
$parcel$export(module.exports, "useFloatingTree", () => $3f69993268aa5b7a$export$db0c2a7c7a2a4f69);
$parcel$export(module.exports, "useFloatingNodeId", () => $3f69993268aa5b7a$export$9b136e0e758a42f4);
$parcel$export(module.exports, "FloatingNode", () => $3f69993268aa5b7a$export$ca00a83b5b253862);
$parcel$export(module.exports, "FloatingTree", () => $3f69993268aa5b7a$export$587b60129641c4c8);
$parcel$export(module.exports, "useHover", () => $3f69993268aa5b7a$export$ae780daf29e6d456);
$parcel$export(module.exports, "useDelayGroupContext", () => $3f69993268aa5b7a$export$e2411914b150383d);
$parcel$export(module.exports, "FloatingDelayGroup", () => $3f69993268aa5b7a$export$718279509ff1e241);
$parcel$export(module.exports, "useDelayGroup", () => $3f69993268aa5b7a$export$560fc8be89c8b4a8);
$parcel$export(module.exports, "useFloatingPortalNode", () => $3f69993268aa5b7a$export$ac107512f3c5cca6);
$parcel$export(module.exports, "FloatingPortal", () => $3f69993268aa5b7a$export$31fa5d718fa2ac09);
$parcel$export(module.exports, "FloatingFocusManager", () => $3f69993268aa5b7a$export$8aeee49171ded61a);
$parcel$export(module.exports, "FloatingOverlay", () => $3f69993268aa5b7a$export$a35954495955337b);
$parcel$export(module.exports, "useClick", () => $3f69993268aa5b7a$export$98524f11226063fc);
$parcel$export(module.exports, "useClientPoint", () => $3f69993268aa5b7a$export$7fe170a73a621816);
$parcel$export(module.exports, "useDismiss", () => $3f69993268aa5b7a$export$fcdf1ba5fafc089b);
$parcel$export(module.exports, "useFloatingRootContext", () => $3f69993268aa5b7a$export$1df81146f8ad8e4c);
$parcel$export(module.exports, "useFloating", () => $3f69993268aa5b7a$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useFocus", () => $3f69993268aa5b7a$export$f8168d8dd8fd66e6);
$parcel$export(module.exports, "useInteractions", () => $3f69993268aa5b7a$export$a519f7794e446ddd);
$parcel$export(module.exports, "useListNavigation", () => $3f69993268aa5b7a$export$b5d22cac4ad33f40);
$parcel$export(module.exports, "useRole", () => $3f69993268aa5b7a$export$f66572793fa256a1);
$parcel$export(module.exports, "useTransitionStatus", () => $3f69993268aa5b7a$export$b2ef21706733f7e5);
$parcel$export(module.exports, "useTransitionStyles", () => $3f69993268aa5b7a$export$769fba13884bc2f4);
$parcel$export(module.exports, "useTypeahead", () => $3f69993268aa5b7a$export$d8d674d50b73ba93);
$parcel$export(module.exports, "inner", () => $3f69993268aa5b7a$export$4ae363f1d88fb658);
$parcel$export(module.exports, "useInnerOffset", () => $3f69993268aa5b7a$export$3d74b0dda7cc82ff);
$parcel$export(module.exports, "safePolygon", () => $3f69993268aa5b7a$export$7484214ab62358d2);
$parcel$export(module.exports, "arrow", () => (parcelRequire("33OG6")).arrow);
$parcel$export(module.exports, "autoPlacement", () => (parcelRequire("618j3")).autoPlacement);
$parcel$export(module.exports, "autoUpdate", () => (parcelRequire("618j3")).autoUpdate);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("618j3")).computePosition);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("618j3")).detectOverflow);
$parcel$export(module.exports, "flip", () => (parcelRequire("618j3")).flip);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("33bLr")).getOverflowAncestors);
$parcel$export(module.exports, "hide", () => (parcelRequire("618j3")).hide);
$parcel$export(module.exports, "inline", () => (parcelRequire("618j3")).inline);
$parcel$export(module.exports, "limitShift", () => (parcelRequire("618j3")).limitShift);
$parcel$export(module.exports, "offset", () => (parcelRequire("618j3")).offset);
$parcel$export(module.exports, "platform", () => (parcelRequire("618j3")).platform);
$parcel$export(module.exports, "shift", () => (parcelRequire("618j3")).shift);
$parcel$export(module.exports, "size", () => (parcelRequire("618j3")).size);

var $acw62 = parcelRequire("acw62");

var $4wHOx = parcelRequire("4wHOx");

var $1obCQ = parcelRequire("1obCQ");

var $33OG6 = parcelRequire("33OG6");
var $618j3 = parcelRequire("618j3");
var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");

var $33bLr = parcelRequire("33bLr");

var $e8HHX = parcelRequire("e8HHX");

var $1u0KT = parcelRequire("1u0KT");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $3f69993268aa5b7a$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $3f69993268aa5b7a$var$SafeReact = {
    ...$acw62
};
const $3f69993268aa5b7a$var$useInsertionEffect = $3f69993268aa5b7a$var$SafeReact.useInsertionEffect;
const $3f69993268aa5b7a$var$useSafeInsertionEffect = $3f69993268aa5b7a$var$useInsertionEffect || ((fn)=>fn());
function $3f69993268aa5b7a$var$useEffectEvent(callback) {
    const ref = $acw62.useRef(()=>{});
    $3f69993268aa5b7a$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $3f69993268aa5b7a$var$ARROW_UP = "ArrowUp";
const $3f69993268aa5b7a$var$ARROW_DOWN = "ArrowDown";
const $3f69993268aa5b7a$var$ARROW_LEFT = "ArrowLeft";
const $3f69993268aa5b7a$var$ARROW_RIGHT = "ArrowRight";
function $3f69993268aa5b7a$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    const isDisabledIndex = disabledIndices ? (index)=>disabledIndices.includes(index) : (index)=>{
        const element = list[index];
        return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
    };
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && isDisabledIndex(index));
    return index;
}
function $3f69993268aa5b7a$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $3f69993268aa5b7a$var$ARROW_UP) {
        stop && (0, $4wHOx.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $3f69993268aa5b7a$var$ARROW_DOWN) {
        stop && (0, $4wHOx.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $1obCQ.floor)(prevIndex / cols);
        if (event.key === $3f69993268aa5b7a$var$ARROW_RIGHT) {
            stop && (0, $4wHOx.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $3f69993268aa5b7a$var$ARROW_LEFT) {
            stop && (0, $4wHOx.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices,
                    decrement: true
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $1obCQ.floor)(maxIndex / cols) === prevRow;
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $3f69993268aa5b7a$var$ARROW_LEFT ? maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $3f69993268aa5b7a$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            return firstCellIndex + sizes[index].width - 1;
        case "bl":
            return firstCellIndex + (sizes[index].height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $3f69993268aa5b7a$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
let $3f69993268aa5b7a$var$rafId = 0;
function $3f69993268aa5b7a$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($3f69993268aa5b7a$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $3f69993268aa5b7a$var$rafId = requestAnimationFrame(exec);
}
var $3f69993268aa5b7a$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $3f69993268aa5b7a$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $3f69993268aa5b7a$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $3f69993268aa5b7a$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $3f69993268aa5b7a$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $acw62.useState(()=>new Map());
    const register = $acw62.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($3f69993268aa5b7a$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$3f69993268aa5b7a$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $3f69993268aa5b7a$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($3f69993268aa5b7a$var$FloatingListContext);
    const [index$1, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $3f69993268aa5b7a$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $acw62.cloneElement(render, computedProps);
    return /*#__PURE__*/ $acw62.createElement("div", computedProps);
}
const $3f69993268aa5b7a$var$CompositeContext = /*#__PURE__*/ $acw62.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $3f69993268aa5b7a$var$horizontalKeys = [
    $3f69993268aa5b7a$var$ARROW_LEFT,
    $3f69993268aa5b7a$var$ARROW_RIGHT
];
const $3f69993268aa5b7a$var$verticalKeys = [
    $3f69993268aa5b7a$var$ARROW_UP,
    $3f69993268aa5b7a$var$ARROW_DOWN
];
const $3f69993268aa5b7a$var$allKeys = [
    ...$3f69993268aa5b7a$var$horizontalKeys,
    ...$3f69993268aa5b7a$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$43586241d9db0c6d = /*#__PURE__*/ $acw62.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = "both", loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices = [], activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $acw62.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $acw62.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $acw62.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$3f69993268aa5b7a$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !disabledIndices.includes(index));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(disabledIndices != null && disabledIndices.includes(index)) ? cellIndex : foundIndex, -1);
            nextIndex = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                    ...disabledIndices,
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? "bl" : event.key === $3f69993268aa5b7a$var$ARROW_RIGHT ? "tr" : "tl")
            })]; // navigated cell will never be nullish
        }
        const minIndex = $3f69993268aa5b7a$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(elementsRef, disabledIndices);
        const toEndKeys = {
            horizontal: [
                $3f69993268aa5b7a$var$ARROW_RIGHT
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_DOWN
            ],
            both: [
                $3f69993268aa5b7a$var$ARROW_RIGHT,
                $3f69993268aa5b7a$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $3f69993268aa5b7a$var$ARROW_LEFT
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_UP
            ],
            both: [
                $3f69993268aa5b7a$var$ARROW_LEFT,
                $3f69993268aa5b7a$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $3f69993268aa5b7a$var$allKeys : ({
            horizontal: $3f69993268aa5b7a$var$horizontalKeys,
            vertical: $3f69993268aa5b7a$var$verticalKeys,
            both: $3f69993268aa5b7a$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $3f69993268aa5b7a$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $3f69993268aa5b7a$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $acw62.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $acw62.useContext($3f69993268aa5b7a$var$CompositeContext);
    const { ref: ref, index: index } = $3f69993268aa5b7a$export$dcdc7ff5149f7d1a();
    const mergedRef = $3f69993268aa5b7a$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $3f69993268aa5b7a$var$renderJsx(render, computedProps);
});
function $3f69993268aa5b7a$var$_extends() {
    $3f69993268aa5b7a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f69993268aa5b7a$var$_extends.apply(this, arguments);
}
let $3f69993268aa5b7a$var$serverHandoffComplete = false;
let $3f69993268aa5b7a$var$count = 0;
const $3f69993268aa5b7a$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $3f69993268aa5b7a$var$count++;
function $3f69993268aa5b7a$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$3f69993268aa5b7a$var$serverHandoffComplete ? $3f69993268aa5b7a$var$genId() : undefined);
    $3f69993268aa5b7a$var$index(()=>{
        if (id == null) setId($3f69993268aa5b7a$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        $3f69993268aa5b7a$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $3f69993268aa5b7a$var$useReactId = $3f69993268aa5b7a$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $3f69993268aa5b7a$export$f680877a34711e37 = $3f69993268aa5b7a$var$useReactId || $3f69993268aa5b7a$var$useFloatingId;
let $3f69993268aa5b7a$var$devMessageSet;
function $3f69993268aa5b7a$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $3f69993268aa5b7a$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $3f69993268aa5b7a$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $3f69993268aa5b7a$export$f680877a34711e37();
    if (!floating) return null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const [side, alignment] = placement.split("-");
    const isRTL = (0, $618j3.platform).isRTL(floating);
    const isCustomShape = !!d;
    const isVerticalSide = side === "top" || side === "bottom";
    const yOffsetProp = staticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = staticOffset && alignment === "end" ? "right" : "left";
    if (staticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $acw62.createElement("svg", $3f69993268aa5b7a$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: "" + rotation + (transform != null ? transform : ""),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $acw62.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $3f69993268aa5b7a$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $3f69993268aa5b7a$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $3f69993268aa5b7a$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($3f69993268aa5b7a$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $3f69993268aa5b7a$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$9b136e0e758a42f4(customParentId) {
    const id = $3f69993268aa5b7a$export$f680877a34711e37();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const reactParentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $3f69993268aa5b7a$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $3f69993268aa5b7a$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $3f69993268aa5b7a$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $3f69993268aa5b7a$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $3f69993268aa5b7a$var$safePolygonIdentifier = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("safe-polygon");
function $3f69993268aa5b7a$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $4wHOx.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $3f69993268aa5b7a$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: { domReference: domReference, floating: floating } } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const handleCloseRef = $3f69993268aa5b7a$var$useLatestRef(handleClose);
    const delayRef = $3f69993268aa5b7a$var$useLatestRef(delay);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled || !handleCloseRef.current || !open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $4wHOx.getDocument)(floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $4wHOx.getDocument)(floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($3f69993268aa5b7a$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$3f69993268aa5b7a$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                onOpenChange(true, event, "hover");
            }, openDelay);
            else onOpenChange(true, event, "hover");
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $4wHOx.getDocument)(floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $4wHOx.contains)(floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $33bLr.isElement)(domReference)) {
            const ref = domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            floating == null || floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                floating == null || floating.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        domReference,
        floating,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $3f69993268aa5b7a$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            const body = (0, $4wHOx.getDocument)(floating).body;
            body.setAttribute($3f69993268aa5b7a$var$safePolygonIdentifier, "");
            body.style.pointerEvents = "none";
            performedPointerEventsMutationRef.current = true;
            if ((0, $33bLr.isElement)(domReference) && floating) {
                var _tree$nodesRef$curren;
                const ref = domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                ref.style.pointerEvents = "auto";
                floating.style.pointerEvents = "auto";
                return ()=>{
                    ref.style.pointerEvents = "";
                    floating.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        floating,
        domReference,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            reference: {
                onPointerDown: setPointerRef,
                onPointerEnter: setPointerRef,
                onMouseMove (event) {
                    function handleMouseMove() {
                        if (!blockMouseMoveRef.current) onOpenChange(true, event.nativeEvent, "hover");
                    }
                    if (mouseOnly && !(0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current)) return;
                    if (open || restMs === 0) return;
                    clearTimeout(restTimeoutRef.current);
                    if (pointerTypeRef.current === "touch") handleMouseMove();
                    else restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            },
            floating: {
                onMouseEnter () {
                    clearTimeout(timeoutRef.current);
                },
                onMouseLeave (event) {
                    closeWithDelay(event.nativeEvent, false);
                }
            }
        };
    }, [
        enabled,
        mouseOnly,
        open,
        restMs,
        onOpenChange,
        closeWithDelay
    ]);
}
const $3f69993268aa5b7a$var$NOOP = ()=>{};
const $3f69993268aa5b7a$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $3f69993268aa5b7a$var$NOOP,
    setState: $3f69993268aa5b7a$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $3f69993268aa5b7a$export$e2411914b150383d = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else setState({
                isInstantPhase: true
            });
        } else {
            setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $3f69993268aa5b7a$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $3f69993268aa5b7a$var$index(()=>{
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $3f69993268aa5b7a$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (setCurrentId === $3f69993268aa5b7a$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $3f69993268aa5b7a$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3f69993268aa5b7a$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $3f69993268aa5b7a$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $3f69993268aa5b7a$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $3f69993268aa5b7a$var$counterMap = /*#__PURE__*/ new WeakMap();
let $3f69993268aa5b7a$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $3f69993268aa5b7a$var$markerMap = {};
let $3f69993268aa5b7a$var$lockCount = 0;
const $3f69993268aa5b7a$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const $3f69993268aa5b7a$var$unwrapHost = (node)=>node && (node.host || $3f69993268aa5b7a$var$unwrapHost(node.parentNode));
const $3f69993268aa5b7a$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $3f69993268aa5b7a$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $3f69993268aa5b7a$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $3f69993268aa5b7a$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$3f69993268aa5b7a$var$markerMap[markerName]) $3f69993268aa5b7a$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $3f69993268aa5b7a$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, (node)=>{
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterValue = ($3f69993268aa5b7a$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $3f69993268aa5b7a$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $3f69993268aa5b7a$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    $3f69993268aa5b7a$var$lockCount++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($3f69993268aa5b7a$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $3f69993268aa5b7a$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$3f69993268aa5b7a$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $3f69993268aa5b7a$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $3f69993268aa5b7a$var$lockCount--;
        if (!$3f69993268aa5b7a$var$lockCount) {
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$uncontrolledElementsSet = new WeakSet();
            $3f69993268aa5b7a$var$markerMap = {};
        }
    };
}
function $3f69993268aa5b7a$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $4wHOx.getDocument)(avoidElements[0]).body;
    return $3f69993268aa5b7a$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const $3f69993268aa5b7a$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $3f69993268aa5b7a$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $3f69993268aa5b7a$var$getNextTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "next");
}
function $3f69993268aa5b7a$var$getPreviousTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "prev");
}
function $3f69993268aa5b7a$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $4wHOx.contains)(containerElement, relatedTarget);
}
function $3f69993268aa5b7a$var$disableFocusInside(container) {
    const tabbableElements = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $3f69993268aa5b7a$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $3f69993268aa5b7a$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $3f69993268aa5b7a$var$timeoutId;
function $3f69993268aa5b7a$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($3f69993268aa5b7a$var$timeoutId);
    }
}
const $3f69993268aa5b7a$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    $3f69993268aa5b7a$var$index(()=>{
        if ((0, $4wHOx.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$3f69993268aa5b7a$var$createAttribute("focus-guard")]: "",
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $acw62.createElement("span", $3f69993268aa5b7a$var$_extends({}, props, restProps));
});
const $3f69993268aa5b7a$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$attr = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $3f69993268aa5b7a$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $3f69993268aa5b7a$export$f680877a34711e37();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    $3f69993268aa5b7a$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $33bLr.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $3f69993268aa5b7a$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $3f69993268aa5b7a$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $3f69993268aa5b7a$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $3f69993268aa5b7a$var$enableFocusInside : $3f69993268aa5b7a$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        focusManagerState == null ? void 0 : focusManagerState.modal
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ (0, $1u0KT.createPortal)(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent));
            }
        }
    }));
}
const $3f69993268aa5b7a$var$usePortalContext = ()=>$acw62.useContext($3f69993268aa5b7a$var$PortalContext);
const $3f69993268aa5b7a$var$LIST_LIMIT = 20;
let $3f69993268aa5b7a$var$previouslyFocusedElements = [];
function $3f69993268aa5b7a$var$addPreviouslyFocusedElement(element) {
    $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $33bLr.getNodeName)(tabbableEl) === "body") return;
    if (!(0, $e8HHX.isTabbable)(tabbableEl, $3f69993268aa5b7a$var$getTabbableOptions())) {
        const tabbableChild = (0, $e8HHX.tabbable)(tabbableEl, $3f69993268aa5b7a$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $3f69993268aa5b7a$var$previouslyFocusedElements.push(tabbableEl);
    if ($3f69993268aa5b7a$var$previouslyFocusedElements.length > $3f69993268aa5b7a$var$LIST_LIMIT) $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.slice(-$3f69993268aa5b7a$var$LIST_LIMIT);
}
function $3f69993268aa5b7a$var$getPreviouslyFocusedElement() {
    return $3f69993268aa5b7a$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $3f69993268aa5b7a$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("button", $3f69993268aa5b7a$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $3f69993268aa5b7a$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $4wHOx.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $3f69993268aa5b7a$var$supportsInert() ? _guards : true;
    const orderRef = $3f69993268aa5b7a$var$useLatestRef(order);
    const initialFocusRef = $3f69993268aa5b7a$var$useLatestRef(initialFocus);
    const returnFocusRef = $3f69993268aa5b7a$var$useLatestRef(returnFocus);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const isInsidePortal = portalContext != null;
    const getTabbableContent = $acw62.useCallback(function(container) {
        if (container === void 0) container = floating;
        return container ? (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions()) : [];
    }, [
        floating
    ]);
    const getTabbableElements = $acw62.useCallback((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floating && type === "floating") return floating;
            return content;
        }).filter(Boolean).flat();
    }, [
        domReference,
        floating,
        orderRef,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled || !modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $4wHOx.contains)(floating, (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floating))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $4wHOx.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $4wHOx.getTarget)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $4wHOx.stopEvent)(event);
                    if (event.shiftKey) $3f69993268aa5b7a$var$enqueueFocus(els[els.length - 1]);
                    else $3f69993268aa5b7a$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floating && event.shiftKey) {
                    (0, $4wHOx.stopEvent)(event);
                    $3f69993268aa5b7a$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $4wHOx.getDocument)(floating);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled || !closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $4wHOx.contains)(domReference, relatedTarget) || (0, $4wHOx.contains)(floating, relatedTarget) || (0, $4wHOx.contains)(relatedTarget, floating) || (0, $4wHOx.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) || tree && ($3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $4wHOx.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $4wHOx.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $3f69993268aa5b7a$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $3f69993268aa5b7a$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event);
                }
            });
        }
        if (floating && (0, $33bLr.isHTMLElement)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            !modal && floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                !modal && floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $3f69993268aa5b7a$var$createAttribute("portal") + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $3f69993268aa5b7a$var$markOthers(insideElements, guards, !guards) : $3f69993268aa5b7a$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floating) return;
        const doc = (0, $4wHOx.getDocument)(floating);
        const previouslyFocusedElement = (0, $4wHOx.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floating);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
            const focusAlreadyInsideFloatingEl = (0, $4wHOx.contains)(floating, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $3f69993268aa5b7a$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floating
            });
        });
    }, [
        disabled,
        open,
        floating,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floating) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $4wHOx.getDocument)(floating);
        const previouslyFocusedElement = (0, $4wHOx.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $3f69993268aa5b7a$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $4wHOx.isVirtualClick)(event) || (0, $4wHOx.isVirtualPointerEvent)(event));
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $4wHOx.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $4wHOx.contains)(floating, activeEl) || tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $4wHOx.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = $3f69993268aa5b7a$var$getPreviouslyFocusedElement();
            if (// eslint-disable-next-line react-hooks/exhaustive-deps
            returnFocusRef.current && !preventReturnFocusRef.current && (0, $33bLr.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
            // since it likely entered a different element which should be
            // respected: https://github.com/floating-ui/floating-ui/issues/2607
            (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) $3f69993268aa5b7a$var$enqueueFocus(returnElement, {
                // When dismissing nested floating elements, by the time the rAF has
                // executed, the menus will all have been unmounted. When they try
                // to get focused, the calls get ignored — leaving the root
                // reference focused as desired.
                cancelPrevious: false,
                preventScroll: preventReturnFocusScroll
            });
        };
    }, [
        disabled,
        floating,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floating || typeof MutationObserver !== "function" || ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floating.getAttribute("tabindex");
            if (orderRef.current.includes("floating") || (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
                if (tabIndex !== "0") floating.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floating.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floating, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && (isInsidePortal || modal);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $3f69993268aa5b7a$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $3f69993268aa5b7a$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
const $3f69993268aa5b7a$var$activeLocks = /*#__PURE__*/ new Set();
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $3f69993268aa5b7a$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    const lockId = $3f69993268aa5b7a$export$f680877a34711e37();
    $3f69993268aa5b7a$var$index(()=>{
        if (!lockScroll) return;
        $3f69993268aa5b7a$var$activeLocks.add(lockId);
        const isIOS = /iP(hone|ad|od)|iOS/.test((0, $4wHOx.getPlatform)());
        const bodyStyle = document.body.style;
        // RTL <body> scrollbar
        const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.pageXOffset;
        const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.pageYOffset;
        bodyStyle.overflow = "hidden";
        if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
        // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (isIOS) {
            var _window$visualViewpor, _window$visualViewpor2;
            // iOS 12 does not support `visualViewport`.
            const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
            const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
            Object.assign(bodyStyle, {
                position: "fixed",
                top: -(scrollY - Math.floor(offsetTop)) + "px",
                left: -(scrollX - Math.floor(offsetLeft)) + "px",
                right: "0"
            });
        }
        return ()=>{
            $3f69993268aa5b7a$var$activeLocks.delete(lockId);
            if ($3f69993268aa5b7a$var$activeLocks.size === 0) {
                Object.assign(bodyStyle, {
                    overflow: "",
                    [paddingProp]: ""
                });
                if (isIOS) {
                    Object.assign(bodyStyle, {
                        position: "",
                        top: "",
                        left: "",
                        right: ""
                    });
                    window.scrollTo(scrollX, scrollY);
                }
            }
        };
    }, [
        lockId,
        lockScroll
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", $3f69993268aa5b7a$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $3f69993268aa5b7a$var$isButtonTarget(event) {
    return (0, $33bLr.isHTMLElement)(event.target) && event.target.tagName === "BUTTON";
}
function $3f69993268aa5b7a$var$isSpaceIgnored(element) {
    return (0, $4wHOx.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $3f69993268aa5b7a$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    pointerTypeRef.current = event.pointerType;
                },
                onMouseDown (event) {
                    // Ignore all buttons except for the "main" button.
                    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                    if (event.button !== 0) return;
                    if ((0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (eventOption === "click") return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                    else {
                        // Prevent stealing focus from the floating element
                        event.preventDefault();
                        onOpenChange(true, event.nativeEvent, "click");
                    }
                },
                onClick (event) {
                    if (eventOption === "mousedown" && pointerTypeRef.current) {
                        pointerTypeRef.current = undefined;
                        return;
                    }
                    if ((0, $4wHOx.isMouseLikePointerType)(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                },
                onKeyDown (event) {
                    pointerTypeRef.current = undefined;
                    if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event)) return;
                    if (event.key === " " && !$3f69993268aa5b7a$var$isSpaceIgnored(domReference)) {
                        // Prevent scrolling
                        event.preventDefault();
                        didKeyDownRef.current = true;
                    }
                    if (event.key === "Enter") {
                        if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                        else onOpenChange(true, event.nativeEvent, "click");
                    }
                },
                onKeyUp (event) {
                    if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event) || $3f69993268aa5b7a$var$isSpaceIgnored(domReference)) return;
                    if (event.key === " " && didKeyDownRef.current) {
                        didKeyDownRef.current = false;
                        if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                        else onOpenChange(true, event.nativeEvent, "click");
                    }
                }
            }
        };
    }, [
        enabled,
        dataRef,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        domReference,
        toggle,
        open,
        onOpenChange
    ]);
}
function $3f69993268aa5b7a$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $3f69993268aa5b7a$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $3f69993268aa5b7a$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = $3f69993268aa5b7a$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($3f69993268aa5b7a$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $4wHOx.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $33bLr.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $4wHOx.getTarget)(event);
            if (!(0, $4wHOx.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            reference: {
                onPointerDown: setPointerTypeRef,
                onPointerEnter: setPointerTypeRef,
                onMouseMove: handleReferenceEnterOrMove,
                onMouseEnter: handleReferenceEnterOrMove
            }
        };
    }, [
        enabled,
        handleReferenceEnterOrMove
    ]);
}
const $3f69993268aa5b7a$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $3f69993268aa5b7a$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $3f69993268aa5b7a$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $3f69993268aa5b7a$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: { reference: reference, domReference: domReference, floating: floating }, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $3f69993268aa5b7a$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $3f69993268aa5b7a$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $3f69993268aa5b7a$var$normalizeProp(capture);
    const closeOnEscapeKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $4wHOx.isReactEvent)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $4wHOx.getTarget)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $4wHOx.getTarget)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $4wHOx.getTarget)(event);
        const inertSelector = "[" + $3f69993268aa5b7a$var$createAttribute("inert") + "]";
        const markers = (0, $4wHOx.getDocument)(floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $33bLr.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $33bLr.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $33bLr.getParentNode)(targetRootAncestor);
            if ((0, $33bLr.isLastTraversableNode)(nextParent) || !(0, $33bLr.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $33bLr.isElement)(target) && !(0, $4wHOx.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $4wHOx.contains)(target, floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $4wHOx.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $33bLr.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $33bLr.getComputedStyle)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $4wHOx.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $4wHOx.isEventTargetWithin)(event, floating) || (0, $4wHOx.isEventTargetWithin)(event, domReference) || targetIsInsideChildren) return;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $4wHOx.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $4wHOx.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        const doc = (0, $4wHOx.getDocument)(floating);
        escapeKey && doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $33bLr.isElement)(domReference)) ancestors = (0, $33bLr.getOverflowAncestors)(domReference);
            if ((0, $33bLr.isElement)(floating)) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(floating));
            if (!(0, $33bLr.isElement)(reference) && reference && reference.contextElement) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
        };
    }, [
        dataRef,
        floating,
        domReference,
        reference,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onKeyDown: closeOnEscapeKeyDown,
                [$3f69993268aa5b7a$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
                }
            },
            floating: {
                onKeyDown: closeOnEscapeKeyDown,
                onMouseDown () {
                    endedOrStartedInsideRef.current = true;
                },
                onMouseUp () {
                    endedOrStartedInsideRef.current = true;
                },
                [$3f69993268aa5b7a$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                    insideReactTreeRef.current = true;
                }
            }
        };
    }, [
        enabled,
        referencePress,
        outsidePressEvent,
        referencePressEvent,
        onOpenChange,
        closeOnEscapeKeyDown
    ]);
}
function $3f69993268aa5b7a$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $3f69993268aa5b7a$export$f680877a34711e37();
    const dataRef = $acw62.useRef({});
    const [events] = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub());
    const nested = $3f69993268aa5b7a$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $acw62.useState(elementsProp.reference);
    const onOpenChange = $3f69993268aa5b7a$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $acw62.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $acw62.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $acw62.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3f69993268aa5b7a$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $3f69993268aa5b7a$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.reference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $acw62.useRef(null);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    $3f69993268aa5b7a$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $33OG6.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = (0, $33bLr.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ((0, $33bLr.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $33bLr.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $33bLr.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $3f69993268aa5b7a$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $33bLr.getWindow)(domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $33bLr.isHTMLElement)(domReference) && domReference === (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    if ((0, $4wHOx.isVirtualPointerEvent)(event.nativeEvent)) return;
                    keyboardModalityRef.current = false;
                },
                onMouseLeave () {
                    blockFocusRef.current = false;
                },
                onFocus (event) {
                    if (blockFocusRef.current) return;
                    const target = (0, $4wHOx.getTarget)(event.nativeEvent);
                    if (visibleOnly && (0, $33bLr.isElement)(target)) try {
                        // Mac Safari unreliably matches `:focus-visible` on the reference
                        // if focus was outside the page initially - use the fallback
                        // instead.
                        if ((0, $4wHOx.isSafari)() && (0, $4wHOx.isMac)()) throw Error();
                        if (!target.matches(":focus-visible")) return;
                    } catch (e) {
                        // Old browsers will throw an error when using `:focus-visible`.
                        if (!keyboardModalityRef.current && !(0, $4wHOx.isTypeableElement)(target)) return;
                    }
                    onOpenChange(true, event.nativeEvent, "focus");
                },
                onBlur (event) {
                    blockFocusRef.current = false;
                    const relatedTarget = event.relatedTarget;
                    // Hit the non-modal focus management portal guard. Focus will be
                    // moved into the floating element immediately after.
                    const movedToFocusGuard = (0, $33bLr.isElement)(relatedTarget) && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                    // Wait for the window blur listener to fire.
                    timeoutRef.current = window.setTimeout(()=>{
                        var _dataRef$current$floa;
                        const activeEl = (0, $4wHOx.activeElement)(domReference ? domReference.ownerDocument : document);
                        // Focus left the page, keep it open.
                        if (!relatedTarget && activeEl === domReference) return;
                        // When focusing the reference element (e.g. regular click), then
                        // clicking into the floating element, prevent it from hiding.
                        // Note: it must be focusable, e.g. `tabindex="-1"`.
                        // We can not rely on relatedTarget to point to the correct element
                        // as it will only point to the shadow host of the newly focused element
                        // and not the element that actually has received focus if it is located
                        // inside a shadow root.
                        if ((0, $4wHOx.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $4wHOx.contains)(domReference, activeEl) || movedToFocusGuard) return;
                        onOpenChange(false, event.nativeEvent, "focus");
                    });
                }
            }
        };
    }, [
        enabled,
        visibleOnly,
        dataRef,
        domReference,
        onOpenChange
    ]);
}
const $3f69993268aa5b7a$var$ACTIVE_KEY = "active";
const $3f69993268aa5b7a$var$SELECTED_KEY = "selected";
function $3f69993268aa5b7a$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$3f69993268aa5b7a$var$ACTIVE_KEY]: _, [$3f69993268aa5b7a$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $3f69993268aa5b7a$var$ACTIVE_KEY,
                    $3f69993268aa5b7a$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $3f69993268aa5b7a$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    // The dependencies are a dynamic array, so we can't use the linter's
    // suggestion to add it to the deps array.
    const deps = propsList;
    const getReferenceProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getItemProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "item"), // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    propsList.map((key)=>key == null ? void 0 : key.item));
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $3f69993268aa5b7a$var$isPreventScrollSupported = false;
function $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $3f69993268aa5b7a$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_UP || key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_LEFT || key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $3f69993268aa5b7a$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_RIGHT : key === $3f69993268aa5b7a$var$ARROW_LEFT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_UP;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $3f69993268aa5b7a$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: { domReference: domReference, floating: floating } } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!floating);
    const forceSyncFocus = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $3f69993268aa5b7a$var$useLatestRef(disabledIndices);
    const latestOpenRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const scrollItemIntoViewRef = $3f69993268aa5b7a$var$useLatestRef(scrollItemIntoView);
    const floatingRef = $3f69993268aa5b7a$var$useLatestRef(floating);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = $3f69993268aa5b7a$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        const item = listRef.current[indexRef.current];
        if (!item) return;
        if (virtual) {
            setActiveId(item.id);
            tree == null || tree.events.emit("virtualfocus", item);
            if (virtualItemRef) virtualItemRef.current = item;
        } else $3f69993268aa5b7a$var$enqueueFocus(item, {
            preventScroll: true,
            // Mac Safari does not move the virtual cursor unless the focus call
            // is sync. However, for the very first focus call, we need to wait
            // for the position to be ready in order to prevent unwanted
            // scrolling. This means the virtual cursor will not move to the first
            // item when first opening the floating element, but will on
            // subsequent calls. `preventScroll` is supported in modern Safari,
            // so we can use that instead.
            // iOS Safari must be async or the first item will not be focused.
            sync: (0, $4wHOx.isMac)() && (0, $4wHOx.isSafari)() ? $3f69993268aa5b7a$var$isPreventScrollSupported || forceSyncFocus.current : false
        });
        requestAnimationFrame(()=>{
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            item.scrollIntoView == null || item.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $3f69993268aa5b7a$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $3f69993268aa5b7a$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndex != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $3f69993268aa5b7a$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current) : $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        floating,
        activeIndex,
        selectedIndex,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $3f69993268aa5b7a$var$index(()=>{
        var _nodes$find;
        if (!enabled || floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $4wHOx.activeElement)((0, $4wHOx.getDocument)(floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $4wHOx.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        floating,
        tree,
        parentId,
        virtual
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled || !tree || !virtual || parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!floating;
    });
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $3f69993268aa5b7a$var$enqueueFocus(floatingRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        const disabledIndices = disabledIndicesRef.current;
        function onKeyDown(event) {
            isPointerModalityRef.current = false;
            forceSyncFocus.current = true;
            // If the floating element is animating out, ignore navigation. Otherwise,
            // the `activeIndex` gets set to 0 despite not being open so the next time
            // the user ArrowDowns, the first item won't be focused.
            if (!latestOpenRef.current && event.currentTarget === floatingRef.current) return;
            if (nested && $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
                (0, $4wHOx.stopEvent)(event);
                onOpenChange(false, event.nativeEvent, "list-navigation");
                if ((0, $33bLr.isHTMLElement)(domReference) && !virtual) domReference.focus();
                return;
            }
            const currentIndex = indexRef.current;
            const minIndex = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
            const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices);
            if (event.key === "Home") {
                (0, $4wHOx.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === "End") {
                (0, $4wHOx.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
            // Grid navigation.
            if (cols > 1) {
                const sizes = itemSizes || Array.from({
                    length: listRef.current.length
                }, ()=>({
                        width: 1,
                        height: 1
                    }));
                // To calculate movements on the grid, we use hypothetical cell indices
                // as if every item was 1x1, then convert back to real indices.
                const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
                const minGridIndex = cellMap.findIndex((index)=>index != null && !(disabledIndices != null && disabledIndices.includes(index)));
                // last enabled index
                const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(disabledIndices != null && disabledIndices.includes(index)) ? cellIndex : foundIndex, -1);
                indexRef.current = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                    current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
                }, {
                    event: event,
                    orientation: orientation,
                    loop: loop,
                    cols: cols,
                    // treat undefined (empty grid spaces) as disabled indices so we
                    // don't end up in them
                    disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                        ...disabledIndices || [],
                        undefined
                    ], cellMap),
                    minIndex: minGridIndex,
                    maxIndex: maxGridIndex,
                    prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                    // we're moving in so we don't end up in the same item. Prefer
                    // top/left over bottom/right.
                    event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? "bl" : event.key === $3f69993268aa5b7a$var$ARROW_RIGHT ? "tr" : "tl"),
                    stopEvent: true
                })]; // navigated cell will never be nullish
                onNavigate(indexRef.current);
                if (orientation === "both") return;
            }
            if ($3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation)) {
                (0, $4wHOx.stopEvent)(event);
                // Reset the index if no item is focused.
                if (open && !virtual && (0, $4wHOx.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                    indexRef.current = $3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                    onNavigate(indexRef.current);
                    return;
                }
                if ($3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                    if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                    else indexRef.current = Math.min(maxIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    }));
                } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.max(minIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                }));
                if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
                else onNavigate(indexRef.current);
            }
        }
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $4wHOx.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $4wHOx.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
        const activeItem = listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId);
        return {
            reference: {
                ...ariaActiveDescendantProp,
                onKeyDown (event) {
                    isPointerModalityRef.current = false;
                    const isArrowKey = event.key.indexOf("Arrow") === 0;
                    const isCrossOpenKey = $3f69993268aa5b7a$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                    const isCrossCloseKey = $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                    const isMainKey = $3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation);
                    const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                    if (virtual && open) {
                        const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                        const deepestNode = tree && rootNode ? $3f69993268aa5b7a$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                        if (isArrowKey && deepestNode && virtualItemRef) {
                            const eventObject = new KeyboardEvent("keydown", {
                                key: event.key,
                                bubbles: true
                            });
                            if (isCrossOpenKey || isCrossCloseKey) {
                                var _deepestNode$context, _deepestNode$context2;
                                const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                                const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? activeItem : null;
                                if (dispatchItem) {
                                    (0, $4wHOx.stopEvent)(event);
                                    dispatchItem.dispatchEvent(eventObject);
                                    setVirtualId(undefined);
                                }
                            }
                            if (isMainKey && deepestNode.context) {
                                if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                    var _deepestNode$context$;
                                    (0, $4wHOx.stopEvent)(event);
                                    (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                    return;
                                }
                            }
                        }
                        return onKeyDown(event);
                    }
                    // If a floating element should not open on arrow key down, avoid
                    // setting `activeIndex` while it's closed.
                    if (!open && !openOnArrowKeyDown && isArrowKey) return;
                    if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                    if (nested) {
                        if (isCrossOpenKey) {
                            (0, $4wHOx.stopEvent)(event);
                            if (open) {
                                indexRef.current = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
                                onNavigate(indexRef.current);
                            } else onOpenChange(true, event.nativeEvent, "list-navigation");
                        }
                        return;
                    }
                    if (isMainKey) {
                        if (selectedIndex != null) indexRef.current = selectedIndex;
                        (0, $4wHOx.stopEvent)(event);
                        if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                        else onKeyDown(event);
                        if (open) onNavigate(indexRef.current);
                    }
                },
                onFocus () {
                    if (open) onNavigate(null);
                },
                onPointerDown: checkVirtualPointer,
                onMouseDown: checkVirtualMouse,
                onClick: checkVirtualMouse
            },
            floating: {
                "aria-orientation": orientation === "both" ? undefined : orientation,
                ...!(0, $4wHOx.isTypeableCombobox)(domReference) && ariaActiveDescendantProp,
                onKeyDown: onKeyDown,
                onPointerMove () {
                    isPointerModalityRef.current = true;
                }
            },
            item: item
        };
    }, [
        domReference,
        floatingRef,
        activeId,
        virtualId,
        disabledIndicesRef,
        latestOpenRef,
        listRef,
        enabled,
        orientation,
        rtl,
        virtual,
        open,
        hasActiveIndex,
        nested,
        selectedIndex,
        openOnArrowKeyDown,
        allowEscape,
        cols,
        loop,
        focusItemOnOpen,
        onNavigate,
        onOpenChange,
        item,
        tree,
        virtualItemRef,
        itemSizes,
        dense
    ]);
}
const $3f69993268aa5b7a$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $3f69993268aa5b7a$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const ariaRole = (_componentRoleToAriaR = $3f69993268aa5b7a$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $3f69993268aa5b7a$export$f680877a34711e37();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const isNested = parentId != null;
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return {
            reference: {
                ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
            },
            floating: floatingProps
        };
        return {
            reference: {
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
                "aria-controls": open ? floatingId : undefined,
                ...ariaRole === "listbox" && {
                    role: "combobox"
                },
                ...ariaRole === "menu" && {
                    id: referenceId
                },
                ...ariaRole === "menu" && isNested && {
                    role: "menuitem"
                },
                ...role === "select" && {
                    "aria-autocomplete": "none"
                },
                ...role === "combobox" && {
                    "aria-autocomplete": "list"
                }
            },
            floating: {
                ...floatingProps,
                ...ariaRole === "menu" && {
                    "aria-labelledby": referenceId
                }
            },
            item (_ref) {
                let { active: active, selected: selected } = _ref;
                const commonProps = {
                    role: "option",
                    ...active && {
                        id: floatingId + "-option"
                    }
                };
                // For `menu`, we are unable to tell if the item is a `menuitemradio`
                // or `menuitemcheckbox`. For backwards-compatibility reasons, also
                // avoid defaulting to `menuitem` as it may overwrite custom role props.
                switch(role){
                    case "select":
                        return {
                            ...commonProps,
                            "aria-selected": active && selected
                        };
                    case "combobox":
                        return {
                            ...commonProps,
                            ...active && {
                                "aria-selected": true
                            }
                        };
                }
                return {};
            }
        };
    }, [
        enabled,
        role,
        ariaRole,
        open,
        floatingId,
        referenceId,
        isNested
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $3f69993268aa5b7a$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $3f69993268aa5b7a$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $3f69993268aa5b7a$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $3f69993268aa5b7a$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $acw62.useState("unmounted");
    const isMounted = $3f69993268aa5b7a$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $3f69993268aa5b7a$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $3f69993268aa5b7a$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $3f69993268aa5b7a$var$useLatestRef(unstable_initial);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(unstable_open);
    const closeRef = $3f69993268aa5b7a$var$useLatestRef(unstable_close);
    const commonRef = $3f69993268aa5b7a$var$useLatestRef(unstable_common);
    $3f69993268aa5b7a$var$index(()=>{
        const initialStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $3f69993268aa5b7a$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef("");
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $3f69993268aa5b7a$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $3f69993268aa5b7a$var$useLatestRef(findMatch);
    const ignoreKeysRef = $3f69993268aa5b7a$var$useLatestRef(ignoreKeys);
    $3f69993268aa5b7a$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setTypingChange(value) {
            if (value) {
                if (!dataRef.current.typing) {
                    dataRef.current.typing = value;
                    onTypingChange(value);
                }
            } else if (dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        }
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        function onKeyDown(event) {
            const listContent = listRef.current;
            if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
                if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
                else if (event.key === " ") (0, $4wHOx.stopEvent)(event);
            }
            if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
            event.key.length !== 1 || // Modifier key.
            event.ctrlKey || event.metaKey || event.altKey) return;
            if (open && event.key !== " ") {
                (0, $4wHOx.stopEvent)(event);
                setTypingChange(true);
            }
            // Bail out if the list contains a word like "llama" or "aaron". TODO:
            // allow it in this case, too.
            const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
                var _text$, _text$2;
                return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
            });
            // Allows the user to cycle through items that start with the same letter
            // in rapid succession.
            if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
                stringRef.current = "";
                prevIndexRef.current = matchIndexRef.current;
            }
            stringRef.current += event.key;
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(()=>{
                stringRef.current = "";
                prevIndexRef.current = matchIndexRef.current;
                setTypingChange(false);
            }, resetMs);
            const prevIndex = prevIndexRef.current;
            const index = getMatchingIndex(listContent, [
                ...listContent.slice((prevIndex || 0) + 1),
                ...listContent.slice(0, (prevIndex || 0) + 1)
            ], stringRef.current);
            if (index !== -1) {
                onMatch(index);
                matchIndexRef.current = index;
            } else if (event.key !== " ") {
                stringRef.current = "";
                setTypingChange(false);
            }
        }
        return {
            reference: {
                onKeyDown: onKeyDown
            },
            floating: {
                onKeyDown: onKeyDown,
                onKeyUp (event) {
                    if (event.key === " ") setTypingChange(false);
                }
            }
        };
    }, [
        enabled,
        open,
        dataRef,
        listRef,
        resetMs,
        ignoreKeysRef,
        findMatchRef,
        onMatch,
        onTypingChange
    ]);
}
function $3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $3f69993268aa5b7a$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = props;
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $618j3.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            const overflow = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
            const refOverflow = await (0, $618j3.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = Math.max(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
            el.style.maxHeight = maxHeight + "px";
            el.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) (0, $1u0KT.flushSync)(()=>onFallbackChange(true));
                else (0, $1u0KT.flushSync)(()=>onFallbackChange(false));
            }
            if (overflowRef) overflowRef.current = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, el.offsetHeight), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $3f69993268aa5b7a$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                (0, $1u0KT.flushSync)(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $4wHOx.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            floating: {
                onKeyDown () {
                    controlledScrollingRef.current = true;
                },
                onWheel () {
                    controlledScrollingRef.current = false;
                },
                onPointerMove () {
                    controlledScrollingRef.current = false;
                },
                onScroll () {
                    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                    if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                    if (prevScrollTopRef.current !== null) {
                        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) (0, $1u0KT.flushSync)(()=>onChange((d)=>d + scrollDiff));
                    }
                    // [Firefox] Wait for the height change to have been applied.
                    requestAnimationFrame(()=>{
                        prevScrollTopRef.current = el.scrollTop;
                    });
                }
            }
        };
    }, [
        enabled,
        overflowRef,
        elements.floating,
        scrollRef,
        onChange
    ]);
}
function $3f69993268aa5b7a$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $3f69993268aa5b7a$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $3f69993268aa5b7a$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $4wHOx.getTarget)(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $4wHOx.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $4wHOx.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $3f69993268aa5b7a$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $33bLr.isElement)(event.relatedTarget) && (0, $4wHOx.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("4wHOx", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $34bc2325b4db944b$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $34bc2325b4db944b$export$2344b14b097df817);
$parcel$export(module.exports, "getPlatform", () => $34bc2325b4db944b$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $34bc2325b4db944b$export$7935961ef7719cb0);
$parcel$export(module.exports, "isVirtualClick", () => $34bc2325b4db944b$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $34bc2325b4db944b$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isSafari", () => $34bc2325b4db944b$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $34bc2325b4db944b$export$9ac100e40613ea10);
$parcel$export(module.exports, "isMouseLikePointerType", () => $34bc2325b4db944b$export$81cf264172d31e51);
$parcel$export(module.exports, "isReactEvent", () => $34bc2325b4db944b$export$94781ce41a161222);
$parcel$export(module.exports, "isRootElement", () => $34bc2325b4db944b$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $34bc2325b4db944b$export$f65ca476c09acec0);
$parcel$export(module.exports, "isEventTargetWithin", () => $34bc2325b4db944b$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "getTarget", () => $34bc2325b4db944b$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isTypeableElement", () => $34bc2325b4db944b$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "stopEvent", () => $34bc2325b4db944b$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isTypeableCombobox", () => $34bc2325b4db944b$export$259ba5ae38188551);

var $33bLr = parcelRequire("33bLr");
function $34bc2325b4db944b$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $34bc2325b4db944b$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $33bLr.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $34bc2325b4db944b$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $34bc2325b4db944b$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $34bc2325b4db944b$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($34bc2325b4db944b$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $34bc2325b4db944b$export$29bf1b5f2c56cf63(event) {
    if ($34bc2325b4db944b$export$c8f880a2d81914c4()) return false;
    return !$34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $34bc2325b4db944b$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $34bc2325b4db944b$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($34bc2325b4db944b$export$867a782338812cb4()) || re.test($34bc2325b4db944b$export$7935961ef7719cb0());
}
function $34bc2325b4db944b$export$9ac100e40613ea10() {
    return $34bc2325b4db944b$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $34bc2325b4db944b$export$c8f880a2d81914c4() {
    return $34bc2325b4db944b$export$7935961ef7719cb0().includes("jsdom/");
}
function $34bc2325b4db944b$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $34bc2325b4db944b$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
function $34bc2325b4db944b$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $34bc2325b4db944b$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $34bc2325b4db944b$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $34bc2325b4db944b$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $34bc2325b4db944b$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $34bc2325b4db944b$export$42ad131c32f0fb8d(element) {
    return (0, $33bLr.isHTMLElement)(element) && element.matches($34bc2325b4db944b$export$78b3d091ff376bc);
}
function $34bc2325b4db944b$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $34bc2325b4db944b$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $34bc2325b4db944b$export$42ad131c32f0fb8d(element);
}

});

parcelRegister("33OG6", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $23a8f689f1d4c3be$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "useFloating", () => $23a8f689f1d4c3be$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("618j3")).computePosition);

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $618j3.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $618j3.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $23a8f689f1d4c3be$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $618j3.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}

});

parcelRegister("e8HHX", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $a4b3b7902c9a987d$export$17100aea90429aa7);
$parcel$export(module.exports, "isTabbable", () => $a4b3b7902c9a987d$export$bebd5a1431fec25d);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(",");
var $a4b3b7902c9a987d$var$NoElement = typeof Element === "undefined";
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "hidden";
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "radio";
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat("iframe").join(",");
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};

});



parcelRegister("kqTi2", function(module, exports) {

$parcel$export(module.exports, "MapContainer", () => $ee011fc978fcb926$export$23f3dfd47374502b);

var $hv573 = parcelRequire("hv573");

var $8JYDX = parcelRequire("8JYDX");

var $acw62 = parcelRequire("acw62");
function $ee011fc978fcb926$var$_extends() {
    $ee011fc978fcb926$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ee011fc978fcb926$var$_extends.apply(this, arguments);
}
function $ee011fc978fcb926$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $acw62.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $acw62.useState)(null);
    (0, $acw62.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0, $acw62.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $8JYDX.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $hv573.createLeafletContext)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hv573.LeafletProvider), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $ee011fc978fcb926$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $ee011fc978fcb926$export$23f3dfd47374502b = /*#__PURE__*/ (0, $acw62.forwardRef)($ee011fc978fcb926$var$MapContainerComponent);

});
parcelRegister("hv573", function(module, exports) {

$parcel$export(module.exports, "createLeafletContext", () => $cbd94c399cef41ea$export$fb237fa819e17281);
$parcel$export(module.exports, "extendContext", () => $cbd94c399cef41ea$export$9efaf186a2224858);
$parcel$export(module.exports, "LeafletProvider", () => $cbd94c399cef41ea$export$a24c9fc2f87814b2);
$parcel$export(module.exports, "useLeafletContext", () => $cbd94c399cef41ea$export$ea59151b8430a4e9);

var $acw62 = parcelRequire("acw62");
const $cbd94c399cef41ea$export$b8efcc4bff45e15b = 1;
function $cbd94c399cef41ea$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $cbd94c399cef41ea$export$b8efcc4bff45e15b,
        map: map
    });
}
function $cbd94c399cef41ea$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $cbd94c399cef41ea$export$7de1b54b0142048f = (0, $acw62.createContext)(null);
const $cbd94c399cef41ea$export$a24c9fc2f87814b2 = $cbd94c399cef41ea$export$7de1b54b0142048f.Provider;
function $cbd94c399cef41ea$export$ea59151b8430a4e9() {
    const context = (0, $acw62.useContext)($cbd94c399cef41ea$export$7de1b54b0142048f);
    if (context == null) throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
    return context;
}

});

parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});


parcelRegister("i7g9v", function(module, exports) {

$parcel$export(module.exports, "Marker", () => $d30568f206d68912$export$e98856a975cab58e);

var $gQoCq = parcelRequire("gQoCq");
var $3grOU = parcelRequire("3grOU");
var $hv573 = parcelRequire("hv573");

var $8JYDX = parcelRequire("8JYDX");
const $d30568f206d68912$export$e98856a975cab58e = (0, $3grOU.createLayerComponent)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $8JYDX.Marker)(position, options);
    return (0, $gQoCq.createElementObject)(marker, (0, $hv573.extendContext)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});

});
parcelRegister("gQoCq", function(module, exports) {

$parcel$export(module.exports, "createElementObject", () => $c4349977e33cccc7$export$a080ff44e8067a44);
$parcel$export(module.exports, "createElementHook", () => $c4349977e33cccc7$export$2e66ec8a7fb1892f);

var $acw62 = parcelRequire("acw62");
function $c4349977e33cccc7$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $c4349977e33cccc7$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $acw62.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $acw62.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $acw62.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $acw62.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}

});

parcelRegister("3grOU", function(module, exports) {

$parcel$export(module.exports, "createLayerComponent", () => $26087237d6669ee9$export$8a4d5778bce4c3ac);
$parcel$export(module.exports, "createOverlayComponent", () => $26087237d6669ee9$export$7d18e209be943d7d);
$parcel$export(module.exports, "createTileLayerComponent", () => $26087237d6669ee9$export$4f432c6de5c4ddb8);

var $fBdT2 = parcelRequire("fBdT2");

var $2lNaM = parcelRequire("2lNaM");

var $gQoCq = parcelRequire("gQoCq");

var $arQru = parcelRequire("arQru");

var $4ETWl = parcelRequire("4ETWl");

var $3fu6b = parcelRequire("3fu6b");
function $26087237d6669ee9$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $gQoCq.createElementObject)(createInstance(props), context);
    }
    const useElement = (0, $gQoCq.createElementHook)(createElement);
    const useControl = (0, $2lNaM.createControlHook)(useElement);
    return (0, $fBdT2.createLeafComponent)(useControl);
}
function $26087237d6669ee9$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $gQoCq.createElementHook)(createElement, updateElement);
    const useLayer = (0, $arQru.createLayerHook)(useElement);
    return (0, $fBdT2.createContainerComponent)(useLayer);
}
function $26087237d6669ee9$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $gQoCq.createElementHook)(createElement);
    const useOverlay = (0, $4ETWl.createDivOverlayHook)(useElement, useLifecycle);
    return (0, $fBdT2.createDivOverlayComponent)(useOverlay);
}
function $26087237d6669ee9$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $gQoCq.createElementHook)(createElement, updateElement);
    const usePath = (0, $3fu6b.createPathHook)(useElement);
    return (0, $fBdT2.createContainerComponent)(usePath);
}
function $26087237d6669ee9$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $gQoCq.createElementHook)(createElement, updateElement);
    const useLayer = (0, $arQru.createLayerHook)(useElement);
    return (0, $fBdT2.createLeafComponent)(useLayer);
}

});
parcelRegister("fBdT2", function(module, exports) {

$parcel$export(module.exports, "createContainerComponent", () => $b5b5154e09abe911$export$96eac748c3f41e82);
$parcel$export(module.exports, "createDivOverlayComponent", () => $b5b5154e09abe911$export$bc37ddc24ed05446);
$parcel$export(module.exports, "createLeafComponent", () => $b5b5154e09abe911$export$18af5c7a9e9b3664);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $hv573 = parcelRequire("hv573");
function $b5b5154e09abe911$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hv573.LeafletProvider), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(ContainerComponent);
}
function $b5b5154e09abe911$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $acw62.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $acw62.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $1u0KT.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(OverlayComponent);
}
function $b5b5154e09abe911$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(LeafComponent);
}

});

parcelRegister("2lNaM", function(module, exports) {

$parcel$export(module.exports, "createControlHook", () => $1b63afa14c569d34$export$28d24ab3914549cd);

var $acw62 = parcelRequire("acw62");

var $hv573 = parcelRequire("hv573");
function $1b63afa14c569d34$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $hv573.useLeafletContext)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $acw62.useRef)(props.position);
        const { position: position } = props;
        (0, $acw62.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $acw62.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}

});

parcelRegister("arQru", function(module, exports) {

$parcel$export(module.exports, "useLayerLifecycle", () => $79b51af07cb34fe6$export$cd00a227f8cfb2c2);
$parcel$export(module.exports, "createLayerHook", () => $79b51af07cb34fe6$export$73f852c6a5abdefa);

var $acw62 = parcelRequire("acw62");

var $52wO4 = parcelRequire("52wO4");

var $hv573 = parcelRequire("hv573");

var $9Fnap = parcelRequire("9Fnap");

var $4mEZd = parcelRequire("4mEZd");
function $79b51af07cb34fe6$export$cd00a227f8cfb2c2(element, context) {
    (0, $acw62.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $79b51af07cb34fe6$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $hv573.useLeafletContext)();
        const elementRef = useElement((0, $4mEZd.withPane)(props, context), context);
        (0, $52wO4.useAttribution)(context.map, props.attribution);
        (0, $9Fnap.useEventHandlers)(elementRef.current, props.eventHandlers);
        $79b51af07cb34fe6$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}

});
parcelRegister("52wO4", function(module, exports) {

$parcel$export(module.exports, "useAttribution", () => $3ab6965f3c0b8e48$export$46b870813daca3d4);

var $acw62 = parcelRequire("acw62");
function $3ab6965f3c0b8e48$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $acw62.useRef)(attribution);
    (0, $acw62.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

});

parcelRegister("9Fnap", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", () => $7099e9dbf72f5596$export$8ce912bc34d0dbea);

var $acw62 = parcelRequire("acw62");
function $7099e9dbf72f5596$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

});

parcelRegister("4mEZd", function(module, exports) {

$parcel$export(module.exports, "withPane", () => $32d90284a15401c8$export$6ee5d263358f5c0e);
function $32d90284a15401c8$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}

});


parcelRegister("4ETWl", function(module, exports) {

$parcel$export(module.exports, "createDivOverlayHook", () => $36464a5b4c62d1dd$export$d5eca53b0accc0e0);

var $52wO4 = parcelRequire("52wO4");

var $hv573 = parcelRequire("hv573");

var $9Fnap = parcelRequire("9Fnap");

var $4mEZd = parcelRequire("4mEZd");
function $36464a5b4c62d1dd$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $hv573.useLeafletContext)();
        const elementRef = useElement((0, $4mEZd.withPane)(props, context), context);
        (0, $52wO4.useAttribution)(context.map, props.attribution);
        (0, $9Fnap.useEventHandlers)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

});

parcelRegister("3fu6b", function(module, exports) {

$parcel$export(module.exports, "createPathHook", () => $25da1ed181e98b0a$export$5fea2fe6048fc3db);

var $acw62 = parcelRequire("acw62");

var $hv573 = parcelRequire("hv573");

var $9Fnap = parcelRequire("9Fnap");

var $arQru = parcelRequire("arQru");

var $4mEZd = parcelRequire("4mEZd");
function $25da1ed181e98b0a$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $25da1ed181e98b0a$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $hv573.useLeafletContext)();
        const elementRef = useElement((0, $4mEZd.withPane)(props, context), context);
        (0, $9Fnap.useEventHandlers)(elementRef.current, props.eventHandlers);
        (0, $arQru.useLayerLifecycle)(elementRef.current, context);
        $25da1ed181e98b0a$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}

});



parcelRegister("5Dm6P", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $41a1beb44c6aafd3$export$129a32eedafa97c5);

var $gQoCq = parcelRequire("gQoCq");
var $3grOU = parcelRequire("3grOU");

var $8JYDX = parcelRequire("8JYDX");

var $acw62 = parcelRequire("acw62");
const $41a1beb44c6aafd3$export$129a32eedafa97c5 = (0, $3grOU.createOverlayComponent)(function createPopup(props, context) {
    const popup = new (0, $8JYDX.Popup)(props, context.overlayContainer);
    return (0, $gQoCq.createElementObject)(popup, context);
}, function usePopupLifecycle(element, context, { position: position }, setOpen) {
    (0, $acw62.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) setOpen(false);
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});

});

parcelRegister("4ysIF", function(module, exports) {

$parcel$export(module.exports, "TileLayer", () => $35109d75658c2839$export$f52ee31d61d0b27b);

var $gQoCq = parcelRequire("gQoCq");
var $3grOU = parcelRequire("3grOU");
var $cN0aC = parcelRequire("cN0aC");
var $4mEZd = parcelRequire("4mEZd");

var $8JYDX = parcelRequire("8JYDX");
const $35109d75658c2839$export$f52ee31d61d0b27b = (0, $3grOU.createTileLayerComponent)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $8JYDX.TileLayer)(url, (0, $4mEZd.withPane)(options, context));
    return (0, $gQoCq.createElementObject)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $cN0aC.updateGridLayer)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});

});
parcelRegister("cN0aC", function(module, exports) {

$parcel$export(module.exports, "updateGridLayer", () => $94fa316de2622a09$export$b39104a5f1b9296f);
function $94fa316de2622a09$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}

});


parcelRegister("bSFz8", function(module, exports) {

$parcel$export(module.exports, "useMapEvent", () => $8a64faf0323c3697$export$4c2959913f5c7962);

var $hv573 = parcelRequire("hv573");

var $acw62 = parcelRequire("acw62");
function $8a64faf0323c3697$export$86f8f9f08863e403() {
    return (0, $hv573.useLeafletContext)().map;
}
function $8a64faf0323c3697$export$4c2959913f5c7962(type, handler) {
    const map = $8a64faf0323c3697$export$86f8f9f08863e403();
    (0, $acw62.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $8a64faf0323c3697$export$1c51e2c234152172(handlers) {
    const map = $8a64faf0323c3697$export$86f8f9f08863e403();
    (0, $acw62.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}

});

parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("htkMF", function(module, exports) {

$parcel$export(module.exports, "ReactMarkdown", () => $cb8544603a0b034a$export$83ef7ab426386201);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $acw62 = parcelRequire("acw62");

var $kfsOU = parcelRequire("kfsOU");

var $hBHqC = parcelRequire("hBHqC");

var $3F7xF = parcelRequire("3F7xF");

var $kMNw8 = parcelRequire("kMNw8");

var $c9Z8w = parcelRequire("c9Z8w");

var $9LDLu = parcelRequire("9LDLu");

var $2Hi3l = parcelRequire("2Hi3l");

var $i5UZr = parcelRequire("i5UZr");
const $cb8544603a0b034a$var$own = {}.hasOwnProperty;
const $cb8544603a0b034a$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $cb8544603a0b034a$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $cb8544603a0b034a$export$83ef7ab426386201(options) {
    for(const key in $cb8544603a0b034a$var$deprecated)if ($cb8544603a0b034a$var$own.call($cb8544603a0b034a$var$deprecated, key) && $cb8544603a0b034a$var$own.call(options, key)) {
        const deprecation = $cb8544603a0b034a$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$cb8544603a0b034a$var$changelog}#${deprecation.id}> for more info)`);
        delete $cb8544603a0b034a$var$deprecated[key];
    }
    const processor = (0, $hBHqC.unified)().use((0, $3F7xF.default)).use(options.remarkPlugins || []).use((0, $kMNw8.default), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $2Hi3l.default), options);
    const file = new (0, $kfsOU.VFile)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, (0, $i5UZr.childrenToReact)({
        options: options,
        schema: (0, $9LDLu.html),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$cb8544603a0b034a$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};

});
parcelRegister("kfsOU", function(module, exports) {

$parcel$export(module.exports, "VFile", () => $ebdb906eb43ac433$export$93dff69eb10dc7ce);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ 
var $7B5Ea = parcelRequire("7B5Ea");

var $bpyKL = parcelRequire("bpyKL");

var $9haXP = parcelRequire("9haXP");

var $4lnqT = parcelRequire("4lnqT");
parcelRequire("dzJSz");
var $k7DYN = parcelRequire("k7DYN");
var $dzJSz = parcelRequire("dzJSz");
/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $ebdb906eb43ac433$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $ebdb906eb43ac433$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $ebdb906eb43ac433$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $k7DYN.isUrl)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $4lnqT.proc).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $ebdb906eb43ac433$var$order.length){
            const prop = $ebdb906eb43ac433$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$ebdb906eb43ac433$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $k7DYN.isUrl)(path)) path = (0, $dzJSz.urlToPath)(path);
        $ebdb906eb43ac433$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $9haXP.path).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $ebdb906eb43ac433$var$assertPath(this.basename, "dirname");
        this.path = (0, $9haXP.path).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $9haXP.path).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $ebdb906eb43ac433$var$assertNonEmpty(basename, "basename");
        $ebdb906eb43ac433$var$assertPart(basename, "basename");
        this.path = (0, $9haXP.path).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $9haXP.path).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $ebdb906eb43ac433$var$assertPart(extname, "extname");
        $ebdb906eb43ac433$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $9haXP.path).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $9haXP.path).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $ebdb906eb43ac433$var$assertNonEmpty(stem, "stem");
        $ebdb906eb43ac433$var$assertPart(stem, "stem");
        this.path = (0, $9haXP.path).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $bpyKL.VFileMessage)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPart(part, name) {
    if (part && part.includes((0, $9haXP.path).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $9haXP.path).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $ebdb906eb43ac433$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7B5Ea)))(value);
}

});
parcelRegister("7B5Ea", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});

parcelRegister("bpyKL", function(module, exports) {

$parcel$export(module.exports, "VFileMessage", () => $84ecfcc79391545c$export$752e5c445fe834ef);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
var $f9WaX = parcelRequire("f9WaX");
class $84ecfcc79391545c$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $f9WaX.stringifyPosition)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.file = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.name = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.reason = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.message = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.stack = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.fatal = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.column = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.line = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.source = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.ruleId = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.position = null;

});
parcelRegister("f9WaX", function(module, exports) {

$parcel$export(module.exports, "stringifyPosition", () => $b094d2c4d032c594$export$c304dd45fe166145);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $b094d2c4d032c594$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $b094d2c4d032c594$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $b094d2c4d032c594$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $b094d2c4d032c594$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $b094d2c4d032c594$var$point(point) {
    return $b094d2c4d032c594$var$index(point && point.line) + ":" + $b094d2c4d032c594$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $b094d2c4d032c594$var$position(pos) {
    return $b094d2c4d032c594$var$point(pos && pos.start) + "-" + $b094d2c4d032c594$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $b094d2c4d032c594$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRegister("9haXP", function(module, exports) {

$parcel$export(module.exports, "path", () => $6c0e34cf2f183349$export$bb654e07daaf8c3a);
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $6c0e34cf2f183349$export$bb654e07daaf8c3a = {
    basename: $6c0e34cf2f183349$var$basename,
    dirname: $6c0e34cf2f183349$var$dirname,
    extname: $6c0e34cf2f183349$var$extname,
    join: $6c0e34cf2f183349$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $6c0e34cf2f183349$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $6c0e34cf2f183349$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$dirname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $6c0e34cf2f183349$var$extname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $6c0e34cf2f183349$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $6c0e34cf2f183349$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $6c0e34cf2f183349$var$normalize(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $6c0e34cf2f183349$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $6c0e34cf2f183349$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 

});

parcelRegister("4lnqT", function(module, exports) {

$parcel$export(module.exports, "proc", () => $329b4cd6854e87dd$export$97a5aaf482767187);
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $329b4cd6854e87dd$export$97a5aaf482767187 = {
    cwd: $329b4cd6854e87dd$var$cwd
};
function $329b4cd6854e87dd$var$cwd() {
    return "/";
}

});

parcelRegister("dzJSz", function(module, exports) {

$parcel$export(module.exports, "urlToPath", () => $028cf007d1b71fb0$export$9b2b676c902de799);
$parcel$export(module.exports, "isUrl", () => (parcelRequire("k7DYN")).isUrl);
/// <reference lib="dom" />

var $k7DYN = parcelRequire("k7DYN");
function $028cf007d1b71fb0$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $k7DYN.isUrl)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $028cf007d1b71fb0$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $028cf007d1b71fb0$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}

});
parcelRegister("k7DYN", function(module, exports) {

$parcel$export(module.exports, "isUrl", () => $ea6379392cbaeecd$export$8304a22d431f958);
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $ea6379392cbaeecd$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}

});



parcelRegister("hBHqC", function(module, exports) {

$parcel$export(module.exports, "unified", () => $cd17945441716b11$export$7cc1b2fe10c52bb);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ 
var $knL6O = parcelRequire("knL6O");

var $7B5Ea = parcelRequire("7B5Ea");

var $1XwqA = parcelRequire("1XwqA");

var $lJ4VN = parcelRequire("lJ4VN");

var $23inL = parcelRequire("23inL");

var $kfsOU = parcelRequire("kfsOU");
const $cd17945441716b11$export$7cc1b2fe10c52bb = $cd17945441716b11$var$base().freeze();
const $cd17945441716b11$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $cd17945441716b11$var$base() {
    const transformers = (0, $23inL.trough)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $cd17945441716b11$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($1XwqA)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $cd17945441716b11$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $cd17945441716b11$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $cd17945441716b11$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $cd17945441716b11$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $lJ4VN.default)(entry[1]) && (0, $lJ4VN.default)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($1XwqA)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $cd17945441716b11$var$vfile(doc);
        const Parser = processor.Parser;
        $cd17945441716b11$var$assertParser("parse", Parser);
        if ($cd17945441716b11$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $cd17945441716b11$var$vfile(doc);
        const Compiler = processor.Compiler;
        $cd17945441716b11$var$assertCompiler("stringify", Compiler);
        $cd17945441716b11$var$assertNode(node);
        if ($cd17945441716b11$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $cd17945441716b11$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $cd17945441716b11$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $cd17945441716b11$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $knL6O.bail)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $cd17945441716b11$var$assertParser("process", processor.Parser);
        $cd17945441716b11$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $cd17945441716b11$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($cd17945441716b11$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $cd17945441716b11$var$assertParser("processSync", processor.Parser);
        $cd17945441716b11$var$assertCompiler("processSync", processor.Compiler);
        const file = $cd17945441716b11$var$vfile(doc);
        processor.process(file, done);
        $cd17945441716b11$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $knL6O.bail)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $cd17945441716b11$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($cd17945441716b11$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $cd17945441716b11$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($cd17945441716b11$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $cd17945441716b11$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $cd17945441716b11$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $cd17945441716b11$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $cd17945441716b11$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $lJ4VN.default)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $cd17945441716b11$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $cd17945441716b11$var$vfile(value) {
    return $cd17945441716b11$var$looksLikeAVFile(value) ? value : new (0, $kfsOU.VFile)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $cd17945441716b11$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $cd17945441716b11$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($7B5Ea)))(value);
}

});
parcelRegister("knL6O", function(module, exports) {

$parcel$export(module.exports, "bail", () => $ed6a7f7e034afcf2$export$dd911e13ecb11e05);
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $ed6a7f7e034afcf2$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}

});

parcelRegister("1XwqA", function(module, exports) {
"use strict";
var $16d474a0815e976d$var$hasOwn = Object.prototype.hasOwnProperty;
var $16d474a0815e976d$var$toStr = Object.prototype.toString;
var $16d474a0815e976d$var$defineProperty = Object.defineProperty;
var $16d474a0815e976d$var$gOPD = Object.getOwnPropertyDescriptor;
var $16d474a0815e976d$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $16d474a0815e976d$var$toStr.call(arr) === "[object Array]";
};
var $16d474a0815e976d$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $16d474a0815e976d$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $16d474a0815e976d$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $16d474a0815e976d$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $16d474a0815e976d$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $16d474a0815e976d$var$setProperty = function setProperty(target, options) {
    if ($16d474a0815e976d$var$defineProperty && options.name === "__proto__") $16d474a0815e976d$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $16d474a0815e976d$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$16d474a0815e976d$var$hasOwn.call(obj, name)) return void 0;
        else if ($16d474a0815e976d$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $16d474a0815e976d$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $16d474a0815e976d$var$getProperty(target, name);
            copy = $16d474a0815e976d$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($16d474a0815e976d$var$isPlainObject(copy) || (copyIsArray = $16d474a0815e976d$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $16d474a0815e976d$var$isArray(src) ? src : [];
                    } else clone = src && $16d474a0815e976d$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $16d474a0815e976d$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $16d474a0815e976d$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("lJ4VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd11a02fceb57d58$export$2e2bcd8739ae039);
function $fd11a02fceb57d58$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

});

parcelRegister("23inL", function(module, exports) {

$parcel$export(module.exports, "trough", () => $17ea1ee7077b6d45$export$91b56f5ca106aa43);
/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $17ea1ee7077b6d45$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $17ea1ee7077b6d45$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $17ea1ee7077b6d45$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}

});


parcelRegister("3F7xF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aab0d1dd6b1383c$export$2e2bcd8739ae039);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ 
var $32C5u = parcelRequire("32C5u");
function $2aab0d1dd6b1383c$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $32C5u.fromMarkdown)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}

});
parcelRegister("32C5u", function(module, exports) {

$parcel$export(module.exports, "fromMarkdown", () => $236f1a66ed1dd212$export$d744d789c09bfde6);
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.

var $apdnY = parcelRequire("apdnY");

var $2JaIP = parcelRequire("2JaIP");

var $hFzKD = parcelRequire("hFzKD");

var $6Jw5n = parcelRequire("6Jw5n");

var $34rZa = parcelRequire("34rZa");

var $1lC1m = parcelRequire("1lC1m");

var $9HErY = parcelRequire("9HErY");

var $gxs7E = parcelRequire("gxs7E");

var $f9WaX = parcelRequire("f9WaX");
const $236f1a66ed1dd212$var$own = {}.hasOwnProperty;
const $236f1a66ed1dd212$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $236f1a66ed1dd212$var$compiler(options)((0, $6Jw5n.postprocess)((0, $2JaIP.parse)(options).document().write((0, $hFzKD.preprocess)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $236f1a66ed1dd212$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $236f1a66ed1dd212$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($236f1a66ed1dd212$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $236f1a66ed1dd212$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $236f1a66ed1dd212$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $236f1a66ed1dd212$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $236f1a66ed1dd212$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $f9WaX.stringifyPosition)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $236f1a66ed1dd212$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $236f1a66ed1dd212$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $apdnY.toString)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $236f1a66ed1dd212$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $236f1a66ed1dd212$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $1lC1m.decodeString)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $9HErY.normalizeIdentifier)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $9HErY.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $34rZa.decodeNumericCharacterReference)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $gxs7E.decodeNamedCharacterReference)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $236f1a66ed1dd212$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $236f1a66ed1dd212$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $236f1a66ed1dd212$var$configure(combined, value);
        else $236f1a66ed1dd212$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $236f1a66ed1dd212$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($236f1a66ed1dd212$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $236f1a66ed1dd212$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $f9WaX.stringifyPosition)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $f9WaX.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $f9WaX.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}

});
parcelRegister("apdnY", function(module, exports) {

$parcel$export(module.exports, "toString", () => $79369f5237095e86$export$f84e8e69fd4488a5);
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $79369f5237095e86$var$emptyOptions = {};
function $79369f5237095e86$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $79369f5237095e86$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $79369f5237095e86$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $79369f5237095e86$var$one(value, includeImageAlt, includeHtml) {
    if ($79369f5237095e86$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $79369f5237095e86$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $79369f5237095e86$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $79369f5237095e86$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $79369f5237095e86$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $79369f5237095e86$var$node(value) {
    return Boolean(value && typeof value === "object");
}

});

parcelRegister("2JaIP", function(module, exports) {

$parcel$export(module.exports, "parse", () => $1fc819ea965a3f81$export$98e6a39c04603d36);
/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
var $1BzS9 = parcelRequire("1BzS9");

var $1YYHd = parcelRequire("1YYHd");

var $4vIRz = parcelRequire("4vIRz");

var $jugKX = parcelRequire("jugKX");

var $2JBld = parcelRequire("2JBld");

var $6oDSH = parcelRequire("6oDSH");

var $8tRNW = parcelRequire("8tRNW");
function $1fc819ea965a3f81$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $1BzS9.combineExtensions)([
        $8tRNW,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $1YYHd.content)),
        document: create((0, $4vIRz.document)),
        flow: create((0, $jugKX.flow)),
        string: create((0, $2JBld.string)),
        text: create((0, $2JBld.text))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $6oDSH.createTokenizer)(parser, initial, from);
        }
    }
}

});
parcelRegister("1BzS9", function(module, exports) {

$parcel$export(module.exports, "combineExtensions", () => $12b512a5203a7cce$export$86a865d89ef3c690);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ 
var $Ux2lp = parcelRequire("Ux2lp");
const $12b512a5203a7cce$var$hasOwnProperty = {}.hasOwnProperty;
function $12b512a5203a7cce$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$12b512a5203a7cce$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $12b512a5203a7cce$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$12b512a5203a7cce$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $12b512a5203a7cce$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $12b512a5203a7cce$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $Ux2lp.splice)(existing, 0, 0, before);
}
function $12b512a5203a7cce$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$12b512a5203a7cce$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $12b512a5203a7cce$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}

});
parcelRegister("Ux2lp", function(module, exports) {

$parcel$export(module.exports, "splice", () => $0a9edb7ff3ef159f$export$869882364835d202);
$parcel$export(module.exports, "push", () => $0a9edb7ff3ef159f$export$4cbf152802aa238);
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $0a9edb7ff3ef159f$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $0a9edb7ff3ef159f$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $0a9edb7ff3ef159f$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}

});


parcelRegister("1YYHd", function(module, exports) {

$parcel$export(module.exports, "content", () => $171a79fbb1402b9a$export$a7db06668cad9adb);
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $171a79fbb1402b9a$export$a7db06668cad9adb = {
    tokenize: $171a79fbb1402b9a$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $171a79fbb1402b9a$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $8GWoH.factorySpace)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}

});
parcelRegister("8GWoH", function(module, exports) {

$parcel$export(module.exports, "factorySpace", () => $653f8b80711d97d0$export$ae105c1eb063a0a2);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $653f8b80711d97d0$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $5Lprs.markdownSpace)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}

});
parcelRegister("5Lprs", function(module, exports) {

$parcel$export(module.exports, "asciiAlpha", () => $432513c48b12fdfc$export$d65d6b62c24d5436);
$parcel$export(module.exports, "asciiAlphanumeric", () => $432513c48b12fdfc$export$75c76db11865a9f4);
$parcel$export(module.exports, "asciiAtext", () => $432513c48b12fdfc$export$4397998b34fe597d);
$parcel$export(module.exports, "asciiControl", () => $432513c48b12fdfc$export$67dbf494fc8394df);
$parcel$export(module.exports, "asciiDigit", () => $432513c48b12fdfc$export$ca8b5b1a6c320e6e);
$parcel$export(module.exports, "asciiHexDigit", () => $432513c48b12fdfc$export$eca2752363989806);
$parcel$export(module.exports, "asciiPunctuation", () => $432513c48b12fdfc$export$35794a7d1db99380);
$parcel$export(module.exports, "markdownLineEnding", () => $432513c48b12fdfc$export$34a1dff1c0936953);
$parcel$export(module.exports, "markdownLineEndingOrSpace", () => $432513c48b12fdfc$export$a30284361b3814b7);
$parcel$export(module.exports, "markdownSpace", () => $432513c48b12fdfc$export$2c6cf65c1127992a);
$parcel$export(module.exports, "unicodePunctuation", () => $432513c48b12fdfc$export$aa04114dd888a7a0);
$parcel$export(module.exports, "unicodeWhitespace", () => $432513c48b12fdfc$export$a0ff789c034ffdf4);
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
var $1Vlly = parcelRequire("1Vlly");
const $432513c48b12fdfc$export$d65d6b62c24d5436 = $432513c48b12fdfc$var$regexCheck(/[A-Za-z]/);
const $432513c48b12fdfc$export$75c76db11865a9f4 = $432513c48b12fdfc$var$regexCheck(/[\dA-Za-z]/);
const $432513c48b12fdfc$export$4397998b34fe597d = $432513c48b12fdfc$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $432513c48b12fdfc$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $432513c48b12fdfc$export$ca8b5b1a6c320e6e = $432513c48b12fdfc$var$regexCheck(/\d/);
const $432513c48b12fdfc$export$eca2752363989806 = $432513c48b12fdfc$var$regexCheck(/[\dA-Fa-f]/);
const $432513c48b12fdfc$export$35794a7d1db99380 = $432513c48b12fdfc$var$regexCheck(/[!-/:-@[-`{-~]/);
function $432513c48b12fdfc$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $432513c48b12fdfc$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $432513c48b12fdfc$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $432513c48b12fdfc$export$aa04114dd888a7a0 = $432513c48b12fdfc$var$regexCheck((0, $1Vlly.unicodePunctuationRegex));
const $432513c48b12fdfc$export$a0ff789c034ffdf4 = $432513c48b12fdfc$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $432513c48b12fdfc$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}

});
parcelRegister("1Vlly", function(module, exports) {

$parcel$export(module.exports, "unicodePunctuationRegex", () => $166bac51b6e2a8af$export$85b5101f24802e8c);
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $166bac51b6e2a8af$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;

});




parcelRegister("4vIRz", function(module, exports) {

$parcel$export(module.exports, "document", () => $348cdb85d1aeadd1$export$5a7bfc01df82fcd1);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");
const $348cdb85d1aeadd1$export$5a7bfc01df82fcd1 = {
    tokenize: $348cdb85d1aeadd1$var$initializeDocument
};
/** @type {Construct} */ const $348cdb85d1aeadd1$var$containerConstruct = {
    tokenize: $348cdb85d1aeadd1$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $348cdb85d1aeadd1$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $Ux2lp.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($348cdb85d1aeadd1$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($348cdb85d1aeadd1$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $Ux2lp.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $348cdb85d1aeadd1$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $8GWoH.factorySpace)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}

});

parcelRegister("jugKX", function(module, exports) {

$parcel$export(module.exports, "flow", () => $e2fdd11cbe455c51$export$ccc7b0636abaffc3);
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 
var $eRfeJ = parcelRequire("eRfeJ");
var $j7la5 = parcelRequire("j7la5");

var $8GWoH = parcelRequire("8GWoH");

const $e2fdd11cbe455c51$export$ccc7b0636abaffc3 = {
    tokenize: $e2fdd11cbe455c51$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $e2fdd11cbe455c51$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $eRfeJ.blankLine), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $8GWoH.factorySpace)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $j7la5.content), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}

});
parcelRegister("eRfeJ", function(module, exports) {

$parcel$export(module.exports, "blankLine", () => $ad11d598ddddec2e$export$d50d28ce3ab2a612);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $ad11d598ddddec2e$export$d50d28ce3ab2a612 = {
    tokenize: $ad11d598ddddec2e$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ad11d598ddddec2e$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $5Lprs.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});

parcelRegister("j7la5", function(module, exports) {

$parcel$export(module.exports, "content", () => $deaf16079a1807fb$export$a7db06668cad9adb);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $iNbDn = parcelRequire("iNbDn");
const $deaf16079a1807fb$export$a7db06668cad9adb = {
    tokenize: $deaf16079a1807fb$var$tokenizeContent,
    resolve: $deaf16079a1807fb$var$resolveContent
};
/** @type {Construct} */ const $deaf16079a1807fb$var$continuationConstruct = {
    tokenize: $deaf16079a1807fb$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $deaf16079a1807fb$var$resolveContent(events) {
    (0, $iNbDn.subtokenize)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $deaf16079a1807fb$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $5Lprs.markdownLineEnding)(code)) return effects.check($deaf16079a1807fb$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $deaf16079a1807fb$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $8GWoH.factorySpace)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}

});
parcelRegister("iNbDn", function(module, exports) {

$parcel$export(module.exports, "subtokenize", () => $dae5d3de466990fa$export$12949d1dd00fddf4);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
var $Ux2lp = parcelRequire("Ux2lp");
function $dae5d3de466990fa$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $dae5d3de466990fa$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $Ux2lp.splice)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $dae5d3de466990fa$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $Ux2lp.splice)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}

});



parcelRegister("2JBld", function(module, exports) {

$parcel$export(module.exports, "resolver", () => $1fdcbfee479a4092$export$50397835cbfdbc24);
$parcel$export(module.exports, "string", () => $1fdcbfee479a4092$export$22b082955e083ec3);
$parcel$export(module.exports, "text", () => $1fdcbfee479a4092$export$6f093cfa640b7166);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $1fdcbfee479a4092$export$50397835cbfdbc24 = {
    resolveAll: $1fdcbfee479a4092$var$createResolver()
};
const $1fdcbfee479a4092$export$22b082955e083ec3 = $1fdcbfee479a4092$var$initializeFactory("string");
const $1fdcbfee479a4092$export$6f093cfa640b7166 = $1fdcbfee479a4092$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $1fdcbfee479a4092$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $1fdcbfee479a4092$var$createResolver(field === "text" ? $1fdcbfee479a4092$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $1fdcbfee479a4092$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $1fdcbfee479a4092$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}

});

parcelRegister("6oDSH", function(module, exports) {

$parcel$export(module.exports, "createTokenizer", () => $4a83eb91ec5d6b95$export$ae34f10ee4b29837);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 
var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");

var $8f02Z = parcelRequire("8f02Z");
function $4a83eb91ec5d6b95$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $Ux2lp.push)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $8f02Z.resolveAll)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $4a83eb91ec5d6b95$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $4a83eb91ec5d6b95$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $Ux2lp.splice)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $4a83eb91ec5d6b95$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $4a83eb91ec5d6b95$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}

});
parcelRegister("8f02Z", function(module, exports) {

$parcel$export(module.exports, "resolveAll", () => $5fffc2d235733349$export$3ff61ec196ff408b);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $5fffc2d235733349$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}

});


parcelRegister("8tRNW", function(module, exports) {

$parcel$export(module.exports, "document", () => $62cac499df3c25a0$export$5a7bfc01df82fcd1);
$parcel$export(module.exports, "contentInitial", () => $62cac499df3c25a0$export$5a2181fb44b58173);
$parcel$export(module.exports, "flowInitial", () => $62cac499df3c25a0$export$cf8bead395eff824);
$parcel$export(module.exports, "flow", () => $62cac499df3c25a0$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "string", () => $62cac499df3c25a0$export$22b082955e083ec3);
$parcel$export(module.exports, "text", () => $62cac499df3c25a0$export$6f093cfa640b7166);
$parcel$export(module.exports, "insideSpan", () => $62cac499df3c25a0$export$d44f260a3f9b69f5);
$parcel$export(module.exports, "attentionMarkers", () => $62cac499df3c25a0$export$b9c0b60d74426aea);
$parcel$export(module.exports, "disable", () => $62cac499df3c25a0$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ 
var $eIIGZ = parcelRequire("eIIGZ");
var $807ia = parcelRequire("807ia");
var $acnAX = parcelRequire("acnAX");
var $7ITXU = parcelRequire("7ITXU");
var $hIELq = parcelRequire("hIELq");
var $2qoAc = parcelRequire("2qoAc");
var $eHPOy = parcelRequire("eHPOy");
var $1XgoW = parcelRequire("1XgoW");
var $ix9Ua = parcelRequire("ix9Ua");
var $1d2Fb = parcelRequire("1d2Fb");
var $e7bPJ = parcelRequire("e7bPJ");
var $aMDJK = parcelRequire("aMDJK");
var $fAOFU = parcelRequire("fAOFU");
var $2yvw6 = parcelRequire("2yvw6");
var $l3YSx = parcelRequire("l3YSx");
var $ifBjz = parcelRequire("ifBjz");
var $9shNq = parcelRequire("9shNq");
var $7twjg = parcelRequire("7twjg");
var $cfK44 = parcelRequire("cfK44");
var $eBJ0T = parcelRequire("eBJ0T");

var $2JBld = parcelRequire("2JBld");
const $62cac499df3c25a0$export$5a7bfc01df82fcd1 = {
    [42]: (0, $7twjg.list),
    [43]: (0, $7twjg.list),
    [45]: (0, $7twjg.list),
    [48]: (0, $7twjg.list),
    [49]: (0, $7twjg.list),
    [50]: (0, $7twjg.list),
    [51]: (0, $7twjg.list),
    [52]: (0, $7twjg.list),
    [53]: (0, $7twjg.list),
    [54]: (0, $7twjg.list),
    [55]: (0, $7twjg.list),
    [56]: (0, $7twjg.list),
    [57]: (0, $7twjg.list),
    [62]: (0, $acnAX.blockQuote)
};
const $62cac499df3c25a0$export$5a2181fb44b58173 = {
    [91]: (0, $ix9Ua.definition)
};
const $62cac499df3c25a0$export$cf8bead395eff824 = {
    [-2]: (0, $eHPOy.codeIndented),
    [-1]: (0, $eHPOy.codeIndented),
    [32]: (0, $eHPOy.codeIndented)
};
const $62cac499df3c25a0$export$ccc7b0636abaffc3 = {
    [35]: (0, $e7bPJ.headingAtx),
    [42]: (0, $eBJ0T.thematicBreak),
    [45]: [
        (0, $cfK44.setextUnderline),
        (0, $eBJ0T.thematicBreak)
    ],
    [60]: (0, $aMDJK.htmlFlow),
    [61]: (0, $cfK44.setextUnderline),
    [95]: (0, $eBJ0T.thematicBreak),
    [96]: (0, $2qoAc.codeFenced),
    [126]: (0, $2qoAc.codeFenced)
};
const $62cac499df3c25a0$export$22b082955e083ec3 = {
    [38]: (0, $hIELq.characterReference),
    [92]: (0, $7ITXU.characterEscape)
};
const $62cac499df3c25a0$export$6f093cfa640b7166 = {
    [-5]: (0, $9shNq.lineEnding),
    [-4]: (0, $9shNq.lineEnding),
    [-3]: (0, $9shNq.lineEnding),
    [33]: (0, $l3YSx.labelStartImage),
    [38]: (0, $hIELq.characterReference),
    [42]: (0, $eIIGZ.attention),
    [60]: [
        (0, $807ia.autolink),
        (0, $fAOFU.htmlText)
    ],
    [91]: (0, $ifBjz.labelStartLink),
    [92]: [
        (0, $1d2Fb.hardBreakEscape),
        (0, $7ITXU.characterEscape)
    ],
    [93]: (0, $2yvw6.labelEnd),
    [95]: (0, $eIIGZ.attention),
    [96]: (0, $1XgoW.codeText)
};
const $62cac499df3c25a0$export$d44f260a3f9b69f5 = {
    null: [
        (0, $eIIGZ.attention),
        (0, $2JBld.resolver)
    ]
};
const $62cac499df3c25a0$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $62cac499df3c25a0$export$e20fbacbb41798b = {
    null: []
};

});
parcelRegister("eIIGZ", function(module, exports) {

$parcel$export(module.exports, "attention", () => $ab77d7b684ccca7a$export$45b92471da762af7);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $Ux2lp = parcelRequire("Ux2lp");

var $i5TSH = parcelRequire("i5TSH");

var $8f02Z = parcelRequire("8f02Z");
const $ab77d7b684ccca7a$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $ab77d7b684ccca7a$var$tokenizeAttention,
    resolveAll: $ab77d7b684ccca7a$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $ab77d7b684ccca7a$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $ab77d7b684ccca7a$var$movePoint(start, -use);
            $ab77d7b684ccca7a$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $Ux2lp.push)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $Ux2lp.push)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $Ux2lp.push)(nextEvents, (0, $8f02Z.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $Ux2lp.push)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $Ux2lp.push)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $Ux2lp.splice)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ab77d7b684ccca7a$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $i5TSH.classifyCharacter)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $i5TSH.classifyCharacter)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $ab77d7b684ccca7a$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

});
parcelRegister("i5TSH", function(module, exports) {

$parcel$export(module.exports, "classifyCharacter", () => $d2c40a75b3c1060a$export$e3902bc0d835cad0);
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $d2c40a75b3c1060a$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $5Lprs.markdownLineEndingOrSpace)(code) || (0, $5Lprs.unicodeWhitespace)(code)) return 1;
    if ((0, $5Lprs.unicodePunctuation)(code)) return 2;
}

});


parcelRegister("807ia", function(module, exports) {

$parcel$export(module.exports, "autolink", () => $5d33fad6991aa1ad$export$17ddf85e4c916ad6);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $5d33fad6991aa1ad$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $5d33fad6991aa1ad$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5d33fad6991aa1ad$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $5Lprs.asciiAlphanumeric)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $5Lprs.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $5Lprs.asciiAtext)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $5Lprs.asciiAlphanumeric)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

});

parcelRegister("acnAX", function(module, exports) {

$parcel$export(module.exports, "blockQuote", () => $76cd53d8c5b717c4$export$200dcd0a5903c968);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $76cd53d8c5b717c4$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation
    },
    exit: $76cd53d8c5b717c4$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $5Lprs.markdownSpace)(code)) // Always populated by defaults.
        return (0, $8GWoH.factorySpace)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($76cd53d8c5b717c4$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $76cd53d8c5b717c4$var$exit(effects) {
    effects.exit("blockQuote");
}

});

parcelRegister("7ITXU", function(module, exports) {

$parcel$export(module.exports, "characterEscape", () => $59f80dfce403f5de$export$2005478564e78d96);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $59f80dfce403f5de$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $59f80dfce403f5de$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $59f80dfce403f5de$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $5Lprs.asciiPunctuation)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("hIELq", function(module, exports) {

$parcel$export(module.exports, "characterReference", () => $ce662a9402db28e3$export$e31905600aaf3d8e);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $gxs7E = parcelRequire("gxs7E");

var $5Lprs = parcelRequire("5Lprs");
const $ce662a9402db28e3$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $ce662a9402db28e3$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce662a9402db28e3$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $5Lprs.asciiAlphanumeric);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $5Lprs.asciiHexDigit);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $5Lprs.asciiDigit);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $5Lprs.asciiAlphanumeric) && !(0, $gxs7E.decodeNamedCharacterReference)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

});
parcelRegister("gxs7E", function(module, exports) {

$parcel$export(module.exports, "decodeNamedCharacterReference", () => $c0a58af43f6129ac$export$289b6a6320f709b4);

var $kmPXE = parcelRequire("kmPXE");
const $c0a58af43f6129ac$var$own = {}.hasOwnProperty;
function $c0a58af43f6129ac$export$289b6a6320f709b4(value) {
    return $c0a58af43f6129ac$var$own.call((0, $kmPXE.characterEntities), value) ? (0, $kmPXE.characterEntities)[value] : false;
}

});
parcelRegister("kmPXE", function(module, exports) {

$parcel$export(module.exports, "characterEntities", () => $ed3e2b2347fac27f$export$ec810d1aafce79a7);
/**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $ed3e2b2347fac27f$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};

});



parcelRegister("2qoAc", function(module, exports) {

$parcel$export(module.exports, "codeFenced", () => $1c411422dc205d23$export$c23e4921f8d87e7c);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
/** @type {Construct} */ const $1c411422dc205d23$var$nonLazyContinuation = {
    tokenize: $1c411422dc205d23$var$tokenizeNonLazyContinuation,
    partial: true
};
const $1c411422dc205d23$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $1c411422dc205d23$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1c411422dc205d23$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($1c411422dc205d23$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $8GWoH.factorySpace)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return effects.check($1c411422dc205d23$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1c411422dc205d23$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

});

parcelRegister("eHPOy", function(module, exports) {

$parcel$export(module.exports, "codeIndented", () => $ab4d46130bbbc8bd$export$47910b7ab28d1853);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $ab4d46130bbbc8bd$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $ab4d46130bbbc8bd$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $ab4d46130bbbc8bd$var$furtherStart = {
    tokenize: $ab4d46130bbbc8bd$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ab4d46130bbbc8bd$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $8GWoH.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) return effects.attempt($ab4d46130bbbc8bd$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ab4d46130bbbc8bd$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $8GWoH.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $5Lprs.markdownLineEnding)(code) ? furtherStart(code) : nok(code);
    }
}

});

parcelRegister("1XgoW", function(module, exports) {

$parcel$export(module.exports, "codeText", () => $16c806108f267846$export$d24f93e715f9df88);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $16c806108f267846$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $16c806108f267846$var$tokenizeCodeText,
    resolve: $16c806108f267846$var$resolveCodeText,
    previous: $16c806108f267846$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $16c806108f267846$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $16c806108f267846$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $16c806108f267846$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

});

parcelRegister("ix9Ua", function(module, exports) {

$parcel$export(module.exports, "definition", () => $d7e2fdfd86ff4dd4$export$69f215ed977cdb73);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $flE5d = parcelRequire("flE5d");

var $i8rQF = parcelRequire("i8rQF");

var $8GWoH = parcelRequire("8GWoH");

var $kXx8i = parcelRequire("kXx8i");

var $5Jc1R = parcelRequire("5Jc1R");

var $5Lprs = parcelRequire("5Lprs");

var $9HErY = parcelRequire("9HErY");
const $d7e2fdfd86ff4dd4$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeDefinition
};
/** @type {Construct} */ const $d7e2fdfd86ff4dd4$var$titleBefore = {
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d7e2fdfd86ff4dd4$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $i8rQF.factoryLabel).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $9HErY.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $flE5d.factoryDestination)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($d7e2fdfd86ff4dd4$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d7e2fdfd86ff4dd4$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $kXx8i.factoryTitle)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $5Lprs.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});
parcelRegister("flE5d", function(module, exports) {

$parcel$export(module.exports, "factoryDestination", () => $b2c7e8deac525d60$export$2e6c8deaa96af245);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $b2c7e8deac525d60$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $5Lprs.asciiControl)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $5Lprs.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $5Lprs.markdownLineEndingOrSpace)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $5Lprs.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}

});

parcelRegister("i8rQF", function(module, exports) {

$parcel$export(module.exports, "factoryLabel", () => $d33e937ae1ea4ed4$export$7b768614d8ba97a7);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $5Lprs = parcelRequire("5Lprs");
function $d33e937ae1ea4ed4$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $5Lprs.markdownLineEnding)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $5Lprs.markdownSpace)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}

});

parcelRegister("kXx8i", function(module, exports) {

$parcel$export(module.exports, "factoryTitle", () => $f42304cc65ff93d0$export$f970569cc855e483);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
function $f42304cc65ff93d0$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $8GWoH.factorySpace)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}

});

parcelRegister("5Jc1R", function(module, exports) {

$parcel$export(module.exports, "factoryWhitespace", () => $42ba7c725dbf102d$export$1f27bd1aa33ce173);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
function $42ba7c725dbf102d$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}

});

parcelRegister("9HErY", function(module, exports) {

$parcel$export(module.exports, "normalizeIdentifier", () => $710781c0cdec9f6d$export$806d55e226cfcd08);
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $710781c0cdec9f6d$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}

});


parcelRegister("1d2Fb", function(module, exports) {

$parcel$export(module.exports, "hardBreakEscape", () => $0e19123aa1bdeff9$export$86c573ab9e06f418);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");
const $0e19123aa1bdeff9$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $0e19123aa1bdeff9$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0e19123aa1bdeff9$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

});

parcelRegister("e7bPJ", function(module, exports) {

$parcel$export(module.exports, "headingAtx", () => $a46ae5f97ae33c5d$export$3871e9deb360695c);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");
const $a46ae5f97ae33c5d$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $a46ae5f97ae33c5d$var$tokenizeHeadingAtx,
    resolve: $a46ae5f97ae33c5d$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $a46ae5f97ae33c5d$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $Ux2lp.splice)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a46ae5f97ae33c5d$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) return (0, $8GWoH.factorySpace)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

});

parcelRegister("aMDJK", function(module, exports) {

$parcel$export(module.exports, "htmlFlow", () => $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $5Lprs = parcelRequire("5Lprs");

var $9Lzi7 = parcelRequire("9Lzi7");

var $eRfeJ = parcelRequire("eRfeJ");
const $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow,
    resolveTo: $7d9d35fac2b6ebcc$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $7d9d35fac2b6ebcc$var$blankLineBefore = {
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeBlankLineBefore,
    partial: true
};
const $7d9d35fac2b6ebcc$var$nonLazyContinuationStart = {
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $7d9d35fac2b6ebcc$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $9Lzi7.htmlRawNames).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $9Lzi7.htmlBlockNames).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $5Lprs.markdownSpace)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $5Lprs.markdownLineEnding)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($7d9d35fac2b6ebcc$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($7d9d35fac2b6ebcc$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $9Lzi7.htmlRawNames).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $5Lprs.asciiAlpha)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $eRfeJ.blankLine), ok, nok);
    }
}

});
parcelRegister("9Lzi7", function(module, exports) {

$parcel$export(module.exports, "htmlBlockNames", () => $71c3e0f388301604$export$7364aee1c59d1879);
$parcel$export(module.exports, "htmlRawNames", () => $71c3e0f388301604$export$948e66da505d080);
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $71c3e0f388301604$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $71c3e0f388301604$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];

});


parcelRegister("fAOFU", function(module, exports) {

$parcel$export(module.exports, "htmlText", () => $b5a186cf1fccfac7$export$398af27f284914fe);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $b5a186cf1fccfac7$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $b5a186cf1fccfac7$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b5a186cf1fccfac7$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $5Lprs.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $5Lprs.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $5Lprs.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $5Lprs.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

});

parcelRegister("2yvw6", function(module, exports) {

$parcel$export(module.exports, "labelEnd", () => $1dc73455d0df3be9$export$470a5dafbbf62654);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $flE5d = parcelRequire("flE5d");

var $i8rQF = parcelRequire("i8rQF");

var $kXx8i = parcelRequire("kXx8i");

var $5Jc1R = parcelRequire("5Jc1R");

var $5Lprs = parcelRequire("5Lprs");

var $Ux2lp = parcelRequire("Ux2lp");

var $9HErY = parcelRequire("9HErY");

var $8f02Z = parcelRequire("8f02Z");
const $1dc73455d0df3be9$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $1dc73455d0df3be9$var$tokenizeLabelEnd,
    resolveTo: $1dc73455d0df3be9$var$resolveToLabelEnd,
    resolveAll: $1dc73455d0df3be9$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$resourceConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeResource
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$referenceFullConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$referenceCollapsedConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $Ux2lp.push)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $Ux2lp.push)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $Ux2lp.push)(media, (0, $8f02Z.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $Ux2lp.push)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $Ux2lp.push)(media, events.slice(close + 1));
    // Media close.
    media = (0, $Ux2lp.push)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $Ux2lp.splice)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $9HErY.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($1dc73455d0df3be9$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($1dc73455d0df3be9$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($1dc73455d0df3be9$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $flE5d.factoryDestination)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $kXx8i.factoryTitle)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $5Lprs.markdownLineEndingOrSpace)(code) ? (0, $5Jc1R.factoryWhitespace)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $i8rQF.factoryLabel).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $9HErY.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("l3YSx", function(module, exports) {

$parcel$export(module.exports, "labelStartImage", () => $f5591a0a77ea393a$export$3d754936e25aa5f5);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $2yvw6 = parcelRequire("2yvw6");
const $f5591a0a77ea393a$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $f5591a0a77ea393a$var$tokenizeLabelStartImage,
    resolveAll: (0, $2yvw6.labelEnd).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f5591a0a77ea393a$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("ifBjz", function(module, exports) {

$parcel$export(module.exports, "labelStartLink", () => $d496929de41504d8$export$5c0cee0701a3b584);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $2yvw6 = parcelRequire("2yvw6");
const $d496929de41504d8$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $d496929de41504d8$var$tokenizeLabelStartLink,
    resolveAll: (0, $2yvw6.labelEnd).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d496929de41504d8$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("9shNq", function(module, exports) {

$parcel$export(module.exports, "lineEnding", () => $6e24888a23d546e6$export$8e62e0ad51c97b2);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

const $6e24888a23d546e6$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $6e24888a23d546e6$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6e24888a23d546e6$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $8GWoH.factorySpace)(effects, ok, "linePrefix");
    }
}

});

parcelRegister("7twjg", function(module, exports) {

$parcel$export(module.exports, "list", () => $57144dde063f82cb$export$8837f4fc672e936d);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");

var $eRfeJ = parcelRequire("eRfeJ");

var $eBJ0T = parcelRequire("eBJ0T");
const $57144dde063f82cb$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $57144dde063f82cb$var$tokenizeListStart,
    continuation: {
        tokenize: $57144dde063f82cb$var$tokenizeListContinuation
    },
    exit: $57144dde063f82cb$var$tokenizeListEnd
};
/** @type {Construct} */ const $57144dde063f82cb$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $57144dde063f82cb$var$indentConstruct = {
    tokenize: $57144dde063f82cb$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $5Lprs.asciiDigit)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $eBJ0T.thematicBreak), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $5Lprs.asciiDigit)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $eRfeJ.blankLine), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($57144dde063f82cb$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $5Lprs.markdownSpace)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $eRfeJ.blankLine), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $8GWoH.factorySpace)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $5Lprs.markdownSpace)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($57144dde063f82cb$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $8GWoH.factorySpace)(effects, effects.attempt($57144dde063f82cb$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $8GWoH.factorySpace)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $8GWoH.factorySpace)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $5Lprs.markdownSpace)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

});
parcelRegister("eBJ0T", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $aa27701f1509407c$export$ba7b13e047416c03);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $aa27701f1509407c$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $aa27701f1509407c$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $aa27701f1509407c$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $5Lprs.markdownLineEnding)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}

});


parcelRegister("cfK44", function(module, exports) {

$parcel$export(module.exports, "setextUnderline", () => $8eba9e38644cd781$export$e104e2de391dfde9);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8GWoH = parcelRequire("8GWoH");

var $5Lprs = parcelRequire("5Lprs");
const $8eba9e38644cd781$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $8eba9e38644cd781$var$tokenizeSetextUnderline,
    resolveTo: $8eba9e38644cd781$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $8eba9e38644cd781$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8eba9e38644cd781$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $5Lprs.markdownSpace)(code) ? (0, $8GWoH.factorySpace)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $5Lprs.markdownLineEnding)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}

});



parcelRegister("hFzKD", function(module, exports) {

$parcel$export(module.exports, "preprocess", () => $cdd1ff6afd8515e5$export$fc37fe19dfda43ee);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $cdd1ff6afd8515e5$var$search = /[\0\t\n\r]/g;
function $cdd1ff6afd8515e5$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $cdd1ff6afd8515e5$var$search.lastIndex = startPosition;
            match = $cdd1ff6afd8515e5$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}

});

parcelRegister("6Jw5n", function(module, exports) {

$parcel$export(module.exports, "postprocess", () => $4e6fd59d488c6494$export$bd0e6e1378a871d7);
/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
var $iNbDn = parcelRequire("iNbDn");
function $4e6fd59d488c6494$export$bd0e6e1378a871d7(events) {
    while(!(0, $iNbDn.subtokenize)(events));
    return events;
}

});

parcelRegister("34rZa", function(module, exports) {

$parcel$export(module.exports, "decodeNumericCharacterReference", () => $23c7742930bb7617$export$15a69557afac2c20);
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $23c7742930bb7617$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}

});

parcelRegister("1lC1m", function(module, exports) {

$parcel$export(module.exports, "decodeString", () => $0fb53ec7385928f9$export$a0fb664af7d0cc44);

var $gxs7E = parcelRequire("gxs7E");

var $34rZa = parcelRequire("34rZa");
const $0fb53ec7385928f9$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $0fb53ec7385928f9$export$a0fb664af7d0cc44(value) {
    return value.replace($0fb53ec7385928f9$var$characterEscapeOrReference, $0fb53ec7385928f9$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $0fb53ec7385928f9$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $34rZa.decodeNumericCharacterReference)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $gxs7E.decodeNamedCharacterReference)($2) || $0;
}

});



parcelRegister("kMNw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f21eb379270d044c$export$2e2bcd8739ae039);
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ 
var $jLZ37 = parcelRequire("jLZ37");
// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $f21eb379270d044c$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $f21eb379270d044c$var$bridge(destination, options) : $f21eb379270d044c$var$mutate(destination || options);
};
var $f21eb379270d044c$export$2e2bcd8739ae039 = $f21eb379270d044c$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $f21eb379270d044c$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $jLZ37.toHast)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $f21eb379270d044c$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $jLZ37.toHast)(node, options);
}

});
parcelRegister("jLZ37", function(module, exports) {

$parcel$export(module.exports, "toHast", () => $e651c33bf4085f1d$export$c0e4c5cf07538633);
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ 
var $5OlNN = parcelRequire("5OlNN");

var $19i3Z = parcelRequire("19i3Z");
function $e651c33bf4085f1d$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $19i3Z.createState)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $5OlNN.footer)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}

});
parcelRegister("5OlNN", function(module, exports) {

$parcel$export(module.exports, "footer", () => $43b288b5d784432f$export$adb608be33961c98);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $43b288b5d784432f$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $8sB1o.normalizeUri)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}

});
parcelRegister("8sB1o", function(module, exports) {

$parcel$export(module.exports, "normalizeUri", () => $628da7f4dfdef27c$export$e42a3e39590d28b5);

var $5Lprs = parcelRequire("5Lprs");

var $8OFFA = parcelRequire("8OFFA");
function $628da7f4dfdef27c$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $8OFFA.encode)($628da7f4dfdef27c$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $628da7f4dfdef27c$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $5Lprs.asciiAlphanumeric)(value.charCodeAt(index + 1)) && (0, $5Lprs.asciiAlphanumeric)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}

});
parcelRegister("8OFFA", function(module, exports) {

$parcel$export(module.exports, "encode", () => $66b350feb28b9f84$export$c564cdbbe6da493);
const $66b350feb28b9f84$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $66b350feb28b9f84$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $66b350feb28b9f84$var$characterReferences[value] + ";";
    }
}

});



parcelRegister("19i3Z", function(module, exports) {

$parcel$export(module.exports, "createState", () => $0d64a4b488f7bd12$export$e6a0daad8304de);
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ 
var $6qkIL = parcelRequire("6qkIL");

var $g7Bfx = parcelRequire("g7Bfx");

var $3ZDbL = parcelRequire("3ZDbL");

var $jyH67 = parcelRequire("jyH67");

var $2YRmg = parcelRequire("2YRmg");
const $0d64a4b488f7bd12$var$own = {}.hasOwnProperty;
function $0d64a4b488f7bd12$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $2YRmg.handlers),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $jyH67.definitions)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $0d64a4b488f7bd12$var$patch;
    state.applyData = $0d64a4b488f7bd12$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $0d64a4b488f7bd12$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $6qkIL.visit)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$0d64a4b488f7bd12$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $3ZDbL.generated)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $g7Bfx.pointStart)(ctx),
                end: (0, $g7Bfx.pointEnd)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $0d64a4b488f7bd12$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $0d64a4b488f7bd12$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $0d64a4b488f7bd12$var$patch(from, to) {
    if (from.position) to.position = (0, $g7Bfx.position)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $0d64a4b488f7bd12$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $0d64a4b488f7bd12$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($0d64a4b488f7bd12$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $0d64a4b488f7bd12$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $0d64a4b488f7bd12$var$defaultUnknownHandler(state, node);
}
function $0d64a4b488f7bd12$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $0d64a4b488f7bd12$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $0d64a4b488f7bd12$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($0d64a4b488f7bd12$var$own.call(data, "hProperties") || $0d64a4b488f7bd12$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $0d64a4b488f7bd12$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $0d64a4b488f7bd12$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}

});
parcelRegister("6qkIL", function(module, exports) {

$parcel$export(module.exports, "visit", () => $4ad53e9051b55a53$export$bf638b60ea8b89b7);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ 
var $imX1f = parcelRequire("imX1f");
const $4ad53e9051b55a53$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $imX1f.visitParents)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};

});
parcelRegister("imX1f", function(module, exports) {

$parcel$export(module.exports, "visitParents", () => $d5f8100665f1cd06$export$70008a21eb6de899);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ 
var $cWBD6 = parcelRequire("cWBD6");

var $23Fte = parcelRequire("23Fte");
const $d5f8100665f1cd06$export$f4d8133c446fe484 = true;
const $d5f8100665f1cd06$export$7f100f842f565dc9 = false;
const $d5f8100665f1cd06$export$8773f85c2fb2c116 = "skip";
const $d5f8100665f1cd06$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $cWBD6.convert)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $23Fte.color)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $d5f8100665f1cd06$var$toResult(visitor(node, parents));
                if (result[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $d5f8100665f1cd06$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $d5f8100665f1cd06$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $d5f8100665f1cd06$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("cWBD6", function(module, exports) {

$parcel$export(module.exports, "convert", () => $96c8174c61624bc3$export$9c68d69a4c5bbcf9);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $96c8174c61624bc3$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $96c8174c61624bc3$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $96c8174c61624bc3$var$ok;
    if (typeof test === "string") return $96c8174c61624bc3$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $96c8174c61624bc3$var$anyFactory(test) : $96c8174c61624bc3$var$propsFactory(test);
    if (typeof test === "function") return $96c8174c61624bc3$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(tests[index]);
    return $96c8174c61624bc3$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$propsFactory(check) {
    return $96c8174c61624bc3$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$typeFactory(check) {
    return $96c8174c61624bc3$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $96c8174c61624bc3$var$ok() {
    return true;
}

});

parcelRegister("23Fte", function(module, exports) {

$parcel$export(module.exports, "color", () => $17fc07be418e6e2a$export$35e9368ef982300f);
/**
 * @param {string} d
 * @returns {string}
 */ function $17fc07be418e6e2a$export$35e9368ef982300f(d) {
    return d;
}

});



parcelRegister("g7Bfx", function(module, exports) {

$parcel$export(module.exports, "pointStart", () => $bbca31c5046a61f5$export$771bf3e4949bfbee);
$parcel$export(module.exports, "pointEnd", () => $bbca31c5046a61f5$export$da309cdce9dc2a25);
$parcel$export(module.exports, "position", () => $bbca31c5046a61f5$export$5880b8b5730aff45);
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $bbca31c5046a61f5$export$771bf3e4949bfbee = $bbca31c5046a61f5$var$point("start");
const $bbca31c5046a61f5$export$da309cdce9dc2a25 = $bbca31c5046a61f5$var$point("end");
function $bbca31c5046a61f5$export$5880b8b5730aff45(node) {
    return {
        start: $bbca31c5046a61f5$export$771bf3e4949bfbee(node),
        end: $bbca31c5046a61f5$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $bbca31c5046a61f5$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}

});

parcelRegister("3ZDbL", function(module, exports) {

$parcel$export(module.exports, "generated", () => $2e8577aa1764555c$export$41ad1363166ec91a);
/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $2e8577aa1764555c$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

});

parcelRegister("jyH67", function(module, exports) {

$parcel$export(module.exports, "definitions", () => $e3d29f9dd459ad71$export$d79264f26953ec1);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
var $6qkIL = parcelRequire("6qkIL");
const $e3d29f9dd459ad71$var$own = {}.hasOwnProperty;
function $e3d29f9dd459ad71$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $6qkIL.visit)(tree, "definition", (definition)=>{
        const id = $e3d29f9dd459ad71$var$clean(definition.identifier);
        if (id && !$e3d29f9dd459ad71$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $e3d29f9dd459ad71$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $e3d29f9dd459ad71$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $e3d29f9dd459ad71$var$clean(value) {
    return String(value || "").toUpperCase();
}

});

parcelRegister("2YRmg", function(module, exports) {

$parcel$export(module.exports, "handlers", () => $22ba932f8fab6e62$export$455ce229eb3d2472);

var $19M7I = parcelRequire("19M7I");

var $8csaV = parcelRequire("8csaV");

var $dGTos = parcelRequire("dGTos");

var $6OXI0 = parcelRequire("6OXI0");

var $9L7N6 = parcelRequire("9L7N6");

var $hT1R6 = parcelRequire("hT1R6");

var $fmRjw = parcelRequire("fmRjw");

var $b2FpY = parcelRequire("b2FpY");

var $ebILQ = parcelRequire("ebILQ");

var $4xDW2 = parcelRequire("4xDW2");

var $ltxKP = parcelRequire("ltxKP");

var $dRX9X = parcelRequire("dRX9X");

var $8eXiN = parcelRequire("8eXiN");

var $d1oC8 = parcelRequire("d1oC8");

var $11GXx = parcelRequire("11GXx");

var $9nVoC = parcelRequire("9nVoC");

var $5hX5r = parcelRequire("5hX5r");

var $cxBlE = parcelRequire("cxBlE");

var $ad65M = parcelRequire("ad65M");

var $glYDL = parcelRequire("glYDL");

var $jbsRM = parcelRequire("jbsRM");

var $fyvzs = parcelRequire("fyvzs");

var $hdLPH = parcelRequire("hdLPH");

var $cnGZN = parcelRequire("cnGZN");
const $22ba932f8fab6e62$export$455ce229eb3d2472 = {
    blockquote: $19M7I.blockquote,
    break: (0, $8csaV.hardBreak),
    code: $dGTos.code,
    delete: (0, $6OXI0.strikethrough),
    emphasis: $9L7N6.emphasis,
    footnoteReference: $hT1R6.footnoteReference,
    footnote: $fmRjw.footnote,
    heading: $b2FpY.heading,
    html: $ebILQ.html,
    imageReference: $4xDW2.imageReference,
    image: $ltxKP.image,
    inlineCode: $dRX9X.inlineCode,
    linkReference: $8eXiN.linkReference,
    link: $d1oC8.link,
    listItem: $11GXx.listItem,
    list: $9nVoC.list,
    paragraph: $5hX5r.paragraph,
    root: $cxBlE.root,
    strong: $ad65M.strong,
    table: $glYDL.table,
    tableCell: $fyvzs.tableCell,
    tableRow: $jbsRM.tableRow,
    text: $hdLPH.text,
    thematicBreak: $cnGZN.thematicBreak,
    toml: $22ba932f8fab6e62$var$ignore,
    yaml: $22ba932f8fab6e62$var$ignore,
    definition: $22ba932f8fab6e62$var$ignore,
    footnoteDefinition: $22ba932f8fab6e62$var$ignore
};
// Return nothing for nodes that are ignored.
function $22ba932f8fab6e62$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}

});
parcelRegister("19M7I", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $0d7bf6069cd4a99d$export$67dc04e652a298ca);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $0d7bf6069cd4a99d$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("8csaV", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $5f854cb469f7f6cd$export$371da9dd35aba193);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $5f854cb469f7f6cd$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}

});

parcelRegister("dGTos", function(module, exports) {

$parcel$export(module.exports, "code", () => $9f7a2a9a3e8cdc0a$export$6565f9f03506010b);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9f7a2a9a3e8cdc0a$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}

});

parcelRegister("6OXI0", function(module, exports) {

$parcel$export(module.exports, "strikethrough", () => $4f75ba80b35d3487$export$19426ff118fe8be);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $4f75ba80b35d3487$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("9L7N6", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $71ae8bf40e51fddd$export$bef81ba411953b51);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $71ae8bf40e51fddd$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("hT1R6", function(module, exports) {

$parcel$export(module.exports, "footnoteReference", () => $d059032a2037e72d$export$7f87ee744075c1ba);
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $d059032a2037e72d$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $8sB1o.normalizeUri)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}

});

parcelRegister("fmRjw", function(module, exports) {

$parcel$export(module.exports, "footnote", () => $b302441aef2a42d1$export$3b6a720baa2c20ec);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
var $hT1R6 = parcelRequire("hT1R6");
function $b302441aef2a42d1$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $hT1R6.footnoteReference)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("b2FpY", function(module, exports) {

$parcel$export(module.exports, "heading", () => $80a0025fee2734a4$export$46e4a324ac90507f);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $80a0025fee2734a4$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ebILQ", function(module, exports) {

$parcel$export(module.exports, "html", () => $a544d24f31a6d015$export$c0bb0b647f701bb5);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $a544d24f31a6d015$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}

});

parcelRegister("4xDW2", function(module, exports) {

$parcel$export(module.exports, "imageReference", () => $34e938c73615b97e$export$f281796f6bc3b8db);
/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");

var $5XWq3 = parcelRequire("5XWq3");
function $34e938c73615b97e$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $5XWq3.revert)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $8sB1o.normalizeUri)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("5XWq3", function(module, exports) {

$parcel$export(module.exports, "revert", () => $457fc7453091eab4$export$3fdd26f3d9e7dc78);
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $457fc7453091eab4$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}

});


parcelRegister("ltxKP", function(module, exports) {

$parcel$export(module.exports, "image", () => $fa267d4e016e1a94$export$5c452ff88e35e47d);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $fa267d4e016e1a94$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $8sB1o.normalizeUri)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("dRX9X", function(module, exports) {

$parcel$export(module.exports, "inlineCode", () => $a18e1d7c380780d4$export$91b9bee19a0d8569);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $a18e1d7c380780d4$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("8eXiN", function(module, exports) {

$parcel$export(module.exports, "linkReference", () => $5ffda1b647f76013$export$e6c469b1b7b2bc6a);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");

var $5XWq3 = parcelRequire("5XWq3");
function $5ffda1b647f76013$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $5XWq3.revert)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $8sB1o.normalizeUri)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("d1oC8", function(module, exports) {

$parcel$export(module.exports, "link", () => $97ae763275816d1f$export$9c30223ca0a664fb);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
var $8sB1o = parcelRequire("8sB1o");
function $97ae763275816d1f$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $8sB1o.normalizeUri)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("11GXx", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $0bf735405dac3389$export$76c7e83ecc9cdf05);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $0bf735405dac3389$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $0bf735405dac3389$var$listLoose(parent) : $0bf735405dac3389$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $0bf735405dac3389$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("9nVoC", function(module, exports) {

$parcel$export(module.exports, "list", () => $6d52c8b65c22a0f3$export$8837f4fc672e936d);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6d52c8b65c22a0f3$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("5hX5r", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3d9c5fb20df8334b$export$9c206ddddb32a9b);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3d9c5fb20df8334b$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("cxBlE", function(module, exports) {

$parcel$export(module.exports, "root", () => $921589a7f49d4b71$export$e8e78c978b129247);
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $921589a7f49d4b71$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ad65M", function(module, exports) {

$parcel$export(module.exports, "strong", () => $76efd80b61faffa2$export$59ae2c325a998f89);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $76efd80b61faffa2$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("glYDL", function(module, exports) {

$parcel$export(module.exports, "table", () => $be7da570dd44e9e6$export$9852986a3ec5f6a0);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
var $g7Bfx = parcelRequire("g7Bfx");
function $be7da570dd44e9e6$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $g7Bfx.pointStart)(node.children[1]);
        const end = (0, $g7Bfx.pointEnd)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("jbsRM", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $df756fa740e8d832$export$ce666bf02318c957);
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $df756fa740e8d832$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("fyvzs", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $b5328549adeefd62$export$e1e720e5f4603e6a);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $b5328549adeefd62$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("hdLPH", function(module, exports) {

$parcel$export(module.exports, "text", () => $c898c12a1a7a9791$export$6f093cfa640b7166);
/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ 
var $dUAea = parcelRequire("dUAea");
function $c898c12a1a7a9791$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $dUAea.trimLines)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("dUAea", function(module, exports) {

$parcel$export(module.exports, "trimLines", () => $a20c9b53bbfad667$export$a771f20bdd13def9);
const $a20c9b53bbfad667$var$tab = 9 /* `\t` */ ;
const $a20c9b53bbfad667$var$space = 32 /* ` ` */ ;
function $a20c9b53bbfad667$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($a20c9b53bbfad667$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($a20c9b53bbfad667$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $a20c9b53bbfad667$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $a20c9b53bbfad667$var$tab || code === $a20c9b53bbfad667$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $a20c9b53bbfad667$var$tab || code === $a20c9b53bbfad667$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}

});


parcelRegister("cnGZN", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $02537fefb8a9d631$export$ba7b13e047416c03);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $02537fefb8a9d631$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});





parcelRegister("9LDLu", function(module, exports) {

$parcel$export(module.exports, "html", () => $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68);
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ 
var $cOWZl = parcelRequire("cOWZl");

var $7hVQP = parcelRequire("7hVQP");

var $dp35F = parcelRequire("dp35F");

var $9cvpo = parcelRequire("9cvpo");

var $cnARV = parcelRequire("cnARV");

var $9M0Ux = parcelRequire("9M0Ux");

var $b5au4 = parcelRequire("b5au4");

var $dLz4Z = parcelRequire("dLz4Z");

var $i5Okx = parcelRequire("i5Okx");

const $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5 = (0, $cOWZl.merge)([
    (0, $dp35F.xml),
    (0, $7hVQP.xlink),
    (0, $9cvpo.xmlns),
    (0, $cnARV.aria),
    (0, $9M0Ux.html)
], "html");
const $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68 = (0, $cOWZl.merge)([
    (0, $dp35F.xml),
    (0, $7hVQP.xlink),
    (0, $9cvpo.xmlns),
    (0, $cnARV.aria),
    (0, $b5au4.svg)
], "svg");

});
parcelRegister("cOWZl", function(module, exports) {

$parcel$export(module.exports, "merge", () => $9557e96728c042cf$export$4950aa0f605343fb);
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ 
var $kf7Oc = parcelRequire("kf7Oc");
function $9557e96728c042cf$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $kf7Oc.Schema)(property, normal, space);
}

});
parcelRegister("kf7Oc", function(module, exports) {

$parcel$export(module.exports, "Schema", () => $ebcb43fb277eac89$export$19342e026b58ebb7);
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $ebcb43fb277eac89$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.space = null;

});


parcelRegister("7hVQP", function(module, exports) {

$parcel$export(module.exports, "xlink", () => $54e6fef78f3cbe14$export$2bd1230ec7600845);

var $dhyvo = parcelRequire("dhyvo");
const $54e6fef78f3cbe14$export$2bd1230ec7600845 = (0, $dhyvo.create)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});

});
parcelRegister("dhyvo", function(module, exports) {

$parcel$export(module.exports, "create", () => $9ab7a0f2f5273cb1$export$185802fd694ee1f5);
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ 
var $jZGR1 = parcelRequire("jZGR1");

var $kf7Oc = parcelRequire("kf7Oc");

var $j4RPW = parcelRequire("j4RPW");
const $9ab7a0f2f5273cb1$var$own = {}.hasOwnProperty;
function $9ab7a0f2f5273cb1$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($9ab7a0f2f5273cb1$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $j4RPW.DefinedInfo)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $jZGR1.normalize)(prop)] = prop;
        normal[(0, $jZGR1.normalize)(info.attribute)] = prop;
    }
    return new (0, $kf7Oc.Schema)(property, normal, definition.space);
}

});
parcelRegister("jZGR1", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $e8e4f4c42f412e49$export$a3295358bff77e);
/**
 * @param {string} value
 * @returns {string}
 */ function $e8e4f4c42f412e49$export$a3295358bff77e(value) {
    return value.toLowerCase();
}

});

parcelRegister("j4RPW", function(module, exports) {

$parcel$export(module.exports, "DefinedInfo", () => $de3826e2cce515f8$export$ea6b9f0064e88c9b);

var $7kNqS = parcelRequire("7kNqS");

var $aCrbx = parcelRequire("aCrbx");
/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $de3826e2cce515f8$var$checks = Object.keys($aCrbx);
class $de3826e2cce515f8$export$ea6b9f0064e88c9b extends (0, $7kNqS.Info) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $de3826e2cce515f8$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $de3826e2cce515f8$var$checks.length){
            const check = $de3826e2cce515f8$var$checks[index];
            $de3826e2cce515f8$var$mark(this, $de3826e2cce515f8$var$checks[index], (mask & $aCrbx[check]) === $aCrbx[check]);
        }
    }
}
$de3826e2cce515f8$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $de3826e2cce515f8$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}

});
parcelRegister("7kNqS", function(module, exports) {

$parcel$export(module.exports, "Info", () => $5570beed4f72c7cb$export$c4868e4a24d48fad);
class $5570beed4f72c7cb$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.space = null;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.boolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.booleanish = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.number = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.defined = false;

});

parcelRegister("aCrbx", function(module, exports) {

$parcel$export(module.exports, "boolean", () => $7bb28a628b951544$export$4a21f16c33752377);
$parcel$export(module.exports, "booleanish", () => $7bb28a628b951544$export$55e9e1fbc638dc8f);
$parcel$export(module.exports, "overloadedBoolean", () => $7bb28a628b951544$export$242ac3d3042558aa);
$parcel$export(module.exports, "number", () => $7bb28a628b951544$export$98e628dec113755e);
$parcel$export(module.exports, "spaceSeparated", () => $7bb28a628b951544$export$ab8645c862eb5a3e);
$parcel$export(module.exports, "commaSeparated", () => $7bb28a628b951544$export$9c8d678629b3d3);
$parcel$export(module.exports, "commaOrSpaceSeparated", () => $7bb28a628b951544$export$2ad25cfebf36cacd);
let $7bb28a628b951544$var$powers = 0;
const $7bb28a628b951544$export$4a21f16c33752377 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$55e9e1fbc638dc8f = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$242ac3d3042558aa = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$98e628dec113755e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$ab8645c862eb5a3e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$9c8d678629b3d3 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$2ad25cfebf36cacd = $7bb28a628b951544$var$increment();
function $7bb28a628b951544$var$increment() {
    return 2 ** ++$7bb28a628b951544$var$powers;
}

});




parcelRegister("dp35F", function(module, exports) {

$parcel$export(module.exports, "xml", () => $9c2001df32d7e0eb$export$f2913fe8983302e);

var $dhyvo = parcelRequire("dhyvo");
const $9c2001df32d7e0eb$export$f2913fe8983302e = (0, $dhyvo.create)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});

});

parcelRegister("9cvpo", function(module, exports) {

$parcel$export(module.exports, "xmlns", () => $6b2d9925b04ededa$export$e20c24a128671213);

var $dhyvo = parcelRequire("dhyvo");

var $kPKic = parcelRequire("kPKic");
const $6b2d9925b04ededa$export$e20c24a128671213 = (0, $dhyvo.create)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $kPKic.caseInsensitiveTransform),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

});
parcelRegister("kPKic", function(module, exports) {

$parcel$export(module.exports, "caseInsensitiveTransform", () => $f2ac7ad36db76cd1$export$32b9e4cec9c208e1);

var $luIs3 = parcelRequire("luIs3");
function $f2ac7ad36db76cd1$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $luIs3.caseSensitiveTransform)(attributes, property.toLowerCase());
}

});
parcelRegister("luIs3", function(module, exports) {

$parcel$export(module.exports, "caseSensitiveTransform", () => $fa5ee16f731231fb$export$5b10b3bc32d7efbc);
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $fa5ee16f731231fb$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("cnARV", function(module, exports) {

$parcel$export(module.exports, "aria", () => $90343b68c9a7ed34$export$4d2d26490572750a);

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");
const $90343b68c9a7ed34$export$4d2d26490572750a = (0, $dhyvo.create)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $aCrbx.booleanish),
        ariaAutoComplete: null,
        ariaBusy: (0, $aCrbx.booleanish),
        ariaChecked: (0, $aCrbx.booleanish),
        ariaColCount: (0, $aCrbx.number),
        ariaColIndex: (0, $aCrbx.number),
        ariaColSpan: (0, $aCrbx.number),
        ariaControls: (0, $aCrbx.spaceSeparated),
        ariaCurrent: null,
        ariaDescribedBy: (0, $aCrbx.spaceSeparated),
        ariaDetails: null,
        ariaDisabled: (0, $aCrbx.booleanish),
        ariaDropEffect: (0, $aCrbx.spaceSeparated),
        ariaErrorMessage: null,
        ariaExpanded: (0, $aCrbx.booleanish),
        ariaFlowTo: (0, $aCrbx.spaceSeparated),
        ariaGrabbed: (0, $aCrbx.booleanish),
        ariaHasPopup: null,
        ariaHidden: (0, $aCrbx.booleanish),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $aCrbx.spaceSeparated),
        ariaLevel: (0, $aCrbx.number),
        ariaLive: null,
        ariaModal: (0, $aCrbx.booleanish),
        ariaMultiLine: (0, $aCrbx.booleanish),
        ariaMultiSelectable: (0, $aCrbx.booleanish),
        ariaOrientation: null,
        ariaOwns: (0, $aCrbx.spaceSeparated),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $aCrbx.number),
        ariaPressed: (0, $aCrbx.booleanish),
        ariaReadOnly: (0, $aCrbx.booleanish),
        ariaRelevant: null,
        ariaRequired: (0, $aCrbx.booleanish),
        ariaRoleDescription: (0, $aCrbx.spaceSeparated),
        ariaRowCount: (0, $aCrbx.number),
        ariaRowIndex: (0, $aCrbx.number),
        ariaRowSpan: (0, $aCrbx.number),
        ariaSelected: (0, $aCrbx.booleanish),
        ariaSetSize: (0, $aCrbx.number),
        ariaSort: null,
        ariaValueMax: (0, $aCrbx.number),
        ariaValueMin: (0, $aCrbx.number),
        ariaValueNow: (0, $aCrbx.number),
        ariaValueText: null,
        role: null
    }
});

});

parcelRegister("9M0Ux", function(module, exports) {

$parcel$export(module.exports, "html", () => $71d94da779c1399e$export$c0bb0b647f701bb5);

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");

var $kPKic = parcelRequire("kPKic");
const $71d94da779c1399e$export$c0bb0b647f701bb5 = (0, $dhyvo.create)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $kPKic.caseInsensitiveTransform),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $aCrbx.commaSeparated),
        acceptCharset: (0, $aCrbx.spaceSeparated),
        accessKey: (0, $aCrbx.spaceSeparated),
        action: null,
        allow: null,
        allowFullScreen: (0, $aCrbx.boolean),
        allowPaymentRequest: (0, $aCrbx.boolean),
        allowUserMedia: (0, $aCrbx.boolean),
        alt: null,
        as: null,
        async: (0, $aCrbx.boolean),
        autoCapitalize: null,
        autoComplete: (0, $aCrbx.spaceSeparated),
        autoFocus: (0, $aCrbx.boolean),
        autoPlay: (0, $aCrbx.boolean),
        blocking: (0, $aCrbx.spaceSeparated),
        capture: null,
        charSet: null,
        checked: (0, $aCrbx.boolean),
        cite: null,
        className: (0, $aCrbx.spaceSeparated),
        cols: (0, $aCrbx.number),
        colSpan: null,
        content: null,
        contentEditable: (0, $aCrbx.booleanish),
        controls: (0, $aCrbx.boolean),
        controlsList: (0, $aCrbx.spaceSeparated),
        coords: (0, $aCrbx.number) | (0, $aCrbx.commaSeparated),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $aCrbx.boolean),
        defer: (0, $aCrbx.boolean),
        dir: null,
        dirName: null,
        disabled: (0, $aCrbx.boolean),
        download: (0, $aCrbx.overloadedBoolean),
        draggable: (0, $aCrbx.booleanish),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $aCrbx.boolean),
        formTarget: null,
        headers: (0, $aCrbx.spaceSeparated),
        height: (0, $aCrbx.number),
        hidden: (0, $aCrbx.boolean),
        high: (0, $aCrbx.number),
        href: null,
        hrefLang: null,
        htmlFor: (0, $aCrbx.spaceSeparated),
        httpEquiv: (0, $aCrbx.spaceSeparated),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $aCrbx.boolean),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $aCrbx.boolean),
        itemId: null,
        itemProp: (0, $aCrbx.spaceSeparated),
        itemRef: (0, $aCrbx.spaceSeparated),
        itemScope: (0, $aCrbx.boolean),
        itemType: (0, $aCrbx.spaceSeparated),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $aCrbx.boolean),
        low: (0, $aCrbx.number),
        manifest: null,
        max: null,
        maxLength: (0, $aCrbx.number),
        media: null,
        method: null,
        min: null,
        minLength: (0, $aCrbx.number),
        multiple: (0, $aCrbx.boolean),
        muted: (0, $aCrbx.boolean),
        name: null,
        nonce: null,
        noModule: (0, $aCrbx.boolean),
        noValidate: (0, $aCrbx.boolean),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $aCrbx.boolean),
        optimum: (0, $aCrbx.number),
        pattern: null,
        ping: (0, $aCrbx.spaceSeparated),
        placeholder: null,
        playsInline: (0, $aCrbx.boolean),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $aCrbx.boolean),
        referrerPolicy: null,
        rel: (0, $aCrbx.spaceSeparated),
        required: (0, $aCrbx.boolean),
        reversed: (0, $aCrbx.boolean),
        rows: (0, $aCrbx.number),
        rowSpan: (0, $aCrbx.number),
        sandbox: (0, $aCrbx.spaceSeparated),
        scope: null,
        scoped: (0, $aCrbx.boolean),
        seamless: (0, $aCrbx.boolean),
        selected: (0, $aCrbx.boolean),
        shadowRootDelegatesFocus: (0, $aCrbx.boolean),
        shadowRootMode: null,
        shape: null,
        size: (0, $aCrbx.number),
        sizes: null,
        slot: null,
        span: (0, $aCrbx.number),
        spellCheck: (0, $aCrbx.booleanish),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $aCrbx.number),
        step: null,
        style: null,
        tabIndex: (0, $aCrbx.number),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $aCrbx.boolean),
        useMap: null,
        value: (0, $aCrbx.booleanish),
        width: (0, $aCrbx.number),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $aCrbx.spaceSeparated),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $aCrbx.number),
        borderColor: null,
        bottomMargin: (0, $aCrbx.number),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $aCrbx.boolean),
        declare: (0, $aCrbx.boolean),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $aCrbx.number),
        leftMargin: (0, $aCrbx.number),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $aCrbx.number),
        marginWidth: (0, $aCrbx.number),
        noResize: (0, $aCrbx.boolean),
        noHref: (0, $aCrbx.boolean),
        noShade: (0, $aCrbx.boolean),
        noWrap: (0, $aCrbx.boolean),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $aCrbx.number),
        rules: null,
        scheme: null,
        scrolling: (0, $aCrbx.booleanish),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $aCrbx.number),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $aCrbx.number),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $aCrbx.boolean),
        disableRemotePlayback: (0, $aCrbx.boolean),
        prefix: null,
        property: null,
        results: (0, $aCrbx.number),
        security: null,
        unselectable: null
    }
});

});

parcelRegister("b5au4", function(module, exports) {

$parcel$export(module.exports, "svg", () => $81184b40caf3b243$export$7ed1367e7fa1ad68);

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");

var $luIs3 = parcelRequire("luIs3");
const $81184b40caf3b243$export$7ed1367e7fa1ad68 = (0, $dhyvo.create)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $luIs3.caseSensitiveTransform),
    properties: {
        about: (0, $aCrbx.commaOrSpaceSeparated),
        accentHeight: (0, $aCrbx.number),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $aCrbx.number),
        amplitude: (0, $aCrbx.number),
        arabicForm: null,
        ascent: (0, $aCrbx.number),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $aCrbx.number),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $aCrbx.number),
        by: null,
        calcMode: null,
        capHeight: (0, $aCrbx.number),
        className: (0, $aCrbx.spaceSeparated),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $aCrbx.number),
        diffuseConstant: (0, $aCrbx.number),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $aCrbx.number),
        dominantBaseline: null,
        download: (0, $aCrbx.boolean),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $aCrbx.number),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $aCrbx.number),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $aCrbx.number),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $aCrbx.commaSeparated),
        g2: (0, $aCrbx.commaSeparated),
        glyphName: (0, $aCrbx.commaSeparated),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $aCrbx.number),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $aCrbx.number),
        horizOriginX: (0, $aCrbx.number),
        horizOriginY: (0, $aCrbx.number),
        id: null,
        ideographic: (0, $aCrbx.number),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $aCrbx.number),
        k: (0, $aCrbx.number),
        k1: (0, $aCrbx.number),
        k2: (0, $aCrbx.number),
        k3: (0, $aCrbx.number),
        k4: (0, $aCrbx.number),
        kernelMatrix: (0, $aCrbx.commaOrSpaceSeparated),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $aCrbx.number),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $aCrbx.number),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $aCrbx.number),
        overlineThickness: (0, $aCrbx.number),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $aCrbx.number),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $aCrbx.spaceSeparated),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $aCrbx.number),
        pointsAtY: (0, $aCrbx.number),
        pointsAtZ: (0, $aCrbx.number),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $aCrbx.commaOrSpaceSeparated),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $aCrbx.commaOrSpaceSeparated),
        rev: (0, $aCrbx.commaOrSpaceSeparated),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $aCrbx.commaOrSpaceSeparated),
        requiredFeatures: (0, $aCrbx.commaOrSpaceSeparated),
        requiredFonts: (0, $aCrbx.commaOrSpaceSeparated),
        requiredFormats: (0, $aCrbx.commaOrSpaceSeparated),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $aCrbx.number),
        specularExponent: (0, $aCrbx.number),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $aCrbx.number),
        strikethroughThickness: (0, $aCrbx.number),
        string: null,
        stroke: null,
        strokeDashArray: (0, $aCrbx.commaOrSpaceSeparated),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $aCrbx.number),
        strokeOpacity: (0, $aCrbx.number),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $aCrbx.number),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $aCrbx.commaOrSpaceSeparated),
        tabIndex: (0, $aCrbx.number),
        tableValues: null,
        target: null,
        targetX: (0, $aCrbx.number),
        targetY: (0, $aCrbx.number),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $aCrbx.commaOrSpaceSeparated),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $aCrbx.number),
        underlineThickness: (0, $aCrbx.number),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $aCrbx.number),
        values: null,
        vAlphabetic: (0, $aCrbx.number),
        vMathematical: (0, $aCrbx.number),
        vectorEffect: null,
        vHanging: (0, $aCrbx.number),
        vIdeographic: (0, $aCrbx.number),
        version: null,
        vertAdvY: (0, $aCrbx.number),
        vertOriginX: (0, $aCrbx.number),
        vertOriginY: (0, $aCrbx.number),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $aCrbx.number),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});

});

parcelRegister("dLz4Z", function(module, exports) {

$parcel$export(module.exports, "find", () => $a05ae03077f3d80b$export$71aa6c912b956294);
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 
var $jZGR1 = parcelRequire("jZGR1");

var $j4RPW = parcelRequire("j4RPW");

var $7kNqS = parcelRequire("7kNqS");
const $a05ae03077f3d80b$var$valid = /^data[-\w.:]+$/i;
const $a05ae03077f3d80b$var$dash = /-[a-z]/g;
const $a05ae03077f3d80b$var$cap = /[A-Z]/g;
function $a05ae03077f3d80b$export$71aa6c912b956294(schema, value) {
    const normal = (0, $jZGR1.normalize)(value);
    let prop = value;
    let Type = (0, $7kNqS.Info);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $a05ae03077f3d80b$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($a05ae03077f3d80b$var$dash, $a05ae03077f3d80b$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$a05ae03077f3d80b$var$dash.test(rest)) {
                let dashes = rest.replace($a05ae03077f3d80b$var$cap, $a05ae03077f3d80b$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $j4RPW.DefinedInfo);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a05ae03077f3d80b$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a05ae03077f3d80b$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});

parcelRegister("i5Okx", function(module, exports) {

$parcel$export(module.exports, "hastToReact", () => $d2bfbc2ede41b173$export$d8abd7e5fb6871f9);
/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $d2bfbc2ede41b173$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};

});


parcelRegister("2Hi3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6d99e229d437d1$export$2e2bcd8739ae039);

var $6qkIL = parcelRequire("6qkIL");
function $1f6d99e229d437d1$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $6qkIL.visit)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}

});

parcelRegister("i5UZr", function(module, exports) {

$parcel$export(module.exports, "childrenToReact", () => $d2c4e6a13f14eb77$export$4b745c302603ab5d);
/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $acw62 = parcelRequire("acw62");

var $7xmGU = parcelRequire("7xmGU");

var $fWRhB = parcelRequire("fWRhB");

var $dLz4Z = parcelRequire("dLz4Z");
var $i5Okx = parcelRequire("i5Okx");
var $9LDLu = parcelRequire("9LDLu");

var $4T1Yz = parcelRequire("4T1Yz");

var $ath1E = parcelRequire("ath1E");

var $9BYkS = parcelRequire("9BYkS");

var $1hTyX = parcelRequire("1hTyX");
const $d2c4e6a13f14eb77$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $d2c4e6a13f14eb77$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $d2c4e6a13f14eb77$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($d2c4e6a13f14eb77$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$d2c4e6a13f14eb77$var$tableElements.has(node.tagName) || !(0, $fWRhB.whitespace)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $d2c4e6a13f14eb77$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $1hTyX.uriTransformer) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $9LDLu.svg);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($d2c4e6a13f14eb77$var$own.call(node.properties, property)) $d2c4e6a13f14eb77$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $d2c4e6a13f14eb77$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $d2c4e6a13f14eb77$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7xmGU))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $d2c4e6a13f14eb77$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $d2c4e6a13f14eb77$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $d2c4e6a13f14eb77$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $d2c4e6a13f14eb77$var$addProperty(props, prop, value, ctx) {
    const info = (0, $dLz4Z.find)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $ath1E.stringify)(result) : (0, $4T1Yz.stringify)(result);
    if (info.property === "style" && typeof result === "string") result = $d2c4e6a13f14eb77$var$parseStyle(result);
    if (info.space && info.property) props[$d2c4e6a13f14eb77$var$own.call((0, $i5Okx.hastToReact), info.property) ? (0, $i5Okx.hastToReact)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $d2c4e6a13f14eb77$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $9BYkS.default)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $d2c4e6a13f14eb77$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $d2c4e6a13f14eb77$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $d2c4e6a13f14eb77$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}

});
parcelRegister("7xmGU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("grs8m"));

});
parcelRegister("grs8m", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $bf84fdbf263c7796$export$a7c73072b1a182ae, (v) => $bf84fdbf263c7796$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $bf84fdbf263c7796$export$9f27bc3417b4524d, (v) => $bf84fdbf263c7796$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $bf84fdbf263c7796$export$db77ccec0bb4ccac, (v) => $bf84fdbf263c7796$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $bf84fdbf263c7796$export$8392c0c9d3dcbd35, (v) => $bf84fdbf263c7796$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $bf84fdbf263c7796$export$ffb0004e005737fa, (v) => $bf84fdbf263c7796$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $bf84fdbf263c7796$export$b624eff549462981, (v) => $bf84fdbf263c7796$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $bf84fdbf263c7796$export$7897aa7841a5380c, (v) => $bf84fdbf263c7796$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $bf84fdbf263c7796$export$602eac185826482c, (v) => $bf84fdbf263c7796$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $bf84fdbf263c7796$export$e2c29f18771995cb, (v) => $bf84fdbf263c7796$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $bf84fdbf263c7796$export$5f8d39834fd61797, (v) => $bf84fdbf263c7796$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bf84fdbf263c7796$export$74bf444e3cd11ea5, (v) => $bf84fdbf263c7796$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $bf84fdbf263c7796$export$998bcd577473dd93, (v) => $bf84fdbf263c7796$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $bf84fdbf263c7796$export$92387174baf9b227, (v) => $bf84fdbf263c7796$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $bf84fdbf263c7796$export$ec112efeb987d9c6, (v) => $bf84fdbf263c7796$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $bf84fdbf263c7796$export$b706b080d889d2c9, (v) => $bf84fdbf263c7796$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $bf84fdbf263c7796$export$5be5a87408f70ddc, (v) => $bf84fdbf263c7796$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $bf84fdbf263c7796$export$45a5e7f76e0caa8d, (v) => $bf84fdbf263c7796$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $bf84fdbf263c7796$export$455c2e768291efa6, (v) => $bf84fdbf263c7796$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $bf84fdbf263c7796$export$9522e17588c12572, (v) => $bf84fdbf263c7796$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $bf84fdbf263c7796$export$2110ac352bb060b9, (v) => $bf84fdbf263c7796$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $bf84fdbf263c7796$export$56885ab8b9c456ab, (v) => $bf84fdbf263c7796$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $bf84fdbf263c7796$export$d927fcb6adf8f9de, (v) => $bf84fdbf263c7796$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $bf84fdbf263c7796$export$b82d16f27459e05a, (v) => $bf84fdbf263c7796$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $bf84fdbf263c7796$export$522c17b4f5e123e8, (v) => $bf84fdbf263c7796$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $bf84fdbf263c7796$export$1aabd8a0274ecfd6, (v) => $bf84fdbf263c7796$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $bf84fdbf263c7796$export$3d6c20d97e46b957, (v) => $bf84fdbf263c7796$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $bf84fdbf263c7796$export$9b621391a187a31a, (v) => $bf84fdbf263c7796$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $bf84fdbf263c7796$export$f5bbd400c2f4426f, (v) => $bf84fdbf263c7796$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bf84fdbf263c7796$export$a7c73072b1a182ae;
var $bf84fdbf263c7796$export$9f27bc3417b4524d;
var $bf84fdbf263c7796$export$db77ccec0bb4ccac;
var $bf84fdbf263c7796$export$8392c0c9d3dcbd35;
var $bf84fdbf263c7796$export$ffb0004e005737fa;
var $bf84fdbf263c7796$export$b624eff549462981;
var $bf84fdbf263c7796$export$7897aa7841a5380c;
var $bf84fdbf263c7796$export$602eac185826482c;
var $bf84fdbf263c7796$export$e2c29f18771995cb;
var $bf84fdbf263c7796$export$5f8d39834fd61797;
var $bf84fdbf263c7796$export$74bf444e3cd11ea5;
var $bf84fdbf263c7796$export$998bcd577473dd93;
var $bf84fdbf263c7796$export$92387174baf9b227;
var $bf84fdbf263c7796$export$ec112efeb987d9c6;
var $bf84fdbf263c7796$export$b706b080d889d2c9;
var $bf84fdbf263c7796$export$5be5a87408f70ddc;
var $bf84fdbf263c7796$export$45a5e7f76e0caa8d;
var $bf84fdbf263c7796$export$455c2e768291efa6;
var $bf84fdbf263c7796$export$9522e17588c12572;
var $bf84fdbf263c7796$export$2110ac352bb060b9;
var $bf84fdbf263c7796$export$56885ab8b9c456ab;
var $bf84fdbf263c7796$export$d927fcb6adf8f9de;
var $bf84fdbf263c7796$export$b82d16f27459e05a;
var $bf84fdbf263c7796$export$522c17b4f5e123e8;
var $bf84fdbf263c7796$export$1aabd8a0274ecfd6;
var $bf84fdbf263c7796$export$3d6c20d97e46b957;
var $bf84fdbf263c7796$export$9b621391a187a31a;
var $bf84fdbf263c7796$export$f5bbd400c2f4426f;
"use strict";
var $bf84fdbf263c7796$var$b = Symbol.for("react.element"), $bf84fdbf263c7796$var$c = Symbol.for("react.portal"), $bf84fdbf263c7796$var$d = Symbol.for("react.fragment"), $bf84fdbf263c7796$var$e = Symbol.for("react.strict_mode"), $bf84fdbf263c7796$var$f = Symbol.for("react.profiler"), $bf84fdbf263c7796$var$g = Symbol.for("react.provider"), $bf84fdbf263c7796$var$h = Symbol.for("react.context"), $bf84fdbf263c7796$var$k = Symbol.for("react.server_context"), $bf84fdbf263c7796$var$l = Symbol.for("react.forward_ref"), $bf84fdbf263c7796$var$m = Symbol.for("react.suspense"), $bf84fdbf263c7796$var$n = Symbol.for("react.suspense_list"), $bf84fdbf263c7796$var$p = Symbol.for("react.memo"), $bf84fdbf263c7796$var$q = Symbol.for("react.lazy"), $bf84fdbf263c7796$var$t = Symbol.for("react.offscreen"), $bf84fdbf263c7796$var$u;
$bf84fdbf263c7796$var$u = Symbol.for("react.module.reference");
function $bf84fdbf263c7796$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $bf84fdbf263c7796$var$b:
                switch(a = a.type, a){
                    case $bf84fdbf263c7796$var$d:
                    case $bf84fdbf263c7796$var$f:
                    case $bf84fdbf263c7796$var$e:
                    case $bf84fdbf263c7796$var$m:
                    case $bf84fdbf263c7796$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bf84fdbf263c7796$var$k:
                            case $bf84fdbf263c7796$var$h:
                            case $bf84fdbf263c7796$var$l:
                            case $bf84fdbf263c7796$var$q:
                            case $bf84fdbf263c7796$var$p:
                            case $bf84fdbf263c7796$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $bf84fdbf263c7796$var$c:
                return r;
        }
    }
}
$bf84fdbf263c7796$export$a7c73072b1a182ae = $bf84fdbf263c7796$var$h;
$bf84fdbf263c7796$export$9f27bc3417b4524d = $bf84fdbf263c7796$var$g;
$bf84fdbf263c7796$export$db77ccec0bb4ccac = $bf84fdbf263c7796$var$b;
$bf84fdbf263c7796$export$8392c0c9d3dcbd35 = $bf84fdbf263c7796$var$l;
$bf84fdbf263c7796$export$ffb0004e005737fa = $bf84fdbf263c7796$var$d;
$bf84fdbf263c7796$export$b624eff549462981 = $bf84fdbf263c7796$var$q;
$bf84fdbf263c7796$export$7897aa7841a5380c = $bf84fdbf263c7796$var$p;
$bf84fdbf263c7796$export$602eac185826482c = $bf84fdbf263c7796$var$c;
$bf84fdbf263c7796$export$e2c29f18771995cb = $bf84fdbf263c7796$var$f;
$bf84fdbf263c7796$export$5f8d39834fd61797 = $bf84fdbf263c7796$var$e;
$bf84fdbf263c7796$export$74bf444e3cd11ea5 = $bf84fdbf263c7796$var$m;
$bf84fdbf263c7796$export$998bcd577473dd93 = $bf84fdbf263c7796$var$n;
$bf84fdbf263c7796$export$92387174baf9b227 = function() {
    return !1;
};
$bf84fdbf263c7796$export$ec112efeb987d9c6 = function() {
    return !1;
};
$bf84fdbf263c7796$export$b706b080d889d2c9 = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$h;
};
$bf84fdbf263c7796$export$5be5a87408f70ddc = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$g;
};
$bf84fdbf263c7796$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bf84fdbf263c7796$var$b;
};
$bf84fdbf263c7796$export$455c2e768291efa6 = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$l;
};
$bf84fdbf263c7796$export$9522e17588c12572 = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$d;
};
$bf84fdbf263c7796$export$2110ac352bb060b9 = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$q;
};
$bf84fdbf263c7796$export$56885ab8b9c456ab = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$p;
};
$bf84fdbf263c7796$export$d927fcb6adf8f9de = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$c;
};
$bf84fdbf263c7796$export$b82d16f27459e05a = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$f;
};
$bf84fdbf263c7796$export$522c17b4f5e123e8 = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$e;
};
$bf84fdbf263c7796$export$1aabd8a0274ecfd6 = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$m;
};
$bf84fdbf263c7796$export$3d6c20d97e46b957 = function(a) {
    return $bf84fdbf263c7796$var$v(a) === $bf84fdbf263c7796$var$n;
};
$bf84fdbf263c7796$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bf84fdbf263c7796$var$d || a === $bf84fdbf263c7796$var$f || a === $bf84fdbf263c7796$var$e || a === $bf84fdbf263c7796$var$m || a === $bf84fdbf263c7796$var$n || a === $bf84fdbf263c7796$var$t || "object" === typeof a && null !== a && (a.$$typeof === $bf84fdbf263c7796$var$q || a.$$typeof === $bf84fdbf263c7796$var$p || a.$$typeof === $bf84fdbf263c7796$var$g || a.$$typeof === $bf84fdbf263c7796$var$h || a.$$typeof === $bf84fdbf263c7796$var$l || a.$$typeof === $bf84fdbf263c7796$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$bf84fdbf263c7796$export$f5bbd400c2f4426f = $bf84fdbf263c7796$var$v;

});


parcelRegister("fWRhB", function(module, exports) {

$parcel$export(module.exports, "whitespace", () => $b9c59aaa17277982$export$7af1228ff777d175);
/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $b9c59aaa17277982$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}

});

parcelRegister("4T1Yz", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $38edd4def83e695e$export$fac44ee5b035f737);
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $38edd4def83e695e$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $38edd4def83e695e$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}

});

parcelRegister("ath1E", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $79f9d1c25aee8303$export$fac44ee5b035f737);
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $79f9d1c25aee8303$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $79f9d1c25aee8303$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}

});

parcelRegister("9BYkS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8da4e934f9d6258$export$2e2bcd8739ae039);

var $8SsuU = parcelRequire("8SsuU");
var $d8da4e934f9d6258$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8SsuU)));

});
parcelRegister("8SsuU", function(module, exports) {

var $dvUl4 = parcelRequire("dvUl4");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $676978e4775c0e9c$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $dvUl4(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $676978e4775c0e9c$var$StyleToObject;
module.exports.default = $676978e4775c0e9c$var$StyleToObject; // ESM support

});
parcelRegister("dvUl4", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $9d69df5777ad44b8$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $9d69df5777ad44b8$var$NEWLINE_REGEX = /\n/g;
var $9d69df5777ad44b8$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $9d69df5777ad44b8$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $9d69df5777ad44b8$var$COLON_REGEX = /^:\s*/;
var $9d69df5777ad44b8$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $9d69df5777ad44b8$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $9d69df5777ad44b8$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $9d69df5777ad44b8$var$NEWLINE = "\n";
var $9d69df5777ad44b8$var$FORWARD_SLASH = "/";
var $9d69df5777ad44b8$var$ASTERISK = "*";
var $9d69df5777ad44b8$var$EMPTY_STRING = "";
// types
var $9d69df5777ad44b8$var$TYPE_COMMENT = "comment";
var $9d69df5777ad44b8$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($9d69df5777ad44b8$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($9d69df5777ad44b8$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($9d69df5777ad44b8$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(0) || $9d69df5777ad44b8$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($9d69df5777ad44b8$var$EMPTY_STRING != style.charAt(i) && ($9d69df5777ad44b8$var$ASTERISK != style.charAt(i) || $9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($9d69df5777ad44b8$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $9d69df5777ad44b8$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($9d69df5777ad44b8$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($9d69df5777ad44b8$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($9d69df5777ad44b8$var$VALUE_REGEX);
        var ret = pos({
            type: $9d69df5777ad44b8$var$TYPE_DECLARATION,
            property: $9d69df5777ad44b8$var$trim(prop[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)),
            value: val ? $9d69df5777ad44b8$var$trim(val[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)) : $9d69df5777ad44b8$var$EMPTY_STRING
        });
        // ;
        match($9d69df5777ad44b8$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $9d69df5777ad44b8$var$trim(str) {
    return str ? str.replace($9d69df5777ad44b8$var$TRIM_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING) : $9d69df5777ad44b8$var$EMPTY_STRING;
}

});



parcelRegister("1hTyX", function(module, exports) {

$parcel$export(module.exports, "uriTransformer", () => $0f027a92973e6333$export$b83532a10e2e268b);
const $0f027a92973e6333$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $0f027a92973e6333$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $0f027a92973e6333$var$protocols.length){
        const protocol = $0f027a92973e6333$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}

});



parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("8x08q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $63618293c58b5f80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $63618293c58b5f80$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $63618293c58b5f80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63618293c58b5f80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63618293c58b5f80$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $63618293c58b5f80$var$_extends() {
    $63618293c58b5f80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63618293c58b5f80$var$_extends.apply(this, arguments);
}
function $63618293c58b5f80$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $63618293c58b5f80$var$_setPrototypeOf(subClass, superClass);
}
function $63618293c58b5f80$var$_getPrototypeOf(o) {
    $63618293c58b5f80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63618293c58b5f80$var$_getPrototypeOf(o);
}
function $63618293c58b5f80$var$_setPrototypeOf(o, p) {
    $63618293c58b5f80$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63618293c58b5f80$var$_setPrototypeOf(o, p);
}
function $63618293c58b5f80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$_construct(Parent, args, Class) {
    if ($63618293c58b5f80$var$_isNativeReflectConstruct()) $63618293c58b5f80$var$_construct = Reflect.construct.bind();
    else $63618293c58b5f80$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $63618293c58b5f80$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $63618293c58b5f80$var$_construct.apply(null, arguments);
}
function $63618293c58b5f80$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $63618293c58b5f80$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $63618293c58b5f80$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$63618293c58b5f80$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $63618293c58b5f80$var$_construct(Class, arguments, $63618293c58b5f80$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $63618293c58b5f80$var$_setPrototypeOf(Wrapper, Class);
    };
    return $63618293c58b5f80$var$_wrapNativeSuper(Class);
}
function $63618293c58b5f80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $63618293c58b5f80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
}
function $63618293c58b5f80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63618293c58b5f80$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $63618293c58b5f80$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $63618293c58b5f80$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $63618293c58b5f80$var$_toPropertyKey(arg) {
    var key = $63618293c58b5f80$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $63618293c58b5f80$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $63618293c58b5f80$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $63618293c58b5f80$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $63618293c58b5f80$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $63618293c58b5f80$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$n = "numeric", $63618293c58b5f80$var$s = "short", $63618293c58b5f80$var$l = "long";
var $63618293c58b5f80$var$DATE_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATE_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_24_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
/**
 * @interface
 */ var $63618293c58b5f80$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $63618293c58b5f80$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton$1 === null) $63618293c58b5f80$var$singleton$1 = new SystemZone();
                return $63618293c58b5f80$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$dtfCache = {};
function $63618293c58b5f80$var$makeDTF(zone) {
    if (!$63618293c58b5f80$var$dtfCache[zone]) $63618293c58b5f80$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $63618293c58b5f80$var$dtfCache[zone];
}
var $63618293c58b5f80$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $63618293c58b5f80$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $63618293c58b5f80$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $63618293c58b5f80$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$63618293c58b5f80$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $63618293c58b5f80$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $63618293c58b5f80$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$63618293c58b5f80$var$ianaZoneCache[name]) $63618293c58b5f80$var$ianaZoneCache[name] = new IANAZone(name);
        return $63618293c58b5f80$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $63618293c58b5f80$var$ianaZoneCache = {};
        $63618293c58b5f80$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale, this.name);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $63618293c58b5f80$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $63618293c58b5f80$var$partsOffset(dtf, date) : $63618293c58b5f80$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $63618293c58b5f80$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$_excluded = [
    "base"
], $63618293c58b5f80$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $63618293c58b5f80$var$intlLFCache = {};
function $63618293c58b5f80$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $63618293c58b5f80$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlDTCache = {};
function $63618293c58b5f80$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlNumCache = {};
function $63618293c58b5f80$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $63618293c58b5f80$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $63618293c58b5f80$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$intlRelCache = {};
function $63618293c58b5f80$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(_opts, $63618293c58b5f80$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $63618293c58b5f80$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$sysLocaleCache = null;
function $63618293c58b5f80$var$systemLocale() {
    if ($63618293c58b5f80$var$sysLocaleCache) return $63618293c58b5f80$var$sysLocaleCache;
    else {
        $63618293c58b5f80$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $63618293c58b5f80$var$sysLocaleCache;
    }
}
var $63618293c58b5f80$var$weekInfoCache = {};
function $63618293c58b5f80$var$getCachedWeekInfo(locString) {
    var data = $63618293c58b5f80$var$weekInfoCache[locString];
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        $63618293c58b5f80$var$weekInfoCache[locString] = data;
    }
    return data;
}
function $63618293c58b5f80$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $63618293c58b5f80$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $63618293c58b5f80$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $63618293c58b5f80$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $63618293c58b5f80$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $63618293c58b5f80$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $63618293c58b5f80$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(opts, $63618293c58b5f80$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $63618293c58b5f80$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $63618293c58b5f80$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $63618293c58b5f80$var$roundTo(i, 3);
            return $63618293c58b5f80$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $63618293c58b5f80$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $63618293c58b5f80$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $63618293c58b5f80$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $63618293c58b5f80$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $63618293c58b5f80$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $63618293c58b5f80$var$hasRelative()) this.rtf = $63618293c58b5f80$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $63618293c58b5f80$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $63618293c58b5f80$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $63618293c58b5f80$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $63618293c58b5f80$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $63618293c58b5f80$var$systemLocale());
        var numberingSystemR = numberingSystem || $63618293c58b5f80$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $63618293c58b5f80$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $63618293c58b5f80$var$validateWeekSettings(weekSettings) || $63618293c58b5f80$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $63618293c58b5f80$var$sysLocaleCache = null;
        $63618293c58b5f80$var$intlDTCache = {};
        $63618293c58b5f80$var$intlNumCache = {};
        $63618293c58b5f80$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $63618293c58b5f80$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $63618293c58b5f80$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $63618293c58b5f80$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $63618293c58b5f80$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $63618293c58b5f80$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $63618293c58b5f80$var$listStuff(this, undefined, function() {
            return $63618293c58b5f80$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 9),
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $63618293c58b5f80$var$DateTime.utc(-40, 1, 1),
                $63618293c58b5f80$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $63618293c58b5f80$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $63618293c58b5f80$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $63618293c58b5f80$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $63618293c58b5f80$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$63618293c58b5f80$var$hasLocaleWeekInfo()) return $63618293c58b5f80$var$fallbackWeekSettings;
        else return $63618293c58b5f80$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $63618293c58b5f80$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $63618293c58b5f80$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $63618293c58b5f80$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $63618293c58b5f80$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($63618293c58b5f80$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.fixed, format);
    } /** @override **/ ;
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $63618293c58b5f80$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $63618293c58b5f80$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton === null) $63618293c58b5f80$var$singleton = new FixedOffsetZone(0);
                return $63618293c58b5f80$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($63618293c58b5f80$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($63618293c58b5f80$var$Zone);
/**
 * @private
 */ function $63618293c58b5f80$var$normalizeZone(input, defaultZone) {
    if ($63618293c58b5f80$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $63618293c58b5f80$var$Zone) return input;
    else if ($63618293c58b5f80$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $63618293c58b5f80$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        else return $63618293c58b5f80$var$FixedOffsetZone.parseSpecifier(lowered) || $63618293c58b5f80$var$IANAZone.create(input);
    } else if ($63618293c58b5f80$var$isNumber(input)) return $63618293c58b5f80$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $63618293c58b5f80$var$InvalidZone(input);
}
var $63618293c58b5f80$var$now = function now() {
    return Date.now();
}, $63618293c58b5f80$var$defaultZone = "system", $63618293c58b5f80$var$defaultLocale = null, $63618293c58b5f80$var$defaultNumberingSystem = null, $63618293c58b5f80$var$defaultOutputCalendar = null, $63618293c58b5f80$var$twoDigitCutoffYear = 60, $63618293c58b5f80$var$throwOnInvalid, $63618293c58b5f80$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $63618293c58b5f80$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $63618293c58b5f80$var$Locale.resetCache();
        $63618293c58b5f80$var$IANAZone.resetCache();
    };
    $63618293c58b5f80$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $63618293c58b5f80$var$now;
            },
            set: function set(n) {
                $63618293c58b5f80$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $63618293c58b5f80$var$normalizeZone($63618293c58b5f80$var$defaultZone, $63618293c58b5f80$var$SystemZone.instance);
            },
            set: function set(zone) {
                $63618293c58b5f80$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $63618293c58b5f80$var$defaultLocale;
            },
            set: function set(locale) {
                $63618293c58b5f80$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $63618293c58b5f80$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $63618293c58b5f80$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $63618293c58b5f80$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $63618293c58b5f80$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $63618293c58b5f80$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $63618293c58b5f80$var$defaultWeekSettings = $63618293c58b5f80$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $63618293c58b5f80$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $63618293c58b5f80$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $63618293c58b5f80$var$throwOnInvalid;
            },
            set: function set(t) {
                $63618293c58b5f80$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $63618293c58b5f80$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $63618293c58b5f80$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $63618293c58b5f80$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $63618293c58b5f80$var$unitOutOfRange(unit, value) {
    return new $63618293c58b5f80$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $63618293c58b5f80$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $63618293c58b5f80$var$computeOrdinal(year, month, day) {
    return day + ($63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder)[month - 1];
}
function $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal) {
    var table = $63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $63618293c58b5f80$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $63618293c58b5f80$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day), weekday = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $63618293c58b5f80$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $63618293c58b5f80$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $63618293c58b5f80$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $63618293c58b5f80$var$timeObject(gregObj));
}
function $63618293c58b5f80$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $63618293c58b5f80$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $63618293c58b5f80$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $63618293c58b5f80$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(weekData));
}
function $63618293c58b5f80$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day);
    return $63618293c58b5f80$var$_extends({
        year: year,
        ordinal: ordinal
    }, $63618293c58b5f80$var$timeObject(gregData));
}
function $63618293c58b5f80$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $63618293c58b5f80$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$63618293c58b5f80$var$isUndefined(obj.localWeekday) || !$63618293c58b5f80$var$isUndefined(obj.localWeekNumber) || !$63618293c58b5f80$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$63618293c58b5f80$var$isUndefined(obj.weekday) || !$63618293c58b5f80$var$isUndefined(obj.weekNumber) || !$63618293c58b5f80$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $63618293c58b5f80$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $63618293c58b5f80$var$isInteger(obj.weekYear), validWeek = $63618293c58b5f80$var$integerBetween(obj.weekNumber, 1, $63618293c58b5f80$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $63618293c58b5f80$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $63618293c58b5f80$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $63618293c58b5f80$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidOrdinalData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validOrdinal = $63618293c58b5f80$var$integerBetween(obj.ordinal, 1, $63618293c58b5f80$var$daysInYear(obj.year));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $63618293c58b5f80$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidGregorianData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validMonth = $63618293c58b5f80$var$integerBetween(obj.month, 1, 12), validDay = $63618293c58b5f80$var$integerBetween(obj.day, 1, $63618293c58b5f80$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $63618293c58b5f80$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $63618293c58b5f80$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $63618293c58b5f80$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $63618293c58b5f80$var$integerBetween(minute, 0, 59), validSecond = $63618293c58b5f80$var$integerBetween(second, 0, 59), validMillisecond = $63618293c58b5f80$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $63618293c58b5f80$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $63618293c58b5f80$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $63618293c58b5f80$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $63618293c58b5f80$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $63618293c58b5f80$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $63618293c58b5f80$var$isNumber(o) {
    return typeof o === "number";
}
function $63618293c58b5f80$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $63618293c58b5f80$var$isString(o) {
    return typeof o === "string";
}
function $63618293c58b5f80$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $63618293c58b5f80$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $63618293c58b5f80$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $63618293c58b5f80$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $63618293c58b5f80$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $63618293c58b5f80$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $63618293c58b5f80$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$63618293c58b5f80$var$integerBetween(settings.firstDay, 1, 7) || !$63618293c58b5f80$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$63618293c58b5f80$var$integerBetween(v, 1, 7);
        })) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $63618293c58b5f80$var$integerBetween(thing, bottom, top) {
    return $63618293c58b5f80$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $63618293c58b5f80$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $63618293c58b5f80$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $63618293c58b5f80$var$parseInteger(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $63618293c58b5f80$var$parseFloating(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $63618293c58b5f80$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($63618293c58b5f80$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $63618293c58b5f80$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $63618293c58b5f80$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $63618293c58b5f80$var$daysInYear(year) {
    return $63618293c58b5f80$var$isLeapYear(year) ? 366 : 365;
}
function $63618293c58b5f80$var$daysInMonth(year, month) {
    var modMonth = $63618293c58b5f80$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $63618293c58b5f80$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $63618293c58b5f80$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $63618293c58b5f80$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $63618293c58b5f80$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $63618293c58b5f80$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $63618293c58b5f80$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($63618293c58b5f80$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $63618293c58b5f80$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $63618293c58b5f80$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $63618293c58b5f80$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $63618293c58b5f80$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $63618293c58b5f80$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $63618293c58b5f80$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($63618293c58b5f80$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $63618293c58b5f80$var$asNumber(v);
    }
    return normalized;
}
function $63618293c58b5f80$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + ":" + $63618293c58b5f80$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + $63618293c58b5f80$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $63618293c58b5f80$var$timeObject(obj) {
    return $63618293c58b5f80$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $63618293c58b5f80$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $63618293c58b5f80$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $63618293c58b5f80$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $63618293c58b5f80$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$monthsNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$monthsShort);
        case "long":
            return [].concat($63618293c58b5f80$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $63618293c58b5f80$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $63618293c58b5f80$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $63618293c58b5f80$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$weekdaysNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$weekdaysShort);
        case "long":
            return [].concat($63618293c58b5f80$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$meridiems = [
    "AM",
    "PM"
];
var $63618293c58b5f80$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $63618293c58b5f80$var$erasShort = [
    "BC",
    "AD"
];
var $63618293c58b5f80$var$erasNarrow = [
    "B",
    "A"
];
function $63618293c58b5f80$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$erasNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$erasShort);
        case "long":
            return [].concat($63618293c58b5f80$var$erasLong);
        default:
            return null;
    }
}
function $63618293c58b5f80$var$meridiemForDateTime(dt) {
    return $63618293c58b5f80$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $63618293c58b5f80$var$weekdayForDateTime(dt, length) {
    return $63618293c58b5f80$var$weekdays(length)[dt.weekday - 1];
}
function $63618293c58b5f80$var$monthForDateTime(dt, length) {
    return $63618293c58b5f80$var$months(length)[dt.month - 1];
}
function $63618293c58b5f80$var$eraForDateTime(dt, length) {
    return $63618293c58b5f80$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $63618293c58b5f80$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $63618293c58b5f80$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $63618293c58b5f80$var$_macroTokenToFormatOpts = {
    D: $63618293c58b5f80$var$DATE_SHORT,
    DD: $63618293c58b5f80$var$DATE_MED,
    DDD: $63618293c58b5f80$var$DATE_FULL,
    DDDD: $63618293c58b5f80$var$DATE_HUGE,
    t: $63618293c58b5f80$var$TIME_SIMPLE,
    tt: $63618293c58b5f80$var$TIME_WITH_SECONDS,
    ttt: $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET,
    tttt: $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET,
    T: $63618293c58b5f80$var$TIME_24_SIMPLE,
    TT: $63618293c58b5f80$var$TIME_24_WITH_SECONDS,
    TTT: $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET,
    f: $63618293c58b5f80$var$DATETIME_SHORT,
    ff: $63618293c58b5f80$var$DATETIME_MED,
    fff: $63618293c58b5f80$var$DATETIME_FULL,
    ffff: $63618293c58b5f80$var$DATETIME_HUGE,
    F: $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS,
    FFF: $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $63618293c58b5f80$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $63618293c58b5f80$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $63618293c58b5f80$var$padStart(n, p);
        var opts = $63618293c58b5f80$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $63618293c58b5f80$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $63618293c58b5f80$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $63618293c58b5f80$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $63618293c58b5f80$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $63618293c58b5f80$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $63618293c58b5f80$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $63618293c58b5f80$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $63618293c58b5f80$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $63618293c58b5f80$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $63618293c58b5f80$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $63618293c58b5f80$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $63618293c58b5f80$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $63618293c58b5f80$var$isoExtendedZone = "(?:" + $63618293c58b5f80$var$offsetRegex.source + "?(?:\\[(" + $63618293c58b5f80$var$ianaRegex.source + ")\\])?)?";
var $63618293c58b5f80$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $63618293c58b5f80$var$isoTimeRegex = RegExp("" + $63618293c58b5f80$var$isoTimeBaseRegex.source + $63618293c58b5f80$var$isoExtendedZone);
var $63618293c58b5f80$var$isoTimeExtensionRegex = RegExp("(?:T" + $63618293c58b5f80$var$isoTimeRegex.source + ")?");
var $63618293c58b5f80$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $63618293c58b5f80$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $63618293c58b5f80$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $63618293c58b5f80$var$extractISOWeekData = $63618293c58b5f80$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $63618293c58b5f80$var$extractISOOrdinalData = $63618293c58b5f80$var$simpleParse("year", "ordinal");
var $63618293c58b5f80$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $63618293c58b5f80$var$sqlTimeRegex = RegExp($63618293c58b5f80$var$isoTimeBaseRegex.source + " ?(?:" + $63618293c58b5f80$var$offsetRegex.source + "|(" + $63618293c58b5f80$var$ianaRegex.source + "))?");
var $63618293c58b5f80$var$sqlTimeExtensionRegex = RegExp("(?: " + $63618293c58b5f80$var$sqlTimeRegex.source + ")?");
function $63618293c58b5f80$var$int(match, pos, fallback) {
    var m = match[pos];
    return $63618293c58b5f80$var$isUndefined(m) ? fallback : $63618293c58b5f80$var$parseInteger(m);
}
function $63618293c58b5f80$var$extractISOYmd(match, cursor) {
    var item = {
        year: $63618293c58b5f80$var$int(match, cursor),
        month: $63618293c58b5f80$var$int(match, cursor + 1, 1),
        day: $63618293c58b5f80$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractISOTime(match, cursor) {
    var item = {
        hours: $63618293c58b5f80$var$int(match, cursor, 0),
        minutes: $63618293c58b5f80$var$int(match, cursor + 1, 0),
        seconds: $63618293c58b5f80$var$int(match, cursor + 2, 0),
        milliseconds: $63618293c58b5f80$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $63618293c58b5f80$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $63618293c58b5f80$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $63618293c58b5f80$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $63618293c58b5f80$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $63618293c58b5f80$var$isoTimeOnly = RegExp("^T?" + $63618293c58b5f80$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $63618293c58b5f80$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $63618293c58b5f80$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($63618293c58b5f80$var$parseFloating(yearStr)),
            months: maybeNegate($63618293c58b5f80$var$parseFloating(monthStr)),
            weeks: maybeNegate($63618293c58b5f80$var$parseFloating(weekStr)),
            days: maybeNegate($63618293c58b5f80$var$parseFloating(dayStr)),
            hours: maybeNegate($63618293c58b5f80$var$parseFloating(hourStr)),
            minutes: maybeNegate($63618293c58b5f80$var$parseFloating(minuteStr)),
            seconds: maybeNegate($63618293c58b5f80$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($63618293c58b5f80$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $63618293c58b5f80$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $63618293c58b5f80$var$untruncateYear($63618293c58b5f80$var$parseInteger(yearStr)) : $63618293c58b5f80$var$parseInteger(yearStr),
        month: $63618293c58b5f80$var$monthsShort.indexOf(monthStr) + 1,
        day: $63618293c58b5f80$var$parseInteger(dayStr),
        hour: $63618293c58b5f80$var$parseInteger(hourStr),
        minute: $63618293c58b5f80$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $63618293c58b5f80$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $63618293c58b5f80$var$weekdaysLong.indexOf(weekdayStr) + 1 : $63618293c58b5f80$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $63618293c58b5f80$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $63618293c58b5f80$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $63618293c58b5f80$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $63618293c58b5f80$var$FixedOffsetZone(offset)
    ];
}
function $63618293c58b5f80$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $63618293c58b5f80$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $63618293c58b5f80$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
function $63618293c58b5f80$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
var $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoYmdRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoWeekRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoOrdinalRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOWeekTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOWeekData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOOrdinalDateAndTime = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOOrdinalData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
/*
 * @private
 */ function $63618293c58b5f80$var$parseISODate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOWeekTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOOrdinalDateAndTime
    ], [
        $63618293c58b5f80$var$isoTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeAndOffset
    ]);
}
function $63618293c58b5f80$var$parseRFC2822Date(s) {
    return $63618293c58b5f80$var$parse($63618293c58b5f80$var$preprocessRFC2822(s), [
        $63618293c58b5f80$var$rfc2822,
        $63618293c58b5f80$var$extractRFC2822
    ]);
}
function $63618293c58b5f80$var$parseHTTPDate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$rfc1123,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$rfc850,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$ascii,
        $63618293c58b5f80$var$extractASCII
    ]);
}
function $63618293c58b5f80$var$parseISODuration(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoDuration,
        $63618293c58b5f80$var$extractISODuration
    ]);
}
var $63618293c58b5f80$var$extractISOTimeOnly = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime);
function $63618293c58b5f80$var$parseISOTimeOnly(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoTimeOnly,
        $63618293c58b5f80$var$extractISOTimeOnly
    ]);
}
var $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlYmdRegex, $63618293c58b5f80$var$sqlTimeExtensionRegex);
var $63618293c58b5f80$var$sqlTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlTimeRegex);
var $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
function $63618293c58b5f80$var$parseSQL(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$sqlTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $63618293c58b5f80$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $63618293c58b5f80$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $63618293c58b5f80$var$casualMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $63618293c58b5f80$var$lowOrderMatrix), $63618293c58b5f80$var$daysInYearAccurate = 365.2425, $63618293c58b5f80$var$daysInMonthAccurate = 30.436875, $63618293c58b5f80$var$accurateMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 7,
        days: $63618293c58b5f80$var$daysInYearAccurate,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 28,
        days: $63618293c58b5f80$var$daysInYearAccurate / 4,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24 / 4,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440 / 4,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $63618293c58b5f80$var$daysInMonthAccurate / 7,
        days: $63618293c58b5f80$var$daysInMonthAccurate,
        hours: $63618293c58b5f80$var$daysInMonthAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInMonthAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400000
    }
}, $63618293c58b5f80$var$lowOrderMatrix);
// units ordered by size
var $63618293c58b5f80$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $63618293c58b5f80$var$reverseUnits = $63618293c58b5f80$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $63618293c58b5f80$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $63618293c58b5f80$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $63618293c58b5f80$var$Duration(conf);
}
function $63618293c58b5f80$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $63618293c58b5f80$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $63618293c58b5f80$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $63618293c58b5f80$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $63618293c58b5f80$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $63618293c58b5f80$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $63618293c58b5f80$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $63618293c58b5f80$var$accurateMatrix : $63618293c58b5f80$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $63618293c58b5f80$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $63618293c58b5f80$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($63618293c58b5f80$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $63618293c58b5f80$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $63618293c58b5f80$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $63618293c58b5f80$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $63618293c58b5f80$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$2;
        var l = $63618293c58b5f80$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($63618293c58b5f80$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($63618293c58b5f80$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($63618293c58b5f80$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $63618293c58b5f80$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $63618293c58b5f80$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $63618293c58b5f80$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $63618293c58b5f80$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $63618293c58b5f80$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($63618293c58b5f80$var$hasOwnProperty(dur.values, k) || $63618293c58b5f80$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $63618293c58b5f80$var$asNumber(fn(this.values[k], k));
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $63618293c58b5f80$var$_extends({}, this.values, $63618293c58b5f80$var$normalizeObject(values, Duration.normalizeUnit));
        return $63618293c58b5f80$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $63618293c58b5f80$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $63618293c58b5f80$var$normalizeValues(this.matrix, vals);
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $63618293c58b5f80$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $63618293c58b5f80$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($63618293c58b5f80$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($63618293c58b5f80$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $63618293c58b5f80$var$normalizeValues(this.matrix, built);
        return $63618293c58b5f80$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $63618293c58b5f80$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $63618293c58b5f80$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $63618293c58b5f80$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $63618293c58b5f80$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $63618293c58b5f80$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $63618293c58b5f80$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $63618293c58b5f80$var$friendlyDateTime(start), builtEnd = $63618293c58b5f80$var$friendlyDateTime(end);
        var validateError = $63618293c58b5f80$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $63618293c58b5f80$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $63618293c58b5f80$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $63618293c58b5f80$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $63618293c58b5f80$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ ;
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($63618293c58b5f80$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $63618293c58b5f80$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $63618293c58b5f80$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $63618293c58b5f80$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $63618293c58b5f80$var$Settings.defaultZone;
        var proto = $63618293c58b5f80$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $63618293c58b5f80$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $63618293c58b5f80$var$normalizeZone(input, $63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ ;
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getStartOfWeek();
    } /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ ;
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getMinDaysInFirstWeek();
    } /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ ;
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getWeekendDays().slice();
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $63618293c58b5f80$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $63618293c58b5f80$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $63618293c58b5f80$var$hasRelative(),
            localeWeek: $63618293c58b5f80$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $63618293c58b5f80$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($63618293c58b5f80$var$Duration.fromMillis(ms).as("days"));
}
function $63618293c58b5f80$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $63618293c58b5f80$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $63618293c58b5f80$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $63618293c58b5f80$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $63618293c58b5f80$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $63618293c58b5f80$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $63618293c58b5f80$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $63618293c58b5f80$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $63618293c58b5f80$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $63618293c58b5f80$var$hanidecChars = $63618293c58b5f80$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $63618293c58b5f80$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($63618293c58b5f80$var$numberingSystems.hanidec) !== -1) value += $63618293c58b5f80$var$hanidecChars.indexOf(str[i]);
            else for(var key in $63618293c58b5f80$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $63618293c58b5f80$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $63618293c58b5f80$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $63618293c58b5f80$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $63618293c58b5f80$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $63618293c58b5f80$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($63618293c58b5f80$var$parseDigits(s));
        }
    };
}
var $63618293c58b5f80$var$NBSP = String.fromCharCode(160);
var $63618293c58b5f80$var$spaceOrNBSP = "[ " + $63618293c58b5f80$var$NBSP + "]";
var $63618293c58b5f80$var$spaceOrNBSPRegExp = new RegExp($63618293c58b5f80$var$spaceOrNBSP, "g");
function $63618293c58b5f80$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($63618293c58b5f80$var$spaceOrNBSPRegExp, $63618293c58b5f80$var$spaceOrNBSP);
}
function $63618293c58b5f80$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($63618293c58b5f80$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $63618293c58b5f80$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($63618293c58b5f80$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $63618293c58b5f80$var$stripInsensitivities(s) === $63618293c58b5f80$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $63618293c58b5f80$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $63618293c58b5f80$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $63618293c58b5f80$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $63618293c58b5f80$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $63618293c58b5f80$var$unitForToken(token, loc) {
    var one = $63618293c58b5f80$var$digitRegex(loc), two = $63618293c58b5f80$var$digitRegex(loc, "{2}"), three = $63618293c58b5f80$var$digitRegex(loc, "{3}"), four = $63618293c58b5f80$var$digitRegex(loc, "{4}"), six = $63618293c58b5f80$var$digitRegex(loc, "{6}"), oneOrTwo = $63618293c58b5f80$var$digitRegex(loc, "{1,2}"), oneToThree = $63618293c58b5f80$var$digitRegex(loc, "{1,3}"), oneToSix = $63618293c58b5f80$var$digitRegex(loc, "{1,6}"), oneToNine = $63618293c58b5f80$var$digitRegex(loc, "{1,9}"), twoToFour = $63618293c58b5f80$var$digitRegex(loc, "{2,4}"), fourToSix = $63618293c58b5f80$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($63618293c58b5f80$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $63618293c58b5f80$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $63618293c58b5f80$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $63618293c58b5f80$var$intUnit(oneToSix);
            case "yy":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            case "yyyy":
                return $63618293c58b5f80$var$intUnit(four);
            case "yyyyy":
                return $63618293c58b5f80$var$intUnit(fourToSix);
            case "yyyyyy":
                return $63618293c58b5f80$var$intUnit(six);
            // months
            case "M":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "MM":
                return $63618293c58b5f80$var$intUnit(two);
            case "MMM":
                return $63618293c58b5f80$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $63618293c58b5f80$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "LL":
                return $63618293c58b5f80$var$intUnit(two);
            case "LLL":
                return $63618293c58b5f80$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $63618293c58b5f80$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "dd":
                return $63618293c58b5f80$var$intUnit(two);
            // ordinals
            case "o":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "ooo":
                return $63618293c58b5f80$var$intUnit(three);
            // time
            case "HH":
                return $63618293c58b5f80$var$intUnit(two);
            case "H":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "hh":
                return $63618293c58b5f80$var$intUnit(two);
            case "h":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "mm":
                return $63618293c58b5f80$var$intUnit(two);
            case "m":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "q":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "qq":
                return $63618293c58b5f80$var$intUnit(two);
            case "s":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "ss":
                return $63618293c58b5f80$var$intUnit(two);
            case "S":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "SSS":
                return $63618293c58b5f80$var$intUnit(three);
            case "u":
                return $63618293c58b5f80$var$simple(oneToNine);
            case "uu":
                return $63618293c58b5f80$var$simple(oneOrTwo);
            case "uuu":
                return $63618293c58b5f80$var$intUnit(one);
            // meridiem
            case "a":
                return $63618293c58b5f80$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $63618293c58b5f80$var$intUnit(four);
            case "kk":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "WW":
                return $63618293c58b5f80$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $63618293c58b5f80$var$intUnit(one);
            case "EEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $63618293c58b5f80$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $63618293c58b5f80$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $63618293c58b5f80$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $63618293c58b5f80$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $63618293c58b5f80$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $63618293c58b5f80$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $63618293c58b5f80$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $63618293c58b5f80$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($63618293c58b5f80$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $63618293c58b5f80$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$63618293c58b5f80$var$isUndefined(matches.z)) zone = $63618293c58b5f80$var$IANAZone.create(matches.z);
    if (!$63618293c58b5f80$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $63618293c58b5f80$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$63618293c58b5f80$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$63618293c58b5f80$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$63618293c58b5f80$var$isUndefined(matches.u)) matches.S = $63618293c58b5f80$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $63618293c58b5f80$var$dummyDateTimeCache = null;
function $63618293c58b5f80$var$getDummyDateTime() {
    if (!$63618293c58b5f80$var$dummyDateTimeCache) $63618293c58b5f80$var$dummyDateTimeCache = $63618293c58b5f80$var$DateTime.fromMillis(1555555555555);
    return $63618293c58b5f80$var$dummyDateTimeCache;
}
function $63618293c58b5f80$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $63618293c58b5f80$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $63618293c58b5f80$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $63618293c58b5f80$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $63618293c58b5f80$var$explainFromTokens(locale, input, format) {
    var tokens = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $63618293c58b5f80$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $63618293c58b5f80$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $63618293c58b5f80$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $63618293c58b5f80$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($63618293c58b5f80$var$hasOwnProperty(matches, "a") && $63618293c58b5f80$var$hasOwnProperty(matches, "H")) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $63618293c58b5f80$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $63618293c58b5f80$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $63618293c58b5f80$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($63618293c58b5f80$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $63618293c58b5f80$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $63618293c58b5f80$var$INVALID = "Invalid DateTime";
var $63618293c58b5f80$var$MAX_DATE = 8.64e15;
function $63618293c58b5f80$var$unsupportedZone(zone) {
    return new $63618293c58b5f80$var$Invalid("unsupported zone", 'the zone "' + zone.name + '" is not supported');
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $63618293c58b5f80$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $63618293c58b5f80$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $63618293c58b5f80$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $63618293c58b5f80$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $63618293c58b5f80$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $63618293c58b5f80$var$DateTime($63618293c58b5f80$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $63618293c58b5f80$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $63618293c58b5f80$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $63618293c58b5f80$var$objToTS(obj, offset, zone) {
    return $63618293c58b5f80$var$fixOffset($63618293c58b5f80$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $63618293c58b5f80$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $63618293c58b5f80$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $63618293c58b5f80$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $63618293c58b5f80$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $63618293c58b5f80$var$objToLocalTS(c);
    var _fixOffset = $63618293c58b5f80$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $63618293c58b5f80$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $63618293c58b5f80$var$DateTime.fromObject(parsed, $63618293c58b5f80$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $63618293c58b5f80$var$DateTime.invalid(new $63618293c58b5f80$var$Invalid("unparsable", 'the input "' + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $63618293c58b5f80$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $63618293c58b5f80$var$Formatter.create($63618293c58b5f80$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $63618293c58b5f80$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $63618293c58b5f80$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.day);
    } else {
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += $63618293c58b5f80$var$padStart(o.c.day);
    }
    return c;
}
function $63618293c58b5f80$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $63618293c58b5f80$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $63618293c58b5f80$var$padStart(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $63618293c58b5f80$var$padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += $63618293c58b5f80$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $63618293c58b5f80$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $63618293c58b5f80$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $63618293c58b5f80$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $63618293c58b5f80$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
    return normalized;
}
function $63618293c58b5f80$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $63618293c58b5f80$var$normalizeUnit(unit);
    }
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $63618293c58b5f80$var$quickDT(obj, opts) {
    var zone = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone), loc = $63618293c58b5f80$var$Locale.fromObject(opts), tsNow = $63618293c58b5f80$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$63618293c58b5f80$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($63618293c58b5f80$var$isUndefined(obj[u])) obj[u] = $63618293c58b5f80$var$defaultUnitValues[u];
        }
        var invalid = $63618293c58b5f80$var$hasInvalidGregorianData(obj) || $63618293c58b5f80$var$hasInvalidTimeData(obj);
        if (invalid) return $63618293c58b5f80$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $63618293c58b5f80$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $63618293c58b5f80$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $63618293c58b5f80$var$diffRelative(start, end, opts) {
    var round = $63618293c58b5f80$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $63618293c58b5f80$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $63618293c58b5f80$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $63618293c58b5f80$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $63618293c58b5f80$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $63618293c58b5f80$var$Invalid("invalid input") : null) || (!zone.isValid ? $63618293c58b5f80$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $63618293c58b5f80$var$isUndefined(config.ts) ? $63618293c58b5f80$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $63618293c58b5f80$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $63618293c58b5f80$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $63618293c58b5f80$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(milliseconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$63618293c58b5f80$var$MAX_DATE || milliseconds > $63618293c58b5f80$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(seconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        var loc = $63618293c58b5f80$var$Locale.fromObject(opts);
        var normalized = $63618293c58b5f80$var$normalizeObject(obj, $63618293c58b5f80$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $63618293c58b5f80$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = !$63618293c58b5f80$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $63618293c58b5f80$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $63618293c58b5f80$var$orderedWeekUnits;
            defaultValues = $63618293c58b5f80$var$defaultWeekUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $63618293c58b5f80$var$orderedOrdinalUnits;
            defaultValues = $63618293c58b5f80$var$defaultOrdinalUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToOrdinal(objNow);
        } else {
            units = $63618293c58b5f80$var$orderedUnits;
            defaultValues = $63618293c58b5f80$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$63618293c58b5f80$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $63618293c58b5f80$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $63618293c58b5f80$var$hasInvalidOrdinalData(normalized) : $63618293c58b5f80$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $63618293c58b5f80$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $63618293c58b5f80$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $63618293c58b5f80$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $63618293c58b5f80$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $63618293c58b5f80$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $63618293c58b5f80$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $63618293c58b5f80$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(fmt)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $63618293c58b5f80$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $63618293c58b5f80$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(fmt), $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $63618293c58b5f80$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $63618293c58b5f80$var$tsToObj(ts1, o1);
        var c2 = $63618293c58b5f80$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $63618293c58b5f80$var$clone(this, {
                ts: ts1
            }),
            $63618293c58b5f80$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($63618293c58b5f80$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $63618293c58b5f80$var$normalizeZone(zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $63618293c58b5f80$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $63618293c58b5f80$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $63618293c58b5f80$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $63618293c58b5f80$var$normalizeObject(values, $63618293c58b5f80$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $63618293c58b5f80$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$63618293c58b5f80$var$isUndefined(normalized.weekYear) || !$63618293c58b5f80$var$isUndefined(normalized.weekNumber) || !$63618293c58b5f80$var$isUndefined(normalized.weekday), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $63618293c58b5f80$var$weekToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$63618293c58b5f80$var$isUndefined(normalized.ordinal)) mixed = $63618293c58b5f80$var$ordinalToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $63618293c58b5f80$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($63618293c58b5f80$var$isUndefined(normalized.day)) mixed.day = Math.min($63618293c58b5f80$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $63618293c58b5f80$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $63618293c58b5f80$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration).negate();
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $63618293c58b5f80$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $63618293c58b5f80$var$_toISODate(this, ext);
        c += "T";
        c += $63618293c58b5f80$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $63618293c58b5f80$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $63618293c58b5f80$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $63618293c58b5f80$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $63618293c58b5f80$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $63618293c58b5f80$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $63618293c58b5f80$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $63618293c58b5f80$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $63618293c58b5f80$var$maybeArray(unit).map($63618293c58b5f80$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $63618293c58b5f80$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $63618293c58b5f80$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $63618293c58b5f80$var$diffRelative(base, this.plus(padding), $63618293c58b5f80$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $63618293c58b5f80$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $63618293c58b5f80$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $63618293c58b5f80$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $63618293c58b5f80$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $63618293c58b5f80$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $63618293c58b5f80$var$friendlyDateTime(dateTimeish) {
    if ($63618293c58b5f80$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $63618293c58b5f80$var$isNumber(dateTimeish.valueOf())) return $63618293c58b5f80$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $63618293c58b5f80$var$DateTime.fromObject(dateTimeish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $63618293c58b5f80$var$VERSION = "3.4.4";
module.exports.DateTime = $63618293c58b5f80$var$DateTime;
module.exports.Duration = $63618293c58b5f80$var$Duration;
module.exports.FixedOffsetZone = $63618293c58b5f80$var$FixedOffsetZone;
module.exports.IANAZone = $63618293c58b5f80$var$IANAZone;
module.exports.Info = $63618293c58b5f80$var$Info;
module.exports.Interval = $63618293c58b5f80$var$Interval;
module.exports.InvalidZone = $63618293c58b5f80$var$InvalidZone;
module.exports.Settings = $63618293c58b5f80$var$Settings;
module.exports.SystemZone = $63618293c58b5f80$var$SystemZone;
module.exports.VERSION = $63618293c58b5f80$var$VERSION;
module.exports.Zone = $63618293c58b5f80$var$Zone;

});

parcelRegister("8WR9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $683cf8c388805c2a$export$2e2bcd8739ae039);
function $683cf8c388805c2a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $683cf8c388805c2a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $683cf8c388805c2a$var$_typeof(obj);
}
function $683cf8c388805c2a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $683cf8c388805c2a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $683cf8c388805c2a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $683cf8c388805c2a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $683cf8c388805c2a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $683cf8c388805c2a$var$_extends() {
    $683cf8c388805c2a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $683cf8c388805c2a$var$_extends.apply(this, arguments);
}
function $683cf8c388805c2a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $683cf8c388805c2a$var$_setPrototypeOf(subClass, superClass);
}
function $683cf8c388805c2a$var$_getPrototypeOf(o) {
    $683cf8c388805c2a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $683cf8c388805c2a$var$_getPrototypeOf(o);
}
function $683cf8c388805c2a$var$_setPrototypeOf(o, p) {
    $683cf8c388805c2a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $683cf8c388805c2a$var$_setPrototypeOf(o, p);
}
function $683cf8c388805c2a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $683cf8c388805c2a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $683cf8c388805c2a$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $683cf8c388805c2a$var$_assertThisInitialized(self);
}
function $683cf8c388805c2a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $683cf8c388805c2a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $683cf8c388805c2a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $683cf8c388805c2a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $683cf8c388805c2a$var$_possibleConstructorReturn(this, result);
    };
}
/**
 * This class represents a basic channel.
 */ var $683cf8c388805c2a$export$cfdacaa37f9b4dd7 = /*#__PURE__*/ function() {
    function Channel() {
        $683cf8c388805c2a$var$_classCallCheck(this, Channel);
    }
    $683cf8c388805c2a$var$_createClass(Channel, [
        {
            key: "listenForWhisper",
            value: /**
     * Listen for a whisper event on the channel instance.
     */ function listenForWhisper(event, callback) {
                return this.listen(".client-" + event, callback);
            }
        },
        {
            key: "notification",
            value: function notification(callback) {
                return this.listen(".Illuminate\\Notifications\\Events\\BroadcastNotificationCreated", callback);
            }
        },
        {
            key: "stopListeningForWhisper",
            value: function stopListeningForWhisper(event, callback) {
                return this.stopListening(".client-" + event, callback);
            }
        }
    ]);
    return Channel;
}();
/**
 * Event name formatter
 */ var $683cf8c388805c2a$export$a8f50c7ec96013cf = /*#__PURE__*/ function() {
    /**
   * Create a new class instance.
   */ function EventFormatter(namespace) {
        $683cf8c388805c2a$var$_classCallCheck(this, EventFormatter);
        this.namespace = namespace; //
    }
    /**
   * Format the given event name.
   */ $683cf8c388805c2a$var$_createClass(EventFormatter, [
        {
            key: "format",
            value: function format(event) {
                if (event.charAt(0) === "." || event.charAt(0) === "\\") return event.substr(1);
                else if (this.namespace) event = this.namespace + "." + event;
                return event.replace(/\./g, "\\");
            }
        },
        {
            key: "setNamespace",
            value: function setNamespace(value) {
                this.namespace = value;
            }
        }
    ]);
    return EventFormatter;
}();
/**
 * This class represents a Pusher channel.
 */ var $683cf8c388805c2a$var$PusherChannel = /*#__PURE__*/ function(_Channel) {
    $683cf8c388805c2a$var$_inherits(PusherChannel, _Channel);
    var _super = $683cf8c388805c2a$var$_createSuper(PusherChannel);
    /**
   * Create a new class instance.
   */ function PusherChannel(pusher, name, options) {
        var _this;
        $683cf8c388805c2a$var$_classCallCheck(this, PusherChannel);
        _this = _super.call(this);
        _this.name = name;
        _this.pusher = pusher;
        _this.options = options;
        _this.eventFormatter = new $683cf8c388805c2a$export$a8f50c7ec96013cf(_this.options.namespace);
        _this.subscribe();
        return _this;
    }
    /**
   * Subscribe to a Pusher channel.
   */ $683cf8c388805c2a$var$_createClass(PusherChannel, [
        {
            key: "subscribe",
            value: function subscribe() {
                this.subscription = this.pusher.subscribe(this.name);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                this.pusher.unsubscribe(this.name);
            }
        },
        {
            key: "listen",
            value: function listen(event, callback) {
                this.on(this.eventFormatter.format(event), callback);
                return this;
            }
        },
        {
            key: "listenToAll",
            value: function listenToAll(callback) {
                var _this2 = this;
                this.subscription.bind_global(function(event, data) {
                    if (event.startsWith("pusher:")) return;
                    var namespace = _this2.options.namespace.replace(/\./g, "\\");
                    var formattedEvent = event.startsWith(namespace) ? event.substring(namespace.length + 1) : "." + event;
                    callback(formattedEvent, data);
                });
                return this;
            }
        },
        {
            key: "stopListening",
            value: function stopListening(event, callback) {
                if (callback) this.subscription.unbind(this.eventFormatter.format(event), callback);
                else this.subscription.unbind(this.eventFormatter.format(event));
                return this;
            }
        },
        {
            key: "stopListeningToAll",
            value: function stopListeningToAll(callback) {
                if (callback) this.subscription.unbind_global(callback);
                else this.subscription.unbind_global();
                return this;
            }
        },
        {
            key: "subscribed",
            value: function subscribed(callback) {
                this.on("pusher:subscription_succeeded", function() {
                    callback();
                });
                return this;
            }
        },
        {
            key: "error",
            value: function error(callback) {
                this.on("pusher:subscription_error", function(status) {
                    callback(status);
                });
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                this.subscription.bind(event, callback);
                return this;
            }
        }
    ]);
    return PusherChannel;
}($683cf8c388805c2a$export$cfdacaa37f9b4dd7);
/**
 * This class represents a Pusher private channel.
 */ var $683cf8c388805c2a$var$PusherPrivateChannel = /*#__PURE__*/ function(_PusherChannel) {
    $683cf8c388805c2a$var$_inherits(PusherPrivateChannel, _PusherChannel);
    var _super = $683cf8c388805c2a$var$_createSuper(PusherPrivateChannel);
    function PusherPrivateChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, PusherPrivateChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(PusherPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
                return this;
            }
        }
    ]);
    return PusherPrivateChannel;
}($683cf8c388805c2a$var$PusherChannel);
/**
 * This class represents a Pusher private channel.
 */ var $683cf8c388805c2a$var$PusherEncryptedPrivateChannel = /*#__PURE__*/ function(_PusherChannel) {
    $683cf8c388805c2a$var$_inherits(PusherEncryptedPrivateChannel, _PusherChannel);
    var _super = $683cf8c388805c2a$var$_createSuper(PusherEncryptedPrivateChannel);
    function PusherEncryptedPrivateChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, PusherEncryptedPrivateChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(PusherEncryptedPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
                return this;
            }
        }
    ]);
    return PusherEncryptedPrivateChannel;
}($683cf8c388805c2a$var$PusherChannel);
/**
 * This class represents a Pusher presence channel.
 */ var $683cf8c388805c2a$var$PusherPresenceChannel = /*#__PURE__*/ function(_PusherChannel) {
    $683cf8c388805c2a$var$_inherits(PusherPresenceChannel, _PusherChannel);
    var _super = $683cf8c388805c2a$var$_createSuper(PusherPresenceChannel);
    function PusherPresenceChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, PusherPresenceChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(PusherPresenceChannel, [
        {
            key: "here",
            value: /**
     * Register a callback to be called anytime the member list changes.
     */ function here(callback) {
                this.on("pusher:subscription_succeeded", function(data) {
                    callback(Object.keys(data.members).map(function(k) {
                        return data.members[k];
                    }));
                });
                return this;
            }
        },
        {
            key: "joining",
            value: function joining(callback) {
                this.on("pusher:member_added", function(member) {
                    callback(member.info);
                });
                return this;
            }
        },
        {
            key: "whisper",
            value: function whisper(eventName, data) {
                this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
                return this;
            }
        },
        {
            key: "leaving",
            value: function leaving(callback) {
                this.on("pusher:member_removed", function(member) {
                    callback(member.info);
                });
                return this;
            }
        }
    ]);
    return PusherPresenceChannel;
}($683cf8c388805c2a$var$PusherChannel);
/**
 * This class represents a Socket.io channel.
 */ var $683cf8c388805c2a$var$SocketIoChannel = /*#__PURE__*/ function(_Channel) {
    $683cf8c388805c2a$var$_inherits(SocketIoChannel, _Channel);
    var _super = $683cf8c388805c2a$var$_createSuper(SocketIoChannel);
    /**
   * Create a new class instance.
   */ function SocketIoChannel(socket, name, options) {
        var _this;
        $683cf8c388805c2a$var$_classCallCheck(this, SocketIoChannel);
        _this = _super.call(this);
        /**
     * The event callbacks applied to the socket.
     */ _this.events = {};
        /**
     * User supplied callbacks for events on this channel.
     */ _this.listeners = {};
        _this.name = name;
        _this.socket = socket;
        _this.options = options;
        _this.eventFormatter = new $683cf8c388805c2a$export$a8f50c7ec96013cf(_this.options.namespace);
        _this.subscribe();
        return _this;
    }
    /**
   * Subscribe to a Socket.io channel.
   */ $683cf8c388805c2a$var$_createClass(SocketIoChannel, [
        {
            key: "subscribe",
            value: function subscribe() {
                this.socket.emit("subscribe", {
                    channel: this.name,
                    auth: this.options.auth || {}
                });
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                this.unbind();
                this.socket.emit("unsubscribe", {
                    channel: this.name,
                    auth: this.options.auth || {}
                });
            }
        },
        {
            key: "listen",
            value: function listen(event, callback) {
                this.on(this.eventFormatter.format(event), callback);
                return this;
            }
        },
        {
            key: "stopListening",
            value: function stopListening(event, callback) {
                this.unbindEvent(this.eventFormatter.format(event), callback);
                return this;
            }
        },
        {
            key: "subscribed",
            value: function subscribed(callback) {
                this.on("connect", function(socket) {
                    callback(socket);
                });
                return this;
            }
        },
        {
            key: "error",
            value: function error(callback) {
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                var _this2 = this;
                this.listeners[event] = this.listeners[event] || [];
                if (!this.events[event]) {
                    this.events[event] = function(channel, data) {
                        if (_this2.name === channel && _this2.listeners[event]) _this2.listeners[event].forEach(function(cb) {
                            return cb(data);
                        });
                    };
                    this.socket.on(event, this.events[event]);
                }
                this.listeners[event].push(callback);
                return this;
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                var _this3 = this;
                Object.keys(this.events).forEach(function(event) {
                    _this3.unbindEvent(event);
                });
            }
        },
        {
            key: "unbindEvent",
            value: function unbindEvent(event, callback) {
                this.listeners[event] = this.listeners[event] || [];
                if (callback) this.listeners[event] = this.listeners[event].filter(function(cb) {
                    return cb !== callback;
                });
                if (!callback || this.listeners[event].length === 0) {
                    if (this.events[event]) {
                        this.socket.removeListener(event, this.events[event]);
                        delete this.events[event];
                    }
                    delete this.listeners[event];
                }
            }
        }
    ]);
    return SocketIoChannel;
}($683cf8c388805c2a$export$cfdacaa37f9b4dd7);
/**
 * This class represents a Socket.io private channel.
 */ var $683cf8c388805c2a$var$SocketIoPrivateChannel = /*#__PURE__*/ function(_SocketIoChannel) {
    $683cf8c388805c2a$var$_inherits(SocketIoPrivateChannel, _SocketIoChannel);
    var _super = $683cf8c388805c2a$var$_createSuper(SocketIoPrivateChannel);
    function SocketIoPrivateChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, SocketIoPrivateChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(SocketIoPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                this.socket.emit("client event", {
                    channel: this.name,
                    event: "client-".concat(eventName),
                    data: data
                });
                return this;
            }
        }
    ]);
    return SocketIoPrivateChannel;
}($683cf8c388805c2a$var$SocketIoChannel);
/**
 * This class represents a Socket.io presence channel.
 */ var $683cf8c388805c2a$var$SocketIoPresenceChannel = /*#__PURE__*/ function(_SocketIoPrivateChann) {
    $683cf8c388805c2a$var$_inherits(SocketIoPresenceChannel, _SocketIoPrivateChann);
    var _super = $683cf8c388805c2a$var$_createSuper(SocketIoPresenceChannel);
    function SocketIoPresenceChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, SocketIoPresenceChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(SocketIoPresenceChannel, [
        {
            key: "here",
            value: /**
     * Register a callback to be called anytime the member list changes.
     */ function here(callback) {
                this.on("presence:subscribed", function(members) {
                    callback(members.map(function(m) {
                        return m.user_info;
                    }));
                });
                return this;
            }
        },
        {
            key: "joining",
            value: function joining(callback) {
                this.on("presence:joining", function(member) {
                    return callback(member.user_info);
                });
                return this;
            }
        },
        {
            key: "whisper",
            value: function whisper(eventName, data) {
                this.socket.emit("client event", {
                    channel: this.name,
                    event: "client-".concat(eventName),
                    data: data
                });
                return this;
            }
        },
        {
            key: "leaving",
            value: function leaving(callback) {
                this.on("presence:leaving", function(member) {
                    return callback(member.user_info);
                });
                return this;
            }
        }
    ]);
    return SocketIoPresenceChannel;
}($683cf8c388805c2a$var$SocketIoPrivateChannel);
/**
 * This class represents a null channel.
 */ var $683cf8c388805c2a$var$NullChannel = /*#__PURE__*/ function(_Channel) {
    $683cf8c388805c2a$var$_inherits(NullChannel, _Channel);
    var _super = $683cf8c388805c2a$var$_createSuper(NullChannel);
    function NullChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, NullChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(NullChannel, [
        {
            key: "subscribe",
            value: /**
     * Subscribe to a channel.
     */ function subscribe() {}
        },
        {
            key: "unsubscribe",
            value: function unsubscribe() {}
        },
        {
            key: "listen",
            value: function listen(event, callback) {
                return this;
            }
        },
        {
            key: "listenToAll",
            value: function listenToAll(callback) {
                return this;
            }
        },
        {
            key: "stopListening",
            value: function stopListening(event, callback) {
                return this;
            }
        },
        {
            key: "subscribed",
            value: function subscribed(callback) {
                return this;
            }
        },
        {
            key: "error",
            value: function error(callback) {
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                return this;
            }
        }
    ]);
    return NullChannel;
}($683cf8c388805c2a$export$cfdacaa37f9b4dd7);
/**
 * This class represents a null private channel.
 */ var $683cf8c388805c2a$var$NullPrivateChannel = /*#__PURE__*/ function(_NullChannel) {
    $683cf8c388805c2a$var$_inherits(NullPrivateChannel, _NullChannel);
    var _super = $683cf8c388805c2a$var$_createSuper(NullPrivateChannel);
    function NullPrivateChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, NullPrivateChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(NullPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                return this;
            }
        }
    ]);
    return NullPrivateChannel;
}($683cf8c388805c2a$var$NullChannel);
/**
 * This class represents a null presence channel.
 */ var $683cf8c388805c2a$var$NullPresenceChannel = /*#__PURE__*/ function(_NullChannel) {
    $683cf8c388805c2a$var$_inherits(NullPresenceChannel, _NullChannel);
    var _super = $683cf8c388805c2a$var$_createSuper(NullPresenceChannel);
    function NullPresenceChannel() {
        $683cf8c388805c2a$var$_classCallCheck(this, NullPresenceChannel);
        return _super.apply(this, arguments);
    }
    $683cf8c388805c2a$var$_createClass(NullPresenceChannel, [
        {
            key: "here",
            value: /**
     * Register a callback to be called anytime the member list changes.
     */ function here(callback) {
                return this;
            }
        },
        {
            key: "joining",
            value: function joining(callback) {
                return this;
            }
        },
        {
            key: "whisper",
            value: function whisper(eventName, data) {
                return this;
            }
        },
        {
            key: "leaving",
            value: function leaving(callback) {
                return this;
            }
        }
    ]);
    return NullPresenceChannel;
}($683cf8c388805c2a$var$NullChannel);
var $683cf8c388805c2a$export$b2278035370d6017 = /*#__PURE__*/ function() {
    /**
   * Create a new class instance.
   */ function Connector(options) {
        $683cf8c388805c2a$var$_classCallCheck(this, Connector);
        /**
     * Default connector options.
     */ this._defaultOptions = {
            auth: {
                headers: {}
            },
            authEndpoint: "/broadcasting/auth",
            userAuthentication: {
                endpoint: "/broadcasting/user-auth",
                headers: {}
            },
            broadcaster: "pusher",
            csrfToken: null,
            bearerToken: null,
            host: null,
            key: null,
            namespace: "App.Events"
        };
        this.setOptions(options);
        this.connect();
    }
    /**
   * Merge the custom options with the defaults.
   */ $683cf8c388805c2a$var$_createClass(Connector, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = $683cf8c388805c2a$var$_extends(this._defaultOptions, options);
                var token = this.csrfToken();
                if (token) {
                    this.options.auth.headers["X-CSRF-TOKEN"] = token;
                    this.options.userAuthentication.headers["X-CSRF-TOKEN"] = token;
                }
                token = this.options.bearerToken;
                if (token) {
                    this.options.auth.headers["Authorization"] = "Bearer " + token;
                    this.options.userAuthentication.headers["Authorization"] = "Bearer " + token;
                }
                return options;
            }
        },
        {
            key: "csrfToken",
            value: function csrfToken() {
                var selector;
                if (typeof window !== "undefined" && window["Laravel"] && window["Laravel"].csrfToken) return window["Laravel"].csrfToken;
                else if (this.options.csrfToken) return this.options.csrfToken;
                else if (typeof document !== "undefined" && typeof document.querySelector === "function" && (selector = document.querySelector('meta[name="csrf-token"]'))) return selector.getAttribute("content");
                return null;
            }
        }
    ]);
    return Connector;
}();
/**
 * This class creates a connector to Pusher.
 */ var $683cf8c388805c2a$var$PusherConnector = /*#__PURE__*/ function(_Connector) {
    $683cf8c388805c2a$var$_inherits(PusherConnector, _Connector);
    var _super = $683cf8c388805c2a$var$_createSuper(PusherConnector);
    function PusherConnector() {
        var _this;
        $683cf8c388805c2a$var$_classCallCheck(this, PusherConnector);
        _this = _super.apply(this, arguments);
        /**
     * All of the subscribed channel names.
     */ _this.channels = {};
        return _this;
    }
    /**
   * Create a fresh Pusher connection.
   */ $683cf8c388805c2a$var$_createClass(PusherConnector, [
        {
            key: "connect",
            value: function connect() {
                if (typeof this.options.client !== "undefined") this.pusher = this.options.client;
                else if (this.options.Pusher) this.pusher = new this.options.Pusher(this.options.key, this.options);
                else this.pusher = new Pusher(this.options.key, this.options);
            }
        },
        {
            key: "signin",
            value: function signin() {
                this.pusher.signin();
            }
        },
        {
            key: "listen",
            value: function listen(name, event, callback) {
                return this.channel(name).listen(event, callback);
            }
        },
        {
            key: "channel",
            value: function channel(name) {
                if (!this.channels[name]) this.channels[name] = new $683cf8c388805c2a$var$PusherChannel(this.pusher, name, this.options);
                return this.channels[name];
            }
        },
        {
            key: "privateChannel",
            value: function privateChannel(name) {
                if (!this.channels["private-" + name]) this.channels["private-" + name] = new $683cf8c388805c2a$var$PusherPrivateChannel(this.pusher, "private-" + name, this.options);
                return this.channels["private-" + name];
            }
        },
        {
            key: "encryptedPrivateChannel",
            value: function encryptedPrivateChannel(name) {
                if (!this.channels["private-encrypted-" + name]) this.channels["private-encrypted-" + name] = new $683cf8c388805c2a$var$PusherEncryptedPrivateChannel(this.pusher, "private-encrypted-" + name, this.options);
                return this.channels["private-encrypted-" + name];
            }
        },
        {
            key: "presenceChannel",
            value: function presenceChannel(name) {
                if (!this.channels["presence-" + name]) this.channels["presence-" + name] = new $683cf8c388805c2a$var$PusherPresenceChannel(this.pusher, "presence-" + name, this.options);
                return this.channels["presence-" + name];
            }
        },
        {
            key: "leave",
            value: function leave(name) {
                var _this2 = this;
                var channels = [
                    name,
                    "private-" + name,
                    "private-encrypted-" + name,
                    "presence-" + name
                ];
                channels.forEach(function(name, index) {
                    _this2.leaveChannel(name);
                });
            }
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(name) {
                if (this.channels[name]) {
                    this.channels[name].unsubscribe();
                    delete this.channels[name];
                }
            }
        },
        {
            key: "socketId",
            value: function socketId() {
                return this.pusher.connection.socket_id;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.pusher.disconnect();
            }
        }
    ]);
    return PusherConnector;
}($683cf8c388805c2a$export$b2278035370d6017);
/**
 * This class creates a connnector to a Socket.io server.
 */ var $683cf8c388805c2a$var$SocketIoConnector = /*#__PURE__*/ function(_Connector) {
    $683cf8c388805c2a$var$_inherits(SocketIoConnector, _Connector);
    var _super = $683cf8c388805c2a$var$_createSuper(SocketIoConnector);
    function SocketIoConnector() {
        var _this;
        $683cf8c388805c2a$var$_classCallCheck(this, SocketIoConnector);
        _this = _super.apply(this, arguments);
        /**
     * All of the subscribed channel names.
     */ _this.channels = {};
        return _this;
    }
    /**
   * Create a fresh Socket.io connection.
   */ $683cf8c388805c2a$var$_createClass(SocketIoConnector, [
        {
            key: "connect",
            value: function connect() {
                var _this2 = this;
                var io1 = this.getSocketIO();
                this.socket = io1(this.options.host, this.options);
                this.socket.on("reconnect", function() {
                    Object.values(_this2.channels).forEach(function(channel) {
                        channel.subscribe();
                    });
                });
                return this.socket;
            }
        },
        {
            key: "getSocketIO",
            value: function getSocketIO() {
                if (typeof this.options.client !== "undefined") return this.options.client;
                if (typeof io !== "undefined") return io;
                throw new Error("Socket.io client not found. Should be globally available or passed via options.client");
            }
        },
        {
            key: "listen",
            value: function listen(name, event, callback) {
                return this.channel(name).listen(event, callback);
            }
        },
        {
            key: "channel",
            value: function channel(name) {
                if (!this.channels[name]) this.channels[name] = new $683cf8c388805c2a$var$SocketIoChannel(this.socket, name, this.options);
                return this.channels[name];
            }
        },
        {
            key: "privateChannel",
            value: function privateChannel(name) {
                if (!this.channels["private-" + name]) this.channels["private-" + name] = new $683cf8c388805c2a$var$SocketIoPrivateChannel(this.socket, "private-" + name, this.options);
                return this.channels["private-" + name];
            }
        },
        {
            key: "presenceChannel",
            value: function presenceChannel(name) {
                if (!this.channels["presence-" + name]) this.channels["presence-" + name] = new $683cf8c388805c2a$var$SocketIoPresenceChannel(this.socket, "presence-" + name, this.options);
                return this.channels["presence-" + name];
            }
        },
        {
            key: "leave",
            value: function leave(name) {
                var _this3 = this;
                var channels = [
                    name,
                    "private-" + name,
                    "presence-" + name
                ];
                channels.forEach(function(name) {
                    _this3.leaveChannel(name);
                });
            }
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(name) {
                if (this.channels[name]) {
                    this.channels[name].unsubscribe();
                    delete this.channels[name];
                }
            }
        },
        {
            key: "socketId",
            value: function socketId() {
                return this.socket.id;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.socket.disconnect();
            }
        }
    ]);
    return SocketIoConnector;
}($683cf8c388805c2a$export$b2278035370d6017);
/**
 * This class creates a null connector.
 */ var $683cf8c388805c2a$var$NullConnector = /*#__PURE__*/ function(_Connector) {
    $683cf8c388805c2a$var$_inherits(NullConnector, _Connector);
    var _super = $683cf8c388805c2a$var$_createSuper(NullConnector);
    function NullConnector() {
        var _this;
        $683cf8c388805c2a$var$_classCallCheck(this, NullConnector);
        _this = _super.apply(this, arguments);
        /**
     * All of the subscribed channel names.
     */ _this.channels = {};
        return _this;
    }
    /**
   * Create a fresh connection.
   */ $683cf8c388805c2a$var$_createClass(NullConnector, [
        {
            key: "connect",
            value: function connect() {}
        },
        {
            key: "listen",
            value: function listen(name, event, callback) {
                return new $683cf8c388805c2a$var$NullChannel();
            }
        },
        {
            key: "channel",
            value: function channel(name) {
                return new $683cf8c388805c2a$var$NullChannel();
            }
        },
        {
            key: "privateChannel",
            value: function privateChannel(name) {
                return new $683cf8c388805c2a$var$NullPrivateChannel();
            }
        },
        {
            key: "encryptedPrivateChannel",
            value: function encryptedPrivateChannel(name) {
                return new $683cf8c388805c2a$var$NullPrivateChannel();
            }
        },
        {
            key: "presenceChannel",
            value: function presenceChannel(name) {
                return new $683cf8c388805c2a$var$NullPresenceChannel();
            }
        },
        {
            key: "leave",
            value: function leave(name) {}
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(name) {}
        },
        {
            key: "socketId",
            value: function socketId() {
                return "fake-socket-id";
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
    return NullConnector;
}($683cf8c388805c2a$export$b2278035370d6017);
/**
 * This class is the primary API for interacting with broadcasting.
 */ var $683cf8c388805c2a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Create a new class instance.
   */ function Echo(options) {
        $683cf8c388805c2a$var$_classCallCheck(this, Echo);
        this.options = options;
        this.connect();
        if (!this.options.withoutInterceptors) this.registerInterceptors();
    }
    /**
   * Get a channel instance by name.
   */ $683cf8c388805c2a$var$_createClass(Echo, [
        {
            key: "channel",
            value: function channel(_channel) {
                return this.connector.channel(_channel);
            }
        },
        {
            key: "connect",
            value: function connect() {
                if (this.options.broadcaster == "pusher") this.connector = new $683cf8c388805c2a$var$PusherConnector(this.options);
                else if (this.options.broadcaster == "socket.io") this.connector = new $683cf8c388805c2a$var$SocketIoConnector(this.options);
                else if (this.options.broadcaster == "null") this.connector = new $683cf8c388805c2a$var$NullConnector(this.options);
                else if (typeof this.options.broadcaster == "function") this.connector = new this.options.broadcaster(this.options);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.connector.disconnect();
            }
        },
        {
            key: "join",
            value: function join(channel) {
                return this.connector.presenceChannel(channel);
            }
        },
        {
            key: "leave",
            value: function leave(channel) {
                this.connector.leave(channel);
            }
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(channel) {
                this.connector.leaveChannel(channel);
            }
        },
        {
            key: "leaveAllChannels",
            value: function leaveAllChannels() {
                for(var channel in this.connector.channels)this.leaveChannel(channel);
            }
        },
        {
            key: "listen",
            value: function listen(channel, event, callback) {
                return this.connector.listen(channel, event, callback);
            }
        },
        {
            key: "private",
            value: function _private(channel) {
                return this.connector.privateChannel(channel);
            }
        },
        {
            key: "encryptedPrivate",
            value: function encryptedPrivate(channel) {
                return this.connector.encryptedPrivateChannel(channel);
            }
        },
        {
            key: "socketId",
            value: function socketId() {
                return this.connector.socketId();
            }
        },
        {
            key: "registerInterceptors",
            value: function registerInterceptors() {
                if (typeof Vue === "function" && Vue.http) this.registerVueRequestInterceptor();
                if (typeof axios === "function") this.registerAxiosRequestInterceptor();
                if (typeof jQuery === "function") this.registerjQueryAjaxSetup();
                if ((typeof Turbo === "undefined" ? "undefined" : $683cf8c388805c2a$var$_typeof(Turbo)) === "object") this.registerTurboRequestInterceptor();
            }
        },
        {
            key: "registerVueRequestInterceptor",
            value: function registerVueRequestInterceptor() {
                var _this = this;
                Vue.http.interceptors.push(function(request, next) {
                    if (_this.socketId()) request.headers.set("X-Socket-ID", _this.socketId());
                    next();
                });
            }
        },
        {
            key: "registerAxiosRequestInterceptor",
            value: function registerAxiosRequestInterceptor() {
                var _this2 = this;
                axios.interceptors.request.use(function(config) {
                    if (_this2.socketId()) config.headers["X-Socket-Id"] = _this2.socketId();
                    return config;
                });
            }
        },
        {
            key: "registerjQueryAjaxSetup",
            value: function registerjQueryAjaxSetup() {
                var _this3 = this;
                if (typeof jQuery.ajax != "undefined") jQuery.ajaxPrefilter(function(options, originalOptions, xhr) {
                    if (_this3.socketId()) xhr.setRequestHeader("X-Socket-Id", _this3.socketId());
                });
            }
        },
        {
            key: "registerTurboRequestInterceptor",
            value: function registerTurboRequestInterceptor() {
                var _this4 = this;
                document.addEventListener("turbo:before-fetch-request", function(event) {
                    event.detail.fetchOptions.headers["X-Socket-Id"] = _this4.socketId();
                });
            }
        }
    ]);
    return Echo;
}();

});

parcelRegister("e0UFp", function(module, exports) {
/*!
 * Pusher JavaScript Library v7.6.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 2);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            var __extends = this && this.__extends || function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package base64 implements Base64 encoding and decoding.
 */ // Invalid character used in decoding to indicate
            // that the character to decode is out of range of
            // alphabet and cannot be decoded.
            var INVALID_BYTE = 256;
            /**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */ var Coder = /** @class */ function() {
                // TODO(dchest): methods to encode chunk-by-chunk.
                function Coder(_paddingCharacter) {
                    if (_paddingCharacter === void 0) _paddingCharacter = "=";
                    this._paddingCharacter = _paddingCharacter;
                }
                Coder.prototype.encodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 8 + 5) / 6 | 0;
                    return (length + 2) / 3 * 4 | 0;
                };
                Coder.prototype.encode = function(data) {
                    var out = "";
                    var i = 0;
                    for(; i < data.length - 2; i += 3){
                        var c = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        out += this._encodeByte(c >>> 6 & 63);
                        out += this._encodeByte(c >>> 0 & 63);
                    }
                    var left = data.length - i;
                    if (left > 0) {
                        var c = data[i] << 16 | (left === 2 ? data[i + 1] << 8 : 0);
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        if (left === 2) out += this._encodeByte(c >>> 6 & 63);
                        else out += this._paddingCharacter || "";
                        out += this._paddingCharacter || "";
                    }
                    return out;
                };
                Coder.prototype.maxDecodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 6 + 7) / 8 | 0;
                    return length / 4 * 3 | 0;
                };
                Coder.prototype.decodedLength = function(s) {
                    return this.maxDecodedLength(s.length - this._getPaddingLength(s));
                };
                Coder.prototype.decode = function(s) {
                    if (s.length === 0) return new Uint8Array(0);
                    var paddingLength = this._getPaddingLength(s);
                    var length = s.length - paddingLength;
                    var out = new Uint8Array(this.maxDecodedLength(length));
                    var op = 0;
                    var i = 0;
                    var haveBad = 0;
                    var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
                    for(; i < length - 4; i += 4){
                        v0 = this._decodeChar(s.charCodeAt(i + 0));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        out[op++] = v1 << 4 | v2 >>> 2;
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                        haveBad |= v2 & INVALID_BYTE;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (i < length - 1) {
                        v0 = this._decodeChar(s.charCodeAt(i));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                    }
                    if (i < length - 2) {
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        out[op++] = v1 << 4 | v2 >>> 2;
                        haveBad |= v2 & INVALID_BYTE;
                    }
                    if (i < length - 3) {
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (haveBad !== 0) throw new Error("Base64Coder: incorrect characters for decoding");
                    return out;
                };
                // Standard encoding have the following encoded/decoded ranges,
                // which we need to convert between.
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
                //
                // Encode 6 bits in b into a new character.
                Coder.prototype._encodeByte = function(b) {
                    // Encoding uses constant time operations as follows:
                    //
                    // 1. Define comparison of A with B using (A - B) >>> 8:
                    //          if A > B, then result is positive integer
                    //          if A <= B, then result is 0
                    //
                    // 2. Define selection of C or 0 using bitwise AND: X & C:
                    //          if X == 0, then result is 0
                    //          if X != 0, then result is C
                    //
                    // 3. Start with the smallest comparison (b >= 0), which is always
                    //    true, so set the result to the starting ASCII value (65).
                    //
                    // 4. Continue comparing b to higher ASCII values, and selecting
                    //    zero if comparison isn't true, otherwise selecting a value
                    //    to add to result, which:
                    //
                    //          a) undoes the previous addition
                    //          b) provides new value to add
                    //
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -15;
                    // b > 62
                    result += 62 - b >>> 8 & 3;
                    return String.fromCharCode(result);
                };
                // Decode a character code into a byte.
                // Must return 256 if character is out of alphabet range.
                Coder.prototype._decodeChar = function(c) {
                    // Decoding works similar to encoding: using the same comparison
                    // function, but now it works on ranges: result is always incremented
                    // by value, but this value becomes zero if the range is not
                    // satisfied.
                    //
                    // Decoding starts with invalid value, 256, which is then
                    // subtracted when the range is satisfied. If none of the ranges
                    // apply, the function returns 256, which is then checked by
                    // the caller to throw error.
                    var result = INVALID_BYTE; // start with invalid character
                    // c == 43 (c > 42 and c < 44)
                    result += (42 - c & c - 44) >>> 8 & -INVALID_BYTE + c - 43 + 62;
                    // c == 47 (c > 46 and c < 48)
                    result += (46 - c & c - 48) >>> 8 & -INVALID_BYTE + c - 47 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                Coder.prototype._getPaddingLength = function(s) {
                    var paddingLength = 0;
                    if (this._paddingCharacter) {
                        for(var i = s.length - 1; i >= 0; i--){
                            if (s[i] !== this._paddingCharacter) break;
                            paddingLength++;
                        }
                        if (s.length < 4 || paddingLength > 2) throw new Error("Base64Coder: incorrect padding");
                    }
                    return paddingLength;
                };
                return Coder;
            }();
            exports.Coder = Coder;
            var stdCoder = new Coder();
            function encode(data) {
                return stdCoder.encode(data);
            }
            exports.encode = encode;
            function decode(s) {
                return stdCoder.decode(s);
            }
            exports.decode = decode;
            /**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */ var URLSafeCoder = /** @class */ function(_super) {
                __extends(URLSafeCoder, _super);
                function URLSafeCoder() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                // URL-safe encoding have the following encoded/decoded ranges:
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
                //
                URLSafeCoder.prototype._encodeByte = function(b) {
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -13;
                    // b > 62
                    result += 62 - b >>> 8 & 49;
                    return String.fromCharCode(result);
                };
                URLSafeCoder.prototype._decodeChar = function(c) {
                    var result = INVALID_BYTE;
                    // c == 45 (c > 44 and c < 46)
                    result += (44 - c & c - 46) >>> 8 & -INVALID_BYTE + c - 45 + 62;
                    // c == 95 (c > 94 and c < 96)
                    result += (94 - c & c - 96) >>> 8 & -INVALID_BYTE + c - 95 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                return URLSafeCoder;
            }(Coder);
            exports.URLSafeCoder = URLSafeCoder;
            var urlSafeCoder = new URLSafeCoder();
            function encodeURLSafe(data) {
                return urlSafeCoder.encode(data);
            }
            exports.encodeURLSafe = encodeURLSafe;
            function decodeURLSafe(s) {
                return urlSafeCoder.decode(s);
            }
            exports.decodeURLSafe = decodeURLSafe;
            exports.encodedLength = function(length) {
                return stdCoder.encodedLength(length);
            };
            exports.maxDecodedLength = function(length) {
                return stdCoder.maxDecodedLength(length);
            };
            exports.decodedLength = function(s) {
                return stdCoder.decodedLength(s);
            };
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package utf8 implements UTF-8 encoding and decoding.
 */ var INVALID_UTF16 = "utf8: invalid string";
            var INVALID_UTF8 = "utf8: invalid source encoding";
            /**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encode(s) {
                // Calculate result length and allocate output array.
                // encodedLength() also validates string and throws errors,
                // so we don't need repeat validation here.
                var arr = new Uint8Array(encodedLength(s));
                var pos = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) arr[pos++] = c;
                    else if (c < 0x800) {
                        arr[pos++] = 0xc0 | c >> 6;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800) {
                        arr[pos++] = 0xe0 | c >> 12;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else {
                        i++; // get one more character
                        c = (c & 0x3ff) << 10;
                        c |= s.charCodeAt(i) & 0x3ff;
                        c += 0x10000;
                        arr[pos++] = 0xf0 | c >> 18;
                        arr[pos++] = 0x80 | c >> 12 & 0x3f;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    }
                }
                return arr;
            }
            exports.encode = encode;
            /**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encodedLength(s) {
                var result = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) result += 1;
                    else if (c < 0x800) result += 2;
                    else if (c < 0xd800) result += 3;
                    else if (c <= 0xdfff) {
                        if (i >= s.length - 1) throw new Error(INVALID_UTF16);
                        i++; // "eat" next character
                        result += 4;
                    } else throw new Error(INVALID_UTF16);
                }
                return result;
            }
            exports.encodedLength = encodedLength;
            /**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */ function decode(arr) {
                var chars = [];
                for(var i = 0; i < arr.length; i++){
                    var b = arr[i];
                    if (b & 0x80) {
                        var min = void 0;
                        if (b < 0xe0) {
                            // Need 1 more byte.
                            if (i >= arr.length) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x1f) << 6 | n1 & 0x3f;
                            min = 0x80;
                        } else if (b < 0xf0) {
                            // Need 2 more bytes.
                            if (i >= arr.length - 1) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | n2 & 0x3f;
                            min = 0x800;
                        } else if (b < 0xf8) {
                            // Need 3 more bytes.
                            if (i >= arr.length - 2) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            var n3 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | n3 & 0x3f;
                            min = 0x10000;
                        } else throw new Error(INVALID_UTF8);
                        if (b < min || b >= 0xd800 && b <= 0xdfff) throw new Error(INVALID_UTF8);
                        if (b >= 0x10000) {
                            // Surrogate pair.
                            if (b > 0x10ffff) throw new Error(INVALID_UTF8);
                            b -= 0x10000;
                            chars.push(String.fromCharCode(0xd800 | b >> 10));
                            b = 0xdc00 | b & 0x3ff;
                        }
                    }
                    chars.push(String.fromCharCode(b));
                }
                return chars.join("");
            }
            exports.decode = decode;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            // required so we don't have to do require('pusher').default etc.
            module1.exports = __webpack_require__(3).default;
        /***/ },
        /* 3 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            // ESM COMPAT FLAG
            __webpack_require__.r(__webpack_exports__);
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_receiver_factory.ts
            var ScriptReceiverFactory = function() {
                function ScriptReceiverFactory(prefix, name) {
                    this.lastId = 0;
                    this.prefix = prefix;
                    this.name = name;
                }
                ScriptReceiverFactory.prototype.create = function(callback) {
                    this.lastId++;
                    var number = this.lastId;
                    var id = this.prefix + number;
                    var name = this.name + "[" + number + "]";
                    var called = false;
                    var callbackWrapper = function() {
                        if (!called) {
                            callback.apply(null, arguments);
                            called = true;
                        }
                    };
                    this[number] = callbackWrapper;
                    return {
                        number: number,
                        id: id,
                        name: name,
                        callback: callbackWrapper
                    };
                };
                ScriptReceiverFactory.prototype.remove = function(receiver) {
                    delete this[receiver.number];
                };
                return ScriptReceiverFactory;
            }();
            var ScriptReceivers = new ScriptReceiverFactory("_pusher_script_", "Pusher.ScriptReceivers");
            // CONCATENATED MODULE: ./src/core/defaults.ts
            var Defaults = {
                VERSION: "7.6.0",
                PROTOCOL: 7,
                wsPort: 80,
                wssPort: 443,
                wsPath: "",
                httpHost: "sockjs.pusher.com",
                httpPort: 80,
                httpsPort: 443,
                httpPath: "/pusher",
                stats_host: "stats.pusher.com",
                authEndpoint: "/pusher/auth",
                authTransport: "ajax",
                activityTimeout: 120000,
                pongTimeout: 30000,
                unavailableTimeout: 10000,
                cluster: "mt1",
                userAuthentication: {
                    endpoint: "/pusher/user-auth",
                    transport: "ajax"
                },
                channelAuthorization: {
                    endpoint: "/pusher/auth",
                    transport: "ajax"
                },
                cdn_http: "http://js.pusher.com",
                cdn_https: "https://js.pusher.com",
                dependency_suffix: ""
            };
            /* harmony default export */ var defaults = Defaults;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependency_loader.ts
            var dependency_loader_DependencyLoader = function() {
                function DependencyLoader(options) {
                    this.options = options;
                    this.receivers = options.receivers || ScriptReceivers;
                    this.loading = {};
                }
                DependencyLoader.prototype.load = function(name, options, callback) {
                    var self = this;
                    if (self.loading[name] && self.loading[name].length > 0) self.loading[name].push(callback);
                    else {
                        self.loading[name] = [
                            callback
                        ];
                        var request = runtime.createScriptRequest(self.getPath(name, options));
                        var receiver = self.receivers.create(function(error) {
                            self.receivers.remove(receiver);
                            if (self.loading[name]) {
                                var callbacks = self.loading[name];
                                delete self.loading[name];
                                var successCallback = function(wasSuccessful) {
                                    if (!wasSuccessful) request.cleanup();
                                };
                                for(var i = 0; i < callbacks.length; i++)callbacks[i](error, successCallback);
                            }
                        });
                        request.send(receiver);
                    }
                };
                DependencyLoader.prototype.getRoot = function(options) {
                    var cdn;
                    var protocol = runtime.getDocument().location.protocol;
                    if (options && options.useTLS || protocol === "https:") cdn = this.options.cdn_https;
                    else cdn = this.options.cdn_http;
                    return cdn.replace(/\/*$/, "") + "/" + this.options.version;
                };
                DependencyLoader.prototype.getPath = function(name, options) {
                    return this.getRoot(options) + "/" + name + this.options.suffix + ".js";
                };
                return DependencyLoader;
            }();
            /* harmony default export */ var dependency_loader = dependency_loader_DependencyLoader;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependencies.ts
            var DependenciesReceivers = new ScriptReceiverFactory("_pusher_dependencies", "Pusher.DependenciesReceivers");
            var Dependencies = new dependency_loader({
                cdn_http: defaults.cdn_http,
                cdn_https: defaults.cdn_https,
                version: defaults.VERSION,
                suffix: defaults.dependency_suffix,
                receivers: DependenciesReceivers
            });
            // CONCATENATED MODULE: ./src/core/utils/url_store.ts
            var urlStore = {
                baseUrl: "https://pusher.com",
                urls: {
                    authenticationEndpoint: {
                        path: "/docs/channels/server_api/authenticating_users"
                    },
                    authorizationEndpoint: {
                        path: "/docs/channels/server_api/authorizing-users/"
                    },
                    javascriptQuickStart: {
                        path: "/docs/javascript_quick_start"
                    },
                    triggeringClientEvents: {
                        path: "/docs/client_api_guide/client_events#trigger-events"
                    },
                    encryptedChannelSupport: {
                        fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
                    }
                }
            };
            var buildLogSuffix = function(key) {
                var urlPrefix = "See:";
                var urlObj = urlStore.urls[key];
                if (!urlObj) return "";
                var url;
                if (urlObj.fullUrl) url = urlObj.fullUrl;
                else if (urlObj.path) url = urlStore.baseUrl + urlObj.path;
                if (!url) return "";
                return urlPrefix + " " + url;
            };
            /* harmony default export */ var url_store = {
                buildLogSuffix: buildLogSuffix
            };
            // CONCATENATED MODULE: ./src/core/auth/options.ts
            var AuthRequestType;
            (function(AuthRequestType) {
                AuthRequestType["UserAuthentication"] = "user-authentication";
                AuthRequestType["ChannelAuthorization"] = "channel-authorization";
            })(AuthRequestType || (AuthRequestType = {}));
            // CONCATENATED MODULE: ./src/core/errors.ts
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var BadEventName = function(_super) {
                __extends(BadEventName, _super);
                function BadEventName(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return BadEventName;
            }(Error);
            var BadChannelName = function(_super) {
                __extends(BadChannelName, _super);
                function BadChannelName(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return BadChannelName;
            }(Error);
            var RequestTimedOut = function(_super) {
                __extends(RequestTimedOut, _super);
                function RequestTimedOut(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return RequestTimedOut;
            }(Error);
            var TransportPriorityTooLow = function(_super) {
                __extends(TransportPriorityTooLow, _super);
                function TransportPriorityTooLow(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return TransportPriorityTooLow;
            }(Error);
            var TransportClosed = function(_super) {
                __extends(TransportClosed, _super);
                function TransportClosed(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return TransportClosed;
            }(Error);
            var UnsupportedFeature = function(_super) {
                __extends(UnsupportedFeature, _super);
                function UnsupportedFeature(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return UnsupportedFeature;
            }(Error);
            var UnsupportedTransport = function(_super) {
                __extends(UnsupportedTransport, _super);
                function UnsupportedTransport(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return UnsupportedTransport;
            }(Error);
            var UnsupportedStrategy = function(_super) {
                __extends(UnsupportedStrategy, _super);
                function UnsupportedStrategy(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return UnsupportedStrategy;
            }(Error);
            var HTTPAuthError = function(_super) {
                __extends(HTTPAuthError, _super);
                function HTTPAuthError(status, msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    _this.status = status;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return HTTPAuthError;
            }(Error);
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/auth/xhr_auth.ts
            var ajax = function(context, query, authOptions, authRequestType, callback) {
                var xhr = runtime.createXHR();
                xhr.open("POST", authOptions.endpoint, true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                for(var headerName in authOptions.headers)xhr.setRequestHeader(headerName, authOptions.headers[headerName]);
                if (authOptions.headersProvider != null) {
                    var dynamicHeaders = authOptions.headersProvider();
                    for(var headerName in dynamicHeaders)xhr.setRequestHeader(headerName, dynamicHeaders[headerName]);
                }
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            var data = void 0;
                            var parsed = false;
                            try {
                                data = JSON.parse(xhr.responseText);
                                parsed = true;
                            } catch (e) {
                                callback(new HTTPAuthError(200, "JSON returned from " + authRequestType.toString() + " endpoint was invalid, yet status code was 200. Data was: " + xhr.responseText), null);
                            }
                            if (parsed) callback(null, data);
                        } else {
                            var suffix = "";
                            switch(authRequestType){
                                case AuthRequestType.UserAuthentication:
                                    suffix = url_store.buildLogSuffix("authenticationEndpoint");
                                    break;
                                case AuthRequestType.ChannelAuthorization:
                                    suffix = "Clients must be authorized to join private or presence channels. " + url_store.buildLogSuffix("authorizationEndpoint");
                                    break;
                            }
                            callback(new HTTPAuthError(xhr.status, "Unable to retrieve auth string from " + authRequestType.toString() + " endpoint - " + ("received status: " + xhr.status + " from " + authOptions.endpoint + ". " + suffix)), null);
                        }
                    }
                };
                xhr.send(query);
                return xhr;
            };
            /* harmony default export */ var xhr_auth = ajax;
            // CONCATENATED MODULE: ./src/core/base64.ts
            function encode(s) {
                return btoa(utob(s));
            }
            var fromCharCode = String.fromCharCode;
            var b64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var b64tab = {};
            for(var base64_i = 0, l = b64chars.length; base64_i < l; base64_i++)b64tab[b64chars.charAt(base64_i)] = base64_i;
            var cb_utob = function(c) {
                var cc = c.charCodeAt(0);
                return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
            };
            var utob = function(u) {
                return u.replace(/[^\x00-\x7F]/g, cb_utob);
            };
            var cb_encode = function(ccc) {
                var padlen = [
                    0,
                    2,
                    1
                ][ccc.length % 3];
                var ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
                var chars = [
                    b64chars.charAt(ord >>> 18),
                    b64chars.charAt(ord >>> 12 & 63),
                    padlen >= 2 ? "=" : b64chars.charAt(ord >>> 6 & 63),
                    padlen >= 1 ? "=" : b64chars.charAt(ord & 63)
                ];
                return chars.join("");
            };
            var btoa = window.btoa || function(b) {
                return b.replace(/[\s\S]{1,3}/g, cb_encode);
            };
            // CONCATENATED MODULE: ./src/core/utils/timers/abstract_timer.ts
            var Timer = function() {
                function Timer(set, clear, delay, callback) {
                    var _this = this;
                    this.clear = clear;
                    this.timer = set(function() {
                        if (_this.timer) _this.timer = callback(_this.timer);
                    }, delay);
                }
                Timer.prototype.isRunning = function() {
                    return this.timer !== null;
                };
                Timer.prototype.ensureAborted = function() {
                    if (this.timer) {
                        this.clear(this.timer);
                        this.timer = null;
                    }
                };
                return Timer;
            }();
            /* harmony default export */ var abstract_timer = Timer;
            // CONCATENATED MODULE: ./src/core/utils/timers/index.ts
            var timers_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            function timers_clearTimeout(timer) {
                window.clearTimeout(timer);
            }
            function timers_clearInterval(timer) {
                window.clearInterval(timer);
            }
            var OneOffTimer = function(_super) {
                timers_extends(OneOffTimer, _super);
                function OneOffTimer(delay, callback) {
                    return _super.call(this, setTimeout, timers_clearTimeout, delay, function(timer) {
                        callback();
                        return null;
                    }) || this;
                }
                return OneOffTimer;
            }(abstract_timer);
            var PeriodicTimer = function(_super) {
                timers_extends(PeriodicTimer, _super);
                function PeriodicTimer(delay, callback) {
                    return _super.call(this, setInterval, timers_clearInterval, delay, function(timer) {
                        callback();
                        return timer;
                    }) || this;
                }
                return PeriodicTimer;
            }(abstract_timer);
            // CONCATENATED MODULE: ./src/core/util.ts
            var Util = {
                now: function() {
                    if (Date.now) return Date.now();
                    else return new Date().valueOf();
                },
                defer: function(callback) {
                    return new OneOffTimer(0, callback);
                },
                method: function(name) {
                    var args = [];
                    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                    var boundArguments = Array.prototype.slice.call(arguments, 1);
                    return function(object) {
                        return object[name].apply(object, boundArguments.concat(arguments));
                    };
                }
            };
            /* harmony default export */ var util = Util;
            // CONCATENATED MODULE: ./src/core/utils/collections.ts
            function extend(target) {
                var sources = [];
                for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
                for(var i = 0; i < sources.length; i++){
                    var extensions = sources[i];
                    for(var property in extensions)if (extensions[property] && extensions[property].constructor && extensions[property].constructor === Object) target[property] = extend(target[property] || {}, extensions[property]);
                    else target[property] = extensions[property];
                }
                return target;
            }
            function stringify() {
                var m = [
                    "Pusher"
                ];
                for(var i = 0; i < arguments.length; i++)if (typeof arguments[i] === "string") m.push(arguments[i]);
                else m.push(safeJSONStringify(arguments[i]));
                return m.join(" : ");
            }
            function arrayIndexOf(array, item) {
                var nativeIndexOf = Array.prototype.indexOf;
                if (array === null) return -1;
                if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item);
                for(var i = 0, l = array.length; i < l; i++){
                    if (array[i] === item) return i;
                }
                return -1;
            }
            function objectApply(object, f) {
                for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) f(object[key], key, object);
            }
            function keys(object) {
                var keys = [];
                objectApply(object, function(_, key) {
                    keys.push(key);
                });
                return keys;
            }
            function values(object) {
                var values = [];
                objectApply(object, function(value) {
                    values.push(value);
                });
                return values;
            }
            function apply(array, f, context) {
                for(var i = 0; i < array.length; i++)f.call(context || window, array[i], i, array);
            }
            function map(array, f) {
                var result = [];
                for(var i = 0; i < array.length; i++)result.push(f(array[i], i, array, result));
                return result;
            }
            function mapObject(object, f) {
                var result = {};
                objectApply(object, function(value, key) {
                    result[key] = f(value);
                });
                return result;
            }
            function filter(array, test) {
                test = test || function(value) {
                    return !!value;
                };
                var result = [];
                for(var i = 0; i < array.length; i++)if (test(array[i], i, array, result)) result.push(array[i]);
                return result;
            }
            function filterObject(object, test) {
                var result = {};
                objectApply(object, function(value, key) {
                    if (test && test(value, key, object, result) || Boolean(value)) result[key] = value;
                });
                return result;
            }
            function flatten(object) {
                var result = [];
                objectApply(object, function(value, key) {
                    result.push([
                        key,
                        value
                    ]);
                });
                return result;
            }
            function any(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (test(array[i], i, array)) return true;
                }
                return false;
            }
            function collections_all(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (!test(array[i], i, array)) return false;
                }
                return true;
            }
            function encodeParamsObject(data) {
                return mapObject(data, function(value) {
                    if (typeof value === "object") value = safeJSONStringify(value);
                    return encodeURIComponent(encode(value.toString()));
                });
            }
            function buildQueryString(data) {
                var params = filterObject(data, function(value) {
                    return value !== undefined;
                });
                var query = map(flatten(encodeParamsObject(params)), util.method("join", "=")).join("&");
                return query;
            }
            function decycleObject(object) {
                var objects = [], paths = [];
                return function derez(value, path) {
                    var i, name, nu;
                    switch(typeof value){
                        case "object":
                            if (!value) return null;
                            for(i = 0; i < objects.length; i += 1){
                                if (objects[i] === value) return {
                                    $ref: paths[i]
                                };
                            }
                            objects.push(value);
                            paths.push(path);
                            if (Object.prototype.toString.apply(value) === "[object Array]") {
                                nu = [];
                                for(i = 0; i < value.length; i += 1)nu[i] = derez(value[i], path + "[" + i + "]");
                            } else {
                                nu = {};
                                for(name in value)if (Object.prototype.hasOwnProperty.call(value, name)) nu[name] = derez(value[name], path + "[" + JSON.stringify(name) + "]");
                            }
                            return nu;
                        case "number":
                        case "string":
                        case "boolean":
                            return value;
                    }
                }(object, "$");
            }
            function safeJSONStringify(source) {
                try {
                    return JSON.stringify(source);
                } catch (e) {
                    return JSON.stringify(decycleObject(source));
                }
            }
            // CONCATENATED MODULE: ./src/core/logger.ts
            var logger_Logger = function() {
                function Logger() {
                    this.globalLog = function(message) {
                        if (window.console && window.console.log) window.console.log(message);
                    };
                }
                Logger.prototype.debug = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    this.log(this.globalLog, args);
                };
                Logger.prototype.warn = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    this.log(this.globalLogWarn, args);
                };
                Logger.prototype.error = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    this.log(this.globalLogError, args);
                };
                Logger.prototype.globalLogWarn = function(message) {
                    if (window.console && window.console.warn) window.console.warn(message);
                    else this.globalLog(message);
                };
                Logger.prototype.globalLogError = function(message) {
                    if (window.console && window.console.error) window.console.error(message);
                    else this.globalLogWarn(message);
                };
                Logger.prototype.log = function(defaultLoggingFunction) {
                    var args = [];
                    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                    var message = stringify.apply(this, arguments);
                    if (core_pusher.log) core_pusher.log(message);
                    else if (core_pusher.logToConsole) {
                        var log = defaultLoggingFunction.bind(this);
                        log(message);
                    }
                };
                return Logger;
            }();
            /* harmony default export */ var logger = new logger_Logger();
            // CONCATENATED MODULE: ./src/runtimes/web/auth/jsonp_auth.ts
            var jsonp = function(context, query, authOptions, authRequestType, callback) {
                if (authOptions.headers !== undefined || authOptions.headersProvider != null) logger.warn("To send headers with the " + authRequestType.toString() + " request, you must use AJAX, rather than JSONP.");
                var callbackName = context.nextAuthCallbackID.toString();
                context.nextAuthCallbackID++;
                var document1 = context.getDocument();
                var script = document1.createElement("script");
                context.auth_callbacks[callbackName] = function(data) {
                    callback(null, data);
                };
                var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
                script.src = authOptions.endpoint + "?callback=" + encodeURIComponent(callback_name) + "&" + query;
                var head = document1.getElementsByTagName("head")[0] || document1.documentElement;
                head.insertBefore(script, head.firstChild);
            };
            /* harmony default export */ var jsonp_auth = jsonp;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_request.ts
            var ScriptRequest = function() {
                function ScriptRequest(src) {
                    this.src = src;
                }
                ScriptRequest.prototype.send = function(receiver) {
                    var self = this;
                    var errorString = "Error loading " + self.src;
                    self.script = document.createElement("script");
                    self.script.id = receiver.id;
                    self.script.src = self.src;
                    self.script.type = "text/javascript";
                    self.script.charset = "UTF-8";
                    if (self.script.addEventListener) {
                        self.script.onerror = function() {
                            receiver.callback(errorString);
                        };
                        self.script.onload = function() {
                            receiver.callback(null);
                        };
                    } else self.script.onreadystatechange = function() {
                        if (self.script.readyState === "loaded" || self.script.readyState === "complete") receiver.callback(null);
                    };
                    if (self.script.async === undefined && document.attachEvent && /opera/i.test(navigator.userAgent)) {
                        self.errorScript = document.createElement("script");
                        self.errorScript.id = receiver.id + "_error";
                        self.errorScript.text = receiver.name + "('" + errorString + "');";
                        self.script.async = self.errorScript.async = false;
                    } else self.script.async = true;
                    var head = document.getElementsByTagName("head")[0];
                    head.insertBefore(self.script, head.firstChild);
                    if (self.errorScript) head.insertBefore(self.errorScript, self.script.nextSibling);
                };
                ScriptRequest.prototype.cleanup = function() {
                    if (this.script) {
                        this.script.onload = this.script.onerror = null;
                        this.script.onreadystatechange = null;
                    }
                    if (this.script && this.script.parentNode) this.script.parentNode.removeChild(this.script);
                    if (this.errorScript && this.errorScript.parentNode) this.errorScript.parentNode.removeChild(this.errorScript);
                    this.script = null;
                    this.errorScript = null;
                };
                return ScriptRequest;
            }();
            /* harmony default export */ var script_request = ScriptRequest;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/jsonp_request.ts
            var jsonp_request_JSONPRequest = function() {
                function JSONPRequest(url, data) {
                    this.url = url;
                    this.data = data;
                }
                JSONPRequest.prototype.send = function(receiver) {
                    if (this.request) return;
                    var query = buildQueryString(this.data);
                    var url = this.url + "/" + receiver.number + "?" + query;
                    this.request = runtime.createScriptRequest(url);
                    this.request.send(receiver);
                };
                JSONPRequest.prototype.cleanup = function() {
                    if (this.request) this.request.cleanup();
                };
                return JSONPRequest;
            }();
            /* harmony default export */ var jsonp_request = jsonp_request_JSONPRequest;
            // CONCATENATED MODULE: ./src/runtimes/web/timeline/jsonp_timeline.ts
            var getAgent = function(sender, useTLS) {
                return function(data, callback) {
                    var scheme = "http" + (useTLS ? "s" : "") + "://";
                    var url = scheme + (sender.host || sender.options.host) + sender.options.path;
                    var request = runtime.createJSONPRequest(url, data);
                    var receiver = runtime.ScriptReceivers.create(function(error, result) {
                        ScriptReceivers.remove(receiver);
                        request.cleanup();
                        if (result && result.host) sender.host = result.host;
                        if (callback) callback(error, result);
                    });
                    request.send(receiver);
                };
            };
            var jsonp_timeline_jsonp = {
                name: "jsonp",
                getAgent: getAgent
            };
            /* harmony default export */ var jsonp_timeline = jsonp_timeline_jsonp;
            // CONCATENATED MODULE: ./src/core/transports/url_schemes.ts
            function getGenericURL(baseScheme, params, path) {
                var scheme = baseScheme + (params.useTLS ? "s" : "");
                var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
                return scheme + "://" + host + path;
            }
            function getGenericPath(key, queryString) {
                var path = "/app/" + key;
                var query = "?protocol=" + defaults.PROTOCOL + "&client=js" + "&version=" + defaults.VERSION + (queryString ? "&" + queryString : "");
                return path + query;
            }
            var ws = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || "") + getGenericPath(key, "flash=false");
                    return getGenericURL("ws", params, path);
                }
            };
            var http = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || "/pusher") + getGenericPath(key);
                    return getGenericURL("http", params, path);
                }
            };
            var sockjs = {
                getInitial: function(key, params) {
                    return getGenericURL("http", params, params.httpPath || "/pusher");
                },
                getPath: function(key, params) {
                    return getGenericPath(key);
                }
            };
            // CONCATENATED MODULE: ./src/core/events/callback_registry.ts
            var callback_registry_CallbackRegistry = function() {
                function CallbackRegistry() {
                    this._callbacks = {};
                }
                CallbackRegistry.prototype.get = function(name) {
                    return this._callbacks[prefix(name)];
                };
                CallbackRegistry.prototype.add = function(name, callback, context) {
                    var prefixedEventName = prefix(name);
                    this._callbacks[prefixedEventName] = this._callbacks[prefixedEventName] || [];
                    this._callbacks[prefixedEventName].push({
                        fn: callback,
                        context: context
                    });
                };
                CallbackRegistry.prototype.remove = function(name, callback, context) {
                    if (!name && !callback && !context) {
                        this._callbacks = {};
                        return;
                    }
                    var names = name ? [
                        prefix(name)
                    ] : keys(this._callbacks);
                    if (callback || context) this.removeCallback(names, callback, context);
                    else this.removeAllCallbacks(names);
                };
                CallbackRegistry.prototype.removeCallback = function(names, callback, context) {
                    apply(names, function(name) {
                        this._callbacks[name] = filter(this._callbacks[name] || [], function(binding) {
                            return callback && callback !== binding.fn || context && context !== binding.context;
                        });
                        if (this._callbacks[name].length === 0) delete this._callbacks[name];
                    }, this);
                };
                CallbackRegistry.prototype.removeAllCallbacks = function(names) {
                    apply(names, function(name) {
                        delete this._callbacks[name];
                    }, this);
                };
                return CallbackRegistry;
            }();
            /* harmony default export */ var callback_registry = callback_registry_CallbackRegistry;
            function prefix(name) {
                return "_" + name;
            }
            // CONCATENATED MODULE: ./src/core/events/dispatcher.ts
            var dispatcher_Dispatcher = function() {
                function Dispatcher(failThrough) {
                    this.callbacks = new callback_registry();
                    this.global_callbacks = [];
                    this.failThrough = failThrough;
                }
                Dispatcher.prototype.bind = function(eventName, callback, context) {
                    this.callbacks.add(eventName, callback, context);
                    return this;
                };
                Dispatcher.prototype.bind_global = function(callback) {
                    this.global_callbacks.push(callback);
                    return this;
                };
                Dispatcher.prototype.unbind = function(eventName, callback, context) {
                    this.callbacks.remove(eventName, callback, context);
                    return this;
                };
                Dispatcher.prototype.unbind_global = function(callback) {
                    if (!callback) {
                        this.global_callbacks = [];
                        return this;
                    }
                    this.global_callbacks = filter(this.global_callbacks || [], function(c) {
                        return c !== callback;
                    });
                    return this;
                };
                Dispatcher.prototype.unbind_all = function() {
                    this.unbind();
                    this.unbind_global();
                    return this;
                };
                Dispatcher.prototype.emit = function(eventName, data, metadata) {
                    for(var i = 0; i < this.global_callbacks.length; i++)this.global_callbacks[i](eventName, data);
                    var callbacks = this.callbacks.get(eventName);
                    var args = [];
                    if (metadata) args.push(data, metadata);
                    else if (data) args.push(data);
                    if (callbacks && callbacks.length > 0) for(var i = 0; i < callbacks.length; i++)callbacks[i].fn.apply(callbacks[i].context || window, args);
                    else if (this.failThrough) this.failThrough(eventName, data);
                    return this;
                };
                return Dispatcher;
            }();
            /* harmony default export */ var dispatcher = dispatcher_Dispatcher;
            // CONCATENATED MODULE: ./src/core/transports/transport_connection.ts
            var transport_connection_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var transport_connection_TransportConnection = function(_super) {
                transport_connection_extends(TransportConnection, _super);
                function TransportConnection(hooks, name, priority, key, options) {
                    var _this = _super.call(this) || this;
                    _this.initialize = runtime.transportConnectionInitializer;
                    _this.hooks = hooks;
                    _this.name = name;
                    _this.priority = priority;
                    _this.key = key;
                    _this.options = options;
                    _this.state = "new";
                    _this.timeline = options.timeline;
                    _this.activityTimeout = options.activityTimeout;
                    _this.id = _this.timeline.generateUniqueID();
                    return _this;
                }
                TransportConnection.prototype.handlesActivityChecks = function() {
                    return Boolean(this.hooks.handlesActivityChecks);
                };
                TransportConnection.prototype.supportsPing = function() {
                    return Boolean(this.hooks.supportsPing);
                };
                TransportConnection.prototype.connect = function() {
                    var _this = this;
                    if (this.socket || this.state !== "initialized") return false;
                    var url = this.hooks.urls.getInitial(this.key, this.options);
                    try {
                        this.socket = this.hooks.getSocket(url, this.options);
                    } catch (e) {
                        util.defer(function() {
                            _this.onError(e);
                            _this.changeState("closed");
                        });
                        return false;
                    }
                    this.bindListeners();
                    logger.debug("Connecting", {
                        transport: this.name,
                        url: url
                    });
                    this.changeState("connecting");
                    return true;
                };
                TransportConnection.prototype.close = function() {
                    if (this.socket) {
                        this.socket.close();
                        return true;
                    } else return false;
                };
                TransportConnection.prototype.send = function(data) {
                    var _this = this;
                    if (this.state === "open") {
                        util.defer(function() {
                            if (_this.socket) _this.socket.send(data);
                        });
                        return true;
                    } else return false;
                };
                TransportConnection.prototype.ping = function() {
                    if (this.state === "open" && this.supportsPing()) this.socket.ping();
                };
                TransportConnection.prototype.onOpen = function() {
                    if (this.hooks.beforeOpen) this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
                    this.changeState("open");
                    this.socket.onopen = undefined;
                };
                TransportConnection.prototype.onError = function(error) {
                    this.emit("error", {
                        type: "WebSocketError",
                        error: error
                    });
                    this.timeline.error(this.buildTimelineMessage({
                        error: error.toString()
                    }));
                };
                TransportConnection.prototype.onClose = function(closeEvent) {
                    if (closeEvent) this.changeState("closed", {
                        code: closeEvent.code,
                        reason: closeEvent.reason,
                        wasClean: closeEvent.wasClean
                    });
                    else this.changeState("closed");
                    this.unbindListeners();
                    this.socket = undefined;
                };
                TransportConnection.prototype.onMessage = function(message) {
                    this.emit("message", message);
                };
                TransportConnection.prototype.onActivity = function() {
                    this.emit("activity");
                };
                TransportConnection.prototype.bindListeners = function() {
                    var _this = this;
                    this.socket.onopen = function() {
                        _this.onOpen();
                    };
                    this.socket.onerror = function(error) {
                        _this.onError(error);
                    };
                    this.socket.onclose = function(closeEvent) {
                        _this.onClose(closeEvent);
                    };
                    this.socket.onmessage = function(message) {
                        _this.onMessage(message);
                    };
                    if (this.supportsPing()) this.socket.onactivity = function() {
                        _this.onActivity();
                    };
                };
                TransportConnection.prototype.unbindListeners = function() {
                    if (this.socket) {
                        this.socket.onopen = undefined;
                        this.socket.onerror = undefined;
                        this.socket.onclose = undefined;
                        this.socket.onmessage = undefined;
                        if (this.supportsPing()) this.socket.onactivity = undefined;
                    }
                };
                TransportConnection.prototype.changeState = function(state, params) {
                    this.state = state;
                    this.timeline.info(this.buildTimelineMessage({
                        state: state,
                        params: params
                    }));
                    this.emit(state, params);
                };
                TransportConnection.prototype.buildTimelineMessage = function(message) {
                    return extend({
                        cid: this.id
                    }, message);
                };
                return TransportConnection;
            }(dispatcher);
            /* harmony default export */ var transport_connection = transport_connection_TransportConnection;
            // CONCATENATED MODULE: ./src/core/transports/transport.ts
            var transport_Transport = function() {
                function Transport(hooks) {
                    this.hooks = hooks;
                }
                Transport.prototype.isSupported = function(environment) {
                    return this.hooks.isSupported(environment);
                };
                Transport.prototype.createConnection = function(name, priority, key, options) {
                    return new transport_connection(this.hooks, name, priority, key, options);
                };
                return Transport;
            }();
            /* harmony default export */ var transports_transport = transport_Transport;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/transports/transports.ts
            var WSTransport = new transports_transport({
                urls: ws,
                handlesActivityChecks: false,
                supportsPing: false,
                isInitialized: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                isSupported: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                getSocket: function(url) {
                    return runtime.createWebSocket(url);
                }
            });
            var httpConfiguration = {
                urls: http,
                handlesActivityChecks: false,
                supportsPing: true,
                isInitialized: function() {
                    return true;
                }
            };
            var streamingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createStreamingSocket(url);
                }
            }, httpConfiguration);
            var pollingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createPollingSocket(url);
                }
            }, httpConfiguration);
            var xhrConfiguration = {
                isSupported: function() {
                    return runtime.isXHRSupported();
                }
            };
            var XHRStreamingTransport = new transports_transport(extend({}, streamingConfiguration, xhrConfiguration));
            var XHRPollingTransport = new transports_transport(extend({}, pollingConfiguration, xhrConfiguration));
            var Transports = {
                ws: WSTransport,
                xhr_streaming: XHRStreamingTransport,
                xhr_polling: XHRPollingTransport
            };
            /* harmony default export */ var transports = Transports;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transports.ts
            var SockJSTransport = new transports_transport({
                file: "sockjs",
                urls: sockjs,
                handlesActivityChecks: true,
                supportsPing: false,
                isSupported: function() {
                    return true;
                },
                isInitialized: function() {
                    return window.SockJS !== undefined;
                },
                getSocket: function(url, options) {
                    return new window.SockJS(url, null, {
                        js_path: Dependencies.getPath("sockjs", {
                            useTLS: options.useTLS
                        }),
                        ignore_null_origin: options.ignoreNullOrigin
                    });
                },
                beforeOpen: function(socket, path) {
                    socket.send(JSON.stringify({
                        path: path
                    }));
                }
            });
            var xdrConfiguration = {
                isSupported: function(environment) {
                    var yes = runtime.isXDRSupported(environment.useTLS);
                    return yes;
                }
            };
            var XDRStreamingTransport = new transports_transport(extend({}, streamingConfiguration, xdrConfiguration));
            var XDRPollingTransport = new transports_transport(extend({}, pollingConfiguration, xdrConfiguration));
            transports.xdr_streaming = XDRStreamingTransport;
            transports.xdr_polling = XDRPollingTransport;
            transports.sockjs = SockJSTransport;
            /* harmony default export */ var transports_transports = transports;
            // CONCATENATED MODULE: ./src/runtimes/web/net_info.ts
            var net_info_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var NetInfo = function(_super) {
                net_info_extends(NetInfo, _super);
                function NetInfo() {
                    var _this = _super.call(this) || this;
                    var self = _this;
                    if (window.addEventListener !== undefined) {
                        window.addEventListener("online", function() {
                            self.emit("online");
                        }, false);
                        window.addEventListener("offline", function() {
                            self.emit("offline");
                        }, false);
                    }
                    return _this;
                }
                NetInfo.prototype.isOnline = function() {
                    if (window.navigator.onLine === undefined) return true;
                    else return window.navigator.onLine;
                };
                return NetInfo;
            }(dispatcher);
            var net_info_Network = new NetInfo();
            // CONCATENATED MODULE: ./src/core/transports/assistant_to_the_transport_manager.ts
            var assistant_to_the_transport_manager_AssistantToTheTransportManager = function() {
                function AssistantToTheTransportManager(manager, transport, options) {
                    this.manager = manager;
                    this.transport = transport;
                    this.minPingDelay = options.minPingDelay;
                    this.maxPingDelay = options.maxPingDelay;
                    this.pingDelay = undefined;
                }
                AssistantToTheTransportManager.prototype.createConnection = function(name, priority, key, options) {
                    var _this = this;
                    options = extend({}, options, {
                        activityTimeout: this.pingDelay
                    });
                    var connection = this.transport.createConnection(name, priority, key, options);
                    var openTimestamp = null;
                    var onOpen = function() {
                        connection.unbind("open", onOpen);
                        connection.bind("closed", onClosed);
                        openTimestamp = util.now();
                    };
                    var onClosed = function(closeEvent) {
                        connection.unbind("closed", onClosed);
                        if (closeEvent.code === 1002 || closeEvent.code === 1003) _this.manager.reportDeath();
                        else if (!closeEvent.wasClean && openTimestamp) {
                            var lifespan = util.now() - openTimestamp;
                            if (lifespan < 2 * _this.maxPingDelay) {
                                _this.manager.reportDeath();
                                _this.pingDelay = Math.max(lifespan / 2, _this.minPingDelay);
                            }
                        }
                    };
                    connection.bind("open", onOpen);
                    return connection;
                };
                AssistantToTheTransportManager.prototype.isSupported = function(environment) {
                    return this.manager.isAlive() && this.transport.isSupported(environment);
                };
                return AssistantToTheTransportManager;
            }();
            /* harmony default export */ var assistant_to_the_transport_manager = assistant_to_the_transport_manager_AssistantToTheTransportManager;
            // CONCATENATED MODULE: ./src/core/connection/protocol/protocol.ts
            var Protocol = {
                decodeMessage: function(messageEvent) {
                    try {
                        var messageData = JSON.parse(messageEvent.data);
                        var pusherEventData = messageData.data;
                        if (typeof pusherEventData === "string") try {
                            pusherEventData = JSON.parse(messageData.data);
                        } catch (e) {}
                        var pusherEvent = {
                            event: messageData.event,
                            channel: messageData.channel,
                            data: pusherEventData
                        };
                        if (messageData.user_id) pusherEvent.user_id = messageData.user_id;
                        return pusherEvent;
                    } catch (e) {
                        throw {
                            type: "MessageParseError",
                            error: e,
                            data: messageEvent.data
                        };
                    }
                },
                encodeMessage: function(event) {
                    return JSON.stringify(event);
                },
                processHandshake: function(messageEvent) {
                    var message = Protocol.decodeMessage(messageEvent);
                    if (message.event === "pusher:connection_established") {
                        if (!message.data.activity_timeout) throw "No activity timeout specified in handshake";
                        return {
                            action: "connected",
                            id: message.data.socket_id,
                            activityTimeout: message.data.activity_timeout * 1000
                        };
                    } else if (message.event === "pusher:error") return {
                        action: this.getCloseAction(message.data),
                        error: this.getCloseError(message.data)
                    };
                    else throw "Invalid handshake";
                },
                getCloseAction: function(closeEvent) {
                    if (closeEvent.code < 4000) {
                        if (closeEvent.code >= 1002 && closeEvent.code <= 1004) return "backoff";
                        else return null;
                    } else if (closeEvent.code === 4000) return "tls_only";
                    else if (closeEvent.code < 4100) return "refused";
                    else if (closeEvent.code < 4200) return "backoff";
                    else if (closeEvent.code < 4300) return "retry";
                    else return "refused";
                },
                getCloseError: function(closeEvent) {
                    if (closeEvent.code !== 1000 && closeEvent.code !== 1001) return {
                        type: "PusherError",
                        data: {
                            code: closeEvent.code,
                            message: closeEvent.reason || closeEvent.message
                        }
                    };
                    else return null;
                }
            };
            /* harmony default export */ var protocol_protocol = Protocol;
            // CONCATENATED MODULE: ./src/core/connection/connection.ts
            var connection_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var connection_Connection = function(_super) {
                connection_extends(Connection, _super);
                function Connection(id, transport) {
                    var _this = _super.call(this) || this;
                    _this.id = id;
                    _this.transport = transport;
                    _this.activityTimeout = transport.activityTimeout;
                    _this.bindListeners();
                    return _this;
                }
                Connection.prototype.handlesActivityChecks = function() {
                    return this.transport.handlesActivityChecks();
                };
                Connection.prototype.send = function(data) {
                    return this.transport.send(data);
                };
                Connection.prototype.send_event = function(name, data, channel) {
                    var event = {
                        event: name,
                        data: data
                    };
                    if (channel) event.channel = channel;
                    logger.debug("Event sent", event);
                    return this.send(protocol_protocol.encodeMessage(event));
                };
                Connection.prototype.ping = function() {
                    if (this.transport.supportsPing()) this.transport.ping();
                    else this.send_event("pusher:ping", {});
                };
                Connection.prototype.close = function() {
                    this.transport.close();
                };
                Connection.prototype.bindListeners = function() {
                    var _this = this;
                    var listeners = {
                        message: function(messageEvent) {
                            var pusherEvent;
                            try {
                                pusherEvent = protocol_protocol.decodeMessage(messageEvent);
                            } catch (e) {
                                _this.emit("error", {
                                    type: "MessageParseError",
                                    error: e,
                                    data: messageEvent.data
                                });
                            }
                            if (pusherEvent !== undefined) {
                                logger.debug("Event recd", pusherEvent);
                                switch(pusherEvent.event){
                                    case "pusher:error":
                                        _this.emit("error", {
                                            type: "PusherError",
                                            data: pusherEvent.data
                                        });
                                        break;
                                    case "pusher:ping":
                                        _this.emit("ping");
                                        break;
                                    case "pusher:pong":
                                        _this.emit("pong");
                                        break;
                                }
                                _this.emit("message", pusherEvent);
                            }
                        },
                        activity: function() {
                            _this.emit("activity");
                        },
                        error: function(error) {
                            _this.emit("error", error);
                        },
                        closed: function(closeEvent) {
                            unbindListeners();
                            if (closeEvent && closeEvent.code) _this.handleCloseEvent(closeEvent);
                            _this.transport = null;
                            _this.emit("closed");
                        }
                    };
                    var unbindListeners = function() {
                        objectApply(listeners, function(listener, event) {
                            _this.transport.unbind(event, listener);
                        });
                    };
                    objectApply(listeners, function(listener, event) {
                        _this.transport.bind(event, listener);
                    });
                };
                Connection.prototype.handleCloseEvent = function(closeEvent) {
                    var action = protocol_protocol.getCloseAction(closeEvent);
                    var error = protocol_protocol.getCloseError(closeEvent);
                    if (error) this.emit("error", error);
                    if (action) this.emit(action, {
                        action: action,
                        error: error
                    });
                };
                return Connection;
            }(dispatcher);
            /* harmony default export */ var connection_connection = connection_Connection;
            // CONCATENATED MODULE: ./src/core/connection/handshake/index.ts
            var handshake_Handshake = function() {
                function Handshake(transport, callback) {
                    this.transport = transport;
                    this.callback = callback;
                    this.bindListeners();
                }
                Handshake.prototype.close = function() {
                    this.unbindListeners();
                    this.transport.close();
                };
                Handshake.prototype.bindListeners = function() {
                    var _this = this;
                    this.onMessage = function(m) {
                        _this.unbindListeners();
                        var result;
                        try {
                            result = protocol_protocol.processHandshake(m);
                        } catch (e) {
                            _this.finish("error", {
                                error: e
                            });
                            _this.transport.close();
                            return;
                        }
                        if (result.action === "connected") _this.finish("connected", {
                            connection: new connection_connection(result.id, _this.transport),
                            activityTimeout: result.activityTimeout
                        });
                        else {
                            _this.finish(result.action, {
                                error: result.error
                            });
                            _this.transport.close();
                        }
                    };
                    this.onClosed = function(closeEvent) {
                        _this.unbindListeners();
                        var action = protocol_protocol.getCloseAction(closeEvent) || "backoff";
                        var error = protocol_protocol.getCloseError(closeEvent);
                        _this.finish(action, {
                            error: error
                        });
                    };
                    this.transport.bind("message", this.onMessage);
                    this.transport.bind("closed", this.onClosed);
                };
                Handshake.prototype.unbindListeners = function() {
                    this.transport.unbind("message", this.onMessage);
                    this.transport.unbind("closed", this.onClosed);
                };
                Handshake.prototype.finish = function(action, params) {
                    this.callback(extend({
                        transport: this.transport,
                        action: action
                    }, params));
                };
                return Handshake;
            }();
            /* harmony default export */ var connection_handshake = handshake_Handshake;
            // CONCATENATED MODULE: ./src/core/timeline/timeline_sender.ts
            var timeline_sender_TimelineSender = function() {
                function TimelineSender(timeline, options) {
                    this.timeline = timeline;
                    this.options = options || {};
                }
                TimelineSender.prototype.send = function(useTLS, callback) {
                    if (this.timeline.isEmpty()) return;
                    this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
                };
                return TimelineSender;
            }();
            /* harmony default export */ var timeline_sender = timeline_sender_TimelineSender;
            // CONCATENATED MODULE: ./src/core/channels/channel.ts
            var channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var channel_Channel = function(_super) {
                channel_extends(Channel, _super);
                function Channel(name, pusher) {
                    var _this = _super.call(this, function(event, data) {
                        logger.debug("No callbacks on " + name + " for " + event);
                    }) || this;
                    _this.name = name;
                    _this.pusher = pusher;
                    _this.subscribed = false;
                    _this.subscriptionPending = false;
                    _this.subscriptionCancelled = false;
                    return _this;
                }
                Channel.prototype.authorize = function(socketId, callback) {
                    return callback(null, {
                        auth: ""
                    });
                };
                Channel.prototype.trigger = function(event, data) {
                    if (event.indexOf("client-") !== 0) throw new BadEventName("Event '" + event + "' does not start with 'client-'");
                    if (!this.subscribed) {
                        var suffix = url_store.buildLogSuffix("triggeringClientEvents");
                        logger.warn("Client event triggered before channel 'subscription_succeeded' event . " + suffix);
                    }
                    return this.pusher.send_event(event, data, this.name);
                };
                Channel.prototype.disconnect = function() {
                    this.subscribed = false;
                    this.subscriptionPending = false;
                };
                Channel.prototype.handleEvent = function(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName === "pusher_internal:subscription_succeeded") this.handleSubscriptionSucceededEvent(event);
                    else if (eventName === "pusher_internal:subscription_count") this.handleSubscriptionCountEvent(event);
                    else if (eventName.indexOf("pusher_internal:") !== 0) {
                        var metadata = {};
                        this.emit(eventName, data, metadata);
                    }
                };
                Channel.prototype.handleSubscriptionSucceededEvent = function(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else this.emit("pusher:subscription_succeeded", event.data);
                };
                Channel.prototype.handleSubscriptionCountEvent = function(event) {
                    if (event.data.subscription_count) this.subscriptionCount = event.data.subscription_count;
                    this.emit("pusher:subscription_count", event.data);
                };
                Channel.prototype.subscribe = function() {
                    var _this = this;
                    if (this.subscribed) return;
                    this.subscriptionPending = true;
                    this.subscriptionCancelled = false;
                    this.authorize(this.pusher.connection.socket_id, function(error, data) {
                        if (error) {
                            _this.subscriptionPending = false;
                            logger.error(error.toString());
                            _this.emit("pusher:subscription_error", Object.assign({}, {
                                type: "AuthError",
                                error: error.message
                            }, error instanceof HTTPAuthError ? {
                                status: error.status
                            } : {}));
                        } else _this.pusher.send_event("pusher:subscribe", {
                            auth: data.auth,
                            channel_data: data.channel_data,
                            channel: _this.name
                        });
                    });
                };
                Channel.prototype.unsubscribe = function() {
                    this.subscribed = false;
                    this.pusher.send_event("pusher:unsubscribe", {
                        channel: this.name
                    });
                };
                Channel.prototype.cancelSubscription = function() {
                    this.subscriptionCancelled = true;
                };
                Channel.prototype.reinstateSubscription = function() {
                    this.subscriptionCancelled = false;
                };
                return Channel;
            }(dispatcher);
            /* harmony default export */ var channels_channel = channel_Channel;
            // CONCATENATED MODULE: ./src/core/channels/private_channel.ts
            var private_channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var PrivateChannel = function(_super) {
                private_channel_extends(PrivateChannel, _super);
                function PrivateChannel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                PrivateChannel.prototype.authorize = function(socketId, callback) {
                    return this.pusher.config.channelAuthorizer({
                        channelName: this.name,
                        socketId: socketId
                    }, callback);
                };
                return PrivateChannel;
            }(channels_channel);
            /* harmony default export */ var private_channel = PrivateChannel;
            // CONCATENATED MODULE: ./src/core/channels/members.ts
            var members_Members = function() {
                function Members() {
                    this.reset();
                }
                Members.prototype.get = function(id) {
                    if (Object.prototype.hasOwnProperty.call(this.members, id)) return {
                        id: id,
                        info: this.members[id]
                    };
                    else return null;
                };
                Members.prototype.each = function(callback) {
                    var _this = this;
                    objectApply(this.members, function(member, id) {
                        callback(_this.get(id));
                    });
                };
                Members.prototype.setMyID = function(id) {
                    this.myID = id;
                };
                Members.prototype.onSubscription = function(subscriptionData) {
                    this.members = subscriptionData.presence.hash;
                    this.count = subscriptionData.presence.count;
                    this.me = this.get(this.myID);
                };
                Members.prototype.addMember = function(memberData) {
                    if (this.get(memberData.user_id) === null) this.count++;
                    this.members[memberData.user_id] = memberData.user_info;
                    return this.get(memberData.user_id);
                };
                Members.prototype.removeMember = function(memberData) {
                    var member = this.get(memberData.user_id);
                    if (member) {
                        delete this.members[memberData.user_id];
                        this.count--;
                    }
                    return member;
                };
                Members.prototype.reset = function() {
                    this.members = {};
                    this.count = 0;
                    this.myID = null;
                    this.me = null;
                };
                return Members;
            }();
            /* harmony default export */ var members = members_Members;
            // CONCATENATED MODULE: ./src/core/channels/presence_channel.ts
            var presence_channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(_)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var presence_channel_PresenceChannel = function(_super) {
                presence_channel_extends(PresenceChannel, _super);
                function PresenceChannel(name, pusher) {
                    var _this = _super.call(this, name, pusher) || this;
                    _this.members = new members();
                    return _this;
                }
                PresenceChannel.prototype.authorize = function(socketId, callback) {
                    var _this = this;
                    _super.prototype.authorize.call(this, socketId, function(error, authData) {
                        return __awaiter(_this, void 0, void 0, function() {
                            var channelData, suffix;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!!error) return [
                                            3,
                                            3
                                        ];
                                        authData;
                                        if (!(authData.channel_data != null)) return [
                                            3,
                                            1
                                        ];
                                        channelData = JSON.parse(authData.channel_data);
                                        this.members.setMyID(channelData.user_id);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4,
                                            this.pusher.user.signinDonePromise
                                        ];
                                    case 2:
                                        _a.sent();
                                        if (this.pusher.user.user_data != null) this.members.setMyID(this.pusher.user.user_data.id);
                                        else {
                                            suffix = url_store.buildLogSuffix("authorizationEndpoint");
                                            logger.error("Invalid auth response for channel '" + this.name + "', " + ("expected 'channel_data' field. " + suffix + ", ") + "or the user should be signed in.");
                                            callback("Invalid auth response");
                                            return [
                                                2
                                            ];
                                        }
                                        _a.label = 3;
                                    case 3:
                                        callback(error, authData);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    });
                };
                PresenceChannel.prototype.handleEvent = function(event) {
                    var eventName = event.event;
                    if (eventName.indexOf("pusher_internal:") === 0) this.handleInternalEvent(event);
                    else {
                        var data = event.data;
                        var metadata = {};
                        if (event.user_id) metadata.user_id = event.user_id;
                        this.emit(eventName, data, metadata);
                    }
                };
                PresenceChannel.prototype.handleInternalEvent = function(event) {
                    var eventName = event.event;
                    var data = event.data;
                    switch(eventName){
                        case "pusher_internal:subscription_succeeded":
                            this.handleSubscriptionSucceededEvent(event);
                            break;
                        case "pusher_internal:subscription_count":
                            this.handleSubscriptionCountEvent(event);
                            break;
                        case "pusher_internal:member_added":
                            var addedMember = this.members.addMember(data);
                            this.emit("pusher:member_added", addedMember);
                            break;
                        case "pusher_internal:member_removed":
                            var removedMember = this.members.removeMember(data);
                            if (removedMember) this.emit("pusher:member_removed", removedMember);
                            break;
                    }
                };
                PresenceChannel.prototype.handleSubscriptionSucceededEvent = function(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else {
                        this.members.onSubscription(event.data);
                        this.emit("pusher:subscription_succeeded", this.members);
                    }
                };
                PresenceChannel.prototype.disconnect = function() {
                    this.members.reset();
                    _super.prototype.disconnect.call(this);
                };
                return PresenceChannel;
            }(private_channel);
            /* harmony default export */ var presence_channel = presence_channel_PresenceChannel;
            // EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
            var utf8 = __webpack_require__(1);
            // EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
            var base64 = __webpack_require__(0);
            // CONCATENATED MODULE: ./src/core/channels/encrypted_channel.ts
            var encrypted_channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var encrypted_channel_EncryptedChannel = function(_super) {
                encrypted_channel_extends(EncryptedChannel, _super);
                function EncryptedChannel(name, pusher, nacl) {
                    var _this = _super.call(this, name, pusher) || this;
                    _this.key = null;
                    _this.nacl = nacl;
                    return _this;
                }
                EncryptedChannel.prototype.authorize = function(socketId, callback) {
                    var _this = this;
                    _super.prototype.authorize.call(this, socketId, function(error, authData) {
                        if (error) {
                            callback(error, authData);
                            return;
                        }
                        var sharedSecret = authData["shared_secret"];
                        if (!sharedSecret) {
                            callback(new Error("No shared_secret key in auth payload for encrypted channel: " + _this.name), null);
                            return;
                        }
                        _this.key = Object(base64["decode"])(sharedSecret);
                        delete authData["shared_secret"];
                        callback(null, authData);
                    });
                };
                EncryptedChannel.prototype.trigger = function(event, data) {
                    throw new UnsupportedFeature("Client events are not currently supported for encrypted channels");
                };
                EncryptedChannel.prototype.handleEvent = function(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName.indexOf("pusher_internal:") === 0 || eventName.indexOf("pusher:") === 0) {
                        _super.prototype.handleEvent.call(this, event);
                        return;
                    }
                    this.handleEncryptedEvent(eventName, data);
                };
                EncryptedChannel.prototype.handleEncryptedEvent = function(event, data) {
                    var _this = this;
                    if (!this.key) {
                        logger.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                        return;
                    }
                    if (!data.ciphertext || !data.nonce) {
                        logger.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + data);
                        return;
                    }
                    var cipherText = Object(base64["decode"])(data.ciphertext);
                    if (cipherText.length < this.nacl.secretbox.overheadLength) {
                        logger.error("Expected encrypted event ciphertext length to be " + this.nacl.secretbox.overheadLength + ", got: " + cipherText.length);
                        return;
                    }
                    var nonce = Object(base64["decode"])(data.nonce);
                    if (nonce.length < this.nacl.secretbox.nonceLength) {
                        logger.error("Expected encrypted event nonce length to be " + this.nacl.secretbox.nonceLength + ", got: " + nonce.length);
                        return;
                    }
                    var bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                    if (bytes === null) {
                        logger.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...");
                        this.authorize(this.pusher.connection.socket_id, function(error, authData) {
                            if (error) {
                                logger.error("Failed to make a request to the authEndpoint: " + authData + ". Unable to fetch new key, so dropping encrypted event");
                                return;
                            }
                            bytes = _this.nacl.secretbox.open(cipherText, nonce, _this.key);
                            if (bytes === null) {
                                logger.error("Failed to decrypt event with new key. Dropping encrypted event");
                                return;
                            }
                            _this.emit(event, _this.getDataToEmit(bytes));
                            return;
                        });
                        return;
                    }
                    this.emit(event, this.getDataToEmit(bytes));
                };
                EncryptedChannel.prototype.getDataToEmit = function(bytes) {
                    var raw = Object(utf8["decode"])(bytes);
                    try {
                        return JSON.parse(raw);
                    } catch (_a) {
                        return raw;
                    }
                };
                return EncryptedChannel;
            }(private_channel);
            /* harmony default export */ var encrypted_channel = encrypted_channel_EncryptedChannel;
            // CONCATENATED MODULE: ./src/core/connection/connection_manager.ts
            var connection_manager_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var connection_manager_ConnectionManager = function(_super) {
                connection_manager_extends(ConnectionManager, _super);
                function ConnectionManager(key, options) {
                    var _this = _super.call(this) || this;
                    _this.state = "initialized";
                    _this.connection = null;
                    _this.key = key;
                    _this.options = options;
                    _this.timeline = _this.options.timeline;
                    _this.usingTLS = _this.options.useTLS;
                    _this.errorCallbacks = _this.buildErrorCallbacks();
                    _this.connectionCallbacks = _this.buildConnectionCallbacks(_this.errorCallbacks);
                    _this.handshakeCallbacks = _this.buildHandshakeCallbacks(_this.errorCallbacks);
                    var Network = runtime.getNetwork();
                    Network.bind("online", function() {
                        _this.timeline.info({
                            netinfo: "online"
                        });
                        if (_this.state === "connecting" || _this.state === "unavailable") _this.retryIn(0);
                    });
                    Network.bind("offline", function() {
                        _this.timeline.info({
                            netinfo: "offline"
                        });
                        if (_this.connection) _this.sendActivityCheck();
                    });
                    _this.updateStrategy();
                    return _this;
                }
                ConnectionManager.prototype.connect = function() {
                    if (this.connection || this.runner) return;
                    if (!this.strategy.isSupported()) {
                        this.updateState("failed");
                        return;
                    }
                    this.updateState("connecting");
                    this.startConnecting();
                    this.setUnavailableTimer();
                };
                ConnectionManager.prototype.send = function(data) {
                    if (this.connection) return this.connection.send(data);
                    else return false;
                };
                ConnectionManager.prototype.send_event = function(name, data, channel) {
                    if (this.connection) return this.connection.send_event(name, data, channel);
                    else return false;
                };
                ConnectionManager.prototype.disconnect = function() {
                    this.disconnectInternally();
                    this.updateState("disconnected");
                };
                ConnectionManager.prototype.isUsingTLS = function() {
                    return this.usingTLS;
                };
                ConnectionManager.prototype.startConnecting = function() {
                    var _this = this;
                    var callback = function(error, handshake) {
                        if (error) _this.runner = _this.strategy.connect(0, callback);
                        else if (handshake.action === "error") {
                            _this.emit("error", {
                                type: "HandshakeError",
                                error: handshake.error
                            });
                            _this.timeline.error({
                                handshakeError: handshake.error
                            });
                        } else {
                            _this.abortConnecting();
                            _this.handshakeCallbacks[handshake.action](handshake);
                        }
                    };
                    this.runner = this.strategy.connect(0, callback);
                };
                ConnectionManager.prototype.abortConnecting = function() {
                    if (this.runner) {
                        this.runner.abort();
                        this.runner = null;
                    }
                };
                ConnectionManager.prototype.disconnectInternally = function() {
                    this.abortConnecting();
                    this.clearRetryTimer();
                    this.clearUnavailableTimer();
                    if (this.connection) {
                        var connection = this.abandonConnection();
                        connection.close();
                    }
                };
                ConnectionManager.prototype.updateStrategy = function() {
                    this.strategy = this.options.getStrategy({
                        key: this.key,
                        timeline: this.timeline,
                        useTLS: this.usingTLS
                    });
                };
                ConnectionManager.prototype.retryIn = function(delay) {
                    var _this = this;
                    this.timeline.info({
                        action: "retry",
                        delay: delay
                    });
                    if (delay > 0) this.emit("connecting_in", Math.round(delay / 1000));
                    this.retryTimer = new OneOffTimer(delay || 0, function() {
                        _this.disconnectInternally();
                        _this.connect();
                    });
                };
                ConnectionManager.prototype.clearRetryTimer = function() {
                    if (this.retryTimer) {
                        this.retryTimer.ensureAborted();
                        this.retryTimer = null;
                    }
                };
                ConnectionManager.prototype.setUnavailableTimer = function() {
                    var _this = this;
                    this.unavailableTimer = new OneOffTimer(this.options.unavailableTimeout, function() {
                        _this.updateState("unavailable");
                    });
                };
                ConnectionManager.prototype.clearUnavailableTimer = function() {
                    if (this.unavailableTimer) this.unavailableTimer.ensureAborted();
                };
                ConnectionManager.prototype.sendActivityCheck = function() {
                    var _this = this;
                    this.stopActivityCheck();
                    this.connection.ping();
                    this.activityTimer = new OneOffTimer(this.options.pongTimeout, function() {
                        _this.timeline.error({
                            pong_timed_out: _this.options.pongTimeout
                        });
                        _this.retryIn(0);
                    });
                };
                ConnectionManager.prototype.resetActivityCheck = function() {
                    var _this = this;
                    this.stopActivityCheck();
                    if (this.connection && !this.connection.handlesActivityChecks()) this.activityTimer = new OneOffTimer(this.activityTimeout, function() {
                        _this.sendActivityCheck();
                    });
                };
                ConnectionManager.prototype.stopActivityCheck = function() {
                    if (this.activityTimer) this.activityTimer.ensureAborted();
                };
                ConnectionManager.prototype.buildConnectionCallbacks = function(errorCallbacks) {
                    var _this = this;
                    return extend({}, errorCallbacks, {
                        message: function(message) {
                            _this.resetActivityCheck();
                            _this.emit("message", message);
                        },
                        ping: function() {
                            _this.send_event("pusher:pong", {});
                        },
                        activity: function() {
                            _this.resetActivityCheck();
                        },
                        error: function(error) {
                            _this.emit("error", error);
                        },
                        closed: function() {
                            _this.abandonConnection();
                            if (_this.shouldRetry()) _this.retryIn(1000);
                        }
                    });
                };
                ConnectionManager.prototype.buildHandshakeCallbacks = function(errorCallbacks) {
                    var _this = this;
                    return extend({}, errorCallbacks, {
                        connected: function(handshake) {
                            _this.activityTimeout = Math.min(_this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                            _this.clearUnavailableTimer();
                            _this.setConnection(handshake.connection);
                            _this.socket_id = _this.connection.id;
                            _this.updateState("connected", {
                                socket_id: _this.socket_id
                            });
                        }
                    });
                };
                ConnectionManager.prototype.buildErrorCallbacks = function() {
                    var _this = this;
                    var withErrorEmitted = function(callback) {
                        return function(result) {
                            if (result.error) _this.emit("error", {
                                type: "WebSocketError",
                                error: result.error
                            });
                            callback(result);
                        };
                    };
                    return {
                        tls_only: withErrorEmitted(function() {
                            _this.usingTLS = true;
                            _this.updateStrategy();
                            _this.retryIn(0);
                        }),
                        refused: withErrorEmitted(function() {
                            _this.disconnect();
                        }),
                        backoff: withErrorEmitted(function() {
                            _this.retryIn(1000);
                        }),
                        retry: withErrorEmitted(function() {
                            _this.retryIn(0);
                        })
                    };
                };
                ConnectionManager.prototype.setConnection = function(connection) {
                    this.connection = connection;
                    for(var event in this.connectionCallbacks)this.connection.bind(event, this.connectionCallbacks[event]);
                    this.resetActivityCheck();
                };
                ConnectionManager.prototype.abandonConnection = function() {
                    if (!this.connection) return;
                    this.stopActivityCheck();
                    for(var event in this.connectionCallbacks)this.connection.unbind(event, this.connectionCallbacks[event]);
                    var connection = this.connection;
                    this.connection = null;
                    return connection;
                };
                ConnectionManager.prototype.updateState = function(newState, data) {
                    var previousState = this.state;
                    this.state = newState;
                    if (previousState !== newState) {
                        var newStateDescription = newState;
                        if (newStateDescription === "connected") newStateDescription += " with new socket ID " + data.socket_id;
                        logger.debug("State changed", previousState + " -> " + newStateDescription);
                        this.timeline.info({
                            state: newState,
                            params: data
                        });
                        this.emit("state_change", {
                            previous: previousState,
                            current: newState
                        });
                        this.emit(newState, data);
                    }
                };
                ConnectionManager.prototype.shouldRetry = function() {
                    return this.state === "connecting" || this.state === "connected";
                };
                return ConnectionManager;
            }(dispatcher);
            /* harmony default export */ var connection_manager = connection_manager_ConnectionManager;
            // CONCATENATED MODULE: ./src/core/channels/channels.ts
            var channels_Channels = function() {
                function Channels() {
                    this.channels = {};
                }
                Channels.prototype.add = function(name, pusher) {
                    if (!this.channels[name]) this.channels[name] = createChannel(name, pusher);
                    return this.channels[name];
                };
                Channels.prototype.all = function() {
                    return values(this.channels);
                };
                Channels.prototype.find = function(name) {
                    return this.channels[name];
                };
                Channels.prototype.remove = function(name) {
                    var channel = this.channels[name];
                    delete this.channels[name];
                    return channel;
                };
                Channels.prototype.disconnect = function() {
                    objectApply(this.channels, function(channel) {
                        channel.disconnect();
                    });
                };
                return Channels;
            }();
            /* harmony default export */ var channels = channels_Channels;
            function createChannel(name, pusher) {
                if (name.indexOf("private-encrypted-") === 0) {
                    if (pusher.config.nacl) return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
                    var errMsg = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available";
                    var suffix = url_store.buildLogSuffix("encryptedChannelSupport");
                    throw new UnsupportedFeature(errMsg + ". " + suffix);
                } else if (name.indexOf("private-") === 0) return factory.createPrivateChannel(name, pusher);
                else if (name.indexOf("presence-") === 0) return factory.createPresenceChannel(name, pusher);
                else if (name.indexOf("#") === 0) throw new BadChannelName('Cannot create a channel with name "' + name + '".');
                else return factory.createChannel(name, pusher);
            }
            // CONCATENATED MODULE: ./src/core/utils/factory.ts
            var Factory = {
                createChannels: function() {
                    return new channels();
                },
                createConnectionManager: function(key, options) {
                    return new connection_manager(key, options);
                },
                createChannel: function(name, pusher) {
                    return new channels_channel(name, pusher);
                },
                createPrivateChannel: function(name, pusher) {
                    return new private_channel(name, pusher);
                },
                createPresenceChannel: function(name, pusher) {
                    return new presence_channel(name, pusher);
                },
                createEncryptedChannel: function(name, pusher, nacl) {
                    return new encrypted_channel(name, pusher, nacl);
                },
                createTimelineSender: function(timeline, options) {
                    return new timeline_sender(timeline, options);
                },
                createHandshake: function(transport, callback) {
                    return new connection_handshake(transport, callback);
                },
                createAssistantToTheTransportManager: function(manager, transport, options) {
                    return new assistant_to_the_transport_manager(manager, transport, options);
                }
            };
            /* harmony default export */ var factory = Factory;
            // CONCATENATED MODULE: ./src/core/transports/transport_manager.ts
            var transport_manager_TransportManager = function() {
                function TransportManager(options) {
                    this.options = options || {};
                    this.livesLeft = this.options.lives || Infinity;
                }
                TransportManager.prototype.getAssistant = function(transport) {
                    return factory.createAssistantToTheTransportManager(this, transport, {
                        minPingDelay: this.options.minPingDelay,
                        maxPingDelay: this.options.maxPingDelay
                    });
                };
                TransportManager.prototype.isAlive = function() {
                    return this.livesLeft > 0;
                };
                TransportManager.prototype.reportDeath = function() {
                    this.livesLeft -= 1;
                };
                return TransportManager;
            }();
            /* harmony default export */ var transport_manager = transport_manager_TransportManager;
            // CONCATENATED MODULE: ./src/core/strategies/sequential_strategy.ts
            var sequential_strategy_SequentialStrategy = function() {
                function SequentialStrategy(strategies, options) {
                    this.strategies = strategies;
                    this.loop = Boolean(options.loop);
                    this.failFast = Boolean(options.failFast);
                    this.timeout = options.timeout;
                    this.timeoutLimit = options.timeoutLimit;
                }
                SequentialStrategy.prototype.isSupported = function() {
                    return any(this.strategies, util.method("isSupported"));
                };
                SequentialStrategy.prototype.connect = function(minPriority, callback) {
                    var _this = this;
                    var strategies = this.strategies;
                    var current = 0;
                    var timeout = this.timeout;
                    var runner = null;
                    var tryNextStrategy = function(error, handshake) {
                        if (handshake) callback(null, handshake);
                        else {
                            current = current + 1;
                            if (_this.loop) current = current % strategies.length;
                            if (current < strategies.length) {
                                if (timeout) {
                                    timeout = timeout * 2;
                                    if (_this.timeoutLimit) timeout = Math.min(timeout, _this.timeoutLimit);
                                }
                                runner = _this.tryStrategy(strategies[current], minPriority, {
                                    timeout: timeout,
                                    failFast: _this.failFast
                                }, tryNextStrategy);
                            } else callback(true);
                        }
                    };
                    runner = this.tryStrategy(strategies[current], minPriority, {
                        timeout: timeout,
                        failFast: this.failFast
                    }, tryNextStrategy);
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                };
                SequentialStrategy.prototype.tryStrategy = function(strategy, minPriority, options, callback) {
                    var timer = null;
                    var runner = null;
                    if (options.timeout > 0) timer = new OneOffTimer(options.timeout, function() {
                        runner.abort();
                        callback(true);
                    });
                    runner = strategy.connect(minPriority, function(error, handshake) {
                        if (error && timer && timer.isRunning() && !options.failFast) return;
                        if (timer) timer.ensureAborted();
                        callback(error, handshake);
                    });
                    return {
                        abort: function() {
                            if (timer) timer.ensureAborted();
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            runner.forceMinPriority(p);
                        }
                    };
                };
                return SequentialStrategy;
            }();
            /* harmony default export */ var sequential_strategy = sequential_strategy_SequentialStrategy;
            // CONCATENATED MODULE: ./src/core/strategies/best_connected_ever_strategy.ts
            var best_connected_ever_strategy_BestConnectedEverStrategy = function() {
                function BestConnectedEverStrategy(strategies) {
                    this.strategies = strategies;
                }
                BestConnectedEverStrategy.prototype.isSupported = function() {
                    return any(this.strategies, util.method("isSupported"));
                };
                BestConnectedEverStrategy.prototype.connect = function(minPriority, callback) {
                    return connect(this.strategies, minPriority, function(i, runners) {
                        return function(error, handshake) {
                            runners[i].error = error;
                            if (error) {
                                if (allRunnersFailed(runners)) callback(true);
                                return;
                            }
                            apply(runners, function(runner) {
                                runner.forceMinPriority(handshake.transport.priority);
                            });
                            callback(null, handshake);
                        };
                    });
                };
                return BestConnectedEverStrategy;
            }();
            /* harmony default export */ var best_connected_ever_strategy = best_connected_ever_strategy_BestConnectedEverStrategy;
            function connect(strategies, minPriority, callbackBuilder) {
                var runners = map(strategies, function(strategy, i, _, rs) {
                    return strategy.connect(minPriority, callbackBuilder(i, rs));
                });
                return {
                    abort: function() {
                        apply(runners, abortRunner);
                    },
                    forceMinPriority: function(p) {
                        apply(runners, function(runner) {
                            runner.forceMinPriority(p);
                        });
                    }
                };
            }
            function allRunnersFailed(runners) {
                return collections_all(runners, function(runner) {
                    return Boolean(runner.error);
                });
            }
            function abortRunner(runner) {
                if (!runner.error && !runner.aborted) {
                    runner.abort();
                    runner.aborted = true;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/cached_strategy.ts
            var cached_strategy_CachedStrategy = function() {
                function CachedStrategy(strategy, transports, options) {
                    this.strategy = strategy;
                    this.transports = transports;
                    this.ttl = options.ttl || 1800000;
                    this.usingTLS = options.useTLS;
                    this.timeline = options.timeline;
                }
                CachedStrategy.prototype.isSupported = function() {
                    return this.strategy.isSupported();
                };
                CachedStrategy.prototype.connect = function(minPriority, callback) {
                    var usingTLS = this.usingTLS;
                    var info = fetchTransportCache(usingTLS);
                    var strategies = [
                        this.strategy
                    ];
                    if (info && info.timestamp + this.ttl >= util.now()) {
                        var transport = this.transports[info.transport];
                        if (transport) {
                            this.timeline.info({
                                cached: true,
                                transport: info.transport,
                                latency: info.latency
                            });
                            strategies.push(new sequential_strategy([
                                transport
                            ], {
                                timeout: info.latency * 2 + 1000,
                                failFast: true
                            }));
                        }
                    }
                    var startTimestamp = util.now();
                    var runner = strategies.pop().connect(minPriority, function cb(error, handshake) {
                        if (error) {
                            flushTransportCache(usingTLS);
                            if (strategies.length > 0) {
                                startTimestamp = util.now();
                                runner = strategies.pop().connect(minPriority, cb);
                            } else callback(error);
                        } else {
                            storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp);
                            callback(null, handshake);
                        }
                    });
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                };
                return CachedStrategy;
            }();
            /* harmony default export */ var cached_strategy = cached_strategy_CachedStrategy;
            function getTransportCacheKey(usingTLS) {
                return "pusherTransport" + (usingTLS ? "TLS" : "NonTLS");
            }
            function fetchTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    var serializedCache = storage[getTransportCacheKey(usingTLS)];
                    if (serializedCache) return JSON.parse(serializedCache);
                } catch (e) {
                    flushTransportCache(usingTLS);
                }
                return null;
            }
            function storeTransportCache(usingTLS, transport, latency) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                        timestamp: util.now(),
                        transport: transport,
                        latency: latency
                    });
                } catch (e) {}
            }
            function flushTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    delete storage[getTransportCacheKey(usingTLS)];
                } catch (e) {}
            }
            // CONCATENATED MODULE: ./src/core/strategies/delayed_strategy.ts
            var delayed_strategy_DelayedStrategy = function() {
                function DelayedStrategy(strategy, _a) {
                    var number = _a.delay;
                    this.strategy = strategy;
                    this.options = {
                        delay: number
                    };
                }
                DelayedStrategy.prototype.isSupported = function() {
                    return this.strategy.isSupported();
                };
                DelayedStrategy.prototype.connect = function(minPriority, callback) {
                    var strategy = this.strategy;
                    var runner;
                    var timer = new OneOffTimer(this.options.delay, function() {
                        runner = strategy.connect(minPriority, callback);
                    });
                    return {
                        abort: function() {
                            timer.ensureAborted();
                            if (runner) runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                };
                return DelayedStrategy;
            }();
            /* harmony default export */ var delayed_strategy = delayed_strategy_DelayedStrategy;
            // CONCATENATED MODULE: ./src/core/strategies/if_strategy.ts
            var IfStrategy = function() {
                function IfStrategy(test, trueBranch, falseBranch) {
                    this.test = test;
                    this.trueBranch = trueBranch;
                    this.falseBranch = falseBranch;
                }
                IfStrategy.prototype.isSupported = function() {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.isSupported();
                };
                IfStrategy.prototype.connect = function(minPriority, callback) {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.connect(minPriority, callback);
                };
                return IfStrategy;
            }();
            /* harmony default export */ var if_strategy = IfStrategy;
            // CONCATENATED MODULE: ./src/core/strategies/first_connected_strategy.ts
            var FirstConnectedStrategy = function() {
                function FirstConnectedStrategy(strategy) {
                    this.strategy = strategy;
                }
                FirstConnectedStrategy.prototype.isSupported = function() {
                    return this.strategy.isSupported();
                };
                FirstConnectedStrategy.prototype.connect = function(minPriority, callback) {
                    var runner = this.strategy.connect(minPriority, function(error, handshake) {
                        if (handshake) runner.abort();
                        callback(error, handshake);
                    });
                    return runner;
                };
                return FirstConnectedStrategy;
            }();
            /* harmony default export */ var first_connected_strategy = FirstConnectedStrategy;
            // CONCATENATED MODULE: ./src/runtimes/web/default_strategy.ts
            function testSupportsStrategy(strategy) {
                return function() {
                    return strategy.isSupported();
                };
            }
            var getDefaultStrategy = function(config, baseOptions, defineTransport) {
                var definedTransports = {};
                function defineTransportStrategy(name, type, priority, options, manager) {
                    var transport = defineTransport(config, name, type, priority, options, manager);
                    definedTransports[name] = transport;
                    return transport;
                }
                var ws_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.wsHost + ":" + config.wsPort,
                    hostTLS: config.wsHost + ":" + config.wssPort,
                    httpPath: config.wsPath
                });
                var wss_options = Object.assign({}, ws_options, {
                    useTLS: true
                });
                var sockjs_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.httpHost + ":" + config.httpPort,
                    hostTLS: config.httpHost + ":" + config.httpsPort,
                    httpPath: config.httpPath
                });
                var timeouts = {
                    loop: true,
                    timeout: 15000,
                    timeoutLimit: 60000
                };
                var ws_manager = new transport_manager({
                    lives: 2,
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var streaming_manager = new transport_manager({
                    lives: 2,
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var ws_transport = defineTransportStrategy("ws", "ws", 3, ws_options, ws_manager);
                var wss_transport = defineTransportStrategy("wss", "ws", 3, wss_options, ws_manager);
                var sockjs_transport = defineTransportStrategy("sockjs", "sockjs", 1, sockjs_options);
                var xhr_streaming_transport = defineTransportStrategy("xhr_streaming", "xhr_streaming", 1, sockjs_options, streaming_manager);
                var xdr_streaming_transport = defineTransportStrategy("xdr_streaming", "xdr_streaming", 1, sockjs_options, streaming_manager);
                var xhr_polling_transport = defineTransportStrategy("xhr_polling", "xhr_polling", 1, sockjs_options);
                var xdr_polling_transport = defineTransportStrategy("xdr_polling", "xdr_polling", 1, sockjs_options);
                var ws_loop = new sequential_strategy([
                    ws_transport
                ], timeouts);
                var wss_loop = new sequential_strategy([
                    wss_transport
                ], timeouts);
                var sockjs_loop = new sequential_strategy([
                    sockjs_transport
                ], timeouts);
                var streaming_loop = new sequential_strategy([
                    new if_strategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
                ], timeouts);
                var polling_loop = new sequential_strategy([
                    new if_strategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
                ], timeouts);
                var http_loop = new sequential_strategy([
                    new if_strategy(testSupportsStrategy(streaming_loop), new best_connected_ever_strategy([
                        streaming_loop,
                        new delayed_strategy(polling_loop, {
                            delay: 4000
                        })
                    ]), polling_loop)
                ], timeouts);
                var http_fallback_loop = new if_strategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
                var wsStrategy;
                if (baseOptions.useTLS) wsStrategy = new best_connected_ever_strategy([
                    ws_loop,
                    new delayed_strategy(http_fallback_loop, {
                        delay: 2000
                    })
                ]);
                else wsStrategy = new best_connected_ever_strategy([
                    ws_loop,
                    new delayed_strategy(wss_loop, {
                        delay: 2000
                    }),
                    new delayed_strategy(http_fallback_loop, {
                        delay: 5000
                    })
                ]);
                return new cached_strategy(new first_connected_strategy(new if_strategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
                    ttl: 1800000,
                    timeline: baseOptions.timeline,
                    useTLS: baseOptions.useTLS
                });
            };
            /* harmony default export */ var default_strategy = getDefaultStrategy;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transport_connection_initializer.ts
            /* harmony default export */ var transport_connection_initializer = function() {
                var self = this;
                self.timeline.info(self.buildTimelineMessage({
                    transport: self.name + (self.options.useTLS ? "s" : "")
                }));
                if (self.hooks.isInitialized()) self.changeState("initialized");
                else if (self.hooks.file) {
                    self.changeState("initializing");
                    Dependencies.load(self.hooks.file, {
                        useTLS: self.options.useTLS
                    }, function(error, callback) {
                        if (self.hooks.isInitialized()) {
                            self.changeState("initialized");
                            callback(true);
                        } else {
                            if (error) self.onError(error);
                            self.onClose();
                            callback(false);
                        }
                    });
                } else self.onClose();
            };
            // CONCATENATED MODULE: ./src/runtimes/web/http/http_xdomain_request.ts
            var http_xdomain_request_hooks = {
                getRequest: function(socket) {
                    var xdr = new window.XDomainRequest();
                    xdr.ontimeout = function() {
                        socket.emit("error", new RequestTimedOut());
                        socket.close();
                    };
                    xdr.onerror = function(e) {
                        socket.emit("error", e);
                        socket.close();
                    };
                    xdr.onprogress = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                    };
                    xdr.onload = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                        socket.emit("finished", 200);
                        socket.close();
                    };
                    return xdr;
                },
                abortRequest: function(xdr) {
                    xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
                    xdr.abort();
                }
            };
            /* harmony default export */ var http_xdomain_request = http_xdomain_request_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_request.ts
            var http_request_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var MAX_BUFFER_LENGTH = 262144;
            var http_request_HTTPRequest = function(_super) {
                http_request_extends(HTTPRequest, _super);
                function HTTPRequest(hooks, method, url) {
                    var _this = _super.call(this) || this;
                    _this.hooks = hooks;
                    _this.method = method;
                    _this.url = url;
                    return _this;
                }
                HTTPRequest.prototype.start = function(payload) {
                    var _this = this;
                    this.position = 0;
                    this.xhr = this.hooks.getRequest(this);
                    this.unloader = function() {
                        _this.close();
                    };
                    runtime.addUnloadListener(this.unloader);
                    this.xhr.open(this.method, this.url, true);
                    if (this.xhr.setRequestHeader) this.xhr.setRequestHeader("Content-Type", "application/json");
                    this.xhr.send(payload);
                };
                HTTPRequest.prototype.close = function() {
                    if (this.unloader) {
                        runtime.removeUnloadListener(this.unloader);
                        this.unloader = null;
                    }
                    if (this.xhr) {
                        this.hooks.abortRequest(this.xhr);
                        this.xhr = null;
                    }
                };
                HTTPRequest.prototype.onChunk = function(status, data) {
                    while(true){
                        var chunk = this.advanceBuffer(data);
                        if (chunk) this.emit("chunk", {
                            status: status,
                            data: chunk
                        });
                        else break;
                    }
                    if (this.isBufferTooLong(data)) this.emit("buffer_too_long");
                };
                HTTPRequest.prototype.advanceBuffer = function(buffer) {
                    var unreadData = buffer.slice(this.position);
                    var endOfLinePosition = unreadData.indexOf("\n");
                    if (endOfLinePosition !== -1) {
                        this.position += endOfLinePosition + 1;
                        return unreadData.slice(0, endOfLinePosition);
                    } else return null;
                };
                HTTPRequest.prototype.isBufferTooLong = function(buffer) {
                    return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
                };
                return HTTPRequest;
            }(dispatcher);
            /* harmony default export */ var http_request = http_request_HTTPRequest;
            // CONCATENATED MODULE: ./src/core/http/state.ts
            var State;
            (function(State) {
                State[State["CONNECTING"] = 0] = "CONNECTING";
                State[State["OPEN"] = 1] = "OPEN";
                State[State["CLOSED"] = 3] = "CLOSED";
            })(State || (State = {}));
            /* harmony default export */ var state = State;
            // CONCATENATED MODULE: ./src/core/http/http_socket.ts
            var autoIncrement = 1;
            var http_socket_HTTPSocket = function() {
                function HTTPSocket(hooks, url) {
                    this.hooks = hooks;
                    this.session = randomNumber(1000) + "/" + randomString(8);
                    this.location = getLocation(url);
                    this.readyState = state.CONNECTING;
                    this.openStream();
                }
                HTTPSocket.prototype.send = function(payload) {
                    return this.sendRaw(JSON.stringify([
                        payload
                    ]));
                };
                HTTPSocket.prototype.ping = function() {
                    this.hooks.sendHeartbeat(this);
                };
                HTTPSocket.prototype.close = function(code, reason) {
                    this.onClose(code, reason, true);
                };
                HTTPSocket.prototype.sendRaw = function(payload) {
                    if (this.readyState === state.OPEN) try {
                        runtime.createSocketRequest("POST", getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                        return true;
                    } catch (e) {
                        return false;
                    }
                    else return false;
                };
                HTTPSocket.prototype.reconnect = function() {
                    this.closeStream();
                    this.openStream();
                };
                HTTPSocket.prototype.onClose = function(code, reason, wasClean) {
                    this.closeStream();
                    this.readyState = state.CLOSED;
                    if (this.onclose) this.onclose({
                        code: code,
                        reason: reason,
                        wasClean: wasClean
                    });
                };
                HTTPSocket.prototype.onChunk = function(chunk) {
                    if (chunk.status !== 200) return;
                    if (this.readyState === state.OPEN) this.onActivity();
                    var payload;
                    var type = chunk.data.slice(0, 1);
                    switch(type){
                        case "o":
                            payload = JSON.parse(chunk.data.slice(1) || "{}");
                            this.onOpen(payload);
                            break;
                        case "a":
                            payload = JSON.parse(chunk.data.slice(1) || "[]");
                            for(var i = 0; i < payload.length; i++)this.onEvent(payload[i]);
                            break;
                        case "m":
                            payload = JSON.parse(chunk.data.slice(1) || "null");
                            this.onEvent(payload);
                            break;
                        case "h":
                            this.hooks.onHeartbeat(this);
                            break;
                        case "c":
                            payload = JSON.parse(chunk.data.slice(1) || "[]");
                            this.onClose(payload[0], payload[1], true);
                            break;
                    }
                };
                HTTPSocket.prototype.onOpen = function(options) {
                    if (this.readyState === state.CONNECTING) {
                        if (options && options.hostname) this.location.base = replaceHost(this.location.base, options.hostname);
                        this.readyState = state.OPEN;
                        if (this.onopen) this.onopen();
                    } else this.onClose(1006, "Server lost session", true);
                };
                HTTPSocket.prototype.onEvent = function(event) {
                    if (this.readyState === state.OPEN && this.onmessage) this.onmessage({
                        data: event
                    });
                };
                HTTPSocket.prototype.onActivity = function() {
                    if (this.onactivity) this.onactivity();
                };
                HTTPSocket.prototype.onError = function(error) {
                    if (this.onerror) this.onerror(error);
                };
                HTTPSocket.prototype.openStream = function() {
                    var _this = this;
                    this.stream = runtime.createSocketRequest("POST", getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
                    this.stream.bind("chunk", function(chunk) {
                        _this.onChunk(chunk);
                    });
                    this.stream.bind("finished", function(status) {
                        _this.hooks.onFinished(_this, status);
                    });
                    this.stream.bind("buffer_too_long", function() {
                        _this.reconnect();
                    });
                    try {
                        this.stream.start();
                    } catch (error) {
                        util.defer(function() {
                            _this.onError(error);
                            _this.onClose(1006, "Could not start streaming", false);
                        });
                    }
                };
                HTTPSocket.prototype.closeStream = function() {
                    if (this.stream) {
                        this.stream.unbind_all();
                        this.stream.close();
                        this.stream = null;
                    }
                };
                return HTTPSocket;
            }();
            function getLocation(url) {
                var parts = /([^\?]*)\/*(\??.*)/.exec(url);
                return {
                    base: parts[1],
                    queryString: parts[2]
                };
            }
            function getSendURL(url, session) {
                return url.base + "/" + session + "/xhr_send";
            }
            function getUniqueURL(url) {
                var separator = url.indexOf("?") === -1 ? "?" : "&";
                return url + separator + "t=" + +new Date() + "&n=" + autoIncrement++;
            }
            function replaceHost(url, hostname) {
                var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
                return urlParts[1] + hostname + urlParts[3];
            }
            function randomNumber(max) {
                return runtime.randomInt(max);
            }
            function randomString(length) {
                var result = [];
                for(var i = 0; i < length; i++)result.push(randomNumber(32).toString(32));
                return result.join("");
            }
            /* harmony default export */ var http_socket = http_socket_HTTPSocket;
            // CONCATENATED MODULE: ./src/core/http/http_streaming_socket.ts
            var http_streaming_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + "/" + session + "/xhr_streaming" + url.queryString;
                },
                onHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                sendHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                onFinished: function(socket, status) {
                    socket.onClose(1006, "Connection interrupted (" + status + ")", false);
                }
            };
            /* harmony default export */ var http_streaming_socket = http_streaming_socket_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_polling_socket.ts
            var http_polling_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + "/" + session + "/xhr" + url.queryString;
                },
                onHeartbeat: function() {},
                sendHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                onFinished: function(socket, status) {
                    if (status === 200) socket.reconnect();
                    else socket.onClose(1006, "Connection interrupted (" + status + ")", false);
                }
            };
            /* harmony default export */ var http_polling_socket = http_polling_socket_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http_xhr_request.ts
            var http_xhr_request_hooks = {
                getRequest: function(socket) {
                    var Constructor = runtime.getXHRAPI();
                    var xhr = new Constructor();
                    xhr.onreadystatechange = xhr.onprogress = function() {
                        switch(xhr.readyState){
                            case 3:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                break;
                            case 4:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                socket.emit("finished", xhr.status);
                                socket.close();
                                break;
                        }
                    };
                    return xhr;
                },
                abortRequest: function(xhr) {
                    xhr.onreadystatechange = null;
                    xhr.abort();
                }
            };
            /* harmony default export */ var http_xhr_request = http_xhr_request_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http.ts
            var HTTP = {
                createStreamingSocket: function(url) {
                    return this.createSocket(http_streaming_socket, url);
                },
                createPollingSocket: function(url) {
                    return this.createSocket(http_polling_socket, url);
                },
                createSocket: function(hooks, url) {
                    return new http_socket(hooks, url);
                },
                createXHR: function(method, url) {
                    return this.createRequest(http_xhr_request, method, url);
                },
                createRequest: function(hooks, method, url) {
                    return new http_request(hooks, method, url);
                }
            };
            /* harmony default export */ var http_http = HTTP;
            // CONCATENATED MODULE: ./src/runtimes/web/http/http.ts
            http_http.createXDR = function(method, url) {
                return this.createRequest(http_xdomain_request, method, url);
            };
            /* harmony default export */ var web_http_http = http_http;
            // CONCATENATED MODULE: ./src/runtimes/web/runtime.ts
            var Runtime = {
                nextAuthCallbackID: 1,
                auth_callbacks: {},
                ScriptReceivers: ScriptReceivers,
                DependenciesReceivers: DependenciesReceivers,
                getDefaultStrategy: default_strategy,
                Transports: transports_transports,
                transportConnectionInitializer: transport_connection_initializer,
                HTTPFactory: web_http_http,
                TimelineTransport: jsonp_timeline,
                getXHRAPI: function() {
                    return window.XMLHttpRequest;
                },
                getWebSocketAPI: function() {
                    return window.WebSocket || window.MozWebSocket;
                },
                setup: function(PusherClass) {
                    var _this = this;
                    window.Pusher = PusherClass;
                    var initializeOnDocumentBody = function() {
                        _this.onDocumentBody(PusherClass.ready);
                    };
                    if (!window.JSON) Dependencies.load("json2", {}, initializeOnDocumentBody);
                    else initializeOnDocumentBody();
                },
                getDocument: function() {
                    return document;
                },
                getProtocol: function() {
                    return this.getDocument().location.protocol;
                },
                getAuthorizers: function() {
                    return {
                        ajax: xhr_auth,
                        jsonp: jsonp_auth
                    };
                },
                onDocumentBody: function(callback) {
                    var _this = this;
                    if (document.body) callback();
                    else setTimeout(function() {
                        _this.onDocumentBody(callback);
                    }, 0);
                },
                createJSONPRequest: function(url, data) {
                    return new jsonp_request(url, data);
                },
                createScriptRequest: function(src) {
                    return new script_request(src);
                },
                getLocalStorage: function() {
                    try {
                        return window.localStorage;
                    } catch (e) {
                        return undefined;
                    }
                },
                createXHR: function() {
                    if (this.getXHRAPI()) return this.createXMLHttpRequest();
                    else return this.createMicrosoftXHR();
                },
                createXMLHttpRequest: function() {
                    var Constructor = this.getXHRAPI();
                    return new Constructor();
                },
                createMicrosoftXHR: function() {
                    return new ActiveXObject("Microsoft.XMLHTTP");
                },
                getNetwork: function() {
                    return net_info_Network;
                },
                createWebSocket: function(url) {
                    var Constructor = this.getWebSocketAPI();
                    return new Constructor(url);
                },
                createSocketRequest: function(method, url) {
                    if (this.isXHRSupported()) return this.HTTPFactory.createXHR(method, url);
                    else if (this.isXDRSupported(url.indexOf("https:") === 0)) return this.HTTPFactory.createXDR(method, url);
                    else throw "Cross-origin HTTP requests are not supported";
                },
                isXHRSupported: function() {
                    var Constructor = this.getXHRAPI();
                    return Boolean(Constructor) && new Constructor().withCredentials !== undefined;
                },
                isXDRSupported: function(useTLS) {
                    var protocol = useTLS ? "https:" : "http:";
                    var documentProtocol = this.getProtocol();
                    return Boolean(window["XDomainRequest"]) && documentProtocol === protocol;
                },
                addUnloadListener: function(listener) {
                    if (window.addEventListener !== undefined) window.addEventListener("unload", listener, false);
                    else if (window.attachEvent !== undefined) window.attachEvent("onunload", listener);
                },
                removeUnloadListener: function(listener) {
                    if (window.addEventListener !== undefined) window.removeEventListener("unload", listener, false);
                    else if (window.detachEvent !== undefined) window.detachEvent("onunload", listener);
                },
                randomInt: function(max) {
                    var random = function() {
                        var crypto = window.crypto || window["msCrypto"];
                        var random = crypto.getRandomValues(new Uint32Array(1))[0];
                        return random / Math.pow(2, 32);
                    };
                    return Math.floor(random() * max);
                }
            };
            /* harmony default export */ var runtime = Runtime;
            // CONCATENATED MODULE: ./src/core/timeline/level.ts
            var TimelineLevel;
            (function(TimelineLevel) {
                TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
                TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
                TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
            })(TimelineLevel || (TimelineLevel = {}));
            /* harmony default export */ var timeline_level = TimelineLevel;
            // CONCATENATED MODULE: ./src/core/timeline/timeline.ts
            var timeline_Timeline = function() {
                function Timeline(key, session, options) {
                    this.key = key;
                    this.session = session;
                    this.events = [];
                    this.options = options || {};
                    this.sent = 0;
                    this.uniqueID = 0;
                }
                Timeline.prototype.log = function(level, event) {
                    if (level <= this.options.level) {
                        this.events.push(extend({}, event, {
                            timestamp: util.now()
                        }));
                        if (this.options.limit && this.events.length > this.options.limit) this.events.shift();
                    }
                };
                Timeline.prototype.error = function(event) {
                    this.log(timeline_level.ERROR, event);
                };
                Timeline.prototype.info = function(event) {
                    this.log(timeline_level.INFO, event);
                };
                Timeline.prototype.debug = function(event) {
                    this.log(timeline_level.DEBUG, event);
                };
                Timeline.prototype.isEmpty = function() {
                    return this.events.length === 0;
                };
                Timeline.prototype.send = function(sendfn, callback) {
                    var _this = this;
                    var data = extend({
                        session: this.session,
                        bundle: this.sent + 1,
                        key: this.key,
                        lib: "js",
                        version: this.options.version,
                        cluster: this.options.cluster,
                        features: this.options.features,
                        timeline: this.events
                    }, this.options.params);
                    this.events = [];
                    sendfn(data, function(error, result) {
                        if (!error) _this.sent++;
                        if (callback) callback(error, result);
                    });
                    return true;
                };
                Timeline.prototype.generateUniqueID = function() {
                    this.uniqueID++;
                    return this.uniqueID;
                };
                return Timeline;
            }();
            /* harmony default export */ var timeline_timeline = timeline_Timeline;
            // CONCATENATED MODULE: ./src/core/strategies/transport_strategy.ts
            var transport_strategy_TransportStrategy = function() {
                function TransportStrategy(name, priority, transport, options) {
                    this.name = name;
                    this.priority = priority;
                    this.transport = transport;
                    this.options = options || {};
                }
                TransportStrategy.prototype.isSupported = function() {
                    return this.transport.isSupported({
                        useTLS: this.options.useTLS
                    });
                };
                TransportStrategy.prototype.connect = function(minPriority, callback) {
                    var _this = this;
                    if (!this.isSupported()) return failAttempt(new UnsupportedStrategy(), callback);
                    else if (this.priority < minPriority) return failAttempt(new TransportPriorityTooLow(), callback);
                    var connected = false;
                    var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
                    var handshake = null;
                    var onInitialized = function() {
                        transport.unbind("initialized", onInitialized);
                        transport.connect();
                    };
                    var onOpen = function() {
                        handshake = factory.createHandshake(transport, function(result) {
                            connected = true;
                            unbindListeners();
                            callback(null, result);
                        });
                    };
                    var onError = function(error) {
                        unbindListeners();
                        callback(error);
                    };
                    var onClosed = function() {
                        unbindListeners();
                        var serializedTransport;
                        serializedTransport = safeJSONStringify(transport);
                        callback(new TransportClosed(serializedTransport));
                    };
                    var unbindListeners = function() {
                        transport.unbind("initialized", onInitialized);
                        transport.unbind("open", onOpen);
                        transport.unbind("error", onError);
                        transport.unbind("closed", onClosed);
                    };
                    transport.bind("initialized", onInitialized);
                    transport.bind("open", onOpen);
                    transport.bind("error", onError);
                    transport.bind("closed", onClosed);
                    transport.initialize();
                    return {
                        abort: function() {
                            if (connected) return;
                            unbindListeners();
                            if (handshake) handshake.close();
                            else transport.close();
                        },
                        forceMinPriority: function(p) {
                            if (connected) return;
                            if (_this.priority < p) {
                                if (handshake) handshake.close();
                                else transport.close();
                            }
                        }
                    };
                };
                return TransportStrategy;
            }();
            /* harmony default export */ var transport_strategy = transport_strategy_TransportStrategy;
            function failAttempt(error, callback) {
                util.defer(function() {
                    callback(error);
                });
                return {
                    abort: function() {},
                    forceMinPriority: function() {}
                };
            }
            // CONCATENATED MODULE: ./src/core/strategies/strategy_builder.ts
            var strategy_builder_Transports = runtime.Transports;
            var strategy_builder_defineTransport = function(config, name, type, priority, options, manager) {
                var transportClass = strategy_builder_Transports[type];
                if (!transportClass) throw new UnsupportedTransport(type);
                var enabled = (!config.enabledTransports || arrayIndexOf(config.enabledTransports, name) !== -1) && (!config.disabledTransports || arrayIndexOf(config.disabledTransports, name) === -1);
                var transport;
                if (enabled) {
                    options = Object.assign({
                        ignoreNullOrigin: config.ignoreNullOrigin
                    }, options);
                    transport = new transport_strategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
                } else transport = strategy_builder_UnsupportedStrategy;
                return transport;
            };
            var strategy_builder_UnsupportedStrategy = {
                isSupported: function() {
                    return false;
                },
                connect: function(_, callback) {
                    var deferred = util.defer(function() {
                        callback(new UnsupportedStrategy());
                    });
                    return {
                        abort: function() {
                            deferred.ensureAborted();
                        },
                        forceMinPriority: function() {}
                    };
                }
            };
            // CONCATENATED MODULE: ./src/core/auth/user_authenticator.ts
            var composeChannelQuery = function(params, authOptions) {
                var query = "socket_id=" + encodeURIComponent(params.socketId);
                for(var key in authOptions.params)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(authOptions.params[key]);
                if (authOptions.paramsProvider != null) {
                    var dynamicParams = authOptions.paramsProvider();
                    for(var key in dynamicParams)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dynamicParams[key]);
                }
                return query;
            };
            var UserAuthenticator = function(authOptions) {
                if (typeof runtime.getAuthorizers()[authOptions.transport] === "undefined") throw "'" + authOptions.transport + "' is not a recognized auth transport";
                return function(params, callback) {
                    var query = composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.UserAuthentication, callback);
                };
            };
            /* harmony default export */ var user_authenticator = UserAuthenticator;
            // CONCATENATED MODULE: ./src/core/auth/channel_authorizer.ts
            var channel_authorizer_composeChannelQuery = function(params, authOptions) {
                var query = "socket_id=" + encodeURIComponent(params.socketId);
                query += "&channel_name=" + encodeURIComponent(params.channelName);
                for(var key in authOptions.params)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(authOptions.params[key]);
                if (authOptions.paramsProvider != null) {
                    var dynamicParams = authOptions.paramsProvider();
                    for(var key in dynamicParams)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dynamicParams[key]);
                }
                return query;
            };
            var ChannelAuthorizer = function(authOptions) {
                if (typeof runtime.getAuthorizers()[authOptions.transport] === "undefined") throw "'" + authOptions.transport + "' is not a recognized auth transport";
                return function(params, callback) {
                    var query = channel_authorizer_composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.ChannelAuthorization, callback);
                };
            };
            /* harmony default export */ var channel_authorizer = ChannelAuthorizer;
            // CONCATENATED MODULE: ./src/core/auth/deprecated_channel_authorizer.ts
            var ChannelAuthorizerProxy = function(pusher, authOptions, channelAuthorizerGenerator) {
                var deprecatedAuthorizerOptions = {
                    authTransport: authOptions.transport,
                    authEndpoint: authOptions.endpoint,
                    auth: {
                        params: authOptions.params,
                        headers: authOptions.headers
                    }
                };
                return function(params, callback) {
                    var channel = pusher.channel(params.channelName);
                    var channelAuthorizer = channelAuthorizerGenerator(channel, deprecatedAuthorizerOptions);
                    channelAuthorizer.authorize(params.socketId, callback);
                };
            };
            // CONCATENATED MODULE: ./src/core/config.ts
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            function getConfig(opts, pusher) {
                var config = {
                    activityTimeout: opts.activityTimeout || defaults.activityTimeout,
                    cluster: opts.cluster || defaults.cluster,
                    httpPath: opts.httpPath || defaults.httpPath,
                    httpPort: opts.httpPort || defaults.httpPort,
                    httpsPort: opts.httpsPort || defaults.httpsPort,
                    pongTimeout: opts.pongTimeout || defaults.pongTimeout,
                    statsHost: opts.statsHost || defaults.stats_host,
                    unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
                    wsPath: opts.wsPath || defaults.wsPath,
                    wsPort: opts.wsPort || defaults.wsPort,
                    wssPort: opts.wssPort || defaults.wssPort,
                    enableStats: getEnableStatsConfig(opts),
                    httpHost: getHttpHost(opts),
                    useTLS: shouldUseTLS(opts),
                    wsHost: getWebsocketHost(opts),
                    userAuthenticator: buildUserAuthenticator(opts),
                    channelAuthorizer: buildChannelAuthorizer(opts, pusher)
                };
                if ("disabledTransports" in opts) config.disabledTransports = opts.disabledTransports;
                if ("enabledTransports" in opts) config.enabledTransports = opts.enabledTransports;
                if ("ignoreNullOrigin" in opts) config.ignoreNullOrigin = opts.ignoreNullOrigin;
                if ("timelineParams" in opts) config.timelineParams = opts.timelineParams;
                if ("nacl" in opts) config.nacl = opts.nacl;
                return config;
            }
            function getHttpHost(opts) {
                if (opts.httpHost) return opts.httpHost;
                if (opts.cluster) return "sockjs-" + opts.cluster + ".pusher.com";
                return defaults.httpHost;
            }
            function getWebsocketHost(opts) {
                if (opts.wsHost) return opts.wsHost;
                if (opts.cluster) return getWebsocketHostFromCluster(opts.cluster);
                return getWebsocketHostFromCluster(defaults.cluster);
            }
            function getWebsocketHostFromCluster(cluster) {
                return "ws-" + cluster + ".pusher.com";
            }
            function shouldUseTLS(opts) {
                if (runtime.getProtocol() === "https:") return true;
                else if (opts.forceTLS === false) return false;
                return true;
            }
            function getEnableStatsConfig(opts) {
                if ("enableStats" in opts) return opts.enableStats;
                if ("disableStats" in opts) return !opts.disableStats;
                return false;
            }
            function buildUserAuthenticator(opts) {
                var userAuthentication = __assign(__assign({}, defaults.userAuthentication), opts.userAuthentication);
                if ("customHandler" in userAuthentication && userAuthentication["customHandler"] != null) return userAuthentication["customHandler"];
                return user_authenticator(userAuthentication);
            }
            function buildChannelAuth(opts, pusher) {
                var channelAuthorization;
                if ("channelAuthorization" in opts) channelAuthorization = __assign(__assign({}, defaults.channelAuthorization), opts.channelAuthorization);
                else {
                    channelAuthorization = {
                        transport: opts.authTransport || defaults.authTransport,
                        endpoint: opts.authEndpoint || defaults.authEndpoint
                    };
                    if ("auth" in opts) {
                        if ("params" in opts.auth) channelAuthorization.params = opts.auth.params;
                        if ("headers" in opts.auth) channelAuthorization.headers = opts.auth.headers;
                    }
                    if ("authorizer" in opts) channelAuthorization.customHandler = ChannelAuthorizerProxy(pusher, channelAuthorization, opts.authorizer);
                }
                return channelAuthorization;
            }
            function buildChannelAuthorizer(opts, pusher) {
                var channelAuthorization = buildChannelAuth(opts, pusher);
                if ("customHandler" in channelAuthorization && channelAuthorization["customHandler"] != null) return channelAuthorization["customHandler"];
                return channel_authorizer(channelAuthorization);
            }
            // CONCATENATED MODULE: ./src/core/watchlist.ts
            var watchlist_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var watchlist_WatchlistFacade = function(_super) {
                watchlist_extends(WatchlistFacade, _super);
                function WatchlistFacade(pusher) {
                    var _this = _super.call(this, function(eventName, data) {
                        logger.debug("No callbacks on watchlist events for " + eventName);
                    }) || this;
                    _this.pusher = pusher;
                    _this.bindWatchlistInternalEvent();
                    return _this;
                }
                WatchlistFacade.prototype.handleEvent = function(pusherEvent) {
                    var _this = this;
                    pusherEvent.data.events.forEach(function(watchlistEvent) {
                        _this.emit(watchlistEvent.name, watchlistEvent);
                    });
                };
                WatchlistFacade.prototype.bindWatchlistInternalEvent = function() {
                    var _this = this;
                    this.pusher.connection.bind("message", function(pusherEvent) {
                        var eventName = pusherEvent.event;
                        if (eventName === "pusher_internal:watchlist_events") _this.handleEvent(pusherEvent);
                    });
                };
                return WatchlistFacade;
            }(dispatcher);
            /* harmony default export */ var watchlist = watchlist_WatchlistFacade;
            // CONCATENATED MODULE: ./src/core/utils/flat_promise.ts
            function flatPromise() {
                var resolve, reject;
                var promise = new Promise(function(res, rej) {
                    resolve = res;
                    reject = rej;
                });
                return {
                    promise: promise,
                    resolve: resolve,
                    reject: reject
                };
            }
            /* harmony default export */ var flat_promise = flatPromise;
            // CONCATENATED MODULE: ./src/core/user.ts
            var user_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var user_UserFacade = function(_super) {
                user_extends(UserFacade, _super);
                function UserFacade(pusher) {
                    var _this = _super.call(this, function(eventName, data) {
                        logger.debug("No callbacks on user for " + eventName);
                    }) || this;
                    _this.signin_requested = false;
                    _this.user_data = null;
                    _this.serverToUserChannel = null;
                    _this.signinDonePromise = null;
                    _this._signinDoneResolve = null;
                    _this._onAuthorize = function(err, authData) {
                        if (err) {
                            logger.warn("Error during signin: " + err);
                            _this._cleanup();
                            return;
                        }
                        _this.pusher.send_event("pusher:signin", {
                            auth: authData.auth,
                            user_data: authData.user_data
                        });
                    };
                    _this.pusher = pusher;
                    _this.pusher.connection.bind("state_change", function(_a) {
                        var previous = _a.previous, current = _a.current;
                        if (previous !== "connected" && current === "connected") _this._signin();
                        if (previous === "connected" && current !== "connected") {
                            _this._cleanup();
                            _this._newSigninPromiseIfNeeded();
                        }
                    });
                    _this.watchlist = new watchlist(pusher);
                    _this.pusher.connection.bind("message", function(event) {
                        var eventName = event.event;
                        if (eventName === "pusher:signin_success") _this._onSigninSuccess(event.data);
                        if (_this.serverToUserChannel && _this.serverToUserChannel.name === event.channel) _this.serverToUserChannel.handleEvent(event);
                    });
                    return _this;
                }
                UserFacade.prototype.signin = function() {
                    if (this.signin_requested) return;
                    this.signin_requested = true;
                    this._signin();
                };
                UserFacade.prototype._signin = function() {
                    if (!this.signin_requested) return;
                    this._newSigninPromiseIfNeeded();
                    if (this.pusher.connection.state !== "connected") return;
                    this.pusher.config.userAuthenticator({
                        socketId: this.pusher.connection.socket_id
                    }, this._onAuthorize);
                };
                UserFacade.prototype._onSigninSuccess = function(data) {
                    try {
                        this.user_data = JSON.parse(data.user_data);
                    } catch (e) {
                        logger.error("Failed parsing user data after signin: " + data.user_data);
                        this._cleanup();
                        return;
                    }
                    if (typeof this.user_data.id !== "string" || this.user_data.id === "") {
                        logger.error("user_data doesn't contain an id. user_data: " + this.user_data);
                        this._cleanup();
                        return;
                    }
                    this._signinDoneResolve();
                    this._subscribeChannels();
                };
                UserFacade.prototype._subscribeChannels = function() {
                    var _this = this;
                    var ensure_subscribed = function(channel) {
                        if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                        else if (!channel.subscriptionPending && _this.pusher.connection.state === "connected") channel.subscribe();
                    };
                    this.serverToUserChannel = new channels_channel("#server-to-user-" + this.user_data.id, this.pusher);
                    this.serverToUserChannel.bind_global(function(eventName, data) {
                        if (eventName.indexOf("pusher_internal:") === 0 || eventName.indexOf("pusher:") === 0) return;
                        _this.emit(eventName, data);
                    });
                    ensure_subscribed(this.serverToUserChannel);
                };
                UserFacade.prototype._cleanup = function() {
                    this.user_data = null;
                    if (this.serverToUserChannel) {
                        this.serverToUserChannel.unbind_all();
                        this.serverToUserChannel.disconnect();
                        this.serverToUserChannel = null;
                    }
                    if (this.signin_requested) this._signinDoneResolve();
                };
                UserFacade.prototype._newSigninPromiseIfNeeded = function() {
                    if (!this.signin_requested) return;
                    if (this.signinDonePromise && !this.signinDonePromise.done) return;
                    var _a = flat_promise(), promise = _a.promise, resolve = _a.resolve, _ = _a.reject;
                    promise.done = false;
                    var setDone = function() {
                        promise.done = true;
                    };
                    promise.then(setDone)["catch"](setDone);
                    this.signinDonePromise = promise;
                    this._signinDoneResolve = resolve;
                };
                return UserFacade;
            }(dispatcher);
            /* harmony default export */ var user = user_UserFacade;
            // CONCATENATED MODULE: ./src/core/pusher.ts
            var pusher_Pusher = function() {
                function Pusher(app_key, options) {
                    var _this = this;
                    checkAppKey(app_key);
                    options = options || {};
                    if (!options.cluster && !(options.wsHost || options.httpHost)) {
                        var suffix = url_store.buildLogSuffix("javascriptQuickStart");
                        logger.warn("You should always specify a cluster when connecting. " + suffix);
                    }
                    if ("disableStats" in options) logger.warn("The disableStats option is deprecated in favor of enableStats");
                    this.key = app_key;
                    this.config = getConfig(options, this);
                    this.channels = factory.createChannels();
                    this.global_emitter = new dispatcher();
                    this.sessionID = runtime.randomInt(1000000000);
                    this.timeline = new timeline_timeline(this.key, this.sessionID, {
                        cluster: this.config.cluster,
                        features: Pusher.getClientFeatures(),
                        params: this.config.timelineParams || {},
                        limit: 50,
                        level: timeline_level.INFO,
                        version: defaults.VERSION
                    });
                    if (this.config.enableStats) this.timelineSender = factory.createTimelineSender(this.timeline, {
                        host: this.config.statsHost,
                        path: "/timeline/v2/" + runtime.TimelineTransport.name
                    });
                    var getStrategy = function(options) {
                        return runtime.getDefaultStrategy(_this.config, options, strategy_builder_defineTransport);
                    };
                    this.connection = factory.createConnectionManager(this.key, {
                        getStrategy: getStrategy,
                        timeline: this.timeline,
                        activityTimeout: this.config.activityTimeout,
                        pongTimeout: this.config.pongTimeout,
                        unavailableTimeout: this.config.unavailableTimeout,
                        useTLS: Boolean(this.config.useTLS)
                    });
                    this.connection.bind("connected", function() {
                        _this.subscribeAll();
                        if (_this.timelineSender) _this.timelineSender.send(_this.connection.isUsingTLS());
                    });
                    this.connection.bind("message", function(event) {
                        var eventName = event.event;
                        var internal = eventName.indexOf("pusher_internal:") === 0;
                        if (event.channel) {
                            var channel = _this.channel(event.channel);
                            if (channel) channel.handleEvent(event);
                        }
                        if (!internal) _this.global_emitter.emit(event.event, event.data);
                    });
                    this.connection.bind("connecting", function() {
                        _this.channels.disconnect();
                    });
                    this.connection.bind("disconnected", function() {
                        _this.channels.disconnect();
                    });
                    this.connection.bind("error", function(err) {
                        logger.warn(err);
                    });
                    Pusher.instances.push(this);
                    this.timeline.info({
                        instances: Pusher.instances.length
                    });
                    this.user = new user(this);
                    if (Pusher.isReady) this.connect();
                }
                Pusher.ready = function() {
                    Pusher.isReady = true;
                    for(var i = 0, l = Pusher.instances.length; i < l; i++)Pusher.instances[i].connect();
                };
                Pusher.getClientFeatures = function() {
                    return keys(filterObject({
                        ws: runtime.Transports.ws
                    }, function(t) {
                        return t.isSupported({});
                    }));
                };
                Pusher.prototype.channel = function(name) {
                    return this.channels.find(name);
                };
                Pusher.prototype.allChannels = function() {
                    return this.channels.all();
                };
                Pusher.prototype.connect = function() {
                    this.connection.connect();
                    if (this.timelineSender) {
                        if (!this.timelineSenderTimer) {
                            var usingTLS = this.connection.isUsingTLS();
                            var timelineSender = this.timelineSender;
                            this.timelineSenderTimer = new PeriodicTimer(60000, function() {
                                timelineSender.send(usingTLS);
                            });
                        }
                    }
                };
                Pusher.prototype.disconnect = function() {
                    this.connection.disconnect();
                    if (this.timelineSenderTimer) {
                        this.timelineSenderTimer.ensureAborted();
                        this.timelineSenderTimer = null;
                    }
                };
                Pusher.prototype.bind = function(event_name, callback, context) {
                    this.global_emitter.bind(event_name, callback, context);
                    return this;
                };
                Pusher.prototype.unbind = function(event_name, callback, context) {
                    this.global_emitter.unbind(event_name, callback, context);
                    return this;
                };
                Pusher.prototype.bind_global = function(callback) {
                    this.global_emitter.bind_global(callback);
                    return this;
                };
                Pusher.prototype.unbind_global = function(callback) {
                    this.global_emitter.unbind_global(callback);
                    return this;
                };
                Pusher.prototype.unbind_all = function(callback) {
                    this.global_emitter.unbind_all();
                    return this;
                };
                Pusher.prototype.subscribeAll = function() {
                    var channelName;
                    for(channelName in this.channels.channels)if (this.channels.channels.hasOwnProperty(channelName)) this.subscribe(channelName);
                };
                Pusher.prototype.subscribe = function(channel_name) {
                    var channel = this.channels.add(channel_name, this);
                    if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                    else if (!channel.subscriptionPending && this.connection.state === "connected") channel.subscribe();
                    return channel;
                };
                Pusher.prototype.unsubscribe = function(channel_name) {
                    var channel = this.channels.find(channel_name);
                    if (channel && channel.subscriptionPending) channel.cancelSubscription();
                    else {
                        channel = this.channels.remove(channel_name);
                        if (channel && channel.subscribed) channel.unsubscribe();
                    }
                };
                Pusher.prototype.send_event = function(event_name, data, channel) {
                    return this.connection.send_event(event_name, data, channel);
                };
                Pusher.prototype.shouldUseTLS = function() {
                    return this.config.useTLS;
                };
                Pusher.prototype.signin = function() {
                    this.user.signin();
                };
                Pusher.instances = [];
                Pusher.isReady = false;
                Pusher.logToConsole = false;
                Pusher.Runtime = runtime;
                Pusher.ScriptReceivers = runtime.ScriptReceivers;
                Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
                Pusher.auth_callbacks = runtime.auth_callbacks;
                return Pusher;
            }();
            /* harmony default export */ var core_pusher = __webpack_exports__["default"] = pusher_Pusher;
            function checkAppKey(key) {
                if (key === null || key === undefined) throw "You must pass your app key when you instantiate Pusher.";
            }
            runtime.setup(pusher_Pusher);
        /***/ }
    ]);
});

});

parcelRegister("dW8ts", function(module, exports) {

$parcel$export(module.exports, "default", () => $a25743eeb178c628$export$2e2bcd8739ae039);

var $5bibj = parcelRequire("5bibj");

var $3FRCC = parcelRequire("3FRCC");

var $acw62 = parcelRequire("acw62");
var $a25743eeb178c628$var$isTouch = function(event) {
    return TouchEvent ? event instanceof TouchEvent : "touches" in event;
};
var $a25743eeb178c628$var$isMouse = function(event) {
    return event instanceof MouseEvent;
};
var $a25743eeb178c628$var$calcPosition = function(event) {
    return $a25743eeb178c628$var$isTouch(event) ? {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
    } : $a25743eeb178c628$var$isMouse(event) ? {
        x: event.pageX,
        y: event.pageY
    } : null;
};
var $a25743eeb178c628$var$useLongPress = function(callback, options) {
    if (options === void 0) options = {};
    var _a = options.pressDelay, pressDelay = _a === void 0 ? 500 : _a, _b = options.moveThreshold, moveThreshold = _b === void 0 ? 25 : _b, _c = options.preventContextMenuOnLongPress, preventContextMenuOnLongPress = _c === void 0 ? false : _c, _d = options.preventLongPressOnMove, preventLongPressOnMove = _d === void 0 ? false : _d;
    var callbackRef = (0, $5bibj.default)(callback);
    var timeoutRef = $acw62.useRef();
    var startPositionsRef = $acw62.useRef(null);
    var isPressedRef = $acw62.useRef(false);
    var startLongPress = function(event) {
        // Ignore events other than mouse and touch
        if (!$a25743eeb178c628$var$isMouse(event) && !$a25743eeb178c628$var$isTouch(event)) return;
        if (isPressedRef.current) return;
        // Main button pressed
        isPressedRef.current = $a25743eeb178c628$var$isMouse(event) ? event.button === 0 : true;
        startPositionsRef.current = $a25743eeb178c628$var$calcPosition(event);
        timeoutRef.current = setTimeout(function() {
            var _a;
            return void ((_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef));
        }, pressDelay);
    };
    var stopLongPress = function(event) {
        // Ignore events other than mouse and touch
        if (!$a25743eeb178c628$var$isMouse(event) && !$a25743eeb178c628$var$isTouch(event)) return;
        isPressedRef.current = false;
        startPositionsRef.current = null;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    var preventLongPress = function(event) {
        if (!preventLongPressOnMove) return;
        // Ignore events other than mouse and touch
        if (!$a25743eeb178c628$var$isMouse(event) && !$a25743eeb178c628$var$isTouch(event)) return;
        if (!startPositionsRef.current) return;
        var position = $a25743eeb178c628$var$calcPosition(event);
        var initialPosition = startPositionsRef.current;
        if (!position) return;
        var dx = Math.abs(position.x - initialPosition.x);
        var dy = Math.abs(position.y - initialPosition.y);
        if (dx > moveThreshold || dy > moveThreshold) stopLongPress(event);
    };
    var preventContextMenu = function(event) {
        var _a;
        if (!isPressedRef.current) return;
        if (preventContextMenuOnLongPress) (_a = event.preventDefault) === null || _a === void 0 || _a.call(event);
    };
    var handleEvents = function(node, unsubscribe) {
        if (unsubscribe === void 0) unsubscribe = false;
        node.oncontextmenu = unsubscribe ? null : preventContextMenu;
        var fn = unsubscribe ? node.removeEventListener.bind(node) : node.addEventListener.bind(node);
        fn("mousedown", startLongPress);
        fn("touchstart", startLongPress);
        fn("mousemove", preventLongPress);
        fn("touchmove", preventLongPress);
        fn("mouseup", stopLongPress);
        fn("mouseleave", stopLongPress);
        fn("touchend", stopLongPress);
    };
    var subscriber = function(node) {
        handleEvents(node);
        return function() {
            return void handleEvents(node, true);
        };
    };
    var registerNode = (0, $3FRCC.default)(subscriber);
    $acw62.useEffect(function() {
        return function() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    return {
        registerNode: registerNode
    };
};
var $a25743eeb178c628$export$2e2bcd8739ae039 = $a25743eeb178c628$var$useLongPress;

});
parcelRegister("5bibj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5c1546bd02a880$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $3c5c1546bd02a880$var$useGetLatest = function(value) {
    var ref = $acw62.useRef(value);
    $acw62.useEffect(function() {
        return void (ref.current = value);
    });
    return ref;
};
var $3c5c1546bd02a880$export$2e2bcd8739ae039 = $3c5c1546bd02a880$var$useGetLatest;

});

parcelRegister("3FRCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2acecba0242266b1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $2acecba0242266b1$var$useRegisterNodeRef = function(callback, deps) {
    if (deps === void 0) deps = [];
    var cleanupRef = $acw62.useRef(null);
    var registerRef = $acw62.useCallback(function(node) {
        if (cleanupRef.current !== null) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (node) {
            var cleanup = callback(node);
            if (cleanup) cleanupRef.current = cleanup;
            else cleanupRef.current = null;
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    return registerRef;
};
var $2acecba0242266b1$export$2e2bcd8739ae039 = $2acecba0242266b1$var$useRegisterNodeRef;

});


parcelRegister("82Jpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $37725514f612d091$export$2e2bcd8739ae039);
/**
 * simplebar-react - v3.2.4
 * React component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat
 * Under MIT License
 */ 
var $acw62 = parcelRequire("acw62");

var $j5vru = parcelRequire("j5vru");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $37725514f612d091$var$__assign = function() {
    $37725514f612d091$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37725514f612d091$var$__assign.apply(this, arguments);
};
function $37725514f612d091$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $37725514f612d091$export$2e2bcd8739ae039 = $acw62.forwardRef(function(_a, ref) {
    var children = _a.children, _b = _a.scrollableNodeProps, scrollableNodeProps = _b === void 0 ? {} : _b, otherProps = $37725514f612d091$var$__rest(_a, [
        "children",
        "scrollableNodeProps"
    ]);
    var elRef = $acw62.useRef();
    var scrollableNodeRef = $acw62.useRef();
    var contentNodeRef = $acw62.useRef();
    var options = {};
    var rest = {};
    Object.keys(otherProps).forEach(function(key) {
        if (Object.prototype.hasOwnProperty.call((0, $j5vru.default).defaultOptions, key)) options[key] = otherProps[key];
        else rest[key] = otherProps[key];
    });
    var classNames = $37725514f612d091$var$__assign($37725514f612d091$var$__assign({}, (0, $j5vru.default).defaultOptions.classNames), options.classNames);
    var scrollableNodeFullProps = $37725514f612d091$var$__assign($37725514f612d091$var$__assign({}, scrollableNodeProps), {
        className: "".concat(classNames.contentWrapper).concat(scrollableNodeProps.className ? " ".concat(scrollableNodeProps.className) : ""),
        tabIndex: 0,
        role: "region",
        "aria-label": options.ariaLabel || (0, $j5vru.default).defaultOptions.ariaLabel
    });
    $acw62.useEffect(function() {
        var instance;
        scrollableNodeRef.current = scrollableNodeFullProps.ref ? scrollableNodeFullProps.ref.current : scrollableNodeRef.current;
        if (elRef.current) {
            instance = new (0, $j5vru.default)(elRef.current, $37725514f612d091$var$__assign($37725514f612d091$var$__assign($37725514f612d091$var$__assign({}, options), scrollableNodeRef.current && {
                scrollableNode: scrollableNodeRef.current
            }), contentNodeRef.current && {
                contentNode: contentNodeRef.current
            }));
            if (typeof ref === "function") ref(instance);
            else if (ref) ref.current = instance;
        }
        return function() {
            instance === null || instance === void 0 || instance.unMount();
            instance = null;
            if (typeof ref === "function") ref(null);
        };
    }, []);
    return $acw62.createElement("div", $37725514f612d091$var$__assign({
        "data-simplebar": "init",
        ref: elRef
    }, rest), $acw62.createElement("div", {
        className: classNames.wrapper
    }, $acw62.createElement("div", {
        className: classNames.heightAutoObserverWrapperEl
    }, $acw62.createElement("div", {
        className: classNames.heightAutoObserverEl
    })), $acw62.createElement("div", {
        className: classNames.mask
    }, $acw62.createElement("div", {
        className: classNames.offset
    }, typeof children === "function" ? children({
        scrollableNodeRef: scrollableNodeRef,
        scrollableNodeProps: $37725514f612d091$var$__assign($37725514f612d091$var$__assign({}, scrollableNodeFullProps), {
            ref: scrollableNodeRef
        }),
        contentNodeRef: contentNodeRef,
        contentNodeProps: {
            className: classNames.contentEl,
            ref: contentNodeRef
        }
    }) : $acw62.createElement("div", $37725514f612d091$var$__assign({}, scrollableNodeFullProps), $acw62.createElement("div", {
        className: classNames.contentEl
    }, children)))), $acw62.createElement("div", {
        className: classNames.placeholder
    })), $acw62.createElement("div", {
        className: "".concat(classNames.track, " simplebar-horizontal")
    }, $acw62.createElement("div", {
        className: classNames.scrollbar
    })), $acw62.createElement("div", {
        className: "".concat(classNames.track, " simplebar-vertical")
    }, $acw62.createElement("div", {
        className: classNames.scrollbar
    })));
});
$37725514f612d091$export$2e2bcd8739ae039.displayName = "SimpleBar";

});
parcelRegister("j5vru", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a417f77a944e031$export$2e2bcd8739ae039);
/**
 * simplebar-core - v1.2.4
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ 
var $dPIJZ = parcelRequire("dPIJZ");
var $2f2C0 = parcelRequire("2f2C0");

var $l9KfY = parcelRequire("l9KfY");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $6a417f77a944e031$var$__assign = function() {
    $6a417f77a944e031$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a417f77a944e031$var$__assign.apply(this, arguments);
};
var $6a417f77a944e031$var$cachedScrollbarWidth = null;
var $6a417f77a944e031$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($l9KfY))) window.addEventListener("resize", function() {
    if ($6a417f77a944e031$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $6a417f77a944e031$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $6a417f77a944e031$var$cachedScrollbarWidth = null;
    }
});
function $6a417f77a944e031$var$scrollbarWidth() {
    if ($6a417f77a944e031$var$cachedScrollbarWidth === null) {
        if (typeof document === "undefined") {
            $6a417f77a944e031$var$cachedScrollbarWidth = 0;
            return $6a417f77a944e031$var$cachedScrollbarWidth;
        }
        var body = document.body;
        var box = document.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $6a417f77a944e031$var$cachedScrollbarWidth = width;
    }
    return $6a417f77a944e031$var$cachedScrollbarWidth;
}
function $6a417f77a944e031$var$getElementWindow$1(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $6a417f77a944e031$var$getElementDocument$1(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
// Helper function to retrieve options from element attributes
var $6a417f77a944e031$var$getOptions$1 = function(obj) {
    var initialObj = {};
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(_, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, initialObj);
    return options;
};
function $6a417f77a944e031$var$addClasses$1(el, classes) {
    var _a;
    if (!el) return;
    (_a = el.classList).add.apply(_a, classes.split(" "));
}
function $6a417f77a944e031$var$removeClasses$1(el, classes) {
    if (!el) return;
    classes.split(" ").forEach(function(className) {
        el.classList.remove(className);
    });
}
function $6a417f77a944e031$var$classNamesToQuery$1(classNames) {
    return ".".concat(classNames.split(" ").join("."));
}
var $6a417f77a944e031$var$helpers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getElementWindow: $6a417f77a944e031$var$getElementWindow$1,
    getElementDocument: $6a417f77a944e031$var$getElementDocument$1,
    getOptions: $6a417f77a944e031$var$getOptions$1,
    addClasses: $6a417f77a944e031$var$addClasses$1,
    removeClasses: $6a417f77a944e031$var$removeClasses$1,
    classNamesToQuery: $6a417f77a944e031$var$classNamesToQuery$1
});
var $6a417f77a944e031$var$getElementWindow = $6a417f77a944e031$var$getElementWindow$1, $6a417f77a944e031$var$getElementDocument = $6a417f77a944e031$var$getElementDocument$1, $6a417f77a944e031$var$getOptions = $6a417f77a944e031$var$getOptions$1, $6a417f77a944e031$var$addClasses = $6a417f77a944e031$var$addClasses$1, $6a417f77a944e031$var$removeClasses = $6a417f77a944e031$var$removeClasses$1, $6a417f77a944e031$var$classNamesToQuery = $6a417f77a944e031$var$classNamesToQuery$1;
var $6a417f77a944e031$export$2e2bcd8739ae039 = /** @class */ function() {
    function SimpleBarCore(element, options) {
        if (options === void 0) options = {};
        var _this = this;
        this.removePreventClickId = null;
        this.minScrollbarWidth = 20;
        this.stopScrollDelay = 175;
        this.isScrolling = false;
        this.isMouseEntering = false;
        this.scrollXTicking = false;
        this.scrollYTicking = false;
        this.wrapperEl = null;
        this.contentWrapperEl = null;
        this.contentEl = null;
        this.offsetEl = null;
        this.maskEl = null;
        this.placeholderEl = null;
        this.heightAutoObserverWrapperEl = null;
        this.heightAutoObserverEl = null;
        this.rtlHelpers = null;
        this.scrollbarWidth = 0;
        this.resizeObserver = null;
        this.mutationObserver = null;
        this.elStyles = null;
        this.isRtl = null;
        this.mouseX = 0;
        this.mouseY = 0;
        this.onMouseMove = function() {};
        this.onWindowResize = function() {};
        this.onStopScrolling = function() {};
        this.onMouseEntered = function() {};
        /**
         * On scroll event handling
         */ this.onScroll = function() {
            var elWindow = $6a417f77a944e031$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
            if (!_this.isScrolling) {
                _this.isScrolling = true;
                $6a417f77a944e031$var$addClasses(_this.el, _this.classNames.scrolling);
            }
            _this.showScrollbar("x");
            _this.showScrollbar("y");
            _this.onStopScrolling();
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) _this.positionScrollbar("x");
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) _this.positionScrollbar("y");
            _this.scrollYTicking = false;
        };
        this._onStopScrolling = function() {
            $6a417f77a944e031$var$removeClasses(_this.el, _this.classNames.scrolling);
            if (_this.options.autoHide) {
                _this.hideScrollbar("x");
                _this.hideScrollbar("y");
            }
            _this.isScrolling = false;
        };
        this.onMouseEnter = function() {
            if (!_this.isMouseEntering) {
                $6a417f77a944e031$var$addClasses(_this.el, _this.classNames.mouseEntered);
                _this.showScrollbar("x");
                _this.showScrollbar("y");
                _this.isMouseEntering = true;
            }
            _this.onMouseEntered();
        };
        this._onMouseEntered = function() {
            $6a417f77a944e031$var$removeClasses(_this.el, _this.classNames.mouseEntered);
            if (_this.options.autoHide) {
                _this.hideScrollbar("x");
                _this.hideScrollbar("y");
            }
            _this.isMouseEntering = false;
        };
        this._onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this._onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.onPointerEvent = function(e) {
            if (!_this.axis.x.track.el || !_this.axis.y.track.el || !_this.axis.x.scrollbar.el || !_this.axis.y.scrollbar.el) return;
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
            // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Prevent event leaking
                e.stopPropagation();
                if (e.type === "pointerdown" && e.pointerType !== "touch") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        /**
         * Drag scrollbar handle
         */ this.drag = function(e) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (!_this.draggedAxis || !_this.contentWrapperEl) return;
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = (_b = (_a = track.rect) === null || _a === void 0 ? void 0 : _a[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _b !== void 0 ? _b : 0;
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = (_d = (_c = _this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c[_this.axis[_this.draggedAxis].scrollSizeAttr]) !== null && _d !== void 0 ? _d : 0;
            var hostSize = parseInt((_f = (_e = _this.elStyles) === null || _e === void 0 ? void 0 : _e[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _f !== void 0 ? _f : "0px", 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
            // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - ((_h = (_g = track.rect) === null || _g === void 0 ? void 0 : _g[_this.axis[_this.draggedAxis].offsetAttr]) !== null && _h !== void 0 ? _h : 0) - _this.axis[_this.draggedAxis].dragOffset;
            dragPos = _this.draggedAxis === "x" && _this.isRtl ? ((_k = (_j = track.rect) === null || _j === void 0 ? void 0 : _j[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _k !== void 0 ? _k : 0) - scrollbar.size - dragPos : dragPos;
            // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size);
            // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize);
            // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x" && _this.isRtl) scrollPos = ((_l = SimpleBarCore.getRtlHelpers()) === null || _l === void 0 ? void 0 : _l.isScrollingToNegative) ? -scrollPos : scrollPos;
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        /**
         * End scroll handle drag
         */ this.onEndDrag = function(e) {
            var elDocument = $6a417f77a944e031$var$getElementDocument(_this.el);
            var elWindow = $6a417f77a944e031$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            $6a417f77a944e031$var$removeClasses(_this.el, _this.classNames.dragging);
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        /**
         * Handler to ignore click events during drag
         */ this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.options = $6a417f77a944e031$var$__assign($6a417f77a944e031$var$__assign({}, SimpleBarCore.defaultOptions), options);
        this.classNames = $6a417f77a944e031$var$__assign($6a417f77a944e031$var$__assign({}, SimpleBarCore.defaultOptions.classNames), options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                forceVisible: false,
                track: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                },
                scrollbar: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                }
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                forceVisible: false,
                track: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                },
                scrollbar: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                }
            }
        };
        if (typeof this.el !== "object" || !this.el.nodeName) throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));
        this.onMouseMove = (0, $2f2C0.default)(this._onMouseMove, 64);
        this.onWindowResize = (0, $dPIJZ.default)(this._onWindowResize, 64, {
            leading: true
        });
        this.onStopScrolling = (0, $dPIJZ.default)(this._onStopScrolling, this.stopScrollDelay);
        this.onMouseEntered = (0, $dPIJZ.default)(this._onMouseEntered, this.stopScrollDelay);
        this.init();
    }
    /**
     * Helper to fix browsers inconsistency on RTL:
     *  - Firefox inverts the scrollbar initial position
     *  - IE11 inverts both scrollbar position and scrolling offset
     * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
     */ SimpleBarCore.getRtlHelpers = function() {
        if (SimpleBarCore.rtlHelpers) return SimpleBarCore.rtlHelpers;
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="simplebar-dummy-scrollbar-size"><div></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        var dummyChild = scrollbarDummyEl === null || scrollbarDummyEl === void 0 ? void 0 : scrollbarDummyEl.firstElementChild;
        if (!dummyChild) return null;
        document.body.appendChild(scrollbarDummyEl);
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBarCore.getOffset(scrollbarDummyEl);
        var dummyChildOffset = SimpleBarCore.getOffset(dummyChild);
        scrollbarDummyEl.scrollLeft = -999;
        var dummyChildOffsetAfterScroll = SimpleBarCore.getOffset(dummyChild);
        document.body.removeChild(scrollbarDummyEl);
        SimpleBarCore.rtlHelpers = {
            // determines if the scrolling is responding with negative values
            isScrollOriginAtZero: dummyContainerOffset.left !== dummyChildOffset.left,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isScrollingToNegative: dummyChildOffset.left !== dummyChildOffsetAfterScroll.left
        };
        return SimpleBarCore.rtlHelpers;
    };
    SimpleBarCore.prototype.getScrollbarWidth = function() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (this.contentWrapperEl && getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $6a417f77a944e031$var$scrollbarWidth();
        } catch (e) {
            return $6a417f77a944e031$var$scrollbarWidth();
        }
    };
    SimpleBarCore.getOffset = function(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $6a417f77a944e031$var$getElementDocument(el);
        var elWindow = $6a417f77a944e031$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    SimpleBarCore.prototype.init = function() {
        // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($l9KfY))) {
            this.initDOM();
            this.rtlHelpers = SimpleBarCore.getRtlHelpers();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    SimpleBarCore.prototype.initDOM = function() {
        var _a, _b;
        // assume that element has his DOM already initiated
        this.wrapperEl = this.el.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.wrapper));
        this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.contentWrapper));
        this.contentEl = this.options.contentNode || this.el.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.contentEl));
        this.offsetEl = this.el.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.offset));
        this.maskEl = this.el.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.mask));
        this.placeholderEl = this.findChild(this.wrapperEl, $6a417f77a944e031$var$classNamesToQuery(this.classNames.placeholder));
        this.heightAutoObserverWrapperEl = this.el.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.heightAutoObserverWrapperEl));
        this.heightAutoObserverEl = this.el.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.heightAutoObserverEl));
        this.axis.x.track.el = this.findChild(this.el, "".concat($6a417f77a944e031$var$classNamesToQuery(this.classNames.track)).concat($6a417f77a944e031$var$classNamesToQuery(this.classNames.horizontal)));
        this.axis.y.track.el = this.findChild(this.el, "".concat($6a417f77a944e031$var$classNamesToQuery(this.classNames.track)).concat($6a417f77a944e031$var$classNamesToQuery(this.classNames.vertical)));
        this.axis.x.scrollbar.el = ((_a = this.axis.x.track.el) === null || _a === void 0 ? void 0 : _a.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.scrollbar))) || null;
        this.axis.y.scrollbar.el = ((_b = this.axis.y.track.el) === null || _b === void 0 ? void 0 : _b.querySelector($6a417f77a944e031$var$classNamesToQuery(this.classNames.scrollbar))) || null;
        if (!this.options.autoHide) {
            $6a417f77a944e031$var$addClasses(this.axis.x.scrollbar.el, this.classNames.visible);
            $6a417f77a944e031$var$addClasses(this.axis.y.scrollbar.el, this.classNames.visible);
        }
    };
    SimpleBarCore.prototype.initListeners = function() {
        var _this = this;
        var _a;
        var elWindow = $6a417f77a944e031$var$getElementWindow(this.el);
        // Event listeners
        this.el.addEventListener("mouseenter", this.onMouseEnter);
        this.el.addEventListener("pointerdown", this.onPointerEvent, true);
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        (_a = this.contentWrapperEl) === null || _a === void 0 || _a.addEventListener("scroll", this.onScroll);
        // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize);
        if (!this.contentEl) return;
        if (window.ResizeObserver) {
            // Hack for https://github.com/WICG/ResizeObserver/issues/38
            var resizeObserverStarted_1 = false;
            var resizeObserver = elWindow.ResizeObserver || ResizeObserver;
            this.resizeObserver = new resizeObserver(function() {
                if (!resizeObserverStarted_1) return;
                elWindow.requestAnimationFrame(function() {
                    _this.recalculate();
                });
            });
            this.resizeObserver.observe(this.el);
            this.resizeObserver.observe(this.contentEl);
            elWindow.requestAnimationFrame(function() {
                resizeObserverStarted_1 = true;
            });
        }
        // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(function() {
            elWindow.requestAnimationFrame(function() {
                _this.recalculate();
            });
        });
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    SimpleBarCore.prototype.recalculate = function() {
        if (!this.heightAutoObserverEl || !this.contentEl || !this.contentWrapperEl || !this.wrapperEl || !this.placeholderEl) return;
        var elWindow = $6a417f77a944e031$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1 || contentElOffsetWidth > 0;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = "".concat(this.elStyles.paddingTop, " ").concat(this.elStyles.paddingRight, " ").concat(this.elStyles.paddingBottom, " ").concat(this.elStyles.paddingLeft);
        this.wrapperEl.style.margin = "-".concat(this.elStyles.paddingTop, " -").concat(this.elStyles.paddingRight, " -").concat(this.elStyles.paddingBottom, " -").concat(this.elStyles.paddingLeft);
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%";
        // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? "".concat(contentElOffsetWidth || contentElScrollWidth, "px") : "auto";
        this.placeholderEl.style.height = "".concat(contentElScrollHeight, "px");
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElOffsetWidth !== 0 && contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight;
        // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar();
        // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        if (this.axis.x.scrollbar.el) this.axis.x.scrollbar.el.style.width = "".concat(this.axis.x.scrollbar.size, "px");
        if (this.axis.y.scrollbar.el) this.axis.y.scrollbar.el.style.height = "".concat(this.axis.y.scrollbar.size, "px");
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    };
    /**
     * Calculate scrollbar size
     */ SimpleBarCore.prototype.getScrollbarSize = function(axis) {
        var _a, _b;
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing || !this.contentEl) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = (_b = (_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) !== null && _b !== void 0 ? _b : 0;
        var scrollbarRatio = trackSize / contentSize;
        var scrollbarSize;
        // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    SimpleBarCore.prototype.positionScrollbar = function(axis) {
        var _a, _b, _c;
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar;
        if (!this.axis[axis].isOverflowing || !this.contentWrapperEl || !scrollbar.el || !this.elStyles) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = ((_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) || 0;
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && ((_b = SimpleBarCore.getRtlHelpers()) === null || _b === void 0 ? void 0 : _b.isScrollOriginAtZero) ? -scrollOffset : scrollOffset;
        if (axis === "x" && this.isRtl) scrollOffset = ((_c = SimpleBarCore.getRtlHelpers()) === null || _c === void 0 ? void 0 : _c.isScrollingToNegative) ? scrollOffset : -scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl ? -handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(".concat(handleOffset, "px, 0, 0)") : "translate3d(0, ".concat(handleOffset, "px, 0)");
    };
    SimpleBarCore.prototype.toggleTrackVisibility = function(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!track || !scrollbar || !this.contentWrapperEl) return;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
            this.el.classList.add("".concat(this.classNames.scrollable, "-").concat(axis));
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
            this.el.classList.remove("".concat(this.classNames.scrollable, "-").concat(axis));
        }
        // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    SimpleBarCore.prototype.showScrollbar = function(axis) {
        if (axis === void 0) axis = "y";
        if (this.axis[axis].isOverflowing && !this.axis[axis].scrollbar.isVisible) {
            $6a417f77a944e031$var$addClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
            this.axis[axis].scrollbar.isVisible = true;
        }
    };
    SimpleBarCore.prototype.hideScrollbar = function(axis) {
        if (axis === void 0) axis = "y";
        if (this.axis[axis].isOverflowing && this.axis[axis].scrollbar.isVisible) {
            $6a417f77a944e031$var$removeClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
            this.axis[axis].scrollbar.isVisible = false;
        }
    };
    SimpleBarCore.prototype.hideNativeScrollbar = function() {
        if (!this.offsetEl) return;
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px";
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px";
    };
    SimpleBarCore.prototype.onMouseMoveForAxis = function(axis) {
        if (axis === void 0) axis = "y";
        var currentAxis = this.axis[axis];
        if (!currentAxis.track.el || !currentAxis.scrollbar.el) return;
        currentAxis.track.rect = currentAxis.track.el.getBoundingClientRect();
        currentAxis.scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
        if (this.isWithinBounds(currentAxis.track.rect)) {
            this.showScrollbar(axis);
            $6a417f77a944e031$var$addClasses(currentAxis.track.el, this.classNames.hover);
            if (this.isWithinBounds(currentAxis.scrollbar.rect)) $6a417f77a944e031$var$addClasses(currentAxis.scrollbar.el, this.classNames.hover);
            else $6a417f77a944e031$var$removeClasses(currentAxis.scrollbar.el, this.classNames.hover);
        } else {
            $6a417f77a944e031$var$removeClasses(currentAxis.track.el, this.classNames.hover);
            if (this.options.autoHide) this.hideScrollbar(axis);
        }
    };
    SimpleBarCore.prototype.onMouseLeaveForAxis = function(axis) {
        if (axis === void 0) axis = "y";
        $6a417f77a944e031$var$removeClasses(this.axis[axis].track.el, this.classNames.hover);
        $6a417f77a944e031$var$removeClasses(this.axis[axis].scrollbar.el, this.classNames.hover);
        if (this.options.autoHide) this.hideScrollbar(axis);
    };
    /**
     * on scrollbar handle drag movement starts
     */ SimpleBarCore.prototype.onDragStart = function(e, axis) {
        var _a;
        if (axis === void 0) axis = "y";
        var elDocument = $6a417f77a944e031$var$getElementDocument(this.el);
        var elWindow = $6a417f77a944e031$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar;
        // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - (((_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) || 0);
        this.draggedAxis = axis;
        $6a417f77a944e031$var$addClasses(this.el, this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    };
    SimpleBarCore.prototype.onTrackClick = function(e, axis) {
        var _this = this;
        var _a, _b, _c, _d;
        if (axis === void 0) axis = "y";
        var currentAxis = this.axis[axis];
        if (!this.options.clickOnTrack || !currentAxis.scrollbar.el || !this.contentWrapperEl) return;
        // Preventing the event's default to trigger click underneath
        e.preventDefault();
        var elWindow = $6a417f77a944e031$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = (_b = (_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) !== null && _b !== void 0 ? _b : 0;
        var hostSize = parseInt((_d = (_c = this.elStyles) === null || _c === void 0 ? void 0 : _c[this.axis[axis].sizeAttr]) !== null && _d !== void 0 ? _d : "0px", 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var speed = 40;
        var scrollTo = function() {
            if (!_this.contentWrapperEl) return;
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    scrolled -= speed;
                    _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                scrolled += speed;
                _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    };
    /**
     * Getter for content element
     */ SimpleBarCore.prototype.getContentElement = function() {
        return this.contentEl;
    };
    /**
     * Getter for original scrolling element
     */ SimpleBarCore.prototype.getScrollElement = function() {
        return this.contentWrapperEl;
    };
    SimpleBarCore.prototype.removeListeners = function() {
        var elWindow = $6a417f77a944e031$var$getElementWindow(this.el);
        // Event listeners
        this.el.removeEventListener("mouseenter", this.onMouseEnter);
        this.el.removeEventListener("pointerdown", this.onPointerEvent, true);
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        // Cancel all debounced functions
        this.onMouseMove.cancel();
        this.onWindowResize.cancel();
        this.onStopScrolling.cancel();
        this.onMouseEntered.cancel();
    };
    /**
     * Remove all listeners from DOM nodes
     */ SimpleBarCore.prototype.unMount = function() {
        this.removeListeners();
    };
    /**
     * Check if mouse is within bounds
     */ SimpleBarCore.prototype.isWithinBounds = function(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    };
    /**
     * Find element children matches query
     */ SimpleBarCore.prototype.findChild = function(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    SimpleBarCore.rtlHelpers = null;
    SimpleBarCore.defaultOptions = {
        forceVisible: false,
        clickOnTrack: true,
        scrollbarMinSize: 25,
        scrollbarMaxSize: 0,
        ariaLabel: "scrollable content",
        classNames: {
            contentEl: "simplebar-content",
            contentWrapper: "simplebar-content-wrapper",
            offset: "simplebar-offset",
            mask: "simplebar-mask",
            wrapper: "simplebar-wrapper",
            placeholder: "simplebar-placeholder",
            scrollbar: "simplebar-scrollbar",
            track: "simplebar-track",
            heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
            heightAutoObserverEl: "simplebar-height-auto-observer",
            visible: "simplebar-visible",
            horizontal: "simplebar-horizontal",
            vertical: "simplebar-vertical",
            hover: "simplebar-hover",
            dragging: "simplebar-dragging",
            scrolling: "simplebar-scrolling",
            scrollable: "simplebar-scrollable",
            mouseEntered: "simplebar-mouse-entered"
        },
        scrollableNode: null,
        contentNode: null,
        autoHide: true
    };
    /**
     * Static functions
     */ SimpleBarCore.getOptions = $6a417f77a944e031$var$getOptions;
    SimpleBarCore.helpers = $6a417f77a944e031$var$helpers;
    return SimpleBarCore;
}();

});
parcelRegister("dPIJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a122be60491e8d4a$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $2OtHx = parcelRequire("2OtHx");

var $1fkDi = parcelRequire("1fkDi");
/** Error message constants. */ var $a122be60491e8d4a$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a122be60491e8d4a$var$nativeMax = Math.max, $a122be60491e8d4a$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a122be60491e8d4a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($a122be60491e8d4a$var$FUNC_ERROR_TEXT);
    wait = (0, $1fkDi.default)(wait) || 0;
    if ((0, $iYDsF.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $a122be60491e8d4a$var$nativeMax((0, $1fkDi.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a122be60491e8d4a$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $2OtHx.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $2OtHx.default)());
    }
    function debounced() {
        var time = (0, $2OtHx.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $a122be60491e8d4a$export$2e2bcd8739ae039 = $a122be60491e8d4a$var$debounce;

});
parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});

parcelRegister("2OtHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c74a585cb2c860$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $20c74a585cb2c860$var$now = function() {
    return (0, $2mpFt.default).Date.now();
};
var $20c74a585cb2c860$export$2e2bcd8739ae039 = $20c74a585cb2c860$var$now;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function("return this")();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("1fkDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e87326299eb9bb7$export$2e2bcd8739ae039);

var $8N45u = parcelRequire("8N45u");

var $iYDsF = parcelRequire("iYDsF");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $0e87326299eb9bb7$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0e87326299eb9bb7$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0e87326299eb9bb7$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0e87326299eb9bb7$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0e87326299eb9bb7$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0e87326299eb9bb7$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $1WN0o.default)(value)) return $0e87326299eb9bb7$var$NAN;
    if ((0, $iYDsF.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $iYDsF.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $8N45u.default)(value);
    var isBinary = $0e87326299eb9bb7$var$reIsBinary.test(value);
    return isBinary || $0e87326299eb9bb7$var$reIsOctal.test(value) ? $0e87326299eb9bb7$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0e87326299eb9bb7$var$reIsBadHex.test(value) ? $0e87326299eb9bb7$var$NAN : +value;
}
var $0e87326299eb9bb7$export$2e2bcd8739ae039 = $0e87326299eb9bb7$var$toNumber;

});
parcelRegister("8N45u", function(module, exports) {

$parcel$export(module.exports, "default", () => $66661208b19b5b1b$export$2e2bcd8739ae039);

var $iu14O = parcelRequire("iu14O");
/** Used to match leading whitespace. */ var $66661208b19b5b1b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $66661208b19b5b1b$var$baseTrim(string) {
    return string ? string.slice(0, (0, $iu14O.default)(string) + 1).replace($66661208b19b5b1b$var$reTrimStart, "") : string;
}
var $66661208b19b5b1b$export$2e2bcd8739ae039 = $66661208b19b5b1b$var$baseTrim;

});
parcelRegister("iu14O", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74bdd257728cf90$export$2e2bcd8739ae039);
/** Used to match a single whitespace character. */ var $d74bdd257728cf90$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d74bdd257728cf90$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d74bdd257728cf90$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d74bdd257728cf90$export$2e2bcd8739ae039 = $d74bdd257728cf90$var$trimmedEndIndex;

});


parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = "[object Null]", $ccdb19c7f0a62300$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});

parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});




parcelRegister("2f2C0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a1f02279ad00e7c$export$2e2bcd8739ae039);

var $dPIJZ = parcelRequire("dPIJZ");

var $iYDsF = parcelRequire("iYDsF");
/** Error message constants. */ var $1a1f02279ad00e7c$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $1a1f02279ad00e7c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($1a1f02279ad00e7c$var$FUNC_ERROR_TEXT);
    if ((0, $iYDsF.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $dPIJZ.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $1a1f02279ad00e7c$export$2e2bcd8739ae039 = $1a1f02279ad00e7c$var$throttle;

});

parcelRegister("l9KfY", function(module, exports) {
var $f66e51d1bd8869ea$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
module.exports = $f66e51d1bd8869ea$var$canUseDOM;

});



parcelRegister("apXAB", function(module, exports) {

$parcel$export(module.exports, "init", () => $795a7664e1a3c052$export$2cd8252107eb640b);

var $6zmxU = parcelRequire("6zmxU");

var $htFdx = parcelRequire("htFdx");
/**
 * Inits the React SDK
 */ function $795a7664e1a3c052$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $htFdx.applySdkMetadata)(opts, "react");
    (0, $6zmxU.init)(opts);
}

});
parcelRegister("6zmxU", function(module, exports) {

$parcel$export(module.exports, "init", () => $4c87801c815e53f1$export$2cd8252107eb640b);

var $b8438 = parcelRequire("b8438");
var $hKg1m = parcelRequire("hKg1m");
var $cmFjP = parcelRequire("cmFjP");
var $71tRZ = parcelRequire("71tRZ");
var $iDxMj = parcelRequire("iDxMj");
var $6jMsx = parcelRequire("6jMsx");
var $cCtO1 = parcelRequire("cCtO1");

var $3dtKS = parcelRequire("3dtKS");
var $4g0Ct = parcelRequire("4g0Ct");
var $16dZf = parcelRequire("16dZf");
var $esO9h = parcelRequire("esO9h");

var $gWrK2 = parcelRequire("gWrK2");

var $b7h0d = parcelRequire("b7h0d");

var $6JSNk = parcelRequire("6JSNk");

var $fxK4w = parcelRequire("fxK4w");

var $bMyDX = parcelRequire("bMyDX");

var $dw5F0 = parcelRequire("dw5F0");

var $efOBd = parcelRequire("efOBd");

var $9SQUp = parcelRequire("9SQUp");

var $llG7W = parcelRequire("llG7W");

var $9AlIt = parcelRequire("9AlIt");

var $cyjuS = parcelRequire("cyjuS");

var $c0B2u = parcelRequire("c0B2u");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $4c87801c815e53f1$export$5ef831fccfce35e5 = [
    (0, $6jMsx.inboundFiltersIntegration)(),
    (0, $hKg1m.functionToStringIntegration)(),
    (0, $llG7W.browserApiErrorsIntegration)(),
    (0, $fxK4w.breadcrumbsIntegration)(),
    (0, $dw5F0.globalHandlersIntegration)(),
    (0, $9SQUp.linkedErrorsIntegration)(),
    (0, $bMyDX.dedupeIntegration)(),
    (0, $efOBd.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $4c87801c815e53f1$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$4c87801c815e53f1$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4c87801c815e53f1$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4c87801c815e53f1$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $6JSNk.WINDOW).SENTRY_RELEASE && (0, $6JSNk.WINDOW).SENTRY_RELEASE.id) options.release = (0, $6JSNk.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $16dZf.stackParserFromStackParserOptions)(options.stackParser || (0, $9AlIt.defaultStackParser)),
        integrations: (0, $71tRZ.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $esO9h.supportsFetch)() ? (0, $cyjuS.makeFetchTransport) : (0, $c0B2u.makeXHRTransport))
    };
    (0, $cCtO1.initAndBind)((0, $gWrK2.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $4c87801c815e53f1$var$startSessionTracking();
}
const $4c87801c815e53f1$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $cmFjP.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $6JSNk.WINDOW).document) {
        (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $6JSNk.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $iDxMj.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $6JSNk.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $6JSNk.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $6JSNk.WINDOW).document.head || (0, $6JSNk.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4c87801c815e53f1$export$4997ffc0176396a6(fn) {
    return (0, $6JSNk.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4c87801c815e53f1$var$startSessionTracking() {
    if (typeof (0, $6JSNk.WINDOW).document === "undefined") {
        (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $b8438.startSession)({
        ignoreDuration: true
    });
    (0, $b8438.captureSession)();
    // We want to create a session for every navigation as well
    (0, $3dtKS.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $b8438.startSession)({
                ignoreDuration: true
            });
            (0, $b8438.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $4c87801c815e53f1$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $b8438.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("b8438", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $81a395368bb6f380$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $81a395368bb6f380$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "addBreadcrumb", () => $81a395368bb6f380$export$efda9a273d7a036d);
$parcel$export(module.exports, "withScope", () => $81a395368bb6f380$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $81a395368bb6f380$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $81a395368bb6f380$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "startSession", () => $81a395368bb6f380$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $81a395368bb6f380$export$667e7b4d445d566b);

var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");

var $kfXMR = parcelRequire("kfXMR");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $oyvka = parcelRequire("oyvka");

var $az0Em = parcelRequire("az0Em");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $81a395368bb6f380$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().captureException(exception, (0, $az0Em.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $81a395368bb6f380$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $81a395368bb6f380$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ function $81a395368bb6f380$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $81a395368bb6f380$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81a395368bb6f380$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $81a395368bb6f380$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $81a395368bb6f380$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $81a395368bb6f380$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $81a395368bb6f380$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $81a395368bb6f380$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $81a395368bb6f380$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $81a395368bb6f380$export$9a4fed82c350c2bd(callback) {
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return callback((0, $cmFjP.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $81a395368bb6f380$export$e57ac09b143d92a2(span, callback) {
    return $81a395368bb6f380$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $81a395368bb6f380$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (!client) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $b1E2c.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $81a395368bb6f380$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $cvSY8.timestampInSeconds)();
    function finishCheckIn(status) {
        $81a395368bb6f380$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $cvSY8.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $2zW56.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$4909b86c8034bf73(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$8360e631d277ea4d(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $81a395368bb6f380$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $81a395368bb6f380$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $81a395368bb6f380$export$3f95c6f800b78024() {
    return !!$81a395368bb6f380$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $81a395368bb6f380$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $81a395368bb6f380$export$c0d84948cecf78d8(context) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $kfXMR.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $3bpJ1.GLOBAL_OBJ).navigator || {};
    const session = (0, $oyvka.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $oyvka.updateSession)(currentSession, {
        status: "exited"
    });
    $81a395368bb6f380$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $81a395368bb6f380$export$17a5be43989a0bc1() {
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $oyvka.closeSession)(session);
    $81a395368bb6f380$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $81a395368bb6f380$var$_sendSessionUpdate() {
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $81a395368bb6f380$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $81a395368bb6f380$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $81a395368bb6f380$var$_sendSessionUpdate();
}

});
parcelRegister("3bpJ1", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $25165aaf01761cfd$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $25165aaf01761cfd$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $25165aaf01761cfd$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $25165aaf01761cfd$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $25165aaf01761cfd$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $25165aaf01761cfd$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $25165aaf01761cfd$var$isGlobalObj(window) || typeof self == "object" && $25165aaf01761cfd$var$isGlobalObj(self) || typeof $parcel$global == "object" && $25165aaf01761cfd$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $25165aaf01761cfd$export$256479dc0cea61c4() {
    return $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $25165aaf01761cfd$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $25165aaf01761cfd$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("2zW56", function(module, exports) {

$parcel$export(module.exports, "isError", () => $1e0be767ffa822d8$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $1e0be767ffa822d8$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $1e0be767ffa822d8$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $1e0be767ffa822d8$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $1e0be767ffa822d8$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $1e0be767ffa822d8$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $1e0be767ffa822d8$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $1e0be767ffa822d8$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $1e0be767ffa822d8$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $1e0be767ffa822d8$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $1e0be767ffa822d8$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $1e0be767ffa822d8$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $1e0be767ffa822d8$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $1e0be767ffa822d8$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $1e0be767ffa822d8$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $1e0be767ffa822d8$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $1e0be767ffa822d8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$e6127cc7fe7395c3(wat) {
    switch($1e0be767ffa822d8$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $1e0be767ffa822d8$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$var$isBuiltin(wat, className) {
    return $1e0be767ffa822d8$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9f9636d330b71954(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$ef9e2056653f0c8e(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$12e869b2a583f783(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$844ec244b1367d54(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c3825b437cbdea5c(wat) {
    return wat === null || $1e0be767ffa822d8$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49841c62b9eff15(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1e0be767ffa822d8$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$bc2894c7158efbac(wat) {
    return $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("4g0Ct", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $3199231328e69de5$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $3199231328e69de5$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $3199231328e69de5$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $3199231328e69de5$export$af88d00dbe7f521);

var $eKZKa = parcelRequire("eKZKa");

var $3bpJ1 = parcelRequire("3bpJ1");
/** Prefix for logging strings */ const $3199231328e69de5$var$PREFIX = "Sentry Logger ";
const $3199231328e69de5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $3199231328e69de5$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3199231328e69de5$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $3bpJ1.GLOBAL_OBJ))) return callback();
    const console = (0, $3bpJ1.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($3199231328e69de5$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $3199231328e69de5$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $3199231328e69de5$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $eKZKa.DEBUG_BUILD) $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $3199231328e69de5$export$cda52e2a8927a2ca(()=>{
                (0, $3bpJ1.GLOBAL_OBJ).console[name](`${$3199231328e69de5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $3199231328e69de5$export$af88d00dbe7f521 = $3199231328e69de5$var$makeLogger();

});
parcelRegister("eKZKa", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $abe5418a531ee1d6$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $abe5418a531ee1d6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("cvSY8", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $91c304fc757d5e0f$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $91c304fc757d5e0f$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $91c304fc757d5e0f$export$baf075a948ffc0bf);

var $3bpJ1 = parcelRequire("3bpJ1");
const $91c304fc757d5e0f$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $91c304fc757d5e0f$export$7740643b9eeaf0c4() {
    return Date.now() / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $3bpJ1.GLOBAL_OBJ);
    if (!performance || !performance.now) return $91c304fc757d5e0f$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $91c304fc757d5e0f$export$ee52dced521e3e18 = $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $91c304fc757d5e0f$export$c5907b5a8838db13 = $91c304fc757d5e0f$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $91c304fc757d5e0f$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $91c304fc757d5e0f$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $3bpJ1.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $91c304fc757d5e0f$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $91c304fc757d5e0f$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("b1E2c", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $806ed7b2edb8ea09$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $806ed7b2edb8ea09$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $806ed7b2edb8ea09$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $806ed7b2edb8ea09$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $806ed7b2edb8ea09$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $806ed7b2edb8ea09$export$3131421a7d01b4fb);

var $jL8lq = parcelRequire("jL8lq");

var $91U3U = parcelRequire("91U3U");

var $3bpJ1 = parcelRequire("3bpJ1");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $806ed7b2edb8ea09$export$19f53698e68b2496() {
    const gbl = (0, $3bpJ1.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $806ed7b2edb8ea09$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $806ed7b2edb8ea09$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $806ed7b2edb8ea09$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $806ed7b2edb8ea09$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $806ed7b2edb8ea09$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $806ed7b2edb8ea09$export$d364f2020ab30578(input) {
    const match = input.match($806ed7b2edb8ea09$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $806ed7b2edb8ea09$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $91U3U.snipLine)(line, 0));
    frame.context_line = (0, $91U3U.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $91U3U.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $806ed7b2edb8ea09$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $jL8lq.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $806ed7b2edb8ea09$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("jL8lq", function(module, exports) {

$parcel$export(module.exports, "fill", () => $e628e125e878fd27$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $e628e125e878fd27$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $e628e125e878fd27$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $e628e125e878fd27$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $e628e125e878fd27$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $e628e125e878fd27$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $e628e125e878fd27$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $e628e125e878fd27$export$d25f2688db1bb433);

var $ibKgU = parcelRequire("ibKgU");

var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");

var $91U3U = parcelRequire("91U3U");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e628e125e878fd27$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e628e125e878fd27$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $e628e125e878fd27$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e628e125e878fd27$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e628e125e878fd27$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e628e125e878fd27$export$62ff257738bf57f5(value) {
    if ((0, $2zW56.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e628e125e878fd27$var$getOwnProperties(value)
    };
    else if ((0, $2zW56.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $e628e125e878fd27$var$serializeEventTarget(value.target),
            currentTarget: $e628e125e878fd27$var$serializeEventTarget(value.currentTarget),
            ...$e628e125e878fd27$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $2zW56.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e628e125e878fd27$var$serializeEventTarget(target) {
    try {
        return (0, $2zW56.isElement)(target) ? (0, $ibKgU.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $e628e125e878fd27$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e628e125e878fd27$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($e628e125e878fd27$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $91U3U.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $91U3U.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e628e125e878fd27$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($e628e125e878fd27$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $e628e125e878fd27$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e628e125e878fd27$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $e628e125e878fd27$var$isPojo(input) {
    if (!(0, $2zW56.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e628e125e878fd27$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2zW56.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("ibKgU", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $d3dd25a69ce66c78$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $d3dd25a69ce66c78$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $d3dd25a69ce66c78$export$c660c1f3ab49225c);
$parcel$export(module.exports, "getComponentName", () => $d3dd25a69ce66c78$export$26727cfcc4d7e0fc);

var $2zW56 = parcelRequire("2zW56");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $d3dd25a69ce66c78$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
const $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d3dd25a69ce66c78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($d3dd25a69ce66c78$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $2zW56.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $d3dd25a69ce66c78$export$1cfafeee2987818b() {
    try {
        return $d3dd25a69ce66c78$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d3dd25a69ce66c78$export$c660c1f3ab49225c(selector) {
    if ($d3dd25a69ce66c78$var$WINDOW.document && $d3dd25a69ce66c78$var$WINDOW.document.querySelector) return $d3dd25a69ce66c78$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $d3dd25a69ce66c78$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$d3dd25a69ce66c78$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("91U3U", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $692fb1c9fae23fc3$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $692fb1c9fae23fc3$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $692fb1c9fae23fc3$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $692fb1c9fae23fc3$export$a7a5ec66062ea5d);

var $2zW56 = parcelRequire("2zW56");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $692fb1c9fae23fc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $2zW56.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $692fb1c9fae23fc3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $2zW56.isString)(value)) return false;
    if ((0, $2zW56.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $2zW56.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $692fb1c9fae23fc3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$692fb1c9fae23fc3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("kfXMR", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $ebf395d8a45b5e48$export$849dbeeeda01ae98);
const $ebf395d8a45b5e48$export$849dbeeeda01ae98 = "production";

});

parcelRegister("8IHa9", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $6593ea065203555e$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6593ea065203555e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("cmFjP", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $9007972943bbf579$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $9007972943bbf579$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $9007972943bbf579$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $9007972943bbf579$export$70d775fb1f267027);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $b1E2c = parcelRequire("b1E2c");

var $kfXMR = parcelRequire("kfXMR");

var $8IHa9 = parcelRequire("8IHa9");

var $coQoV = parcelRequire("coQoV");

var $oyvka = parcelRequire("oyvka");

var $9OAWn = parcelRequire("9OAWn");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9007972943bbf579$export$24a86ef7798177e4 = parseFloat((0, $9OAWn.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9007972943bbf579$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $9007972943bbf579$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $9007972943bbf579$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $coQoV.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $coQoV.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $2zW56.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9007972943bbf579$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $cvSY8.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $4g0Ct.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $9007972943bbf579$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $9007972943bbf579$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $8IHa9.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $4g0Ct.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $4g0Ct.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $oyvka.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $kfXMR.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $3bpJ1.GLOBAL_OBJ).navigator || {};
        const session = (0, $oyvka.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $oyvka.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9007972943bbf579$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9007972943bbf579$export$19eade501500c6c1() {
    (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ = (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $3bpJ1.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ function $9007972943bbf579$export$4188a14ad302d1bc(hub) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    const oldHub = $9007972943bbf579$export$bfa8a924a84a76b7(registry);
    $9007972943bbf579$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ function $9007972943bbf579$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9007972943bbf579$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $9007972943bbf579$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $9007972943bbf579$export$a07cdf6544bbd7c().getIsolationScope();
}
function $9007972943bbf579$var$getGlobalHub(registry = $9007972943bbf579$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(registry).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$849f05434e95d2f2(registry, new $9007972943bbf579$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $9007972943bbf579$export$236689a79f5aa020(carrier, parent = $9007972943bbf579$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(carrier).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $9007972943bbf579$export$849f05434e95d2f2(carrier, new $9007972943bbf579$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9007972943bbf579$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9007972943bbf579$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9007972943bbf579$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $9007972943bbf579$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $3bpJ1.getGlobalSingleton)("hub", ()=>new $9007972943bbf579$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $9007972943bbf579$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("coQoV", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $90705fab783f17f9$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $90705fab783f17f9$export$aa55d5ab8e05984f);

var $cvSY8 = parcelRequire("cvSY8");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $b1E2c = parcelRequire("b1E2c");

var $6T4Sa = parcelRequire("6T4Sa");

var $oyvka = parcelRequire("oyvka");

var $8ltoy = parcelRequire("8ltoy");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $90705fab783f17f9$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $90705fab783f17f9$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $90705fab783f17f9$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $90705fab783f17f9$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $oyvka.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   * @deprecated Use extra or tags instead.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $90705fab783f17f9$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $2zW56.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $cvSY8.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $8ltoy.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $6T4Sa.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $6T4Sa.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!this._client) {
            (0, $4g0Ct.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!this._client) {
            (0, $4g0Ct.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!this._client) {
            (0, $4g0Ct.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $90705fab783f17f9$export$aa55d5ab8e05984f() {
    if (!$90705fab783f17f9$var$globalScope) $90705fab783f17f9$var$globalScope = new $90705fab783f17f9$export$775b6bb06e53a214();
    return $90705fab783f17f9$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $90705fab783f17f9$export$c83048efd17527d6(scope) {
    $90705fab783f17f9$var$globalScope = scope;
}
function $90705fab783f17f9$var$generatePropagationContext() {
    return {
        traceId: (0, $b1E2c.uuid4)(),
        spanId: (0, $b1E2c.uuid4)().substring(16)
    };
}

});
parcelRegister("6T4Sa", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", () => $503ba8c00efa1d46$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $503ba8c00efa1d46$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $503ba8c00efa1d46$export$bf2a096c3e883e79);

var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");

var $8IHa9 = parcelRequire("8IHa9");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$3c4238858b85e8ac() {
    return (0, $3bpJ1.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $503ba8c00efa1d46$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $8IHa9.DEBUG_BUILD) && processor.id && result === null && (0, $4g0Ct.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $2zW56.isThenable)(result)) result.then((final)=>$503ba8c00efa1d46$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("j3a3y", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $dde6191ffa17294f$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $dde6191ffa17294f$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $dde6191ffa17294f$export$78e43115b553f358);

var $2zW56 = parcelRequire("2zW56");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $dde6191ffa17294f$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($dde6191ffa17294f$var$States || ($dde6191ffa17294f$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $dde6191ffa17294f$export$1fda8aa4d135f8aa(value) {
    return new $dde6191ffa17294f$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $dde6191ffa17294f$export$78e43115b553f358(reason) {
    return new $dde6191ffa17294f$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $dde6191ffa17294f$export$6f292d4960313241 {
    constructor(executor){
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init2.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init3.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $dde6191ffa17294f$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($dde6191ffa17294f$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($dde6191ffa17294f$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $dde6191ffa17294f$var$States.PENDING) return;
            if ((0, $2zW56.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $dde6191ffa17294f$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $dde6191ffa17294f$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $dde6191ffa17294f$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("oyvka", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $049d01d3a3164ac2$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $049d01d3a3164ac2$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $049d01d3a3164ac2$export$56521d9ba90f62ee);

var $jL8lq = parcelRequire("jL8lq");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $049d01d3a3164ac2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $cvSY8.timestampInSeconds)();
    const session = {
        sid: (0, $b1E2c.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$049d01d3a3164ac2$var$sessionToJSON(session)
    };
    if (context) $049d01d3a3164ac2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $049d01d3a3164ac2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $cvSY8.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $b1E2c.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $049d01d3a3164ac2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $049d01d3a3164ac2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $049d01d3a3164ac2$var$sessionToJSON(session) {
    return (0, $jL8lq.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("8ltoy", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $613716288721a3ee$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $613716288721a3ee$export$25ac7e259a513db4);

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");

var $bPHT6 = parcelRequire("bPHT6");

var $ga8Oo = parcelRequire("ga8Oo");

var $jfPQV = parcelRequire("jfPQV");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $613716288721a3ee$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $613716288721a3ee$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $613716288721a3ee$var$applySpanToEvent(event, span);
    $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint);
    $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $613716288721a3ee$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $613716288721a3ee$export$b1a120a2871faa46(data, "extra", extra);
    $613716288721a3ee$export$b1a120a2871faa46(data, "tags", tags);
    $613716288721a3ee$export$b1a120a2871faa46(data, "user", user);
    $613716288721a3ee$export$b1a120a2871faa46(data, "contexts", contexts);
    $613716288721a3ee$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $613716288721a3ee$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $613716288721a3ee$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $jL8lq.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $jL8lq.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $jL8lq.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $jL8lq.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $613716288721a3ee$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $jfPQV.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $ga8Oo.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $bPHT6.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $jfPQV.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $b1E2c.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("bPHT6", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $89d6805454b84092$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $89d6805454b84092$export$a117f995597e25df);

var $jL8lq = parcelRequire("jL8lq");

var $kfXMR = parcelRequire("kfXMR");

var $b8438 = parcelRequire("b8438");

var $ga8Oo = parcelRequire("ga8Oo");

var $jfPQV = parcelRequire("jfPQV");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $89d6805454b84092$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $jL8lq.dropUndefinedKeys)({
        environment: options.environment || (0, $kfXMR.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $89d6805454b84092$export$a117f995597e25df(span) {
    const client = (0, $b8438.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $89d6805454b84092$export$366bad00d6815eed((0, $jfPQV.spanToJSON)(span).trace_id || "", client, (0, $b8438.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $ga8Oo.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $jfPQV.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $jfPQV.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("ga8Oo", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", () => $bc446a546b963a28$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $bc446a546b963a28$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("jfPQV", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $e047a3e652f57c75$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $e047a3e652f57c75$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTraceContext", () => $e047a3e652f57c75$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $e047a3e652f57c75$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceHeader", () => $e047a3e652f57c75$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $e047a3e652f57c75$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $e047a3e652f57c75$export$3f7581298f56c6d7);

var $jL8lq = parcelRequire("jL8lq");
var $65HJt = parcelRequire("65HJt");
var $cvSY8 = parcelRequire("cvSY8");
// These are aligned with OpenTelemetry trace flags
const $e047a3e652f57c75$export$208d5b368507fb8b = 0x0;
const $e047a3e652f57c75$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $e047a3e652f57c75$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $e047a3e652f57c75$export$92d8c23565496537(span);
    return (0, $jL8lq.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $e047a3e652f57c75$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $e047a3e652f57c75$export$5caecac1caaf3a71(span);
    return (0, $65HJt.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $e047a3e652f57c75$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $e047a3e652f57c75$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $e047a3e652f57c75$var$ensureTimestampInSeconds(input.getTime());
    return (0, $cvSY8.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $e047a3e652f57c75$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $e047a3e652f57c75$export$92d8c23565496537(span) {
    if ($e047a3e652f57c75$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $e047a3e652f57c75$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $e047a3e652f57c75$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $e047a3e652f57c75$export$eb571cd9b5d98de8);
}

});
parcelRegister("65HJt", function(module, exports) {

$parcel$export(module.exports, "extractTraceparentData", () => $46f5220cb64aa700$export$8e9a29865c0a1226);
$parcel$export(module.exports, "tracingContextFromHeaders", () => $46f5220cb64aa700$export$ca5c066532785b6e);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $46f5220cb64aa700$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $46f5220cb64aa700$export$f35d907436da45cf);

var $dzA7g = parcelRequire("dzA7g");

var $b1E2c = parcelRequire("b1E2c");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $46f5220cb64aa700$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $46f5220cb64aa700$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($46f5220cb64aa700$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $46f5220cb64aa700$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dzA7g.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $b1E2c.uuid4)(),
            spanId: (0, $b1E2c.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $b1E2c.uuid4)(),
            parentSpanId: parentSpanId || (0, $b1E2c.uuid4)().substring(16),
            spanId: (0, $b1E2c.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $46f5220cb64aa700$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dzA7g.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $b1E2c.uuid4)(),
        spanId: (0, $b1E2c.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $b1E2c.uuid4)(),
        parentSpanId: parentSpanId || (0, $b1E2c.uuid4)().substring(16),
        spanId: (0, $b1E2c.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $46f5220cb64aa700$export$f35d907436da45cf(traceId = (0, $b1E2c.uuid4)(), spanId = (0, $b1E2c.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("dzA7g", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $9e1a8f302f19c673$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $9e1a8f302f19c673$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $9e1a8f302f19c673$export$56766feef403f365);

var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");
const $9e1a8f302f19c673$export$9ca9946bd449ac06 = "baggage";
const $9e1a8f302f19c673$export$6e69537d67fa20f = "sentry-";
const $9e1a8f302f19c673$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $9e1a8f302f19c673$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $9e1a8f302f19c673$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $2zW56.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($9e1a8f302f19c673$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($9e1a8f302f19c673$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $9e1a8f302f19c673$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$9e1a8f302f19c673$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $9e1a8f302f19c673$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $9e1a8f302f19c673$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $9e1a8f302f19c673$export$bdd844ddb2def819) {
            (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});






parcelRegister("9OAWn", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $725570364ca356d5$export$31499a9cd224b78c);
const $725570364ca356d5$export$31499a9cd224b78c = "7.104.0";

});


parcelRegister("az0Em", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $7b0dad5cf366cc16$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $7b0dad5cf366cc16$export$76b5f966996d1653);

var $b1E2c = parcelRequire("b1E2c");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $drMc1 = parcelRequire("drMc1");
var $91U3U = parcelRequire("91U3U");

var $kfXMR = parcelRequire("kfXMR");

var $6T4Sa = parcelRequire("6T4Sa");

var $coQoV = parcelRequire("coQoV");

var $8ltoy = parcelRequire("8ltoy");

var $jfPQV = parcelRequire("jfPQV");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $7b0dad5cf366cc16$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $b1E2c.uuid4)(),
        timestamp: event.timestamp || (0, $cvSY8.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $7b0dad5cf366cc16$var$applyClientOptions(prepared, options);
    $7b0dad5cf366cc16$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $7b0dad5cf366cc16$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $7b0dad5cf366cc16$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $b1E2c.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $coQoV.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $8ltoy.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $8ltoy.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8ltoy.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $6T4Sa.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $6T4Sa.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $7b0dad5cf366cc16$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $7b0dad5cf366cc16$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $7b0dad5cf366cc16$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $kfXMR.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $91U3U.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $91U3U.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $91U3U.truncate)(request.url, maxValueLength);
}
const $7b0dad5cf366cc16$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $7b0dad5cf366cc16$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $3bpJ1.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $7b0dad5cf366cc16$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $7b0dad5cf366cc16$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $7b0dad5cf366cc16$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $7b0dad5cf366cc16$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $7b0dad5cf366cc16$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $drMc1.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $drMc1.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $drMc1.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $drMc1.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $drMc1.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $jfPQV.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $drMc1.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $7b0dad5cf366cc16$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $coQoV.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $7b0dad5cf366cc16$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($7b0dad5cf366cc16$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $coQoV.Scope) || typeof hint === "function";
}
const $7b0dad5cf366cc16$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $7b0dad5cf366cc16$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$7b0dad5cf366cc16$var$captureContextKeys.includes(key));
}

});
parcelRegister("drMc1", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $9ca32e18a091d955$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $9ca32e18a091d955$export$23fbbb20bed71033);

var $2zW56 = parcelRequire("2zW56");

var $3BHn6 = parcelRequire("3BHn6");

var $jL8lq = parcelRequire("jL8lq");

var $16dZf = parcelRequire("16dZf");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $9ca32e18a091d955$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $9ca32e18a091d955$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $9ca32e18a091d955$export$a3295358bff77e(object, depth);
    if ($9ca32e18a091d955$var$jsonSize(normalized) > maxSize) return $9ca32e18a091d955$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $9ca32e18a091d955$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $3BHn6.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $2zW56.isNaN)(value)) return value;
    const stringified = $9ca32e18a091d955$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $9ca32e18a091d955$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $jL8lq.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $9ca32e18a091d955$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $9ca32e18a091d955$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $2zW56.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $2zW56.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $16dZf.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $9ca32e18a091d955$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $9ca32e18a091d955$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $9ca32e18a091d955$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$var$jsonSize(value) {
    return $9ca32e18a091d955$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $9ca32e18a091d955$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("3BHn6", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $2a06788518a26cc6$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $2a06788518a26cc6$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("16dZf", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $0cd1337813906a62$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $0cd1337813906a62$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $0cd1337813906a62$export$aad197c7121a6651);

var $cDXrx = parcelRequire("cDXrx");
const $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $0cd1337813906a62$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0cd1337813906a62$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($0cd1337813906a62$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $0cd1337813906a62$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0cd1337813906a62$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0cd1337813906a62$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $0cd1337813906a62$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $0cd1337813906a62$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $0cd1337813906a62$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $0cd1337813906a62$var$defaultFunctionName;
        return fn.name || $0cd1337813906a62$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0cd1337813906a62$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $0cd1337813906a62$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $cDXrx.node)(getModule)
    ];
}

});
parcelRegister("cDXrx", function(module, exports) {

$parcel$export(module.exports, "node", () => $93473cbc517fed7c$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $93473cbc517fed7c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("hKg1m", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", () => $ceb328f2f449885f$export$7918117e9202e4fb);
$parcel$export(module.exports, "FunctionToString", () => $ceb328f2f449885f$export$da4704525c20ae79);

var $jL8lq = parcelRequire("jL8lq");

var $b8438 = parcelRequire("b8438");

var $71tRZ = parcelRequire("71tRZ");
let $ceb328f2f449885f$var$originalFunctionToString;
const $ceb328f2f449885f$var$INTEGRATION_NAME = "FunctionToString";
const $ceb328f2f449885f$var$SETUP_CLIENTS = new WeakMap();
const $ceb328f2f449885f$var$_functionToStringIntegration = ()=>{
    return {
        name: $ceb328f2f449885f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ceb328f2f449885f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $jL8lq.getOriginalFunction)(this);
                    const context = $ceb328f2f449885f$var$SETUP_CLIENTS.has((0, $b8438.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ceb328f2f449885f$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ceb328f2f449885f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ceb328f2f449885f$export$7918117e9202e4fb = (0, $71tRZ.defineIntegration)($ceb328f2f449885f$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ceb328f2f449885f$export$da4704525c20ae79 = (0, $71tRZ.convertIntegrationFnToClass)($ceb328f2f449885f$var$INTEGRATION_NAME, $ceb328f2f449885f$export$7918117e9202e4fb);

});
parcelRegister("71tRZ", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", () => $51cfcbefde61ff20$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $51cfcbefde61ff20$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $51cfcbefde61ff20$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $51cfcbefde61ff20$export$35abcfd71227c6ca);
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $51cfcbefde61ff20$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $51cfcbefde61ff20$export$2323046b9414659f);

var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $6T4Sa = parcelRequire("6T4Sa");

var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");
const $51cfcbefde61ff20$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $51cfcbefde61ff20$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $51cfcbefde61ff20$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $b1E2c.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $51cfcbefde61ff20$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $51cfcbefde61ff20$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $51cfcbefde61ff20$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $51cfcbefde61ff20$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($51cfcbefde61ff20$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $6T4Sa.addGlobalEventProcessor), (0, $cmFjP.getCurrentHub));
        $51cfcbefde61ff20$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $51cfcbefde61ff20$export$2d8f5188773bcddd(integration) {
    const client = (0, $b8438.getClient)();
    if (!client || !client.addIntegration) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $51cfcbefde61ff20$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $51cfcbefde61ff20$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $51cfcbefde61ff20$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("iDxMj", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $d91612272370ed71$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $d91612272370ed71$export$671c7ed8e40a7a57);

var $ldaPw = parcelRequire("ldaPw");
var $jL8lq = parcelRequire("jL8lq");
const $d91612272370ed71$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $d91612272370ed71$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $d91612272370ed71$var$_getIngestEndpoint(dsn) {
    return `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $d91612272370ed71$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $jL8lq.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $d91612272370ed71$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $d91612272370ed71$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$d91612272370ed71$var$_getIngestEndpoint(dsn)}?${$d91612272370ed71$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $d91612272370ed71$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $ldaPw.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $ldaPw.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("ldaPw", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $f7133678d936cd5e$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $f7133678d936cd5e$export$128827c3562ec0cb);

var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");
/** Regular expression used to parse a Dsn. */ const $f7133678d936cd5e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f7133678d936cd5e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f7133678d936cd5e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f7133678d936cd5e$export$b892860177f70a30(str) {
    const match = $f7133678d936cd5e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $4g0Ct.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f7133678d936cd5e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f7133678d936cd5e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f7133678d936cd5e$var$validateDsn(dsn) {
    if (!(0, $eKZKa.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f7133678d936cd5e$var$isValidProtocol(protocol)) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f7133678d936cd5e$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $f7133678d936cd5e$export$b892860177f70a30(from) : $f7133678d936cd5e$var$dsnFromComponents(from);
    if (!components || !$f7133678d936cd5e$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("6jMsx", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", () => $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba);
$parcel$export(module.exports, "InboundFilters", () => $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4);

var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");
var $91U3U = parcelRequire("91U3U");

var $8IHa9 = parcelRequire("8IHa9");

var $71tRZ = parcelRequire("71tRZ");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $499a1b6c2e7bd9e9$var$INTEGRATION_NAME = "InboundFilters";
const $499a1b6c2e7bd9e9$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $499a1b6c2e7bd9e9$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $499a1b6c2e7bd9e9$var$_mergeOptions(options, clientOptions);
            return $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba = (0, $71tRZ.defineIntegration)($499a1b6c2e7bd9e9$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4 = (0, $71tRZ.convertIntegrationFnToClass)($499a1b6c2e7bd9e9$var$INTEGRATION_NAME, $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba);
function $499a1b6c2e7bd9e9$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $499a1b6c2e7bd9e9$var$_isSentryError(event)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$499a1b6c2e7bd9e9$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event).some((message)=>(0, $91U3U.stringMatchesSomePattern)(message, ignoreErrors));
}
function $499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $91U3U.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $499a1b6c2e7bd9e9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? false : (0, $91U3U.stringMatchesSomePattern)(url, denyUrls);
}
function $499a1b6c2e7bd9e9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? true : (0, $91U3U.stringMatchesSomePattern)(url, allowUrls);
}
function $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $8IHa9.DEBUG_BUILD) && possibleMessages.length === 0) (0, $4g0Ct.logger).error(`Could not extract message for event ${(0, $b1E2c.getEventDescription)(event)}`);
    return possibleMessages;
}
function $499a1b6c2e7bd9e9$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`Cannot extract url for event ${(0, $b1E2c.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("cCtO1", function(module, exports) {

$parcel$export(module.exports, "initAndBind", () => $93002778f3923c52$export$5333c3f1c58d9bc1);

var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $93002778f3923c52$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $8IHa9.DEBUG_BUILD) (0, $4g0Ct.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $4g0Ct.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $b8438.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $93002778f3923c52$export$ecb76f41d43c0e43(client);
    $93002778f3923c52$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $93002778f3923c52$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $93002778f3923c52$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("3dtKS", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $2579aac1b9dfd189$export$3f18c56c58114e75);

var $jL8lq = parcelRequire("jL8lq");



var $3bpJ1 = parcelRequire("3bpJ1");

var $epYsr = parcelRequire("epYsr");

var $dbwHv = parcelRequire("dbwHv");
const $2579aac1b9dfd189$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
let $2579aac1b9dfd189$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2579aac1b9dfd189$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $2579aac1b9dfd189$var$instrumentHistory);
}
function $2579aac1b9dfd189$var$instrumentHistory() {
    if (!(0, $epYsr.supportsHistory)()) return;
    const oldOnPopState = $2579aac1b9dfd189$var$WINDOW.onpopstate;
    $2579aac1b9dfd189$var$WINDOW.onpopstate = function(...args) {
        const to = $2579aac1b9dfd189$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $2579aac1b9dfd189$var$lastHref;
        $2579aac1b9dfd189$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $dbwHv.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $2579aac1b9dfd189$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $2579aac1b9dfd189$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $dbwHv.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $jL8lq.fill)($2579aac1b9dfd189$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $jL8lq.fill)($2579aac1b9dfd189$var$WINDOW.history, "replaceState", historyReplacementFunction);
}

});
parcelRegister("epYsr", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", () => $a7f24c22762d2906$export$67fc34576016d6ec);

var $3bpJ1 = parcelRequire("3bpJ1");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $a7f24c22762d2906$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a7f24c22762d2906$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $a7f24c22762d2906$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a7f24c22762d2906$var$WINDOW && !!$a7f24c22762d2906$var$WINDOW.history.pushState && !!$a7f24c22762d2906$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("dbwHv", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $9995ab194a6bc98e$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $9995ab194a6bc98e$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $9995ab194a6bc98e$export$b18c893e424d3127);

var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");

var $16dZf = parcelRequire("16dZf");
// We keep the handlers globally
const $9995ab194a6bc98e$var$handlers = {};
const $9995ab194a6bc98e$var$instrumented = {};
/** Add a handler function. */ function $9995ab194a6bc98e$export$a4e09611e30da72e(type, handler) {
    $9995ab194a6bc98e$var$handlers[type] = $9995ab194a6bc98e$var$handlers[type] || [];
    $9995ab194a6bc98e$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $9995ab194a6bc98e$export$b17eab759a1cb5fe() {
    Object.keys($9995ab194a6bc98e$var$handlers).forEach((key)=>{
        $9995ab194a6bc98e$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $9995ab194a6bc98e$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$9995ab194a6bc98e$var$instrumented[type]) {
        instrumentFn();
        $9995ab194a6bc98e$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $9995ab194a6bc98e$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $9995ab194a6bc98e$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("esO9h", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $a87a94b8e4ff7f26$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $a87a94b8e4ff7f26$export$c82d238e23c40b21);

var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $a87a94b8e4ff7f26$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a87a94b8e4ff7f26$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a87a94b8e4ff7f26$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a87a94b8e4ff7f26$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a87a94b8e4ff7f26$export$18cf36ed71d733e7($a87a94b8e4ff7f26$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a87a94b8e4ff7f26$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a87a94b8e4ff7f26$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$531055a6c684a70a() {
    return "ReportingObserver" in $a87a94b8e4ff7f26$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("gWrK2", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $c55795097f9daeb0$export$1df9218a526d318d);

var $htFdx = parcelRequire("htFdx");
var $80A9Z = parcelRequire("80A9Z");

var $iDlgA = parcelRequire("iDlgA");
var $ldaPw = parcelRequire("ldaPw");
var $Wgg6o = parcelRequire("Wgg6o");
var $4g0Ct = parcelRequire("4g0Ct");

var $b7h0d = parcelRequire("b7h0d");

var $30niQ = parcelRequire("30niQ");

var $6JSNk = parcelRequire("6JSNk");

var $f87TS = parcelRequire("f87TS");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c55795097f9daeb0$export$1df9218a526d318d extends (0, $80A9Z.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $6JSNk.WINDOW).SENTRY_SDK_SOURCE || (0, $Wgg6o.getSDKSource)();
        (0, $htFdx.applySdkMetadata)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $6JSNk.WINDOW).document) (0, $6JSNk.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $6JSNk.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $30niQ.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $30niQ.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $f87TS.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $iDlgA.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $ldaPw.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("htFdx", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", () => $cb951e05ebb58c43$export$b9f95b027256052c);

var $9OAWn = parcelRequire("9OAWn");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $cb951e05ebb58c43$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $9OAWn.SDK_VERSION)
            })),
        version: (0, $9OAWn.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("80A9Z", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $5d4a5f71b683f78e$export$4f22f74eddb7716a);

var $3PPTH = parcelRequire("3PPTH");
var $b1E2c = parcelRequire("b1E2c");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $ldaPw = parcelRequire("ldaPw");
var $j3a3y = parcelRequire("j3a3y");
var $bLvfM = parcelRequire("bLvfM");

var $iDxMj = parcelRequire("iDxMj");

var $8IHa9 = parcelRequire("8IHa9");

var $dljpV = parcelRequire("dljpV");

var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");

var $71tRZ = parcelRequire("71tRZ");

var $fPHvB = parcelRequire("fPHvB");

var $oyvka = parcelRequire("oyvka");

var $bPHT6 = parcelRequire("bPHT6");

var $az0Em = parcelRequire("az0Em");
const $5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5d4a5f71b683f78e$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $ldaPw.makeDsn)(options.dsn);
        else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $iDxMj.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $b1E2c.checkOrSetAlreadyCaught)(exception)) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $2zW56.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $2zW56.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $b1E2c.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $oyvka.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $j3a3y.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $71tRZ.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $71tRZ.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $dljpV.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $3PPTH.addItemToEnvelope)(env, (0, $3PPTH.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $dljpV.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $fPHvB.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $71tRZ.setupIntegrations)(this, integrations);
        (0, $71tRZ.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $oyvka.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $cmFjP.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $az0Em.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $bPHT6.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $8IHa9.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $4g0Ct.logger).log(sentryError.message);
                else (0, $4g0Ct.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $5d4a5f71b683f78e$var$isTransactionEvent(event);
        const isError = $5d4a5f71b683f78e$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $j3a3y.rejectedSyncPromise)(new (0, $bLvfM.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $bLvfM.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5d4a5f71b683f78e$var$processBeforeSend(options, prepared, hint);
            return $5d4a5f71b683f78e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $bLvfM.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $bLvfM.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $bLvfM.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Error while sending event:", reason);
        });
        else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5d4a5f71b683f78e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $2zW56.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $2zW56.isPlainObject)(event) && event !== null) throw new (0, $bLvfM.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $bLvfM.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $2zW56.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $bLvfM.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5d4a5f71b683f78e$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($5d4a5f71b683f78e$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5d4a5f71b683f78e$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $5d4a5f71b683f78e$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5d4a5f71b683f78e$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $5d4a5f71b683f78e$export$9aac0b9f77928fbf(callback) {
    const client = (0, $b8438.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("3PPTH", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $2cae643f899492f0$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $2cae643f899492f0$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $2cae643f899492f0$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $2cae643f899492f0$export$32f9b428425aac85);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $2cae643f899492f0$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $2cae643f899492f0$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $2cae643f899492f0$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $2cae643f899492f0$export$92b6093782fe661b);

var $ldaPw = parcelRequire("ldaPw");

var $drMc1 = parcelRequire("drMc1");

var $jL8lq = parcelRequire("jL8lq");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $2cae643f899492f0$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $2cae643f899492f0$export$604a45d95a155e2b(envelope, types) {
    return $2cae643f899492f0$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $2cae643f899492f0$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $2cae643f899492f0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $2cae643f899492f0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $2cae643f899492f0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $drMc1.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $2cae643f899492f0$var$concatBuffers(parts);
}
function $2cae643f899492f0$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $2cae643f899492f0$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $2cae643f899492f0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $2cae643f899492f0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $jL8lq.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    // TODO: This is a temporary workaround until we have a proper data category for metrics
    statsd: "unknown"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $2cae643f899492f0$export$b11169581eeaf237(type) {
    return $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $2cae643f899492f0$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $2cae643f899492f0$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $ldaPw.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $jL8lq.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRegister("bLvfM", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $890c53ca2f6b4a7a$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $890c53ca2f6b4a7a$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("dljpV", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $9b6c4c62dbf66cae$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $9b6c4c62dbf66cae$export$c31057337a18010f);

var $3PPTH = parcelRequire("3PPTH");
var $ldaPw = parcelRequire("ldaPw");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $9b6c4c62dbf66cae$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $3PPTH.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $ldaPw.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $3PPTH.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9b6c4c62dbf66cae$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $3PPTH.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $3PPTH.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $3PPTH.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("fPHvB", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", () => $b86d5e61843389b9$export$f23eb96e33154901);

var $3PPTH = parcelRequire("3PPTH");
var $ldaPw = parcelRequire("ldaPw");

var $3wGrN = parcelRequire("3wGrN");
/**
 * Create envelope from a metric aggregate.
 */ function $b86d5e61843389b9$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $ldaPw.dsnToString)(dsn);
    const item = $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $3PPTH.createEnvelope)(headers, [
        item
    ]);
}
function $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $3wGrN.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("3wGrN", function(module, exports) {

$parcel$export(module.exports, "serializeMetricBuckets", () => $2915496cd851a181$export$66decd709db01dc8);

var $jL8lq = parcelRequire("jL8lq");

var $hPoOA = parcelRequire("hPoOA");
/**
 * Generate bucket key from metric properties.
 */ function $2915496cd851a181$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $jL8lq.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $2915496cd851a181$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $2915496cd851a181$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/**
 * Sanitizes tags.
 */ function $2915496cd851a181$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = key.replace((0, $hPoOA.NAME_AND_TAG_KEY_NORMALIZATION_REGEX), "_");
        tags[sanitizedKey] = String(unsanitizedTags[key]).replace((0, $hPoOA.TAG_VALUE_NORMALIZATION_REGEX), "");
    }
    return tags;
}

});
parcelRegister("hPoOA", function(module, exports) {

$parcel$export(module.exports, "NAME_AND_TAG_KEY_NORMALIZATION_REGEX", () => $cfaa72d12e86b292$export$73db7eda248c6468);
$parcel$export(module.exports, "TAG_VALUE_NORMALIZATION_REGEX", () => $cfaa72d12e86b292$export$2699a97e88d47e55);
const $cfaa72d12e86b292$export$ffbd59c90957aeda = "c";
const $cfaa72d12e86b292$export$41106537ee4dbdd = "g";
const $cfaa72d12e86b292$export$d2e7506772279f4e = "s";
const $cfaa72d12e86b292$export$9818d6472d7991f0 = "d";
/**
 * Normalization regex for metric names and metric tag names.
 *
 * This enforces that names and tag keys only contain alphanumeric characters,
 * underscores, forward slashes, periods, and dashes.
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $cfaa72d12e86b292$export$73db7eda248c6468 = /[^a-zA-Z0-9_/.-]+/g;
/**
 * Normalization regex for metric tag values.
 *
 * This enforces that values only contain words, digits, or the following
 * special characters: _:/@.{}[\]$-
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $cfaa72d12e86b292$export$2699a97e88d47e55 = /[^\w\d\s_:/@.{}[\]$-]+/g;
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const $cfaa72d12e86b292$export$9fcf9b73aae4b12 = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const $cfaa72d12e86b292$export$8f071e089fcfe0c = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const $cfaa72d12e86b292$export$aa41e9d920739c1a = 10000;

});




parcelRegister("iDlgA", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $d90c5d9ac5d72442$export$f3b9ed77c03eeb00);

var $3PPTH = parcelRequire("3PPTH");

var $cvSY8 = parcelRequire("cvSY8");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d90c5d9ac5d72442$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $cvSY8.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $3PPTH.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("Wgg6o", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", () => $0af207894032bdf2$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0af207894032bdf2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0af207894032bdf2$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("b7h0d", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $817d897c5dc6d664$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $817d897c5dc6d664$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("30niQ", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $230372ac01587541$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $230372ac01587541$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $230372ac01587541$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $230372ac01587541$export$5425b53185d13d6c);

var $b8438 = parcelRequire("b8438");

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $drMc1 = parcelRequire("drMc1");
var $j3a3y = parcelRequire("j3a3y");
/**
 * This function creates an exception from a JavaScript Error
 */ function $230372ac01587541$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $230372ac01587541$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $230372ac01587541$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $b8438.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $2zW56.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $drMc1.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $230372ac01587541$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $230372ac01587541$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $230372ac01587541$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $230372ac01587541$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($230372ac01587541$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $230372ac01587541$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $230372ac01587541$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $230372ac01587541$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $2zW56.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $230372ac01587541$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $2zW56.isDOMError)(exception) || (0, $2zW56.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $2zW56.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $b1E2c.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $2zW56.isError)(exception)) // we have a real Error object, do nothing
    return $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $2zW56.isPlainObject)(exception) || (0, $2zW56.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $230372ac01587541$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b1E2c.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $b1E2c.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $2zW56.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $jL8lq.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $2zW56.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $2zW56.isEvent)(exception)) {
        const className = $230372ac01587541$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $230372ac01587541$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("6JSNk", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $4e817323ced6d78c$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $4e817323ced6d78c$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $4e817323ced6d78c$export$4997ffc0176396a6);


var $b8438 = parcelRequire("b8438");

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $3bpJ1 = parcelRequire("3bpJ1");
const $4e817323ced6d78c$export$56d8a8a25bd48b81 = (0, $3bpJ1.GLOBAL_OBJ);
let $4e817323ced6d78c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4e817323ced6d78c$export$b79738ab10c590b2() {
    return $4e817323ced6d78c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4e817323ced6d78c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4e817323ced6d78c$var$ignoreOnError++;
    setTimeout(()=>{
        $4e817323ced6d78c$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4e817323ced6d78c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $jL8lq.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$4e817323ced6d78c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4e817323ced6d78c$export$1265a142ff5ba165();
            (0, $b8438.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b1E2c.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $b1E2c.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $b8438.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $jL8lq.markFunctionWrapped)(sentryWrapped, fn);
    (0, $jL8lq.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("f87TS", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $b03dbb36f8019264$export$24a4dfcb686ee5bf);

var $3PPTH = parcelRequire("3PPTH");
var $ldaPw = parcelRequire("ldaPw");
/**
 * Creates an envelope from a user feedback.
 */ function $b03dbb36f8019264$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $ldaPw.dsnToString)(dsn)
        }
    };
    const item = $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $3PPTH.createEnvelope)(headers, [
        item
    ]);
}
function $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("fxK4w", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", () => $b50dad0732e7f682$export$c079d904b326663a);
$parcel$export(module.exports, "Breadcrumbs", () => $b50dad0732e7f682$export$2dc68d50d56fbbd);

var $b8438 = parcelRequire("b8438");
var $71tRZ = parcelRequire("71tRZ");

var $9pOsc = parcelRequire("9pOsc");
var $iymxC = parcelRequire("iymxC");
var $j8BFi = parcelRequire("j8BFi");
var $3dtKS = parcelRequire("3dtKS");
var $eYtML = parcelRequire("eYtML");
var $ibKgU = parcelRequire("ibKgU");
var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");
var $3bJff = parcelRequire("3bJff");
var $91U3U = parcelRequire("91U3U");
var $aU92a = parcelRequire("aU92a");

var $b7h0d = parcelRequire("b7h0d");

var $6JSNk = parcelRequire("6JSNk");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $b50dad0732e7f682$var$INTEGRATION_NAME = "Breadcrumbs";
const $b50dad0732e7f682$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $b50dad0732e7f682$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $iymxC.addConsoleInstrumentationHandler)($b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $9pOsc.addClickKeypressInstrumentationHandler)($b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $eYtML.addXhrInstrumentationHandler)($b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $j8BFi.addFetchInstrumentationHandler)($b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3dtKS.addHistoryInstrumentationHandler)($b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $b50dad0732e7f682$export$c079d904b326663a = (0, $71tRZ.defineIntegration)($b50dad0732e7f682$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b50dad0732e7f682$export$2dc68d50d56fbbd = (0, $71tRZ.convertIntegrationFnToClass)($b50dad0732e7f682$var$INTEGRATION_NAME, $b50dad0732e7f682$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $b8438.getClient)() !== client) return;
        (0, $b8438.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $b1E2c.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $b50dad0732e7f682$var$_isEvent(event) ? event.target : event;
            target = (0, $ibKgU.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $ibKgU.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $b8438.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $aU92a.severityLevelFromString)(handlerData.level),
            message: (0, $91U3U.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $91U3U.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $b8438.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $eYtML.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $b8438.addBreadcrumb)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $b8438.addBreadcrumb)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $b8438.addBreadcrumb)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $3bJff.parseUrl)((0, $6JSNk.WINDOW).location.href);
        let parsedFrom = from ? (0, $3bJff.parseUrl)(from) : undefined;
        const parsedTo = (0, $3bJff.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $b8438.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $b50dad0732e7f682$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("9pOsc", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $6dad95eb90f2d36c$export$5aeffd3db2cf9df7);

var $b1E2c = parcelRequire("b1E2c");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
const $6dad95eb90f2d36c$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
const $6dad95eb90f2d36c$var$DEBOUNCE_DURATION = 1000;
let $6dad95eb90f2d36c$var$debounceTimerID;
let $6dad95eb90f2d36c$var$lastCapturedEventType;
let $6dad95eb90f2d36c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6dad95eb90f2d36c$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $6dad95eb90f2d36c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $6dad95eb90f2d36c$export$3014bbf0af0e1d4a() {
    if (!$6dad95eb90f2d36c$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $dbwHv.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler, true);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $6dad95eb90f2d36c$var$WINDOW[target] && $6dad95eb90f2d36c$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $jL8lq.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $jL8lq.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $6dad95eb90f2d36c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $6dad95eb90f2d36c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $6dad95eb90f2d36c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $6dad95eb90f2d36c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $6dad95eb90f2d36c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($6dad95eb90f2d36c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $jL8lq.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $jL8lq.addNonEnumerableProperty)(target, "_sentryId", (0, $b1E2c.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6dad95eb90f2d36c$var$lastCapturedEventType = event.type;
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($6dad95eb90f2d36c$var$debounceTimerID);
        $6dad95eb90f2d36c$var$debounceTimerID = $6dad95eb90f2d36c$var$WINDOW.setTimeout(()=>{
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = undefined;
            $6dad95eb90f2d36c$var$lastCapturedEventType = undefined;
        }, $6dad95eb90f2d36c$var$DEBOUNCE_DURATION);
    };
}
function $6dad95eb90f2d36c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("iymxC", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $d81ce3377b27def9$export$1d6e0d073f9e6723);

var $4g0Ct = parcelRequire("4g0Ct");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d81ce3377b27def9$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $d81ce3377b27def9$var$instrumentConsole);
}
function $d81ce3377b27def9$var$instrumentConsole() {
    if (!("console" in (0, $3bpJ1.GLOBAL_OBJ))) return;
    (0, $4g0Ct.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $3bpJ1.GLOBAL_OBJ).console)) return;
        (0, $jL8lq.fill)((0, $3bpJ1.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $4g0Ct.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $dbwHv.triggerHandlers)("console", handlerData);
                const log = (0, $4g0Ct.originalConsoleMethods)[level];
                log && log.apply((0, $3bpJ1.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("j8BFi", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $deebfb2c2f3e82fb$export$f75d3c772c923df0);

var $jL8lq = parcelRequire("jL8lq");

var $esO9h = parcelRequire("esO9h");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $deebfb2c2f3e82fb$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $deebfb2c2f3e82fb$var$instrumentFetch);
}
function $deebfb2c2f3e82fb$var$instrumentFetch() {
    if (!(0, $esO9h.supportsNativeFetch)()) return;
    (0, $jL8lq.fill)((0, $3bpJ1.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $deebfb2c2f3e82fb$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $dbwHv.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $3bpJ1.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $dbwHv.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $dbwHv.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $deebfb2c2f3e82fb$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $deebfb2c2f3e82fb$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($deebfb2c2f3e82fb$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $deebfb2c2f3e82fb$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $deebfb2c2f3e82fb$var$getUrlFromResource(url),
            method: $deebfb2c2f3e82fb$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $deebfb2c2f3e82fb$var$getUrlFromResource(arg),
        method: $deebfb2c2f3e82fb$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});

parcelRegister("eYtML", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $ae6dc6125d1c3217$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $ae6dc6125d1c3217$export$26ace48dd54c9aea);

var $2zW56 = parcelRequire("2zW56");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
const $ae6dc6125d1c3217$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
const $ae6dc6125d1c3217$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ae6dc6125d1c3217$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $ae6dc6125d1c3217$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $ae6dc6125d1c3217$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$ae6dc6125d1c3217$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $jL8lq.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $2zW56.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $ae6dc6125d1c3217$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $dbwHv.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $jL8lq.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $jL8lq.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $2zW56.isString)(header) && (0, $2zW56.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $jL8lq.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $dbwHv.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $ae6dc6125d1c3217$var$parseUrl(url) {
    if ((0, $2zW56.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("3bJff", function(module, exports) {

$parcel$export(module.exports, "parseUrl", () => $25257edadcf16f49$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getNumberOfUrlSegments", () => $25257edadcf16f49$export$69dd85280a8d374c);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $25257edadcf16f49$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $25257edadcf16f49$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $25257edadcf16f49$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $25257edadcf16f49$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});

parcelRegister("aU92a", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", () => $7f06244a5e0d22e8$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $7f06244a5e0d22e8$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $7f06244a5e0d22e8$export$e01cef29b4327697(level) {
    return $7f06244a5e0d22e8$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $7f06244a5e0d22e8$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $7f06244a5e0d22e8$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

});


parcelRegister("bMyDX", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", () => $893f0ce260470ef7$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $893f0ce260470ef7$export$688d98c249d31ad3);

var $71tRZ = parcelRequire("71tRZ");

var $4g0Ct = parcelRequire("4g0Ct");

var $b7h0d = parcelRequire("b7h0d");
const $893f0ce260470ef7$var$INTEGRATION_NAME = "Dedupe";
const $893f0ce260470ef7$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $893f0ce260470ef7$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $893f0ce260470ef7$export$6d39aa44cd0c7567 = (0, $71tRZ.defineIntegration)($893f0ce260470ef7$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $893f0ce260470ef7$export$688d98c249d31ad3 = (0, $71tRZ.convertIntegrationFnToClass)($893f0ce260470ef7$var$INTEGRATION_NAME, $893f0ce260470ef7$export$6d39aa44cd0c7567);
function $893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $893f0ce260470ef7$var$_getExceptionFromEvent(previousEvent);
    const currentException = $893f0ce260470ef7$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $893f0ce260470ef7$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $893f0ce260470ef7$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $893f0ce260470ef7$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $893f0ce260470ef7$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("dw5F0", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", () => $9d72a78ef45a7c39$export$66acc70e8cf2b71a);
$parcel$export(module.exports, "GlobalHandlers", () => $9d72a78ef45a7c39$export$204155decbc90e5a);

var $b8438 = parcelRequire("b8438");
var $71tRZ = parcelRequire("71tRZ");

var $isDtX = parcelRequire("isDtX");
var $e5Ga6 = parcelRequire("e5Ga6");
var $ibKgU = parcelRequire("ibKgU");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");

var $b7h0d = parcelRequire("b7h0d");

var $30niQ = parcelRequire("30niQ");

var $6JSNk = parcelRequire("6JSNk");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $9d72a78ef45a7c39$var$INTEGRATION_NAME = "GlobalHandlers";
const $9d72a78ef45a7c39$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $9d72a78ef45a7c39$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $9d72a78ef45a7c39$export$66acc70e8cf2b71a = (0, $71tRZ.defineIntegration)($9d72a78ef45a7c39$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9d72a78ef45a7c39$export$204155decbc90e5a = (0, $71tRZ.convertIntegrationFnToClass)($9d72a78ef45a7c39$var$INTEGRATION_NAME, $9d72a78ef45a7c39$export$66acc70e8cf2b71a);
function $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client) {
    (0, $isDtX.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $b8438.getClient)() !== client || (0, $6JSNk.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $2zW56.isString)(msg) ? $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) : $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame((0, $30niQ.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $b8438.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $e5Ga6.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $b8438.getClient)() !== client || (0, $6JSNk.shouldIgnoreOnError)()) return;
        const error = $9d72a78ef45a7c39$var$_getUnhandledRejectionError(e);
        const event = (0, $2zW56.isPrimitive)(error) ? $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(error) : (0, $30niQ.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $b8438.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_getUnhandledRejectionError(error) {
    if ((0, $2zW56.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $2zW56.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $2zW56.isString)(url) && url.length > 0 ? url : (0, $ibKgU.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9d72a78ef45a7c39$var$globalHandlerLog(type) {
    (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Global Handler attached: ${type}`);
}
function $9d72a78ef45a7c39$var$getOptions() {
    const client = (0, $b8438.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("isDtX", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $d70977d9b36915fd$export$55b5c3ba2194f0c6);

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
let $d70977d9b36915fd$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d70977d9b36915fd$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $d70977d9b36915fd$var$instrumentError);
}
function $d70977d9b36915fd$var$instrumentError() {
    $d70977d9b36915fd$var$_oldOnErrorHandler = (0, $3bpJ1.GLOBAL_OBJ).onerror;
    (0, $3bpJ1.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $dbwHv.triggerHandlers)("error", handlerData);
        if ($d70977d9b36915fd$var$_oldOnErrorHandler && !$d70977d9b36915fd$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d70977d9b36915fd$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $3bpJ1.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("e5Ga6", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $a4223cccebdcb864$export$8bf4fc6858821a4e);

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
let $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a4223cccebdcb864$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $a4223cccebdcb864$var$instrumentUnhandledRejection);
}
function $a4223cccebdcb864$var$instrumentUnhandledRejection() {
    $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection;
    (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $dbwHv.triggerHandlers)("unhandledrejection", handlerData);
        if ($a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler && !$a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("efOBd", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", () => $a609b75c449d57c1$export$1378794447170364);
$parcel$export(module.exports, "HttpContext", () => $a609b75c449d57c1$export$5d2ee9a544b09a94);

var $71tRZ = parcelRequire("71tRZ");

var $6JSNk = parcelRequire("6JSNk");
const $a609b75c449d57c1$var$INTEGRATION_NAME = "HttpContext";
const $a609b75c449d57c1$var$_httpContextIntegration = ()=>{
    return {
        name: $a609b75c449d57c1$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $6JSNk.WINDOW).navigator && !(0, $6JSNk.WINDOW).location && !(0, $6JSNk.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $6JSNk.WINDOW).location && (0, $6JSNk.WINDOW).location.href;
            const { referrer: referrer } = (0, $6JSNk.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $6JSNk.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $a609b75c449d57c1$export$1378794447170364 = (0, $71tRZ.defineIntegration)($a609b75c449d57c1$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a609b75c449d57c1$export$5d2ee9a544b09a94 = (0, $71tRZ.convertIntegrationFnToClass)($a609b75c449d57c1$var$INTEGRATION_NAME, $a609b75c449d57c1$export$1378794447170364);

});

parcelRegister("9SQUp", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", () => $732232d08e00e18c$export$ebabb00eb7f3a395);
$parcel$export(module.exports, "LinkedErrors", () => $732232d08e00e18c$export$8d1e60aaf616fb4f);

var $71tRZ = parcelRequire("71tRZ");

var $b1zT6 = parcelRequire("b1zT6");

var $30niQ = parcelRequire("30niQ");
const $732232d08e00e18c$var$DEFAULT_KEY = "cause";
const $732232d08e00e18c$var$DEFAULT_LIMIT = 5;
const $732232d08e00e18c$var$INTEGRATION_NAME = "LinkedErrors";
const $732232d08e00e18c$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $732232d08e00e18c$var$DEFAULT_LIMIT;
    const key = options.key || $732232d08e00e18c$var$DEFAULT_KEY;
    return {
        name: $732232d08e00e18c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $b1zT6.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $30niQ.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $732232d08e00e18c$export$ebabb00eb7f3a395 = (0, $71tRZ.defineIntegration)($732232d08e00e18c$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $732232d08e00e18c$export$8d1e60aaf616fb4f = (0, $71tRZ.convertIntegrationFnToClass)($732232d08e00e18c$var$INTEGRATION_NAME, $732232d08e00e18c$export$ebabb00eb7f3a395);

});
parcelRegister("b1zT6", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $021240852b914991$export$b91c38ed7d8ae9b2);

var $2zW56 = parcelRequire("2zW56");

var $91U3U = parcelRequire("91U3U");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $021240852b914991$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $2zW56.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $021240852b914991$var$truncateAggregateExceptions($021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $2zW56.isInstanceOf)(error[key], Error)) {
        $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $2zW56.isInstanceOf)(childError, Error)) {
            $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $021240852b914991$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $021240852b914991$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $91U3U.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("llG7W", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", () => $f8ac3caec1ed9186$export$59bfe9f1c76150e);
$parcel$export(module.exports, "TryCatch", () => $f8ac3caec1ed9186$export$f1a018517668e6d3);

var $71tRZ = parcelRequire("71tRZ");

var $jL8lq = parcelRequire("jL8lq");
var $16dZf = parcelRequire("16dZf");

var $6JSNk = parcelRequire("6JSNk");
const $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $f8ac3caec1ed9186$var$INTEGRATION_NAME = "TryCatch";
const $f8ac3caec1ed9186$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $f8ac3caec1ed9186$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $jL8lq.fill)((0, $6JSNk.WINDOW), "setTimeout", $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $jL8lq.fill)((0, $6JSNk.WINDOW), "setInterval", $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $jL8lq.fill)((0, $6JSNk.WINDOW), "requestAnimationFrame", $f8ac3caec1ed9186$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $6JSNk.WINDOW)) (0, $jL8lq.fill)(XMLHttpRequest.prototype, "send", $f8ac3caec1ed9186$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($f8ac3caec1ed9186$var$_wrapEventTarget);
            }
        }
    };
};
const $f8ac3caec1ed9186$export$59bfe9f1c76150e = (0, $71tRZ.defineIntegration)($f8ac3caec1ed9186$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f8ac3caec1ed9186$export$f1a018517668e6d3 = (0, $71tRZ.convertIntegrationFnToClass)($f8ac3caec1ed9186$var$INTEGRATION_NAME, $f8ac3caec1ed9186$export$59bfe9f1c76150e);
function $f8ac3caec1ed9186$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $6JSNk.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $16dZf.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f8ac3caec1ed9186$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $6JSNk.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $16dZf.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $f8ac3caec1ed9186$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $jL8lq.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $16dZf.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $jL8lq.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $16dZf.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $6JSNk.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $f8ac3caec1ed9186$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $6JSNk.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $jL8lq.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $6JSNk.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $6JSNk.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $jL8lq.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("9AlIt", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", () => $6fa852429033a8df$export$2b2b997d81bf3907);

var $16dZf = parcelRequire("16dZf");
// global reference to slice
const $6fa852429033a8df$var$UNKNOWN_FUNCTION = "?";
const $6fa852429033a8df$var$OPERA10_PRIORITY = 10;
const $6fa852429033a8df$var$OPERA11_PRIORITY = 20;
const $6fa852429033a8df$var$CHROME_PRIORITY = 30;
const $6fa852429033a8df$var$WINJS_PRIORITY = 40;
const $6fa852429033a8df$var$GECKO_PRIORITY = 50;
function $6fa852429033a8df$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $6fa852429033a8df$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $6fa852429033a8df$var$chrome = (line)=>{
    const parts = $6fa852429033a8df$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, parts[2]);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$263a749fff749872 = [
    $6fa852429033a8df$var$CHROME_PRIORITY,
    $6fa852429033a8df$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $6fa852429033a8df$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $6fa852429033a8df$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $6fa852429033a8df$var$gecko = (line)=>{
    const parts = $6fa852429033a8df$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION;
        [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(func, filename);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$cdba47a5dd2804d = [
    $6fa852429033a8df$var$GECKO_PRIORITY,
    $6fa852429033a8df$var$gecko
];
const $6fa852429033a8df$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$winjs = (line)=>{
    const parts = $6fa852429033a8df$var$winjsRegex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $6fa852429033a8df$export$179460296da408e8 = [
    $6fa852429033a8df$var$WINJS_PRIORITY,
    $6fa852429033a8df$var$winjs
];
const $6fa852429033a8df$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $6fa852429033a8df$var$opera10 = (line)=>{
    const parts = $6fa852429033a8df$var$opera10Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[3] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $6fa852429033a8df$export$f892b52c880ffc7a = [
    $6fa852429033a8df$var$OPERA10_PRIORITY,
    $6fa852429033a8df$var$opera10
];
const $6fa852429033a8df$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $6fa852429033a8df$var$opera11 = (line)=>{
    const parts = $6fa852429033a8df$var$opera11Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[5], parts[3] || parts[4] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $6fa852429033a8df$export$af11af13f09fb0dc = [
    $6fa852429033a8df$var$OPERA11_PRIORITY,
    $6fa852429033a8df$var$opera11
];
const $6fa852429033a8df$export$7197c0fe6554c079 = [
    $6fa852429033a8df$export$263a749fff749872,
    $6fa852429033a8df$export$cdba47a5dd2804d,
    $6fa852429033a8df$export$179460296da408e8
];
const $6fa852429033a8df$export$2b2b997d81bf3907 = (0, $16dZf.createStackParser)(...$6fa852429033a8df$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $6fa852429033a8df$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $6fa852429033a8df$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("cyjuS", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", () => $9237c8bb75383bbf$export$b2311068c46d7cc8);

var $7j791 = parcelRequire("7j791");

var $j3a3y = parcelRequire("j3a3y");

var $aK927 = parcelRequire("aK927");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9237c8bb75383bbf$export$b2311068c46d7cc8(options, nativeFetch = (0, $aK927.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $aK927.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $j3a3y.rejectedSyncPromise)(e);
        }
    }
    return (0, $7j791.createTransport)(options, makeRequest);
}

});
parcelRegister("7j791", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $551fd97e865f07d3$export$d09f50d9ab7f7b69);

var $3PPTH = parcelRequire("3PPTH");
var $jf8Z1 = parcelRequire("jf8Z1");
var $4g0Ct = parcelRequire("4g0Ct");
var $jpxdy = parcelRequire("jpxdy");
var $j3a3y = parcelRequire("j3a3y");
var $bLvfM = parcelRequire("bLvfM");

var $8IHa9 = parcelRequire("8IHa9");
const $551fd97e865f07d3$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $551fd97e865f07d3$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $jpxdy.makePromiseBuffer)(options.bufferSize || $551fd97e865f07d3$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $3PPTH.forEachEnvelopeItem)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $3PPTH.envelopeItemTypeToDataCategory)(type);
            if ((0, $jf8Z1.isRateLimited)(rateLimits, envelopeItemDataCategory)) {
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $j3a3y.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $3PPTH.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $3PPTH.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $3PPTH.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $3PPTH.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $jf8Z1.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $bLvfM.SentryError)) {
                (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $j3a3y.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("jf8Z1", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", () => $e02662e4aa308398$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $e02662e4aa308398$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $e02662e4aa308398$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e02662e4aa308398$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e02662e4aa308398$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e02662e4aa308398$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $e02662e4aa308398$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e02662e4aa308398$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("jpxdy", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $e21a1e6dd57da767$export$85a4f67f852183e6);

var $bLvfM = parcelRequire("bLvfM");

var $j3a3y = parcelRequire("j3a3y");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e21a1e6dd57da767$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $j3a3y.rejectedSyncPromise)(new (0, $bLvfM.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $j3a3y.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("aK927", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $7d25350de9c66b8e$export$8be2119ce08e3379);
$parcel$export(module.exports, "clearCachedFetchImplementation", () => $7d25350de9c66b8e$export$d499686d2dd738c6);

var $esO9h = parcelRequire("esO9h");
var $4g0Ct = parcelRequire("4g0Ct");

var $b7h0d = parcelRequire("b7h0d");

var $6JSNk = parcelRequire("6JSNk");
let $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $7d25350de9c66b8e$export$8be2119ce08e3379() {
    if ($7d25350de9c66b8e$var$cachedFetchImpl) return $7d25350de9c66b8e$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $esO9h.isNativeFetch)((0, $6JSNk.WINDOW).fetch)) return $7d25350de9c66b8e$var$cachedFetchImpl = (0, $6JSNk.WINDOW).fetch.bind((0, $6JSNk.WINDOW));
    const document = (0, $6JSNk.WINDOW).document;
    let fetchImpl = (0, $6JSNk.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $b7h0d.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $7d25350de9c66b8e$var$cachedFetchImpl = fetchImpl.bind((0, $6JSNk.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $7d25350de9c66b8e$export$d499686d2dd738c6() {
    $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
}

});


parcelRegister("c0B2u", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", () => $8be23756f879b8e4$export$5e1441cee30d5a39);

var $7j791 = parcelRequire("7j791");

var $j3a3y = parcelRequire("j3a3y");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $8be23756f879b8e4$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8be23756f879b8e4$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8be23756f879b8e4$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $7j791.createTransport)(options, makeRequest);
}

});



parcelRegister("dsEvO", function(module, exports) {

$parcel$export(module.exports, "reactRouterV6BrowserTracingIntegration", () => $9ccd50b999ac5edd$export$47113a480541ff59);
$parcel$export(module.exports, "wrapCreateBrowserRouter", () => $9ccd50b999ac5edd$export$7f4c656bd7ebbb6b);

var $2sI0s = parcelRequire("2sI0s");parcelRequire("aDaS8");
var $6JSNk = parcelRequire("6JSNk");

var $fJmes = parcelRequire("fJmes");
var $ga8Oo = parcelRequire("ga8Oo");
var $h5OHf = parcelRequire("h5OHf");
var $jfPQV = parcelRequire("jfPQV");

var $3bJff = parcelRequire("3bJff");
var $4g0Ct = parcelRequire("4g0Ct");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");

var $6bnLz = parcelRequire("6bnLz");
const $9ccd50b999ac5edd$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $9ccd50b999ac5edd$var$activeTransaction;
let $9ccd50b999ac5edd$var$_useEffect;
let $9ccd50b999ac5edd$var$_useLocation;
let $9ccd50b999ac5edd$var$_useNavigationType;
let $9ccd50b999ac5edd$var$_createRoutesFromChildren;
let $9ccd50b999ac5edd$var$_matchRoutes;
let $9ccd50b999ac5edd$var$_customStartTransaction;
let $9ccd50b999ac5edd$var$_startTransactionOnLocationChange;
let $9ccd50b999ac5edd$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $9ccd50b999ac5edd$export$47113a480541ff59(options) {
    const integration = (0, $2sI0s.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $2sI0s.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $6JSNk.WINDOW) && (0, $6JSNk.WINDOW).location && (0, $6JSNk.WINDOW).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $2sI0s.startBrowserTracingPageLoadSpan)(client, {
                name: initPathName,
                attributes: {
                    [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                    [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                    [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            $9ccd50b999ac5edd$var$_useEffect = useEffect;
            $9ccd50b999ac5edd$var$_useLocation = useLocation;
            $9ccd50b999ac5edd$var$_useNavigationType = useNavigationType;
            $9ccd50b999ac5edd$var$_matchRoutes = matchRoutes;
            $9ccd50b999ac5edd$var$_createRoutesFromChildren = createRoutesFromChildren;
            $9ccd50b999ac5edd$var$_stripBasename = stripBasename || false;
            $9ccd50b999ac5edd$var$_customStartTransaction = startNavigationCallback;
            $9ccd50b999ac5edd$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $9ccd50b999ac5edd$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $6JSNk.WINDOW) && (0, $6JSNk.WINDOW).location && (0, $6JSNk.WINDOW).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $9ccd50b999ac5edd$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        $9ccd50b999ac5edd$var$_useEffect = useEffect;
        $9ccd50b999ac5edd$var$_useLocation = useLocation;
        $9ccd50b999ac5edd$var$_useNavigationType = useNavigationType;
        $9ccd50b999ac5edd$var$_matchRoutes = matchRoutes;
        $9ccd50b999ac5edd$var$_createRoutesFromChildren = createRoutesFromChildren;
        $9ccd50b999ac5edd$var$_stripBasename = stripBasename || false;
        $9ccd50b999ac5edd$var$_customStartTransaction = customStartTransaction;
        $9ccd50b999ac5edd$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $9ccd50b999ac5edd$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function $9ccd50b999ac5edd$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $9ccd50b999ac5edd$var$_stripBasename ? $9ccd50b999ac5edd$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $9ccd50b999ac5edd$var$_stripBasename ? $9ccd50b999ac5edd$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $3bJff.getNumberOfUrlSegments)(pathBuilder) !== (0, $3bJff.getNumberOfUrlSegments)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        ($9ccd50b999ac5edd$var$_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        ($9ccd50b999ac5edd$var$_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        $9ccd50b999ac5edd$var$_stripBasename ? $9ccd50b999ac5edd$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function $9ccd50b999ac5edd$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $9ccd50b999ac5edd$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $9ccd50b999ac5edd$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
}
function $9ccd50b999ac5edd$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $9ccd50b999ac5edd$var$_matchRoutes(routes, location, basename);
    if ($9ccd50b999ac5edd$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($9ccd50b999ac5edd$var$activeTransaction) $9ccd50b999ac5edd$var$activeTransaction.end();
        const [name, source] = $9ccd50b999ac5edd$var$getNormalizedName(routes, location, branches, basename);
        $9ccd50b999ac5edd$var$activeTransaction = $9ccd50b999ac5edd$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source,
                [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ccd50b999ac5edd$export$c6111e8561a02a8b(Routes) {
    if (!$9ccd50b999ac5edd$var$_useEffect || !$9ccd50b999ac5edd$var$_useLocation || !$9ccd50b999ac5edd$var$_useNavigationType || !$9ccd50b999ac5edd$var$_createRoutesFromChildren || !$9ccd50b999ac5edd$var$_matchRoutes || !$9ccd50b999ac5edd$var$_customStartTransaction) {
        (0, $6bnLz.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$9ccd50b999ac5edd$var$_useEffect}. useLocation: ${$9ccd50b999ac5edd$var$_useLocation}. useNavigationType: ${$9ccd50b999ac5edd$var$_useNavigationType}.
      createRoutesFromChildren: ${$9ccd50b999ac5edd$var$_createRoutesFromChildren}. matchRoutes: ${$9ccd50b999ac5edd$var$_matchRoutes}. customStartTransaction: ${$9ccd50b999ac5edd$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $9ccd50b999ac5edd$var$_useLocation();
        const navigationType = $9ccd50b999ac5edd$var$_useNavigationType();
        $9ccd50b999ac5edd$var$_useEffect(()=>{
            const routes = $9ccd50b999ac5edd$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $9ccd50b999ac5edd$var$updatePageloadTransaction($9ccd50b999ac5edd$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $9ccd50b999ac5edd$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $acw62.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $9ccd50b999ac5edd$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $9ccd50b999ac5edd$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$9ccd50b999ac5edd$var$_useEffect || !$9ccd50b999ac5edd$var$_useLocation || !$9ccd50b999ac5edd$var$_useNavigationType || !$9ccd50b999ac5edd$var$_matchRoutes || !$9ccd50b999ac5edd$var$_customStartTransaction) {
        (0, $6bnLz.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $9ccd50b999ac5edd$var$_useLocation();
        const navigationType = $9ccd50b999ac5edd$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $9ccd50b999ac5edd$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $9ccd50b999ac5edd$var$updatePageloadTransaction($9ccd50b999ac5edd$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $9ccd50b999ac5edd$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $acw62.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $9ccd50b999ac5edd$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $9ccd50b999ac5edd$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $9ccd50b999ac5edd$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) $9ccd50b999ac5edd$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($9ccd50b999ac5edd$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) $9ccd50b999ac5edd$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $9ccd50b999ac5edd$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($9ccd50b999ac5edd$var$activeTransaction) return $9ccd50b999ac5edd$var$activeTransaction;
    const span = (0, $fJmes.getActiveSpan)();
    const rootSpan = span ? (0, $ga8Oo.getRootSpan)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $jfPQV.spanToJSON)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}

});
parcelRegister("2sI0s", function(module, exports) {

$parcel$export(module.exports, "browserTracingIntegration", () => $1cb05507144a6a23$export$b4109253475213e9);
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", () => $1cb05507144a6a23$export$aa44a07f82af519f);
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", () => $1cb05507144a6a23$export$7d159749bd9969ad);

var $gu0hs = parcelRequire("gu0hs");
var $fJmes = parcelRequire("fJmes");
var $5UTPE = parcelRequire("5UTPE");
var $b8438 = parcelRequire("b8438");
var $cmFjP = parcelRequire("cmFjP");
var $h5OHf = parcelRequire("h5OHf");
var $jfPQV = parcelRequire("jfPQV");
var $2EZoq = parcelRequire("2EZoq");

var $3dtKS = parcelRequire("3dtKS");
var $cvSY8 = parcelRequire("cvSY8");
var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");
var $65HJt = parcelRequire("65HJt");

var $ef7As = parcelRequire("ef7As");

var $eaxd5 = parcelRequire("eaxd5");

var $bVXeC = parcelRequire("bVXeC");

var $jbMYb = parcelRequire("jbMYb");

var $jAq9Y = parcelRequire("jAq9Y");

var $lR7hQ = parcelRequire("lR7hQ");
const $1cb05507144a6a23$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $1cb05507144a6a23$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $2EZoq.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    _experiments: {},
    ...(0, $jAq9Y.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $1cb05507144a6a23$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $ef7As.DEBUG_BUILD) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $gu0hs.addTracingExtensions)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$1cb05507144a6a23$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $jbMYb.startTrackingWebVitals)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdtoRouteNameMapping = {};
    if (options.enableInp) (0, $jbMYb.startTrackingINP)(interactionIdtoRouteNameMapping);
    if (options.enableLongTask) (0, $jbMYb.startTrackingLongTasks)();
    if (options._experiments.enableInteractions) (0, $jbMYb.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $cmFjP.getCurrentHub)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $1cb05507144a6a23$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $1cb05507144a6a23$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $65HJt.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $lR7hQ.WINDOW);
        const idleTransaction = (0, $gu0hs.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $lR7hQ.WINDOW).document) {
            (0, $lR7hQ.WINDOW).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $lR7hQ.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $lR7hQ.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $jbMYb.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $1cb05507144a6a23$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $ef7As.DEBUG_BUILD) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $4g0Ct.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $lR7hQ.WINDOW).location && (0, $lR7hQ.WINDOW).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $jfPQV.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $jfPQV.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $lR7hQ.WINDOW).location) {
                const context = {
                    name: (0, $lR7hQ.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $cvSY8.browserPerformanceTimeOrigin) ? (0, $cvSY8.browserPerformanceTimeOrigin) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
                    }
                };
                $1cb05507144a6a23$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $lR7hQ.WINDOW).location) (0, $3dtKS.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $lR7hQ.WINDOW).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
                        }
                    };
                    $1cb05507144a6a23$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $eaxd5.registerBackgroundTabDetection)();
            if (_experiments.enableInteractions) $1cb05507144a6a23$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $1cb05507144a6a23$var$registerInpInteractionListener(interactionIdtoRouteNameMapping, latestRoute);
            (0, $jAq9Y.instrumentOutgoingRequests)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $1cb05507144a6a23$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $fJmes.getActiveSpan)();
    const op = span && (0, $jfPQV.spanToJSON)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $1cb05507144a6a23$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $fJmes.getActiveSpan)();
    const op = span && (0, $jfPQV.spanToJSON)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $1cb05507144a6a23$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $ibKgU.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $1cb05507144a6a23$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $5UTPE.getActiveTransaction)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $lR7hQ.WINDOW);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.context ? $1cb05507144a6a23$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $gu0hs.startIdleTransaction)(// eslint-disable-next-line deprecation/deprecation
        (0, $cmFjP.getCurrentHub)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $1cb05507144a6a23$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $1cb05507144a6a23$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $1cb05507144a6a23$var$registerInpInteractionListener(interactionIdtoRouteNameMapping, latestRoute) {
    (0, $bVXeC.addPerformanceInstrumentationHandler)("event", ({ entries: entries })=>{
        const client = (0, $b8438.getClient)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $5UTPE.getActiveTransaction)();
        const currentScope = (0, $b8438.getCurrentScope)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        for (const entry of entries)if ($1cb05507144a6a23$var$isPerformanceEventTiming(entry)) {
            const duration = entry.duration;
            const keys = Object.keys(interactionIdtoRouteNameMapping);
            const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                return interactionIdtoRouteNameMapping[a].duration < interactionIdtoRouteNameMapping[b].duration ? a : b;
            }) : undefined;
            if (minInteractionId === undefined || duration > interactionIdtoRouteNameMapping[minInteractionId].duration) {
                const interactionId = entry.interactionId;
                const routeName = latestRoute.name;
                const parentContext = latestRoute.context;
                if (interactionId && routeName && parentContext) {
                    if (minInteractionId && Object.keys(interactionIdtoRouteNameMapping).length >= $1cb05507144a6a23$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete interactionIdtoRouteNameMapping[minInteractionId];
                    interactionIdtoRouteNameMapping[interactionId] = {
                        routeName: routeName,
                        duration: duration,
                        parentContext: parentContext,
                        user: user,
                        activeTransaction: activeTransaction,
                        replayId: replayId
                    };
                }
            }
        }
    });
}
function $1cb05507144a6a23$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

});
parcelRegister("gu0hs", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => $bfffaa6649a6ba90$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $bfffaa6649a6ba90$export$653d0ef2bad9cdf9);

var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $jfPQV = parcelRequire("jfPQV");

var $54O61 = parcelRequire("54O61");

var $2EZoq = parcelRequire("2EZoq");

var $kJ1jU = parcelRequire("kJ1jU");

var $6Tqu0 = parcelRequire("6Tqu0");
/** Returns all trace headers that are currently on the top scope. */ function $bfffaa6649a6ba90$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $jfPQV.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $bfffaa6649a6ba90$var$_startTransaction(transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $6Tqu0.Transaction)(transactionContext, this);
    transaction = (0, $kJ1jU.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $bfffaa6649a6ba90$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $2EZoq.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $kJ1jU.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $bfffaa6649a6ba90$export$653d0ef2bad9cdf9() {
    const carrier = (0, $cmFjP.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $bfffaa6649a6ba90$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $bfffaa6649a6ba90$var$traceHeaders;
    (0, $54O61.registerErrorInstrumentation)();
}

});
parcelRegister("54O61", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $3b242f8574a305e5$export$637857c1d87b640c);

var $isDtX = parcelRequire("isDtX");
var $e5Ga6 = parcelRequire("e5Ga6");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $5UTPE = parcelRequire("5UTPE");
let $3b242f8574a305e5$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $3b242f8574a305e5$export$637857c1d87b640c() {
    if ($3b242f8574a305e5$var$errorsInstrumented) return;
    $3b242f8574a305e5$var$errorsInstrumented = true;
    (0, $isDtX.addGlobalErrorInstrumentationHandler)($3b242f8574a305e5$var$errorCallback);
    (0, $e5Ga6.addGlobalUnhandledRejectionInstrumentationHandler)($3b242f8574a305e5$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $3b242f8574a305e5$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $5UTPE.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$3b242f8574a305e5$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRegister("5UTPE", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", () => $44ed7dd0e837ba6e$export$a7feb32fdd923295);

var $65HJt = parcelRequire("65HJt");

var $cmFjP = parcelRequire("cmFjP");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ function $44ed7dd0e837ba6e$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $cmFjP.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $44ed7dd0e837ba6e$export$8e9a29865c0a1226 = (0, $65HJt.extractTraceparentData);

});


parcelRegister("2EZoq", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $1efef08b5fe9fa0b$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $1efef08b5fe9fa0b$export$b279e6bd7040371f);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");

var $8IHa9 = parcelRequire("8IHa9");

var $jfPQV = parcelRequire("jfPQV");

var $cKEJC = parcelRequire("cKEJC");

var $6Tqu0 = parcelRequire("6Tqu0");
const $1efef08b5fe9fa0b$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $1efef08b5fe9fa0b$var$FINISH_REASON_TAG = "finishReason";
const $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $1efef08b5fe9fa0b$export$370d6113c18ba86c extends (0, $cKEJC.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $jfPQV.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $1efef08b5fe9fa0b$export$b279e6bd7040371f extends (0, $6Tqu0.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $1efef08b5fe9fa0b$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $jfPQV.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($1efef08b5fe9fa0b$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $8IHa9.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $4g0Ct.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $jfPQV.spanToJSON)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $jfPQV.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $8IHa9.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $4g0Ct.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $4g0Ct.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] flushing IdleTransaction");
        } else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $1efef08b5fe9fa0b$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $cvSY8.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("cKEJC", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $948960fec1caf8ab$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $948960fec1caf8ab$export$5f1714a13ed34c01);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");

var $8IHa9 = parcelRequire("8IHa9");

var $B23rB = parcelRequire("B23rB");

var $h5OHf = parcelRequire("h5OHf");

var $ga8Oo = parcelRequire("ga8Oo");

var $jfPQV = parcelRequire("jfPQV");

var $9pnio = parcelRequire("9pnio");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $948960fec1caf8ab$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $948960fec1caf8ab$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $b1E2c.uuid4)();
        this._spanId = spanContext.spanId || (0, $b1E2c.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $cvSY8.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || "manual",
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $jfPQV.TRACE_FLAG_SAMPLED) : (0, $jfPQV.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $948960fec1caf8ab$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $ga8Oo.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $8IHa9.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $jfPQV.spanToJSON)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $4g0Ct.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $9pnio.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $ga8Oo.getRootSpan)(this);
        if ((0, $8IHa9.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $4g0Ct.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $jfPQV.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $jfPQV.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $jfPQV.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $B23rB.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("B23rB", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", () => $06f50cce9c869194$export$2e7205e45c58797d);

var $jL8lq = parcelRequire("jL8lq");




var $fJmes = parcelRequire("fJmes");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $06f50cce9c869194$var$SPAN_METRIC_SUMMARY;
function $06f50cce9c869194$var$getMetricStorageForSpan(span) {
    return $06f50cce9c869194$var$SPAN_METRIC_SUMMARY ? $06f50cce9c869194$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $06f50cce9c869194$export$2e7205e45c58797d(span) {
    const storage = $06f50cce9c869194$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $jL8lq.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $06f50cce9c869194$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $fJmes.getActiveSpan)();
    if (span) {
        const storage = $06f50cce9c869194$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$06f50cce9c869194$var$SPAN_METRIC_SUMMARY) $06f50cce9c869194$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $06f50cce9c869194$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("fJmes", function(module, exports) {

$parcel$export(module.exports, "startInactiveSpan", () => $b73c4ddb8b981968$export$63dbba021a6b4047);
$parcel$export(module.exports, "getActiveSpan", () => $b73c4ddb8b981968$export$1be426a8e585c83e);
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $b73c4ddb8b981968$export$c08fbc656a245d03);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");
var $65HJt = parcelRequire("65HJt");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $jfPQV = parcelRequire("jfPQV");



var $bPHT6 = parcelRequire("bPHT6");

var $b8438 = parcelRequire("b8438");

var $b5vSa = parcelRequire("b5vSa");

var $duCnO = parcelRequire("duCnO");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $b73c4ddb8b981968$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = (0, $b8438.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    const activeSpan = $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $b5vSa.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$a1bd95187356f372(context, callback) {
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return (0, $b8438.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $cmFjP.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $b5vSa.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $jfPQV.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $b73c4ddb8b981968$export$cb9e396e6b90b703 = $b73c4ddb8b981968$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$c10292ad04b92aea(context, callback) {
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return (0, $b8438.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $cmFjP.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $b5vSa.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $jfPQV.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$63dbba021a6b4047(context) {
    if (!(0, $duCnO.hasTracingEnabled)()) return undefined;
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $b73c4ddb8b981968$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $b8438.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $b73c4ddb8b981968$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $b8438.getCurrentScope)().getSpan();
}
const $b73c4ddb8b981968$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $b8438.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $65HJt.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $8IHa9.DEBUG_BUILD) && traceparentData) (0, $4g0Ct.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $jL8lq.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $duCnO.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $bPHT6.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $jfPQV.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $b73c4ddb8b981968$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $b73c4ddb8b981968$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $jfPQV.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $b73c4ddb8b981968$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $jL8lq.addNonEnumerableProperty)(span, $b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $jL8lq.addNonEnumerableProperty)(span, $b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $b73c4ddb8b981968$export$c08fbc656a245d03(span) {
    return {
        scope: span[$b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("b5vSa", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", () => $8128e29c1611c34e$export$18ce21a8b7efd7e9);

var $2zW56 = parcelRequire("2zW56");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $8128e29c1611c34e$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $8128e29c1611c34e$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $8128e29c1611c34e$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $2zW56.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("duCnO", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $9d2bd9c413e91a74$export$5008da00b1b6dee6);

var $b8438 = parcelRequire("b8438");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $9d2bd9c413e91a74$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $b8438.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});



parcelRegister("h5OHf", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $033619b8172dea69$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $033619b8172dea69$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $033619b8172dea69$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $033619b8172dea69$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $033619b8172dea69$export$1efec95406bbe327);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $033619b8172dea69$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $033619b8172dea69$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $033619b8172dea69$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $033619b8172dea69$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $033619b8172dea69$export$1efec95406bbe327 = "profile_id";

});

parcelRegister("9pnio", function(module, exports) {

$parcel$export(module.exports, "setHttpStatus", () => $6d9884e3956d809f$export$2ad6630ec8164254);
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $6d9884e3956d809f$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($6d9884e3956d809f$export$beb8e6a823e89c5d || ($6d9884e3956d809f$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $6d9884e3956d809f$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $6d9884e3956d809f$export$ac65c70d78fcdb55 = $6d9884e3956d809f$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $6d9884e3956d809f$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $6d9884e3956d809f$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}

});


parcelRegister("6Tqu0", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $504c6c1458d8d0e9$export$febc5573c75cefb0);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $B23rB = parcelRequire("B23rB");

var $h5OHf = parcelRequire("h5OHf");

var $jfPQV = parcelRequire("jfPQV");

var $bPHT6 = parcelRequire("bPHT6");

var $cKEJC = parcelRequire("cKEJC");

var $fJmes = parcelRequire("fJmes");
/** JSDoc */ class $504c6c1458d8d0e9$export$febc5573c75cefb0 extends (0, $cKEJC.Span) {
    /**
   * The reference to the current hub.
   */ // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $cmFjP.getCurrentHub)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $cKEJC.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $jfPQV.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $jL8lq.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $bPHT6.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $jfPQV.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $jfPQV.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $fJmes.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $jfPQV.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $jL8lq.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $bPHT6.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $B23rB.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("kJ1jU", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", () => $f16908c3df50a491$export$b3258c3993bc9b71);
$parcel$export(module.exports, "isValidSampleRate", () => $f16908c3df50a491$export$2603c8d332a51c42);

var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $h5OHf = parcelRequire("h5OHf");

var $duCnO = parcelRequire("duCnO");

var $jfPQV = parcelRequire("jfPQV");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $f16908c3df50a491$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $duCnO.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$f16908c3df50a491$export$2603c8d332a51c42(sampleRate)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $8IHa9.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $4g0Ct.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $jfPQV.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $f16908c3df50a491$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $2zW56.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("ef7As", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $a5e85a0c259bdb77$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a5e85a0c259bdb77$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("eaxd5", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", () => $a50bc2aef3fcf638$export$6f18f55521af71a1);

var $5UTPE = parcelRequire("5UTPE");
var $jfPQV = parcelRequire("jfPQV");

var $4g0Ct = parcelRequire("4g0Ct");

var $ef7As = parcelRequire("ef7As");

var $lR7hQ = parcelRequire("lR7hQ");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $a50bc2aef3fcf638$export$6f18f55521af71a1() {
    if ((0, $lR7hQ.WINDOW) && (0, $lR7hQ.WINDOW).document) (0, $lR7hQ.WINDOW).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $5UTPE.getActiveTransaction)();
        if ((0, $lR7hQ.WINDOW).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $jfPQV.spanToJSON)(activeTransaction);
            (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}

});
parcelRegister("lR7hQ", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $fe9433352f19d4b6$export$56d8a8a25bd48b81);

var $3bpJ1 = parcelRequire("3bpJ1");
const $fe9433352f19d4b6$export$56d8a8a25bd48b81 = (0, $3bpJ1.GLOBAL_OBJ);

});


parcelRegister("bVXeC", function(module, exports) {

$parcel$export(module.exports, "addClsInstrumentationHandler", () => $8b02f76565f096cc$export$861b82818b37ba5b);
$parcel$export(module.exports, "addLcpInstrumentationHandler", () => $8b02f76565f096cc$export$3fd4b53331200102);
$parcel$export(module.exports, "addFidInstrumentationHandler", () => $8b02f76565f096cc$export$2707d7471c0b918f);
$parcel$export(module.exports, "addInpInstrumentationHandler", () => $8b02f76565f096cc$export$da3b76aa2022cbd7);
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", () => $8b02f76565f096cc$export$69816c1a049f8db6);

var $16dZf = parcelRequire("16dZf");
var $4g0Ct = parcelRequire("4g0Ct");

var $ef7As = parcelRequire("ef7As");

var $ASru9 = parcelRequire("ASru9");

var $lNnZe = parcelRequire("lNnZe");

var $lWdw3 = parcelRequire("lWdw3");

var $hlPhs = parcelRequire("hlPhs");

var $h0Rau = parcelRequire("h0Rau");
const $8b02f76565f096cc$var$handlers = {};
const $8b02f76565f096cc$var$instrumented = {};
let $8b02f76565f096cc$var$_previousCls;
let $8b02f76565f096cc$var$_previousFid;
let $8b02f76565f096cc$var$_previousLcp;
let $8b02f76565f096cc$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $8b02f76565f096cc$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $8b02f76565f096cc$var$addMetricObserver("cls", callback, $8b02f76565f096cc$var$instrumentCls, $8b02f76565f096cc$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $8b02f76565f096cc$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $8b02f76565f096cc$var$addMetricObserver("lcp", callback, $8b02f76565f096cc$var$instrumentLcp, $8b02f76565f096cc$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$2707d7471c0b918f(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("fid", callback, $8b02f76565f096cc$var$instrumentFid, $8b02f76565f096cc$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$da3b76aa2022cbd7(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("inp", callback, $8b02f76565f096cc$var$instrumentInp, $8b02f76565f096cc$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$69816c1a049f8db6(type, callback) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        $8b02f76565f096cc$var$instrumentPerformanceObserver(type);
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $8b02f76565f096cc$var$triggerHandlers(type, data) {
    const typeHandlers = $8b02f76565f096cc$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}
function $8b02f76565f096cc$var$instrumentCls() {
    return (0, $ASru9.onCLS)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("cls", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousCls = metric;
    });
}
function $8b02f76565f096cc$var$instrumentFid() {
    return (0, $lNnZe.onFID)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("fid", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousFid = metric;
    });
}
function $8b02f76565f096cc$var$instrumentLcp() {
    return (0, $hlPhs.onLCP)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("lcp", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousLcp = metric;
    });
}
function $8b02f76565f096cc$var$instrumentInp() {
    return (0, $lWdw3.onINP)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("inp", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousInp = metric;
    });
}
function $8b02f76565f096cc$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    let stopListening;
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        stopListening = instrumentFn();
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $8b02f76565f096cc$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $h0Rau.observe)(type, (entries)=>{
        $8b02f76565f096cc$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $8b02f76565f096cc$var$addHandler(type, handler) {
    $8b02f76565f096cc$var$handlers[type] = $8b02f76565f096cc$var$handlers[type] || [];
    $8b02f76565f096cc$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $8b02f76565f096cc$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $8b02f76565f096cc$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

});
parcelRegister("ASru9", function(module, exports) {

$parcel$export(module.exports, "onCLS", () => $06ed980438256cb2$export$a7873055838e5ad8);

var $1HbA2 = parcelRequire("1HbA2");

var $jZl9S = parcelRequire("jZl9S");

var $h0Rau = parcelRequire("h0Rau");

var $i7szO = parcelRequire("i7szO");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $06ed980438256cb2$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $jZl9S.initMetric)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $h0Rau.observe)("layout-shift", handleEntries);
    if (po) {
        report = (0, $1HbA2.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $i7szO.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("1HbA2", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $13c2ca2b7f8f393a$export$17679dccdd551979);
const $13c2ca2b7f8f393a$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("jZl9S", function(module, exports) {

$parcel$export(module.exports, "initMetric", () => $e8d4206fcb32f41c$export$3c29b44508a0612b);

var $lR7hQ = parcelRequire("lR7hQ");

var $7AuFo = parcelRequire("7AuFo");

var $7xVW0 = parcelRequire("7xVW0");

var $VY45i = parcelRequire("VY45i");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e8d4206fcb32f41c$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $VY45i.getNavigationEntry)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $lR7hQ.WINDOW).document.prerendering || (0, $7xVW0.getActivationStart)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $7AuFo.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("7AuFo", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", () => $5863aef6ed758511$export$407ea409d1f3b539);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $5863aef6ed758511$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("7xVW0", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", () => $57e88e157c530457$export$d3e828b3c7b5b845);

var $VY45i = parcelRequire("VY45i");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57e88e157c530457$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $VY45i.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("VY45i", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", () => $0ae3ea9e7f2c4254$export$6431553786c94949);

var $lR7hQ = parcelRequire("lR7hQ");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $lR7hQ.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $lR7hQ.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $0ae3ea9e7f2c4254$export$6431553786c94949 = ()=>{
    if ((0, $lR7hQ.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $lR7hQ.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $lR7hQ.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};

});



parcelRegister("h0Rau", function(module, exports) {

$parcel$export(module.exports, "observe", () => $c62bade033a6ea98$export$d1203567a167490e);
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $c62bade033a6ea98$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("i7szO", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4);

var $lR7hQ = parcelRequire("lR7hQ");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $lR7hQ.WINDOW).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};

});


parcelRegister("lNnZe", function(module, exports) {

$parcel$export(module.exports, "onFID", () => $fde0c7d375f4fcfc$export$39705a25c49af873);

var $1HbA2 = parcelRequire("1HbA2");

var $fGWFf = parcelRequire("fGWFf");

var $jZl9S = parcelRequire("jZl9S");

var $h0Rau = parcelRequire("h0Rau");

var $i7szO = parcelRequire("i7szO");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $fde0c7d375f4fcfc$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $fGWFf.getVisibilityWatcher)();
    const metric = (0, $jZl9S.initMetric)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $h0Rau.observe)("first-input", handleEntries);
    report = (0, $1HbA2.bindReporter)(onReport, metric);
    if (po) (0, $i7szO.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("fGWFf", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", () => $b6c848c639162360$export$443f86b2c77012c4);

var $lR7hQ = parcelRequire("lR7hQ");

var $i7szO = parcelRequire("i7szO");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b6c848c639162360$var$firstHiddenTime = -1;
const $b6c848c639162360$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $lR7hQ.WINDOW).document.visibilityState === "hidden" && !(0, $lR7hQ.WINDOW).document.prerendering ? 0 : Infinity;
};
const $b6c848c639162360$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $i7szO.onHidden)(({ timeStamp: timeStamp })=>{
        $b6c848c639162360$var$firstHiddenTime = timeStamp;
    }, true);
};
const $b6c848c639162360$export$443f86b2c77012c4 = ()=>{
    if ($b6c848c639162360$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $b6c848c639162360$var$firstHiddenTime = $b6c848c639162360$var$initHiddenTime();
        $b6c848c639162360$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $b6c848c639162360$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("lWdw3", function(module, exports) {

$parcel$export(module.exports, "onINP", () => $ff897fbbb59b5bdf$export$7df4b36ecaed99e1);

var $1HbA2 = parcelRequire("1HbA2");

var $jZl9S = parcelRequire("jZl9S");

var $h0Rau = parcelRequire("h0Rau");

var $i7szO = parcelRequire("i7szO");

var $7BllH = parcelRequire("7BllH");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $ff897fbbb59b5bdf$var$getInteractionCountForNavigation = ()=>{
    return (0, $7BllH.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $ff897fbbb59b5bdf$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $ff897fbbb59b5bdf$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $ff897fbbb59b5bdf$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $ff897fbbb59b5bdf$var$longestInteractionList[$ff897fbbb59b5bdf$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $ff897fbbb59b5bdf$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $ff897fbbb59b5bdf$var$longestInteractionList.length < $ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $ff897fbbb59b5bdf$var$longestInteractionMap[interaction.id] = interaction;
            $ff897fbbb59b5bdf$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $ff897fbbb59b5bdf$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $ff897fbbb59b5bdf$var$longestInteractionList.splice($ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $ff897fbbb59b5bdf$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $ff897fbbb59b5bdf$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($ff897fbbb59b5bdf$var$longestInteractionList.length - 1, Math.floor($ff897fbbb59b5bdf$var$getInteractionCountForNavigation() / 50));
    return $ff897fbbb59b5bdf$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $ff897fbbb59b5bdf$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $7BllH.initInteractionCountPolyfill)();
    const metric = (0, $jZl9S.initMetric)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $ff897fbbb59b5bdf$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$ff897fbbb59b5bdf$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $ff897fbbb59b5bdf$var$processEntry(entry);
            }
        });
        const inp = $ff897fbbb59b5bdf$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $h0Rau.observe)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $1HbA2.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $i7szO.onHidden)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $ff897fbbb59b5bdf$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

});
parcelRegister("7BllH", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", () => $588c8c9828db8996$export$8a962f2683a476d1);
$parcel$export(module.exports, "initInteractionCountPolyfill", () => $588c8c9828db8996$export$67d90cda6b78a2eb);

var $h0Rau = parcelRequire("h0Rau");
let $588c8c9828db8996$var$interactionCountEstimate = 0;
let $588c8c9828db8996$var$minKnownInteractionId = Infinity;
let $588c8c9828db8996$var$maxKnownInteractionId = 0;
const $588c8c9828db8996$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $588c8c9828db8996$var$minKnownInteractionId = Math.min($588c8c9828db8996$var$minKnownInteractionId, e.interactionId);
            $588c8c9828db8996$var$maxKnownInteractionId = Math.max($588c8c9828db8996$var$maxKnownInteractionId, e.interactionId);
            $588c8c9828db8996$var$interactionCountEstimate = $588c8c9828db8996$var$maxKnownInteractionId ? ($588c8c9828db8996$var$maxKnownInteractionId - $588c8c9828db8996$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $588c8c9828db8996$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $588c8c9828db8996$export$8a962f2683a476d1 = ()=>{
    return $588c8c9828db8996$var$po ? $588c8c9828db8996$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $588c8c9828db8996$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $588c8c9828db8996$var$po) return;
    $588c8c9828db8996$var$po = (0, $h0Rau.observe)("event", $588c8c9828db8996$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("hlPhs", function(module, exports) {

$parcel$export(module.exports, "onLCP", () => $ca1c2d1679c3e1ef$export$947b1626ab8d5632);

var $1HbA2 = parcelRequire("1HbA2");

var $7xVW0 = parcelRequire("7xVW0");

var $fGWFf = parcelRequire("fGWFf");

var $jZl9S = parcelRequire("jZl9S");

var $h0Rau = parcelRequire("h0Rau");

var $i7szO = parcelRequire("i7szO");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ca1c2d1679c3e1ef$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $ca1c2d1679c3e1ef$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $fGWFf.getVisibilityWatcher)();
    const metric = (0, $jZl9S.initMetric)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $7xVW0.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $h0Rau.observe)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $1HbA2.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $i7szO.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});


parcelRegister("jbMYb", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", () => $df8507bffbb2043c$export$7c69f0412d101b88);
$parcel$export(module.exports, "startTrackingLongTasks", () => $df8507bffbb2043c$export$f396d19077034ad2);
$parcel$export(module.exports, "startTrackingInteractions", () => $df8507bffbb2043c$export$e27543e0976315e4);
$parcel$export(module.exports, "startTrackingINP", () => $df8507bffbb2043c$export$f17d06681a4744a3);
$parcel$export(module.exports, "addPerformanceEntries", () => $df8507bffbb2043c$export$5f8fa6b3467a7443);

var $3lXaQ = parcelRequire("3lXaQ");
var $5UTPE = parcelRequire("5UTPE");
var $b8438 = parcelRequire("b8438");
var $duCnO = parcelRequire("duCnO");
var $kJ1jU = parcelRequire("kJ1jU");
var $cqs41 = parcelRequire("cqs41");
var $cKEJC = parcelRequire("cKEJC");
var $jfPQV = parcelRequire("jfPQV");

var $cvSY8 = parcelRequire("cvSY8");
var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");
var $3bJff = parcelRequire("3bJff");

var $ef7As = parcelRequire("ef7As");

var $bVXeC = parcelRequire("bVXeC");

var $lR7hQ = parcelRequire("lR7hQ");

var $fGWFf = parcelRequire("fGWFf");

var $89BSK = parcelRequire("89BSK");
const $df8507bffbb2043c$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $df8507bffbb2043c$var$msToSec(time) {
    return time / 1000;
}
function $df8507bffbb2043c$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $lR7hQ.WINDOW) && (0, $lR7hQ.WINDOW).addEventListener && (0, $lR7hQ.WINDOW).performance;
}
let $df8507bffbb2043c$var$_performanceCursor = 0;
let $df8507bffbb2043c$var$_measurements = {};
let $df8507bffbb2043c$var$_lcpEntry;
let $df8507bffbb2043c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $df8507bffbb2043c$export$7c69f0412d101b88() {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (performance && (0, $cvSY8.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $lR7hQ.WINDOW).performance.mark("sentry-tracing-init");
        const fidCallback = $df8507bffbb2043c$var$_trackFID();
        const clsCallback = $df8507bffbb2043c$var$_trackCLS();
        const lcpCallback = $df8507bffbb2043c$var$_trackLCP();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $df8507bffbb2043c$export$f396d19077034ad2() {
    (0, $bVXeC.addPerformanceInstrumentationHandler)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $5UTPE.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $df8507bffbb2043c$export$e27543e0976315e4() {
    (0, $bVXeC.addPerformanceInstrumentationHandler)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $5UTPE.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
                const span = {
                    description: (0, $ibKgU.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $ibKgU.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $df8507bffbb2043c$export$f17d06681a4744a3(interactionIdtoRouteNameMapping) {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (performance && (0, $cvSY8.browserPerformanceTimeOrigin)) {
        const inpCallback = $df8507bffbb2043c$var$_trackINP(interactionIdtoRouteNameMapping);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $df8507bffbb2043c$var$_trackCLS() {
    return (0, $bVXeC.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding CLS");
        $df8507bffbb2043c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $df8507bffbb2043c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $df8507bffbb2043c$var$_trackLCP() {
    return (0, $bVXeC.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding LCP");
        $df8507bffbb2043c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $df8507bffbb2043c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $df8507bffbb2043c$var$_trackFID() {
    return (0, $bVXeC.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin));
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding FID");
        $df8507bffbb2043c$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $df8507bffbb2043c$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Starts tracking the Interaction to Next Paint on the current page. */ function $df8507bffbb2043c$var$_trackINP(interactionIdtoRouteNameMapping) {
    return (0, $bVXeC.addInpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries.find((e)=>e.name === "click");
        const client = (0, $b8438.getClient)();
        if (!entry || !client) return;
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $df8507bffbb2043c$var$msToSec(metric.value);
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = entry.interactionId !== undefined ? interactionIdtoRouteNameMapping[entry.interactionId] : {
            routeName: undefined,
            parentContext: undefined,
            activeTransaction: undefined,
            user: undefined,
            replayId: undefined
        };
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $cKEJC.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: "ui.interaction.click",
            name: (0, $ibKgU.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $df8507bffbb2043c$var$getSampleRate(parentContext, options);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $3lXaQ.createSpanEnvelope)([
                span
            ]) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $df8507bffbb2043c$export$5f8fa6b3467a7443(transaction) {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $lR7hQ.WINDOW).performance.getEntries || !(0, $cvSY8.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    const { op: op, start_timestamp: transactionStartTime } = (0, $jfPQV.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($df8507bffbb2043c$var$_performanceCursor).forEach((entry)=>{
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $fGWFf.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding FP");
                        $df8507bffbb2043c$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding FCP");
                        $df8507bffbb2043c$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $df8507bffbb2043c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $df8507bffbb2043c$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $df8507bffbb2043c$export$45095b07f0832bb1($df8507bffbb2043c$var$_measurements, responseStartTimestamp, requestStartTimestamp, transactionStartTime);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$df8507bffbb2043c$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $df8507bffbb2043c$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $df8507bffbb2043c$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $df8507bffbb2043c$var$_measurements["mark.fid"];
        if (fidMark && $df8507bffbb2043c$var$_measurements["fid"]) {
            // create span for FID
            (0, $89BSK._startChild)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $df8507bffbb2043c$var$msToSec($df8507bffbb2043c$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $df8507bffbb2043c$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $df8507bffbb2043c$var$_measurements)) delete $df8507bffbb2043c$var$_measurements.cls;
        Object.keys($df8507bffbb2043c$var$_measurements).forEach((measurementName)=>{
            (0, $cqs41.setMeasurement)(measurementName, $df8507bffbb2043c$var$_measurements[measurementName].value, $df8507bffbb2043c$var$_measurements[measurementName].unit);
        });
        $df8507bffbb2043c$var$_tagMetricInfo(transaction);
    }
    $df8507bffbb2043c$var$_lcpEntry = undefined;
    $df8507bffbb2043c$var$_clsEntry = undefined;
    $df8507bffbb2043c$var$_measurements = {};
}
/** Create measure related spans */ function $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $89BSK._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $89BSK._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(start),
        endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $89BSK._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
        });
        (0, $89BSK._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $3bJff.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $lR7hQ.WINDOW).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $89BSK._startChild)(transaction, {
        description: resourceUrl.replace((0, $lR7hQ.WINDOW).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $df8507bffbb2043c$var$_trackNavigator(transaction) {
    const navigator = (0, $lR7hQ.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $89BSK.isMeasurementValue)(connection.rtt)) $df8507bffbb2043c$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $89BSK.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $89BSK.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $df8507bffbb2043c$var$_tagMetricInfo(transaction) {
    if ($df8507bffbb2043c$var$_lcpEntry) {
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($df8507bffbb2043c$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $ibKgU.htmlTreeAsString)($df8507bffbb2043c$var$_lcpEntry.element));
        if ($df8507bffbb2043c$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $df8507bffbb2043c$var$_lcpEntry.id);
        if ($df8507bffbb2043c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $df8507bffbb2043c$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $df8507bffbb2043c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($df8507bffbb2043c$var$_clsEntry && $df8507bffbb2043c$var$_clsEntry.sources) {
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding CLS Data");
        $df8507bffbb2043c$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $ibKgU.htmlTreeAsString)(source.node)));
    }
}
function $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $df8507bffbb2043c$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb information to measurements
 *
 * Exported for tests
 */ function $df8507bffbb2043c$export$45095b07f0832bb1(_measurements, responseStartTimestamp, requestStartTimestamp, transactionStartTime) {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === "number" && transactionStartTime) {
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding TTFB");
        _measurements["ttfb"] = {
            // As per https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStart,
            // responseStart can be 0 if the request is coming straight from the cache.
            // This might lead us to calculate a negative ttfb if we don't use Math.max here.
            //
            // This logic is the same as what is in the web-vitals library to calculate ttfb
            // https://github.com/GoogleChrome/web-vitals/blob/2301de5015e82b09925238a228a0893635854587/src/onTTFB.ts#L92
            // TODO(abhi): We should use the web-vitals library instead of this custom calculation.
            value: Math.max(responseStartTimestamp - transactionStartTime, 0) * 1000,
            unit: "millisecond"
        };
        if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements["ttfb.requestTime"] = {
            value: (responseStartTimestamp - requestStartTimestamp) * 1000,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $df8507bffbb2043c$var$getSampleRate(transactionContext, options) {
    if (!(0, $duCnO.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $lR7hQ.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $kJ1jU.isValidSampleRate)(sampleRate)) {
        (0, $ef7As.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return false;
    }
    return sampleRate;
}

});
parcelRegister("3lXaQ", function(module, exports) {

$parcel$export(module.exports, "createSpanEnvelope", () => $27113bf3441639bf$export$19a0081d4b39d77);

var $3PPTH = parcelRequire("3PPTH");
/**
 * Create envelope from Span item.
 */ function $27113bf3441639bf$export$19a0081d4b39d77(spans) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    const items = spans.map($27113bf3441639bf$var$createSpanItem);
    return (0, $3PPTH.createEnvelope)(headers, items);
}
function $27113bf3441639bf$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}

});

parcelRegister("cqs41", function(module, exports) {

$parcel$export(module.exports, "setMeasurement", () => $90bdaea68141640c$export$7cc31b475d33a706);

var $5UTPE = parcelRequire("5UTPE");
/**
 * Adds a measurement to the current active transaction.
 */ function $90bdaea68141640c$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $5UTPE.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

});

parcelRegister("89BSK", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", () => $5efc8c95ea982b90$export$27169ccae1b439e3);
$parcel$export(module.exports, "_startChild", () => $5efc8c95ea982b90$export$8bd469e1f37aa721);
/**
 * Checks if a given value is a valid measurement value.
 */ function $5efc8c95ea982b90$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $5efc8c95ea982b90$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("jAq9Y", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => $e425abf0f1e5a10f$export$864489cb3478db3e);

var $b8438 = parcelRequire("b8438");
var $bPHT6 = parcelRequire("bPHT6");
var $cmFjP = parcelRequire("cmFjP");
var $duCnO = parcelRequire("duCnO");
var $h5OHf = parcelRequire("h5OHf");
var $9pnio = parcelRequire("9pnio");
var $jfPQV = parcelRequire("jfPQV");
var $fJmes = parcelRequire("fJmes");

var $j8BFi = parcelRequire("j8BFi");
var $eYtML = parcelRequire("eYtML");
var $dzA7g = parcelRequire("dzA7g");
var $cvSY8 = parcelRequire("cvSY8");
var $65HJt = parcelRequire("65HJt");
var $91U3U = parcelRequire("91U3U");

var $g513L = parcelRequire("g513L");

var $bVXeC = parcelRequire("bVXeC");
/* eslint-disable max-lines */ const $e425abf0f1e5a10f$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $e425abf0f1e5a10f$export$15bd0305d05ad07b,
    tracePropagationTargets: $e425abf0f1e5a10f$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $e425abf0f1e5a10f$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $j8BFi.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $g513L.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $eYtML.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
}
function $e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $e425abf0f1e5a10f$var$addHTTPTimings(span) {
    const { url: url } = (0, $jfPQV.spanToJSON)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $bVXeC.addPerformanceInstrumentationHandler)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $e425abf0f1e5a10f$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $e425abf0f1e5a10f$var$getAbsoluteTime(time = 0) {
    return (((0, $cvSY8.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $e425abf0f1e5a10f$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $cvSY8.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $91U3U.stringMatchesSomePattern)(url, tracePropagationTargets || $e425abf0f1e5a10f$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $eYtML.SENTRY_XHR_DATA_KEY];
    if (!(0, $duCnO.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $9pnio.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $b8438.getCurrentScope)();
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const span = shouldCreateSpanResult ? (0, $fJmes.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url,
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $b8438.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $jfPQV.spanToTraceHeader)(span) : (0, $65HJt.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $dzA7g.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $bPHT6.getDynamicSamplingContextFromSpan)(span) : (0, $bPHT6.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $dzA7g.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}

});
parcelRegister("g513L", function(module, exports) {

$parcel$export(module.exports, "instrumentFetchRequest", () => $bb4def6c8b51e56d$export$6d73c62358c655be);

var $b8438 = parcelRequire("b8438");
var $bPHT6 = parcelRequire("bPHT6");
var $cmFjP = parcelRequire("cmFjP");
var $duCnO = parcelRequire("duCnO");
var $h5OHf = parcelRequire("h5OHf");
var $9pnio = parcelRequire("9pnio");
var $jfPQV = parcelRequire("jfPQV");
var $fJmes = parcelRequire("fJmes");

var $dzA7g = parcelRequire("dzA7g");
var $65HJt = parcelRequire("65HJt");
var $2zW56 = parcelRequire("2zW56");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $bb4def6c8b51e56d$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $duCnO.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                (0, $9pnio.setHttpStatus)(span, handlerData.response.status);
                const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                if (contentLength) {
                    const contentLengthNum = parseInt(contentLength);
                    if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
                }
            } else if (handlerData.error) span.setStatus("internal_error");
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $b8438.getCurrentScope)();
    const client = (0, $b8438.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult ? (0, $fJmes.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $jfPQV.spanToTraceHeader)(span) : (0, $65HJt.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $dzA7g.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $bPHT6.getDynamicSamplingContextFromSpan)(span) : (0, $bPHT6.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $2zW56.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $2zW56.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $dzA7g.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $dzA7g.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}

});



parcelRegister("aDaS8", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => (parcelRequire("6JSNk")).WINDOW);

var $a9oM8 = parcelRequire("a9oM8");

var $6JSNk = parcelRequire("6JSNk");







var $6zmxU = parcelRequire("6zmxU");







var $a05ws = parcelRequire("a05ws");




var $2sI0s = parcelRequire("2sI0s");



let $7bd5fae7baa5e8bf$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $6JSNk.WINDOW).Sentry && (0, $6JSNk.WINDOW).Sentry.Integrations) $7bd5fae7baa5e8bf$var$windowIntegrations = (0, $6JSNk.WINDOW).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $7bd5fae7baa5e8bf$export$99d02219d259eb94 = {
    ...$7bd5fae7baa5e8bf$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $a9oM8.Integrations),
    ...$a05ws
};

});
parcelRegister("a9oM8", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $763df686ae13a93b$export$99d02219d259eb94);

var $gu0hs = parcelRequire("gu0hs");

var $2EZoq = parcelRequire("2EZoq");

var $cKEJC = parcelRequire("cKEJC");


var $5UTPE = parcelRequire("5UTPE");

var $9pnio = parcelRequire("9pnio");

var $fJmes = parcelRequire("fJmes");

var $bPHT6 = parcelRequire("bPHT6");

var $cqs41 = parcelRequire("cqs41");

var $kJ1jU = parcelRequire("kJ1jU");

var $h5OHf = parcelRequire("h5OHf");


var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");





var $iDxMj = parcelRequire("iDxMj");

var $80A9Z = parcelRequire("80A9Z");


var $cCtO1 = parcelRequire("cCtO1");

var $7j791 = parcelRequire("7j791");




var $71tRZ = parcelRequire("71tRZ");




var $3lXaQ = parcelRequire("3lXaQ");

var $duCnO = parcelRequire("duCnO");




var $jfPQV = parcelRequire("jfPQV");

var $ga8Oo = parcelRequire("ga8Oo");

var $htFdx = parcelRequire("htFdx");




var $6jMsx = parcelRequire("6jMsx");

var $hKg1m = parcelRequire("hKg1m");


var $icP6J = parcelRequire("icP6J");

/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $763df686ae13a93b$export$99d02219d259eb94 = $icP6J;

});
parcelRegister("icP6J", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("hKg1m")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("6jMsx")).InboundFilters);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("eyaGL")).LinkedErrors);

var $hKg1m = parcelRequire("hKg1m");

var $6jMsx = parcelRequire("6jMsx");

var $eyaGL = parcelRequire("eyaGL");
 /* eslint-disable deprecation/deprecation */ 
});
parcelRegister("eyaGL", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", () => $a97c883563fbc553$export$8d1e60aaf616fb4f);

var $b1zT6 = parcelRequire("b1zT6");
var $goTyw = parcelRequire("goTyw");

var $71tRZ = parcelRequire("71tRZ");
const $a97c883563fbc553$var$DEFAULT_KEY = "cause";
const $a97c883563fbc553$var$DEFAULT_LIMIT = 5;
const $a97c883563fbc553$var$INTEGRATION_NAME = "LinkedErrors";
const $a97c883563fbc553$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $a97c883563fbc553$var$DEFAULT_LIMIT;
    const key = options.key || $a97c883563fbc553$var$DEFAULT_KEY;
    return {
        name: $a97c883563fbc553$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $b1zT6.applyAggregateErrorsToEvent)((0, $goTyw.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $a97c883563fbc553$export$ebabb00eb7f3a395 = (0, $71tRZ.defineIntegration)($a97c883563fbc553$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a97c883563fbc553$export$8d1e60aaf616fb4f = (0, $71tRZ.convertIntegrationFnToClass)($a97c883563fbc553$var$INTEGRATION_NAME, $a97c883563fbc553$export$ebabb00eb7f3a395);

});
parcelRegister("goTyw", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $bf09fb77f1b0ae9a$export$a6c2d27607295951);

var $2zW56 = parcelRequire("2zW56");

var $b1E2c = parcelRequire("b1E2c");

var $drMc1 = parcelRequire("drMc1");

var $jL8lq = parcelRequire("jL8lq");
/**
 * Extracts stack frames from the error.stack string
 */ function $bf09fb77f1b0ae9a$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $bf09fb77f1b0ae9a$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $bf09fb77f1b0ae9a$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $bf09fb77f1b0ae9a$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $jL8lq.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $bf09fb77f1b0ae9a$export$9dd56ed1ef0c3420(getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $2zW56.isError)(exception)) {
        if ((0, $2zW56.isPlainObject)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $drMc1.normalizeToSize)(exception, normalizeDepth)
            };
            const message = $bf09fb77f1b0ae9a$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $bf09fb77f1b0ae9a$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $b1E2c.addExceptionTypeValue)(event, undefined, undefined);
    (0, $b1E2c.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $bf09fb77f1b0ae9a$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $bf09fb77f1b0ae9a$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $2zW56.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

});




parcelRegister("a05ws", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("dw5F0")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("llG7W")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("fxK4w")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("9SQUp")).LinkedErrors);
$parcel$export(module.exports, "HttpContext", () => (parcelRequire("efOBd")).HttpContext);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("bMyDX")).Dedupe);

var $dw5F0 = parcelRequire("dw5F0");

var $llG7W = parcelRequire("llG7W");

var $fxK4w = parcelRequire("fxK4w");

var $9SQUp = parcelRequire("9SQUp");

var $efOBd = parcelRequire("efOBd");

var $bMyDX = parcelRequire("bMyDX");
 /* eslint-disable deprecation/deprecation */ 
});


parcelRegister("6bnLz", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $480634a75d8ae79a$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $480634a75d8ae79a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});



parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};

});

parcelRegister("g7FV5", function(module, exports) {

$parcel$export(module.exports, "makeActivityLink", () => (parcelRequire("9G1do")).default);
$parcel$export(module.exports, "ActivityModuleConfig", () => (parcelRequire("cAVWq")).default);

var $9G1do = parcelRequire("9G1do");

var $cAVWq = parcelRequire("cAVWq");

});
parcelRegister("9G1do", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b8fa95a1b99229$export$2e2bcd8739ae039);
function $70b8fa95a1b99229$export$2e2bcd8739ae039(opts) {
    const params = new URLSearchParams();
    if (opts.site_user_id) params.append("site_user_id", opts.site_user_id.toString());
    if (opts.ip) params.append("ip", opts.ip);
    if (opts.client_id) params.append("client_id", opts.client_id);
    if (opts.section) params.append("section", opts.section);
    if (params.toString() === "") return "/activity";
    return `/activity?${params.toString()}`;
}

});

parcelRegister("cAVWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b5cac325a04621$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $92b5cac325a04621$var$ActivityInfo = $acw62.lazy(()=>(parcelRequire("2MPBA")));
const $92b5cac325a04621$var$ActivityModule = {
    routes: [
        (0, $fCKVd.makeSimpleRoute)({
            path: "/activity",
            name: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0456",
            element: $acw62.createElement($92b5cac325a04621$var$ActivityInfo, null),
            loader: {
                sync: {
                    data: {
                        endpoint: "activity",
                        queryString: true
                    }
                }
            }
        })
    ]
};
var $92b5cac325a04621$export$2e2bcd8739ae039 = $92b5cac325a04621$var$ActivityModule;

});
parcelRegister("2MPBA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fVQYD").then(()=>parcelRequire("ib6ij"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});




parcelRegister("dT9L5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eIfok").then(()=>parcelRequire("cHDY8"));

});

parcelRegister("1Ibm0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hU5YH").then(()=>parcelRequire("4jDiB"));

});

parcelRegister("imhCU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gIWGs").then(()=>parcelRequire("8reD0"));

});

parcelRegister("kRLTu", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("g4dkr").then(()=>parcelRequire("kgQX1"));

});

parcelRegister("bC6sA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8lIGq").then(()=>parcelRequire("gibkN"));

});

parcelRegister("kBjug", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5ifCV").then(()=>parcelRequire("lGnTN"));

});

parcelRegister("iu64A", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jiCwM").then(()=>parcelRequire("hDNEf"));

});

parcelRegister("3pf6U", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8dN4Y").then(()=>parcelRequire("2EG3x"));

});

parcelRegister("hawWd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aiFKc").then(()=>parcelRequire("9lX7m"));

});

parcelRegister("63ILp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kjs6k").then(()=>parcelRequire("dYnIk"));

});

parcelRegister("2t3aA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2kOOk").then(()=>parcelRequire("2vAQY"));

});

parcelRegister("7PZHN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gn6Zd").then(()=>parcelRequire("6nG50"));

});

parcelRegister("5dS8i", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hPeTu").then(()=>parcelRequire("ch0EE"));

});

parcelRegister("dou2U", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ddEdg").then(()=>parcelRequire("cktaX"));

});

parcelRegister("3jDBg", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("2kJM8"),
    $Gr8vk("9vkeC")
]).then(()=>parcelRequire("jpNtF"));

});

parcelRegister("7t0rb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7kyqY").then(()=>parcelRequire("h6SbI"));

});

parcelRegister("fz0YS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("qfMd7").then(()=>parcelRequire("dznXZ"));

});

parcelRegister("jbzoy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9iJ5Z").then(()=>parcelRequire("Lfhu3"));

});

parcelRegister("dv5Uq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("2kJM8"),
    $Gr8vk("1Scjg")
]).then(()=>parcelRequire("3oVOT"));

});

parcelRegister("1Y5Ni", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hBGiX").then(()=>parcelRequire("3yaYP"));

});

parcelRegister("2c6hI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cCFAn").then(()=>parcelRequire("1oaVf"));

});

parcelRegister("1Zyzf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hZfTL").then(()=>parcelRequire("dB0IZ"));

});

parcelRegister("hg4xt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3WLhj").then(()=>parcelRequire("lVdmY"));

});

parcelRegister("ljAGu", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c9CES").then(()=>parcelRequire("3KiS8"));

});

parcelRegister("3rQSa", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9yumZ").then(()=>parcelRequire("aOQBH"));

});

parcelRegister("01wJb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lMbOp").then(()=>parcelRequire("6KcZ5"));

});

parcelRegister("cOS9v", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("2kJM8"),
    $Gr8vk("boG4k")
]).then(()=>parcelRequire("cxJCX"));

});

parcelRegister("fWZAm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4MHN1").then(()=>parcelRequire("ilsOV"));

});

parcelRegister("7vpBw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fdT2Z").then(()=>parcelRequire("ahhja"));

});

parcelRegister("1a5Lm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aBpZJ").then(()=>parcelRequire("68vRh"));

});

parcelRegister("j3a7A", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1fzLI").then(()=>parcelRequire("lHcYE"));

});

parcelRegister("5KJ6Y", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("krF79").then(()=>parcelRequire("1uOP8"));

});

parcelRegister("9B9iQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iMK7A").then(()=>parcelRequire("ecaPQ"));

});

parcelRegister("2gy8O", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c959h").then(()=>parcelRequire("8dDoF"));

});

parcelRegister("8Gwhq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cOugU").then(()=>parcelRequire("j6g2T"));

});

parcelRegister("kPSKK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iOCzG").then(()=>parcelRequire("2bwgH"));

});

parcelRegister("5I4uO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gtyAB").then(()=>parcelRequire("c8FRq"));

});

parcelRegister("6QHdf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fndzT").then(()=>parcelRequire("85lK7"));

});

parcelRegister("K4nmq", function(module, exports) {

$parcel$export(module.exports, "MediaSelectAction", () => $08a7b0eeacb46685$export$b418f20b44c2d35b);
$parcel$export(module.exports, "MediaType", () => $08a7b0eeacb46685$export$483c11740a902fcd);
$parcel$export(module.exports, "useMediaLibraryService", () => $08a7b0eeacb46685$export$6786621ea5daf880);
$parcel$export(module.exports, "MediaLibrary", () => $08a7b0eeacb46685$export$6c378f65a9da3030);
$parcel$export(module.exports, "MediaLibraryModal", () => $08a7b0eeacb46685$export$4eeee67d3df98ed8);
$parcel$export(module.exports, "useMedia", () => $08a7b0eeacb46685$export$1f6a311a7539099a);
$parcel$export(module.exports, "useMediaData", () => $08a7b0eeacb46685$export$ba33b39b853b4664);
$parcel$export(module.exports, "MediaDisplay", () => $08a7b0eeacb46685$export$5b22ab56777dd834);
$parcel$export(module.exports, "MediaGallery", () => $08a7b0eeacb46685$export$26639b5e905ce7df);

var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

var $ket0H = parcelRequire("ket0H");
var $9PE8j = parcelRequire("9PE8j");

var $5sKyw = parcelRequire("5sKyw");

var $6LAgE = parcelRequire("6LAgE");
var $aX99y = parcelRequire("aX99y");
var $77pHI = parcelRequire("77pHI");
var $99eL8 = parcelRequire("99eL8");
var $48fuN = parcelRequire("48fuN");
var $186Ez = parcelRequire("186Ez");
var $6WSsf = parcelRequire("6WSsf");
var $gfQkH = parcelRequire("gfQkH");
var $h7C4J = parcelRequire("h7C4J");
var $4dB0L = parcelRequire("4dB0L");

var $6LAgE = parcelRequire("6LAgE");

var $f57q8 = parcelRequire("f57q8");

var $gzHIW = parcelRequire("gzHIW");

var $1yfa6 = parcelRequire("1yfa6");
parcelRequire("ivqYv");
var $gydR2 = parcelRequire("gydR2");
var $40h1t = parcelRequire("40h1t");
var $9RtmZ = parcelRequire("9RtmZ");
var $4CnrE = parcelRequire("4CnrE");

var $9QePP = parcelRequire("9QePP");

var $jrCwd = parcelRequire("jrCwd");

var $22i8b = parcelRequire("22i8b");
var $08a7b0eeacb46685$var$We = (0, $acw62.createContext)(void 0);
$08a7b0eeacb46685$var$We.displayName = "MediaLibraryContext";
var $08a7b0eeacb46685$var$q = $08a7b0eeacb46685$var$We;
var $08a7b0eeacb46685$export$b418f20b44c2d35b = ((a)=>(a.None = "none", a.SelectSingle = "selectSingle", a.SelectMultiple = "selectMultiple", a))($08a7b0eeacb46685$export$b418f20b44c2d35b || {});
var $08a7b0eeacb46685$var$oe = class oe extends (0, $fCKVd.AbstractDataStore) {
    constructor(r){
        super();
        this._folders = null;
        this._selectedFolder = null;
        this._error = void 0;
        this._folderChangeListeners = [];
        this._data = {
            folders: null,
            selectedFolder: null
        };
        this._service = r;
    }
    get selectedFolder() {
        return this._selectedFolder;
    }
    get realSelectedFolder() {
        let r = this.selectedFolder;
        return r === oe.CONTEXT_FOLDER ? null : r;
    }
    set selectedFolder(r) {
        this._selectedFolder = r, this._callListeners(), this._folderChangeListeners.forEach((a)=>a());
    }
    onFolderChange(r) {
        return this._folderChangeListeners.push(r), ()=>{
            this._folderChangeListeners = this._folderChangeListeners.filter((a)=>a !== r);
        };
    }
    async _loadFolders() {
        try {
            let r = await (0, $ket0H.default).getData(this._service.getEndpoint("folder")), a = {
                id: 0,
                parent: null,
                name: "/",
                children: r.filter((o)=>o.parent === null).map((o)=>o.id)
            };
            this._folders = [
                a,
                ...r.map((o)=>({
                        ...o,
                        parent: o.parent ? o.parent : 0
                    }))
            ];
        } catch (r) {
            console.error(r), this._error = (0, $9PE8j.default)(r), this._folders = null;
        }
        this._callListeners();
    }
    async init() {
        this._folders === null && await this._loadFolders();
    }
    get _editModalState() {
        if (!this._service.states) throw new Error("Modals states not set");
        return this._service.states.folderEditModal;
    }
    async openFolderEdit(r) {
        this._editModalState.setData(null), this._editModalState.open(), await this.init();
        try {
            let a = await (0, $ket0H.default).getData(this._service.getEndpoint(`folder/${r}`), {
                type: "edit"
            });
            this._editModalState.setData(a);
        } catch (a) {
            this._editModalState.close(), this._service.app.toasts.createToast({
                title: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445",
                body: (0, $9PE8j.default)(a),
                variant: "danger"
            });
        }
    }
    openFolderCreate(r) {
        this._editModalState.setData({
            name: "",
            parent: r
        }), this._editModalState.open();
    }
    async handleSubmit(r) {
        r.id ? await (0, $ket0H.default).put(this._service.getEndpoint(`folder/${r.id}`), r) : await (0, $ket0H.default).post(this._service.getEndpoint("folder"), r), await this._loadFolders(), this._editModalState.close();
    }
    async deleteFolder(r) {
        await (0, $ket0H.default).delete(this._service.getEndpoint(`folder/${r}`)), await this._loadFolders(), this._selectedFolder === r && (this.selectedFolder = null);
    }
    openFolderDelete(r, a) {
        if (!this._service.states) throw new Error("Modals states not set");
        this._service.states.deleteModal.setData({
            text: `\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0430\u043F\u043A\u0443 "${a}"? \u0426\u0435 \u043D\u0435 \u043F\u0440\u0438\u0437\u0432\u0435\u0434\u0435 \u0434\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432, \u044F\u043A\u0456 \u0432 \u043D\u0456\u0439 \u0437\u043D\u0430\u0445\u043E\u0434\u044F\u0442\u044C\u0441\u044F.`,
            onConfirm: ()=>this.deleteFolder(r)
        }), this._service.states.deleteModal.open();
    }
    _callListeners() {
        this._data = {
            folders: this._folders,
            selectedFolder: this._selectedFolder,
            error: this._error
        }, super._callListeners();
    }
    getData() {
        return this._data;
    }
};
$08a7b0eeacb46685$var$oe.CONTEXT_FOLDER = "**context-folder**";
var $08a7b0eeacb46685$export$44ab4af4e5e60c25 = $08a7b0eeacb46685$var$oe;
var $08a7b0eeacb46685$var$Z = class extends (0, $fCKVd.AbstractDataStore) {
    constructor(r, a){
        super();
        this._onDestroy = [];
        this._reloadTimeout = null;
        this._data = {
            loading: !1,
            isAllLoaded: !1,
            page: 1,
            search: "",
            media: null,
            selectedMedia: []
        };
        this._service = r, this._opts = a;
    }
    _updateData(r) {
        this._data = {
            ...this._data,
            ...r
        }, this._callListeners();
    }
    get _context() {
        return this._service.folderManager.selectedFolder === $08a7b0eeacb46685$export$44ab4af4e5e60c25.CONTEXT_FOLDER ? this._service.currentContext : null;
    }
    get _selectedFolder() {
        return this._service.folderManager.realSelectedFolder;
    }
    async _loadMedia(r) {
        var a, o, i;
        if (!(!r && (this._data.loading || this._data.isAllLoaded))) {
            this._updateData({
                loading: !0
            });
            try {
                let d = await (0, $ket0H.default).getData(this._service.getEndpoint("media"), {
                    page: this._data.page,
                    search: (a = this._data.search) != null ? a : void 0,
                    media_folder_id: (o = this._selectedFolder) != null ? o : void 0,
                    context: (i = this._context) != null ? i : void 0,
                    types: this._service.getAllowedTypes(this._opts.types)
                });
                this._updateData({
                    media: this._data.media ? [
                        ...this._data.media,
                        ...d
                    ] : d,
                    loading: !1,
                    page: this._data.page + 1,
                    isAllLoaded: d.length < 5,
                    error: void 0
                });
            } catch (d) {
                console.error(d), this._updateData({
                    loading: !1,
                    media: this._data.media ? this._data.media : [],
                    error: (0, $9PE8j.default)(d)
                });
            }
        }
    }
    loadMore() {
        this._loadMedia();
    }
    getData() {
        return this._data;
    }
    get allowSelect() {
        return !!this._opts.selectAction && this._opts.selectAction !== "none";
    }
    handleMediaClick(r) {
        var a, o;
        switch(this._opts.selectAction){
            case "selectSingle":
                this._updateData({
                    selectedMedia: [
                        r
                    ]
                });
                break;
            case "selectMultiple":
                this._updateData({
                    selectedMedia: this._data.selectedMedia.some((i)=>i.id === r.id) ? this._data.selectedMedia.filter((i)=>i.id !== r.id) : [
                        ...this._data.selectedMedia,
                        r
                    ]
                });
                break;
        }
        (o = (a = this._opts).handleSelect) == null || o.call(a, this._data.selectedMedia);
    }
    handleSubmit() {
        var r, a;
        (a = (r = this._opts).handleSubmit) == null || a.call(r, this._data.selectedMedia);
    }
    _handleFolderChange() {
        this._updateData({
            isAllLoaded: !1,
            page: 1,
            search: "",
            media: null
        }), this._loadMedia();
    }
    _filterMediaList(r) {
        return r.filter((a)=>this._service.getAllowedTypes(this._opts.types).includes(a.type)).filter((a)=>this._selectedFolder ? a.folder_id == this._selectedFolder : !0);
    }
    _handleMediaAdd(r) {
        this._updateData({
            media: this._filterMediaList(this._data.media ? [
                r,
                ...this._data.media
            ] : [
                r
            ])
        });
    }
    set search(r) {
        this._updateData({
            loading: !0,
            isAllLoaded: !1,
            page: 1,
            search: r,
            media: null
        }), this._reloadTimeout && clearTimeout(this._reloadTimeout), this._reloadTimeout = setTimeout(()=>{
            this._loadMedia(!0);
        }, 500);
    }
    _handleMediaUpdate(r) {
        this._data.media && this._updateData({
            media: this._filterMediaList(this._data.media.map((a)=>a.id === r.id ? r : a))
        });
    }
    _handleMediaDelete(r) {
        this._data.media && this._updateData({
            media: this._data.media.filter((a)=>a.id !== r)
        });
    }
    init() {
        this._onDestroy.push(this._service.folderManager.onFolderChange(this._handleFolderChange.bind(this)), this._service.upload.onMediaAdd(this._handleMediaAdd.bind(this)), this._service.mediaManager.onMediaUpdate(this._handleMediaUpdate.bind(this)), this._service.mediaManager.onMediaDelete(this._handleMediaDelete.bind(this))), this._loadMedia();
    }
    destroy() {
        this._onDestroy.forEach((r)=>r()), this._onDestroy = [];
    }
};
var $08a7b0eeacb46685$export$483c11740a902fcd = ((i)=>(i.Image = "image", i.Video = "video", i.Audio = "audio", i.File = "file", i.Embed = "embed", i))($08a7b0eeacb46685$export$483c11740a902fcd || {}), $08a7b0eeacb46685$var$$e = (t)=>Object.values($08a7b0eeacb46685$export$483c11740a902fcd).includes(t), $08a7b0eeacb46685$var$ze = [
    "image",
    "video",
    "audio",
    "file",
    "embed"
], $08a7b0eeacb46685$var$Ge = {
    image: "image-outline",
    video: "video-outline",
    audio: "volume-high",
    file: "file-document-outline",
    embed: "link"
};
var $08a7b0eeacb46685$var$Ve = (t)=>typeof t == "object" && typeof t.endpoint == "string" && (t.types === void 0 || Array.isArray(t.types) && t.types.every($08a7b0eeacb46685$var$$e));
var $08a7b0eeacb46685$var$Vt = ({ data: t })=>{
    var e;
    return t.status === "uploading" ? t.progress > 99 ? $acw62.createElement("div", {
        className: "d-flex align-items-center gap-1"
    }, $acw62.createElement((0, $4dB0L.default), {
        animation: "border",
        size: "sm"
    }), $acw62.createElement("span", null, "\u0406\u0434\u0435 \u043E\u0431\u0440\u043E\u0431\u043A\u0430, \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435...")) : $acw62.createElement((0, $gfQkH.default), {
        variant: "success",
        now: t.progress
    }) : t.status === "success" ? $acw62.createElement("div", null, "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E") : $acw62.createElement("div", null, (e = t.error) != null ? e : "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F");
}, $08a7b0eeacb46685$var$jt = ({ data: t })=>$acw62.createElement("div", null, $acw62.createElement("div", {
        className: "w-100 overflow-hidden text-truncate fw-bold mb-1 font-16"
    }, t.name), $acw62.createElement($08a7b0eeacb46685$var$Vt, {
        data: t
    })), $08a7b0eeacb46685$var$je = $08a7b0eeacb46685$var$jt;
var $08a7b0eeacb46685$export$25fd4802638b1485 = class {
    constructor(e){
        this._uploadingFiles = {};
        this._onMediaAddListeners = [];
        this._relatedBlocks = [];
        this._service = e, this._uploadInput = this._initUploadInput(), this._dropPopup = this._initDropPopup(), window.addEventListener("beforeunload", this._handleUnload.bind(this)), window.addEventListener("dragenter", this._handleDragEvent.bind(this)), window.addEventListener("dragover", this._handleDragEvent.bind(this));
    }
    _handleInputChanged(e) {
        e.preventDefault(), e.target instanceof HTMLInputElement && e.target.files && (e.target.files.length > 0 && this.uploadFiles(e.target.files), e.target.value = "");
    }
    _initUploadInput() {
        let e = document.createElement("input");
        return e.type = "file", e.multiple = !0, e.style.display = "none", e.addEventListener("change", this._handleInputChanged.bind(this)), document.body.appendChild(e), e;
    }
    _initDropPopup() {
        let e = document.createElement("div");
        return e.className = "media-library-drop-popup", e.style.display = "none", e.addEventListener("dragover", this._handleDragEvent.bind(this)), e.addEventListener("dragleave", this._handleDragEvent.bind(this)), e.addEventListener("drop", this._handleDragEvent.bind(this)), document.body.appendChild(e), e;
    }
    set _dragPopupEnabled(e) {
        this._dropPopup.style.display = e ? "" : "none";
    }
    _handleUnload(e) {
        if (Object.values(this._uploadingFiles).some((r)=>r.status === "uploading")) return e.preventDefault(), "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u0435\u0434\u0456\u0430 \u0449\u0435 \u043D\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E";
    }
    _updateBlockMessage(e, r, a) {
        let o = this._getRelatedBlock(e, r);
        if (!o) {
            this._dropPopup.removeAttribute("data-message");
            return;
        }
        let i = typeof o.message == "function" ? o.message(a) : o.message;
        i ? this._dropPopup.setAttribute("data-message", i) : this._dropPopup.removeAttribute("data-message");
    }
    _isMediaModalOpen() {
        var e;
        return !!((e = document.querySelector(".media-library-modal")) != null && e.classList.contains("show"));
    }
    _getRelatedBlock(e, r) {
        if (!this._isMediaModalOpen()) return this._relatedBlocks.find((a)=>{
            let o = a.block.getBoundingClientRect();
            return e >= o.left && e <= o.right && r >= o.top && r <= o.bottom;
        });
    }
    _handleDragUpload(e, r, a) {
        let o = this._getRelatedBlock(r, a), i = this.uploadFiles(e);
        o == null || o.handler(i);
    }
    _handleDragEvent(e) {
        var r, a, o, i, d;
        e.preventDefault(), e.stopPropagation(), e.type === "dragenter" || e.type === "dragover" ? ((o = (a = (r = e.dataTransfer) == null ? void 0 : r.items) == null ? void 0 : a[0]) == null ? void 0 : o.kind) === "file" && (this._dragPopupEnabled = !0, this._updateBlockMessage(e.clientX, e.clientY, e.dataTransfer.items.length)) : e.type === "dragleave" ? this._dragPopupEnabled = !1 : e.type === "drop" && (this._dragPopupEnabled = !1, (d = (i = e.dataTransfer) == null ? void 0 : i.files) != null && d.length && this._handleDragUpload(e.dataTransfer.files, e.clientX, e.clientY));
    }
    initDropdownIframe(e, r) {
        let a = (o)=>{
            var i, d, n;
            ((n = (d = (i = o.dataTransfer) == null ? void 0 : i.items) == null ? void 0 : d[0]) == null ? void 0 : n.kind) === "file" && this._handleDragEvent(o);
        };
        return e.addEventListener("dragenter", a), e.addEventListener("dragover", a), this._relatedBlocks.push(r), ()=>{
            e.removeEventListener("dragenter", a), e.removeEventListener("dragover", a), this._relatedBlocks = this._relatedBlocks.filter((o)=>o !== r);
        };
    }
    onMediaAdd(e) {
        return this._onMediaAddListeners.push(e), ()=>{
            this._onMediaAddListeners = this._onMediaAddListeners.filter((r)=>r !== e);
        };
    }
    _resolveUploadToastBody(e) {
        return $acw62.createElement($08a7b0eeacb46685$var$je, {
            data: e
        });
    }
    _makeUploadItem(e) {
        let r = (0, $5sKyw.default)(), a = {
            ...e,
            status: "uploading",
            progress: 0
        }, o = this._service.app.toasts.createToast({
            icon: "upload",
            title: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u0435\u0434\u0456\u0430",
            body: this._resolveUploadToastBody(a),
            disableClose: !0
        });
        return this._uploadingFiles = {
            ...this._uploadingFiles,
            [r]: {
                ...a,
                toast: o
            }
        }, r;
    }
    _getToastVariant(e) {
        switch(e){
            case "error":
                return "danger";
            case "success":
                return "success";
            default:
                return;
        }
    }
    _updateUploadItem(e, r) {
        let a = this._uploadingFiles[e];
        if (!a) throw new Error(`Upload item with id ${e} not found`);
        let o = {
            ...a,
            ...r
        };
        this._uploadingFiles = {
            ...this._uploadingFiles,
            [e]: o
        };
        let { toast: i, ...d } = o;
        a.toast.update({
            variant: this._getToastVariant(o.status),
            body: this._resolveUploadToastBody(d),
            disableClose: o.status === "uploading"
        });
    }
    _cleanUpUploadItem(e) {
        let r = this._uploadingFiles[e];
        r && (r.toast.delete(), delete this._uploadingFiles[e]);
    }
    get _uploadFolder() {
        return this._service.folderManager.realSelectedFolder;
    }
    async _makeUpload(e, r) {
        let a = this._makeUploadItem(e), o = (d)=>{
            if (!d.total) return;
            let n = Math.round(d.loaded * 100 / d.total);
            this._updateUploadItem(a, {
                progress: n
            });
        }, i = {
            ...r,
            folder: this._uploadFolder,
            context: this._service.currentContext
        };
        try {
            let { data: d } = await (0, $ket0H.default).postWithFile(this._service.getEndpoint("media"), i, {
                onUploadProgress: o,
                timeout: 12e4
            });
            return this._updateUploadItem(a, {
                status: "success",
                progress: 100
            }), d.forEach((c)=>this._onMediaAddListeners.forEach((B)=>B(c))), d;
        } catch (d) {
            let n = [
                d == null ? void 0 : d.errorMessage,
                d == null ? void 0 : d.message,
                "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F"
            ].find((c)=>c && c.length > 0);
            throw this._updateUploadItem(a, {
                status: "error",
                progress: 100,
                error: n
            }), new Error(n);
        } finally{
            setTimeout(()=>this._cleanUpUploadItem(a), 5e3);
        }
    }
    uploadFiles(e) {
        if (e.length === 0) return Promise.resolve([]);
        let r = {
            files: e
        }, a = {
            type: e.length > 1 ? "file-group" : "file",
            name: e.length > 1 ? `${e[0].name} \u0456 \u0449\u0435 ${e.length - 1} \u0444\u0430\u0439\u043B\u0456\u0432` : e[0].name,
            size: Array.from(e).reduce((o, i)=>o + i.size, 0)
        };
        return this._makeUpload(a, r);
    }
    openUploadFileDialog() {
        this._uploadInput.click();
    }
    addFromLinks(e, r) {
        let a = {
            links: e
        }, o = {
            type: e.length > 1 ? "link-group" : "link",
            name: e.length > 1 ? `${e[0]} \u0456 \u0449\u0435 ${e.length - 1} \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u044C` : e[0]
        }, i = this._makeUpload(o, a);
        return typeof r == "function" && r(i), i;
    }
    openUploadLinkDialog(e) {
        var r, a;
        (r = this._service.states) == null || r.uploadLinkModal.setData({
            handler: e
        }), (a = this._service.states) == null || a.uploadLinkModal.open();
    }
};
var $08a7b0eeacb46685$export$4a0c46dbbe2ddb67 = class {
    constructor(e){
        this._onMediaUpdateListeners = [];
        this._onMediaDeleteListeners = [];
        this._service = e;
    }
    onMediaUpdate(e) {
        return this._onMediaUpdateListeners.push(e), ()=>{
            this._onMediaUpdateListeners = this._onMediaUpdateListeners.filter((r)=>r !== e);
        };
    }
    onMediaDelete(e) {
        return this._onMediaDeleteListeners.push(e), ()=>{
            this._onMediaDeleteListeners = this._onMediaDeleteListeners.filter((r)=>r !== e);
        };
    }
    async openMediaEdit(e) {
        if (!this._service.states) throw new Error("MediaLibraryService states not set");
        this._service.states.mediaEditModal.setData(null), this._service.states.mediaEditModal.open();
        try {
            let r = await this._service.loadMedia(e);
            this._service.states.mediaEditModal.setData({
                id: r.id,
                folder_id: r.folder_id
            });
        } catch (r) {
            this._service.states.mediaEditModal.close(), this._service.app.toasts.createToast({
                title: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445",
                body: (0, $9PE8j.default)(r),
                variant: "danger"
            });
        }
    }
    async handleEditFormSubmit(e, r) {
        var i;
        let a = this._service.getEndpoint(`media/${e}`), { data: o } = await (0, $ket0H.default).put(a, r);
        this._onMediaUpdateListeners.forEach((d)=>d(o)), (i = this._service.states) == null || i.mediaEditModal.close();
    }
    async openMediaDelete(e) {
        if (!this._service.states) throw new Error("MediaLibraryService states not set");
        this._service.states.deleteModal.setData(null), this._service.states.deleteModal.open();
        try {
            let r = await this._service.loadMedia(e);
            this._service.states.deleteModal.setData({
                text: `\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043C\u0435\u0434\u0456\u0430 ${r.filename}?`,
                onConfirm: ()=>this.handleMediaDelete(e)
            });
        } catch (r) {
            this._service.states.deleteModal.close(), this._service.app.toasts.createToast({
                title: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445",
                body: (0, $9PE8j.default)(r),
                variant: "danger"
            });
        }
    }
    async handleMediaDelete(e) {
        let r = this._service.getEndpoint(`media/${e}`);
        await (0, $ket0H.default).delete(r), this._onMediaDeleteListeners.forEach((a)=>a(e));
    }
};
var $08a7b0eeacb46685$export$2b7e434e551ff47c = class {
    constructor(e){
        this._states = void 0;
        this.app = e, this._config = this._resolveConfig(), this.upload = new $08a7b0eeacb46685$export$25fd4802638b1485(this), this.folderManager = new $08a7b0eeacb46685$export$44ab4af4e5e60c25(this), this.mediaManager = new $08a7b0eeacb46685$export$4a0c46dbbe2ddb67(this), this.app.services.register("ova-media-library", this);
    }
    get currentContext() {
        let e = this.app.pageContext.getData();
        return e ? e.data.mediaContext && typeof e.data.mediaContext == "string" && e.data.mediaContext.length > 0 ? e.data.mediaContext : e.data.id ? `page-${e.type}-${e.data.id}` : `page-${e.type}` : null;
    }
    setStates(e) {
        this._states = e;
    }
    get states() {
        return this._states;
    }
    _resolveConfig() {
        var r;
        let e = (r = this.app.config.external) == null ? void 0 : r.media;
        if (!$08a7b0eeacb46685$var$Ve(e)) throw new Error("Invalid media library config");
        return e;
    }
    getEndpoint(e) {
        return `${this._config.endpoint}/${e}`;
    }
    async loadMedia(e) {
        return await (0, $ket0H.default).getData(this.getEndpoint(`media/${e}`));
    }
    async loadMediaList(e) {
        return await (0, $ket0H.default).getData(this.getEndpoint("media/multiple"), {
            ids: e
        });
    }
    getAllowedTypes(e) {
        var a;
        let r = (a = this._config.types) != null ? a : $08a7b0eeacb46685$var$ze;
        return e ? e.filter((o)=>r.includes(o)) : r;
    }
}, $08a7b0eeacb46685$export$2b87e9e9c363f2fd = (t)=>t instanceof $08a7b0eeacb46685$export$2b7e434e551ff47c, $08a7b0eeacb46685$export$6786621ea5daf880 = ()=>(0, $fCKVd.useAppService)("ova-media-library", $08a7b0eeacb46685$export$2b87e9e9c363f2fd);
var $08a7b0eeacb46685$var$Zt = ({ children: t, ...e })=>{
    let r = $08a7b0eeacb46685$export$6786621ea5daf880(), a = $acw62.useMemo(()=>new $08a7b0eeacb46685$var$Z(r, e), []);
    return $acw62.useEffect(()=>(a.init(), ()=>a.destroy()), []), $acw62.createElement($08a7b0eeacb46685$var$q.Provider, {
        value: a
    }, t);
}, $08a7b0eeacb46685$var$Ke = $08a7b0eeacb46685$var$Zt;
function $08a7b0eeacb46685$var$b() {
    let t = (0, $acw62.useContext)($08a7b0eeacb46685$var$q);
    if (!t) throw new Error("useMediaLibraryContext must be used within a MediaLibraryContextProvider");
    return t;
}
function $08a7b0eeacb46685$var$P() {
    let t = $08a7b0eeacb46685$var$b();
    return (0, $fCKVd.useExternalStore)(()=>t);
}
var $08a7b0eeacb46685$var$Qe = $08a7b0eeacb46685$var$Ke;
var $08a7b0eeacb46685$var$er = ({ wrapper: t = $acw62.Fragment })=>{
    let e = $08a7b0eeacb46685$var$b(), { selectedMedia: r } = $08a7b0eeacb46685$var$P();
    return e.allowSelect ? $acw62.createElement(t, null, $acw62.createElement("span", {
        className: "me-1 small text-muted"
    }, r.length > 0 ? `\u0412\u0438\u0431\u0440\u0430\u043D\u043E ${r.length} \u043C\u0435\u0434\u0456\u0430` : "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0432\u0438\u0431\u0440\u0430\u043D\u043E"), $acw62.createElement((0, $6LAgE.default), {
        disabled: r.length === 0,
        onClick: e.handleSubmit.bind(e)
    }, "\u0412\u0438\u0431\u0440\u0430\u0442\u0438")) : null;
}, $08a7b0eeacb46685$var$fe = $08a7b0eeacb46685$var$er;
var $08a7b0eeacb46685$var$tr = ({ children: t, ...e })=>$acw62.createElement($08a7b0eeacb46685$var$Qe, {
        ...e
    }, t), $08a7b0eeacb46685$var$Me = $08a7b0eeacb46685$var$tr;
var $08a7b0eeacb46685$var$rr = ({ className: t, children: e })=>$acw62.createElement((0, $aX99y.default), {
        className: t != null ? t : "h-100 mb-0"
    }, $acw62.createElement((0, $aX99y.default).Body, {
        className: "p-2"
    }, e)), $08a7b0eeacb46685$var$ye = $08a7b0eeacb46685$var$rr;
var $08a7b0eeacb46685$var$ir = ()=>{
    let t = $08a7b0eeacb46685$export$6786621ea5daf880().upload;
    return $acw62.createElement((0, $gzHIW.default), {
        as: (0, $f57q8.default)
    }, $acw62.createElement((0, $6LAgE.default), {
        variant: "outline-success",
        size: "sm",
        onClick: t.openUploadFileDialog.bind(t)
    }, $acw62.createElement("i", {
        className: "mdi mdi-upload me-1"
    }), "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438"), $acw62.createElement((0, $gzHIW.default).Toggle, {
        split: !0,
        variant: "outline-success",
        size: "sm"
    }), $acw62.createElement((0, $gzHIW.default).Menu, null, $acw62.createElement((0, $gzHIW.default).Item, {
        onClick: t.openUploadLinkDialog.bind(t, void 0)
    }, $acw62.createElement("i", {
        className: "mdi mdi-link me-1"
    }), "\u0412\u0441\u0442\u0430\u0432\u043A\u0430 \u0437 \u0441\u043E\u0446\u043C\u0435\u0440\u0435\u0436")));
}, $08a7b0eeacb46685$var$rt = $08a7b0eeacb46685$var$ir;
var $08a7b0eeacb46685$var$at = "folder-context", $08a7b0eeacb46685$var$sr = ({ id: t, trigger: e })=>{
    let r = $08a7b0eeacb46685$export$6786621ea5daf880().folderManager;
    return $acw62.createElement((0, $40h1t.default), {
        id: t
    }, $acw62.createElement((0, $4CnrE.default), {
        onClick: ()=>{
            var a;
            return r.openFolderEdit((a = e == null ? void 0 : e.folderId) != null ? a : 0);
        }
    }, "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438"), $acw62.createElement((0, $4CnrE.default), {
        onClick: ()=>{
            var a;
            return r.openFolderCreate((a = e == null ? void 0 : e.folderId) != null ? a : 0);
        }
    }, "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0430\u043F\u043A\u0443"), $acw62.createElement((0, $4CnrE.default), {
        onClick: ()=>{
            var a, o;
            return r.openFolderDelete((a = e == null ? void 0 : e.folderId) != null ? a : 0, (o = e == null ? void 0 : e.folderName) != null ? o : "");
        }
    }, "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438"));
}, $08a7b0eeacb46685$var$ot = (0, $gydR2.default)($08a7b0eeacb46685$var$at)($08a7b0eeacb46685$var$sr), $08a7b0eeacb46685$var$it = ({ folderId: t, folderName: e, children: r })=>$acw62.createElement((0, $9RtmZ.default), {
        id: $08a7b0eeacb46685$var$at,
        folderId: t,
        folderName: e,
        renderTag: "span",
        collect: (a)=>a
    }, r);
var $08a7b0eeacb46685$var$mr = ({ name: t, isSelected: e, icon: r, handleSelect: a, handleIconClick: o, contextMenuProps: i })=>$acw62.createElement("div", {
        className: (0, $9QePP.default)("d-flex align-items-center user-select-none text-truncate", {
            "text-primary": e
        }),
        role: o ? void 0 : "button",
        onClick: o ? void 0 : a
    }, $acw62.createElement("i", {
        className: `mdi mdi-${r} font-20 me-1`,
        role: o ? "button" : void 0,
        onClick: o || a
    }), i ? $acw62.createElement($08a7b0eeacb46685$var$it, {
        ...i
    }, $acw62.createElement("span", {
        role: "button",
        onClick: a
    }, t)) : $acw62.createElement("span", {
        role: "button",
        onClick: a
    }, t)), $08a7b0eeacb46685$var$de = $08a7b0eeacb46685$var$mr;
var $08a7b0eeacb46685$var$vr = ({ className: t, onSelect: e })=>{
    let r = $08a7b0eeacb46685$export$6786621ea5daf880().folderManager, { folders: a, selectedFolder: o, error: i } = (0, $fCKVd.useExternalStore)(r), d = (0, $fCKVd.useAppPageContextData)(), n = (c)=>{
        r.selectedFolder = c, e == null || e(c);
    };
    return $acw62.useEffect(()=>(r.init(), ()=>{
            r.selectedFolder = null;
        }), []), i ? $acw62.createElement((0, $fCKVd.FlexCenteredInfo), {
        color: "danger",
        text: i,
        icon: "alert-circle-outline"
    }) : a === null ? $acw62.createElement((0, $fCKVd.FlexCentered), null, $acw62.createElement((0, $fCKVd.BouncingLoader), null)) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement("div", {
        className: t
    }, $acw62.createElement("div", {
        className: "d-flex align-items-center user-select-none"
    }, $acw62.createElement($08a7b0eeacb46685$var$de, {
        name: "\u0443\u0441\u0456 \u043C\u0435\u0434\u0456\u0430",
        isSelected: !o,
        icon: "folder-multiple-image",
        handleSelect: ()=>n(null)
    }), $acw62.createElement("div", {
        className: "ms-auto"
    }, $acw62.createElement((0, $6LAgE.default), {
        variant: "outline-secondary",
        className: "px-1 py-0 mdi mdi-folder-plus font-16",
        onClick: ()=>r.openFolderCreate(null)
    }))), d && $acw62.createElement($08a7b0eeacb46685$var$de, {
        name: "\u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u043C\u0435\u0434\u0456\u0430",
        isSelected: o === $08a7b0eeacb46685$export$44ab4af4e5e60c25.CONTEXT_FOLDER,
        icon: "folder-pound-outline",
        handleSelect: ()=>n($08a7b0eeacb46685$export$44ab4af4e5e60c25.CONTEXT_FOLDER)
    }), a.length > 1 && $acw62.createElement((0, $1yfa6.default), {
        data: a,
        propagateCollapse: !0,
        onNodeSelect: (c)=>n(c.element.id),
        selectedIds: o ? [
            o
        ] : [],
        className: "tree-view",
        nodeRenderer: ({ element: c, handleExpand: B, handleSelect: kt, isBranch: Oe, isSelected: Nt })=>$acw62.createElement($08a7b0eeacb46685$var$de, {
                name: c.name,
                isSelected: Nt,
                icon: Oe ? "folder-plus-outline" : "folder-outline",
                handleSelect: kt,
                handleIconClick: Oe ? B : void 0,
                contextMenuProps: {
                    folderId: c.id,
                    folderName: c.name
                }
            })
    }), $acw62.createElement($08a7b0eeacb46685$var$ot, null)));
}, $08a7b0eeacb46685$var$J = $08a7b0eeacb46685$var$vr;
var $08a7b0eeacb46685$var$_r = ()=>{
    var i;
    let t = $08a7b0eeacb46685$export$6786621ea5daf880().folderManager, { folders: e, selectedFolder: r } = (0, $fCKVd.useExternalStore)(t), a = (0, $fCKVd.useModal)(), o = $acw62.useMemo(()=>!e || !r ? null : e.find((d)=>d.id === r), [
        e,
        r
    ]);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $fCKVd.Modal), {
        title: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0430\u043F\u043A\u0438",
        state: a
    }, $acw62.createElement((0, $fCKVd.Modal).Body, null, $acw62.createElement($08a7b0eeacb46685$var$J, {
        onSelect: a.close
    }))), $acw62.createElement("div", {
        className: "d-none d-lg-inline-flex align-items-center"
    }, $acw62.createElement("i", {
        className: `mdi mdi-${o ? "folder" : "folder-multiple-outline"} font-20`
    }), $acw62.createElement("span", {
        className: "ms-1 text-truncate"
    }, (i = o == null ? void 0 : o.name) != null ? i : "\u0432\u0441\u0456 \u043F\u0430\u043F\u043A\u0438")), $acw62.createElement((0, $6LAgE.default), {
        variant: "outline-secondary",
        size: "sm",
        className: "d-lg-none py-0 d-inline-flex align-items-center",
        onClick: a.open
    }, $acw62.createElement("i", {
        className: `mdi mdi-${o ? "folder" : "folder-multiple-outline"} font-20 lh-sm`
    })));
}, $08a7b0eeacb46685$var$nt = $08a7b0eeacb46685$var$_r;
var $08a7b0eeacb46685$var$Cr = ({ show: t })=>{
    let e = $08a7b0eeacb46685$var$b(), { search: r } = $08a7b0eeacb46685$var$P();
    return $acw62.createElement("div", {
        className: t ? "w-100" : "d-none d-lg-block ms-auto"
    }, $acw62.createElement((0, $48fuN.default), {
        size: "sm",
        placeholder: "\u041F\u043E\u0448\u0443\u043A...",
        value: r,
        onChange: (o)=>{
            e.search = o.target.value;
        }
    }));
}, $08a7b0eeacb46685$var$be = $08a7b0eeacb46685$var$Cr;
var $08a7b0eeacb46685$var$Lr = ({ handleClick: t })=>$acw62.createElement((0, $6LAgE.default), {
        variant: "outline-secondary",
        size: "sm",
        className: "d-lg-none py-0 d-inline-flex align-items-center me-auto",
        onClick: t
    }, $acw62.createElement("i", {
        className: "mdi mdi-magnify font-20 lh-sm"
    })), $08a7b0eeacb46685$var$lt = $08a7b0eeacb46685$var$Lr;
var $08a7b0eeacb46685$var$Rr = ()=>{
    let [t, e] = $acw62.useState(!1), r = $08a7b0eeacb46685$var$b();
    return t ? $acw62.createElement("div", {
        className: "mb-2 d-flex align-items-center gap-1"
    }, $acw62.createElement($08a7b0eeacb46685$var$be, {
        show: !0
    }), $acw62.createElement((0, $77pHI.default), {
        onClick: ()=>{
            e(!1), r.search = "";
        }
    })) : $acw62.createElement("div", {
        className: "mb-2 d-flex gap-1 px-1"
    }, $acw62.createElement($08a7b0eeacb46685$var$nt, null), $acw62.createElement($08a7b0eeacb46685$var$lt, {
        handleClick: ()=>e(!0)
    }), $acw62.createElement($08a7b0eeacb46685$var$be, null), $acw62.createElement($08a7b0eeacb46685$var$rt, null));
}, $08a7b0eeacb46685$var$st = $08a7b0eeacb46685$var$Rr;
var $08a7b0eeacb46685$var$mt = "media-context", $08a7b0eeacb46685$var$Tr = ({ id: t, trigger: e })=>{
    let r = $08a7b0eeacb46685$export$6786621ea5daf880().mediaManager;
    return $acw62.createElement((0, $40h1t.default), {
        id: t
    }, $acw62.createElement((0, $4CnrE.default), {
        onClick: ()=>r.openMediaEdit(e.media.id)
    }, "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438"), $acw62.createElement((0, $4CnrE.default), {
        onClick: ()=>r.openMediaDelete(e.media.id)
    }, "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438"));
}, $08a7b0eeacb46685$var$ct = (0, $gydR2.default)($08a7b0eeacb46685$var$mt)($08a7b0eeacb46685$var$Tr), $08a7b0eeacb46685$var$ut = ({ as: t, attributes: e, media: r, triggerOnLeftClick: a, children: o })=>$acw62.createElement((0, $9RtmZ.default), {
        id: $08a7b0eeacb46685$var$mt,
        media: r,
        renderTag: t,
        attributes: e,
        collect: (i)=>i,
        triggerOnLeftClick: a
    }, o);
var $08a7b0eeacb46685$var$kr = ({ data: t })=>{
    var o;
    let e = $08a7b0eeacb46685$var$b(), { selectedMedia: r } = $08a7b0eeacb46685$var$P(), a = $acw62.useMemo(()=>r.some((i)=>i.id === t.id), [
        r
    ]);
    return $acw62.createElement($08a7b0eeacb46685$var$ut, {
        as: "div",
        media: t,
        triggerOnLeftClick: !e.allowSelect
    }, $acw62.createElement("div", {
        onClick: ()=>e.handleMediaClick(t),
        role: "button",
        className: `media-card ${a ? "media-card-selected" : ""}`
    }, (o = t.thumb) != null && o.url ? $acw62.createElement("img", {
        src: t.thumb.url,
        alt: t.filename,
        style: {
            objectFit: "cover",
            backgroundImage: `url(${t.thumb.pixel})`
        },
        className: "media-card-preview"
    }) : $acw62.createElement((0, $fCKVd.FlexCenteredInfo), {
        icon: "image-off-outline",
        text: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u0435\u0432'\u044E"
    }), $acw62.createElement("div", {
        className: "media-card-info"
    }, $acw62.createElement("i", {
        className: `mdi mdi-${$08a7b0eeacb46685$var$Ge[t.type]} me-1`
    }), t.filename)));
}, $08a7b0eeacb46685$var$ft = $08a7b0eeacb46685$var$kr;
var $08a7b0eeacb46685$var$Or = ()=>{
    let { media: t, loading: e, error: r } = $08a7b0eeacb46685$var$P();
    return t === null ? $acw62.createElement((0, $fCKVd.FlexCentered), null, $acw62.createElement((0, $fCKVd.BouncingLoader), null)) : t.length === 0 ? $acw62.createElement((0, $fCKVd.FlexCenteredInfo), {
        text: "\u041D\u0435\u043C\u0430\u0454 \u043C\u0435\u0434\u0456\u0430",
        icon: "image-off-outline"
    }) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement($08a7b0eeacb46685$var$ct, null), $acw62.createElement("div", {
        className: "p-1"
    }, $acw62.createElement((0, $h7C4J.default), {
        className: "gx-1 gy-1"
    }, t.map((a)=>$acw62.createElement((0, $99eL8.default), {
            xs: 6,
            sm: 4,
            md: 3,
            xl: 2,
            key: `item-${a.id}`
        }, $acw62.createElement($08a7b0eeacb46685$var$ft, {
            data: a
        }))))), e && $acw62.createElement("div", {
        className: "pt-3"
    }, $acw62.createElement((0, $fCKVd.BouncingLoader), null)), r && $acw62.createElement((0, $fCKVd.FlexCenteredInfo), {
        color: "danger",
        text: r,
        icon: "alert-circle-outline"
    }));
}, $08a7b0eeacb46685$var$yt = $08a7b0eeacb46685$var$Or;
var $08a7b0eeacb46685$var$Wr = ()=>{
    let t = $08a7b0eeacb46685$var$b(), e = $acw62.useCallback((r)=>{
        let a = r.currentTarget.scrollHeight, o = r.currentTarget.scrollTop + r.currentTarget.clientHeight;
        a - o < 40 && t.loadMore();
    }, []);
    return $acw62.createElement("div", {
        className: "custom-scrollbar scroll-vertical position-absolute top-0 bottom-0 start-0 end-0",
        onScroll: e
    }, $acw62.createElement($08a7b0eeacb46685$var$yt, null));
}, $08a7b0eeacb46685$var$ht = $08a7b0eeacb46685$var$Wr;
var $08a7b0eeacb46685$var$$r = ()=>$acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $h7C4J.default), {
        className: "g-1",
        style: {
            height: 700
        }
    }, $acw62.createElement((0, $99eL8.default), {
        lg: 3,
        className: "d-none d-lg-block"
    }, $acw62.createElement($08a7b0eeacb46685$var$ye, null, $acw62.createElement("div", {
        className: "h-100 position-relative"
    }, $acw62.createElement($08a7b0eeacb46685$var$J, {
        className: "custom-scrollbar scroll-vertical position-absolute top-0 bottom-0 start-0 end-0"
    })))), $acw62.createElement((0, $99eL8.default), {
        lg: 9
    }, $acw62.createElement($08a7b0eeacb46685$var$ye, null, $acw62.createElement("div", {
        className: "h-100 d-flex flex-column align-items-stretch"
    }, $acw62.createElement($08a7b0eeacb46685$var$st, null), $acw62.createElement("div", {
        className: "flex-grow-1 position-relative"
    }, $acw62.createElement($08a7b0eeacb46685$var$ht, null))))))), $08a7b0eeacb46685$var$xe = $08a7b0eeacb46685$var$$r;
var $08a7b0eeacb46685$var$Vr = ({ data: t })=>{
    let e = $08a7b0eeacb46685$export$6786621ea5daf880().folderManager, { folders: r } = (0, $fCKVd.useExternalStore)(e), a = $acw62.useMemo(()=>r ? r.filter((i)=>i.parent !== null).filter((i)=>{
            var d;
            return i.id.toString() !== ((d = t == null ? void 0 : t.id) == null ? void 0 : d.toString());
        }).map((i)=>({
                value: i.id,
                label: i.name
            })) : [], [
        r,
        t.id
    ]), o = $acw62.useMemo(()=>{
        var i, d, n;
        return {
            id: (i = t.id) != null ? i : null,
            name: (d = t.name) != null ? d : "",
            parent: (n = t.parent) != null ? n : null
        };
    }, [
        t
    ]);
    return $acw62.createElement((0, $fCKVd.Form).Callback, {
        data: o,
        handleSubmit: e.handleSubmit.bind(e),
        showSuccess: !1
    }, $acw62.createElement((0, $fCKVd.Modal).Body, null, $acw62.createElement((0, $fCKVd.Form).HiddenInput, {
        name: "id"
    }), $acw62.createElement((0, $fCKVd.Form).Input, {
        name: "name",
        label: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0430\u043F\u043A\u0438"
    }), $acw62.createElement((0, $fCKVd.Form).Select, {
        name: "parent",
        options: a,
        label: "\u0411\u0430\u0442\u044C\u043A\u0456\u0432\u0441\u044C\u043A\u0430 \u043F\u0430\u043F\u043A\u0430",
        allowEmpty: !0
    })), $acw62.createElement((0, $fCKVd.Modal).Footer, null, $acw62.createElement((0, $fCKVd.Form).Submit, null, t != null && t.id ? "\u0417\u043C\u0456\u043D\u0438\u0442\u0438" : "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438")));
}, $08a7b0eeacb46685$var$jr = ({ state: t })=>{
    let e = t.data ? t.data.id ? `\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0430\u043F\u043A\u0443 ${t.data.name}` : "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0430\u043F\u043A\u0443" : "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...";
    return $acw62.createElement((0, $fCKVd.Modal), {
        state: t,
        title: e,
        className: "modal-nested",
        backdropClassName: "modal-backdrop-nested"
    }, t.data ? $acw62.createElement($08a7b0eeacb46685$var$Vr, {
        data: t.data
    }) : $acw62.createElement((0, $fCKVd.BouncingLoader), null));
}, $08a7b0eeacb46685$var$bt = $08a7b0eeacb46685$var$jr;
var $08a7b0eeacb46685$var$Xr = ()=>$acw62.createElement($acw62.Fragment, null, "\u041F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u043D\u0456 \u0441\u0435\u0440\u0432\u0456\u0441\u0438:", " ", $acw62.createElement("b", null, "YouTube"), ", ", $acw62.createElement("b", null, "Facebook"), ", ", $acw62.createElement("b", null, "Instagram"), ", ", $acw62.createElement("b", null, "Telegram"), ", ", $acw62.createElement("b", null, "Twitter (X)"), ", ", $acw62.createElement("b", null, "TikTok")), $08a7b0eeacb46685$var$qr = ({ state: t })=>{
    var a;
    let e = $08a7b0eeacb46685$export$6786621ea5daf880().upload, r = $acw62.useCallback(async (o)=>{
        var i;
        await e.addFromLinks([
            o.link
        ], (i = t.data) == null ? void 0 : i.handler), t.close();
    }, [
        (a = t.data) == null ? void 0 : a.handler
    ]);
    return $acw62.createElement((0, $fCKVd.Modal), {
        state: t,
        title: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0437\u0430 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C",
        className: "modal-nested",
        backdropClassName: "modal-backdrop-nested"
    }, $acw62.createElement((0, $fCKVd.Form).Callback, {
        handleSubmit: r,
        showSuccess: !1
    }, $acw62.createElement((0, $fCKVd.Modal).Body, null, $acw62.createElement((0, $fCKVd.Form).Input, {
        name: "link",
        label: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
        text: $acw62.createElement($08a7b0eeacb46685$var$Xr, null),
        groupClass: ""
    })), $acw62.createElement((0, $fCKVd.Modal).Footer, null, $acw62.createElement((0, $fCKVd.Form).Submit, null, "\u0414\u043E\u0434\u0430\u0442\u0438"))));
}, $08a7b0eeacb46685$var$Ft = $08a7b0eeacb46685$var$qr;
var $08a7b0eeacb46685$var$Jr = ({ state: t })=>{
    var r;
    let e = async ()=>{
        var a;
        await ((a = t.data) == null ? void 0 : a.onConfirm()), t.close();
    };
    return $acw62.createElement((0, $fCKVd.Modal), {
        state: t,
        title: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u044F \u0434\u0456\u0457",
        titleBg: "danger",
        className: "modal-nested",
        backdropClassName: "modal-backdrop-nested"
    }, t.data ? $acw62.createElement((0, $fCKVd.Form).Callback, {
        handleSubmit: e,
        showSuccess: !1
    }, $acw62.createElement((0, $fCKVd.Modal).Body, null, $acw62.createElement("div", null, (r = t.data) == null ? void 0 : r.text)), $acw62.createElement((0, $fCKVd.Modal).Footer, null, $acw62.createElement((0, $fCKVd.Form).Submit, {
        variant: "danger",
        enable: !0
    }, "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438"), $acw62.createElement((0, $6LAgE.default), {
        variant: "secondary",
        onClick: t.close
    }, "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"))) : $acw62.createElement((0, $fCKVd.BouncingLoader), null));
}, $08a7b0eeacb46685$var$_t = $08a7b0eeacb46685$var$Jr;
var $08a7b0eeacb46685$var$ea = (t)=>({
        folder_id: t.folder_id
    }), $08a7b0eeacb46685$var$ta = ({ data: t })=>{
    let e = $08a7b0eeacb46685$export$6786621ea5daf880().mediaManager, r = $08a7b0eeacb46685$export$6786621ea5daf880().folderManager, { folders: a } = (0, $fCKVd.useExternalStore)(r), o = $acw62.useMemo(()=>{
        var d;
        return (d = a == null ? void 0 : a.filter((n)=>n.parent !== null).map((n)=>({
                value: n.id,
                label: n.name
            }))) != null ? d : [];
    }, [
        a
    ]), i = $acw62.useCallback(async (d)=>{
        await e.handleEditFormSubmit(t.id, d);
    }, [
        t.id
    ]);
    return $acw62.createElement((0, $fCKVd.Form).Callback, {
        data: $08a7b0eeacb46685$var$ea(t),
        handleSubmit: i,
        showSuccess: !1
    }, $acw62.createElement((0, $fCKVd.Modal).Body, null, $acw62.createElement((0, $fCKVd.Form).Select, {
        name: "folder_id",
        options: o,
        label: "\u041F\u0430\u043F\u043A\u0430",
        allowEmpty: !0,
        groupClass: ""
    })), $acw62.createElement((0, $fCKVd.Modal).Footer, null, $acw62.createElement((0, $fCKVd.Form).Submit, null, "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438")));
}, $08a7b0eeacb46685$var$ra = ({ state: t })=>$acw62.createElement((0, $fCKVd.Modal), {
        state: t,
        title: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043C\u0435\u0434\u0456\u0430",
        className: "modal-nested",
        backdropClassName: "modal-backdrop-nested"
    }, t.data ? $acw62.createElement($08a7b0eeacb46685$var$ta, {
        data: t.data
    }) : $acw62.createElement((0, $fCKVd.BouncingLoader), null)), $08a7b0eeacb46685$var$St = $08a7b0eeacb46685$var$ra;
var $08a7b0eeacb46685$var$aa = ()=>{
    let t = $08a7b0eeacb46685$export$6786621ea5daf880(), e = (0, $fCKVd.useModal)(), r = (0, $fCKVd.useModal)(), a = (0, $fCKVd.useModal)(), o = (0, $fCKVd.useModal)();
    return $acw62.useEffect(()=>{
        t.setStates({
            folderEditModal: e,
            uploadLinkModal: a,
            mediaEditModal: r,
            deleteModal: o
        });
    }, []), $acw62.createElement($acw62.Fragment, null, $acw62.createElement($08a7b0eeacb46685$var$bt, {
        state: e
    }), $acw62.createElement($08a7b0eeacb46685$var$Ft, {
        state: a
    }), $acw62.createElement($08a7b0eeacb46685$var$St, {
        state: r
    }), $acw62.createElement($08a7b0eeacb46685$var$_t, {
        state: o
    }));
}, $08a7b0eeacb46685$var$Ct = $08a7b0eeacb46685$var$aa;
function $08a7b0eeacb46685$var$Re(t) {
    let e = new $08a7b0eeacb46685$export$2b7e434e551ff47c(t);
    t.services.register("media-library", e), t.helpers.register("initializer", $08a7b0eeacb46685$var$Ct, "auth");
}
var $08a7b0eeacb46685$var$oa = ({ children: t })=>$acw62.createElement("div", {
        className: "mt-2"
    }, t), $08a7b0eeacb46685$var$ia = ({ showButtons: t, ...e })=>$acw62.createElement($08a7b0eeacb46685$var$Me, {
        ...e
    }, $acw62.createElement($08a7b0eeacb46685$var$xe, null), t && $acw62.createElement($08a7b0eeacb46685$var$fe, {
        wrapper: $08a7b0eeacb46685$var$oa
    })), $08a7b0eeacb46685$export$6c378f65a9da3030 = Object.assign($08a7b0eeacb46685$var$ia, {
    Buttons: $08a7b0eeacb46685$var$fe,
    Wrapper: $08a7b0eeacb46685$var$Me,
    Body: $08a7b0eeacb46685$var$xe,
    initializer: $08a7b0eeacb46685$var$Re
});
var $08a7b0eeacb46685$var$da = ({ state: t, handleSelect: e, handleSubmit: r, closeOnSelect: a, closeOnSubmit: o, selectAction: i, ...d })=>{
    let n = $acw62.useCallback((B)=>{
        e && e(B), a && t.close();
    }, []), c = $acw62.useCallback((B)=>{
        r && r(B), o && t.close();
    }, []);
    return $acw62.createElement((0, $fCKVd.Modal), {
        title: "\u041C\u0435\u0434\u0456\u0430 \u0431\u0456\u0431\u043B\u0456\u043E\u0442\u0435\u043A\u0430",
        size: "xl",
        state: t,
        className: "media-library-modal"
    }, $acw62.createElement($08a7b0eeacb46685$export$6c378f65a9da3030.Wrapper, {
        ...d,
        handleSelect: n,
        handleSubmit: c,
        selectAction: i
    }, $acw62.createElement((0, $fCKVd.Modal).Body, null, $acw62.createElement($08a7b0eeacb46685$export$6c378f65a9da3030.Body, null)), $acw62.createElement($08a7b0eeacb46685$export$6c378f65a9da3030.Buttons, {
        wrapper: (0, $fCKVd.Modal).Footer
    })));
}, $08a7b0eeacb46685$export$4eeee67d3df98ed8 = $08a7b0eeacb46685$var$da;
function $08a7b0eeacb46685$export$1f6a311a7539099a(t) {
    let e = $08a7b0eeacb46685$export$6786621ea5daf880();
    return (0, $acw62.useMemo)(()=>t ? Array.isArray(t) ? e.loadMediaList(t) : e.loadMedia(t) : Promise.resolve(null), [
        t
    ]);
}
function $08a7b0eeacb46685$export$ba33b39b853b4664(t) {
    let e = $08a7b0eeacb46685$export$6786621ea5daf880(), [r, a] = (0, $acw62.useState)();
    return (0, $acw62.useEffect)(()=>{
        if (a(void 0), !t) {
            a(null);
            return;
        }
        e.loadMedia(t).then((o)=>a(o)).catch((o)=>console.error(o));
    }, [
        t
    ]), r;
}
var $08a7b0eeacb46685$var$ma = ({ data: t, caption: e })=>{
    var r, a, o;
    return $acw62.createElement("div", {
        className: "ova-engine-audio"
    }, $acw62.createElement("audio", {
        preload: "none"
    }, $acw62.createElement("source", {
        src: (r = t.url) != null ? r : "",
        type: t.mime_type
    })), $acw62.createElement("div", {
        className: "ova-engine-audio-player"
    }, $acw62.createElement("button", {
        className: "ova-engine-audio-player__play"
    }, "\u0412\u0456\u0434\u0442\u0432\u043E\u0440\u0438\u0442\u0438"), $acw62.createElement("input", {
        type: "range",
        "aria-label": "position",
        className: "ova-engine-audio-player__progress",
        min: 0,
        max: 100,
        value: 0,
        readOnly: !0
    }), $acw62.createElement("div", {
        className: "ova-engine-audio-player__time"
    }, "00:00 / ", (o = (a = t.meta_data) == null ? void 0 : a.duration) != null ? o : "00:00"), $acw62.createElement("button", {
        className: "ova-engine-audio-player__volume-button"
    }, "\u0413\u0443\u0447\u043D\u0456\u0441\u0442\u044C"), $acw62.createElement("input", {
        type: "range",
        "aria-label": "volume",
        className: "ova-engine-audio-player__volume-range",
        min: 0,
        max: 1,
        value: 1,
        step: .01,
        readOnly: !0
    })), e && $acw62.createElement("figcaption", null, e));
}, $08a7b0eeacb46685$var$Dt = $08a7b0eeacb46685$var$ma;
function $08a7b0eeacb46685$var$Te(t) {
    return t.split("/").pop() || "";
}
var $08a7b0eeacb46685$var$ca = ({ data: t, alt: e, lazy: r, className: a })=>$acw62.createElement("picture", {
        className: a
    }, t.sources.map((o, i)=>$acw62.createElement("source", {
            key: i,
            srcSet: o.url,
            type: `image/${o.ext}`,
            media: o.width ? `(min-width: ${o.width}px)` : void 0
        })), $acw62.createElement("img", {
        src: t.url,
        alt: e != null ? e : "",
        loading: r ? "lazy" : "eager",
        style: {
            aspectRatio: t.aspectRatio,
            backgroundImage: t.pixel ? `url(${t.pixel})` : ""
        }
    })), $08a7b0eeacb46685$export$c049f7d80347532d = $08a7b0eeacb46685$var$ca;
var $08a7b0eeacb46685$var$ua = ({ data: t, caption: e, lazy: r })=>t.image ? $acw62.createElement("figure", {
        className: "ova-engine-embed",
        "data-code-url": "TODO",
        "data-social-type": $08a7b0eeacb46685$var$Te(t.mime_type)
    }, $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
        data: t.image,
        alt: e,
        lazy: r,
        className: "ova-engine-embed-preview"
    }), e && $acw62.createElement("figcaption", null, e)) : null, $08a7b0eeacb46685$var$Lt = $08a7b0eeacb46685$var$ua;
var $08a7b0eeacb46685$var$fa = ({ data: t, caption: e, lazy: r })=>{
    var a, o, i, d, n;
    return t.image ? $acw62.createElement("figure", {
        className: "ova-engine-video ova-engine-video-youtube",
        "data-video-youtube": (o = (a = t.meta_data) == null ? void 0 : a.videoId) != null ? o : "",
        "data-video-youtube-start": (n = (d = (i = t.meta_data) == null ? void 0 : i.startTime) == null ? void 0 : d.toString()) != null ? n : "0"
    }, $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
        data: t.image,
        alt: e,
        lazy: r,
        className: "ova-engine-video-placeholder"
    }), e && $acw62.createElement("figcaption", null, e)) : null;
}, $08a7b0eeacb46685$var$Pt = $08a7b0eeacb46685$var$fa;
function $08a7b0eeacb46685$var$Be(t) {
    return t.split(".").pop() || "";
}
var $08a7b0eeacb46685$var$Ma = ({ data: t, lazy: e, caption: r, disableInteraction: a })=>t.url ? $acw62.createElement(a ? "span" : "a", {
        href: t.url,
        className: "ova-engine-document",
        "data-file-type": $08a7b0eeacb46685$var$Be(t.url)
    }, $acw62.createElement("figure", null, t.preview ? $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
        data: t.preview,
        alt: r,
        lazy: e
    }) : $acw62.createElement("div", {
        className: "ova-engine-document-placeholder"
    }), $acw62.createElement("figcaption", null, r != null ? r : t.filename))) : null, $08a7b0eeacb46685$var$Rt = $08a7b0eeacb46685$var$Ma;
var $08a7b0eeacb46685$var$ga = ({ data: t, caption: e, lazy: r })=>!t.url || !t.image ? null : $acw62.createElement("figure", {
        className: "ova-engine-video",
        "data-video-local": t.url
    }, $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
        data: t.image,
        alt: e,
        lazy: r,
        className: "ova-engine-video-placeholder"
    }), e && $acw62.createElement("figcaption", null, e)), $08a7b0eeacb46685$var$It = $08a7b0eeacb46685$var$ga;
var $08a7b0eeacb46685$var$ya = ({ data: t, caption: e, lazy: r })=>t.image ? $acw62.createElement("figure", {
        className: "ova-engine-image"
    }, $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
        data: t.image,
        alt: e,
        lazy: r
    }), e && $acw62.createElement("figcaption", null, e)) : null, $08a7b0eeacb46685$var$wt = $08a7b0eeacb46685$var$ya;
var $08a7b0eeacb46685$var$ha = ({ data: t, ...e })=>t.type === "audio" ? $acw62.createElement($08a7b0eeacb46685$var$Dt, {
        data: t,
        ...e
    }) : t.type === "embed" ? t.mime_type === "ova-embed/youtube" ? $acw62.createElement($08a7b0eeacb46685$var$Pt, {
        data: t,
        ...e
    }) : $acw62.createElement($08a7b0eeacb46685$var$Lt, {
        data: t,
        ...e
    }) : t.type === "file" ? $acw62.createElement($08a7b0eeacb46685$var$Rt, {
        data: t,
        ...e
    }) : t.type === "video" ? $acw62.createElement($08a7b0eeacb46685$var$It, {
        data: t,
        ...e
    }) : t.type === "image" ? $acw62.createElement($08a7b0eeacb46685$var$wt, {
        data: t,
        ...e
    }) : null, $08a7b0eeacb46685$export$5b22ab56777dd834 = $08a7b0eeacb46685$var$ha;
var $08a7b0eeacb46685$var$Fa = ({ data: t, conversion: e, alt: r, fallbackType: a, lazy: o })=>{
    let i = $acw62.useMemo(()=>t.conversions[e] ? t.conversions[e] : a === "image" && t.image ? t.image : a === "preview" && t.preview ? t.preview : null, []);
    return i ? $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
        data: i,
        alt: r,
        lazy: o,
        className: (0, $9QePP.default)("ova-engine-image-conversion", `ova-engine-image-conversion-${e}`, {
            "ova-engine-image-conversion--video": t.type === "video" || t.mime_type === "ova-embed/youtube"
        })
    }) : null;
}, $08a7b0eeacb46685$export$1542c537e6822675 = $08a7b0eeacb46685$var$Fa;
var $08a7b0eeacb46685$var$Sa = (t)=>{
    t && (0, $jrCwd.default)(t, {
        itemSelector: ".ova-gallery__item",
        gutter: 2,
        lastRow: "center",
        rowHeight: 200,
        rowHeightTolerance: .2
    });
}, $08a7b0eeacb46685$var$Ca = ({ items: t, captions: e, lazy: r, disableInteraction: a })=>{
    let o = $acw62.useMemo(()=>t.filter((d)=>!!d.image).map((d)=>({
                media: d,
                caption: e == null ? void 0 : e[d.id],
                width: 1920,
                height: 1920 * d.image.aspectRatio
            })), []), i = a ? "span" : "a";
    return $acw62.createElement("div", {
        className: "ova-gallery",
        ref: $08a7b0eeacb46685$var$Sa
    }, o.map((d)=>$acw62.createElement(i, {
            href: d.media.image.url,
            key: d.media.id,
            "data-lg-size": `${d.width}-${d.height}`,
            className: "ova-gallery__item"
        }, $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
            data: d.media.preview,
            alt: d.caption,
            lazy: r
        }))));
}, $08a7b0eeacb46685$export$26639b5e905ce7df = $08a7b0eeacb46685$var$Ca;
var $08a7b0eeacb46685$var$Pa = ({ data: t, alt: e, lazy: r })=>t.preview ? $acw62.createElement($08a7b0eeacb46685$export$c049f7d80347532d, {
        data: t.preview,
        alt: e,
        lazy: r,
        className: (0, $9QePP.default)("ova-engine-image-preview", {
            "ova-engine-image-preview-video": t.type === "video" || t.mime_type === "ova-embed/youtube"
        })
    }) : null, $08a7b0eeacb46685$export$a694a2f74268cca = $08a7b0eeacb46685$var$Pa;
var $08a7b0eeacb46685$var$Tt = (0, $acw62.createContext)(void 0), $08a7b0eeacb46685$var$ke = ()=>{
    let t = (0, $acw62.useContext)($08a7b0eeacb46685$var$Tt);
    if (!t) throw new Error("useFormMediaSelectContext must be used within a FormMediaSelectContext");
    return t;
}, $08a7b0eeacb46685$var$Bt = $08a7b0eeacb46685$var$Tt;
var $08a7b0eeacb46685$var$Ea = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg fill='%238391a2' viewBox='-20 -20 72 72' xmlns='http://www.w3.org/2000/svg'%3E%3Cstyle%3E.c1%7Bfill:none;%7D%3C/style%3E%3Cpath d='M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z'/%3E%3Cpath d='M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z'/%3E%3Crect class='c1' width='32' height='32'/%3E%3C/svg%3E", $08a7b0eeacb46685$var$Ne = $08a7b0eeacb46685$var$Ea;
var $08a7b0eeacb46685$var$ka = ({ children: t })=>{
    let { media: e } = $08a7b0eeacb46685$var$ke(), r = $acw62.useMemo(()=>{
        var a, o, i;
        if (e !== void 0) return e === null ? {
            src: $08a7b0eeacb46685$var$Ne,
            name: "\u043D\u0435 \u0432\u0438\u0431\u0440\u0430\u043D\u043E"
        } : {
            src: (o = (a = e.image) == null ? void 0 : a.url) != null ? o : $08a7b0eeacb46685$var$Ne,
            name: (i = e.filename) != null ? i : "\u041D\u0435\u043C\u0430\u0454 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F"
        };
    }, [
        e
    ]);
    return $acw62.createElement($acw62.Fragment, null, t(r));
}, $08a7b0eeacb46685$var$Na = ({ variant: t = "secondary", size: e = "sm", children: r, ...a })=>{
    let { openModal: o } = $08a7b0eeacb46685$var$ke();
    return $acw62.createElement((0, $6LAgE.default), {
        variant: t,
        size: e,
        ...a,
        onClick: o
    }, r != null ? r : $acw62.createElement("i", {
        className: "mdi mdi-pencil font-16"
    }));
}, $08a7b0eeacb46685$var$Ua = ({ mediaId: t, onChange: e, types: r, children: a })=>{
    let o = (0, $fCKVd.useModal)(), i = $08a7b0eeacb46685$export$ba33b39b853b4664(t);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement($08a7b0eeacb46685$export$4eeee67d3df98ed8, {
        state: o,
        handleSubmit: (d)=>e(d[0].id),
        closeOnSubmit: !0,
        selectAction: "selectSingle",
        types: r
    }), $acw62.createElement($08a7b0eeacb46685$var$Bt.Provider, {
        value: {
            media: i,
            mediaId: t,
            openModal: o.open
        }
    }, a));
}, $08a7b0eeacb46685$var$C = Object.assign($08a7b0eeacb46685$var$Ua, {
    Media: $08a7b0eeacb46685$var$ka,
    Button: $08a7b0eeacb46685$var$Na
});
var $08a7b0eeacb46685$var$Wa = ({ name: t, types: e, children: r })=>{
    let { control: a } = (0, $fCKVd.Form).useFormContext();
    return $acw62.createElement((0, $22i8b.Controller), {
        control: a,
        name: t,
        render: ({ field: { value: o, onChange: i } })=>$acw62.createElement($acw62.Fragment, null, $acw62.createElement($08a7b0eeacb46685$var$C, {
                mediaId: o,
                onChange: i,
                types: e,
                children: r
            }))
    });
}, $08a7b0eeacb46685$var$X = $08a7b0eeacb46685$var$Wa;
var $08a7b0eeacb46685$var$za = ({ aspectRatio: t = "16/9", ...e })=>$acw62.createElement($08a7b0eeacb46685$var$X, {
        ...e
    }, $acw62.createElement((0, $aX99y.default), {
        style: {
            aspectRatio: t
        }
    }, $acw62.createElement($08a7b0eeacb46685$var$C.Media, null, (r)=>r ? $acw62.createElement((0, $aX99y.default).Img, {
            src: r.src,
            alt: r.name,
            style: {
                objectFit: "cover",
                height: "100%"
            }
        }) : $acw62.createElement((0, $fCKVd.FlexCentered), null, $acw62.createElement((0, $fCKVd.BouncingLoader), null))), $acw62.createElement((0, $aX99y.default).ImgOverlay, {
        className: "text-end"
    }, $acw62.createElement($08a7b0eeacb46685$var$C.Button, null)))), $08a7b0eeacb46685$export$74ac09ae479df5f1 = $08a7b0eeacb46685$var$za;
var $08a7b0eeacb46685$var$qa = ({ name: t, types: e, maxWidth: r, ...a })=>$acw62.createElement($08a7b0eeacb46685$var$X, {
        name: t,
        types: e
    }, $acw62.createElement((0, $fCKVd.Form).GroupContainer, {
        name: t,
        ...a
    }, ({ isError: o, errorMessage: i })=>$acw62.createElement("div", {
            className: "d-flex align-items-start gap-2"
        }, $acw62.createElement("div", {
            className: "flex-grow-1"
        }, $acw62.createElement($08a7b0eeacb46685$var$C.Media, null, (d)=>d ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $186Ez.default), {
                thumbnail: !0,
                className: o ? "border border-danger" : "",
                src: d.src,
                alt: d.name,
                style: {
                    maxWidth: r
                }
            }), o && $acw62.createElement("div", {
                className: "small text-danger"
            }, i)) : $acw62.createElement((0, $fCKVd.BouncingLoader), null))), $acw62.createElement($08a7b0eeacb46685$var$C.Button, null)))), $08a7b0eeacb46685$export$8b921ef180763237 = $08a7b0eeacb46685$var$qa;
var $08a7b0eeacb46685$var$Ka = ({ name: t, types: e, ...r })=>$acw62.createElement($08a7b0eeacb46685$var$X, {
        name: t,
        types: e
    }, $acw62.createElement((0, $fCKVd.Form).InputGroupContainer, {
        name: t,
        ...r
    }, ({ isError: a })=>$acw62.createElement($acw62.Fragment, null, $acw62.createElement($08a7b0eeacb46685$var$C.Media, null, (o)=>o ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $6WSsf.default).Text, {
                className: "p-0"
            }, $acw62.createElement("img", {
                src: o.src,
                alt: o.name,
                style: {
                    height: 36
                }
            })), $acw62.createElement((0, $6WSsf.default).Text, {
                className: (0, $9QePP.default)("flex-grow-1", a && "text-danger")
            }, o.name)) : $acw62.createElement((0, $6WSsf.default).Text, {
                className: "flex-grow-1 lh-1"
            }, $acw62.createElement("i", {
                className: "mdi mdi-loading mdi-spin font-20 me-1"
            }), "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...")), $acw62.createElement($08a7b0eeacb46685$var$C.Button, null)))), $08a7b0eeacb46685$export$21db5aa2fe75a07c = $08a7b0eeacb46685$var$Ka;

});
parcelRegister("186Ez", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2bb30966f67ea2$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8rTrh = parcelRequire("8rTrh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $0d2bb30966f67ea2$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
const $0d2bb30966f67ea2$var$Image = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $8rTrh.useBootstrapPrefix)(bsPrefix, "img");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        // eslint-disable-line jsx-a11y/alt-text
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$0d2bb30966f67ea2$var$Image.displayName = "Image";
var $0d2bb30966f67ea2$export$2e2bcd8739ae039 = $0d2bb30966f67ea2$var$Image;

});

parcelRegister("gfQkH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd56a4485ab443d2$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8rTrh = parcelRequire("8rTrh");

var $iaLOT = parcelRequire("iaLOT");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $bd56a4485ab443d2$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $bd56a4485ab443d2$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $acw62.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const element = /*#__PURE__*/ (0, $ayMG0.jsx)($bd56a4485ab443d2$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $acw62.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $bd56a4485ab443d2$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $bd56a4485ab443d2$var$ROUND_PRECISION) / $bd56a4485ab443d2$var$ROUND_PRECISION;
}
function $bd56a4485ab443d2$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$bd56a4485ab443d2$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $bd56a4485ab443d2$var$ProgressBar = /*#__PURE__*/ $acw62.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $8rTrh.useBootstrapPrefix)(props.bsPrefix, "progress");
    if (isChild) return $bd56a4485ab443d2$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        children: children ? (0, $iaLOT.map)(children, (child)=>/*#__PURE__*/ (0, $acw62.cloneElement)(child, {
                isChild: true
            })) : $bd56a4485ab443d2$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$bd56a4485ab443d2$var$ProgressBar.displayName = "ProgressBar";
var $bd56a4485ab443d2$export$2e2bcd8739ae039 = $bd56a4485ab443d2$var$ProgressBar;

});

parcelRegister("1yfa6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214ba4a0ed97e08$export$2e2bcd8739ae039);

var $8g1PZ = parcelRequire("8g1PZ");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
function $1214ba4a0ed97e08$var$d(e) {
    return ($1214ba4a0ed97e08$var$d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
}
function $1214ba4a0ed97e08$var$i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $1214ba4a0ed97e08$var$s(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == n) return;
        var a, l, r = [], d = !0, i = !1;
        try {
            for(n = n.call(e); !(d = (a = n.next()).done) && (r.push(a.value), !t || r.length !== t); d = !0);
        } catch (e) {
            i = !0, l = e;
        } finally{
            try {
                d || null == n.return || n.return();
            } finally{
                if (i) throw l;
            }
        }
        return r;
    }(e, t) || $1214ba4a0ed97e08$var$o(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $1214ba4a0ed97e08$var$c(e) {
    return function(e) {
        if (Array.isArray(e)) return $1214ba4a0ed97e08$var$u(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || $1214ba4a0ed97e08$var$o(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $1214ba4a0ed97e08$var$o(e, t) {
    if (e) {
        if ("string" == typeof e) return $1214ba4a0ed97e08$var$u(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $1214ba4a0ed97e08$var$u(e, t) : void 0;
    }
}
function $1214ba4a0ed97e08$var$u(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, a = new Array(t); n < t; n++)a[n] = e[n];
    return a;
}
function $1214ba4a0ed97e08$var$f(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = $1214ba4a0ed97e08$var$o(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var a = 0, l = function() {};
            return {
                s: l,
                n: function() {
                    return a >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[a++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: l
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r, d = !0, i = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return d = e.done, e;
        },
        e: function(e) {
            i = !0, r = e;
        },
        f: function() {
            try {
                d || null == n.return || n.return();
            } finally{
                if (i) throw r;
            }
        }
    };
}
function $1214ba4a0ed97e08$var$h(e, t) {
    var n = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var l = 0;
        for(a = Object.getOwnPropertySymbols(e); l < a.length; l++)t.indexOf(a[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[l]) && (n[a[l]] = e[a[l]]);
    }
    return n;
}
var $1214ba4a0ed97e08$var$p = {
    root: "tree",
    node: "tree-node",
    branch: "tree-node__branch",
    branchWrapper: "tree-branch-wrapper",
    leafListItem: "tree-leaf-list-item",
    leaf: "tree-node__leaf",
    nodeGroup: "tree-node-group"
}, $1214ba4a0ed97e08$var$v = {
    select: "SELECT",
    focus: "FOCUS",
    exclusiveSelect: "EXCLUSIVE_SELECT"
}, $1214ba4a0ed97e08$export$125ef903505d7891 = Object.freeze(Object.values($1214ba4a0ed97e08$var$v)), $1214ba4a0ed97e08$var$S = Object.freeze(Object.values({
    check: "check",
    select: "select"
})), $1214ba4a0ed97e08$var$y = "COLLAPSE", $1214ba4a0ed97e08$var$I = "COLLAPSE_MANY", $1214ba4a0ed97e08$var$g = "EXPAND", $1214ba4a0ed97e08$var$m = "EXPAND_MANY", $1214ba4a0ed97e08$var$w = "HALF_SELECT", $1214ba4a0ed97e08$var$E = "SELECT", $1214ba4a0ed97e08$var$A = "DESELECT", $1214ba4a0ed97e08$var$O = "TOGGLE", $1214ba4a0ed97e08$var$W = "TOGGLE_SELECT", $1214ba4a0ed97e08$var$x = "SELECT_MANY", $1214ba4a0ed97e08$var$T = "EXCLUSIVE_CHANGE_SELECT_MANY", $1214ba4a0ed97e08$var$j = "FOCUS", $1214ba4a0ed97e08$var$N = "BLUR", $1214ba4a0ed97e08$var$D = "DISABLE", $1214ba4a0ed97e08$var$C = "ENABLE", $1214ba4a0ed97e08$var$U = "CLEAR_MANUALLY_TOGGLED", $1214ba4a0ed97e08$var$M = "CONTROLLED_SELECT_MANY", $1214ba4a0ed97e08$var$k = "UPDATE_TREE_STATE_WHEN_DATA_CHANGED", $1214ba4a0ed97e08$var$L = function() {}, $1214ba4a0ed97e08$var$R = function() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    return function(e) {
        for(var n = 0, a = t; n < a.length; n++){
            var l = a[n];
            if (l && l(e), e.defaultPrevented) break;
        }
    };
}, $1214ba4a0ed97e08$var$_ = function(e, t) {
    var n, a = new Set, l = $1214ba4a0ed97e08$var$f(e);
    try {
        for(l.s(); !(n = l.n()).done;){
            var r = n.value;
            t.has(r) || a.add(r);
        }
    } catch (e) {
        l.e(e);
    } finally{
        l.f();
    }
    return a;
}, $1214ba4a0ed97e08$var$B = function(e, t) {
    return new Set([].concat($1214ba4a0ed97e08$var$c($1214ba4a0ed97e08$var$_(e, t)), $1214ba4a0ed97e08$var$c($1214ba4a0ed97e08$var$_(t, e))));
}, $1214ba4a0ed97e08$var$F = function(e) {
    var t = (0, $acw62.useRef)();
    return (0, $acw62.useEffect)(function() {
        t.current = e;
    }, [
        e
    ]), t.current;
}, $1214ba4a0ed97e08$var$z = function(e, t) {
    var n;
    return !!(null === (n = $1214ba4a0ed97e08$var$re(e, t).children) || void 0 === n ? void 0 : n.length);
}, $1214ba4a0ed97e08$var$H = function(e, t) {
    return $1214ba4a0ed97e08$var$re(e, t).parent;
}, $1214ba4a0ed97e08$var$K = function(e, t, n) {
    for(var a = t, l = [];;){
        var r = $1214ba4a0ed97e08$var$H(e, a);
        if (0 === r || null == r || null != r && n.has(r)) break;
        l.push(r), a = r;
    }
    return l;
}, $1214ba4a0ed97e08$var$P = function(e, t, n) {
    var a = [];
    return function e(t, l) {
        var r = $1214ba4a0ed97e08$var$re(t, l);
        if (null != r.children) {
            var d, i = $1214ba4a0ed97e08$var$f(r.children.filter(function(e) {
                return !n.has(e);
            }));
            try {
                for(i.s(); !(d = i.n()).done;){
                    var s = d.value;
                    a.push(s), e(t, s);
                }
            } catch (e) {
                i.e(e);
            } finally{
                i.f();
            }
        }
    }(e, t), a;
}, $1214ba4a0ed97e08$var$G = function(e, t) {
    var n = $1214ba4a0ed97e08$var$re(e, t);
    return null == n.children ? [] : n.children;
}, $1214ba4a0ed97e08$var$V = function(e, t, n) {
    var a = $1214ba4a0ed97e08$var$H(e, t);
    if (null != a) {
        var l = $1214ba4a0ed97e08$var$re(e, a), r = l.children.indexOf(t) + n;
        if (l.children[r]) return l.children[r];
    }
    return null;
}, $1214ba4a0ed97e08$var$Y = function(e, t, n) {
    var a = $1214ba4a0ed97e08$var$re(e, t);
    for($1214ba4a0ed97e08$var$le(e).id === t && (a = $1214ba4a0ed97e08$var$re(e, $1214ba4a0ed97e08$var$re(e, t).children[$1214ba4a0ed97e08$var$re(e, t).children.length - 1])); n.has(a.id) && $1214ba4a0ed97e08$var$z(e, a.id);)a = $1214ba4a0ed97e08$var$re(e, a.children[a.children.length - 1]);
    return a.id;
}, $1214ba4a0ed97e08$var$q = function(e, t, n) {
    if (t === $1214ba4a0ed97e08$var$le(e).children[0]) return null;
    var a = $1214ba4a0ed97e08$var$V(e, t, -1);
    return null == a ? $1214ba4a0ed97e08$var$H(e, t) : $1214ba4a0ed97e08$var$Y(e, a, n);
}, $1214ba4a0ed97e08$var$X = function(e, t, n) {
    var a = $1214ba4a0ed97e08$var$re(e, t).id;
    if ($1214ba4a0ed97e08$var$z(e, a) && n.has(a)) return $1214ba4a0ed97e08$var$re(e, a).children[0];
    for(;;){
        var l = $1214ba4a0ed97e08$var$V(e, a, 1);
        if (null != l) return l;
        if (null == (a = $1214ba4a0ed97e08$var$H(e, a))) return null;
    }
}, $1214ba4a0ed97e08$var$$ = function(e) {
    var t = e.data, n = e.expandedIds, a = e.from, l = e.to, r = [], d = t.length, i = 0, s = a;
    if (r.push(a), a < l) for(; i < d && (null != (s = $1214ba4a0ed97e08$var$X(t, s, n)) && r.push(s), null != s && s !== l);)i += 1;
    else if (a > l) for(; i < d && (null != (s = $1214ba4a0ed97e08$var$q(t, s, n)) && r.push(s), null != s && s !== l);)i += 1;
    return r;
}, $1214ba4a0ed97e08$export$79f9fa345a841d8b = function(e) {
    var t = 0, n = [];
    return function e(a, l) {
        var r, d = Object.assign(Object.assign({
            id: a.id || t,
            name: a.name,
            children: []
        }, a.isBranch && {
            isBranch: a.isBranch
        }), {
            parent: l,
            metadata: a.metadata ? Object.assign({}, a.metadata) : void 0
        });
        if (n.find(function(e) {
            return e.id === d.id;
        })) throw Error("Multiple TreeView nodes have the same ID (".concat(d.id, "). IDs must be unique."));
        if (n.push(d), t += 1, null === (r = a.children) || void 0 === r ? void 0 : r.length) {
            var i, s = $1214ba4a0ed97e08$var$f(a.children);
            try {
                for(s.s(); !(i = s.n()).done;)e(i.value, d.id);
            } catch (e) {
                s.e(e);
            } finally{
                s.f();
            }
            var c, o = $1214ba4a0ed97e08$var$f(n.values());
            try {
                for(o.s(); !(c = o.n()).done;){
                    var u = c.value;
                    u.parent === d.id && d.children.push(u.id);
                }
            } catch (e) {
                o.e(e);
            } finally{
                o.f();
            }
        }
    }(e, null), n;
}, $1214ba4a0ed97e08$var$Q = function(e) {
    var t = e.isSelected, n = e.isDisabled, a = e.multiSelect;
    return n || a ? t : !!t || void 0;
}, $1214ba4a0ed97e08$var$Z = function(e) {
    var t = e.isSelected, n = e.isDisabled, a = e.isHalfSelected, l = e.multiSelect;
    return n ? t : a ? "mixed" : l ? t : !!t || void 0;
}, $1214ba4a0ed97e08$var$ee = function(e, t, n) {
    return t.concat.apply(t, $1214ba4a0ed97e08$var$c(t.filter(function(t) {
        return $1214ba4a0ed97e08$var$z(e, t);
    }).map(function(t) {
        return $1214ba4a0ed97e08$var$P(e, t, n);
    })));
}, $1214ba4a0ed97e08$var$te = function(e, t, n) {
    null != t ? window.navigator.userAgent.match(/Trident/) ? setTimeout(function() {
        return !t.contains(document.activeElement) && n();
    }, 0) : !t.contains(e.nativeEvent.relatedTarget) && n() : console.warn("ref not set on <ul>");
}, $1214ba4a0ed97e08$var$ne = function(e, t, n) {
    var a = $1214ba4a0ed97e08$var$G(e, t);
    return $1214ba4a0ed97e08$var$z(e, t) && !n.has(t) && 1 === a.length && a.every(function(e) {
        return n.has(e);
    });
}, $1214ba4a0ed97e08$var$ae = function(e, t, n, a) {
    var l = function(e, t, n) {
        return $1214ba4a0ed97e08$var$z(e, t) && n.has(t) && $1214ba4a0ed97e08$var$P(e, t, new Set).some(function(e) {
            return n.has(e);
        });
    }(e, t, n), r = function(e, t, n) {
        var a = $1214ba4a0ed97e08$var$G(e, t);
        return $1214ba4a0ed97e08$var$z(e, t) && n.has(t) && 1 === a.length && a.every(function(e) {
            return n.has(e);
        });
    }(e, t, n);
    return function(e, t, n, a) {
        var l = $1214ba4a0ed97e08$var$P(e, t, new Set);
        return $1214ba4a0ed97e08$var$z(e, t) && n.has(t) && l.every(function(e) {
            return n.has(e);
        }) && l.every(function(e) {
            return !a.has(e);
        });
    }(e, t, n, a) ? $1214ba4a0ed97e08$var$W : l && !r ? $1214ba4a0ed97e08$var$w : $1214ba4a0ed97e08$var$W;
}, $1214ba4a0ed97e08$var$le = function(e) {
    var t = e.find(function(e) {
        return null === e.parent;
    });
    if (!t) throw Error("TreeView data must contain parent node.");
    return t;
}, $1214ba4a0ed97e08$var$re = function(e, t) {
    var n = e.find(function(e) {
        return e.id === t;
    });
    if (null == n) throw Error("Node with id=".concat(t, " doesn't exist in the tree."));
    return n;
}, $1214ba4a0ed97e08$var$de = function(e) {
    var t = Array.from(new Set(e));
    return e.length !== t.length;
}, $1214ba4a0ed97e08$var$ie = function(e, t) {
    switch(t.type){
        case $1214ba4a0ed97e08$var$y:
            var n = new Set(e.expandedIds);
            return n.delete(t.id), Object.assign(Object.assign({}, e), {
                expandedIds: n,
                tabbableId: t.id,
                isFocused: !0,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith
            });
        case $1214ba4a0ed97e08$var$I:
            var a, l = new Set(e.expandedIds), r = $1214ba4a0ed97e08$var$f(t.ids);
            try {
                for(r.s(); !(a = r.n()).done;){
                    var d = a.value;
                    l.delete(d);
                }
            } catch (e) {
                r.e(e);
            } finally{
                r.f();
            }
            return Object.assign(Object.assign({}, e), {
                expandedIds: l,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith
            });
        case $1214ba4a0ed97e08$var$g:
            var i = new Set(e.expandedIds);
            return i.add(t.id), Object.assign(Object.assign({}, e), {
                expandedIds: i,
                tabbableId: t.id,
                isFocused: !0,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith
            });
        case $1214ba4a0ed97e08$var$m:
            var s = new Set([].concat($1214ba4a0ed97e08$var$c(e.expandedIds), $1214ba4a0ed97e08$var$c(t.ids)));
            return Object.assign(Object.assign({}, e), {
                expandedIds: s,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith
            });
        case $1214ba4a0ed97e08$var$O:
            var o = new Set(e.expandedIds);
            return e.expandedIds.has(t.id) ? o.delete(t.id) : o.add(t.id), Object.assign(Object.assign({}, e), {
                expandedIds: o,
                tabbableId: t.id,
                isFocused: !0,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith
            });
        case $1214ba4a0ed97e08$var$w:
            if (e.disabledIds.has(t.id)) return e;
            var u = new Set(e.halfSelectedIds), h = new Set(e.selectedIds);
            return u.add(t.id), h.delete(t.id), Object.assign(Object.assign({}, e), {
                selectedIds: h,
                halfSelectedIds: u,
                tabbableId: t.keepFocus ? e.tabbableId : t.id,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith,
                lastManuallyToggled: t.lastManuallyToggled,
                lastUserSelect: t.NotUserAction ? e.lastUserSelect : t.id
            });
        case $1214ba4a0ed97e08$var$E:
            if (!t.NotUserAction && e.disabledIds.has(t.id)) return e;
            var p;
            t.multiSelect ? (p = new Set(e.selectedIds)).add(t.id) : (p = new Set).add(t.id);
            var v = new Set(e.halfSelectedIds);
            return v.delete(t.id), Object.assign(Object.assign({}, e), {
                selectedIds: p,
                halfSelectedIds: v,
                tabbableId: t.keepFocus ? e.tabbableId : t.id,
                isFocused: !0 !== t.NotUserAction,
                lastUserSelect: t.NotUserAction ? e.lastUserSelect : t.id,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith,
                lastManuallyToggled: t.lastManuallyToggled
            });
        case $1214ba4a0ed97e08$var$A:
            if (!t.NotUserAction && e.disabledIds.has(t.id)) return e;
            var b, S = new Set(e.selectedIds);
            return S.delete(t.id), t.multiSelect ? (b = new Set(e.halfSelectedIds)).delete(t.id) : b = new Set, Object.assign(Object.assign({}, e), {
                selectedIds: S,
                halfSelectedIds: b,
                tabbableId: t.keepFocus ? e.tabbableId : t.id,
                isFocused: !0,
                lastUserSelect: t.NotUserAction ? e.lastUserSelect : t.id,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith,
                lastManuallyToggled: t.lastManuallyToggled
            });
        case $1214ba4a0ed97e08$var$W:
            if (e.disabledIds.has(t.id)) return e;
            var L, R = e.selectedIds.has(t.id);
            t.multiSelect ? (L = new Set(e.selectedIds), R ? L.delete(t.id) : L.add(t.id)) : (L = new Set, R || L.add(t.id));
            var B = new Set(e.halfSelectedIds);
            return B.delete(t.id), Object.assign(Object.assign({}, e), {
                selectedIds: L,
                halfSelectedIds: B,
                tabbableId: t.id,
                isFocused: !0,
                lastUserSelect: t.NotUserAction ? e.lastUserSelect : t.id,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith,
                lastManuallyToggled: t.lastManuallyToggled
            });
        case $1214ba4a0ed97e08$var$x:
            var F, z = t.ids.filter(function(t) {
                return !e.disabledIds.has(t);
            });
            if (t.multiSelect) {
                F = t.select ? new Set([].concat($1214ba4a0ed97e08$var$c(e.selectedIds), $1214ba4a0ed97e08$var$c(z))) : $1214ba4a0ed97e08$var$_(e.selectedIds, new Set(z));
                var H = $1214ba4a0ed97e08$var$_(e.halfSelectedIds, F);
                return Object.assign(Object.assign({}, e), {
                    selectedIds: F,
                    halfSelectedIds: H,
                    lastAction: t.type,
                    lastInteractedWith: t.lastInteractedWith,
                    lastManuallyToggled: t.lastManuallyToggled
                });
            }
            return e;
        case $1214ba4a0ed97e08$var$T:
            var K, P = t.ids.filter(function(t) {
                return !e.disabledIds.has(t);
            });
            if (t.multiSelect) {
                K = t.select ? new Set(P) : $1214ba4a0ed97e08$var$_(e.selectedIds, new Set(P));
                var G = $1214ba4a0ed97e08$var$_(e.halfSelectedIds, K);
                return Object.assign(Object.assign({}, e), {
                    selectedIds: K,
                    halfSelectedIds: G,
                    lastAction: t.type,
                    lastInteractedWith: t.lastInteractedWith,
                    lastManuallyToggled: t.lastManuallyToggled
                });
            }
            return e;
        case $1214ba4a0ed97e08$var$M:
            var V, Y = e.lastInteractedWith, q = e.tabbableId;
            if (t.multiSelect) V = new Set(t.ids), t.ids.length && (Y = t.ids[t.ids.length - 1], q = t.ids[t.ids.length - 1]);
            else {
                V = new Set, t.ids.length > 1 && console.warn("Tree in singleSelect mode, only the first item from selectedIds will be selected.");
                var X = t.ids[0];
                X && V.add(X), Y = null != X ? X : Y, q = null != X ? X : Y;
            }
            var $ = new Set(e.halfSelectedIds);
            t.ids.every(function(e) {
                return $.delete(e);
            });
            var J = new Set(t.ids);
            return Object.assign(Object.assign({}, e), {
                selectedIds: V,
                halfSelectedIds: $,
                controlledIds: J,
                isFocused: !0,
                lastAction: t.type,
                tabbableId: q,
                lastInteractedWith: Y
            });
        case $1214ba4a0ed97e08$var$j:
            return Object.assign(Object.assign({}, e), {
                tabbableId: t.id,
                isFocused: !0,
                lastAction: t.type,
                lastInteractedWith: t.lastInteractedWith
            });
        case $1214ba4a0ed97e08$var$N:
            return Object.assign(Object.assign({}, e), {
                isFocused: !1
            });
        case $1214ba4a0ed97e08$var$D:
            var Q = new Set(e.disabledIds);
            return Q.add(t.id), Object.assign(Object.assign({}, e), {
                disabledIds: Q
            });
        case $1214ba4a0ed97e08$var$C:
            var Z = new Set(e.disabledIds);
            return Z.delete(t.id), Object.assign(Object.assign({}, e), {
                disabledIds: Z
            });
        case $1214ba4a0ed97e08$var$U:
            return Object.assign(Object.assign({}, e), {
                lastManuallyToggled: null
            });
        case $1214ba4a0ed97e08$var$k:
            return Object.assign(Object.assign({}, e), {
                tabbableId: t.tabbableId,
                lastInteractedWith: t.lastInteractedWith,
                lastManuallyToggled: t.lastManuallyToggled,
                lastUserSelect: t.lastUserSelect
            });
        default:
            throw new Error("Invalid action passed to the reducer");
    }
}, $1214ba4a0ed97e08$var$se = function(t) {
    var a = t.element, l = t.dispatch, r = t.data, d = t.selectedIds, s = t.tabbableId, o = t.isFocused, u = t.expandedIds, f = t.disabledIds, p = t.halfSelectedIds, b = t.lastUserSelect, S = t.nodeRefs, y = t.leafRefs, g = t.baseClassNames, m = t.nodeRenderer, w = t.nodeAction, A = t.setsize, N = t.posinset, D = t.level, C = t.propagateCollapse, U = t.propagateSelect, M = t.multiSelect, k = t.togglableSelect, _ = t.clickAction, B = t.state, F = function(e) {
        if (!(e.ctrlKey || e.altKey || e.shiftKey)) {
            if (u.has(a.id) && C) {
                var t = [
                    a.id
                ].concat($1214ba4a0ed97e08$var$c($1214ba4a0ed97e08$var$P(r, a.id, new Set)));
                l({
                    type: $1214ba4a0ed97e08$var$I,
                    ids: t,
                    lastInteractedWith: a.id
                });
            } else l({
                type: $1214ba4a0ed97e08$var$O,
                id: a.id,
                lastInteractedWith: a.id
            });
        }
    }, H = function() {
        return l({
            type: $1214ba4a0ed97e08$var$j,
            id: a.id,
            lastInteractedWith: a.id
        });
    }, K = function(e) {
        if (e.shiftKey) {
            var t = $1214ba4a0ed97e08$var$$({
                data: r,
                expandedIds: u,
                from: b,
                to: a.id
            }).filter(function(e) {
                return !f.has(e);
            });
            t = U ? $1214ba4a0ed97e08$var$ee(r, t, f) : t, l({
                type: $1214ba4a0ed97e08$var$T,
                select: !0,
                multiSelect: M,
                ids: t,
                lastInteractedWith: a.id,
                lastManuallyToggled: a.id
            });
        } else e.ctrlKey || _ === $1214ba4a0ed97e08$var$v.select ? (l({
            type: k ? $1214ba4a0ed97e08$var$ae(r, a.id, d, f) : $1214ba4a0ed97e08$var$E,
            id: a.id,
            multiSelect: M,
            lastInteractedWith: a.id,
            lastManuallyToggled: a.id
        }), U && !f.has(a.id) && l({
            type: $1214ba4a0ed97e08$var$x,
            ids: $1214ba4a0ed97e08$var$ee(r, [
                a.id
            ], f),
            select: !k || !d.has(a.id),
            multiSelect: M,
            lastInteractedWith: a.id,
            lastManuallyToggled: a.id
        })) : _ === $1214ba4a0ed97e08$var$v.exclusiveSelect ? l({
            type: k ? $1214ba4a0ed97e08$var$W : $1214ba4a0ed97e08$var$E,
            id: a.id,
            multiSelect: !1,
            lastInteractedWith: a.id,
            lastManuallyToggled: a.id
        }) : _ === $1214ba4a0ed97e08$var$v.focus && l({
            type: $1214ba4a0ed97e08$var$j,
            id: a.id,
            lastInteractedWith: a.id
        });
    }, G = function(t) {
        var n;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(t, ($1214ba4a0ed97e08$var$i(n = {}, "".concat(t, "--expanded"), u.has(a.id)), $1214ba4a0ed97e08$var$i(n, "".concat(t, "--selected"), d.has(a.id)), $1214ba4a0ed97e08$var$i(n, "".concat(t, "--focused"), s === a.id && o), n));
    }, V = "select" === w ? {
        "aria-selected": $1214ba4a0ed97e08$var$Q({
            isSelected: d.has(a.id),
            isDisabled: f.has(a.id),
            multiSelect: M
        })
    } : {
        "aria-checked": $1214ba4a0ed97e08$var$Z({
            isSelected: d.has(a.id),
            isDisabled: f.has(a.id),
            isHalfSelected: p.has(a.id),
            multiSelect: M
        })
    };
    return $1214ba4a0ed97e08$var$z(r, a.id) || a.isBranch ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({
        role: "treeitem",
        "aria-expanded": u.has(a.id),
        "aria-setsize": A,
        "aria-posinset": N,
        "aria-level": D,
        "aria-disabled": f.has(a.id),
        tabIndex: s === a.id ? 0 : -1,
        ref: function(e) {
            null != (null == S ? void 0 : S.current) && null != e && (S.current[a.id] = e);
        },
        className: g.branchWrapper
    }, V), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, m({
        element: a,
        isBranch: !0,
        isSelected: d.has(a.id),
        isHalfSelected: p.has(a.id),
        isExpanded: u.has(a.id),
        isDisabled: f.has(a.id),
        dispatch: l,
        getNodeProps: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = t.onClick;
            return {
                onClick: null == n ? $1214ba4a0ed97e08$var$R(K, F, H) : $1214ba4a0ed97e08$var$R(n, H),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(G(g.node), g.branch),
                ref: function(e) {
                    null != (null == y ? void 0 : y.current) && (y.current[a.id] = e);
                }
            };
        },
        setsize: A,
        posinset: N,
        level: D,
        handleSelect: K,
        handleExpand: F,
        treeState: B
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1214ba4a0ed97e08$var$ce, Object.assign({
        getClasses: G
    }, function(e) {
        e.setsize, e.posinset;
        return $1214ba4a0ed97e08$var$h(e, [
            "setsize",
            "posinset"
        ]);
    }(t))))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "none",
        className: G(g.leafListItem)
    }, m({
        element: a,
        isBranch: !1,
        isSelected: d.has(a.id),
        isHalfSelected: !1,
        isExpanded: !1,
        isDisabled: f.has(a.id),
        dispatch: l,
        getNodeProps: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = t.onClick;
            return Object.assign({
                role: "treeitem",
                tabIndex: s === a.id ? 0 : -1,
                onClick: $1214ba4a0ed97e08$var$R(null == n ? K : n, H),
                ref: function(e) {
                    null != (null == S ? void 0 : S.current) && null != (null == y ? void 0 : y.current) && (S.current[a.id] = e, y.current[a.id] = e);
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(G(g.node), g.leaf),
                "aria-setsize": A,
                "aria-posinset": N,
                "aria-level": D,
                disabled: f.has(a.id),
                "aria-disabled": f.has(a.id)
            }, V);
        },
        setsize: A,
        posinset: N,
        level: D,
        handleSelect: K,
        handleExpand: $1214ba4a0ed97e08$var$L,
        treeState: B
    }));
}, $1214ba4a0ed97e08$var$ce = function(e) {
    var t = e.data, a = e.element, l = e.expandedIds, r = e.getClasses, i = e.baseClassNames, s = e.level, c = $1214ba4a0ed97e08$var$h(e, [
        "data",
        "element",
        "expandedIds",
        "getClasses",
        "baseClassNames",
        "level"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        role: "group",
        className: r(i.nodeGroup)
    }, l.has(a.id) && a.children.length > 0 && a.children.map(function(e, r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1214ba4a0ed97e08$var$se, Object.assign({
            data: t,
            expandedIds: l,
            baseClassNames: i,
            key: "".concat(e, "-").concat($1214ba4a0ed97e08$var$d(e)),
            element: $1214ba4a0ed97e08$var$re(t, e),
            setsize: a.children.length,
            posinset: r + 1,
            level: s + 1
        }, c));
    }));
}, $1214ba4a0ed97e08$var$oe = function(e) {
    var t = e.data, n = e.controlledSelectedIds, d = e.controlledExpandedIds, i = e.defaultExpandedIds, o = e.defaultSelectedIds, u = e.defaultDisabledIds, h = e.nodeRefs, p = e.leafRefs, v = e.onSelect, b = e.onNodeSelect, S = e.onExpand, W = e.onLoadData, T = e.togglableSelect, N = e.multiSelect, D = e.propagateSelect, C = e.propagateSelectUpwards, R = e.treeRef, G = $1214ba4a0ed97e08$var$le(t), V = $1214ba4a0ed97e08$var$s((0, $acw62.useReducer)($1214ba4a0ed97e08$var$ie, {
        selectedIds: new Set(n || o),
        controlledIds: new Set(n),
        tabbableId: G.children[0],
        isFocused: !1,
        expandedIds: new Set(d || i),
        halfSelectedIds: new Set,
        lastUserSelect: G.children[0],
        lastInteractedWith: null,
        lastManuallyToggled: null,
        disabledIds: new Set(u)
    }), 2), Y = V[0], q = V[1], X = Y.selectedIds, $ = Y.expandedIds, J = Y.disabledIds, Q = Y.tabbableId, Z = Y.halfSelectedIds, te = Y.lastAction, ae = Y.lastInteractedWith, de = Y.lastManuallyToggled, se = $1214ba4a0ed97e08$var$F(X) || new Set, ce = $1214ba4a0ed97e08$var$B(X, se);
    (0, $acw62.useEffect)(function() {
        var e;
        if (null != v && v !== $1214ba4a0ed97e08$var$L) {
            var n, a = $1214ba4a0ed97e08$var$f(ce);
            try {
                for(a.s(); !(n = a.n()).done;){
                    var l = n.value, r = $1214ba4a0ed97e08$var$z(t, l) || !!(null === (e = $1214ba4a0ed97e08$var$re(t, Q)) || void 0 === e ? void 0 : e.isBranch);
                    v({
                        element: $1214ba4a0ed97e08$var$re(t, l),
                        isBranch: r,
                        isExpanded: !!r && $.has(l),
                        isSelected: X.has(l),
                        isDisabled: J.has(l),
                        isHalfSelected: !!r && Z.has(l),
                        treeState: Y
                    });
                }
            } catch (e) {
                a.e(e);
            } finally{
                a.f();
            }
        }
    }, [
        t,
        X,
        $,
        J,
        Z,
        ce,
        v,
        Y
    ]), (0, $acw62.useEffect)(function() {
        null != b && b !== $1214ba4a0ed97e08$var$L && null != de && ce.size && (b({
            element: $1214ba4a0ed97e08$var$re(t, de),
            isSelected: X.has(de),
            isBranch: $1214ba4a0ed97e08$var$z(t, de),
            treeState: Y
        }), q({
            type: $1214ba4a0ed97e08$var$U
        }));
    }, [
        de,
        X,
        ce
    ]);
    var oe = $1214ba4a0ed97e08$var$F($) || new Set;
    (0, $acw62.useEffect)(function() {
        var e = $1214ba4a0ed97e08$var$B($, oe);
        if (null != S && S !== $1214ba4a0ed97e08$var$L) {
            var n, a = $1214ba4a0ed97e08$var$f(e);
            try {
                for(a.s(); !(n = a.n()).done;){
                    var l = n.value;
                    S({
                        element: $1214ba4a0ed97e08$var$re(t, l),
                        isExpanded: $.has(l),
                        isSelected: X.has(l),
                        isDisabled: J.has(l),
                        isHalfSelected: Z.has(l),
                        treeState: Y
                    });
                }
            } catch (e) {
                a.e(e);
            } finally{
                a.f();
            }
        }
    }, [
        t,
        X,
        $,
        J,
        Z,
        oe,
        S,
        Y
    ]);
    var ue, fe, he = (ue = t, fe = (0, $acw62.useRef)(), (0, $acw62.useEffect)(function() {
        fe.current = ue;
    }), fe.current || new Map);
    (0, $acw62.useEffect)(function() {
        var e = $1214ba4a0ed97e08$var$B($, oe);
        if (W) {
            var n, a = $1214ba4a0ed97e08$var$f(e);
            try {
                for(a.s(); !(n = a.n()).done;){
                    var l = n.value;
                    W({
                        element: $1214ba4a0ed97e08$var$re(t, l),
                        isExpanded: $.has(l),
                        isSelected: X.has(l),
                        isDisabled: J.has(l),
                        isHalfSelected: Z.has(l),
                        treeState: Y
                    });
                }
            } catch (e) {
                a.e(e);
            } finally{
                a.f();
            }
            if (he !== t && T && D) {
                var r, d = $1214ba4a0ed97e08$var$f($);
                try {
                    for(d.s(); !(r = d.n()).done;){
                        var i = r.value;
                        X.has(i) && q({
                            type: $1214ba4a0ed97e08$var$x,
                            ids: $1214ba4a0ed97e08$var$ee(t, [
                                i
                            ], J),
                            select: !0,
                            multiSelect: N,
                            lastInteractedWith: i
                        });
                    }
                } catch (e) {
                    d.e(e);
                } finally{
                    d.f();
                }
            }
        }
    }, [
        t,
        X,
        $,
        J,
        Z,
        oe,
        W,
        Y
    ]), (0, $acw62.useEffect)(function() {
        if (he !== t) {
            var e = $1214ba4a0ed97e08$var$le(t);
            e.children.length && q({
                type: $1214ba4a0ed97e08$var$k,
                tabbableId: t.find(function(e) {
                    return e.id === Y.tabbableId;
                }) ? Y.tabbableId : e.children[0],
                lastInteractedWith: t.find(function(e) {
                    return e.id === Y.lastInteractedWith;
                }) ? Y.lastInteractedWith : null,
                lastManuallyToggled: t.find(function(e) {
                    return e.id === Y.lastManuallyToggled;
                }) ? Y.lastManuallyToggled : null,
                lastUserSelect: t.find(function(e) {
                    return e.id === Y.lastUserSelect;
                }) ? Y.lastUserSelect : e.children[0]
            });
        }
    }, [
        t
    ]);
    var pe = $1214ba4a0ed97e08$var$B(new Set(n), X);
    return (0, $acw62.useEffect)(function() {
        if (n) {
            pe.size && q({
                type: $1214ba4a0ed97e08$var$M,
                ids: n,
                multiSelect: N
            });
            var e, a = $1214ba4a0ed97e08$var$f(n);
            try {
                for(a.s(); !(e = a.n()).done;){
                    var l = e.value;
                    D && !J.has(l) && q({
                        type: $1214ba4a0ed97e08$var$x,
                        ids: $1214ba4a0ed97e08$var$ee(t, [
                            l
                        ], J),
                        select: !0,
                        multiSelect: N,
                        lastInteractedWith: l
                    });
                }
            } catch (e) {
                a.e(e);
            } finally{
                a.f();
            }
        }
    }, [
        n
    ]), (0, $acw62.useEffect)(function() {
        var e = new Set(d), n = $1214ba4a0ed97e08$var$_(e, oe), a = $1214ba4a0ed97e08$var$_(oe, e);
        if (a.size) {
            var l, r = $1214ba4a0ed97e08$var$f(a);
            try {
                for(r.s(); !(l = r.n()).done;){
                    var i = l.value;
                    if ($1214ba4a0ed97e08$var$z(t, i) || $1214ba4a0ed97e08$var$re(t, i).isBranch) {
                        var s = [
                            i
                        ].concat($1214ba4a0ed97e08$var$c($1214ba4a0ed97e08$var$P(t, i, new Set)));
                        q({
                            type: $1214ba4a0ed97e08$var$I,
                            ids: s,
                            lastInteractedWith: i
                        });
                    }
                }
            } catch (e) {
                r.e(e);
            } finally{
                r.f();
            }
        }
        if (n.size) {
            var o, u = $1214ba4a0ed97e08$var$f(n);
            try {
                for(u.s(); !(o = u.n()).done;){
                    var h = o.value;
                    if ($1214ba4a0ed97e08$var$z(t, h) || $1214ba4a0ed97e08$var$re(t, h).isBranch) {
                        var p = $1214ba4a0ed97e08$var$H(t, h);
                        q(p ? {
                            type: $1214ba4a0ed97e08$var$m,
                            ids: [
                                h,
                                p
                            ],
                            lastInteractedWith: h
                        } : {
                            type: $1214ba4a0ed97e08$var$g,
                            id: h,
                            lastInteractedWith: h
                        });
                    }
                }
            } catch (e) {
                u.e(e);
            } finally{
                u.f();
            }
        }
    }, [
        d
    ]), (0, $acw62.useEffect)(function() {
        if (C) {
            var e = new Set($1214ba4a0ed97e08$var$c(ce));
            ae && te !== $1214ba4a0ed97e08$var$j && te !== $1214ba4a0ed97e08$var$y && te !== $1214ba4a0ed97e08$var$g && te !== $1214ba4a0ed97e08$var$O && e.add(ae);
            var n = [];
            e.forEach(function(e) {
                t.find(function(t) {
                    return t.id === e;
                }) || n.push(e);
            }), n.forEach(function(t) {
                return e.delete(t);
            });
            var a, l = function(e, t, n, a, l, r) {
                var d, i = {
                    every: new Set,
                    some: new Set,
                    none: new Set
                }, s = $1214ba4a0ed97e08$var$f(t);
                try {
                    for(s.s(); !(d = s.n()).done;)for(var c = d.value;;){
                        var o = $1214ba4a0ed97e08$var$H(e, c);
                        if (0 === o || null == o || null != o && a.has(o)) break;
                        var u = $1214ba4a0ed97e08$var$re(e, o).children.filter(function(e) {
                            return !a.has(e);
                        });
                        if (0 === u.length) break;
                        if (u.some(function(e) {
                            return n.has(e) || i.some.has(e) && !i.none.has(e) || l.has(e) && !i.none.has(e);
                        })) u.every(function(e) {
                            return n.has(e);
                        }) ? i.every.add(o) : i.some.add(o);
                        else {
                            var h = $1214ba4a0ed97e08$var$K(e, c, a).find(function(e) {
                                return n.has(e);
                            });
                            if (!r && h) {
                                $1214ba4a0ed97e08$var$P(e, h, a).forEach(function(e) {
                                    l.has(e) && i.none.add(e);
                                });
                                break;
                            }
                            i.none.add(o);
                        }
                        c = o;
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
                return i;
            }(t, e, X, J, Z, N), r = l.every, d = l.some, i = l.none, s = $1214ba4a0ed97e08$var$f(r);
            try {
                for(s.s(); !(a = s.n()).done;){
                    var o = a.value;
                    X.has(o) || q({
                        type: $1214ba4a0ed97e08$var$E,
                        id: o,
                        multiSelect: N || $1214ba4a0ed97e08$var$ne(t, o, X),
                        keepFocus: !0,
                        NotUserAction: !0,
                        lastInteractedWith: ae
                    });
                }
            } catch (e) {
                s.e(e);
            } finally{
                s.f();
            }
            var u, h = $1214ba4a0ed97e08$var$f(d);
            try {
                for(h.s(); !(u = h.n()).done;){
                    var p = u.value;
                    Z.has(p) || q({
                        type: $1214ba4a0ed97e08$var$w,
                        id: p,
                        lastInteractedWith: ae,
                        keepFocus: !0,
                        NotUserAction: !0
                    });
                }
            } catch (e) {
                h.e(e);
            } finally{
                h.f();
            }
            var v, b = $1214ba4a0ed97e08$var$f(i);
            try {
                for(b.s(); !(v = b.n()).done;){
                    var S = v.value;
                    (X.has(S) || Z.has(S)) && q({
                        type: $1214ba4a0ed97e08$var$A,
                        id: S,
                        multiSelect: N,
                        keepFocus: !0,
                        NotUserAction: !0,
                        lastInteractedWith: ae,
                        lastManuallyToggled: de
                    });
                }
            } catch (e) {
                b.e(e);
            } finally{
                b.f();
            }
        }
    }, [
        t,
        N,
        C,
        X,
        $,
        J,
        Z,
        te,
        se,
        ce,
        ae,
        pe
    ]), (0, $acw62.useEffect)(function() {
        if (null != ae && null != Q && null != (null == h ? void 0 : h.current) && null != (null == p ? void 0 : p.current) && (null == (null == R ? void 0 : R.current) || document.activeElement && R.current.contains(document.activeElement))) {
            var e = h.current[Q];
            !function(e) {
                null != e && e.scrollIntoView && e.scrollIntoView({
                    block: "nearest"
                });
            }(p.current[ae]), function(e) {
                null != e && e.focus && e.focus({
                    preventScroll: !0
                });
            }(e);
        }
    }, [
        Q,
        h,
        p,
        ae
    ]), [
        Y,
        q
    ];
}, $1214ba4a0ed97e08$var$ue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, l) {
    var r = t.data, i = t.selectedIds, c = t.nodeRenderer, o = t.onSelect, u = void 0 === o ? $1214ba4a0ed97e08$var$L : o, f = t.onNodeSelect, b = void 0 === f ? $1214ba4a0ed97e08$var$L : f, S = t.onExpand, y = void 0 === S ? $1214ba4a0ed97e08$var$L : S, I = t.onLoadData, g = t.className, m = void 0 === g ? "" : g, w = t.multiSelect, E = void 0 !== w && w, A = t.propagateSelect, O = void 0 !== A && A, W = t.propagateSelectUpwards, x = void 0 !== W && W, T = t.propagateCollapse, j = void 0 !== T && T, D = t.expandOnKeyboardSelect, C = void 0 !== D && D, U = t.togglableSelect, M = void 0 !== U && U, k = t.defaultExpandedIds, R = void 0 === k ? [] : k, _ = t.defaultSelectedIds, B = void 0 === _ ? [] : _, F = t.defaultDisabledIds, z = void 0 === F ? [] : F, H = t.clickAction, K = void 0 === H ? $1214ba4a0ed97e08$var$v.select : H, P = t.nodeAction, G = void 0 === P ? "select" : P, V = t.expandedIds, Y = t.onBlur, q = $1214ba4a0ed97e08$var$h(t, [
        "data",
        "selectedIds",
        "nodeRenderer",
        "onSelect",
        "onNodeSelect",
        "onExpand",
        "onLoadData",
        "className",
        "multiSelect",
        "propagateSelect",
        "propagateSelectUpwards",
        "propagateCollapse",
        "expandOnKeyboardSelect",
        "togglableSelect",
        "defaultExpandedIds",
        "defaultSelectedIds",
        "defaultDisabledIds",
        "clickAction",
        "nodeAction",
        "expandedIds",
        "onBlur"
    ]);
    !function(e) {
        if ($1214ba4a0ed97e08$var$de(e.map(function(e) {
            return e.id;
        }))) throw Error("Multiple TreeView nodes have the same ID. IDs must be unique.");
        if (e.forEach(function(e) {
            if (e.id === e.parent) throw Error("Node with id=".concat(e.id, " has parent reference to itself."));
            if ($1214ba4a0ed97e08$var$de(e.children)) throw Error("Node with id=".concat(e.id, " contains duplicate ids in its children."));
        }), 0 === e.filter(function(e) {
            return null === e.parent;
        }).length) throw Error("TreeView must have one root node.");
        if (e.filter(function(e) {
            return null === e.parent;
        }).length > 1) throw Error("TreeView can have only one root node.");
        $1214ba4a0ed97e08$var$le(e).children.length || console.warn("TreeView have no nodes to display.");
    }(r);
    var X = (0, $acw62.useRef)({}), $ = (0, $acw62.useRef)({}), J = (0, $acw62.useRef)(null);
    null != l && (J = l);
    var Q = $1214ba4a0ed97e08$var$s($1214ba4a0ed97e08$var$oe({
        data: r,
        controlledSelectedIds: i,
        controlledExpandedIds: V,
        defaultExpandedIds: R,
        defaultSelectedIds: B,
        defaultDisabledIds: z,
        nodeRefs: X,
        leafRefs: $,
        onSelect: u,
        onNodeSelect: b,
        onExpand: y,
        onLoadData: I,
        togglableSelect: M,
        multiSelect: E,
        propagateSelect: O,
        propagateSelectUpwards: x,
        treeRef: J
    }), 2), Z = Q[0], ee = Q[1];
    return O = O && E, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))($1214ba4a0ed97e08$var$p.root, m),
        role: "tree",
        "aria-multiselectable": "select" === G ? E : void 0,
        ref: J,
        onBlur: function(e) {
            $1214ba4a0ed97e08$var$te(e, J.current, function() {
                Y && Y({
                    treeState: Z,
                    dispatch: ee
                }), ee({
                    type: $1214ba4a0ed97e08$var$N
                });
            });
        },
        onKeyDown: $1214ba4a0ed97e08$var$fe({
            data: r,
            tabbableId: Z.tabbableId,
            expandedIds: Z.expandedIds,
            selectedIds: Z.selectedIds,
            disabledIds: Z.disabledIds,
            halfSelectedIds: Z.halfSelectedIds,
            clickAction: K,
            dispatch: ee,
            propagateCollapse: j,
            propagateSelect: O,
            multiSelect: E,
            expandOnKeyboardSelect: C,
            togglableSelect: M
        })
    }, q), $1214ba4a0ed97e08$var$le(r).children.map(function(e, t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1214ba4a0ed97e08$var$se, Object.assign({
            key: "".concat(e, "-").concat($1214ba4a0ed97e08$var$d(e)),
            data: r,
            element: $1214ba4a0ed97e08$var$re(r, e),
            setsize: $1214ba4a0ed97e08$var$le(r).children.length,
            posinset: t + 1,
            level: 1
        }, Z, {
            state: Z,
            dispatch: ee,
            nodeRefs: X,
            leafRefs: $,
            baseClassNames: $1214ba4a0ed97e08$var$p,
            nodeRenderer: c,
            propagateCollapse: j,
            propagateSelect: O,
            propagateSelectUpwards: x,
            multiSelect: E,
            togglableSelect: M,
            clickAction: K,
            nodeAction: G
        }));
    }));
}), $1214ba4a0ed97e08$var$fe = function(e) {
    var t = e.data, n = e.expandedIds, a = e.selectedIds, l = e.disabledIds, r = e.tabbableId, d = e.dispatch, i = e.propagateCollapse, s = e.propagateSelect, o = e.multiSelect, u = e.expandOnKeyboardSelect, f = e.togglableSelect, h = e.clickAction;
    return function(e) {
        var p = $1214ba4a0ed97e08$var$re(t, r), b = p.id;
        if (e.ctrlKey) {
            if ("a" === e.key && h !== $1214ba4a0ed97e08$var$v.focus) {
                e.preventDefault();
                var S = t.filter(function(e) {
                    return null !== e.parent;
                }).map(function(e) {
                    return e.id;
                }).filter(function(e) {
                    return !l.has(e);
                });
                d({
                    type: $1214ba4a0ed97e08$var$x,
                    multiSelect: o,
                    select: Array.from(a).filter(function(e) {
                        return !l.has(e);
                    }).length !== S.length,
                    ids: S,
                    lastInteractedWith: p.id
                });
            } else if (e.shiftKey && ("Home" === e.key || "End" === e.key) && h !== $1214ba4a0ed97e08$var$v.focus) {
                var w = "Home" === e.key ? $1214ba4a0ed97e08$var$le(t).children[0] : $1214ba4a0ed97e08$var$Y(t, b, n), A = $1214ba4a0ed97e08$var$$({
                    data: t,
                    expandedIds: n,
                    from: b,
                    to: w
                }).filter(function(e) {
                    return !l.has(e);
                });
                d({
                    type: $1214ba4a0ed97e08$var$x,
                    multiSelect: o,
                    select: !0,
                    ids: s ? $1214ba4a0ed97e08$var$ee(t, A, l) : A
                }), d({
                    type: $1214ba4a0ed97e08$var$j,
                    id: w,
                    lastInteractedWith: w
                });
            }
        } else {
            if (e.shiftKey) switch(e.key){
                case "ArrowUp":
                    e.preventDefault();
                    var W = $1214ba4a0ed97e08$var$q(t, b, n);
                    return void (null == W || l.has(W) || (h !== $1214ba4a0ed97e08$var$v.focus && d({
                        type: $1214ba4a0ed97e08$var$x,
                        ids: s ? $1214ba4a0ed97e08$var$ee(t, [
                            W
                        ], l) : [
                            W
                        ],
                        select: !0,
                        multiSelect: o,
                        lastInteractedWith: W,
                        lastManuallyToggled: W
                    }), d({
                        type: $1214ba4a0ed97e08$var$j,
                        id: W,
                        lastInteractedWith: W
                    })));
                case "ArrowDown":
                    e.preventDefault();
                    var T = $1214ba4a0ed97e08$var$X(t, b, n);
                    return void (null == T || l.has(T) || (h !== $1214ba4a0ed97e08$var$v.focus && d({
                        type: $1214ba4a0ed97e08$var$x,
                        ids: s ? $1214ba4a0ed97e08$var$ee(t, [
                            T
                        ], l) : [
                            T
                        ],
                        multiSelect: o,
                        select: !0,
                        lastInteractedWith: T,
                        lastManuallyToggled: T
                    }), d({
                        type: $1214ba4a0ed97e08$var$j,
                        id: T,
                        lastInteractedWith: T
                    })));
            }
            switch(e.key){
                case "ArrowDown":
                    e.preventDefault();
                    var N = $1214ba4a0ed97e08$var$X(t, b, n);
                    return void (null != N && d({
                        type: $1214ba4a0ed97e08$var$j,
                        id: N,
                        lastInteractedWith: N
                    }));
                case "ArrowUp":
                    e.preventDefault();
                    var D = $1214ba4a0ed97e08$var$q(t, b, n);
                    return void (null != D && d({
                        type: $1214ba4a0ed97e08$var$j,
                        id: D,
                        lastInteractedWith: D
                    }));
                case "ArrowLeft":
                    if (e.preventDefault(), ($1214ba4a0ed97e08$var$z(t, b) || p.isBranch) && n.has(r)) {
                        if (i) {
                            var C = [
                                b
                            ].concat($1214ba4a0ed97e08$var$c($1214ba4a0ed97e08$var$P(t, b, new Set)));
                            d({
                                type: $1214ba4a0ed97e08$var$I,
                                ids: C,
                                lastInteractedWith: p.id
                            });
                        } else d({
                            type: $1214ba4a0ed97e08$var$y,
                            id: b,
                            lastInteractedWith: b
                        });
                    } else if (!$1214ba4a0ed97e08$var$le(t).children.includes(b)) {
                        var U = $1214ba4a0ed97e08$var$H(t, b);
                        if (null == U) throw new Error("parentId of root element is null");
                        d({
                            type: $1214ba4a0ed97e08$var$j,
                            id: U,
                            lastInteractedWith: U
                        });
                    }
                    return;
                case "ArrowRight":
                    return e.preventDefault(), void (($1214ba4a0ed97e08$var$z(t, b) || p.isBranch) && (n.has(r) ? d({
                        type: $1214ba4a0ed97e08$var$j,
                        id: p.children[0],
                        lastInteractedWith: p.children[0]
                    }) : d({
                        type: $1214ba4a0ed97e08$var$g,
                        id: b,
                        lastInteractedWith: b
                    })));
                case "Home":
                    e.preventDefault(), d({
                        type: $1214ba4a0ed97e08$var$j,
                        id: $1214ba4a0ed97e08$var$le(t).children[0],
                        lastInteractedWith: $1214ba4a0ed97e08$var$le(t).children[0]
                    });
                    break;
                case "End":
                    e.preventDefault();
                    var M = $1214ba4a0ed97e08$var$Y(t, $1214ba4a0ed97e08$var$le(t).id, n);
                    return void d({
                        type: $1214ba4a0ed97e08$var$j,
                        id: M,
                        lastInteractedWith: M
                    });
                case "*":
                    e.preventDefault();
                    var k = $1214ba4a0ed97e08$var$H(t, b);
                    if (null == k) throw new Error("parentId of element is null");
                    var L = $1214ba4a0ed97e08$var$re(t, k).children.filter(function(e) {
                        return $1214ba4a0ed97e08$var$z(t, e) || $1214ba4a0ed97e08$var$re(t, e).isBranch;
                    });
                    return void d({
                        type: $1214ba4a0ed97e08$var$m,
                        ids: L,
                        lastInteractedWith: b
                    });
                case "Enter":
                case " ":
                case "Spacebar":
                    if (e.preventDefault(), h === $1214ba4a0ed97e08$var$v.focus) return;
                    return d({
                        type: f ? $1214ba4a0ed97e08$var$ae(t, b, a, l) : $1214ba4a0ed97e08$var$E,
                        id: b,
                        multiSelect: o,
                        lastInteractedWith: b,
                        lastManuallyToggled: b
                    }), s && !l.has(p.id) && d({
                        type: $1214ba4a0ed97e08$var$x,
                        ids: $1214ba4a0ed97e08$var$ee(t, [
                            b
                        ], l),
                        select: !f || !a.has(b),
                        multiSelect: o,
                        lastInteractedWith: b,
                        lastManuallyToggled: b
                    }), void (u && d({
                        type: $1214ba4a0ed97e08$var$O,
                        id: b,
                        lastInteractedWith: b
                    }));
                default:
                    if (1 === e.key.length) for(var R = $1214ba4a0ed97e08$var$X(t, b, n); R !== b;)if (null != R) {
                        if ($1214ba4a0ed97e08$var$re(t, R).name[0].toLowerCase() === e.key.toLowerCase()) return void d({
                            type: $1214ba4a0ed97e08$var$j,
                            id: R,
                            lastInteractedWith: b
                        });
                        R = $1214ba4a0ed97e08$var$X(t, R, n);
                    } else R = $1214ba4a0ed97e08$var$le(t).children[0];
                    return;
            }
        }
    };
};
$1214ba4a0ed97e08$var$ue.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onNodeSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    nodeRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    defaultExpandedIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultSelectedIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    expandedIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    selectedIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultDisabledIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    propagateCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    propagateSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    propagateSelectUpwards: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    multiSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    expandOnKeyboardSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    togglableSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    nodeAction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($1214ba4a0ed97e08$var$S),
    clickAction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($1214ba4a0ed97e08$export$125ef903505d7891),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onLoadData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $1214ba4a0ed97e08$export$2e2bcd8739ae039 = $1214ba4a0ed97e08$var$ue;

});

parcelRegister("ivqYv", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => (parcelRequire("40h1t")).default);
$parcel$export(module.exports, "ContextMenuTrigger", () => (parcelRequire("9RtmZ")).default);
$parcel$export(module.exports, "MenuItem", () => (parcelRequire("4CnrE")).default);
$parcel$export(module.exports, "connectMenu", () => (parcelRequire("gydR2")).default);

var $40h1t = parcelRequire("40h1t");

var $9RtmZ = parcelRequire("9RtmZ");

var $4CnrE = parcelRequire("4CnrE");

var $jgXSY = parcelRequire("jgXSY");

var $gydR2 = parcelRequire("gydR2");

var $edRt2 = parcelRequire("edRt2");

});
parcelRegister("40h1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea45ddbb9f332af$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $8coUR = parcelRequire("8coUR");

var $31Wdr = parcelRequire("31Wdr");

var $d2eW7 = parcelRequire("d2eW7");

var $jgXSY = parcelRequire("jgXSY");

var $edRt2 = parcelRequire("edRt2");

var $3kaub = parcelRequire("3kaub");
/* This is a backward-compatible shim for React < 18 */ function $2ea45ddbb9f332af$var$flushSync(callback) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).flushSync) (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).flushSync(callback);
    else callback();
}
class $2ea45ddbb9f332af$export$2e2bcd8739ae039 extends (0, $d2eW7.default) {
    static propTypes = {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        hideOnLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        rtl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        onHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onShow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        preventHideOnContextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        preventHideOnResize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        preventHideOnScroll: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    };
    static defaultProps = {
        className: "",
        data: {},
        hideOnLeave: false,
        rtl: false,
        onHide () {
            return null;
        },
        onMouseLeave () {
            return null;
        },
        onShow () {
            return null;
        },
        preventHideOnContextMenu: false,
        preventHideOnResize: false,
        preventHideOnScroll: false,
        style: {}
    };
    constructor(props){
        super(props);
        this.state = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, this.state, {
            x: 0,
            y: 0,
            isVisible: false
        });
    }
    getSubMenuType() {
        // eslint-disable-line class-methods-use-this
        return 0, $jgXSY.default;
    }
    componentDidMount() {
        this.listenId = (0, $31Wdr.default).register(this.handleShow, this.handleHide);
    }
    componentDidUpdate() {
        const wrapper = window.requestAnimationFrame || setTimeout;
        if (this.state.isVisible) wrapper(()=>{
            const { x: x, y: y } = this.state;
            const { top: top, left: left } = this.props.rtl ? this.getRTLMenuPosition(x, y) : this.getMenuPosition(x, y);
            wrapper(()=>{
                if (!this.menu) return;
                this.menu.style.top = `${top}px`;
                this.menu.style.left = `${left}px`;
                this.menu.style.opacity = 1;
                this.menu.style.pointerEvents = "auto";
            });
        });
        else wrapper(()=>{
            if (!this.menu) return;
            this.menu.style.opacity = 0;
            this.menu.style.pointerEvents = "none";
        });
    }
    componentWillUnmount() {
        if (this.listenId) (0, $31Wdr.default).unregister(this.listenId);
        this.unregisterHandlers();
    }
    registerHandlers = ()=>{
        document.addEventListener("mousedown", this.handleOutsideClick);
        document.addEventListener("touchstart", this.handleOutsideClick);
        if (!this.props.preventHideOnScroll) document.addEventListener("scroll", this.handleHide);
        if (!this.props.preventHideOnContextMenu) document.addEventListener("contextmenu", this.handleHide);
        document.addEventListener("keydown", this.handleKeyNavigation);
        if (!this.props.preventHideOnResize) window.addEventListener("resize", this.handleHide);
    };
    unregisterHandlers = ()=>{
        document.removeEventListener("mousedown", this.handleOutsideClick);
        document.removeEventListener("touchstart", this.handleOutsideClick);
        document.removeEventListener("scroll", this.handleHide);
        document.removeEventListener("contextmenu", this.handleHide);
        document.removeEventListener("keydown", this.handleKeyNavigation);
        window.removeEventListener("resize", this.handleHide);
    };
    handleShow = (e)=>{
        if (e.detail.id !== this.props.id || this.state.isVisible) return;
        const { x: x, y: y } = e.detail.position;
        this.setState({
            isVisible: true,
            x: x,
            y: y
        });
        this.registerHandlers();
        (0, $3kaub.callIfExists)(this.props.onShow, e);
    };
    handleHide = (e)=>{
        if (this.state.isVisible && (!e.detail || !e.detail.id || e.detail.id === this.props.id)) {
            this.unregisterHandlers();
            $2ea45ddbb9f332af$var$flushSync(()=>{
                /* We rely on being able to read this state change in handleShow,
         * so let's force a synchronous update in React 18. */ this.setState({
                    isVisible: false,
                    selectedItem: null,
                    forceSubMenuOpen: false
                });
            });
            (0, $3kaub.callIfExists)(this.props.onHide, e);
        }
    };
    handleOutsideClick = (e)=>{
        if (!this.menu.contains(e.target)) (0, $edRt2.hideMenu)();
    };
    handleMouseLeave = (event)=>{
        event.preventDefault();
        (0, $3kaub.callIfExists)(this.props.onMouseLeave, event, (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, this.props.data, (0, $3kaub.store).data), (0, $3kaub.store).target);
        if (this.props.hideOnLeave) (0, $edRt2.hideMenu)();
    };
    handleContextMenu = (e)=>{
        e.preventDefault();
        this.handleHide(e);
    };
    // Disabling this rule for more consistency.
    /* eslint-disable-next-line class-methods-use-this */ hideMenu = (e)=>{
        if (e.key === "Escape" || e.key === "Esc" || e.key === "Enter") (0, $edRt2.hideMenu)();
    };
    getMenuPosition = (()=>{
        var _this = this;
        return function() {
            let x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            let menuStyles = {
                top: y,
                left: x
            };
            if (!_this.menu) return menuStyles;
            const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
            const rect = _this.menu.getBoundingClientRect();
            if (y + rect.height > innerHeight) menuStyles.top -= rect.height;
            if (x + rect.width > innerWidth) menuStyles.left -= rect.width;
            if (menuStyles.top < 0) menuStyles.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
            if (menuStyles.left < 0) menuStyles.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
            return menuStyles;
        };
    })();
    getRTLMenuPosition = (()=>{
        var _this2 = this;
        return function() {
            let x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            let menuStyles = {
                top: y,
                left: x
            };
            if (!_this2.menu) return menuStyles;
            const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
            const rect = _this2.menu.getBoundingClientRect();
            // Try to position the menu on the left side of the cursor
            menuStyles.left = x - rect.width;
            if (y + rect.height > innerHeight) menuStyles.top -= rect.height;
            if (menuStyles.left < 0) menuStyles.left += rect.width;
            if (menuStyles.top < 0) menuStyles.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
            if (menuStyles.left + rect.width > innerWidth) menuStyles.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
            return menuStyles;
        };
    })();
    menuRef = (c)=>{
        this.menu = c;
    };
    render() {
        const { children: children, className: className, style: style } = this.props;
        const { isVisible: isVisible } = this.state;
        const inlineStyle = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, style, {
            position: "fixed",
            opacity: 0,
            pointerEvents: "none"
        });
        const menuClassnames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menu, className, {
            [(0, $3kaub.cssClasses).menuVisible]: isVisible
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
            role: "menu",
            tabIndex: "-1",
            ref: this.menuRef,
            style: inlineStyle,
            className: menuClassnames,
            onContextMenu: this.handleContextMenu,
            onMouseLeave: this.handleMouseLeave
        }, this.renderChildren(children));
    }
}

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("31Wdr", function(module, exports) {

$parcel$export(module.exports, "default", () => $234e9f8ae67bf98c$export$2e2bcd8739ae039);

var $edRt2 = parcelRequire("edRt2");

var $3kaub = parcelRequire("3kaub");
class $234e9f8ae67bf98c$var$GlobalEventListener {
    constructor(){
        this.callbacks = {};
        if (0, $3kaub.canUseDOM) {
            window.addEventListener((0, $edRt2.MENU_SHOW), this.handleShowEvent);
            window.addEventListener((0, $edRt2.MENU_HIDE), this.handleHideEvent);
        }
    }
    handleShowEvent = (event)=>{
        for(const id in this.callbacks)if ((0, $3kaub.hasOwnProp)(this.callbacks, id)) this.callbacks[id].show(event);
    };
    handleHideEvent = (event)=>{
        for(const id in this.callbacks)if ((0, $3kaub.hasOwnProp)(this.callbacks, id)) this.callbacks[id].hide(event);
    };
    register = (showCallback, hideCallback)=>{
        const id = (0, $3kaub.uniqueId)();
        this.callbacks[id] = {
            show: showCallback,
            hide: hideCallback
        };
        return id;
    };
    unregister = (id)=>{
        if (id && this.callbacks[id]) delete this.callbacks[id];
    };
}
var $234e9f8ae67bf98c$export$2e2bcd8739ae039 = new $234e9f8ae67bf98c$var$GlobalEventListener();

});
parcelRegister("edRt2", function(module, exports) {

$parcel$export(module.exports, "MENU_SHOW", () => $a5abc11d4ec98a8a$export$3ecf1847e7a8ad80);
$parcel$export(module.exports, "MENU_HIDE", () => $a5abc11d4ec98a8a$export$9b33af708e91c7a5);
$parcel$export(module.exports, "showMenu", () => $a5abc11d4ec98a8a$export$978857af675b1906);
$parcel$export(module.exports, "hideMenu", () => $a5abc11d4ec98a8a$export$cdf0b0ed532145ff);

var $8coUR = parcelRequire("8coUR");

var $3kaub = parcelRequire("3kaub");
const $a5abc11d4ec98a8a$export$3ecf1847e7a8ad80 = "REACT_CONTEXTMENU_SHOW";
const $a5abc11d4ec98a8a$export$9b33af708e91c7a5 = "REACT_CONTEXTMENU_HIDE";
function $a5abc11d4ec98a8a$export$fef770714ecf9cef(eventName, opts) {
    let target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
    // Compatibale with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    let event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("CustomEvent");
        event.initCustomEvent(eventName, false, true, opts);
    }
    if (target) {
        target.dispatchEvent(event);
        (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))((0, $3kaub.store), opts);
    }
}
function $a5abc11d4ec98a8a$export$978857af675b1906() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let target = arguments.length > 1 ? arguments[1] : undefined;
    $a5abc11d4ec98a8a$export$fef770714ecf9cef($a5abc11d4ec98a8a$export$3ecf1847e7a8ad80, (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, opts, {
        type: $a5abc11d4ec98a8a$export$3ecf1847e7a8ad80
    }), target);
}
function $a5abc11d4ec98a8a$export$cdf0b0ed532145ff() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let target = arguments.length > 1 ? arguments[1] : undefined;
    $a5abc11d4ec98a8a$export$fef770714ecf9cef($a5abc11d4ec98a8a$export$9b33af708e91c7a5, (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, opts, {
        type: $a5abc11d4ec98a8a$export$9b33af708e91c7a5
    }), target);
}

});
parcelRegister("3kaub", function(module, exports) {

$parcel$export(module.exports, "callIfExists", () => $26bb5fa366889929$export$c736948f016ca53a);
$parcel$export(module.exports, "hasOwnProp", () => $26bb5fa366889929$export$a6b793de298f3b60);
$parcel$export(module.exports, "uniqueId", () => $26bb5fa366889929$export$8b15d37bc3f197d4);
$parcel$export(module.exports, "cssClasses", () => $26bb5fa366889929$export$c1c0562ec8379000);
$parcel$export(module.exports, "store", () => $26bb5fa366889929$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "canUseDOM", () => $26bb5fa366889929$export$71594e8a50f746f4);
function $26bb5fa366889929$export$c736948f016ca53a(func) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return typeof func === "function" && func(...args);
}
function $26bb5fa366889929$export$a6b793de298f3b60(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $26bb5fa366889929$export$8b15d37bc3f197d4() {
    return Math.random().toString(36).substring(7);
}
const $26bb5fa366889929$export$c1c0562ec8379000 = {
    menu: "react-contextmenu",
    menuVisible: "react-contextmenu--visible",
    menuWrapper: "react-contextmenu-wrapper",
    menuItem: "react-contextmenu-item",
    menuItemActive: "react-contextmenu-item--active",
    menuItemDisabled: "react-contextmenu-item--disabled",
    menuItemDivider: "react-contextmenu-item--divider",
    menuItemSelected: "react-contextmenu-item--selected",
    subMenu: "react-contextmenu-submenu"
};
const $26bb5fa366889929$export$6f57813fe9f31bf9 = {};
const $26bb5fa366889929$export$71594e8a50f746f4 = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);

});



parcelRegister("d2eW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d70c55fd795fec$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $4CnrE = parcelRequire("4CnrE");
class $97d70c55fd795fec$export$2e2bcd8739ae039 extends (0, $acw62.Component) {
    static propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired
    };
    constructor(props){
        super(props);
        this.seletedItemRef = null;
        this.state = {
            selectedItem: null,
            forceSubMenuOpen: false
        };
    }
    handleKeyNavigation = (e)=>{
        // check for isVisible strictly here as it might be undefined when this code executes in the context of SubMenu
        // but we only need to check when it runs in the ContextMenu context
        if (this.state.isVisible === false) return;
        switch(e.key){
            case "ArrowLeft":
            case "Left":
            case "Escape":
            case "Esc":
                // IE specific value
                e.preventDefault();
                this.hideMenu(e);
                break;
            case "ArrowUp":
            case "Up":
                // IE specific value
                e.preventDefault();
                this.selectChildren(true);
                break;
            case "ArrowDown":
            case "Down":
                // IE specific value
                e.preventDefault();
                this.selectChildren(false);
                break;
            case "ArrowRight":
            case "Right":
                // IE specific value
                this.tryToOpenSubMenu(e);
                break;
            case "Enter":
                // enter
                e.preventDefault();
                this.tryToOpenSubMenu(e);
                {
                    // determine the selected item is disabled or not
                    const disabled = this.seletedItemRef && this.seletedItemRef.props && this.seletedItemRef.props.disabled;
                    if (this.seletedItemRef && this.seletedItemRef.ref instanceof HTMLElement && !disabled) this.seletedItemRef.ref.click();
                    else this.hideMenu(e);
                }
                break;
            default:
        }
    };
    handleForceClose = ()=>{
        this.setState({
            forceSubMenuOpen: false
        });
    };
    tryToOpenSubMenu = (e)=>{
        if (this.state.selectedItem && this.state.selectedItem.type === this.getSubMenuType()) {
            e.preventDefault();
            this.setState({
                forceSubMenuOpen: true
            });
        }
    };
    selectChildren = (forward)=>{
        const { selectedItem: selectedItem } = this.state;
        const children = [];
        let disabledChildrenCount = 0;
        let disabledChildIndexes = {};
        const childCollector = (child, index)=>{
            // child can be empty in case you do conditional rendering of components, in which
            // case it should not be accounted for as a real child
            if (!child) return;
            if ([
                (0, $4CnrE.default),
                this.getSubMenuType()
            ].indexOf(child.type) < 0) // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(child.props.children, childCollector);
            else if (!child.props.divider) {
                if (child.props.disabled) {
                    ++disabledChildrenCount;
                    disabledChildIndexes[index] = true;
                }
                children.push(child);
            }
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(this.props.children, childCollector);
        if (disabledChildrenCount === children.length) // All menu items are disabled, so none can be selected, don't do anything
        return;
        function findNextEnabledChildIndex(currentIndex) {
            let i = currentIndex;
            let incrementCounter = ()=>{
                if (forward) --i;
                else ++i;
                if (i < 0) i = children.length - 1;
                else if (i >= children.length) i = 0;
            };
            do incrementCounter();
            while (i !== currentIndex && disabledChildIndexes[i]);
            return i === currentIndex ? null : i;
        }
        const currentIndex = selectedItem ? selectedItem.index : -1;
        const nextEnabledChildIndex = findNextEnabledChildIndex(currentIndex);
        if (nextEnabledChildIndex !== null) this.setState({
            selectedItem: {
                index: nextEnabledChildIndex,
                // We need to know the type of the selected item, so we can
                // check it during render and tryToOpenSubMenu.
                type: children[nextEnabledChildIndex].type
            },
            forceSubMenuOpen: false
        });
    };
    onChildMouseMove = (child, itemIndex)=>{
        if (this.state.selectedItem === null || this.state.selectedItem.index !== itemIndex) this.setState({
            selectedItem: {
                index: itemIndex,
                type: child.type
            },
            forceSubMenuOpen: false
        });
    };
    onChildMouseLeave = ()=>{
        this.setState({
            selectedItem: null,
            forceSubMenuOpen: false
        });
    };
    /**
   * Render all the children.
   * It has a `childIndexRef` parameter to be able to construct the child
   * indexes properly. A reference was needed for this function because this
   * is a recursive function that could mutate the index and pass it back to
   * the caller. That parameter should always be undefined while calling from
   * outside.
   * TODO: Rewrite this function in a way that we don't need this reference.
   */ renderChildren = (()=>{
        var _this = this;
        return function(children) {
            let childIndexRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                value: -1
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
                let currentChildIndexRef = childIndexRef;
                const props = {};
                if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) return child;
                if ([
                    (0, $4CnrE.default),
                    _this.getSubMenuType()
                ].indexOf(child.type) < 0) {
                    // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
                    props.children = _this.renderChildren(child.props.children, currentChildIndexRef);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, props);
                }
                // At this point we know that this is a menu item and we are going to
                // render it. We need to increment the child index and assign it as
                // the item index.
                let itemIndex = null;
                if (!child.props.divider) // A MenuItem can be a divider. Do not increment the value if it's.
                itemIndex = ++currentChildIndexRef.value;
                props.onMouseLeave = _this.onChildMouseLeave.bind(_this);
                if (child.type === _this.getSubMenuType()) {
                    // special props for SubMenu only
                    props.forceOpen = _this.state.forceSubMenuOpen && _this.state.selectedItem && _this.state.selectedItem.index === itemIndex;
                    props.forceClose = _this.handleForceClose;
                    props.parentKeyNavigationHandler = _this.handleKeyNavigation;
                }
                if (!child.props.divider && _this.state.selectedItem && _this.state.selectedItem.index === itemIndex) {
                    // special props for selected item only
                    props.selected = true;
                    props.ref = (ref)=>{
                        _this.seletedItemRef = ref;
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, props);
                }
                // onMouseMove is only needed for non selected items
                props.onMouseMove = ()=>_this.onChildMouseMove(child, itemIndex);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, props);
            });
        };
    })();
}

});
parcelRegister("4CnrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cce5b751389a5c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $8coUR = parcelRequire("8coUR");

var $edRt2 = parcelRequire("edRt2");

var $3kaub = parcelRequire("3kaub");
function $35cce5b751389a5c$var$_extends() {
    $35cce5b751389a5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $35cce5b751389a5c$var$_extends.apply(this, arguments);
}
class $35cce5b751389a5c$export$2e2bcd8739ae039 extends (0, $acw62.Component) {
    static propTypes = {
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onMouseMove: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        preventClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    };
    static defaultProps = {
        attributes: {},
        children: null,
        className: "",
        data: {},
        disabled: false,
        divider: false,
        onClick () {
            return null;
        },
        onMouseMove: ()=>null,
        onMouseLeave: ()=>null,
        preventClose: false,
        selected: false,
        role: "menuitem"
    };
    handleClick = (event)=>{
        if (event.button !== 0 && event.button !== 1) event.preventDefault();
        if (this.props.disabled || this.props.divider) return;
        (0, $3kaub.callIfExists)(this.props.onClick, event, (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, this.props.data, (0, $3kaub.store).data), (0, $3kaub.store).target);
        if (this.props.preventClose) return;
        (0, $edRt2.hideMenu)();
    };
    render() {
        const { attributes: attributes, children: children, className: className, disabled: disabled, divider: divider, selected: selected, role: role } = this.props;
        const menuItemClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, (0, $3kaub.cssClasses).menuItem, attributes.className, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItemDisabled, attributes.disabledClassName)]: disabled,
            [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItemDivider, attributes.dividerClassName)]: divider,
            [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItemSelected, attributes.selectedClassName)]: selected
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $35cce5b751389a5c$var$_extends({}, attributes, {
            className: menuItemClassNames,
            role: role,
            tabIndex: "-1",
            "aria-disabled": disabled ? "true" : "false",
            "aria-orientation": divider ? "horizontal" : null,
            ref: (ref)=>{
                this.ref = ref;
            },
            onMouseMove: this.props.onMouseMove,
            onMouseLeave: this.props.onMouseLeave,
            onTouchEnd: this.handleClick,
            onClick: this.handleClick
        }), divider ? null : children);
    }
}

});


parcelRegister("jgXSY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e07df703ba5357a8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $8coUR = parcelRequire("8coUR");

var $edRt2 = parcelRequire("edRt2");

var $d2eW7 = parcelRequire("d2eW7");

var $3kaub = parcelRequire("3kaub");

var $31Wdr = parcelRequire("31Wdr");
function $e07df703ba5357a8$var$_extends() {
    $e07df703ba5357a8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e07df703ba5357a8$var$_extends.apply(this, arguments);
}
class $e07df703ba5357a8$export$2e2bcd8739ae039 extends (0, $d2eW7.default) {
    static propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        hoverDelay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        rtl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        onMouseMove: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        onMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        forceOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        forceClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        parentKeyNavigationHandler: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    };
    static defaultProps = {
        disabled: false,
        hoverDelay: 500,
        attributes: {},
        className: "",
        rtl: false,
        selected: false,
        onMouseMove: ()=>null,
        onMouseOut: ()=>null,
        forceOpen: false,
        forceClose: ()=>null,
        parentKeyNavigationHandler: ()=>null
    };
    constructor(props){
        super(props);
        this.state = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, this.state, {
            visible: false
        });
    }
    componentDidMount() {
        this.listenId = (0, $31Wdr.default).register(()=>{}, this.hideSubMenu);
    }
    getSubMenuType() {
        // eslint-disable-line class-methods-use-this
        return $e07df703ba5357a8$export$2e2bcd8739ae039;
    }
    shouldComponentUpdate(nextProps, nextState) {
        this.isVisibilityChange = (this.state.visible !== nextState.visible || this.props.forceOpen !== nextProps.forceOpen) && !(this.state.visible && nextProps.forceOpen) && !(this.props.forceOpen && nextState.visible);
        return true;
    }
    componentDidUpdate() {
        if (!this.isVisibilityChange) return;
        if (this.props.forceOpen || this.state.visible) {
            const wrapper = window.requestAnimationFrame || setTimeout;
            wrapper(()=>{
                const styles = this.props.rtl ? this.getRTLMenuPosition() : this.getMenuPosition();
                this.subMenu.style.removeProperty("top");
                this.subMenu.style.removeProperty("bottom");
                this.subMenu.style.removeProperty("left");
                this.subMenu.style.removeProperty("right");
                if ((0, $3kaub.hasOwnProp)(styles, "top")) this.subMenu.style.top = styles.top;
                if ((0, $3kaub.hasOwnProp)(styles, "left")) this.subMenu.style.left = styles.left;
                if ((0, $3kaub.hasOwnProp)(styles, "bottom")) this.subMenu.style.bottom = styles.bottom;
                if ((0, $3kaub.hasOwnProp)(styles, "right")) this.subMenu.style.right = styles.right;
                this.subMenu.classList.add((0, $3kaub.cssClasses).menuVisible);
                this.registerHandlers();
                this.setState({
                    selectedItem: null
                });
            });
        } else {
            const cleanup = ()=>{
                this.subMenu.removeEventListener("transitionend", cleanup);
                this.subMenu.style.removeProperty("bottom");
                this.subMenu.style.removeProperty("right");
                this.subMenu.style.top = 0;
                this.subMenu.style.left = "100%";
                this.unregisterHandlers();
            };
            this.subMenu.addEventListener("transitionend", cleanup);
            this.subMenu.classList.remove((0, $3kaub.cssClasses).menuVisible);
        }
    }
    componentWillUnmount() {
        if (this.listenId) (0, $31Wdr.default).unregister(this.listenId);
        if (this.opentimer) clearTimeout(this.opentimer);
        if (this.closetimer) clearTimeout(this.closetimer);
        this.unregisterHandlers(true);
    }
    getMenuPosition = ()=>{
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        const rect = this.subMenu.getBoundingClientRect();
        const position = {};
        if (rect.bottom > innerHeight) position.bottom = 0;
        else position.top = 0;
        if (rect.right < innerWidth) position.left = "100%";
        else position.right = "100%";
        return position;
    };
    getRTLMenuPosition = ()=>{
        const { innerHeight: innerHeight } = window;
        const rect = this.subMenu.getBoundingClientRect();
        const position = {};
        if (rect.bottom > innerHeight) position.bottom = 0;
        else position.top = 0;
        if (rect.left < 0) position.left = "100%";
        else position.right = "100%";
        return position;
    };
    hideMenu = (e)=>{
        e.preventDefault();
        this.hideSubMenu(e);
    };
    hideSubMenu = (e)=>{
        // avoid closing submenus of a different menu tree
        if (e.detail && e.detail.id && this.menu && e.detail.id !== this.menu.id) return;
        if (this.props.forceOpen) this.props.forceClose();
        this.setState({
            visible: false,
            selectedItem: null
        });
        this.unregisterHandlers();
    };
    handleClick = (event)=>{
        event.preventDefault();
        if (this.props.disabled) return;
        (0, $3kaub.callIfExists)(this.props.onClick, event, (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, this.props.data, (0, $3kaub.store).data), (0, $3kaub.store).target);
        if (!this.props.onClick || this.props.preventCloseOnClick) return;
        (0, $edRt2.hideMenu)();
    };
    handleMouseEnter = ()=>{
        if (this.closetimer) clearTimeout(this.closetimer);
        if (this.props.disabled || this.state.visible) return;
        this.opentimer = setTimeout(()=>this.setState({
                visible: true,
                selectedItem: null
            }), this.props.hoverDelay);
    };
    handleMouseLeave = ()=>{
        if (this.opentimer) clearTimeout(this.opentimer);
        if (!this.state.visible) return;
        this.closetimer = setTimeout(()=>this.setState({
                visible: false,
                selectedItem: null
            }), this.props.hoverDelay);
    };
    menuRef = (c)=>{
        this.menu = c;
    };
    subMenuRef = (c)=>{
        this.subMenu = c;
    };
    registerHandlers = ()=>{
        document.removeEventListener("keydown", this.props.parentKeyNavigationHandler);
        document.addEventListener("keydown", this.handleKeyNavigation);
    };
    unregisterHandlers = (dismounting)=>{
        document.removeEventListener("keydown", this.handleKeyNavigation);
        if (!dismounting) document.addEventListener("keydown", this.props.parentKeyNavigationHandler);
    };
    render() {
        const { children: children, attributes: attributes, disabled: disabled, title: title, selected: selected } = this.props;
        const { visible: visible } = this.state;
        const menuProps = {
            ref: this.menuRef,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItem, (0, $3kaub.cssClasses).subMenu, attributes.listClassName),
            style: {
                position: "relative"
            }
        };
        const menuItemProps = {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItem, attributes.className, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItemDisabled, attributes.disabledClassName)]: disabled,
                [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItemActive, attributes.visibleClassName)]: visible,
                [(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuItemSelected, attributes.selectedClassName)]: selected
            }),
            onMouseMove: this.props.onMouseMove,
            onMouseOut: this.props.onMouseOut,
            onClick: this.handleClick
        };
        const subMenuProps = {
            ref: this.subMenuRef,
            style: {
                position: "absolute",
                transition: "opacity 1ms",
                // trigger transitionend event
                top: 0,
                left: "100%"
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menu, this.props.className)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", $e07df703ba5357a8$var$_extends({}, menuProps, {
            role: "menuitem",
            tabIndex: "-1",
            "aria-haspopup": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $e07df703ba5357a8$var$_extends({}, attributes, menuItemProps), title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", $e07df703ba5357a8$var$_extends({}, subMenuProps, {
            role: "menu",
            tabIndex: "-1"
        }), this.renderChildren(children)));
    }
}

});


parcelRegister("9RtmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $72dfd881dda58c1a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $8coUR = parcelRequire("8coUR");

var $edRt2 = parcelRequire("edRt2");

var $3kaub = parcelRequire("3kaub");
class $72dfd881dda58c1a$export$2e2bcd8739ae039 extends (0, $acw62.Component) {
    static propTypes = {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        collect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        disable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        holdToDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        posX: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        posY: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        renderTag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        // Trigger on left click in addition to right click
        triggerOnLeftClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        disableIfShiftIsPressed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    };
    static defaultProps = {
        attributes: {},
        collect () {
            return null;
        },
        disable: false,
        holdToDisplay: 1000,
        renderTag: "div",
        posX: 0,
        posY: 0,
        triggerOnLeftClick: false,
        disableIfShiftIsPressed: false
    };
    touchHandled = false;
    handleMouseDown = (event)=>{
        if (this.props.holdToDisplay >= 0 && event.button === 0) {
            event.persist();
            event.stopPropagation();
            this.mouseDownTimeoutId = setTimeout(()=>this.handleContextClick(event), this.props.holdToDisplay);
        }
        (0, $3kaub.callIfExists)(this.props.attributes.onMouseDown, event);
    };
    handleMouseUp = (event)=>{
        if (event.button === 0) clearTimeout(this.mouseDownTimeoutId);
        (0, $3kaub.callIfExists)(this.props.attributes.onMouseUp, event);
    };
    handleMouseOut = (event)=>{
        if (event.button === 0) clearTimeout(this.mouseDownTimeoutId);
        (0, $3kaub.callIfExists)(this.props.attributes.onMouseOut, event);
    };
    handleTouchstart = (event)=>{
        this.touchHandled = false;
        if (this.props.holdToDisplay >= 0) {
            event.persist();
            event.stopPropagation();
            this.touchstartTimeoutId = setTimeout(()=>{
                this.handleContextClick(event);
                this.touchHandled = true;
            }, this.props.holdToDisplay);
        }
        (0, $3kaub.callIfExists)(this.props.attributes.onTouchStart, event);
    };
    handleTouchEnd = (event)=>{
        if (this.touchHandled) event.preventDefault();
        clearTimeout(this.touchstartTimeoutId);
        (0, $3kaub.callIfExists)(this.props.attributes.onTouchEnd, event);
    };
    handleContextMenu = (event)=>{
        this.handleContextClick(event);
        (0, $3kaub.callIfExists)(this.props.attributes.onContextMenu, event);
    };
    // Note: this function is registered only if triggerOnLeftClick is true.
    handleMouseClick = (event)=>{
        this.handleContextClick(event);
        (0, $3kaub.callIfExists)(this.props.attributes.onClick, event);
    };
    handleContextClick = (event)=>{
        if (this.props.disable) return;
        if (this.props.disableIfShiftIsPressed && event.shiftKey) return;
        event.preventDefault();
        event.stopPropagation();
        let x = event.clientX || event.touches && event.touches[0].pageX;
        let y = event.clientY || event.touches && event.touches[0].pageY;
        if (this.props.posX) x -= this.props.posX;
        if (this.props.posY) y -= this.props.posY;
        (0, $edRt2.hideMenu)();
        let data = (0, $3kaub.callIfExists)(this.props.collect, this.props);
        let showMenuConfig = {
            position: {
                x: x,
                y: y
            },
            target: this.elem,
            id: this.props.id
        };
        if (data && typeof data.then === "function") // it's promise
        data.then((resp)=>{
            showMenuConfig.data = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, resp, {
                target: event.target
            });
            (0, $edRt2.showMenu)(showMenuConfig);
        });
        else {
            showMenuConfig.data = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, data, {
                target: event.target
            });
            (0, $edRt2.showMenu)(showMenuConfig);
        }
    };
    elemRef = (c)=>{
        this.elem = c;
    };
    render() {
        const { renderTag: renderTag, attributes: attributes, children: children, triggerOnLeftClick: triggerOnLeftClick } = this.props;
        const newAttrs = {
            ...attributes,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $3kaub.cssClasses).menuWrapper, attributes.className),
            onContextMenu: this.handleContextMenu,
            onClick: triggerOnLeftClick ? this.handleMouseClick : null,
            onMouseDown: this.handleMouseDown,
            onMouseUp: this.handleMouseUp,
            onTouchStart: this.handleTouchstart,
            onTouchEnd: this.handleTouchEnd,
            onMouseOut: this.handleMouseOut,
            ref: this.elemRef
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(renderTag, newAttrs, children);
    }
}

});

parcelRegister("gydR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ca9183781c0481$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9RtmZ = parcelRequire("9RtmZ");

var $31Wdr = parcelRequire("31Wdr");
function $c0ca9183781c0481$var$_extends() {
    $c0ca9183781c0481$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0ca9183781c0481$var$_extends.apply(this, arguments);
}
// collect ContextMenuTrigger's expected props to NOT pass them on as part of the context
const $c0ca9183781c0481$var$ignoredTriggerProps = [
    ...Object.keys((0, $9RtmZ.default).propTypes),
    "children"
];
function $c0ca9183781c0481$export$2e2bcd8739ae039(menuId) {
    // expect menu component to connect as inner parameter
    // <Child/> is presumably a wrapper of <ContextMenu/>
    return function connect(Child) {
        // return wrapper for <Child/> that forwards the ContextMenuTrigger's additional props
        return class ConnectMenu extends (0, $acw62.Component) {
            constructor(props){
                super(props);
                this.state = {
                    trigger: null
                };
            }
            componentDidMount() {
                this.listenId = (0, $31Wdr.default).register(this.handleShow, this.handleHide);
            }
            componentWillUnmount() {
                if (this.listenId) (0, $31Wdr.default).unregister(this.listenId);
            }
            handleShow = (e)=>{
                if (e.detail.id !== menuId) return;
                // the onShow event's detail.data object holds all ContextMenuTrigger props
                const { data: data } = e.detail;
                const filteredData = {};
                for(const key in data)// exclude props the ContextMenuTrigger is expecting itself
                if (!$c0ca9183781c0481$var$ignoredTriggerProps.includes(key)) filteredData[key] = data[key];
                this.setState({
                    trigger: filteredData
                });
            };
            handleHide = ()=>{
                this.setState({
                    trigger: null
                });
            };
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Child, $c0ca9183781c0481$var$_extends({}, this.props, {
                    id: menuId,
                    trigger: this.state.trigger
                }));
            }
        };
    };
}

});


parcelRegister("jrCwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e27e6af446543659$export$2e2bcd8739ae039);
/*!
 * Flickr's Justified Gallery [fjGallery] v2.2.0 (https://flickr-justified-gallery.nkdev.info)
 * Copyright 2024 nK <https://nkdev.info>
 * Licensed under MIT (https://github.com/nk-o/flickr-justified-gallery/blob/master/LICENSE)
 */ /* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $e27e6af446543659$var$throttle(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self1 = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self1, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $e27e6af446543659$var$debounce(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $e27e6af446543659$var$throttle(delay, callback, {
        debounceMode: atBegin !== false
    });
}
var $e27e6af446543659$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
function $e27e6af446543659$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
/**
 * Row
 * Wrapper for each row in a justified layout.
 * Stores relevant values and provides methods for calculating layout of individual rows.
 *
 * @param {Object} layoutConfig - The same as that passed
 * @param {Object} Initialization parameters. The following are all required:
 * @param params.index {Number} The index of this row
 * @param params.top {Number} Top of row, relative to container
 * @param params.left {Number} Left side of row relative to container (equal to container left padding)
 * @param params.width {Number} Width of row, not including container padding
 * @param params.spacing {Number} Horizontal spacing between items
 * @param params.targetRowHeight {Number} Layout algorithm will aim for this row height
 * @param params.targetRowHeightTolerance {Number} Row heights may vary +/- (`targetRowHeight` x `targetRowHeightTolerance`)
 * @param params.edgeCaseMinRowHeight {Number} Absolute minimum row height for edge cases that cannot be resolved within tolerance.
 * @param params.edgeCaseMaxRowHeight {Number} Absolute maximum row height for edge cases that cannot be resolved within tolerance.
 * @param params.isBreakoutRow {Boolean} Is this row in particular one of those breakout rows? Always false if it's not that kind of photo list
 * @param params.widowLayoutStyle {String} If widows are visible, how should they be laid out?
 * @constructor
 */ const $e27e6af446543659$var$Row = function(params) {
    // The index of this row
    this.index = params.index;
    // Top of row, relative to container
    this.top = params.top;
    // Left side of row relative to container (equal to container left padding)
    this.left = params.left;
    // Width of row, not including container padding
    this.width = params.width;
    // Horizontal spacing between items
    this.spacing = params.spacing;
    // Row height calculation values
    this.targetRowHeight = params.targetRowHeight;
    this.targetRowHeightTolerance = params.targetRowHeightTolerance;
    this.minAspectRatio = this.width / params.targetRowHeight * (1 - params.targetRowHeightTolerance);
    this.maxAspectRatio = this.width / params.targetRowHeight * (1 + params.targetRowHeightTolerance);
    // Edge case row height minimum/maximum
    this.edgeCaseMinRowHeight = params.edgeCaseMinRowHeight;
    this.edgeCaseMaxRowHeight = params.edgeCaseMaxRowHeight;
    // Widow layout direction
    this.widowLayoutStyle = params.widowLayoutStyle;
    // Full width breakout rows
    this.isBreakoutRow = params.isBreakoutRow;
    // Store layout data for each item in row
    this.items = [];
    // Height remains at 0 until it's been calculated
    this.height = 0;
};
$e27e6af446543659$var$Row.prototype = {
    /**
   * Attempt to add a single item to the row.
   * This is the heart of the justified algorithm.
   * This method is direction-agnostic; it deals only with sizes, not positions.
   *
   * If the item fits in the row, without pushing row height beyond min/max tolerance,
   * the item is added and the method returns true.
   *
   * If the item leaves row height too high, there may be room to scale it down and add another item.
   * In this case, the item is added and the method returns true, but the row is incomplete.
   *
   * If the item leaves row height too short, there are too many items to fit within tolerance.
   * The method will either accept or reject the new item, favoring the resulting row height closest to within tolerance.
   * If the item is rejected, left/right padding will be required to fit the row height within tolerance;
   * if the item is accepted, top/bottom cropping will be required to fit the row height within tolerance.
   *
   * @method addItem
   * @param itemData {Object} Item layout data, containing item aspect ratio.
   * @return {Boolean} True if successfully added; false if rejected.
   */ addItem: function(itemData) {
        const newItems = this.items.concat(itemData);
        // Calculate aspect ratios for items only; exclude spacing
        const rowWidthWithoutSpacing = this.width - (newItems.length - 1) * this.spacing;
        const newAspectRatio = newItems.reduce(function(sum, item) {
            return sum + item.aspectRatio;
        }, 0);
        const targetAspectRatio = rowWidthWithoutSpacing / this.targetRowHeight;
        let previousRowWidthWithoutSpacing;
        let previousAspectRatio;
        let previousTargetAspectRatio;
        // Handle big full-width breakout photos if we're doing them
        if (this.isBreakoutRow) {
            // Only do it if there's no other items in this row
            if (this.items.length === 0) // Only go full width if this photo is a square or landscape
            {
                if (itemData.aspectRatio >= 1) {
                    // Close out the row with a full width photo
                    this.items.push(itemData);
                    this.completeLayout(rowWidthWithoutSpacing / itemData.aspectRatio, "justify");
                    return true;
                }
            }
        }
        if (newAspectRatio < this.minAspectRatio) {
            // New aspect ratio is too narrow / scaled row height is too tall.
            // Accept this item and leave row open for more items.
            this.items.push(Object.assign({}, itemData));
            return true;
        } else if (newAspectRatio > this.maxAspectRatio) {
            // New aspect ratio is too wide / scaled row height will be too short.
            // Accept item if the resulting aspect ratio is closer to target than it would be without the item.
            // NOTE: Any row that falls into this block will require cropping/padding on individual items.
            if (this.items.length === 0) {
                // When there are no existing items, force acceptance of the new item and complete the layout.
                // This is the pano special case.
                this.items.push(Object.assign({}, itemData));
                this.completeLayout(rowWidthWithoutSpacing / newAspectRatio, "justify");
                return true;
            }
            // Calculate width/aspect ratio for row before adding new item
            previousRowWidthWithoutSpacing = this.width - (this.items.length - 1) * this.spacing;
            previousAspectRatio = this.items.reduce(function(sum, item) {
                return sum + item.aspectRatio;
            }, 0);
            previousTargetAspectRatio = previousRowWidthWithoutSpacing / this.targetRowHeight;
            if (Math.abs(newAspectRatio - targetAspectRatio) > Math.abs(previousAspectRatio - previousTargetAspectRatio)) {
                // Row with new item is us farther away from target than row without; complete layout and reject item.
                this.completeLayout(previousRowWidthWithoutSpacing / previousAspectRatio, "justify");
                return false;
            } else {
                // Row with new item is us closer to target than row without;
                // accept the new item and complete the row layout.
                this.items.push(Object.assign({}, itemData));
                this.completeLayout(rowWidthWithoutSpacing / newAspectRatio, "justify");
                return true;
            }
        } else {
            // New aspect ratio / scaled row height is within tolerance;
            // accept the new item and complete the row layout.
            this.items.push(Object.assign({}, itemData));
            this.completeLayout(rowWidthWithoutSpacing / newAspectRatio, "justify");
            return true;
        }
    },
    /**
   * Check if a row has completed its layout.
   *
   * @method isLayoutComplete
   * @return {Boolean} True if complete; false if not.
   */ isLayoutComplete: function() {
        return this.height > 0;
    },
    /**
   * Set row height and compute item geometry from that height.
   * Will justify items within the row unless instructed not to.
   *
   * @method completeLayout
   * @param newHeight {Number} Set row height to this value.
   * @param widowLayoutStyle {String} How should widows display? Supported: left | justify | center
   */ completeLayout: function(newHeight, widowLayoutStyle) {
        let itemWidthSum = this.left;
        const rowWidthWithoutSpacing = this.width - (this.items.length - 1) * this.spacing;
        let clampedToNativeRatio;
        let clampedHeight;
        let errorWidthPerItem;
        let roundedCumulativeErrors;
        let singleItemGeometry;
        let centerOffset;
        // Justify unless explicitly specified otherwise.
        if (typeof widowLayoutStyle === "undefined" || [
            "justify",
            "center",
            "left"
        ].indexOf(widowLayoutStyle) < 0) widowLayoutStyle = "left";
        // Clamp row height to edge case minimum/maximum.
        clampedHeight = Math.max(this.edgeCaseMinRowHeight, Math.min(newHeight, this.edgeCaseMaxRowHeight));
        if (newHeight !== clampedHeight) {
            // If row height was clamped, the resulting row/item aspect ratio will be off,
            // so force it to fit the width (recalculate aspectRatio to match clamped height).
            // NOTE: this will result in cropping/padding commensurate to the amount of clamping.
            this.height = clampedHeight;
            clampedToNativeRatio = rowWidthWithoutSpacing / clampedHeight / (rowWidthWithoutSpacing / newHeight);
        } else {
            // If not clamped, leave ratio at 1.0.
            this.height = newHeight;
            clampedToNativeRatio = 1.0;
        }
        // Compute item geometry based on newHeight.
        this.items.forEach(function(item) {
            item.row = this.index;
            item.top = this.top;
            item.width = item.aspectRatio * this.height * clampedToNativeRatio;
            item.height = this.height;
            // Left-to-right.
            // TODO right to left
            // item.left = this.width - itemWidthSum - item.width;
            item.left = itemWidthSum;
            // Increment width.
            itemWidthSum += item.width + this.spacing;
        }, this);
        // If specified, ensure items fill row and distribute error
        // caused by rounding width and height across all items.
        if (widowLayoutStyle === "justify") {
            itemWidthSum -= this.spacing + this.left;
            errorWidthPerItem = (itemWidthSum - this.width) / this.items.length;
            roundedCumulativeErrors = this.items.map(function(item, i) {
                return Math.round((i + 1) * errorWidthPerItem);
            });
            if (this.items.length === 1) {
                // For rows with only one item, adjust item width to fill row.
                singleItemGeometry = this.items[0];
                singleItemGeometry.width -= Math.round(errorWidthPerItem);
            } else // For rows with multiple items, adjust item width and shift items to fill the row,
            // while maintaining equal spacing between items in the row.
            this.items.forEach(function(item, i) {
                if (i > 0) {
                    item.left -= roundedCumulativeErrors[i - 1];
                    item.width -= roundedCumulativeErrors[i] - roundedCumulativeErrors[i - 1];
                } else item.width -= roundedCumulativeErrors[i];
            });
        } else if (widowLayoutStyle === "center") {
            // Center widows
            centerOffset = (this.width - itemWidthSum) / 2;
            this.items.forEach(function(item) {
                item.left += centerOffset + this.spacing;
            }, this);
        }
    },
    /**
   * Force completion of row layout with current items.
   *
   * @method forceComplete
   * @param fitToWidth {Boolean} Stretch current items to fill the row width.
   *                             This will likely result in padding.
   * @param fitToWidth {Number}
   */ forceComplete: function(fitToWidth, rowHeight) {
        // TODO Handle fitting to width
        // var rowWidthWithoutSpacing = this.width - (this.items.length - 1) * this.spacing,
        // 	currentAspectRatio = this.items.reduce(function (sum, item) {
        // 		return sum + item.aspectRatio;
        // 	}, 0);
        if (typeof rowHeight === "number") this.completeLayout(rowHeight, this.widowLayoutStyle);
        else // Complete using target row height.
        this.completeLayout(this.targetRowHeight, this.widowLayoutStyle);
    },
    /**
   * Return layout data for items within row.
   * Note: returns actual list, not a copy.
   *
   * @method getItems
   * @return Layout data for items within row.
   */ getItems: function() {
        return this.items;
    }
};
/*!
 * Copyright 2019 SmugMug, Inc. | Copyright 2024 nK
 * Licensed under the terms of the MIT license. Please see LICENSE file in the project root for terms.
 * @license
 */ /**
 * Create a new, empty row.
 *
 * @method createNewRow
 * @param layoutConfig {Object} The layout configuration
 * @param layoutData {Object} The current state of the layout
 * @return A new, empty row of the type specified by this layout.
 */ function $e27e6af446543659$var$createNewRow(layoutConfig, layoutData) {
    let isBreakoutRow;
    // Work out if this is a full width breakout row
    if (layoutConfig.fullWidthBreakoutRowCadence !== false) {
        if ((layoutData._rows.length + 1) % layoutConfig.fullWidthBreakoutRowCadence === 0) isBreakoutRow = true;
    }
    return new $e27e6af446543659$var$Row({
        index: layoutData._rows.length,
        top: layoutData._containerHeight,
        left: layoutConfig.containerPadding.left,
        width: layoutConfig.containerWidth - layoutConfig.containerPadding.left - layoutConfig.containerPadding.right,
        spacing: layoutConfig.boxSpacing.horizontal,
        targetRowHeight: layoutConfig.targetRowHeight,
        targetRowHeightTolerance: layoutConfig.targetRowHeightTolerance,
        edgeCaseMinRowHeight: layoutConfig.edgeCaseMinRowHeight * layoutConfig.targetRowHeight,
        edgeCaseMaxRowHeight: layoutConfig.edgeCaseMaxRowHeight * layoutConfig.targetRowHeight,
        rightToLeft: false,
        isBreakoutRow: isBreakoutRow,
        widowLayoutStyle: layoutConfig.widowLayoutStyle
    });
}
/**
 * Add a completed row to the layout.
 * Note: the row must have already been completed.
 *
 * @method addRow
 * @param layoutConfig {Object} The layout configuration
 * @param layoutData {Object} The current state of the layout
 * @param row {Row} The row to add.
 * @return {Array} Each item added to the row.
 */ function $e27e6af446543659$var$addRow(layoutConfig, layoutData, row) {
    layoutData._rows.push(row);
    layoutData._layoutItems = layoutData._layoutItems.concat(row.getItems());
    // Increment the container height
    layoutData._containerHeight += row.height + layoutConfig.boxSpacing.vertical;
    return row.items;
}
/**
 * Calculate the current layout for all items in the list that require layout.
 * "Layout" means geometry: position within container and size
 *
 * @method computeLayout
 * @param layoutConfig {Object} The layout configuration
 * @param layoutData {Object} The current state of the layout
 * @param itemLayoutData {Array} Array of items to lay out, with data required to lay out each item
 * @return {Object} The newly-calculated layout, containing the new container height, and lists of layout items
 */ function $e27e6af446543659$var$computeLayout(layoutConfig, layoutData, itemLayoutData) {
    let laidOutItems = [];
    let itemAdded;
    let currentRow;
    let nextToLastRowHeight;
    // Apply forced aspect ratio if specified, and set a flag.
    if (layoutConfig.forceAspectRatio) itemLayoutData.forEach(function(itemData) {
        itemData.forcedAspectRatio = true;
        itemData.aspectRatio = layoutConfig.forceAspectRatio;
    });
    // Loop through the items
    itemLayoutData.some(function(itemData, i) {
        if (isNaN(itemData.aspectRatio)) throw new Error("Item " + i + " has an invalid aspect ratio");
        // If not currently building up a row, make a new one.
        if (!currentRow) currentRow = $e27e6af446543659$var$createNewRow(layoutConfig, layoutData);
        // Attempt to add item to the current row.
        itemAdded = currentRow.addItem(itemData);
        if (currentRow.isLayoutComplete()) {
            // Row is filled; add it and start a new one
            laidOutItems = laidOutItems.concat($e27e6af446543659$var$addRow(layoutConfig, layoutData, currentRow));
            if (layoutData._rows.length >= layoutConfig.maxNumRows) {
                currentRow = null;
                return true;
            }
            currentRow = $e27e6af446543659$var$createNewRow(layoutConfig, layoutData);
            // Item was rejected; add it to its own row
            if (!itemAdded) {
                itemAdded = currentRow.addItem(itemData);
                if (currentRow.isLayoutComplete()) {
                    // If the rejected item fills a row on its own, add the row and start another new one
                    laidOutItems = laidOutItems.concat($e27e6af446543659$var$addRow(layoutConfig, layoutData, currentRow));
                    if (layoutData._rows.length >= layoutConfig.maxNumRows) {
                        currentRow = null;
                        return true;
                    }
                    currentRow = $e27e6af446543659$var$createNewRow(layoutConfig, layoutData);
                }
            }
        }
    });
    // Handle any leftover content (orphans) depending on where they lie
    // in this layout update, and in the total content set.
    if (currentRow && currentRow.getItems().length && layoutConfig.showWidows) {
        // Last page of all content or orphan suppression is suppressed; lay out orphans.
        if (layoutData._rows.length) {
            // Only Match previous row's height if it exists and it isn't a breakout row
            if (layoutData._rows[layoutData._rows.length - 1].isBreakoutRow) nextToLastRowHeight = layoutData._rows[layoutData._rows.length - 1].targetRowHeight;
            else nextToLastRowHeight = layoutData._rows[layoutData._rows.length - 1].height;
            currentRow.forceComplete(false, nextToLastRowHeight);
        } else // ...else use target height if there is no other row height to reference.
        currentRow.forceComplete(false);
        laidOutItems = laidOutItems.concat($e27e6af446543659$var$addRow(layoutConfig, layoutData, currentRow));
        layoutConfig._widowCount = currentRow.getItems().length;
    }
    // We need to clean up the bottom container padding
    // First remove the height added for box spacing
    layoutData._containerHeight = layoutData._containerHeight - layoutConfig.boxSpacing.vertical;
    // Then add our bottom container padding
    layoutData._containerHeight = layoutData._containerHeight + layoutConfig.containerPadding.bottom;
    return {
        containerHeight: layoutData._containerHeight,
        widowCount: layoutConfig._widowCount,
        boxes: layoutData._layoutItems
    };
}
/**
 * Takes in a bunch of box data and config. Returns
 * geometry to lay them out in a justified view.
 *
 * @method covertSizesToAspectRatios
 * @param sizes {Array} Array of objects with widths and heights
 * @return {Array} A list of aspect ratios
 */ function $e27e6af446543659$var$index(input, config) {
    let layoutConfig = {};
    const layoutData = {};
    // Defaults
    const defaults = {
        containerWidth: 1060,
        containerPadding: 10,
        boxSpacing: 10,
        targetRowHeight: 320,
        targetRowHeightTolerance: 0.25,
        edgeCaseMinRowHeight: 0.5,
        edgeCaseMaxRowHeight: 2.5,
        maxNumRows: Number.POSITIVE_INFINITY,
        forceAspectRatio: false,
        showWidows: true,
        fullWidthBreakoutRowCadence: false,
        widowLayoutStyle: "left"
    };
    const containerPadding = {};
    const boxSpacing = {};
    config = config || {};
    // Merge defaults and config passed in
    layoutConfig = Object.assign(defaults, config);
    // Sort out padding and spacing values
    containerPadding.top = !isNaN(parseFloat(layoutConfig.containerPadding.top)) ? layoutConfig.containerPadding.top : layoutConfig.containerPadding;
    containerPadding.right = !isNaN(parseFloat(layoutConfig.containerPadding.right)) ? layoutConfig.containerPadding.right : layoutConfig.containerPadding;
    containerPadding.bottom = !isNaN(parseFloat(layoutConfig.containerPadding.bottom)) ? layoutConfig.containerPadding.bottom : layoutConfig.containerPadding;
    containerPadding.left = !isNaN(parseFloat(layoutConfig.containerPadding.left)) ? layoutConfig.containerPadding.left : layoutConfig.containerPadding;
    boxSpacing.horizontal = !isNaN(parseFloat(layoutConfig.boxSpacing.horizontal)) ? layoutConfig.boxSpacing.horizontal : layoutConfig.boxSpacing;
    boxSpacing.vertical = !isNaN(parseFloat(layoutConfig.boxSpacing.vertical)) ? layoutConfig.boxSpacing.vertical : layoutConfig.boxSpacing;
    layoutConfig.containerPadding = containerPadding;
    layoutConfig.boxSpacing = boxSpacing;
    // Local
    layoutData._layoutItems = [];
    layoutData._awakeItems = [];
    layoutData._inViewportItems = [];
    layoutData._leadingOrphans = [];
    layoutData._trailingOrphans = [];
    layoutData._containerHeight = layoutConfig.containerPadding.top;
    layoutData._rows = [];
    layoutData._orphans = [];
    layoutConfig._widowCount = 0;
    // Convert widths and heights to aspect ratios if we need to
    return $e27e6af446543659$var$computeLayout(layoutConfig, layoutData, input.map(function(item) {
        if (item.width && item.height) return {
            aspectRatio: item.width / item.height
        };
        else return {
            aspectRatio: item
        };
    }));
}
var $e27e6af446543659$var$betterJustifiedLayout = $e27e6af446543659$var$index;
var $e27e6af446543659$var$justifiedLayout = /*@__PURE__*/ $e27e6af446543659$var$getDefaultExportFromCjs($e27e6af446543659$var$betterJustifiedLayout);
function $e27e6af446543659$var$ready(callback) {
    if (document.readyState === "complete" || document.readyState === "interactive") // Already ready or interactive, execute callback
    callback();
    else document.addEventListener("DOMContentLoaded", callback, {
        capture: true,
        once: true,
        passive: true
    });
}
/* eslint-disable import/no-mutable-exports */ /* eslint-disable no-restricted-globals */ let $e27e6af446543659$var$win;
if (typeof window !== "undefined") $e27e6af446543659$var$win = window;
else if (typeof $parcel$global !== "undefined") $e27e6af446543659$var$win = $parcel$global;
else if (typeof self !== "undefined") $e27e6af446543659$var$win = self;
else $e27e6af446543659$var$win = {};
var $e27e6af446543659$var$global$1 = $e27e6af446543659$var$win;
// get image dimensions
// thanks https://gist.github.com/dimsemenov/5382856
function $e27e6af446543659$var$getImgDimensions(img, cb) {
    let interval;
    let hasSize = false;
    let addedListeners = false;
    const onHasSize = ()=>{
        if (hasSize) {
            cb(hasSize);
            return;
        }
        // check for non-zero, non-undefined naturalWidth
        if (!img.naturalWidth) return;
        hasSize = {
            width: img.naturalWidth,
            height: img.naturalHeight
        };
        cb(hasSize);
        clearInterval(interval);
        if (addedListeners) // eslint-disable-next-line no-use-before-define
        removeListeners();
    };
    const onLoaded = ()=>{
        onHasSize();
    };
    const onError = ()=>{
        onHasSize();
    };
    const checkSize = ()=>{
        if (img.naturalWidth > 0) onHasSize();
    };
    const addListeners = ()=>{
        addedListeners = true;
        img.addEventListener("load", onLoaded);
        img.addEventListener("error", onError);
    };
    const removeListeners = ()=>{
        addedListeners = false;
        img.removeEventListener("load", onLoaded);
        img.removeEventListener("error", onError);
    };
    checkSize();
    if (!hasSize) {
        addListeners();
        interval = setInterval(checkSize, 100);
    }
}
// list with all fjGallery instances
// need to render all in one scroll/resize event
const $e27e6af446543659$var$fjGalleryList = [];
const $e27e6af446543659$var$updateFjGallery = /*#__PURE__*/ $e27e6af446543659$var$rafSchd(()=>{
    $e27e6af446543659$var$fjGalleryList.forEach((item)=>{
        item.resize();
    });
});
$e27e6af446543659$var$global$1.addEventListener("resize", $e27e6af446543659$var$updateFjGallery);
$e27e6af446543659$var$global$1.addEventListener("orientationchange", $e27e6af446543659$var$updateFjGallery);
$e27e6af446543659$var$global$1.addEventListener("load", $e27e6af446543659$var$updateFjGallery);
$e27e6af446543659$var$ready(()=>{
    $e27e6af446543659$var$updateFjGallery();
});
let $e27e6af446543659$var$instanceID = 0;
// fjGallery class
class $e27e6af446543659$var$FJGallery {
    constructor(container, userOptions){
        const self1 = this;
        self1.instanceID = $e27e6af446543659$var$instanceID;
        $e27e6af446543659$var$instanceID += 1;
        self1.$container = container;
        self1.images = [];
        self1.defaults = {
            itemSelector: ".fj-gallery-item",
            imageSelector: "img",
            gutter: 10,
            // supports object like `{ horizontal: 10, vertical: 10 }`.
            rowHeight: 320,
            rowHeightTolerance: 0.25,
            // [0, 1]
            maxRowsCount: Number.POSITIVE_INFINITY,
            edgeCaseMinRowHeight: 0.5,
            edgeCaseMaxRowHeight: 2.5,
            lastRow: "left",
            // left, center, right, hide
            transitionDuration: "0.3s",
            calculateItemsHeight: false,
            resizeDebounce: 100,
            isRtl: self1.css(self1.$container, "direction") === "rtl",
            // events
            onInit: null,
            // function() {}
            onDestroy: null,
            // function() {}
            onAppendImages: null,
            // function() {}
            onBeforeJustify: null,
            // function() {}
            onJustify: null // function() {}
        };
        // prepare data-options
        const dataOptions = self1.$container.dataset || {};
        const pureDataOptions = {};
        Object.keys(dataOptions).forEach((key)=>{
            const loweCaseOption = key.substr(0, 1).toLowerCase() + key.substr(1);
            if (loweCaseOption && typeof self1.defaults[loweCaseOption] !== "undefined") pureDataOptions[loweCaseOption] = dataOptions[key];
        });
        self1.options = {
            ...self1.defaults,
            ...pureDataOptions,
            ...userOptions
        };
        self1.pureOptions = {
            ...self1.options
        };
        // debounce for resize
        self1.resize = $e27e6af446543659$var$debounce(self1.options.resizeDebounce, self1.resize);
        self1.justify = $e27e6af446543659$var$rafSchd(self1.justify.bind(self1));
        self1.init();
    }
    // add styles to element
    // eslint-disable-next-line class-methods-use-this
    css(el, styles) {
        if (typeof styles === "string") return $e27e6af446543659$var$global$1.getComputedStyle(el).getPropertyValue(styles);
        Object.keys(styles).forEach((key)=>{
            el.style[key] = styles[key];
        });
        return el;
    }
    // set temporary transition with event listener
    applyTransition($item, properties) {
        const self1 = this;
        // Remove previous event listener
        self1.onTransitionEnd($item)();
        // Add transitions
        self1.css($item, {
            "transition-property": properties.join(", "),
            "transition-duration": self1.options.transitionDuration
        });
        // Add event listener
        $item.addEventListener("transitionend", self1.onTransitionEnd($item, properties), false);
    }
    onTransitionEnd($item) {
        const self1 = this;
        return ()=>{
            self1.css($item, {
                "transition-property": "",
                "transition-duration": ""
            });
            $item.removeEventListener("transitionend", self1.onTransitionEnd($item));
        };
    }
    // add to fjGallery instances list
    addToFjGalleryList() {
        $e27e6af446543659$var$fjGalleryList.push(this);
        $e27e6af446543659$var$updateFjGallery();
    }
    // remove from fjGallery instances list
    removeFromFjGalleryList() {
        const self1 = this;
        $e27e6af446543659$var$fjGalleryList.forEach((item, key)=>{
            if (item.instanceID === self1.instanceID) $e27e6af446543659$var$fjGalleryList.splice(key, 1);
        });
    }
    init() {
        const self1 = this;
        self1.appendImages(self1.$container.querySelectorAll(self1.options.itemSelector));
        self1.addToFjGalleryList();
        // call onInit event
        if (self1.options.onInit) self1.options.onInit.call(self1);
    }
    // append images
    appendImages($images) {
        const self1 = this;
        // check if jQuery
        if ($e27e6af446543659$var$global$1.jQuery && $images instanceof $e27e6af446543659$var$global$1.jQuery) $images = $images.get();
        if (!$images || !$images.length) return;
        $images.forEach(($item)=>{
            // if $images is jQuery, for some reason in this array there is undefined item, that not a DOM,
            // so we need to check for $item.querySelector.
            if ($item && !$item.fjGalleryImage && $item.querySelector) {
                const $image = $item.querySelector(self1.options.imageSelector);
                if ($image) {
                    $item.fjGalleryImage = self1;
                    const data = {
                        $item: $item,
                        $image: $image,
                        width: parseFloat($image.getAttribute("width")) || false,
                        height: parseFloat($image.getAttribute("height")) || false,
                        loadSizes () {
                            const itemData = this;
                            $e27e6af446543659$var$getImgDimensions($image, (dimensions)=>{
                                if (itemData.width !== dimensions.width || itemData.height !== dimensions.height) {
                                    itemData.width = dimensions.width;
                                    itemData.height = dimensions.height;
                                    self1.resize();
                                }
                            });
                        }
                    };
                    data.loadSizes();
                    self1.images.push(data);
                }
            }
        });
        // call onAppendImages event
        if (self1.options.onAppendImages) self1.options.onAppendImages.call(self1, [
            $images
        ]);
        self1.justify();
    }
    // justify images
    justify() {
        const self1 = this;
        const justifyArray = [];
        self1.justifyCount = (self1.justifyCount || 0) + 1;
        // call onBeforeJustify event
        if (self1.options.onBeforeJustify) self1.options.onBeforeJustify.call(self1);
        self1.images.forEach((data)=>{
            if (data.width && data.height) justifyArray.push(data.width / data.height);
        });
        const justifiedOptions = {
            containerWidth: self1.$container.getBoundingClientRect().width,
            containerPadding: {
                top: parseFloat(self1.css(self1.$container, "padding-top")) || 0,
                right: parseFloat(self1.css(self1.$container, "padding-right")) || 0,
                bottom: parseFloat(self1.css(self1.$container, "padding-bottom")) || 0,
                left: parseFloat(self1.css(self1.$container, "padding-left")) || 0
            },
            boxSpacing: self1.options.gutter,
            targetRowHeight: self1.options.rowHeight,
            targetRowHeightTolerance: self1.options.rowHeightTolerance,
            maxNumRows: self1.options.maxRowsCount,
            edgeCaseMinRowHeight: self1.options.edgeCaseMinRowHeight,
            edgeCaseMaxRowHeight: self1.options.edgeCaseMaxRowHeight,
            showWidows: self1.options.lastRow !== "hide"
        };
        const justifiedData = $e27e6af446543659$var$justifiedLayout(justifyArray, justifiedOptions);
        // Align last row
        if (justifiedData.widowCount && (self1.options.lastRow === "center" || self1.options.lastRow === "right")) {
            const lastItemData = justifiedData.boxes[justifiedData.boxes.length - 1];
            let gapSize = justifiedOptions.containerWidth - lastItemData.width - lastItemData.left;
            if (self1.options.lastRow === "center") gapSize /= 2;
            if (self1.options.lastRow === "right") gapSize -= justifiedOptions.containerPadding.right;
            for(let i = 1; i <= justifiedData.widowCount; i += 1)justifiedData.boxes[justifiedData.boxes.length - i].left = justifiedData.boxes[justifiedData.boxes.length - i].left + gapSize;
        }
        // RTL compatibility
        if (self1.options.isRtl) justifiedData.boxes.forEach((boxData, i)=>{
            justifiedData.boxes[i].left = justifiedOptions.containerWidth - justifiedData.boxes[i].left - justifiedData.boxes[i].width - justifiedOptions.containerPadding.right + justifiedOptions.containerPadding.left;
        });
        let i = 0;
        let additionalTopOffset = 0;
        const rowsMaxHeight = {};
        // Set image sizes.
        self1.images.forEach((data, imgI)=>{
            if (justifiedData.boxes[i] && data.width && data.height) {
                // calculate additional offset based on actual items height.
                if (self1.options.calculateItemsHeight && typeof rowsMaxHeight[justifiedData.boxes[i].row] === "undefined" && Object.keys(rowsMaxHeight).length) additionalTopOffset += rowsMaxHeight[Object.keys(rowsMaxHeight).pop()] - justifiedData.boxes[imgI - 1].height;
                if (self1.options.transitionDuration && self1.justifyCount > 1) self1.applyTransition(data.$item, [
                    "transform"
                ]);
                self1.css(data.$item, {
                    display: "",
                    position: "absolute",
                    transform: `translateX(${justifiedData.boxes[i].left}px) translateY(${justifiedData.boxes[i].top + additionalTopOffset}px) translateZ(0)`,
                    width: `${justifiedData.boxes[i].width}px`
                });
                // calculate actual items height.
                if (self1.options.calculateItemsHeight) {
                    const rect = data.$item.getBoundingClientRect();
                    if (typeof rowsMaxHeight[justifiedData.boxes[i].row] === "undefined" || rowsMaxHeight[justifiedData.boxes[i].row] < rect.height) rowsMaxHeight[justifiedData.boxes[i].row] = rect.height;
                }
                i += 1;
            } else self1.css(data.$item, {
                display: "none"
            });
        });
        // increase additional offset based on the latest row items height.
        if (self1.options.calculateItemsHeight && Object.keys(rowsMaxHeight).length) additionalTopOffset += rowsMaxHeight[Object.keys(rowsMaxHeight).pop()] - justifiedData.boxes[justifiedData.boxes.length - 1].height;
        if (self1.options.transitionDuration) self1.applyTransition(self1.$container, [
            "height"
        ]);
        // Set container height.
        self1.css(self1.$container, {
            height: `${justifiedData.containerHeight + additionalTopOffset}px`
        });
        // call onJustify event
        if (self1.options.onJustify) self1.options.onJustify.call(self1);
    }
    // update options and resize gallery items
    updateOptions(options) {
        const self1 = this;
        self1.options = {
            ...self1.options,
            ...options
        };
        self1.justify();
    }
    destroy() {
        const self1 = this;
        self1.removeFromFjGalleryList();
        self1.justifyCount = 0;
        // call onDestroy event
        if (self1.options.onDestroy) self1.options.onDestroy.call(self1);
        // remove styles.
        self1.css(self1.$container, {
            height: "",
            transition: ""
        });
        self1.images.forEach((data)=>{
            self1.css(data.$item, {
                position: "",
                transform: "",
                transition: "",
                width: "",
                height: ""
            });
        });
        // delete fjGalleryImage instance from images
        self1.images.forEach((val)=>{
            delete val.$item.fjGalleryImage;
        });
        // delete fjGallery instance from container
        delete self1.$container.fjGallery;
    }
    resize() {
        const self1 = this;
        self1.justify();
    }
}
// global definition
const $e27e6af446543659$export$2e2bcd8739ae039 = function(items, options, ...args) {
    // check for dom element
    // thanks: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
    if (typeof HTMLElement === "object" ? items instanceof HTMLElement : items && typeof items === "object" && items !== null && items.nodeType === 1 && typeof items.nodeName === "string") items = [
        items
    ];
    const len = items.length;
    let k = 0;
    let ret;
    for(k; k < len; k += 1){
        if (typeof options === "object" || typeof options === "undefined") {
            if (!items[k].fjGallery) // eslint-disable-next-line new-cap
            items[k].fjGallery = new $e27e6af446543659$var$FJGallery(items[k], options);
        } else if (items[k].fjGallery) // eslint-disable-next-line prefer-spread
        ret = items[k].fjGallery[options].apply(items[k].fjGallery, args);
        if (typeof ret !== "undefined") return ret;
    }
    return items;
};
$e27e6af446543659$export$2e2bcd8739ae039.constructor = $e27e6af446543659$var$FJGallery;

});



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("g7FV5");
var $cAVWq = parcelRequire("cAVWq");

var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

var $aphAM = parcelRequire("aphAM");

const $0ee8538dce656b69$var$AdBlockForm = $acw62.lazy(()=>(parcelRequire("dT9L5")));

const $0ee8538dce656b69$var$AdPlacesForm = $acw62.lazy(()=>(parcelRequire("1Ibm0")));

const $0ee8538dce656b69$var$AdVendorForm = $acw62.lazy(()=>(parcelRequire("imhCU")));

const $0ee8538dce656b69$var$adBlocksDatatableRenderConfig = ()=>(parcelRequire("kRLTu"));
const $0ee8538dce656b69$var$AdsModuleConfig = {
    navigation: {
        order: 900,
        item: {
            icon: "google-ads",
            name: "\u0420\u0435\u043A\u043B\u0430\u043C\u0430",
            children: [
                {
                    url: "/ads/blocks",
                    name: "\u0411\u043B\u043E\u043A\u0438"
                },
                {
                    url: "/ads/vendors",
                    name: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438"
                },
                {
                    url: "/ads/places",
                    name: "\u041C\u0456\u0441\u0446\u044F"
                }
            ]
        }
    },
    routes: [
        (0, $fCKVd.makeSimpleRoute)({
            path: "/ads",
            name: "\u0420\u0435\u043A\u043B\u0430\u043C\u0430",
            children: [
                (0, $fCKVd.makeSimpleRoute)({
                    index: true,
                    name: "\u0420\u0435\u043A\u043B\u0430\u043C\u0430",
                    element: $acw62.createElement((0, $aphAM.Navigate), {
                        to: "./blocks"
                    })
                }),
                (0, $fCKVd.makeCrudRoute)({
                    type: "simple",
                    basePath: "blocks",
                    baseEndpoint: "ads/blocks",
                    name: "\u0420\u0435\u043A\u043B\u0430\u043C\u043D\u0456 \u0431\u043B\u043E\u043A\u0438",
                    index: {
                        name: "\u0420\u0435\u043A\u043B\u0430\u043C\u043D\u0456 \u0431\u043B\u043E\u043A\u0438",
                        renderConfig: $0ee8538dce656b69$var$adBlocksDatatableRenderConfig
                    },
                    forms: {
                        createName: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u043E\u0433\u043E \u0431\u043B\u043E\u043A\u0443",
                        updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u043E\u0433\u043E \u0431\u043B\u043E\u043A\u0443",
                        element: $acw62.createElement($0ee8538dce656b69$var$AdBlockForm, null),
                        helpers: {
                            places: "helpers/ads/places",
                            conditions: "helpers/ads/conditions",
                            vendors: "helpers/ads/vendors",
                            ["google-aspect-ratios"]: "helpers/ads/google-aspect-ratios",
                            ["google-formats"]: "helpers/ads/google-formats"
                        }
                    }
                }),
                (0, $fCKVd.makeSimpleRoute)({
                    path: "places",
                    name: "\u041C\u0456\u0441\u0446\u044F",
                    element: $acw62.createElement($0ee8538dce656b69$var$AdPlacesForm, null),
                    loader: {
                        sync: {
                            data: {
                                endpoint: "ads/places"
                            }
                        }
                    },
                    action: {
                        endpoint: "ads/places",
                        method: "post"
                    }
                }),
                (0, $fCKVd.makeCrudRoute)({
                    type: "simple",
                    basePath: "vendors",
                    baseEndpoint: "ads/vendors",
                    name: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438",
                    index: {
                        name: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438"
                    },
                    forms: {
                        createName: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430",
                        updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430",
                        element: $acw62.createElement($0ee8538dce656b69$var$AdVendorForm, null)
                    }
                })
            ]
        })
    ]
};
var $0ee8538dce656b69$export$2e2bcd8739ae039 = $0ee8538dce656b69$var$AdsModuleConfig;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $c6844113a98d778c$var$Dashboard = $acw62.lazy(()=>(parcelRequire("bC6sA")));
const $c6844113a98d778c$var$AnalyticsModule = {
    routes: [
        (0, $fCKVd.makeSimpleRoute)({
            index: true,
            name: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430",
            element: $acw62.createElement($c6844113a98d778c$var$Dashboard, null)
        })
    ]
};
var $c6844113a98d778c$export$2e2bcd8739ae039 = $c6844113a98d778c$var$AnalyticsModule;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $928f9dedc48f31c4$var$CommentsList = $acw62.lazy(()=>(parcelRequire("kBjug")));

const $928f9dedc48f31c4$var$CommentInfo = $acw62.lazy(()=>(parcelRequire("iu64A")));
const $928f9dedc48f31c4$var$config = {
    navigation: [
        {
            order: 300,
            item: {
                url: "/comments",
                icon: "comment-multiple-outline",
                name: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440\u0456",
                counters: {
                    "comments-wait-cnt": "warning"
                }
            }
        }
    ],
    routes: [
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "comments",
            baseEndpoint: "comments",
            name: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440\u0456",
            index: {
                name: "\u0421\u043F\u0438\u0441\u043E\u043A \u043A\u043E\u043C\u0435\u043D\u0442\u0430\u0440\u0456\u0432",
                wrapper: $928f9dedc48f31c4$var$CommentsList
            },
            show: {
                name: "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F \u043F\u0440\u043E \u043A\u043E\u043C\u0435\u043D\u0442\u0430\u0440 #{data.id}",
                element: $acw62.createElement($928f9dedc48f31c4$var$CommentInfo, null),
                relations: {
                    "votes": "votes",
                    "feedback": "feedback"
                }
            }
        })
    ]
};
var $928f9dedc48f31c4$export$2e2bcd8739ae039 = $928f9dedc48f31c4$var$config;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $74f451efa4fd1d64$var$FeedbackListWrapper = $acw62.lazy(()=>(parcelRequire("3pf6U")));

const $74f451efa4fd1d64$var$FeedbackDisplay = $acw62.lazy(()=>(parcelRequire("hawWd")));

const $74f451efa4fd1d64$var$feedbackMessagesDatatableRenderConfig = ()=>(parcelRequire("63ILp"));
const $74f451efa4fd1d64$var$FeedbackModule = {
    navigation: {
        order: 550,
        item: {
            url: "/feedback",
            icon: "comment-quote",
            name: "\u0417\u0432\u043E\u0440\u043E\u0442\u043D\u0456\u0439 \u0437\u0432'\u044F\u0437\u043E\u043A",
            counters: {
                "feedback-wait-cnt": "warning"
            }
        }
    },
    routes: (0, $fCKVd.makeCrudRoute)({
        type: "simple",
        basePath: "feedback",
        baseEndpoint: "feedback",
        name: "\u0417\u0432\u043E\u0440\u043E\u0442\u043D\u0456\u0439 \u0437\u0432'\u044F\u0437\u043E\u043A",
        index: {
            name: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
            renderConfig: $74f451efa4fd1d64$var$feedbackMessagesDatatableRenderConfig,
            wrapper: $74f451efa4fd1d64$var$FeedbackListWrapper
        },
        show: {
            name: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F #{data.id}",
            element: $acw62.createElement($74f451efa4fd1d64$var$FeedbackDisplay, null)
        }
    })
};
var $74f451efa4fd1d64$export$2e2bcd8739ae039 = $74f451efa4fd1d64$var$FeedbackModule;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $99aa4134c74fa375$var$MediaIndex = $acw62.lazy(()=>(parcelRequire("2t3aA")));
const $99aa4134c74fa375$var$MediaModuleConfig = {
    navigation: {
        order: 400,
        item: {
            url: "/media",
            icon: "folder-multiple-image",
            name: "\u041C\u0435\u0434\u0456\u0430"
        }
    },
    routes: [
        (0, $fCKVd.makeSimpleRoute)({
            name: "\u041C\u0435\u0434\u0456\u0430",
            path: "media",
            element: $acw62.createElement($99aa4134c74fa375$var$MediaIndex, null)
        })
    ]
};
var $99aa4134c74fa375$export$2e2bcd8739ae039 = $99aa4134c74fa375$var$MediaModuleConfig;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

var $aphAM = parcelRequire("aphAM");

const $ee9382e1c5acf290$var$noticeDatatableRenderConfig = ()=>(parcelRequire("7PZHN"));

const $ee9382e1c5acf290$var$noticeCategoriesDatatableRenderConfig = ()=>(parcelRequire("5dS8i"));

const $ee9382e1c5acf290$var$noticeRegionsDatatableRenderConfig = ()=>(parcelRequire("dou2U"));

const $ee9382e1c5acf290$var$NoticeForm = $acw62.lazy(()=>(parcelRequire("3jDBg")));

const $ee9382e1c5acf290$var$NoticeCategoryForm = $acw62.lazy(()=>(parcelRequire("7t0rb")));

const $ee9382e1c5acf290$var$NoticeRegionForm = $acw62.lazy(()=>(parcelRequire("fz0YS")));
const $ee9382e1c5acf290$var$NoticesModule = {
    navigation: {
        order: 600,
        item: {
            icon: "bulletin-board",
            name: "\u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F",
            children: [
                {
                    url: "/notices/notices",
                    name: "\u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F"
                },
                {
                    url: "/notices/categories",
                    name: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
                },
                {
                    url: "/notices/regions",
                    name: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
                }
            ]
        }
    },
    routes: [
        (0, $fCKVd.makeSimpleRoute)({
            name: "\u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F",
            path: "/notices",
            children: [
                (0, $fCKVd.makeSimpleRoute)({
                    index: true,
                    name: "\u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F",
                    element: $acw62.createElement((0, $aphAM.Navigate), {
                        to: "/notices/notices"
                    })
                }),
                (0, $fCKVd.makeCrudRoute)({
                    type: "simple",
                    basePath: "notices",
                    baseEndpoint: "notices/notices",
                    name: "\u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F",
                    index: {
                        name: "\u0421\u043F\u0438\u0441\u043E\u043A \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                        renderConfig: $ee9382e1c5acf290$var$noticeDatatableRenderConfig
                    },
                    forms: {
                        createName: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F",
                        updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F",
                        element: $acw62.createElement($ee9382e1c5acf290$var$NoticeForm, null),
                        helpers: {
                            categories: "helpers/notices/categories",
                            regions: "helpers/notices/regions"
                        }
                    }
                }),
                (0, $fCKVd.makeCrudRoute)({
                    type: "simple",
                    basePath: "categories",
                    baseEndpoint: "notices/categories",
                    name: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                    index: {
                        name: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                        renderConfig: $ee9382e1c5acf290$var$noticeCategoriesDatatableRenderConfig
                    },
                    forms: {
                        createName: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                        updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                        element: $acw62.createElement($ee9382e1c5acf290$var$NoticeCategoryForm, null)
                    }
                }),
                (0, $fCKVd.makeCrudRoute)({
                    type: "simple",
                    basePath: "regions",
                    baseEndpoint: "notices/regions",
                    name: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                    index: {
                        name: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                        renderConfig: $ee9382e1c5acf290$var$noticeRegionsDatatableRenderConfig
                    },
                    forms: {
                        createName: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u0435\u0433\u0456\u043E\u043D\u0443 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                        updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u0435\u0433\u0456\u043E\u043D\u0443 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C",
                        element: $acw62.createElement($ee9382e1c5acf290$var$NoticeRegionForm, null)
                    }
                })
            ]
        })
    ]
};
var $ee9382e1c5acf290$export$2e2bcd8739ae039 = $ee9382e1c5acf290$var$NoticesModule;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $0b3b4b1d0cb869da$var$SpecialPageForm = $acw62.lazy(()=>(parcelRequire("jbzoy")));

const $0b3b4b1d0cb869da$var$StaticPageForm = $acw62.lazy(()=>(parcelRequire("dv5Uq")));

const $0b3b4b1d0cb869da$var$specialPagesDatatableRenderConfig = ()=>(parcelRequire("1Y5Ni"));

const $0b3b4b1d0cb869da$var$staticPagesDatatableRenderConfig = ()=>(parcelRequire("2c6hI"));
const $0b3b4b1d0cb869da$var$PagesModule = {
    navigation: {
        order: 800,
        item: {
            icon: "text-box-outline",
            name: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
            children: [
                {
                    url: "/pages/special",
                    name: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438"
                },
                {
                    url: "/pages/static",
                    name: "\u0421\u0442\u0430\u0442\u0438\u0447\u043D\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438"
                }
            ]
        }
    },
    routes: [
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "pages/special",
            baseEndpoint: "pages/special",
            name: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
            index: {
                name: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
                renderConfig: $0b3b4b1d0cb869da$var$specialPagesDatatableRenderConfig
            },
            update: {
                name: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u043E\u0457 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
                element: $acw62.createElement($0b3b4b1d0cb869da$var$SpecialPageForm, null)
            }
        }),
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "pages/static",
            baseEndpoint: "pages/static",
            name: "\u0421\u0442\u0430\u0442\u0438\u0447\u043D\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
            index: {
                name: "\u0421\u0442\u0430\u0442\u0438\u0447\u043D\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
                renderConfig: $0b3b4b1d0cb869da$var$staticPagesDatatableRenderConfig
            },
            forms: {
                createName: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0438\u0447\u043D\u043E\u0457 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
                updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0438\u0447\u043D\u043E\u0457 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
                element: $acw62.createElement($0b3b4b1d0cb869da$var$StaticPageForm, null)
            }
        })
    ]
};
var $0b3b4b1d0cb869da$export$2e2bcd8739ae039 = $0b3b4b1d0cb869da$var$PagesModule;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $b8fccea09404b4f0$var$PoolForm = $acw62.lazy(()=>(parcelRequire("1Zyzf")));

const $b8fccea09404b4f0$var$poolsDatatableRenderConfig = ()=>(parcelRequire("hg4xt"));
const $b8fccea09404b4f0$var$PoolModuleConfig = {
    init: (app)=>{
        app.navigation.GlobalButtons.registerDropdownItem("create", "pool", {
            icon: "poll",
            title: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
            url: "/pools/create"
        }, true);
    },
    navigation: {
        order: 500,
        item: {
            url: "/pools",
            icon: "poll",
            name: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F"
        }
    },
    routes: [
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "pools",
            baseEndpoint: "pools",
            name: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
            index: {
                name: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
                renderConfig: $b8fccea09404b4f0$var$poolsDatatableRenderConfig
            },
            forms: {
                createName: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
                updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
                element: $acw62.createElement($b8fccea09404b4f0$var$PoolForm, null)
            }
        })
    ]
};
var $b8fccea09404b4f0$export$2e2bcd8739ae039 = $b8fccea09404b4f0$var$PoolModuleConfig;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $5a772d7d8a3af53c$var$PostDraftCreateHelper = $acw62.lazy(()=>(parcelRequire("ljAGu")));

const $5a772d7d8a3af53c$var$postsDatatableRenderConfig = ()=>(parcelRequire("3rQSa"));

const $5a772d7d8a3af53c$var$postDraftsDatatableRenderConfig = ()=>(parcelRequire("01wJb"));

const $5a772d7d8a3af53c$var$PostEditForm = $acw62.lazy(()=>(parcelRequire("cOS9v")));

const $5a772d7d8a3af53c$var$PublicPostInitLoader = $acw62.lazy(()=>(parcelRequire("fWZAm")));
const $5a772d7d8a3af53c$var$PostsModuleConfig = {
    init: (app)=>{
        app.helpers.register("posts.draft.create-modal", $5a772d7d8a3af53c$var$PostDraftCreateHelper, "auth");
    },
    navigation: [
        {
            order: 100,
            item: {
                url: "/posts/drafts",
                icon: "file-document-edit",
                name: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0438"
            }
        },
        {
            order: 200,
            item: {
                url: "/posts/public",
                icon: "file-document-check-outline",
                name: "\u041E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u0456"
            }
        }
    ],
    routes: [
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "posts/drafts",
            baseEndpoint: "posts/drafts",
            name: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0438",
            index: {
                name: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0438",
                renderConfig: $5a772d7d8a3af53c$var$postDraftsDatatableRenderConfig
            },
            update: {
                name: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0443\u0431\u043B\u0456\u043A\u0430\u0446\u0456\u0457",
                element: $acw62.createElement($5a772d7d8a3af53c$var$PostEditForm, null),
                // relations: {
                //     'data': {
                //         isSync: true,
                //         endpoint: 'data',
                //         condition: () => true,
                //     },
                // },
                helpers: {
                    authors: "helpers/posts/authors",
                    categories: "helpers/posts/categories",
                    options: "helpers/posts/options",
                    ["other/ukr-net-categories"]: "helpers/posts/other/ukr-net-categories",
                    ["meta/comments/enable-status"]: "helpers/comments/enable-status"
                }
            }
        }),
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "posts/public",
            baseEndpoint: "posts/public",
            name: "\u041E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u0456",
            index: {
                name: "\u041E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u0456",
                renderConfig: $5a772d7d8a3af53c$var$postsDatatableRenderConfig
            },
            update: {
                name: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0443\u0431\u043B\u0456\u043A\u0430\u0446\u0456\u0457",
                element: $acw62.createElement($5a772d7d8a3af53c$var$PublicPostInitLoader, null)
            }
        })
    ]
};
var $5a772d7d8a3af53c$export$2e2bcd8739ae039 = $5a772d7d8a3af53c$var$PostsModuleConfig;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");
const $547d501905074f71$var$userFormDefaults = {
    name: "",
    username: "",
    permissions: [],
    roles: []
};
var $547d501905074f71$export$2e2bcd8739ae039 = $547d501905074f71$var$userFormDefaults;



const $01149ae715b51fd8$var$GeneralSettingsForm = $acw62.lazy(()=>(parcelRequire("7vpBw")));

const $01149ae715b51fd8$var$UserForm = $acw62.lazy(()=>(parcelRequire("1a5Lm")));

const $01149ae715b51fd8$var$SiteUserEditForm = $acw62.lazy(()=>(parcelRequire("j3a7A")));

const $01149ae715b51fd8$var$NavigationList = $acw62.lazy(()=>(parcelRequire("5KJ6Y")));

const $01149ae715b51fd8$var$NavigationEditForm = $acw62.lazy(()=>(parcelRequire("9B9iQ")));

const $01149ae715b51fd8$var$siteUsersDatatableRenderConfig = ()=>(parcelRequire("2gy8O"));
const $01149ae715b51fd8$var$SettingsModuleConfig = {
    navigation: {
        order: 1000,
        item: {
            icon: "cog",
            name: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
            children: [
                {
                    url: "/settings/general",
                    name: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0456"
                },
                {
                    url: "/settings/navigation",
                    name: "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F"
                },
                {
                    url: "/settings/users",
                    name: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456 \u0430\u0434\u043C\u0456\u043D\u043F\u0430\u043D\u0435\u043B\u0456"
                },
                {
                    url: "/settings/site-users",
                    name: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456 \u0441\u0430\u0439\u0442\u0443"
                }
            ]
        }
    },
    routes: [
        (0, $fCKVd.makeSimpleRoute)({
            path: "/settings/general",
            loader: {
                sync: {
                    "data": {
                        endpoint: "settings/general"
                    }
                },
                defer: {
                    "posts/categories": {
                        endpoint: "helpers/terms/categories"
                    },
                    "posts/ukr-net-categories": {
                        endpoint: "helpers/posts/other/ukr-net-categories"
                    },
                    "pages-list": {
                        endpoint: "helpers/settings/general/pages-list"
                    },
                    "comments/enable-status": {
                        endpoint: "helpers/comments/enable-status"
                    },
                    "org/types": {
                        endpoint: "helpers/settings/general/org/types"
                    }
                }
            },
            name: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0456",
            element: $acw62.createElement($01149ae715b51fd8$var$GeneralSettingsForm, null)
        }),
        (0, $fCKVd.makeSimpleRoute)({
            path: "/settings/navigation",
            name: "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F",
            children: [
                (0, $fCKVd.makeSimpleRoute)({
                    index: true,
                    name: "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0439\u043D\u0456 \u043C\u0435\u043D\u044E",
                    loader: {
                        sync: {
                            "data": {
                                endpoint: "settings/navigation"
                            }
                        }
                    },
                    element: $acw62.createElement($01149ae715b51fd8$var$NavigationList, null)
                }),
                (0, $fCKVd.makeSimpleRoute)({
                    path: "edit/:id",
                    name: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043C\u0435\u043D\u044E {data.name}",
                    element: $acw62.createElement($01149ae715b51fd8$var$NavigationEditForm, null),
                    loader: {
                        sync: {
                            "data": {
                                endpoint: "settings/navigation/{id}"
                            }
                        },
                        defer: {
                            "list-special-pages": {
                                endpoint: "helpers/settings/navigation/list/special-page"
                            },
                            "list-pages": {
                                endpoint: "helpers/settings/navigation/list/page"
                            },
                            "list-categories": {
                                endpoint: "helpers/settings/navigation/list/category"
                            },
                            "list-tags": {
                                endpoint: "helpers/settings/navigation/list/tag"
                            }
                        }
                    }
                })
            ]
        }),
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "settings/users",
            baseEndpoint: "settings/users",
            name: "\u0420\u0435\u0434\u0430\u043A\u0446\u0456\u044F",
            index: {
                name: "\u0420\u0435\u0434\u0430\u043A\u0446\u0456\u044F"
            },
            forms: {
                createName: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430",
                updateName: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 {data.name}",
                element: $acw62.createElement($01149ae715b51fd8$var$UserForm, null),
                initialData: (0, $547d501905074f71$export$2e2bcd8739ae039),
                helpers: {
                    "permissions": "helpers/users/permissions",
                    "roles": "helpers/users/roles"
                }
            }
        }),
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "settings/site-users",
            baseEndpoint: "settings/site-users",
            name: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456",
            index: {
                name: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456",
                renderConfig: $01149ae715b51fd8$var$siteUsersDatatableRenderConfig
            },
            update: {
                name: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 {data.name}",
                element: $acw62.createElement($01149ae715b51fd8$var$SiteUserEditForm, null)
            }
        })
    ]
};
var $01149ae715b51fd8$export$2e2bcd8739ae039 = $01149ae715b51fd8$var$SettingsModuleConfig;





var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

const $ff030f0698a70e2f$var$CategoryForm = $acw62.lazy(()=>(parcelRequire("8Gwhq")));

const $ff030f0698a70e2f$var$TagForm = $acw62.lazy(()=>(parcelRequire("kPSKK")));

const $ff030f0698a70e2f$var$categoriesDatatableRenderConfig = ()=>(parcelRequire("5I4uO"));

const $ff030f0698a70e2f$var$tagsDatatableRenderConfig = ()=>(parcelRequire("6QHdf"));
const $ff030f0698a70e2f$var$TermsModule = {
    navigation: {
        order: 700,
        item: {
            icon: "tag-multiple",
            name: "\u0420\u0443\u0431\u0440\u0438\u043A\u0438 \u0442\u0430 \u0442\u0435\u0433\u0438",
            children: [
                {
                    url: "/terms/categories",
                    name: "\u0420\u0443\u0431\u0440\u0438\u043A\u0438"
                },
                {
                    url: "/terms/tags",
                    name: "\u0422\u0435\u0433\u0438"
                }
            ]
        }
    },
    routes: [
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "terms/categories",
            baseEndpoint: "terms/categories",
            name: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
            index: {
                name: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
                renderConfig: $ff030f0698a70e2f$var$categoriesDatatableRenderConfig
            },
            forms: {
                createName: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044E",
                updateName: '\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044E "{data.name}"',
                element: $acw62.createElement($ff030f0698a70e2f$var$CategoryForm, null),
                helpers: {
                    types: "helpers/terms/category-types"
                }
            }
        }),
        (0, $fCKVd.makeCrudRoute)({
            type: "simple",
            basePath: "terms/tags",
            baseEndpoint: "terms/tags",
            name: "\u0422\u0435\u0433\u0438",
            index: {
                name: "\u0422\u0435\u0433\u0438",
                renderConfig: $ff030f0698a70e2f$var$tagsDatatableRenderConfig
            },
            forms: {
                createName: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0442\u0435\u0433",
                updateName: '\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0442\u0435\u0433 "{data.name}"',
                element: $acw62.createElement($ff030f0698a70e2f$var$TagForm, null)
            }
        })
    ]
};
var $ff030f0698a70e2f$export$2e2bcd8739ae039 = $ff030f0698a70e2f$var$TermsModule;





var $ket0H = parcelRequire("ket0H");
class $65b4100334580ed5$var$ModulesRegistry {
    static _isModuleEnabled(name) {
        var _a;
        return (_a = $65b4100334580ed5$var$ModulesRegistry._enableModules[name]) !== null && _a !== void 0 ? _a : false;
    }
    static enableModule(name) {
        this._enableModules[name] = true;
    }
    static disableModule(name) {
        this._enableModules[name] = false;
    }
    static registerModule(name, config) {
        this._modules[name] = config;
        this.enableModule(name);
    }
    static getNavigation() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return Object.entries(this._modules).filter(([key])=>this._isModuleEnabled(key)).map(([_, i])=>Array.isArray(i.navigation) ? i.navigation : i.navigation ? [
                    i.navigation
                ] : []).flat().sort((item1, item2)=>item1.order - item2.order).map((i)=>i.item);
        });
    }
    static getGlobalButtons() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return {
                create: {
                    variant: "primary",
                    icon: "plus",
                    title: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
                    order: 99,
                    items: {}
                }
            };
        });
    }
    static getNavCounters() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return (0, $ket0H.default).getData("nav/counters");
        });
    }
    static getRoutes() {
        return Object.entries(this._modules).filter(([key])=>this._isModuleEnabled(key)).map(([_, i])=>i.routes).filter((i)=>!!i).flat(1);
    }
    static initModules(app) {
        var _a;
        for (const [key, module] of Object.entries(this._modules)){
            if (!this._isModuleEnabled(key)) continue;
            (_a = module.init) === null || _a === void 0 || _a.call(module, app);
        }
    }
}
$65b4100334580ed5$var$ModulesRegistry._enableModules = {
    "activity": true,
    "ads": true,
    "analytics": true,
    "comments": true,
    "feedback": true,
    "media": true,
    "notices": true,
    "pages": true,
    "pool": true,
    "posts": true,
    "terms": true,
    "settings": true
};
$65b4100334580ed5$var$ModulesRegistry._modules = {
    "activity": (0, $cAVWq.default),
    "ads": (0, $0ee8538dce656b69$export$2e2bcd8739ae039),
    "analytics": (0, $c6844113a98d778c$export$2e2bcd8739ae039),
    "comments": (0, $928f9dedc48f31c4$export$2e2bcd8739ae039),
    "feedback": (0, $74f451efa4fd1d64$export$2e2bcd8739ae039),
    "media": (0, $99aa4134c74fa375$export$2e2bcd8739ae039),
    "notices": (0, $ee9382e1c5acf290$export$2e2bcd8739ae039),
    "pages": (0, $0b3b4b1d0cb869da$export$2e2bcd8739ae039),
    "pool": (0, $b8fccea09404b4f0$export$2e2bcd8739ae039),
    "posts": (0, $5a772d7d8a3af53c$export$2e2bcd8739ae039),
    "terms": (0, $ff030f0698a70e2f$export$2e2bcd8739ae039),
    "settings": (0, $01149ae715b51fd8$export$2e2bcd8739ae039)
};
var $65b4100334580ed5$export$2e2bcd8739ae039 = $65b4100334580ed5$var$ModulesRegistry;





var $acw62 = parcelRequire("acw62");
const $5525c5113fea0303$var$Logo = (props)=>{
    return $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#fff",
        viewBox: "0 0 295 57.26"
    }, props), $acw62.createElement("path", {
        d: "M69.17 8.2v.92a5.91 5.91 0 0 0-2.88 1.14A10.24 10.24 0 0 0 63.81 14L51.32 42.59h-1l-13.42-29a15.29 15.29 0 0 0-1.45-2.73 4.63 4.63 0 0 0-1.62-1.2 7.88 7.88 0 0 0-2.61-.56v-.9h14.66v.92a7.06 7.06 0 0 0-3.23.79 1.78 1.78 0 0 0-.74 1.46 10.69 10.69 0 0 0 1.22 3.87L52.24 35l8.45-19.47a12.45 12.45 0 0 0 1.24-4 1.85 1.85 0 0 0-.76-1.38 5.21 5.21 0 0 0-2.59-.93l-.45-.07V8.2ZM81.22 30.57H67.35l-2.43 5.3A8 8 0 0 0 64 38.8a1.68 1.68 0 0 0 .78 1.35 7.18 7.18 0 0 0 3.37.76v.91H56.89v-.91a6.25 6.25 0 0 0 2.9-1 15 15 0 0 0 3-4.84L75.38 7.43h.92l12.47 28a12.57 12.57 0 0 0 2.73 4.38 5.85 5.85 0 0 0 3.42 1.13v.91H80.79v-.91a5.58 5.58 0 0 0 2.89-.67 1.72 1.72 0 0 0 .76-1.39 9.91 9.91 0 0 0-1.06-3.45Zm-.75-1.84L74.4 15.14l-6.23 13.59ZM30 12.4a17.7 17.7 0 0 0-5.35-3.62c0 .89.2 3.14.8 3.83Q29 16.86 29 25.48q0 8-3.29 11.66a10.68 10.68 0 0 1-8.34 3.69 9.49 9.49 0 0 1-7.6-3.37Q6 33 6.05 24.79c0-4.59.91-8.21 2.68-10.91a.52.52 0 0 1-.11-.1A1.77 1.77 0 0 1 8.1 13l-.38-.35-.35-.25c-.2-.06-.4-.1-.59-.17a4.41 4.41 0 0 1-.9-.43l-.07.05A16.54 16.54 0 0 0 0 24.89a17 17 0 0 0 17.46 17.7 17.1 17.1 0 0 0 12.46-5.06 17.06 17.06 0 0 0 5.15-12.72A16.6 16.6 0 0 0 30 12.4Z"
    }), $acw62.createElement("path", {
        d: "M24.54 27.79a1.22 1.22 0 0 0-.1-.63l-.18-.71a.48.48 0 0 0 .15-.29.5.5 0 0 0-.23-.46.61.61 0 0 0-.14-.07c0-.07-.86-3.23-1.05-4.85a5.86 5.86 0 0 1 0-.93 4.73 4.73 0 0 0-.05-1.33 4.75 4.75 0 0 0-.38-.94 4.22 4.22 0 0 1-.43-1.2A2.87 2.87 0 0 0 22 16a1.57 1.57 0 0 1-.09-.6 2.51 2.51 0 0 1 .14-.52 2.77 2.77 0 0 0 .15-.49.67.67 0 0 0 .1-.44v-.05h-.1a2.51 2.51 0 0 0-.5-1.32 11.67 11.67 0 0 0-.84-.93c.09-.14.2-.29.28-.43a6.79 6.79 0 0 0 .71-1.8 8.66 8.66 0 0 0 .51-1.21c.12-.32.24-.63.29-.72l.05-.11h-.12a2 2 0 0 0-.68.12 2.5 2.5 0 0 0-.05-.29v-.1h-.06a4.51 4.51 0 0 0-2.62 1.45c0-.39-.46-.63-.92-.68a9.14 9.14 0 0 0-4.63 1.19c-.65.29-1.32.59-2 .82a21.29 21.29 0 0 1-2.92.68l-.54.1c-.43.08-.86.18-1.29.28a9.16 9.16 0 0 0-3.27 4.33 19.32 19.32 0 0 0-1.23 5.77 28.09 28.09 0 0 0-.08 7.27A20 20 0 0 0 2.94 31a21.59 21.59 0 0 1 4.56-4.35c1.4-1 2.55-1.31 3.52-1l.1.16A7.5 7.5 0 0 0 12.43 27c.18.15.35.29.5.43a.37.37 0 0 0-.07.45.89.89 0 0 0 .3.31 1.35 1.35 0 0 0 .52.27h.05a3.88 3.88 0 0 1 .84 1 .65.65 0 0 0 0 .13c-.09.41.3.75.67.91a2 2 0 0 0 .63.17H16l.16.07c.15.19.36.41.58.65a9.61 9.61 0 0 1 .9 1.05 2.42 2.42 0 0 1 .36 1.25 4.39 4.39 0 0 0 .8 2.07 2.24 2.24 0 0 0 1.39.65 1.35 1.35 0 0 0 .61-.09 2.92 2.92 0 0 0 2.74-1.06c.12-.14.34-.34.47-.47l.15-.14a.38.38 0 0 0 .12-.09.6.6 0 0 0 .09-.13 1.83 1.83 0 0 0 .25-.35 4 4 0 0 0 .38-1.72v-.29a16.34 16.34 0 0 0-.46-4.28Z"
    }), $acw62.createElement("text", {
        style: {
            fontSize: 50,
            fontFamily: "TimesNewRomanPSMT,Times New Roman",
            letterSpacing: "-.02em"
        },
        transform: "matrix(1.09 0 0 1 98.79 41.82)"
    }, "ENGINE"));
};
var $5525c5113fea0303$export$2e2bcd8739ae039 = $5525c5113fea0303$var$Logo;



var $7WQrb = parcelRequire("7WQrb");

var $ket0H = parcelRequire("ket0H");
class $ac754b9938626444$export$2e2bcd8739ae039 {
    static login(data) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const response = yield (0, $ket0H.default).post("auth", data);
            return response.data;
        });
    }
    static getAuth() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return yield (0, $ket0H.default).getData("auth");
        });
    }
    static logout() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield (0, $ket0H.default).delete("auth", {});
        });
    }
}



var $ket0H = parcelRequire("ket0H");

var $fCKVd = parcelRequire("fCKVd");
(0, $fCKVd.AppLayout).singleton({
    layoutColor: [
        "dark"
    ],
    leftbarTheme: [
        "dark"
    ]
});
(0, $ket0H.default).setConfig({
    baseUrl: "/api/",
    timeout: 10000
});



var $acw62 = parcelRequire("acw62");

var $fCKVd = parcelRequire("fCKVd");

var $8x08q = parcelRequire("8x08q");
const $4bdf0fe432b5a63b$var$searchTypes = {
    posts: {
        icon: "file-document-check-outline",
        name: "\u041E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u0456",
        allowCheck: (app)=>app.auth.can("posts.public::view"),
        render: ({ data: data })=>{
            var _a;
            return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("b", null, data.title), $acw62.createElement("span", {
                className: "ms-auto text-muted small"
            }, $acw62.createElement((0, $fCKVd.DateTimeFormat), {
                dt: data.publish_dt,
                children: (dt)=>dt.toLocaleString((0, $8x08q.DateTime).DATETIME_SHORT)
            })), data.author && $acw62.createElement("span", {
                className: "ms-1 text-muted small"
            }, $acw62.createElement("i", {
                className: "mdi mdi-account"
            }), " ", (_a = data.author) === null || _a === void 0 ? void 0 : _a.name));
        }
    },
    drafts: {
        icon: "file-document-edit",
        name: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0438",
        allowCheck: (app)=>app.auth.canAny([
                "posts.drafts::all",
                "posts.drafts::create"
            ]),
        render: ({ data: data })=>{
            var _a;
            return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("b", null, data.title), $acw62.createElement("span", {
                className: "ms-auto text-muted small"
            }, $acw62.createElement((0, $fCKVd.DateTimeFormat), {
                dt: data.publish_dt,
                children: (dt)=>dt.toLocaleString((0, $8x08q.DateTime).DATETIME_SHORT)
            })), data.author && $acw62.createElement("span", {
                className: "ms-1 text-muted small"
            }, $acw62.createElement("i", {
                className: "mdi mdi-account"
            }), " ", (_a = data.author) === null || _a === void 0 ? void 0 : _a.name));
        }
    },
    pools: {
        icon: "poll",
        name: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        allowCheck: (app)=>app.auth.can("pools::all"),
        render: ({ data: data })=>$acw62.createElement($acw62.Fragment, null, $acw62.createElement("b", null, data.txt), $acw62.createElement("span", {
                className: "ms-auto text-muted small"
            }, $acw62.createElement((0, $fCKVd.DateTimeFormat), {
                dt: data.created_at,
                children: (dt)=>dt.toLocaleString((0, $8x08q.DateTime).DATETIME_SHORT)
            })))
    },
    notices: {
        icon: "bulletin-board",
        name: "\u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F",
        allowCheck: (app)=>app.auth.can("notices::manage"),
        render: ({ data: data })=>$acw62.createElement($acw62.Fragment, null, $acw62.createElement("b", null, data.title), $acw62.createElement("span", {
                className: "ms-auto text-muted small"
            }, $acw62.createElement((0, $fCKVd.DateTimeFormat), {
                dt: data.publish_dt,
                children: (dt)=>dt.toLocaleString((0, $8x08q.DateTime).DATETIME_SHORT)
            })))
    },
    categories: {
        icon: "book-open-variant",
        name: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        allowCheck: (app)=>app.auth.can("terms.categories::manage")
    },
    tags: {
        icon: "tag",
        name: "\u0422\u0435\u0433\u0438",
        allowCheck: (app)=>app.auth.can("terms.tags::manage")
    },
    pages: {
        icon: "file-document",
        name: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
        allowCheck: (app)=>app.auth.can("pages.static::manage")
    },
    users: {
        icon: "account",
        name: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456 \u0430\u0434\u043C\u0456\u043D\u043F\u0430\u043D\u0435\u043B\u0456",
        allowCheck: (app)=>app.auth.can("settings.users::manage")
    }
};
var $4bdf0fe432b5a63b$export$2e2bcd8739ae039 = $4bdf0fe432b5a63b$var$searchTypes;



var $K4nmq = parcelRequire("K4nmq");
const $44c0b3a74c92684f$var$adminDomain = window.location.hostname;
const $44c0b3a74c92684f$var$siteDomain = $44c0b3a74c92684f$var$adminDomain.replace("admin.", "");
const $44c0b3a74c92684f$var$appConfig = {
    base: {
        appName: "OVA Engine",
        appCreateYear: 2021,
        logoComponent: (0, $5525c5113fea0303$export$2e2bcd8739ae039),
        siteDomain: $44c0b3a74c92684f$var$siteDomain
    },
    actions: {
        endpoint: "actions"
    },
    search: {
        endpoint: "search",
        types: (0, $4bdf0fe432b5a63b$export$2e2bcd8739ae039)
    },
    auth: {
        loginHandler: (0, $ac754b9938626444$export$2e2bcd8739ae039).login,
        authUserResolver: (0, $ac754b9938626444$export$2e2bcd8739ae039).getAuth,
        logoutHandler: (0, $ac754b9938626444$export$2e2bcd8739ae039).logout
    },
    navigation: {
        navigationMenuResolver: ()=>(0, $65b4100334580ed5$export$2e2bcd8739ae039).getNavigation(),
        globalButtonsResolver: ()=>(0, $65b4100334580ed5$export$2e2bcd8739ae039).getGlobalButtons(),
        navigationCountersResolver: ()=>(0, $65b4100334580ed5$export$2e2bcd8739ae039).getNavCounters()
    },
    external: {
        rtc: {
            rtcWsUrl: `wss://${$44c0b3a74c92684f$var$adminDomain}/rtc/ws/`,
            baseEndpoint: "collaboration"
        },
        media: {
            endpoint: "media"
        },
        websocket: {
            host: $44c0b3a74c92684f$var$adminDomain,
            port: "443",
            appKey: "ws-admin",
            authEndpoint: "/api/broadcasting/auth"
        }
    }
};
const $44c0b3a74c92684f$var$onAppReady = (app)=>{
    (0, $65b4100334580ed5$export$2e2bcd8739ae039).initModules(app);
    (0, $K4nmq.MediaLibrary).initializer(app);
};
const $44c0b3a74c92684f$var$OvaEngineAdmin = ({ config: instanceConfig, editorConfig: editorConfig })=>{
    const config = $acw62.useMemo(()=>Object.assign(Object.assign(Object.assign({}, $44c0b3a74c92684f$var$appConfig), instanceConfig ? {
            base: Object.assign(Object.assign({}, $44c0b3a74c92684f$var$appConfig.base), instanceConfig)
        } : {}), editorConfig ? {
            external: Object.assign(Object.assign({}, $44c0b3a74c92684f$var$appConfig.external), {
                editor: editorConfig
            })
        } : {}), []);
    const appRoutes = $acw62.useMemo(()=>(0, $65b4100334580ed5$export$2e2bcd8739ae039).getRoutes(), []);
    return $acw62.createElement((0, $fCKVd.Application), {
        appRoutes: appRoutes,
        config: config,
        onAppReady: $44c0b3a74c92684f$var$onAppReady
    });
};
var $44c0b3a74c92684f$export$2e2bcd8739ae039 = $44c0b3a74c92684f$var$OvaEngineAdmin;






const $70fc9a727fa662ae$var$config = {
    sentryDsn: undefined,
    appRelease: "master-cc1d8382"
};
const $70fc9a727fa662ae$var$editorConfig = {
    table: false
};
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $44c0b3a74c92684f$export$2e2bcd8739ae039), {
    config: $70fc9a727fa662ae$var$config,
    editorConfig: $70fc9a727fa662ae$var$editorConfig
}));


//# sourceMappingURL=index.2ad9c421.js.map
